rlzWDPDashJSONP([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reduxAuthWrapper = __webpack_require__(245);
	
	var _lodash = __webpack_require__(294);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _createStore = __webpack_require__(295);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _reactTapEventPlugin = __webpack_require__(636);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _materialUi = __webpack_require__(642);
	
	var _App = __webpack_require__(1013);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _FAQ = __webpack_require__(1059);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _I = __webpack_require__(1067);
	
	var _I2 = _interopRequireDefault(_I);
	
	var _Home = __webpack_require__(1073);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _WidgetListStatsByUser = __webpack_require__(1083);
	
	var _WidgetListStatsByUser2 = _interopRequireDefault(_WidgetListStatsByUser);
	
	var _LoginForm = __webpack_require__(1087);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Account = __webpack_require__(1088);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _AccountDefaults = __webpack_require__(1116);
	
	var _AccountDefaults2 = _interopRequireDefault(_AccountDefaults);
	
	var _AccountPassword = __webpack_require__(1118);
	
	var _AccountPassword2 = _interopRequireDefault(_AccountPassword);
	
	var _WidgetPick = __webpack_require__(1119);
	
	var _WidgetPick2 = _interopRequireDefault(_WidgetPick);
	
	var _WidgetCustomizer = __webpack_require__(1120);
	
	var _WidgetCustomizer2 = _interopRequireDefault(_WidgetCustomizer);
	
	var _WidgetDemo = __webpack_require__(1300);
	
	var _WidgetDemo2 = _interopRequireDefault(_WidgetDemo);
	
	var _ThemesList = __webpack_require__(1301);
	
	var _ThemesList2 = _interopRequireDefault(_ThemesList);
	
	var _ThemeCustomizer = __webpack_require__(1313);
	
	var _ThemeCustomizer2 = _interopRequireDefault(_ThemeCustomizer);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _TvProgramDashboard = __webpack_require__(1381);
	
	var _TvProgramDashboard2 = _interopRequireDefault(_TvProgramDashboard);
	
	var _index = __webpack_require__(1386);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _PlayerPerformanceIndex = __webpack_require__(1471);
	
	var _PlayerPerformanceIndex2 = _interopRequireDefault(_PlayerPerformanceIndex);
	
	var _PacksScene = __webpack_require__(1478);
	
	var _PacksScene2 = _interopRequireDefault(_PacksScene);
	
	var _PacksList = __webpack_require__(1481);
	
	var _PacksList2 = _interopRequireDefault(_PacksList);
	
	var _Pack = __webpack_require__(1484);
	
	var _Pack2 = _interopRequireDefault(_Pack);
	
	var _UsersPacksDashboard = __webpack_require__(1489);
	
	var _UsersPacksDashboard2 = _interopRequireDefault(_UsersPacksDashboard);
	
	var _WidgetDashboard = __webpack_require__(1490);
	
	var _WidgetDashboard2 = _interopRequireDefault(_WidgetDashboard);
	
	var _CommonI18DashboardIndex = __webpack_require__(1498);
	
	var _CommonI18DashboardIndex2 = _interopRequireDefault(_CommonI18DashboardIndex);
	
	var _TemplateCustomizer = __webpack_require__(1499);
	
	var _TemplateCustomizer2 = _interopRequireDefault(_TemplateCustomizer);
	
	var _TemplatesList = __webpack_require__(1586);
	
	var _TemplatesList2 = _interopRequireDefault(_TemplatesList);
	
	var _TournamentSMBrowser = __webpack_require__(1589);
	
	var _TournamentSMBrowser2 = _interopRequireDefault(_TournamentSMBrowser);
	
	var _TeamSeasonHomeSMB = __webpack_require__(1591);
	
	var _TeamSeasonHomeSMB2 = _interopRequireDefault(_TeamSeasonHomeSMB);
	
	var _TeamSeasonStatsSMB = __webpack_require__(1676);
	
	var _TeamSeasonStatsSMB2 = _interopRequireDefault(_TeamSeasonStatsSMB);
	
	var _TeamSquadSMB = __webpack_require__(1677);
	
	var _TeamSquadSMB2 = _interopRequireDefault(_TeamSquadSMB);
	
	var _TeamHostSMB = __webpack_require__(1679);
	
	var _TeamHostSMB2 = _interopRequireDefault(_TeamHostSMB);
	
	var _PlayerHostSMB = __webpack_require__(1681);
	
	var _PlayerHostSMB2 = _interopRequireDefault(_PlayerHostSMB);
	
	var _PlayerSeasonSMB = __webpack_require__(1683);
	
	var _PlayerSeasonSMB2 = _interopRequireDefault(_PlayerSeasonSMB);
	
	var _PlayerH2HSeasonSMB = __webpack_require__(1684);
	
	var _PlayerH2HSeasonSMB2 = _interopRequireDefault(_PlayerH2HSeasonSMB);
	
	var _EventSMB = __webpack_require__(1685);
	
	var _EventSMB2 = _interopRequireDefault(_EventSMB);
	
	var _EventIncidentsSMB = __webpack_require__(1686);
	
	var _EventIncidentsSMB2 = _interopRequireDefault(_EventIncidentsSMB);
	
	var _EventStatsSMB = __webpack_require__(1687);
	
	var _EventStatsSMB2 = _interopRequireDefault(_EventStatsSMB);
	
	var _EventTeamFormSMB = __webpack_require__(1688);
	
	var _EventTeamFormSMB2 = _interopRequireDefault(_EventTeamFormSMB);
	
	var _EventPlayerPerformanceSMB = __webpack_require__(1689);
	
	var _EventPlayerPerformanceSMB2 = _interopRequireDefault(_EventPlayerPerformanceSMB);
	
	var _EventLineupSMB = __webpack_require__(1690);
	
	var _EventLineupSMB2 = _interopRequireDefault(_EventLineupSMB);
	
	var _EventHost = __webpack_require__(1691);
	
	var _EventHost2 = _interopRequireDefault(_EventHost);
	
	var _EventBookieSMB = __webpack_require__(1693);
	
	var _EventBookieSMB2 = _interopRequireDefault(_EventBookieSMB);
	
	var _TournamentRoundSMB = __webpack_require__(1694);
	
	var _TournamentRoundSMB2 = _interopRequireDefault(_TournamentRoundSMB);
	
	var _TournamentHomeSMB = __webpack_require__(1695);
	
	var _TournamentHomeSMB2 = _interopRequireDefault(_TournamentHomeSMB);
	
	var _TournamentRoundHost = __webpack_require__(1697);
	
	var _TournamentRoundHost2 = _interopRequireDefault(_TournamentRoundHost);
	
	var _TournamentStageSMB = __webpack_require__(1701);
	
	var _TournamentStageSMB2 = _interopRequireDefault(_TournamentStageSMB);
	
	var _SportHomeSMBrowser = __webpack_require__(1702);
	
	var _SportHomeSMBrowser2 = _interopRequireDefault(_SportHomeSMBrowser);
	
	var _F1HomeSMBrowser = __webpack_require__(1704);
	
	var _F1HomeSMBrowser2 = _interopRequireDefault(_F1HomeSMBrowser);
	
	var _F1GPXSMBrowser = __webpack_require__(1705);
	
	var _F1GPXSMBrowser2 = _interopRequireDefault(_F1GPXSMBrowser);
	
	var _SMPostPage = __webpack_require__(1708);
	
	var _SMPostPage2 = _interopRequireDefault(_SMPostPage);
	
	var _SMBrowser = __webpack_require__(1709);
	
	var _SMBrowser2 = _interopRequireDefault(_SMBrowser);
	
	var _WidgetStatsByWIID = __webpack_require__(1711);
	
	var _WidgetStatsByWIID2 = _interopRequireDefault(_WidgetStatsByWIID);
	
	var _ClientSummary = __webpack_require__(1712);
	
	var _ClientSummary2 = _interopRequireDefault(_ClientSummary);
	
	var _WidgetsSummary = __webpack_require__(1714);
	
	var _WidgetsSummary2 = _interopRequireDefault(_WidgetsSummary);
	
	var _WidgetPortfolio = __webpack_require__(1715);
	
	var _WidgetPortfolio2 = _interopRequireDefault(_WidgetPortfolio);
	
	var _WidgetPickerPage = __webpack_require__(1812);
	
	var _WidgetPickerPage2 = _interopRequireDefault(_WidgetPickerPage);
	
	var _WidgetEditPage = __webpack_require__(1818);
	
	var _WidgetEditPage2 = _interopRequireDefault(_WidgetEditPage);
	
	var _SMLink = __webpack_require__(1819);
	
	var _Create = __webpack_require__(1820);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _Edit = __webpack_require__(1899);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _List = __webpack_require__(1900);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _CampaignView = __webpack_require__(1944);
	
	var _CampaignView2 = _interopRequireDefault(_CampaignView);
	
	var _ManualTrigger = __webpack_require__(1970);
	
	var _ManualTrigger2 = _interopRequireDefault(_ManualTrigger);
	
	var _PostPredictions = __webpack_require__(1974);
	
	var _PostPredictions2 = _interopRequireDefault(_PostPredictions);
	
	var _ManualPost = __webpack_require__(2123);
	
	var _ManualPost2 = _interopRequireDefault(_ManualPost);
	
	var _FactsView = __webpack_require__(2126);
	
	var _FactsView2 = _interopRequireDefault(_FactsView);
	
	var _IDSTournaments = __webpack_require__(2128);
	
	var _IDSTournaments2 = _interopRequireDefault(_IDSTournaments);
	
	var _IDSTournament = __webpack_require__(2130);
	
	var _IDSTournament2 = _interopRequireDefault(_IDSTournament);
	
	var _IDSTeam = __webpack_require__(2131);
	
	var _IDSTeam2 = _interopRequireDefault(_IDSTeam);
	
	var _ProviderIds = __webpack_require__(2132);
	
	var _ProviderIds2 = _interopRequireDefault(_ProviderIds);
	
	var _CreateAccount = __webpack_require__(2133);
	
	var _CreateAccount2 = _interopRequireDefault(_CreateAccount);
	
	var _AccountsList = __webpack_require__(2136);
	
	var _AccountsList2 = _interopRequireDefault(_AccountsList);
	
	var _UpdateAccount = __webpack_require__(2137);
	
	var _UpdateAccount2 = _interopRequireDefault(_UpdateAccount);
	
	var _Hub = __webpack_require__(2146);
	
	var _Hub2 = _interopRequireDefault(_Hub);
	
	var _KeyValSS = __webpack_require__(2158);
	
	var _KeyValSS2 = _interopRequireDefault(_KeyValSS);
	
	var _MessageScene = __webpack_require__(2159);
	
	var _MessageScene2 = _interopRequireDefault(_MessageScene);
	
	var _withFeature = __webpack_require__(1864);
	
	var _odds = __webpack_require__(1638);
	
	var _TournamentStageHost = __webpack_require__(2169);
	
	var _TournamentStageHost2 = _interopRequireDefault(_TournamentStageHost);
	
	var _index3 = __webpack_require__(2170);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _styles = __webpack_require__(2180);
	
	var _darkBaseTheme = __webpack_require__(1719);
	
	var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);
	
	var _getMuiTheme = __webpack_require__(907);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* end IDSFinder */
	
	/* ProviderIds */
	
	// import WidgetEmbed from './editor/components/WidgetEmbed';
	
	(0, _reactTapEventPlugin2.default)();
	/* ProviderIds */
	
	/* IDSFinder */
	
	
	var NoMatch = function NoMatch() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        'Page not found!'
	    );
	};
	
	var DarkFullPageContainer = function DarkFullPageContainer(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        _styles.MuiThemeProvider,
	        { muiTheme: (0, _getMuiTheme2.default)(_darkBaseTheme2.default) },
	        _react2.default.createElement(
	            _materialUi.Paper,
	            {
	                style: {
	                    height: 'calc(100vh - 64px - 30px)' // remove action bar and 2x15 paddings
	                }
	            },
	            children
	        )
	    );
	};
	
	function requireAuth(nextState, replace) {
	    if (!_auth2.default.loggedIn()) {
	        replace({
	            pathname: '/login',
	            state: { nextPathname: nextState.location.pathname }
	        });
	    }
	}
	
	function requireSocialAuth(nextState, replace) {
	    // check account for social
	    if (!_auth2.default.loggedIn()) {
	        replace({
	            pathname: '/login',
	            state: { nextPathname: nextState.location.pathname }
	        });
	    }
	}
	
	var htmlRoot = document.getElementById('root');
	
	var loggedIn = new _reduxAuthWrapper.UserAuthWrapper({
	    authSelector: function authSelector(state) {
	        return state.user;
	    },
	    wrapperDisplayName: 'UserIsLoggedIn',
	    failureRedirectPath: '/login'
	});
	
	var isAdmin = new _reduxAuthWrapper.UserAuthWrapper({
	    authSelector: function authSelector(state) {
	        return state.user;
	    },
	    wrapperDisplayName: 'UserIsLoggedIn',
	    failureRedirectPath: '/home',
	    predicate: function predicate(user) {
	        return (0, _lodash2.default)(user.roles, function (role) {
	            return role === 'admin';
	        });
	    }
	});
	
	var hasFeature = function hasFeature(features) {
	    return new _reduxAuthWrapper.UserAuthWrapper({
	        authSelector: function authSelector(state) {
	            return state.user;
	        },
	        wrapperDisplayName: 'UserHasFeautures',
	        failureRedirectPath: '/home',
	        predicate: function predicate(user) {
	            return (0, _withFeature.allPermissionsPresent)(features, user);
	        }
	    });
	};
	
	if (false) {
	    window.store = _createStore2.default;
	} else {
	    if (location.protocol !== 'https:') {
	        location.protocol = 'https:';
	    }
	}
	
	if (htmlRoot) {
	    _reactDom2.default.render(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _createStore2.default },
	        _react2.default.createElement(
	            _reactRouter.Router,
	            { history: _reactRouter.browserHistory },
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { component: _App2.default },
	                _react2.default.createElement(_reactRouter.Route, { path: '/(login)', component: _LoginForm2.default, params: { disableMiniMenu: true } }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/hub', component: loggedIn(_Hub2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/key-val-ss2',
	                    params: { disableFooter: true, disableHeader: true, container: 'container-white' },
	                    component: _KeyValSS2.default
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/home', component: loggedIn(_Home2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/campaigns', params: { container: 'container' }, component: loggedIn(_List2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/campaigns/social', component: loggedIn(_SMLink.SMLinkManager) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/campaigns/create',
	                    params: { container: 'container' },
	                    component: loggedIn(_Create2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/campaigns/edit/:campaignId',
	                    params: { container: 'container' },
	                    component: loggedIn(_Edit2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/campaigns/view/:campaignId/prediction',
	                    params: { container: 'container' },
	                    component: loggedIn(_PostPredictions2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/campaigns/view/:campaignId(/:tab)',
	                    params: { container: 'container' },
	                    component: loggedIn(_CampaignView2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/campaigns/manual-trigger', component: loggedIn(_ManualTrigger2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/campaigns/manual-post(/:campaignId)(/:widgetId)',
	                    component: loggedIn(_ManualPost2.default),
	                    params: { container: 'container-white' }
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/interests', params: { container: 'container' }, component: loggedIn(_index4.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/messages',
	                    params: { container: 'container-white' },
	                    component: loggedIn(hasFeature('messageServices')(_MessageScene2.default))
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/faq', component: loggedIn(_FAQ2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/i18', component: loggedIn(_I2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/stats', component: loggedIn(_WidgetListStatsByUser2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/summary/client', component: loggedIn(_ClientSummary2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/summary/widgets', component: loggedIn(_WidgetsSummary2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/account', params: { container: 'container-white' }, component: loggedIn(_Account2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/account/defaults',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_AccountDefaults2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/account/password',
	                    params: { container: 'container' },
	                    component: loggedIn(_AccountPassword2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/pick', params: { container: 'container' }, component: loggedIn(_WidgetPick2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/create/:widgetId', component: loggedIn(_WidgetCustomizer2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/:widgetId/customize', params: { disableFooter: true }, onEnter: requireAuth }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/widgets/:widgetId/customizer',
	                    params: { disableFooter: true },
	                    component: loggedIn(_WidgetCustomizer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/:wiid/statistics', component: loggedIn(_WidgetStatsByWIID2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/:widgetId/demo', component: loggedIn(_WidgetDemo2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/themes',
	                    params: { container: 'container-white', isHidden: false },
	                    component: loggedIn(_ThemesList2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/themes/hidden',
	                    params: { container: 'container-white', isHidden: true },
	                    component: loggedIn(_ThemesList2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/themes/:themeId/customize',
	                    params: { disableFooter: true },
	                    component: loggedIn(_ThemeCustomizer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/themes/:themeId/customizer',
	                    params: { disableFooter: true },
	                    component: loggedIn(_ThemeCustomizer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/themes/:themeId/customizer/:widgets',
	                    params: { disableFooter: true },
	                    component: loggedIn(_ThemeCustomizer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/widgets/:widgetId/show-case/:name', component: loggedIn(_WidgetDemo2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/sm/templates',
	                    params: { disableFooter: true, container: 'container-white', isHidden: false },
	                    component: loggedIn(_TemplatesList2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/sm/templates/hidden',
	                    params: { disableFooter: true, container: 'container-white', isHidden: true },
	                    component: loggedIn(_TemplatesList2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/sm/templates/create',
	                    params: { disableFooter: true },
	                    component: loggedIn(_TemplateCustomizer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/sm/templates/edit', params: { disableFooter: true }, component: _TemplateCustomizer2.default }),
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: '/portfolio' },
	                    _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'default' }),
	                    _react2.default.createElement(_reactRouter.Route, { path: ':type', component: _WidgetPortfolio2.default })
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: '/editor', component: loggedIn(DarkFullPageContainer) },
	                    _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'pick/all' }),
	                    _react2.default.createElement(_reactRouter.Route, { path: 'pick', components: _WidgetPickerPage2.default }),
	                    _react2.default.createElement(_reactRouter.Route, { path: 'pick/:tab', components: _WidgetPickerPage2.default }),
	                    _react2.default.createElement(_reactRouter.Route, { path: ':widgetId/:tab', components: _WidgetEditPage2.default }),
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        { path: ':widgetId' },
	                        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'layout' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    {
	                        path: '/sm/browser',
	                        params: { doubleAppBar: true },
	                        components: { main: _SMBrowser2.default, menu: _SMBrowser.SMBrowserMenu },
	                        onEnter: requireSocialAuth
	                    },
	                    _react2.default.createElement(_reactRouter.Route, {
	                        path: 'post',
	                        component: loggedIn(_SMPostPage2.default),
	                        params: { container: 'container', disableTemplateChange: true }
	                    }),
	                    _react2.default.createElement(_reactRouter.Route, {
	                        path: 'post/:widgetId',
	                        component: loggedIn(_SMPostPage2.default),
	                        params: { container: 'container', disableTemplateChange: true }
	                    }),
	                    _react2.default.createElement(_reactRouter.Route, { path: 'f1', component: loggedIn(_F1HomeSMBrowser2.default), params: { sport: 'f1' } }),
	                    _react2.default.createElement(_reactRouter.Route, { path: 'f1/:gpId', component: loggedIn(_F1GPXSMBrowser2.default), params: { sport: 'f1' } }),
	                    _react2.default.createElement(_reactRouter.Route, { path: 'f1/gpx/:gpId', component: loggedIn(_F1GPXSMBrowser2.default), params: { sport: 'f1' } }),
	                    _react2.default.createElement(_reactRouter.Route, { path: ':sport', component: loggedIn(_SportHomeSMBrowser2.default) }),
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        {
	                            path: ':sport/tournaments/:tournamentId',
	                            params: { doubleAppBar: true },
	                            components: loggedIn(_TournamentSMBrowser2.default),
	                            onEnter: requireSocialAuth
	                        },
	                        _react2.default.createElement(
	                            _reactRouter.Route,
	                            { path: ':seasonId' },
	                            _react2.default.createElement(
	                                _reactRouter.Route,
	                                { path: 'team/:teamId', components: loggedIn(_TeamHostSMB2.default) },
	                                _react2.default.createElement(_reactRouter.Route, { path: 'home', component: loggedIn(_TeamSeasonHomeSMB2.default) }),
	                                _react2.default.createElement(_reactRouter.Route, { path: 'stats', component: loggedIn(_TeamSeasonStatsSMB2.default) }),
	                                _react2.default.createElement(
	                                    _reactRouter.Route,
	                                    { path: 'squad' },
	                                    _react2.default.createElement(_reactRouter.IndexRoute, { component: loggedIn(_TeamSquadSMB2.default) }),
	                                    _react2.default.createElement(
	                                        _reactRouter.Route,
	                                        { path: 'players/:playerId', components: loggedIn(_PlayerHostSMB2.default) },
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'home', component: loggedIn(_PlayerSeasonSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'compare', component: loggedIn(_PlayerH2HSeasonSMB2.default) })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactRouter.Route,
	                                { path: 'stages/:stageId', component: loggedIn(_TournamentStageHost2.default) },
	                                _react2.default.createElement(
	                                    _reactRouter.Route,
	                                    { path: 'rounds/:round', component: loggedIn(_TournamentRoundHost2.default) },
	                                    _react2.default.createElement(
	                                        _reactRouter.Route,
	                                        { path: 'events/:eventId', component: loggedIn(_EventHost2.default) },
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'home', component: loggedIn(_EventSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'stats', component: loggedIn(_EventStatsSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'incidents', component: loggedIn(_EventIncidentsSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'lineup', component: loggedIn(_EventLineupSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'bookie', component: loggedIn(_EventBookieSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, { path: 'team-form', component: loggedIn(_EventTeamFormSMB2.default) }),
	                                        _react2.default.createElement(_reactRouter.Route, {
	                                            path: 'best-players',
	                                            component: loggedIn(_EventPlayerPerformanceSMB2.default)
	                                        }),
	                                        _react2.default.createElement(_reactRouter.Route, {
	                                            path: ':other',
	                                            component: function component(_ref2) {
	                                                var params = _ref2.params;
	                                                return _react2.default.createElement(
	                                                    'h1',
	                                                    null,
	                                                    params.other,
	                                                    ' page is under construction'
	                                                );
	                                            }
	                                        }),
	                                        _react2.default.createElement(_reactRouter.IndexRoute, { component: loggedIn(_EventSMB2.default) })
	                                    ),
	                                    _react2.default.createElement(_reactRouter.IndexRoute, { component: loggedIn(_TournamentRoundSMB2.default) })
	                                ),
	                                _react2.default.createElement(_reactRouter.IndexRoute, { component: loggedIn(_TournamentStageSMB2.default) })
	                            ),
	                            _react2.default.createElement(_reactRouter.IndexRoute, { component: loggedIn(_TournamentHomeSMB2.default) })
	                        ),
	                        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'current' })
	                    )
	                ),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/facts',
	                    params: { disableFooter: true, container: 'container-white' },
	                    component: loggedIn(_FactsView2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/media/uploads',
	                    params: { disableFooter: true, container: 'container-white' },
	                    component: loggedIn(_ImageUploaderContainer2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/ids-finder/:sport/tournaments',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_IDSTournaments2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/ids-finder/:sport/tournaments/:tournamentId',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_IDSTournament2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/ids-finder/:sport/teams/:teamId',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_IDSTeam2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/mapping/:source',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_ProviderIds2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/tv-program',
	                    params: { container: 'container-white' },
	                    component: loggedIn(_TvProgramDashboard2.default)
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/grid-maker-tool',
	                    component: loggedIn(_index2.default),
	                    params: { container: 'container-white' }
	                }),
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: '/admin/packs', component: loggedIn(_PacksScene2.default) },
	                    _react2.default.createElement(_reactRouter.Route, { path: ':packId', component: _Pack2.default }),
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _PacksList2.default })
	                ),
	                _react2.default.createElement(_reactRouter.Route, { path: '/admin/users-packs', component: loggedIn(_UsersPacksDashboard2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/admin/widgets-dashboard(/:widgetId)', component: loggedIn(_WidgetDashboard2.default) }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/admin/common-i18-dashboard', component: loggedIn(_CommonI18DashboardIndex2.default) }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/ppi',
	                    component: loggedIn(_PlayerPerformanceIndex2.default),
	                    params: { container: 'container-white' }
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/admin/accounts/edit/:username',
	                    params: { container: 'container-white' },
	                    component: loggedIn(isAdmin(_UpdateAccount2.default))
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/admin/accounts/create',
	                    params: { container: 'container-white' },
	                    component: loggedIn(isAdmin(_CreateAccount2.default))
	                }),
	                _react2.default.createElement(_reactRouter.Route, {
	                    path: '/admin/accounts',
	                    params: { container: 'container-white' },
	                    component: loggedIn(isAdmin(_AccountsList2.default))
	                }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/odds(/:eventId)', component: _odds.OddsScene }),
	                _react2.default.createElement(_reactRouter.Route, { path: '*', component: NoMatch })
	            )
	        )
	    ), htmlRoot);
	}

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getStore = undefined;
	
	var _redux = __webpack_require__(260);
	
	var _reduxThunk = __webpack_require__(296);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouterRedux = __webpack_require__(297);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _actionTypes = __webpack_require__(337);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _user = __webpack_require__(340);
	
	var _reducers = __webpack_require__(341);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _selectors = __webpack_require__(618);
	
	var _middlewares = __webpack_require__(634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authMiddleware = function authMiddleware(store) {
	    return function (next) {
	        return function (action) {
	            next(action);
	            if ((action.type === _reduxQuery.actionTypes.REQUEST_FAILURE || action.type === _actionTypes2.default.REQUEST_FAILURE) && action.status === 401) {
	                _auth2.default.logout();
	                store.dispatch({ type: _user.USER_ACTIONS.LOGOUT });
	            }
	        };
	    };
	};
	
	var reduxRouterMiddleware = (0, _reactRouterRedux.syncHistory)(_reactRouter.browserHistory);
	
	var getStore = exports.getStore = function getStore() {
	    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var middleware = [_reduxThunk2.default, (0, _reduxQuery.queryMiddleware)(_selectors.getQueries, _selectors.getEntities), authMiddleware, reduxRouterMiddleware, _middlewares.generateLineUp, _middlewares.postLineUp];
	    var enhancers = [];
	
	    var composeEnhancers = _redux.compose;
	
	    if (false) {
	        var composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
	        if (typeof composeWithDevToolsExtension === 'function') {
	            composeEnhancers = composeWithDevToolsExtension;
	        }
	    }
	    var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers.apply(undefined, [_redux.applyMiddleware.apply(undefined, middleware)].concat(enhancers)));
	    return store;
	};
	
	exports.default = getStore();

/***/ },
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var prefix = 'requery/';
	
	exports.default = {
	    REQUEST_START: prefix + 'REQUEST_START',
	    REQUEST_SUCCESS: prefix + 'REQUEST_SUCCESS',
	    REQUEST_FAILURE: prefix + 'REQUEST_FAILURE'
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Auth = function () {
	    function Auth() {
	        _classCallCheck(this, Auth);
	
	        this._user = null;
	        this._token = null;
	    }
	
	    _createClass(Auth, [{
	        key: 'saveUser',
	        value: function saveUser(user) {
	            user.props = _lodash2.default.reduce(user.defaultProps, function (memo, p) {
	                try {
	                    memo[p.key] = JSON.parse(p.value);
	                } catch (e2) {
	                    memo[p.key] = p.value;
	                }
	                return memo;
	            }, { lang: 'en' });
	
	            var serializedUser = JSON.stringify(user);
	            localStorage.setItem('user', serializedUser);
	            this._user = user;
	        }
	    }, {
	        key: 'getUser',
	        value: function getUser() {
	            if (this._user) return this._user;
	
	            var serializedUser = localStorage.getItem('user');
	            if (!serializedUser) return null;
	            this._user = JSON.parse(serializedUser);
	
	            return this._user;
	        }
	    }, {
	        key: 'saveAccessToken',
	        value: function saveAccessToken(token) {
	            localStorage.setItem('accessToken', token);
	            this._token = token;
	            return this._token;
	        }
	    }, {
	        key: 'getAccessToken',
	        value: function getAccessToken() {
	            return this._token || localStorage.getItem('accessToken');
	        }
	    }, {
	        key: 'logout',
	        value: function logout(cb) {
	            localStorage.removeItem('user');
	            localStorage.removeItem('accessToken');
	            this._token = null;
	            this._user = null;
	        }
	    }, {
	        key: 'loggedIn',
	        value: function loggedIn() {
	            return Boolean(this.getAccessToken() && this.getUser());
	        }
	    }, {
	        key: 'hasAdminRights',
	        value: function hasAdminRights() {
	            return this.loggedIn() && (this.getUser().roles || []).indexOf('admin') >= 0;
	        }
	    }]);
	
	    return Auth;
	}();
	
	var service = new Auth();
	if (false) {
	    window.auth = service;
	}
	exports.default = new Auth();

/***/ },
/* 339 */,
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.USER_ACTIONS = undefined;
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_ACTIONS = exports.USER_ACTIONS = {
	    LOGIN: 'user/ADD',
	    UPDATE: 'user/UPDATE',
	    LOGOUT: 'user/REMOVE'
	};
	
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _auth2.default.getUser();
	    var action = arguments[1];
	    var type = action.type,
	        payload = action.payload;
	
	
	    switch (type) {
	        case USER_ACTIONS.LOGIN:
	        case USER_ACTIONS.UPDATE:
	            return payload;
	        case USER_ACTIONS.LOGOUT:
	            return null;
	        default:
	            return state;
	    }
	};
	
	exports.default = reducer;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(260);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _reactRouterRedux = __webpack_require__(297);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reducer = __webpack_require__(572);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _user = __webpack_require__(340);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _reducer3 = __webpack_require__(573);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _ui = __webpack_require__(574);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _reducer5 = __webpack_require__(575);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__(577);
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__(582);
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__(584);
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _pagination = __webpack_require__(586);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _actions = __webpack_require__(587);
	
	var _reducer13 = __webpack_require__(595);
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__(613);
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__(616);
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = (0, _redux.combineReducers)({
	    entities: _reduxQuery.entitiesReducer,
	    queries: _reduxQuery.queriesReducer
	});
	//ToDo: topScorersReducer create a separate store !
	
	var routing = function routing() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { location: _reactRouter.browserHistory.getCurrentLocation() };
	    var action = arguments[1];
	    return (0, _reactRouterRedux.routeReducer)(state, action);
	};
	
	//ToDo: topScorersReducer create a separate store !!
	exports.default = (0, _redux.combineReducers)({
	    oddsSelection: _actions.oddsSelection.buildReducer('oddsSelection'),
	    pagination: _pagination2.default,
	    routing: routing,
	    query: query,
	    requery: _reducer2.default,
	    form: _reduxForm.reducer,
	    user: _user2.default,
	    ui: _ui2.default,
	    smBrowser: _reducer4.default,
	    packs: _reducer6.default,
	    makerToolPage: _reducer8.default,
	    ppi: _reducer10.default,
	    commonI18Dashboard: _reducer12.default,
	    editor: _reducer14.default,
	    portfolio: _reducer18.default,
	    widgetPicker: _reducer16.default
	});

/***/ },
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(337);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	    entities: {},
	    queries: {},
	    list: {}
	};
	
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	    var type = action.type;
	
	    switch (type) {
	        case _actionTypes2.default.REQUEST_START:
	            {
	                var queryKey = action.queryKey,
	                    url = action.url;
	
	                state.queries[queryKey] = {
	                    isPending: true,
	                    isFinished: false,
	                    url: url
	                };
	                return state;
	            }
	        case _actionTypes2.default.REQUEST_SUCCESS:
	            {
	                var entities = action.entities,
	                    list = action.list,
	                    _queryKey = action.queryKey,
	                    status = action.status;
	
	                return {
	                    list: list,
	                    entities: entities,
	                    queries: _extends({}, state.queries, _defineProperty({}, _queryKey, {
	                        url: state.queries[_queryKey].url,
	                        isFinished: true,
	                        isPending: false,
	                        status: status
	                    }))
	                };
	            }
	        case _actionTypes2.default.REQUEST_FAILURE:
	            {
	                var _queryKey2 = action.queryKey,
	                    _status = action.status;
	
	                return _extends({}, state, {
	                    queries: _extends({}, state.queries, _defineProperty({}, _queryKey2, {
	                        url: state.queries[_queryKey2].url,
	                        isFinished: true,
	                        isPending: false,
	                        status: _status
	                    }))
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	exports.default = reducer;

/***/ },
/* 573 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ACTIONS = exports.ACTIONS = {
	    loadTournament: 'ui/CHANGE'
	};
	
	var defaultState = {
	    tournament: null,
	    seasonId: null,
	    season: null,
	
	    nearestEvents: [],
	    hashImagePreviewEnable: true,
	    hashImagePreviewFailedCount: 0,
	    event: null,
	    team: null,
	
	    widgets: [],
	    templates: []
	};
	
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    var type = action.type,
	        payload = action.payload;
	
	
	    switch (action.type) {
	        case 'initLoad':
	            return _extends({}, state, payload);
	        case 'hashPreviewFailed':
	            var hashImagePreviewFailedCount = state.hashImagePreviewFailedCount + 1;
	            var hashImagePreviewEnable = hashImagePreviewFailedCount <= 3;
	            return _extends({}, state, { hashImagePreviewFailedCount: hashImagePreviewFailedCount, hashImagePreviewEnable: hashImagePreviewEnable });
	        case 'eventLoaded':
	            return _extends({}, state, { event: payload });
	        case 'bulk':
	            return _extends({}, state, payload);
	        default:
	            return state;
	    }
	};
	
	exports.default = reducer;

/***/ },
/* 574 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var UI_ACTIONS = exports.UI_ACTIONS = {
	    CHANGE: 'ui/CHANGE'
	};
	
	var defaultState = {
	    devEdit: true // process.env.NODE_ENV === 'dev'
	};
	
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    var key = action.key,
	        value = action.value,
	        type = action.type;
	
	    switch (type) {
	        case UI_ACTIONS.CHANGE:
	            return _extends({}, state, _defineProperty({}, key, value));
	        default:
	            return state;
	    }
	};
	
	exports.default = reducer;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(576);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var packsDefault = {
	    filterWidgetsText: '',
	    editPackId: '',
	    editPackWidgets: [],
	    isEditPackWidgets: false,
	    resetPackWidgets: 0
	};
	
	exports.default = function () {
	    var packs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : packsDefault;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	        case _constants.FILTER_WIDGETS_TEXT:
	            return _extends({}, packs, {
	                filterWidgetsText: payload.text
	            });
	        case _constants.GET_PACK_WIDGETS:
	            return _extends({}, packs, {
	                editPackId: payload.packId,
	                editPackWidgets: payload.widgets
	            });
	        case _constants.RESET_PACK_WIDGETS:
	            return _extends({}, packs, {
	                isEditPackWidgets: false,
	                resetPackWidgets: Math.random(Date.now)
	            });
	        case _constants.POST_PACK_WIDGET:
	            return _extends({}, packs, {
	                isEditPackWidgets: true,
	                editPackWidgets: [].concat(_toConsumableArray(packs.editPackWidgets), [payload.widgetId])
	            });
	        case _constants.DELETE_PACK_WIDGET:
	            return _extends({}, packs, {
	                isEditPackWidgets: true,
	                editPackWidgets: packs.editPackWidgets.filter(function (widgetId) {
	                    return widgetId !== payload.widgetId;
	                })
	            });
	        default:
	            return packs;
	    }
	};

/***/ },
/* 576 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILTER_WIDGETS_TEXT = exports.FILTER_WIDGETS_TEXT = 'FILTER_WIDGETS_TEXT';
	
	var GET_PACK_WIDGETS = exports.GET_PACK_WIDGETS = 'GET_PACK_WIDGETS';
	var RESET_PACK_WIDGETS = exports.RESET_PACK_WIDGETS = 'RESET_PACK_WIDGETS';
	var POST_PACK_WIDGET = exports.POST_PACK_WIDGET = 'POST_PACK_WIDGET';
	var DELETE_PACK_WIDGET = exports.DELETE_PACK_WIDGET = 'DELETE_PACK_WIDGET';

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _constants = __webpack_require__(578);
	
	var _constants2 = __webpack_require__(579);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var makerToolPageDefault = {
	    idLineUp: 0,
	    lineupType: '',
	    lineupTemplate: '',
	    searchInputText: '',
	    mapPitchPos: {},
	    activeParticipants: {},
	    customPitchLineupList: [],
	    pitchLineupStatus: '',
	    pitchLineupLoading: false
	};
	
	var generateMap = function generateMap(obj) {
	    return Object.entries(obj).reduce(function (acc, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            key = _ref2[0],
	            curr = _ref2[1];
	
	        return _extends({}, acc, _defineProperty({}, curr.positionCode, key));
	    }, {});
	};
	
	var filterPos = function filterPos(obj, pos) {
	    return Object.entries(obj).reduce(function (acc, _ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            key = _ref4[0],
	            val = _ref4[1];
	
	        if (parseInt(val.positionCode, 10) === parseInt(pos, 10)) {
	            return _extends({}, acc);
	        }
	
	        return _extends({}, acc, _defineProperty({}, key, val));
	    }, {});
	};
	
	exports.default = function () {
	    var makerToolPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makerToolPageDefault;
	    var _ref5 = arguments[1];
	    var type = _ref5.type,
	        payload = _ref5.payload;
	
	    switch (type) {
	        case _constants2.SET + _constants.ID_LINEUP:
	            return _extends({}, makerToolPage, { idLineUp: payload.idLineUp });
	        case _constants.SEARCH_INPUT_TEXT:
	            return _extends({}, makerToolPage, { searchInputText: payload.text });
	        case _constants2.SET + _constants.LINEUP_TYPE:
	            return _extends({}, makerToolPage, { lineupType: payload.type });
	        case _constants2.SET + _constants.LINEUP_TEMPLATE:
	            return _extends({}, makerToolPage, { lineupTemplate: payload.template });
	        case _constants2.SET + _constants.PARTICIPANT_CUSTOM_NAME:
	            return _extends({}, makerToolPage, {
	                activeParticipants: _extends({}, makerToolPage.activeParticipants, _defineProperty({}, payload.id, _extends({}, makerToolPage.activeParticipants[payload.id], { name: payload.text })))
	            });
	        case _constants2.SET + _constants.PARTICIPANT_CUSTOM_TEXT:
	            return _extends({}, makerToolPage, {
	                activeParticipants: _extends({}, makerToolPage.activeParticipants, _defineProperty({}, payload.id, _extends({}, makerToolPage.activeParticipants[payload.id], { customText: payload.text })))
	            });
	        case _constants2.SET + _constants.PARTICIPANT_PITCH:
	            {
	                var activeParticipants = filterPos(makerToolPage.activeParticipants, payload.position);
	
	                activeParticipants = _extends({}, activeParticipants, _defineProperty({}, payload.participant.id, _extends({}, payload.participant, { positionCode: payload.position })));
	
	                return _extends({}, makerToolPage, {
	                    activeParticipants: activeParticipants,
	                    mapPitchPos: generateMap(activeParticipants)
	                });
	            }
	        case _constants2.DELETE + _constants.PARTICIPANT_PITCH:
	            {
	                var _activeParticipants = filterPos(makerToolPage.activeParticipants, payload.position);
	
	                return _extends({}, makerToolPage, {
	                    activeParticipants: _activeParticipants,
	                    mapPitchPos: generateMap(_activeParticipants)
	                });
	            }
	        case _constants2.GENERATE + _constants.PARTICIPANT_PITCH:
	            {
	                var customPitchLineupList = [];
	                var lineupTemplate = makerToolPage.lineupTemplate.split('-').map(function (item) {
	                    return parseInt(item, 10);
	                });
	                var lineupTemplateLength = lineupTemplate.length;
	
	                for (var row = 1; row <= lineupTemplateLength; row++) {
	                    for (var item = 1; item <= lineupTemplate[row - 1]; item++) {
	                        var customPitchLineupItem = makerToolPage.activeParticipants[makerToolPage.mapPitchPos['' + row + item]];
	
	                        if (customPitchLineupItem) {
	                            customPitchLineupList.push(customPitchLineupItem);
	                        } else {
	                            customPitchLineupList.push({
	                                id: Math.floor(10000 + Math.random() * 90000),
	                                name: 'Unknown',
	                                positionCode: '' + row + item,
	                                customText: '',
	                                unknown: true
	                            });
	                        }
	                    }
	                }
	
	                return _extends({}, makerToolPage, { customPitchLineupList: customPitchLineupList });
	            }
	        case _constants2.SET + _constants.PITCH_LINEUP_TEMPLATE:
	            {
	                var _activeParticipants2 = payload.template.reduce(function (acc, curr) {
	                    return curr.unknown ? _extends({}, acc) : _extends({}, acc, _defineProperty({}, curr.id, curr));
	                }, {});
	
	                return _extends({}, makerToolPage, {
	                    activeParticipants: _activeParticipants2,
	                    mapPitchPos: generateMap(_activeParticipants2),
	                    customPitchLineupList: payload.template
	                });
	            }
	        case _constants2.POST + _constants.PARTICIPANT_PITCH + _constants2.START:
	            return _extends({}, makerToolPage, { pitchLineupLoading: true });
	        case _constants2.POST + _constants.PARTICIPANT_PITCH + _constants2.SUCCESS:
	            return _extends({}, makerToolPage, { pitchLineupStatus: 'success', pitchLineupLoading: false });
	        case _constants2.POST + _constants.PARTICIPANT_PITCH + _constants2.FAIL:
	            return _extends({}, makerToolPage, { pitchLineupStatus: 'fail', pitchLineupLoading: false });
	        default:
	            return makerToolPage;
	    }
	};

/***/ },
/* 578 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ID_LINEUP = exports.ID_LINEUP = 'ID_LINEUP';
	var LINEUP_TYPE = exports.LINEUP_TYPE = 'LINEUP_TYPE';
	var LINEUP_TEMPLATE = exports.LINEUP_TEMPLATE = 'LINEUP_TEMPLATE';
	var SEARCH_INPUT_TEXT = exports.SEARCH_INPUT_TEXT = 'SEARCH_INPUT_TEXT';
	var PARTICIPANT_PITCH = exports.PARTICIPANT_PITCH = 'PARTICIPANT_PITCH';
	var PITCH_LINEUP_TEMPLATE = exports.PITCH_LINEUP_TEMPLATE = 'PITCH_LINEUP_TEMPLATE';
	var PARTICIPANT_CUSTOM_NAME = exports.PARTICIPANT_CUSTOM_NAME = 'PARTICIPANT_CUSTOM_NAME';
	var PARTICIPANT_CUSTOM_TEXT = exports.PARTICIPANT_CUSTOM_TEXT = 'PARTICIPANT_CUSTOM_TEXT';

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAIL = exports.SUCCESS = exports.START = exports.DELETE = exports.PUT = exports.POST = exports.SET = exports.GET = exports.GENERATE = exports.FINISHED_REQ_DELAY = exports.LOADING_COLOR = exports.LOADING_CLASSNAME = exports.TIMEZONE_BUTTONS = exports.POST_STATUS = exports.NOTIFICATION_TYPES = exports.LANGUAGES = exports.PRESENTATION_TYPES = exports.CAMPAIGN_FORM_KEYS = exports.MANUAL_POST_FORM_ID = exports.MANUAL_TRIGGER_FORM_ID = exports.WIZZARD_FORM_ID = exports.CAMPAIGN_FORM_ID = exports.STORE_KEYS = exports.SMLINKS_BY_USER_ID = exports.SOCIAL_NETWORKS = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SOCIAL_NETWORKS = exports.SOCIAL_NETWORKS = [{
	    title: 'TW',
	    getAddress: function getAddress(client) {
	        return _cfg2.default.apis.smpg + '/twitter/connect?client=' + client + '&service=any';
	    },
	    key: 'tw',
	    label: 'Add twitter account'
	}, {
	    title: 'FB',
	    getAddress: function getAddress(client) {
	        return _cfg2.default.apis.smpg + '/facebook/connect?client=' + client + '&service=any';
	    },
	    key: 'fb',
	    label: 'Add fb page'
	}, {
	    title: 'TG',
	    getAddress: function getAddress(client) {
	        return _cfg2.default.apis.smpg + '/telegram/connect?client=' + client + '&service=any';
	    },
	    key: 'telegram',
	    label: 'Add telegram channel'
	}, {
	    title: 'LB',
	    getAddress: function getAddress(client) {
	        return _cfg2.default.apis.smpg + '/liveblog/connect?client=' + client + '&service=any';
	    },
	    key: 'liveblog',
	    label: 'Add live blog'
	}];
	
	var SMLINKS_BY_USER_ID = exports.SMLINKS_BY_USER_ID = _cfg2.default.apis.smpg + '/smlinks';
	
	var STORE_KEYS = exports.STORE_KEYS = {
	    SMLINKS: 'smlinks',
	    WIDGET_SPECS: 'widget-specs',
	    TEMPLATES: 'templates',
	    TEMPLATE_BY_ID: 'templatesById',
	    PORTFOLIO: 'portfolio',
	    CAMPAIGNS: 'campaigns',
	    TOURNAMENTS: 'tournaments',
	    EVENTS: 'events',
	    TEAMS: 'teams',
	    POSTS: 'posts',
	    BY_ID: 'ById'
	};
	
	/**
	 * Redux form constants
	 */
	var CAMPAIGN_FORM_ID = exports.CAMPAIGN_FORM_ID = 'campaign';
	var WIZZARD_FORM_ID = exports.WIZZARD_FORM_ID = 'campaign-wizzard';
	var MANUAL_TRIGGER_FORM_ID = exports.MANUAL_TRIGGER_FORM_ID = 'manual-trigger';
	var MANUAL_POST_FORM_ID = exports.MANUAL_POST_FORM_ID = 'manual-post';
	
	var CAMPAIGN_FORM_KEYS = exports.CAMPAIGN_FORM_KEYS = {
	    TITLE: 'title',
	    ACTIVE: 'active',
	    TIMEZONE: 'timezone',
	    LANGUAGE: 'language',
	    NOTIFICATIONS: {
	        ARRAY: 'notificationsTo',
	        TYPE: 'type',
	        VALUE: 'value'
	    },
	    TEMPLATE: 'template',
	    START_DATE: 'startDate',
	    END_DATE: 'endDate',
	    CALENDAR: 'calendar',
	    MODERATION: 'moderation',
	    USER_ID: 'userId',
	    TARGETS: {
	        ARRAY: 'targets',
	        TYPE: 'type',
	        VALUE: 'value'
	    },
	    RULES: {
	        ARRAY: 'rules',
	        KEY: 'triggerType',
	        CONDITIONS: {
	            ARRAY: 'conditions'
	        }
	    },
	    WIDGET: {
	        SECTION: 'presentation',
	        TYPE: 'type',
	        NAME: 'name',
	        PARAMS: {
	            SECTION: 'params',
	            USER: 'user',
	            CLIENT: 'client',
	            THEME: 'theme',
	            TEMPLATE: 'template',
	            ADDITIONAL: {
	                ARRAY: 'additional',
	                KEY: 'key',
	                VALUE: 'value',
	                BY_TRIGGER: 'byTrigger',
	                CUSTOM_VALUE: 'customValue'
	            }
	        },
	        TRIGGER_PARAMS: {
	            SECTION: 'triggerMappings'
	        }
	    }
	};
	
	var PRESENTATION_TYPES = exports.PRESENTATION_TYPES = {
	    WIDGET: 'widget-social'
	};
	
	var LANGUAGES = exports.LANGUAGES = [{
	    name: 'Dansk',
	    key: 'da'
	}, {
	    name: 'English',
	    key: 'en'
	}, {
	    name: 'Norwegian',
	    key: 'no'
	}, {
	    name: 'German',
	    key: 'de'
	}, {
	    name: 'Finnish',
	    key: 'fi'
	}];
	
	var NOTIFICATION_TYPES = exports.NOTIFICATION_TYPES = [{
	    key: 'email',
	    name: 'Email'
	}];
	
	var POST_STATUS = exports.POST_STATUS = {
	    AWAITING: 'awaiting_for_moderation',
	    PUBLISHED: 'finished',
	    NOT_PUBLISHED: 'not-published',
	    IN_PROGRESS: 'inprogress',
	    REJECTED: 'rejected',
	    FAILED: 'failed'
	};
	
	var TIMEZONE_BUTTONS = exports.TIMEZONE_BUTTONS = ['Europe/Copenhagen', 'Europe/Oslo', 'Europe/Stockholm'];
	
	var LOADING_CLASSNAME = exports.LOADING_CLASSNAME = 'show-loading-animation';
	var LOADING_COLOR = exports.LOADING_COLOR = '#ccc';
	var FINISHED_REQ_DELAY = exports.FINISHED_REQ_DELAY = 700;
	
	var GENERATE = exports.GENERATE = 'GENERATE_';
	
	var GET = exports.GET = 'GET_';
	var SET = exports.SET = 'SET_';
	
	var POST = exports.POST = 'POST_';
	var PUT = exports.PUT = 'PUT_';
	var DELETE = exports.DELETE = 'DELETE_';
	
	var START = exports.START = '_START';
	var SUCCESS = exports.SUCCESS = '_SUCCESS';
	var FAIL = exports.FAIL = '_FAIL';

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Linkr = __webpack_require__(581);
	var config = ({"env":"prod","stanbol":{"ss":{"url":"http://52.31.186.23:8082"}},"@mongodb":"mongodb://localhost:27001/swp_test","mongodb":"mongodb://172.10.2.181:27017/wdp","mongodb_stage":"mongodb://localhost:27001/swp","mongodb_smpg":"mongodb://172.10.2.181:27017/smpg","mongodb_sport":"mongodb://localhost:27001/sportservice","jwt":{"secretKey":"releaze.sportInnovations"},"smb":{"url":"http://127.0.0.1:3001","port":3001},"widgets":{"url":"https://widgets.tjekscores.dk","@@url":"http://127.0.0.1:3003","@url":"http://3308b256.ngrok.io","port":80,"version":"0.3.1","libversion":"1.0.3"},"ab":{"widgets":{"url":"https://api.si-ab.com","stageUrl":"https://api-stage.si-ab.com"}},"injector":{"version":"0.3.1"},"assets":"https://cdn.tjekscores.dk/wdp/prod","@assets":"https://cdn.tjekscores.dk/wdp/prod","dev-server":{"port":8080},"apis":{"ss2":"https://ss2.si-ab.com","webshot":"https://webshot-prod.tjekscores.dk","@html2video":"http://127.0.0.1:8888","html2video":"https://html2video.tjekscores.dk","facts":"http://facts-api-stage-1556505486.eu-west-1.elb.amazonaws.com","smpg":"https://smpg.tjekscores.dk","@@smpg":"http://local.tjekscores.dk:8083","@smpg":"http://127.0.0.1:8083","ps":"https://ps.tjekscores.dk","@webshot":"http://wdp-webshot-prod-916696882.eu-west-1.elb.amazonaws.com","@webshot2":"https://webshot-prod.tjekscores.dk"},"swpe":{"contet.length.limit":50000},"dash":{"version":"0.3.1.2","api":{"port":80,"host":"https://wdp.tjekscores.dk","@host":"http://831330d1.ngrok.io"}},"urls":{"publicPath":"https://cdn.tjekscores.dk/wdp/prod","@publicPath":"https://cdn.tjekscores.dk/wdp/prod"},"cdn":{"key":"AKIAQ55RLMP2KPZ3SVBS","secret":"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","bucket":"rlz.cdn","region":"eu-west-1","cloudfront":"E1SANLH6LGD2L8","s3Url":"https://s3-eu-west-1.amazonaws.com","cdnUrl":"https://cdn.tjekscores.dk"},"rabbitmq":{"@url":"amqp://rlz:admin@rabbit-prod-1023334297.eu-west-1.elb.amazonaws.com:5672","url":"amqps://admin:adminadminadmin@b-8ea2cde3-dba5-496d-90a6-c7953532fb63.mq.eu-west-1.amazonaws.com:5671"},"campaign_manager":{"loggerKey":"b39a96b6-f436-4243-8aa0-b21ca2f0c6f4","host":"https://cmp.tjekscores.dk","port":8011,"secretKey":"campaignManagerNotifications"},"bots":{"messenger":{"pageId":"674145922790588","appId":"262143280946125","api":"http://social-bot-stage.tjekscores.dk"}},"fbWDP":{"appId":"371836229679740"},"triggerer":{"host":"https://triggerer.si-ab.com","loggerKey":"ff9598cd-0150-4955-9e49-4ad88b0e3291","supportedLeagues":[46,47,85,42,242,73,9514],"supportedLeagues@":[38,40,42,46,47,48,50,51,53,54,55,57,58,59,60,61,62,63,64,65,67,68,69,71,73,74,77,85,86,87,108,109,110,112,113,114,117,120,122,123,124,125,126,130,132,133,134,135,136,137,138,139,140,141,143,145,146,149,150,151,161,164,165,166,168,171,172,176,177,186,189,192,193,195,196,198,203,206,207,209,212,213,214,215,217,222,223,235,237,239,242,245,247,256,263,266,278,288,289,290,298,299,9806,9807,9808,9809,78,268,8814,9067,9483,117,9478,9372,523,8974,224,9011,440,230,111,536,537,9080,9410,282,284,9227,9717,9676,9677,9089,331,9382,332,333,76,292,9579,9375,9787,9377,9379,293,9134,9500,9553,9495],"port":80},"stats_service":{"loggerKey":"a7dca39a-27a1-4307-b111-9970f89b563b"},"autoUpdateInterval":30,"ga":{"client_email":"150164870142-compute@developer.gserviceaccount.com","private_key":"-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC+M/IgFOyIxNLY\nRHWt03yuEYH0UOIDQEproKdnywF6AheJsSGZT6zWn7bm7B0um73rIuIK+45Iw4nI\neAWyJ3k5WqsJ52pTy/lEFdo0FhUQvAQDKXqZTJqF+jr0GhfZBbSq10YzjA4FCc8U\nFwd53a1I1EPJkoa5CuDqUG23YgGBmsieR90zWRJ2hsm0CBP3nG3ffxym/pYqkxSe\nsH3WNeXr7YZDffKbuBnfBfSgku3qlqbTHgE63ALTUV8/xu5wT8lOvlKDpVfHf6tT\nNAin8lTYn8Jzkb2K1kqkIKirv7LBJ4P3fi1QBUGWEFCT6FEAxme3/q7ArH9v//ZZ\n6w/EJmn7AgMBAAECggEAfnMme3Gtt1ezHRiWa9P4RflZvkWvnJ23XEpYQUbTWnvd\njir2vWgc7isMfAVpeT0NTC/Ku6Z196YYCfDRSJm5nAnNQC5boA4xT7R/drVfl9qH\niFqhKR2mdX/ghbx7Mkr6y8GG6GoqP+s/gom07K4VsB9+WZpSet7inKSP7KT5f2F0\nYf0iNIh/3fn0forR8SYz/LPBXGngdjqGFUQKN4Z3azYzusYeCIF8ZC9vk27NNGjq\n+BBR1uHNRNWsZjOdtXLU/XNN/uJr/wk1xsdp16zrLf+kUt+zSFUiVTlEBdaHvGoT\nqOasSsKMFFG2117Y9PF4RKWA5edqJqv93B8FOdTM4QKBgQDmorMAukxdwPN9MhKx\n2y0jtCK2m/1hg3m376w1VuySmfxgKy5IFF9AAMIeISvZRnm2DoaJuI51wsjbPnkK\nYi3r6ABNKjHhKno2Ru1mtu7Q4vcFexlJ8m1pTjwxikDrkOtRsSePlCxY5ySCevN0\nFXbvYgxqgsginowQJe6MIPrE0wKBgQDTHuiQXLyhfkZ3epg0gTxXcWNL0zbnTkER\nSgax+oRtsRH55JhUsbmI4X9h9LNyrciYEGcie2Iyb4A/Tuu+zDFuwBW/NJLDbCQW\nfG8lp4FmrpVAtddObRSew0lpokwD78Tl0NAFyENtvLHaYgP8Hq8nK2KEShB/8SgZ\n0E63vLqtOQKBgB1W2zCfgnF2x0LI6OnpON/O3Y+fXmdWQ1iry5tpeGTZ4+oT9CpF\nNSy+K/OLQrm8JmWLiX/hk3XVlpmVY+53OOJGvCsU0A2VysA226JyaQT3qnbvBvOK\nPHLl+fBPZxzQba8RuzefoNiaZuGWZHwC8wNW1L+D7ZPB2Y2AVc1LsLrzAoGAYKru\nYeuUk312Vo7T0na6Ym+Qv89efFrggEIc/rFuoatKR9nbxiv6gCqAYSHiaMgZ6UbZ\ncnh8ZguX9WT1nM9ycvuQ+ZPg/4osm/8uBVfFcHbP8GlSxJ49qtRQcQXXOJY42eHa\n3krsVPrplMz8dhy2poC/A0PGek65xdgTsx2/fEECgYBN+qKyfkO1y5xbQK61T/Da\nBPkA6eTOWsBhp3B3ge0b61CttgxTBOHqUAhxs31zWVLFAHlUV8vtwezgpLqqbtSB\nkh/DmEJh04kRX7DmVZS7DyloTBg6xXqocHiq80Wq7jWbdYLKmPWM0mlg1A60dbV7\nvxyhH5MtxmqEGkwFdBRTMA==\n-----END PRIVATE KEY-----\n"},"shortenerKey":"AIzaSyBSOeLTB6R1V7yqmDuCjQUPMgT_hHmEUSc","bitlyKey":"27634e94f4683bf78c7c7ae163023af56534537e","supportedLanguages":["en","da","se","de","fi","th","sc"],"bookmakers":[{"id":"none","name":"None"},{"id":"unibet","name":"Unibet"},{"id":"leovegas","name":"Leovegas"},{"id":"comeon","name":"Comeon"},{"id":"comeon__de","name":"Comeon/DE"},{"id":"betbull","name":"Betbull"}],"cdnLibs":{"@xgif":"http://cdn.tjekscores.dk/utils/x-gif.html","xgif":"http://s3-eu-west-1.amazonaws.com/rlz.cdn/utils/x-gif.html"},"webshotBrowser":"chrome"});
	config.WDPLinkr = new Linkr(config);
	config.build = {
	    git: { hash: ("1af80d9\n") },
	    env: ("prod")
	};
	
	exports.default = config;

/***/ },
/* 581 */
/***/ function(module, exports) {

	'use strict';
	
	var Linkr = function Linkr(cfg) {
	    var serialize = function serialize(obj) {
	        var str = [];
	        for (var p in obj) {
	            if (obj.hasOwnProperty(p)) {
	                if (obj[p] instanceof Array) {
	                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
	                } else if (obj[p] instanceof Object) {
	                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
	                } else {
	                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	                }
	            }
	        }return str.join('&');
	    };
	
	    // var C_ASSETS_URL        = config.assets;
	    return {
	        widget: {
	            iframe: function iframe(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgetName';
	
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/iframe?' + serialize(qs || {});
	            },
	            esi: function esi(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgeName';
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/esi?' + serialize(qs || {});
	            },
	            sm: function sm(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgeName';
	
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/sm?' + serialize(qs || {});
	            },
	            image: function image(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgeName';
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/hash-image?' + serialize(qs || {});
	            },
	            demo: function demo(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgeName';
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/demo-image?' + serialize(qs || {});
	            },
	            animated: function animated(client, user, theme, name, qs) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                name = name || '$widgeName';
	                return cfg.widgets.url + '/widget/' + [client, user, theme, name].join('/') + '/animated?' + serialize(qs || {});
	            },
	            scriptPath: function scriptPath(name) {
	                return cfg.assets + '/js/standalone/' + name + '.js?v=' + cfg.widgets.version;
	            }
	        },
	        injector: function injector() {
	            return cfg.assets + '/js/core/rlz-widget-injector.js?v=' + cfg.injector.version;
	        },
	        serialize: serialize,
	        client: {
	            cssPath: function cssPath(client, user, theme) {
	                client = client || 'core';
	                user = user || 'rlz';
	                theme = theme || 'default';
	                return cfg.assets + '/css/clients/' + client + '.' + user + '.' + theme + '.css?v=' + cfg.widgets.version;
	            }
	        }
	    };
	};
	
	module.exports = Linkr;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(583);
	
	var _constants2 = __webpack_require__(579);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// import { SET, DELETE, POST, GENERATE, START, SUCCESS, FAIL } from '../constants';
	
	var ppiDefault = {
	    playersWeights: {
	        goalkeeper: {},
	        forward: {},
	        defender: {},
	        midfielder: {}
	    },
	    typePlayersList: ['goalkeeper', 'defender', 'midfielder', 'forward'],
	    // tableRows: {
	    //     in_line_up: {
	    //         title: 'I startopstillingen',
	    //         label: 'in_line_up'
	    //     },
	    //     subbed_in: {
	    //         title: 'Indskiftet',
	    //         label: 'subbed_in'
	    //     },
	    //     clean_sheet: {
	    //         title: 'Rent Bur',
	    //         label: 'clean_sheet'
	    //     },
	    //     goal_assists: {
	    //         title: 'Assist',
	    //         label: 'goal_assists'
	    //     },
	    //     goals: {
	    //         title: 'Mål',
	    //         label: 'goals'
	    //     },
	    //     saved_penalty: {
	    //         title: 'Reddet straffe',
	    //         label: 'saved_penalty'
	    //     },
	    //     saves: {
	    //         title: 'Redning',
	    //         label: 'saves'
	    //     },
	    //     total_tackle: {
	    //         title: 'Nøgletackling',
	    //         label: 'total_tackle'
	    //     },
	    //     blocked_pass: {
	    //         title: 'Blokeringer',
	    //         label: 'blocked_pass'
	    //     },
	    //     total_clearance: {
	    //         title: 'Clearinger',
	    //         label: 'total_clearance'
	    //     },
	    //     duel_won: {
	    //         title: 'Vundne bolde',
	    //         label: 'duel_won'
	    //     },
	    //     total_scoring: {
	    //         title: 'Skud på mål',
	    //         label: 'total_scoring'
	    //     },
	    //     missed_penalty: {
	    //         title: 'Brændt straffespark',
	    //         label: 'missed_penalty'
	    //     },
	    //     yellow_card: {
	    //         title: 'Gult kort',
	    //         label: 'yellow_card'
	    //     },
	    //     red_card: {
	    //         title: 'Rødt kort',
	    //         label: 'red_card'
	    //     },
	    //     own_goals: {
	    //         title: 'Selvmål',
	    //         label: 'own_goals'
	    //     },
	    //     /////
	    //     punches: {
	    //         title: 'Punches',
	    //         label: 'punches'
	    //         // typePlayer: ''
	    //     },
	    //     att_freekick_goal: {
	    //         title: 'Mål scoret på frispark',
	    //         label: 'att_freekick_goal'
	    //     }
	    // },
	    tableRowList: ['home_win', 'away_win', 'draw', 'loosing_home', 'loosing_away', 'goals_against', 'minimum_goal_victory',
	    //
	    'in_line_up', 'subbed_in', 'clean_sheet', 'goal_assists', 'goals', 'saved_penalty', 'saves', 'total_tackle', 'blocked_pass', 'total_clearance', 'duel_won', 'total_scoring', 'missed_penalty', 'yellow_card', 'red_card', 'own_goals',
	    //
	    'punches', 'att_freekick_goal'],
	    tableRowVisibleList: []
	};
	
	exports.default = function () {
	    var ppi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ppiDefault;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	        case _constants2.POST + _constants.PPI_TABLE:
	            return ppi;
	        case _constants.LOAD_DEFAULT_PPI_WEIGHTS:
	            return _extends({}, ppi, { playersWeights: payload.playersWeights });
	        case _constants.LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST:
	            return _extends({}, ppi, { tableRowVisibleList: payload.list });
	        case _constants.ADD_PPI_TABLE_ROW:
	            {
	                if (!ppi.tableRowVisibleList.includes(payload.labelRow)) {
	                    return _extends({}, ppi, {
	                        tableRowVisibleList: [].concat(_toConsumableArray(ppi.tableRowVisibleList), [payload.labelRow])
	                    });
	                }
	
	                return ppi;
	            }
	        case _constants.DELETE_PPI_TABLE_ROW:
	            {
	                var playersWeights = _extends({}, ppi.playersWeights);
	
	                ppi.typePlayersList.forEach(function (pl) {
	                    if (playersWeights[pl]) {
	                        playersWeights[pl] = _extends({}, ppi.playersWeights[pl]);
	                        delete playersWeights[pl][payload.labelRow];
	                    }
	                });
	
	                return _extends({}, ppi, {
	                    playersWeights: playersWeights,
	                    tableRowVisibleList: [].concat(_toConsumableArray(ppi.tableRowVisibleList.filter(function (row) {
	                        return row !== payload.labelRow;
	                    })))
	                });
	            }
	        case _constants.CHANGE_PPI_TABLE_ITEM:
	            return _extends({}, ppi, {
	                playersWeights: _extends({}, ppi.playersWeights, _defineProperty({}, payload.typePlayer, _extends({}, ppi.playersWeights[payload.typePlayer], _defineProperty({}, payload.label, payload.value))))
	            });
	        default:
	            return ppi;
	    }
	};

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_DEFAULT_PPI_WEIGHTS = exports.LOAD_DEFAULT_PPI_WEIGHTS = 'LOAD_DEFAULT_PPI';
	var CHANGE_PPI_TABLE_ITEM = exports.CHANGE_PPI_TABLE_ITEM = 'CHANGE_PPI_TABLE_ITEM';
	var PPI_TABLE = exports.PPI_TABLE = 'PPI_TABLE';
	var ADD_PPI_TABLE_ROW = exports.ADD_PPI_TABLE_ROW = 'ADD_PPI_TABLE_ROW';
	var DELETE_PPI_TABLE_ROW = exports.DELETE_PPI_TABLE_ROW = 'DELETE_PPI_TABLE_ROW';
	var LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST = exports.LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST = 'LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST';

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _constants = __webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var commonI18DashboardDefault = {
	    supportedLanguages: _cfg2.default.supportedLanguages,
	    defaultLanguage: 'en',
	    secondaryLanguage: '',
	    i18: {},
	    statsDefault: {},
	    statsList: [],
	    LANGUAGES: {
	        en: 'English',
	        da: 'Danish',
	        no: 'Norwegian',
	        de: 'Deutsch',
	        fi: 'Finish',
	        th: 'Thai',
	        se: 'Swedish',
	        sc: 'Chinise simpl',
	        tc: 'Chinise trad'
	    }
	};
	
	exports.default = function () {
	    var commonI18Dashboard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : commonI18DashboardDefault;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	        case _constants.ADD_DEFAULT_COMMON_DICTIONARY:
	            {
	                var en = _extends({}, payload.commonDictionaryEn, payload.entities.i18.en);
	
	                return _extends({}, commonI18Dashboard, {
	                    i18: payload.entities.i18,
	                    statsDefault: en,
	                    statsList: Object.keys(en).sort()
	                });
	            }
	
	        case _constants.LOAD_COMMON_DICTIONARY:
	            {
	                var _en = payload.i18 && payload.i18.en || {};
	
	                return _extends({}, commonI18Dashboard, {
	                    i18: payload.i18,
	                    statsDefault: _en,
	                    statsList: Object.keys(_en).sort()
	                });
	            }
	
	        case _constants.SELECT_SECONDARY_LANG:
	            return _extends({}, commonI18Dashboard, {
	                secondaryLanguage: payload.lang
	            });
	
	        case _constants.CHANGE_I18_TABLE_ITEM:
	            {
	                var lang = payload.lang === 'secondary' ? commonI18Dashboard.secondaryLanguage : payload.lang;
	                var i18 = _extends({}, commonI18Dashboard.i18, _defineProperty({}, lang, _extends({}, commonI18Dashboard.i18[lang], _defineProperty({}, payload.label, payload.value))));
	
	                if (payload.value === '') {
	                    Reflect.deleteProperty(i18[lang], payload.label);
	                }
	
	                return _extends({}, commonI18Dashboard, {
	                    i18: i18
	                });
	            }
	
	        default:
	            return commonI18Dashboard;
	    }
	};

/***/ },
/* 585 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ADD_DEFAULT_COMMON_DICTIONARY = exports.ADD_DEFAULT_COMMON_DICTIONARY = 'ADD_DEFAULT_COMMON_DICTIONARY';
	var LOAD_COMMON_DICTIONARY = exports.LOAD_COMMON_DICTIONARY = 'LOAD_COMMON_DICTIONARY';
	var CHANGE_I18_TABLE_ITEM = exports.CHANGE_I18_TABLE_ITEM = 'CHANGE_I18_TABLE_ITEM';
	var SELECT_SECONDARY_LANG = exports.SELECT_SECONDARY_LANG = 'SELECT_SECONDARY_LANG';

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ACTION_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_TYPES = exports.ACTION_TYPES = {
	    CHANGE_PAGE: 'pagination/CHANGE_PAGE',
	    SET_PAGINATION_IDS: 'pagination/SET_PAGINATION_IDS',
	    REMOVE_ID_FROM_PAGE: 'pagination/REMOVE_ID_FROM_PAGE',
	    SET_COUNT: 'pagination/SET_COUNT'
	};
	
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	    var type = action.type;
	
	    switch (type) {
	        case ACTION_TYPES.CHANGE_PAGE:
	            {
	                var currentPage = action.currentPage,
	                    key = action.key;
	
	                state[key] = _extends({}, state[key], { currentPage: currentPage });
	                return _extends({}, state);
	            }
	        case ACTION_TYPES.SET_PAGINATION_IDS:
	            {
	                var _currentPage = action.currentPage,
	                    _key = action.key,
	                    ids = action.ids;
	
	                if (_currentPage === undefined) {
	                    throw new Error(type + ': currentPage is undefined in action \n' + JSON.stringify(action, null, 4));
	                }
	                return _extends({}, _lodash2.default.setWith(state, _key + '.pages.' + _currentPage, ids, Object));
	            }
	        case ACTION_TYPES.SET_COUNT:
	            {
	                var _key2 = action.key,
	                    count = action.count;
	
	                state[_key2] = _extends({}, state[_key2], { count: count });
	                return _extends({}, state);
	            }
	        case ACTION_TYPES.REMOVE_ID_FROM_PAGE:
	            {
	                var _currentPage2 = action.currentPage,
	                    _key3 = action.key,
	                    id = action.id;
	
	                var dirtyIds = _lodash2.default.get(state, _key3 + '.pages.' + _currentPage2, []);
	                var cleanIds = dirtyIds.filter(function (el) {
	                    return el !== id;
	                });
	                _lodash2.default.setWith(state, _key3 + '.pages.' + _currentPage2, cleanIds, Object);
	                if (state[_key3].count > 0) {
	                    --state[_key3].count;
	                }
	                return _extends({}, state);
	            }
	        default:
	            return state;
	    }
	};
	
	exports.default = reducer;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchOdds = exports.getOutcomeRef = exports.oddNameSelector = exports.oddsSelection = exports.setProvider = exports.setCampaign = exports.setEventId = exports.toggleSelection = exports.resetSelection = exports.removeOutcome = exports.selectOutcome = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxQuery = __webpack_require__(298);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(588);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _oddslib = __webpack_require__(589);
	
	var _oddslib2 = _interopRequireDefault(_oddslib);
	
	var _stateducer = __webpack_require__(591);
	
	var _helpers = __webpack_require__(592);
	
	var _actions = __webpack_require__(593);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _constants = __webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var selectOutcome = exports.selectOutcome = (0, _stateducer.createAction)('selectOutcome');
	var removeOutcome = exports.removeOutcome = (0, _stateducer.createAction)('removeOutcome');
	var resetSelection = exports.resetSelection = (0, _stateducer.createAction)('resetSelection');
	var toggleSelection = exports.toggleSelection = (0, _stateducer.createAction)('toggleSelection');
	var setEventId = exports.setEventId = (0, _stateducer.createAction)('setEventId');
	var setCampaign = exports.setCampaign = (0, _stateducer.createAction)('setCampaign');
	var setProvider = exports.setProvider = (0, _stateducer.createAction)('setProvider');
	
	var initialOdds = {
	    selected: {},
	    selectedOrder: [],
	    eventId: 0,
	    selectedCampaign: _constants.emptyValue,
	    selectedProvider: _constants.emptyValue
	};
	
	var oddsSelection = (0, _stateducer.createState)(initialOdds).on(selectOutcome, function (_ref, id) {
	    var selected = _ref.selected,
	        selectedOrder = _ref.selectedOrder,
	        rest = _objectWithoutProperties(_ref, ['selected', 'selectedOrder']);
	
	    return _extends({}, rest, { selected: _extends({}, selected, _defineProperty({}, id, true)), selectedOrder: selectedOrder.concat(id) });
	}).on(removeOutcome, function (_ref2, id) {
	    var selected = _ref2.selected,
	        selectedOrder = _ref2.selectedOrder,
	        rest = _objectWithoutProperties(_ref2, ['selected', 'selectedOrder']);
	
	    return _extends({}, rest, {
	        selected: _extends({}, selected, _defineProperty({}, id, false)),
	        selectedOrder: selectedOrder.filter(function (id2) {
	            return id2 !== id;
	        })
	    });
	}).on(toggleSelection, function (_ref3, id) {
	    var selected = _ref3.selected,
	        selectedOrder = _ref3.selectedOrder,
	        rest = _objectWithoutProperties(_ref3, ['selected', 'selectedOrder']);
	
	    return selected[id] ? _extends({}, rest, {
	        selected: _extends({}, selected, _defineProperty({}, id, false)),
	        selectedOrder: selectedOrder.filter(function (id2) {
	            return id2 !== id;
	        })
	    }) : _extends({}, rest, { selected: _extends({}, selected, _defineProperty({}, id, true)), selectedOrder: selectedOrder.concat(id) });
	}).on(setEventId, function (state, id) {
	    return _extends({}, state, {
	        selected: {},
	        selectedOrder: [],
	        eventId: id
	    });
	}).on(setCampaign, function (state, id) {
	    return _extends({}, state, { selectedCampaign: id });
	}).on(setProvider, function (state, id) {
	    return _extends({}, state, {
	        selected: {},
	        selectedOrder: [],
	        selectedProvider: id
	    });
	}).on(resetSelection, function () {
	    return initialOdds;
	});
	
	exports.oddsSelection = oddsSelection;
	var oddNameSelector = exports.oddNameSelector = function oddNameSelector(eventId, market, provider) {
	    return eventId + '/' + String(provider) + '/' + market;
	};
	
	var getOutcomeRef = exports.getOutcomeRef = function getOutcomeRef(outcome) {
	    if (!outcome) {
	        throw new TypeError('Outcome is not an object while creating a reference to it.');
	    }
	    if ((typeof outcome === 'undefined' ? 'undefined' : _typeof(outcome)) === 'symbol') {
	        return outcome;
	    }
	    var value = outcome.value,
	        type = outcome.type;
	
	    return (0, _helpers.isNullOrUndefined)(value) ? String(type) : type + '/' + value;
	};
	
	var getOddsConverter = function getOddsConverter(oddsFormat) {
	    switch (oddsFormat) {
	        case 'fractional':
	            {
	                return function (oddValue) {
	                    try {
	                        return _oddslib2.default.from('decimal', oddValue).to('fractional');
	                    } catch (e) {
	                        return '-';
	                    }
	                };
	            }
	        default:
	            return function (v) {
	                return v;
	            };
	    }
	};
	
	var transformOdds = function transformOdds(oddsFormat, market, body, provider) {
	    // api returns an array for some reasons
	    var firstOdd = (0, _get2.default)(body, ['eventsOdds', 0]);
	    if (!firstOdd) {
	        return null;
	    }
	    var converter = getOddsConverter(oddsFormat);
	
	    var betOffers = firstOdd.betOffers,
	        odd = _objectWithoutProperties(firstOdd, ['betOffers']);
	
	    var id = odd.eventId + '/' + provider + '/' + market;
	    var values = betOffers.reduce(function (acc, fullBetOffer, index) {
	        var outcomes = fullBetOffer.outcomes,
	            betOffer = _objectWithoutProperties(fullBetOffer, ['outcomes']);
	
	        var betOfferID = id + '/' + index;
	
	        var outcomesObject = outcomes.reduce(function (nextOut, outcome) {
	            var outcomeId = id + '/' + getOutcomeRef(outcome);
	            nextOut[outcomeId] = _extends({}, outcome, {
	                odds: converter(outcome.odds),
	                internalBetofferId: betOfferID
	            });
	            // if (outcome.id) nextOut[outcomeId].id = outcome.id
	            return nextOut;
	        }, {});
	
	        acc.outcomes = _extends({}, acc.outcomes, outcomesObject);
	
	        acc.betOffers[betOfferID] = _extends({}, betOffer, {
	            outcomes: Object.keys(outcomesObject)
	        });
	
	        return acc;
	    }, {
	        betOffers: {},
	        outcomes: {}
	    });
	    return {
	        betOffers: values.betOffers,
	        outcomes: values.outcomes,
	        odds: _defineProperty({}, id, _extends({}, odd, {
	            lastUpdateAt: (0, _get2.default)((0, _head2.default)(Object.values(values.betOffers)), 'lastUpdateAt'),
	            betOffers: Object.keys(values.betOffers)
	        }))
	    };
	};
	
	var fetchOdds = exports.fetchOdds = function fetchOdds(eventId, market, provider) {
	    return function (dispatch, getState) {
	        var oddsKey = oddNameSelector(eventId, market, provider);
	        var oddsFormat = (0, _get2.default)(getState().user, ['props', 'oddsFormat']);
	        return dispatch((0, _reduxQuery.requestAsync)({
	            url: _cfg2.default.apis.ss2 + '/odds/' + market,
	            queryKey: oddsKey,
	            body: {
	                provider: provider,
	                eventId: eventId
	            },
	            transform: function transform(body) {
	                return transformOdds(oddsFormat, market, body, provider);
	            },
	            update: {
	                odds: _actions.UPDATE_DEFAULT.MERGE,
	                betOffers: _actions.UPDATE_DEFAULT.MERGE,
	                outcomes: _actions.UPDATE_DEFAULT.MERGE
	            },
	            force: true
	        }));
	    };
	};

/***/ },
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.safeParse = exports.isNullOrUndefined = exports.removeFromQuery = exports.addToQuery = exports.responseStatusIsOk = exports.toIdArray = exports.toIdMap = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(188);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toIdMap = exports.toIdMap = function toIdMap(ar) {
	    return ar.reduce(function (acc, cur) {
	        if (cur._id) {
	            acc[cur._id] = cur;
	        }
	        return acc;
	    }, {});
	};
	
	var toIdArray = exports.toIdArray = function toIdArray(ar) {
	    return ar.reduce(function (acc, el) {
	        return el._id ? acc.concat(el._id) : acc;
	    }, []);
	};
	
	var responseStatusIsOk = exports.responseStatusIsOk = function responseStatusIsOk(status) {
	    return status >= 200 && status < 300;
	};
	
	var addToQuery = exports.addToQuery = function addToQuery(key, value) {
	    var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
	        query = _browserHistory$getCu.query;
	
	    var pathname = window.location.pathname;
	
	
	    _reactRouter.browserHistory.replace({
	        pathname: pathname,
	        query: _extends({}, query, _defineProperty({}, key, value))
	    });
	};
	
	var removeFromQuery = exports.removeFromQuery = function removeFromQuery(key) {
	    var _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(),
	        query = _browserHistory$getCu2.query;
	
	    var pathname = window.location.pathname;
	
	
	    _reactRouter.browserHistory.replace({
	        pathname: pathname,
	        query: _lodash2.default.omit(query, [key])
	    });
	};
	
	var isNullOrUndefined = exports.isNullOrUndefined = function isNullOrUndefined(value) {
	    return [undefined, null].some(function (e) {
	        return e === value;
	    });
	};
	
	var badValues = [undefined, null, ''];
	var safeParse = exports.safeParse = function safeParse(str) {
	    if (badValues.some(function (v) {
	        return v === str;
	    })) {
	        return null;
	    }
	    if ((typeof str === 'undefined' ? 'undefined' : _typeof(str)) === 'object') {
	        return str;
	    }
	    try {
	        return JSON.parse(str);
	    } catch (e) {
	        return null;
	    }
	};

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.requestAsync = exports.UPDATE_DEFAULT = exports.httpMethods = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reqFns;
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _actionTypes = __webpack_require__(337);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var httpMethods = exports.httpMethods = {
	    GET: 'GET',
	    POST: 'POST',
	    PUT: 'PUT',
	    PATCH: 'PATCH',
	    DELETE: 'DELETE'
	};
	
	var reqFns = (_reqFns = {}, _defineProperty(_reqFns, httpMethods.GET, _superagent2.default.get), _defineProperty(_reqFns, httpMethods.POST, _superagent2.default.post), _defineProperty(_reqFns, httpMethods.PUT, _superagent2.default.put), _defineProperty(_reqFns, httpMethods.PATCH, _superagent2.default.patch), _defineProperty(_reqFns, httpMethods.DELETE, _superagent2.default.delete), _reqFns);
	
	var getQueryKey = function getQueryKey(_ref) {
	    var url = _ref.url;
	    return url;
	};
	
	var handlePropError = function handlePropError(message) {
	    return Promise.reject(message);
	};
	
	var simpleTransform = function simpleTransform(storeKey, normalizeProp) {
	    return function (body) {
	        return _defineProperty({}, storeKey, body.reduce(function (acc, cur) {
	            acc[cur[normalizeProp]] = cur;
	            return acc;
	        }, {}));
	    };
	};
	
	var UPDATE_DEFAULT = exports.UPDATE_DEFAULT = {
	    MERGE: function MERGE(cur, next) {
	        return _extends({}, cur, next);
	    },
	    LATEST: function LATEST(cur, next) {
	        return next;
	    }
	};
	
	var getSimpleUpdate = function getSimpleUpdate(storeKey, update) {
	    if (typeof update === 'function') {
	        return _defineProperty({}, storeKey, update);
	    }
	    return (typeof update === 'undefined' ? 'undefined' : _typeof(update)) === 'object' ? update : _defineProperty({}, storeKey, UPDATE_DEFAULT.LATEST);
	};
	
	var simpleList = function simpleList(storeKey, normalizeProp) {
	    return function (body) {
	        return _defineProperty({}, storeKey, function () {
	            return body.map(function (item) {
	                return item[normalizeProp];
	            });
	        });
	    };
	};
	
	var getResolvers = function getResolvers(_ref6) {
	    var normalizeProp = _ref6.normalizeProp,
	        storeKey = _ref6.storeKey,
	        transform = _ref6.transform,
	        update = _ref6.update,
	        list = _ref6.list;
	
	    if (transform && update) {
	        return {
	            entities: transform,
	            update: update,
	            list: list
	        };
	    }
	    if (normalizeProp && storeKey) {
	        return {
	            entities: simpleTransform(storeKey, normalizeProp),
	            list: simpleList(storeKey, normalizeProp),
	            update: getSimpleUpdate(storeKey, update)
	        };
	    }
	    return null;
	};
	
	var getReqFn = function getReqFn(options) {
	    var method = options.method || httpMethods.GET;
	    var fn = reqFns[method];
	    if (!fn) {
	        return fn;
	    }
	    if (options.withCredentials) {
	        return fn.withCredentials();
	    }
	    return fn;
	};
	
	var requestAsync = exports.requestAsync = function requestAsync(_ref7) {
	    var url = _ref7.url,
	        body = _ref7.body,
	        normalizeProp = _ref7.normalizeProp,
	        storeKey = _ref7.storeKey,
	        transform = _ref7.transform,
	        update = _ref7.update,
	        list = _ref7.list,
	        nextAction = _ref7.nextAction,
	        _ref7$queryKey = _ref7.queryKey,
	        queryKey = _ref7$queryKey === undefined ? getQueryKey({ url: url }) : _ref7$queryKey,
	        _ref7$options = _ref7.options,
	        options = _ref7$options === undefined ? {} : _ref7$options;
	    return function (dispatch, getState) {
	        if (!url) {
	            return handlePropError('No url specified');
	        }
	        if (normalizeProp && transform) {
	            return handlePropError('normalizeProp and transform cannot be used together');
	        }
	        if (storeKey && transform) {
	            return handlePropError('storeKey and transform cannot be used together');
	        }
	        var resolvers = getResolvers({
	            normalizeProp: normalizeProp,
	            storeKey: storeKey,
	            transform: transform,
	            update: update,
	            list: list
	        });
	        if (!resolvers) {
	            return handlePropError('Prop error');
	        }
	        dispatch({ type: _actionTypes2.default.REQUEST_START, url: url, queryKey: queryKey });
	        var reqFunction = getReqFn(options);
	        if (!reqFunction) {
	            return handlePropError('Wrong httpMethod specified ' + options.method);
	        }
	        return reqFunction(url, body).then(function (response) {
	            var body = response.body,
	                status = response.status;
	
	            var transformedEntities = resolvers.entities(body);
	
	            var _getState = getState(),
	                requery = _getState.requery;
	
	            var updatedEntites = Object.keys(resolvers.update).reduce(function (acc, key) {
	                var updateFn = resolvers.update[key];
	                var cur = requery.entities[key];
	                var next = transformedEntities[key];
	                acc[key] = updateFn(cur, next);
	                return acc;
	            }, {});
	            var totalEntities = _extends({}, requery.entities, updatedEntites);
	            var listObj = resolvers.list(body);
	            var listItems = Object.keys(listObj).reduce(function (acc, key) {
	                var prevListArray = Array.isArray(requery.list[key]) ? requery.list[key] : [];
	                acc[key] = listObj[key](prevListArray, body);
	                return acc;
	            }, {});
	            var totalList = _extends({}, requery.list, listItems);
	
	            dispatch({
	                type: _actionTypes2.default.REQUEST_SUCCESS,
	                entities: totalEntities,
	                list: totalList,
	                status: status,
	                queryKey: queryKey
	            });
	
	            if (nextAction) {
	                var action = nextAction();
	
	                dispatch(_extends({}, action, {
	                    type: action.type,
	                    payload: _extends({}, action.payload, {
	                        entities: totalEntities,
	                        list: totalList
	                    })
	                }));
	            }
	
	            return {
	                body: body,
	                status: status,
	                entities: totalEntities,
	                list: totalList,
	                updated: updatedEntites
	            };
	        }).catch(function (error) {
	            var _error$status = error.status,
	                status = _error$status === undefined ? 0 : _error$status;
	
	            dispatch({ type: _actionTypes2.default.REQUEST_FAILURE, status: status, queryKey: queryKey });
	            throw error;
	        });
	    };
	};

/***/ },
/* 594 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SINGLE_OPTION_MARKETS = exports.SINGLE_OPTION_MARKETS = ['match', 'halftime', 'nextGoal', 'btts'];
	var marketDisplayName = exports.marketDisplayName = {
	    match: 'Full time',
	    halftime: 'Half time',
	    nextGoal: 'Next goal',
	    btts: 'Both teams to score',
	    goals: 'Total goals',
	    score: 'Correct score'
	};
	
	var commonOutcome = exports.commonOutcome = Symbol('common');
	var emptyValue = exports.emptyValue = Symbol(null);

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _immutabilityHelper = __webpack_require__(596);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _range = __webpack_require__(597);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _flatten = __webpack_require__(602);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _fromPairs = __webpack_require__(605);
	
	var _fromPairs2 = _interopRequireDefault(_fromPairs);
	
	var _compact = __webpack_require__(606);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _pick = __webpack_require__(607);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var BASE_ALLOWED_KEYS = ['username', 'client', 'variation'];
	var ALLOWED_KEY_REGEX = /(area|custom|text)\d{1,3}/gm;
	var pickAllowedKeys = function pickAllowedKeys(jsprops, keys) {
	    // ...range(1, 12).map(i => `area${i}`),
	    // ...range(1, 12).map(i => `custom${i}`),
	    // ...range(1, 100).map(i => `text${i}`),
	
	    var customProps = _lodash2.default.chain(jsprops).toPairs().filter(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            key = _ref2[0];
	
	        return key.match(ALLOWED_KEY_REGEX);
	    }).fromPairs().value();
	
	    return _extends({}, (0, _pick2.default)(jsprops, keys), customProps);
	};
	
	var weditor = {
	    widgets: {},
	    widgetId: null,
	    cmps: [],
	    jsprops: {},
	    allowedKeys: [],
	    zoom: 1.0,
	    template: null,
	    autozoom: true,
	    preview: false,
	    previewError: false
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : weditor;
	    var _ref3 = arguments[1];
	    var type = _ref3.type,
	        payload = _ref3.payload;
	
	    switch (type) {
	        case _constants.PICKER_OPEN_TAB:
	            {
	                return _extends({}, state, { picker: payload });
	            }
	
	        case _constants.EDITOR_SET_TEMPLATE:
	            {
	                return _extends({}, state, { template: payload });
	            }
	
	        case _constants.WIDGETS_LOAD:
	            {
	                var widgets = _extends({}, state.widgets);
	                widgets[payload.set] = payload.widgets;
	                return _extends({}, state, { widgets: widgets });
	            }
	
	        case _constants.EDITOR_AUTO_ZOOM:
	            {
	                return _extends({}, state, { autozoom: payload });
	            }
	
	        case _constants.WIDGET_CMP_LOADED:
	            {
	                return _extends({}, state, { cmps: [].concat(_toConsumableArray(state.cmps), [payload]) });
	            }
	
	        case _constants.EDITOR_SET_PREVIEW_STATUS:
	            {
	                return _extends({}, state, { preview: payload.status, previewError: payload.error });
	            }
	
	        case _constants.WIDGET_JSPROP_UPDATE_FILELD:
	            {
	                var field = payload.field,
	                    _update = payload.update;
	
	
	                if (!_update) return state;
	
	                return _extends({}, state, {
	                    jsprops: (0, _immutabilityHelper2.default)(state.jsprops, !state.jsprops[field] ? { $merge: _defineProperty({}, field, _update) } : _defineProperty({}, field, { $merge: _update })),
	                    widgetProps: (0, _immutabilityHelper2.default)(state.widgetProps, !state.widgetProps[field] ? { $merge: _defineProperty({}, field, _update) } : _defineProperty({}, field, { $merge: _update }))
	                });
	            }
	
	        case _constants.WIDGET_JSPROP_CHANGE:
	            {
	                var allowedKeys = state.allowedKeys;
	
	
	                var widgetProps = pickAllowedKeys(_extends({ template: state.template }, state.jsprops, payload), allowedKeys);
	
	                if (widgetProps.stageIds) {
	                    try {
	                        widgetProps.stageIds = JSON.parse(widgetProps.stageIds);
	                    } catch (e) {
	                        try {
	                            widgetProps.stageIds = JSON.parse('[' + widgetProps.stageIds + ']');
	                        } catch (e) {
	                            widgetProps.stageIds = [];
	                        }
	                    }
	                    if (!Array.isArray(widgetProps.stageIds)) {
	                        widgetProps.stageIds = [widgetProps.stageIds];
	                    }
	                }
	
	                return _extends({}, state, {
	                    jsprops: _extends({}, state.jsprops, payload),
	                    widgetProps: widgetProps
	                });
	            }
	
	        case _constants.WIDGET_FAV:
	            {
	                return _extends({}, state, {
	                    widget: _extends({}, state.widget, {
	                        fav: true
	                    })
	                });
	            }
	
	        case _constants.EDITOR_TEMPLATE_CHANGE:
	            {
	                return _extends({}, state, {
	
	                    template: payload
	                });
	            }
	
	        case _constants.EDITOR_ZOOM:
	            {
	                return _extends({}, state, {
	                    zoom: payload.zoom || 1.0,
	                    autozoom: payload.autozoom
	                });
	            }
	
	        case _constants.EDITOR_TAB_OPEN:
	            {
	                return _extends({}, state, {
	                    tab: payload
	                });
	            }
	
	        case _constants.EDITOR_RESET_WIDGET:
	            {
	                return _extends({}, state, {
	                    widgetId: null,
	                    tab: 'layout',
	                    jsprops: null,
	                    widgetProps: null,
	                    widget: null,
	                    template: null
	                });
	            }
	
	        case _constants.WIDGET_SELECTED:
	            {
	                var widget = payload.widget,
	                    params = payload.params;
	                // detect allowed keys
	
	                var _allowedKeys = [].concat(BASE_ALLOWED_KEYS, _toConsumableArray((0, _flatten2.default)(widget.spec.propTypes.map(function (p) {
	                    return p.propsMap && Object.values(p.propsMap) || p.key;
	                }))));
	
	                var baseJSProps = (0, _fromPairs2.default)((0, _compact2.default)(widget.spec.propTypes.map(function (p) {
	                    return p.defaultValue ? [p.key, p.defaultValue] : null;
	                })));
	
	                // jsprops = baseJSProps + userBaseProps + queryStrings
	
	                var jsprops = _extends({ template: state.template }, baseJSProps, params);
	
	                return _extends({}, state, {
	                    widget: widget,
	                    widgetId: widget.id,
	                    allowedKeys: _allowedKeys,
	                    jsprops: jsprops,
	                    widgetProps: pickAllowedKeys(jsprops, _allowedKeys),
	                    baseJSProps: baseJSProps
	                });
	            }
	
	        default:
	            return state;
	    }
	};

/***/ },
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LOAD = exports.LOAD = 'LOAD';
	var WIDGETS_LOAD = exports.WIDGETS_LOAD = 'WIDGETS_LOAD';
	var WIDGET_CMP_LOADED = exports.WIDGET_CMP_LOADED = 'WIDGET_CMP_LOADED';
	var WIDGET_JSPROP_CHANGE = exports.WIDGET_JSPROP_CHANGE = 'WIDGET_JSPROP_CHANGE';
	var WIDGET_SELECTED = exports.WIDGET_SELECTED = 'WIDGET_SELECTED';
	var WIDGET_JSPROP_UPDATE_FILELD = exports.WIDGET_JSPROP_UPDATE_FILELD = 'WIDGET_JSPROP_UPDATE_FILELD';
	var EDITOR_RESET_WIDGET = exports.EDITOR_RESET_WIDGET = 'EDITOR_RESET_WIDGET';
	var EDITOR_TEMPLATE_CHANGE = exports.EDITOR_TEMPLATE_CHANGE = 'EDITOR_TEMPLATE_CHANGE';
	var EDITOR_TAB_OPEN = exports.EDITOR_TAB_OPEN = 'EDITOR_TAB_OPEN';
	var EDITOR_ZOOM = exports.EDITOR_ZOOM = 'EDITOR_ZOOM';
	var EDITOR_AUTO_ZOOM = exports.EDITOR_AUTO_ZOOM = 'EDITOR_AUTO_ZOOM';
	var EDITOR_SET_TEMPLATE = exports.EDITOR_SET_TEMPLATE = 'EDITOR_SET_TEMPLATE';
	var EDITOR_SET_PREVIEW_STATUS = exports.EDITOR_SET_PREVIEW_STATUS = 'EDITOR_SET_PREVIEW_STATUS';
	var WIDGET_FAV = exports.WIDGET_FAV = 'WIDGET_FAV';
	
	var EDITOR = exports.EDITOR = {
	    TABS: {
	        LAYOUT: 'layout',
	        PARAMS: 'data',
	        IMAGE_MANIPULATIONS: 'im'
	    }
	};

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(614);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weditor = {
	    widgets: {},
	    info: {},
	    template: null,
	    tab: _constants.TABS.ALL,
	    params: {}
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : weditor;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	        case _constants.PICKER_WIDGETS_LOAD:
	            {
	                var widgets = _extends({}, state.widgets);
	                widgets[payload.set] = payload.widgets;
	                return _extends({}, state, { widgets: widgets });
	            }
	        case _constants.PICKER_SET_TEMPLATE:
	            {
	                return _extends({}, state, { template: payload });
	            }
	        case _constants.PICKER_INFO_LOAD:
	            {
	                var info = _extends({}, state.info);
	                info[payload.set] = payload.data;
	                return _extends({}, state, { info: info });
	            }
	    }
	    return state;
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GROUP_KEY = exports.TABS = exports.ALL_WIDGETS = exports.EDITOR = exports.PICKER_SET_TEMPLATE = exports.PICKER_INFO_LOAD = exports.PICKER_WIDGETS_LOAD = undefined;
	
	var _widgetCategories = __webpack_require__(615);
	
	var _widgetCategories2 = _interopRequireDefault(_widgetCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PICKER_WIDGETS_LOAD = exports.PICKER_WIDGETS_LOAD = 'PICKER_WIDGETS_LOAD';
	var PICKER_INFO_LOAD = exports.PICKER_INFO_LOAD = 'PICKER_INFO_LOAD';
	var PICKER_SET_TEMPLATE = exports.PICKER_SET_TEMPLATE = 'PICKER_SET_TEMPLATE';
	
	var EDITOR = exports.EDITOR = {
	    TABS: {
	        LAYOUT: 'layout',
	        PARAMS: 'params',
	        IMAGE_MANIPULATIONS: 'im'
	    }
	};
	
	var ALL_WIDGETS = exports.ALL_WIDGETS = [_widgetCategories2.default.V2.TOURNAMENT_FIXTURES, _widgetCategories2.default.V2.TOURNAMENT_TABLES, _widgetCategories2.default.V2.MATCH_PRE, _widgetCategories2.default.V2.MATCH_LIVE, _widgetCategories2.default.V2.PLAYERS_STATS, _widgetCategories2.default.V2.PLAYERS_H2H, _widgetCategories2.default.V2.TEAMS, _widgetCategories2.default.V2.TOP_LISTS, _widgetCategories2.default.V2.TRANSFERS, _widgetCategories2.default.V2.EDITORIAL, _widgetCategories2.default.V2.ODDS, _widgetCategories2.default.V2.BASEBALL];
	
	var TABS = exports.TABS = {};
	TABS.ALL = 'all';
	TABS.LEAGUE = 'league';
	TABS.PLAYER = 'player';
	TABS.TEAM = 'team';
	TABS.EVENT = 'event';
	TABS.PORTFOLIO = 'portfolio';
	TABS.INTERESTS = 'interests';
	
	var GROUP_KEY = exports.GROUP_KEY = 'spec.v2Categories';

/***/ },
/* 615 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CATEGORIES = {};
	CATEGORIES.V2 = {};
	
	CATEGORIES.V2.PLAYERS = 'PLAYERS';
	CATEGORIES.V2.PLAYERS_STATS = 'PLAYERS_STATS';
	CATEGORIES.V2.PLAYERS_H2H = 'PLAYERS_H2H';
	
	CATEGORIES.V2.TEAMS_FIXTURES = 'TEAMS_FIXTURES';
	
	CATEGORIES.V2.TEAMS = 'TEAMS';
	CATEGORIES.V2.TEAMS_H2H = 'TEAMS_H2H';
	
	CATEGORIES.V2.MATCH = 'MATCH';
	CATEGORIES.V2.MATCH_PRE = 'MATCH_PRE';
	CATEGORIES.V2.MATCH_LIVE = 'MATCH_LIVE';
	
	CATEGORIES.V2.MATCH_POST = 'MATCH_POST';
	CATEGORIES.V2.MATCH_DETAILED_PRE = 'MATCH_DETAILED_PRE';
	CATEGORIES.V2.MATCH_DETAILED_LIVE = 'MATCH_DETAILED_LIVE';
	CATEGORIES.V2.MATCH_DETAILED_POST = 'MATCH_DETAILED_POST';
	CATEGORIES.V2.MATCH_DETAILED_STREAKS = 'MATCH_DETAILED_STREAKS';
	CATEGORIES.V2.MATCH_DETAILED_LINEUP = 'MATCH_DETAILED_LINEUP';
	CATEGORIES.V2.MATCH_DETAILED_STATS = 'MATCH_DETAILED_STATS';
	
	CATEGORIES.V2.STREAKS = 'STREAKS';
	CATEGORIES.V2.BOOKIES = 'BOOKIES';
	CATEGORIES.V2.TOP_LISTS = 'TOP_LIST';
	CATEGORIES.V2.EDITORIAL = 'EDITORIAL';
	CATEGORIES.V2.TRANSFERS = 'TRANSFERS';
	
	CATEGORIES.V2.ODDS = 'ODDS';
	
	CATEGORIES.V2.BASEBALL = 'BASEBALL';
	
	CATEGORIES.V2.TOURNAMENT_FIXTURES = 'TOURNAMENT_FIXTURES';
	CATEGORIES.V2.TOURNAMENT_TABLES = 'TOURNAMENT_TABLES';
	CATEGORIES.V2.TOURNAMENT = 'TOURNAMENT';
	
	exports.default = CATEGORIES;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(617);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var portfolios = {
	    byIds: {},
	    allIds: []
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : portfolios;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	        case _constants.LOAD_PORTFOLIO:
	            {
	                return _extends({}, state, {
	                    byIds: _defineProperty({}, payload.type, payload),
	                    allIds: [].concat(_toConsumableArray(state.allIds), [payload.type])
	                });
	            }
	        default:
	            return state;
	    }
	};

/***/ },
/* 617 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_PORTFOLIO = exports.LOAD_PORTFOLIO = 'LOAD_PORTFOLIO';

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.teamsKeyBySportAndTtId = exports.eventsKeyByDate = exports.eventsKeyBySportAndTtId = exports.tournamentsKey = exports.eventsKey = exports.getEntities = exports.getQueries = undefined;
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getQueries = exports.getQueries = function getQueries(state) {
	    return state.query.queries;
	};
	var getEntities = exports.getEntities = function getEntities(state) {
	    return state.query.entities;
	};
	
	var eventsKey = exports.eventsKey = function eventsKey(_ref) {
	    var _ref$sportType = _ref.sportType,
	        sportType = _ref$sportType === undefined ? '*' : _ref$sportType,
	        _ref$tournamentId = _ref.tournamentId,
	        tournamentId = _ref$tournamentId === undefined ? '*' : _ref$tournamentId,
	        date = _ref.date;
	    return sportType + '.' + tournamentId + '.' + date;
	};
	
	var tournamentsKey = exports.tournamentsKey = function tournamentsKey(sport) {
	    if (!sport) {
	        return 'tournaments.*';
	    }
	    return 'tournaments.' + sport;
	};
	
	var eventsKeyBySportAndTtId = exports.eventsKeyBySportAndTtId = function eventsKeyBySportAndTtId(sportId, tournamentId) {
	    var sportPart = sportId ? sportId : '*';
	    var tournamentPart = tournamentId ? tournamentId : '*';
	    return 'nextEvents.' + sportPart + '.' + tournamentPart;
	};
	
	var eventsKeyByDate = exports.eventsKeyByDate = function eventsKeyByDate(date) {
	    var d = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    return 'events.' + d;
	};
	
	var teamsKeyBySportAndTtId = exports.teamsKeyBySportAndTtId = function teamsKeyBySportAndTtId(sportId, tournamentId) {
	    var sportPart = sportId ? sportId : '*';
	    var tournamentPart = tournamentId ? tournamentId : '*';
	    return 'teams.' + sportPart + '.' + tournamentPart;
	};

/***/ },
/* 619 */,
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./da": 621,
		"./da.js": 621,
		"./de": 622,
		"./de-at": 623,
		"./de-at.js": 623,
		"./de.js": 622,
		"./en-au": 624,
		"./en-au.js": 624,
		"./en-ca": 625,
		"./en-ca.js": 625,
		"./en-gb": 626,
		"./en-gb.js": 626,
		"./en-ie": 627,
		"./en-ie.js": 627,
		"./en-nz": 628,
		"./en-nz.js": 628,
		"./fi": 629,
		"./fi.js": 629,
		"./nb": 630,
		"./nb.js": 630,
		"./th": 631,
		"./th.js": 631,
		"./zh-cn": 632,
		"./zh-cn.js": 632,
		"./zh-hk": 633,
		"./zh-hk.js": 633
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 620;


/***/ },
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.postLineUp = exports.generateLineUp = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(579);
	
	var _actions = __webpack_require__(635);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var generateLineUp = function generateLineUp() {
	    return function (next) {
	        return function (action) {
	            var generateLineUp = action.generateLineUp,
	                type = action.type,
	                rest = _objectWithoutProperties(action, ['generateLineUp', 'type']);
	
	            if (!generateLineUp) return next(action);
	
	            next(_extends({}, rest, { type: type }));
	            next(_extends({}, rest, { type: (0, _actions.generateParticipantPitch)().type }));
	            return next(_extends({}, rest, (0, _actions.postParticipantPitch)()));
	        };
	    };
	};
	
	exports.generateLineUp = generateLineUp;
	var postLineUp = function postLineUp(store) {
	    return function (next) {
	        return function (action) {
	            var postLineUp = action.postLineUp,
	                type = action.type,
	                rest = _objectWithoutProperties(action, ['postLineUp', 'type']);
	
	            if (!postLineUp) return next(action);
	
	            if (type === (0, _actions.postParticipantPitch)().type && store.getState().makerToolPage.idLineUp !== 0) {
	                next({ type: type + _constants.START });
	
	                fetch('http://ss2.si-ab.com/admin/keyval', {
	                    method: 'PUT',
	                    headers: {
	                        'Content-Type': 'application/json'
	                    },
	                    body: JSON.stringify({
	                        appName: 'maker-tool',
	                        key: '' + store.getState().makerToolPage.idLineUp,
	                        value: JSON.stringify({
	                            type: store.getState().makerToolPage.lineupType,
	                            players: store.getState().makerToolPage.customPitchLineupList
	                        })
	                    })
	                }).then(function (res) {
	                    if (res.status === 200) {
	                        return next(_extends({}, rest, { type: type + _constants.SUCCESS, res: res }));
	                    }
	
	                    throw new Error('Error load status ' + status);
	                }).catch(function (error) {
	                    return next(_extends({}, rest, { type: type + _constants.FAIL, error: error }));
	                });
	            } else {
	                return next(action);
	            }
	        };
	    };
	};
	exports.postLineUp = postLineUp;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchTeams = exports.fetchPlayers = exports.fetchTournaments = exports.toIdArray = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setIdLineUp = setIdLineUp;
	exports.setLineupType = setLineupType;
	exports.setParticipantCustomName = setParticipantCustomName;
	exports.setParticipantCustomText = setParticipantCustomText;
	exports.setLineupTemplate = setLineupTemplate;
	exports.searchInputText = searchInputText;
	exports.setParticipantPitch = setParticipantPitch;
	exports.deleteParticipantPitch = deleteParticipantPitch;
	exports.setPitchLineupTemplate = setPitchLineupTemplate;
	exports.generateParticipantPitch = generateParticipantPitch;
	exports.postParticipantPitch = postParticipantPitch;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _actions = __webpack_require__(593);
	
	var _constants = __webpack_require__(578);
	
	var _constants2 = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toIdArray = exports.toIdArray = function toIdArray(ar) {
	    return ar.reduce(function (acc, el) {
	        return el.id ? acc.concat(el.id) : acc;
	    }, []);
	};
	
	var fetchTournaments = exports.fetchTournaments = function fetchTournaments() {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.apis.ss2 + '/tournaments',
	        update: {
	            tournaments: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                tournaments: body.reduce(function (acc, el) {
	                    return _extends({}, acc, _defineProperty({}, el.id, el));
	                }, {})
	            };
	        },
	        list: function list(body) {
	            return {
	                tournaments: function tournaments() {
	                    return toIdArray(body);
	                }
	            };
	        },
	        queryKey: 'GET:tournaments',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var fetchPlayers = exports.fetchPlayers = function fetchPlayers() {
	    var ttId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.apis.ss2 + '/players?ttId=' + ttId,
	        update: {
	            players: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                players: body.reduce(function (acc, el) {
	                    return _extends({}, acc, _defineProperty({}, el.id, el));
	                }, {})
	            };
	        },
	        list: function list(body) {
	            return {
	                players: function players() {
	                    return toIdArray(body);
	                }
	            };
	        },
	        queryKey: 'GET:players',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var fetchTeams = exports.fetchTeams = function fetchTeams() {
	    var ttId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.apis.ss2 + '/tournaments/' + ttId + '/teams',
	        update: {
	            teams: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                teams: body.reduce(function (acc, el) {
	                    return _extends({}, acc, _defineProperty({}, el.id, el));
	                }, {})
	            };
	        },
	        list: function list(body) {
	            return {
	                teams: function teams() {
	                    return toIdArray(body);
	                }
	            };
	        },
	        queryKey: 'GET:teams',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	function setIdLineUp(idLineUp) {
	    var generateLineUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return {
	        type: _constants2.SET + _constants.ID_LINEUP,
	        payload: { idLineUp: idLineUp },
	        generateLineUp: generateLineUp
	    };
	}
	
	function setLineupType(type) {
	    return {
	        type: _constants2.SET + _constants.LINEUP_TYPE,
	        payload: { type: type }
	    };
	}
	
	function setParticipantCustomName(id, text) {
	    var generateLineUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    return {
	        type: _constants2.SET + _constants.PARTICIPANT_CUSTOM_NAME,
	        payload: { id: id, text: text },
	        generateLineUp: generateLineUp
	    };
	}
	
	function setParticipantCustomText(id, text) {
	    var generateLineUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    return {
	        type: _constants2.SET + _constants.PARTICIPANT_CUSTOM_TEXT,
	        payload: { id: id, text: text },
	        generateLineUp: generateLineUp
	    };
	}
	
	function setLineupTemplate(template) {
	    var generateLineUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return {
	        type: _constants2.SET + _constants.LINEUP_TEMPLATE,
	        payload: { template: template },
	        generateLineUp: generateLineUp
	    };
	}
	
	function searchInputText(text) {
	    return {
	        type: _constants.SEARCH_INPUT_TEXT,
	        payload: { text: text }
	    };
	}
	
	function setParticipantPitch(position, participant) {
	    var generateLineUp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    return {
	        type: _constants2.SET + _constants.PARTICIPANT_PITCH,
	        payload: { position: position, participant: participant },
	        generateLineUp: generateLineUp
	    };
	}
	
	function deleteParticipantPitch(position) {
	    var generateLineUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return {
	        type: _constants2.DELETE + _constants.PARTICIPANT_PITCH,
	        payload: { position: position },
	        generateLineUp: generateLineUp
	    };
	}
	
	function setPitchLineupTemplate(template) {
	    var generateLineUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return {
	        type: _constants2.SET + _constants.PITCH_LINEUP_TEMPLATE,
	        payload: { template: template },
	        generateLineUp: generateLineUp
	    };
	}
	
	function generateParticipantPitch() {
	    var generateLineUp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    return {
	        type: _constants2.GENERATE + _constants.PARTICIPANT_PITCH,
	        generateLineUp: generateLineUp
	    };
	}
	
	function postParticipantPitch() {
	    return {
	        type: _constants2.POST + _constants.PARTICIPANT_PITCH,
	        postLineUp: true
	    };
	}

/***/ },
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _MuiThemeProvider = __webpack_require__(906);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _MenuIconSVG = __webpack_require__(1016);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AppMenu = __webpack_require__(1026);
	
	var _getMuiTheme = __webpack_require__(907);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _user = __webpack_require__(340);
	
	var _GlobalSnackbar = __webpack_require__(1046);
	
	var _actions = __webpack_require__(1047);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SM_MUI_THEME = (0, _getMuiTheme2.default)({
	    palette: {
	        primary1Color: '#009688'
	    },
	    appBar: {
	        height: 64
	    }
	});
	var DEFAULT_MUI_THEME = (0, _getMuiTheme2.default)({
	    palette: {
	        primary1Color: '#3F51B5'
	    },
	    appBar: {
	        height: 64
	    }
	});
	
	var App = function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            drawerOpen: false,
	            minimizedMainMenu: true,
	            menuIcon: _react2.default.createElement(_MenuIconSVG.IconMenuDefault, null)
	        }, _this.logout = function () {
	            var removeUser = _this.props.removeUser;
	
	            removeUser();
	            _auth2.default.logout();
	            _this.context.router.push('/login');
	        }, _this.goToAccount = function () {
	            _this.context.router.push('/account');
	        }, _this.openDrawer = function () {
	            _this.setState({
	                drawerOpen: !_this.state.drawerOpen
	            }, function () {
	                _this.setState({
	                    menuIcon: !_this.state.drawerOpen ? _react2.default.createElement(_MenuIconSVG.IconMenuOpen, null) : _react2.default.createElement(_MenuIconSVG.IconMenuClose, null)
	                });
	            });
	        }, _this.handleDrawerClose = function (menuItem) {
	            return function () {
	                _this.setState({
	                    drawerOpen: false,
	                    menuIcon: _react2.default.createElement(_MenuIconSVG.IconMenuOpen, null)
	                });
	            };
	        }, _this.onRequestChange = function () {
	            return function () {
	                _this.setState({
	                    drawerOpen: !_this.state.drawerOpen
	                }, function () {
	                    _this.setState({
	                        menuIcon: !_this.state.drawerOpen ? _react2.default.createElement(_MenuIconSVG.IconMenuOpen, null) : _react2.default.createElement(_MenuIconSVG.IconMenuClose, null)
	                    });
	                });
	            };
	        }, _this.handleResize = function () {
	            _this.setState({
	                minimizedMainMenu: !(window.innerWidth < 1200)
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(App, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return { user: _auth2.default.getUser() };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.handleResize();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                updateUser = _props.updateUser,
	                removeUser = _props.removeUser,
	                user = _props.user,
	                dispatch = _props.dispatch;
	
	
	            if (user) {
	                _superagent2.default.get('/api/v2/me').query({ access_token: _auth2.default.getAccessToken() }).then(function (_ref2) {
	                    var body = _ref2.body;
	
	                    _auth2.default.saveUser(body);
	                    updateUser(body);
	
	                    dispatch((0, _actions.fetchWidgetSpecs)(user.defaultTemplateId));
	                    dispatch((0, _actions.fetchPortfolio)());
	                    dispatch((0, _actions.fetchTemplates)());
	                }).catch(function (e) {
	                    if ([401, 403].some(function (code) {
	                        return code === e.status;
	                    })) {
	                        removeUser();
	                    }
	                });
	
	                // if (user && user.client) {
	                //     // widgets/standalone/FixturesList/spec
	                //     fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`)
	                //         .then(response => response.json())
	                //         .then(spec => {
	                //             this.setState({ spec, isLoading: false });
	                //         })
	                //         .catch(err => {
	                //             this.setState({ specError: err, isLoading: false });
	                //         });
	                // } else {
	                //     console.warn('No user data in context', user);
	                // }
	            }
	
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	            var menuIcon = this.state.menuIcon;
	
	            var nestedParams = _lodash2.default.clone(this.props.params);
	
	            _lodash2.default.reduce(this.props.routes, function (sum, item) {
	                return _lodash2.default.extend(sum, item.params);
	            }, nestedParams);
	
	            var showFooter = nestedParams.disableFooter !== true;
	            var disableHeader = this.props.params.disableHeader;
	
	
	            var doubleAppBar = nestedParams.doubleAppBar;
	            var disableMiniMenu = nestedParams.disableMiniMenu;
	
	            var isSM = window.location.href.indexOf('/sm/') !== -1;
	            var muiTheme = DEFAULT_MUI_THEME;
	            var appBarStyles = {
	                zIndex: 1400
	            };
	
	            if (doubleAppBar) appBarStyles.boxShadow = 'none';
	
	            if (nestedParams.fullsize) {
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            width: '100%',
	                            height: '100%',
	                            background: '#f0f',
	                            flex: 1
	                        }
	                    },
	                    _react2.default.createElement(
	                        _MuiThemeProvider2.default,
	                        { muiTheme: muiTheme },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    width: '100%',
	                                    height: '100%'
	                                }
	                            },
	                            this.props.children || this.props.main
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _MuiThemeProvider2.default,
	                { muiTheme: muiTheme },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)({
	                            'menu-sticked': 1,
	                            pane: nestedParams.pane
	                        })
	                    },
	                    _react2.default.createElement('div', { id: 'wdp-top' }),
	                    _react2.default.createElement(_AppMenu.MainMenu, _extends({}, this.props, {
	                        drawerOpen: this.state.drawerOpen,
	                        handleDrawerClose: this.handleDrawerClose,
	                        onRequestChange: this.onRequestChange,
	                        pathname: this.props.location.pathname
	                    })),
	                    !disableHeader && _react2.default.createElement(rmd.AppBar, {
	                        className: 'main-bar',
	                        title: this.props.menu || user && 'Hi, ' + user.username || 'WDP',
	                        style: appBarStyles,
	                        iconElementLeft: user ? _react2.default.createElement(
	                            rmd.IconButton,
	                            { onClick: this.openDrawer },
	                            menuIcon
	                        ) : null,
	                        showMenuIconButton: user !== null,
	                        iconElementRight: user && _react2.default.createElement(
	                            rmd.IconMenu,
	                            {
	                                iconButtonElement: _react2.default.createElement(
	                                    rmd.IconButton,
	                                    null,
	                                    _react2.default.createElement(_moreVert2.default, { color: 'white' })
	                                ),
	                                menuStyle: {
	                                    zIndex: 10001,
	                                    position: 'relative'
	                                },
	                                style: {
	                                    zIndex: 10001,
	                                    position: 'relative'
	                                },
	                                iconStyle: { marginTop: 3 },
	                                anchorOrigin: {
	                                    horizontal: 'right',
	                                    vertical: 'top'
	                                },
	                                targetOrigin: {
	                                    horizontal: 'right',
	                                    vertical: 'top'
	                                }
	                            },
	                            _react2.default.createElement(rmd.MenuItem, { primaryText: 'Settings', onClick: this.goToAccount }),
	                            _react2.default.createElement(rmd.MenuItem, { primaryText: 'Sign out', onClick: this.logout })
	                        )
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: (0, _classnames2.default)(nestedParams.container || 'container-fluid', 'page-wrap', {
	                                disableFooter: !showFooter,
	                                offsetLeft: nestedParams.container !== 'container' && nestedParams.container !== 'container-white' && !disableMiniMenu,
	                                disableHeader: disableHeader,
	                                pane: nestedParams.pane
	                            })
	                        },
	                        user && !disableMiniMenu && this.state.minimizedMainMenu && _react2.default.createElement(_AppMenu.MainMenuMinimized, _extends({}, this.props, { drawerOpen: this.state.drawerOpen })),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-content' },
	                            this.props.children || this.props.main
	                        )
	                    ),
	                    _react2.default.createElement(_GlobalSnackbar.GlobalSnackBar, null)
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react2.default.Component);
	
	App.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	App.childContextTypes = {
	    user: _propTypes2.default.object
	};
	
	
	App.propTypes = {
	    user: _propTypes2.default.object,
	    updateUser: _propTypes2.default.func.isRequired,
	    removeUser: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        updateUser: function updateUser(user) {
	            return dispatch({ type: _user.USER_ACTIONS.UPDATE, payload: user });
	        },
	        removeUser: function removeUser() {
	            return dispatch({ type: _user.USER_ACTIONS.LOGOUT });
	        }
	    };
	})(App);

/***/ },
/* 1014 */,
/* 1015 */,
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IconMenuOpen = exports.IconMenuClose = exports.IconMenuDefault = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: 24px;\n    height: 24px;\n    svg {\n        stroke: #fff;\n        fill: none;\n        stroke-width: 6;\n    }\n'], ['\n    width: 24px;\n    height: 24px;\n    svg {\n        stroke: #fff;\n        fill: none;\n        stroke-width: 6;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Icon = _styledComponents2.default.div(_templateObject);
	
	function IconMenuDefault(props) {
	    return _react2.default.createElement(
	        Icon,
	        null,
	        _react2.default.createElement(
	            'svg',
	            { viewBox: '0 0 64 64' },
	            _react2.default.createElement('path', {
	                strokeLinejoin: 'bevel',
	                d: 'M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994'
	            }),
	            _react2.default.createElement('path', { strokeLinejoin: 'bevel', d: 'm 5.1969746,31.909063 53.8166424,0' }),
	            _react2.default.createElement('path', {
	                strokeLinejoin: 'bevel',
	                d: 'M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698'
	            })
	        )
	    );
	}
	
	function IconMenuClose(props) {
	    return _react2.default.createElement(
	        Icon,
	        null,
	        _react2.default.createElement(
	            'svg',
	            { viewBox: '0 0 64 64' },
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'd',
	                    dur: '.25s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: 'M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994',
	                    to: 'M12.972944,50.936147C12.972944,50.936147,51.027056,12.882035,51.027056,12.882035',
	                    fill: 'freeze'
	                })
	            ),
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel', strokeOpacity: '1', d: 'm 5.1969746,31.909063 53.8166424,0' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'stroke-opacity',
	                    dur: '.125s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: '1',
	                    to: '0',
	                    fill: 'freeze'
	                })
	            ),
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'd',
	                    dur: '.25s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: 'M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698',
	                    to: 'M12.972944,12.882035000000002C12.972944,12.882035000000002,51.027056,50.936147,51.027056,50.936147',
	                    fill: 'freeze'
	                })
	            )
	        )
	    );
	}
	
	function IconMenuOpen(props) {
	    return _react2.default.createElement(
	        Icon,
	        null,
	        _react2.default.createElement(
	            'svg',
	            { viewBox: '0 0 64 64' },
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'd',
	                    dur: '.25s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: 'M12.972944,50.936147C12.972944,50.936147,51.027056,12.882035,51.027056,12.882035',
	                    to: 'M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994',
	                    fill: 'freeze'
	                })
	            ),
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel', strokeOpacity: '1', d: 'm 5.1969746,31.909063 53.8166424,0' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'stroke-opacity',
	                    dur: '.125s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: '0',
	                    to: '1',
	                    fill: 'freeze'
	                })
	            ),
	            _react2.default.createElement(
	                'path',
	                { strokeLinejoin: 'bevel' },
	                _react2.default.createElement('animate', {
	                    attributeName: 'd',
	                    dur: '.25s',
	                    repeatCount: '1',
	                    calcMode: 'spline',
	                    keySplines: '.1,.8,.2,1',
	                    from: 'M12.972944,12.882035000000002C12.972944,12.882035000000002,51.027056,50.936147,51.027056,50.936147',
	                    to: 'M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698',
	                    fill: 'freeze'
	                })
	            )
	        )
	    );
	}
	
	exports.IconMenuDefault = IconMenuDefault;
	exports.IconMenuClose = IconMenuClose;
	exports.IconMenuOpen = IconMenuOpen;

/***/ },
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainMenuMinimized = exports.MainMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    background-color: #fff;\n    box-sizing: border-box;\n    border-right: 1px solid ', ';\n    height: 100%;\n    width: 64px;\n    position: fixed;\n    z-index: 1300;\n    left: 0px;\n    top: 0px;\n    padding: 64px 0 0 0;\n    transition: all 0.4s ease-out;\n'], ['\n    background-color: #fff;\n    box-sizing: border-box;\n    border-right: 1px solid ', ';\n    height: 100%;\n    width: 64px;\n    position: fixed;\n    z-index: 1300;\n    left: 0px;\n    top: 0px;\n    padding: 64px 0 0 0;\n    transition: all 0.4s ease-out;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    border-bottom: 1px solid ', ';\n\n    &.active-section {\n        &:after {\n            content: \'\';\n            display: block;\n            width: 3px;\n            height: 100%;\n            background: ', ';\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: all 0.2s ease;\n        }\n    }\n\n    &:last-child {\n        border-bottom: none;\n    }\n'], ['\n    position: relative;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    border-bottom: 1px solid ', ';\n\n    &.active-section {\n        &:after {\n            content: \'\';\n            display: block;\n            width: 3px;\n            height: 100%;\n            background: ', ';\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: all 0.2s ease;\n        }\n    }\n\n    &:last-child {\n        border-bottom: none;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    max-height: 48px;\n\n    &.active,\n    &:hover {\n        background-color: ', ';\n        transition: all 0.3s ease-out;\n        svg {\n            fill: #fff !important;\n        }\n        div {\n            color: #fff;\n        }\n    }\n'], ['\n    max-height: 48px;\n\n    &.active,\n    &:hover {\n        background-color: ', ';\n        transition: all 0.3s ease-out;\n        svg {\n            fill: #fff !important;\n        }\n        div {\n            color: #fff;\n        }\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    max-height: 48px;\n    text-align: center;\n\n    &.active,\n    &:hover {\n        background-color: ', ';\n        transition: all 0.3s ease-out;\n        svg {\n            fill: #fff !important;\n        }\n    }\n'], ['\n    max-height: 48px;\n    text-align: center;\n\n    &.active,\n    &:hover {\n        background-color: ', ';\n        transition: all 0.3s ease-out;\n        svg {\n            fill: #fff !important;\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(188);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colors = __webpack_require__(910);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _home = __webpack_require__(1028);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _collections = __webpack_require__(1029);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _palette = __webpack_require__(1030);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _code = __webpack_require__(1032);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _allInclusive = __webpack_require__(1033);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _viewWeek = __webpack_require__(1034);
	
	var _viewWeek2 = _interopRequireDefault(_viewWeek);
	
	var _assignmentInd = __webpack_require__(1035);
	
	var _assignmentInd2 = _interopRequireDefault(_assignmentInd);
	
	var _viewQuilt = __webpack_require__(1036);
	
	var _viewQuilt2 = _interopRequireDefault(_viewQuilt);
	
	var _language = __webpack_require__(1037);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _settings = __webpack_require__(1038);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _message = __webpack_require__(1039);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _findInPage = __webpack_require__(1040);
	
	var _findInPage2 = _interopRequireDefault(_findInPage);
	
	var _findReplace = __webpack_require__(1041);
	
	var _findReplace2 = _interopRequireDefault(_findReplace);
	
	var _pictureInPicture = __webpack_require__(1042);
	
	var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);
	
	var _viewModule = __webpack_require__(1043);
	
	var _viewModule2 = _interopRequireDefault(_viewModule);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _liveTv = __webpack_require__(1044);
	
	var _liveTv2 = _interopRequireDefault(_liveTv);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reorder = __webpack_require__(1045);
	
	var _reorder2 = _interopRequireDefault(_reorder);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var MenuStickedMinimized = _styledComponents2.default.div(_templateObject, _colors.grey300);
	
	var UL = _styledComponents2.default.ul(_templateObject2, _colors.grey300, _colors.cyan500);
	
	var Item = _styledComponents2.default.li(_templateObject3, _colors.indigo500);
	
	var LI = _styledComponents2.default.li(_templateObject4, _colors.indigo500);
	
	var MENU_ITEMS = [{
	    name: 'Home',
	    link: '/home',
	    icon: _react2.default.createElement(_home2.default, null),
	    section: 'home'
	}, {
	    name: 'Social Messages',
	    link: '/messages',
	    icon: _react2.default.createElement(_message2.default, null),
	    section: 'others'
	}, {
	    name: 'Widgets',
	    link: '/widgets/pick',
	    icon: _react2.default.createElement(_code2.default, null),
	    section: 'html_js_widgets'
	}, {
	    name: 'Themes',
	    link: '/themes',
	    icon: _react2.default.createElement(_palette2.default, null),
	    section: 'html_js_widgets'
	}, {
	    name: 'Widget Overview',
	    link: '/v2/widgets',
	    external: true,
	    icon: _react2.default.createElement(_reorder2.default, null),
	    section: 'social_media_images'
	}, {
	    name: 'SM Browser',
	    link: '/sm/browser/football/tournaments/46',
	    parttern: '/sm/browser/football/tournaments',
	    icon: _react2.default.createElement(_share2.default, null),
	    section: 'social_media_images'
	}, {
	    name: 'SM Widgets',
	    link: '/sm/browser/post',
	    icon: _react2.default.createElement(_code2.default, null),
	    section: 'social_media_images'
	}, {
	    name: 'SM Templates',
	    link: '/sm/templates',
	    icon: _react2.default.createElement(_style2.default, null),
	
	    section: 'social_media_images'
	}, {
	    name: 'Campaigns',
	    link: '/campaigns',
	    icon: _react2.default.createElement(_allInclusive2.default, null),
	    // icon: ({
	    //     /*<Badge
	    //         badgeContent={10}
	    //         secondary
	    //         badgeStyle={{ top: '2px', right: '-6px', width: '18px', height: '18px', fontSize: '9px' }}
	    //         style={{ padding: 0 }}
	    //     >
	    //         <IconButton
	    //             iconStyle={{ fill: grey600 }}
	    //             touch
	    //             tooltipStyles={{ top: '65%', left: '100%' }}
	    //             tooltipPosition="top-right"
	    //             tooltip="Campaigns"
	    //         >
	    //             <IconCampaigns />
	    //         </IconButton>
	    //     </Badge>*/
	    // },
	    // (
	
	    // )),
	    section: 'scheduled_social_posting'
	}, {
	    name: 'TV Schedule',
	    link: '/tv-program',
	    icon: _react2.default.createElement(_liveTv2.default, null),
	    section: 'tv_program'
	}, {
	    name: 'Grid Maker Tool',
	    link: '/grid-maker-tool',
	    icon: _react2.default.createElement(_pictureInPicture2.default, null),
	    section: 'grid_maker_tool'
	}, {
	    name: 'Images',
	    link: '/media/uploads',
	    icon: _react2.default.createElement(_collections2.default, null),
	    section: 'others'
	}, {
	    name: 'Account Settings',
	    link: '/account',
	    icon: _react2.default.createElement(_settings2.default, null),
	    section: 'others'
	},
	// {
	//     name: 'Ids Finder',
	//     link: '/ids-finder/soccer/tournaments',
	//     icon: <IconFindInPage />,
	//     section: 'others',
	// },
	// {
	//     name: 'Provider Ids',
	//     link: '/mapping/nordic',
	//     icon: <IconFindAndReplace />,
	//     section: 'others',
	// },
	// {
	//     name: 'Player Performance Index',
	//     link: '/ppi',
	//     icon: <IconViewModule />,
	//     section: 'others',
	// },
	{
	    name: 'Accounts',
	    link: '/admin/accounts',
	    icon: _react2.default.createElement(_assignmentInd2.default, null),
	    section: 'administration'
	}, {
	    name: 'Packs',
	    link: '/admin/packs',
	    icon: _react2.default.createElement(_viewWeek2.default, null),
	    section: 'administration'
	}, {
	    name: 'Users Packs',
	    link: '/admin/users-packs',
	    icon: _react2.default.createElement(_assignmentInd2.default, null),
	    section: 'administration'
	}, {
	    name: 'Widgets Dashboard',
	    link: '/admin/widgets-dashboard',
	    icon: _react2.default.createElement(_viewQuilt2.default, null),
	    section: 'administration'
	}, {
	    name: 'i18 Dashboard',
	    link: '/admin/common-i18-dashboard',
	    icon: _react2.default.createElement(_language2.default, null),
	    section: 'administration'
	}];
	
	var getMenuSections = function getMenuSections(_ref) {
	    var isHTMLAllowed = _ref.isHTMLAllowed,
	        isSMAllowed = _ref.isSMAllowed,
	        isCampaignsAllowed = _ref.isCampaignsAllowed,
	        hasAdminRights = _ref.hasAdminRights,
	        isTVAllowed = _ref.isTVAllowed,
	        isGridMakerToolAllowed = _ref.isGridMakerToolAllowed;
	
	    var sections = [{
	        name: 'home',
	        allowed: true
	    }, {
	        name: 'html_js_widgets',
	        allowed: isHTMLAllowed,
	        menuHeading: 'HTML/JS Widgets'
	    }, {
	        name: 'social_media_images',
	        allowed: isSMAllowed,
	        menuHeading: 'Social Media Images'
	    }, {
	        name: 'tv_program',
	        allowed: isTVAllowed,
	        menuHeading: 'TV'
	    }, {
	        name: 'grid_maker_tool',
	        allowed: isGridMakerToolAllowed,
	        menuHeading: 'Grid Maker Tool'
	    }, {
	        name: 'scheduled_social_posting',
	        allowed: isSMAllowed && isCampaignsAllowed,
	        menuHeading: 'Scheduled Social Posting'
	    }, {
	        name: 'others',
	        allowed: true,
	        menuHeading: false
	    }, {
	        name: 'administration',
	        allowed: hasAdminRights,
	        menuHeading: 'Administration'
	    }];
	
	    return sections;
	};
	
	var MainMenu = function (_Component) {
	    _inherits(MainMenu, _Component);
	
	    function MainMenu() {
	        _classCallCheck(this, MainMenu);
	
	        return _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).apply(this, arguments));
	    }
	
	    _createClass(MainMenu, [{
	        key: 'addActiveClass',
	        value: function addActiveClass(linkTo) {
	            var pathname = this.context.router.location.pathname;
	
	            return linkTo === pathname ? 'active' : '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                drawerOpen = _props.drawerOpen,
	                handleDrawerClose = _props.handleDrawerClose,
	                onRequestChange = _props.onRequestChange;
	
	
	            var user = this.context.user;
	
	            var isHTMLAllowed = user && _lodash2.default.get(user, 'permissions.htmlWidgets', false);
	            var isSMAllowed = user && _lodash2.default.get(user, 'permissions.smWidgets', false);
	            var isCampaignsAllowed = user && _lodash2.default.get(user, 'permissions.campaigns', false);
	            var isTVAllowed = user && _lodash2.default.get(user, 'permissions.tvSchedule', false);
	            var isGridMakerToolAllowed = user && _lodash2.default.get(user, 'permissions.gridMakerTool', false);
	
	            var hasAdminRights = _auth2.default.hasAdminRights();
	
	            var sections = getMenuSections({
	                isHTMLAllowed: isHTMLAllowed,
	                isSMAllowed: isSMAllowed,
	                isCampaignsAllowed: isCampaignsAllowed,
	                hasAdminRights: hasAdminRights,
	                isTVAllowed: isTVAllowed,
	                isGridMakerToolAllowed: isGridMakerToolAllowed
	            });
	            var pathname = this.context.router.location.pathname;
	            return _react2.default.createElement(
	                rmd.Drawer,
	                {
	                    open: drawerOpen,
	                    docked: true,
	                    zDepth: 1,
	                    onRequestChange: onRequestChange(),
	                    containerClassName: 'drawer'
	                },
	                _react2.default.createElement('div', { className: 'drawer-top' }),
	                sections.map(function (section) {
	                    var allowed = section.allowed || hasAdminRights;
	
	                    if (!allowed) {
	                        return;
	                    }
	                    return _react2.default.createElement(
	                        UL,
	                        { key: section.name },
	                        section.menuHeading && _react2.default.createElement(
	                            'li',
	                            { className: 'menu-heading' },
	                            section.menuHeading
	                        ),
	                        MENU_ITEMS.map(function (item) {
	                            //for grouping menu items into UL
	                            if (section.name !== item.section) return;
	
	                            return _react2.default.createElement(
	                                Item,
	                                {
	                                    key: item.name,
	                                    className: (0, _classnames2.default)({
	                                        active: pathname.indexOf(item.parttern || item.parttern) === 0
	                                    }),
	                                    onClick: function onClick(e) {
	                                        if (item.external) {
	                                            e.stopPropagation();
	                                            window.location.href = item.link;
	                                        }
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: item.link },
	                                    _react2.default.createElement(
	                                        rmd.MenuItem,
	                                        { leftIcon: item.icon, onTouchTap: handleDrawerClose('home') },
	                                        item.name
	                                    )
	                                )
	                            );
	                        })
	                    );
	                })
	            );
	        }
	    }]);
	
	    return MainMenu;
	}(_react.Component);
	
	MainMenu.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	
	var MainMenuMinimized = function (_Component2) {
	    _inherits(MainMenuMinimized, _Component2);
	
	    function MainMenuMinimized() {
	        _classCallCheck(this, MainMenuMinimized);
	
	        return _possibleConstructorReturn(this, (MainMenuMinimized.__proto__ || Object.getPrototypeOf(MainMenuMinimized)).apply(this, arguments));
	    }
	
	    _createClass(MainMenuMinimized, [{
	        key: 'render',
	        value: function render() {
	            var drawerOpen = this.props.drawerOpen;
	
	            var pathname = this.context.router.location.pathname;
	            var user = this.context.user;
	            var isHTMLAllowed = user && _lodash2.default.get(user, 'permissions.htmlWidgets', false);
	            var isSMAllowed = user && _lodash2.default.get(user, 'permissions.smWidgets', false);
	            var isCampaignsAllowed = user && _lodash2.default.get(user, 'permissions.campaigns', false);
	            var isTVAllowed = user && _lodash2.default.get(user, 'permissions.tvSchedule', false);
	            var isGridMakerToolAllowed = user && _lodash2.default.get(user, 'permissions.gridMakerTool', false);
	
	            var hasAdminRights = _auth2.default.hasAdminRights();
	
	            var sections = getMenuSections({
	                isHTMLAllowed: isHTMLAllowed,
	                isSMAllowed: isSMAllowed,
	                isCampaignsAllowed: isCampaignsAllowed,
	                hasAdminRights: hasAdminRights,
	                isTVAllowed: isTVAllowed,
	                isGridMakerToolAllowed: isGridMakerToolAllowed
	            });
	
	            var activeMenuItem = _lodash2.default.find(MENU_ITEMS, function (item) {
	                return pathname.indexOf(item.parttern || item.parttern) === 0;
	            });
	
	            var menuStyles = {
	                transform: drawerOpen ? 'translateX(-100%)' : 'translateX(0)'
	            };
	
	            return _react2.default.createElement(
	                MenuStickedMinimized,
	                { style: menuStyles },
	                sections.map(function (section) {
	                    var allowed = section.allowed || hasAdminRights;
	                    if (!allowed) return;
	                    return _react2.default.createElement(
	                        UL,
	                        {
	                            key: section.name,
	                            className: (0, _classnames2.default)({
	                                'active-section': activeMenuItem && section.name === activeMenuItem.section
	                            })
	                        },
	                        MENU_ITEMS.map(function (item) {
	                            //for grouping menu items into UL
	                            if (section.name !== item.section) return;
	
	                            return _react2.default.createElement(
	                                LI,
	                                {
	                                    key: item.link,
	                                    className: (0, _classnames2.default)({
	                                        active: pathname.indexOf(item.parttern || item.parttern) === 0
	                                    })
	                                },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: item.link,
	                                        onClick: function onClick(e) {
	                                            if (item.external) {
	                                                e.stopPropagation();
	                                                window.location.href = item.link;
	                                            }
	                                        }
	                                    },
	                                    _react2.default.createElement(
	                                        _IconButton2.default,
	                                        {
	                                            iconStyle: { fill: _colors.grey600 },
	                                            tooltipStyles: {
	                                                left: 60,
	                                                top: 0,
	                                                zIndex: 100000,
	                                                pointerEvents: 'none'
	                                            },
	                                            tooltip: item.name
	                                        },
	                                        item.icon
	                                    )
	                                )
	                            );
	                        })
	                    );
	                })
	            );
	        }
	    }]);
	
	    return MainMenuMinimized;
	}(_react.Component);
	
	MainMenuMinimized.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = MainMenu;
	exports.MainMenu = MainMenu;
	exports.MainMenuMinimized = MainMenuMinimized;

/***/ },
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GlobalSnackBar = exports.showSnackBarMessage = exports.closeSnackBar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _reactRedux = __webpack_require__(250);
	
	var _ui = __webpack_require__(574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var closeSnackBar = exports.closeSnackBar = function closeSnackBar(dispatch) {
	    dispatch({ type: _ui.UI_ACTIONS.CHANGE, key: 'snackbarOpen', value: false });
	    dispatch({ type: _ui.UI_ACTIONS.CHANGE, key: 'snackbarText', value: null });
	};
	var timer = void 0;
	var showSnackBarMessage = exports.showSnackBarMessage = function showSnackBarMessage(message) {
	    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
	    return function (dispatch) {
	        clearTimeout(timer);
	        dispatch({ type: _ui.UI_ACTIONS.CHANGE, key: 'snackbarText', value: message });
	        dispatch({ type: _ui.UI_ACTIONS.CHANGE, key: 'snackbarOpen', value: true });
	        if (Number.isFinite(time)) {
	            timer = setTimeout(function () {
	                dispatch(closeSnackBar);
	            }, time);
	        }
	    };
	};
	
	var GlobalSnackBar = exports.GlobalSnackBar = (0, _reactRedux.connect)(function (_ref) {
	    var ui = _ref.ui;
	    return {
	        open: Boolean(ui.snackbarOpen),
	        text: ui.snackbarText || ''
	    };
	})(function (_ref2) {
	    var open = _ref2.open,
	        text = _ref2.text;
	    return _react2.default.createElement(_materialUi.Snackbar, { open: open, message: text });
	});

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _widgetSpecs = __webpack_require__(1048);
	
	Object.defineProperty(exports, 'fetchWidgetSpecs', {
	  enumerable: true,
	  get: function get() {
	    return _widgetSpecs.fetchWidgetSpecs;
	  }
	});
	
	var _templates = __webpack_require__(1050);
	
	Object.defineProperty(exports, 'fetchTemplates', {
	  enumerable: true,
	  get: function get() {
	    return _templates.fetchTemplates;
	  }
	});
	Object.defineProperty(exports, 'fetchTemplateById', {
	  enumerable: true,
	  get: function get() {
	    return _templates.fetchTemplateById;
	  }
	});
	
	var _user = __webpack_require__(1051);
	
	Object.keys(_user).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _user[key];
	    }
	  });
	});
	
	var _tournaments = __webpack_require__(1052);
	
	Object.defineProperty(exports, 'fetchTournamentById', {
	  enumerable: true,
	  get: function get() {
	    return _tournaments.fetchTournamentById;
	  }
	});
	
	var _portolio = __webpack_require__(1053);
	
	Object.defineProperty(exports, 'fetchPortfolio', {
	  enumerable: true,
	  get: function get() {
	    return _portolio.fetchPortfolio;
	  }
	});
	
	var _teams = __webpack_require__(1054);
	
	Object.defineProperty(exports, 'fetchTeamById', {
	  enumerable: true,
	  get: function get() {
	    return _teams.fetchTeamById;
	  }
	});
	Object.defineProperty(exports, 'fetchTeamsBySportAndLeague', {
	  enumerable: true,
	  get: function get() {
	    return _teams.fetchTeamsBySportAndLeague;
	  }
	});
	
	var _events = __webpack_require__(1058);
	
	Object.defineProperty(exports, 'fetchEventById', {
	  enumerable: true,
	  get: function get() {
	    return _events.fetchEventById;
	  }
	});
	Object.defineProperty(exports, 'fetchEventsByTournament', {
	  enumerable: true,
	  get: function get() {
	    return _events.fetchEventsByTournament;
	  }
	});
	Object.defineProperty(exports, 'fetchEventsByDate', {
	  enumerable: true,
	  get: function get() {
	    return _events.fetchEventsByDate;
	  }
	});

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchWidgetSpecs = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchWidgetSpecs = exports.fetchWidgetSpecs = function fetchWidgetSpecs(template) {
	    var requestConfig = (0, _helpers.createApiFetch)({
	        url: _cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken() + '&template=' + template,
	        key: _constants.STORE_KEYS.WIDGET_SPECS
	    });
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createApiFetchById = exports.handleServerError = exports.createPostRequest = exports.createApiFetch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _reduxForm = __webpack_require__(342);
	
	var _actions = __webpack_require__(593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultTransform = function defaultTransform(key) {
	    return function (v) {
	        return _defineProperty({}, key, v);
	    };
	};
	
	var defaultUpdate = function defaultUpdate(key) {
	    return _defineProperty({}, key, _actions.UPDATE_DEFAULT.LATEST);
	};
	
	var createApiFetch = exports.createApiFetch = function createApiFetch(_ref3) {
	    var url = _ref3.url,
	        key = _ref3.key,
	        _ref3$queryKey = _ref3.queryKey,
	        queryKey = _ref3$queryKey === undefined ? key : _ref3$queryKey,
	        _ref3$configOptions = _ref3.configOptions,
	        configOptions = _ref3$configOptions === undefined ? {} : _ref3$configOptions;
	    return _extends({
	        url: url,
	        transform: defaultTransform(key),
	        queryKey: queryKey,
	        force: true,
	        update: defaultUpdate(key)
	    }, configOptions);
	};
	
	var createPostRequest = exports.createPostRequest = function createPostRequest(_ref4) {
	    var url = _ref4.url,
	        body = _ref4.body,
	        _ref4$key = _ref4.key,
	        key = _ref4$key === undefined ? '' : _ref4$key,
	        _ref4$configOptions = _ref4.configOptions,
	        configOptions = _ref4$configOptions === undefined ? {} : _ref4$configOptions;
	    var options = configOptions.options;
	
	    return _extends({
	        url: url,
	        body: body,
	        queryKey: key,
	        update: defaultUpdate(key),
	        force: true,
	        options: _extends({}, options, { method: _reduxQuery.httpMethods.POST })
	    }, configOptions);
	};
	
	var handleServerError = exports.handleServerError = function handleServerError(response) {
	    var status = response.status;
	
	    if (status >= 400) {
	        var body = response.body;
	
	        throw new _reduxForm.SubmissionError(body);
	    }
	    if (!status) {
	        throw new _reduxForm.SubmissionError({ _error: 'Server is not responding' });
	    }
	};
	
	var transformById = function transformById(dataKey, idKey) {
	    return function (data) {
	        var _ref5 = data || {},
	            id = _ref5[idKey];
	
	        if (id === undefined) {
	            return {};
	        }
	        return _defineProperty({}, dataKey, _defineProperty({}, id, data));
	    };
	};
	
	var createApiFetchById = exports.createApiFetchById = function createApiFetchById(_ref7) {
	    var url = _ref7.url,
	        id = _ref7.id,
	        key = _ref7.key,
	        _ref7$idKey = _ref7.idKey,
	        idKey = _ref7$idKey === undefined ? 'id' : _ref7$idKey,
	        body = _ref7.body;
	
	    var requestConfig = {
	        url: url,
	        key: key,
	        body: body,
	        queryKey: key + '/' + id,
	        force: false,
	        transform: transformById(key, idKey),
	        update: _defineProperty({}, key, function (prev, curr) {
	            return _extends({}, prev, curr);
	        })
	    };
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchTemplateById = exports.fetchTemplates = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchTemplates = exports.fetchTemplates = function fetchTemplates() {
	    var requestConfig = (0, _helpers.createApiFetch)({
	        url: '/api/templates/list?access_token=' + _auth2.default.getAccessToken(),
	        key: _constants.STORE_KEYS.TEMPLATES
	    });
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};
	
	var fetchTemplateById = exports.fetchTemplateById = function fetchTemplateById(id) {
	    var requestConfig = (0, _helpers.createApiFetch)({
	        url: '/api/templates/' + id + '?access_token=' + _auth2.default.getAccessToken(),
	        key: _constants.STORE_KEYS.TEMPLATE_BY_ID + '.' + id
	    });
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};

/***/ },
/* 1051 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchTournamentsBySport = exports.fetchAllTournaments = exports.fetchTournamentById = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _selectors = __webpack_require__(618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ss2 = _cfg2.default.apis.ss2;
	
	var fetchTournamentById = exports.fetchTournamentById = function fetchTournamentById(tournamentId) {
	    var url = ss2 + '/tournaments/' + tournamentId;
	    return (0, _helpers.createApiFetchById)({
	        id: tournamentId,
	        url: url,
	        key: _constants.STORE_KEYS.TOURNAMENTS + _constants.STORE_KEYS.BY_ID
	    });
	};
	
	var fetchAllTournaments = exports.fetchAllTournaments = function fetchAllTournaments() {
	    var url = ss2 + '/tournaments';
	    return (0, _reduxQuery.requestAsync)((0, _helpers.createApiFetch)({
	        url: url,
	        key: _constants.STORE_KEYS.TOURNAMENTS,
	        configOptions: {
	            force: false
	        }
	    }));
	};
	
	var fetchTournamentsBySport = exports.fetchTournamentsBySport = function fetchTournamentsBySport(sportId) {
	    var key = (0, _selectors.tournamentsKey)(sportId);
	    return (0, _reduxQuery.requestAsync)({
	        url: ss2 + '/tournaments' + (sportId ? '?sportId=' + sportId : ''),
	        queryKey: key,
	        transform: function transform(response) {
	            return _defineProperty({}, key, Array.isArray(response) ? response.filter(function (tournament) {
	                return _cfg2.default.triggerer.supportedLeagues.indexOf(tournament.id) !== -1;
	            }) : []);
	        },
	        update: _defineProperty({}, key, function (prev, next) {
	            return next;
	        })
	    });
	};

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPortfolio = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchPortfolio = exports.fetchPortfolio = function fetchPortfolio(type) {
	    var requestConfig = (0, _helpers.createApiFetch)({
	        url: '/api/portfolio/' + (type || 'default') + '?access_token=' + _auth2.default.getAccessToken(),
	        key: _constants.STORE_KEYS.PORTFOLIO
	    });
	
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchTeamsBySportAndLeague = exports.fetchTeamById = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _queryString = __webpack_require__(1055);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _selectors = __webpack_require__(618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ss2 = _cfg2.default.apis.ss2;
	
	var fetchTeamById = exports.fetchTeamById = function fetchTeamById(teamId) {
	    var url = ss2 + '/teams/' + teamId;
	    return (0, _helpers.createApiFetchById)({
	        id: teamId,
	        url: url,
	        key: _constants.STORE_KEYS.TEAMS
	    });
	};
	
	var fetchTeamsBySportAndLeague = exports.fetchTeamsBySportAndLeague = function fetchTeamsBySportAndLeague(_ref) {
	    var _update;
	
	    var sportId = _ref.sportId,
	        tournamentId = _ref.tournamentId;
	
	    var key = (0, _selectors.teamsKeyBySportAndTtId)(sportId, tournamentId);
	    var query = _queryString2.default.stringify({
	        ttId: tournamentId,
	        sportId: sportId
	    });
	    var url = ss2 + '/teams?' + query;
	    if (tournamentId) {
	        url = ss2 + '/tournaments/' + tournamentId + '/teams';
	    }
	
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(teams) {
	            var _ref2;
	
	            return _ref2 = {}, _defineProperty(_ref2, key, teams.map(function (team) {
	                return team.id;
	            })), _defineProperty(_ref2, 'teams', teams.reduce(function (acc, cur) {
	                acc[cur.id] = cur;
	                return acc;
	            }, {})), _ref2;
	        },
	        update: (_update = {}, _defineProperty(_update, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update, 'teams', function teams(prev, next) {
	            return _extends({}, prev, next);
	        }), _update)
	    });
	};

/***/ },
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchEventsByDate = exports.fetchComingEventsForStage = exports.fetchComingEventsForStageKey = exports.fetchEvents = exports.fetchEventsKey = exports.fetchLatestEventsForStage = exports.fetchLatestEventsForStageKey = exports.fetchRoundEventsForStage = exports.fetchRoundEventsForStageKey = exports.fetchEventsByTournament = exports.fetchEventById = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _selectors = __webpack_require__(618);
	
	var _querystring = __webpack_require__(291);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ss2 = _cfg2.default.apis.ss2;
	var fetchEventById = exports.fetchEventById = function fetchEventById(eventId) {
	    return function (dispatch, getState) {
	        var url = ss2 + '/events/' + eventId;
	        var locale = (0, _get2.default)(getState(), ['user', 'props', 'lang']);
	        return dispatch((0, _helpers.createApiFetchById)({
	            id: eventId,
	            url: url,
	            idKey: 'eventId',
	            key: _constants.STORE_KEYS.EVENTS,
	            body: {
	                locale: locale
	            }
	        }));
	    };
	};
	
	var fetchEventsByTournament = exports.fetchEventsByTournament = function fetchEventsByTournament(_ref) {
	    var _update;
	
	    var sportId = _ref.sportId,
	        tournamentId = _ref.tournamentId,
	        _ref$fromDate = _ref.fromDate,
	        fromDate = _ref$fromDate === undefined ? (0, _moment2.default)().startOf('d').toJSON() : _ref$fromDate;
	
	    var tournamentPart = tournamentId ? '&ttId=' + tournamentId : '';
	    var sportPart = sportId ? '&sportId=' + sportId : '';
	    var url = ss2 + '/events-v2?fromDate=' + fromDate + '&limit=10' + tournamentPart + sportPart;
	    var key = (0, _selectors.eventsKeyBySportAndTtId)(sportId, tournamentId);
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref2) {
	            var _ref3;
	
	            var events = _ref2.events;
	            return _ref3 = {}, _defineProperty(_ref3, key, events.map(function (e) {
	                return e.eventId;
	            })), _defineProperty(_ref3, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref3;
	        },
	        update: (_update = {}, _defineProperty(_update, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update)
	    });
	};
	
	var fetchRoundEventsForStageKey = exports.fetchRoundEventsForStageKey = function fetchRoundEventsForStageKey(stageId, round) {
	    return 'events:stage:round:' + stageId + ':' + round;
	};
	
	var fetchRoundEventsForStage = exports.fetchRoundEventsForStage = function fetchRoundEventsForStage(stageId, round) {
	    var _update2;
	
	    var url = ss2 + '/events-v2?stageId=' + stageId + '&round=' + round;
	    var key = fetchRoundEventsForStageKey(stageId, round);
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref4) {
	            var _ref5;
	
	            var events = _ref4.events;
	            return _ref5 = {}, _defineProperty(_ref5, key, events.map(function (e) {
	                return e.eventId;
	            })), _defineProperty(_ref5, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref5;
	        },
	        update: (_update2 = {}, _defineProperty(_update2, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update2, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update2)
	    });
	};
	
	var fetchLatestEventsForStageKey = exports.fetchLatestEventsForStageKey = function fetchLatestEventsForStageKey(stageId) {
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	    return 'events:latests:' + stageId;
	};
	
	var fetchLatestEventsForStage = exports.fetchLatestEventsForStage = function fetchLatestEventsForStage(stageId) {
	    var _update3;
	
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	
	    var date = (0, _moment2.default)().startOf('day');
	
	    var url = ss2 + '/events-v2?stageId=' + stageId + '&toDate=' + date.format('YYYY-MM-DD') + '&sortDirection=desc&limit=' + limit;
	
	    var key = fetchLatestEventsForStageKey(stageId);
	
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref6) {
	            var _ref7;
	
	            var events = _ref6.events;
	            return _ref7 = {}, _defineProperty(_ref7, key, events.map(function (e) {
	                return e.eventId;
	            }).reverse()), _defineProperty(_ref7, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref7;
	        },
	        update: (_update3 = {}, _defineProperty(_update3, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update3, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update3)
	    });
	};
	
	var fetchEventsKey = exports.fetchEventsKey = function fetchEventsKey(props) {
	    return 'events:' + _querystring2.default.stringify(props);
	};
	
	var fetchEvents = exports.fetchEvents = function fetchEvents(props) {
	    var _update4;
	
	    var url = ss2 + '/events-v2?' + _querystring2.default.stringify(props);
	    var key = fetchEventsKey(props);
	
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref8) {
	            var _ref9;
	
	            var events = _ref8.events;
	            return _ref9 = {}, _defineProperty(_ref9, key, events.map(function (e) {
	                return e.eventId;
	            })), _defineProperty(_ref9, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref9;
	        },
	        update: (_update4 = {}, _defineProperty(_update4, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update4, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update4)
	    });
	};
	
	var fetchComingEventsForStageKey = exports.fetchComingEventsForStageKey = function fetchComingEventsForStageKey(stageId) {
	    return 'events:coming:' + stageId;
	};
	
	var fetchComingEventsForStage = exports.fetchComingEventsForStage = function fetchComingEventsForStage(stageId) {
	    var _update5;
	
	    var date = (0, _moment2.default)().startOf('day');
	    var url = ss2 + '/events-v2?stageId=' + stageId + '&fromDate=' + date.format('YYYY-MM-DD') + '&sortDirection=asc&limit=12';
	    var key = fetchComingEventsForStageKey(stageId);
	
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref10) {
	            var _ref11;
	
	            var events = _ref10.events;
	            return _ref11 = {}, _defineProperty(_ref11, key, events.map(function (e) {
	                return e.eventId;
	            })), _defineProperty(_ref11, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref11;
	        },
	        update: (_update5 = {}, _defineProperty(_update5, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update5, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update5)
	    });
	};
	
	var fetchEventsByDate = exports.fetchEventsByDate = function fetchEventsByDate(date) {
	    var _update6;
	
	    var d = (0, _moment2.default)(date);
	    var fromDate = d.clone().startOf('d');
	    var toDate = d.clone().endOf('d');
	    var url = ss2 + '/events-v2?fromDate=' + fromDate.toJSON() + '&toDate=' + toDate.toJSON();
	    var key = (0, _selectors.eventsKeyByDate)(date);
	    return (0, _reduxQuery.requestAsync)({
	        url: url,
	        queryKey: key,
	        force: true,
	        transform: function transform(_ref12) {
	            var _ref13;
	
	            var events = _ref12.events;
	            return _ref13 = {}, _defineProperty(_ref13, key, events.map(function (e) {
	                return e.eventId;
	            })), _defineProperty(_ref13, 'events', events.reduce(function (acc, cur) {
	                acc[cur.eventId] = cur;
	                return acc;
	            }, {})), _ref13;
	        },
	        update: (_update6 = {}, _defineProperty(_update6, key, function (prev, next) {
	            return next;
	        }), _defineProperty(_update6, 'events', function events(prev, next) {
	            return _extends({}, prev, next);
	        }), _update6)
	    });
	};

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _under_construction = __webpack_require__(1060);
	
	var _under_construction2 = _interopRequireDefault(_under_construction);
	
	var _tw = __webpack_require__(1061);
	
	var _tw2 = _interopRequireDefault(_tw);
	
	var _fb = __webpack_require__(1062);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _edit_theme = __webpack_require__(1063);
	
	var _edit_theme2 = _interopRequireDefault(_edit_theme);
	
	var _create_widget = __webpack_require__(1064);
	
	var _create_widget2 = _interopRequireDefault(_create_widget);
	
	var _suggested = __webpack_require__(1065);
	
	var _suggested2 = _interopRequireDefault(_suggested);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FAQ = function (_React$Component) {
	    _inherits(FAQ, _React$Component);
	
	    function FAQ(props, context) {
	        _classCallCheck(this, FAQ);
	
	        var _this = _possibleConstructorReturn(this, (FAQ.__proto__ || Object.getPrototypeOf(FAQ)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(FAQ, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var colors = ['#F4013C', '#F46E02', '#04A9F4'];
	            return _react2.default.createElement(
	                'div',
	                { className: 'home' },
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Hi, ',
	                        user.username
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FAQ;
	}(_react2.default.Component);
	
	FAQ.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = FAQ;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/under_construction.png";

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/tw.png";

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/fb.png";

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/edit_theme.png";

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/create_widget.png";

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/suggested.png";

/***/ },
/* 1066 */,
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _reactRouter = __webpack_require__(188);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _save = __webpack_require__(1069);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var I18 = function (_React$Component) {
	    _inherits(I18, _React$Component);
	
	    function I18(props, context) {
	        _classCallCheck(this, I18);
	
	        var _this = _possibleConstructorReturn(this, (I18.__proto__ || Object.getPrototypeOf(I18)).call(this, props, context));
	
	        _this.loadData = function () {
	            var user = _this.context.user;
	            var supportedLanguages = _this.props.supportedLanguages;
	
	            if (!user || !user.client) return null;
	
	            return _bluebird2.default.props({
	                spec: fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?i18=true&access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                    return response.json();
	                }),
	                i18: fetch('/api/i18/' + user.client + '/' + user.username).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                var values = result.i18.values || {};
	
	                // if new values will came -> set those vals
	                _lodash2.default.each(result.spec.widgets, function (widget) {
	                    values[widget.id] = values[widget.id] || {};
	                    _lodash2.default.each(supportedLanguages, function (lang) {
	                        values[widget.id][lang] = values[widget.id][lang] || {};
	                        var userLangDict = _lodash2.default.get(values, widget.id + '.' + lang, {});
	                        var defLangDict = _lodash2.default.get(widget, 'i18.' + lang, {});
	
	                        _lodash2.default.each(Object.keys(defLangDict), function (key) {
	                            if (!userLangDict[key]) {
	                                userLangDict[key] = defLangDict[key];
	                            }
	                        });
	                    });
	                });
	
	                _this.setState({
	                    spec: result.spec,
	                    values: values
	                });
	            });
	        };
	
	        _this.renderInputGroup = function (widget, key, defVal) {
	            var supportedLanguages = _this.props.supportedLanguages;
	            var values = _this.state.values;
	
	
	            return _react2.default.createElement(
	                rmd.TableRow,
	                { key: widget.name + '_' + key },
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    widget.id + '.lang.' + key
	                ),
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    defVal
	                ),
	                supportedLanguages.map(function (lang) {
	                    var langDictionary = _lodash2.default.get(values, widget.id + '.' + lang, {});
	                    var value = langDictionary[key];
	
	                    return _react2.default.createElement(
	                        rmd.TableRowColumn,
	                        { key: widget.id + '.' + lang + '.' + key },
	                        _react2.default.createElement(rmd.TextField, {
	                            defaultValue: value,
	                            id: widget.id + '.' + lang + '.' + key,
	                            onBlur: function onBlur(event) {
	                                var langVals = _lodash2.default.get(values, widget.id + '.' + lang, {});
	                                langVals[key] = event.target.value;
	                                _lodash2.default.set(values, widget.id + '.' + lang, langVals);
	                                _this.setState({ values: values });
	                            }
	                        })
	                    );
	                })
	            );
	        };
	
	        _this.state = {
	            spec: {},
	            values: {}
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(I18, [{
	        key: 'handleSaveTranslations',
	        value: function handleSaveTranslations() {
	            var user = this.context.user;
	            fetch('/api/i18/' + user.client + '/' + user.username, {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(this.state.values)
	            }).then(function (response) {
	                var status = response.status;
	
	                if (status == 200) {
	                    return response.json();
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var supportedLanguages = this.props.supportedLanguages;
	
	            var user = this.context.user;
	            var _state = this.state,
	                spec = _state.spec,
	                specError = _state.specError,
	                filter = _state.filter;
	
	
	            if (!spec) {
	                var iconStyle = {
	                    width: 30,
	                    height: 30,
	                    marginRight: 15,
	                    marginBottom: -10
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_error2.default, { color: _colors.red500, style: iconStyle }),
	                    'Widget specification not found for client ',
	                    user.client
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'pick-widget' },
	                _react2.default.createElement(
	                    rmd.FloatingActionButton,
	                    {
	                        onClick: function onClick() {
	                            return _this2.handleSaveTranslations();
	                        },
	                        style: {
	                            position: 'fixed',
	                            bottom: '30px',
	                            right: '30px',
	                            zIndex: 1000
	                        }
	                    },
	                    _react2.default.createElement(_save2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _lodash2.default.chain(spec.widgets || []).map(function (widget, i) {
	                                var inherited = _lodash2.default.get(widget, 'i18.inherited', false);
	                                var dictionary = _lodash2.default.get(widget, 'i18.en', {});
	
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: widget.id, className: 'col-xs-12' },
	                                    _react2.default.createElement(
	                                        rmd.Card,
	                                        { className: 'widget-template' },
	                                        _react2.default.createElement('div', { style: { height: '1px' } }),
	                                        _react2.default.createElement(rmd.CardTitle, { title: widget.name, subtitle: 'id: ' + widget.id }),
	                                        _react2.default.createElement(
	                                            rmd.CardText,
	                                            null,
	                                            _lodash2.default.get(widget, 'i18.inherited', false) && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                'I18 is inherited from parent widget'
	                                            ),
	                                            !inherited && _lodash2.default.isEmpty(dictionary) && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                'I18 is not configured - ask developer'
	                                            ),
	                                            !inherited && !_lodash2.default.isEmpty(dictionary) && _react2.default.createElement(
	                                                rmd.Table,
	                                                { selectable: false },
	                                                _react2.default.createElement(
	                                                    rmd.TableHeader,
	                                                    { displaySelectAll: false },
	                                                    _react2.default.createElement(
	                                                        rmd.TableRow,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            rmd.TableHeaderColumn,
	                                                            null,
	                                                            'Key'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            rmd.TableHeaderColumn,
	                                                            null,
	                                                            'Dev example'
	                                                        ),
	                                                        supportedLanguages.map(function (lang) {
	                                                            return _react2.default.createElement(
	                                                                rmd.TableHeaderColumn,
	                                                                { key: lang },
	                                                                lang
	                                                            );
	                                                        })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    rmd.TableBody,
	                                                    { displayRowCheckbox: false, showRowHover: true },
	                                                    Object.keys(dictionary).map(function (k) {
	                                                        return _this2.renderInputGroup(widget, k, dictionary[k]);
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                );
	                            }).value()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return I18;
	}(_react2.default.Component);
	
	I18.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	I18.defaultProps = {
	    supportedLanguages: ['en', 'da', 'no']
	};
	exports.default = I18;

/***/ },
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _googleClientApi = __webpack_require__(1074);
	
	var _googleClientApi2 = _interopRequireDefault(_googleClientApi);
	
	var _arrowForward = __webpack_require__(1082);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _allInclusive = __webpack_require__(1033);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _code = __webpack_require__(1032);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COLORS = ['#F4013C', '#F46E02', '#3F51B5', '#E91E63'];
	
	var Home = function (_React$Component) {
	    _inherits(Home, _React$Component);
	
	    function Home(props, context) {
	        _classCallCheck(this, Home);
	
	        var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props, context));
	
	        _this.loadData = function () {
	            var token = _auth2.default.getAccessToken();
	            if (!token) {
	                return Promise.resolve(null);
	            }
	            return fetch(_cfg2.default.dash.api.host + '/api/widgets?access_token=' + token).then(function (response) {
	                return response.json();
	            }).then(function (body) {
	                return _this.setState({
	                    widgets: body.widgets,
	                    isLoading: false
	                });
	            }).catch(function (err) {
	                _this.setState({ error: err, isLoading: false });
	            });
	        };
	
	        _this.buildCharts = function (gapi, path, viewSelectorContainer, chartContainer) {
	            return fetch(_cfg2.default.dash.api.host + '/api/auth/google/token').then(function (response) {
	                return response.json();
	            }).then(function (tokens) {
	                gapi.analytics.auth.authorize({
	                    serverAuth: {
	                        access_token: tokens.access_token
	                    }
	                });
	
	                var viewSelector = new gapi.analytics.ViewSelector({
	                    container: viewSelectorContainer
	                });
	                viewSelector.execute();
	
	                var dataChart = new gapi.analytics.googleCharts.DataChart({
	                    query: {
	                        metrics: 'ga:sessions, ga:pageviews, ga:users',
	                        dimensions: 'ga:date',
	                        filters: 'ga:pagePath=@' + path,
	                        'start-date': '30daysAgo',
	                        'end-date': 'yesterday'
	                    },
	                    chart: {
	                        container: chartContainer,
	                        type: 'LINE',
	                        options: {
	                            width: '100%'
	                        }
	                    }
	                });
	                viewSelector.on('change', function (ids) {
	                    var newIds = {
	                        query: {
	                            ids: ids
	                        }
	                    };
	                    dataChart.set(newIds).execute();
	                });
	            });
	        };
	
	        _this.renderSocialSection = function () {
	            var user = _this.context.user;
	
	
	            return _react2.default.createElement(
	                'section',
	                { className: 'row blue-section section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'section-header' },
	                            'Social Media Images'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/campaigns' },
	                            _react2.default.createElement(
	                                rmd.Card,
	                                { className: 'home-info-card' },
	                                _react2.default.createElement(
	                                    rmd.CardText,
	                                    {
	                                        className: 'card-body',
	                                        style: { textAlign: 'center', backgroundColor: COLORS[3] }
	                                    },
	                                    _react2.default.createElement('img', { src: _cfg2.default.assets + '/assets/suggested.png' }),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Schedule automated posting of sport events to social channels '
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    rmd.CardActions,
	                                    { className: 'actions' },
	                                    _react2.default.createElement(rmd.FlatButton, { className: 'create', label: 'Create an automated campaign' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            widgets: [],
	            isLoading: true
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(Home, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var user = this.context.user;
	
	            (0, _googleClientApi2.default)().then(function (gapi) {
	                gapi.load('analytics', function () {
	                    // this.buildCharts(user.client, "view-selector-client", "timeline-client");
	                    _this2.buildCharts(gapi, user.username, 'view-selector-user', 'timeline-user');
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	
	            var isHTMLAllowed = user && _lodash2.default.get(user, 'permissions.htmlWidgets');
	            var isSMAllowed = user && _lodash2.default.get(user, 'permissions.smWidgets');
	            var isCampaignsAllowed = user && _lodash2.default.get(user, 'permissions.campaigns');
	
	            var topWidgets = _lodash2.default.chain(this.state.widgets || []).map(function (widget) {
	                widget.lastWeekPageViews = (widget.lastWeekStats || []).reduce(function (sum, val) {
	                    return sum + val.pageviews;
	                }, 0);
	                return widget;
	            }).orderBy('lastWeekPageViews', 'desc').slice(0, 5).value();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'home' },
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'section-header' },
	                                    'Widgets'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4  ' + (!isHTMLAllowed && 'feature-disabled') },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/widgets/pick' },
	                                    _react2.default.createElement(
	                                        rmd.Card,
	                                        { className: 'home-info-card' },
	                                        _react2.default.createElement(
	                                            rmd.CardText,
	                                            {
	                                                className: 'card-body',
	                                                style: { textAlign: 'center', backgroundColor: COLORS[1] }
	                                            },
	                                            _react2.default.createElement(_code2.default, { style: { height: 88, width: 88, fill: '#fff' } }),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Create widget for website, integrate using embed code'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.CardActions,
	                                            { className: 'actions' },
	                                            _react2.default.createElement(rmd.FlatButton, {
	                                                className: 'create',
	                                                label: 'Create widget',
	                                                labelPosition: 'before',
	                                                icon: _react2.default.createElement(_arrowForward2.default, { style: { width: '18px' } }),
	                                                primary: true
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4  ' + (!isSMAllowed && 'feature-disabled') },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/sm/browser/football/tournaments/46' },
	                                    _react2.default.createElement(
	                                        rmd.Card,
	                                        { className: 'home-info-card' },
	                                        _react2.default.createElement(
	                                            rmd.CardText,
	                                            {
	                                                className: 'card-body',
	                                                style: { textAlign: 'center', backgroundColor: COLORS[0] }
	                                            },
	                                            _react2.default.createElement(_share2.default, { style: { height: 88, width: 88, fill: '#fff' } }),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Find ready to publish Images with nice content'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.CardActions,
	                                            { className: 'actions' },
	                                            _react2.default.createElement(rmd.FlatButton, {
	                                                className: 'create',
	                                                label: 'Browse social images',
	                                                labelPosition: 'before',
	                                                icon: _react2.default.createElement(_arrowForward2.default, { style: { width: '18px' } }),
	                                                primary: true
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4  ' + (!(isSMAllowed && isCampaignsAllowed) && 'feature-disabled') },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/campaigns' },
	                                    _react2.default.createElement(
	                                        rmd.Card,
	                                        { className: 'home-info-card' },
	                                        _react2.default.createElement(
	                                            rmd.CardText,
	                                            {
	                                                className: 'card-body',
	                                                style: { textAlign: 'center', backgroundColor: COLORS[3] }
	                                            },
	                                            _react2.default.createElement(_allInclusive2.default, { style: { height: 88, width: 88, fill: '#fff' } }),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Automate posting sports content to social channels '
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.CardActions,
	                                            { className: 'actions' },
	                                            _react2.default.createElement(rmd.FlatButton, {
	                                                className: 'create',
	                                                label: 'Create an automated campaign',
	                                                labelPosition: 'before',
	                                                icon: _react2.default.createElement(_arrowForward2.default, { style: { width: '18px' } }),
	                                                primary: true
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'gray-section section', style: { display: 'none' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'section-header' },
	                                    'Featured resources'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'section-header' },
	                                    'Analytics'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.Card,
	                                    { className: 'home-info-card' },
	                                    _react2.default.createElement('div', { id: 'view-selector-user', style: { display: 'none' } }),
	                                    _react2.default.createElement('div', { id: 'timeline-user' })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section gray-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'section-header' },
	                                    'Usage'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.Card,
	                                    { className: 'home-info-card' },
	                                    _react2.default.createElement(
	                                        rmd.Table,
	                                        null,
	                                        _react2.default.createElement(
	                                            rmd.TableHeader,
	                                            { displaySelectAll: false, adjustForCheckbox: false },
	                                            _react2.default.createElement(
	                                                rmd.TableRow,
	                                                null,
	                                                _react2.default.createElement(
	                                                    rmd.TableHeaderColumn,
	                                                    null,
	                                                    'WIID'
	                                                ),
	                                                _react2.default.createElement(
	                                                    rmd.TableHeaderColumn,
	                                                    null,
	                                                    'Widget Name'
	                                                ),
	                                                _react2.default.createElement(
	                                                    rmd.TableHeaderColumn,
	                                                    null,
	                                                    'Created'
	                                                ),
	                                                _react2.default.createElement(
	                                                    rmd.TableHeaderColumn,
	                                                    { style: { width: '40%' } },
	                                                    'Locations'
	                                                ),
	                                                _react2.default.createElement(
	                                                    rmd.TableHeaderColumn,
	                                                    null,
	                                                    'Page views (last week)'
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.TableBody,
	                                            { displayRowCheckbox: false },
	                                            this.state.isLoading && _react2.default.createElement(
	                                                rmd.TableRow,
	                                                null,
	                                                _react2.default.createElement(
	                                                    rmd.TableRowColumn,
	                                                    null,
	                                                    'Loading...'
	                                                )
	                                            ),
	                                            !_lodash2.default.get(this.state.widgets, 'length') && !this.state.isLoading && _react2.default.createElement(
	                                                rmd.TableRow,
	                                                null,
	                                                _react2.default.createElement(
	                                                    rmd.TableRowColumn,
	                                                    null,
	                                                    'No widget templates have been saved yet'
	                                                )
	                                            ),
	                                            topWidgets.map(function (widget) {
	                                                var locations = _lodash2.default.chain(widget.stats || []).sortBy(function (location) {
	                                                    return location.pageviews;
	                                                }).reverse().slice(0, 3).map(function (row) {
	                                                    return _react2.default.createElement(
	                                                        'a',
	                                                        { style: { display: 'block' }, href: row.screenName },
	                                                        row.screenName
	                                                    );
	                                                }).value();
	
	                                                return _react2.default.createElement(
	                                                    rmd.TableRow,
	                                                    { key: widget._id },
	                                                    _react2.default.createElement(
	                                                        rmd.TableRowColumn,
	                                                        null,
	                                                        widget._id
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        rmd.TableRowColumn,
	                                                        null,
	                                                        widget.widgetName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        rmd.TableRowColumn,
	                                                        null,
	                                                        widget.createdAt
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        rmd.TableRowColumn,
	                                                        { style: { width: '40%' } },
	                                                        locations
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        rmd.TableRowColumn,
	                                                        null,
	                                                        widget.lastWeekPageViews
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.CardActions,
	                                        { style: { textAlign: 'right' } },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/stats' },
	                                            _react2.default.createElement(
	                                                rmd.RaisedButton,
	                                                {
	                                                    backgroundColor: '#a4c639',
	                                                    style: { marginRight: 15 },
	                                                    onClick: this.saveFields
	                                                },
	                                                'See all'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Home;
	}(_react2.default.Component);
	
	Home.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = Home;

/***/ },
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _noteAdd = __webpack_require__(1084);
	
	var _noteAdd2 = _interopRequireDefault(_noteAdd);
	
	var _info = __webpack_require__(1085);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _deleteForever = __webpack_require__(1086);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	var _reactRouter = __webpack_require__(188);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stats = function (_React$Component) {
	    _inherits(Stats, _React$Component);
	
	    function Stats(props, context) {
	        _classCallCheck(this, Stats);
	
	        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props, context));
	
	        _this.loadData = function () {
	            var user = _this.context.user;
	
	
	            if (!user || !user.client) return null;
	
	            return fetch(_cfg2.default.dash.api.host + '/api/widgets?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (body) {
	                return _this.setState({ widgets: body.widgets, isLoading: false });
	            }).catch(function (err) {
	                _this.setState({ error: err, isLoading: false });
	            });
	        };
	
	        _this.cleanDrafts = function () {
	            var params = {
	                userId: _this.context.user._id
	            };
	            var url = _cfg2.default.dash.api.host + '/api/widgets/drafts';
	            _this.setState({ isSaving: true });
	            return fetch(url, {
	                method: 'delete',
	                body: JSON.stringify(params),
	                headers: { 'Content-Type': 'application/json' }
	            }).then(function () {
	                var widgets = _this.state.widgets.filter(function (w) {
	                    return w.template;
	                });
	                _this.setState({ widgets: widgets, saveSuccess: true });
	            }).catch(function (err) {
	                _this.setState({ error: err, isSaving: false, saveError: true });
	            });
	        };
	
	        _this.state = {
	            widgets: [],
	            category: 'drafts',
	            isLoading: true,
	            saveSuccess: false,
	            saveError: false
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(Stats, [{
	        key: 'renderIndications',
	        value: function renderIndications() {
	            var _this2 = this;
	
	            return [_react2.default.createElement(rmd.Snackbar, {
	                open: this.state.saveSuccess,
	                key: 'save-success-snack',
	                message: 'Widget instance(s) has been successfully deleted',
	                autoHideDuration: 4000
	            }), _react2.default.createElement(rmd.Snackbar, {
	                open: this.state.saveError,
	                key: 'save-error-snack',
	                className: 'snackbar-error',
	                message: 'Server error. Unable to delete widget',
	                action: 'close',
	                onActionTouchTap: function onActionTouchTap() {
	                    return _this2.setState({ saveError: false });
	                }
	            })];
	        }
	    }, {
	        key: 'deleteWidget',
	        value: function deleteWidget(widget) {
	            var _this3 = this;
	
	            var params = {
	                userId: widget.userId
	            };
	            var url = _cfg2.default.dash.api.host + '/api/widgets/' + widget._id;
	            this.setState({ isSaving: true });
	            return fetch(url, {
	                method: 'delete',
	                body: JSON.stringify(params),
	                headers: { 'Content-Type': 'application/json' }
	            }).then(function () {
	                var widgets = _this3.state.widgets.filter(function (w) {
	                    return w._id !== widget._id;
	                });
	                _this3.setState({ widgets: widgets, saveSuccess: true });
	            }).catch(function (err) {
	                _this3.setState({ error: err, isSaving: false, saveError: true });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _context = this.context,
	                user = _context.user,
	                router = _context.router;
	            var category = this.state.category;
	
	
	            var widgets = _lodash2.default.chain(this.state.widgets).map(function (widget) {
	                widget.lastWeekPageViews = (widget.lastWeekStats || []).reduce(function (sum, val) {
	                    return sum + val.pageviews;
	                }, 0);
	                return widget;
	            }).orderBy('lastWeekPageViews', 'desc').value();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'home' },
	                _react2.default.createElement(
	                    rmd.Card,
	                    null,
	                    _react2.default.createElement(
	                        rmd.Table,
	                        null,
	                        _react2.default.createElement(
	                            rmd.TableHeader,
	                            { displaySelectAll: false, adjustForCheckbox: false },
	                            _react2.default.createElement(
	                                rmd.TableRow,
	                                null,
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    null,
	                                    'WIID'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    null,
	                                    'Widget Name'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    null,
	                                    'Created'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    { style: { width: '30%' } },
	                                    'Locations'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    null,
	                                    'Page views (last week)'
	                                ),
	                                _react2.default.createElement(
	                                    rmd.TableHeaderColumn,
	                                    null,
	                                    'Page views sum'
	                                ),
	                                _react2.default.createElement(rmd.TableHeaderColumn, null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            rmd.TableBody,
	                            { displayRowCheckbox: false },
	                            this.state.isLoading && _react2.default.createElement(
	                                rmd.TableRow,
	                                null,
	                                _react2.default.createElement(
	                                    rmd.TableRowColumn,
	                                    null,
	                                    'Loading...'
	                                )
	                            ),
	                            !this.state.widgets.length && !this.state.isLoading && _react2.default.createElement(
	                                rmd.TableRow,
	                                null,
	                                _react2.default.createElement(
	                                    rmd.TableRowColumn,
	                                    null,
	                                    'No widget instances have been saved yet'
	                                )
	                            ),
	                            widgets.map(function (widget) {
	                                var queryString = Object.keys(widget.props || {}).map(function (prop) {
	                                    return prop + '=' + encodeURIComponent(widget.props[prop]) + '&';
	                                }).join('');
	                                var cloneLink = '/widgets/' + widget.widgetName + '/customizer?' + queryString;
	                                // var editLink = `/widgets/${widget.widgetName}/customizer?${queryString}wiid=${widget._id}`;
	                                var statsLink = '/widgets/' + widget._id + '/statistics';
	                                var topLocationsByPageViews = _lodash2.default.chain(widget.lastWeekStats || []).sortBy(function (location) {
	                                    return location.pageviews;
	                                }).reverse().slice(0, 3).value();
	
	                                var locations = topLocationsByPageViews.map(function (row) {
	                                    return _react2.default.createElement(
	                                        'a',
	                                        { style: { display: 'block' }, href: row.screenName },
	                                        row.screenName
	                                    );
	                                });
	
	                                var pageviews = topLocationsByPageViews.map(function (row) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        row.pageviews
	                                    );
	                                });
	
	                                return _react2.default.createElement(
	                                    rmd.TableRow,
	                                    { key: widget._id },
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        null,
	                                        widget._id
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        null,
	                                        widget.widgetName
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        null,
	                                        widget.createdAt
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        { style: { width: '30%' } },
	                                        locations
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        null,
	                                        pageviews
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        null,
	                                        widget.lastWeekPageViews
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableRowColumn,
	                                        {
	                                            style: {
	                                                overflow: 'visible',
	                                                textAlign: 'right'
	                                            }
	                                        },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: statsLink },
	                                            _react2.default.createElement(
	                                                rmd.IconButton,
	                                                { tooltip: 'Stats' },
	                                                _react2.default.createElement(_info2.default, null)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: cloneLink },
	                                            _react2.default.createElement(
	                                                rmd.IconButton,
	                                                { tooltip: 'Clone' },
	                                                _react2.default.createElement(_noteAdd2.default, null)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.IconButton,
	                                            {
	                                                tooltip: 'Delete',
	                                                onClick: _this4.deleteWidget.bind(_this4, widget)
	                                            },
	                                            _react2.default.createElement(_deleteForever2.default, null)
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                this.renderIndications()
	            );
	        }
	    }]);
	
	    return Stats;
	}(_react2.default.Component);
	
	Stats.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = Stats;

/***/ },
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _reactRedux = __webpack_require__(250);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _user = __webpack_require__(340);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginForm = function (_React$Component) {
	    _inherits(LoginForm, _React$Component);
	
	    function LoginForm(props) {
	        _classCallCheck(this, LoginForm);
	
	        var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
	
	        _this.handleLogin = function (e) {
	            if (e.type === 'click' || e.type === 'keypress' && e.charCode === 13) {
	                return fetch('/api/v2/auth/login', {
	                    method: 'POST',
	                    headers: {
	                        'Content-Type': 'application/json'
	                    },
	                    body: JSON.stringify({
	                        username: _this.state.username,
	                        password: _this.state.password
	                    })
	                }).then(function (response) {
	                    if (response.ok) {
	                        return response.json().then(function (_ref) {
	                            var token = _ref.token,
	                                user = _ref.user;
	
	                            _auth2.default.saveUser(user);
	                            _auth2.default.saveAccessToken(token);
	                            _this.props.dispatch({ type: _user.USER_ACTIONS.LOGIN, payload: user });
	                            _this.context.router.push('/home');
	                        });
	                    } else {
	                        _this.setState({ error: ' ' });
	                    }
	                }).catch(function (err) {});
	            }
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(LoginForm, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-content' },
	                    _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'loginform' },
	                        _react2.default.createElement(
	                            rmd.CardMedia,
	                            null,
	                            _react2.default.createElement('img', { src: 'https://www.getmdl.io/assets/demos/welcome_card.jpg', alt: 'login' })
	                        ),
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            null,
	                            _react2.default.createElement(rmd.TextField, {
	                                value: this.state.username || '',
	                                onChange: function onChange(e) {
	                                    return _this2.setState({ username: e.target.value });
	                                },
	                                errorText: this.state.error,
	                                onKeyPress: this.handleLogin,
	                                style: { width: '100%' },
	                                floatingLabelText: 'User name'
	                            }),
	                            _react2.default.createElement(rmd.TextField, {
	                                type: 'password',
	                                value: this.state.password || '',
	                                onChange: function onChange(e) {
	                                    return _this2.setState({ password: e.target.value });
	                                },
	                                errorText: this.state.error,
	                                onKeyPress: this.handleLogin,
	                                style: { width: '100%' },
	                                floatingLabelText: 'Password'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            rmd.CardActions,
	                            { className: 'actions' },
	                            _react2.default.createElement(rmd.RaisedButton, { label: 'Login', primary: true, onClick: this.handleLogin })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginForm;
	}(_react2.default.Component);
	
	LoginForm.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _reactRedux.connect)()(LoginForm);

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _reactRouter = __webpack_require__(188);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _InterestsList = __webpack_require__(1093);
	
	var _InterestsList2 = _interopRequireDefault(_InterestsList);
	
	var _SMLinkManager = __webpack_require__(1095);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _settings = __webpack_require__(1038);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _lock = __webpack_require__(1110);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _today = __webpack_require__(1111);
	
	var _today2 = _interopRequireDefault(_today);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _addCircleOutline = __webpack_require__(1112);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	var _star = __webpack_require__(1113);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _CampaignsList = __webpack_require__(1114);
	
	var _CampaignsList2 = _interopRequireDefault(_CampaignsList);
	
	var _TemplatesList = __webpack_require__(1115);
	
	var _TemplatesList2 = _interopRequireDefault(_TemplatesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function Section(_ref) {
	    var icon = _ref.icon,
	        title = _ref.title,
	        subTitle = _ref.subTitle,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'section',
	        { style: { display: 'flex', margin: '10px 0', padding: '10px 0', borderBottom: '1px solid #ccc' } },
	        icon,
	        _react2.default.createElement(
	            'div',
	            { style: { width: 200, padding: 10 } },
	            _react2.default.createElement(
	                'div',
	                null,
	                title
	            ),
	            subTitle && _react2.default.createElement(
	                'div',
	                null,
	                subTitle
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { flexGrow: 1 } },
	            children
	        )
	    );
	};
	
	var Account = function (_React$Component) {
	    _inherits(Account, _React$Component);
	
	    function Account(props, context) {
	        _classCallCheck(this, Account);
	
	        var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props, context));
	
	        _this.loadData = function () {
	            return fetch('/api/users/' + _auth2.default.getUser()._id + '?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (user) {
	                _this.setState({ user: user });
	            });
	        };
	
	        _this.saveDomains = function (e) {
	            var newDomainsStr = e.target.value;
	
	            var newDomains = Array.isArray(newDomainsStr) ? _lodash2.default.uniq(newDomainsStr) : _lodash2.default.uniq(newDomainsStr.split('\n'));
	            var body = {
	                allowedDomains: newDomains
	            };
	
	            _this.setState({ saveSuccess: false });
	
	            return fetch('/api/users/' + _auth2.default.getUser()._id + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(body)
	            }).then(function (response) {
	                if (response.ok) {
	                    return response.json().then(function (user) {
	                        _this.setState({
	                            saveSuccess: true,
	                            user: user
	                        });
	                        _auth2.default.saveUser(user);
	                    });
	                } else {
	                    _this.setState({ saveError: true });
	                }
	            }).catch(function (err) {
	                _this.setState({ saveError: true, isSaving: false });
	            });
	        };
	
	        _this.getScriptSingle = function () {
	            return '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '" crossorigin></script>';
	        };
	
	        _this.getScriptAdv = function () {
	            var user = _this.state.user;
	
	            if (!user) return;
	
	            return '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '" crossorigin></script>\n<script type="text/javascript">\n    WDPDefaults.set("client", "' + user.client + '");\n    WDPDefaults.set("user", "' + user.username + '");\n    WDPDefaults.set("theme", "' + user.defaultTheme + '");\n    WDPDefaults.set("token", "' + user.accessToken + '");\n    WDPDefaults.set("ga",    "' + (user.defaultProps.GA || '') + '");\n    WDPDefaults.set("load",  "js");\n    WDPDefaults.set("lang",  "' + (user.defaultProps.lang || 'en') + '");\n</script>';
	        };
	
	        _this.handleSMDialogOpen = function () {
	            _this.setState({ showSMDialog: true });
	        };
	
	        _this.handleSMDialogClose = function () {
	            _this.setState({ showSMDialog: false });
	        };
	
	        _this.state = {
	            // isLoading: true,
	            saveSuccess: false,
	            saveError: false,
	            copyToastOpen: false,
	            showSMDialog: false
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(Account, [{
	        key: 'renderIndications',
	        value: function renderIndications() {
	            var _this2 = this;
	
	            return [
	            // this.state.isSaving ? (
	            //     <CircularProgress key="saving" size={0.4} style={{ position: 'absolute', right: 0, top: 0 }} />
	            // ) : "",
	            // this.state.saveSuccess ? (
	            //     <DoneIcon key="save-success" style={{ position: 'absolute', right: 5, bottom: 15 }} />
	            // ) : "",
	            _react2.default.createElement(_Snackbar2.default, {
	                open: this.state.saveSuccess,
	                key: 'save-success-snack',
	                message: 'Domains have been successfully saved',
	                autoHideDuration: 4000
	            }), _react2.default.createElement(_Snackbar2.default, {
	                open: this.state.saveError,
	                key: 'save-error-snack',
	                className: 'snackbar-error',
	                message: 'Server error. Records are not saved ',
	                action: 'close',
	                onActionTouchTap: function onActionTouchTap() {
	                    return _this2.setState({ saveError: false });
	                }
	            }), _react2.default.createElement(_Snackbar2.default, {
	                open: this.state.copyToastOpen,
	                key: 'snck-copied-msg',
	                message: 'Copied!',
	                autoHideDuration: 4000,
	                onActionTouchTap: function onActionTouchTap() {
	                    return _this2.setState({ copyToastOpen: false });
	                }
	            })];
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var iconStyle = {
	                width: 36,
	                height: 36
	            };
	            var user = this.state.user;
	            var userDomains = user && (Array.isArray(user.allowedDomains) ? user.allowedDomains.join('\n') : user.allowedDomains);
	
	            var domainsString = this.state.allowedDomains || userDomains;
	
	            // if (!user) return <div />;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_lock2.default, { color: 'gray', style: iconStyle }), title: 'Access token' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'value' },
	                            _react2.default.createElement(_TextField2.default, {
	                                onBlur: this.saveDomains,
	                                onChange: function onChange(e) {
	                                    _this3.setState({ allowedDomains: e.target.value });
	                                },
	                                value: domainsString,
	                                style: { marginTop: -12 },
	                                errorText: this.state.error,
	                                multiLine: true,
	                                rows: 1,
	                                floatingLabelText: 'Allowed domains',
	                                hintText: 'Enter allowed domains (top level)'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_TextField2.default, {
	                        style: { width: 300 },
	                        value: user && user.accessToken,
	                        floatingLabelText: 'Access token',
	                        floatingLabelFixed: true
	                    })
	                ),
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_settings2.default, { color: 'gray', style: iconStyle }), title: 'Default settings' },
	                    _react2.default.createElement(_RaisedButton2.default, { href: 'account/defaults', label: 'Edit defaults' })
	                ),
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_today2.default, { color: 'gray', style: iconStyle }), title: 'Default calendar' },
	                    _react2.default.createElement(_CampaignsList2.default, null)
	                ),
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_style2.default, { color: 'gray', style: iconStyle }), title: 'Default template' },
	                    _react2.default.createElement(_TemplatesList2.default, null)
	                ),
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_star2.default, { color: 'gray', style: iconStyle }), title: 'Interests' },
	                    _react2.default.createElement(_InterestsList2.default, null),
	                    _react2.default.createElement(_FlatButton2.default, {
	                        icon: _react2.default.createElement(_addCircleOutline2.default, null),
	                        label: 'Manage interests',
	                        onTouchTap: function onTouchTap() {
	                            _reactRouter.browserHistory.push({
	                                pathname: '/interests'
	                            });
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    Section,
	                    { icon: _react2.default.createElement(_share2.default, { color: 'gray', style: iconStyle }), title: 'Social links' },
	                    _react2.default.createElement(_SMLinkManager.SMLinkTable, null),
	                    _react2.default.createElement(_FlatButton2.default, {
	                        icon: _react2.default.createElement(_addCircleOutline2.default, null),
	                        label: 'Connect social network',
	                        onTouchTap: this.handleSMDialogOpen
	                    })
	                ),
	                this.renderIndications(),
	                _react2.default.createElement(
	                    _Dialog2.default,
	                    { open: this.state.showSMDialog, onRequestClose: this.handleSMDialogClose },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Link your social account'
	                    ),
	                    _react2.default.createElement(_SMLinkManager.SMLinkAddButtons, { onAdd: this.handleSMDialogClose })
	                )
	            );
	        }
	    }]);
	
	    return Account;
	}(_react2.default.Component);
	
	exports.default = Account;

/***/ },
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _Checkbox = __webpack_require__(853);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _actions = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesCheckbox = {
	    marginBottom: 16
	};
	
	var onCheckIsDefault = function onCheckIsDefault(interestId, action) {
	    return function (event) {
	        var isInputChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        action(interestId, { isDefault: isInputChecked });
	    };
	};
	
	function InterestsList(_ref) {
	    var interests = _ref.interests,
	        putInterest = _ref.putInterest;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        interests.map(function (_ref2) {
	            var id = _ref2._id,
	                name = _ref2.name,
	                isDefault = _ref2.isDefault;
	            return _react2.default.createElement(_Checkbox2.default, {
	                key: id,
	                defaultChecked: isDefault,
	                label: name,
	                onCheck: onCheckIsDefault(id, putInterest),
	                style: stylesCheckbox
	            });
	        })
	    );
	}
	
	InterestsList.defaultProps = {
	    interests: []
	};
	
	InterestsList.propTypes = {
	    interests: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        _id: _propTypes2.default.string.isRequired,
	        name: _propTypes2.default.string.isRequired,
	        isDefault: _propTypes2.default.bool.isRequired
	    })).isRequired,
	    putInterest: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref3) {
	    var user = _ref3.user;
	    return { interests: user.interests };
	}, { putInterest: _actions.putInterest })(InterestsList);

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deleteInterest = exports.putInterest = exports.postInterest = exports.fetchInterests = exports.fetchTeams = exports.fetchTournaments = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _actions = __webpack_require__(593);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var fetchTournaments = exports.fetchTournaments = function fetchTournaments() {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.apis.ss2 + '/tournaments',
	        update: {
	            tournaments: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(tournaments) {
	            return {
	                tournaments: tournaments.reduce(function (acc, curr) {
	                    return _extends({}, acc, _defineProperty({}, curr.id, curr));
	                }, {})
	            };
	        },
	        list: function list(_tournaments) {
	            return {
	                tournaments: function tournaments() {
	                    return _tournaments.map(function (t) {
	                        return t.id;
	                    });
	                }
	            };
	        },
	        queryKey: 'GET:tournaments',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var fetchTeams = exports.fetchTeams = function fetchTeams() {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.apis.ss2 + '/teams',
	        update: {
	            teams: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(teams) {
	            return {
	                teams: teams.reduce(function (acc, curr) {
	                    return _extends({}, acc, _defineProperty({}, curr.id, curr));
	                }, {})
	            };
	        },
	        list: function list(_teams) {
	            return {
	                teams: function teams() {
	                    return _teams.map(function (t) {
	                        return t.id;
	                    });
	                }
	            };
	        },
	        queryKey: 'GET:teams',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var fetchInterests = exports.fetchInterests = function fetchInterests() {
	    return function (dispatch, getState) {
	        var userId = getState().user._id;
	
	        if (userId == null) {
	            return dispatch({
	                type: 'err'
	            });
	        }
	
	        return dispatch((0, _actions.requestAsync)({
	            url: _cfg2.default.dash.api.host + '/api/users/' + userId + '/interests?access_token=' + _auth2.default.getAccessToken(),
	            update: {
	                userInterests: _actions.UPDATE_DEFAULT.MERGE
	            },
	            transform: function transform() {
	                var interests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                return {
	                    userInterests: interests.reduce(function (acc, curr) {
	                        return _extends({}, acc, _defineProperty({}, curr._id, curr));
	                    }, {})
	                };
	            },
	            list: function list() {
	                var interests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                return {
	                    userInterests: function userInterests() {
	                        return (0, _helpers.toIdArray)(interests);
	                    }
	                };
	            },
	            queryKey: 'GET:userInterests',
	            options: {
	                method: _actions.httpMethods.GET
	            }
	        }));
	    };
	};
	
	var postInterest = exports.postInterest = function postInterest(interest) {
	    return function (dispatch, getState) {
	        var userId = getState().user._id;
	
	        if (userId == null) {
	            return dispatch({
	                type: 'err'
	            });
	        }
	
	        return dispatch((0, _actions.requestAsync)({
	            url: _cfg2.default.dash.api.host + '/api/users/' + userId + '/interests?access_token=' + _auth2.default.getAccessToken(),
	            body: interest,
	            update: {
	                userInterests: _actions.UPDATE_DEFAULT.MERGE
	            },
	            transform: function transform(_ref) {
	                var _ref$interest = _ref.interest,
	                    interest = _ref$interest === undefined ? {} : _ref$interest;
	                return {
	                    userInterests: _defineProperty({}, interest._id, interest)
	                };
	            },
	            list: function list(_ref2) {
	                var _ref2$interest = _ref2.interest,
	                    interest = _ref2$interest === undefined ? {} : _ref2$interest;
	                return {
	                    userInterests: function userInterests(prevInterests) {
	                        return prevInterests.concat(interest._id);
	                    }
	                };
	            },
	            queryKey: 'POST:userInterests',
	            options: {
	                method: _actions.httpMethods.POST
	            }
	        }));
	    };
	};
	
	var putInterest = exports.putInterest = function putInterest(interestId, interest) {
	    return function (dispatch, getState) {
	        var userId = getState().user._id;
	
	        if (userId == null || interestId == null) {
	            return dispatch({
	                type: 'err'
	            });
	        }
	
	        return dispatch((0, _actions.requestAsync)({
	            url: _cfg2.default.dash.api.host + '/api/users/' + userId + '/interests/' + interestId + '?access_token=' + _auth2.default.getAccessToken(),
	            body: interest,
	            update: {
	                userInterests: _actions.UPDATE_DEFAULT.MERGE
	            },
	            transform: function transform() {
	                var interest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return {
	                    userInterests: _defineProperty({}, interest._id, interest)
	                };
	            },
	            list: function list() {
	                return {
	                    userInterests: function userInterests(prevInterests) {
	                        return prevInterests;
	                    }
	                };
	            },
	            queryKey: 'PUT:userInterests',
	            options: {
	                method: _actions.httpMethods.PUT
	            }
	        }));
	    };
	};
	
	var deleteInterest = exports.deleteInterest = function deleteInterest(interestId) {
	    return function (dispatch, getState) {
	        var userId = getState().user._id;
	
	        if (userId == null) {
	            return dispatch({
	                type: 'err'
	            });
	        }
	
	        return dispatch((0, _actions.requestAsync)({
	            url: _cfg2.default.dash.api.host + '/api/users/' + userId + '/interests/' + interestId + '?access_token=' + _auth2.default.getAccessToken(),
	            update: {
	                userInterests: _actions.UPDATE_DEFAULT.MERGE
	            },
	            transform: function transform() {
	                return {
	                    userInterests: {}
	                };
	            },
	            list: function list() {
	                return {
	                    userInterests: function userInterests(prevInterests) {
	                        return prevInterests.filter(function (i) {
	                            return i !== interestId;
	                        });
	                    }
	                };
	            },
	            queryKey: 'DELETE:userInterests',
	            options: {
	                method: _actions.httpMethods.DELETE
	            }
	        }));
	    };
	};

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SMLinkAddButtons = exports.SMLinkTable = exports.withSmlinks = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var _replay = __webpack_require__(1103);
	
	var _replay2 = _interopRequireDefault(_replay);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _SMLink = __webpack_require__(1105);
	
	var _constants = __webpack_require__(579);
	
	var _smlinks = __webpack_require__(1107);
	
	var _selectors = __webpack_require__(618);
	
	var _SMLinkTitle = __webpack_require__(1108);
	
	var _SMLinkTitle2 = _interopRequireDefault(_SMLinkTitle);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withSmlinks = exports.withSmlinks = (0, _reactRedux.connect)(function (state) {
	    return {
	        smlinks: (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.SMLINKS],
	        smlinksPending: _lodash2.default.get((0, _selectors.getQueries)(state).smlinks, 'isPending')
	    };
	}, {
	    fetchSmlinks: _smlinks.fetchSmlinks,
	    deleteSmlink: _smlinks.deleteSmlink
	});
	
	var createOnEditSMLink = function createOnEditSMLink(userId) {
	    return function (smlink) {
	        var smtype = smlink.smtype,
	            smlinkId = smlink._id;
	        var smpg = _cfg2.default.apis.smpg;
	
	        if (smtype === 'fb') {
	            var url = smpg + '/facebook/update?smlinkId=' + smlinkId + '&client=' + userId + '&service=any';
	            window.open(url, 'Update', 'height=500,width=700');
	        } else if (smtype === 'tw') {
	            var _url = smpg + '/twitter/update?smlinkId=' + smlinkId + '&client=' + userId + '&service=any';
	            window.open(_url, 'Update', 'height=500,width=700');
	        }
	    };
	};
	
	var SMLinkTable = exports.SMLinkTable = (0, _recompose.compose)(withSmlinks, (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        this.props.fetchSmlinks();
	    }
	}), (0, _recompose.getContext)({
	    user: _propTypes2.default.object
	}))(function (_ref) {
	    var smlinks = _ref.smlinks,
	        user = _ref.user,
	        smlinksPending = _ref.smlinksPending,
	        deleteSmlink = _ref.deleteSmlink;
	
	    var items = Array.isArray(smlinks) ? smlinks : [];
	    var onEdit = createOnEditSMLink(user._id);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        smlinksPending ? _react2.default.createElement(_materialUi.LinearProgress, null) : null,
	        items.map(function (link) {
	            return _react2.default.createElement(
	                'div',
	                { key: link._id, style: { display: 'flex' } },
	                _react2.default.createElement(_SMLinkTitle2.default, { id: link._id, style: { minWidth: 250 } }),
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { tooltip: 'Update', onTouchTap: function onTouchTap() {
	                            return onEdit(link);
	                        } },
	                    _react2.default.createElement(_replay2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { tooltip: 'Delete', onTouchTap: function onTouchTap() {
	                            return deleteSmlink(link.id);
	                        } },
	                    _react2.default.createElement(_delete2.default, null)
	                )
	            );
	        }),
	        !smlinksPending && !items.length ? _react2.default.createElement(
	            'h4',
	            { style: { textAlign: 'center' } },
	            'No smlinks'
	        ) : null
	    );
	});
	
	var SMLinkAddButtons = exports.SMLinkAddButtons = withSmlinks((_temp2 = _class = function (_React$Component) {
	    _inherits(_SMLinkAddButtons, _React$Component);
	
	    function _SMLinkAddButtons() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _SMLinkAddButtons);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _SMLinkAddButtons.__proto__ || Object.getPrototypeOf(_SMLinkAddButtons)).call.apply(_ref2, [this].concat(args))), _this), _this.updateLinks = function () {
	            clearTimeout(_this.timeout);
	            _this.timeout = setTimeout(function () {
	                _this.props.fetchSmlinks();
	            }, 300);
	        }, _this.onSmlinkAdd = function () {
	            _this.updateLinks();
	            if (_this.props.onAdd) {
	                _this.props.onAdd();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // Two events are sent by smpg. Filter them manually.
	
	
	    _createClass(_SMLinkAddButtons, [{
	        key: 'renderButtons',
	        value: function renderButtons() {
	            var _this2 = this;
	
	            var id = this.context.user._id;
	            var types = this.props.types;
	
	            var items = Array.isArray(types) && types.length ? _constants.SOCIAL_NETWORKS.filter(function (_ref3) {
	                var key = _ref3.key;
	                return types.some(function (type) {
	                    return type === key;
	                });
	            }) : _constants.SOCIAL_NETWORKS;
	            return items.map(function (network) {
	                return _react2.default.createElement(_SMLink.SMLinkButton, {
	                    key: network.key,
	                    type: network.key,
	                    title: network.label || network.title,
	                    onChange: _this2.onSmlinkAdd,
	                    address: network.getAddress(id),
	                    style: { margin: 10 }
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderButtons()
	            );
	        }
	    }]);
	
	    return _SMLinkAddButtons;
	}(_react2.default.Component), _class.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	}, _temp2));
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Here you can manage your social networks'
	        ),
	        _react2.default.createElement(SMLinkAddButtons, null),
	        _react2.default.createElement(SMLinkTable, null)
	    );
	};

/***/ },
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SMLink = __webpack_require__(1106);
	
	Object.defineProperty(exports, 'SMLinkButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SMLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getWindowName = function getWindowName(service) {
	    return 'Connect your ' + service + ' account to WDP';
	};
	
	var SMPG_ORIGIN = _cfg2.default.apis.smpg;
	
	var SMLink = function (_React$PureComponent) {
	    _inherits(SMLink, _React$PureComponent);
	
	    function SMLink() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SMLink);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SMLink.__proto__ || Object.getPrototypeOf(SMLink)).call.apply(_ref, [this].concat(args))), _this), _this.onMessageReceived = function (message) {
	            var onChange = _this.props.onChange;
	
	            if (message.origin === SMPG_ORIGIN && onChange) {
	                onChange(message);
	            }
	        }, _this.onButtonClick = function () {
	            var _this$props = _this.props,
	                address = _this$props.address,
	                title = _this$props.title;
	
	            var windowName = getWindowName(title);
	            window.open(address, windowName, 'height=500,width=700');
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SMLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            addEventListener('message', this.onMessageReceived, false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                style = _props.style,
	                type = _props.type;
	
	
	            return _react2.default.createElement(_materialUi.RaisedButton, {
	                primary: true,
	                labelColor: 'white',
	                label: title,
	                style: style,
	                onClick: this.onButtonClick
	            });
	        }
	    }]);
	
	    return SMLink;
	}(_react2.default.PureComponent);
	
	exports.default = SMLink;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deleteSmlink = exports.fetchSmlinks = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1049);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _actions = __webpack_require__(593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SOC_NETWORK_MAP = _constants.SOCIAL_NETWORKS.reduce(function (acc, cur) {
	    acc[cur.key] = cur.title;
	    return acc;
	}, {});
	
	var getLinkTitle = function getLinkTitle(link) {
	    return SOC_NETWORK_MAP[link.smtype] || 'Unknown';
	};
	
	var transformSmlinks = function transformSmlinks(links) {
	    var _ref;
	
	    var array = links.map(function (link) {
	        return _extends({
	            title: getLinkTitle(link) + '. ' + link.name
	        }, link);
	    });
	    var byId = array.reduce(function (acc, cur) {
	        acc[cur._id] = cur;
	        return acc;
	    }, {});
	    return _ref = {}, _defineProperty(_ref, _constants.STORE_KEYS.SMLINKS, array), _defineProperty(_ref, _constants.STORE_KEYS.SMLINKS + _constants.STORE_KEYS.BY_ID, byId), _ref;
	};
	
	var fetchSmlinks = exports.fetchSmlinks = function fetchSmlinks() {
	    var _update;
	
	    var requestConfig = (0, _helpers.createApiFetch)({
	        url: _constants.SMLINKS_BY_USER_ID + '?access_token=' + _auth2.default.getAccessToken(),
	        key: _constants.STORE_KEYS.SMLINKS,
	        configOptions: {
	            transform: transformSmlinks,
	            update: (_update = {}, _defineProperty(_update, _constants.STORE_KEYS.SMLINKS, function (prev, cur) {
	                return cur;
	            }), _defineProperty(_update, _constants.STORE_KEYS.SMLINKS + _constants.STORE_KEYS.BY_ID, function (prev, cur) {
	                return _extends({}, prev, cur);
	            }), _update)
	        }
	    });
	    return (0, _reduxQuery.requestAsync)(requestConfig);
	};
	
	var deleteSmlink = exports.deleteSmlink = function deleteSmlink() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return function (dispatch, getState) {
	        return dispatch((0, _reduxQuery.requestAsync)({
	            url: _cfg2.default.apis.smpg + '/unlink/' + id + '?access_token=' + _auth2.default.getAccessToken(),
	            update: _defineProperty({}, _constants.STORE_KEYS.SMLINKS, _actions.UPDATE_DEFAULT.LATEST),
	            transform: function transform() {
	                return _defineProperty({}, _constants.STORE_KEYS.SMLINKS, (0, _get2.default)(getState(), ['query', 'entities', _constants.STORE_KEYS.SMLINKS], []).filter(function (_ref2) {
	                    var idLink = _ref2.id;
	                    return idLink !== id;
	                }));
	            },
	            list: function list() {
	                return _defineProperty({}, _constants.STORE_KEYS.SMLINKS, (0, _get2.default)(getState(), ['query', 'entities', _constants.STORE_KEYS.SMLINKS], []).filter(function (_ref4) {
	                    var idLink = _ref4.id;
	                    return idLink !== id;
	                }));
	            },
	            force: true,
	            queryKey: 'DELETE:' + _constants.STORE_KEYS.SMLINKS,
	            options: {
	                method: _actions.httpMethods.DELETE
	            }
	        }));
	    };
	};

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _materialUi = __webpack_require__(642);
	
	var _warning = __webpack_require__(1109);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _colors = __webpack_require__(910);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _selectors = __webpack_require__(618);
	
	var _smlinks = __webpack_require__(1107);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMLINK_BY_ID = _constants.STORE_KEYS.SMLINKS + _constants.STORE_KEYS.BY_ID;
	
	var onEditSmlink = function onEditSmlink(smlink, userId) {
	    var smtype = smlink.smtype,
	        smlinkId = smlink._id;
	    var smpg = _cfg2.default.apis.smpg;
	
	    if (smtype === 'fb') {
	        var url = smpg + '/facebook/update?id=' + smlinkId + '&client=' + userId + '&service=any';
	        window.open(url, 'Update', 'height=500,width=700');
	    } else if (smtype === 'tw') {
	        var _url = smpg + '/twitter/update?id=' + smlinkId + '&client=' + userId + '&service=any';
	        window.open(_url, 'Update', 'height=500,width=700');
	    }
	};
	
	var SMLinkTitle = function SMLinkTitle(_ref) {
	    var smlink = _ref.smlink,
	        user = _ref.user,
	        style = _ref.style,
	        onClick = _ref.onClick;
	
	    var value = _lodash2.default.get(smlink, 'title');
	    var invalid = _lodash2.default.get(smlink, 'invalid');
	    var hasOnClick = onClick instanceof Function;
	    var handleClick = function handleClick() {
	        if (hasOnClick) {
	            onClick(smlink);
	        }
	    };
	    return _react2.default.createElement(
	        'span',
	        {
	            style: _extends({
	                display: 'flex',
	                alignItems: 'center',
	                cursor: hasOnClick ? 'pointer' : 'initial'
	            }, style),
	            onClick: handleClick
	        },
	        value,
	        ' ',
	        invalid && _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                tooltip: 'Click to fix the issue with your account',
	                onTouchTap: function onTouchTap() {
	                    return onEditSmlink(smlink, user._id);
	                }
	            },
	            _react2.default.createElement(_warning2.default, { color: _colors.deepOrange500, style: { marginLeft: 8 } })
	        )
	    );
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.getContext)({
	    user: _propTypes2.default.object
	}), (0, _reactRedux.connect)(function (state, _ref2) {
	    var id = _ref2.id;
	    return {
	        smlink: _lodash2.default.get((0, _selectors.getEntities)(state)[SMLINK_BY_ID], id)
	    };
	}, function (dispatch) {
	    return {
	        updateSmlinks: function updateSmlinks() {
	            return dispatch((0, _smlinks.fetchSmlinks)());
	        }
	    };
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        var onMessageReceived = function onMessageReceived(message) {
	            if (message.origin === _cfg2.default.apis.smpg) {
	                _this.props.updateSmlinks();
	            }
	        };
	        if (!this.props.smlink) {
	            this.props.updateSmlinks();
	        }
	        addEventListener('message', onMessageReceived, false);
	    }
	}))(SMLinkTitle);

/***/ },
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _RadioButton = __webpack_require__(950);
	
	var _user = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var radioButtonStyles = {
	    marginBottom: 16
	};
	
	var CampaignsList = function (_Component) {
	    _inherits(CampaignsList, _Component);
	
	    function CampaignsList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CampaignsList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CampaignsList.__proto__ || Object.getPrototypeOf(CampaignsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            defaultCampaignId: _this.props.user && _this.props.user.defaultCampaignId || '',
	            campaigns: []
	        }, _this.loadData = function () {
	            fetch(_cfg2.default.campaign_manager.host + '/api/campaigns?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	                return res.json();
	            }).then(function (_ref2) {
	                var campaigns = _ref2.campaigns;
	
	                _this.setState({ campaigns: campaigns });
	            }).catch(function (error) {});
	        }, _this.handleCampaignDefault = function (event, defaultCampaignId) {
	            var userId = _this.props.user._id;
	
	
	            return fetch(_cfg2.default.dash.api.host + '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    defaultCampaignId: defaultCampaignId
	                })
	            }).then(function (res) {
	                return res.json();
	            }).then(function () {
	                _auth2.default.saveUser(_extends({}, _this.props.user, { defaultCampaignId: defaultCampaignId }));
	                _this.props.updateUser(_extends({}, _this.props.user, { defaultCampaignId: defaultCampaignId }));
	
	                _this.setState({
	                    defaultCampaignId: defaultCampaignId
	                });
	            }).catch(function (error) {});
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CampaignsList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _RadioButton.RadioButtonGroup,
	                    {
	                        name: 'campaign_default',
	                        defaultSelected: this.state.defaultCampaignId,
	                        onChange: this.handleCampaignDefault
	                    },
	                    this.state.campaigns.filter(function (_ref3) {
	                        var calendar = _ref3.calendar;
	                        return calendar;
	                    }).map(function (_ref4) {
	                        var id = _ref4._id,
	                            title = _ref4.title;
	                        return _react2.default.createElement(_RadioButton.RadioButton, { key: id, value: id, label: title, style: radioButtonStyles });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CampaignsList;
	}(_react.Component);
	
	CampaignsList.defaultProps = { user: { defaultCampaignId: '' } };
	
	CampaignsList.propTypes = {
	    user: _propTypes2.default.shape({
	        _id: _propTypes2.default.string.isRequired,
	        defaultCampaignId: _propTypes2.default.string
	    }).isRequired,
	    updateUser: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref5) {
	    var user = _ref5.user;
	    return { user: user };
	}, {
	    updateUser: function updateUser(user) {
	        return { type: _user.USER_ACTIONS.UPDATE, payload: user };
	    }
	})(CampaignsList);

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _RadioButton = __webpack_require__(950);
	
	var _user = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var radioButtonStyles = {
	    marginBottom: 16
	};
	
	var TemplatesList = function (_Component) {
	    _inherits(TemplatesList, _Component);
	
	    function TemplatesList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TemplatesList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TemplatesList.__proto__ || Object.getPrototypeOf(TemplatesList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            defaultTemplateId: _this.props.user && _this.props.user.defaultTemplateId || '',
	            templates: []
	        }, _this.loadData = function () {
	            fetch(_cfg2.default.dash.api.host + '/api/templates/list?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	                return res.json();
	            }).then(function (templates) {
	                _this.setState({ templates: templates });
	            }).catch(function (error) {});
	        }, _this.handleTemplateSetDefault = function (event, defaultTemplateId) {
	            var userId = _this.props.user._id;
	
	
	            return fetch(_cfg2.default.dash.api.host + '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    defaultTemplateId: defaultTemplateId
	                })
	            }).then(function (res) {
	                return res.json();
	            }).then(function () {
	                _auth2.default.saveUser(_extends({}, _this.props.user, { defaultTemplateId: defaultTemplateId }));
	                _this.props.updateUser(_extends({}, _this.props.user, { defaultTemplateId: defaultTemplateId }));
	
	                _this.setState({
	                    defaultTemplateId: defaultTemplateId
	                });
	            }).catch(function (error) {});
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TemplatesList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _RadioButton.RadioButtonGroup,
	                    {
	                        name: 'template_default',
	                        defaultSelected: this.state.defaultTemplateId,
	                        onChange: this.handleTemplateSetDefault
	                    },
	                    this.state.templates.filter(function (_ref2) {
	                        var isHidden = _ref2.isHidden;
	                        return !isHidden;
	                    }).map(function (_ref3) {
	                        var id = _ref3.id,
	                            name = _ref3.name;
	                        return _react2.default.createElement(_RadioButton.RadioButton, { key: id, value: id, label: name, style: radioButtonStyles });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TemplatesList;
	}(_react.Component);
	
	TemplatesList.defaultProps = { user: { defaultTemplateId: '' } };
	
	TemplatesList.propTypes = {
	    user: _propTypes2.default.shape({
	        defaultTemplateId: _propTypes2.default.string
	    }).isRequired,
	    updateUser: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref4) {
	    var user = _ref4.user;
	    return { user: user };
	}, {
	    updateUser: function updateUser(user) {
	        return { type: _user.USER_ACTIONS.UPDATE, payload: user };
	    }
	})(TemplatesList);

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _done = __webpack_require__(1117);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mandatoryFields = [{
	    key: 'teamId',
	    dataType: 'ENET_TEAM_ID',
	    desc: 'Default team',
	    required: true
	}, {
	    key: 'tournamentId',
	    dataType: 'ENET_TOURNAMENT_ID',
	    desc: 'Default tournament id',
	    required: true
	}, {
	    key: 'lang',
	    dataType: 'LANGUAGE',
	    desc: 'Default language',
	    required: true
	}, {
	    key: 'GA',
	    dataType: 'STRING',
	    desc: 'Google Anatytics account',
	    required: true
	}];
	
	var AccountDefaults = function (_React$Component) {
	    _inherits(AccountDefaults, _React$Component);
	
	    function AccountDefaults(props, context) {
	        _classCallCheck(this, AccountDefaults);
	
	        var _this = _possibleConstructorReturn(this, (AccountDefaults.__proto__ || Object.getPrototypeOf(AccountDefaults)).call(this, props, context));
	
	        _this.loadData = function () {
	            var token = _auth2.default.getAccessToken();
	            var userId = _this.context.user._id;
	
	            return fetch('/api/users/' + userId + '?access_token=' + token).then(function (response) {
	                return response.json();
	            }).then(function (user) {
	                var combinedFields = _lodash2.default.unionWith(user.defaultProps, mandatoryFields, function (a, b) {
	                    return a.key === b.key;
	                });
	
	                _this.setState({
	                    fields: combinedFields,
	                    isLoading: false
	                });
	            });
	        };
	
	        _this.addField = function () {
	            var fields = _this.state.fields;
	            fields.push({
	                key: '',
	                value: '',
	                dataType: '',
	                desc: '',
	                isNew: true
	            });
	
	            _this.setState({ fields: fields });
	        };
	
	        _this.saveFields = function () {
	            var fields = _this.state.fields;
	            var body = {
	                defaultProps: fields
	            };
	
	            var invalidFields = fields.filter(function (f) {
	                return !f.key;
	            });
	
	            if (invalidFields.length) {
	                invalidFields.forEach(function (f) {
	                    f.keyError = ' ';
	                });
	                _this.setState({ fields: fields });
	                return;
	            }
	
	            _this.setState({ isSaving: true, saveSuccess: false });
	            var token = _auth2.default.getAccessToken();
	            var userId = _this.context.user._id;
	
	            return fetch('/api/users/' + userId, {
	                method: 'PUT',
	
	                headers: {
	                    'Content-Type': 'application/json',
	                    authorization: token
	                },
	                body: JSON.stringify(body)
	            }).then(function (response) {
	                if (response.ok) {
	                    return response.json().then(function (user) {
	                        _this.setState({ isSaving: false, saveSuccess: true, fields: user.defaultProps });
	                        _auth2.default.saveUser(user);
	                    });
	                } else {
	                    _this.setState({ saveError: true, isSaving: false });
	                }
	            }).catch(function (err) {
	                _this.setState({ saveError: true, isSaving: false });
	            });
	        };
	
	        _this.renderPropertyRow = function (field, index) {
	            return _react2.default.createElement(
	                rmd.TableRow,
	                { key: index },
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    !field.required ? _react2.default.createElement(rmd.TextField, {
	                        value: field.key || '',
	                        onChange: _this.setFieldKey.bind(_this, field),
	                        errorText: field.keyError,
	                        name: 'New key',
	                        hintText: 'Enter key'
	                    }) : field.key
	                ),
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    _react2.default.createElement(rmd.TextField, {
	                        value: field.value || '',
	                        onChange: _this.setFieldValue.bind(_this, field),
	                        errorText: _this.state.errors[field.key],
	                        name: field.key,
	                        hintText: 'Enter value'
	                    })
	                ),
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    field.dataType
	                ),
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    null,
	                    field.desc
	                ),
	                _react2.default.createElement(
	                    rmd.TableRowColumn,
	                    { style: { width: 90 } },
	                    !field.required ? _react2.default.createElement(
	                        rmd.IconButton,
	                        { onClick: _this.removeProp.bind(_this, index) },
	                        _react2.default.createElement(_delete2.default, null)
	                    ) : ''
	                )
	            );
	        };
	
	        _this.state = {
	            fields: mandatoryFields,
	            isLoading: true,
	            saveSuccess: false,
	            saveError: false,
	            errors: {}
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(AccountDefaults, [{
	        key: 'removeProp',
	        value: function removeProp(index) {
	            var fields = this.state.fields;
	
	            fields.splice(index, 1);
	
	            this.setState({ fields: fields });
	        }
	    }, {
	        key: 'setFieldValue',
	        value: function setFieldValue(field, e) {
	            field.value = e.target.value;
	
	            this.setState({ fields: this.state.fields });
	        }
	    }, {
	        key: 'setFieldKey',
	        value: function setFieldKey(field, e) {
	            field.key = e.target.value;
	
	            this.setState({ fields: this.state.fields });
	        }
	    }, {
	        key: 'renderFooter',
	        value: function renderFooter() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                rmd.CardActions,
	                { className: 'actions' },
	                _react2.default.createElement(
	                    rmd.RaisedButton,
	                    { onClick: this.addField, style: { marginRight: 30 } },
	                    'Add field'
	                ),
	                _react2.default.createElement(
	                    rmd.RaisedButton,
	                    { backgroundColor: '#a4c639', style: { marginRight: 45 }, onClick: this.saveFields },
	                    'Save all'
	                ),
	                this.state.isSaving ? _react2.default.createElement(rmd.CircularProgress, { size: 0.4, style: { position: 'absolute', right: 0, top: 0 } }) : '',
	                this.state.saveSuccess ? _react2.default.createElement(_done2.default, { style: { position: 'absolute', right: 5, bottom: 15 } }) : '',
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.saveSuccess,
	                    message: 'Properties have been successfully saved',
	                    autoHideDuration: 4000
	                }),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.saveError,
	                    className: 'snackbar-error',
	                    message: 'Server error. Records are not saved ',
	                    action: 'close',
	                    onActionTouchTap: function onActionTouchTap() {
	                        return _this2.setState({ saveError: false });
	                    }
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'account-defaults' },
	                        _react2.default.createElement(
	                            rmd.Table,
	                            { selectable: false },
	                            _react2.default.createElement(
	                                rmd.TableHeader,
	                                { displaySelectAll: false },
	                                _react2.default.createElement(
	                                    rmd.TableRow,
	                                    null,
	                                    _react2.default.createElement(
	                                        rmd.TableHeaderColumn,
	                                        null,
	                                        'Key'
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableHeaderColumn,
	                                        null,
	                                        'Value'
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableHeaderColumn,
	                                        null,
	                                        'Data Type'
	                                    ),
	                                    _react2.default.createElement(
	                                        rmd.TableHeaderColumn,
	                                        null,
	                                        'Description'
	                                    ),
	                                    _react2.default.createElement(rmd.TableHeaderColumn, { style: { width: 90 } })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                rmd.TableBody,
	                                { displayRowCheckbox: false, showRowHover: true },
	                                this.state.fields.map(this.renderPropertyRow)
	                            )
	                        ),
	                        this.renderFooter()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AccountDefaults;
	}(_react2.default.Component);
	
	AccountDefaults.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = AccountDefaults;

/***/ },
/* 1117 */,
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountPassword = function (_React$Component) {
	    _inherits(AccountPassword, _React$Component);
	
	    function AccountPassword(props, context) {
	        _classCallCheck(this, AccountPassword);
	
	        var _this = _possibleConstructorReturn(this, (AccountPassword.__proto__ || Object.getPrototypeOf(AccountPassword)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AccountPassword, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            return _react2.default.createElement(
	                'div',
	                { className: 'row account' },
	                'Change password!!'
	            );
	        }
	    }]);
	
	    return AccountPassword;
	}(_react2.default.Component);
	
	AccountPassword.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = AccountPassword;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _reactRouter = __webpack_require__(188);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var notFoundIconStyle = {
	    width: 30,
	    height: 30,
	    marginRight: 15,
	    marginBottom: -10
	};
	
	var widgetImageStyle = {
	    maxWidth: '400px',
	    margin: '0px auto',
	    backgroundPosition: 'top',
	    backgroundRepeat: 'no-repeat'
	};
	
	var WidgetPick = function (_React$Component) {
	    _inherits(WidgetPick, _React$Component);
	
	    function WidgetPick(props, context) {
	        _classCallCheck(this, WidgetPick);
	
	        var _this = _possibleConstructorReturn(this, (WidgetPick.__proto__ || Object.getPrototypeOf(WidgetPick)).call(this, props, context));
	
	        _this.colors = ['#F4013C', '#F46E02', '#04A9F4'];
	        _this.filters = [{ type: 'all', label: 'All' }, { type: 'tournamentId', label: 'Only for league' }, { type: 'teamId', label: 'Only for club' }, { type: 'playerId', label: 'Only for player' }, { type: 'eventId', label: 'Only for match' }, { type: 'social', label: 'Social' }];
	
	        _this.loadData = function () {
	            var user = _this.context.user;
	
	            if (user && user.client) {
	                // widgets/standalone/FixturesList/spec
	                fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                    return response.json();
	                }).then(function (spec) {
	                    _this.setState({ spec: spec, isLoading: false });
	                }).catch(function (err) {
	                    _this.setState({ specError: err, isLoading: false });
	                });
	            } else {}
	        };
	
	        _this.handleFilterChange = function (event, index, filter) {
	            return _this.setState({ filter: filter });
	        };
	
	        _this.getNotFoundSpec = function () {
	            var user = _this.context.user;
	
	            var client = _lodash2.default.get(user, 'client', '');
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_error2.default, { color: _colors.red500, style: notFoundIconStyle }),
	                'Widget specification not found for client ',
	                client
	            );
	        };
	
	        _this.getGroups = function () {
	            var spec = _this.state.spec;
	
	            return _this.filters.map(function (f) {
	                return {
	                    key: f.key,
	                    widgets: _lodash2.default.filter(spec.widgets, function (widget) {
	                        return _lodash2.default.find(widget.spec.propTypes, function (p) {
	                            return p.key === f.key;
	                        });
	                    })
	                };
	            });
	        };
	
	        _this.renderFilterDropdown = function () {
	            var filter = _this.state.filter;
	
	            var options = _this.filters.map(function (filter) {
	                return _react2.default.createElement(rmd.MenuItem, { value: filter.type, key: filter.type, primaryText: filter.label });
	            });
	
	            return _react2.default.createElement(
	                rmd.DropDownMenu,
	                { value: filter, onChange: _this.handleFilterChange },
	                options
	            );
	        };
	
	        _this.getFilteredWidgets = function () {
	            var _this$state = _this.state,
	                widgets = _this$state.spec.widgets,
	                filter = _this$state.filter;
	
	
	            if (filter === 'social') {
	                return _lodash2.default.filter(widgets, function (s) {
	                    return !_lodash2.default.isEmpty(s.spec) && s.spec.social;
	                });
	            }
	            if (filter === 'all') {
	                return _lodash2.default.filter(widgets, function (s) {
	                    return !_lodash2.default.isEmpty(s.spec) && !s.spec.social;
	                });
	            }
	
	            return _lodash2.default.filter(widgets, function (s) {
	                return !s.spec.social && _lodash2.default.find(s.spec.propTypes, function (p) {
	                    return p.key === filter;
	                });
	            });
	        };
	
	        _this.renderWidgets = function () {
	            var _this$state2 = _this.state,
	                spec = _this$state2.spec,
	                filter = _this$state2.filter;
	
	            if (!Array.isArray(_lodash2.default.get(spec, 'widgets'))) {
	                return null;
	            }
	            var widgets = _this.getFilteredWidgets();
	            return widgets.map(_this.renderSingleWidget);
	        };
	
	        _this.renderSingleWidget = function (widget) {
	            var user = _this.context.user;
	
	            var snapshotUrl = _cfg2.default.widgets.url + '/widget/' + user.client + '/' + user.username + '/default/' + widget.id + '/demo-image?a=test';
	
	            return _react2.default.createElement(
	                'div',
	                { key: widget.id, className: 'col-xs-12 col-sm-6 col-md-6' },
	                _react2.default.createElement(
	                    rmd.Card,
	                    { className: 'widget-template' },
	                    _react2.default.createElement('div', { style: { height: '1px' } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'widget-preview-box', style: { textAlign: 'center', background: '#444' } },
	                        _react2.default.createElement('img', {
	                            src: snapshotUrl,
	                            style: {
	                                width: '90%',
	                                maxHeight: 300,
	                                minHeight: 300,
	                                objectFit: 'contain'
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(rmd.CardTitle, { titleStyle: { fontSize: '18px' }, title: widget.name }),
	                    _react2.default.createElement(
	                        rmd.CardActions,
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/widgets/' + widget.id + '/show-case/' + widget.name },
	                            _react2.default.createElement(rmd.FlatButton, { label: 'Demo' })
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/widgets/' + widget.id + '/customizer' },
	                            _react2.default.createElement(rmd.FlatButton, { className: 'create', label: 'Create', primary: true })
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            spec: {},
	            filter: 'all'
	        };
	        _this.loadData();
	        return _this;
	    }
	
	    /**
	     * @deprecated
	     */
	
	
	    _createClass(WidgetPick, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var _state = this.state,
	                spec = _state.spec,
	                specError = _state.specError,
	                filter = _state.filter;
	
	
	            if (!spec) {
	                return this.getNotFoundSpec();
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'pick-widget' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { padding: '16px 0' } },
	                    this.renderFilterDropdown()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    this.renderWidgets()
	                )
	            );
	        }
	    }]);
	
	    return WidgetPick;
	}(_react2.default.Component);
	
	WidgetPick.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = WidgetPick;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(1121);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _specs = __webpack_require__(1125);
	
	var _specs2 = _interopRequireDefault(_specs);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loadScript = __webpack_require__(1130);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _pickers = __webpack_require__(1131);
	
	var _pickers2 = _interopRequireDefault(_pickers);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _done = __webpack_require__(1117);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _phoneIphone = __webpack_require__(1291);
	
	var _phoneIphone2 = _interopRequireDefault(_phoneIphone);
	
	var _tabletMac = __webpack_require__(1292);
	
	var _tabletMac2 = _interopRequireDefault(_tabletMac);
	
	var _laptopMac = __webpack_require__(1293);
	
	var _laptopMac2 = _interopRequireDefault(_laptopMac);
	
	var _desktopMac = __webpack_require__(1294);
	
	var _desktopMac2 = _interopRequireDefault(_desktopMac);
	
	var _settingsOverscan = __webpack_require__(1295);
	
	var _settingsOverscan2 = _interopRequireDefault(_settingsOverscan);
	
	var _openInNew = __webpack_require__(1296);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _attachment = __webpack_require__(1297);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _code = __webpack_require__(1032);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _allInclusive = __webpack_require__(1033);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _web = __webpack_require__(1298);
	
	var _web2 = _interopRequireDefault(_web);
	
	var _prod = __webpack_require__(1299);
	
	var _prod2 = _interopRequireDefault(_prod);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var previewSizeIcons = {
	    xs: _phoneIphone2.default,
	    sm: _tabletMac2.default,
	    md: _laptopMac2.default,
	    lg: _desktopMac2.default,
	    auto: _settingsOverscan2.default
	};
	
	var C_MEDIA_LOCALSTORAGE = 'C_MEDIA_LOCALSTORAGE';
	var C_GLOBAL_SETUP = 'C_GLOBAL_SETUP';
	
	var STAGE_WIDGETS_URL = _prod2.default.widgets.url;
	
	var iconStyle = {
	    width: 30,
	    height: 30,
	    marginRight: 15,
	    marginBottom: -10
	};
	
	var WidgetCustomizer = function (_React$Component) {
	    _inherits(WidgetCustomizer, _React$Component);
	
	    function WidgetCustomizer(props, context) {
	        _classCallCheck(this, WidgetCustomizer);
	
	        var _this = _possibleConstructorReturn(this, (WidgetCustomizer.__proto__ || Object.getPrototypeOf(WidgetCustomizer)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var wiid = props.location.query.wiid;
	
	
	        _this.state = {
	            isLoading: true,
	            widget: {},
	            clientSpec: {},
	            propValues: {},
	            // propValues: {...props.location.query},
	            modalIsOpen: false,
	            widgetWidth: 500,
	            previewHeight: 500,
	            wiid: wiid,
	            previewSize: localStorage.getItem(C_MEDIA_LOCALSTORAGE) || 'auto',
	            globalSetup: localStorage.getItem(C_GLOBAL_SETUP) === 'true' || false,
	            previewProps: {},
	            previewPropsJS: {},
	            globalSetupDialogue: false,
	            showWPInstructions: false
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(WidgetCustomizer, [{
	        key: 'changePropValue',
	        value: function changePropValue(prop, val) {
	            var _this2 = this;
	
	            var changedProp = void 0;
	            if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	                changedProp = prop;
	            } else {
	                changedProp = {};
	                changedProp[prop] = val;
	            }
	
	            var propValues = Object.assign({}, this.state.propValues, changedProp);
	            this.setState({ propValues: propValues }, function () {
	                _this2.updateWIID(_this2.state.wiid);
	            });
	        }
	    }, {
	        key: 'createPreviewProps',
	        value: function createPreviewProps() {
	            var dataAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var state = arguments[1];
	
	            var previewProps = {};
	            var nextState = state || this.state;
	            var widgetProps = nextState.widget.propTypes || [];
	
	            widgetProps.forEach(function (prop) {
	                var toMap = _extends({}, prop.propsMap, _lodash2.default.fromPairs([[prop.key, prop.key]]));
	                // var toMap = _.fromPairs([[prop.key, prop.key]]);
	
	                Object.keys(toMap).forEach(function (from) {
	                    var to = toMap[from];
	                    var value = nextState.propValues[from];
	
	                    try {
	                        value = JSON.parse(value);
	                    } catch (e) {
	                        value = nextState.propValues[from];
	                    }
	
	                    if (Array.isArray(value)) {
	                        value = JSON.stringify(value);
	                    }
	
	                    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	                        value = JSON.stringify(value);
	                    }
	
	                    var key = dataAttributes ? 'data-' + _lodash2.default.kebabCase(to) : to;
	
	                    if (value !== '' && value !== undefined && value !== null) previewProps[key] = value;
	                });
	            });
	
	            return previewProps;
	        }
	    }, {
	        key: 'generateAssets',
	        value: function generateAssets() {
	            var user = this.context.user;
	
	            return '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '" crossorigin></script>\n<link rel="stylesheet" type="text/css" href="' + _cfg2.default.WDPLinkr.client.cssPath(user.client, user.username, this.state.propValues.theme) + '"/>';
	        }
	    }, {
	        key: 'generateWPShortcutCode',
	        value: function generateWPShortcutCode() {
	            return 'function handle_rlz_widget_shortcode ( $atts, $content = null ) {\n    $params = "";\n    foreach ($atts as $key => $value) {\n        if (substr($value, 0, 1) == \'$\') $value = $_GET[substr($value, 1)];\n        $params .= $key . \'="\' . $value . \'" \';\n    }\n    return "<rlz-widget " . $params . "></rlz-widget>";\n}\n\nadd_shortcode(\'rlz-widget\', \'handle_rlz_widget_shortcode\');\n';
	        }
	    }, {
	        key: 'generateCode',
	        value: function generateCode(method, all, previewProps) {
	            var optionalParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	            var isWP = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	            var user = this.context.user;
	            var widgetId = this.props.params.widgetId;
	
	            var commonParams = {
	                'data-load': method,
	                'data-client': user.client,
	                'data-user': user.username,
	                'data-theme': this.state.propValues.theme,
	                'data-token': user.accessToken,
	                'data-ga': user.defaultProps.GA,
	                'data-lang': this.state.propValues.lang
	            };
	            var pp = _lodash2.default.clone(previewProps);
	            Reflect.deleteProperty(pp, 'data-theme');
	            Reflect.deleteProperty(pp, 'data-debug');
	
	            var params = _lodash2.default.extend({}, pp, all && commonParams, optionalParams);
	
	            if (isWP) {
	                var paramsStr = _lodash2.default.chain(params).toPairs().reduce(function (memo, p) {
	                    return memo + '  ' + p[0] + '="' + JSON.stringify(p[1]) + '"';
	                }, '').value();
	                return '[rlz-widget data-name=' + widgetId + ' data-wiid=' + this.state.wiid + ' ' + paramsStr + ' /]';
	            }
	
	            return _server2.default.renderToStaticMarkup(_react2.default.createElement('rlz-widget', _extends({ 'data-name': widgetId, 'data-wiid': this.state.wiid }, params)));
	        }
	    }, {
	        key: 'generateSetup',
	        value: function generateSetup() {
	            var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var loadMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'js';
	            var crossorigin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	            var user = this.context.user;
	
	            var output = '';
	            if (crossorigin) {
	                output = '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '" crossorigin></script>';
	            } else {
	                output = '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '"></script>';
	            }
	
	            var defaults = '\n<script type="text/javascript">\n    WDPDefaults.set("client", "' + user.client + '");\n    WDPDefaults.set("user", "' + user.username + '");\n    WDPDefaults.set("theme", "' + this.state.propValues.theme + '");\n    WDPDefaults.set("token", "' + user.accessToken + '");\n    WDPDefaults.set("ga",    "' + (user.defaultProps.GA || '') + '");\n    WDPDefaults.set("load",  "' + loadMethod + '");\n    WDPDefaults.set("lang",  "' + (this.state.propValues.lang || 'en') + '");\n</script>';
	
	            return output + (global ? defaults : '');
	        }
	    }, {
	        key: 'renderJSStep1',
	        value: function renderJSStep1() {
	            var _this3 = this;
	
	            var load = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'js';
	            var globalSetup = this.state.globalSetup;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '1. Enter init script once a page where widget. In <head/> or bottom of all pages with widgets'
	                ),
	                _react2.default.createElement('textarea', {
	                    readOnly: true,
	                    style: { width: '100%' },
	                    rows: globalSetup ? 10 : 2,
	                    value: this.generateSetup(globalSetup, load)
	                }),
	                _react2.default.createElement(rmd.Checkbox, {
	                    label: 'Define WDPDefaults (theme, lang, accesstoken) globally',
	                    style: { marginTop: '10px', fontSize: '12px' },
	                    checked: this.state.globalSetup,
	                    onCheck: function onCheck(e, val) {
	                        _this3.setState({ globalSetup: val });
	                        localStorage.setItem(C_GLOBAL_SETUP, true);
	                    }
	                })
	            );
	        }
	    }, {
	        key: 'renderEmbedCode',
	        value: function renderEmbedCode() {
	            var _this4 = this;
	
	            var user = this.context.user;
	            var widgetId = this.props.params.widgetId;
	            var _state = this.state,
	                widget = _state.widget,
	                globalSetup = _state.globalSetup,
	                previewHeight = _state.previewHeight,
	                previewProps = _state.previewProps,
	                previewPropsJS = _state.previewPropsJS;
	
	
	            return _react2.default.createElement(
	                rmd.Card,
	                { className: 'card embed-code' },
	                _react2.default.createElement(
	                    rmd.Tabs,
	                    null,
	                    _react2.default.createElement(
	                        rmd.Tab,
	                        { label: 'JS Embed', icon: _react2.default.createElement(_code2.default, null) },
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Widget integration using embed code [JS integration]'
	                            ),
	                            this.renderJSStep1(),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '2. Put widget <embed/> code on a page'
	                            ),
	                            _react2.default.createElement('textarea', {
	                                readOnly: true,
	                                style: { width: '100%' },
	                                rows: 3,
	                                value: this.generateCode('js', !globalSetup, previewProps)
	                            }),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Wordpress shortcode (',
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        style: {
	                                            color: 'rgb(0, 188, 212)',
	                                            fontSize: '12px',
	                                            textDecoration: 'underline'
	                                        },
	                                        href: '#',
	                                        onClick: function onClick() {
	                                            return _this4.setState({ showWPInstructions: true });
	                                        }
	                                    },
	                                    'Get a WP shortcut code'
	                                ),
	                                ')'
	                            ),
	                            _react2.default.createElement('textarea', {
	                                readOnly: true,
	                                style: { width: '100%' },
	                                rows: 3,
	                                value: this.generateCode('js', !globalSetup, previewProps, {}, true)
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        rmd.Tab,
	                        { label: 'Iframe', icon: _react2.default.createElement(_web2.default, null) },
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Link to widget that can be used in iframe'
	                            ),
	                            _react2.default.createElement('textarea', { readOnly: true, style: { width: '100%' }, rows: 2, value: this.generateIframe() }),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Widget integration using embed code [Iframe integration]'
	                            ),
	                            this.renderJSStep1('iframe'),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '2. Put widget <embed/> code on a page'
	                            ),
	                            _react2.default.createElement('textarea', {
	                                readOnly: true,
	                                style: { width: '100%' },
	                                rows: 3,
	                                value: this.generateCode('iframe', !globalSetup, previewProps)
	                            }),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Wordpress shortcode (',
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        style: {
	                                            color: 'rgb(0, 188, 212)',
	                                            fontSize: '12px',
	                                            textDecoration: 'underline'
	                                        },
	                                        href: '#',
	                                        onClick: function onClick() {
	                                            return _this4.setState({ showWPInstructions: true });
	                                        }
	                                    },
	                                    'Get a WP shortcut code'
	                                ),
	                                ')'
	                            ),
	                            _react2.default.createElement('textarea', {
	                                readOnly: true,
	                                style: { width: '100%' },
	                                rows: 3,
	                                value: this.generateCode('iframe', !globalSetup, previewProps, true)
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        rmd.Tab,
	                        { label: 'ESI', icon: _react2.default.createElement(_allInclusive2.default, null) },
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Link to widget that can be used for ESI'
	                            ),
	                            _react2.default.createElement('textarea', {
	                                readOnly: true,
	                                style: { width: '100%' },
	                                rows: 2,
	                                value: _cfg2.default.WDPLinkr.widget.esi(user.client, user.username, this.state.propValues.theme, widgetId, previewPropsJS)
	                            }),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'You will have to include on page following libraries'
	                            ),
	                            _react2.default.createElement('textarea', { readOnly: true, style: { width: '100%' }, rows: 5, value: this.generateAssets() })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    rmd.CardActions,
	                    null,
	                    this.state.isSaving ? _react2.default.createElement(rmd.CircularProgress, { size: 0.4, style: { position: 'absolute', right: 0, top: 0 } }) : '',
	                    this.state.saveSuccess ? _react2.default.createElement(_done2.default, {
	                        style: {
	                            position: 'absolute',
	                            right: 5,
	                            bottom: 15
	                        }
	                    }) : ''
	                )
	            );
	        }
	    }, {
	        key: 'renderWidgetPreview',
	        value: function renderWidgetPreview() {
	            var _this5 = this;
	
	            var user = this.context.user;
	            var widgetId = this.props.params.widgetId;
	            var wiid = this.props.location.query.wiid;
	            var _state2 = this.state,
	                isLoading = _state2.isLoading,
	                widget = _state2.widget,
	                clientSpec = _state2.clientSpec,
	                previewProps = _state2.previewProps,
	                previewWidth = _state2.previewWidth,
	                previewHeight = _state2.previewHeight,
	                previewPropsJS = _state2.previewPropsJS;
	
	
	            var iframeURL = _cfg2.default.WDPLinkr.widget.iframe(user.client, user.username, this.state.propValues.theme, widgetId, previewPropsJS);
	
	            var smURL = _cfg2.default.WDPLinkr.widget.sm(user.client, user.username, this.state.propValues.theme, widgetId, previewPropsJS);
	
	            return _react2.default.createElement(
	                rmd.Card,
	                { className: 'card widget-preview' },
	                _react2.default.createElement(
	                    rmd.Toolbar,
	                    null,
	                    _react2.default.createElement(rmd.ToolbarGroup, { firstChild: true }),
	                    widget && !widget.social && _react2.default.createElement(
	                        rmd.ToolbarGroup,
	                        null,
	                        _react2.default.createElement(rmd.ToolbarTitle, { text: 'Preview on' }),
	                        ['xs', 'sm', 'md', 'lg', 'auto'].map(function (dm) {
	                            var IconXX = previewSizeIcons[dm];
	                            return _react2.default.createElement(
	                                rmd.IconButton,
	                                {
	                                    key: dm,
	                                    label: dm,
	                                    disabled: _this5.state.previewSize === dm,
	                                    onClick: function onClick(e) {
	                                        localStorage.setItem(C_MEDIA_LOCALSTORAGE, dm);
	                                        _this5.setState({ previewSize: dm }, function () {
	                                            return window.dispatchEvent(new Event('resize'));
	                                        });
	                                    }
	                                },
	                                IconXX && _react2.default.createElement(IconXX, null)
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    rmd.CardText,
	                    { className: 'wdp-preview-container' },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'wdp-preview',
	                            className: 'wdp-preview wdp-preview-' + (widget.social ? '800px' : this.state.previewSize)
	                        },
	                        !isLoading && _react2.default.createElement('rlz-widget', _extends({
	                            ref: 'preview',
	                            'data-name': widgetId,
	                            'data-load': 'js',
	                            'data-client': user.client,
	                            'data-user': user.username,
	                            'data-token': user.accessToken,
	                            'data-wiid': this.state.wiid,
	                            'data-customizer': 'true'
	                        }, previewProps))
	                    ),
	                    previewWidth && previewHeight && _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-preview-sizes' },
	                        _react2.default.createElement(
	                            'table',
	                            null,
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Width'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        previewWidth,
	                                        'px'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        'Height'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        previewHeight,
	                                        'px'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    rmd.CardText,
	                    null,
	                    _react2.default.createElement(rmd.Toggle, {
	                        label: 'Use preview widget height (' + (previewHeight || 100) + 'px) as default',
	                        disabled: !previewHeight,
	                        labelPosition: 'right',
	                        toggled: this.state.propValues.defaultHeight > 0,
	                        onToggle: function onToggle(e, usePreviewHeight) {
	                            _this5.changePropValue('defaultHeight', usePreviewHeight && _this5.state.previewHeight || '');
	                            _this5.setState({
	                                usePreviewHeight: usePreviewHeight,
	                                previewHeight: previewHeight
	                            });
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    rmd.CardActions,
	                    { className: 'actions' },
	                    _react2.default.createElement(rmd.FlatButton, {
	                        href: this.state.widget.social ? smURL : iframeURL,
	                        label: 'Open in new Window',
	                        target: '_blank',
	                        icon: _react2.default.createElement(_openInNew2.default, null)
	                    }),
	                    _react2.default.createElement(rmd.FlatButton, {
	                        label: 'example-' + widgetId + '.html',
	                        onClick: this.handleExampleDownload,
	                        icon: _react2.default.createElement(_attachment2.default, null)
	                    })
	                )
	            );
	        }
	
	        // saveWidgetTemplate = () => {
	        //     this.setState({isSaving: true});
	        //     return this.updateWIID(this.state.wiid, true).then(() => this.setState({saveSuccess: true}));
	        // }
	
	    }, {
	        key: 'renderModal',
	        value: function renderModal() {
	            var styles = {
	                maxWidth: '90%',
	                height: '90%',
	                width: +this.state.widgetWidth + 48
	            };
	
	            var buttonStyles = {
	                margin: '0 6px'
	            };
	            var okIconUrl = 'http://s10.postimg.org/3yid0uket/success.png';
	            var errorIconUrl = 'http://s10.postimg.org/86d59llud/fail.png';
	
	            var actions = [_react2.default.createElement(rmd.FlatButton, { label: 'Cancel', secondary: true, onTouchTap: this.closeModal.bind(this) }), _react2.default.createElement(rmd.FlatButton, { label: 'Download', primary: true, onTouchTap: this.downloadImage.bind(this) })];
	
	            return _react2.default.createElement(
	                rmd.Dialog,
	                {
	                    open: this.state.modalIsOpen,
	                    modal: false,
	                    actions: actions,
	                    onRequestClose: this.closeModal.bind(this),
	                    contentStyle: styles,
	                    autoScrollBodyContent: true
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'preview' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Preview'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'preview-image-wrapper',
	                            id: 'preview-image-wrapper',
	                            style: {
	                                maxWidth: this.state.widgetWidth + 'px',
	                                height: this.state.contentHeight ? this.state.contentHeight + 'px' : false
	                            }
	                        },
	                        _react2.default.createElement('img', {
	                            onLoad: function onLoad() {
	                                return document.getElementById('preview-image-wrapper').style.height = 'auto';
	                            },
	                            id: 'preview-image',
	                            src: this.state.previewUrl,
	                            className: 'preview-image',
	                            alt: 'preview'
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'handleParamChange',
	        value: function handleParamChange(param, event) {
	            var obj = {};
	            obj[param] = event.target.value;
	            this.setState(obj);
	        }
	    }, {
	        key: 'downloadImage',
	        value: function downloadImage() {
	            var link = document.createElement('a');
	            link.download = this.props.params.widgetId;
	            link.href = this.state.previewUrl;
	            link.click();
	        }
	    }, {
	        key: 'openImagePreview',
	        value: function openImagePreview() {
	            var _this6 = this;
	
	            // var widgetName = this.props.widgetName;
	            // var iframe = document.getElementById('target');
	            // var widgetHeight = iframe.height && parseInt(iframe.height);
	
	            var convertUrl = _cfg2.default.apis.webshot + '/api/convert';
	            var user = this.context.user;
	            var widgetId = this.props.params.widgetId;
	            var previewPropsJS = this.state.previewPropsJS;
	
	
	            var widgetIframeUrl = _cfg2.default.WDPLinkr.widget.iframe(user.client, user.username, previewPropsJS.theme, widgetId, previewPropsJS);
	
	            // TEMP:
	            // webshot can't access localhost
	            widgetIframeUrl = widgetIframeUrl.replace('http://127.0.0.1:3003', STAGE_WIDGETS_URL);
	            // console.log(widgetIframeUrl)
	            var imageQuality = 100;
	
	            var params = {
	                // "filename": widgetName,
	                quality: imageQuality,
	                url: widgetIframeUrl,
	                captureSelector: '.wdp',
	                whiteBg: false,
	                browser: _cfg2.default.webshotBrowser,
	                // "offset" + offset +
	                // "windowHeight" + widgetHeight +
	                windowWidth: this.state.widgetWidth,
	                renderDelay: 2000
	            };
	
	            fetch(convertUrl, {
	                method: 'post',
	                body: JSON.stringify(params),
	                headers: { 'Content-Type': 'application/json' }
	            }).then(function (response) {
	                return response.json();
	            }).then(function (json) {
	                return _this6.openModal(json.url);
	            });
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal(previewUrl) {
	            this.setState({ modalIsOpen: true, previewUrl: previewUrl });
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            this.clearPreview();
	            this.setState({
	                modalIsOpen: false,
	                status: null,
	                postHeader: null,
	                postUrl: null
	            });
	        }
	    }, {
	        key: 'clearPreview',
	        value: function clearPreview() {
	            var filename = this.state.previewUrl.split('/').pop();
	            var deleteUrl = _cfg2.default.apis.webshot + '/api/clear/' + filename;
	
	            fetch(deleteUrl, { method: 'delete' });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var user = this.context.user;
	            var widgetId = this.props.params.widgetId;
	            var _state3 = this.state,
	                isLoading = _state3.isLoading,
	                widget = _state3.widget,
	                clientSpec = _state3.clientSpec,
	                previewProps = _state3.previewProps,
	                previewPropsJS = _state3.previewPropsJS;
	
	            var widgetProps = widget.propTypes || [];
	
	            if (!isLoading && _lodash2.default.isEmpty(clientSpec)) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_error2.default, { color: _colors.red500, style: iconStyle }),
	                    'Widget specification not found for client ',
	                    user.client
	                );
	            }
	
	            var ThemePicker = _pickers2.default['theme_picker'];
	
	            var groupedWidgetProps = _lodash2.default.groupBy(widgetProps, function (w) {
	                return w.scope || 'custom';
	            });
	
	            var titles = {
	                custom: {
	                    title: 'Main widget parameters',
	                    subtitle: 'Setup widget to Your needs'
	                },
	                template: {
	                    title: 'Pick a template',
	                    subtitle: 'Setup widget to Your needs'
	                },
	                styling: {
	                    title: 'Styling',
	                    subtitle: 'Setup widget to Your needs'
	                },
	                common: {
	                    title: 'Common parameters',
	                    subtitle: 'Control header, more button, language etc'
	                },
	                images: {
	                    title: 'Preview image parameters',
	                    subtitle: 'Control editorial images'
	                }
	            };
	
	            var commonParamsExpanded = previewPropsJS.suppressHeader === true || !_lodash2.default.isEmpty(previewPropsJS.moreButtonLabel);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'widget-customizer' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-customizer__variables' },
	                    !widgetProps.length && _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'card widget-params' },
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            null,
	                            'No params defined for widget'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        rmd.Card,
	                        { style: { marginTop: '0px' } },
	                        _react2.default.createElement(rmd.CardHeader, { title: '' + widget.id, subtitle: widget.name })
	                    ),
	                    _lodash2.default.toPairs(groupedWidgetProps).map(function (pair) {
	                        var group = pair[0];
	                        var widgets = pair[1];
	                        return _react2.default.createElement(
	                            rmd.Card,
	                            { key: group, className: 'card widget-params', initiallyExpanded: true },
	                            _react2.default.createElement(rmd.CardHeader, {
	                                style: { background: '#f3f3f3' },
	                                title: titles[group] && titles[group].title || '',
	                                subtitle: titles[group] && titles[group].subtitle || '',
	                                actAsExpander: true,
	                                showExpandableButton: true
	                            }),
	                            _react2.default.createElement(
	                                rmd.CardText,
	                                { expandable: true, style: { padding: 0 } },
	                                widgets && _lodash2.default.filter(widgets, function (p) {
	                                    return p.type !== 'hidden';
	                                }).map(_this7.renderPicker)
	                            )
	                        );
	                    }),
	                    _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'card widget-preview' },
	                        _react2.default.createElement(rmd.CardHeader, {
	                            style: { background: '#f3f3f3' },
	                            title: 'Widget documentation',
	                            subtitle: 'Available properties',
	                            actAsExpander: true,
	                            showExpandableButton: true
	                        }),
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            { expandable: true, key: 'props' },
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                JSON.stringify(previewProps, null, 4)
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-customizer__content' },
	                    this.renderWidgetPreview(),
	                    this.renderEmbedCode(),
	                    false && this.renderSocialPost()
	                ),
	                this.renderModal(),
	                this.renderGlobalSetupCodeSnipped(),
	                this.renderWPInstructions()
	            );
	        }
	    }]);
	
	    return WidgetCustomizer;
	}(_react2.default.Component);
	
	WidgetCustomizer.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this8 = this;
	
	    this.componentDidMount = function () {
	        window.addEventListener('message', _lodash2.default.debounce(function (message) {
	            // console.log("WC >> WIDGET POST MESSAGE ABOUT HEIGHT CHANGE");
	            try {
	                var data = JSON.parse(message.data);
	                if (_this8.state.previewWidth !== data.width || _this8.state.previewHeight !== data.height) {
	                    _this8.setState({
	                        previewWidth: data.width,
	                        previewHeight: data.height
	                    });
	                }
	            } catch (e) {}
	        }, 1000), false);
	    };
	
	    this.componentWillUpdate = function (nextProps, nextState) {
	        nextState.previewProps = _this8.createPreviewProps(true, nextState);
	        nextState.previewPropsJS = _this8.createPreviewProps(false, nextState);
	    };
	
	    this.loadData = function () {
	        // console.log("WC >> LOAD DATA");
	        var user = _this8.context.user;
	        var defaultTheme = user.defaultTheme;
	        var widgetId = _this8.props.params.widgetId;
	
	
	        if (!user || !user.client) return null;
	        return _bluebird2.default.props({
	            clientSpec: fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken()),
	            widget: fetch(_cfg2.default.widgets.url + '/widgets/standalone/' + widgetId + '/spec'),
	            themes: fetch(_cfg2.default.dash.api.host + '/api/themes?access_token=' + _auth2.default.getAccessToken())
	        }).then(function (result) {
	            return _bluebird2.default.props({
	                clientSpec: result.clientSpec.status === 200 && result.clientSpec.json(),
	                widget: result.widget.status === 200 && result.widget.json(),
	                themes: result.themes.status === 200 && result.themes.json()
	            });
	        }).then(function (results) {
	            var clientPreferences = _lodash2.default.chain(user.defaultProps)
	            // .filter(prop => _.find(results.widget.propTypes, {key: prop.key}))
	            .map(function (prop) {
	                return [prop.key, prop.value];
	            }).fromPairs().value();
	
	            var widgetDefaults = _lodash2.default.chain(results.widget.propTypes).map(function (i) {
	                return [i.key, i.defaultValue];
	            }).fromPairs().value();
	
	            // detect default theme
	            var theme = results.themes.find(function (t) {
	                return t.id === defaultTheme;
	            }) || _lodash2.default.first(results.themes);
	
	            var mergedProps = _lodash2.default.merge({
	                theme: theme && theme.id
	            }, widgetDefaults, clientPreferences, _this8.props.location.query);
	
	            // console.log("WC >> DATA LOADED");
	            _this8.setState({
	                widget: results.widget,
	                clientSpec: results.clientSpec,
	                propValues: mergedProps,
	                isLoading: false
	            });
	        }).catch(function (err) {
	            _this8.setState({ err: err, isLoading: false });
	        });
	    };
	
	    this.generateIframe = function () {
	        var widgetId = _this8.props.params.widgetId;
	        var _state4 = _this8.state,
	            widget = _state4.widget,
	            globalSetup = _state4.globalSetup,
	            previewHeight = _state4.previewHeight,
	            previewProps = _state4.previewProps,
	            previewPropsJS = _state4.previewPropsJS;
	        var user = _this8.context.user;
	
	        return _cfg2.default.WDPLinkr.widget.iframe(user.client, user.username, _this8.state.propValues.theme, widgetId, previewPropsJS);
	    };
	
	    this.handleExampleDownload = function () {
	        var link = document.createElement('a');
	        var previewProps = _this8.state.previewProps;
	        var widgetId = _this8.props.params.widgetId;
	
	        link.download = 'Example-' + widgetId + '.html';
	        link.href = 'data:text/plain;base64,' + btoa('\n<!-- INIT SCRIPT CODE -->\n' + _this8.generateSetup(false, 'js', false) + '\n<!-- EMBED CODE -->\n' + _this8.generateCode('js', true, previewProps));
	        link.click();
	    };
	
	    this.renderPicker = function (prop, i, array) {
	        var Picker = _pickers2.default[prop.type];
	        if (!Picker) return _react2.default.createElement(
	            'div',
	            null,
	            prop.type
	        );
	        var user = _this8.context.user;
	
	        var clientPreferences = _lodash2.default.chain(user.defaultProps).map(function (prop) {
	            var val = prop.value;
	            try {
	                val = JSON.parse(prop.value);
	            } catch (e) {
	                //console.log(e);
	            }
	            return [prop.key, val];
	        }).fromPairs().value();
	
	        return [_react2.default.createElement(
	            rmd.CardText,
	            { key: prop.key + 'p' },
	            _react2.default.createElement(Picker, _extends({}, prop, prop.props, clientPreferences, _this8.state.previewPropsJS, {
	                key: prop.key,
	                propKey: prop.key,
	                value: _this8.state.previewPropsJS[prop.key],
	                onChange: _this8.changePropValue.bind(_this8),
	                error: _this8.state.error
	            }))
	        ), i !== array.length - 1 && _react2.default.createElement(rmd.Divider, { key: prop.key + 'd' })];
	    };
	
	    this.renderGlobalSetupCodeSnipped = function () {
	        var actions = [false && _react2.default.createElement(rmd.FlatButton, { label: 'Copy', secondary: true, onTouchTap: function onTouchTap() {} }), _react2.default.createElement(rmd.FlatButton, { label: 'Close', primary: true, onTouchTap: function onTouchTap() {
	                return _this8.setState({ globalSetupDialogue: false });
	            } })];
	        var styles = {
	            maxWidth: '90%',
	            height: '90%'
	        };
	        return _react2.default.createElement(
	            rmd.Dialog,
	            {
	                open: _this8.state.globalSetupDialogue,
	                modal: false,
	                actions: actions,
	                onRequestClose: function onRequestClose() {
	                    return _this8.setState({ globalSetupDialogue: false });
	                },
	                contentStyle: styles,
	                autoScrollBodyContent: true
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'preview' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Global setup'
	                ),
	                _react2.default.createElement('textarea', { readOnly: true, style: { width: '100%' }, rows: 15, value: _this8.generateSetup() })
	            )
	        );
	    };
	
	    this.renderWPInstructions = function () {
	        var actions = [_react2.default.createElement(rmd.FlatButton, { label: 'Close', primary: true, onTouchTap: function onTouchTap() {
	                return _this8.setState({ showWPInstructions: false });
	            } })];
	        var styles = {
	            maxWidth: '90%',
	            height: '90%'
	        };
	        var codeStyle = {
	            color: '#000',
	            fontSize: '14px'
	        };
	        return _react2.default.createElement(
	            rmd.Dialog,
	            {
	                open: _this8.state.showWPInstructions,
	                modal: false,
	                actions: actions,
	                onRequestClose: function onRequestClose() {
	                    return _this8.setState({ showWPInstructions: false });
	                },
	                contentStyle: styles,
	                autoScrollBodyContent: true
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'preview' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Shortcut for default WYSIWYG editor'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'It is possible to install shortcut using availble free plugins with no actual php coding. Using shortcode in Wordpress editor is best option because of next issues:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'By default WP will try to wrap <rlz-widget/> with <p/>'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'This macro will allow to read get parameters from querystring, which is very useful when using WDPDeeplinker'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'To access get parameter from querystring',
	                    ' ',
	                    _react2.default.createElement(
	                        'code',
	                        { style: codeStyle },
	                        '/matchcenter?eventId=123456'
	                    ),
	                    ' attribute in macros should look like',
	                    ' ',
	                    _react2.default.createElement(
	                        'code',
	                        { style: codeStyle },
	                        'eventId="$eventId"'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'In the end embed code of widget should look like this:',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'code',
	                        { style: codeStyle },
	                        '[rlz-widget data-name="TournamentTable" data-tournament-id="$tournamentId" /]'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Complete code of shortcode listed below:'
	                ),
	                _react2.default.createElement('textarea', { readOnly: true, style: { width: '100%' }, rows: 15, value: _this8.generateWPShortcutCode() })
	            )
	        );
	    };
	
	    this.updateWIID = function (wiid, template) {
	        var widgetId = _this8.props.params.widgetId;
	
	        var params = {
	            userId: _this8.context.user._id,
	            props: _this8.state.propValues,
	            template: template
	        };
	        var url = _cfg2.default.dash.api.host + '/api/widgets/' + widgetId;
	        if (wiid) {
	            url += '/' + wiid;
	        }
	
	        return fetch(url, {
	            method: 'post',
	            body: JSON.stringify(params),
	            headers: { 'Content-Type': 'application/json' }
	        }).then(function (response) {
	            return response.json();
	        }).then(function (widgetInstance) {
	            if (!wiid) {
	                // console.log("WC >>  WIID SAVED");
	                _this8.setState({ wiid: widgetInstance._id });
	            }
	            // console.log("WC >> URL WAS UPDATED...");
	            _this8.context.router.replace(_extends({}, _this8.props.location, {
	                query: Object.assign({}, _this8.state.previewPropsJS, {
	                    wiid: widgetInstance._id
	                })
	            }));
	        }).catch(function (err) {
	            _this8.setState({ error: err, isSaving: false });
	        });
	    };
	
	    this.renderSocialPost = function () {
	        if (!_this8.state.widget.social) return;
	        return _react2.default.createElement(
	            rmd.Card,
	            { className: 'card sm-share', style: { display: 'block' } },
	            _react2.default.createElement(rmd.CardHeader, { title: 'Share to SM' }),
	            _react2.default.createElement(
	                rmd.CardText,
	                null,
	                _react2.default.createElement(rmd.TextField, {
	                    floatingLabelText: 'Image width, px',
	                    value: _this8.state.widgetWidth,
	                    style: { marginRight: '30px' },
	                    onChange: _this8.handleParamChange.bind(_this8, 'widgetWidth')
	                })
	            ),
	            _react2.default.createElement(
	                rmd.CardActions,
	                null,
	                _react2.default.createElement(rmd.RaisedButton, { label: 'Image', primary: true, onClick: _this8.openImagePreview.bind(_this8) })
	            )
	        );
	    };
	};
	
	exports.default = WidgetCustomizer;

/***/ },
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    core: __webpack_require__(1126),
	    spdk: __webpack_require__(1128),
	    tv2no: __webpack_require__(1129)
	};

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var path = __webpack_require__(1127);
	
	module.exports = {
	    id: 'core',
	    name: 'core',
	    salt: '',
	    defaultSCSSPath: path.resolve(__dirname, '../../widgets/themes/core/core.default.scss'),
	    themesDir: path.resolve(__dirname, '../../widgets/themes/core/')
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1127 */,
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var path = __webpack_require__(1127);
	var CLIENT = 'spdk';
	
	module.exports = {
	    id: '' + CLIENT,
	    name: 'Superliga.dk',
	    salt: 'hi2',
	    defaultSCSSPath: path.resolve(__dirname, '../../widgets/themes/' + CLIENT + '/' + CLIENT + '.default.scss'),
	    themesDir: path.resolve(__dirname, '../../widgets/themes/' + CLIENT + '/')
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var path = __webpack_require__(1127);
	
	module.exports = {
	    id: 'tv2no',
	    name: 'tv2no',
	    salt: '',
	    defaultSCSSPath: path.resolve(__dirname, '../../widgets/themes/tv2no/tv2no.default.scss'),
	    themesDir: path.resolve(__dirname, '../../widgets/themes/tv2no/')
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1130 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (url, callback) {
	    var script = document.createElement("script");
	    script.type = "text/javascript";
	
	    if (script.readyState) {
	        // IE
	        script.onreadystatechange = function () {
	            if (script.readyState == "loaded" || script.readyState == "complete") {
	                script.onreadystatechange = null;
	                callback && callback(false, url);
	            }
	        };
	    } else {
	        //Others
	        script.onload = function () {
	            callback && callback(false, url);
	        };
	    }
	
	    script.onerror = function () {
	        callback && callback(true, url);
	    };
	
	    script.src = url;
	    document.getElementsByTagName("head")[0].appendChild(script);
	};

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _EventByTeamPicker = __webpack_require__(1132);
	
	var _EventByTeamPicker2 = _interopRequireDefault(_EventByTeamPicker);
	
	var _EventByDatePicker = __webpack_require__(1135);
	
	var _EventByDatePicker2 = _interopRequireDefault(_EventByDatePicker);
	
	var _TournamentPicker = __webpack_require__(1136);
	
	var _TournamentPicker2 = _interopRequireDefault(_TournamentPicker);
	
	var _Switcher = __webpack_require__(1155);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _Checkboxes = __webpack_require__(1156);
	
	var _Checkboxes2 = _interopRequireDefault(_Checkboxes);
	
	var _RoundPicker = __webpack_require__(1157);
	
	var _RoundPicker2 = _interopRequireDefault(_RoundPicker);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _ThemePicker = __webpack_require__(1158);
	
	var _ThemePicker2 = _interopRequireDefault(_ThemePicker);
	
	var _TemplatePicker = __webpack_require__(1159);
	
	var _TemplatePicker2 = _interopRequireDefault(_TemplatePicker);
	
	var _WidgetHeaderPicker = __webpack_require__(1160);
	
	var _WidgetHeaderPicker2 = _interopRequireDefault(_WidgetHeaderPicker);
	
	var _MoreButtonPicker = __webpack_require__(1161);
	
	var _MoreButtonPicker2 = _interopRequireDefault(_MoreButtonPicker);
	
	var _TextFieldPicker = __webpack_require__(1162);
	
	var _TextFieldPicker2 = _interopRequireDefault(_TextFieldPicker);
	
	var _TextAreaPicker = __webpack_require__(1163);
	
	var _TextAreaPicker2 = _interopRequireDefault(_TextAreaPicker);
	
	var _SelectPicker = __webpack_require__(1164);
	
	var _SelectPicker2 = _interopRequireDefault(_SelectPicker);
	
	var _PlayerPicker = __webpack_require__(1165);
	
	var _PlayerPicker2 = _interopRequireDefault(_PlayerPicker);
	
	var _EnumPicker = __webpack_require__(1166);
	
	var _EnumPicker2 = _interopRequireDefault(_EnumPicker);
	
	var _PlayerComparisonPicker = __webpack_require__(1167);
	
	var _PlayerComparisonPicker2 = _interopRequireDefault(_PlayerComparisonPicker);
	
	var _PlayersComparisonPicker = __webpack_require__(1168);
	
	var _PlayersComparisonPicker2 = _interopRequireDefault(_PlayersComparisonPicker);
	
	var _TeamPlayerPicker = __webpack_require__(1169);
	
	var _TeamPlayerPicker2 = _interopRequireDefault(_TeamPlayerPicker);
	
	var _TournamentPickerMulti = __webpack_require__(1170);
	
	var _TournamentPickerMulti2 = _interopRequireDefault(_TournamentPickerMulti);
	
	var _LiveListTournamentsPicker = __webpack_require__(1171);
	
	var _LiveListTournamentsPicker2 = _interopRequireDefault(_LiveListTournamentsPicker);
	
	var _DatePicker = __webpack_require__(1172);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _TeamTournamentsPicker = __webpack_require__(1173);
	
	var _TeamTournamentsPicker2 = _interopRequireDefault(_TeamTournamentsPicker);
	
	var _StagePicker = __webpack_require__(1174);
	
	var _StagePicker2 = _interopRequireDefault(_StagePicker);
	
	var _StagePickerOneCheck = __webpack_require__(1175);
	
	var _StagePickerOneCheck2 = _interopRequireDefault(_StagePickerOneCheck);
	
	var _IncidentPicker = __webpack_require__(1176);
	
	var _IncidentPicker2 = _interopRequireDefault(_IncidentPicker);
	
	var _Slider = __webpack_require__(1177);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _PreviewImagePicker = __webpack_require__(1178);
	
	var _PreviewImagePicker2 = _interopRequireDefault(_PreviewImagePicker);
	
	var _TransferPicker = __webpack_require__(1185);
	
	var _TransferPicker2 = _interopRequireDefault(_TransferPicker);
	
	var _SportByDatePicker = __webpack_require__(1186);
	
	var _SportByDatePicker2 = _interopRequireDefault(_SportByDatePicker);
	
	var _F1GrandPrixPicker = __webpack_require__(1187);
	
	var _F1GrandPrixPicker2 = _interopRequireDefault(_F1GrandPrixPicker);
	
	var _OddsPicker = __webpack_require__(1188);
	
	var _OddsPicker2 = _interopRequireDefault(_OddsPicker);
	
	var _OddsProviderPicker = __webpack_require__(1189);
	
	var _OddsProviderPicker2 = _interopRequireDefault(_OddsProviderPicker);
	
	var _MultipleBackgroundsPicker = __webpack_require__(1190);
	
	var _MultipleBackgroundsPicker2 = _interopRequireDefault(_MultipleBackgroundsPicker);
	
	var _DNDBgrPicker = __webpack_require__(1193);
	
	var _DNDBgrPicker2 = _interopRequireDefault(_DNDBgrPicker);
	
	var _OverlayStyler = __webpack_require__(1194);
	
	var _OverlayStyler2 = _interopRequireDefault(_OverlayStyler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import EventPicker from './EventPicker';
	var pickers = {
	    team_picker: _TeamPicker2.default,
	    event_picker: _TextFieldPicker2.default,
	    event_by_team_picker: _EventByTeamPicker2.default,
	    event_by_date_picker: _EventByDatePicker2.default,
	    tournament_picker: _TournamentPicker2.default,
	    tournament_picker_multi: _TournamentPickerMulti2.default,
	    round_picker: _RoundPicker2.default,
	    boolean: _Switcher2.default,
	    checkboxes: _Checkboxes2.default,
	    textfield_picker: _TextFieldPicker2.default,
	    textarea_picker: _TextAreaPicker2.default,
	    more_button_picker: _MoreButtonPicker2.default,
	    select_picker: _SelectPicker2.default,
	    theme_picker: _ThemePicker2.default,
	    template_picker: _TemplatePicker2.default,
	    player_picker: _PlayerPicker2.default,
	    widget_header_picker: _WidgetHeaderPicker2.default,
	    enum_picker: _EnumPicker2.default,
	    player_comparison_picker: _PlayerComparisonPicker2.default,
	    players_comparison_picker: _PlayersComparisonPicker2.default,
	    team_player_picker: _TeamPlayerPicker2.default,
	    date_picker: _DatePicker2.default,
	    team_tournaments_picker: _TeamTournamentsPicker2.default,
	    stage_picker: _StagePickerOneCheck2.default,
	    stages_picker: _StagePicker2.default,
	    incident_picker: _IncidentPicker2.default,
	    overlay_styler: _OverlayStyler2.default,
	    live_list_tournaments_picker: _LiveListTournamentsPicker2.default,
	    slider: _Slider2.default,
	    preview_image: _PreviewImagePicker2.default,
	    transfer_picker: _TransferPicker2.default,
	    sport_by_date_picker: _SportByDatePicker2.default,
	    f1_grand_prix_picker: _F1GrandPrixPicker2.default,
	    odds_picker: _OddsPicker2.default,
	    odds_provider_picker: _OddsProviderPicker2.default,
	    multiple_backgrounds_picker: _MultipleBackgroundsPicker2.default,
	    dnd_bgr_picker: _DNDBgrPicker2.default
	};
	
	exports.default = pickers;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _navigationArrowDropRight = __webpack_require__(1134);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _EventByDatePicker = __webpack_require__(1135);
	
	var _EventByDatePicker2 = _interopRequireDefault(_EventByDatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventByTeamPicker = function (_React$Component) {
	    _inherits(EventByTeamPicker, _React$Component);
	
	    function EventByTeamPicker(props, context) {
	        _classCallCheck(this, EventByTeamPicker);
	
	        var _this = _possibleConstructorReturn(this, (EventByTeamPicker.__proto__ || Object.getPrototypeOf(EventByTeamPicker)).call(this, props, context));
	
	        _this.handleTeamChange = function (key, value) {
	            var teamId = value;
	            var limit = _this.props.limit;
	
	            var date = (0, _moment2.default)().format('YYYY-MM-DD');
	            _this.setState({ teamId: teamId });
	            _this.props.onChange('teamId', teamId);
	            return _bluebird2.default.props({
	                finished: fetch(_cfg2.default.apis.ss2 + '/events-v2?teamId=' + teamId + '&limit=' + limit + '&toDate=' + date + '&sortDirection=desc'),
	                upcoming: fetch(_cfg2.default.apis.ss2 + '/events-v2?teamId=' + teamId + '&limit=' + limit + '&fromDate=' + date)
	            }).then(function (result) {
	                return _bluebird2.default.props({
	                    finished: result.finished.status === 200 && result.finished.json(),
	                    upcoming: result.upcoming.status === 200 && result.upcoming.json()
	                });
	            }).then(function (res) {
	                _this.setState({
	                    events: [].concat(res.finished.events.reverse()).concat(res.upcoming.events),
	                    finished: res.finished.events,
	                    upcoming: res.upcoming.events
	                });
	            });
	        };
	
	        _this.handleEventChange = function (e, key, val) {
	            if (val == -1) {
	                _this.setState({ eventPicker: true });
	            } else {
	                _this.setState({ eventId: val }, function () {
	                    _this.props.onChange('eventId', val);
	                });
	            }
	        };
	
	        _this.state = {
	            teamId: +props.teamId,
	            eventId: +props.eventId,
	            events: [],
	            finished: [],
	            upcoming: [],
	            eventPicker: false
	        };
	        return _this;
	    }
	
	    _createClass(EventByTeamPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleTeamChange(null, this.state.teamId);
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(e) {
	            // var text = `${moment(e.startDate).utc().format('DD.MM')} ${e.homeShortName}-${e.awayShortName}`;
	            var text = (0, _moment2.default)(e.startDate).utc().format('DD MMM') + ' ' + e.homeName + ' - ' + e.awayName;
	            var secondaryText = null;
	            if (e.statusType === 'finished') {
	                secondaryText = e.score.home + '-' + e.score.away;
	            }
	            return _react2.default.createElement(rmd.MenuItem, {
	                style: { minWidth: '500px' },
	                key: e.eventId,
	                value: e.eventId,
	                primaryText: text,
	                secondaryText: secondaryText
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var eventsOptions = this.state.events;
	            var _state = this.state,
	                finished = _state.finished,
	                upcoming = _state.upcoming,
	                eventPicker = _state.eventPicker,
	                eventId = _state.eventId;
	
	
	            var customSelection = eventId && !_.find(eventsOptions, function (e) {
	                return e.eventId == eventId;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TeamPicker2.default, { onChange: this.handleTeamChange, teamId: this.state.teamId }),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Events'
	                        //value={this.state.eventId}
	                        , disabled: !this.state.teamId,
	                        autoWidth: true,
	                        style: { overflow: 'hidden', width: '100%' },
	                        value: this.state.eventId,
	                        onChange: this.handleEventChange
	                    },
	                    finished.map(this.renderOption),
	                    _react2.default.createElement(rmd.Divider, { key: '1' }),
	                    upcoming.map(this.renderOption),
	                    _react2.default.createElement(rmd.Divider, { key: '2' }),
	                    _react2.default.createElement(rmd.MenuItem, { key: '3', value: -1, primaryText: 'Search event', rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null) }),
	                    customSelection && _react2.default.createElement(rmd.Divider, { key: '4' }),
	                    customSelection && _react2.default.createElement(rmd.MenuItem, { key: 'custom', value: eventId, primaryText: 'Custom event', secondaryText: eventId })
	                ),
	                _react2.default.createElement(
	                    rmd.Dialog,
	                    {
	                        open: eventPicker,
	                        onRequestClose: function onRequestClose() {
	                            return _this2.setState({ eventPicker: false });
	                        },
	                        modal: false
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'preview' },
	                        _react2.default.createElement(_EventByDatePicker2.default, {
	                            style: { minWidth: '500px' },
	                            onChange: function onChange(key, val) {
	                                if (key == 'eventId') {
	                                    _this2.setState({ eventPicker: false, eventId: val }, function () {
	                                        _this2.props.onChange && _this2.props.onChange('eventId', val);
	                                    });
	                                }
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EventByTeamPicker;
	}(_react2.default.Component);
	
	EventByTeamPicker.defaultProps = {
	    limit: 10
	};
	exports.default = EventByTeamPicker;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _AutoComplete = __webpack_require__(789);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamPicker = function (_React$Component) {
	    _inherits(TeamPicker, _React$Component);
	
	    function TeamPicker(props) {
	        _classCallCheck(this, TeamPicker);
	
	        var _this = _possibleConstructorReturn(this, (TeamPicker.__proto__ || Object.getPrototypeOf(TeamPicker)).call(this, props));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.tournamentId !== _this.props.tournamentId) {
	                _this.loadTeams();
	            }
	            if (nextProps.teamId !== _this.props.teamId) {
	                _this.setState({ teamId: nextProps.teamId }, function () {
	                    _this.loadTeams();
	                });
	            }
	            if (nextProps.resetPicker === true) {
	                _this.handleReset();
	            }
	        };
	
	        _this.handleTeamChange = function (srting, index) {
	            var team = _this.state.teams[index];
	            //const { keyProperty } = this.state;
	
	            if (team) {
	                _this.props.onChange(_this.state.keyProperty, team.id);
	                //this.props.onChange({ [keyProperty]: team.id, [team.id]: team.name });
	            } else {
	                _this.props.onChange(_this.state.keyProperty, null);
	            }
	        };
	
	        _this.handleUpdateInput = function (searchText) {
	            _this.setState({ searchText: searchText });
	        };
	
	        _this.handleOnClose = function () {
	            var ac = _this.autoComplete.current;
	
	            if (ac.state.searchText === '') {
	                _this.props.onChange(_this.state.keyProperty, null);
	            }
	        };
	
	        _this.handleReset = function () {
	            _this.setState({
	                searchText: '',
	                teamId: null
	            });
	        };
	
	        var keyProperty = _this.getPropertyFor(props.customKey ? props.propKey : 'teamId');
	
	        _this.state = {
	            keyProperty: keyProperty,
	            teams: [],
	            searchText: '',
	            teamId: props[keyProperty] && +props[keyProperty]
	        };
	
	        _this.autoComplete = { current: {} };
	
	        _this.setAutoCompleteRef = function (element) {
	            _this.autoComplete.current = element;
	        };
	        return _this;
	    }
	
	    _createClass(TeamPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadTeams();
	        }
	    }, {
	        key: 'getPropertyFor',
	        value: function getPropertyFor(key) {
	            return (0, _get2.default)(this, 'props.propsMap[' + key + ']', key);
	        }
	    }, {
	        key: 'loadTeams',
	        value: function loadTeams() {
	            var _this2 = this;
	
	            var tournamentId = this.props.tournamentId;
	            var teamId = this.state.teamId;
	
	            var searchText = this.state.searchText;
	
	            return fetch(_cfg2.default.apis.ss2 + '/teams').then(function (response) {
	                return response.json();
	            }).then(function (teams) {
	                var team = teams.find(function (t) {
	                    return t.id === teamId;
	                });
	
	                if (team) {
	                    searchText = team.name;
	                }
	
	                if (tournamentId) {
	                    teams = teams.filter(function (t) {
	                        return t.tournamentTemplateId.includes(tournamentId);
	                    });
	                }
	
	                _this2.setState({
	                    teams: teams,
	                    searchText: searchText
	                });
	            }).catch(function (e) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_AutoComplete2.default, {
	                ref: this.setAutoCompleteRef,
	                hintText: 'Start typing team name',
	                dataSource: this.state.teams,
	                dataSourceConfig: { text: 'name', value: 'id' },
	                onNewRequest: this.handleTeamChange,
	                searchText: this.state.searchText,
	                onUpdateInput: this.handleUpdateInput,
	                onClose: this.handleOnClose,
	                floatingLabelText: this.props.label || 'Team',
	                maxSearchResults: 50,
	                value: this.state.teamId,
	                openOnFocus: this.state.teams.length < 30,
	                filter: _AutoComplete2.default.fuzzyFilter,
	                fullWidth: true,
	                menuStyle: { maxHeight: '500px', overflow: 'scroll' }
	            });
	        }
	    }]);
	
	    return TeamPicker;
	}(_react2.default.Component);
	
	TeamPicker.defaultProps = {
	    sportId: 1,
	    resetPicker: false
	};
	
	TeamPicker.propTypes = {
	    sportId: _propTypes2.default.number,
	    label: _propTypes2.default.string,
	    customKey: _propTypes2.default.string,
	    propKey: _propTypes2.default.string,
	    teamId: _propTypes2.default.number,
	    tournamentId: _propTypes2.default.number,
	    resetPicker: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = TeamPicker;

/***/ },
/* 1134 */,
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOURNAMENTS = [46, 85, 239, 47, 87, 54, 55, 42, 73, 57, 53, 71, 61, 67, 59, 135, 77, 50, 48, 108, 109, 146];
	
	var getInitialDate = function getInitialDate(date, eventId) {
	    if (eventId) {
	        return date ? new Date(date) : null;
	    }
	    return date ? new Date(date) : new Date();
	};
	
	var EventByDatePicker = function (_React$Component) {
	    _inherits(EventByDatePicker, _React$Component);
	
	    function EventByDatePicker(props, context) {
	        _classCallCheck(this, EventByDatePicker);
	
	        var _this = _possibleConstructorReturn(this, (EventByDatePicker.__proto__ || Object.getPrototypeOf(EventByDatePicker)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var date = props.date,
	            eventId = props.eventId;
	
	        _this.state = {
	            date: getInitialDate(date, eventId),
	            eventId: eventId ? Number(eventId) : null,
	            events: []
	        };
	        return _this;
	    }
	
	    _createClass(EventByDatePicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var eventId = this.props.eventId;
	
	            if (eventId) {
	                _superagent2.default.get(_cfg2.default.apis.ss2 + '/events/' + eventId).then(function (res) {
	                    if (res.body) {
	                        if (_this2.props.eventId === eventId) {
	                            var startDate = res.body.startDate;
	
	                            _this2.handleDateChange(null, new Date(startDate), true);
	                        }
	                    }
	                });
	            }
	            if (this.state.date) {
	                this.handleDateChange(null, this.state.date);
	            }
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(e) {
	            // const text = `${moment(e.startDate).utc().format('DD.MM')} ${e.homeShortName}-${e.awayShortName}`;
	            var text = (0, _moment2.default)(e.startDate).utc().format('HH:mm') + ' ' + e.homeName + ' - ' + e.awayName;
	            var secondaryText = e.statusType === 'finished' ? e.score.home + '-' + e.score.away : null;
	            return _react2.default.createElement(_materialUi.MenuItem, {
	                style: { minWidth: '400px' },
	                key: e.eventId,
	                value: e.eventId,
	                primaryText: text,
	                secondaryText: secondaryText
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var eventsOptions = this.state.events;
	            var options = _lodash2.default.toPairs(_lodash2.default.groupBy(eventsOptions, function (event) {
	                return event.tournamentName;
	            }));
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_materialUi.DatePicker, {
	                    hintText: 'Choose date',
	                    style: { overflow: 'hidden', width: '100%' },
	                    value: this.state.date,
	                    container: 'dialog',
	                    autoOk: true,
	                    onChange: this.handleDateChange
	                }),
	                _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        autoWidth: true,
	                        floatingLabelText: 'Events',
	                        style: { overflow: 'hidden', width: '100%' },
	                        value: this.state.eventId,
	                        disabled: !this.state.date,
	                        onChange: this.handleEventChange
	                    },
	                    options.map(function (pair) {
	                        return [_react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    padding: '5px 24px',
	                                    fontSize: '12px',
	                                    backgroundColor: '#eaeaea'
	                                },
	                                key: pair[0]
	                            },
	                            pair[0]
	                        ), pair[1].map(_this3.renderOption)];
	                    })
	                )
	            );
	        }
	    }]);
	
	    return EventByDatePicker;
	}(_react2.default.Component);
	
	EventByDatePicker.propTypes = {
	    eventId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    onChange: _propTypes2.default.func.isRequired,
	    date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	EventByDatePicker.defaultProps = {
	    sportId: 1
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.handleDateChange = function (_, value) {
	        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var date = (0, _moment2.default)(value);
	        var from = date.format('YYYY-MM-DD');
	        var to = date.add(1, 'day').format('YYYY-MM-DD');
	        var sportId = _this4.props.sportId;
	
	        _this4.setState({ date: value });
	        if (!silent) {
	            _this4.props.onChange('date', from);
	        }
	        var baseUrl = _cfg2.default.apis.ss2 + '/events-v2?fromDate=' + from + '&toDate=' + to + '&sportId=' + sportId;
	        var url = TOURNAMENTS.reduce(function (sum, val) {
	            return sum + '&ttId[]=' + val;
	        }, baseUrl);
	        return _superagent2.default.get(url).then(function (res) {
	            _this4.setState({ events: res.body.events });
	        });
	    };
	
	    this.handleEventChange = function (e, key, val) {
	        _this4.setState({ eventId: val }, function () {
	            _this4.props.onChange('eventId', val);
	        });
	    };
	};
	
	exports.default = EventByDatePicker;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _reactSelect = __webpack_require__(1141);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentPicker = function (_Component) {
	    _inherits(TournamentPicker, _Component);
	
	    function TournamentPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TournamentPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TournamentPicker.__proto__ || Object.getPrototypeOf(TournamentPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            countryId: null,
	            countries: [],
	            tournament: {},
	            tournaments: [],
	            tournamentIds: '',
	            tournamentId: _this.props.tournamentId && +_this.props.tournamentId,
	            seasonId: +_this.props.seasonId || null
	        }, _this.componentWillReceiveProps = function (nextProps) {
	            //console.log('CWRP', nextProps.tournamentId, this.props.tournamentId, isNaN(nextProps.tournamentId));
	
	            if (nextProps.tournamentId && !isNaN(nextProps.tournamentId) && nextProps.tournamentId != _this.props.tournamentId) {
	                _this.setState({
	                    seasonId: +nextProps.seasonId || null,
	                    tournamentId: +nextProps.tournamentId
	                }, function () {
	                    if (_this.state.tournamentId) _this.loadTournaments();
	                });
	            }
	
	            // if (nextProps.resetPicker === true) {
	            //     this.handleResetSelection();
	            // }
	        }, _this.handleCountryChange = function (e, key, payload) {
	            _this.props.onChange({ tournamentId: null, seasonId: null });
	            //console.log('handleCountryChange ');
	            _this.setState({ countryId: payload, tournament: null, tournamentId: null, seasonId: null }, function () {
	                //console.log('handleCountryChange ');
	                _this.loadSeasonsForTournament();
	            });
	
	            if (_this.props.onCountryChange) {
	                _this.props.onCountryChange({ tournament: null, seasonId: null });
	            }
	        }, _this.handleTournamentChange = function (e, key, payload) {
	            _this.setState({ tournamentId: payload, seasonId: null }, function () {
	                _this.props.onChange({ tournamentId: payload, seasonId: null });
	                _this.loadSeasonsForTournament();
	            });
	        }, _this.handleMultiTournamentChange = function (payload) {
	            var tournamentIds = payload.map(function (t) {
	                return t.value;
	            });
	            _this.setState({ tournamentIds: tournamentIds }, function () {
	                _this.props.onChange({ tournamentIds: tournamentIds });
	            });
	        }, _this.handleSeasonChange = function (e, key, seasonId) {
	            var tournamentId = _this.state.tournamentId;
	
	            _this.props.onChange({ tournamentId: tournamentId, seasonId: seasonId });
	            _this.setState({ seasonId: seasonId });
	        }, _this.handleResetSelection = function () {
	            _this.setState({ countryId: null, tournament: null, tournamentId: null, seasonId: null }, function () {
	                _this.props.onChange({ tournamentId: null, seasonId: null });
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TournamentPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.loadTournaments().then(function (t) {
	                if (_this2.state.tournamentId) _this2.loadSeasonsForTournament();
	            });
	        }
	    }, {
	        key: 'loadTournaments',
	        value: function loadTournaments() {
	            var _this3 = this;
	
	            var _props = this.props,
	                sportId = _props.sportId,
	                pro = _props.pro,
	                onChange = _props.onChange;
	            var _state = this.state,
	                tournamentId = _state.tournamentId,
	                countryId = _state.countryId;
	
	
	            return fetch(_cfg2.default.apis.ss2 + '/tournaments?sportId=' + sportId).then(function (response) {
	                return response.json();
	            }).then(function (tournaments) {
	                return tournaments.filter(function (t) {
	                    return t.gender === 'male';
	                });
	            }).then(function (tournaments) {
	                if (pro) tournaments = _lodash2.default.filter(tournaments, function (t) {
	                    return _RCore2.default.proTournaments.indexOf(t.id) !== -1;
	                });
	
	                var countries = _lodash2.default.chain(tournaments).map(function (t) {
	                    return _lodash2.default.pick(t, 'countryId', 'countryName');
	                }).uniqBy('countryId').value();
	
	                if (tournamentId && !countryId) {
	                    // restore countryId from tournamentId
	                    var t = _lodash2.default.find(tournaments, function (t) {
	                        return t.id === tournamentId;
	                    });
	
	                    if (t) countryId = t.countryId;else {
	                        countryId = null;
	                        tournamentId = null;
	                    }
	                }
	                _this3.setState({ tournaments: tournaments, countries: countries, countryId: countryId, tournamentId: tournamentId }, function () {
	                    _this3.loadSeasonsForTournament();
	                    onChange({ tournamentId: tournamentId });
	                });
	            }).catch(function (e) {
	                _this3.setState({ tournaments: [], countries: [], countryId: null });
	            });
	        }
	    }, {
	        key: 'loadSeasonsForTournament',
	        value: function loadSeasonsForTournament() {
	            var _this4 = this;
	
	            var pro = this.props.pro;
	
	            if (!this.state.tournamentId) return;
	
	            return fetch(_cfg2.default.apis.ss2 + '/tournaments/' + this.state.tournamentId).then(function (response) {
	                return response.json();
	            }).then(function (tournament) {
	                if (pro) tournament.seasons = _lodash2.default.filter(tournament.seasons, function (ts) {
	                    return _RCore2.default.proSeasons.indexOf(ts.id) !== -1;
	                });
	
	                _this4.setState({ tournament: tournament });
	            }).catch(function (e) {
	                _this4.setState({ tournament: {} });
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(_MenuItem2.default, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state2 = this.state,
	                tournamentIds = _state2.tournamentIds,
	                tournamentId = _state2.tournamentId,
	                seasonId = _state2.seasonId,
	                countryId = _state2.countryId,
	                _state2$tournaments = _state2.tournaments,
	                tournaments = _state2$tournaments === undefined ? [] : _state2$tournaments,
	                _state2$countries = _state2.countries,
	                countries = _state2$countries === undefined ? [] : _state2$countries;
	            var _props2 = this.props,
	                allowReset = _props2.allowReset,
	                multi = _props2.multi,
	                hideSeasonPicker = _props2.hideSeasonPicker,
	                _props2$styleWrapper = _props2.styleWrapper,
	                styleWrapper = _props2$styleWrapper === undefined ? {} : _props2$styleWrapper;
	
	            var tournament = this.state.tournament || {};
	
	            var tournamentsOptions = _lodash2.default.chain(tournaments).filter(function (t) {
	                return t.countryId === countryId;
	            }).orderBy(function (t) {
	                return t.isTop ? 0 : 10;
	            }).map(function (t) {
	                if (multi) return { label: t.name, value: t.id };
	                return { text: t.name, value: t.id };
	            }).value();
	
	            var countriesOptions = countries.map(function (c) {
	                return { text: c.countryName, value: c.countryId };
	            });
	            var seasonOptions = _lodash2.default.chain(tournament.seasons || []).orderBy(['year'], ['desc']).map(function (c) {
	                return { text: c.year, value: +c.id };
	            }).value();
	            var seasonPickerAvailable = tournamentId && seasonOptions.length > 0;
	            // var currentSeasonYear = tournament && tournament.currentSeason && tournament.currentSeason.year;
	
	            var currentSeason = seasonOptions && seasonOptions[0] && seasonOptions[0].value;
	
	            return _react2.default.createElement(
	                'div',
	                { style: styleWrapper },
	                _react2.default.createElement(
	                    _SelectField2.default,
	                    { floatingLabelText: 'Country', value: countryId, onChange: this.handleCountryChange },
	                    countriesOptions.map(this.renderOption)
	                ),
	                !multi && _react2.default.createElement(
	                    _SelectField2.default,
	                    {
	                        floatingLabelText: 'Tournament',
	                        value: tournamentId,
	                        disabled: !countryId,
	                        onChange: this.handleTournamentChange
	                    },
	                    tournamentsOptions.map(this.renderOption)
	                ),
	                multi && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-tournament-multi-picker' },
	                    _react2.default.createElement(_reactSelect2.default, {
	                        value: tournamentIds,
	                        multi: true,
	                        options: tournamentsOptions,
	                        search: true,
	                        placeholder: 'Select leagues',
	                        onChange: this.handleMultiTournamentChange
	                    })
	                ),
	                !(hideSeasonPicker || multi) && _react2.default.createElement(
	                    _SelectField2.default,
	                    {
	                        floatingLabelText: 'Season',
	                        value: seasonId || currentSeason,
	                        disabled: !seasonPickerAvailable,
	                        floatingLabelFixed: !!seasonPickerAvailable,
	                        onChange: this.handleSeasonChange
	                    },
	                    seasonOptions.map(this.renderOption)
	                ),
	                allowReset && _react2.default.createElement(_FlatButton2.default, { onClick: this.handleResetSelection, label: 'Reset tournament selection' })
	            );
	        }
	    }]);
	
	    return TournamentPicker;
	}(_react.Component);
	
	TournamentPicker.defaultProps = {
	    sportId: 1,
	    pro: false,
	    multi: false,
	    allowReset: false,
	    resetPicker: false,
	    hideSeasonPicker: false,
	    styleWrapper: {}
	};
	
	TournamentPicker.propTypes = {
	    sportId: _propTypes2.default.number,
	    pro: _propTypes2.default.bool,
	    multi: _propTypes2.default.bool,
	    allowReset: _propTypes2.default.bool,
	    resetPicker: _propTypes2.default.bool,
	    hideSeasonPicker: _propTypes2.default.bool,
	    seasonId: _propTypes2.default.number,
	    tournamentId: _propTypes2.default.number,
	    styleWrapper: _propTypes2.default.object,
	    onCountryChange: _propTypes2.default.func,
	    onChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = TournamentPicker;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RCore = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ScreenSizeObserver = __webpack_require__(1138);
	
	var _ScreenSizeObserver2 = _interopRequireDefault(_ScreenSizeObserver);
	
	var _Deeplinker = __webpack_require__(1139);
	
	var _Deeplinker2 = _interopRequireDefault(_Deeplinker);
	
	var _ImageUrlHelper = __webpack_require__(1140);
	
	var _ImageUrlHelper2 = _interopRequireDefault(_ImageUrlHelper);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var proTournaments = [46];
	var proSeasons = [11488, 10392, 9524];
	
	var proSeasonsInfo = [{
	    name: '2017/2018',
	    id: 11488
	}, {
	    name: '2016/2017',
	    id: 10392
	}, {
	    name: '2015/2016',
	    id: 9524
	}];
	
	var PromiseProps = function PromiseProps(obj) {
	    var awaitables = [];
	    var keys = Object.keys(obj);
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var a = obj[key];
	        awaitables.push(a);
	    }
	
	    return Promise.all(awaitables).then(function (results) {
	        var byName = {};
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            byName[key] = results[i];
	        }
	        return byName;
	    });
	};
	
	var promiseProps = PromiseProps;
	
	var standardError = function standardError(code, message) {
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return promiseProps({
	        __status: _extends({}, data, {
	            error: true,
	            message: message,
	            code: code
	        })
	    });
	};
	
	var i18Register = function i18Register(val, def) {
	    if (_lodash2.default.isEmpty(val)) val = { en: {}, no: {}, da: {} };
	    _lodash2.default.keys(val).forEach(function (lang) {
	        val[lang] = _lodash2.default.merge({}, {}, def && def[lang], val[lang]);
	    });
	
	    return val;
	};
	
	// import tournamentsTranslations from '../../helpers/i18.tournaments';
	
	var getLangFromContext = function getLangFromContext() {
	    if (!_lodash2.default.get(this, 'context.info')) {}
	    var lang = _lodash2.default.get(this, 'context.info.lang') || 'en';
	    return lang;
	};
	
	var getTranslation = function getTranslation(key) {
	    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var i18Dict = i18Register(this.dict || {});
	
	    var translation = _lodash2.default.get(i18Dict, lang + '[\'' + key + '\']', '');
	
	    //if no translation found for specified language, get english version
	    if (!translation) translation = _lodash2.default.get(i18Dict, 'en.[\'' + key + '\']', '');
	
	    //if no english version found, return untranslated lang-key value
	    if (!translation) translation = '$' + lang + '.' + key;
	    if (translation === ' ') return '';
	    if (translation === '<empty>') return '';
	    return translation;
	};
	
	var i18 = function i18(key) {
	    for (var _len = arguments.length, vals = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        vals[_key - 1] = arguments[_key];
	    }
	
	    if (!key) return '';
	    if (!this.context || !this.context.info) return void 0;
	    var dict = _lodash2.default.merge({}, this.i18CommonDict, this.i18dict);
	
	    if (_lodash2.default.isEmpty(dict)) return void 0;
	
	    var lang = this.context.info.lang || 'en';
	
	    var label = '';
	    if (dict[lang] && dict[lang][key]) {
	        label = dict[lang][key];
	    } else {
	        if (typeof window !== 'undefined') {
	            window.rlzI18 = window.rlzI18 || {};
	            var val = key;
	            window.rlzI18[key] = val;
	        }
	        // label = `$${lang}.${key}`;
	
	        if (dict['en'] && dict['en'][key]) {
	            label = dict['en'][key];
	        } else {
	            label = '$' + lang + '.' + key;
	        }
	    }
	    vals = vals || [];
	    vals.forEach(function (val, i) {
	        if (!val && val !== 0) return;
	        if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	            Object.keys(val).forEach(function (valKey) {
	                var v = val[valKey];
	                label = label.replace('{' + valKey + '}', !_lodash2.default.isUndefined(val) && !_lodash2.default.isNull(val) ? v : '');
	            });
	        } else {
	            label = label.replace('{' + i + '}', !_lodash2.default.isUndefined(val) && !_lodash2.default.isNull(val) ? val : '');
	        }
	    });
	
	    if (label === ' ') return '';
	    if (label === '<empty>') return '';
	    return label;
	    // return template (vals);
	};
	
	var playerShortName = function playerShortName(name) {
	    if (!name) return;
	    var chunks = name.split(' ');
	    if (chunks.length === 1) return name;
	    var shortName = '';
	    for (var i = 0; i < chunks.length - 1; i++) {
	        var chunk = chunks[i];
	        shortName += chunk[0] + '. ';
	    }
	    shortName += chunks[chunks.length - 1];
	    return shortName;
	};
	
	var channelsImages = {
	    'TV3 Sport': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
	    'TV3 Sport 1': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
	    'TV3 Sport 2': 'http://cdn.tjekscores.dk/tv/tv3sport.png',
	    'TV3 Max': 'http://cdn.tjekscores.dk/tv/tv3max.png',
	    'TV3+': 'http://cdn.tjekscores.dk/tv/tv3plus.png',
	    'Canal 9': 'http://cdn.tjekscores.dk/tv/canal9.png',
	    'EuroSport DK': 'http://spdk.tjekscores.dk/images/spdk/channels/TV_eurosport.png',
	    'EuroSport 2': 'http://spdk.tjekscores.dk/images/spdk/channels/TV_eurosport.png',
	    'Viasat Extra': 'http://cdn.tjekscores.dk/tv/viasat_extra.png'
	};
	
	var tvChannelToImg = function tvChannelToImg(name) {
	    if (channelsImages[name]) return channelsImages[name] + '?a=1';
	};
	
	var isProStatsDataAvailable = function isProStatsDataAvailable(tournamentId, seasonId) {
	    var tournamentOk = proTournaments.indexOf(tournamentId) !== -1;
	    if (!seasonId) return tournamentOk;
	    return tournamentOk && proSeasons.indexOf(seasonId) !== -1;
	};
	
	var hasCDNPlayerLogos = function hasCDNPlayerLogos(seasonId) {
	    var client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'core';
	
	    if (client === 'tv2no') return [11522].indexOf(seasonId) !== -1;
	    return [12725, 11488, 10392, 9524, 9731, 9730, 'current'].indexOf(seasonId) !== -1;
	};
	
	var hasCDNClubLogos = function hasCDNClubLogos(tournamentId) {
	    return [46, 47, 54, 55, 57, 59, 67, 87, 42].indexOf(tournamentId) !== -1;
	};
	
	var formatValue = function formatValue(val, key) {
	    if (!val) return '';
	    switch (key) {
	        case 'distanceData.topSpeed':
	        case 'maxStats.distanceData.topSpeed':
	            return val.toFixed(2);
	
	        case 'distanceData.distance':
	        case 'eventsStats.distanceData.distance':
	        case 'averageStats.distanceData.distance':
	            return val.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	        default:
	            return val.toFixed(0);
	    }
	};
	
	var getStatUnit = function getStatUnit(key) {
	    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    switch (key) {
	        case 'distanceData.topSpeed':
	        case 'maxStats.distanceData.topSpeed':
	            return 'km/h';
	        case 'distanceData.distance':
	        case 'averageStats.distanceData.distance':
	            return short ? 'meters.short' : 'short';
	        default:
	            return null;
	    }
	};
	
	var stylesObjectToString = function stylesObjectToString(stylesObject) {
	    return Object.entries(stylesObject).reduce(function (styleString, entry) {
	        return styleString + _lodash2.default.kebabCase(entry[0]) + ':' + entry[1] + ';';
	    }, '');
	};
	
	var getFirstLastName = function getFirstLastName() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (!name) return {};
	    var nameChunks = name.split(' ');
	    var lastName = _lodash2.default.last(nameChunks);
	    var firstName = _lodash2.default.take(nameChunks, nameChunks.length - 1).join(' ');
	    var firstNameChunks = firstName.split(' ');
	    var shortFirstName = firstNameChunks.map(function (n) {
	        return n.charAt(0).toUpperCase() + '.';
	    }).join(' ');
	    return {
	        lastName: lastName,
	        firstName: firstName,
	        shortFirstName: shortFirstName.length > 1 ? shortFirstName : ''
	    };
	};
	
	var prepareWidgetPropsObj = function prepareWidgetPropsObj(props) {
	    var converted = {};
	    Object.keys(props || {}).forEach(function (k) {
	        var v = props[k];
	
	        if (v === '' || v === null || v === 'undefined' || _lodash2.default.isUndefined(v)) return;
	        if (_lodash2.default.isObject(v)) {
	            converted[k] = JSON.stringify(v);
	        } else {
	            converted[k] = v;
	        }
	    });
	
	    return converted;
	};
	
	var obj2InjectorParams = function obj2InjectorParams(props) {
	    var converted = {};
	
	    Object.keys(props || {}).forEach(function (key) {
	        var wkey = 'data-' + _lodash2.default.kebabCase(key);
	        var value = props[key];
	        try {
	            // value = JSON.parse(value);
	        } catch (e) {
	            value = props[key];
	        }
	        converted[wkey] = value;
	    });
	
	    return converted;
	};
	
	var injectorParams2Obj = function injectorParams2Obj(props) {
	    var converted = {};
	    Object.keys(props || {}).forEach(function (key) {
	        var wkey = _lodash2.default.camelCase(key.replace('data-', ''));
	        var value = props[key];
	
	        try {
	            value = JSON.parse(value);
	        } catch (e) {
	            value = props[key];
	        }
	        wkey = wkey.replace('h2H', 'h2h');
	        converted[wkey] = value;
	    });
	    return converted;
	};
	
	var dataAttributesToObject = function dataAttributesToObject(attributes) {
	    return _lodash2.default.reduce(_lodash2.default.keys(attributes), function (result, attribute) {
	        var name = attribute.split('data-')[1] || attribute;
	        if (name.indexOf('-') !== -1) {
	            name = name.split('-').map(function (part, i) {
	                if (i === 0) return part;
	                return part.substr(0, 1).toUpperCase() + part.substr(1);
	            }).join('');
	        }
	        var value;
	        try {
	            value = JSON.parse(attributes[attribute]);
	        } catch (e) {
	            value = attributes[attribute];
	        }
	
	        //Checks if value either null or undefined (as undefined == null)
	        if (value == null) {
	            return result;
	        }
	        // dirty hot fix
	        name = name.replace('h2H', 'h2h');
	        result[name] = value;
	        return result;
	    }, {});
	};
	
	var sportToId = function sportToId(sport) {
	    if (sport === 'football' || sport === 'soccer') return 1;
	    if (sport === 'handball') return 20;
	    if (sport === 'basket' || sport === 'basketball') return 23;
	    if (sport === 'tennis') return 2;
	    if (sport === 'icehockey' || sport === 'hockey') return 5;
	    if (sport === 'f1' || sport === 'F1') return 99;
	    return 1;
	};
	
	var RCore = {
	    proTournaments: proTournaments,
	    proSeasons: proSeasons,
	    proSeasonsInfo: proSeasonsInfo,
	    obj2InjectorParams: obj2InjectorParams,
	    injectorParams2Obj: injectorParams2Obj,
	    standardError: standardError,
	    ScreenSizeObserver: _ScreenSizeObserver2.default,
	    Deeplinker: _Deeplinker2.default,
	    PromiseProps: PromiseProps,
	    promiseProps: PromiseProps,
	    i18: i18,
	    stylesObjectToString: stylesObjectToString,
	    playerShortName: playerShortName,
	    isProStatsDataAvailable: isProStatsDataAvailable,
	    hasCDNPlayerLogos: hasCDNPlayerLogos,
	    imageUrls: _ImageUrlHelper2.default,
	    formatValue: formatValue,
	    i18Register: i18Register,
	    getFirstLastName: getFirstLastName,
	    dataAttributesToObject: dataAttributesToObject,
	    sportToId: sportToId,
	    hasCDNClubLogos: hasCDNClubLogos,
	    getLangFromContext: getLangFromContext,
	    getTranslation: getTranslation,
	    getStatUnit: getStatUnit,
	    prepareWidgetPropsObj: prepareWidgetPropsObj,
	    channelsImages: channelsImages,
	    tvChannelToImg: tvChannelToImg,
	    nbsp: '\xA0'
	};
	
	exports.default = RCore;
	exports.RCore = RCore;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Theme stores the state of the current theme, and allows components to subscribe to future changes
	function between(w, min, max) {
	    return w >= min && w <= max;
	}
	var C_SCREEN_XS_CLASS = 'wdp-widget-xs';
	var C_SCREEN_SM_CLASS = 'wdp-widget-sm';
	var C_SCREEN_MD_CLASS = 'wdp-widget-md';
	var C_SCREEN_LG_CLASS = 'wdp-widget-lg';
	
	var C_SCREEN_XS = 420;
	var C_SCREEN_SM = 768;
	var C_SCREEN_MD = 992;
	
	function detectScreenSize(width, cfg) {
	    width = width || cfg.xs;
	
	    if (between(width, 0, cfg.xs - 1)) return C_SCREEN_XS_CLASS;
	    if (between(width, cfg.xs, cfg.sm - 1)) return C_SCREEN_SM_CLASS;
	    if (between(width, cfg.sm, cfg.md - 1)) return C_SCREEN_MD_CLASS;
	    if (between(width, cfg.md, 100000)) return C_SCREEN_LG_CLASS;
	
	    return C_SCREEN_SM_CLASS;
	}
	
	var ScreenSizeObserver = function ScreenSizeObserver(px, cfg) {
	    this.updateCfg(cfg);
	
	    this.screenSize = detectScreenSize(px, this.cfg);
	    this.subscriptions = [];
	};
	
	ScreenSizeObserver.prototype.updateCfg = function (cfg) {
	    this.cfg = _lodash2.default.extend({
	        xs: C_SCREEN_XS,
	        sm: C_SCREEN_SM,
	        md: C_SCREEN_MD
	    }, cfg);
	};
	
	ScreenSizeObserver.prototype.isXS = function () {
	    return this.screenSize === C_SCREEN_XS_CLASS;
	};
	
	ScreenSizeObserver.prototype.isSM = function () {
	    return this.screenSize === C_SCREEN_SM_CLASS;
	};
	
	ScreenSizeObserver.prototype.isMD = function () {
	    return this.screenSize === C_SCREEN_MD_CLASS;
	};
	
	ScreenSizeObserver.prototype.isLG = function () {
	    return this.screenSize === C_SCREEN_LG_CLASS;
	};
	
	ScreenSizeObserver.prototype.getSS = function () {
	    return this.screenSize.slice(-2);
	};
	
	ScreenSizeObserver.prototype.getScreenSize = function () {
	    return this.screenSize;
	};
	
	ScreenSizeObserver.prototype.setScreenSize = function (screenSize) {
	    this.screenSize = screenSize;
	    this.subscriptions.forEach(function (f) {
	        return f();
	    });
	};
	
	ScreenSizeObserver.prototype.onUpdateWidth = function (x) {
	    this.setScreenSize(detectScreenSize(x, this.cfg));
	};
	
	ScreenSizeObserver.prototype.subscribe = function (f) {
	    this.subscriptions.push(f);
	};
	
	ScreenSizeObserver.prototype.unsubscribe = function (f) {
	    Reflect.deleteProperty(this.subscriptions, f);
	};
	
	module.exports = ScreenSizeObserver;

/***/ },
/* 1139 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var Deeplinker = function Deeplinker(serialized) {
	    this.links = {};
	    if (serialized) this.initWith(serialized);
	};
	
	Deeplinker.prototype.initWith = function (serialized) {
	    for (var i in serialized) {
	        if (serialized[i].indexOf('function') != -1) {
	            try {
	                var evalInContext = function evalInContext() {
	                    eval.bind(this)(dd);
	                    this.pFn = global[fn];
	                    delete global[fn];
	                };
	
	                /**
	                    this hell code is about to deserialize function passed as string (code as a string).
	                    cause eval() exposes function into global -> means for nodejs execution - complete disaster.
	                    Idea is to create random name function, take from global, delete from global
	                */
	                var ctx = {};
	                var fn = 'fn_' + Math.round(Math.random() * 1000000);
	                var dd = 'var ' + fn + ' = ' + serialized[i] + ';';
	
	                evalInContext.call(ctx);
	
	                this.links[i] = ctx.pFn;
	            } catch (e) {}
	        } else {
	            this.links[i] = serialized[i];
	        }
	    }
	};
	
	Deeplinker.prototype.register = function (action, url) {
	    if (typeof url == 'string' && url.indexOf('//') == -1) url = window.location.origin + url;
	    this.links[action] = url;
	};
	
	Deeplinker.prototype.resolve = function (action, params) {
	    var url = this.links[action];
	
	    if (typeof url === 'function') {
	        url = url(params);
	    }
	
	    if (url) {
	        for (var i in params) {
	            url = url.replace('${' + i + '}', encodeURIComponent(params[i]));
	        }
	    }
	
	    return url;
	};
	
	Deeplinker.prototype.serialize = function () {
	    var links = '';
	    for (var i in this.links) {
	        links += 'deeplinker[' + i + ']=' + encodeURIComponent(this.links[i].toString().replace(/\n/g, '')) + '&';
	    }
	    return links;
	};
	
	module.exports = Deeplinker;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getPlayerImg: function getPlayerImg(teamId, playerId) {
	        var seasonId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'current';
	
	        return this._getCDNPlayerUrl(teamId, playerId, 88, 88, 'png', seasonId);
	    },
	    getPlayerImgBig: function getPlayerImgBig(teamId, playerId) {
	        var seasonId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'current';
	
	        return this._getCDNPlayerUrl(teamId, playerId, 524, 584, 'png', seasonId);
	    },
	    getPlayerImgOriginal: function getPlayerImgOriginal(teamId, playerId) {
	        var seasonId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'current';
	
	        return this._getCDNPlayerUrl(teamId, playerId, null, null, 'png', seasonId);
	    },
	    getPlayerLargeImg: function getPlayerLargeImg(teamId, playerId) {
	        var seasonId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'current';
	
	        return this._getCDNPlayerUrl(teamId, playerId, 262, 292, 'png', seasonId);
	    },
	    getTeamImg: function getTeamImg(teamId, seasonId) {
	        seasonId = 11488;
	        return this._getCDNTeamUrl(teamId, 262, 262, 'png', seasonId);
	    },
	    getTeamLargeImg: function getTeamLargeImg(teamId, seasonId) {
	        seasonId = 11488;
	        return this._getCDNTeamUrl(teamId, 262, 262, 'png', seasonId);
	    },
	    getFlagImg: function getFlagImg(countryId) {
	        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 17;
	        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
	
	        return 'https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_flage_' + countryId + '.png&width-px=' + width + '&height-px=' + height;
	    },
	    _getCDNPlayerUrl: function _getCDNPlayerUrl(teamId, playerId, width, height, format, seasonId) {
	        var size = 'original';
	        if (width && height) size = width + 'x' + height;
	        return 'https://driu3sl4x7vty.cloudfront.net/wdp/' + seasonId + '/' + size + '/' + teamId + '/' + playerId + '.' + format;
	    },
	    _getCDNTeamUrl: function _getCDNTeamUrl(teamId, width, height, format, seasonId) {
	        return 'https://dxugi372p6nmc.cloudfront.net/spdk/' + seasonId + '/' + width + 'x' + height + '/' + teamId + '/teamlogo.' + format;
	    },
	    _getS3Url: function _getS3Url(teamId, playerId, width, height, format, seasonId) {
	        return 'https://s3-eu-west-1.amazonaws.com/sport.images/spdk/' + seasonId + '/' + width + 'x' + height + '/' + teamId + '/' + playerId + '.' + format;
	    },
	    getMatchPageHeaderImage: function getMatchPageHeaderImage(teamId, tournamentId, matchGallery, seasonId) {
	        seasonId = 10392;
	        if (tournamentId === 85 || tournamentId === 239) {
	            return matchGallery ? this.urls.assets('images/spdk/1-2-divisions/match_gallery_small.jpg') : this.urls.assets('images/spdk/1-2-divisions/match_header.jpg');
	        }
	        return 'https://d2r4jv2ozk6vji.cloudfront.net/spdk/' + seasonId + '/1920x500/' + teamId + '/home_match_image.jpg';
	    },
	    getLiveStatsBackgroundImage: function getLiveStatsBackgroundImage(teamId, seasonId) {
	        return 'https://dx7x1cuv1qubz.cloudfront.net/spdk/' + seasonId + '/1920x500/' + teamId + '/live_stats_center_background.jpg';
	    },
	    getHead2HeadImage: function getHead2HeadImage(teamId, seasonId) {
	        return 'https://d1x64qk0gqfk0t.cloudfront.net/spdk/' + seasonId + '/1920x500/' + teamId + '/head2head_image.jpg';
	    },
	    getTeamProfileImage: function getTeamProfileImage(teamId, seasonId) {
	        return 'https://s3-eu-west-1.amazonaws.com/spdk/' + seasonId + '/1920x500/' + teamId + '/team_profile.jpg';
	    },
	    getRandomBackground: function getRandomBackground() {
	        var n = Math.floor(Math.random() * 5) + 1;
	        return 'url(' + this.urls.assets('images/spdk/backgrounds/fun_bg' + n + '.jpg') + ')';
	    },
	    getTeamShirtImg: function getTeamShirtImg(teamId) {
	        return 'https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_' + teamId + '.png&width-px=40&height-px=40&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png';
	    }
	};

/***/ },
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switcher = function (_React$Component) {
	    _inherits(Switcher, _React$Component);
	
	    function Switcher(props, context) {
	        _classCallCheck(this, Switcher);
	
	        var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props, context));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var value = false;
	            try {
	                value = JSON.parse(nextProps.value);
	            } catch (e) {
	                value = false;
	            }
	            _this.setState({ value: value });
	        };
	
	        _this.onToggle = function () {
	            var value = !_this.state.value;
	            _this.setState({ value: value });
	            return _this.props.onChange(_this.props.propKey, value);
	        };
	
	        var val = false;
	        try {
	            val = JSON.parse(props.value || props[props.propKey] || false);
	        } catch (e) {
	            val = false;
	        }
	
	        _this.state = {
	            value: val
	        };
	        return _this;
	    }
	
	    _createClass(Switcher, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(rmd.Toggle, { label: this.props.label, toggled: this.state.value, onToggle: this.onToggle })
	            );
	        }
	    }]);
	
	    return Switcher;
	}(_react2.default.Component);
	
	exports.default = Switcher;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkboxes = function (_React$Component) {
	    _inherits(Checkboxes, _React$Component);
	
	    function Checkboxes(props, context) {
	        _classCallCheck(this, Checkboxes);
	
	        var _this = _possibleConstructorReturn(this, (Checkboxes.__proto__ || Object.getPrototypeOf(Checkboxes)).call(this, props, context));
	
	        _this.parseValue = function (value) {
	            if (!value && value !== 0) return [];
	            try {
	                // if array passed
	                // if (typeof value == 'string') throw new Error();
	                if (_this.props.output == 'csv') {
	                    value = value + '';
	                    value = _.compact((value || '').split(','));
	                } else {
	                    value = JSON.parse(value);
	                }
	            } catch (e) {
	                if (_this.props.output == 'csv') {
	                    value = _.compact((value || '').split(','));
	                }
	            }
	
	            return value || [];
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            _this.setState({ value: _this.parseValue(nextProps.value) });
	        };
	
	        _this.onCheck = function (key, isChecked) {
	            _this.setState({
	                value: isChecked ? [].concat(_toConsumableArray(_this.state.value), [String(key)]) : _this.state.value.filter(function (v) {
	                    return v !== String(key);
	                })
	            }, function () {
	                return _this.props.output === 'csv' ? _this.props.onChange(_this.props.propKey, _this.state.value.join(",")) : _this.props.onChange(_this.props.propKey, _this.state.value);
	            });
	        };
	
	        _this.state = { value: _this.parseValue(props.value), options: props.options };
	        return _this;
	    }
	
	    _createClass(Checkboxes, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var value = this.state.value;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    this.props.label
	                ),
	                this.state.options.map(function (o) {
	                    return _react2.default.createElement(rmd.Checkbox, {
	                        checked: value && !!value.find(function (v) {
	                            return v == o.key;
	                        }),
	                        label: o.label,
	                        key: o.key,
	                        onCheck: function onCheck(e, isChecked) {
	                            return _this2.onCheck(o.key, isChecked);
	                        }
	                    });
	                })
	            );
	        }
	    }]);
	
	    return Checkboxes;
	}(_react2.default.Component);
	
	exports.default = Checkboxes;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoundPicker = function (_React$Component) {
	    _inherits(RoundPicker, _React$Component);
	
	    function RoundPicker(props, context) {
	        _classCallCheck(this, RoundPicker);
	
	        var _this = _possibleConstructorReturn(this, (RoundPicker.__proto__ || Object.getPrototypeOf(RoundPicker)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var key = props.propKey || 'round';
	        var value = +props[key] || null;
	
	        _this.state = {
	            rounds: [],
	            tournamentId: props.tournamentId,
	            seasonId: props.seasonId,
	            round: value
	        };
	        return _this;
	    }
	
	    _createClass(RoundPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            // super.componentWillReceiveProps(nextProps)
	            var tournamentId = nextProps.tournamentId,
	                seasonId = nextProps.seasonId;
	
	            if (nextProps !== this.props.tournamentId || nextProps !== this.props.seasonId) {
	                this.setState({ tournamentId: tournamentId, seasonId: seasonId }, function () {
	                    _this2.loadData();
	                });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return true;
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this3 = this;
	
	            var _state = this.state,
	                tournamentId = _state.tournamentId,
	                seasonId = _state.seasonId;
	
	            if (!tournamentId) return;
	
	            return _bluebird2.default.props({
	                tournamentId: tournamentId,
	                seasonId: seasonId || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId).then(function (response) {
	                    return response.json();
	                }).then(function (t) {
	                    return t.currentSeason && t.currentSeason.id || _lodash2.default.last(t.seasons).id;
	                })
	            }).then(function (res) {
	                return fetch(_cfg2.default.apis.ss2 + '/tournaments/' + res.tournamentId + '/season?seasonId=' + res.seasonId).then(function (response) {
	                    return response.json();
	                }).then(function (s) {
	                    return s.season.stages[0].roundsList;
	                }).catch(function (e) {
	                    return [];
	                });
	            }).then(function (rounds) {
	                var state = { rounds: rounds };
	
	                // default value = max round
	                if (_this3.props.options && _this3.props.options.defaultMaxRound && !_this3.state.round) {
	                    var round = _lodash2.default.last(rounds).name;
	                    state.round = +round;
	                }
	                _this3.setState(state);
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var rounds = _lodash2.default.chain(this.state.rounds || []).map(function (c) {
	                return { text: 'Round ' + c.name, value: +c.name };
	            }).value();
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: this.props.label || 'Round',
	                        floatingLabelFixed: rounds.length > 0,
	                        value: this.state.round,
	                        disabled: rounds.length === 0,
	                        onChange: this.handleRoundChange
	                    },
	                    this.renderOption({ text: 'Current', value: null, key: 'current' }),
	                    rounds.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return RoundPicker;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.handleRoundChange = function (e, k, val) {
	        var key = _this4.props.propKey || 'round';
	        var round = +val;
	        _this4.props.onChange(key, round);
	        _this4.setState({ round: round });
	    };
	};
	
	exports.default = RoundPicker;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemePicker = function (_React$Component) {
	    _inherits(ThemePicker, _React$Component);
	
	    function ThemePicker(props, context) {
	        _classCallCheck(this, ThemePicker);
	
	        var _this = _possibleConstructorReturn(this, (ThemePicker.__proto__ || Object.getPrototypeOf(ThemePicker)).call(this, props, context));
	
	        _this.handleThemeChange = function (e, key, payload) {
	            _this.props.onChange('theme', payload);
	            _this.setState({ themeId: payload });
	        };
	
	        _this.state = {
	            themes: [],
	            themeId: props.theme || context.user.defaultTheme
	        };
	        return _this;
	    }
	
	    _createClass(ThemePicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadThemes();
	        }
	    }, {
	        key: 'loadThemes',
	        value: function loadThemes() {
	            var _this2 = this;
	
	            var themeId = this.state.themeId;
	            var user = this.context.user;
	
	
	            return fetch(_cfg2.default.dash.api.host + '/api/themes?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (themes) {
	                var theme = themes.find(function (t) {
	                    return t.id == themeId;
	                });
	
	                if (!theme) theme = _lodash2.default.first(themes);
	
	                _this2.setState({
	                    themes: themes,
	                    themeId: theme && theme.id
	                });
	            }).catch(function (e) {});
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, {
	                key: option.value,
	                value: option.value,
	                primaryText: option.text
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                themes = _state.themes,
	                themeId = _state.themeId;
	
	            themeId = themeId || (themes.find(function (t) {
	                return t.isDefault;
	            }) || {}).id;
	            var themesOptions = themes.filter(function (t) {
	                return !t.isHidden;
	            }).map(function (t) {
	                return { text: t.name, value: t.id };
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                !_lodash2.default.isEmpty(themesOptions) && _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        floatingLabelText: 'Theme',
	                        value: themeId,
	                        onChange: this.handleThemeChange },
	                    themesOptions.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return ThemePicker;
	}(_react2.default.Component);
	
	ThemePicker.defaultProps = {
	    sportId: 1
	};
	ThemePicker.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = ThemePicker;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplatePicker = function (_React$Component) {
	    _inherits(TemplatePicker, _React$Component);
	
	    function TemplatePicker(props, context) {
	        _classCallCheck(this, TemplatePicker);
	
	        var _this = _possibleConstructorReturn(this, (TemplatePicker.__proto__ || Object.getPrototypeOf(TemplatePicker)).call(this, props, context));
	
	        _this.handleThemeChange = function (e, key, payload) {
	            _this.props.onChange(_this.props.propKey, payload);
	            _this.setState({ templateId: payload });
	        };
	
	        _this.state = {
	            templates: [],
	            templateId: props[props.propKey] || context.user && context.user.defaultTemplate
	        };
	        return _this;
	    }
	
	    _createClass(TemplatePicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadTemplates();
	        }
	    }, {
	        key: 'loadTemplates',
	        value: function loadTemplates() {
	            var _this2 = this;
	
	            var templateId = this.state.templateId;
	            var user = this.context.user;
	
	
	            return fetch('/api/templates/list?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (templates) {
	                var template = templates.find(function (t) {
	                    return t.id === templateId;
	                });
	                if (!template) {
	                    template = _lodash2.default.first(templates);
	                    // fire selection
	                    // this.props.onChange(this.props.propKey, template.id);
	                    // console.log(this.props.propKey," - to - ", template.id)
	                }
	
	                _this2.setState({
	                    templates: templates,
	                    templateId: template.id
	                });
	            }).catch(function (e) {});
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                templates = _state.templates,
	                templateId = _state.templateId;
	
	            templateId = templateId || (templates.find(function (t) {
	                return t.isDefault;
	            }) || {}).id;
	            var themesOptions = _lodash2.default.filter(templates, function (t) {
	                return !t.isHidden;
	            }).map(function (t) {
	                return { text: t.name, value: t.id };
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                !_lodash2.default.isEmpty(themesOptions) && _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        floatingLabelText: 'Template Theme',
	                        value: templateId,
	                        onChange: this.handleThemeChange
	                    },
	                    themesOptions.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return TemplatePicker;
	}(_react2.default.Component);
	
	TemplatePicker.defaultProps = {
	    sportId: 1
	};
	TemplatePicker.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = TemplatePicker;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WHPicker = function (_React$Component) {
	    _inherits(WHPicker, _React$Component);
	
	    function WHPicker(props, context) {
	        _classCallCheck(this, WHPicker);
	
	        var _this = _possibleConstructorReturn(this, (WHPicker.__proto__ || Object.getPrototypeOf(WHPicker)).call(this, props, context));
	
	        _this.handleOnBlur = function (e) {
	            var _this$state = _this.state,
	                supressHeader = _this$state.supressHeader,
	                customTitle = _this$state.customTitle;
	
	
	            if (!supressHeader) {
	                _this.props.onChange('customTitle', customTitle);
	            } else {
	                _this.props.onChange('customTitle', null);
	            }
	        };
	
	        _this.onChange = function (e) {
	            _this.setState({ customTitle: e.target.value });
	        };
	
	        _this.handleSupressHeaderToggle = function (e, value) {
	            var _this$state2 = _this.state,
	                supressHeader = _this$state2.supressHeader,
	                customTitle = _this$state2.customTitle;
	
	
	            _this.setState({ supressHeader: !!value });
	
	            if (value) {
	                _this.props.onChange({ 'suppressHeader': true, 'customTitle': null });
	            } else {
	                _this.props.onChange({ 'suppressHeader': null, 'customTitle': _this.state.customTitle });
	            }
	        };
	
	        _this.state = {
	            supressHeader: props.suppressHeader == true,
	            customTitle: props.customTitle || ''
	        };
	        return _this;
	    }
	
	    _createClass(WHPicker, [{
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                supressHeader = _state.supressHeader,
	                label = _state.label,
	                url = _state.url;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(rmd.Toggle, {
	                    label: 'Suppress header',
	                    onToggle: this.handleSupressHeaderToggle,
	                    toggled: supressHeader }),
	                !supressHeader && _react2.default.createElement(rmd.TextField, {
	                    value: this.state.customTitle || "",
	                    onChange: this.onChange,
	                    onBlur: this.handleOnBlur,
	                    errorText: this.props.error,
	                    floatingLabelText: 'Override default title' })
	            );
	        }
	    }]);
	
	    return WHPicker;
	}(_react2.default.Component);
	
	exports.default = WHPicker;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MBPicker = function (_React$Component) {
	    _inherits(MBPicker, _React$Component);
	
	    function MBPicker(props, context) {
	        _classCallCheck(this, MBPicker);
	
	        var _this = _possibleConstructorReturn(this, (MBPicker.__proto__ || Object.getPrototypeOf(MBPicker)).call(this, props, context));
	
	        _this.onChange = function (key, e) {
	
	            _this.setState(_.fromPairs([[key, e.target.value]]));
	        };
	
	        _this.handleOnBlur = function (e) {
	            var _this$state = _this.state,
	                enabled = _this$state.enabled,
	                label = _this$state.label,
	                url = _this$state.url;
	
	            if (enabled && !_.isEmpty(label) && !_.isEmpty(url)) {
	                _this.props.onChange({ 'moreButtonUrl': url, 'moreButtonLabel': label });
	            }
	        };
	
	        _this.handleEnableToggle = function (e, value) {
	            _this.setState({ enabled: value });
	            if (!value) {
	                _this.props.onChange({ 'moreButtonUrl': null, 'moreButtonLabel': null });
	                _this.setState({ url: "", label: "" });
	            }
	        };
	
	        _this.state = {
	            enabled: !_.isEmpty(props.moreButtonUrl) && !_.isEmpty(props.moreButtonLabel),
	            label: props.moreButtonLabel || "",
	            url: props.moreButtonUrl || ""
	        };
	        return _this;
	    }
	
	    _createClass(MBPicker, [{
	        key: "render",
	        value: function render() {
	            var _state = this.state,
	                enabled = _state.enabled,
	                label = _state.label,
	                url = _state.url;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(rmd.Toggle, {
	                    label: "Display More Button",
	                    onToggle: this.handleEnableToggle,
	                    toggled: this.state.enabled }),
	                enabled && _react2.default.createElement(rmd.TextField, {
	                    value: label || "",
	                    onChange: this.onChange.bind(this, 'label'),
	                    onBlur: this.handleOnBlur,
	                    hintText: "Enter Label Text",
	                    floatingLabelText: "Label" }),
	                enabled && _react2.default.createElement(rmd.TextField, {
	                    value: url || "",
	                    onChange: this.onChange.bind(this, 'url'),
	                    onBlur: this.handleOnBlur,
	                    hintText: "http://",
	                    floatingLabelText: "Url" })
	            );
	        }
	    }]);
	
	    return MBPicker;
	}(_react2.default.Component);
	
	exports.default = MBPicker;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldPicker = function (_React$Component) {
	    _inherits(TextFieldPicker, _React$Component);
	
	    function TextFieldPicker(props, context) {
	        _classCallCheck(this, TextFieldPicker);
	
	        var _this = _possibleConstructorReturn(this, (TextFieldPicker.__proto__ || Object.getPrototypeOf(TextFieldPicker)).call(this, props, context));
	
	        _this.onChange = function (e) {
	            var value = e.target.value;
	            _this.setState({ value: value });
	        };
	
	        _this.handleOnBlur = function () {
	            _this.props.onChange(_this.props.propKey, _this.state.value);
	        };
	
	        _this.state = {
	            value: props[props.propKey] || ''
	        };
	        return _this;
	    }
	
	    _createClass(TextFieldPicker, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(rmd.TextField, {
	                value: this.state.value || '',
	                onChange: this.onChange,
	                onBlur: this.handleOnBlur,
	                errorText: this.props.error,
	                floatingLabelText: this.props.label || '' + this.props.propKey
	            });
	        }
	    }]);
	
	    return TextFieldPicker;
	}(_react2.default.Component);
	
	exports.default = TextFieldPicker;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextAreaPicker = function (_React$Component) {
	    _inherits(TextAreaPicker, _React$Component);
	
	    function TextAreaPicker(props, context) {
	        _classCallCheck(this, TextAreaPicker);
	
	        var _this = _possibleConstructorReturn(this, (TextAreaPicker.__proto__ || Object.getPrototypeOf(TextAreaPicker)).call(this, props, context));
	
	        _this.onChange = function (e) {
	            var value = e.target.value;
	            _this.setState({ value: value });
	        };
	
	        _this.handleOnBlur = function () {
	            _this.props.onChange(_this.props.propKey, _this.state.value);
	        };
	
	        _this.state = {
	            value: props[props.propKey] || ''
	        };
	        return _this;
	    }
	
	    _createClass(TextAreaPicker, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(rmd.TextField, {
	                value: this.state.value || '',
	                multiLine: true,
	                onChange: this.onChange,
	                onBlur: this.handleOnBlur,
	                errorText: this.props.error,
	                floatingLabelText: this.props.label || '' + this.props.propKey
	            });
	        }
	    }]);
	
	    return TextAreaPicker;
	}(_react2.default.Component);
	
	exports.default = TextAreaPicker;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectPicker = function (_React$Component) {
	    _inherits(SelectPicker, _React$Component);
	
	    function SelectPicker(props, context) {
	        _classCallCheck(this, SelectPicker);
	
	        var _this = _possibleConstructorReturn(this, (SelectPicker.__proto__ || Object.getPrototypeOf(SelectPicker)).call(this, props, context));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var value = null;
	            try {
	                value = JSON.parse(nextProps[nextProps.propKey]);
	            } catch (e) {
	                value = nextProps[nextProps.propKey] || null;
	            }
	            _this.setState({ value: value });
	        };
	
	        _this.handleChange = function (e, key, payload) {
	            _this.props.onChange(_this.props.propKey, payload);
	            _this.setState({ value: payload });
	        };
	
	        var initState = {};
	
	        try {
	            initState.value = JSON.parse(props[props.propKey]);
	        } catch (e) {
	            initState.value = props[props.propKey] || null;
	        }
	        _this.state = initState;
	        return _this;
	    }
	
	    _createClass(SelectPicker, [{
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        value: this.state.value,
	                        floatingLabelText: this.props.label,
	                        floatingLabelFixed: true,
	                        onChange: this.handleChange
	                    },
	                    this.props.options.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return SelectPicker;
	}(_react2.default.Component);
	
	SelectPicker.defaultProps = {
	    options: []
	};
	exports.default = SelectPicker;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];
	
	var PlayerPicker = function (_React$Component) {
	    _inherits(PlayerPicker, _React$Component);
	
	    function PlayerPicker(props, context) {
	        _classCallCheck(this, PlayerPicker);
	
	        var _this = _possibleConstructorReturn(this, (PlayerPicker.__proto__ || Object.getPrototypeOf(PlayerPicker)).call(this, props, context));
	
	        _this.handleTeamChange = function (key, value) {
	            var teamId = value;
	
	            if (!_lodash2.default.isInteger(teamId)) {
	                _this.setState({ teamId: null, playerId: null, players: [] }, function () {
	                    var _this$props$onChange;
	
	                    _this.props.onChange((_this$props$onChange = {}, _defineProperty(_this$props$onChange, _this.state.teamKeyProperty, null), _defineProperty(_this$props$onChange, _this.state.playerKeyProperty, null), _this$props$onChange));
	                });
	                return;
	            }
	            _this.setState({ teamId: teamId });
	
	            _this.props.onChange(_this.state.teamKeyProperty, teamId);
	
	            return fetch(_cfg2.default.apis.ss2 + '/teams/' + teamId + '/members').then(function (response) {
	                return response.status === 200 && response.json();
	            }).then(function (team) {
	                return _this.setState({ players: team.players });
	            });
	        };
	
	        _this.handlePlayerChange = function (e, key, val) {
	            _this.setState({ playerId: val }, function () {
	                _this.props.onChange(_this.state.playerKeyProperty, val);
	            });
	        };
	
	        var playerKeyProperty = _this.getPropertyFor(props.customKey ? props.propsMap.playerId : 'playerId');
	        var teamKeyProperty = _this.getPropertyFor(props.customKey ? props.propsMap.teamId : 'teamId');
	
	        _this.state = {
	            playerKeyProperty: playerKeyProperty,
	            teamKeyProperty: teamKeyProperty,
	            //teamId: props[teamKeyProperty] && +props[teamKeyProperty] || this.props.teamId,
	            teamId: _this.props.hideTeamPicker ? _this.props.teamId : props[teamKeyProperty] && +props[teamKeyProperty],
	            playerId: props[playerKeyProperty] && +props[playerKeyProperty],
	            players: []
	        };
	        return _this;
	    }
	
	    _createClass(PlayerPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleTeamChange(null, this.state.teamId);
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(pl) {
	            var text = (pl.number || '') + '. ' + pl.name;
	
	            return _react2.default.createElement(rmd.MenuItem, { key: pl.id, value: pl.id, primaryText: text });
	        }
	    }, {
	        key: 'getPropertyFor',
	        value: function getPropertyFor(key) {
	            return _lodash2.default.get(this, 'props.propsMap[' + key + ']', key);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var playersOptions = _lodash2.default.orderBy(this.state.players, [function (pl) {
	                return POSITIONS_ORDER.indexOf(pl.position);
	            }, 'number']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                !this.props.hideTeamPicker && _react2.default.createElement(_TeamPicker2.default, {
	                    onChange: this.handleTeamChange,
	                    tournamentId: this.props.tournamentId,
	                    teamId: this.state.teamId
	                }),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Players',
	                        floatingLabelFixed: true,
	                        value: this.state.playerId,
	                        disabled: !this.state.teamId,
	                        maxHeight: 400,
	                        onChange: this.handlePlayerChange
	                    },
	                    _react2.default.createElement(rmd.MenuItem, { key: 'zero', value: null, primaryText: 'Any' }),
	                    playersOptions.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return PlayerPicker;
	}(_react2.default.Component);
	
	exports.default = PlayerPicker;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnumPicker = function (_React$Component) {
	    _inherits(EnumPicker, _React$Component);
	
	    function EnumPicker(props, context) {
	        _classCallCheck(this, EnumPicker);
	
	        var _this = _possibleConstructorReturn(this, (EnumPicker.__proto__ || Object.getPrototypeOf(EnumPicker)).call(this, props, context));
	
	        _this.handleValueChange = function (e, key, payload) {
	            var propKey = _this.props.propKey;
	            _this.props.onChange(propKey, payload);
	
	            _this.setState({ value: payload });
	        };
	
	        _this.state = {
	            value: _this.props.value
	        };
	        return _this;
	    }
	
	    _createClass(EnumPicker, [{
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, {
	                key: option.value || option,
	                value: option.value || option,
	                primaryText: option.text || option
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: this.props.label,
	                        value: this.state.value,
	                        onChange: this.handleValueChange
	                    },
	                    this.props.options.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return EnumPicker;
	}(_react2.default.Component);
	
	exports.default = EnumPicker;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];
	
	var PlayerComparisonPicker = function (_React$Component) {
	    _inherits(PlayerComparisonPicker, _React$Component);
	
	    function PlayerComparisonPicker(props, context) {
	        _classCallCheck(this, PlayerComparisonPicker);
	
	        var _this = _possibleConstructorReturn(this, (PlayerComparisonPicker.__proto__ || Object.getPrototypeOf(PlayerComparisonPicker)).call(this, props, context));
	
	        _this.handleEventChange = function (key, value) {
	            var eventId = value;
	            if (!eventId) return null;
	
	            return fetch(_cfg2.default.apis.ss2 + '/events/' + eventId).then(function (response) {
	                return response.status === 200 && response.json();
	            }).then(function (event) {
	                return _bluebird2.default.props({
	                    homeId: event.homeId,
	                    awayId: event.awayId,
	                    homePlayers: fetch(_cfg2.default.apis.ss2 + '/teams/' + event.homeId + '/members').then(function (response) {
	                        return response.status === 200 && response.json();
	                    }).then(function (res) {
	                        return res.players;
	                    }),
	                    awayPlayers: fetch(_cfg2.default.apis.ss2 + '/teams/' + event.awayId + '/members').then(function (response) {
	                        return response.status === 200 && response.json();
	                    }).then(function (res) {
	                        return res.players;
	                    })
	                });
	            }).then(function (result) {
	                return _this.setState(result);
	            });
	        };
	
	        _this.state = {
	            homePlayerId: +props.homePlayerId,
	            awayPlayerId: +props.awayPlayerId,
	            homePlayers: [],
	            awayPlayers: []
	        };
	        return _this;
	    }
	
	    _createClass(PlayerComparisonPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.handleEventChange(null, this.props.eventId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.eventId != newProps.eventId) {
	                this.handleEventChange(null, newProps.eventId);
	            }
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(pl) {
	            var text = (pl.number || '') + '. ' + pl.name;
	
	            return _react2.default.createElement(rmd.MenuItem, { key: pl.id, value: pl.id, primaryText: text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var homePlayersOptions = _.orderBy(this.state.homePlayers, [function (pl) {
	                return POSITIONS_ORDER.indexOf(pl.position);
	            }, 'number']);
	            var awayPlayersOptions = _.orderBy(this.state.awayPlayers, [function (pl) {
	                return POSITIONS_ORDER.indexOf(pl.position);
	            }, 'number']);
	
	            //console.log( '--->>', 'PROPS', this.props );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Home team player',
	                        value: this.state.homePlayerId,
	                        disabled: !this.state.homeId,
	                        maxHeight: 400,
	                        onChange: function onChange(e, key, val) {
	                            return _this2.setState({ homePlayerId: val }, function () {
	                                _this2.props.onChange('homePlayerId', val);
	                            });
	                        }
	                    },
	                    homePlayersOptions.map(this.renderOption)
	                ),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Away team player',
	                        value: this.state.awayPlayerId,
	                        disabled: !this.state.awayId,
	                        maxHeight: 400,
	                        onChange: function onChange(e, key, val) {
	                            return _this2.setState({ awayPlayerId: val }, function () {
	                                _this2.props.onChange('awayPlayerId', val);
	                            });
	                        }
	                    },
	                    awayPlayersOptions.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return PlayerComparisonPicker;
	}(_react2.default.Component);
	
	exports.default = PlayerComparisonPicker;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-top: 30px;\n'], ['\n    margin-top: 30px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    background: rgba(0, 0, 0, 0.2);\n    margin: 0 -7px 5px;\n    padding: 12px;\n'], ['\n    background: rgba(0, 0, 0, 0.2);\n    margin: 0 -7px 5px;\n    padding: 12px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    font-weight: normal;\n    margin: 0;\n    color: rgb(0, 160, 181);\n'], ['\n    font-weight: normal;\n    margin: 0;\n    color: rgb(0, 160, 181);\n']);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Picker = _styledComponents2.default.div(_templateObject);
	
	var Event = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.div(_templateObject3);
	
	var POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];
	
	var PlayersComparisonPicker = function (_React$Component) {
	    _inherits(PlayersComparisonPicker, _React$Component);
	
	    function PlayersComparisonPicker(props, context) {
	        _classCallCheck(this, PlayersComparisonPicker);
	
	        var _this = _possibleConstructorReturn(this, (PlayersComparisonPicker.__proto__ || Object.getPrototypeOf(PlayersComparisonPicker)).call(this, props, context));
	
	        _this.handleEventChange = function (events) {
	            if (!events) {
	                return null;
	            }
	
	            return events.map(function (event) {
	                var _Promise$props;
	
	                return _bluebird2.default.props((_Promise$props = {}, _defineProperty(_Promise$props, event.homeId, fetch(_cfg2.default.apis.ss2 + '/teams/' + event.homeId + '/members').then(function (response) {
	                    return response.json();
	                }).then(function (res) {
	                    return res.players;
	                })), _defineProperty(_Promise$props, event.awayId, fetch(_cfg2.default.apis.ss2 + '/teams/' + event.awayId + '/members').then(function (response) {
	                    return response.json();
	                }).then(function (res) {
	                    return res.players;
	                })), _Promise$props)).then(function (result) {
	                    return _this.setState(result);
	                });
	            });
	        };
	
	        _this.state = {
	            tournament: {},
	            events: [],
	            players: props.players || {}
	        };
	        return _this;
	    }
	
	    _createClass(PlayersComparisonPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.handleEventChange(this.state.events);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            var _this2 = this;
	
	            if (Number(this.props.round || '') !== Number(newProps.round || '')) {
	                this.handleEventChange(null);
	                this.props.onChange('players', {});
	                this.setState({
	                    players: {}
	                }, function () {
	                    _this2.loadData();
	                });
	            }
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this3 = this;
	
	            var _props = this.props,
	                tournamentId = _props.tournamentId,
	                stageIds = _props.stageIds,
	                round = _props.round;
	
	
	            return fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '?locale=da').then(function (res) {
	                return res.json();
	            }).then(function (tournament) {
	                var id = tournament.id,
	                    currentRound = tournament.currentRound,
	                    seasonId = tournament.seasonId;
	
	
	                return _bluebird2.default.props({
	                    tournament: tournament,
	                    events: fetch(_cfg2.default.apis.ss2 + '/events-v2?ttId[]=' + id + '&seasonId=' + seasonId + '&round=' + (round || currentRound)).then(function (res) {
	                        return res.json();
	                    }).then(function (_ref) {
	                        var events = _ref.events;
	
	                        _this3.handleEventChange(events);
	
	                        return events;
	                    })
	                });
	            }).then(function (result) {
	                return _this3.setState(result);
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(pl) {
	            var text = (pl.number || '') + '. ' + pl.name;
	
	            return _react2.default.createElement(rmd.MenuItem, { key: pl.id, value: pl.id, primaryText: text });
	        }
	    }, {
	        key: 'sortPlayersByType',
	        value: function sortPlayersByType(players) {
	            return _lodash2.default.orderBy(players, [function (pl) {
	                return POSITIONS_ORDER.indexOf(pl.position);
	            }, 'number']);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var events = this.state.events;
	
	
	            return _react2.default.createElement(
	                Picker,
	                null,
	                events.map(function (ev) {
	                    return _react2.default.createElement(
	                        Event,
	                        null,
	                        _react2.default.createElement(
	                            Title,
	                            null,
	                            ev.homeName,
	                            ' - ',
	                            ev.awayName
	                        ),
	                        _react2.default.createElement(
	                            rmd.SelectField,
	                            {
	                                floatingLabelText: ev.homeShortName + ' player',
	                                value: _this4.state.players['' + ev.homeId] || ''
	                                //disabled={!this.state.homeId}
	                                , maxHeight: 400,
	                                onChange: function onChange(e, key, val) {
	                                    return _this4.setState({
	                                        players: _extends({}, _this4.state.players, _defineProperty({}, ev.homeId, val))
	                                    }, function () {
	                                        _this4.props.onChange('players', _extends({}, _this4.state.players, _defineProperty({}, ev.homeId, val)));
	                                    });
	                                }
	                            },
	                            _this4.sortPlayersByType(_this4.state[ev.homeId]).map(_this4.renderOption)
	                        ),
	                        _react2.default.createElement(
	                            rmd.SelectField,
	                            {
	                                floatingLabelText: ev.awayShortName + ' player',
	                                value: _this4.state.players['' + ev.awayId] || ''
	                                //disabled={!this.state.homeId}
	                                , maxHeight: 400,
	                                onChange: function onChange(e, key, val) {
	                                    return _this4.setState({
	                                        players: _extends({}, _this4.state.players, _defineProperty({}, ev.awayId, val))
	                                    }, function () {
	                                        _this4.props.onChange('players', _extends({}, _this4.state.players, _defineProperty({}, ev.awayId, val)));
	                                    });
	                                }
	                            },
	                            _this4.sortPlayersByType(_this4.state[ev.awayId]).map(_this4.renderOption)
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return PlayersComparisonPicker;
	}(_react2.default.Component);
	
	exports.default = PlayersComparisonPicker;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];
	
	var TeamPlayerPicker = function (_Component) {
	    _inherits(TeamPlayerPicker, _Component);
	
	    function TeamPlayerPicker(props, context) {
	        _classCallCheck(this, TeamPlayerPicker);
	
	        var _this = _possibleConstructorReturn(this, (TeamPlayerPicker.__proto__ || Object.getPrototypeOf(TeamPlayerPicker)).call(this, props, context));
	
	        _this.handleEventChange = function (key, teamId) {
	            return _bluebird2.default.props({
	                homeId: teamId,
	                players: fetch(_cfg2.default.apis.ss2 + '/teams/' + teamId + '/members').then(function (response) {
	                    return response.status === 200 && response.json();
	                }).then(function (res) {
	                    return res.players;
	                })
	            }).then(function (result) {
	                return _this.setState(result);
	            });
	        };
	
	        _this.state = {
	            playerId: +props.playerId,
	            players: []
	        };
	        return _this;
	    }
	
	    _createClass(TeamPlayerPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.handleEventChange(null, this.props.teamId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.teamId !== newProps.teamId) {
	                this.handleEventChange(null, newProps.teamId);
	            }
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(pl) {
	            var text = (pl.number || '') + '. ' + pl.name;
	
	            return _react2.default.createElement(rmd.MenuItem, { key: pl.id, value: pl.id, primaryText: text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                players = _state.players,
	                playerId = _state.playerId,
	                homeId = _state.homeId;
	
	
	            var playersOptions = _.orderBy(players, [function (pl) {
	                return POSITIONS_ORDER.indexOf(pl.position);
	            }, 'number']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Players',
	                        value: playerId,
	                        disabled: !homeId,
	                        maxHeight: 400,
	                        onChange: function onChange(e, key, val) {
	                            return _this2.setState({ playerId: val }, function () {
	                                _this2.props.onChange('playerId', val);
	                            });
	                        }
	                    },
	                    playersOptions.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return TeamPlayerPicker;
	}(_react.Component);
	
	exports.default = TeamPlayerPicker;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactSelect = __webpack_require__(1141);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentPickerMulti = function (_React$Component) {
	    _inherits(TournamentPickerMulti, _React$Component);
	
	    function TournamentPickerMulti(props, context) {
	        _classCallCheck(this, TournamentPickerMulti);
	
	        var _this = _possibleConstructorReturn(this, (TournamentPickerMulti.__proto__ || Object.getPrototypeOf(TournamentPickerMulti)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var tournamentIds = void 0;
	        try {
	            tournamentIds = JSON.parse(props.tournamentIds);
	        } catch (e) {
	            tournamentIds = [];
	        }
	
	        _this.state = {
	            tournaments: [],
	            tournamentIds: tournamentIds
	        };
	        return _this;
	    }
	
	    _createClass(TournamentPickerMulti, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadTournaments();
	        }
	    }, {
	        key: 'loadTournaments',
	        value: function loadTournaments() {
	            var _this2 = this;
	
	            var sportId = this.props.sportId;
	            var _state = this.state,
	                tournamentId = _state.tournamentId,
	                countryId = _state.countryId;
	
	
	            return fetch(_cfg2.default.apis.ss2 + '/tournaments?sportId=' + sportId).then(function (response) {
	                return response.json();
	            }).then(function (tournaments) {
	                return _this2.setState({ tournaments: tournaments });
	            }).catch(function (e) {
	                _this2.setState({ tournaments: [] });
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state2 = this.state,
	                tournaments = _state2.tournaments,
	                tournamentIds = _state2.tournamentIds;
	
	
	            var tournamentsOptions = this.state.tournaments.map(function (t) {
	                return { label: t.name, value: t.id };
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-tournament-multi-picker' },
	                _react2.default.createElement(_reactSelect2.default, {
	                    value: tournamentIds,
	                    multi: true,
	                    options: tournamentsOptions,
	                    search: true,
	                    placeholder: 'Select leagues',
	                    onChange: this.handleTournamentChange
	                })
	            );
	        }
	    }]);
	
	    return TournamentPickerMulti;
	}(_react2.default.Component);
	
	TournamentPickerMulti.defaultProps = {
	    sportId: 1
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.handleTournamentChange = function (payload) {
	        var tournamentIds = payload.map(function (t) {
	            return t.value;
	        });
	        _this3.setState({ tournamentIds: tournamentIds }, function () {
	            _this3.props.onChange({ tournamentIds: tournamentIds });
	        });
	    };
	};
	
	exports.default = TournamentPickerMulti;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TournamentPickerMulti = __webpack_require__(1170);
	
	var _TournamentPickerMulti2 = _interopRequireDefault(_TournamentPickerMulti);
	
	var _TournamentPicker = __webpack_require__(1136);
	
	var _TournamentPicker2 = _interopRequireDefault(_TournamentPicker);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LLTPicker = function (_React$Component) {
	    _inherits(LLTPicker, _React$Component);
	
	    function LLTPicker(props, context) {
	        _classCallCheck(this, LLTPicker);
	
	        var _this = _possibleConstructorReturn(this, (LLTPicker.__proto__ || Object.getPrototypeOf(LLTPicker)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var type = props.leaguesType;
	        try {
	            var tournamentIds = JSON.parse(props.tournamentIds);
	        } catch (e) {}
	
	        if (!_lodash2.default.isEqual(tournamentIds.sort(), _this.topLeagues.sort())) {
	            type = 'custom';
	        }
	
	        _this.state = {
	            label: props.label || "",
	            type: type,
	            tournamentIds: tournamentIds,
	            countryTournamentIds: []
	        };
	        return _this;
	    }
	
	    _createClass(LLTPicker, [{
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            var oldTournamentIds = _lodash2.default.union(this.state.tournamentIds, this.state.countryTournamentIds);
	            var newTournamentIds = _lodash2.default.union(nextState.tournamentIds, nextState.countryTournamentIds);
	
	            if (!_lodash2.default.isEqual(oldTournamentIds.sort(), newTournamentIds.sort())) {
	                this.props.onChange({ 'tournamentIds': newTournamentIds });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var label = this.state.label;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        maxHeight: 200,
	                        value: this.state.type,
	                        floatingLabelText: label,
	                        floatingLabelFixed: true,
	                        onChange: this.handleTypeChange
	                    },
	                    [{
	                        value: 'top',
	                        text: 'Top leagues'
	                    }, {
	                        value: 'top.country',
	                        text: 'Top leagues + Country'
	                    }, {
	                        value: 'custom',
	                        text: 'Custom leagues'
	                    }].map(function (option) {
	                        return _react2.default.createElement(rmd.MenuItem, {
	                            key: option.value,
	                            value: option.value,
	                            primaryText: option.text
	                        });
	                    })
	                ),
	                _react2.default.createElement(_TournamentPickerMulti2.default, { key: this.state.type, onChange: this.handleMultiPickerTournaments, tournamentIds: JSON.stringify(this.state.tournamentIds) }),
	                this.state.type == 'top.country' && _react2.default.createElement(_TournamentPicker2.default, { onChange: this.handleCountryTournamentsPicker, multi: true, hideSeasonPicker: true })
	            );
	        }
	    }]);
	
	    return LLTPicker;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.topLeagues = [47, 87, 55, 54, 53, 42, 73];
	
	    this.handleTypeChange = function (e, index, type) {
	        switch (type) {
	            case 'custom':
	                _this2.setState({ type: type, tournamentIds: [], countryTournamentIds: [] });
	                break;
	            case 'top.country':
	            case 'top':
	                _this2.setState({
	                    type: type,
	                    tournamentIds: _this2.topLeagues,
	                    countryTournamentIds: []
	                });
	                break;
	        }
	    };
	
	    this.handleMultiPickerTournaments = function (_ref) {
	        var tournamentIds = _ref.tournamentIds;
	
	        _this2.setState({
	            tournamentIds: tournamentIds
	        });
	    };
	
	    this.handleCountryTournamentsPicker = function (_ref2) {
	        var _ref2$tournamentIds = _ref2.tournamentIds,
	            tournamentIds = _ref2$tournamentIds === undefined ? [] : _ref2$tournamentIds;
	
	        _this2.setState({
	            countryTournamentIds: tournamentIds
	        });
	    };
	};
	
	exports.default = LLTPicker;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = function (_React$Component) {
	    _inherits(DatePicker, _React$Component);
	
	    function DatePicker(props, context) {
	        _classCallCheck(this, DatePicker);
	
	        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props, context));
	
	        _this.handleDateChange = function (key, value) {
	            var date = (0, _moment2.default)(value).local();
	            var from = date.format('YYYY-MM-DD');
	            _this.setState({ date: value });
	            _this.props.onChange('date', from);
	        };
	
	        _this.state = {
	            date: props.date ? new Date(props.date) : new Date()
	        };
	        return _this;
	    }
	
	    _createClass(DatePicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleDateChange(null, this.state.date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(rmd.DatePicker, {
	                    hintText: 'Choose date',
	                    floatingLabelText: this.props.label,
	                    value: this.state.date,
	                    container: 'inline',
	                    autoOk: true,
	                    onChange: this.handleDateChange
	                })
	            );
	        }
	    }]);
	
	    return DatePicker;
	}(_react2.default.Component);
	
	exports.default = DatePicker;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamTournamentsPicker = function (_React$Component) {
	    _inherits(TeamTournamentsPicker, _React$Component);
	
	    function TeamTournamentsPicker(props, context) {
	        _classCallCheck(this, TeamTournamentsPicker);
	
	        var _this = _possibleConstructorReturn(this, (TeamTournamentsPicker.__proto__ || Object.getPrototypeOf(TeamTournamentsPicker)).call(this, props, context));
	
	        _this.handleTournamentCheck = function (tId, e, val) {
	            var singleOption = _this.props.singleOption;
	
	            var ttIds = val ? [].concat(_toConsumableArray(singleOption ? [] : _this.state.ttIds), [tId]) : _this.state.ttIds.filter(function (id) {
	                return id !== tId;
	            });
	            var seasonIds = _this.state.tournamentsTeam.reduce(function (acc, curr) {
	                if (ttIds.indexOf(curr.id) !== -1) return [].concat(_toConsumableArray(acc), [curr.currentSeason.id]);else return [].concat(_toConsumableArray(acc));
	            }, []);
	            var allTournaments = false;
	
	            if (ttIds.length === _this.state.tournamentTeamIds.length || !ttIds.length) allTournaments = true;
	
	            _this.setState({
	                ttIds: ttIds,
	                seasonIds: seasonIds,
	                allTournaments: allTournaments
	            }, function () {
	                _this.onChangeProp();
	            });
	        };
	
	        var tournamentKey = props.propsMap && props.propsMap.ttIds ? props.propsMap.ttIds : 'ttIds';
	        var seasonKey = props.propsMap && props.propsMap.seasonIds ? props.propsMap.seasonIds : 'seasonIds';
	
	        try {
	            var tournaments = _this.isArrayHandler(props[tournamentKey]);
	
	            _this.state = {
	                teamId: parseInt(props.teamId, 10),
	                tournamentKey: tournamentKey,
	                seasonKey: seasonKey,
	                mainTournamentId: null,
	                tournamentTeamIds: [],
	                tournamentsTeam: [],
	                seasonsTeamIds: [],
	                ttIds: tournaments,
	                seasonIds: _this.isArrayHandler(props[seasonKey]),
	                allTournaments: tournaments.length === 0
	            };
	        } catch (e) {}
	        return _this;
	    }
	
	    _createClass(TeamTournamentsPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadTournaments();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var _this2 = this;
	
	            var teamId = _ref.teamId;
	
	            if (this.state.teamId !== teamId) {
	                this.setState({
	                    teamId: teamId,
	                    mainTournamentId: null,
	                    tournamentTeamIds: [],
	                    tournamentsTeam: [],
	                    seasonsTeamIds: [],
	                    allTournaments: true,
	                    ttIds: [],
	                    seasonIds: []
	                }, function () {
	                    _this2.loadTournaments();
	                });
	            }
	        }
	    }, {
	        key: 'isArrayHandler',
	        value: function isArrayHandler(isArr) {
	            if (Array.isArray(isArr)) return isArr;else return isArr ? [isArr] : [];
	        }
	    }, {
	        key: 'onChangeProp',
	        value: function onChangeProp() {
	            var _props = this.props,
	                onChange = _props.onChange,
	                singleOption = _props.singleOption;
	            var _state = this.state,
	                tournamentKey = _state.tournamentKey,
	                seasonKey = _state.seasonKey,
	                allTournaments = _state.allTournaments,
	                ttIds = _state.ttIds,
	                seasonIds = _state.seasonIds,
	                tournamentTeamIds = _state.tournamentTeamIds,
	                seasonsTeamIds = _state.seasonsTeamIds;
	
	
	            if (singleOption) {
	                if (allTournaments) {
	                    var _onChange;
	
	                    onChange((_onChange = {}, _defineProperty(_onChange, tournamentKey, null), _defineProperty(_onChange, seasonKey, null), _onChange), null);
	                } else {
	                    var _onChange2;
	
	                    onChange((_onChange2 = {}, _defineProperty(_onChange2, tournamentKey, ttIds.length ? ttIds[0] : null), _defineProperty(_onChange2, seasonKey, seasonIds.length ? seasonIds[0] : null), _onChange2));
	                }
	            } else if (allTournaments) {
	                var _onChange3;
	
	                // onChange(
	                //     {
	                //         [tournamentKey]: null,
	                //         [seasonKey]: null
	                //     },
	                //     null
	                // );
	                onChange((_onChange3 = {}, _defineProperty(_onChange3, tournamentKey, tournamentTeamIds.filter(function (id) {
	                    return id !== 489;
	                })), _defineProperty(_onChange3, seasonKey, seasonsTeamIds), _onChange3), null);
	            } else {
	                var _onChange4;
	
	                onChange((_onChange4 = {}, _defineProperty(_onChange4, tournamentKey, ttIds.length ? ttIds : null), _defineProperty(_onChange4, seasonKey, seasonIds.length ? seasonIds : null), _onChange4));
	            }
	        }
	    }, {
	        key: 'loadTournaments',
	        value: function loadTournaments() {
	            var _this3 = this;
	
	            var _state2 = this.state,
	                teamId = _state2.teamId,
	                ttIds = _state2.ttIds;
	
	
	            if (!teamId) return _RCore2.default.promiseProps({});
	
	            return _RCore2.default.promiseProps({
	                team: fetch(_cfg2.default.apis.ss2 + '/teams/' + teamId).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (res) {
	                return _RCore2.default.promiseProps(_extends({}, res, {
	                    tournamentTeamIds: res.team && res.team.tournamentTemplateId,
	                    mainTournamentId: res.team && res.team.mainTournamentId
	                }));
	            }).then(function (res) {
	                return _RCore2.default.promiseProps(_extends({}, res, {
	                    allTournaments: ttIds.length === 0,
	                    ttIds: ttIds.length === 0 ? _this3.isArrayHandler(res.mainTournamentId) : ttIds,
	                    tournamentsTeam: Promise.all(res.tournamentTeamIds.map(function (id) {
	                        return fetch(_cfg2.default.apis.ss2 + '/tournaments/' + id).then(function (response) {
	                            return response.json();
	                        });
	                    })).then(function (res) {
	                        return res.filter(function (tournament) {
	                            return tournament.currentSeason;
	                        });
	                    })
	                }));
	            }).then(function (res) {
	                var tournamentsTeam = res.tournamentsTeam.filter(function (tournament) {
	                    return tournament.currentSeason;
	                });
	
	                return _RCore2.default.promiseProps(_extends({}, res, {
	                    seasonsTeamIds: tournamentsTeam.reduce(function (acc, curr) {
	                        return curr.id !== 489 ? [].concat(_toConsumableArray(acc), [curr.currentSeason.id]) : acc;
	                    }, []),
	                    seasonIds: tournamentsTeam.reduce(function (acc, curr) {
	                        if (res.ttIds.indexOf(curr.id) !== -1) {
	                            return [].concat(_toConsumableArray(acc), [curr.currentSeason.id]);
	                        } else {
	                            return [].concat(_toConsumableArray(acc));
	                        }
	                    }, [])
	                }));
	            }).then(function (res) {
	                _this3.setState(res, function () {
	                    _this3.onChangeProp();
	                });
	            }).catch(function (e) {});
	        }
	    }, {
	        key: 'checkedHandler',
	        value: function checkedHandler(id) {
	            var _state3 = this.state,
	                allTournaments = _state3.allTournaments,
	                ttIds = _state3.ttIds,
	                tournamentTeamIds = _state3.tournamentTeamIds;
	
	
	            return allTournaments ? tournamentTeamIds.indexOf(id) !== -1 : ttIds.indexOf(id) !== -1;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state4 = this.state,
	                tournamentsTeam = _state4.tournamentsTeam,
	                allTournaments = _state4.allTournaments,
	                tournamentTeamIds = _state4.tournamentTeamIds,
	                seasonsTeamIds = _state4.seasonsTeamIds;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(rmd.Toggle, {
	                    label: 'All tournaments',
	                    toggled: allTournaments,
	                    onToggle: function onToggle(e, value) {
	                        if (allTournaments && !value) {
	                            _this4.setState({
	                                allTournaments: value,
	                                ttIds: [tournamentTeamIds[0]],
	                                seasonIds: [seasonsTeamIds[0]]
	                            }, function () {
	                                _this4.onChangeProp();
	                            });
	                        } else {
	                            _this4.setState({
	                                allTournaments: value
	                            }, function () {
	                                _this4.onChangeProp();
	                            });
	                        }
	                    },
	                    style: { marginBottom: '16px', marginTop: '16px' }
	                }),
	                tournamentsTeam.map(function (t) {
	                    if (t.id === 489) return;
	
	                    return _react2.default.createElement(rmd.Checkbox, {
	                        key: t.id,
	                        disabled: allTournaments,
	                        checked: _this4.checkedHandler(t.id),
	                        onCheck: _this4.handleTournamentCheck.bind(_this4, t.id),
	                        label: t.name + '  '
	                    });
	                })
	            );
	        }
	    }]);
	
	    return TeamTournamentsPicker;
	}(_react2.default.Component);
	
	TeamTournamentsPicker.defaultProps = {
	    singleOption: false
	};
	exports.default = TeamTournamentsPicker;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagePicker = function (_React$Component) {
	    _inherits(StagePicker, _React$Component);
	
	    function StagePicker(props, context) {
	        _classCallCheck(this, StagePicker);
	
	        var _this = _possibleConstructorReturn(this, (StagePicker.__proto__ || Object.getPrototypeOf(StagePicker)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var stageId = [];
	        try {
	            var candidate = props[_lodash2.default.get(props, 'propsMap.stageId', 'stageId')];
	            if (_lodash2.default.isArray(candidate)) stageId = props[_lodash2.default.get(props, 'propsMap.stageId', 'stageId')];else stageId = JSON.parse(props[_lodash2.default.get(props, 'propsMap.stageId', 'stageId')]) || [];
	        } catch (e) {}
	
	        _this.state = {
	            tournamentId: +props.tournamentId,
	            seasonId: +props.seasonId,
	            season: {},
	            stageId: stageId,
	            // all: stageId.length === 0,
	            all: false
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(StagePicker, [{
	        key: 'getPropertyFor',
	        value: function getPropertyFor(key) {
	            return _lodash2.default.get(this, 'props.propsMap[' + key + ']', key);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                season = _state.season,
	                stageId = _state.stageId,
	                all = _state.all;
	            //if (!season || (season.stages && season.stages.length === 1)) return <div />;
	
	            if (!season || !season.stages) return _react2.default.createElement('div', null);
	
	            var allStages = season.stages.map(function (s) {
	                return s.id;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(rmd.Toggle, {
	                    label: 'All stages',
	                    toggled: all,
	                    onToggle: function onToggle(e, value) {
	                        if (value) {
	                            _this2.setState({ all: true, stageId: allStages }, function () {
	                                _this2.props.onChange(_this2.getPropertyFor('stageId'), allStages);
	                            });
	                        } else {
	                            _this2.setState({ all: false }, function () {
	                                _this2.props.onChange(_this2.getPropertyFor('stageId'), null);
	                            });
	                        }
	                    },
	                    style: { marginBottom: '16px' }
	                }),
	                _lodash2.default.chain(season.stages || []).groupBy(function (st) {
	                    return (0, _moment2.default)(st.startDate).format('MMM YY') + ' - ' + (0, _moment2.default)(st.endDate).format('MMM YY');
	                }).toPairs().map(function (p) {
	                    var group = p[0];
	                    var stages = p[1];
	                    return [_react2.default.createElement(
	                        'div',
	                        { key: group },
	                        group
	                    ), _lodash2.default.sortBy(stages, function (st) {
	                        return st.name;
	                    }).map(function (st) {
	                        return _react2.default.createElement(rmd.Checkbox, {
	                            key: st.id,
	                            disabled: all,
	                            checked: stageId.indexOf(st.id) !== -1,
	                            onCheck: _this2.handleStageCheck.bind(_this2, st.id),
	                            label: '' + st.name
	                        });
	                    })];
	                }).value()
	            );
	        }
	    }]);
	
	    return StagePicker;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.componentWillReceiveProps = function (nextProps) {
	        var _state2 = _this3.state,
	            tournamentId = _state2.tournamentId,
	            seasonId = _state2.seasonId;
	
	
	        if (nextProps.tournamentId !== tournamentId || nextProps.seasonId && nextProps.seasonId !== seasonId) {
	            _this3.setState({
	                tournamentId: nextProps.tournamentId,
	                seasonId: nextProps.seasonId,
	                // all: true,
	                all: false,
	                stageId: []
	            }, function () {
	                _this3.loadData();
	                // if was changed tournament and stageIds remains not empty (means previous) => reset them
	                _this3.props.onChange(_this3.getPropertyFor('stageId'), []);
	            });
	        }
	    };
	
	    this.loadData = function () {
	        var _state3 = _this3.state,
	            tournamentId = _state3.tournamentId,
	            seasonId = _state3.seasonId;
	
	        if (!tournamentId) return _bluebird2.default.resolve({});
	
	        return _RCore2.default.promiseProps({
	            season: fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/seasons?locale=en').then(function (response) {
	                return response.json();
	            }).then(function (seasons) {
	                var season = _lodash2.default.find(seasons, function (s) {
	                    if (!seasonId) return s.isCurrent;
	                    return s.id === seasonId;
	                });
	                if (!season) season = _lodash2.default.last(seasons);
	
	                return season;
	            })
	        }).then(function (res) {
	            var season = res.season;
	            var stageIds = _this3.props.stageIds;
	
	            var currentDate = (0, _moment2.default)(new Date()).format('YYYY-01-01');
	
	            return _RCore2.default.promiseProps({
	                season: season,
	                stageId: fetch(_cfg2.default.apis.ss2 + '/events-v2?locale=en&seasonId=' + season.id + '&fromDate=' + currentDate).then(function (response) {
	                    return response.json();
	                }).then(function (res) {
	                    return res.events;
	                })
	                // .then(events => {
	                //     if (!this.props.autoHighlighting) return [];
	                //     const event = _.find(events, ev => ev.properties && ['1/8', '1/4', '1/2'].includes(ev.properties.round));
	                //
	                //     const currentStage = event && event.tournamentStageId ? [event.tournamentStageId] : [];
	                //     const stages = stageIds.length ? stageIds : currentStage;
	                //
	                //     this.props.onChange(this.getPropertyFor('stageId'), stages);
	                //
	                //     return stages;
	                // })
	                .then(function () {
	                    var stages = stageIds.length ? stageIds : [];
	                    _this3.props.onChange(_this3.getPropertyFor('stageId'), stages);
	
	                    return stages;
	                })
	            });
	        }).then(function (res) {
	            _this3.setState(_extends({}, res));
	        }).catch(function (e) {});
	    };
	
	    this.handleStageCheck = function (stId, e, val) {
	        var _state4 = _this3.state,
	            stageId = _state4.stageId,
	            season = _state4.season;
	
	        var allStages = season.stages.map(function (s) {
	            return s.id;
	        });
	
	        _this3.setState({
	            stageId: val ? _lodash2.default.concat(stageId, stId) : _lodash2.default.without(stageId, stId)
	        }, function () {
	            if (_this3.state.stageId.length === 0) {
	                _this3.setState({ all: true, stageId: allStages });
	                _this3.props.onChange(_this3.getPropertyFor('stageId'), allStages);
	            } else {
	                _this3.props.onChange(_this3.getPropertyFor('stageId'), _this3.state.stageId);
	            }
	        });
	    };
	};
	
	exports.default = StagePicker;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagePickerOneCheck = function (_React$Component) {
	    _inherits(StagePickerOneCheck, _React$Component);
	
	    function StagePickerOneCheck(props, context) {
	        _classCallCheck(this, StagePickerOneCheck);
	
	        var _this = _possibleConstructorReturn(this, (StagePickerOneCheck.__proto__ || Object.getPrototypeOf(StagePickerOneCheck)).call(this, props, context));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var _this$state = _this.state,
	                tournamentId = _this$state.tournamentId,
	                seasonId = _this$state.seasonId;
	
	            if (nextProps.tournamentId !== tournamentId || nextProps.seasonId && nextProps.seasonId !== seasonId) {
	                _this.setState({
	                    tournamentId: nextProps.tournamentId,
	                    seasonId: nextProps.seasonId,
	                    stageId: null
	                }, function () {
	                    _this.loadData();
	
	                    // if was changed tournament and stageIds remains not empty (means previous) => reset them
	                    if (nextProps.stageId !== null) _this.props.onChange('stageId', null);
	                });
	            }
	        };
	
	        _this.loadData = function () {
	            var _this$state2 = _this.state,
	                tournamentId = _this$state2.tournamentId,
	                seasonId = _this$state2.seasonId;
	
	            if (!tournamentId) return Promise.resolve({});
	            return fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/seasons').then(function (response) {
	                return response.json();
	            }).then(function (seasons) {
	                var season = _lodash2.default.find(seasons, function (s) {
	                    if (!seasonId) return s.isCurrent;
	                    return s.id === seasonId;
	                });
	                if (!season) season = _lodash2.default.last(seasons);
	
	                _this.setState({ season: season });
	            }).catch(function (e) {});
	        };
	
	        _this.handleStageCheck = function (stId) {
	            var stageId = _this.state.stageId;
	
	
	            _this.setState({
	                stageId: stageId !== stId ? stId : null
	            }, function () {
	                if (_this.state.stageId === null) {
	                    _this.props.onChange('stageId', null);
	                } else {
	                    _this.props.onChange('stageId', JSON.stringify(_this.state.stageId));
	                }
	            });
	        };
	
	        _this.state = {
	            tournamentId: +props.tournamentId,
	            seasonId: +props.seasonId,
	            season: {},
	            stageId: +props.stageId
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(StagePickerOneCheck, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                season = _state.season,
	                stageId = _state.stageId;
	
	            if (season.stages && season.stages.length === 1) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { marginTop: '10px', display: 'inline-block' } },
	                    'Select the Stage'
	                ),
	                _lodash2.default.chain(season.stages || []).filter(function (st) {
	                    return _this2.props.isLeague ? !st.isCup : true;
	                }).groupBy(function (st) {
	                    return (0, _moment2.default)(st.startDate).format('MMM YY') + ' - ' + (0, _moment2.default)(st.endDate).format('MMM YY');
	                }).toPairs().map(function (p) {
	                    var group = p[0];
	                    var stages = p[1];
	
	                    return [_react2.default.createElement(
	                        'div',
	                        { style: { padding: '10px 0' } },
	                        group
	                    ), _lodash2.default.sortBy(stages, function (st) {
	                        return p[1].rank;
	                    }).map(function (st) {
	                        return _react2.default.createElement(rmd.Checkbox, {
	                            key: st.id,
	                            disabled: false,
	                            checked: stageId === st.id,
	                            onCheck: _this2.handleStageCheck.bind(_this2, st.id),
	                            label: '' + st.name
	                        });
	                    })];
	                }).value()
	            );
	        }
	    }]);
	
	    return StagePickerOneCheck;
	}(_react2.default.Component);
	
	exports.default = StagePickerOneCheck;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IncidentPicker = function (_React$Component) {
	    _inherits(IncidentPicker, _React$Component);
	
	    function IncidentPicker(props, context) {
	        _classCallCheck(this, IncidentPicker);
	
	        var _this = _possibleConstructorReturn(this, (IncidentPicker.__proto__ || Object.getPrototypeOf(IncidentPicker)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var incidentId = props.incidentId,
	            eventId = props.eventId;
	
	        _this.state = {
	            incidentId: Number(incidentId)
	        };
	        return _this;
	    }
	
	    _createClass(IncidentPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var eventId = nextProps.eventId;
	
	            if (eventId !== this.props.eventId) {
	                this.setState({ event: null }, function () {
	                    _this2.loadData();
	                });
	            }
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this3 = this;
	
	            var eventId = this.props.eventId;
	
	            if (!eventId) return;
	
	            return _bluebird2.default.props({
	                event: fetch(_cfg2.default.apis.ss2 + '/events/' + eventId)
	            }).then(function (result) {
	                return _bluebird2.default.props({
	                    event: result.event.status === 200 && result.event.json()
	                });
	            }).then(function (res) {
	                _this3.setState({ event: res.event });
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(_materialUi.MenuItem, {
	                key: option.incidentId,
	                value: option.incidentId,
	                primaryText: option.type + ' - ' + option.participantName,
	                secondaryText: option.min + "'"
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var incidents = _lodash2.default.get(this.state, 'event.incidents', []);
	            var filter = this.props.filter;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        floatingLabelText: this.props.label || 'Incident',
	                        floatingLabelFixed: incidents.length > 0,
	                        value: this.state.incidentId,
	                        style: { width: '100%' },
	                        disabled: incidents.length === 0,
	                        onChange: this.handleRoundChange
	                    },
	                    _lodash2.default.filter(incidents, function (i) {
	                        return filter ? filter.includes(i.typeId) : true;
	                    }).map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return IncidentPicker;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.handleRoundChange = function (e, k, val) {
	        var key = _this4.props.propKey || 'incidentId';
	        var incidentId = Number(val);
	        if (_this4.props.onChange) {
	            _this4.props.onChange(key, incidentId);
	        }
	        _this4.setState({ incidentId: incidentId });
	    };
	};
	
	exports.default = IncidentPicker;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = function (_React$Component) {
	    _inherits(Slider, _React$Component);
	
	    function Slider(props, context) {
	        _classCallCheck(this, Slider);
	
	        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.handleChange = function (e, val) {
	            _this.props.onChange(_this.props.propKey, val);
	        };
	
	        _this.state = {
	            value: props[props.propKey]
	        };
	        return _this;
	    }
	
	    _createClass(Slider, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var value = this.state.value;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { style: { paddingTop: '30px', display: 'inline-block' } },
	                    this.props.label
	                ),
	                _react2.default.createElement(rmd.Slider, { step: 0.1, defaultValue: value, onChange: this.handleChange })
	            );
	        }
	    }]);
	
	    return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 10 -15px;\n    padding: 0 15px;\n    &:hover {\n        background: rgba(0, 0, 0, 0.3);\n    }\n'], ['\n    margin: 10 -15px;\n    padding: 0 15px;\n    &:hover {\n        background: rgba(0, 0, 0, 0.3);\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutabilityHelper = __webpack_require__(596);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _collections = __webpack_require__(1029);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _materialUi = __webpack_require__(642);
	
	var _Subheader = __webpack_require__(818);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var C_LAYER_DEFAULT = {
	    scale: 1.0,
	    translateX: 50,
	    translateY: 50,
	    opacity: 1.0,
	    backgroundImage: null,
	    backgroundSize: 'cover',
	    backgroundPositionX: 'center',
	    backgroundPositionY: 'center'
	};
	
	var HSection = _styledComponents2.default.div(_templateObject);
	
	var PreviewImagePicker = function (_React$Component) {
	    _inherits(PreviewImagePicker, _React$Component);
	
	    function PreviewImagePicker(props, context) {
	        _classCallCheck(this, PreviewImagePicker);
	
	        // parse
	        var _this = _possibleConstructorReturn(this, (PreviewImagePicker.__proto__ || Object.getPrototypeOf(PreviewImagePicker)).call(this, props, context));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            // parse
	            var v = '';
	            try {
	                v = JSON.parse(nextProps[nextProps.propKey]);
	            } catch (e) {
	                if (_lodash2.default.isObject(nextProps[nextProps.propKey])) v = nextProps[nextProps.propKey];else v = _lodash2.default.extend({}, C_LAYER_DEFAULT, nextProps.default);
	            }
	            // console.log('!CDP !');
	        };
	
	        var v = '';
	        try {
	            v = JSON.parse(props[props.propKey]);
	        } catch (e) {
	            if (_lodash2.default.isObject(props[props.propKey])) v = props[props.propKey];else v = _lodash2.default.extend({}, C_LAYER_DEFAULT, props.default);
	        }
	
	        _this.state = {
	            value: v,
	            expanded: false
	        };
	        return _this;
	    }
	
	    _createClass(PreviewImagePicker, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                value = _state.value,
	                expanded = _state.expanded,
	                imagePicker = _state.imagePicker;
	
	            var layer = value;
	
	            var uploadPreview = this.state.imageToUpload && this.state.imageToUpload.preview;
	
	            var images = _lodash2.default.sortBy(this.state.userImages, function (img) {
	                return -new Date(img.createdAt);
	            });
	            images = _lodash2.default.take(images, 8);
	
	            var properyChange = function properyChange(object) {
	                _this2.setState((0, _immutabilityHelper2.default)(_this2.state, {
	                    value: { $merge: object }
	                }), function () {
	                    _this2.props.onChange(_this2.props.propKey, _this2.state.value);
	                });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'preview-image-picker' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: 'baseline' } },
	                    _react2.default.createElement(_materialUi.TextField, {
	                        floatingLabelFixed: true,
	                        floatingLabelText: this.props.label,
	                        value: layer.backgroundImage,
	                        onBlur: function onBlur(e) {
	                            properyChange({ backgroundImage: e.target.value });
	                        },
	                        onChange: function onChange(e, backgroundImage) {
	                            return _this2.setState((0, _immutabilityHelper2.default)(_this2.state, {
	                                value: { $merge: { backgroundImage: backgroundImage } }
	                            }));
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        icon: _react2.default.createElement(_collections2.default, null),
	                        style: { minWidth: '44px', marginLeft: 5 },
	                        onClick: function onClick() {
	                            _this2.setState({ imagePicker: true });
	                        }
	                    })
	                ),
	                layer.backgroundImage && _react2.default.createElement('img', { key: '1', style: { width: '100%' }, src: layer.backgroundImage }),
	                layer.backgroundImage && _react2.default.createElement(_materialUi.FlatButton, {
	                    style: { width: '100%' },
	                    label: 'Image manipulations',
	                    onClick: function onClick(e) {
	                        return _this2.setState({
	                            expanded: !expanded,
	                            anchorEl: e.target
	                        });
	                    }
	                }),
	                this.props.plain === true && _react2.default.createElement(
	                    'div',
	                    { style: { margin: 8 } },
	                    _react2.default.createElement(Fields, {
	                        layer: layer,
	                        properyChange: properyChange,
	                        disableTopOverlay: this.props.disableTopOverlay
	                    })
	                ),
	                expanded && _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: expanded,
	                        anchorEl: this.state.anchorEl,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: function onRequestClose() {
	                            return _this2.setState({ expanded: false });
	                        },
	                        style: { width: 400 }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { padding: 16 } },
	                        _react2.default.createElement(Fields, {
	                            layer: layer,
	                            properyChange: properyChange,
	                            disableTopOverlay: this.props.disableTopOverlay
	                        }),
	                        _react2.default.createElement(_materialUi.FlatButton, {
	                            label: 'Reset',
	                            onClick: function onClick() {
	                                var resetTo = _lodash2.default.extend({}, C_LAYER_DEFAULT);
	                                Reflect.deleteProperty(resetTo, 'backgroundImage');
	                                properyChange(resetTo);
	                            }
	                        }),
	                        _react2.default.createElement(_materialUi.FlatButton, {
	                            label: 'Done',
	                            style: { float: 'right' },
	                            onClick: function onClick() {
	                                _this2.setState({
	                                    expanded: false
	                                });
	                            }
	                        })
	                    )
	                ),
	                imagePicker && _react2.default.createElement(_ImageUploaderContainer2.default, {
	                    onCopy: function onCopy(url) {
	                        _this2.setState((0, _immutabilityHelper2.default)(_this2.state, {
	                            value: {
	                                $merge: { backgroundImage: url }
	                            },
	                            imagePicker: { $set: false }
	                        }), function () {
	                            _this2.props.onChange(_this2.props.propKey, _this2.state.value);
	                        });
	                    },
	                    onClose: function onClose() {
	                        _this2.setState({
	                            imagePicker: null
	                        });
	                    },
	                    modal: true,
	                    galleryFirst: true,
	                    cdnOnly: true,
	                    cdnLabel: 'Pick'
	                })
	            );
	        }
	    }]);
	
	    return PreviewImagePicker;
	}(_react2.default.Component);
	
	PreviewImagePicker.defaultProps = {
	    disableTopOverlay: false
	};
	
	
	var CommonFields = function CommonFields(_ref) {
	    var layer = _ref.layer,
	        properyChange = _ref.properyChange,
	        disableTopOverlay = _ref.disableTopOverlay;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _materialUi.SelectField,
	            {
	                floatingLabelText: 'Image fit',
	                value: layer.backgroundSize,
	                key: 'backgroundSize',
	                style: { width: '100%' },
	                onChange: function onChange(e, index, backgroundSize) {
	                    if (backgroundSize === 'cover') {
	                        properyChange({
	                            backgroundSize: backgroundSize,
	                            scale: 1,
	                            translateX: 50,
	                            translateY: 50,
	                            backgroundPositionX: 'center',
	                            backgroundPositionY: 'center'
	                        });
	                    } else {
	                        // contain
	                        properyChange({
	                            backgroundSize: backgroundSize,
	                            scale: 1,
	
	                            translateX: 0,
	                            translateY: 0,
	                            backgroundPositionX: 'center',
	                            backgroundPositionY: 'center'
	                        });
	                    }
	                }
	            },
	            _react2.default.createElement(_materialUi.MenuItem, { key: 'c2', value: 'contain', primaryText: 'Contain image in widget' }),
	            _react2.default.createElement(_materialUi.MenuItem, { key: 'c1', value: 'cover', primaryText: 'Cover whole widget' })
	        ),
	        !disableTopOverlay && _react2.default.createElement(_materialUi.Toggle, {
	            label: 'Top Overlay',
	            defaultToggled: layer.topOverlay === true,
	            onToggle: function onToggle(e, isInputChecked) {
	                properyChange({
	                    topOverlay: isInputChecked
	                });
	            }
	        })
	    );
	};
	
	var FieldsForZoomable = function FieldsForZoomable(_ref2) {
	    var layer = _ref2.layer,
	        properyChange = _ref2.properyChange,
	        disableTopOverlay = _ref2.disableTopOverlay;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            HSection,
	            null,
	            _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    floatingLabelText: 'Horizontal',
	                    value: layer.backgroundPositionX,
	                    key: 'backgroundPositionX',
	                    style: { width: 150 },
	                    onChange: function onChange(e, index, backgroundPositionX) {
	                        properyChange({ backgroundPositionX: backgroundPositionX });
	                    }
	                },
	                ['center', 'left', 'right', 'moveX'].map(function (o) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: o, value: o, primaryText: o });
	                })
	            ),
	            layer.backgroundPositionX === 'moveX' && _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'row', width: '100%' } },
	                _react2.default.createElement(_materialUi.Slider, {
	                    step: 1,
	                    min: -1000,
	                    max: 1000,
	                    key: 'translateX',
	                    value: layer.translateX,
	                    sliderStyle: {
	                        marginBottom: '0px',
	                        marginTop: '12px'
	                    },
	                    style: {
	                        flexGrow: 1,
	                        width: '100%',
	                        marginRight: 5
	                    },
	                    onChange: function onChange(e, translateX) {
	                        properyChange({ translateX: translateX });
	                    }
	                }),
	                _react2.default.createElement(_materialUi.FlatButton, {
	                    label: 'reset',
	                    onClick: function onClick() {
	                        properyChange({ translateX: 0 });
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            HSection,
	            null,
	            _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    floatingLabelText: 'Vertical',
	                    value: layer.backgroundPositionY,
	                    key: 'backgroundPositionY',
	                    style: { width: 150 },
	                    onChange: function onChange(e, index, backgroundPositionY) {
	                        properyChange({ backgroundPositionY: backgroundPositionY });
	                    }
	                },
	                ['center', 'top', 'bottom', 'moveY'].map(function (o) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: o, value: o, primaryText: o });
	                })
	            ),
	            layer.backgroundPositionY === 'moveY' && _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'row', width: '100%' } },
	                _react2.default.createElement(_materialUi.Slider, {
	                    step: 1,
	                    min: -1000,
	                    max: 1000,
	                    key: 'translateY',
	                    value: layer.translateY,
	                    sliderStyle: {
	                        marginBottom: '0px',
	                        marginTop: '12px'
	                    },
	                    style: {
	                        flexGrow: 1,
	                        width: '100%',
	                        marginRight: 5
	                    },
	                    onChange: function onChange(e, translateY) {
	                        properyChange({ translateY: translateY });
	                    }
	                }),
	                _react2.default.createElement(_materialUi.FlatButton, {
	                    label: 'reset',
	                    onClick: function onClick() {
	                        properyChange({ translateY: 0 });
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _Subheader2.default,
	            null,
	            'Scale/Zoom'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'row', width: '100%' } },
	            _react2.default.createElement(_materialUi.Slider, {
	                step: 0.1,
	                min: 1,
	                max: 10,
	                key: 'Scale',
	                value: layer.scale,
	                sliderStyle: {
	                    marginBottom: '0px',
	                    marginTop: '12px'
	                },
	                style: {
	                    flexGrow: 1,
	                    width: '100%',
	                    marginRight: 5
	                },
	                onChange: function onChange(e, scale) {
	                    properyChange({ scale: scale });
	                }
	            }),
	            _react2.default.createElement(_materialUi.FlatButton, {
	                label: 'reset',
	                onClick: function onClick() {
	                    properyChange({ scale: 1.0 });
	                }
	            })
	        )
	    );
	};
	
	var FieldsForCover = function FieldsForCover(_ref3) {
	    var layer = _ref3.layer,
	        properyChange = _ref3.properyChange;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _Subheader2.default,
	            { key: '1' },
	            'Move X (if landscape)'
	        ),
	        _react2.default.createElement(_materialUi.Slider, {
	            step: 1,
	            min: 0,
	            max: 100,
	            key: 'translateX',
	            value: layer.translateX,
	            sliderStyle: {
	                marginBottom: '0px',
	                marginTop: '12px'
	            },
	            onChange: function onChange(e, translateX) {
	                properyChange({ translateX: translateX });
	            }
	        }),
	        _react2.default.createElement(
	            _Subheader2.default,
	            { key: '2' },
	            'Move Y (if portrait)'
	        ),
	        _react2.default.createElement(_materialUi.Slider, {
	            step: 1,
	            min: 0,
	            max: 100,
	            key: 'translateY',
	            value: layer.translateY,
	            sliderStyle: {
	                marginBottom: '0px',
	                marginTop: '12px'
	            },
	            onChange: function onChange(e, translateY) {
	                properyChange({ translateY: translateY });
	            }
	        })
	    );
	};
	
	var Fields = function Fields(_ref4) {
	    var layer = _ref4.layer,
	        properyChange = _ref4.properyChange,
	        disableTopOverlay = _ref4.disableTopOverlay;
	
	    var bgrCover = !(layer.backgroundSize === 'contain' || layer.backgroundSize === 'initial');
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(CommonFields, { layer: layer, properyChange: properyChange, disableTopOverlay: disableTopOverlay }),
	        bgrCover ? _react2.default.createElement(FieldsForCover, { layer: layer, properyChange: properyChange, disableTopOverlay: disableTopOverlay }) : _react2.default.createElement(FieldsForZoomable, { layer: layer, properyChange: properyChange, disableTopOverlay: disableTopOverlay }),
	        _react2.default.createElement(
	            _Subheader2.default,
	            null,
	            'Opacity'
	        ),
	        _react2.default.createElement(_materialUi.Slider, {
	            step: 0.1,
	            min: 0.1,
	            max: 1,
	            key: 'Opacity',
	            value: layer.opacity,
	            sliderStyle: {
	                marginBottom: '0px',
	                marginTop: '12px'
	            },
	            onChange: function onChange(e, opacity) {
	                properyChange({ opacity: opacity });
	            }
	        })
	    );
	};
	
	exports.default = PreviewImagePicker;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1180);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _utils = __webpack_require__(1181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _thumbs = __webpack_require__(1182);
	
	var _thumbs2 = _interopRequireDefault(_thumbs);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FastImagesPicker = __webpack_require__(1183);
	
	var _FastImagesPicker2 = _interopRequireDefault(_FastImagesPicker);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageUploaderContainer = function (_React$Component) {
	    _inherits(ImageUploaderContainer, _React$Component);
	
	    function ImageUploaderContainer(props) {
	        _classCallCheck(this, ImageUploaderContainer);
	
	        var _this = _possibleConstructorReturn(this, (ImageUploaderContainer.__proto__ || Object.getPrototypeOf(ImageUploaderContainer)).call(this, props));
	
	        _this.loadData = function () {
	            var additionalState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var token = _auth2.default.getAccessToken();
	            return _bluebird2.default.props({
	                userImages: fetch(_cfg2.default.dash.api.host + '/api/media?access_token=' + token).then(function (response) {
	                    return response.json();
	                }),
	                userImagesSize: fetch(_cfg2.default.dash.api.host + '/api/media/size?access_token=' + token).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (response) {
	                var userImages = response.userImages,
	                    userImagesSize = response.userImagesSize;
	
	                _this.setState(_extends({}, additionalState, { userImages: userImages, userImagesSize: userImagesSize }));
	            });
	        };
	
	        _this.onUpload = function () {
	            var user = _this.context.user;
	            var userId = user._id,
	                client = user.client,
	                username = user.username;
	
	
	            _this.setState({
	                imageUploading: true
	            });
	
	            var _this$state = _this.state,
	                imageToUpload = _this$state.imageToUpload,
	                imageToUploadName = _this$state.imageToUploadName,
	                imageToUploadKind = _this$state.imageToUploadKind;
	
	            if (!imageToUploadName) imageToUploadName = imageToUpload.name;
	
	            var formData = new FormData();
	            formData.append('file', imageToUpload);
	            formData.append('userName', client + '_' + username);
	            formData.append('imageName', imageToUploadName);
	            formData.append('imageKind', imageToUploadKind);
	
	            var additionalState = {
	                imageToUpload: null,
	                imageToUploadName: '',
	                imageToUploadKind: 'other',
	                imageUploading: false
	            };
	
	            var token = _auth2.default.getAccessToken();
	            return fetch(_cfg2.default.dash.api.host + '/api/media/upload?access_token=' + token, {
	                method: 'POST',
	                body: formData
	            }).then(function (response) {
	                if (response.status === 200) {
	                    return response.json();
	                }
	            }).then(function (uploadInfo) {
	                if (uploadInfo.error) {
	                    _this.setState(_extends({}, additionalState, { uploadError: true, uploadErrorMessage: uploadInfo.message }));
	                } else {
	                    _this.setState({ uploadOK: true });
	                    _this.loadData(additionalState);
	                }
	            }).catch(function (e) {
	                _this.setState(_extends({}, additionalState, {
	                    uploadError: true,
	                    uploadErrorMessage: 'Could not upload image. Try again.'
	                }));
	            });
	        };
	
	        _this.onDelete = function (key, keys) {
	            var user = _this.context.user;
	            var userId = user._id;
	
	            var token = _auth2.default.getAccessToken();
	
	            fetch(_cfg2.default.dash.api.host + '/api/media/delete?access_token=' + token, {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    keys: keys,
	                    key: key
	                })
	            }).then(function (response) {
	                if (response.status === 200) {
	                    return response.json();
	                }
	            }).then(function (response) {
	                _this.loadData({ drawerOpen: false, pickedImgKey: null });
	            });
	        };
	
	        _this.onPick = function (value, img) {
	            _this.setState({
	                drawerOpen: img.key !== _this.state.pickedImgKey,
	                pickedImgKey: img.key === _this.state.pickedImgKey ? null : img.key
	            });
	        };
	
	        _this.renderSize = function () {
	            return _utils2.default.bytesToSize(_this.state.userImagesSize, 2);
	        };
	
	        _this.onDrop = function (acceptedFiles, rejectedFiles) {
	            var image = _lodash2.default.first(acceptedFiles);
	            if (image.size > 5 * 1024 * 1024) {
	                _this.setState({
	                    imageToUpload: null,
	                    imageToUploadName: '',
	                    imageToUploadKind: 'other',
	                    imageUploading: false,
	                    uploadError: true,
	                    uploadErrorMessage: 'Size of the image is more than 5 MB'
	                });
	            } else {
	                _this.setState({
	                    imageToUpload: image,
	                    imageToUploadName: image.name.replace('.' + _utils2.default.getExtension(image.name), '')
	                });
	            }
	        };
	
	        _this.onImageNameChange = function (e) {
	            _this.setState({
	                imageToUploadName: e.target.value
	            });
	        };
	
	        _this.onImageKindChange = function (e, index, value) {
	            _this.setState({
	                imageToUploadKind: value
	            });
	        };
	
	        _this.onImageUploadCancel = function () {
	            _this.setState({
	                imageToUpload: null,
	                imageToUploadName: '',
	                imageToUploadKind: 'other',
	                imageUploaderOpen: false
	            });
	        };
	
	        _this.renderImageDetails = function () {
	            var img = _this.state.userImages.find(function (i) {
	                return i.key === _this.state.pickedImgKey;
	            });
	            if (!img) return null;
	
	            var name = img.name,
	                thumbs = img.thumbs,
	                url = img.url,
	                cdnUrl = img.cdnUrl,
	                s3Url = img.s3Url,
	                width = img.width,
	                height = img.height;
	
	            var previewUrl = thumbs.find(function (t) {
	                return t.size === 'preview';
	            }).s3Url;
	
	            var cdnLabel = _this.props.cdnLabel || 'CDN';
	            var copyButtons = [{ url: cdnUrl, label: cdnLabel }];
	
	            if (!_this.props.cdnOnly) {
	                var s3Label = _this.props.s3Label || 'S3';
	                copyButtons.push({ url: s3Url, label: s3Label });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-image-uploader__image-details', style: { paddingTop: 70 } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'rlz-image-uploader__image-details__thumb__name' },
	                    width,
	                    ' x ',
	                    height,
	                    ' (original)'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__image-details__preview' },
	                    _react2.default.createElement(
	                        rmd.Paper,
	                        { zDepth: 1 },
	                        _react2.default.createElement('img', { src: cdnUrl, alt: name, height: 200, style: { objectFit: 'contain' } })
	                    ),
	                    _this.renderCopyButtons(copyButtons)
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__image-details__thumbs' },
	                    thumbs.map(function (t) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: t.key, className: 'rlz-image-uploader__image-details__thumb' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'rlz-image-uploader__image-details__thumb__name' },
	                                t.width,
	                                ' x ',
	                                t.height
	                            ),
	                            _react2.default.createElement(
	                                rmd.Paper,
	                                { zDepth: 1 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'rlz-image-uploader__image-details__thumb__image' },
	                                    _react2.default.createElement('img', {
	                                        src: t.s3Url || t.cdnUrl || previewUrl,
	                                        alt: t.size,
	                                        style: { objectFit: 'contain' }
	                                    })
	                                )
	                            ),
	                            _this.renderCopyButtons(copyButtons)
	                        );
	                    })
	                ),
	                _react2.default.createElement('div', { className: 'rlz-image-uploader__image-details__info' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__image-details__actions' },
	                    _react2.default.createElement(rmd.RaisedButton, {
	                        onClick: function onClick() {
	                            var keys = [img.key];
	                            img.thumbs.map(function (t) {
	                                return keys.push(t.key);
	                            });
	                            _this.onDelete(img.key, keys);
	                        },
	                        label: 'Delete',
	                        secondary: true
	                    })
	                )
	            );
	        };
	
	        _this.renderCopyButtons = function () {
	            var buttons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-image-uploader__copy-buttons' },
	                buttons.map(function (btn) {
	                    return _react2.default.createElement(
	                        _reactCopyToClipboard2.default,
	                        {
	                            key: btn.url,
	                            text: btn.url,
	                            onCopy: _this.props.onCopy || function (value) {
	                                return _this.setState({ copyToastOpen: true });
	                            }
	                        },
	                        _react2.default.createElement(rmd.RaisedButton, { label: btn.label })
	                    );
	                })
	            );
	        };
	
	        _this.renderUploadBox = function () {
	            var _this$state2 = _this.state,
	                imageToUpload = _this$state2.imageToUpload,
	                imageToUploadName = _this$state2.imageToUploadName,
	                imageUploading = _this$state2.imageUploading;
	
	            var _ref = imageToUpload || {},
	                imagePreview = _ref.preview;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-image-uploader__upload-box' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Upload image (drag and drop or add)'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__upload' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-image-uploader__image-input' },
	                        _react2.default.createElement(
	                            _reactDropzone2.default,
	                            { onDrop: _this.onDrop },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rlz-image-uploader__image-preview' },
	                                _react2.default.createElement(_add2.default, null),
	                                _react2.default.createElement('img', { src: imagePreview })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-image-uploader__upload-control' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Configure'
	                        ),
	                        _react2.default.createElement(rmd.TextField, {
	                            floatingLabelText: 'Image name (unique) *',
	                            value: _this.state.imageToUploadName,
	                            onChange: _this.onImageNameChange
	                        }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            rmd.SelectField,
	                            {
	                                floatingLabelText: 'Resource type',
	                                value: _this.state.imageToUploadKind,
	                                onChange: _this.onImageKindChange
	                            },
	                            _thumbs2.default.map(function (t) {
	                                return _react2.default.createElement(rmd.MenuItem, { key: t.kind, value: t.kind, primaryText: t.kind });
	                            })
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(rmd.FlatButton, {
	                            label: imageUploading ? 'Uploading...' : 'Upload',
	                            primary: true,
	                            disabled: !imageToUploadName || imageUploading,
	                            onTouchTap: _this.onUpload
	                        }),
	                        _react2.default.createElement(rmd.FlatButton, {
	                            label: 'Cancel',
	                            primary: true,
	                            disabled: imageUploading || !imageToUpload,
	                            onTouchTap: _this.onImageUploadCancel
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.renderGallery = function () {
	            var images = _lodash2.default.sortBy(_this.state.userImages, function (img) {
	                return -new Date(img.createdAt);
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-image-uploader__gallery' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Gallery'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__used-space' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Used space: ',
	                        _this.renderSize()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-image-uploader__uploaded-images' },
	                    _react2.default.createElement(_FastImagesPicker2.default, {
	                        images: images,
	                        onDelete: _this.onDelete,
	                        onPick: _this.onPick,
	                        pickedKey: _this.state.pickedImgKey
	                    })
	                )
	            );
	        };
	
	        _this.state = {
	            imageToUpload: null,
	            imageToUploadName: '',
	            imageToUploadKind: 'other',
	            copyToastOpen: false,
	            uploadError: false,
	            uploadErrorMessage: '',
	            imageUploading: false,
	            pickedImgKey: null,
	            drawerOpen: false,
	            userImagesSize: 0,
	            userImages: []
	        };
	        return _this;
	    }
	
	    _createClass(ImageUploaderContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'renderModal',
	        value: function renderModal() {
	            return _react2.default.createElement(
	                rmd.Dialog,
	                {
	                    modal: true,
	                    open: true,
	                    autoScrollBodyContent: true,
	                    contentStyle: {
	                        overflow: 'hidden'
	                    },
	                    actions: [_react2.default.createElement(rmd.FlatButton, { label: 'close', onClick: this.props.onClose })],
	                    onRequestClose: this.props.onClose
	                },
	                this.renderContent()
	            );
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var _this2 = this;
	
	            var drawerOpen = this.state.drawerOpen;
	            var _props = this.props,
	                showGallery = _props.showGallery,
	                galleryFirst = _props.galleryFirst,
	                modal = _props.modal;
	
	
	            var wrapperClasses = (0, _classnames2.default)('rlz-image-uploader', {});
	
	            return _react2.default.createElement(
	                'div',
	                { className: wrapperClasses },
	                showGallery && galleryFirst && this.renderGallery(),
	                this.renderUploadBox(),
	                showGallery && !galleryFirst && this.renderGallery(),
	                _react2.default.createElement(
	                    rmd.Drawer,
	                    {
	                        className: 'rlz-image-uploader__image-details-bar',
	                        width: 400,
	                        openSecondary: true,
	                        open: this.state.drawerOpen,
	                        disableSwipeToOpen: true
	                    },
	                    _react2.default.createElement(rmd.AppBar, {
	                        onLeftIconButtonTouchTap: function onLeftIconButtonTouchTap() {
	                            _this2.setState({ drawerOpen: false, pickedImgKey: null });
	                        },
	                        iconElementLeft: _react2.default.createElement(
	                            rmd.IconButton,
	                            null,
	                            _react2.default.createElement(_close2.default, null)
	                        ),
	                        style: { zIndex: 100000, top: !modal && 64 },
	                        title: (this.state.userImages.find(function (i) {
	                            return i.key === _this2.state.pickedImgKey;
	                        }) || {}).name
	                    }),
	                    this.renderImageDetails()
	                ),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.copyToastOpen,
	                    message: 'Copied to clipboard',
	                    autoHideDuration: 2000,
	                    onActionTouchTap: function onActionTouchTap() {
	                        return _this2.setState({ copyToastOpen: false });
	                    }
	                }),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.uploadOK,
	                    message: 'IMAGE WAS UPLOADED',
	                    autoHideDuration: 4000,
	                    bodyStyle: {},
	                    onRequestClose: function onRequestClose() {
	                        return _this2.setState({ uploadError: false, uploadOK: false });
	                    }
	                }),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.uploadError,
	                    message: this.state.uploadErrorMessage,
	                    autoHideDuration: 4000,
	                    bodyStyle: { backgroundColor: 'rgba(198,40,40,0.8)' },
	                    onRequestClose: function onRequestClose() {
	                        return _this2.setState({ uploadError: false, uploadErrorMessage: '' });
	                    }
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var drawerOpen = this.state.drawerOpen;
	            var _props2 = this.props,
	                galleryFirst = _props2.galleryFirst,
	                modal = _props2.modal;
	
	
	            if (modal) return this.renderModal();
	            return this.renderContent();
	        }
	    }]);
	
	    return ImageUploaderContainer;
	}(_react2.default.Component);
	
	ImageUploaderContainer.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	ImageUploaderContainer.defaultProps = {
	    showGallery: true,
	    galleryFirst: false
	};
	exports.default = ImageUploaderContainer;

/***/ },
/* 1180 */,
/* 1181 */
/***/ function(module, exports) {

	'use strict';
	
	var utils = {
	    getExtension: function getExtension(fname) {
	        return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
	    },
	    bytesToSize: function bytesToSize(bytes, decimals) {
	        if (bytes == 0) return '0 Bytes';
	        var k = 1000,
	            dm = decimals + 1 || 3,
	            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            i = Math.floor(Math.log(bytes) / Math.log(k));
	        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	    }
	};
	
	module.exports = utils;

/***/ },
/* 1182 */
/***/ function(module, exports) {

	'use strict';
	
	var thumbs = [{
	    kind: 'avatar',
	    variants: [{
	        size: 'preview',
	        width: 300,
	        height: 300
	    }, {
	        size: 'small',
	        square: true,
	        width: 100
	    }, {
	        size: 'medium',
	        square: true,
	        width: 200
	    }, {
	        size: 'large',
	        square: true,
	        width: 300
	    }]
	}, {
	    kind: 'other',
	    variants: [{
	        size: 'preview',
	        width: 480,
	        height: 320
	    }, {
	        size: 'small',
	        width: 960,
	        height: 540
	    }, {
	        size: 'medium',
	        width: 1366,
	        height: 768
	    }, {
	        size: 'large',
	        width: 1920,
	        height: 1080
	    }]
	}];
	
	module.exports = thumbs;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _reactDropzone = __webpack_require__(1180);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FastImagesPicker = function FastImagesPicker(_ref) {
	    var images = _ref.images,
	        onPick = _ref.onPick,
	        pickedKey = _ref.pickedKey,
	        upload = _ref.upload,
	        onDrop = _ref.onDrop,
	        uploadPreview = _ref.uploadPreview,
	        uploading = _ref.uploading,
	        _ref$gridSize = _ref.gridSize,
	        gridSize = _ref$gridSize === undefined ? 5 : _ref$gridSize,
	        itemHeight = _ref.itemHeight;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'rlz-fast-image-picker' },
	        upload && _react2.default.createElement(
	            rmd.Paper,
	            { zDepth: 1, key: 'dropzone', className: 'rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__image-input rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__uploaded-image__grid-size-' + gridSize },
	            _react2.default.createElement(
	                _reactDropzone2.default,
	                { onDrop: onDrop, style: { height: itemHeight } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-fast-image-picker__image-preview', style: { height: itemHeight } },
	                    _react2.default.createElement(_add2.default, null),
	                    _react2.default.createElement('img', { src: uploadPreview })
	                )
	            ),
	            uploading && _react2.default.createElement(
	                'span',
	                { className: 'rlz-fast-image-picker__uploading-indicator' },
	                _react2.default.createElement(rmd.CircularProgress, { size: 80, thickness: 5 })
	            )
	        ),
	        images.map(function (img, i) {
	
	            var previewUrl = img.thumbs.find(function (t) {
	                return t.size == 'preview';
	            }).url;
	
	            return _react2.default.createElement(
	                rmd.Paper,
	                { zDepth: pickedKey == img.key ? 4 : 1, key: i, className: 'rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__uploaded-image__grid-size-' + gridSize },
	                _react2.default.createElement(
	                    _reactCopyToClipboard2.default,
	                    { text: img.url, onCopy: function onCopy(value) {
	                            onPick(value, img);
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-fast-image-picker__uploaded-image-preview-wrapper', style: { height: itemHeight } },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', { className: 'rlz-fast-image-picker__uploaded-image-preview', src: previewUrl })
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = FastImagesPicker;

/***/ },
/* 1184 */,
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransferPicker = function (_React$Component) {
	    _inherits(TransferPicker, _React$Component);
	
	    function TransferPicker(props, context) {
	        _classCallCheck(this, TransferPicker);
	
	        var _this = _possibleConstructorReturn(this, (TransferPicker.__proto__ || Object.getPrototypeOf(TransferPicker)).call(this, props, context));
	
	        _this.handleTeamChange = function (key, teamId) {
	            _this.setState({
	                teamId: teamId
	            }, _this.loadTransfers);
	        };
	
	        _this.handleTransferChange = function (srting, index, value) {
	            var transfer = _this.state.transfers.find(function (t) {
	                return t.id === value;
	            });
	
	            if (transfer) {
	                _this.props.onChange(_this.state.keyProperty, transfer.id);
	                _this.setState({
	                    transferId: transfer.id
	                });
	            } else {
	                _this.props.onChange(_this.state.keyProperty, null);
	            }
	        };
	
	        var keyProperty = _this.getPropertyFor('transferId');
	
	        _this.state = {
	            keyProperty: keyProperty,
	            transfers: [],
	            transferId: props[keyProperty] && +props[keyProperty]
	        };
	        return _this;
	    }
	
	    _createClass(TransferPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadTransfers();
	        }
	    }, {
	        key: 'loadTransfers',
	        value: function loadTransfers() {
	            var _this2 = this;
	
	            var _state = this.state,
	                transferId = _state.transferId,
	                teamId = _state.teamId;
	
	
	            return Promise.all([fetch(_cfg2.default.apis.ss2 + '/transfers' + (teamId ? '?teamId=' + teamId + '&limit=500' : '')).then(function (response) {
	                return response.json();
	            })]).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    transfers = _ref2[0],
	                    teams = _ref2[1];
	
	                _this2.setState({
	                    transfers: transfers,
	                    teamId: teamId,
	                    transferId: transferId
	                });
	            }).catch(function (e) {
	                _this2.setState({ transfers: [] });
	            });
	        }
	    }, {
	        key: 'getPropertyFor',
	        value: function getPropertyFor(key) {
	            return _lodash2.default.get(this, 'props.propsMap[' + key + ']', key);
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            return _react2.default.createElement(rmd.MenuItem, { key: option.value, value: option.value, primaryText: option.text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state2 = this.state,
	                transfers = _state2.transfers,
	                transferId = _state2.transferId;
	
	
	            var transfersOptions = transfers.filter(function (t) {
	                return t.type === 'transfer';
	            }).map(function (t) {
	                return {
	                    text: t.playerName + '. ' + t.fromTeamName + ' to ' + t.toTeamName,
	                    value: t.id
	                };
	            });
	
	            var rumourOptions = transfers.filter(function (t) {
	                return t.type === 'rumour';
	            }).map(function (t) {
	                return {
	                    text: t.playerName + '. ' + t.fromTeamName + ' to ' + t.toTeamName,
	                    value: t.id
	                };
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TeamPicker2.default, { onChange: this.handleTeamChange }),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    { floatingLabelText: 'Transfer', value: transferId, onChange: this.handleTransferChange },
	                    [{ value: null, text: 'Custom' }].concat(_toConsumableArray(transfersOptions)).map(this.renderOption)
	                ),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    { floatingLabelText: 'Rumour', value: transferId, onChange: this.handleTransferChange },
	                    [{ value: null, text: 'Custom' }].concat(_toConsumableArray(rumourOptions)).map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return TransferPicker;
	}(_react2.default.Component);
	
	exports.default = TransferPicker;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePickerBySport = function (_React$Component) {
	    _inherits(DatePickerBySport, _React$Component);
	
	    function DatePickerBySport(props, context) {
	        _classCallCheck(this, DatePickerBySport);
	
	        var _this = _possibleConstructorReturn(this, (DatePickerBySport.__proto__ || Object.getPrototypeOf(DatePickerBySport)).call(this, props, context));
	
	        _this.handleDateChange = function (key, value) {
	            var date = (0, _moment2.default)(value).local();
	            var from = date.format('YYYY-MM-DD');
	            _this.setState({ date: value });
	            _this.props.onChange('date', from);
	        };
	
	        _this.handleChange = function (event, index, value) {
	            _this.setState({
	                sport: value,
	                disabledPickerValue: value !== _lodash2.default.head(_this.props.sports)
	            });
	
	            _this.props.onChange('sport', value);
	        };
	
	        _this.state = {
	            date: props.date ? new Date(props.date) : new Date(),
	            disabledPickerValue: true,
	            sport: props.sport || props.defaultSportValue
	        };
	        return _this;
	    }
	
	    _createClass(DatePickerBySport, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleDateChange(null, this.state.date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        floatingLabelText: 'Sport',
	                        style: { overflow: 'hidden', width: '100%' },
	                        value: this.state.sport,
	                        disabled: !this.state.date,
	                        autoWidth: true,
	                        onChange: this.handleChange
	                    },
	                    this.props.sports.map(function (sport, i) {
	                        return _react2.default.createElement(rmd.MenuItem, { style: { minWidth: '400px' }, key: i, value: sport, primaryText: sport });
	                    })
	                ),
	                !this.state.disabledPickerValue && _react2.default.createElement(rmd.DatePicker, {
	                    hintText: 'Choose date',
	                    style: { overflow: 'hidden', width: '100%' },
	                    floatingLabelText: 'Date (when all sports)',
	                    value: this.state.date,
	                    container: 'dialog',
	                    autoOk: true,
	                    onChange: this.handleDateChange
	                })
	            );
	        }
	    }]);
	
	    return DatePickerBySport;
	}(_react2.default.Component);
	
	exports.default = DatePickerBySport;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YEARS = _lodash2.default.range(2001, +(0, _moment2.default)().format('YYYY') + 1).reverse();
	
	var F1GrandPrixPicker = function (_Component) {
	    _inherits(F1GrandPrixPicker, _Component);
	
	    function F1GrandPrixPicker(props, context) {
	        _classCallCheck(this, F1GrandPrixPicker);
	
	        var _this = _possibleConstructorReturn(this, (F1GrandPrixPicker.__proto__ || Object.getPrototypeOf(F1GrandPrixPicker)).call(this, props, context));
	
	        _this.handleYearChange = function (e, key, payload) {
	            _this.setState({ year: payload, gpxId: undefined, disabled: false }, function () {
	                // this.props.onChange({ year: payload, gpxId: undefined });
	                _this.props.onChange(_this.getPropertyFor('year'), payload);
	                _this.loadData();
	            });
	        };
	
	        _this.handleGrandPrixChange = function (e, key, payload) {
	            _this.setState({ gpxId: payload }, function () {
	                _this.props.onChange(_this.getPropertyFor('gpxId'), payload);
	            });
	        };
	
	        _this.state = {
	            year: props.year || (0, _moment2.default)().year(),
	            gpxId: props.gpxId || null
	        };
	        return _this;
	    }
	
	    _createClass(F1GrandPrixPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this2 = this;
	
	            var year = this.state.year;
	
	
	            return fetch(_cfg2.default.apis.ss2 + '/f1/gpx?year=' + year).then(function (response) {
	                return response.json();
	            }).then(function (gp) {
	                _this2.setState({
	                    grandPrix: _lodash2.default.sortBy(gp, 'startDate')
	                });
	            }).catch(function (e) {});
	        }
	    }, {
	        key: 'getPropertyFor',
	        value: function getPropertyFor(key) {
	            return _lodash2.default.get(this, 'props.propsMap[' + key + ']', key);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.grandPrix) return null;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        value: this.state.year,
	                        floatingLabelText: 'Year',
	                        onChange: this.handleYearChange
	                    },
	                    YEARS.map(function (y) {
	                        return _react2.default.createElement(rmd.MenuItem, { key: y, value: y, primaryText: y });
	                    })
	                ),
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        value: this.state.gpxId,
	                        floatingLabelText: 'Grand Prix',
	                        onChange: this.handleGrandPrixChange
	                    },
	                    this.state.grandPrix.map(function (gp) {
	                        return _react2.default.createElement(rmd.MenuItem, { key: gp.id, value: gp.id, primaryText: gp.name_en || '---' });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return F1GrandPrixPicker;
	}(_react.Component);
	
	F1GrandPrixPicker.defaultProps = {};
	exports.default = F1GrandPrixPicker;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OddsPicker = function (_Component) {
	    _inherits(OddsPicker, _Component);
	
	    function OddsPicker(props, context) {
	        _classCallCheck(this, OddsPicker);
	
	        var _this = _possibleConstructorReturn(this, (OddsPicker.__proto__ || Object.getPrototypeOf(OddsPicker)).call(this, props, context));
	
	        _this.state = {
	            oldValue: props[props.propKey + 'Old'] || '',
	            newValue: props[props.propKey + 'New'] || ''
	        };
	        return _this;
	    }
	
	    _createClass(OddsPicker, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: '15px' } },
	                    this.props.label
	                ),
	                _react2.default.createElement(rmd.TextField, {
	                    value: this.state.oldValue,
	                    onChange: function onChange(e, value) {
	                        _this2.setState({ oldValue: value }, function () {
	                            _this2.props.onChange(_this2.props.propKey + 'Old', value);
	                        });
	                    },
	                    errorText: this.props.error,
	                    floatingLabelText: 'Old' || '' + this.props.propKey,
	                    fullWidth: false,
	                    style: { margin: '0 5px', width: 'calc(50% - 10px)' }
	                }),
	                _react2.default.createElement(rmd.TextField, {
	                    value: this.state.newValue,
	                    onChange: function onChange(e, value) {
	                        _this2.setState({ newValue: value }, function () {
	                            _this2.props.onChange(_this2.props.propKey + 'New', value);
	                        });
	                    },
	                    errorText: this.props.error,
	                    floatingLabelText: 'New' || '' + this.props.propKey,
	                    fullWidth: false,
	                    style: { margin: '0 5px', width: 'calc(50% - 10px)' }
	                })
	            );
	        }
	    }]);
	
	    return OddsPicker;
	}(_react.Component);
	
	OddsPicker.defaultProps = {};
	exports.default = OddsPicker;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PROVIDERS = ['comeon', 'betbull'];
	
	var OddsProviderPicker = function (_Component) {
	    _inherits(OddsProviderPicker, _Component);
	
	    function OddsProviderPicker(props, context) {
	        _classCallCheck(this, OddsProviderPicker);
	
	        var _this = _possibleConstructorReturn(this, (OddsProviderPicker.__proto__ || Object.getPrototypeOf(OddsProviderPicker)).call(this, props, context));
	
	        _this.handleChange = function (e, key, payload) {
	            _this.props.onChange(_this.props.propKey, payload);
	            _this.setState({ value: payload });
	        };
	
	        _this.state = {
	            value: props[props.propKey]
	        };
	        return _this;
	    }
	
	    _createClass(OddsProviderPicker, [{
	        key: 'renderOption',
	        value: function renderOption(value) {
	            return _react2.default.createElement(rmd.MenuItem, { key: value, value: value, primaryText: value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    rmd.SelectField,
	                    {
	                        style: { width: '100%' },
	                        value: this.state.value,
	                        floatingLabelText: this.props.label,
	                        floatingLabelFixed: true,
	                        onChange: this.handleChange
	                    },
	                    PROVIDERS.map(this.renderOption)
	                )
	            );
	        }
	    }]);
	
	    return OddsProviderPicker;
	}(_react.Component);
	
	OddsProviderPicker.defaultProps = {};
	exports.default = OddsProviderPicker;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    color: rgba(0, 0, 0, 0.3);\n    font-size: 12px;\n    display: block;\n    margin-bottom: 10px;\n'], ['\n    color: rgba(0, 0, 0, 0.3);\n    font-size: 12px;\n    display: block;\n    margin-bottom: 10px;\n']);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Label = _styledComponents2.default.label(_templateObject);
	
	var MultipleBackgroundsPicker = function (_Component) {
	    _inherits(MultipleBackgroundsPicker, _Component);
	
	    function MultipleBackgroundsPicker(props, context) {
	        _classCallCheck(this, MultipleBackgroundsPicker);
	
	        var _this = _possibleConstructorReturn(this, (MultipleBackgroundsPicker.__proto__ || Object.getPrototypeOf(MultipleBackgroundsPicker)).call(this, props, context));
	
	        _this.onManipulation = function (e) {
	            if (_this.props.id !== e.detail.id) return;
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.positionControl.x !== _this.state.multipleOptions.positionControl.x || nextProps.positionControl.y !== _this.state.multipleOptions.positionControl.y) {
	                _this.setState(function (_ref) {
	                    var multipleOptions = _ref.multipleOptions;
	                    return {
	                        multipleOptions: _extends({}, multipleOptions, {
	                            positionControl: { x: nextProps.positionControl.x, y: nextProps.positionControl.y }
	                        })
	                    };
	                }, function () {
	                    _this.props.onChange(_this.props.propKey, _this.state.multipleOptions);
	                });
	            }
	
	            if (nextProps.url !== _this.state.multipleOptions.url) {
	                _this.setState(function (_ref2) {
	                    var multipleOptions = _ref2.multipleOptions;
	                    return {
	                        multipleOptions: _extends({}, multipleOptions, {
	                            url: nextProps.url,
	                            optimalScale: nextProps.imgControl.optimalScale,
	                            currentScale: nextProps.imgControl.currentScale
	                        })
	                    };
	                }, function () {
	                    _this.props.onChange(_this.props.propKey, _this.state.multipleOptions);
	                });
	            }
	        };
	
	        _this.onCheck = function (type) {
	            return function () {
	                var _this$props$imageCont;
	
	                var id = _this.props.id;
	
	
	                _this.setState(function (_ref3) {
	                    var multipleOptions = _ref3.multipleOptions;
	                    return {
	                        multipleOptions: _extends({}, multipleOptions, _defineProperty({}, '' + type, !multipleOptions[type]))
	                    };
	                }, function () {
	                    _this.props.onChange(_this.props.propKey, _this.state.multipleOptions);
	                });
	
	                _this.props.imageControl((_this$props$imageCont = {}, _defineProperty(_this$props$imageCont, type, !_this.props[type]), _defineProperty(_this$props$imageCont, 'id', id), _this$props$imageCont));
	            };
	        };
	
	        _this.handleSliderChange = function (event, value) {
	            var id = _this.props.id;
	            var optimalScale = _this.state.multipleOptions.optimalScale;
	
	
	            if (value >= optimalScale) {
	                _this.setState(function (_ref4) {
	                    var multipleOptions = _ref4.multipleOptions;
	                    return {
	                        multipleOptions: _extends({}, multipleOptions, { currentScale: value })
	                    };
	                }, function () {
	                    _this.props.onChange(_this.props.propKey, _this.state.multipleOptions);
	                });
	            }
	
	            _this.props.imageControl({
	                imgControl: _extends({}, _this.props.imgControl, { currentScale: value }),
	                id: id
	            });
	        };
	
	        _this.handleControlledDrag = function (e, position) {
	            var id = _this.props.id;
	            var x = position.x,
	                y = position.y;
	
	            //for stor
	
	            _this.props.imageDrag({
	                positionControl: { x: x, y: y },
	                id: id
	            });
	        };
	
	        _this.handleSliderDragStop = function () {
	            var _this$state$multipleO = _this.state.multipleOptions,
	                currentScale = _this$state$multipleO.currentScale,
	                positionControl = _this$state$multipleO.positionControl;
	            var _this$props = _this.props,
	                areaControl = _this$props.areaControl,
	                imgControl = _this$props.imgControl;
	
	            var maxXcoord = -(imgControl.width * currentScale - areaControl.width);
	            var maxYcoord = -(imgControl.height * currentScale - areaControl.height);
	
	            if (maxXcoord > positionControl.x || Math.floor(maxYcoord) > positionControl.y) {
	                _this.handleControlledDrag(null, { x: maxXcoord, y: maxYcoord / 2 });
	            }
	        };
	
	        _this.state = {
	            multipleOptions: props[props.propKey] || {
	                flipX: props.flipX,
	                flipY: props.flipY,
	                optimalScale: props.imgControl.optimalScale,
	                currentScale: props.imgControl.currentScale,
	                positionControl: { x: props.positionControl.x, y: props.positionControl.y },
	                url: props.url
	            }
	        };
	        return _this;
	    }
	
	    _createClass(MultipleBackgroundsPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var propKey = this.props.propKey;
	            var id = this.props.id;
	
	
	            this.props.imageControl({
	                url: this.props[propKey] && this.props[propKey].url ? this.props[propKey].url : this.props.url,
	                id: id
	            });
	            window.addEventListener('WDPBgrManipulations', this.onManipulation, false);
	        }
	
	        //for Checkbox
	
	
	        //when change zoom
	
	
	        //when drag image
	
	
	        //when end change zoom
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var currentScale = this.state.multipleOptions.currentScale;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Label,
	                    null,
	                    this.props.label
	                ),
	                _react2.default.createElement(rmd.Checkbox, {
	                    checked: this.state.multipleOptions['flipX'],
	                    label: 'Flip X',
	                    onCheck: this.onCheck('flipX')
	                }),
	                _react2.default.createElement(rmd.Checkbox, {
	                    checked: this.state.multipleOptions['flipY'],
	                    label: 'Flip Y',
	                    onCheck: this.onCheck('flipY')
	                }),
	                _react2.default.createElement(
	                    'span',
	                    { style: { padding: '30px 0 0', display: 'block' } },
	                    'Zoom'
	                ),
	                _react2.default.createElement(rmd.Slider, {
	                    min: 1,
	                    max: 10,
	                    step: 0.01,
	                    value: currentScale,
	                    onChange: this.handleSliderChange,
	                    onDragStop: this.handleSliderDragStop,
	                    style: { padding: '0 5px', boxSizing: 'border-box' }
	                })
	            );
	        }
	    }]);
	
	    return MultipleBackgroundsPicker;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var topScorersMultiBg = state.topScorersMultiBg;
	
	
	    return {
	        areaControl: topScorersMultiBg.areaControl,
	        imgControl: topScorersMultiBg.imgControl[props.id],
	        positionControl: topScorersMultiBg.positionControl[props.id],
	        flipX: topScorersMultiBg.flipX[props.id],
	        flipY: topScorersMultiBg.flipY[props.id],
	        url: topScorersMultiBg.url[props.id]
	    };
	}, { imageControl: _actions.imageControl, imageDrag: _actions.imageDrag })(MultipleBackgroundsPicker);

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.imageDrag = exports.imageControl = undefined;
	
	var _constants = __webpack_require__(1192);
	
	var imageControl = exports.imageControl = function imageControl(options) {
	    return {
	        type: _constants.IMAGE_CONTROL,
	        payload: options
	    };
	};
	
	var imageDrag = exports.imageDrag = function imageDrag(options) {
	    return {
	        type: _constants.IMAGE_DRAG,
	        payload: options
	    };
	};

/***/ },
/* 1192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IMAGE_CONTROL = exports.IMAGE_CONTROL = 'IMAGE_CONTROL';
	var IMAGE_DRAG = exports.IMAGE_DRAG = 'IMAGE_DRAG';

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    color: rgba(0, 0, 0, 0.3);\n    font-size: 12px;\n    display: block;\n    margin-bottom: 10px;\n'], ['\n    color: rgba(0, 0, 0, 0.3);\n    font-size: 12px;\n    display: block;\n    margin-bottom: 10px;\n']);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _recompose = __webpack_require__(1096);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _addCircleOutline = __webpack_require__(1112);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Label = _styledComponents2.default.label(_templateObject);
	
	
	var AreaManipulations = function AreaManipulations(_ref) {
	    var id = _ref.id,
	        onChange = _ref.onChange,
	        name = _ref.name,
	        props = _objectWithoutProperties(_ref, ['id', 'onChange', 'name']);
	
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0 ' } },
	        _react2.default.createElement('img', { src: props.url, style: { width: 50, height: 50, objectFit: 'cover' } }),
	        _react2.default.createElement(
	            'span',
	            { style: { padding: 10, flexGrow: 1 } },
	            name
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                onClick: function onClick(e) {
	                    onChange(id, null);
	                }
	            },
	            _react2.default.createElement(_close2.default, { color: '#fff' })
	        )
	    );
	};
	
	var DNDBgrPicker = function (_Component) {
	    _inherits(DNDBgrPicker, _Component);
	
	    function DNDBgrPicker(props, context) {
	        _classCallCheck(this, DNDBgrPicker);
	
	        var _this = _possibleConstructorReturn(this, (DNDBgrPicker.__proto__ || Object.getPrototypeOf(DNDBgrPicker)).call(this, props, context));
	
	        _this.onManipulation = function (e) {
	            // if (this.props.propKey !== e.detail.id) return;
	
	            _this.props.onChange(e.detail.id, _extends({}, _lodash2.default.get(_this.props, '' + e.detail.id, {}), e.detail.values));
	
	            // upstream changes
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            // console.log('WHAT', nextProps);
	        };
	
	        _this.state = props[props.propKey] || {};
	        _this.state.revision = 0;
	        return _this;
	    }
	
	    _createClass(DNDBgrPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            window.addEventListener('WDPBgrManipulations', this.onManipulation, false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var areas = _lodash2.default.chain(this.props).keys().filter(function (k) {
	                return k.indexOf('area') === 0 && _this2.props[k] && !_lodash2.default.isEmpty(_this2.props[k]);
	            }).map(function (key) {
	                return _extends({ key: key }, _this2.props[key]);
	            }).value();
	
	            var dnd = this.props[this.props.propKey] || {};
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                areas.map(function (area, index) {
	                    return _react2.default.createElement(AreaManipulations, _extends({
	                        key: area.key,
	                        id: area.key
	                    }, area, {
	                        name: index + '. layer',
	                        onChange: _this2.props.onChange
	                    }));
	                }),
	                areas.length < 5 && _react2.default.createElement(rmd.FlatButton, {
	                    icon: _react2.default.createElement(_addCircleOutline2.default, null),
	                    label: 'Add custom background',
	                    onClick: function onClick() {
	                        _this2.props.onChange('area' + (areas.length + 1), {
	                            init: 1
	                        });
	                    }
	                }),
	                _react2.default.createElement(rmd.Divider, { style: { marginTop: 15, marginBottom: 15 } }),
	                areas.length >= 2 && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        rmd.SelectField,
	                        {
	                            floatingLabelText: 'Direction',
	                            value: dnd.direction || 'row',
	                            onChange: function onChange(e, index, direction) {
	                                _this2.props.onChange(_this2.props.propKey, _extends({}, dnd, { direction: direction }));
	                            }
	                        },
	                        ['row', 'column'].map(function (t) {
	                            return _react2.default.createElement(rmd.MenuItem, { key: t, value: t, primaryText: t });
	                        })
	                    ),
	                    _react2.default.createElement(rmd.Toggle, {
	                        label: 'Split with border between',
	                        checked: dnd.border,
	                        style: { marginTop: 15 },
	                        onToggle: function onToggle(e, isChecked) {
	                            _this2.props.onChange(_this2.props.propKey, _extends({}, dnd, { border: isChecked }));
	                        }
	                    }),
	                    _react2.default.createElement(rmd.Divider, { style: { marginTop: 15, marginBottom: 15 } })
	                ),
	                _react2.default.createElement(_materialUi.FlatButton, {
	                    label: 'Upload image',
	                    style: { width: '100%' },
	                    onClick: function onClick() {
	                        _this2.setState({
	                            showUploader: true
	                        });
	                    }
	                }),
	                this.state.showUploader && _react2.default.createElement(_ImageUploaderContainer2.default, {
	                    onCopy: function onCopy(url) {
	                        alert(url);
	                    },
	                    onClose: function onClose() {
	                        _this2.setState({
	                            showUploader: false,
	                            revision: _this2.state.revision + 1
	                        });
	                    },
	                    modal: true,
	                    showGallery: false
	                })
	            );
	        }
	    }]);
	
	    return DNDBgrPicker;
	}(_react.Component);
	
	exports.default = DNDBgrPicker;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactColor = __webpack_require__(1195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayStyler = function (_React$Component) {
	    _inherits(OverlayStyler, _React$Component);
	
	    function OverlayStyler(props, context) {
	        _classCallCheck(this, OverlayStyler);
	
	        var _this = _possibleConstructorReturn(this, (OverlayStyler.__proto__ || Object.getPrototypeOf(OverlayStyler)).call(this, props, context));
	
	        _this.onOpacityChange = function (e, val) {
	            _this.setState({
	                opacity: val
	            }, _this.notifyChanges);
	            // var color = window.getComputedStyle(document.querySelector('.wdp.wdp_default .primary-color'), null).getPropertyValue('color');
	            // console.log("COLOR", color);
	        };
	
	        _this.onColorChange = function (name, val, e) {
	            var o = {};
	            o[name] = val.hex;
	            _this.setState(o, _this.notifyChanges);
	        };
	
	        _this.onChangeGradient = function (e, val) {
	            _this.setState({
	                gradient: val,
	                position: val == "radial" ? "center" : "to bottom right"
	            }, _this.notifyChanges);
	        };
	
	        _this.onChangeGradientPosition = function (e, val) {
	            _this.setState({
	                position: val
	            }, _this.notifyChanges);
	        };
	
	        _this.notifyChanges = function () {
	            _this.props.onChange('overlayStyle', JSON.stringify({
	                opacity: _this.state.opacity,
	                startColor: _this.state.startColor,
	                endColor: _this.state.endColor,
	                gradient: _this.state.gradient,
	                position: _this.state.position
	            }));
	            // var col
	        };
	
	        _this.componentDidMount = function () {
	            // var color = window.getComputedStyle(document.querySelector('.wdp.wdp_default .primary-color'), null).getPropertyValue('color');
	            // console.log("COLOR", color);
	        };
	
	        _this.getGradientsPosition = function () {
	            return _this.state.gradient == 'radial' ? ['center'] : ['to bottom right', 'to bottom', 'to bottom left', 'to right', 'to left', 'to top right', 'to top', 'to top left'];
	        };
	
	        var def = {};
	
	        try {
	            def = JSON.parse(props[props.propKey]);
	        } catch (e) {
	            def = {
	                opacity: 0.7,
	                startColor: "#D10C0F",
	                endColor: "#458734",
	                gradient: "linear",
	                position: "to bottom right"
	            };
	        }
	        _this.state = def;
	        return _this;
	    }
	
	    _createClass(OverlayStyler, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Overlay opacity'
	                ),
	                _react2.default.createElement(rmd.Slider, {
	                    step: 0.10,
	                    value: this.state.opacity,
	                    onChange: this.onOpacityChange }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Gradient type'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp wdp_default' },
	                    _react2.default.createElement('div', { className: 'primary-color' })
	                ),
	                _react2.default.createElement(
	                    rmd.RadioButtonGroup,
	                    { name: 'Gradient', valueSelected: this.state.gradient, onChange: this.onChangeGradient, style: { height: '24px', margin: '10px 0' } },
	                    _react2.default.createElement(rmd.RadioButton, {
	                        value: 'radial',
	                        label: 'Radial',
	                        style: { float: 'left', width: '50%' }
	                    }),
	                    _react2.default.createElement(rmd.RadioButton, {
	                        value: 'linear',
	                        label: 'Linear',
	                        style: { float: 'left', width: '50%' }
	                    })
	                ),
	                _react2.default.createElement(
	                    rmd.RadioButtonGroup,
	                    { name: 'Position', valueSelected: this.state.position, onChange: this.onChangeGradientPosition },
	                    this.getGradientsPosition().map(function (p) {
	                        return _react2.default.createElement(rmd.RadioButton, {
	                            key: p,
	                            value: p,
	                            label: p,
	                            style: { float: 'left', width: '50%' }
	                        });
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '10px 0' } },
	                    'Gradinet start color'
	                ),
	                _react2.default.createElement(_reactColor.SliderPicker, { disableAlpha: true, color: this.state.startColor, onChangeComplete: this.onColorChange.bind(this, 'startColor') }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '10px 0' } },
	                    'Gradinet stop color'
	                ),
	                _react2.default.createElement(_reactColor.SliderPicker, { disableAlpha: true, color: this.state.endColor, onChangeComplete: this.onColorChange.bind(this, 'endColor') })
	            );
	        }
	    }]);
	
	    return OverlayStyler;
	}(_react2.default.Component);
	
	exports.default = OverlayStyler;

/***/ },
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */
/***/ function(module, exports) {

	module.exports = {
		"env": "prod",
		"mongodb": "mongodb://172.10.2.181:27017/wdp",
		"mongodb_smpg": "mongodb://172.10.2.181:27017/smpg",
		"widgets": {
			"url": "https://widgets.tjekscores.dk",
			"port": 80
		},
		"assets": "https://cdn.tjekscores.dk/wdp/prod",
		"apis": {
			"ss2": "https://ss2.si-ab.com",
			"smpg": "https://smpg.tjekscores.dk",
			"@webshot": "http://wdp-webshot-prod-916696882.eu-west-1.elb.amazonaws.com",
			"@webshot2": "https://webshot-prod.tjekscores.dk",
			"webshot": "https://webshot-prod.tjekscores.dk",
			"ps": "https://ps.tjekscores.dk",
			"html2video": "https://html2video.tjekscores.dk"
		},
		"dash": {
			"api": {
				"port": 80,
				"host": "https://wdp.tjekscores.dk"
			}
		},
		"urls": {
			"publicPath": "https://cdn.tjekscores.dk/wdp/prod"
		},
		"campaign_manager": {
			"loggerKey": "b39a96b6-f436-4243-8aa0-b21ca2f0c6f4",
			"host": "https://cmp.tjekscores.dk",
			"port": 8011
		},
		"rabbitmq": {
			"@url": "amqp://rlz:admin@rabbit-prod-1023334297.eu-west-1.elb.amazonaws.com:5672",
			"url": "amqps://admin:adminadminadmin@b-8ea2cde3-dba5-496d-90a6-c7953532fb63.mq.eu-west-1.amazonaws.com:5671"
		},
		"bots": {
			"messenger": {
				"api": "http://social-bot-stage.tjekscores.dk"
			}
		},
		"stats_service": {
			"loggerKey": "a7dca39a-27a1-4307-b111-9970f89b563b"
		},
		"triggerer": {
			"loggerKey": "ff9598cd-0150-4955-9e49-4ad88b0e3291",
			"port": 80
		},
		"autoUpdateInterval": 30
	};

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(1121);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _FontIcon = __webpack_require__(771);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _reactRouter = __webpack_require__(188);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetDemo = function (_React$Component) {
	    _inherits(WidgetDemo, _React$Component);
	
	    function WidgetDemo(props, context) {
	        _classCallCheck(this, WidgetDemo);
	
	        var _this = _possibleConstructorReturn(this, (WidgetDemo.__proto__ || Object.getPrototypeOf(WidgetDemo)).call(this, props, context));
	
	        _this.renderDemo = function (demo) {
	            var user = _this.context.user;
	            var widget = _this.state.widget;
	
	            var previewProps = {};
	            Object.keys(demo.props).forEach(function (key) {
	                var wkey = 'data-' + _lodash2.default.kebabCase(key);
	                previewProps[wkey] = demo.props[key];
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-6', key: demo.title },
	                _react2.default.createElement(
	                    rmd.Card,
	                    { className: 'card widget-params' },
	                    _react2.default.createElement(rmd.CardHeader, { title: demo.title }),
	                    _react2.default.createElement(
	                        rmd.CardText,
	                        null,
	                        _react2.default.createElement('rlz-widget', _extends({
	                            'data-name': widget.id,
	                            'data-load': 'js',
	                            'data-client': user.client,
	                            'data-user': user.username,
	                            'data-theme': 'default',
	                            'data-token': user.accessToken,
	                            'data-ga': '$GA_INIT_TOKEN',
	                            'data-lang': 'da'
	                        }, previewProps))
	                    ),
	                    _react2.default.createElement(
	                        rmd.CardText,
	                        null,
	                        _react2.default.createElement('textarea', {
	                            readOnly: true,
	                            style: { width: '100%' },
	                            rows: 5,
	                            value: _server2.default.renderToStaticMarkup(_react2.default.createElement('rlz-widget', _extends({
	                                'data-name': widget.id,
	                                'data-load': 'js',
	                                'data-client': user.client,
	                                'data-user': user.username,
	                                'data-theme': 'default',
	                                'data-token': user.accessToken,
	                                'data-ga': '$GA_INIT_TOKEN',
	                                'data-lang': 'da'
	                            }, previewProps)))
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.handleOpenCreate = function () {
	            var widget = _this.state.widget;
	
	            _reactRouter.browserHistory.push('/widgets/' + widget.id + '/customizer');
	        };
	
	        _this.state = {
	            widget: {}
	        };
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(WidgetDemo, [{
	        key: 'loadData',
	        value: function loadData() {
	            var _this2 = this;
	
	            var widgetId = this.props.params.widgetId;
	
	            return _bluebird2.default.props({
	                widget: fetch(_cfg2.default.widgets.url + '/widgets/standalone/' + widgetId + '/spec').then(function (res) {
	                    return res.json();
	                })
	            }).then(function (result) {
	                _this2.setState(result);
	            }).catch(function (err) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var _props$params = this.props.params,
	                widgetId = _props$params.widgetId,
	                name = _props$params.name;
	            var widget = this.state.widget;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'widget-demo' },
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    name
	                ),
	                _react2.default.createElement(rmd.RaisedButton, {
	                    onClick: this.handleOpenCreate,
	                    label: 'Create widget',
	                    secondary: true,
	                    icon: _react2.default.createElement(_add2.default, null)
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    (widget.demo || []).map(this.renderDemo)
	                )
	            );
	        }
	    }]);
	
	    return WidgetDemo;
	}(_react2.default.Component);
	
	WidgetDemo.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = WidgetDemo;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _colors = __webpack_require__(910);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = ({"env":"prod","stanbol":{"ss":{"url":"http://52.31.186.23:8082"}},"@mongodb":"mongodb://localhost:27001/swp_test","mongodb":"mongodb://172.10.2.181:27017/wdp","mongodb_stage":"mongodb://localhost:27001/swp","mongodb_smpg":"mongodb://172.10.2.181:27017/smpg","mongodb_sport":"mongodb://localhost:27001/sportservice","jwt":{"secretKey":"releaze.sportInnovations"},"smb":{"url":"http://127.0.0.1:3001","port":3001},"widgets":{"url":"https://widgets.tjekscores.dk","@@url":"http://127.0.0.1:3003","@url":"http://3308b256.ngrok.io","port":80,"version":"0.3.1","libversion":"1.0.3"},"ab":{"widgets":{"url":"https://api.si-ab.com","stageUrl":"https://api-stage.si-ab.com"}},"injector":{"version":"0.3.1"},"assets":"https://cdn.tjekscores.dk/wdp/prod","@assets":"https://cdn.tjekscores.dk/wdp/prod","dev-server":{"port":8080},"apis":{"ss2":"https://ss2.si-ab.com","webshot":"https://webshot-prod.tjekscores.dk","@html2video":"http://127.0.0.1:8888","html2video":"https://html2video.tjekscores.dk","facts":"http://facts-api-stage-1556505486.eu-west-1.elb.amazonaws.com","smpg":"https://smpg.tjekscores.dk","@@smpg":"http://local.tjekscores.dk:8083","@smpg":"http://127.0.0.1:8083","ps":"https://ps.tjekscores.dk","@webshot":"http://wdp-webshot-prod-916696882.eu-west-1.elb.amazonaws.com","@webshot2":"https://webshot-prod.tjekscores.dk"},"swpe":{"contet.length.limit":50000},"dash":{"version":"0.3.1.2","api":{"port":80,"host":"https://wdp.tjekscores.dk","@host":"http://831330d1.ngrok.io"}},"urls":{"publicPath":"https://cdn.tjekscores.dk/wdp/prod","@publicPath":"https://cdn.tjekscores.dk/wdp/prod"},"cdn":{"key":"AKIAQ55RLMP2KPZ3SVBS","secret":"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","bucket":"rlz.cdn","region":"eu-west-1","cloudfront":"E1SANLH6LGD2L8","s3Url":"https://s3-eu-west-1.amazonaws.com","cdnUrl":"https://cdn.tjekscores.dk"},"rabbitmq":{"@url":"amqp://rlz:admin@rabbit-prod-1023334297.eu-west-1.elb.amazonaws.com:5672","url":"amqps://admin:adminadminadmin@b-8ea2cde3-dba5-496d-90a6-c7953532fb63.mq.eu-west-1.amazonaws.com:5671"},"campaign_manager":{"loggerKey":"b39a96b6-f436-4243-8aa0-b21ca2f0c6f4","host":"https://cmp.tjekscores.dk","port":8011,"secretKey":"campaignManagerNotifications"},"bots":{"messenger":{"pageId":"674145922790588","appId":"262143280946125","api":"http://social-bot-stage.tjekscores.dk"}},"fbWDP":{"appId":"371836229679740"},"triggerer":{"host":"https://triggerer.si-ab.com","loggerKey":"ff9598cd-0150-4955-9e49-4ad88b0e3291","supportedLeagues":[46,47,85,42,242,73,9514],"supportedLeagues@":[38,40,42,46,47,48,50,51,53,54,55,57,58,59,60,61,62,63,64,65,67,68,69,71,73,74,77,85,86,87,108,109,110,112,113,114,117,120,122,123,124,125,126,130,132,133,134,135,136,137,138,139,140,141,143,145,146,149,150,151,161,164,165,166,168,171,172,176,177,186,189,192,193,195,196,198,203,206,207,209,212,213,214,215,217,222,223,235,237,239,242,245,247,256,263,266,278,288,289,290,298,299,9806,9807,9808,9809,78,268,8814,9067,9483,117,9478,9372,523,8974,224,9011,440,230,111,536,537,9080,9410,282,284,9227,9717,9676,9677,9089,331,9382,332,333,76,292,9579,9375,9787,9377,9379,293,9134,9500,9553,9495],"port":80},"stats_service":{"loggerKey":"a7dca39a-27a1-4307-b111-9970f89b563b"},"autoUpdateInterval":30,"ga":{"client_email":"150164870142-compute@developer.gserviceaccount.com","private_key":"-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC+M/IgFOyIxNLY\nRHWt03yuEYH0UOIDQEproKdnywF6AheJsSGZT6zWn7bm7B0um73rIuIK+45Iw4nI\neAWyJ3k5WqsJ52pTy/lEFdo0FhUQvAQDKXqZTJqF+jr0GhfZBbSq10YzjA4FCc8U\nFwd53a1I1EPJkoa5CuDqUG23YgGBmsieR90zWRJ2hsm0CBP3nG3ffxym/pYqkxSe\nsH3WNeXr7YZDffKbuBnfBfSgku3qlqbTHgE63ALTUV8/xu5wT8lOvlKDpVfHf6tT\nNAin8lTYn8Jzkb2K1kqkIKirv7LBJ4P3fi1QBUGWEFCT6FEAxme3/q7ArH9v//ZZ\n6w/EJmn7AgMBAAECggEAfnMme3Gtt1ezHRiWa9P4RflZvkWvnJ23XEpYQUbTWnvd\njir2vWgc7isMfAVpeT0NTC/Ku6Z196YYCfDRSJm5nAnNQC5boA4xT7R/drVfl9qH\niFqhKR2mdX/ghbx7Mkr6y8GG6GoqP+s/gom07K4VsB9+WZpSet7inKSP7KT5f2F0\nYf0iNIh/3fn0forR8SYz/LPBXGngdjqGFUQKN4Z3azYzusYeCIF8ZC9vk27NNGjq\n+BBR1uHNRNWsZjOdtXLU/XNN/uJr/wk1xsdp16zrLf+kUt+zSFUiVTlEBdaHvGoT\nqOasSsKMFFG2117Y9PF4RKWA5edqJqv93B8FOdTM4QKBgQDmorMAukxdwPN9MhKx\n2y0jtCK2m/1hg3m376w1VuySmfxgKy5IFF9AAMIeISvZRnm2DoaJuI51wsjbPnkK\nYi3r6ABNKjHhKno2Ru1mtu7Q4vcFexlJ8m1pTjwxikDrkOtRsSePlCxY5ySCevN0\nFXbvYgxqgsginowQJe6MIPrE0wKBgQDTHuiQXLyhfkZ3epg0gTxXcWNL0zbnTkER\nSgax+oRtsRH55JhUsbmI4X9h9LNyrciYEGcie2Iyb4A/Tuu+zDFuwBW/NJLDbCQW\nfG8lp4FmrpVAtddObRSew0lpokwD78Tl0NAFyENtvLHaYgP8Hq8nK2KEShB/8SgZ\n0E63vLqtOQKBgB1W2zCfgnF2x0LI6OnpON/O3Y+fXmdWQ1iry5tpeGTZ4+oT9CpF\nNSy+K/OLQrm8JmWLiX/hk3XVlpmVY+53OOJGvCsU0A2VysA226JyaQT3qnbvBvOK\nPHLl+fBPZxzQba8RuzefoNiaZuGWZHwC8wNW1L+D7ZPB2Y2AVc1LsLrzAoGAYKru\nYeuUk312Vo7T0na6Ym+Qv89efFrggEIc/rFuoatKR9nbxiv6gCqAYSHiaMgZ6UbZ\ncnh8ZguX9WT1nM9ycvuQ+ZPg/4osm/8uBVfFcHbP8GlSxJ49qtRQcQXXOJY42eHa\n3krsVPrplMz8dhy2poC/A0PGek65xdgTsx2/fEECgYBN+qKyfkO1y5xbQK61T/Da\nBPkA6eTOWsBhp3B3ge0b61CttgxTBOHqUAhxs31zWVLFAHlUV8vtwezgpLqqbtSB\nkh/DmEJh04kRX7DmVZS7DyloTBg6xXqocHiq80Wq7jWbdYLKmPWM0mlg1A60dbV7\nvxyhH5MtxmqEGkwFdBRTMA==\n-----END PRIVATE KEY-----\n"},"shortenerKey":"AIzaSyBSOeLTB6R1V7yqmDuCjQUPMgT_hHmEUSc","bitlyKey":"27634e94f4683bf78c7c7ae163023af56534537e","supportedLanguages":["en","da","se","de","fi","th","sc"],"bookmakers":[{"id":"none","name":"None"},{"id":"unibet","name":"Unibet"},{"id":"leovegas","name":"Leovegas"},{"id":"comeon","name":"Comeon"},{"id":"comeon__de","name":"Comeon/DE"},{"id":"betbull","name":"Betbull"}],"cdnLibs":{"@xgif":"http://cdn.tjekscores.dk/utils/x-gif.html","xgif":"http://s3-eu-west-1.amazonaws.com/rlz.cdn/utils/x-gif.html"},"webshotBrowser":"chrome"});
	
	var ThemesList = function (_React$Component) {
	    _inherits(ThemesList, _React$Component);
	
	    function ThemesList(props, context) {
	        _classCallCheck(this, ThemesList);
	
	        var _this = _possibleConstructorReturn(this, (ThemesList.__proto__ || Object.getPrototypeOf(ThemesList)).call(this, props, context));
	
	        _this.loadData = function (additionalStateParams) {
	            var user = _this.context.user;
	
	            if (!user || !user.client) return null;
	            var token = _auth2.default.getAccessToken();
	            return fetch(config.dash.api.host + '/api/themes?access_token=' + token).then(function (response) {
	                return response.json();
	            }).then(function (themes) {
	                _this.setState(_extends({
	                    themes: themes,
	                    isLoading: false
	                }, additionalStateParams));
	            }).catch(function (e) {
	                _this.setState(_extends({
	                    error: e,
	                    isLoading: false
	                }, additionalStateParams));
	            });
	        };
	
	        _this.updateThemeById = function (id) {
	            var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var isPromise = arguments[2];
	
	            var _themes = _lodash2.default.cloneDeep(_this.state.themes).map(function (theme) {
	                if (theme.id === id) {
	                    theme = _extends({}, theme, update);
	                }
	                return theme;
	            });
	
	            if (isPromise) {
	                return new Promise(function (resolve) {
	                    _this.setState({ themes: _themes }, function () {
	                        return resolve();
	                    });
	                });
	            } else {
	                _this.setState({ themes: _themes });
	            }
	        };
	
	        _this.handleThemeCreationOpen = function (e) {
	            e.preventDefault();
	            _this.setState({ themeCreationIsOpen: true });
	        };
	
	        _this.handleThemeCreationClose = function (e) {
	            e.preventDefault();
	            _this.setState({ themeCreationIsOpen: false });
	        };
	
	        _this.handleNewThemeNameChange = function (e) {
	            _this.setState({
	                newThemeName: e.target.value
	            });
	        };
	
	        _this.handleNewThemeDescriptionChange = function (e) {
	            _this.setState({
	                newThemeDescription: e.target.value
	            });
	        };
	
	        _this.handleThemeHide = function (id, isHidden) {
	            id = encodeURIComponent(id);
	
	            _this.updateThemeById(id, { isInteractingWithApi: true });
	
	            var userId = _this.context.user._id;
	
	            fetch(config.dash.api.host + '/api/themes/' + id + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    isHidden: !isHidden
	                })
	            }).then(function (response) {
	                var status = response.status;
	
	
	                if (status === 200) {
	                    _this.updateThemeById(id, { isInteractingWithApi: false, isHiddenInUI: !isHidden });
	                    return response.json();
	                }
	            });
	        };
	
	        _this.handleThemeDefault = function (id) {
	            var userId = _this.context.user._id;
	
	
	            return fetch(config.dash.api.host + '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({ defaultTheme: id })
	            }).then(function (response) {
	                return response.json();
	            }).then(function () {
	                _auth2.default.saveUser(_extends({}, _this.context.user, { defaultTheme: id }));
	                _this.setState({
	                    defaultTheme: id
	                });
	            }).catch(function (e) {
	                return void 0;
	            });
	
	            return _this.updateThemeById(id, { isInteractingWithApi: true }, true).then(function () {
	                return fetch(config.dash.api.host + '/api/themes/reset-default-theme').then(function (response) {
	                    return response.json();
	                }).then(function () {
	                    return fetch(config.dash.api.host + '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(), {
	                        method: 'PUT',
	                        headers: {
	                            'Content-Type': 'application/json'
	                        },
	                        body: JSON.stringify({
	                            isDefault: true
	                        })
	                    });
	                }).then(function (response) {
	                    var status = response.status;
	
	
	                    if (status === 200) {
	                        _this.updateThemeById(_lodash2.default.find(_this.state.themes, function (t) {
	                            return t.isDefault;
	                        }).id, { isDefault: false }, true).then(function () {
	                            return _this.updateThemeById(id, {
	                                isInteractingWithApi: false,
	                                isDefault: true
	                            }, true).then(function () {
	                                return response.json();
	                            });
	                        });
	                    }
	                });
	            });
	        };
	
	        _this.handleThemeCreationSubmit = function (e) {
	            e.preventDefault();
	            var _this$state = _this.state,
	                themeName = _this$state.newThemeName,
	                themeDescription = _this$state.newThemeDescription;
	
	            _this.setState({ themeCreationInProgress: true, themeCreationIsOpen: false, newThemeName: '', newThemeDescription: '' });
	
	            // const themeIdFromName = encodeURIComponent(_.kebabCase(this.state.newThemeName));
	
	            fetch(config.dash.api.host + '/api/themes/create-theme?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({ themeName: themeName, themeDescription: themeDescription })
	            }).then(function (response) {
	                return response.json();
	            }).then(function (info) {
	                return _this.loadData({ themeCreationSucceed: true, themeCreationInProgress: false });
	            }).catch(function (e) {
	                _this.setState({
	                    themeCreationInProgress: false,
	                    themeCreationFailed: true
	                });
	            });
	        };
	
	        _this.state = {
	            themes: [],
	            themeCreationIsOpen: false,
	            defaultTheme: context.user.defaultTheme,
	            newThemeName: '',
	            newThemeDescription: '',
	            themeCreationInProgress: false,
	            themeCreationFailed: false,
	            themeCreationSucceed: false,
	            showHidden: _this.props.route.params.isHidden || false
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(ThemesList, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var themes = this.state.themes;
	
	
	            var actions = [_react2.default.createElement(rmd.FlatButton, { label: 'Cancel', primary: true, onTouchTap: this.handleThemeCreationClose }), _react2.default.createElement(rmd.FlatButton, { label: 'Submit', primary: true, disabled: !this.state.newThemeName, onTouchTap: this.handleThemeCreationSubmit })];
	
	            var hiddenThemesExist = themes.some(function (t) {
	                return t.isHidden;
	            });
	            var hiddenFilterLabel = this.state.showHidden ? 'Show active themes' : 'Show hidden themes';
	            var noThemes = _lodash2.default.isEmpty(themes);
	
	            themes = _lodash2.default.sortBy(themes, function (t) {
	                if (t.id === _this2.state.defaultTheme) return -Infinity;else return new Date(t.createdAt);
	            });
	
	            var mainThemeColors = ['bg-color', 'gray-base', 'primary-color', 'primary-text-color', 'home-color', 'away-color'];
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'pick-theme' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        !noThemes && _react2.default.createElement(
	                            rmd.Subheader,
	                            null,
	                            'Choose existing theme or create new'
	                        ),
	                        noThemes && _react2.default.createElement(
	                            rmd.Subheader,
	                            null,
	                            'Create your first theme!'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6', style: { textAlign: 'right' } },
	                        !noThemes && hiddenThemesExist && _react2.default.createElement(
	                            rmd.Subheader,
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { href: this.state.showHidden ? '/themes' : '/themes/hidden' },
	                                hiddenFilterLabel
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    rmd.Dialog,
	                    { title: 'New theme creation', actions: actions, onRequestClose: this.handleThemeCreationClose, open: this.state.themeCreationIsOpen },
	                    _react2.default.createElement(rmd.TextField, { floatingLabelText: 'Theme name (unique) *', value: this.state.newThemeName, autoFocus: true, onChange: this.handleNewThemeNameChange }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(rmd.TextField, { floatingLabelText: 'Theme description', multiLine: true, rows: 1, rowsMax: 2, onChange: this.handleNewThemeDescriptionChange })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        _reactAddonsCssTransitionGroup2.default,
	                        { transitionName: 'rlzFadeAnimation', transitionEnterTimeout: 500, transitionLeave: false },
	                        themes.filter(function (t) {
	                            return _this2.state.showHidden ? t.isHidden : !t.isHidden;
	                        }).map(function (theme, i) {
	                            var hideActionLabel = 'Hide';
	
	                            if (theme.isHidden) hideActionLabel = 'Show';
	                            if (theme.isHiddenInUI) hideActionLabel = 'Show';
	                            if (theme.isHiddenInUI === false) hideActionLabel = 'Hide';
	
	                            var themeIsDefault = theme.id === _this2.state.defaultTheme;
	
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-6 col-md-4', key: theme.id },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'theme-template-wrapper' },
	                                    _react2.default.createElement(
	                                        rmd.Card,
	                                        { className: 'theme-template' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'theme__theme-colors widget-img' },
	                                            mainThemeColors.map(function (colorName) {
	                                                var backgroundColor = theme.userVariables[colorName];
	                                                if (backgroundColor && backgroundColor.indexOf('$') !== -1) backgroundColor = theme.userVariables[backgroundColor.substr(1)];
	                                                return _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'theme__theme-color', key: colorName, style: { background: backgroundColor, color: backgroundColor } },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'theme__theme-color-name' },
	                                                        colorName
	                                                    )
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.CardText,
	                                            null,
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'theme__theme-name' },
	                                                theme.name
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { style: { color: '#b2b2b2' } },
	                                                theme.description.length ? theme.description : 'No description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            rmd.CardActions,
	                                            { className: 'actions' },
	                                            !themeIsDefault && _react2.default.createElement(rmd.FlatButton, {
	                                                onClick: function onClick(e) {
	                                                    return _this2.handleThemeHide(theme.id, theme.isHiddenInUI !== undefined ? theme.isHiddenInUI : theme.isHidden);
	                                                },
	                                                disabled: theme.isInteractingWithApi,
	                                                className: 'hide',
	                                                label: hideActionLabel
	                                            }),
	                                            !themeIsDefault && !theme.isHidden && !theme.isHiddenInUI && _react2.default.createElement(rmd.FlatButton, {
	                                                onClick: function onClick(e) {
	                                                    return _this2.handleThemeDefault(theme.id);
	                                                },
	                                                disabled: theme.isInteractingWithApi,
	                                                className: 'default',
	                                                secondary: true,
	                                                label: 'Make default'
	                                            }),
	                                            themeIsDefault && _react2.default.createElement(
	                                                rmd.Chip,
	                                                { style: { float: 'left' } },
	                                                _react2.default.createElement(rmd.Avatar, { backgroundColor: _colors.grey200, color: _colors.green700, icon: _react2.default.createElement(_check2.default, null) }),
	                                                'Default theme'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/themes/' + theme.id + '/customize' },
	                                                _react2.default.createElement(rmd.FlatButton, { className: 'create', label: 'Edit', primary: true })
	                                            )
	                                        )
	                                    )
	                                )
	                            );
	                        }),
	                        !this.state.showHidden && _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-6 col-md-4', key: 'create-theme' },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: (0, _classnames2.default)('create-theme-card', { creating: this.state.themeCreationInProgress }),
	                                    onClick: this.state.themeCreationInProgress ? function () {} : this.handleThemeCreationOpen
	                                },
	                                this.state.themeCreationInProgress ? _react2.default.createElement(_autorenew2.default, null) : _react2.default.createElement(_add2.default, null)
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.themeCreationSucceed,
	                    message: 'Theme was successfully created.',
	                    autoHideDuration: 5000,
	                    onRequestClose: function onRequestClose() {
	                        return _this2.setState({ themeCreationSucceed: false });
	                    }
	                }),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.themeCreationFailed,
	                    message: 'Error. Could not create theme. Try again.',
	                    autoHideDuration: 5000,
	                    bodyStyle: { backgroundColor: 'rgba(198,40,40,0.8)' },
	                    onRequestClose: function onRequestClose() {
	                        return _this2.setState({ themeCreationFailed: false });
	                    }
	                })
	            );
	        }
	    }]);
	
	    return ThemesList;
	}(_react2.default.Component);
	
	ThemesList.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = ThemesList;

/***/ },
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loadStyle = __webpack_require__(1314);
	
	var _loadStyle2 = _interopRequireDefault(_loadStyle);
	
	var _SassVariablesEditor = __webpack_require__(1315);
	
	var _SassVariablesEditor2 = _interopRequireDefault(_SassVariablesEditor);
	
	var _ThemePreview = __webpack_require__(1346);
	
	var _ThemePreview2 = _interopRequireDefault(_ThemePreview);
	
	var _WidgetsPreview = __webpack_require__(1380);
	
	var _WidgetsPreview2 = _interopRequireDefault(_WidgetsPreview);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pure = function (_React$PureComponent) {
	    _inherits(Pure, _React$PureComponent);
	
	    function Pure() {
	        _classCallCheck(this, Pure);
	
	        return _possibleConstructorReturn(this, (Pure.__proto__ || Object.getPrototypeOf(Pure)).apply(this, arguments));
	    }
	
	    _createClass(Pure, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                this.props,
	                ' ',
	                this.props.children
	            );
	        }
	    }]);
	
	    return Pure;
	}(_react2.default.PureComponent);
	
	var ThemeCustomizer = function (_React$Component) {
	    _inherits(ThemeCustomizer, _React$Component);
	
	    function ThemeCustomizer(props, context) {
	        _classCallCheck(this, ThemeCustomizer);
	
	        var _this2 = _possibleConstructorReturn(this, (ThemeCustomizer.__proto__ || Object.getPrototypeOf(ThemeCustomizer)).call(this, props, context));
	
	        _this2.handleSave = function (variables) {
	            var _this2$context$user = _this2.context.user,
	                user = _this2$context$user.username,
	                client = _this2$context$user.client,
	                _id = _this2$context$user._id;
	            var theme = _this2.props.params.themeId;
	
	
	            return _bluebird2.default.props({
	                saveUserVariables: fetch('/api/themes/' + theme + '?access_token=' + _auth2.default.getAccessToken(), {
	                    method: 'PUT',
	                    headers: {
	                        'Content-Type': 'application/json'
	                    },
	                    body: JSON.stringify({
	                        userVariables: variables
	                    })
	                }).then(function (response) {
	                    var status = response.status;
	
	
	                    if (status === 200) {
	                        return response.json();
	                    }
	                })
	            });
	        };
	
	        _this2.handlePublish = function (variables) {
	            var userId = _this2.context.user._id;
	            var themeId = _this2.props.params.themeId;
	
	
	            return _this2.handleSave(variables).then(function () {
	                return fetch(_cfg2.default.dash.api.host + '/api/themes/' + themeId + '/publish-styles?access_token=' + _auth2.default.getAccessToken(), {
	                    method: 'POST',
	                    headers: {
	                        'Content-Type': 'application/json'
	                    },
	                    body: JSON.stringify({
	                        variables: variables
	                    })
	                }).then(function (response) {
	                    var status = response.status;
	
	                    if (status === 200) {
	                        return response.json();
	                    }
	                }).then(function (uploadInfo) {
	                    _this2.setState(_extends({}, uploadInfo, { showPublishedNotification: true }));
	                    _this2.loadData();
	                    return { saved: true, publishing: false };
	                });
	            });
	        };
	
	        _this2.handleReset = function () {};
	
	        _this2.handleWidgetsCollapseChange = function (expandedWidgetsIds) {
	            _this2.setState({
	                expandedWidgetsIds: expandedWidgetsIds
	            }, function () {
	                _this2.context.router.replace(_extends({}, _this2.props.location, {
	                    query: {
	                        themSects: _this2.state.expandedThemeSections,
	                        widgets: _this2.state.expandedWidgetsIds
	                    }
	                }));
	            });
	        };
	
	        _this2.handleThemeCollapseChange = function (indexes) {
	            _this2.setState({
	                expandedThemeSections: indexes
	            }, function () {
	                _this2.context.router.replace(_extends({}, _this2.props.location, {
	                    query: {
	                        themSects: _this2.state.expandedThemeSections,
	                        widgets: _this2.state.expandedWidgetsIds
	                    }
	                }));
	            });
	        };
	
	        _this2.handleEditVariableChange = function (editVariable) {
	            _this2.setState({ editVariable: editVariable });
	        };
	
	        _this2.handleVariablesUpdate = function (variables, changedVariable) {
	            var _this2$context$user2 = _this2.context.user,
	                user = _this2$context$user2.username,
	                client = _this2$context$user2.client,
	                userId = _this2$context$user2._id;
	            var themeId = _this2.props.params.themeId;
	
	
	            return fetch(_cfg2.default.dash.api.host + '/api/themes/' + themeId + '/generate-styles?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json' //this causes method to be OPTIONS, but without it variables are not passed to request...
	                },
	                body: JSON.stringify({
	                    variables: variables
	                })
	            }).then(function (response) {
	                return response.text();
	            }).then(function (text) {
	                if (text === 'error') {
	                    _this2.setState({
	                        showErrorNotification: true,
	                        variableWithError: changedVariable
	                    });
	                    return { error: true, variable: changedVariable };
	                }
	                return text;
	            }).catch(function (e) {
	                return void 0;
	            });
	        };
	
	        _this2.handleImagePickerRequest = function (name) {
	            _this2.setState({
	                imagePickerFor: name
	            });
	        };
	
	        _this2.handleCssUpdated = function () {
	            //This dispatch is needed when we need to change color of something in JS (for example, Canvas)
	            window.dispatchEvent(new Event('resize'));
	        };
	
	        var q = props.router.location.query;
	
	        _this2.state = {
	            isLoading: true,
	            expandedWidgetsIds: _lodash2.default.flatten([].concat(q.widgets || [])),
	            expandedThemeSections: _lodash2.default.flatten([].concat(q.themSects || ['Color palette'])),
	            theme: {},
	            variables: {},
	            showPublishedNotification: false,
	            showErrorNotification: false,
	            variableWithError: '',
	            editVariable: null,
	            stylesLoaded: false,
	            spec: {
	                widgets: []
	            }
	        };
	
	        _this2.loadData();
	        return _this2;
	    }
	
	    _createClass(ThemeCustomizer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            var _context$user = this.context.user,
	                client = _context$user.client,
	                username = _context$user.username;
	            var themeId = this.props.params.themeId;
	
	
	            (0, _loadStyle2.default)(_cfg2.default.assets + '/css/clients/' + client + '.' + username + '.' + themeId + '.css', function () {
	                _this3.setState({ stylesLoaded: true });
	            });
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this4 = this;
	
	            var _context$user2 = this.context.user,
	                userId = _context$user2._id,
	                client = _context$user2.client;
	            var themeId = this.props.params.themeId;
	
	            var token = _auth2.default.getAccessToken();
	            return _bluebird2.default.props({
	                theme: fetch(_cfg2.default.dash.api.host + '/api/themes/' + themeId + '?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                    return response.json();
	                }),
	                spec: fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                    return response.json();
	                }).then(function (spec) {
	                    spec.widgets = _lodash2.default.filter(spec.widgets, function (w) {
	                        return w.spec && !w.spec.social;
	                    });
	                    return spec;
	                }),
	                variables: fetch(_cfg2.default.dash.api.host + '/api/themes/ui-variables?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                    return response.json();
	                }),
	                userImages: fetch(_cfg2.default.dash.api.host + '/api/media?access_token=' + token).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (results) {
	                _this4.setState(_extends({}, results, { isLoading: false }));
	            }).catch(function (e) {
	                _this4.setState({
	                    error: e,
	                    isLoading: false
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _state = this.state,
	                isLoading = _state.isLoading,
	                theme = _state.theme,
	                spec = _state.spec,
	                variables = _state.variables,
	                cssUrl = _state.cssUrl,
	                stylesLoaded = _state.stylesLoaded,
	                userImages = _state.userImages;
	            var themeId = this.props.params.themeId;
	            var user = this.context.user;
	            var userVariables = theme.userVariables;
	            //TODO:PACKAGES
	
	            var widgets = spec.widgets.filter(function (w) {
	                return _this5.state.expandedWidgetsIds.indexOf(w.id) !== -1;
	            });
	
	            var sassEditorClasses = (0, _classnames2.default)('wdp-saas-editor-container', {
	                'wdp-saas-editor-container_modal-is-open': this.state.imagePickerFor
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'theme-customizer-container' },
	                _react2.default.createElement(
	                    Pure,
	                    { className: sassEditorClasses },
	                    !isLoading && !_lodash2.default.isEmpty(userVariables) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Theme: ',
	                            theme.name
	                        ),
	                        _react2.default.createElement(_SassVariablesEditor2.default, {
	                            error: this.state.error,
	                            themeId: themeId,
	                            variables: variables,
	                            userImages: userImages,
	                            userVariables: userVariables,
	                            sectionsToShow: this.state.expandedThemeSections,
	                            widgetsToShow: this.state.expandedWidgetsIds,
	                            onSave: this.handleSave,
	                            onPublish: this.handlePublish,
	                            onReset: this.handleReset,
	                            onWidgetsCollapseChange: this.handleWidgetsCollapseChange,
	                            onThemeCollapseChange: this.handleThemeCollapseChange,
	                            onVariablesUpdate: this.handleVariablesUpdate,
	                            onEditVariableChange: this.handleEditVariableChange,
	                            onImagePickerRequest: this.handleImagePickerRequest,
	                            onCssUpdated: this.handleCssUpdated,
	                            router: this.props.router,
	                            route: this.props.route
	                        }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: theme.cssUrl },
	                                    theme.cssUrl
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'id: ',
	                                theme.id
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'client: ',
	                                user.client
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'user: ',
	                                user.username
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'created: ',
	                                (0, _moment2.default)(theme.createdAt).format('HH:mm, DD MMMM')
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'updated: ',
	                                (0, _moment2.default)(theme.updatedAt).format('HH:mm, DD MMMM')
	                            )
	                        )
	                    ),
	                    cssUrl && _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'card rlz-theme-customizer__block' },
	                        _react2.default.createElement(
	                            'a',
	                            { style: { wordBreak: 'break-all' }, href: cssUrl },
	                            cssUrl
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)('card wdp-preview-container', 'rlz-theme-customizer__block', {
	                            'wdp-preview-container_modal-is-open': this.state.imagePickerFor
	                        })
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'preview' },
	                        stylesLoaded && this.state.expandedThemeSections.length > 0 && _react2.default.createElement(_ThemePreview2.default, {
	                            theme: themeId,
	                            editVariable: this.state.editVariable,
	                            sectionsToShow: this.state.expandedThemeSections
	                        }),
	                        stylesLoaded && _react2.default.createElement(_WidgetsPreview2.default, {
	                            token: this.context.user.accessToken,
	                            user: this.context.user.username,
	                            client: this.context.user.client,
	                            theme: themeId,
	                            widgets: widgets
	                        })
	                    )
	                ),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.showPublishedNotification,
	                    message: 'CSS was successfully published.',
	                    autoHideDuration: 4000,
	                    onRequestClose: function onRequestClose() {
	                        return _this5.setState({ showPublishedNotification: false });
	                    }
	                }),
	                _react2.default.createElement(rmd.Snackbar, {
	                    open: this.state.showErrorNotification,
	                    message: 'Error. Wrong variable ' + this.state.variableWithError + ' value.',
	                    autoHideDuration: 4000,
	                    bodyStyle: { backgroundColor: 'rgba(198,40,40,0.8)' },
	                    onRequestClose: function onRequestClose() {
	                        return _this5.setState({ showErrorNotification: false });
	                    }
	                })
	            );
	        }
	    }]);
	
	    return ThemeCustomizer;
	}(_react2.default.Component);
	
	ThemeCustomizer.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = ThemeCustomizer;

/***/ },
/* 1314 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (url, clb) {
	    var head = document.getElementsByTagName("head")[0];
	    if (document.querySelector('link[href="' + url + '"]')) {
	        clb && clb(null, true);
	        return;
	    }
	    var link = document.createElement("link");
	    link.href = url;
	    link.rel = 'stylesheet';
	    link.onerror = function () {
	        clb && clb.bind(link, true).call();
	        head.removeChild(link);
	    };
	    link.onload = clb && clb.bind(link, false);
	
	    // document.getElementsByTagName("head")[0].appendChild(link);
	
	
	    head.insertBefore(link, head.firstChild);
	};

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.i18 = exports.SassVariablesEditor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _checkCircle = __webpack_require__(973);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _addAPhoto = __webpack_require__(1316);
	
	var _addAPhoto2 = _interopRequireDefault(_addAPhoto);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcCollapse = __webpack_require__(1317);
	
	var _rcCollapse2 = _interopRequireDefault(_rcCollapse);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactColor = __webpack_require__(1195);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //TODO: Check if variable exists when referencing to variable
	//TODO: Add validation for colors
	
	
	var Panel = _rcCollapse2.default.Panel;
	
	
	var isHexColor = function isHexColor(string) {
	    var hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/g;
	    return !!string.match(hexColorRegex);
	};
	
	var isRGBAColor = function isRGBAColor(string) {
	    var rgbaColorRegex = /rgba\([0-9\s]*\s*,\s*[0-9\s]*,\s*[0-9\s]*,\s*[0-9\.\s)]*/g;
	    return !!string.match(rgbaColorRegex);
	};
	
	var isRGBColor = function isRGBColor(string) {
	    var rgbColorRegex = /rgb\([0-9\s]*\s*,\s*[0-9\s]*,\s*[0-9\s]*\s*\)]*/g;
	    return !!string.match(rgbColorRegex);
	};
	
	var SassVariablesEditor = function (_React$Component) {
	    _inherits(SassVariablesEditor, _React$Component);
	
	    function SassVariablesEditor(props) {
	        _classCallCheck(this, SassVariablesEditor);
	
	        var _this = _possibleConstructorReturn(this, (SassVariablesEditor.__proto__ || Object.getPrototypeOf(SassVariablesEditor)).call(this, props));
	
	        _this.handleVariableChange = function (name, value, asPromise) {
	            var userVariables = _this.state.userVariables;
	
	            var _userVariables = _extends({}, userVariables); //copy
	
	            _userVariables[name] = value;
	
	            if (asPromise) {
	                return new Promise(function (resolve) {
	                    _this.setState({
	                        userVariables: _userVariables
	                    }, resolve());
	                });
	            }
	
	            _this.setState({
	                userVariables: _userVariables
	            });
	        };
	
	        _this.handleColorPickerRequest = function (name) {
	            return _this.setState({ colorPickerFor: name });
	        };
	
	        _this.handleImagePickerRequest = function (name) {
	            if (name) {
	                _this.refs[name].focus();
	            } else {
	                _this.refs[name].blur();
	            }
	            _this.props.onImagePickerRequest(name);
	            _this.setState({ imagePickerFor: name, currentlyEditingVariable: name });
	        };
	
	        _this.handleVariableInputBlur = function (name, value, changeVariable) {
	            var previousValue = _this.state.previousInputValue;
	            if (previousValue === value) {
	                _this.setState({
	                    currentlyEditingVariable: null
	                });
	                return;
	            }
	
	            if (_this.props.onVariablesUpdate) _this.props.onVariablesUpdate(_this.getCurrentVariables(), name).then(function (css) {
	                if (css.error) {
	                    _this.setState({
	                        compileError: true,
	                        wrongVariableName: name
	                    });
	                } else {
	                    _this.setState({
	                        currentlyEditingVariable: null,
	                        compileError: false,
	                        saved: false,
	                        wrongVariableName: null
	                    }, function () {
	                        _this.addCssToPage(css);
	                        _this.props.onCssUpdated();
	                    });
	                }
	            });
	        };
	
	        _this.saveAlert = function (e) {
	            var confirmationMessage = 'You did not save theme changes. Are you sure you want to leave?';
	            (e || window.event).returnValue = confirmationMessage;
	            return confirmationMessage;
	        };
	
	        _this.generateInitialCss = function () {
	            if (_this.props.error) return;
	            if (_this.state.initialCssGenerated || _lodash2.default.isEmpty(_this.props.variables)) return;
	
	            var variables = _this.getCurrentVariables();
	
	            if (_this.props.onVariablesUpdate) _this.props.onVariablesUpdate(variables).then(function (css) {
	                _this.setState({ initialCssGenerated: true }, _this.addCssToPage(css));
	            });
	        };
	
	        _this.addCssToPage = function (css) {
	            if (!document.querySelector('#wdp-user-style')) {
	                var style = document.createElement('style');
	                style.id = 'wdp-user-style';
	                style.innerHTML = css;
	                document.querySelector('head').appendChild(style);
	            } else {
	                document.querySelector('#wdp-user-style').innerHTML = css;
	            }
	        };
	
	        _this.getCurrentVariables = function (onlyDefault) {
	            var userVariables = _this.state.userVariables;
	            var variables = _this.props.variables;
	            var widgets = variables.widgets,
	                theme = variables.theme;
	
	
	            var flattenVariables = _lodash2.default.flatten([].concat(_toConsumableArray(theme), _toConsumableArray(widgets)).map(function (w) {
	                return w.variables;
	            }));
	
	            return flattenVariables.reduce(function (total, cur) {
	                var variableValue = userVariables[cur.name] || cur.value;
	                if (onlyDefault) {
	                    variableValue = cur.value;
	                }
	                total[cur.name] = variableValue;
	                return total;
	            }, {});
	        };
	
	        _this.findValue = function (name, findInDefault) {
	            if (!name) return;
	            var val = _this.getCurrentVariables(findInDefault)[name];
	            if (val && val[0] === '$') return _this.findValue(val.substring(1));
	            return val;
	        };
	
	        _this.handleVariableInputFocus = function (name, value) {
	            _this.setState({
	                currentlyEditingVariable: name,
	                previousInputValue: value
	            });
	        };
	
	        _this.onImagePick = function (variable, value) {
	            _this.setState({
	                imagePickerFor: null
	            });
	            _this.props.onImagePickerRequest(null);
	            _this.handleVariableChange(variable, value, 'asPromise').then(function () {
	                _this.handleVariableInputBlur(variable, value);
	            });
	        };
	
	        _this.rgbaToString = function (_ref) {
	            var r = _ref.r,
	                g = _ref.g,
	                b = _ref.b,
	                a = _ref.a;
	            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	        };
	
	        _this.renderVariable = function (variable, widget, colorPickerColors) {
	            var userVariableValue = _this.state.userVariables[variable.name];
	            var _this$state = _this.state,
	                currentlyEditingVariable = _this$state.currentlyEditingVariable,
	                compileError = _this$state.compileError,
	                wrongVariableName = _this$state.wrongVariableName;
	            var themeId = _this.props.themeId;
	            var name = variable.name,
	                comment = variable.comment,
	                value = variable.value;
	
	            if (userVariableValue !== undefined) {
	                value = userVariableValue;
	            }
	            var inputValue = _this.state[name] === undefined ? value : _this.state[name];
	            var realValue = inputValue;
	
	            var isDisabled = false;
	            var isError = false;
	            var variableWasChanged = false;
	            if (currentlyEditingVariable) {
	                variableWasChanged = _this.state.previousInputValue !== _this.state.userVariables[currentlyEditingVariable];
	                isDisabled = variableWasChanged && name !== currentlyEditingVariable;
	            }
	
	            if (realValue[0] === '$') realValue = _this.findValue(realValue.substring(1));
	
	            var labelText = name;
	
	            if (wrongVariableName === name) {
	                isError = true;
	            } else if (compileError) {
	                isDisabled = true;
	            }
	
	            var isColor = name.indexOf('color') !== -1 || name.indexOf('gray') !== -1;
	            var isImage = _lodash2.default.last(name.split('-')) === 'image';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-theme-customizer__variable', key: name },
	                _react2.default.createElement(
	                    'small',
	                    { style: { marginTop: '25px', display: 'block' } },
	                    comment
	                ),
	                _react2.default.createElement(rmd.TextField, {
	                    floatingLabelText: '$' + labelText,
	                    floatingLabelStyle: { fontFamily: 'monospace' },
	                    value: inputValue,
	                    fullWidth: true,
	                    ref: name,
	                    disabled: isDisabled,
	                    style: { marginTop: '-14px' },
	                    errorText: isError && 'Wrong variable value',
	                    onChange: function onChange(e) {
	                        return _this.handleVariableChange(name, e.target.value);
	                    },
	                    onBlur: function onBlur(e) {
	                        return _this.handleVariableInputBlur(name, e.target.value, widget.name);
	                    },
	                    onFocus: function onFocus(e) {
	                        return _this.handleVariableInputFocus(name, e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp wdp_' + themeId },
	                    isColor && _react2.default.createElement('div', {
	                        key: 'color-main',
	                        onClick: _this.handleColorPickerRequest.bind(_this, name),
	                        className: (0, _classnames2.default)('rlz-theme-customizer__variable-extended-input rlz-theme-customizer__color-preview', _defineProperty({}, 'bg-' + name, true)),
	                        style: { background: realValue }
	                    }),
	                    isImage && !_this.state.imagePickerFor && _react2.default.createElement(
	                        'div',
	                        {
	                            key: 'image-main',
	                            onClick: _this.handleImagePickerRequest.bind(_this, name),
	                            className: 'rlz-theme-customizer__variable-extended-input rlz-theme-customizer__image-request-button'
	                        },
	                        _react2.default.createElement(_addAPhoto2.default, null)
	                    ),
	                    _this.state.colorPickerFor === name && _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-theme-customizer__color-picker-tool' },
	                        _react2.default.createElement('div', {
	                            style: {
	                                position: 'fixed',
	                                top: '0px',
	                                right: '0px',
	                                bottom: '0px',
	                                left: '0px'
	                            },
	                            onClick: function onClick() {
	                                return _this.handleColorPickerRequest(null);
	                            }
	                        }),
	                        _react2.default.createElement(_reactColor.SketchPicker, {
	                            color: realValue,
	                            presetColors: colorPickerColors,
	                            onChange: function onChange(color, e) {
	                                return _this.handleVariableChange(name, _this.rgbaToString(color.rgb));
	                            },
	                            onChangeComplete: function onChangeComplete(color, e) {
	                                _this.handleVariableInputBlur(name, _this.rgbaToString(color.rgb), widget.name);
	                            }
	                        })
	                    ),
	                    currentlyEditingVariable === name && variableWasChanged && _react2.default.createElement(
	                        'span',
	                        { className: 'rlz-theme-customizer__apply-variable-change' },
	                        _react2.default.createElement(_checkCircle2.default, null)
	                    ),
	                    isColor && _react2.default.createElement('div', { key: 'color-transparent', className: 'rlz-theme-customizer__color-preview_transparent' })
	                )
	            );
	        };
	
	        _this.renderVariables = function () {
	            var _this$props$variables = _this.props.variables,
	                _this$props$variables2 = _this$props$variables.widgets,
	                widgetsVariables = _this$props$variables2 === undefined ? [] : _this$props$variables2,
	                _this$props$variables3 = _this$props$variables.theme,
	                themeVariables = _this$props$variables3 === undefined ? [] : _this$props$variables3;
	            var _this$props = _this.props,
	                widgetsToShow = _this$props.widgetsToShow,
	                sectionsToShow = _this$props.sectionsToShow;
	            // ADD COLOR PICKER
	
	            var colorPickerColors = [];
	            themeVariables.find(function (t) {
	                return t.id === 'Color palette';
	            }).variables.forEach(function (v, i) {
	                var value = v.value;
	                if (_this.state.userVariables[v.name]) value = _this.state.userVariables[v.name];
	                if (isHexColor(value) || isRGBAColor(value) || isRGBColor(value)) colorPickerColors.push({ key: v.name, color: value, title: v.name + ', ' + value });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-theme-customizer__variables' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-theme-customizer__theme-variables' },
	                    _react2.default.createElement(
	                        _rcCollapse2.default,
	                        { onChange: _this.props.onThemeCollapseChange, defaultActiveKey: sectionsToShow },
	                        themeVariables.map(function (t, i) {
	                            return _react2.default.createElement(
	                                Panel,
	                                { showArrow: true, header: t.name, key: t.name },
	                                _react2.default.createElement(
	                                    'div',
	                                    { key: i, className: 'rlz-theme-customizer__theme-variables' },
	                                    t.variables.map(function (v) {
	                                        return _this.renderVariable(v, t, colorPickerColors);
	                                    })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-theme-customizer__widgets-variables' },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { marginLeft: '15px' } },
	                        'Widgets variables'
	                    ),
	                    _react2.default.createElement(
	                        _rcCollapse2.default,
	                        { onChange: _this.props.onWidgetsCollapseChange, defaultActiveKey: widgetsToShow },
	                        widgetsVariables.map(function (w, i) {
	                            if (!w.variables.length) return;
	                            return _react2.default.createElement(
	                                Panel,
	                                { showArrow: true, header: w.name, key: w.id },
	                                _react2.default.createElement(
	                                    'div',
	                                    { key: i, className: 'rlz-theme-customizer__theme-variables' },
	                                    w.variables.map(function (v) {
	                                        return _this.renderVariable(v, w, colorPickerColors);
	                                    })
	                                ),
	                                w.variables.length === 0 && _react2.default.createElement(
	                                    'div',
	                                    { className: 'rlz-theme-customizer__no-variables' },
	                                    'widget does not variables to edit'
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.renderSaveControl = function () {
	            var _this$state2 = _this.state,
	                currentlyEditingVariable = _this$state2.currentlyEditingVariable,
	                saved = _this$state2.saved,
	                compileError = _this$state2.compileError,
	                publishing = _this$state2.publishing,
	                wrongVariableName = _this$state2.wrongVariableName;
	
	            var publishIsDisabled = false;
	            var publishLabel = 'Save & Publish';
	
	            var variableWasChanged = _this.state.previousInputValue !== _this.state.userVariables[currentlyEditingVariable];
	
	            if (saved) {
	                publishLabel = 'Saved';
	                publishIsDisabled = true;
	            }
	
	            if (currentlyEditingVariable && variableWasChanged) {
	                publishLabel = 'Editing in progress';
	                publishIsDisabled = true;
	            }
	            if (compileError) {
	                publishLabel = 'Wrong variable value (' + wrongVariableName + ')';
	                publishIsDisabled = true;
	            }
	
	            if (publishing) {
	                publishLabel = 'CSS is publishing';
	                publishIsDisabled = true;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-theme-customizer__save-control' },
	                _react2.default.createElement(rmd.FlatButton, {
	                    className: 'rlz-theme-customizer__publish',
	                    onClick: function onClick() {
	                        _this.setState({
	                            publishing: true
	                        });
	                        _this.props.onPublish(_this.getCurrentVariables()).then(function (res) {
	                            return _this.setState(res);
	                        });
	                    },
	                    label: publishLabel,
	                    primary: true,
	                    disabled: publishIsDisabled
	                })
	            );
	        };
	
	        _this.state = {
	            userVariables: props.userVariables || {},
	            userImages: props.userImages || [],
	            currentlyEditingVariable: null,
	            compileError: false,
	            wrongVariableName: null,
	            initialCssGenerated: false,
	            publishing: false,
	            saved: true
	        };
	
	        _this.i18dict = SassVariablesEditor.i18;
	        _this.i18 = _RCore2.default.i18.bind(_this);
	        return _this;
	    }
	
	    _createClass(SassVariablesEditor, [{
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            if (nextState.saved === false) {
	                window.addEventListener('beforeunload', this.saveAlert);
	                this.props.router.setRouteLeaveHook(this.props.route, this.saveAlert);
	            } else if (nextState.saved === true) {
	                window.removeEventListener('beforeunload', this.saveAlert);
	                this.props.router.setRouteLeaveHook(this.props.route, function () {
	                    return true;
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.currentlyEditingVariable !== this.state.currentlyEditingVariable && this.props.onEditVariableChange) {
	                this.props.onEditVariableChange(this.state.currentlyEditingVariable);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var variables = this.props.variables;
	
	
	            if (_lodash2.default.isEmpty(variables)) return null;
	            this.generateInitialCss();
	
	            var wrapperClasses = (0, _classnames2.default)('rlz-theme-cutsomizer', {
	                'rlz-theme-customizer_drawer-is-open': this.state.imagePickerFor
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: wrapperClasses },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rlz-theme-customizer__control' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-theme-customizer__inner-wrapper' },
	                        this.renderSaveControl(),
	                        this.renderVariables(),
	                        this.renderSaveControl()
	                    )
	                ),
	                this.state.imagePickerFor && _react2.default.createElement(_ImageUploaderContainer2.default, {
	                    onCopy: function onCopy(copiedValue) {
	                        return _this2.onImagePick(_this2.state.imagePickerFor, copiedValue);
	                    },
	                    onClose: function onClose() {
	                        _this2.setState({
	                            imagePickerFor: null
	                        }, _this2.props.onImagePickerRequest(null));
	                    },
	                    modal: true,
	                    galleryFirst: true,
	                    cdnOnly: true,
	                    cdnLabel: 'Pick'
	                })
	            );
	        }
	    }]);
	
	    return SassVariablesEditor;
	}(_react2.default.Component);
	
	SassVariablesEditor.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	
	var i18 = SassVariablesEditor.i18 = {
	    da: {},
	    en: {
	        'wrong.variable.value': 'wrong variable value'
	    }
	};
	
	exports.default = SassVariablesEditor;
	exports.SassVariablesEditor = SassVariablesEditor;
	exports.i18 = i18;

/***/ },
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _ThemeColorsPreview = __webpack_require__(1366);
	
	var _ThemeColorsPreview2 = _interopRequireDefault(_ThemeColorsPreview);
	
	var _WidgetShowCase = __webpack_require__(1367);
	
	var _WidgetShowCase2 = _interopRequireDefault(_WidgetShowCase);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = {
	    eventLive: {
	        _id: '57ae735cca3c1dff73d94ab7',
	        eventId: 2349244,
	        startDate: '2016-12-07T15:30:00.000Z',
	        statusType: 'inprogress',
	        statusFull: '1st half',
	        homeId: 584106,
	        awayId: 474523,
	        homeName: 'Racing Roma',
	        awayName: 'Tuttocuoio',
	        homeShortName: 'CTR',
	        awayShortName: 'TUT',
	        countryId: 4,
	        country: 'Italien',
	        tournamentName: 'Italien Serie C1 A',
	        tournamentStageId: 845999,
	        tournamentYear: '2016/2017',
	        tournamentId: 10776,
	        tournamentTemplateId: 147,
	        sportId: 1,
	        sport: 'football',
	        teams: [584106, 474523],
	        version: 31,
	        score: { home: '1', away: '0' },
	        detailedScore: { runningscore: { home: '1', away: '0' }, ordinarytime: { home: '1', away: '0' } },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: { round: '17', live: 'yes', gameStarted: '2016-12-07T15:30:51.000Z' },
	        homeCountryId: 4,
	        awayCountryId: 4
	    },
	    eventFinished: null,
	    eventFinishedET: null,
	    eventFinishedPenalty: null,
	    eventUpcoming: {
	        _id: '57bf969b8946a8c3793f248c',
	        eventId: 2363765,
	        startDate: '2016-12-07T19:45:00.000Z',
	        statusType: 'notstarted',
	        statusFull: 'Not started',
	        homeId: 8633,
	        awayId: 9789,
	        homeName: 'Real Madrid',
	        awayName: 'Borussia Dortmund',
	        homeShortName: 'REA',
	        awayShortName: 'DOR',
	        countryId: 11,
	        country: 'International',
	        tournamentName: 'Champions League',
	        tournamentStageId: 846094,
	        tournamentYear: '2016/2017',
	        tournamentId: 10436,
	        tournamentTemplateId: 42,
	        sportId: 1,
	        sport: 'football',
	        teams: [8633, 9789],
	        version: 25,
	        incidents: [],
	        betOffers: [{
	            type: '1x2',
	            scope: 'ord',
	            odd1: 1.85,
	            oddX: 4,
	            odd2: 4.2,
	            live: false,
	            providerId: 23
	        }, { type: '1x2', scope: 'ord', odd1: 1.87, oddX: 3.75, odd2: 3.9, live: false, providerId: 144 }],
	        score: { away: '0', home: '0' },
	        detailedScore: { runningscore: { home: '0', away: '0' }, ordinarytime: { home: '0', away: '0' } },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: {
	            round: '6',
	            live: 'yes',
	            liveStatsType: 'livestats',
	            venueName: 'Estadio Santiago Bernabeu',
	            refereeFK: '298894',
	            hasLineup: true,
	            hasLineupSent: true
	        },
	        homeCountryId: 8,
	        awayCountryId: 3
	    },
	    eventWith2RedCards: {
	        _id: '57bf96968946a8c3793f2419',
	        eventId: 2363692,
	        startDate: '2016-12-06T19:45:00.000Z',
	        statusType: 'finished',
	        statusFull: 'Finished',
	        homeId: 8688,
	        awayId: 10188,
	        homeName: 'Dynamo Kiev',
	        awayName: 'Besiktas',
	        homeShortName: 'DYN',
	        awayShortName: 'BES',
	        countryId: 11,
	        country: 'International',
	        tournamentName: 'Champions League',
	        tournamentStageId: 846090,
	        tournamentYear: '2016/2017',
	        tournamentId: 10436,
	        tournamentTemplateId: 42,
	        sportId: 1,
	        sport: 'football',
	        teams: [8688, 10188],
	        version: 109,
	
	        score: { home: '6', away: '0' },
	        detailedScore: {
	            finalresult: { home: '6', away: '0' },
	            halftime: { home: '4', away: '0' },
	            runningscore: { home: '6', away: '0' },
	            ordinarytime: { home: '6', away: '0' }
	        },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: {
	            round: '6',
	            live: 'yes',
	            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
	            liveStatsType: 'livestats',
	            refereeFK: '155022',
	            hasLineup: true,
	            hasLineupSent: true,
	            lineupConfirmed: 'yes',
	            lineupConfirmedSent: true,
	            gameStarted: '2016-12-06T19:47:35.000Z',
	            firstHalfEnded: '2016-12-06T20:35:45.000Z',
	            secondHalfStarted: '2016-12-06T20:52:30.000Z',
	            spectators: '14036',
	            secondHalfEnded: '2016-12-06T21:37:36.000Z',
	            gameEnded: '2016-12-06T21:37:36.000Z',
	            verified: 'yes'
	        },
	        homeCountryId: 53,
	        awayCountryId: 13
	    }
	};
	
	var ThemePreview = function (_React$Component) {
	    _inherits(ThemePreview, _React$Component);
	
	    function ThemePreview(props) {
	        _classCallCheck(this, ThemePreview);
	
	        var _this = _possibleConstructorReturn(this, (ThemePreview.__proto__ || Object.getPrototypeOf(ThemePreview)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ThemePreview, [{
	        key: 'renderColorPreview',
	        value: function renderColorPreview(name, clazz) {
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('bg-' + clazz, 'color-preview') },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    name
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                theme = _props.theme,
	                sectionsToShow = _props.sectionsToShow,
	                editVariable = _props.editVariable;
	
	            var themeClass = 'wdp_' + (theme || 'default');
	            var wdp = 'wdp';
	
	            return _react2.default.createElement(
	                _WDPContext2.default,
	                _extends({}, this.props, { key: sectionsToShow.toString() }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'theme-preview' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'widget-container' },
	                        _react2.default.createElement(_WidgetShowCase2.default, { editVariable: editVariable })
	                    ),
	                    sectionsToShow.indexOf('Typography') != -1 && _react2.default.createElement(
	                        'section',
	                        { className: (0, _classnames2.default)(wdp, themeClass) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wdp-widget' },
	                            _react2.default.createElement(_UI2.default.WidgetHeader, { title: 'TYPOGRAPHY' }),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Paragraph $font-size-base'
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                'h1. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'h2. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'h3. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'h4. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'h5. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h6',
	                                null,
	                                'h6. Heading ',
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Secondary text'
	                                )
	                            )
	                        )
	                    ),
	                    sectionsToShow.indexOf('Buttons') != -1 && _react2.default.createElement(
	                        'section',
	                        { className: (0, _classnames2.default)(wdp, themeClass) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wdp-widget' },
	                            _react2.default.createElement(
	                                'div',
	                                { classNames: 'wdp-content' },
	                                _react2.default.createElement(_UI2.default.WidgetHeader, { title: 'BUTTONS' }),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Button variants'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-default' },
	                                    'Default action'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-primary' },
	                                    'Primary action'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-neutral' },
	                                    'Neural action'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-success' },
	                                    'Success action'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-alert' },
	                                    'Alert action'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Button sizes'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-lg' },
	                                    'Button lg'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn' },
	                                    'Button'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-sm' },
	                                    'Button sm'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp,
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'wdp-btn wdp-btn-xs' },
	                                    'Button xs'
	                                ),
	                                ' ',
	                                _UI2.default.nbsp
	                            )
	                        )
	                    ),
	                    sectionsToShow.indexOf('Dividers') != -1 && _react2.default.createElement(
	                        'section',
	                        { className: (0, _classnames2.default)(wdp, themeClass) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wdp-widget' },
	                            _react2.default.createElement(_UI2.default.WidgetHeader, { title: 'TABLES' }),
	                            _react2.default.createElement(
	                                'table',
	                                { className: 'wdp-table' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '#'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'First Name'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Last Name'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Username'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            { scope: 'row' },
	                                            '1'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Mark'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Otto'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '@mdo'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            { scope: 'row' },
	                                            '2'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Jacob'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thornton'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '@fat'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            { scope: 'row' },
	                                            '3'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Larry'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'the Bird'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '@twitter'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ThemePreview;
	}(_react2.default.Component);
	
	exports.default = ThemePreview;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.widgets = undefined;
	
	var _BarChart = __webpack_require__(1348);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _WidgetHeader = __webpack_require__(1349);
	
	var _WidgetHeader2 = _interopRequireDefault(_WidgetHeader);
	
	var _PieChart = __webpack_require__(1350);
	
	var _PieChart2 = _interopRequireDefault(_PieChart);
	
	var _Link = __webpack_require__(1351);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _EventHeader = __webpack_require__(1353);
	
	var _EventHeader2 = _interopRequireDefault(_EventHeader);
	
	var _SimpleEventHeader = __webpack_require__(1355);
	
	var _SimpleEventHeader2 = _interopRequireDefault(_SimpleEventHeader);
	
	var _EventCell = __webpack_require__(1356);
	
	var _EventCell2 = _interopRequireDefault(_EventCell);
	
	var _EventCellPredictor = __webpack_require__(1358);
	
	var _EventCellPredictor2 = _interopRequireDefault(_EventCellPredictor);
	
	var _TeamLogo = __webpack_require__(1359);
	
	var _TeamLogo2 = _interopRequireDefault(_TeamLogo);
	
	var _PlayerLogo = __webpack_require__(1360);
	
	var _PlayerLogo2 = _interopRequireDefault(_PlayerLogo);
	
	var _Pitch = __webpack_require__(1362);
	
	var _Pitch2 = _interopRequireDefault(_Pitch);
	
	var _DropdownIcon = __webpack_require__(1363);
	
	var _DropdownIcon2 = _interopRequireDefault(_DropdownIcon);
	
	var _TournamentName = __webpack_require__(1364);
	
	var _TournamentName2 = _interopRequireDefault(_TournamentName);
	
	var _NavBar = __webpack_require__(1365);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var widgets = {
	    PieChart: _PieChart2.default,
	    BarChart: _BarChart2.default,
	    WidgetHeader: _WidgetHeader2.default,
	    Link: _Link2.default,
	    EventHeader: _EventHeader2.default,
	    SimpleEventHeader: _SimpleEventHeader2.default,
	    EventCell: _EventCell2.default,
	    TeamLogo: _TeamLogo2.default,
	    PlayerLogo: _PlayerLogo2.default,
	    Pitch: _Pitch2.default,
	    DropdownIcon: _DropdownIcon2.default,
	    TournamentName: _TournamentName2.default,
	    NavBar: _NavBar2.default,
	    EventCellPredictor: _EventCellPredictor2.default,
	    nbsp: '\xA0'
	};
	
	exports.default = widgets;
	exports.widgets = widgets;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var BarChart = function (_React$Component) {
	    _inherits(BarChart, _React$Component);
	
	    function BarChart(props) {
	        _classCallCheck(this, BarChart);
	
	        return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).call(this, props));
	    }
	
	    _createClass(BarChart, [{
	        key: 'renderH2H',
	        value: function renderH2H() {
	            var _props = this.props,
	                values = _props.values,
	                total = _props.total,
	                width = _props.width,
	                height = _props.height,
	                type = _props.type,
	                title = _props.title,
	                valLabelPosition = _props.valLabelPosition,
	                animation = _props.animation;
	
	            height = height || width;
	            if (!values || values.length != 2) return;
	
	            total = total || _lodash2.default.reduce(values, function (sum, v) {
	                return sum + v[0];
	            }, 0);
	            if (total == 0) total = 1;
	            var val1perc = values[0][0] * 100 / total / 2;
	            var val2perc = values[1][0] * 100 / total / 2;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('wdp-bar-chart', 'wdp-bar-chart__' + type) },
	                title && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-bar-chart__title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)('wdp-bar-chart__bar', 'wdp-bar-chart__bar__' + type, 'wdp-bar-chart__bar__' + valLabelPosition)
	                    },
	                    values[0][1] !== undefined && _react2.default.createElement(
	                        'label',
	                        { className: 'wdp-bar-chart__label wdp-bar-chart__label-home' },
	                        values[0][1]
	                    ),
	                    values[1][1] !== undefined && _react2.default.createElement(
	                        'label',
	                        { className: 'wdp-bar-chart__label wdp-bar-chart__label-away' },
	                        values[1][1]
	                    ),
	                    _react2.default.createElement(
	                        'svg',
	                        { width: width, height: height },
	                        _react2.default.createElement(
	                            'rect',
	                            { key: val1perc + '_1', className: (0, _classnames2.default)('wdp-bar', 'wdp-bar-0'), height: '100%' },
	                            animation && _react2.default.createElement('animate', {
	                                attributeName: 'width',
	                                from: 0,
	                                to: val1perc + '%',
	                                dur: 1000 * val1perc / 100 + 'ms',
	                                begin: '300ms',
	                                fill: 'freeze'
	                            }),
	                            animation && _react2.default.createElement('animate', {
	                                attributeName: 'x',
	                                from: 50 + '%',
	                                to: 50 - val1perc + '%',
	                                dur: 1000 * val1perc / 100 + 'ms',
	                                begin: '300ms',
	                                fill: 'freeze'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'rect',
	                            { key: val2perc + '_2', x: '50%', className: (0, _classnames2.default)('wdp-bar', 'wdp-bar-1'), height: '100%' },
	                            animation && _react2.default.createElement('animate', {
	                                attributeName: 'width',
	                                from: 0,
	                                to: val2perc + '%',
	                                begin: '300ms',
	                                dur: 1000 * val2perc / 100 + 'ms',
	                                fill: 'freeze'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderDefaultBars',
	        value: function renderDefaultBars() {
	            var _props2 = this.props,
	                values = _props2.values,
	                total = _props2.total,
	                width = _props2.width,
	                height = _props2.height,
	                type = _props2.type,
	                title = _props2.title,
	                animation = _props2.animation;
	
	            height = height || width;
	            total = _lodash2.default.reduce(values, function (sum, v) {
	                return sum + v[0];
	            }, 0);
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('wdp-bar-chart', 'wdp-bar-chart-' + type) },
	                title && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-bar-chart__title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('wdp-bar-chart__bar', 'wdp-bar-chart__bar__' + type) },
	                    _react2.default.createElement(
	                        'svg',
	                        { width: width, height: height },
	                        values.map(function (item, i) {
	                            var left = _lodash2.default.chain(values).take(i).reduce(function (sum, v) {
	                                return sum + v[0];
	                            }, 0).value();
	                            var barWidth = item[0] * 100 / total || 0;
	
	                            return [_react2.default.createElement(
	                                'rect',
	                                {
	                                    key: i,
	                                    x: !total ? '0%' : left * 100 / total + '%',
	                                    className: (0, _classnames2.default)('wdp-bar', 'wdp-bar-' + i),
	                                    width: barWidth + '%',
	                                    height: '100%'
	                                },
	                                animation && _react2.default.createElement('animate', {
	                                    attributeName: 'width',
	                                    from: 0,
	                                    to: barWidth + '%',
	                                    dur: 800 * barWidth / 100 + 'ms',
	                                    begin: 300 + 800 * left / 100 + 'ms',
	                                    fill: 'freeze'
	                                })
	                            ), item[1] !== undefined && _react2.default.createElement(
	                                'text',
	                                {
	                                    key: i + 'lbl',
	                                    x: !total ? '0' : left * 100 / total + '%',
	                                    y: '50%',
	                                    dy: '.35em',
	                                    dx: '.35em',
	                                    fill: '#fff'
	                                },
	                                item[1]
	                            )];
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            switch (this.props.type) {
	                case 'h2h':
	                    return this.renderH2H();
	                    break;
	                default:
	                    return this.renderDefaultBars();
	            }
	        }
	    }]);
	
	    return BarChart;
	}(_react2.default.Component);
	
	exports.default = BarChart;
	
	BarChart.defaultProps = {
	    width: '100%',
	    height: 18,
	    valLabelPosition: 'outside',
	    animation: true,
	    values: [[33, '33%'], [33, '33%'], [33, '33%']],
	    type: 'default'
	};

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// main.js
	
	
	var WidgetHeader = function (_React$Component) {
	    _inherits(WidgetHeader, _React$Component);
	
	    function WidgetHeader(props) {
	        _classCallCheck(this, WidgetHeader);
	
	        return _possibleConstructorReturn(this, (WidgetHeader.__proto__ || Object.getPrototypeOf(WidgetHeader)).call(this, props));
	    }
	
	    _createClass(WidgetHeader, [{
	        key: 'renderDefault',
	        value: function renderDefault() {
	            return _react2.default.createElement(
	                'h3',
	                { className: (0, _classnames2.default)('wdp-widget-header', this.props.className) },
	                this.props.title || '\xA0'
	            );
	        }
	    }, {
	        key: 'renderTV2NO',
	        value: function renderTV2NO() {
	            var _context$info = this.context.info,
	                client = _context$info.client,
	                userContext = _context$info.userContext;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)('wdp-widget-header', 'wdp-header__tv2no', this.props.className, {
	                        'wdp-header__tv2no__with_logo': userContext.teamId
	                    })
	                },
	                userContext.teamId && _react2.default.createElement('div', { className: 'wdp-header__tv2no__team-stripe team-' + userContext.teamId + '__bg-color' }),
	                userContext.teamId && _react2.default.createElement(_UI2.default.TeamLogo, { className: 'wdp-header__tv2no__team-logo', teamId: userContext.teamId }),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    this.props.title || '\xA0'
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var client = this.context.info.client;
	
	            switch (client) {
	                case 'tv2no':
	                    return this.renderTV2NO();
	                default:
	                    return this.renderDefault();
	            }
	        }
	    }]);
	
	    return WidgetHeader;
	}(_react2.default.Component);
	
	WidgetHeader.contextTypes = {
	    info: _propTypes2.default.object
	};
	exports.default = WidgetHeader;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var PieChart = function (_React$Component) {
	    _inherits(PieChart, _React$Component);
	
	    function PieChart(props) {
	        _classCallCheck(this, PieChart);
	
	        return _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call(this, props));
	    }
	
	    _createClass(PieChart, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height,
	                radius = _props.radius,
	                values = _props.values,
	                colorClasses = _props.colorClasses,
	                strokeWidth = _props.strokeWidth;
	
	            height = height || width;
	            radius = radius || (width - strokeWidth * 2) / 2;
	            var total = _lodash2.default.reduce(values, function (sum, v) {
	                return sum + v[0];
	            }, 0);
	            return _react2.default.createElement(
	                "svg",
	                { width: width, height: height, className: "wdp-pie-chart wdp-pie-chart-animate", shapeRendering: "geometricPrecision" },
	                values.map(function (item, i) {
	                    var left = _lodash2.default.chain(values).take(i).reduce(function (sum, v) {
	                        return sum + v[0];
	                    }, 0).value();
	                    var leftInDeg = left * 360 / total;
	
	                    var startingAngle = -90;
	                    var additionalProps = item[2] || {};
	                    return [_react2.default.createElement("circle", _extends({ key: i, cx: width / 2, cy: height / 2, r: radius,
	                        strokeLinecap: "round",
	                        className: (0, _classnames2.default)("wdp-pie-arc", "wdp-pie-arc-" + i),
	                        fill: "transparent",
	                        style: {
	                            transform: 'rotate(' + (startingAngle + leftInDeg) + 'deg)'
	
	                        },
	                        strokeDasharray: item[0] * 360 / total + " " + 360,
	                        strokeWidth: strokeWidth
	                    }, additionalProps))];
	                })
	            );
	        }
	    }]);
	
	    return PieChart;
	}(_react2.default.Component);
	
	exports.default = PieChart;
	
	PieChart.defaultProps = {
	    width: 120,
	    height: 120,
	    strokeWidth: 10,
	    values: [[60, "33%"], [10, "33%"], [40, "33%"]]
	};

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _safeAccess = __webpack_require__(1352);
	
	var _safeAccess2 = _interopRequireDefault(_safeAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// main.js
	
	
	var paramsTransformer = {
	    event: function event(_event) {
	        var params = _lodash2.default.pick(_event, 'eventId', 'startDate', 'homeId', 'awayId', 'homeShortName', 'awayShortName', 'tournamentName', 'tournamentId');
	        params.date = params.startDate && (0, _moment2.default)(params.startDate).format("DD-MM-YYYY");
	        params.tournamentId = _event.tournamentTemplateId;
	        for (var i in params) {
	            params[i] = encodeURIComponent(params[i]);
	        }return params;
	    }
	};
	
	var Link = function (_React$Component) {
	    _inherits(Link, _React$Component);
	
	    function Link(props) {
	        _classCallCheck(this, Link);
	
	        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
	    }
	
	    _createClass(Link, [{
	        key: "handleVoid",
	        value: function handleVoid(e) {
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                action = _props.action,
	                withParams = _props.withParams,
	                disabled = _props.disabled;
	
	            var href = null;
	            if (action && this.context.deeplinker && !disabled) {
	                var params = paramsTransformer[action] && paramsTransformer[action](withParams) || withParams;
	                href = this.context.deeplinker.resolve(action, params);
	            } else {
	                // other ways of delivering
	            }
	
	            return _react2.default.createElement(
	                "a",
	                { className: (0, _classnames2.default)("wdp-link", this.props.className, { 'wdp-link-inactive': !href }), href: href, onClick: !href && this.handleVoid },
	                this.props.children
	            );
	        }
	    }]);
	
	    return Link;
	}(_react2.default.Component);
	
	Link.contextTypes = {
	    info: _propTypes2.default.object,
	    deeplinker: _propTypes2.default.object
	};
	
	exports.default = Link;

/***/ },
/* 1352 */,
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var i18 = {
	    'en': {
	        'venue': 'Stadium: {0}',
	        'spectators': 'Attendance: {0}',
	        'wdl.win': "W",
	        'wdl.draw': "D",
	        'wdl.loss': "L",
	        'points': 'points',
	        'live': 'LIVE {0}\'',
	        'ht': 'HT'
	    },
	    'da': {}
	};
	
	var EventHeader = function (_React$Component) {
	    _inherits(EventHeader, _React$Component);
	
	    function EventHeader(props) {
	        _classCallCheck(this, EventHeader);
	
	        var _this = _possibleConstructorReturn(this, (EventHeader.__proto__ || Object.getPrototypeOf(EventHeader)).call(this, props));
	
	        _this.renderGoals = function (team, maxGoalsByTeam) {
	            var event = _this.props.event && (0, _Eventify2.default)(_this.props.event);
	            var goalIds = [7, 8, 10, 12, 18, 28];
	            var teamId = team == 'home' ? event.homeId : event.awayId;
	            var incidents = _lodash2.default.filter(event.incidents, function (inc) {
	                var teamId = team == 'home' ? event.homeId : event.awayId;
	                return teamId == inc.teamId && goalIds.indexOf(inc.typeId) != -1;
	            });
	
	            if (incidents.length < maxGoalsByTeam) {
	                // add fake lines
	                for (var i = incidents.length; i < maxGoalsByTeam; i++) {
	                    incidents.push('fake');
	                }
	            }
	
	            return _lodash2.default.map(incidents, function (inc, i) {
	                if (inc == 'fake') return _react2.default.createElement(
	                    "div",
	                    { key: i },
	                    _UI2.default.nbsp
	                );
	                var incContent = _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: "incident-minute" },
	                        team == 'home' ? inc.min + "'" : ""
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        ' ' + (inc.participantName ? _RCore2.default.playerShortName(inc.participantName) : '-') + ' ' || ' '
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "incident-minute" },
	                        team == 'away' ? inc.min + "'" : ""
	                    )
	                );
	                var params = { teamId: teamId, teamName: inc.teamName, playerId: inc.participantId, playerName: inc.participantName };
	                return _react2.default.createElement(
	                    "div",
	                    { key: i },
	                    inc.participantId && _react2.default.createElement(
	                        _UI2.default.Link,
	                        { action: "player", params: params },
	                        incContent
	                    ),
	                    !inc.participantId && incContent
	                );
	            });
	        };
	
	        _this.i18dict = i18;
	        _this.i18 = _RCore2.default.i18.bind(_this);
	        return _this;
	    }
	
	    _createClass(EventHeader, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // subscribe to future theme changes
	            this.context.screenSizeObserver.subscribe(function () {
	                return _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: "renderForm",
	        value: function renderForm(form) {
	            var _this3 = this;
	
	            var event = this.props.event;
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-wdl" },
	                    form.results.map(function (ev) {
	                        ev.tournamentTemplateId = event.tournamentTemplateId;
	                        ev.tournamentName = event.tournamentName;
	                        return _react2.default.createElement(
	                            _UI2.default.Link,
	                            {
	                                action: "event",
	                                withParams: ev,
	                                className: "wdp-wdl__item wdp-wdl__item__" + ev.outcome },
	                            _this3.i18("wdl." + ev.outcome)
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-eh__info" },
	                    "#",
	                    form.rank,
	                    ", ",
	                    form.points,
	                    " ",
	                    this.i18(form.points > 1 ? 'points' : 'point')
	                )
	            );
	        }
	    }, {
	        key: "renderStub",
	        value: function renderStub() {
	            var _props = this.props,
	                _props$event = _props.event,
	                event = _props$event === undefined ? {} : _props$event,
	                _props$additionalClas = _props.additionalClasses,
	                additionalClasses = _props$additionalClas === undefined ? {} : _props$additionalClas,
	                useShortNames = _props.useShortNames,
	                form = _props.form,
	                simpleView = _props.simpleView;
	
	            var wrapperClasses = (0, _classnames2.default)('wdp-eh', _extends({
	                'wdp-eh_simple': simpleView
	            }, additionalClasses));
	
	            return _react2.default.createElement("div", { className: wrapperClasses });
	        }
	    }, {
	        key: "renderSimpleView",
	        value: function renderSimpleView(event) {}
	    }, {
	        key: "render",
	        value: function render() {
	            var media = this.context.screenSizeObserver;
	            var _props2 = this.props,
	                _props2$event = _props2.event,
	                event = _props2$event === undefined ? {} : _props2$event,
	                _props2$additionalCla = _props2.additionalClasses,
	                additionalClasses = _props2$additionalCla === undefined ? {} : _props2$additionalCla,
	                useShortNames = _props2.useShortNames,
	                form = _props2.form,
	                simpleView = _props2.simpleView;
	
	
	            if (_lodash2.default.isEmpty(event)) return this.renderStub();
	            var _event = event,
	                homeName = _event.homeName,
	                awayName = _event.awayName,
	                score = _event.score;
	
	
	            var showTeamLogo = this.context.teamLogoSettings && this.context.teamLogoSettings.display != 'none';
	
	            event = (0, _Eventify2.default)(event);
	            var evProperties = event.properties;
	
	            if (media.isXS() || media.isSM() || useShortNames === 'true' || useShortNames === true) {
	                homeName = event.homeShortName || event.homeName && event.homeName.substr(0, 3).toUpperCase();
	                awayName = event.awayShortName || event.awayName && event.awayName.substr(0, 3).toUpperCase();
	            }
	
	            var live = event.isLive();
	            var ht = event.isHT();
	            var coming = event.isComing();
	            var finished = event.isFinished();
	            var cancelled = event.isCancelled();
	            var postponed = event.isPostponed();
	            var notStarted = event.statusType == 'notstarted';
	            var mdate = (0, _moment2.default)(event.startDate);
	
	            var useLargeLogos = !media.isXS();
	            // let useLargeLogos = true;
	
	            var useSmallLogos = !useLargeLogos;
	
	            var bottom = [];
	            bottom.push(evProperties && evProperties.venueName && this.i18('venue', evProperties.venueName));
	            bottom.push(evProperties && evProperties.spectators && this.i18('spectators', evProperties.spectators));
	
	            var maxGoalsByTeam = score && Math.max(score.home, score.away) || 0;
	
	            var wrapperClasses = (0, _classnames2.default)('wdp-eh', _extends({
	                'wdp-eh_simple': simpleView
	            }, additionalClasses));
	
	            if (simpleView) return _react2.default.createElement(
	                "div",
	                { className: wrapperClasses },
	                _react2.default.createElement(
	                    "div",
	                    { className: "tac wdp-eh__info" },
	                    live,
	                    " ",
	                    ht
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-eh__board" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-home wdp-eh__team_winner" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wdp-eh__team-name" },
	                            useSmallLogos && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                homeName || _UI2.default.nbsp
	                            )
	                        ),
	                        form && form.home && this.renderForm(form.home)
	                    ),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId })
	                    ),
	                    live && ht && _react2.default.createElement(
	                        "span",
	                        { className: "wdp-eh__live" },
	                        this.i18('ht')
	                    ),
	                    live && !ht && _react2.default.createElement(
	                        "span",
	                        { className: "wdp-eh__live" },
	                        this.i18('live', event.getMinutes())
	                    ),
	                    !notStarted && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__score" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            score && score.home,
	                            " - ",
	                            score && score.away
	                        )
	                    ),
	                    notStarted && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__score" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: " wdp-eh__score__date" },
	                            this.context.moment(event.startDate).format('DD. MMM')
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: " wdp-eh__score__time" },
	                            this.context.moment(event.startDate).format('HH:mm')
	                        )
	                    ),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-away" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wdp-eh__team-name" },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                awayName || _UI2.default.nbsp
	                            ),
	                            useSmallLogos && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId })
	                        ),
	                        form && form.away && this.renderForm(form.away)
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                "div",
	                { className: wrapperClasses },
	                !simpleView && _react2.default.createElement(
	                    "div",
	                    { className: "tac wdp-eh__info" },
	                    _react2.default.createElement(
	                        _UI2.default.Link,
	                        { action: "tournament", withParams: event },
	                        event.tournamentName || _UI2.default.nbsp
	                    )
	                ),
	                !simpleView && _react2.default.createElement(
	                    "div",
	                    { className: "tac wdp-eh__info" },
	                    event.startDate && mdate.format("D MMMM YYYY") || _UI2.default.nbsp
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-eh__board" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-home wdp-eh__team_winner" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wdp-eh__team-name" },
	                            useSmallLogos && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                homeName || _UI2.default.nbsp
	                            )
	                        ),
	                        form && form.home && this.renderForm(form.home)
	                    ),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId })
	                    ),
	                    live && ht && _react2.default.createElement(
	                        "span",
	                        { className: "wdp-eh__live" },
	                        this.i18('ht')
	                    ),
	                    live && ht && _react2.default.createElement(
	                        "span",
	                        { className: "wdp-eh__live" },
	                        this.i18('live', event.getMinutes())
	                    ),
	                    !notStarted && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__score" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            score && score.home,
	                            " - ",
	                            score && score.away
	                        )
	                    ),
	                    notStarted && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__score" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: " wdp-eh__score__date" },
	                            this.context.moment(event.startDate).format('DD. MMM')
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: " wdp-eh__score__time" },
	                            this.context.moment(event.startDate).format('HH:mm')
	                        )
	                    ),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-away" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wdp-eh__team-name" },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                awayName || _UI2.default.nbsp
	                            ),
	                            useSmallLogos && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId })
	                        ),
	                        form && form.away && this.renderForm(form.away)
	                    )
	                ),
	                event.incidents !== 'undefined' && !simpleView && _react2.default.createElement(
	                    "div",
	                    { className: "wdp-eh__board_incidents" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-home wdp-eh__team-incidents" },
	                        this.renderGoals('home', maxGoalsByTeam)
	                    ),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement("div", { className: "wdp-team-logo" })
	                    ),
	                    _react2.default.createElement("div", { className: "wdp-eh__score" }),
	                    showTeamLogo && useLargeLogos && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh-logos-large" },
	                        _react2.default.createElement("div", { className: "wdp-team-logo" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-eh__team wdp-eh__team-incidents" },
	                        this.renderGoals('away', maxGoalsByTeam)
	                    )
	                ),
	                !simpleView && _react2.default.createElement(
	                    "div",
	                    { className: "tac wdp-eh__info wdp-eh__venue-info" },
	                    _lodash2.default.compact(bottom).join(" | ")
	                )
	            );
	        }
	    }]);
	
	    return EventHeader;
	}(_react2.default.Component);
	
	EventHeader.defaultProps = {
	    type: 'default',
	    useShortNames: false,
	    simpleView: false
	};
	EventHeader.contextTypes = {
	    screenSizeObserver: _propTypes2.default.object,
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	exports.default = EventHeader;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var moment = __webpack_require__(619);
	var _ = __webpack_require__(339);
	
	module.exports = function (ev) {
	    if (!ev) return;
	    if (ev.isLive) return ev;
	
	    ev = _extends({}, ev);
	
	    ev.isLive = function () {
	        return this.statusType === 'inprogress';
	    };
	    ev.isComming = function () {
	        return this.statusType === 'notstarted';
	    };
	    ev.isComing = function () {
	        return this.statusType === 'notstarted';
	    };
	    ev.isFinished = function () {
	        return this.statusType === 'finished';
	    };
	    ev.isFT = ev.isFinished;
	
	    ev.isCancelled = function () {
	        return this.statusType === 'cancelled';
	    };
	    ev.isPostponed = function () {
	        return this.statusFull === 'Postponed';
	    };
	    ev.isHT = function () {
	        return this.statusFull === 'Halftime';
	    };
	    ev.isFirstHalf = function () {
	        return this.statusFull === '1st half';
	    };
	    ev.isSecondHalf = function () {
	        return this.statusFull === '2nd half';
	    };
	    ev.isFirstExtra = function () {
	        return this.statusFull === 'Extra Time - 1st half';
	    };
	    ev.isSecondExtra = function () {
	        return this.statusFull === 'Extra Time - 2nd half';
	    };
	    ev.isPenalty = function () {
	        return this.statusFull === 'Penalty';
	    };
	    ev.isFinishedAP = function () {
	        return this.statusFull === 'Finished AP';
	    };
	    ev.isFinishedAET = function () {
	        return this.statusFull === 'Finished AET';
	    };
	    ev.isWaitingForPenalty = function () {
	        return this.statusFull === 'Waiting for Penalty';
	    };
	    ev.isWaitingForET = function () {
	        return this.statusFull === 'Waiting for extra time';
	    };
	    ev.getCurrentMin = function () {
	        return 10;
	    };
	    ev.getStatusShort = function () {
	        if (this.isComing()) return moment(this.startDate).format('HH:mm');
	        if (this.isHT()) return 'HT';
	        if (this.isLive()) return this.getMinutes();
	        if (this.isCancelled()) return 'CAN';
	        if (this.isFinished()) return 'FT';
	        return '';
	    };
	
	    ev.getStartDate = function () {
	        return moment(+moment.utc(this.startDate));
	    };
	    ev.getPureMinutes = function () {
	        if (this.isComming()) return 0;
	        if (this.isFinishedAP()) return 120;
	        if (this.isFinishedAET()) return 120;
	        if (this.isFinished()) return 90;
	
	        // pauses
	        if (this.isHT()) return 45;
	        if (this.isWaitingForET()) return 90;
	        if (this.isWaitingForPenalty()) return 120;
	
	        var ms = moment().unix() - this.getStartDate().unix();
	
	        var mins = this.msToMin(ms) + 1;
	
	        if (this.isFirstHalf()) {
	            return Math.min(mins, 45);
	        } else if (this.isSecondHalf()) {
	            return Math.min(mins - 15, 90);
	        } else if (this.isWaitingForET()) {
	            return Math.min(mins - 15, 90);
	        } else if (this.isFirstExtra()) {
	            // TODO ADD COEF
	            return Math.min(mins - 15, 120);
	        } else if (this.isSecondExtra()) {
	            // TODO ADD COEF
	            return Math.min(mins - 15, 120);
	        }
	
	        // TODO implement EXTRA TIME + PENALTY SHOOTOUT
	
	        return mins;
	    };
	    ev.msToMin = function (ms) {
	        return Math.round(ms / 60);
	    };
	
	    ev.getMatchLength = function () {
	        if (this.sportId === 5) {
	            //hockey
	            return 60 * 60;
	        }
	        if (this.sportId === 1) {
	            if (this.isFinishedAET() || this.isFinishedAP()) return 120; //
	            if (this.isFirstExtra() || this.isSecondExtra() || this.isPenalty() || this.isWaitingForET() || this.isWaitingForPenalty()) return 120;
	
	            return 90;
	        }
	    };
	
	    ev.getLivePeriod = function () {
	        if (this.detailedScore.extratime) return 4;
	        if (this.detailedScore.period3) return 3;
	        if (this.detailedScore.period2) return 2;
	        if (this.detailedScore.period1) return 1;
	        return 1;
	    };
	    ev.getPeriodStatus = function (period) {
	        if (this.isFinished()) return 'finished';
	        if (this.isComming() || this.isCancelled()) return 'notstarted';
	        if (this.isLive()) {
	            if (this.getLivePeriod() < period) return 'notstarted';
	            if (this.getLivePeriod() === period) return 'live';
	            if (this.getLivePeriod() > period) return 'finished';
	        }
	    };
	
	    ev.getProperties = function () {
	        return this.properties || {};
	    };
	
	    ev.getGameStarted = function () {
	        if (this.getProperties().gameStarted) {
	            return moment.utc(this.getProperties().gameStarted);
	        }
	        return null;
	    };
	    ev.getSecondHalfStarted = function () {
	        if (this.getProperties().secondHalfStarted) {
	            return moment.utc(this.getProperties().secondHalfStarted);
	        }
	        return null;
	    };
	    ev.getSecondHalfEnded = function () {
	        if (this.getProperties().secondHalfEnded) {
	            return moment.utc(this.getProperties().secondHalfEnded);
	        }
	        return null;
	    };
	    ev.hasOT = function () {
	        return this.detailedScore && this.detailedScore.extratime;
	    };
	    ev.hasBullittes = function () {
	        return this.detailedScore && this.detailedScore.penaltyshootout;
	    };
	    ev.getGoalsIncidents = function (isHome) {
	        var teamId = isHome ? this.homeId : this.awayId;
	
	        var goalIds = [7, 8, 10, 12, 18, 28];
	
	        var incidents = _.filter(this.incidents, function (inc) {
	            return teamId === inc.teamId && goalIds.indexOf(inc.typeId) !== -1;
	        });
	        return incidents;
	    };
	    ev.getRichIncidents = function () {
	        var incidents = [];
	        _.each(this.incidents, function (i) {
	            incidents.push(_.clone(i)); // avoid firing events when change incidents
	        });
	
	        var stripped = _.filter(incidents, function (i) {
	            return i.typeId !== 20;
	        }); // remove sub_out
	
	        _.chain(stripped).where({ typeId: 32 }).each(function (i) {
	            i.related = _.where(incidents, { typeId: 20, home: i.home, min: i.min })[0];
	        });
	
	        return stripped;
	    };
	    ev.getMinutes = function () {
	        if (this.eventId < 100) {
	            if (ev.isFinished()) {
	                return ev.getMatchLength();
	            }
	            var inc = _.last(ev.incidents);
	            if (inc) return inc.min;
	        }
	
	        if (this.isFirstHalf() && this.getGameStarted()) {
	            var ms = moment().unix() - this.getGameStarted().unix();
	            return Math.min(this.msToMin(ms) + 1, 45);
	        } else if (this.isSecondHalf() && this.getSecondHalfStarted() !== null) {
	            var _ms = moment().unix() - this.getSecondHalfStarted().unix();
	            return Math.min(this.msToMin(_ms) + 1 + 45, 90);
	        } else if (this.isFirstExtra() && this.getSecondHalfEnded() !== null) {
	            // subtract time from end of second half time
	            // TODO ADD RANDOM TIME SHIFT FOR TIMES DELAY
	            var _ms2 = moment().unix() - this.getSecondHalfEnded().unix();
	            return Math.min(this.msToMin(_ms2) + 1 + 90, 120);
	        } else if (this.isSecondExtra() || this.isPenalty() /* && this.getSecondHalfEnded() != null*/) {
	                // subtract time from end of second half time
	                // TODO ADD RANDOM TIME SHIFT FOR TIMES DELAY
	                var _ms3 = moment().unix() - this.getSecondHalfEnded().unix();
	                return Math.min(this.msToMin(_ms3) + 1 + 90, 120);
	            } else {
	            return this.getPureMinutes();
	        }
	    };
	
	    ev.shouldBeLive = function () {
	        if (ev.isFinished()) return false;
	        var difference = moment().diff(moment(ev.startDate), 'minutes');
	        return difference >= -60;
	    };
	
	    ev.getShortHomeName = function () {
	        return this.homeShortName || this.homeName.substring(0, 3).toUpperCase();
	    };
	
	    ev.getShortAwayName = function () {
	        return this.awayShortName || this.awayName.substring(0, 3).toUpperCase();
	    };
	    ev.shortName = function () {
	        return this.getShortHomeName() + '-' + this.getShortAwayName();
	    };
	
	    return ev;
	};

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.i18 = exports.SimpleEventHeader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var SimpleEventHeader = function (_React$Component) {
	    _inherits(SimpleEventHeader, _React$Component);
	
	    function SimpleEventHeader(props) {
	        _classCallCheck(this, SimpleEventHeader);
	
	        var _this = _possibleConstructorReturn(this, (SimpleEventHeader.__proto__ || Object.getPrototypeOf(SimpleEventHeader)).call(this, props));
	
	        _this.renderTeam = function (side) {
	            var _this$props = _this.props,
	                _this$props$event = _this$props.event,
	                event = _this$props$event === undefined ? {} : _this$props$event,
	                useShortNames = _this$props.useShortNames;
	
	            var media = _this.context.screenSizeObserver;
	
	            var name = event[side + "Name"] || _UI2.default.nbsp;
	            var formation = _this.props[side + "Formation"];
	
	            if (media.isXS() || media.isSM() || useShortNames === 'true' || useShortNames === true) {
	                name = event[side + "ShortName"] || name.substr(0, 3).toUpperCase() || name;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "wdp-simple-eh__team wdp-simple-eh__team_" + side },
	                side == 'away' && _react2.default.createElement(
	                    "span",
	                    { className: "wdp-simple-eh__name" },
	                    formation ? formation + " " : null,
	                    name
	                ),
	                _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event[side + "Id"] }),
	                side == 'home' && _react2.default.createElement(
	                    "span",
	                    { className: "wdp-simple-eh__name" },
	                    name,
	                    formation ? " " + formation : null
	                )
	            );
	        };
	
	        _this.i18dict = i18;
	        _this.i18 = _RCore2.default.i18.bind(_this);
	        return _this;
	    }
	
	    _createClass(SimpleEventHeader, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.context.screenSizeObserver.subscribe(function () {
	                return _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props$additionalClas = this.props.additionalClasses,
	                additionalClasses = _props$additionalClas === undefined ? {} : _props$additionalClas;
	
	            // if (_.isEmpty(event)) return this.renderStub();
	
	            var wrapperClasses = (0, _classnames2.default)(_extends({
	                'wdp-simple-eh': true
	            }, additionalClasses));
	
	            return _react2.default.createElement(
	                "div",
	                { className: wrapperClasses },
	                this.renderTeam('home'),
	                this.renderTeam('away')
	            );
	        }
	    }]);
	
	    return SimpleEventHeader;
	}(_react2.default.Component);
	
	SimpleEventHeader.defaultProps = {
	    type: 'default',
	    useShortNames: false
	};
	SimpleEventHeader.contextTypes = {
	    screenSizeObserver: _propTypes2.default.object,
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	
	var i18 = SimpleEventHeader.i18 = {
	    'en': {},
	    'da': {}
	};
	
	exports.default = SimpleEventHeader;
	exports.SimpleEventHeader = SimpleEventHeader;
	exports.i18 = i18;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _i = __webpack_require__(1357);
	
	var _i2 = _interopRequireDefault(_i);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var i18dict = {
	    en: {
	        round: 'Round {0}',
	        'finished.short': 'FT',
	        'cancelled.short': 'CAN',
	        'postponed.short': 'POST',
	        halftime: 'HT',
	        live: "LIVE {0}'",
	        finished: 'Finished',
	        cancelled: 'Cancelled',
	        postponed: 'Postponed'
	    },
	    da: {
	        round: 'Runde {0}',
	        'finished.short': 'SLUT',
	        'cancelled.short': 'CAN',
	        'postponed.short': 'UDSAT',
	        halftime: 'HT',
	        live: "LIVE {0}'",
	        finished: 'SLUT',
	        cancelled: 'Aflyst',
	        postponed: 'Udsat'
	    }
	};
	
	var EventCell = function (_React$Component) {
	    _inherits(EventCell, _React$Component);
	
	    function EventCell(props) {
	        _classCallCheck(this, EventCell);
	
	        var _this = _possibleConstructorReturn(this, (EventCell.__proto__ || Object.getPrototypeOf(EventCell)).call(this, props));
	
	        _this.getEventStatus = function (event, screenSize) {
	            var status = null;
	            if (!event) return null;
	
	            var live = event.isLive();
	            var ht = event.isHT();
	            var coming = event.isComing();
	            var finished = event.isFinished();
	            var cancelled = event.isCancelled();
	            var postponed = event.isPostponed();
	
	            if (live && ht) status = _this.i18('halftime');else if (live && !ht) status = _this.i18('live', event.getMinutes());else if (coming) status = _this.getPreliveStatus(event);else if ((cancelled || finished || postponed) && !coming && screenSize == 'xs') status = _this.i18(event.statusType + '.short');else status = _this.i18(event.statusType);
	
	            return status;
	        };
	
	        _this.renderCompactCell = function () {
	            var _this$props = _this.props,
	                showBroadcast = _this$props.showBroadcast,
	                linksDisabled = _this$props.linksDisabled,
	                lang = _this$props.lang,
	                _this$props$event = _this$props.event,
	                event = _this$props$event === undefined ? EventCell.defaultProps.event : _this$props$event;
	
	            var showTeamLogo = _this.context.teamLogoSettings && _this.context.teamLogoSettings.display !== 'none' || !_lodash2.default.isEmpty(_this.props.teamLogo);
	            event = (0, _Eventify2.default)(event);
	            var coming = event.isComing();
	
	            // var screenSize = this.context.screenSizeObserver.screenSize
	            var screenSize = _this.props.screenSize || _this.getSSSafe();
	            var _event = event,
	                homeName = _event.homeName,
	                awayName = _event.awayName;
	
	            switch (screenSize) {
	                case 'xs':
	                    {
	                        homeName = event.homeShortName || homeName;
	                        awayName = event.awayShortName || awayName;
	                        break;
	                    }
	                case 'sm':
	                case 'md':
	                case 'lg':
	            }
	            return _react2.default.createElement(
	                _UI2.default.Link,
	                {
	                    action: 'event',
	                    withParams: event,
	                    className: (0, _classnames2.default)('wdp-event-cell', 'wdp-event-cell__line-view', 'wdp-event-cell__' + event.statusType, {
	                        'wdp-event-cell__with-logo': showTeamLogo
	                    }),
	                    disabled: linksDisabled,
	                    key: event.eventId + '_compact'
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__main' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__home wdp-event-cell__team-name' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__name' },
	                            homeName
	                        ),
	                        showTeamLogo && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId, size: 'small' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__score' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__home-score wdp-event-cell__team-score' },
	                            coming ? '-' : _lodash2.default.get(event, 'score.home', 0)
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__score-divider' },
	                            ':'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__away-score wdp-event-cell__team-score' },
	                            coming ? '-' : _lodash2.default.get(event, 'score.away', 0)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__away wdp-event-cell__team-name' },
	                        showTeamLogo && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId, size: 'small' }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__name' },
	                            awayName
	                        )
	                    )
	                ),
	                _this.renderCellInfo(event, screenSize, true)
	            );
	        };
	
	        _this.renderCompactV2Cell = function () {
	            var _this$props2 = _this.props,
	                showBroadcast = _this$props2.showBroadcast,
	                linksDisabled = _this$props2.linksDisabled,
	                lang = _this$props2.lang,
	                _this$props2$event = _this$props2.event,
	                event = _this$props2$event === undefined ? EventCell.defaultProps.event : _this$props2$event;
	
	            var showTeamLogo = _this.context.teamLogoSettings && _this.context.teamLogoSettings.display !== 'none' || !_lodash2.default.isEmpty(_this.props.teamLogo);
	            event = (0, _Eventify2.default)(event);
	            var coming = event.isComing();
	
	            // var screenSize = this.context.screenSizeObserver.screenSize
	            var screenSize = _this.props.screenSize || _this.getSSSafe();
	            var _event2 = event,
	                homeName = _event2.homeName,
	                awayName = _event2.awayName;
	
	            switch (screenSize) {
	                case 'xs':
	                    {
	                        homeName = event.homeShortName || homeName;
	                        awayName = event.awayShortName || awayName;
	                        break;
	                    }
	                case 'sm':
	                case 'md':
	                case 'lg':
	            }
	
	            return _react2.default.createElement(
	                _UI2.default.Link,
	                {
	                    action: 'event',
	                    withParams: event,
	                    key: event.eventId + '_v2_compact',
	                    className: (0, _classnames2.default)('wdp-ecell', 'wdp-ecell__compact-v2', 'wdp-ecell__compact-v2__' + event.statusType, {
	                        'wdp-event-cell__with-logo': showTeamLogo,
	                        'wdp-ecell__stub': event.stub
	                    }),
	                    disabled: linksDisabled
	                },
	                event.isComing() && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-ecell__info' },
	                    _this.context.moment(event.startDate).format('dddd, D MMMM')
	                ),
	                event.isLive() && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-ecell__info wdp-ecell__info__live' },
	                    'LIVE ',
	                    event.isHT() ? _this.i18('halftime') : event.getMinutes()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-ecell__main' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-ecell__team wdp-ecell__team__home' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__name' },
	                            homeName
	                        ),
	                        showTeamLogo && _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team_logo' },
	                            _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId, size: 'small' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-ecell__score' },
	                        !event.stub && coming && _this.context.moment(event.startDate).format('HH:mm'),
	                        !event.stub && !coming && _lodash2.default.get(event, 'score.home', 0) + ' - ' + _lodash2.default.get(event, 'score.away', 0),
	                        event.stub && '-'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-ecell__team wdp-ecell__team__away' },
	                        showTeamLogo && _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team_logo' },
	                            _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId, size: 'small' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__name' },
	                            awayName
	                        )
	                    )
	                ),
	                (event.isComing() || event.isLive()) && event.channel && event.channel.logoUrl && _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-ecell__tv-broadcast' },
	                    _react2.default.createElement('img', { height: '18px', src: event.channel.logoUrl })
	                )
	            );
	        };
	
	        _this.state = {};
	        _this.i18 = _RCore2.default.i18.bind(_this);
	        _this.i18dict = i18dict;
	        return _this;
	    }
	
	    _createClass(EventCell, [{
	        key: 'getSSSafe',
	        value: function getSSSafe() {
	            if (!this.context.screenSizeObserver) return 'sm';
	            return this.context.screenSizeObserver.getSS();
	        }
	    }, {
	        key: 'renderBroadcast',
	        value: function renderBroadcast() {
	            var event = this.props.event;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-event-cell__broadcast' },
	                _react2.default.createElement('img', { src: event.channel.logoUrl })
	            );
	        }
	    }, {
	        key: 'renderStub',
	        value: function renderStub() {
	            var showTeamLogo = this.context.teamLogoSettings && this.context.teamLogoSettings.display != 'none' || !_lodash2.default.isEmpty(this.props.teamLogo);
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)('wdp-event-cell', 'wdp-event-cell__stub', 'wdp-event-cell__notstarted', {
	                        'wdp-event-cell__with-logo': showTeamLogo
	                    })
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__score' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__home' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team-score' },
	                            '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__away' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team-score' },
	                            '-'
	                        )
	                    ),
	                    _react2.default.createElement('span', { className: 'wdp-event-cell__status' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__main' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__info' },
	                        _UI2.default.nbsp
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__home' },
	                        showTeamLogo && false && _react2.default.createElement(_UI2.default.TeamLogo, { size: 'small', tournamentId: tournament.id }),
	                        _UI2.default.nbsp
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__away' },
	                        showTeamLogo && false && _react2.default.createElement(_UI2.default.TeamLogo, { size: 'small', tournamentId: tournament.id }),
	                        _UI2.default.nbsp
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderExtraContent',
	        value: function renderExtraContent() {
	            return null;
	        }
	    }, {
	        key: 'getPreliveStatus',
	        value: function getPreliveStatus(event) {
	            return this.context.moment(event.startDate).format('HH:mm');
	        }
	    }, {
	        key: 'renderCellStatus',
	        value: function renderCellStatus(event, screenSize) {
	            // let live        = event.isLive();
	            // let ht          = event.isHT();
	            var coming = event.isComing();
	            // let finished    = event.isFinished();
	            // let cancelled   = event.isCancelled();
	            // let postponed   = event.isPostponed();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-event-cell__score' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__row wdp-event-cell__home' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'wdp-event-cell__team-score' },
	                        coming ? '-' : _lodash2.default.get(event, 'score.home', 0)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__row wdp-event-cell__away' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'wdp-event-cell__team-score' },
	                        coming ? '-' : _lodash2.default.get(event, 'score.away', 0)
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'wdp-event-cell__status' },
	                    this.getEventStatus(event, screenSize)
	                )
	            );
	        }
	    }, {
	        key: 'renderCellInfo',
	        value: function renderCellInfo(event, screenSize, withStatus) {
	            var statusShort = this.props.statusShort;
	
	            var lang = this.context.info.lang;
	            var tournamentName = _lodash2.default.get(_i2.default, lang + '.' + event.tournamentTemplateId, event.tournamentName);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-event-cell__info' },
	                _lodash2.default.compact([!statusShort && _react2.default.createElement(
	                    'span',
	                    { key: 's0' },
	                    _react2.default.createElement(_UI2.default.TournamentName, {
	                        id: event.tournamentTemplateId,
	                        client: this.context.info.client,
	                        name: tournamentName
	                    })
	                ), !statusShort && _react2.default.createElement(
	                    'span',
	                    { key: 's1' },
	                    '-'
	                ), event.tournamentTemplateId !== 489 && event.properties && _react2.default.createElement(
	                    'span',
	                    { key: 's2' },
	                    this.i18('round', event.properties.round)
	                ), event.tournamentTemplateId !== 489 && event.properties && _react2.default.createElement(
	                    'span',
	                    { key: 's3' },
	                    '-'
	                ), _react2.default.createElement(
	                    'span',
	                    { key: 's4' },
	                    this.context.moment(event.startDate).format(screenSize === 'xs' ? 'DD MMM YY' : 'DD MMMM YYYY')
	                ), withStatus && _react2.default.createElement(
	                    'span',
	                    { key: 's5' },
	                    '-'
	                ), withStatus && _react2.default.createElement(
	                    'span',
	                    { key: 's6' },
	                    this.getEventStatus(event, screenSize)
	                )])
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                showBroadcast = _props.showBroadcast,
	                linksDisabled = _props.linksDisabled,
	                lang = _props.lang,
	                _props$event = _props.event,
	                event = _props$event === undefined ? EventCell.defaultProps.event : _props$event;
	            var _event3 = event,
	                homeName = _event3.homeName,
	                awayName = _event3.awayName;
	
	            var showTeamLogo = this.context.teamLogoSettings && this.context.teamLogoSettings.display !== 'none' || !_lodash2.default.isEmpty(this.props.teamLogo);
	            var eventCellView = this.props.display || _lodash2.default.get(this.context, 'eventCellView.display', 'default');
	            event = (0, _Eventify2.default)(event);
	
	            // var screenSize = this.context.screenSizeObserver.screenSize
	            var screenSize = this.props.screenSize || this.getSSSafe();
	
	            switch (screenSize) {
	                case 'xs':
	                    {
	                        homeName = event.homeShortName || homeName;
	                        awayName = event.awayShortName || awayName;
	                        break;
	                    }
	                case 'sm':
	                case 'md':
	                case 'lg':
	            }
	
	            if (eventCellView === 'compact') {
	                return this.renderCompactCell();
	            } else if (eventCellView === 'compact_v2') {
	                return this.renderCompactV2Cell();
	            }
	            // render stub for loading
	            if (event.stub === true) return this.renderStub();
	
	            return _react2.default.createElement(
	                _UI2.default.Link,
	                {
	                    action: 'event',
	                    withParams: event,
	                    key: event.eventId + '_normal',
	                    className: (0, _classnames2.default)('wdp-event-cell', 'wdp-event-cell__' + event.statusType, {
	                        'wdp-event-cell__with-logo': showTeamLogo
	                    }),
	                    disabled: linksDisabled
	                },
	                this.renderCellStatus(event, screenSize),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-event-cell__main' },
	                    this.renderCellInfo(event, screenSize),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__home' },
	                        showTeamLogo && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.homeId, size: 'small' }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team-name' },
	                            homeName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-event-cell__row wdp-event-cell__away' },
	                        showTeamLogo && _react2.default.createElement(_UI2.default.TeamLogo, { teamId: event.awayId, size: 'small' }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'wdp-event-cell__team-name' },
	                            awayName
	                        )
	                    )
	                ),
	                showBroadcast && event.channel && this.renderBroadcast(),
	                this.renderExtraContent(event)
	            );
	        }
	    }]);
	
	    return EventCell;
	}(_react2.default.Component);
	
	EventCell.defaultProps = {
	    event: {
	        homeName: '\xA0',
	        awayName: '\xA0',
	        score: {
	            home: '-',
	            away: '-'
	        },
	        properties: {}
	    },
	    showBroadcast: false,
	    statusShort: false
	};
	EventCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object,
	    moment: _propTypes2.default.func,
	    eventCellView: _propTypes2.default.object
	};
	
	
	EventCell.spec = {
	    propType: {
	        defaultValue: 'default',
	        key: 'eventCellView',
	        type: 'select_picker',
	        label: 'Event cell view',
	        options: [{
	            text: 'Default',
	            value: 'default'
	        }, {
	            text: 'Compact',
	            value: 'compact'
	        }, {
	            text: 'Compact V2',
	            value: 'compact_v2'
	        }]
	    }
	};
	
	exports.default = EventCell;

/***/ },
/* 1357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    da: {
	        46: '3F Superliga',
	        85: '1. division',
	        239: '2. division',
	        256: '3F Ligaen',
	        242: 'DBU Pokalen',
	        47: 'Premier League',
	        48: 'Championship',
	        132: 'The Emirates FA Cup',
	        133: 'Liga Cup',
	        87: 'Primera Division',
	        138: 'Copa del Rey',
	        55: 'Serie A',
	        141: 'Coppa Italia',
	        54: 'Bundesliga',
	        146: '2.Bundesliga',
	        57: 'Æresdivisionen',
	        53: 'Ligue 1',
	        67: 'Allsvenskan',
	        59: 'Tippeligaen',
	        42: 'UEFA Champions League',
	        73: 'UEFA Europa League',
	        71: 'Tyrkiet Super Lig',
	        77: 'VM (Mænd)',
	        50: 'EM (Mænd)',
	        76: 'VM (Kvinder)',
	        292: 'EM (Kvinder)',
	        489: 'Venskabskamp',
	        10353: 'Venskabskamp',
	        352: 'Primo Tours Ligaen',
	        354: '1.division (Kvinder)',
	        358: 'Op/Ned Spil (Kvinder)',
	        350: 'Cup Winners Cup',
	        348: 'Champions League',
	        361: 'EHF Cup',
	        363: 'Europamesterskab',
	        387: 'Verdensmesterskab',
	
	        367: 'Bundesliga (Kvinder)',
	        372: 'Postenligaen (Kvinder)',
	        383: 'Elitserien (Kvinder)',
	
	        353: 'Boxer Mændligaen',
	        355: '1.division (Mænd)',
	        359: 'Op/Ned Spil (Mænd)',
	
	        349: 'Champions League',
	        362: 'EHF Cup',
	        368: 'Bundesliga (Mænd)',
	        364: 'Europamesterskab',
	        388: 'Verdensmesterskab',
	        373: 'Postenligaen (Mænd)',
	        378: 'Liga Asobal',
	        384: 'Elitserien (Mænd)',
	
	        311: 'Metal Ligaen',
	        24: 'NHL',
	        21: 'SHL',
	        9436: 'KHL',
	        328: 'VM',
	        33: 'VM',
	
	        391: 'Basketligaen (Mænd)',
	        390: 'NBA',
	        392: 'Dameligaen (Kvinder)',
	
	        9079: 'Badmintonligaen',
	
	        8884: 'Volleyligaen (Mænd)',
	        8883: 'Volleyligaen (Kvinder)'
	    }
	};

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventCell2 = __webpack_require__(1356);
	
	var _EventCell3 = _interopRequireDefault(_EventCell2);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventCellPredictor = function (_EventCell) {
	    _inherits(EventCellPredictor, _EventCell);
	
	    function EventCellPredictor() {
	        _classCallCheck(this, EventCellPredictor);
	
	        return _possibleConstructorReturn(this, (EventCellPredictor.__proto__ || Object.getPrototypeOf(EventCellPredictor)).apply(this, arguments));
	    }
	
	    _createClass(EventCellPredictor, [{
	        key: "renderCellInfo",
	        value: function renderCellInfo() {
	            return null;
	        }
	    }, {
	        key: "getPreliveStatus",
	        value: function getPreliveStatus(event) {
	            return (0, _moment2.default)(event.startDate).format('DD. MMM');
	        }
	    }, {
	        key: "renderExtraContent",
	        value: function renderExtraContent(event) {
	            if (event.statusType === 'finished') return null;
	
	            var _context = this.context,
	                handleClickPrediction = _context.handleClickPrediction,
	                predictions = _context.predictions;
	
	            var predictionForThisEvent = _lodash2.default.find(predictions, { eventId: event.eventId });
	            var outcome = predictionForThisEvent && predictionForThisEvent.outcome;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "wdp-event-cell__predict-buttons" },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        onClick: function onClick(e) {
	                            return handleClickPrediction(e, event, 'home');
	                        },
	                        className: "wdp-btn wdp-btn-default " + (outcome === 'home' ? 'wdp-btn-success' : "")
	                    },
	                    "1"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        onClick: function onClick(e) {
	                            return handleClickPrediction(e, event, 'draw');
	                        },
	                        className: "wdp-btn wdp-btn-default " + (outcome === 'draw' ? 'wdp-btn-success' : "")
	                    },
	                    "X"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        onClick: function onClick(e) {
	                            return handleClickPrediction(e, event, 'away');
	                        },
	                        className: "wdp-btn wdp-btn-default " + (outcome === 'away' ? 'wdp-btn-success' : "")
	                    },
	                    "2"
	                )
	            );
	        }
	    }]);
	
	    return EventCellPredictor;
	}(_EventCell3.default);
	
	EventCellPredictor.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object,
	    handleClickPrediction: _propTypes2.default.func,
	    predictions: _propTypes2.default.array
	};
	exports.default = EventCellPredictor;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var TeamLogo = function (_React$Component) {
	    _inherits(TeamLogo, _React$Component);
	
	    function TeamLogo(props) {
	        _classCallCheck(this, TeamLogo);
	
	        var _this = _possibleConstructorReturn(this, (TeamLogo.__proto__ || Object.getPrototypeOf(TeamLogo)).call(this, props));
	
	        _this.showTeamLogo = function (teamId, size) {
	            var sizeFolder = 'original';
	            return 'https://dxugi372p6nmc.cloudfront.net/spdk/current/' + sizeFolder + '/' + teamId + '/teamlogo.png?a=324325435546';
	        };
	
	        _this.showClubsJerseys = function (teamId) {
	            var width = 120;
	            var height = 120;
	            return 'https://dxugi372p6nmc.cloudfront.net/spdk/current/64x64/' + teamId + '/teamlogo.png?a=324325435546';
	        };
	
	        _this.showTeamSVGLogo = function (teamId) {
	            return 'https://dxugi372p6nmc.cloudfront.net/spdk/teams/svg/' + teamId + '.svg';
	        };
	
	        return _this;
	    }
	
	    _createClass(TeamLogo, [{
	        key: 'getDisplay',
	        value: function getDisplay() {
	            if (this.props.jerseys) {
	                return 'jersey';
	            }
	
	            var tournamentId = this.props.tournamentId;
	
	            //If we do not have players images on CDN, show jersey
	
	            if (tournamentId && !_RCore2.default.hasCDNClubLogos(tournamentId)) return 'jersey';
	
	            return this.props.display || this.context.teamLogoSettings.display || 'none';
	        }
	    }, {
	        key: 'getTeamLogoSrc',
	        value: function getTeamLogoSrc(teamId, size) {
	            var display = this.getDisplay();
	            switch (display) {
	                case 'jersey':
	                    return this.showClubsJerseys(teamId);
	                case 'logo':
	                    return this.showTeamLogo(teamId, size);
	                case 'svg':
	                    return this.showTeamSVGLogo(teamId, size);
	                default:
	                    return this.showClubsJerseys(teamId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                teamId = _props.teamId,
	                name = _props.name,
	                isNational = _props.isNational,
	                size = _props.size,
	                jerseys = _props.jerseys,
	                displayTypes = _props.displayTypes,
	                display = _props.display,
	                rest = _objectWithoutProperties(_props, ['teamId', 'name', 'isNational', 'size', 'jerseys', 'displayTypes', 'display']);
	            // var screenSize = this.context.screenSizeObserver.screenSize
	
	
	            if (!teamId) return null;
	            if (this.context.teamLogoSettings && this.context.teamLogoSettings.display === 'none') {
	                return _react2.default.createElement('span', { className: 'wdp-team-logo__none' });
	            }
	            return _react2.default.createElement('img', {
	                style: _lodash2.default.extend({ objectFit: 'contain' }, this.props.style),
	                width: this.props.width,
	                height: this.props.height,
	                className: (0, _classnames2.default)('wdp-team-logo', 'wdp-team-logo_' + this.getDisplay(), 'wdp-team-logo_' + size, this.props.className),
	                src: this.getTeamLogoSrc(teamId, size)
	            });
	        }
	    }]);
	
	    return TeamLogo;
	}(_react2.default.Component);
	
	TeamLogo.defaultProps = {
	    size: 'medium',
	    jerseys: false,
	    displayTypes: ['none', 'logo', 'jersey', 'svg']
	};
	TeamLogo.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	
	TeamLogo.spec = {
	    propType: {
	        key: 'teamLogo',
	        type: 'select_picker',
	        defaultValue: 'jersey',
	        label: 'Club image',
	        options: [{
	            text: 'None',
	            value: 'none'
	        }, {
	            text: 'Jersey',
	            value: 'jersey'
	        }, {
	            text: 'Logo',
	            value: 'logo'
	        }, {
	            text: 'SVG',
	            value: 'svg'
	        }]
	    }
	};
	exports.default = TeamLogo;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _TeamColorProfile = __webpack_require__(1361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var PlayerLogo = function (_React$Component) {
	    _inherits(PlayerLogo, _React$Component);
	
	    function PlayerLogo(props) {
	        _classCallCheck(this, PlayerLogo);
	
	        var _this = _possibleConstructorReturn(this, (PlayerLogo.__proto__ || Object.getPrototypeOf(PlayerLogo)).call(this, props));
	
	        _this.getPlrImageSrc = function (playerId, teamId, seasonId, size) {
	            switch (size) {
	                case 'large':
	                    return _RCore2.default.imageUrls.getPlayerImgBig(teamId, playerId, seasonId);
	                    break;
	                case 'original':
	                    return _RCore2.default.imageUrls.getPlayerImgOriginal(teamId, playerId, seasonId);
	                default:
	                    return _RCore2.default.imageUrls.getPlayerImg(teamId, playerId, seasonId);
	            }
	        };
	
	        _this.showClubsJerseys = function (playerId, teamId, seasonId) {
	            var width = 120;
	            var height = 120;
	            return 'https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_' + teamId + '.png&width-px=' + width + '&height-px=' + height + '&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png';
	        };
	
	        return _this;
	    }
	
	    _createClass(PlayerLogo, [{
	        key: 'getPlrLogoSrc',
	        value: function getPlrLogoSrc(playerId, teamId, seasonId, size, isGK) {
	            switch (this.getDisplayType()) {
	                case '3d_jersey_front':
	                    return 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_' + (isGK ? 'gk_' : '') + 'shirt_' + teamId + '.svg';
	                case '3d_jersey_back':
	                    return 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_' + (isGK ? 'gk_' : '') + 'shirt_' + teamId + '.svg';
	                case 'jersey':
	                    return this.showClubsJerseys(playerId, teamId, size, isGK);
	                case 'image':
	                    return this.getPlrImageSrc(playerId, teamId, seasonId, size);
	                default:
	                    return this.showClubsJerseys(playerId, teamId, size, isGK);
	            }
	        }
	    }, {
	        key: 'getDisplayType',
	        value: function getDisplayType() {
	            var seasonId = this.props.seasonId;
	            //If we do not have players images on CDN, show jersey
	            // fallback if there is no player images
	
	            if (this.props.display === 'image' && !_RCore2.default.hasCDNPlayerLogos(seasonId, this.context.info && this.context.info.client)) return 'jersey';
	            return this.props.display || this.context.plrLogoSettings && this.context.plrLogoSettings.display || 'jersey';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                playerId = _props.playerId,
	                teamId = _props.teamId,
	                seasonId = _props.seasonId,
	                name = _props.name,
	                isNational = _props.isNational,
	                size = _props.size,
	                height = _props.height,
	                width = _props.width,
	                display = _props.display,
	                _props$number = _props.number,
	                number = _props$number === undefined ? null : _props$number,
	                positionEnetType = _props.positionEnetType,
	                _props$style = _props.style,
	                style = _props$style === undefined ? {} : _props$style,
	                rest = _objectWithoutProperties(_props, ['playerId', 'teamId', 'seasonId', 'name', 'isNational', 'size', 'height', 'width', 'display', 'number', 'positionEnetType', 'style']);
	            // var screenSize = this.context.screenSizeObserver.screenSize
	
	
	            if (this.context.plrLogoSettings && this.context.plrLogoSettings.display === 'none') return _react2.default.createElement('span', { className: 'wdp-plr-logo__none' });
	
	            return _react2.default.createElement('img', {
	                style: _lodash2.default.extend({ objectFit: 'contain' }, this.props.style),
	                width: this.props.width,
	                height: this.props.height,
	                className: (0, _classnames2.default)('wdp-plr-logo', 'wdp-plr-logo_' + this.getDisplayType(), 'wdp-plr-logo_' + size, this.props.className),
	                onError: function onError(ev, a) {
	                    ev.target.src = 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_8595.png';
	                },
	                src: this.getPlrLogoSrc(playerId, teamId, seasonId, size)
	            });
	        }
	    }]);
	
	    return PlayerLogo;
	}(_react2.default.Component);
	
	PlayerLogo.defaultProps = {
	    size: 'medium',
	    jerseys: false,
	
	    displayTypes: ['none', 'image', 'jersey']
	};
	PlayerLogo.contextTypes = {
	    info: _propTypes2.default.object,
	    plrLogoSettings: _propTypes2.default.object
	};
	
	PlayerLogo.spec = {
	    propType: {
	        key: 'plrImage',
	        type: 'select_picker',
	        label: 'Player image',
	        options: [{
	            text: 'None',
	            value: 'none'
	        }, {
	            text: 'Jersey',
	            value: 'jersey'
	        }, {
	            text: 'Image',
	            value: 'image'
	        }]
	    }
	};
	exports.default = PlayerLogo;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.colorForTeam = undefined;
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Palette = {};
	
	// Vejle BK
	Palette.team8231 = {
	    color: '#DB000F',
	    shirtNumber: '#FFFFFF',
	    stats: '#FFFFFF',
	    gkShirtNumber: '#fff'
	};
	// Vendsyssel FF
	Palette.team8615 = {
	    color: '#F1F7F6',
	    shirtNumber: '#000C6B',
	    stats: '#000C6B',
	    gkShirtNumber: '#fff'
	};
	
	// Esbjerg fB
	Palette.team8285 = {
	    color: '#2F73C4',
	    shirtNumber: '#FFFFFF',
	    stats: '#FFFFFF',
	    gkShirtNumber: '#FFFFFF'
	};
	
	Palette.team8470 = {
	    color: '#B13040',
	    stats: '#ffffff',
	    shirtNumber: '#B13040',
	    gkShirtNumber: '#e5eae8'
	};
	
	// Viborg FF
	Palette.team9939 = {
	    color: '#006A5D',
	    stats: '#FFFFFF',
	    shirtNumber: '#FFFFFF',
	    gkShirtNumber: '#EC0821'
	};
	
	Palette.team9814 = {
	    color: '#efc80c',
	    stats: '#1e1c13',
	    shirtNumber: '#1e1c13',
	    gkShirtNumber: '#e0e4e3'
	};
	
	Palette.team8071 = {
	    color: '#f7f7f7',
	    stats: '#303c5a',
	    shirtNumber: '#303c5a',
	    gkShirtNumber: '#e9e2e3'
	};
	
	Palette.team8595 = {
	    color: '#f5eb3a',
	    stats: '#24577c',
	    shirtNumber: '#24577c',
	    gkShirtNumber: '#862a33'
	};
	
	Palette.team8391 = {
	    color: '#f7f7f7',
	    stats: '#285b88',
	    shirtNumber: '#285b88',
	    gkShirtNumber: '#e8f2ee'
	};
	Palette.team9843 = {
	    color: '#b5dcf3',
	    stats: '#1d1d1d',
	    shirtNumber: '#1d1d1d',
	    gkShirtNumber: '#f4ebec'
	};
	
	Palette.team8113 = {
	    color: '#0c0c0c',
	    stats: '#ea0909',
	    shirtNumber: '#ea0909',
	    gkShirtNumber: '#10130c'
	};
	
	Palette.team10202 = {
	    color: '#e60b0b',
	    stats: '#f9eeee',
	    shirtNumber: '#f9eeee',
	    gkShirtNumber: '#f2ece8'
	};
	
	Palette.team9950 = {
	    color: '#f4cd3e',
	    stats: '#1c1b13',
	    shirtNumber: '#1c1b13',
	    gkShirtNumber: '#131313'
	};
	
	Palette.team9907 = {
	    color: '#0a43aa',
	    stats: '#eff1f6',
	    shirtNumber: '#eff1f6',
	    gkShirtNumber: '#eaeaea'
	};
	
	Palette.team8414 = {
	    color: '#f7f7f7',
	    stats: '#1d64a5',
	    shirtNumber: '#1d64a5',
	    gkShirtNumber: '#eaeaea'
	};
	
	Palette.team8410 = {
	    color: '#92bcec',
	    stats: '#f3f5f8',
	    shirtNumber: '#f3f5f8',
	    gkShirtNumber: '#Ecf1ef'
	};
	
	Palette.team8415 = {
	    color: '#f70b24',
	    stats: '#f8eced',
	    shirtNumber: '#f8eced',
	    gkShirtNumber: '#191a15'
	};
	
	Palette.team8487 = {
	    color: '#9dacc9',
	    stats: '#f2f3f5',
	    shirtNumber: '#f2f3f5',
	    gkShirtNumber: '#16130a'
	};
	
	Palette.team9825 = {
	    color: '#ca0826',
	    stats: '#ffffff',
	    shirtNumber: '#ffffff',
	    gkShirtNumber: '#e2e5e6'
	}; //
	
	Palette.team8678 = {
	    color: '#f91b32',
	    stats: '#161616',
	    shirtNumber: '#faeff0',
	    gkShirtNumber: '#10110a'
	}; //	#f91b32	#161616	#faeff0	#10110a
	Palette.team10204 = {
	    color: '#0f44de',
	    stats: '#ebedf5',
	    shirtNumber: '#ebedf5',
	    gkShirtNumber: '#130c07'
	}; //	#0f44de	#ebedf5	#ebedf5	#130c07
	Palette.team8191 = {
	    color: '#6d2d37',
	    stats: '#bfdde8',
	    shirtNumber: '#bfdde8',
	    gkShirtNumber: '#361b0e'
	}; //	#6d2d37	#bfdde8	#bfdde8	#361b0e
	Palette.team8455 = {
	    color: '#0b4c9f',
	    stats: '#ffffff',
	    shirtNumber: '#ffffff',
	    gkShirtNumber: '#f5ece9'
	}; //	#0b4c9f	#ffffff	#ffffff	#f5ece9
	Palette.team9826 = {
	    color: '#2d62bb',
	    stats: '#edeff4',
	    shirtNumber: '#edeff4',
	    gkShirtNumber: '#333334'
	}; //	#2d62bb	#edeff4	#edeff4	#333334
	Palette.team8668 = {
	    color: '#193c97',
	    stats: '#eceef2',
	    shirtNumber: '#eceef2',
	    gkShirtNumber: '#f4ebeb'
	}; //	#193c97	#eceef2	#eceef2	#f4ebeb
	Palette.team9796 = {
	    color: '#f7f7f7',
	    stats: '#106dbe',
	    shirtNumber: '#1e1e1e',
	    gkShirtNumber: '#ededed'
	}; //	#f7f7f7	#106dbe	#1e1e1e	#ededed
	Palette.team8197 = {
	    color: '#0f4f98',
	    stats: '#eceef2',
	    shirtNumber: '#eceef2',
	    gkShirtNumber: '#ececec'
	}; //	#0f4f98	#eceef2	#eceef2	#ececec
	Palette.team8650 = {
	    color: '#c8252c',
	    stats: '#f5eded',
	    shirtNumber: '#f5eded',
	    gkShirtNumber: '#e7edea'
	}; //	#c8252c	#f5eded	#f5eded	#e7edea
	Palette.team8456 = {
	    color: '#91c3e7',
	    stats: '#2a3545',
	    shirtNumber: '#2a3545',
	    gkShirtNumber: '#eaf2ef'
	}; //	#91c3e7	#2a3545	#2a3545	#eaf2ef
	Palette.team10260 = {
	    color: '#de1b37',
	    stats: '#f6ecee',
	    shirtNumber: '#f6ecee',
	    gkShirtNumber: '#ebebec'
	}; //	#de1b37	#f6ecee	#f6ecee	#ebebec
	Palette.team10261 = {
	    color: '#181818',
	    stats: '#e5465d',
	    shirtNumber: '#e5465d',
	    gkShirtNumber: '#0d1415'
	}; //	#181818	#e5465d	#e5465d	#0d1415
	
	//#eeeeee	#ae2a3b	#ae2a3b	#131007
	Palette.team8466 = {
	    color: '#eeeeee',
	    stats: '#ae2a3b',
	    shirtNumber: '#ae2a3b',
	    gkShirtNumber: '#131007'
	}; //	#eeeeee	#ae2a3b	#ae2a3b	#131007
	Palette.team10194 = {
	    color: '#f5f5f5',
	    stats: '#e11f1f',
	    shirtNumber: '#e11f1f',
	    gkShirtNumber: '#e9e7eb'
	}; //	#f5f5f5	#e11f1f	#e11f1f	#e9e7eb
	Palette.team10003 = {
	    color: '#f7f7f7',
	    stats: '#212121',
	    shirtNumber: '#212121',
	    gkShirtNumber: '#0f1212'
	}; //	#f7f7f7	#212121	#212121	#0f1212
	Palette.team8586 = {
	    color: '#f7f7f7',
	    stats: '#2f618d',
	    shirtNumber: '#2f618d',
	    gkShirtNumber: '#15130b'
	}; //	#f7f7f7	#2f618d	#2f618d	#15130b
	Palette.team9817 = {
	    color: '#f4de6b',
	    stats: '#863d3f',
	    shirtNumber: '#863d3f',
	    gkShirtNumber: '#e8f0f2'
	}; //	#f4de6b	#863d3f	#863d3f	#e8f0f2
	Palette.team8659 = {
	    color: '#2a3a64',
	    stats: '#edeeef',
	    shirtNumber: '#edeeef',
	    gkShirtNumber: '#0b130d'
	}; //	#2a3a64	#edeeef	#edeeef	#0b130d
	Palette.team8654 = {
	    color: '#6d293a',
	    stats: '#f0edee',
	    shirtNumber: '#f0edee',
	    gkShirtNumber: '#14150d'
	}; //	#6d293a	#f0edee	#f0edee	#14150d
	
	// bundesliga
	Palette.team8177 = { color: '#005ca9', stats: ' #ffffff', shirtNumber: '#486190', gkShirtNumber: '#000' };
	Palette.team8178 = { color: '#1a171b', stats: ' #e32221', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8226 = { color: '#1c63b7', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8358 = { color: '#000000', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8406 = { color: '#ba3733', stats: ' #ffffff', shirtNumber: '#ba3733', gkShirtNumber: '#fff' };
	Palette.team8697 = { color: '#19694e', stats: ' #ffffff', shirtNumber: '#50e16a', gkShirtNumber: '#000' };
	Palette.team8721 = { color: '#65b32e', stats: ' #ffffff', shirtNumber: '#2747B8', gkShirtNumber: '#ffffff' };
	Palette.team8722 = { color: '#f7f7f7', stats: ' #ed1c24', shirtNumber: '#ed1c24', gkShirtNumber: '#ed1c24' };
	Palette.team9788 = { color: '#f7f7f7', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9789 = { color: '#fde100', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team9790 = { color: '#376aaa', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9810 = { color: '#f7f7f7', stats: ' #454545', shirtNumber: '#fff', gkShirtNumber: '#454545' };
	Palette.team9823 = { color: '#ed1248', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9904 = { color: '#179d33', stats: ' #000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9905 = { color: '#ed1c24', stats: ' #000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10189 = { color: '#0060a9', stats: ' #f7f7f7', shirtNumber: '#f7f7f7', gkShirtNumber: '#f7f7f7' };
	Palette.team10269 = { color: '#ffffff', stats: ' #e32219', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team178475 = { color: '#f7f7f7', stats: ' #dd0741', shirtNumber: '#dd0741', gkShirtNumber: '#dd0741' };
	Palette.team2004 = { color: '#171415', stats: ' #c51218', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team6238 = { color: '#a4c6e9', stats: ' #000000', shirtNumber: '#1f1916', gkShirtNumber: '#1f1916' };
	Palette.team6694 = { color: '#005aa1', stats: ' #d9d9d9', shirtNumber: '#d9d9d9', gkShirtNumber: '#d9d9d9' };
	Palette.team8014 = { color: '#f4d910', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8248 = { color: '#00963a', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8310 = { color: '#172981', stats: ' #fed200', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8349 = { color: '#00080d', stats: ' #ffee00', shirtNumber: '#ffee00', gkShirtNumber: '#ffee00' };
	Palette.team8359 = { color: '#0a4987', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8428 = { color: '#fcd200', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8449 = { color: '#f7f7f7', stats: ' #194d99', shirtNumber: '#194d99', gkShirtNumber: '#194d99' };
	Palette.team8510 = { color: '#006039', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8527 = { color: '#f7f7f7', stats: ' #1a171b', shirtNumber: '#1a171b', gkShirtNumber: '#1a171b' };
	Palette.team9802 = { color: '#3dbaf0', stats: ' #0e305d', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9892 = { color: '#db001b', stats: ' #f7f7f7', shirtNumber: '#f7f7f7', gkShirtNumber: '#f7f7f7' };
	Palette.team9893 = { color: '#0062ac', stats: ' #fabc00', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10237 = { color: '#b2d1ed', stats: ' #13191e', shirtNumber: '#13191e', gkShirtNumber: '#13191e' };
	Palette.team7988 = { color: '#000000', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8007 = { color: '#3e407b', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8180 = { color: '#1f227a', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8404 = { color: '#f8941a', stats: ' #003d60', shirtNumber: '#003d60', gkShirtNumber: '#003d60' };
	Palette.team8422 = { color: '#ffffff', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8468 = { color: '#e31a22', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8476 = { color: '#f7db13', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8478 = { color: '#e83646', stats: ' #fff506', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8509 = { color: '#2747a3', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8512 = { color: '#e9e9e9', stats: ' #264a90', shirtNumber: '#264a90', gkShirtNumber: '#264a90' };
	Palette.team8605 = { color: '#081d58', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8608 = { color: '#ed1c24', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8609 = { color: '#144f94', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8616 = { color: '#f7c92a', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9917 = { color: '#176fc1', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9918 = { color: '#182c56', stats: ' #ca902b', shirtNumber: '#ca902b', gkShirtNumber: '#ca902b' };
	
	Palette.team8560 = { color: '#0a42a3', stats: '#fafafa', shirtNumber: '#fafafa', gkShirtNumber: '#09140d' };
	Palette.team8634 = { color: '#185493', stats: '#E5A409', shirtNumber: '#f6dc40', gkShirtNumber: '#ea6d41' };
	Palette.team9866 = { color: '#1b3dc0', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8315 = { color: '#fafafa', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9906 = { color: '#ea2441', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9910 = { color: '#93bdd2', stats: '#9e2d35', shirtNumber: '#9e2d35', gkShirtNumber: '#efe7e7' };
	Palette.team9783 = { color: '#0054a0', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team8372 = { color: '#a33031', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team8558 = { color: '#1b68a5', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team8305 = { color: '#4a8ac1', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team7732 = { color: '#cf2a31', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8306 = { color: '#ebcd22', stats: '#00489f', shirtNumber: '#00489f', gkShirtNumber: '#ebcd22' };
	Palette.team7854 = { color: '#1283D6', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8581 = { color: '#11497E', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9864 = { color: '#1B6CBD', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8603 = { color: '#23956a', stats: '#ffffff', shirtNumber: '#23956a', gkShirtNumber: '#000000' };
	Palette.team8633 = { color: '#f8f8f8', stats: '#2AAFD0', shirtNumber: '#2AAFD0', gkShirtNumber: '#ffffff' };
	Palette.team8302 = { color: '#f8f8f8', stats: '#F5364D', shirtNumber: '#F5364D', gkShirtNumber: '#fff' };
	Palette.team10267 = { color: '#000000', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team10205 = { color: '#F6E255', stats: '#1d1c15', shirtNumber: '#1d1c15', gkShirtNumber: '#000000' };
	
	Palette.team674792 = { color: '#000', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#fff' };
	Palette.team9891 = { color: '#FFE200', stats: '#0275BB', shirtNumber: '#0275BB', gkShirtNumber: '#0275BB' };
	Palette.team8534 = { color: '#0261A6', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#fff' };
	Palette.team8587 = { color: '#F5F5F5', stats: '#000', shirtNumber: '#000', gkShirtNumber: '#fff' };
	Palette.team9837 = { color: '#D83E43', stats: '#fff', shirtNumber: '#D83E43', gkShirtNumber: '#000' };
	Palette.team6394 = { color: '#E70812', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
	Palette.team9851 = { color: '#E53B2C', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
	Palette.team8592 = { color: '#02A7E0', stats: '#fff', shirtNumber: '#02A7E0', gkShirtNumber: '#fff' };
	Palette.team8121 = { color: '#fff', stats: '#000', shirtNumber: '#000', gkShirtNumber: '#000' };
	Palette.team9830 = { color: '#FFDB00', stats: '#1C9A42', shirtNumber: '#1C9A42', gkShirtNumber: '#fff' };
	Palette.team96925 = { color: '#251F82', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
	Palette.team10281 = { color: '#9D1B93', stats: '#fff', shirtNumber: '#000', gkShirtNumber: '#000' };
	Palette.team8370 = { color: '#fff', stats: '#D33D2E', shirtNumber: '#000', gkShirtNumber: '#fff' };
	
	Palette.team8686 = { color: '#A92030', stats: '#FBB300', shirtNumber: '#FBB300', gkShirtNumber: '#FBB300' };
	Palette.team9876 = { color: '#252b4f', stats: '#e9c714', shirtNumber: '#e9c714', gkShirtNumber: '#ffffff' };
	Palette.team10252 = { color: '#A4345F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8283 = { color: '#D42327', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8658 = { color: '#003593', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8559 = { color: '#E8E4EC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9937 = { color: '#B1021F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8427 = { color: '#D6313F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9792 = { color: '#F2DA29', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8344 = { color: '#253F9F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10170 = { color: '#ECECEC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9879 = { color: '#ECECEC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8667 = { color: '#F59A15', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9902 = { color: '#2C4EDD', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8463 = { color: '#E4E4E4', stats: '#2A4B9F', shirtNumber: '#2A4B9F', gkShirtNumber: '#ffffff' };
	Palette.team8549 = { color: '#C50007', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10004 = { color: '#1E3979', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9850 = { color: '#FFF916', stats: '#00795E', shirtNumber: '#00795E', gkShirtNumber: '#ffffff' };
	Palette.team10203 = { color: '#FF312C', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8411 = { color: '#DFDFDF', stats: '#001B5B', shirtNumber: '#001B5B', gkShirtNumber: '#ffffff' };
	Palette.team10172 = { color: '#F3FAFF', stats: '#CD2E37', shirtNumber: '#1E78CE', gkShirtNumber: '#ffffff' };
	Palette.team9798 = { color: '#F1F1F1', stats: '#941614', shirtNumber: '#2A4EA5', gkShirtNumber: '#ffffff' };
	Palette.team8657 = { color: '#CC1B21', stats: '#000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10163 = { color: '#506BEB', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8472 = { color: '#F00F19', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8602 = { color: '#FF9D29', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	
	Palette.team8564 = { color: '#B3131C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8524 = { color: '#3467C6', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6266 = { color: '#E9CC64', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team9857 = { color: '#1A183D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8529 = { color: '#20203E', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8533 = { color: '#F9E331', stats: '#174879', shirtNumber: '#174879', gkShirtNumber: '#000000' };
	Palette.team9876 = { color: '#252B4F', stats: '#E9C714', shirtNumber: '#E9C714', gkShirtNumber: '#FFFFFF' };
	Palette.team9884 = { color: '#061144', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#303443' };
	Palette.team8535 = { color: '#492D6F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8636 = { color: '#2863B2', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#F9F116' };
	Palette.team9885 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8543 = { color: '#A5CADD', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8686 = { color: '#8D2833', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#F29101' };
	Palette.team9882 = { color: '#29439A', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team7943 = { color: '#278F5B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8547 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9875 = { color: '#227AAA', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9804 = { color: '#621827', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8600 = { color: '#505050', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team10233 = { color: '#911726', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	
	Palette.team8454 = { color: '#D82432', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9823 = { color: '#D32735', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	
	Palette.teamMER = { color: '#00D2BE', stats: '#000000' };
	Palette.teamFER = { color: '#DC0000', stats: '#FFFFFF' };
	Palette.teamRBR = { color: '#00327D', stats: '#FFFFFF' };
	Palette.teamFIN = { color: '#F596C8', stats: '#000000' };
	Palette.teamWIL = { color: '#F6F6F6', stats: '#002E5E' };
	Palette.teamREN = { color: '#FFF500', stats: '#000000' };
	Palette.teamSTR = { color: '#0032FF', stats: '#FFFFFF' };
	Palette.teamHAS = { color: '#5A5A5A', stats: '#FFFFFF' };
	Palette.teamMCL = { color: '#FF8700', stats: '#000000' };
	Palette.teamSAU = { color: '#9B0000', stats: '#DFE2E6' };
	
	//china
	Palette.team4177 = { color: '#2C7546', stats: '#D0C34D', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team6445 = { color: '#F97D47', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6401 = { color: '#8A292B', stats: '#F0D47B', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team4184 = { color: '#F83C40', stats: '#4161B0', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team256658 = { color: '#66B0E1', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team92646 = { color: '#BE2F37', stats: '#B28E58', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team7803 = { color: '#FFFFFF', stats: '#3A4C9E', shirtNumber: '#3A4C9E', gkShirtNumber: '#000000' };
	Palette.team256659 = { color: '#FFFFFF', stats: '#CEC74E', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team525097 = { color: '#B0142C', stats: '#771E2C', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team51442 = { color: '#9B1627', stats: '#1C3F8D', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team167482 = { color: '#305BB1', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8623 = { color: '#E77D31', stats: '#305BB1', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6628 = { color: '#305BB1', stats: '#89081E', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team198616 = { color: '#A1192B', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team256660 = { color: '#E21D35', stats: '#4A030B', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team4189 = { color: '#FFFFFF', stats: '#305BB1', shirtNumber: '#305BB1', gkShirtNumber: '#000000' };
	// wc
	Palette.team6716 = { color: '#FDCA2E', stats: '#273A35', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8491 = { color: '#FFFFFF', stats: '#CD1F2D', shirtNumber: '#CD1F2D', gkShirtNumber: '#FFFFFF' };
	Palette.team6706 = { color: '#FFFFFF', stats: '#CAD6E1', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8263 = { color: '#BA282D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#20C47D' };
	Palette.team8256 = { color: '#EFC54D', stats: '#419B69', shirtNumber: '#419B69', gkShirtNumber: '#FFFFFF' };
	Palette.team8570 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team8238 = { color: '#CE0A25', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team10255 = { color: '#CE0A25', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6711 = { color: '#FFFFFF', stats: '#B2092C', shirtNumber: '#B2092C', gkShirtNumber: '#FFFFFF' };
	Palette.team8536 = { color: '#0844AB', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6720 = { color: '#D82723', stats: '#E7C451', shirtNumber: '#E7C451', gkShirtNumber: '#000000' };
	Palette.team8258 = { color: '#FDF04D', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#3ABB60' };
	Palette.team6705 = { color: '#D1162F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6262 = { color: '#FFFFFF', stats: '#D1162F', shirtNumber: '#D1162F', gkShirtNumber: '#000000' };
	Palette.team6710 = { color: '#126E6A', stats: '#188E5B', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6346 = { color: '#FFFFFF', stats: '#C4DEB0', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team5922 = { color: '#AD1836', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team5798 = { color: '#FFFFFF', stats: '#A92129', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8568 = { color: '#B1333A', stats: '#922131', shirtNumber: '#c72b33', gkShirtNumber: '#FFFFFF' };
	Palette.team8361 = { color: '#D4232F', stats: '#167A58', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8713 = { color: '#DA272C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team7795 = { color: '#5AA95E', stats: '#fff', shirtNumber: '#5AA95E', gkShirtNumber: '#FFFFFF' };
	Palette.team6395 = { color: '#FFFFFF', stats: '#1BA797', shirtNumber: '#1BA797', gkShirtNumber: '#FFFFFF' };
	Palette.team8205 = { color: '#E63A39', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team6719 = { color: '#FFFFFF', stats: '#CC1018', shirtNumber: '#CC1018', gkShirtNumber: '#FFFFFF' };
	Palette.team5796 = { color: '#7AA7CD', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6723 = { color: '#292E40', stats: '#2097CC', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team10165 = { color: '#FFFFFF', stats: '#DF243D', shirtNumber: '#DF243D', gkShirtNumber: '#FFFFFF' };
	Palette.team6717 = { color: '#CE1932', stats: '#EC576C', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8520 = { color: '#E6DF66', stats: '#2F3A7D', shirtNumber: '#2F3A7D', gkShirtNumber: '#000000' };
	Palette.team7804 = { color: '#F35C54', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#CEF16B' };
	Palette.team6715 = { color: '#CEF16B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team10155 = { color: '#b92730', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	//fin
	Palette.team6550 = { color: '#3971DC', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8424 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9861 = { color: '#336DC3', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6605 = { color: '#F0C72E', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team6634 = { color: '#FFFFFF', stats: '#137676', shirtNumber: '#137676', gkShirtNumber: '#FFFFFF' };
	Palette.team162146 = { color: '#F0DC31', stats: '#148B6D', shirtNumber: '#148B6D', gkShirtNumber: '#F0DC31' };
	Palette.team1693 = { color: '#F8E233', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team4672 = { color: '#FB142C', stats: '#246CBA', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team1576 = { color: '#1E68C7', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team162162 = { color: '#000000', stats: '#9F8465', shirtNumber: '#9F8465', gkShirtNumber: '#000000' };
	Palette.team6633 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team6597 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team10252 = { color: '#780B47', stats: '#B4CDE7', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	//champ
	Palette.team8283 = { color: '#DD3847', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team8658 = { color: '#003E9A', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8559 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9937 = { color: '#E90D37', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#20C47D' };
	Palette.team8427 = { color: '#E73144', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9792 = { color: '#F4D747', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8344 = { color: '#2D4694', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#2D4694' };
	Palette.team10170 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#137F94' };
	Palette.team9879 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8667 = { color: '#FBB95A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9902 = { color: '#2845C4', stats: '#000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team10172 = { color: '#000000', stats: '#0E62BA', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8463 = { color: '#F9F9F9', stats: '#B3914F', shirtNumber: '#B3914F', gkShirtNumber: '#235084' };
	Palette.team8549 = { color: '#CD0C23', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#5BCA7D' };
	Palette.team10004 = { color: '#212E4E', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team9850 = { color: '#FEE857', stats: '#1FCB80', shirtNumber: '#1FCB80', gkShirtNumber: '#ffffff' };
	Palette.team10203 = { color: '#FC333E', stats: '#F9F9F9', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8411 = { color: '#ffffff', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team9798 = { color: '#F9F9F9', stats: '#083DAD', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8472 = { color: '#DB0B2D', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#2D69C7' };
	Palette.team8602 = { color: '#F8872A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team10163 = { color: '#3050B5', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
	Palette.team8657 = { color: '#C00718', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
	Palette.team8119 = { color: '#DD0301', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8528 = { color: '#0350C1', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
	Palette.team8655 = { color: '#ffffff', stats: '#282B90', shirtNumber: '#282B90', gkShirtNumber: '#ffffff' };
	// bund
	Palette.team9912 = { color: '#294FB4', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9911 = { color: '#1776C4', stats: '#0F2D69', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8262 = { color: '#1466C5', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8293 = { color: '#FFFFFF', stats: '#2352B8', shirtNumber: '#2352B8', gkShirtNumber: '#000000' };
	Palette.team8480 = { color: '#FBAE3A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team9776 = { color: '#F8C84F', stats: '#2F649A', shirtNumber: '#2F649A', gkShirtNumber: '#000000' };
	Palette.team8319 = { color: '#3A2B8D', stats: '#F2C88A', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team94937 = { color: '#B90A25', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8194 = { color: '#FFFFFF', stats: '#F11F25', shirtNumber: '#F11F25', gkShirtNumber: '#0C5968' };
	Palette.team8357 = { color: '#FFFFFF', stats: '#137730', shirtNumber: '#137730', gkShirtNumber: '#FFFFFF' };
	Palette.team8150 = { color: '#175AA9', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#175AA9' };
	Palette.team7789 = { color: '#FFFFFF', stats: '#EB2127', shirtNumber: '#EB2127', gkShirtNumber: '#FFFFFF' };
	Palette.team8350 = { color: '#AC0728', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8086 = { color: '#3F3B49', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8152 = { color: '#3F3B49', stats: '#E0334C', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8149 = { color: '#FFFFFF', stats: '#E5253A', shirtNumber: '#E5253A', gkShirtNumber: '#FFFFFF' };
	Palette.team8234 = { color: '#DB1927', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8165 = { color: '#9B2231', stats: '#484452', shirtNumber: '#fff', gkShirtNumber: '#fff' };
	
	Palette.team5797 = { color: '#407950', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6329 = { color: '#104D9D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6317 = { color: '#4F895F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team6714 = { color: '#FFFFFF', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8700 = { color: '#184680', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team5884 = { color: '#102095', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team5884 = { color: '#DB0B0B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8254 = { color: '#EEC200', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team5866 = { color: '#FFFFFF', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8566 = { color: '#103F95', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team5795 = { color: '#95001B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9762 = { color: '#C60606', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	
	Palette.team9829 = { color: '#b80010', stats: '#FFFFFF', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team8342 = { color: '#0177bf', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8640 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
	Palette.team9847 = { color: '#151e2d', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team8687 = { color: '#A5010B', stats: '#f5bc4e', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team9773 = { color: '#00a6f0', stats: '#FFFFFF', shirtNumber: '#00a6f0', gkShirtNumber: '#FFFFFF' };
	Palette.team8637 = { color: '#c5022f', stats: '#ffb900', shirtNumber: '#c5022f', gkShirtNumber: '#FFFFFF' };
	Palette.team8710 = { color: '#009f4b', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8593 = { color: '#d50032', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team8563 = { color: '#f5c308', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	Palette.team9772 = { color: '#FFFFFF', stats: '#c30000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9728 = { color: '#f27022', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
	Palette.team9748 = { color: '#14387f', stats: '#FFFFFF', shirtNumber: '#14387f', gkShirtNumber: '#FFFFFF' };
	Palette.team6033 = { color: '#FF102C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team9760 = { color: '#003990', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
	Palette.team10192 = { color: '#ffcf00', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
	
	Palette.team7787 = { color: '#D7141A', stats: '#fff', shirtNumber: '#D7141A', gkShirtNumber: '#FFFFFF' };
	
	var colorForTeam = function colorForTeam(team, color) {
	    var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#fff';
	
	    return _lodash2.default.get(Palette, 'team' + team + '.' + color, def);
	};
	
	exports.default = Palette;
	exports.colorForTeam = colorForTeam;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var Pitch = function (_React$Component) {
	    _inherits(Pitch, _React$Component);
	
	    function Pitch(props) {
	        _classCallCheck(this, Pitch);
	
	        var _this = _possibleConstructorReturn(this, (Pitch.__proto__ || Object.getPrototypeOf(Pitch)).call(this, props));
	
	        _this.renderTeamOnHalfPitch = function (lineup, teamSide) {
	            var i = -1;
	            var that = _this;
	            return _lodash2.default.chain(lineup).filter(function (plr) {
	                return plr.positionCode > 0;
	            }).sortBy(function (plr) {
	                return parseInt(plr.positionCode);
	            }).groupBy(function (plr) {
	                var pos = plr.positionCode + "";
	                if (pos.length == 3) return pos[0] + pos[1];
	                return pos[0];
	            }).map(function (lineup, x, obj) {
	                i++;
	                var plrsInLine = lineup.length;
	                return _lodash2.default.chain(lineup).sortBy(function (plr) {
	                    return parseInt(plr.positionCode);
	                }).map(function (plr, y) {
	                    return that.renderPlayer(plr.positionCode, plr, teamSide, i, Object.keys(obj).length, y, plrsInLine);
	                }).value();
	            }).value();
	        };
	
	        _this.renderPlayer = function (positionCode, plr, teamSide, x, lines, y, plrsInLine) {
	            //var scaleFactor = (this.state.side == 'home' || this.state.side == 'away') ? 2 : 1;
	            var scaleFactor = parseFloat(_this.props.scaleFactor);
	            var style = {};
	            var isHome = teamSide === 'home';
	
	            // let teamId = isHome ? this.props.homeId : this.props.awayId;
	            // let shirtUrl = this.getTeamShirtImg(teamId);
	            //
	            // let linkToPlayer = this.props.linkToPlayer ? this.props.urls.player('soccer', teamId, plr.playerId, plr.name) : null;
	
	            var gap = plrsInLine == 5 ? 3 * (y % 2 == 0 ? 1 : -1) : 0;
	            if (_this.isLandscape()) {
	                var step = 100 / plrsInLine;
	                style[isHome ? 'left' : 'right'] = scaleFactor * (x / lines * 100 + gap) + "%";
	                style[isHome ? 'bottom' : 'top'] = y * step + 0.5 * step + "%";
	            } else {
	                var step = 100 / plrsInLine;
	                style[isHome ? 'left' : 'right'] = y * step + 0.5 * step + "%";
	                style[isHome ? 'top' : 'bottom'] = scaleFactor * (x / lines * 100 + gap) + "%";
	            }
	
	            var incidents = _this.props.event.incidents.filter(function (inc) {
	                return inc.participantId === plr.playerId;
	            });
	
	            return _react2.default.cloneElement(_this.props.children, _lodash2.default.extend({
	                key: positionCode + "-" + teamSide + "-" + plr.name
	            }, {
	                incidents: incidents,
	                positionCode: positionCode,
	                style: style,
	                teamId: _this.props.event[teamSide + "Id"],
	                tournamentId: _this.props.event.tournamentTemplateId
	            }, plr));
	        };
	
	        return _this;
	    }
	
	    _createClass(Pitch, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // subscribe to future theme changes
	            this.context.screenSizeObserver.subscribe(function () {
	                return _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: "isLandscape",
	        value: function isLandscape() {
	            var media = this.context.screenSizeObserver;
	            return media.isMD() || media.isLG();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                seasonId = _props.seasonId,
	                showTeamLogos = _props.showTeamLogos;
	
	            var homeLinkParams = {
	                teamId: event.homeId,
	                teamName: event.homeName,
	                seasonId: event.tournamentId,
	                tournamentId: event.tournamentTemplateId
	            };
	            var awayLinkParams = {
	                teamId: event.awayId,
	                teamName: event.awayName,
	                seasonId: event.tournamentId,
	                tournamentId: event.tournamentTemplateId
	            };
	            return _react2.default.createElement(
	                "div",
	                { key: "pitch", className: (0, _classnames2.default)("wdp-pitch", { "wdp-pitch__landscape": this.isLandscape(), "wdp-pitch__portrait": !this.isLandscape() }) },
	                _react2.default.createElement("div", { className: "wdp-pitch__center-circle wdp-pitch__bars" }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-pitch__half wdp-pitch__half-home" },
	                    showTeamLogos ? _react2.default.createElement(
	                        _UI2.default.Link,
	                        { action: "team", withParams: homeLinkParams },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { className: "wdp-pitch__team-logo", teamId: event.homeId, seasonId: seasonId })
	                    ) : "",
	                    _react2.default.createElement("span", { className: "wdp-pitch__corner wdp-pitch__bars" }),
	                    _react2.default.createElement("span", { className: "wdp-pitch__corner bl wdp-pitch__bars" }),
	                    _react2.default.createElement("div", { className: "wdp-pitch__post wdp-pitch__bars" }),
	                    _react2.default.createElement("div", { className: "wdp-pitch__straffen wdp-pitch__bars" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-pitch__post-circle wdp-pitch__bars" },
	                        _react2.default.createElement(
	                            "svg",
	                            { width: "80", height: "30" },
	                            _react2.default.createElement("path", { d: "M0,-2 a50,50 0 0,0 80,0" })
	                        )
	                    ),
	                    this.renderTeamOnHalfPitch(this.props.home, 'home')
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "wdp-pitch__half wdp-pitch__half-away" },
	                    showTeamLogos ? _react2.default.createElement(
	                        _UI2.default.Link,
	                        { action: "team", withParams: awayLinkParams },
	                        _react2.default.createElement(_UI2.default.TeamLogo, { className: "wdp-pitch__team-logo", teamId: event.awayId, seasonId: seasonId })
	                    ) : "",
	                    _react2.default.createElement("span", { className: "wdp-pitch__corner tr wdp-pitch__bars" }),
	                    _react2.default.createElement("span", { className: "wdp-pitch__corner br wdp-pitch__bars" }),
	                    _react2.default.createElement("div", { className: "wdp-pitch__post wdp-pitch__bars" }),
	                    _react2.default.createElement("div", { className: "wdp-pitch__straffen wdp-pitch__bars" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-pitch__post-circle wdp-pitch__post-circle_away wdp-pitch__bars" },
	                        _react2.default.createElement(
	                            "svg",
	                            { width: "80", height: "30" },
	                            _react2.default.createElement("path", { d: "M0,-2 a50,50 0 0,0 80,0" })
	                        )
	                    ),
	                    this.renderTeamOnHalfPitch(this.props.away, 'away')
	                )
	            );
	        }
	    }]);
	
	    return Pitch;
	}(_react2.default.Component);
	
	Pitch.contextTypes = {
	    screenSizeObserver: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	Pitch.defaultProps = {
	    scaleFactor: 1.0
	};
	
	var Player = function (_React$Component2) {
	    _inherits(Player, _React$Component2);
	
	    function Player(props) {
	        _classCallCheck(this, Player);
	
	        return _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));
	    }
	
	    _createClass(Player, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                number = _props2.number,
	                teamId = _props2.teamId,
	                name = _props2.name,
	                playerId = _props2.playerId,
	                style = _props2.style,
	                showPlayerImages = _props2.showPlayerImages,
	                seasonId = _props2.seasonId,
	                showJerseys = _props2.showJerseys,
	                tournamentId = _props2.tournamentId;
	
	            var linkParams = {
	                playerId: playerId,
	                teamId: teamId,
	                playerName: name,
	                tournamentId: tournamentId,
	                seasonId: seasonId
	            };
	            var showPlrLogo = this.context.plrLogoSettings && this.context.plrLogoSettings.display != 'none';
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "wdp-pitch__player" },
	                _react2.default.createElement(
	                    _UI2.default.Link,
	                    { action: "player", withParams: linkParams },
	                    showPlrLogo && _react2.default.createElement(_UI2.default.PlayerLogo, { className: "wdp-pitch__player__image", teamId: teamId, playerId: playerId, seasonId: seasonId }),
	                    !showPlrLogo && _react2.default.createElement(
	                        "div",
	                        { className: "wdp-pitch__player__number" },
	                        number
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wdp-pitch__player__name" },
	                        _RCore2.default.playerShortName(name)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Player;
	}(_react2.default.Component);
	
	Player.contextTypes = {
	    plrLogoSettings: _propTypes2.default.object
	};
	
	
	Pitch.Player = Player;
	exports.default = Pitch;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SVGDropdownIcon(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({}, props, { viewBox: "0 0 24 24", className: "wdp-icon-dropdown" }),
	        _react2.default.createElement("path", { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" })
	    );
	}
	
	exports.default = SVGDropdownIcon;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentName = function (_React$Component) {
	    _inherits(TournamentName, _React$Component);
	
	    function TournamentName() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TournamentName);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TournamentName.__proto__ || Object.getPrototypeOf(TournamentName)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
	            var tournamentsWithLogos = [46];
	
	            var _this$props = _this.props,
	                name = _this$props.name,
	                id = _this$props.id;
	
	            if (!id) return _react2.default.createElement(
	                'span',
	                null,
	                '\xA0'
	            );
	
	            if (tournamentsWithLogos.indexOf(id) === -1) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'wdp-tournament-svg-logo_text' },
	                    name || '\xA0'
	                );
	            }
	
	            //Superleague for spdk
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'wdp-tournament-svg-logo_text' },
	                name
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return TournamentName;
	}(_react2.default.Component);
	
	TournamentName.contextTypes = {
	    info: _propTypes2.default.object
	};
	exports.default = TournamentName;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// main.js
	
	
	var NavBar = function (_React$Component) {
	    _inherits(NavBar, _React$Component);
	
	    function NavBar(props, context) {
	        _classCallCheck(this, NavBar);
	
	        var _this = _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props, context));
	
	        _this.measure = function () {
	            var el = _reactDom2.default.findDOMNode(_this);
	            var elitems = _reactDom2.default.findDOMNode(_this.refs.items);
	            var containerWidth = el.offsetWidth;
	            // if (el);
	
	            var itemsToShow = 0;
	            var totalWidth = 0;
	
	            for (var i = 0; i < elitems.children.length; i++) {
	                var item = elitems.children[i];
	                totalWidth += item.offsetWidth;
	
	                if (totalWidth < containerWidth) {
	                    itemsToShow++;
	                }
	            }
	
	            if (itemsToShow === 0) itemsToShow = 1;
	
	            _this.setState({
	                overflow: itemsToShow !== elitems.children.length,
	                itemsToShow: itemsToShow,
	                measured: true
	            });
	            // var widthitems = ReactDOM.findDOMNode(this.refs.items).offsetWidth;
	            // console.log("WIDTH", width, widthitems)
	        };
	
	        _this.state = {
	            overflow: false,
	            itemsToShow: _this.props.children.length,
	            expanded: false,
	            measured: false
	        };
	        return _this;
	    }
	
	    _createClass(NavBar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // subscribe to future theme changes
	            // super.componentDidMount();
	            // window.dispatchEvent(new Event('resize'));
	            this.measure();
	            this.context.screenSizeObserver.subscribe(function () {
	                _this2.measure();
	                _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                overflow = _state.overflow,
	                itemsToShow = _state.itemsToShow,
	                expanded = _state.expanded,
	                measured = _state.measured;
	
	            var media = this.context.screenSizeObserver;
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(this.props.className, 'wdp-nav wdp-nav-tabs wdp-nav-bar') },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'wdp-nav-bar__shadow', ref: 'items' },
	                    this.props.children
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'wdp-nav-bar__list', onClick: function onClick() {
	                            return _this3.setState({ expanded: false });
	                        } },
	                    measured ? _lodash2.default.take(this.props.children, itemsToShow) : _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            null,
	                            _UI2.default.nbsp
	                        )
	                    )
	                ),
	                expanded && _react2.default.createElement(
	                    'ul',
	                    { className: 'wdp-nav-bar__popup', onClick: function onClick() {
	                            return _this3.setState({ expanded: false });
	                        } },
	                    false && _lodash2.default.takeRight(this.props.children, this.props.children.length - itemsToShow),
	                    this.props.children
	                ),
	                overflow && _react2.default.createElement(_UI2.default.DropdownIcon, { onClick: function onClick() {
	                        return _this3.setState({ expanded: !_this3.state.expanded });
	                    } })
	            );
	        }
	    }]);
	
	    return NavBar;
	}(_react2.default.Component);
	
	NavBar.contextTypes = {
	    screenSizeObserver: _propTypes2.default.object
	};
	exports.default = NavBar;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeColorPreview = function (_React$Component) {
	    _inherits(ThemeColorPreview, _React$Component);
	
	    function ThemeColorPreview(props) {
	        _classCallCheck(this, ThemeColorPreview);
	
	        return _possibleConstructorReturn(this, (ThemeColorPreview.__proto__ || Object.getPrototypeOf(ThemeColorPreview)).call(this, props));
	    }
	
	    _createClass(ThemeColorPreview, [{
	        key: "renderColorPreview",
	        value: function renderColorPreview(name, clazz) {
	            return _react2.default.createElement(
	                "div",
	                { key: name, className: (0, _classnames2.default)("bg-" + clazz, "color-preview") },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    name
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                client = _props.client,
	                theme = _props.theme;
	
	            var wdp = "wdp";
	            return _react2.default.createElement(
	                "div",
	                { className: "rlz-common-widget theme-preview" },
	                _react2.default.createElement(
	                    "section",
	                    { className: (0, _classnames2.default)(wdp, theme) },
	                    ['primary-color', 'bg-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['gray-base', 'gray-darker', 'gray-dark', 'gray', 'gray-light', 'gray-lighter'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['nav-color', 'nav-text-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['success-color', 'neutral-color', 'alert-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['win-color', 'draw-color', 'lost-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['text-color', 'headings-color', 'link-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['live-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null),
	                    ['chart-base-color', 'chart-text-color'].map(function (e) {
	                        return _this2.renderColorPreview(e, e);
	                    }),
	                    _react2.default.createElement("div", null)
	                )
	            );
	        }
	    }]);
	
	    return ThemeColorPreview;
	}(_react2.default.Component);
	
	exports.default = ThemeColorPreview;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _BaseWidget2 = __webpack_require__(1368);
	
	var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetShowCase = function (_BaseWidget) {
	    _inherits(WidgetShowCase, _BaseWidget);
	
	    function WidgetShowCase(props) {
	        _classCallCheck(this, WidgetShowCase);
	
	        var _this = _possibleConstructorReturn(this, (WidgetShowCase.__proto__ || Object.getPrototypeOf(WidgetShowCase)).call(this, props));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.editVariable != _this.state.editVariable) {
	                _this.setState({ editVariable: nextProps.editVariable });
	            }
	        };
	
	        _this.componentDidUpdate = function (prevState) {
	            if (prevState.editVariable != _this.state.editVariable) {}
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(WidgetShowCase, [{
	        key: 'renderColorPreview',
	        value: function renderColorPreview(name, clazz) {
	            return _react2.default.createElement(
	                'div',
	                { key: name, className: (0, _classnames2.default)('bg-' + clazz, 'color-preview') },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    name
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var editVariable = this.state.editVariable;
	
	            return _react2.default.createElement(
	                _BaseWidget3.default.BaseBarWrap,
	                { className: (0, _classnames2.default)('wdp-widget', 'wdp-show-case', 'field-' + editVariable), title: 'Example of widget' },
	                _react2.default.createElement(
	                    'div',
	                    { 'data-hint': 'Navigation background color', className: (0, _classnames2.default)('nav-box', { 'wdp-theme-customizer-edit': ['nav-color'].indexOf(editVariable) != -1 }) },
	                    _react2.default.createElement(
	                        _UI2.default.NavBar,
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', 'data-hint': 'Def font color', className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 }) },
	                                'Menu Item 1'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            {
	                                'data-hint': 'Active menu item',
	                                className: (0, _classnames2.default)('wdp-nav-active', { 'wdp-theme-customizer-edit': ['primary-color', 'nav-active-color'].indexOf(editVariable) != -1 })
	                            },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    'data-hint': 'Active font color',
	                                    className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': ['primary-text-color', 'nav-active-text-color'].indexOf(editVariable) != -1 })
	                                },
	                                'Menu Item 2'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', 'data-hint': 'Def font color', className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 }) },
	                                'Menu Item 3'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', 'data-hint': 'Def font color', className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 }) },
	                                'Menu Item 1'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('wdp-content', { 'wdp-theme-customizer-edit': editVariable == 'bg-color' }), 'data-hint': 'Background of widget' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _UI2.default.nbsp
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': editVariable == 'gray-base' }), 'data-hint': 'Fonts, strokes, dividers' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'accent variable' },
	                                '$gray-base'
	                            ),
	                            ' color is negative to background. It is used to create default text colors, stokes, dividers etc.'
	                        ),
	                        ['gray-base', 'gray-darker', 'gray-dark', 'gray', 'gray-light', 'gray-lighter'].map(function (e) {
	                            return _this2.renderColorPreview(e, e);
	                        }),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Main text color will inherin'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'sub-text-color' },
	                            _react2.default.createElement(
	                                'sm',
	                                null,
	                                'Main text color will inhering'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'wdp-divider wdp-vertical-margin wdp-full-width' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)({ 'wdp-theme-customizer-edit': ['primary-color', 'primary-text-color'].indexOf(editVariable) != -1 }), 'data-hint': 'Accents' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _classnames2.default)('variable', { accent: ['primary-color'].indexOf(editVariable) != -1 }) },
	                                '$primary-color'
	                            ),
	                            ' color is as background of active elements or to highlight important data'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _classnames2.default)('variable', { accent: ['primary-text-color'].indexOf(editVariable) != -1 }) },
	                                '$primary-text-color'
	                            ),
	                            ' color is used for text where',
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'variable' },
	                                '$primary-color'
	                            ),
	                            ' is used'
	                        ),
	                        ['primary-color', 'primary-text-color'].map(function (e) {
	                            return _this2.renderColorPreview(e, e);
	                        }),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'bg-primary-color primary-text-color', style: { padding: '5px', textAlign: 'center' } },
	                            'Main text color will inherit'
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'wdp-divider wdp-vertical-margin wdp-full-width' }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: (0, _classnames2.default)('field-' + editVariable, {
	                                'wdp-theme-customizer-edit': ['home-color', 'away-color', 'chart-bar-away-color', 'chart-bar-home-color', 'chart-bar-away-color', 'chart-bar-label-text-color', 'chart-bar-back-color'].indexOf(editVariable) != -1
	                            }),
	                            'data-hint': 'Comparing teams'
	                        },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _classnames2.default)('variable', { accent: ['home-color'].indexOf(editVariable) != -1 }) },
	                                '$home-color'
	                            ),
	                            ' and',
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _classnames2.default)('variable', { accent: ['away-color'].indexOf(editVariable) != -1 }) },
	                                '$away-color'
	                            ),
	                            ' colors are used to when comparing two teams'
	                        ),
	                        _react2.default.createElement(_UI2.default.BarChart, { className: 'wdp-barchart-test wdp-theme-customizer-edit', type: 'h2h', title: 'Simple Bar', values: [[10, '10'], [10, '10']] }),
	                        _react2.default.createElement('br', null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('field-' + editVariable, 'wdp-full-width', { 'wdp-theme-customizer-edit': ['live-color', 'live-text-color'].indexOf(editVariable) != -1 }) },
	                        _react2.default.createElement(_UI2.default.EventCell, { event: data.eventLive, showClubsJerseys: true, display: 'compact_v2' }),
	                        _react2.default.createElement(_UI2.default.EventCell, { event: data.eventComming, showClubsJerseys: true, display: 'compact_v2' }),
	                        _react2.default.createElement(_UI2.default.EventCell, { event: data.eventFinished, showClubsJerseys: true, display: 'compact_v2' }),
	                        _react2.default.createElement(_UI2.default.EventCell, { event: data.eventHT, showClubsJerseys: true, display: 'compact_v2' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WidgetShowCase;
	}(_BaseWidget3.default);
	
	var data = {
	    eventLive: {
	        _id: '57ae735cca3c1dff73d94ab7',
	        eventId: 2349244,
	        startDate: '2016-12-07T15:30:00.000Z',
	        statusType: 'inprogress',
	        statusFull: '1st half',
	        homeId: 584106,
	        awayId: 474523,
	        homeName: 'Racing Roma',
	        awayName: 'Tuttocuoio',
	        homeShortName: 'CTR',
	        awayShortName: 'TUT',
	        countryId: 4,
	        country: 'Italien',
	        tournamentName: 'Italien Serie C1 A',
	        tournamentStageId: 845999,
	        tournamentYear: '2016/2017',
	        tournamentId: 10776,
	        tournamentTemplateId: 147,
	        sportId: 1,
	        sport: 'football',
	        teams: [584106, 474523],
	        version: 31,
	        score: { home: '1', away: '0' },
	        detailedScore: { runningscore: { home: '1', away: '0' }, ordinarytime: { home: '1', away: '0' } },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: { round: '17', live: 'yes', gameStarted: '2016-12-07T15:30:51.000Z' },
	        homeCountryId: 4,
	        awayCountryId: 4
	    },
	    eventComming: {
	        _id: '57bf969b8946a8c3793f248c',
	        eventId: 2363765,
	        startDate: '2016-12-07T19:45:00.000Z',
	        statusType: 'notstarted',
	        statusFull: 'Not started',
	        homeId: 8633,
	        awayId: 9789,
	        homeName: 'Real Madrid',
	        awayName: 'Borussia Dortmund',
	        homeShortName: 'REA',
	        awayShortName: 'DOR',
	        countryId: 11,
	        country: 'International',
	        tournamentName: 'Champions League',
	        tournamentStageId: 846094,
	        tournamentYear: '2016/2017',
	        tournamentId: 10436,
	        tournamentTemplateId: 42,
	        sportId: 1,
	        sport: 'football',
	        teams: [8633, 9789],
	        version: 25,
	        incidents: [],
	        betOffers: [{
	            type: '1x2',
	            scope: 'ord',
	            odd1: 1.85,
	            oddX: 4,
	            odd2: 4.2,
	            live: false,
	            providerId: 23
	        }, { type: '1x2', scope: 'ord', odd1: 1.87, oddX: 3.75, odd2: 3.9, live: false, providerId: 144 }],
	        score: { away: '0', home: '0' },
	        detailedScore: { runningscore: { home: '0', away: '0' }, ordinarytime: { home: '0', away: '0' } },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: {
	            round: '6',
	            live: 'yes',
	            liveStatsType: 'livestats',
	            venueName: 'Estadio Santiago Bernabeu',
	            refereeFK: '298894',
	            hasLineup: true,
	            hasLineupSent: true
	        },
	        homeCountryId: 8,
	        awayCountryId: 3
	    },
	    eventFinished: {
	        _id: '57bf96968946a8c3793f2419',
	        eventId: 2363692,
	        startDate: '2016-12-06T19:45:00.000Z',
	        statusType: 'finished',
	        statusFull: 'Finished',
	        homeId: 8688,
	        awayId: 10188,
	        homeName: 'Dynamo Kiev',
	        awayName: 'Besiktas',
	        homeShortName: 'DYN',
	        awayShortName: 'BES',
	        countryId: 11,
	        country: 'International',
	        tournamentName: 'Champions League',
	        tournamentStageId: 846090,
	        tournamentYear: '2016/2017',
	        tournamentId: 10436,
	        tournamentTemplateId: 42,
	        sportId: 1,
	        sport: 'football',
	        teams: [8688, 10188],
	        version: 109,
	
	        score: { home: '6', away: '0' },
	        detailedScore: {
	            finalresult: { home: '6', away: '0' },
	            halftime: { home: '4', away: '0' },
	            runningscore: { home: '6', away: '0' },
	            ordinarytime: { home: '6', away: '0' }
	        },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: {
	            round: '6',
	            live: 'yes',
	            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
	            liveStatsType: 'livestats',
	            refereeFK: '155022',
	            hasLineup: true,
	            hasLineupSent: true,
	            lineupConfirmed: 'yes',
	            lineupConfirmedSent: true,
	            gameStarted: '2016-12-06T19:47:35.000Z',
	            firstHalfEnded: '2016-12-06T20:35:45.000Z',
	            secondHalfStarted: '2016-12-06T20:52:30.000Z',
	            spectators: '14036',
	            secondHalfEnded: '2016-12-06T21:37:36.000Z',
	            gameEnded: '2016-12-06T21:37:36.000Z',
	            verified: 'yes'
	        },
	        homeCountryId: 53,
	        awayCountryId: 13
	    },
	    eventHT: {
	        _id: '57bf96968946a8c3793f2419',
	        eventId: 2363692,
	        startDate: '2016-12-06T19:45:00.000Z',
	        statusType: 'finished',
	        statusFull: 'Finished',
	        homeId: 8688,
	        awayId: 10188,
	        homeName: 'Dynamo Kiev',
	        awayName: 'Besiktas',
	        homeShortName: 'DYN',
	        awayShortName: 'BES',
	        countryId: 11,
	        country: 'International',
	        tournamentName: 'Champions League',
	        tournamentStageId: 846090,
	        tournamentYear: '2016/2017',
	        tournamentId: 10436,
	        tournamentTemplateId: 42,
	        sportId: 1,
	        sport: 'football',
	        teams: [8688, 10188],
	        version: 109,
	
	        score: { home: '6', away: '0' },
	        detailedScore: {
	            finalresult: { home: '6', away: '0' },
	            halftime: { home: '4', away: '0' },
	            runningscore: { home: '6', away: '0' },
	            ordinarytime: { home: '6', away: '0' }
	        },
	        homeIsToBeDecided: false,
	        awayIsToBeDecided: false,
	        properties: {
	            round: '6',
	            live: 'yes',
	            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
	            liveStatsType: 'livestats',
	            refereeFK: '155022',
	            hasLineup: true,
	            hasLineupSent: true,
	            lineupConfirmed: 'yes',
	            lineupConfirmedSent: true,
	            gameStarted: '2016-12-06T19:47:35.000Z',
	            firstHalfEnded: '2016-12-06T20:35:45.000Z',
	            secondHalfStarted: '2016-12-06T20:52:30.000Z',
	            spectators: '14036',
	            secondHalfEnded: '2016-12-06T21:37:36.000Z',
	            gameEnded: '2016-12-06T21:37:36.000Z',
	            verified: 'yes'
	        },
	        homeCountryId: 53,
	        awayCountryId: 13
	    }
	};
	
	exports.default = WidgetShowCase;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BaseBarWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _isomorphicFetch = __webpack_require__(1375);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _url2 = __webpack_require__(289);
	
	var _url3 = _interopRequireDefault(_url2);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _widgetCategories = __webpack_require__(615);
	
	var _widgetCategories2 = _interopRequireDefault(_widgetCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function checkStatus(response) {
	    if (response.status >= 200 && response.status < 300) {
	        return response;
	    } else {
	        var error = new Error(response.statusText);
	        error.response = response;
	        throw error;
	    }
	}
	
	function parseJSON(response) {
	    return response.json();
	}
	
	var BaseWidget = function (_React$Component) {
	    _inherits(BaseWidget, _React$Component);
	
	    function BaseWidget(props, context) {
	        _classCallCheck(this, BaseWidget);
	
	        var _this = _possibleConstructorReturn(this, (BaseWidget.__proto__ || Object.getPrototypeOf(BaseWidget)).call(this, props, context));
	
	        _this.resetAnimation = function () {
	            if (!_this.animation) return;
	            _this.animation.pause();
	            _this.animation.reset();
	            window.dispatchEvent(new Event('resetAnimation'));
	        };
	
	        _this.revealContent = function () {
	            if (false) return;
	            var element = document.querySelector('.sm-wdp__container');
	            if (!element) return;
	            element.style.visibility = 'visible';
	        };
	
	        _this.getLayoutType = function () {
	            if (_this.props.layoutType) return _this.props.layoutType;
	
	            if (_this.props.variation) return _lodash2.default.get(_this.state.template, 'theme.variations.' + _this.constructor.spec.id + '.' + _this.props.variation + '.widgetProps.layoutType', 'default');
	            return _lodash2.default.get(_this.state.template, 'widgetProps.' + _this.constructor.spec.id + '.layoutType', 'default');
	        };
	
	        _this.addAnimationListeners = function () {
	            window.addEventListener('startAnimation', _this.startAnimation, false);
	            window.addEventListener('pauseAnimation', _this.pauseAnimation, false);
	            window.addEventListener('playAnimation', _this.playAnimation, false);
	            window.addEventListener('restartAnimation', _this.restartAnimation, false);
	        };
	
	        _this.removeAnimationListeners = function () {
	            window.removeEventListener('startAnimation', _this.startAnimation, false);
	            window.removeEventListener('pauseAnimation', _this.pauseAnimation, false);
	            window.removeEventListener('playAnimation', _this.playAnimation, false);
	            window.removeEventListener('restartAnimation', _this.restartAnimation, false);
	        };
	
	        _this.setPState = function (data) {
	            return new Promise(function (resolve, reject) {
	                _this.setState(data, resolve);
	            });
	        };
	
	        _this.smRenderEmpty = function () {
	            if (_this.state.__status) {
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            textAlign: 'center',
	                            padding: 15,
	                            backgroundColor: '#fff',
	                            color: '#000',
	                            width: 800
	                        }
	                    },
	                    'Status: ',
	                    _this.state.__status.message
	                );
	            }
	            return _react2.default.createElement('div', null);
	        };
	
	        _this.mesureHeight = function () {
	            var componentNode = _reactDom2.default.findDOMNode(_this);
	            var height = componentNode && componentNode.offsetHeight;
	            var width = componentNode && componentNode.offsetWidth;
	            var data = {
	                height: height || document.body.offsetHeight,
	                width: width || document.body.offsetWidth,
	                url: window.location.href,
	                from: 'wdp'
	            };
	            if (typeof document !== 'undefined' && typeof parent !== 'undefined' && window.self !== window.top) {
	                var domain = document.referrer;
	                if (domain && data && parent && parent.postMessage) {
	                    try {
	                        parent.postMessage(JSON.stringify(data), domain);
	                    } catch (e) {
	                        //
	                    }
	                }
	            }
	            // post to window
	            try {
	                var mkey = width + '_' + height;
	                if (mkey != _this._mkey) {
	                    _this.props.onMeasure && _this.props.onMeasure(width, height);
	                    window.postMessage(JSON.stringify(data), location.protocol + '//' + location.host);
	                    _this._mkey = mkey;
	                }
	            } catch (e) {
	                //
	            }
	        };
	
	        _this.getTimeline = function (sliceFrom, sliceTo) {
	            var timeline = (typeof _this.timeline === 'function' ? _this.timeline() : _this.timeline) || [];
	            timeline = timeline.slice(sliceFrom, sliceTo);
	            return timeline;
	        };
	
	        _this.buildTimeline = function (sliceFrom, sliceTo) {
	            var builtTimeline = [];
	            var timeline = _this.getTimeline(sliceFrom, sliceTo);
	
	            timeline.forEach(function (position) {
	                var time = position.time,
	                    elements = position.elements,
	                    duration = position.duration,
	                    easing = position.easing;
	
	                (elements || []).forEach(function (el) {
	                    var targets = el.targets,
	                        properties = el.properties;
	
	                    builtTimeline.push(_extends({
	                        targets: targets,
	                        duration: duration,
	                        easing: easing,
	                        offset: time
	                    }, properties));
	                });
	            });
	
	            return builtTimeline;
	        };
	
	        _this.startAnimation = function () {
	            if (_this.state.animationStarted) return;
	            _this.setState({
	                animationStarted: true
	            }, function () {
	                if (_this.video && _this.timeline) {
	                    if (_this.props.screencast) {
	                        // this.animation.seek(1);
	                        _this.animation.play();
	                    } else {
	                        _this.animation.restart();
	                    }
	                }
	            });
	        };
	
	        _this.pauseAnimation = function () {
	            if (!_this.animation) return;
	            _this.animation.pause();
	        };
	
	        _this.playAnimation = function () {
	            if (!_this.animation) return;
	            return _this.state.animationStarted ? _this.animation.play() : _this.dispatchStartAnimationEvent();
	        };
	
	        _this.restartAnimation = function () {
	            if (!_this.animation) return;
	            _this.setState({
	                animationStarted: false
	            }, function () {
	                _this.prepareAnimation(true);
	            });
	        };
	
	        _this.renderEmptyMessage = function (msg) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-widget__empty_message' },
	                msg
	            );
	        };
	
	        _this.renderFailedState = function (load) {
	            var _this$props = _this.props,
	                debug = _this$props.debug,
	                theme = _this$props.theme;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp wdp_' + theme },
	                _react2.default.createElement(
	                    BaseWidget.BaseBarWrap,
	                    _extends({}, _this.props, {
	                        load: load,
	                        className: (0, _classnames2.default)('wdp-widget wdp-widget__failed'),
	                        title: 'Loading error',
	                        defaultHeight: load.lastOKStateHeight
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-content' },
	                        debug && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'WIDGET FAILED TO LOAD BECAUSE OF INTERNAL EXCEPTION'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'If You see that message - You are in debug mode. Please turn off for production'
	                            ),
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                'STACK:',
	                                _react2.default.createElement('br', null),
	                                load && load.exception && load.exception.stack
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'tac' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    onClick: function onClick() {
	                                        _this.reLoadData();
	                                    }
	                                },
	                                'Reload'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        var initState = props.initState || {};
	
	        _this.state = _lodash2.default.assign({
	            initState: !_lodash2.default.isEmpty(initState) && !initState.failed,
	            load: { failed: false, reqQueue: 0 },
	            loaded: false
	        }, initState);
	        _this.i18dict = {};
	        _this.i18CommonDict = _RCore2.default.i18Register(__webpack_require__(1376), __webpack_require__(1378), {});
	        _this.i18 = _RCore2.default.i18.bind(_this);
	        return _this;
	    }
	
	    _createClass(BaseWidget, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            //If this is video widget
	            // if init state is empty -> try to load
	
	            if (!this.state.initState) {
	                this._loadDataRequest = this.loadData().then(function (res) {
	                    res.loaded = true;
	                    _this2.setState(res);
	                }).catch(function (res) {
	                    res.failed = true;
	                    _this2.setState(res);
	                });
	            }
	
	            if (this.video) {
	                this.addAnimationListeners();
	            }
	
	            if (this.state.initState && this.video && this.state.loaded) {
	                this.prepareAnimation();
	                this.revealContent();
	            } else if (this.video && !this.timeline && this.props.startAnimation) {
	                this.dispatchStartAnimationEvent();
	            }
	
	            // subscribe for screen shange updates
	            if (this.context.screenSizeObserver) {
	                this.context.screenSizeObserver.subscribe(function () {
	                    return _this2.forceUpdate();
	                });
	            }
	
	            this._debounceMesureHeight = _lodash2.default.debounce(this.mesureHeight.bind(this), 3000);
	            window.addEventListener('resize', this._debounceMesureHeight, false);
	
	            // to do unmount
	
	            this.mesureHeight();
	            this.trackPageView();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            var _this3 = this;
	
	            // CAUTION: can break the state
	            if (newProps.initState !== this.props.initState) {
	                this.setState(newProps.initState);
	            }
	
	            var ppTypes = _lodash2.default.get(this, 'constructor.spec.propTypes', []);
	            var requiredParamWasChanged = _lodash2.default.filter(ppTypes, function (pp) {
	                return (pp.required || pp.loader) && newProps[pp.key] !== _this3.props[pp.key] || pp.propsMap && _lodash2.default.find(_lodash2.default.values(pp.propsMap), function (pm) {
	                    return newProps[pm] !== _this3.props[pm];
	                });
	            });
	
	            if (requiredParamWasChanged.length) {
	                if (this.video && this.props.noAnimationControls) {
	                    //This is made for AnimatedTournamentTable;
	                    //Otherwise when parameters are changed, it animates like a mess
	                    // window.location.reload();
	                    // return;
	                }
	
	                this.setState({
	                    __r: Math.random(),
	                    loaded: false,
	                    __status: null,
	                    animationStarted: false
	                }, function () {
	                    _this3.reLoadData();
	                });
	            }
	
	            if (newProps.tempTemplate) {
	                this.setState({ template: newProps.tempTemplate });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (typeof window === 'undefined') return;
	            this.mesureHeight();
	
	            if (!prevState.__status && this.state.__status && this.state.__status.error) {
	                if (this.props.onError) this.props.onError(this.state.__status);
	            }
	
	            if (prevState.loaded === false && this.state.loaded === true && !this.state.__status) {
	                if (this.props.onOk) this.props.onOk('GOOD');
	            }
	
	            if (prevState.__status && prevState.__status.error === true && !this.state.__status) {
	                if (this.props.onOk) this.props.onOk('GOOD');
	            }
	            if (this.video && !prevState.loaded && this.state.loaded) {
	                this.resetAnimation();
	                this.prepareAnimation();
	                this.revealContent();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._debounceMesureHeight && this._debounceMesureHeight.cancel) this._debounceMesureHeight.cancel();
	            if (this._loadDataRequest) {}
	            if (this.video && this.animation) {
	                this.pauseAnimation();
	                this.removeAnimationListeners();
	            }
	            window.removeEventListener('resize', this._debounceMesureHeight, false);
	        }
	
	        /* TO BE REFACTORED */
	
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            // eslint-disable-next-line
	            return _RCore2.default.PromiseProps({});
	        }
	    }, {
	        key: 'reLoadData',
	        value: function reLoadData() {
	            var _this4 = this;
	
	            if (this._loadDataRequest) {
	                // wait if current loadData is in progress, let it finish. reload data once again
	                return this._loadDataRequest.then(function () {
	                    return _this4._loadDataRequest = _this4.loadData().then(_this4.setPState).then(function () {
	                        _this4._loadDataRequest = null;
	                    });
	                });
	            } else {
	                this._loadDataRequest = this.loadData().then(this.setPState).then(function () {
	                    _this4._loadDataRequest = null;
	                });
	
	                return this._loadDataRequest;
	            }
	        }
	    }, {
	        key: 'trackPageView',
	        value: function trackPageView() {
	            // eslint-disable-next-line
	            _WDPContext2.default.trackPageView.call(this);
	        }
	    }, {
	        key: 'trackEvent',
	        value: function trackEvent(cat, act, lab) {
	            // eslint-disable-next-line
	            this.context.trackEvent.call(this, cat, act, lab);
	        }
	    }, {
	        key: 'handleScreenSizeUpdate',
	        value: function handleScreenSizeUpdate() {
	            var width = _reactDom2.default.findDOMNode(this).offsetWidth;
	            this.screenSizeObserver.onUpdateWidth(width);
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(url) {
	            var _this5 = this;
	
	            var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            var _ref = this.context.info || {},
	                client = _ref.client,
	                lang = _ref.lang,
	                nautre = _ref.nautre;
	
	            client = client || 'core';
	            // client = 'spdk';
	            var _url = _url3.default.parse(url, true);
	            _url.query = _lodash2.default.extend(_url.query, { locale: lang }, _lodash2.default.omitBy(query, _lodash2.default.isNil));
	            _url.search = null;
	
	            url = _url3.default.format(_url);
	
	            // console.log(`WIDGET REQUEST: ${url}`);
	
	            params.headers = {
	                Accept: 'application/json',
	                'application-name': 'dk.releaze.livecenter.' + client,
	                'Accept-Language': lang
	                //'User-Agent': 'Chrome',
	            };
	            var load = this.state.load;
	            load.reqQueue++;
	            if (!load.failed) {
	                // GOOD IDEA, but  ReactDOM.findDOMNode fails when widgt was unmounted...
	                // console.log("TTT", this)
	                // var componentNode = ReactDOM.findDOMNode(this);
	                // load.lastOKStateHeight = componentNode && componentNode.offsetHeight;
	            }
	
	            return this.setPState({ load: load }).then(function () {
	                // console.log(">> " + this.state.load.reqQueue, url, params);
	                return (0, _isomorphicFetch2.default)(url, params).then(checkStatus).then(parseJSON).then(function (res) {
	                    // console.log(url)
	                    var load = _this5.state.load;
	                    load.reqQueue--;
	                    load.failed = false;
	                    load.exception = null;
	                    _this5.setState(load);
	                    return res;
	                }).catch(function (res) {
	                    load.reqQueue--;
	                    load.failed = true;
	                    load.exception = res;
	                    _this5.setState(load);
	                    return {
	                        error: true,
	                        exception: res
	                    };
	                });
	            });
	        }
	    }, {
	        key: 'dispatchStartAnimationEvent',
	        value: function dispatchStartAnimationEvent() {
	            if (!(true) || this.state.animationStarted) return;
	            window.dispatchEvent(new Event('startAnimation'));
	        }
	    }, {
	        key: 'prepareAnimation',
	        value: function prepareAnimation(start) {
	            var _this6 = this;
	
	            if (!this.timeline) return;
	
	            var _props = this.props,
	                screencast = _props.screencast,
	                startAnimation = _props.startAnimation;
	
	            startAnimation = startAnimation || start;
	            this.setState({ hidedForAnimation: true }, function () {
	                var showPreviewFrame = !screencast && !startAnimation;
	
	                if (!_this6.timeline) return;
	                _this6.anime = _this6.anime || __webpack_require__(1379);
	                _this6.anime.speed = +_this6.props.asm;
	                _this6.animation = _this6.animation || _this6.anime.timeline({
	                    loop: false,
	                    autoplay: false,
	                    complete: function complete() {
	                        window.dispatchEvent(new Event('animationCompleted'));
	                    }
	                });
	
	                //when widget use some stages
	                if (_this6.animation.children.length) {
	                    _this6.animation.children = [];
	                    _this6.animation.reset();
	                }
	
	                _this6.buildTimeline().forEach(function (t) {
	                    return _this6.animation.add(t);
	                });
	                _this6.animation.seek(showPreviewFrame ? (_this6.getTimeline().find(function (t) {
	                    return t.previewFrame;
	                }) || {}).time || 2 : 2);
	
	                if (startAnimation) {
	                    _this6.dispatchStartAnimationEvent();
	                }
	            });
	        }
	    }, {
	        key: 'static',
	        value: function _static(err) {
	            var res = {
	                load: {
	                    failed: true,
	                    status: err.status,
	                    err: err.response,
	                    stack: err.stack + ''
	                }
	            };
	            if (this.setState) this.setState(res);
	            return res;
	        }
	    }, {
	        key: 'renderExplain',
	        value: function renderExplain() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'pre',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Context'
	                    ),
	                    JSON.stringify(this.context, null, 4),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Props'
	                    ),
	                    JSON.stringify(this.props, null, 4),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'State'
	                    ),
	                    JSON.stringify(this.state, null, 4)
	                )
	            );
	        }
	    }], [{
	        key: 'defaultRequestHandler',
	        value: function defaultRequestHandler(response) {
	            if (response.status >= 200 && response.status < 300) {
	                var wrappedResult = {
	                    load: { failed: false, status: response.status },
	                    response: response.json()
	                };
	                if (this.setState) this.setState(wrappedResult);
	                return wrappedResult;
	            } else {
	                var error = new Error(response.statusText);
	                error.response = response;
	                error.status = response.status;
	                throw error;
	            }
	        }
	    }]);
	
	    return BaseWidget;
	}(_react2.default.Component);
	
	BaseWidget.childContextTypes = {
	    info: _propTypes2.default.object,
	    deeplinker: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object
	};
	
	BaseWidget.defaultProps = {
	    client: 'core',
	    user: 'default'
	};
	
	var BaseBarWrap = function (_React$Component2) {
	    _inherits(BaseBarWrap, _React$Component2);
	
	    function BaseBarWrap(props) {
	        _classCallCheck(this, BaseBarWrap);
	
	        return _possibleConstructorReturn(this, (BaseBarWrap.__proto__ || Object.getPrototypeOf(BaseBarWrap)).call(this, props));
	    }
	
	    _createClass(BaseBarWrap, [{
	        key: 'render',
	        value: function render() {
	            var _context$info = this.context.info,
	                client = _context$info.client,
	                user = _context$info.user,
	                theme = _context$info.theme,
	                name = _context$info.name;
	
	            var params = _lodash2.default.omit(this.props, ['children', 'client', 'user', 'theme', 'name', 'className', 'initState', 'load', 'title', 'style']);
	            // HOW TO GET RIGHT PARAMS???
	            var _props2 = this.props,
	                moreButtonUrl = _props2.moreButtonUrl,
	                moreButtonLabel = _props2.moreButtonLabel,
	                load = _props2.load,
	                title = _props2.title,
	                customTitle = _props2.customTitle,
	                suppressHeader = _props2.suppressHeader,
	                defaultHeight = _props2.defaultHeight,
	                disclaimer = _props2.disclaimer,
	                debug = _props2.debug;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp wdp_' + theme },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(this.props.className, {
	                            'wdp-widget-loading': load && load.reqQueue
	                        }),
	                        style: { minHeight: defaultHeight && defaultHeight + 'px' }
	                    },
	                    !suppressHeader && (!_lodash2.default.isEmpty(customTitle) || !_lodash2.default.isEmpty(title)) && _react2.default.createElement(_UI2.default.WidgetHeader, { title: customTitle || title }),
	                    this.props.children,
	                    moreButtonUrl && moreButtonLabel && _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-see-more' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: moreButtonUrl, className: 'wdp-btn wdp-btn-primary' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                moreButtonLabel
	                            )
	                        )
	                    ),
	                    debug && _react2.default.createElement(
	                        'div',
	                        { className: 'wdp-debug-info' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'env: ' + _cfg2.default.build.env + ' hash: ' + _cfg2.default.build.git.hash + ' v:' + _cfg2.default.widgets.version + ' l: ' + _cfg2.default.widgets.libversion
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { target: '_blank', href: _cfg2.default.WDPLinkr.widget.iframe(client, user, theme, name, params) },
	                            _cfg2.default.WDPLinkr.widget.iframe(client, user, theme, name, params)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BaseBarWrap;
	}(_react2.default.Component);
	
	BaseBarWrap.defaultProps = {
	    moreButtonLabel: null,
	    moreButtonUrl: null,
	    suppressHeader: false,
	    clientStyling: false
	};
	BaseBarWrap.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	
	var GA_EVENTS = {};
	GA_EVENTS.ODDS = 'ODDS';
	GA_EVENTS.ODDS_SINGLE_DEEPLINK = 'SINGLE_DEEPLINK';
	GA_EVENTS.ODDS_BETTINGSLIP_ADD_BET = 'BS_ADD_BET';
	GA_EVENTS.ODDS_BETTINGSLIP_DEEPLINK = 'BS_DEEPLINK';
	
	BaseWidget.GA_EVENTS = GA_EVENTS;
	
	BaseWidget.CATEGORIES = _widgetCategories2.default;
	
	BaseBarWrap.spec = {
	    propTypes: [{
	        key: 'moreButton',
	        type: 'more_button_picker',
	        scope: 'common',
	        propsMap: {
	            moreButtonLabel: 'moreButtonLabel',
	            moreButtonUrl: 'moreButtonUrl'
	        }
	    }, {
	        key: 'customTitle',
	        type: 'widget_header_picker',
	        scope: 'common',
	        propsMap: {
	            customTitle: 'customTitle',
	            suppressHeader: 'suppressHeader'
	        }
	    }]
	};
	BaseWidget.BaseBarWrap = BaseBarWrap;
	
	BaseWidget.spec = {
	    propTypes: [{
	        key: 'theme',
	        type: 'theme_picker',
	        scope: 'common'
	    }, {
	        key: 'defaultHeight',
	        type: 'hidden'
	    }, {
	        key: 'lang',
	        type: 'select_picker',
	        label: 'Language',
	        scope: 'common',
	        options: [{
	            text: 'English',
	            value: 'en'
	        }, {
	            text: 'Danish',
	            value: 'da'
	        }, {
	            text: 'Norwegian',
	            value: 'no'
	        }]
	    }, {
	        key: 'debug',
	        label: 'Set debug mode',
	        type: 'boolean',
	        scope: 'common',
	        defaultValue: false
	    }]
	};
	
	BaseWidget.extendSpec = function (id, defs) {
	    var additionalPropTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var prop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var demo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	    var spec = _lodash2.default.cloneDeep(this.spec);
	    spec.id = id;
	
	    Object.keys(defs || {}).map(function (k) {
	        var prop = spec.propTypes.find(function (prop) {
	            return prop.key == k;
	        });
	        if (prop) prop.defaultValue = defs[k];
	    });
	
	    var uniquePropTypes = spec.propTypes.filter(function (prop) {
	        return !_lodash2.default.find(additionalPropTypes, { key: prop.key });
	    });
	    spec.propTypes = [].concat(_toConsumableArray(uniquePropTypes), _toConsumableArray(additionalPropTypes || []));
	
	    if (demo.length) spec.demo = [].concat(_toConsumableArray(demo));
	
	    spec = _extends({}, spec, prop);
	
	    return spec;
	};
	
	// function withLayout(WrappedComponent) {
	//     return class extends BaseWidget {
	
	//         constructor(props) {
	//             super(props);
	//         }
	
	//         static contextTypes = {
	//             info: PropTypes.object,
	//             moment: PropTypes.func
	//         }
	//         // Wrapped component...
	//         loadData = () => {
	
	//             return RCore.promseProps({
	//                 template: Reflect.apply(templateLoadData, this, []),
	//                 widget: Reflect.apply(WrappedComponent.prototype.loadData, this, {})
	//             })
	//         }
	//         render() {
	//             console.log()
	//             return <WrappedComponent {...this.props} layoutType={"2_columns"} />
	//         }
	//     };
	// }
	// let LineupPitchSMWidget = withLayout(Widget)
	
	exports.BaseBarWrap = BaseBarWrap;
	exports.default = BaseWidget;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _momentTimezone = __webpack_require__(1370);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _localeAll = __webpack_require__(1373);
	
	var _localeAll2 = _interopRequireDefault(_localeAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // main.js
	
	
	var ScreenSizeObserver = _RCore2.default.ScreenSizeObserver;
	var Deeplinker = _RCore2.default.Deeplinker;
	
	var WDPContext = function (_React$Component) {
	    _inherits(WDPContext, _React$Component);
	
	    function WDPContext(props) {
	        _classCallCheck(this, WDPContext);
	
	        var _this = _possibleConstructorReturn(this, (WDPContext.__proto__ || Object.getPrototypeOf(WDPContext)).call(this, props));
	
	        _this.handleScreenSizeUpdate = function () {
	            var width = _reactDom2.default.findDOMNode(_this).offsetWidth;
	
	            _this.screenSizeObserver.onUpdateWidth(width);
	        };
	
	        var initState = props.initState || {};
	
	        _this.screenSizeObserver = new ScreenSizeObserver(props.parentWidth);
	
	        /**
	            In browser mode: WDPDeeplinker configured in window;
	            In server mode: to render links serverside it should be configured and the only way to do this
	            is do path deeplink configuration via GET params
	        */
	
	        if (typeof window === 'undefined' && _this.props.deeplinker) {
	            _this.deeplinker = new Deeplinker(_this.props.deeplinker);
	        }
	
	        if (typeof window !== 'undefined') {
	            _this.deeplinker = window.WDPDeeplinker && window.WDPDeeplinker;
	        }
	
	        _this.state = Object.assign({
	            initState: !_lodash2.default.isEmpty(initState) && !initState.failed,
	            load: { failed: false }
	        }, initState);
	        return _this;
	    }
	
	    _createClass(WDPContext, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var ctx = WDPContext.provideBasicContext(this.props);
	
	            ctx.deeplinker = this.deeplinker;
	            ctx.screenSizeObserver = this.screenSizeObserver;
	            ctx.plrLogoSettings = {
	                display: this.props.plrImage
	            };
	            ctx.teamLogoSettings = {
	                display: this.props.teamLogo
	            };
	            ctx.eventCellView = {
	                display: this.props.eventCellView
	            };
	            ctx.oddsProvider = {
	                provider: this.props.odds // provider name
	            };
	            ctx.trackPageView = this.trackPageView;
	            ctx.trackEvent = this.trackEvent;
	
	            var m = _momentTimezone2.default;
	
	            _lodash2.default.toPairs(_localeAll2.default).forEach(function (pair) {
	                return m.locale(pair[0], pair[1]);
	            });
	
	            var lang = this.props.lang || 'en';
	
	            if (lang === 'tc') {
	                lang = 'zh-cn';
	            }
	
	            if (lang === 'sc') {
	                lang = 'zh-hk';
	            }
	
	            m.locale(lang);
	            m.tz.setDefault(this.props.tz && _lodash2.default.isString(this.props.tz) && this.props.tz || 'CET');
	
	            ctx.moment = m;
	            // console.log("M", m, moment, m.locale(this.props.lang || 'en'))
	            // ctx.moment.locale(this.props.lang || 'en')
	            // ctx.moment = ;
	            return ctx;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleScreenSizeUpdate();
	            this._debounceHandleScreenSizeUpdate = _lodash2.default.debounce(this.handleScreenSizeUpdate.bind(this), 500);
	
	            window.addEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._debounceHandleScreenSizeUpdate && this._debounceHandleScreenSizeUpdate.cancel) {
	                this._debounceHandleScreenSizeUpdate.cancel();
	            }
	
	            window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.children
	            );
	        }
	    }], [{
	        key: 'provideBasicContext',
	        value: function provideBasicContext(props) {
	            var baseProps = ['theme', 'client', 'user', 'lang', 'name', 'deeplink', 'wiid', 'userContext'];
	
	            var info = _lodash2.default.pick(props, baseProps);
	            var widgetProps = _lodash2.default.omit(props, baseProps);
	
	            info.social = props.social || _lodash2.default.get(this, 'props.children.props.social', false);
	
	            if (info.lang && _lodash2.default.isArray(info.lang)) {
	                info.lang = _lodash2.default.last(info.lang);
	            }
	            // parse user context
	            info.userContext = info.userContext || '{}';
	
	            if (typeof info.userContext === 'string') {
	                try {
	                    info.userContext = JSON.parse(info.userContext || '{}');
	                } catch (error) {}
	            }
	
	            return {
	                info: info,
	                widgetProps: widgetProps
	            };
	        }
	
	        /**
	         *  This is half mocked context for test and server rendering.
	         *  Deeplinker and ScreenSizeObserver are not important.
	         *
	         */
	
	    }, {
	        key: 'provideMockedContext',
	        value: function provideMockedContext(props) {
	            var ctx = WDPContext.provideBasicContext(props);
	
	            ctx.deeplinker = new Deeplinker();
	            ctx.screenSizeObserver = new ScreenSizeObserver(320);
	
	            var m = _momentTimezone2.default;
	
	            m.tz.setDefault(props.tz && _lodash2.default.isString(props.tz) && props.tz || 'CET');
	            m.locale(props.lang && _lodash2.default.isString(props.lang) && props.lang || 'en');
	
	            ctx.moment = m;
	
	            return ctx;
	        }
	    }, {
	        key: 'trackPageView',
	        value: function trackPageView() {
	            var rlz_ga = window.rlz_ga;
	
	            if (!rlz_ga || this.props.disableTrackPageView) {
	                return;
	            }
	
	            var name = this.constructor.name;
	            var _context$info = this.context.info,
	                client = _context$info.client,
	                user = _context$info.user,
	                wiid = _context$info.wiid;
	
	            var page = '/' + _lodash2.default.chain([client, user, name, wiid || '-']).compact().join('/').value();
	            var location = window.location.href;
	
	            rlz_ga('main.set', 'campaignName', location);
	            rlz_ga('main.set', 'screenName', location);
	            // rlz_ga('main.set', 'pageview', page);
	            rlz_ga('main.send', 'pageview', page);
	            // rlz_ga('client.set', 'pageview', page);
	            rlz_ga('client.send', 'pageview', page);
	        }
	    }, {
	        key: 'trackEvent',
	        value: function trackEvent(cat, act, lab) {
	            var rlz_ga = window.rlz_ga;
	
	            if (!rlz_ga) {
	                return;
	            }
	
	            rlz_ga('main.send', 'event', cat, act, lab);
	            rlz_ga('client.send', 'event', cat, act, lab);
	        }
	    }]);
	
	    return WDPContext;
	}(_react2.default.Component);
	
	WDPContext.defaultProps = {
	    client: 'core',
	    theme: 'default',
	    lang: 'en',
	    user: 'rlz',
	    tz: 'CET'
	};
	WDPContext.childContextTypes = {
	    info: _propTypes2.default.object,
	    widgetProps: _propTypes2.default.object,
	    deeplinker: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object,
	    eventCellView: _propTypes2.default.object,
	    plrLogoSettings: _propTypes2.default.object,
	    oddsProvider: _propTypes2.default.object,
	    moment: _propTypes2.default.func,
	    trackEvent: _propTypes2.default.func,
	    trackPageView: _propTypes2.default.func
	};
	exports.default = WDPContext;

/***/ },
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    no: __webpack_require__(1374).default
	};

/***/ },
/* 1374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    months: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
	    monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays: 'Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag'.split('_'),
	    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    week: {
	        dow: 1,
	        doy: 4
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: 'for %s siden',
	        s: 'noen sekund',
	        m: 'et minutt',
	        mm: '%d minutt',
	        h: 'en time',
	        hh: '%d timer',
	        d: 'en dag',
	        dd: '%d dager',
	        M: 'en måned',
	        MM: '%d måneder',
	        y: 'et år',
	        yy: '%d år'
	    }
	};

/***/ },
/* 1375 */,
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var opta = __webpack_require__(1377);
	var _ = __webpack_require__(339);
	
	module.exports = {
	    en: _.extend({
	        ht: 'HT',
	        finished: 'Finished',
	        live: 'Live',
	        new: 'new',
	        at: 'at',
	        'final.result': 'Final result',
	        'status.full.finished': 'Final result',
	        'status.full.postponed': 'Postponed',
	        'status.full.inprogress': 'Live',
	        'status.full.cancelled': 'Cancelled',
	
	        'status.short.finished': 'FT',
	        'status.short.postponed': 'POST',
	        'status.short.inprogress': 'LIVE',
	        'status.short.notstarted': '',
	        'status.short.cancelled': 'CAN',
	
	        Goalkeeper: 'Goalkeeper',
	        Forward: 'Forward',
	        Midfielder: 'Midfielder',
	        Defender: 'Defender',
	        Coach: 'Coach',
	
	        'round.n': 'Round {0}',
	        'win.short': 'W',
	        'draw.short': 'D',
	        'loss.short': 'L',
	        'notPlayed.short': ' ',
	        'shots.on.goal': 'Shots on goal',
	        name: 'Name',
	        all: 'All',
	        topSpeed: 'Speeds',
	        distance: 'Distances',
	        'meters.short': 'm',
	        'km/h': 'km/h',
	        'matches.short': 'M',
	        'goals.short': 'G',
	        'points.short': 'P',
	        '%': '%',
	        ballpossession: 'Ball possession',
	        averageShots: 'Shots per match',
	        goalsAverage: 'Goals per match ',
	        goalsScored: 'Goals scored',
	        goalsConceded: 'Goals conceded',
	        rank: 'Rank',
	        points: 'Points',
	        form: 'Form',
	        vs: 'vs',
	        round: 'round',
	        goal: 'Goal',
	        assist: 'Assist',
	        owngoal: 'Own goal',
	        yellow_card: 'Yellow card',
	        red_card: 'Red card',
	        goals: 'Goals',
	        matches: 'Matches',
	        attempts: 'Attempts',
	        scoring: 'Scoring',
	        penalty: 'Penalty goals',
	        ycards: 'Yellow cards',
	        rcards: 'Red cards',
	        subs: 'Substitution',
	        in: 'in',
	        out: 'out',
	        min: 'min',
	        matchstart: 'Match start',
	        odds: 'odds',
	        draw: 'draw'
	    }
	    // ProStats.en,
	    // F1.en
	    // opta.en,
	    ),
	    da: {},
	    no: {}
	};

/***/ },
/* 1377 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    en: {
	        "sum.saves_percentage": "saves_percentage",
	        "sum.aerial_won": "aerial_won",
	        "sum.shot_off_target": "shot_off_target",
	        "sum.crosses_18yard": "crosses_18yard",
	        "sum.interception": "interception",
	        "sum.long_pass_own_to_opp": "long_pass_own_to_opp",
	        "sum.poss_won_att_3rd": "poss_won_att_3rd",
	        "sum.accurate_pass": "accurate_pass",
	        "sum.total_contest": "total_contest",
	        "sum.total_offside": "total_offside",
	        "sum.att_hd_miss": "att_hd_miss",
	        "sum.interception_won": "interception_won",
	        "sum.total_att_assist": "total_att_assist",
	        "sum.accurate_layoffs": "accurate_layoffs",
	        "sum.backward_pass": "backward_pass",
	        "sum.accurate_cross": "accurate_cross",
	        "sum.leftside_pass": "leftside_pass",
	        "sum.keeper_throws": "keeper_throws",
	        "sum.blocked_pass": "blocked_pass",
	        "sum.leftside_pass_percentage": "leftside_pass_percentage",
	        "sum.ball_recovery": "ball_recovery",
	        "sum.crosses_18yardplus": "crosses_18yardplus",
	        "sum.att_bx_centre": "att_bx_centre",
	        "sum.total_long_balls": "total_long_balls",
	        "sum.challenge_lost": "challenge_lost",
	        "sum.total_throws": "total_throws",
	        "sum.subs_made": "subs_made",
	        "sum.accurate_chipped_pass": "accurate_chipped_pass",
	        "sum.passes_left": "passes_left",
	        "sum.attempted_tackle_foul": "attempted_tackle_foul",
	        "sum.touches": "touches",
	        "sum.accurate_launches": "accurate_launches",
	        "sum.att_miss_left": "att_miss_left",
	        "sum.att_blocked_total": "att_blocked_total",
	        "sum.total_cross_nocorner": "total_cross_nocorner",
	        "sum.effective_clearance": "effective_clearance",
	        "sum.total_clearance": "total_clearance",
	        "sum.touches_in_opp_box": "touches_in_opp_box",
	        "sum.saved_obox": "saved_obox",
	        "sum.total_flick_on": "total_flick_on",
	        "sum.fouled_final_third": "fouled_final_third",
	        "sum.total_yel_card": "total_yel_card",
	        "sum.total_tackle": "total_tackle",
	        "sum.goal_kicks": "goal_kicks",
	        "sum.shield_ball_oop": "shield_ball_oop",
	        "sum.fwd_pass_percentage": "fwd_pass_percentage",
	        "sum.successful_put_through": "successful_put_through",
	        "sum.total_back_zone_pass": "total_back_zone_pass",
	        "sum.total_corners_intobox": "total_corners_intobox",
	        "sum.long_pass_own_to_opp_success": "long_pass_own_to_opp_success",
	        "sum.head_clearance": "head_clearance",
	        "sum.backward_pass_percentage": "backward_pass_percentage",
	        "sum.att_bx_left": "att_bx_left",
	        "sum.punches": "punches",
	        "sum.diving_save": "diving_save",
	        "sum.accurate_keeper_sweeper": "accurate_keeper_sweeper",
	        "sum.att_rf_total": "att_rf_total",
	        "sum.att_cmiss_high_left": "att_cmiss_high_left",
	        "sum.accurate_flick_on": "accurate_flick_on",
	        "sum.poss_lost_ctrl": "poss_lost_ctrl",
	        "sum.fk_foul_lost": "fk_foul_lost",
	        "sum.total_scoring_att": "total_scoring_att",
	        "sum.total_cross": "total_cross",
	        "sum.att_ibox_miss": "att_ibox_miss",
	        "sum.ground_duels_won": "ground_duels_won",
	        "sum.accurate_fwd_zone_pass": "accurate_fwd_zone_pass",
	        "sum.poss_lost_all": "poss_lost_all",
	        "sum.successful_final_third_passes": "successful_final_third_passes",
	        "sum.accurate_throws": "accurate_throws",
	        "sum.attempts_conceded_ibox": "attempts_conceded_ibox",
	        "sum.att_bx_right": "att_bx_right",
	        "sum.duel_won": "duel_won",
	        "sum.total_pass": "total_pass",
	        "sum.effective_head_clearance": "effective_head_clearance",
	        "sum.attempts_conceded_obox": "attempts_conceded_obox",
	        "sum.won_tackle": "won_tackle",
	        "sum.goals_shots_percentage": "goals_shots_percentage",
	        "sum.poss_won_mid_3rd": "poss_won_mid_3rd",
	        "sum.duel_lost": "duel_lost",
	        "sum.won_contest": "won_contest",
	        "sum.outfielder_block": "outfielder_block",
	        "sum.accurate_back_zone_pass": "accurate_back_zone_pass",
	        "sum.att_lf_total": "att_lf_total",
	        "sum.interceptions_in_box": "interceptions_in_box",
	        "sum.total_through_ball": "total_through_ball",
	        "sum.rightside_pass": "rightside_pass",
	        "sum.accurate_corners_intobox": "accurate_corners_intobox",
	        "sum.passes_right": "passes_right",
	        "sum.corner_taken": "corner_taken",
	        "sum.fwd_pass": "fwd_pass",
	        "sum.total_fwd_zone_pass": "total_fwd_zone_pass",
	        "sum.total_layoffs": "total_layoffs",
	        "sum.lost_corners": "lost_corners",
	        "sum.att_hd_total": "att_hd_total",
	        "sum.clean_sheet": "clean_sheet",
	        "sum.att_miss_high": "att_miss_high",
	        "sum.saved_ibox": "saved_ibox",
	        "sum.formation_used": "formation_used",
	        "sum.put_through": "put_through",
	        "sum.effective_blocked_cross": "effective_blocked_cross",
	        "sum.final_third_entries": "final_third_entries",
	        "sum.dispossessed": "dispossessed",
	        "sum.total_final_third_passes": "total_final_third_passes",
	        "sum.accurate_long_balls_percentage": "accurate_long_balls_percentage",
	        "sum.open_play_pass": "open_play_pass",
	        "sum.won_corners": "won_corners",
	        "sum.att_miss_high_left": "att_miss_high_left",
	        "sum.accurate_long_balls": "accurate_long_balls",
	        "sum.accurate_goal_kicks": "accurate_goal_kicks",
	        "sum.saves": "saves",
	        "sum.accurate_cross_nocorner": "accurate_cross_nocorner",
	        "sum.successful_open_play_pass": "successful_open_play_pass",
	        "sum.pen_area_entries": "pen_area_entries",
	        "sum.total_keeper_sweeper": "total_keeper_sweeper",
	        "sum.att_assist_setplay": "att_assist_setplay",
	        "sum.accurate_pass_percentage": "accurate_pass_percentage",
	        "sum.accurate_fwd_zone_percentage": "accurate_fwd_zone_percentage",
	        "sum.freekick_cross": "freekick_cross",
	        "sum.unsuccessful_touch": "unsuccessful_touch",
	        "sum.rightside_pass_percentage": "rightside_pass_percentage",
	        "sum.blocked_cross": "blocked_cross",
	        "sum.aerial_lost": "aerial_lost",
	        "sum.total_launches": "total_launches",
	        "sum.offtarget_att_assist": "offtarget_att_assist",
	        "sum.accurate_back_zone_percentage": "accurate_back_zone_percentage",
	        "sum.fk_foul_won": "fk_foul_won",
	        "sum.poss_won_def_3rd": "poss_won_def_3rd",
	        "sum.possession_percentage": "possession_percentage",
	        "sum.attempts_ibox": "attempts_ibox",
	        "sum.accurate_keeper_throws": "accurate_keeper_throws",
	        "sum.accurate_freekick_cross": "accurate_freekick_cross",
	        "sum.total_chipped_pass": "total_chipped_pass",
	        "sum.matches_played": "matches_played",
	        "sum.att_assist_openplay": "att_assist_openplay",
	        "sum.att_openplay": "att_openplay",
	        "sum.overrun": "overrun",
	        "sum.att_cmiss_high": "att_cmiss_high",
	        "sum.att_obx_centre": "att_obx_centre",
	        "sum.att_freekick_total": "att_freekick_total",
	        "sum.att_rf_target": "att_rf_target",
	        "sum.att_sv_low_left": "att_sv_low_left",
	        "sum.attempts_obox": "attempts_obox",
	        "sum.att_ibox_target": "att_ibox_target",
	        "sum.ontarget_scoring_att": "ontarget_scoring_att",
	        "sum.att_obox_blocked": "att_obox_blocked",
	        "sum.ontarget_att_assist": "ontarget_att_assist",
	        "sum.big_chance_created": "big_chance_created",
	        "sum.att_obox_target": "att_obox_target",
	        "sum.att_obox_miss": "att_obox_miss",
	        "sum.blocked_scoring_att": "blocked_scoring_att",
	        "sum.big_chance_missed": "big_chance_missed",
	        "sum.att_lf_target": "att_lf_target",
	        "sum.att_freekick_miss": "att_freekick_miss",
	        "sum.total_pull_back": "total_pull_back",
	        "sum.att_ibox_blocked": "att_ibox_blocked",
	        "sum.hit_woodwork": "hit_woodwork",
	        "sum.att_freekick_target": "att_freekick_target",
	        "sum.att_post_left": "att_post_left",
	        "sum.att_miss_right": "att_miss_right",
	        "sum.att_cmiss_right": "att_cmiss_right",
	        "sum.goals_conceded": "goals_conceded",
	        "sum.goals_conceded_ibox": "goals_conceded_ibox",
	        "sum.att_ibox_post": "att_ibox_post",
	        "sum.att_cmiss_left": "att_cmiss_left",
	        "sum.att_setpiece": "att_setpiece",
	        "sum.att_sv_low_centre": "att_sv_low_centre",
	        "sum.att_hd_target": "att_hd_target",
	        "sum.att_sv_high_centre": "att_sv_high_centre",
	        "sum.accurate_through_ball": "accurate_through_ball",
	        "sum.total_high_claim": "total_high_claim",
	        "sum.post_scoring_att": "post_scoring_att",
	        "sum.att_sv_low_right": "att_sv_low_right",
	        "sum.good_high_claim": "good_high_claim",
	        "sum.first_half_goals": "first_half_goals",
	        "sum.six_yard_block": "six_yard_block",
	        "sum.goal_assist_intentional": "goal_assist_intentional",
	        "sum.big_chance_scored": "big_chance_scored",
	        "sum.goals": "goals",
	        "sum.att_goal_low_centre": "att_goal_low_centre",
	        "sum.att_hd_goal": "att_hd_goal",
	        "sum.goal_assist_deadball": "goal_assist_deadball",
	        "sum.att_goal_high_right": "att_goal_high_right",
	        "sum.att_ibox_goal": "att_ibox_goal",
	        "sum.goal_assist_openplay": "goal_assist_openplay",
	        "sum.att_sv_high_left": "att_sv_high_left",
	        "sum.goals_openplay": "goals_openplay",
	        "sum.goal_assist": "goal_assist",
	        "sum.midfielder_goals": "midfielder_goals",
	        "sum.forward_goals": "forward_goals",
	        "sum.att_rf_goal": "att_rf_goal",
	        "sum.att_one_on_one": "att_one_on_one",
	        "sum.goal_assist_setplay": "goal_assist_setplay",
	        "sum.hand_ball": "hand_ball",
	        "sum.att_goal_low_left": "att_goal_low_left",
	        "sum.att_miss_high_right": "att_miss_high_right",
	        "sum.att_lf_goal": "att_lf_goal",
	        "sum.att_goal_low_right": "att_goal_low_right",
	        "sum.defender_goals": "defender_goals",
	        "sum.shot_fastbreak": "shot_fastbreak",
	        "sum.total_fastbreak": "total_fastbreak",
	        "sum.att_fastbreak": "att_fastbreak",
	        "sum.att_pen_goal": "att_pen_goal",
	        "sum.penalty_won": "penalty_won",
	        "sum.att_goal_high_centre": "att_goal_high_centre",
	        "sum.penalty_faced": "penalty_faced",
	        "sum.att_post_high": "att_post_high",
	        "sum.penalty_conceded": "penalty_conceded",
	        "sum.accurate_pull_back": "accurate_pull_back",
	        "sum.second_yellow": "second_yellow",
	        "sum.pen_goals_conceded": "pen_goals_conceded",
	        "sum.total_red_card": "total_red_card",
	        "sum.att_hd_post": "att_hd_post",
	        "sum.clearance_off_line": "clearance_off_line",
	        "sum.penalty_save": "penalty_save",
	        "sum.att_sv_high_right": "att_sv_high_right",
	        "sum.att_cmiss_high_right": "att_cmiss_high_right",
	        "sum.pts_gained_losing_pos": "pts_gained_losing_pos",
	        "sum.att_obox_goal": "att_obox_goal",
	        "sum.goals_conceded_obox": "goals_conceded_obox",
	        "sum.pts_dropped_winning_pos": "pts_dropped_winning_pos",
	        "sum.att_pen_target": "att_pen_target",
	        "sum.att_goal_high_left": "att_goal_high_left",
	        "sum.att_lg_centre": "att_lg_centre",
	        "sum.att_post_right": "att_post_right",
	        "sum.att_obxd_right": "att_obxd_right",
	        "sum.error_lead_to_shot": "error_lead_to_shot",
	        "sum.att_obox_post": "att_obox_post",
	        "sum.att_freekick_post": "att_freekick_post",
	        "sum.last_man_tackle": "last_man_tackle",
	        "sum.own_goals": "own_goals",
	        "sum.att_ibox_own_goal": "att_ibox_own_goal",
	        "sum.att_freekick_goal": "att_freekick_goal",
	        "sum.foul_throw_in": "foul_throw_in",
	        "sum.own_goal_accrued": "own_goal_accrued",
	        "sum.contentious_decision": "contentious_decision",
	        "sum.error_lead_to_goal": "error_lead_to_goal",
	        "sum.att_obx_right": "att_obx_right",
	        "sum.goal_fastbreak": "goal_fastbreak",
	        "sum.att_obxd_left": "att_obxd_left",
	        "sum.att_obx_left": "att_obx_left",
	        "sum.att_obp_goal": "att_obp_goal",
	        "sum.dangerous_play": "dangerous_play",
	        "sum.keeper_pick_up": "keeper_pick_up",
	        "sum.cross_not_claimed": "cross_not_claimed",
	        "sum.dive_catch": "dive_catch",
	        "sum.assist_penalty_won": "assist_penalty_won",
	        "sum.fouls": "fouls",
	        "sum.dive_save": "dive_save",
	        "sum.assist_free_kick_won": "assist_free_kick_won",
	        "sum.assist_pass_lost": "assist_pass_lost",
	        "sum.game_started": "game_started",
	        "sum.stand_save": "stand_save",
	        "sum.sub_in": "sub_in",
	        "sum.starting_eleven": "starting_eleven",
	        "sum.total_sub_off": "total_sub_off",
	        "sum.sub_off": "sub_off",
	        "sum.total_sub_on": "total_sub_on",
	        "sum.formation_place": "formation_place",
	        "sum.assist_own_goal": "assist_own_goal",
	        "sum.starting_bench": "starting_bench",
	        "sum.red_card": "red_card",
	        "sum.assist_attempt_saved": "assist_attempt_saved",
	        "sum.assist_blocked_shot": "assist_blocked_shot",
	        "sum.total_shots_on_goal_opponent": "total_shots_on_goal_opponent",
	        "sum.offside_provoked": "offside_provoked",
	        "sum.stand_catch": "stand_catch",
	        "sum.turnover": "turnover",
	        "sum.second_goal_assist": "second_goal_assist",
	        "sum.assist_post": "assist_post",
	        "sum.gk_smother": "gk_smother",
	        "sum.was_fouled": "was_fouled",
	        "sum.mins_played": "mins_played",
	        "sum.yellow_card": "yellow_card",
	        "sum.head_pass": "head_pass",
	
	        "avg.saves_percentage": "saves_percentage",
	        "avg.aerial_won": "aerial_won",
	        "avg.shot_off_target": "shot_off_target",
	        "avg.crosses_18yard": "crosses_18yard",
	        "avg.interception": "interception",
	        "avg.long_pass_own_to_opp": "long_pass_own_to_opp",
	        "avg.poss_won_att_3rd": "poss_won_att_3rd",
	        "avg.accurate_pass": "accurate_pass",
	        "avg.total_contest": "total_contest",
	        "avg.total_offside": "total_offside",
	        "avg.att_hd_miss": "att_hd_miss",
	        "avg.interception_won": "interception_won",
	        "avg.total_att_assist": "total_att_assist",
	        "avg.accurate_layoffs": "accurate_layoffs",
	        "avg.backward_pass": "backward_pass",
	        "avg.accurate_cross": "accurate_cross",
	        "avg.leftside_pass": "leftside_pass",
	        "avg.keeper_throws": "keeper_throws",
	        "avg.blocked_pass": "blocked_pass",
	        "avg.leftside_pass_percentage": "leftside_pass_percentage",
	        "avg.ball_recovery": "ball_recovery",
	        "avg.crosses_18yardplus": "crosses_18yardplus",
	        "avg.att_bx_centre": "att_bx_centre",
	        "avg.total_long_balls": "total_long_balls",
	        "avg.challenge_lost": "challenge_lost",
	        "avg.total_throws": "total_throws",
	        "avg.subs_made": "subs_made",
	        "avg.accurate_chipped_pass": "accurate_chipped_pass",
	        "avg.passes_left": "passes_left",
	        "avg.attempted_tackle_foul": "attempted_tackle_foul",
	        "avg.touches": "touches",
	        "avg.accurate_launches": "accurate_launches",
	        "avg.att_miss_left": "att_miss_left",
	        "avg.att_blocked_total": "att_blocked_total",
	        "avg.total_cross_nocorner": "total_cross_nocorner",
	        "avg.effective_clearance": "effective_clearance",
	        "avg.total_clearance": "total_clearance",
	        "avg.touches_in_opp_box": "touches_in_opp_box",
	        "avg.saved_obox": "saved_obox",
	        "avg.total_flick_on": "total_flick_on",
	        "avg.fouled_final_third": "fouled_final_third",
	        "avg.total_yel_card": "total_yel_card",
	        "avg.total_tackle": "total_tackle",
	        "avg.goal_kicks": "goal_kicks",
	        "avg.shield_ball_oop": "shield_ball_oop",
	        "avg.fwd_pass_percentage": "fwd_pass_percentage",
	        "avg.successful_put_through": "successful_put_through",
	        "avg.total_back_zone_pass": "total_back_zone_pass",
	        "avg.total_corners_intobox": "total_corners_intobox",
	        "avg.long_pass_own_to_opp_success": "long_pass_own_to_opp_success",
	        "avg.head_clearance": "head_clearance",
	        "avg.backward_pass_percentage": "backward_pass_percentage",
	        "avg.att_bx_left": "att_bx_left",
	        "avg.punches": "punches",
	        "avg.diving_save": "diving_save",
	        "avg.accurate_keeper_sweeper": "accurate_keeper_sweeper",
	        "avg.att_rf_total": "att_rf_total",
	        "avg.att_cmiss_high_left": "att_cmiss_high_left",
	        "avg.accurate_flick_on": "accurate_flick_on",
	        "avg.poss_lost_ctrl": "poss_lost_ctrl",
	        "avg.fk_foul_lost": "fk_foul_lost",
	        "avg.total_scoring_att": "total_scoring_att",
	        "avg.total_cross": "total_cross",
	        "avg.att_ibox_miss": "att_ibox_miss",
	        "avg.ground_duels_won": "ground_duels_won",
	        "avg.accurate_fwd_zone_pass": "accurate_fwd_zone_pass",
	        "avg.poss_lost_all": "poss_lost_all",
	        "avg.successful_final_third_passes": "successful_final_third_passes",
	        "avg.accurate_throws": "accurate_throws",
	        "avg.attempts_conceded_ibox": "attempts_conceded_ibox",
	        "avg.att_bx_right": "att_bx_right",
	        "avg.duel_won": "duel_won",
	        "avg.total_pass": "total_pass",
	        "avg.effective_head_clearance": "effective_head_clearance",
	        "avg.attempts_conceded_obox": "attempts_conceded_obox",
	        "avg.won_tackle": "won_tackle",
	        "avg.goals_shots_percentage": "goals_shots_percentage",
	        "avg.poss_won_mid_3rd": "poss_won_mid_3rd",
	        "avg.duel_lost": "duel_lost",
	        "avg.won_contest": "won_contest",
	        "avg.outfielder_block": "outfielder_block",
	        "avg.accurate_back_zone_pass": "accurate_back_zone_pass",
	        "avg.att_lf_total": "att_lf_total",
	        "avg.interceptions_in_box": "interceptions_in_box",
	        "avg.total_through_ball": "total_through_ball",
	        "avg.rightside_pass": "rightside_pass",
	        "avg.accurate_corners_intobox": "accurate_corners_intobox",
	        "avg.passes_right": "passes_right",
	        "avg.corner_taken": "corner_taken",
	        "avg.fwd_pass": "fwd_pass",
	        "avg.total_fwd_zone_pass": "total_fwd_zone_pass",
	        "avg.total_layoffs": "total_layoffs",
	        "avg.lost_corners": "lost_corners",
	        "avg.att_hd_total": "att_hd_total",
	        "avg.clean_sheet": "clean_sheet",
	        "avg.att_miss_high": "att_miss_high",
	        "avg.saved_ibox": "saved_ibox",
	        "avg.formation_used": "formation_used",
	        "avg.put_through": "put_through",
	        "avg.effective_blocked_cross": "effective_blocked_cross",
	        "avg.final_third_entries": "final_third_entries",
	        "avg.dispossessed": "dispossessed",
	        "avg.total_final_third_passes": "total_final_third_passes",
	        "avg.accurate_long_balls_percentage": "accurate_long_balls_percentage",
	        "avg.open_play_pass": "open_play_pass",
	        "avg.won_corners": "won_corners",
	        "avg.att_miss_high_left": "att_miss_high_left",
	        "avg.accurate_long_balls": "accurate_long_balls",
	        "avg.accurate_goal_kicks": "accurate_goal_kicks",
	        "avg.saves": "saves",
	        "avg.accurate_cross_nocorner": "accurate_cross_nocorner",
	        "avg.successful_open_play_pass": "successful_open_play_pass",
	        "avg.pen_area_entries": "pen_area_entries",
	        "avg.total_keeper_sweeper": "total_keeper_sweeper",
	        "avg.att_assist_setplay": "att_assist_setplay",
	        "avg.accurate_pass_percentage": "accurate_pass_percentage",
	        "avg.accurate_fwd_zone_percentage": "accurate_fwd_zone_percentage",
	        "avg.freekick_cross": "freekick_cross",
	        "avg.unsuccessful_touch": "unsuccessful_touch",
	        "avg.rightside_pass_percentage": "rightside_pass_percentage",
	        "avg.blocked_cross": "blocked_cross",
	        "avg.aerial_lost": "aerial_lost",
	        "avg.total_launches": "total_launches",
	        "avg.offtarget_att_assist": "offtarget_att_assist",
	        "avg.accurate_back_zone_percentage": "accurate_back_zone_percentage",
	        "avg.fk_foul_won": "fk_foul_won",
	        "avg.poss_won_def_3rd": "poss_won_def_3rd",
	        "avg.possession_percentage": "possession_percentage",
	        "avg.attempts_ibox": "attempts_ibox",
	        "avg.accurate_keeper_throws": "accurate_keeper_throws",
	        "avg.accurate_freekick_cross": "accurate_freekick_cross",
	        "avg.total_chipped_pass": "total_chipped_pass",
	        "avg.matches_played": "matches_played",
	        "avg.att_assist_openplay": "att_assist_openplay",
	        "avg.att_openplay": "att_openplay",
	        "avg.overrun": "overrun",
	        "avg.att_cmiss_high": "att_cmiss_high",
	        "avg.att_obx_centre": "att_obx_centre",
	        "avg.att_freekick_total": "att_freekick_total",
	        "avg.att_rf_target": "att_rf_target",
	        "avg.att_sv_low_left": "att_sv_low_left",
	        "avg.attempts_obox": "attempts_obox",
	        "avg.att_ibox_target": "att_ibox_target",
	        "avg.ontarget_scoring_att": "ontarget_scoring_att",
	        "avg.att_obox_blocked": "att_obox_blocked",
	        "avg.ontarget_att_assist": "ontarget_att_assist",
	        "avg.big_chance_created": "big_chance_created",
	        "avg.att_obox_target": "att_obox_target",
	        "avg.att_obox_miss": "att_obox_miss",
	        "avg.blocked_scoring_att": "blocked_scoring_att",
	        "avg.big_chance_missed": "big_chance_missed",
	        "avg.att_lf_target": "att_lf_target",
	        "avg.att_freekick_miss": "att_freekick_miss",
	        "avg.total_pull_back": "total_pull_back",
	        "avg.att_ibox_blocked": "att_ibox_blocked",
	        "avg.hit_woodwork": "hit_woodwork",
	        "avg.att_freekick_target": "att_freekick_target",
	        "avg.att_post_left": "att_post_left",
	        "avg.att_miss_right": "att_miss_right",
	        "avg.att_cmiss_right": "att_cmiss_right",
	        "avg.goals_conceded": "goals_conceded",
	        "avg.goals_conceded_ibox": "goals_conceded_ibox",
	        "avg.att_ibox_post": "att_ibox_post",
	        "avg.att_cmiss_left": "att_cmiss_left",
	        "avg.att_setpiece": "att_setpiece",
	        "avg.att_sv_low_centre": "att_sv_low_centre",
	        "avg.att_hd_target": "att_hd_target",
	        "avg.att_sv_high_centre": "att_sv_high_centre",
	        "avg.accurate_through_ball": "accurate_through_ball",
	        "avg.total_high_claim": "total_high_claim",
	        "avg.post_scoring_att": "post_scoring_att",
	        "avg.att_sv_low_right": "att_sv_low_right",
	        "avg.good_high_claim": "good_high_claim",
	        "avg.first_half_goals": "first_half_goals",
	        "avg.six_yard_block": "six_yard_block",
	        "avg.goal_assist_intentional": "goal_assist_intentional",
	        "avg.big_chance_scored": "big_chance_scored",
	        "avg.goals": "goals",
	        "avg.att_goal_low_centre": "att_goal_low_centre",
	        "avg.att_hd_goal": "att_hd_goal",
	        "avg.goal_assist_deadball": "goal_assist_deadball",
	        "avg.att_goal_high_right": "att_goal_high_right",
	        "avg.att_ibox_goal": "att_ibox_goal",
	        "avg.goal_assist_openplay": "goal_assist_openplay",
	        "avg.att_sv_high_left": "att_sv_high_left",
	        "avg.goals_openplay": "goals_openplay",
	        "avg.goal_assist": "goal_assist",
	        "avg.midfielder_goals": "midfielder_goals",
	        "avg.forward_goals": "forward_goals",
	        "avg.att_rf_goal": "att_rf_goal",
	        "avg.att_one_on_one": "att_one_on_one",
	        "avg.goal_assist_setplay": "goal_assist_setplay",
	        "avg.hand_ball": "hand_ball",
	        "avg.att_goal_low_left": "att_goal_low_left",
	        "avg.att_miss_high_right": "att_miss_high_right",
	        "avg.att_lf_goal": "att_lf_goal",
	        "avg.att_goal_low_right": "att_goal_low_right",
	        "avg.defender_goals": "defender_goals",
	        "avg.shot_fastbreak": "shot_fastbreak",
	        "avg.total_fastbreak": "total_fastbreak",
	        "avg.att_fastbreak": "att_fastbreak",
	        "avg.att_pen_goal": "att_pen_goal",
	        "avg.penalty_won": "penalty_won",
	        "avg.att_goal_high_centre": "att_goal_high_centre",
	        "avg.penalty_faced": "penalty_faced",
	        "avg.att_post_high": "att_post_high",
	        "avg.penalty_conceded": "penalty_conceded",
	        "avg.accurate_pull_back": "accurate_pull_back",
	        "avg.second_yellow": "second_yellow",
	        "avg.pen_goals_conceded": "pen_goals_conceded",
	        "avg.total_red_card": "total_red_card",
	        "avg.att_hd_post": "att_hd_post",
	        "avg.clearance_off_line": "clearance_off_line",
	        "avg.penalty_save": "penalty_save",
	        "avg.att_sv_high_right": "att_sv_high_right",
	        "avg.att_cmiss_high_right": "att_cmiss_high_right",
	        "avg.pts_gained_losing_pos": "pts_gained_losing_pos",
	        "avg.att_obox_goal": "att_obox_goal",
	        "avg.goals_conceded_obox": "goals_conceded_obox",
	        "avg.pts_dropped_winning_pos": "pts_dropped_winning_pos",
	        "avg.att_pen_target": "att_pen_target",
	        "avg.att_goal_high_left": "att_goal_high_left",
	        "avg.att_lg_centre": "att_lg_centre",
	        "avg.att_post_right": "att_post_right",
	        "avg.att_obxd_right": "att_obxd_right",
	        "avg.error_lead_to_shot": "error_lead_to_shot",
	        "avg.att_obox_post": "att_obox_post",
	        "avg.att_freekick_post": "att_freekick_post",
	        "avg.last_man_tackle": "last_man_tackle",
	        "avg.own_goals": "own_goals",
	        "avg.att_ibox_own_goal": "att_ibox_own_goal",
	        "avg.att_freekick_goal": "att_freekick_goal",
	        "avg.foul_throw_in": "foul_throw_in",
	        "avg.own_goal_accrued": "own_goal_accrued",
	        "avg.contentious_decision": "contentious_decision",
	        "avg.error_lead_to_goal": "error_lead_to_goal",
	        "avg.att_obx_right": "att_obx_right",
	        "avg.goal_fastbreak": "goal_fastbreak",
	        "avg.att_obxd_left": "att_obxd_left",
	        "avg.att_obx_left": "att_obx_left",
	        "avg.att_obp_goal": "att_obp_goal",
	        "avg.dangerous_play": "dangerous_play",
	        "avg.keeper_pick_up": "keeper_pick_up",
	        "avg.cross_not_claimed": "cross_not_claimed",
	        "avg.dive_catch": "dive_catch",
	        "avg.assist_penalty_won": "assist_penalty_won",
	        "avg.fouls": "fouls",
	        "avg.dive_save": "dive_save",
	        "avg.assist_free_kick_won": "assist_free_kick_won",
	        "avg.assist_pass_lost": "assist_pass_lost",
	        "avg.game_started": "game_started",
	        "avg.stand_save": "stand_save",
	        "avg.sub_in": "sub_in",
	        "avg.starting_eleven": "starting_eleven",
	        "avg.total_sub_off": "total_sub_off",
	        "avg.sub_off": "sub_off",
	        "avg.total_sub_on": "total_sub_on",
	        "avg.formation_place": "formation_place",
	        "avg.assist_own_goal": "assist_own_goal",
	        "avg.starting_bench": "starting_bench",
	        "avg.red_card": "red_card",
	        "avg.assist_attempt_saved": "assist_attempt_saved",
	        "avg.assist_blocked_shot": "assist_blocked_shot",
	        "avg.total_shots_on_goal_opponent": "total_shots_on_goal_opponent",
	        "avg.offside_provoked": "offside_provoked",
	        "avg.stand_catch": "stand_catch",
	        "avg.turnover": "turnover",
	        "avg.second_goal_assist": "second_goal_assist",
	        "avg.assist_post": "assist_post",
	        "avg.gk_smother": "gk_smother",
	        "avg.was_fouled": "was_fouled",
	        "avg.mins_played": "mins_played",
	        "avg.yellow_card": "yellow_card",
	        "avg.head_pass": "head_pass"
	    },
	    da: {},
	    no: {}
	};
	
	//var a = {};

/***/ },
/* 1378 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    da: {
	        '%': '%',
	        Coach: 'Træner',
	        Defender: 'Forsvar',
	        Forward: 'Angriber',
	        Goalkeeper: 'Målmand',
	        Midfielder: 'Midtbane',
	        all: 'Alle',
	        assist: 'Assist',
	        assists: 'Assists',
	        at: 'kl.',
	        attempts: 'Afslutninger',
	        averageShots: 'Skud pr. kamp',
	        'averageStats.aerialDuels.percentage': 'Luftdueller, % pr. kamp',
	        'averageStats.aerialDuels.total': 'Luftdueller pr. kamp',
	        'averageStats.aerialDuels.won': 'Luftdueller vundet pr. kamp',
	        'averageStats.assists': 'Assister per kamp',
	        'averageStats.ballsWon': 'Erobringer pr. kamp',
	        'averageStats.blocks': 'Blokeringer pr. kamp',
	        'averageStats.catches': 'Grebne bolde pr. kamp',
	        'averageStats.chancesCreated': 'Chancer skabt pr. kamp',
	        'averageStats.clears': 'Clearinger per kamp',
	        'averageStats.cornerKicks': 'Hjørnespark per kamp',
	        'averageStats.crossBreakdown.percentage': 'Succesfulde indlæg (%) per kamp',
	        'averageStats.crossBreakdown.successful': 'Succesfulde indlæg pr. kamp',
	        'averageStats.crosses': 'Indlæg per kamp',
	        'averageStats.distanceData.averageSpeed': 'Gennemsnitlig hastighed pr kamp',
	        'averageStats.distanceData.distance': 'Meter løbet pr kamp',
	        'averageStats.distanceData.sprintAverageLength': 'Gns. sprint længte per kamp',
	        'averageStats.distanceData.sprints': 'Sprinter pr. kamp',
	        'averageStats.distanceData.sprintsDistance': 'Sprint distance pr. kamp',
	        'averageStats.distanceData.topSpeed': 'Top hastighed pr. kamp',
	        'averageStats.foulsCommitted': 'Frispark begået pr. kamp',
	        'averageStats.foulsSuffered': 'Frispark trukket pr. kamp',
	        'averageStats.goalPerShot': 'Mål pr. skud',
	        'averageStats.goals': 'Mål pr. kamp',
	        'averageStats.groundDuels.percentage': 'Dueller, % vundet pr. kamp',
	        'averageStats.groundDuels.total': 'Dueller vundet pr. kamp',
	        'averageStats.groundDuels.won': 'Dueller vundet pr. kamp',
	        'averageStats.keyPasses': 'Nøgle afleveringer',
	        'averageStats.matchesPlayed': 'Kampe spillet',
	        'averageStats.minutesPlayed': 'Minutter pr. kamp',
	        'averageStats.missedPenalty': 'Brændte straffespark pr. kamp',
	        'averageStats.offsides': 'Offsides pr. match',
	        'averageStats.ownGoals': 'Selvmål pr. kamp',
	        'averageStats.passLength.long': 'Lange afl. pr. kamp',
	        'averageStats.passLength.short': 'Korte afl. pr. kamp',
	        'averageStats.penaltyKicks.goals': 'Straffespark scoret pr. kamp',
	        'averageStats.penaltyKicks.shots': 'Straffespark begået pr. kamp',
	        'averageStats.penaltyKicks.won': 'Straffespark trukket pr. kamp',
	        'averageStats.possessionAdvanced': 'Gns. boldbesiddelse',
	        'averageStats.rating': 'Karakter, gennemsnit',
	        'averageStats.redCards': 'Røde kort pr. kamp',
	        'averageStats.saves': 'Redninger pr. kamp',
	        'averageStats.savesPercentage': 'Gns. Redningsprocent',
	        'averageStats.score': 'Mål pr. kamp',
	        'averageStats.shots': 'Skud pr. kamp',
	        'averageStats.shotsFaced': 'Skud imod pr. kamp',
	        'averageStats.shotsOnGoal': 'Skud på mål pr. kamp',
	        'averageStats.shotsOnGoalFaced': 'Skud på mål imod pr. kamp',
	        'averageStats.substitutionsIn': 'Indskiftninger',
	        'averageStats.substitutionsOut': 'Udskiftninger',
	        'averageStats.tackles': 'Tacklinger pr. kamp',
	        'averageStats.touches.blocks': 'Blokeringer pr. kamp',
	        'averageStats.touches.completedPasses': 'Succ. afleveringer pr. kamp',
	        'averageStats.touches.completionPercentage': 'Succ. afleveringer % pr. kamp',
	        'averageStats.touches.interceptions': 'Erobringer pr. kamp',
	        'averageStats.touches.passes': 'Afleveringer pr. kamp',
	        'averageStats.touches.passesReceived': 'Modtaget afleveringer pr. kamp',
	        'averageStats.touches.total': 'Berøringer pr. kamp',
	        'averageStats.yellowCards': 'Gule kort pr. kamp',
	        ballpossession: 'Boldbesiddelse',
	        distance: 'Meter løbet',
	        draw: 'Uafgjort',
	        'draw.short': 'U',
	        'eventsStats.aerialDuels.percentage': 'Luftdueller vundet, %',
	        'eventsStats.aerialDuels.total': 'Luftdueller',
	        'eventsStats.aerialDuels.won': 'Luftdueller vundet',
	        'eventsStats.assists': 'Assists',
	        'eventsStats.ballsWon': 'Bolde vundet',
	        'eventsStats.blocks': 'Blokeringer',
	        'eventsStats.chancesCreated': 'Chancer skabt',
	        'eventsStats.cleanSheets': 'Rent bur',
	        'eventsStats.clears': 'Clearinger',
	        'eventsStats.cornerKicks': 'Hjørnespark',
	        'eventsStats.crossBreakdown.percentage': 'Successfulde indlæg (%)',
	        'eventsStats.crossBreakdown.successful': 'Successfulde indlæg',
	        'eventsStats.crosses': 'Indlæg',
	        'eventsStats.custom.goalsPerMinute': 'Minutter pr. mål',
	        'eventsStats.distanceData.averageSpeed': 'Gennemsnitlig hastighed',
	        'eventsStats.distanceData.distance': 'Meter løbet',
	        'eventsStats.distanceData.sprintAverageLength': 'Gns. sprint distance',
	        'eventsStats.distanceData.sprints': 'Antal sprinter',
	        'eventsStats.distanceData.sprintsDistance': 'Sprint Distance',
	        'eventsStats.distanceData.topSpeed': 'Top hastighed',
	        'eventsStats.formation': '',
	        'eventsStats.foulsCommitted': 'Frispark begået',
	        'eventsStats.foulsSuffered': 'Frispark modtaget',
	        'eventsStats.goalMouthBlocks': '',
	        'eventsStats.goalPerShot': 'Mål pr. skud',
	        'eventsStats.goals': 'Mål',
	        'eventsStats.goalsAllowed': 'Mål imod',
	        'eventsStats.goalsStats.freeKick': 'Mål på frisspark',
	        'eventsStats.goalsStats.header': 'Mål på hovedstød',
	        'eventsStats.groundDuels.percentage': 'Dueller vundet (%)',
	        'eventsStats.groundDuels.total': 'Dueller',
	        'eventsStats.groundDuels.won': 'Dueller vundet',
	        'eventsStats.keyPasses': 'Nøgleafleveringer',
	        'eventsStats.matchesPlayed': 'Kampe spillet',
	        'eventsStats.minutesPlayed': 'Minutter spillet',
	        'eventsStats.missedPenalty': 'Brændt straffespark',
	        'eventsStats.offsides': 'Offsides',
	        'eventsStats.ownGoals': 'Selvmål',
	        'eventsStats.passLength.long': 'Lange afleveringer',
	        'eventsStats.passLength.short': 'Korte afleveringer',
	        'eventsStats.penaltyKicks.goals': 'Mål på straffe',
	        'eventsStats.penaltyKicks.shots': 'Straffespark',
	        'eventsStats.penaltyKicks.won': 'Fremtvunget straffe',
	        'eventsStats.rating': 'Vurdering',
	        'eventsStats.redCards': 'Røde kort',
	        'eventsStats.saves': 'Redninger',
	        'eventsStats.savesPercentage': 'Redningsprocent',
	        'eventsStats.score': 'Stilling',
	        'eventsStats.shots': 'Skud',
	        'eventsStats.shotsFaced': 'Skud imod',
	        'eventsStats.shotsOnGoal': 'Skud på mål',
	        'eventsStats.shotsOnGoalFaced': 'Skud på mål imod',
	        'eventsStats.substitutionsIn': 'Ind',
	        'eventsStats.substitutionsOut': 'Ud',
	        'eventsStats.tackles': 'Tacklinger',
	        'eventsStats.totalDuels.won': 'Dueller vundet',
	        'eventsStats.touches.blocks': 'Blokeringer',
	        'eventsStats.touches.completedPasses': 'Succesfulde afleveringer',
	        'eventsStats.touches.completionPercentage': 'Succesfulde afleveringer (%)',
	        'eventsStats.touches.interceptions': 'Bolderobringer',
	        'eventsStats.touches.passes': 'Afleveringer',
	        'eventsStats.touches.passesReceived': 'Modtaget afleveringer',
	        'eventsStats.touches.total': 'Berøringer',
	        'eventsStats.yellowCards': 'Gule kort',
	        'f1.incident.out': '',
	        'f1.table.comment': '',
	        'f1.table.diff': '<empty>',
	        'f1.table.driverName': 'Kører',
	        'f1.table.driverNumber': '<empty>',
	        'f1.table.gap': 'Gap',
	        'f1.table.gap10': 'Gap 10',
	        'f1.table.gap15': 'Gap 15',
	        'f1.table.in_pit': 'In pit',
	        'f1.table.laps': 'Omg.',
	        'f1.table.out': 'OUT',
	        'f1.table.pits': 'Pit',
	        'f1.table.pos': 'Pos',
	        'f1.table.q1': 'Q1',
	        'f1.table.q2': 'Q2',
	        'f1.table.q3': 'Q3',
	        'f1.table.teamShortName': 'Hold',
	        'f1.table.time': 'Tid',
	        'f1.table.tyre': 'Dæk',
	        'final.result': 'Slutresultat',
	        finished: 'Slut',
	        form: 'Form',
	        goal: 'Mål',
	        goals: 'Mål',
	        'goals.short': 'M',
	        goalsAverage: 'Mål pr. kamp',
	        goalsConceded: 'Mål indkasseret',
	        goalsScored: 'Mål scoret',
	        ht: 'HT',
	        in: 'Ind',
	        'km/h': 'km/h',
	        live: 'Live',
	        'loss.short': 'T',
	        matches: 'Kampe',
	        'matches.short': 'K',
	        matchstart: 'Kampstart',
	        'maxStats.distanceData.topSpeed': 'Topfart',
	        'meters.short': 'm',
	        min: 'min',
	        name: 'Navn',
	        new: 'Ny',
	        'notPlayed.short': '-',
	        odds: 'Odds',
	        out: 'Ud',
	        owngoal: 'Selvmål',
	        penalty: 'Mål på straffe',
	        points: 'Point',
	        'points.short': 'P',
	        rank: 'Rang',
	        red_card: 'Rødt kort',
	        round: 'Runde',
	        'round.n': 'Runde {0}',
	        scoring: 'Scorings %',
	        'shots.on.goal': 'Skud mod mål',
	        'stats.position.1': 'Målmænd',
	        'stats.position.2': 'Angriber',
	        'stats.position.3': 'Midtbane',
	        'stats.position.4': 'Forsvar',
	        'status.full.cancelled': 'Aflyst',
	        'status.full.finished': 'Slutresultat',
	        'status.full.inprogress': 'Live',
	        'status.full.postponed': 'Udsat',
	        'status.short.cancelled': 'Aflyst',
	        'status.short.finished': 'FT',
	        'status.short.inprogress': 'LIVE',
	        'status.short.notstarted': 'Ikke startet',
	        'status.short.postponed': 'Udsat',
	        subs: 'Udskiftning',
	        topSpeed: 'Top hastighed',
	        vs: 'vs',
	        'win.short': 'V',
	        yellow_card: 'Gult kort'
	    },
	    de: {
	        '%': '%',
	        Defender: 'Abwehrspieler',
	        Forward: 'Stürmer',
	        Goalkeeper: 'Torwart',
	        Midfielder: 'Mittelfeldspieler',
	        all: 'Alle',
	        assist: 'Assist',
	        assists: 'Assists',
	        at: 'bei',
	        averageShots: 'Schüsse pro Spiel',
	        'averageStats.aerialDuels.percentage': 'Luftkämpfe, % pro Spiel',
	        'averageStats.aerialDuels.total': 'Luftkämpfe pro Spiel',
	        'averageStats.aerialDuels.won': 'Luftkämpfe gewonnen',
	        'averageStats.assists': 'Assists pro Spiel',
	        'averageStats.ballsWon': 'Gewonnene Zweikämpfe pro Spiel',
	        'averageStats.blocks': 'Abgewehrte Bälle pro Spiel',
	        'averageStats.catches': 'Gefangene Bälle pro Spiel',
	        'averageStats.chancesCreated': 'Erzielte Chancen',
	        'averageStats.clears': 'Abgewehrt pro Spiel',
	        'averageStats.cornerKicks': 'Eckbälle pro Spiel',
	        'averageStats.crossBreakdown.percentage': 'Erfolgreiche Querpässe in % pro Spiel',
	        'averageStats.crossBreakdown.successful': 'Erfolgreiche Querpässe pro Spiel',
	        'averageStats.crosses': 'Querpässe pro Spiel',
	        'averageStats.distanceData.averageSpeed': 'Durchschnittsgeschwindigkeit',
	        'averageStats.distanceData.distance': 'Zurückgelegte Distanz pro Spiel',
	        'averageStats.distanceData.sprintAverageLength': 'Durchschnittliche Sprintlänge pro Spiel',
	        'averageStats.distanceData.sprints': 'Sprints pro Spiel',
	        'averageStats.distanceData.sprintsDistance': 'Sprintlänge pro Spiel',
	        'averageStats.distanceData.topSpeed': 'Höchstgeschwindigkeit pro Spiel',
	        'averageStats.foulsCommitted': 'Andere pro Spiel gefoult',
	        'averageStats.foulsSuffered': 'Gefoult worden pro SpielSpiel',
	        'averageStats.goalPerShot': 'Torschüsse pro Spiel',
	        'averageStats.goals': 'Tore pro Spiel',
	        'averageStats.goalsAllowed': 'Gegentore pro Spiel',
	        'averageStats.groundDuels.percentage': 'Zweikämpfe am Boden in % pro Spiel',
	        'averageStats.groundDuels.total': 'Zweikämpfe am Boden pro Spiel',
	        'averageStats.groundDuels.won': 'Gewonnen Zweikämpfe am Boden',
	        'averageStats.keyPasses': 'Wichtige Pässe pro Spiel',
	        'averageStats.matchesPlayed': 'Einsätze',
	        'averageStats.minutesPlayed': 'Minuten pro Spiel',
	        'averageStats.missedPenalty': 'Verschossene Elfer pro Spiel',
	        'averageStats.offsides': 'Abseits pro Spiel',
	        'averageStats.ownGoals': 'Eigentore pro Spiel',
	        'averageStats.passLength.long': 'Lange Pässe pro Spiel',
	        'averageStats.passLength.short': 'Kurzpässe pro Spiel',
	        'averageStats.penaltyKicks.goals': 'Verwandelte Elfer pro Spiel',
	        'averageStats.penaltyKicks.shots': 'Geschossene Elfer pro Spiel',
	        'averageStats.penaltyKicks.won': 'Erzielte Elfer pro Spiel',
	        'averageStats.possessionAdvanced': 'Ballbesitz pro Spiel',
	        'averageStats.rating': 'Rating pro Spiel',
	        'averageStats.redCards': 'Rote Karten pro Spiel',
	        'averageStats.saves': 'Gehalten pro Spiel',
	        'averageStats.savesPercentage': 'Gehalten in % pro Spiel',
	        'averageStats.score': 'Getroffen pro Spiel',
	        'averageStats.shots': 'Schüsse pro Spiel',
	        'averageStats.shotsFaced': 'Schüsse der Gegner ',
	        'averageStats.shotsOnGoal': 'Schüsse aufs Tor pro Spiel',
	        'averageStats.shotsOnGoalFaced': 'Torschüsse vom Gegner pro Spiel',
	        'averageStats.substitutionsIn': 'Einwechslungen',
	        'averageStats.substitutionsOut': 'Auswechslungen',
	        'averageStats.tackles': 'Tackles pro Spiel',
	        'averageStats.touches.blocks': 'Abgewehrt pro Spiel',
	        'averageStats.touches.completedPasses': 'Erfolgr. Pässe pro Spiel',
	        'averageStats.touches.completionPercentage': 'Erfolgreiche Pässe pro Spiel in %',
	        'averageStats.touches.interceptions': 'Unterbrechungen pro Spiel',
	        'averageStats.touches.passes': 'Pässe pro Spiel',
	        'averageStats.touches.passesReceived': 'Erhaltene Pässe pro Spiel',
	        'averageStats.touches.total': 'Ballkontakte pro Spiel',
	        'averageStats.yellowCards': 'Gelbe Karten pro Spiel',
	        ballpossession: 'Ballbesitz',
	        distance: 'Entfernungen',
	        'draw.short': 'U',
	        'eventsStats.aerialDuels.percentage': 'Luftkämpfe, %',
	        'eventsStats.aerialDuels.total': 'Luftkämpfe',
	        'eventsStats.aerialDuels.won': 'Gewonnene Luftkämpfe',
	        'eventsStats.assists': 'Assists',
	        'eventsStats.ballsWon': 'Gewonnene Bälle',
	        'eventsStats.blocks': 'Abgewehrt',
	        'eventsStats.chancesCreated': 'Chancen erkämpft',
	        'eventsStats.cleanSheets': 'Ohne Gegentore',
	        'eventsStats.clears': 'Geklärt',
	        'eventsStats.cornerKicks': 'Ecken',
	        'eventsStats.crossBreakdown.percentage': 'Erfolgreiche Querpässe in %',
	        'eventsStats.crossBreakdown.successful': 'Erfolgreiche Querpässe',
	        'eventsStats.crosses': 'Querpässe',
	        'eventsStats.custom.goalsPerMinute': 'Tore pro Minute',
	        'eventsStats.distanceData.averageSpeed': 'Durchschnittsgeschwindigkeit',
	        'eventsStats.distanceData.distance': 'Gelaufene Strecke',
	        'eventsStats.distanceData.sprintAverageLength': 'Durchschnittliche Sprintlänge',
	        'eventsStats.distanceData.sprints': 'Sprints',
	        'eventsStats.distanceData.sprintsDistance': 'Sprint Distanz',
	        'eventsStats.distanceData.topSpeed': 'Höchstgeschwindigkeit',
	        'eventsStats.foulsCommitted': 'Gepfiffene Fouls',
	        'eventsStats.foulsSuffered': 'Gefoult worden',
	        'eventsStats.goalPerShot': 'Tore pro Schuss',
	        'eventsStats.goals': 'Tore',
	        'eventsStats.goalsAllowed': 'Tore verhindert',
	        'eventsStats.goalsStats.freeKick': 'Tore aus Freistössen',
	        'eventsStats.goalsStats.header': 'Kopfballtore',
	        'eventsStats.groundDuels.percentage': 'Bodenduelle in %',
	        'eventsStats.groundDuels.total': 'Bodenduelle',
	        'eventsStats.groundDuels.won': 'Gewonnene Bodenduelle',
	        'eventsStats.keyPasses': 'Wichtige Pässe',
	        'eventsStats.matchesPlayed': 'Spiele gespielt',
	        'eventsStats.minutesPlayed': 'Minuten gespielt',
	        'eventsStats.missedPenalty': 'Verschossene Elfmeter',
	        'eventsStats.offsides': 'Abseits',
	        'eventsStats.ownGoals': 'Eigentore',
	        'eventsStats.passLength.long': 'Lange Pässe',
	        'eventsStats.passLength.short': 'Kurzpässe',
	        'eventsStats.penaltyKicks.goals': 'Tore per Elfmeter erzielt',
	        'eventsStats.penaltyKicks.shots': 'Schüsse vom Elfmeterpunkt',
	        'eventsStats.penaltyKicks.won': 'Elfer verschuldet',
	        'eventsStats.rating': 'Rating',
	        'eventsStats.redCards': 'Rote Karten',
	        'eventsStats.saves': 'Gehalten',
	        'eventsStats.savesPercentage': 'Gehalten in %',
	        'eventsStats.score': 'Ergebnis',
	        'eventsStats.shots': 'Schüsse',
	        'eventsStats.shotsFaced': 'Schüsse vom Gegner',
	        'eventsStats.shotsOnGoal': 'Schüsse aufs Tor',
	        'eventsStats.shotsOnGoalFaced': 'Schüsse aufs eigene Tor',
	        'eventsStats.substitutionsIn': 'Wechsel rein',
	        'eventsStats.substitutionsOut': 'Wechsel raus',
	        'eventsStats.tackles': 'Tackles',
	        'eventsStats.totalDuels.won': 'Gewonne Duelle',
	        'eventsStats.touches.blocks': 'Abgewehrt',
	        'eventsStats.touches.completedPasses': 'Erfolgr. Pässe',
	        'eventsStats.touches.completionPercentage': 'Erfolgr. Pässe in %',
	        'eventsStats.touches.interceptions': 'Unterbrechung',
	        'eventsStats.touches.passes': 'Pässe',
	        'eventsStats.touches.passesReceived': 'Erhaltene Pässe',
	        'eventsStats.touches.total': 'Berührungen',
	        'eventsStats.yellowCards': 'Gelbe Karten',
	        'f1.incident.crash': 'CRASH',
	        'f1.incident.out': 'RAUS',
	        'f1.incident.pitStop': 'BOXENSTOP',
	        'f1.incident.retired': 'AUFGEGEBEN',
	        'f1.table.comment': 'Kommentar',
	        'f1.table.diff': '<empty>',
	        'f1.table.driverName': 'Fahrer',
	        'f1.table.driverNumber': '<empty>',
	        'f1.table.gap': 'Rückstand',
	        'f1.table.gap10': 'Rückstand 10',
	        'f1.table.gap15': 'Rückstand 15',
	        'f1.table.in_pit': 'Boxengasse',
	        'f1.table.laps': 'Runden',
	        'f1.table.pits': 'Boxenstopps',
	        'f1.table.pos': '#',
	        'f1.table.q1': 'Q1',
	        'f1.table.q2': 'Q2',
	        'f1.table.q3': 'Q3',
	        'f1.table.teamShortName': 'Team',
	        'f1.table.time': 'Zeit',
	        'f1.table.tyre': 'Reifen',
	        'final.result': 'Endstand',
	        finished: 'Endstand',
	        form: 'Form',
	        goal: 'Tor',
	        goals: 'Tore',
	        'goals.short': 'T',
	        goalsAverage: 'Tor pro Spiel',
	        goalsConceded: 'Tore kassiert',
	        goalsScored: 'Tore erzielt',
	        ht: 'HT',
	        in: 'rein',
	        'km/h': 'km/h',
	        live: 'Live',
	        'loss.short': 'V',
	        'matches.short': 'S',
	        matchstart: 'Matchbeginn',
	        'maxStats.distanceData.topSpeed': 'Höchstgeschwindigkeit',
	        'meters.short': 'm',
	        min: 'min',
	        name: 'Name',
	        new: 'Neu',
	        odds: 'Quoten',
	        out: 'raus',
	        owngoal: 'Eigentor',
	        points: 'Punkte',
	        'points.short': 'P',
	        rank: 'Platz',
	        red_card: 'Rote Karte',
	        round: 'Runde',
	        'round.n': 'Runde {0}',
	        'shots.on.goal': 'Torschüsse',
	        'stats.position.1': 'Torwart',
	        'stats.position.2': 'Stürmer',
	        'stats.position.3': 'Mittelfeldspieler',
	        'stats.position.4': 'Abwehrspieler',
	        'status.full.cancelled': 'Abgesagt',
	        'status.full.finished': 'Endstand',
	        'status.full.inprogress': 'Live',
	        'status.full.postponed': 'Verlegt',
	        'status.short.cancelled': 'ABG',
	        'status.short.finished': 'FT',
	        'status.short.inprogress': 'LIVE',
	        'status.short.postponed': 'VERL',
	        subs: 'Auswechslung',
	        topSpeed: 'Geschwindigkeiten',
	        vs: 'vs',
	        'win.short': 'G',
	        yellow_card: 'Gelbe Karte'
	    },
	    en: {
	        '%': '%',
	        Coach: 'Coach',
	        Defender: 'Defender',
	        Forward: 'Forward',
	        Goalkeeper: 'Goalkeeper',
	        Midfielder: 'Midfielder',
	        all: 'All',
	        assist: 'Assist',
	        assists: 'Assists',
	        at: 'at',
	        attempts: 'Attempts',
	        averageShots: 'Shots per match',
	        'averageStats.aerialDuels.percentage': 'Areal duels, % per match',
	        'averageStats.aerialDuels.total': 'Areal duels per match',
	        'averageStats.aerialDuels.won': 'Areal duels won per match',
	        'averageStats.assists': 'Assists per match',
	        'averageStats.ballsWon': 'Balls won per match',
	        'averageStats.blocks': 'Blocks per match',
	        'averageStats.catches': 'Catches per match',
	        'averageStats.chancesCreated': 'Chances created per match',
	        'averageStats.clears': 'Clearances per match',
	        'averageStats.cornerKicks': 'Corners per match',
	        'averageStats.crossBreakdown.percentage': 'Successful crosses, % per match',
	        'averageStats.crossBreakdown.successful': 'Successful crosses per match',
	        'averageStats.crosses': 'Crosses per match',
	        'averageStats.distanceData.averageSpeed': 'Average speed per match',
	        'averageStats.distanceData.distance': 'Distance covered per match',
	        'averageStats.distanceData.sprintAverageLength': 'Sprints Av. lenght per match',
	        'averageStats.distanceData.sprints': 'Sprints per match',
	        'averageStats.distanceData.sprintsDistance': 'Sprints distance per match',
	        'averageStats.distanceData.topSpeed': 'Top speed per match',
	        'averageStats.foulsCommitted': 'Fouls committed per match',
	        'averageStats.foulsSuffered': 'Fouls suffered per match',
	        'averageStats.goalPerShot': 'Goals per shot per match',
	        'averageStats.goals': 'Goals per match',
	        'averageStats.groundDuels.percentage': 'Ground duels, % per match',
	        'averageStats.groundDuels.total': 'Ground duels per match',
	        'averageStats.groundDuels.won': 'Ground duels won per match',
	        'averageStats.keyPasses': 'Key passes per match',
	        'averageStats.matchesPlayed': 'Matches played',
	        'averageStats.minutesPlayed': 'Minutes per match',
	        'averageStats.missedPenalty': 'Missed penalties per match',
	        'averageStats.offsides': 'Offsides per match',
	        'averageStats.ownGoals': 'Own goals per match',
	        'averageStats.passLength.long': 'Long passes per match',
	        'averageStats.passLength.short': 'Short passes per match',
	        'averageStats.penaltyKicks.goals': 'Penalty kicks Scored per match',
	        'averageStats.penaltyKicks.shots': 'Penalty kicks made per match',
	        'averageStats.penaltyKicks.won': 'Penalty kicks won per Macht',
	        'averageStats.possessionAdvanced': 'Possession advanced per match',
	        'averageStats.rating': 'Rating per match',
	        'averageStats.redCards': 'Red cards per match',
	        'averageStats.saves': 'Saves per match',
	        'averageStats.savesPercentage': 'Saves percentage per match',
	        'averageStats.score': 'Score per match',
	        'averageStats.shots': 'Shots per match',
	        'averageStats.shotsFaced': 'Shots faced per match',
	        'averageStats.shotsOnGoal': 'Shots on goal per match',
	        'averageStats.shotsOnGoalFaced': 'Shots on goal faced per match',
	        'averageStats.substitutionsIn': 'Substitutions in',
	        'averageStats.substitutionsOut': 'substitutions out',
	        'averageStats.tackles': 'Tackles per match',
	        'averageStats.touches.blocks': 'Blocks per match',
	        'averageStats.touches.completedPasses': 'Suc. passes per match',
	        'averageStats.touches.completionPercentage': 'Suc. passes % per match',
	        'averageStats.touches.interceptions': 'Interceptions per match',
	        'averageStats.touches.passes': 'passes per match',
	        'averageStats.touches.passesReceived': 'Received passes per match',
	        'averageStats.touches.total': 'Touches per match',
	        'averageStats.yellowCards': 'Yellow cards per match',
	        ballpossession: 'Ball possession',
	        distance: 'Meters covered',
	        draw: 'Draw',
	        'draw.short': 'D',
	        'eventsStats.aerialDuels.percentage': 'Aerial duels, %',
	        'eventsStats.aerialDuels.total': 'Aerial duels',
	        'eventsStats.aerialDuels.won': 'Aerial duels won',
	        'eventsStats.assists': 'Assists',
	        'eventsStats.ballsWon': 'Balls won',
	        'eventsStats.blocks': 'Blocks ',
	        'eventsStats.chancesCreated': 'Chances created',
	        'eventsStats.cleanSheets': 'Clean sheets',
	        'eventsStats.clears': 'Clearances',
	        'eventsStats.cornerKicks': 'Corners',
	        'eventsStats.crossBreakdown.percentage': 'Successful crosses, %',
	        'eventsStats.crossBreakdown.successful': 'Successful crosses',
	        'eventsStats.crosses': 'Crosses',
	        'eventsStats.custom.goalsPerMinute': 'Goals per minute',
	        'eventsStats.distanceData.averageSpeed': 'Average speed',
	        'eventsStats.distanceData.distance': 'Distance covered',
	        'eventsStats.distanceData.sprintAverageLength': 'Sprints av. Length',
	        'eventsStats.distanceData.sprints': 'Sprints',
	        'eventsStats.distanceData.sprintsDistance': 'Sprints Distance',
	        'eventsStats.distanceData.topSpeed': 'Top speed',
	        'eventsStats.formation': '',
	        'eventsStats.foulsCommitted': 'Fouls committed',
	        'eventsStats.foulsSuffered': 'Fouls suffered',
	        'eventsStats.goalMouthBlocks': '',
	        'eventsStats.goalPerShot': 'Goal per shot',
	        'eventsStats.goals': 'Goals',
	        'eventsStats.goalsAllowed': 'Goals conceded',
	        'eventsStats.goalsStats.freeKick': 'Goal on freekick',
	        'eventsStats.goalsStats.header': 'Goal from header',
	        'eventsStats.groundDuels.percentage': 'Ground duels, %',
	        'eventsStats.groundDuels.total': 'Ground duels',
	        'eventsStats.groundDuels.won': 'Ground duels won',
	        'eventsStats.keyPasses': 'Key passes',
	        'eventsStats.matchesPlayed': 'Matches played',
	        'eventsStats.minutesPlayed': 'Minutes played',
	        'eventsStats.missedPenalty': 'Missed Penalties',
	        'eventsStats.offsides': 'Offsides',
	        'eventsStats.ownGoals': 'Own goals',
	        'eventsStats.passLength.long': 'Long Passes',
	        'eventsStats.passLength.short': 'Short passes',
	        'eventsStats.penaltyKicks.goals': 'Goals made on penalty',
	        'eventsStats.penaltyKicks.shots': 'Shots from penalty',
	        'eventsStats.penaltyKicks.won': 'Penalty against',
	        'eventsStats.possessionAdvanced': '',
	        'eventsStats.rating': 'Rating',
	        'eventsStats.redCards': 'Red cards',
	        'eventsStats.saves': 'Saves',
	        'eventsStats.savesPercentage': 'Saves percentage',
	        'eventsStats.score': 'Score',
	        'eventsStats.shots': 'Shots',
	        'eventsStats.shotsFaced': 'Shots faced',
	        'eventsStats.shotsOnGoal': 'Shots on target',
	        'eventsStats.shotsOnGoalFaced': 'Shots on goal faced',
	        'eventsStats.substitutionsIn': 'Sub in',
	        'eventsStats.substitutionsOut': 'Sub out',
	        'eventsStats.tackles': 'Tackles',
	        'eventsStats.totalDuels.won': 'Duels won',
	        'eventsStats.touches.blocks': 'Blocks',
	        'eventsStats.touches.completedPasses': 'Suc. Passes',
	        'eventsStats.touches.completionPercentage': 'Suc. passes %',
	        'eventsStats.touches.interceptions': 'Interception',
	        'eventsStats.touches.passes': 'Passes',
	        'eventsStats.touches.passesReceived': 'Received passes',
	        'eventsStats.touches.total': 'Touches',
	        'eventsStats.yellowCards': 'Yellow cards',
	        'f1.incident.crash': 'CRASH',
	        'f1.incident.out': 'OUT',
	        'f1.incident.pitStop': 'PIT-STOP',
	        'f1.incident.retired': 'RETIRED',
	        'f1.table.comment': 'Comment',
	        'f1.table.diff': '<empty>',
	        'f1.table.driverName': 'Driver',
	        'f1.table.driverNumber': '<empty>',
	        'f1.table.gap': 'Gap',
	        'f1.table.gap10': 'Gap 10',
	        'f1.table.gap15': 'Gap 15',
	        'f1.table.in_pit': 'In pit',
	        'f1.table.laps': 'Laps',
	        'f1.table.out': 'OUT',
	        'f1.table.pits': 'Pits',
	        'f1.table.pos': 'Pos',
	        'f1.table.q1': 'Q1',
	        'f1.table.q2': 'Q2',
	        'f1.table.q3': 'Q3',
	        'f1.table.teamShortName': 'Team',
	        'f1.table.time': 'Time',
	        'f1.table.tyre': 'Tyres',
	        'final.result': 'Final score',
	        finished: 'Finished',
	        form: 'Form',
	        goal: 'Goal',
	        goals: 'Goals',
	        'goals.short': 'G',
	        goalsAverage: 'Goals per match',
	        goalsConceded: 'Goals conceded',
	        goalsScored: 'Goals scored',
	        ht: 'HT',
	        in: 'In',
	        'km/h': 'km/h',
	        live: 'Live',
	        'loss.short': 'L',
	        matches: 'Matches',
	        'matches.short': 'M',
	        matchstart: 'Kickoff',
	        'maxStats.distanceData.topSpeed': 'Top speed',
	        'meters.short': 'm',
	        min: 'min',
	        name: 'Name',
	        new: 'New',
	        'notPlayed.short': ' ',
	        odds: 'To win',
	        out: 'Out',
	        owngoal: 'Own goal',
	        penalty: 'Penalty goals',
	        points: 'Points',
	        'points.short': 'P',
	        rank: 'Rank',
	        red_card: 'Red card',
	        round: 'round',
	        'round.n': 'Round {0}',
	        scoring: 'Scoring %',
	        'shots.on.goal': 'Shots on goal',
	        'stats.position.1': 'Goalkeeper',
	        'stats.position.2': 'Forward',
	        'stats.position.3': 'Midfielder',
	        'stats.position.4': 'Defender',
	        'status.full.cancelled': 'Cancelled',
	        'status.full.finished': 'Final score',
	        'status.full.inprogress': 'Live',
	        'status.full.postponed': 'Postponed',
	        'status.short.cancelled': 'CAN',
	        'status.short.finished': 'FT',
	        'status.short.inprogress': 'Live',
	        'status.short.notstarted': 'Not started',
	        'status.short.postponed': 'PPND',
	        subs: 'Sub.',
	        topSpeed: 'Top speed',
	        vs: 'vs',
	        'win.short': 'W',
	        yellow_card: 'Yellow card'
	    },
	    fi: {
	        '%': '%',
	        Defender: 'Puolustaja',
	        Forward: 'Hyökkääjä',
	        Goalkeeper: 'Maalivahti',
	        Midfielder: 'Keskikenttä',
	        all: 'Kaikki',
	        assist: 'Syöttö',
	        assists: 'Syötöt',
	        at: 'on',
	        averageShots: 'Laukausta per ottelu',
	        'averageStats.aerialDuels.percentage': 'Kaksintaistoa ilmassa % per ottelu',
	        'averageStats.aerialDuels.total': 'Kaksintaistoa ilmassa per ottelu',
	        'averageStats.aerialDuels.won': 'Kaksintaistoa ilmassa voitettu per ottelu',
	        'averageStats.assists': 'Syötöt yhteensä',
	        'averageStats.ballsWon': 'Voitettua palloa yhteensä',
	        'averageStats.blocks': 'Taklausta yhteensä',
	        'averageStats.catches': 'Torjuttua maalia yhteensä',
	        'averageStats.chancesCreated': 'Maalipaikkaa  yhteensä',
	        'averageStats.clears': 'Katkoa yhteensä',
	        'averageStats.cornerKicks': 'Kulmia yhteensä',
	        'averageStats.crossBreakdown.percentage': 'Onnistunutta keskitystä % yhteensä',
	        'averageStats.crossBreakdown.successful': 'Onnistunutta keskitystä yhteensä',
	        'averageStats.crosses': 'Keskitystä yhteensä',
	        'averageStats.distanceData.averageSpeed': 'Vauhti per ottelu keskimäärä',
	        'averageStats.distanceData.distance': 'Kuljettu matka per ottelu',
	        'averageStats.distanceData.sprintAverageLength': 'Sprinttiosuus per ottelu keskimäärä',
	        'averageStats.distanceData.sprints': 'Sprinttiä per ottelu',
	        'averageStats.distanceData.sprintsDistance': 'Sprinttimatka per ottelu',
	        'averageStats.distanceData.topSpeed': 'Maksimivauhti per ottelu',
	        'averageStats.foulsCommitted': 'Rikkeitä tehty per ottelu',
	        'averageStats.foulsSuffered': 'Rikkeitä per ottelu',
	        'averageStats.goalPerShot': 'Maalia per laukaus per ottelu',
	        'averageStats.goals': 'Maalia per ottelu',
	        'averageStats.goalsAllowed': 'Päästetyt maalit per ottelu',
	        'averageStats.groundDuels.percentage': 'Kaksintaistoa % maassa',
	        'averageStats.groundDuels.total': 'Kaksintaistoa maassa per ottelu',
	        'averageStats.groundDuels.won': 'Kaksintaistoa maassa voitettu per ottelu',
	        'averageStats.keyPasses': 'Ratkaisevaa syöttöä per ottelu',
	        'averageStats.matchesPlayed': 'Ottelua pelattu',
	        'averageStats.minutesPlayed': 'Minuuttia per ottelu',
	        'averageStats.missedPenalty': 'Ohi laukaistua rangaistuspotkua per ottelu',
	        'averageStats.offsides': 'Paitsiota per ottelu',
	        'averageStats.ownGoals': 'Omaa maalia per ottelu',
	        'averageStats.passLength.long': 'Pitää syöttöä per ottelu',
	        'averageStats.passLength.short': 'Lyhyttä syöttöä per ottelu',
	        'averageStats.penaltyKicks.goals': 'Rangaistuspotkua osuttu per ottelu',
	        'averageStats.penaltyKicks.shots': 'Rangaistuspotkua per ottelu ',
	        'averageStats.penaltyKicks.won': 'Rangaistuspotkua voitettu per ottelu',
	        'averageStats.possessionAdvanced': 'Pallonhallinta per ottelu',
	        'averageStats.rating': 'Ottelutilasto',
	        'averageStats.redCards': 'Punaista korttia yhteensä',
	        'averageStats.saves': 'Torjuttua maalia yhteensä',
	        'averageStats.savesPercentage': 'Torjuttua % maalia yhteensä',
	        'averageStats.score': 'Maalia yhteensä',
	        'averageStats.shots': 'Laukausta yhteensä',
	        'averageStats.shotsFaced': 'Laukausta vastaanotettu yhteensä',
	        'averageStats.shotsOnGoal': 'Laukausta kohti maalia per ottelu',
	        'averageStats.shotsOnGoalFaced': 'Laukausta kohti maalia vastaanotettu per ottelu',
	        'averageStats.substitutionsIn': 'Vaihtoa sisään',
	        'averageStats.substitutionsOut': 'Vaihtoa ulos',
	        'averageStats.tackles': 'Taklausta per ottelu',
	        'averageStats.touches.blocks': 'Vartiointia per ottelu',
	        'averageStats.touches.completedPasses': 'Onnistunutta syöttöä per ottelu',
	        'averageStats.touches.completionPercentage': 'Onnistunutta % syöttöä per ottelu',
	        'averageStats.touches.interceptions': 'Katkoa per ottelu',
	        'averageStats.touches.passes': 'Syöttöä per ottelu',
	        'averageStats.touches.passesReceived': 'Vastaanotettua syöttöä per ottelu',
	        'averageStats.touches.total': 'Pallokontaktia per ottelu',
	        'averageStats.yellowCards': 'Keltaista korttia per ottelu',
	        ballpossession: 'Pallonhallinta',
	        distance: 'Matka',
	        'draw.short': 'T',
	        'eventsStats.aerialDuels.percentage': 'Kaksintaisto ilmassa %',
	        'eventsStats.aerialDuels.total': 'Kaksintaisto ilmassa',
	        'eventsStats.aerialDuels.won': 'Kaksintaisto ilmassa voitettu',
	        'eventsStats.assists': 'Avustukset',
	        'eventsStats.ballsWon': 'Voitettua palloa',
	        'eventsStats.blocks': 'Vartiointi',
	        'eventsStats.chancesCreated': 'Maalipaikkaa luotu',
	        'eventsStats.cleanSheets': 'Kaikki laukaukset torjuttu',
	        'eventsStats.clears': 'Torjuttuja',
	        'eventsStats.cornerKicks': 'Kulmapotkut',
	        'eventsStats.crossBreakdown.percentage': 'Onnistuneet keskitykset %',
	        'eventsStats.crossBreakdown.successful': 'Onnistuneet keskitykset',
	        'eventsStats.crosses': 'Keskitykset',
	        'eventsStats.custom.goalsPerMinute': 'Maalia per minuutti',
	        'eventsStats.distanceData.averageSpeed': 'Vauhti keskimäärin',
	        'eventsStats.distanceData.distance': 'Juoksettu matka',
	        'eventsStats.distanceData.sprintAverageLength': 'Sprintti keskimäärin',
	        'eventsStats.distanceData.sprints': 'Sprintit',
	        'eventsStats.distanceData.sprintsDistance': 'Sprintti etäisyys',
	        'eventsStats.distanceData.topSpeed': 'Maksimivauhti',
	        'eventsStats.foulsCommitted': 'Tehdyt rikkeet',
	        'eventsStats.foulsSuffered': 'Rikottu',
	        'eventsStats.goalPerShot': 'Maaliprosentti',
	        'eventsStats.goals': 'Tehdyt maalit',
	        'eventsStats.goalsAllowed': 'Päästetyt maalit',
	        'eventsStats.goalsStats.freeKick': 'Maalit vapaapotkusta',
	        'eventsStats.goalsStats.header': 'Pukatut maalit',
	        'eventsStats.groundDuels.percentage': 'Kaksintaistoa maalla %',
	        'eventsStats.groundDuels.total': 'Kaksintaistoa maalla',
	        'eventsStats.groundDuels.won': 'Kaksintaistoa maalla voitettu',
	        'eventsStats.keyPasses': 'Ratkaisevaa syöttöä',
	        'eventsStats.matchesPlayed': 'Pelattua ottelua',
	        'eventsStats.minutesPlayed': 'Minuuttia pelattu',
	        'eventsStats.missedPenalty': 'Ohi lauottua rangaistuspotkua',
	        'eventsStats.offsides': 'Paitsiota',
	        'eventsStats.ownGoals': 'Omaa maalia',
	        'eventsStats.passLength.long': 'Pitkää syöttöä',
	        'eventsStats.passLength.short': 'Lyhyttä syöttöä',
	        'eventsStats.penaltyKicks.goals': 'Rangaistuspotkumaalit',
	        'eventsStats.penaltyKicks.shots': 'Rangaistuspotkut',
	        'eventsStats.penaltyKicks.won': 'Rangaistuspotkua vastaan',
	        'eventsStats.rating': 'Sijoitus',
	        'eventsStats.redCards': 'Punaista korttia',
	        'eventsStats.saves': 'Torjunnat',
	        'eventsStats.savesPercentage': 'Torjuntaprosentti',
	        'eventsStats.score': 'Pisteet',
	        'eventsStats.shots': 'Laukaukset',
	        'eventsStats.shotsFaced': 'Vastaanotetut laukaukset',
	        'eventsStats.shotsOnGoal': 'Laukaukset maalia kohti',
	        'eventsStats.shotsOnGoalFaced': 'Laukaukset vastaanotettu',
	        'eventsStats.substitutionsIn': 'Vaihto sisään ',
	        'eventsStats.substitutionsOut': 'Vaihto ulos',
	        'eventsStats.tackles': 'Taklausta',
	        'eventsStats.totalDuels.won': 'Voitettu kaksintaisto',
	        'eventsStats.touches.blocks': 'Blokkaukset',
	        'eventsStats.touches.completedPasses': 'Onnistuneet syötöt',
	        'eventsStats.touches.completionPercentage': 'Onnistuneet syötöt %',
	        'eventsStats.touches.interceptions': 'Torjunnat',
	        'eventsStats.touches.passes': 'Syötöt',
	        'eventsStats.touches.passesReceived': 'Vastaanotetut syötöt',
	        'eventsStats.touches.total': 'Kosketukset',
	        'eventsStats.yellowCards': 'Keltaiset kortit',
	        'f1.incident.crash': 'KOLARI',
	        'f1.incident.out': 'ULKONA',
	        'f1.incident.pitStop': 'VARIKKOPYSÄHDYS',
	        'f1.incident.retired': 'KESKEYTTÄNYT',
	        'f1.table.comment': 'Kommentti',
	        'f1.table.diff': '<empty>',
	        'f1.table.driverName': 'Kuski',
	        'f1.table.driverNumber': '<empty>',
	        'f1.table.gap': 'Etäisyys',
	        'f1.table.gap10': 'Etäisyys 10',
	        'f1.table.gap15': 'Etäisyys 15',
	        'f1.table.in_pit': 'Varikolla',
	        'f1.table.laps': 'Kierroksia',
	        'f1.table.pits': 'Varikkokäynnit',
	        'f1.table.pos': '#',
	        'f1.table.q1': 'Q1',
	        'f1.table.q2': 'Q2',
	        'f1.table.q3': 'Q3',
	        'f1.table.teamShortName': 'Tiimi',
	        'f1.table.time': 'Aika',
	        'f1.table.tyre': 'Renkaat',
	        'final.result': 'Tulos',
	        finished: 'Tulos',
	        form: 'Otteluhistoria',
	        goal: 'Maali',
	        goals: 'Maalit',
	        'goals.short': 'M',
	        goalsAverage: '',
	        goalsConceded: 'Päästetyt maalit',
	        goalsScored: 'Tehdyt maalit',
	        ht: 'HT',
	        in: 'Sisään',
	        'km/h': 'km/h',
	        live: 'Live',
	        'loss.short': 'H',
	        'matches.short': 'O',
	        matchstart: 'Ottelun alku',
	        'maxStats.distanceData.topSpeed': 'Maksimivauhti',
	        'meters.short': 'm',
	        min: 'min',
	        name: 'Nimi',
	        new: 'Uusi',
	        odds: 'Kertoimet',
	        out: 'Ulos',
	        owngoal: 'Oma maali',
	        points: 'Pistettä',
	        'points.short': 'P',
	        rank: 'Sija',
	        red_card: 'Punainen kortti',
	        round: 'Kierros',
	        'round.n': 'Kierros {0}',
	        'shots.on.goal': 'Laukausta maalia kohti',
	        'stats.position.1': 'Maalivahti',
	        'stats.position.2': 'Hyökkääjä',
	        'stats.position.3': 'Keskikenttä',
	        'stats.position.4': 'Puolustaja',
	        'status.full.cancelled': 'Peruttu',
	        'status.full.finished': 'Tulos',
	        'status.full.inprogress': 'Live',
	        'status.full.postponed': 'Siirretty myöhemmäksi',
	        'status.short.cancelled': 'PER',
	        'status.short.finished': 'FT',
	        'status.short.inprogress': 'LIVE',
	        'status.short.postponed': 'Lykätty',
	        subs: 'Vaihtopenkki',
	        topSpeed: 'Vauhti',
	        vs: 'vs',
	        'win.short': 'V',
	        yellow_card: 'Keltainen kortti'
	    },
	    no: {
	        'averageStats.score': '',
	        'averageStats.shots': '',
	        draw: '',
	        'eventsStats.aerialDuels.total': '',
	        'eventsStats.crossBreakdown.successful': '',
	        'eventsStats.goalsStats.freeKick': '',
	        'eventsStats.groundDuels.percentage': '',
	        'eventsStats.keyPasses': '',
	        'eventsStats.penaltyKicks.goals': '',
	        'f1.table.diff': '<empty>',
	        'f1.table.driverNumber': '<empty>',
	        'f1.table.gap10': '',
	        'f1.table.in_pit': '',
	        'f1.table.out': '',
	        'f1.table.pos': '',
	        'f1.table.q1': 'Q1',
	        'f1.table.q2': 'Q2',
	        'f1.table.q3': 'Q3',
	        finished: 'Slut',
	        ht: 'HT',
	        live: 'Live',
	        'maxStats.distanceData.topSpeed': '',
	        name: ''
	    },
	    se: {
	        '%': '%',
	        Coach: 'Coach',
	        Defender: 'Försvarare',
	        Forward: 'Angripare',
	        Goalkeeper: 'Målvakt',
	        Midfielder: 'Mittfältare',
	        all: 'Alt',
	        assist: 'Assist',
	        assists: 'Assists',
	        at: 'klockan',
	        attempts: 'Försök',
	        averageShots: 'Skott per match',
	        'averageStats.assists': 'Assists per match',
	        'averageStats.blocks': 'Blockeringar per match',
	        'averageStats.cornerKicks': 'Hörna per match',
	        'averageStats.crosses': 'Cross per match',
	        'averageStats.distanceData.sprints': 'Sprintar per match',
	        'averageStats.distanceData.topSpeed': 'Toppfart per match',
	        'averageStats.foulsCommitted': 'Regelbrott per match',
	        'averageStats.foulsSuffered': 'Regelbrott inför per match',
	        'averageStats.goalPerShot': 'Mål per skott per match',
	        'averageStats.goals': 'Mål per match',
	        'averageStats.matchesPlayed': 'Spelade Matcher',
	        'averageStats.minutesPlayed': 'Minuter per match',
	        'averageStats.offsides': 'Offside per match',
	        'averageStats.ownGoals': 'Självmål per match',
	        'averageStats.redCards': 'Rött kort per match',
	        'averageStats.saves': 'Räddning per match',
	        'averageStats.savesPercentage': 'Rädda procentandelar per match',
	        'averageStats.shots': 'Skott per match',
	        'averageStats.shotsOnGoal': 'Skott på mål per match',
	        'averageStats.shotsOnGoalFaced': 'Skott på mål inför per match',
	        'averageStats.substitutionsIn': 'Byten i',
	        'averageStats.substitutionsOut': 'Byten ut',
	        'averageStats.tackles': ' Tacklar per match',
	        'averageStats.touches.blocks': 'Blockeringar per match',
	        'averageStats.touches.passes': 'Pass per match',
	        'averageStats.touches.passesReceived': ' Mottagna pass per match',
	        'averageStats.yellowCards': 'Gult kort per match',
	        ballpossession: 'Bollinnehav',
	        draw: 'Oavgjort',
	        'draw.short': 'O',
	        'eventsStats.assists': 'Assists',
	        'eventsStats.blocks': 'Blockeringar',
	        'eventsStats.chancesCreated': 'Chanser skapade',
	        'eventsStats.cleanSheets': 'Hålla nollan',
	        'eventsStats.cornerKicks': 'Hörna',
	        'eventsStats.crossBreakdown.percentage': ' Framgångsrika kors, %',
	        'eventsStats.crossBreakdown.successful': ' Framgångsrika kors',
	        'eventsStats.crosses': 'Cross',
	        'eventsStats.custom.goalsPerMinute': 'Mål per minut',
	        'eventsStats.distanceData.averageSpeed': 'Genomsnittshastighet',
	        'eventsStats.distanceData.distance': ' Distans täckt',
	        'eventsStats.distanceData.sprints': 'Sprintar',
	        'eventsStats.distanceData.topSpeed': 'Toppfart',
	        'eventsStats.foulsCommitted': 'Antal regelbrott',
	        'eventsStats.foulsSuffered': 'Antal regelbrott inför',
	        'eventsStats.goalPerShot': 'Mål per skott',
	        'eventsStats.goals': 'Mål',
	        'eventsStats.goalsAllowed': 'Insläppta mål per match',
	        'eventsStats.goalsStats.freeKick': 'Mål på frispark',
	        'eventsStats.goalsStats.header': 'Mål på header',
	        'eventsStats.groundDuels.percentage': ' Ground dueller, %',
	        'eventsStats.groundDuels.total': ' Ground dueller',
	        'eventsStats.groundDuels.won': ' Ground dueller vann',
	        'eventsStats.keyPasses': ' Key passerar',
	        'eventsStats.matchesPlayed': 'Spelade Matcher',
	        'eventsStats.minutesPlayed': 'Minuter spelas',
	        'eventsStats.missedPenalty': 'Missade straff',
	        'eventsStats.offsides': 'Offside',
	        'eventsStats.ownGoals': 'Självmål',
	        'eventsStats.passLength.long': ' Långa pass',
	        'eventsStats.passLength.short': ' Korta passerar',
	        'eventsStats.penaltyKicks.goals': ' Mål på straff',
	        'eventsStats.penaltyKicks.shots': ' Skott från straff',
	        'eventsStats.penaltyKicks.won': ' Straff mot',
	        'eventsStats.redCards': 'Rött kort',
	        'eventsStats.saves': 'Räddninger',
	        'eventsStats.savesPercentage': 'Räddning %',
	        'eventsStats.score': 'Resultat',
	        'eventsStats.shots': 'Skott',
	        'eventsStats.shotsFaced': 'Skott inför',
	        'eventsStats.shotsOnGoal': 'Försök',
	        'eventsStats.shotsOnGoalFaced': 'Skott på mål inför',
	        'eventsStats.substitutionsIn': 'Byte i',
	        'eventsStats.substitutionsOut': 'Byte ut',
	        'eventsStats.tackles': 'Tacklingar',
	        'eventsStats.totalDuels.won': 'Dueller vann',
	        'eventsStats.touches.blocks': 'Blockeringar',
	        'eventsStats.touches.interceptions': 'Uppfångande',
	        'eventsStats.touches.passes': 'Pass',
	        'eventsStats.touches.passesReceived': 'Mottagna pass',
	        'eventsStats.yellowCards': 'Gult kort',
	        'f1.incident.out': 'UT',
	        'f1.table.out': 'UT',
	        'final.result': 'Slutresultat',
	        finished: 'SLUT',
	        form: 'Form',
	        goal: 'Mål',
	        goals: 'Mål',
	        'goals.short': 'M',
	        goalsAverage: 'Mål per match',
	        goalsConceded: 'Insläppta mål per match',
	        goalsScored: 'Gjorda mål',
	        ht: 'HT',
	        in: 'I',
	        'km/h': 'km/t',
	        live: 'Live',
	        'loss.short': 'F',
	        matches: 'Matcher',
	        'matches.short': 'M',
	        matchstart: 'Avspark',
	        'maxStats.distanceData.topSpeed': 'Toppfart',
	        'meters.short': 'm',
	        min: 'min',
	        name: 'Namn',
	        new: 'Ny',
	        odds: 'ATT VINNA?',
	        out: 'Ut',
	        owngoal: 'Självmål',
	        penalty: 'Straffmål',
	        points: 'Poäng',
	        'points.short': 'P',
	        rank: 'Rank',
	        rcards: 'Rött kort',
	        red_card: 'Rött kort',
	        round: 'Omgång',
	        'round.n': 'Omgång {0}',
	        scoring: 'Scoring %',
	        'shots.on.goal': 'Skott på mål',
	        'stats.position.1': 'Målvakt',
	        'stats.position.2': 'Angripare',
	        'stats.position.3': 'Mittfältare',
	        'stats.position.4': 'Försvarare',
	        'status.full.cancelled': 'AVBOKAD',
	        'status.full.finished': 'Slutresultat',
	        'status.full.inprogress': 'Live',
	        'status.full.postponed': 'Uppskjutet',
	        'status.short.cancelled': 'AVBOKAD',
	        'status.short.finished': 'SLUT',
	        'status.short.inprogress': 'Live',
	        'status.short.notstarted': 'Ej påbörjad',
	        'status.short.postponed': 'UPPS',
	        subs: 'Byte',
	        topSpeed: 'Toppfart',
	        vs: 'mot',
	        'win.short': 'V',
	        ycards: 'Gult kort',
	        yellow_card: 'Gult kort'
	    }
	};

/***/ },
/* 1379 */,
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetsPreview = function (_React$Component) {
	    _inherits(WidgetsPreview, _React$Component);
	
	    function WidgetsPreview() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WidgetsPreview);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WidgetsPreview.__proto__ || Object.getPrototypeOf(WidgetsPreview)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps, nextState) {
	            return nextProps.widgets.length !== _this.props.widgets.length;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WidgetsPreview, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                theme = _props.theme,
	                widgets = _props.widgets,
	                token = _props.token,
	                client = _props.client,
	                user = _props.user;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'rlz-theme-customizer__widgets' },
	                widgets.map(function (w, i) {
	                    var demoProps = {};
	                    if (w.spec && w.spec.demo && w.spec.demo[0] && w.spec.demo[0].props) {
	                        var props = w.spec.demo[0].props;
	                        Object.keys(props).forEach(function (key) {
	                            var wkey = 'data-' + _lodash2.default.kebabCase(key);
	                            demoProps[wkey] = props[key];
	                        });
	                    }
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'rlz-theme-customizer__widget', key: w.id + '_2' },
	                        _react2.default.createElement('rlz-widget', _extends({
	                            'data-name': w.id,
	                            'data-load': 'js',
	                            'data-token': token,
	                            'data-theme': theme,
	                            'data-client': client,
	                            'data-user': user,
	                            'data-ga': false,
	                            'data-lang': 'en'
	                        }, demoProps))
	                    );
	                })
	            );
	        }
	    }]);
	
	    return WidgetsPreview;
	}(_react2.default.Component);
	
	exports.default = WidgetsPreview;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding: 4px;\n'], ['\n    padding: 4px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    text-align: left;\n    margin-bottom: 3px;\n    > div {\n        padding: 0 10px;\n        flex-grow: 1;\n    }\n    .date {\n        width: 80px;\n    }\n    .sport {\n        width: 250px;\n    }\n    .name {\n        width: 300px;\n    }\n    .channels {\n        width: 250px;\n    }\n    .description {\n        width: 500px;\n    }\n    .actions {\n        width: 120px;\n        display: flex;\n        justify-content: space-around;\n    }\n    ', ';\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    text-align: left;\n    margin-bottom: 3px;\n    > div {\n        padding: 0 10px;\n        flex-grow: 1;\n    }\n    .date {\n        width: 80px;\n    }\n    .sport {\n        width: 250px;\n    }\n    .name {\n        width: 300px;\n    }\n    .channels {\n        width: 250px;\n    }\n    .description {\n        width: 500px;\n    }\n    .actions {\n        width: 120px;\n        display: flex;\n        justify-content: space-around;\n    }\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _fetch2 = __webpack_require__(1382);
	
	var _fetch3 = _interopRequireDefault(_fetch2);
	
	var _isomorphicFetch = __webpack_require__(1375);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _save = __webpack_require__(1069);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _deleteForever = __webpack_require__(1086);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	var _modeEdit = __webpack_require__(1383);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _update = __webpack_require__(1384);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _fileUpload = __webpack_require__(1385);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Td = _styledComponents2.default.td(_templateObject);
	
	var Event = _styledComponents2.default.div(_templateObject2, function (props) {
	    if (props.header) {
	        return '\n      > div {\n        padding: 10px 10px;\n\n      }\n        font-weight: 700;\n        color: rgba(0,0,0,.7);\n      ';
	    }
	});
	
	var TvProgramDashboard = function (_React$Component) {
	    _inherits(TvProgramDashboard, _React$Component);
	
	    function TvProgramDashboard(props) {
	        _classCallCheck(this, TvProgramDashboard);
	
	        var queryDate = _lodash2.default.get(props, 'location.query.date', null);
	
	        var _this = _possibleConstructorReturn(this, (TvProgramDashboard.__proto__ || Object.getPrototypeOf(TvProgramDashboard)).call(this, props));
	
	        _this.componentDidMount = function () {
	            _this.loadData().then(function (data) {
	                _this.setState(_extends({}, data, {
	                    dataLoaded: true
	                }));
	            }).catch(function (e) {
	                return _this.setState({ dataLoaded: true, error: true });
	            });
	        };
	
	        _this.loadData = function () {
	            if (!_this.state.key) return _bluebird2.default.resolve();
	            return _bluebird2.default.props({
	                program: _fetch3.default.get(_cfg2.default.widgets.url + '/tv-program?key=' + _this.state.key)
	            }).then(function (data) {
	                return data;
	            }).catch(function (err) {
	                return void 0;
	            });
	        };
	
	        _this.programStructure = function () {
	            return [{
	                key: 'sport',
	                type: 'select',
	                multiple: false,
	                values: _lodash2.default.uniqBy(_this.state.program, function (event) {
	                    return event.sport;
	                }).map(function (event) {
	                    return {
	                        value: event.sport,
	                        label: event.sport
	                    };
	                })
	            }, { key: 'sport', type: 'string' },
	            // { key: "sportId", type: "number" },
	            { key: 'eventName', type: 'string' }, { key: 'description', type: 'string' }, { key: 'icon', type: 'string' }, { key: 'startDate', type: 'date' }, { key: 'linkUrl', type: 'string' }, { key: 'linkTitle', type: 'string' }, {
	                key: 'highlightedCountryId',
	                type: 'select',
	                values: [{ value: null, label: '' }, { value: 1, label: 'Denmark' }]
	            }, {
	                key: 'channels',
	                type: 'select',
	                multiple: true,
	                values: [{ value: 'drtv', label: 'drtv' }, { value: 'drdk', label: 'drdk' }, { value: 'dr1', label: 'dr1' }, { value: 'dr2', label: 'dr2' }, { value: 'dr3', label: 'dr3' }, { value: 'eurosport_player', label: 'eurosport_player ' }, { value: 'eurosport1', label: 'eurosport1' }, { value: 'eurosport2', label: 'eurosport2' }, { value: 'kanal5', label: 'kanal5' }]
	                // {
	                //   key: "links",
	                //   type: "array",
	                //   structure: [
	                //     { key: "url", type: "string" },
	                //     { key: "title", type: "string" }
	                //   ]
	                // }
	            }];
	        };
	
	        _this.handleTextFieldChange = function (key, type, event) {
	            var value = event.target.value;
	
	            if (type === 'number') value = +value;
	            _this.setState(_defineProperty({}, key, value));
	        };
	
	        _this.handleArrayAdd = function (key, refName, structure, i) {
	            var currentValues = _this.state[key] || [];
	
	            if (structure) {
	                var _this$setState2;
	
	                var newValue = {};
	                if (currentValues[i]) newValue = currentValues[i];
	                structure.forEach(function (_ref, y) {
	                    var type = _ref.type,
	                        innerKey = _ref.key;
	
	                    var ref = _this.refs[key + '_' + i + '_' + innerKey + '_' + y];
	                    newValue[innerKey] = ref.input.value;
	                    // ref.input.value = null;
	                });
	
	                _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, key, currentValues[i] ? currentValues : [].concat(_toConsumableArray(currentValues), [newValue])), _defineProperty(_this$setState2, 'arraysCount', currentValues[i] ? _this.state.arraysCount : _extends({}, _this.state.arraysCount, _defineProperty({}, key, _this.state.arraysCount[key] + 1 || 2))), _this$setState2));
	            } else {
	                var _this$setState3;
	
	                var _newValue = _this.refs[refName].input.value;
	
	                _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, key, currentValues[i] ? [].concat(_toConsumableArray(currentValues.slice(0, i)), [_newValue], _toConsumableArray(currentValues.slice(i + 1))) : [].concat(_toConsumableArray(currentValues), [_newValue])), _defineProperty(_this$setState3, 'arraysCount', currentValues[i] ? _this.state.arraysCount : _extends({}, _this.state.arraysCount, _defineProperty({}, key, _this.state.arraysCount[key] + 1 || 2))), _this$setState3));
	            }
	        };
	
	        _this.handleArrayDelete = function (key, value) {
	            var currentValues = _this.state[key];
	            _this.setState(_defineProperty({}, key, currentValues.filter(function (v) {
	                return v !== value;
	            })));
	        };
	
	        _this.handleSelectChange = function (key, value) {
	            return _this.setState(_defineProperty({}, key, value));
	        };
	
	        _this.renderSelect = function (key, values, multiple) {
	            return _react2.default.createElement(
	                rmd.SelectField,
	                {
	                    multiple: multiple,
	                    floatingLabelText: key,
	                    value: _this.state[key],
	                    fullWidth: true,
	                    onChange: function onChange(event, index, value) {
	                        return _this.handleSelectChange(key, value);
	                    }
	                },
	                values.map(function (_ref2) {
	                    var v = _ref2.value,
	                        label = _ref2.label;
	
	                    return _react2.default.createElement(rmd.MenuItem, {
	                        primaryText: label,
	                        value: v,
	                        key: v,
	                        insetChildren: multiple,
	                        checked: multiple && _this.state[key] && _this.state[key].indexOf(v) > -1
	                    });
	                })
	            );
	        };
	
	        _this.getEventData = function () {
	            return _lodash2.default.omit(_this.state, ['arraysCount', 'program', 'dataLoaded', 'error', 'saving', 'editId', '_id', 'createdAt', 'updatedAt', '__v']);
	        };
	
	        _this.resettedState = function () {
	            return _this.programStructure().reduce(function (prev, cur) {
	                if (cur.key === 'startDate') return prev;
	                prev[cur.key] = undefined;
	                return prev;
	            }, { arraysCount: {}, editId: null });
	        };
	
	        _this.handleEventAdd = function () {
	            var user = _auth2.default.getUser();
	
	            _this.setState({ saving: true }, function () {
	                _fetch3.default.post(_cfg2.default.widgets.url + '/tv-program', {}, {
	                    program: _extends({}, _this.getEventData(), {
	                        key: _this.state.key
	                    }),
	                    customer: {
	                        client: user.client,
	                        user: user.username
	                    }
	                }).then(function () {
	                    _this.setState({ saving: false });
	                    _this.loadData().then(function (data) {
	                        return _this.setState(_extends({}, data, _this.resettedState()));
	                    });
	                });
	            });
	        };
	
	        _this.handleEventDelete = function (id) {
	            (0, _isomorphicFetch2.default)(_cfg2.default.widgets.url + '/tv-program/' + id, {
	                method: 'DELETE',
	                headers: {
	                    'Content-Type': 'application/json'
	                }
	            }).then(_this.loadData).then(function (data) {
	                return _this.setState(_extends({}, data, _this.resettedState()));
	            });
	        };
	
	        _this.handleEventUpdate = function (id) {
	            (0, _isomorphicFetch2.default)(_cfg2.default.widgets.url + '/tv-program/' + id, {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({ program: _this.getEventData() })
	            }).then(_this.loadData).then(function (data) {
	                return _this.setState(_extends({}, data, { editId: null }, _this.resettedState(), { open: false }));
	            });
	        };
	
	        _this.renderArrays = function (key, structure) {
	            var elements = [];
	
	            var _loop = function _loop(i) {
	                elements.push(_react2.default.createElement(
	                    'div',
	                    { key: i },
	                    structure && _react2.default.createElement(
	                        'div',
	                        { style: { padding: 10, border: '3px solid rgba(0,0,0,.1)', marginBottom: 10 } },
	                        structure.map(function (_ref3, y) {
	                            var innerType = _ref3.type,
	                                innerKey = _ref3.key;
	
	                            var ref = key + '_' + i + '_' + innerKey + '_' + y;
	                            // if (this.state[key]) {console.log('this.', this.state[key][i][innerKey])}
	                            return _react2.default.createElement(rmd.TextField, {
	                                type: 'string',
	                                ref: ref,
	                                id: ref,
	                                fullWidth: true,
	                                key: y,
	                                floatingLabelText: key + ': ' + innerKey
	                            });
	                        }),
	                        i === (_this.state.arraysCount[key] - 1 || 0) && _react2.default.createElement(rmd.RaisedButton, {
	                            label: 'Add this link',
	                            onTouchTap: function onTouchTap() {
	                                return _this.handleArrayAdd(key, 'input_' + key + '_' + i, structure, i);
	                            }
	                        })
	                    ),
	                    !structure && _react2.default.createElement(rmd.TextField, {
	                        type: 'string',
	                        fullWidth: true,
	                        style: { marginRight: 10 },
	                        ref: 'input_' + key + '_' + i,
	                        onChange: function onChange() {
	                            _this.handleArrayAdd(key, 'input_' + key + '_' + i, null, i);
	                        },
	                        floatingLabelText: key + ': ' + (i + 1)
	                    })
	                ));
	            };
	
	            for (var i = 0; i < (_this.state.arraysCount[key] || 1); i++) {
	                _loop(i);
	            }
	            return _react2.default.createElement(
	                'div',
	                { style: { display: !structure ? 'flex' : 'block' } },
	                elements
	            );
	        };
	
	        _this.renderSaveButton = function () {
	            var label = 'Save';
	            if (_this.state.saving) label = 'Saving...';
	
	            return _react2.default.createElement(
	                rmd.FloatingActionButton,
	                {
	                    style: { marginTop: 20, position: 'absolute', right: 20, bottom: 120 },
	                    disabled: _this.state.saving,
	                    onTouchTap: function onTouchTap() {
	                        return _this.state.editId ? _this.handleEventUpdate(_this.state.editId) : _this.handleEventAdd();
	                    }
	                },
	                !_this.state.saving && !_this.state.editId && _react2.default.createElement(_save2.default, null),
	                !_this.state.saving && _this.state.editId && _react2.default.createElement(_fileUpload2.default, null),
	                _this.state.saving && _react2.default.createElement(_update2.default, null)
	            );
	        };
	
	        _this.handleDateChange = function (key, date) {
	            _this.props.router.push({
	                pathname: '/tv-program',
	                query: _extends({}, _this.props.location.query, {
	                    date: (0, _moment2.default)(date).format('YYYY-MM-DD')
	                })
	            });
	            _this.setState(_defineProperty({}, key, date));
	        };
	
	        _this.handleChangeTimePicker24 = function (key, date) {
	            _this.setState(_defineProperty({}, key, date));
	        };
	
	        _this.renderDatePicker = function (key) {
	            var timezone = (0, _moment2.default)().utcOffset() / 60;
	            var sign = Math.sign(timezone) >= 0 ? '+' : '-';
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(rmd.TimePicker, {
	                    format: '24hr',
	                    fullWidth: true,
	                    floatingLabelText: 'Start time (Timezone: ' + sign + timezone + ' hours)',
	                    value: _this.state[key],
	                    onChange: function onChange(event, date) {
	                        return _this.handleChangeTimePicker24(key, date);
	                    }
	                })
	            );
	        };
	
	        _this.renderEventsForDate = function () {
	            var startDate = _this.state.startDate;
	
	
	            if (!startDate) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { marginBottom: 50 } },
	                _react2.default.createElement(
	                    Event,
	                    { header: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'date' },
	                        'Time'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sport' },
	                        'Sport'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'name' },
	                        'Event name'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'description' },
	                        'Description'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'channels' },
	                        'Channels'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions' },
	                        'Actions'
	                    )
	                ),
	                _lodash2.default.sortBy(_this.state.program, ['startDate']).filter(function (p) {
	                    return p.startDate;
	                }).filter(function (p) {
	                    return (0, _moment2.default)(p.startDate).format('YYYY-MM-DD') === (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	                }).map(function (event) {
	                    var _id = event._id,
	                        eventName = event.eventName,
	                        sport = event.sport,
	                        startDate = event.startDate,
	                        description = event.description,
	                        channels = event.channels;
	
	                    return _react2.default.createElement(
	                        Event,
	                        { key: _id },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'date' },
	                            (0, _moment2.default)(startDate).format('HH:mm')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sport' },
	                            sport
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'name' },
	                            eventName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'description' },
	                            description
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'channels' },
	                            channels.reduce(function (prev, cur) {
	                                prev += cur + ', ';
	                                return prev;
	                            }, '')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                rmd.IconButton,
	                                {
	                                    tooltip: 'Edit',
	                                    onTouchTap: function onTouchTap() {
	                                        return _this.setState(_extends({}, event, {
	                                            startDate: (0, _moment2.default)(startDate).toDate(),
	                                            editId: _id,
	                                            open: true
	                                        }));
	                                    }
	                                },
	                                _react2.default.createElement(_modeEdit2.default, null)
	                            ),
	                            _react2.default.createElement(
	                                rmd.IconButton,
	                                {
	                                    tooltip: 'Delete forever',
	                                    onTouchTap: function onTouchTap() {
	                                        return _this.handleEventDelete(_id);
	                                    }
	                                },
	                                _react2.default.createElement(_deleteForever2.default, null)
	                            )
	                        )
	                    );
	                })
	            );
	        };
	
	        _this.handleOpen = function () {
	            _this.setState(_extends({ open: true }, _this.resettedState()));
	        };
	
	        _this.handleClose = function () {
	            _this.setState(_extends({ open: false }, _this.resettedState()));
	        };
	
	        _this.state = {
	            arraysCount: {},
	            program: [],
	            startDate: queryDate ? (0, _moment2.default)(queryDate, 'YYYY-MM-DD').toDate() : (0, _moment2.default)().toDate(),
	            key: _lodash2.default.get(props, 'location.query.key', 'drdk_wo_2018'),
	            open: false
	        };
	        return _this;
	    }
	
	    /*render() {
	    return (
	      <div>
	        <div style={{ display: "flex" }}>
	          <h1>TV Program Dashboard</h1>
	          <rmd.TextField
	            style={{ width: 400, marginLeft: 30 }}
	            value={this.state.key || ""}
	            type="text"
	            floatingLabelText="Key for events group (drdk_wo_2018)"
	            onChange={event => this.handleTextFieldChange("key", "text", event)}
	          />
	        </div>
	        <div className="row">
	          <div className="col-xs-6">
	            {this.programStructure().map(
	              ({ key, type, values, multiple, structure }, i) => {
	                switch (type) {
	                  case "string":
	                  case "number":
	                    return (
	                      <div key={key}>
	                        <rmd.TextField
	                          value={this.state[key] || ""}
	                          type={type}
	                          floatingLabelText={key}
	                          onChange={event =>
	                            this.handleTextFieldChange(key, type, event)
	                          }
	                        />
	                      </div>
	                    );
	                   case "array":
	                    return (
	                      <div key={i}>{this.renderArrays(key, structure)}</div>
	                    );
	                  case "select":
	                    return (
	                      <div key={i}>
	                        {this.renderSelect(key, values, multiple)}
	                      </div>
	                    );
	                  case "date":
	                    return <div key={i}>{this.renderDatePicker(key)}</div>;
	                }
	              }
	            )}
	          </div>
	          <div className="col-xs-6">
	            <div style={{ height: 500, overflowY: "scroll" }}>
	              <table style={{ width: "100%", whiteSpace: "nowrap" }}>
	                <tbody>
	                  {_.sortBy(this.state.program, "updatedAt").map(event => {
	                    let { _id, eventName, sport, startDate } = event;
	                    return (
	                      <tr
	                        onClick={() => this.setState({ ...event, editId: _id })}
	                        key={_id}
	                      >
	                        <Td>{moment(startDate).format("MM/DD, HH:mm")}</Td>
	                        <Td>{sport}</Td>
	                        <Td
	                          style={{
	                            maxWidth: 200,
	                            width: 200,
	                            overflow: "hidden",
	                            textOverflow: "ellipsis"
	                          }}
	                        >
	                          {eventName}
	                        </Td>
	                        <Td>
	                          <rmd.IconButton
	                            onTouchTap={() => this.handleEventDelete(_id)}
	                            style={{ marginRight: 30 }}
	                          >
	                            <ContentDelete />
	                          </rmd.IconButton>
	                        </Td>
	                      </tr>
	                    );
	                  })}
	                </tbody>
	              </table>
	            </div>
	          </div>
	        </div>
	         {this.renderSaveButton()}
	        <div style={{ height: 100 }} />
	      </div>
	    );
	    }*/
	
	    _createClass(TvProgramDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var programStructure = this.programStructure();
	
	            if (!this.state.startDate) return null;
	
	            var actions = [_react2.default.createElement(rmd.FlatButton, { label: 'Cancel', primary: true, onClick: this.handleClose }), _react2.default.createElement(rmd.FlatButton, {
	                label: 'Submit',
	                primary: true,
	                disabled: this.state.saving,
	                onClick: function onClick() {
	                    return _this2.state.editId ? _this2.handleEventUpdate(_this2.state.editId) : _this2.handleEventAdd();
	                }
	            })];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    !this.state.startDate && _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Choose date you want to see/add events for'
	                    ),
	                    this.state.startDate && _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Date selected: ',
	                        (0, _moment2.default)(this.state.startDate).format('dddd, MMMM DD (YYYY)')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                display: 'flex',
	                                justifyContent: 'space-between',
	                                alignItems: 'center'
	                            }
	                        },
	                        _react2.default.createElement(rmd.DatePicker, {
	                            floatingLabelText: 'Choose date',
	                            value: this.state.startDate,
	                            onChange: function onChange(event, date) {
	                                return _this2.handleDateChange('startDate', date);
	                            }
	                        }),
	                        _react2.default.createElement(rmd.TextField, {
	                            value: this.state.key || '',
	                            type: 'text',
	                            floatingLabelText: 'Key for events group',
	                            onChange: function onChange(event) {
	                                return _this2.setState({ key: event.target.value });
	                            },
	                            onBlur: function onBlur() {
	                                _this2.props.router.push({
	                                    pathname: '/tv-program',
	                                    query: _extends({}, _this2.props.location.query, { key: _this2.state.key })
	                                });
	                                _this2.loadData().then(function (data) {
	                                    return _this2.setState(data);
	                                });
	                            }
	                        }),
	                        _react2.default.createElement(rmd.RaisedButton, { label: 'Add new event for this day', onClick: this.handleOpen })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.renderEventsForDate()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        rmd.Dialog,
	                        {
	                            title: 'Event',
	                            actions: actions,
	                            modal: false,
	                            open: this.state.open,
	                            onRequestClose: this.handleClose,
	                            autoScrollBodyContent: true
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                programStructure.filter(function (p) {
	                                    return p.type === 'string' || p.type === 'number';
	                                }).map(function (_ref4, i) {
	                                    var key = _ref4.key,
	                                        type = _ref4.type,
	                                        values = _ref4.values,
	                                        multiple = _ref4.multiple,
	                                        structure = _ref4.structure;
	
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { key: key },
	                                        _react2.default.createElement(rmd.TextField, {
	                                            value: _this2.state[key] || '',
	                                            type: type,
	                                            fullWidth: true,
	                                            floatingLabelText: key,
	                                            onChange: function onChange(event) {
	                                                return _this2.handleTextFieldChange(key, type, event);
	                                            }
	                                        })
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                programStructure.filter(function (p) {
	                                    return p.type === 'array' || p.type === 'select' || p.type === 'date';
	                                }).map(function (_ref5, i) {
	                                    var key = _ref5.key,
	                                        type = _ref5.type,
	                                        values = _ref5.values,
	                                        multiple = _ref5.multiple,
	                                        structure = _ref5.structure;
	
	                                    switch (type) {
	                                        case 'array':
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { key: i },
	                                                _this2.renderArrays(key, structure)
	                                            );
	                                        case 'select':
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { key: i },
	                                                _this2.renderSelect(key, values, multiple)
	                                            );
	                                        case 'date':
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { key: i },
	                                                _this2.renderDatePicker(key)
	                                            );
	                                    }
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TvProgramDashboard;
	}(_react2.default.Component);
	
	exports.default = TvProgramDashboard;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetch = __webpack_require__(1375);
	
	var statusIsOK = function statusIsOK(status) {
	    var result = false;
	    switch (status) {
	        case 200:
	            result = true;
	            break;
	    }
	    return result;
	};
	
	module.exports = {
	    get: function get(url) {
	        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        return fetch(url, Object.assign({ headers: {
	                'Accept': 'application/json'
	            } }, params)).then(function (response) {
	            var status = response.status;
	
	
	            if (statusIsOK(status)) {
	                return response.json();
	            } else {
	                throw new Error();
	            }
	        }).catch(function (e) {
	            throw e;
	        });
	    },
	    post: function post(url) {
	        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        return fetch(url, Object.assign({
	            method: 'POST',
	            headers: {
	                'Content-Type': 'application/json'
	            },
	            body: JSON.stringify(body)
	        }, params)).then(function (response) {
	            var status = response.status;
	
	
	            if (statusIsOK(status)) {
	                return response[params.responseType || 'json']();
	            } else {
	                throw new Error();
	            }
	        }).catch(function (e) {
	            throw e;
	        });
	    }
	};

/***/ },
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 0.53em;\n    padding-bottom: 0.53em;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 0.53em;\n    padding-bottom: 0.53em;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    padding-top: 0.33em;\n'], ['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    padding-top: 0.33em;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: inherit;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    color: ', ';\n    font-weight: inherit;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    margin-bottom: 16px;\n'], ['\n    display: flex;\n    margin-bottom: 16px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n'], ['\n    display: flex;\n    justify-content: center;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n'], ['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CreateTemplateBtn = __webpack_require__(1387);
	
	var _CreateTemplateBtn2 = _interopRequireDefault(_CreateTemplateBtn);
	
	var _DisplayIdLineUp = __webpack_require__(1388);
	
	var _DisplayIdLineUp2 = _interopRequireDefault(_DisplayIdLineUp);
	
	var _MakerTool = __webpack_require__(1389);
	
	var _MakerTool2 = _interopRequireDefault(_MakerTool);
	
	var _ParticipantsPicker = __webpack_require__(1398);
	
	var _ParticipantsPicker2 = _interopRequireDefault(_ParticipantsPicker);
	
	var _WidgetCustomLineUp = __webpack_require__(1403);
	
	var _WidgetCustomLineUp2 = _interopRequireDefault(_WidgetCustomLineUp);
	
	var _EditWidgetBtn = __webpack_require__(1470);
	
	var _EditWidgetBtn2 = _interopRequireDefault(_EditWidgetBtn);
	
	var _Card = __webpack_require__(843);
	
	var _pictureInPicture = __webpack_require__(1042);
	
	var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject);
	
	var HeaderLet = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3, _colors.indigo500);
	
	var Content = _styledComponents2.default.div(_templateObject4);
	
	var Widget = _styledComponents2.default.div(_templateObject5);
	
	var EditWidgetBtnWrapper = _styledComponents2.default.div(_templateObject6);
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var IconPacksStyle = {
	    color: 'inherit'
	};
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	var MakerToolPage = function (_PureComponent) {
	    _inherits(MakerToolPage, _PureComponent);
	
	    function MakerToolPage() {
	        _classCallCheck(this, MakerToolPage);
	
	        return _possibleConstructorReturn(this, (MakerToolPage.__proto__ || Object.getPrototypeOf(MakerToolPage)).apply(this, arguments));
	    }
	
	    _createClass(MakerToolPage, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card.Card,
	                    { style: CardStyle },
	                    _react2.default.createElement(
	                        _Card.CardHeader,
	                        { style: CardHeaderStyle },
	                        _react2.default.createElement(
	                            HeaderWrapper,
	                            null,
	                            _react2.default.createElement(
	                                HeaderLet,
	                                null,
	                                _react2.default.createElement(
	                                    Title,
	                                    null,
	                                    _react2.default.createElement(_pictureInPicture2.default, { style: IconPacksStyle }),
	                                    'Grid Maker Tool Page'
	                                ),
	                                _react2.default.createElement(_DisplayIdLineUp2.default, null)
	                            ),
	                            _react2.default.createElement(_CreateTemplateBtn2.default, null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Card.CardText,
	                        null,
	                        _react2.default.createElement(
	                            Content,
	                            null,
	                            _react2.default.createElement(_MakerTool2.default, null),
	                            _react2.default.createElement(_ParticipantsPicker2.default, null)
	                        ),
	                        _react2.default.createElement(
	                            Widget,
	                            null,
	                            _react2.default.createElement(_WidgetCustomLineUp2.default, null)
	                        ),
	                        _react2.default.createElement(
	                            EditWidgetBtnWrapper,
	                            null,
	                            _react2.default.createElement(_EditWidgetBtn2.default, null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MakerToolPage;
	}(_react.PureComponent);
	
	exports.default = MakerToolPage;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreateTemplateBtn(_ref) {
	    var setIdLineUp = _ref.setIdLineUp,
	        setPitchLineupTemplate = _ref.setPitchLineupTemplate;
	
	    return _react2.default.createElement(_RaisedButton2.default, {
	        label: 'Create Template',
	        onClick: function onClick() {
	            var idLineUp = Math.floor(10000 + Math.random() * 90000);
	            var ttId = new URL(location.href).searchParams.get('ttId');
	
	            history.pushState({}, '', '?' + (ttId ? 'ttId=' + ttId + '&' : '') + 'idLineUp=' + idLineUp);
	            setIdLineUp(idLineUp);
	            setPitchLineupTemplate([]);
	        }
	    });
	}
	
	CreateTemplateBtn.propTypes = {
	    // From connect
	    setIdLineUp: _propTypes2.default.func.isRequired,
	    setPitchLineupTemplate: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { setIdLineUp: _actions.setIdLineUp, setPitchLineupTemplate: _actions.setPitchLineupTemplate })(CreateTemplateBtn);

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    color: #000;\n'], ['\n    color: #000;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _Subheader = __webpack_require__(818);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Strong = _styledComponents2.default.span(_templateObject2);
	
	var subheaderStyle = {
	    width: 'auto',
	    paddingLeft: 0,
	    paddingRight: 10
	};
	
	var flatButtonStyle = {
	    fontSize: '14px'
	};
	
	var DisplayIdLineUp = function (_Component) {
	    _inherits(DisplayIdLineUp, _Component);
	
	    function DisplayIdLineUp() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DisplayIdLineUp);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DisplayIdLineUp.__proto__ || Object.getPrototypeOf(DisplayIdLineUp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            idLineUp: new URL(location.href).searchParams.get('idLineUp') || _this.props.idLineUp || Math.floor(10000 + Math.random() * 90000)
	        }, _this.copyLinkToClipboard = function () {
	            var link = location.href;
	
	            if (!navigator.clipboard) {
	                _this.fallbackCopyTextToClipboard(link);
	                return;
	            }
	
	            navigator.clipboard.writeText(link).catch(function (err) {});
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DisplayIdLineUp, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var idLineUp = this.state.idLineUp;
	            var _props = this.props,
	                setIdLineUp = _props.setIdLineUp,
	                setPitchLineupTemplate = _props.setPitchLineupTemplate;
	
	            var ttId = new URL(location.href).searchParams.get('ttId');
	            idLineUp = parseInt(idLineUp, 10);
	            history.pushState({}, '', '?' + (ttId ? 'ttId=' + ttId + '&' : '') + 'idLineUp=' + idLineUp);
	
	            fetch('http://ss2.si-ab.com/admin/keyval?appName=maker-tool&key=' + idLineUp).then(function (res) {
	                return res.status === 200 && res.json();
	            }).then(function (lineup) {
	                if (lineup && lineup.value) {
	                    setIdLineUp(idLineUp, false);
	                    setPitchLineupTemplate(lineup.value.players || []);
	                } else {
	                    setIdLineUp(idLineUp);
	                }
	            });
	        }
	    }, {
	        key: 'fallbackLinkTextToClipboard',
	        value: function fallbackLinkTextToClipboard(text) {
	            var textArea = document.createElement('textarea');
	            textArea.value = text;
	            document.body.appendChild(textArea);
	            textArea.focus();
	            textArea.select();
	
	            try {
	                document.execCommand('copy');
	            } catch (err) {}
	
	            document.body.removeChild(textArea);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                Wrapper,
	                null,
	                _react2.default.createElement(
	                    _Subheader2.default,
	                    { style: subheaderStyle },
	                    _react2.default.createElement(
	                        Strong,
	                        null,
	                        'LineUp Id: '
	                    ),
	                    location.href
	                ),
	                _react2.default.createElement(
	                    _FlatButton2.default,
	                    { style: flatButtonStyle, onClick: this.copyLinkToClipboard },
	                    'Copy Link'
	                )
	            );
	        }
	    }]);
	
	    return DisplayIdLineUp;
	}(_react.Component);
	
	DisplayIdLineUp.propTypes = {
	    // From connect
	    idLineUp: _propTypes2.default.number,
	    setIdLineUp: _propTypes2.default.func.isRequired,
	    setPitchLineupTemplate: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$makerToolPage = _ref2.makerToolPage;
	    _ref2$makerToolPage = _ref2$makerToolPage === undefined ? {} : _ref2$makerToolPage;
	    var idLineUp = _ref2$makerToolPage.idLineUp;
	    return { idLineUp: idLineUp };
	}, { setIdLineUp: _actions.setIdLineUp, setPitchLineupTemplate: _actions.setPitchLineupTemplate })(DisplayIdLineUp);

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: 800px;\n'], ['\n    width: 800px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n'], ['\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ParticipantLineUp = __webpack_require__(1390);
	
	var _ParticipantLineUp2 = _interopRequireDefault(_ParticipantLineUp);
	
	var _SelectLineUp = __webpack_require__(1396);
	
	var _SelectLineUp2 = _interopRequireDefault(_SelectLineUp);
	
	var _DeleteArea = __webpack_require__(1397);
	
	var _DeleteArea2 = _interopRequireDefault(_DeleteArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.article(_templateObject);
	
	var TopPanel = _styledComponents2.default.header(_templateObject2);
	
	var Content = _styledComponents2.default.div(_templateObject3);
	
	var DeleteAreaWrapper = _styledComponents2.default.div(_templateObject4);
	
	function MakerTool() {
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	            TopPanel,
	            null,
	            _react2.default.createElement(_SelectLineUp2.default, null)
	        ),
	        _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	                DeleteAreaWrapper,
	                null,
	                _react2.default.createElement(_DeleteArea2.default, null)
	            ),
	            _react2.default.createElement(_ParticipantLineUp2.default, null)
	        )
	    );
	}
	
	exports.default = MakerTool;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    height: 789px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    padding: 9px 0;\n    overflow: hidden;\n    box-sizing: border-box;\n'], ['\n    position: relative;\n    height: 789px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    padding: 9px 0;\n    overflow: hidden;\n    box-sizing: border-box;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n    padding: 0 20px;\n    margin-bottom: 13px;\n\n    > div {\n        margin: 0 9px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n    padding: 0 20px;\n    margin-bottom: 13px;\n\n    > div {\n        margin: 0 9px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    svg {\n        position: absolute;\n        top: 145px;\n        left: 0;\n        z-index: -1;\n    }\n'], ['\n    svg {\n        position: absolute;\n        top: 145px;\n        left: 0;\n        z-index: -1;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _ItemPitch = __webpack_require__(1391);
	
	var _ItemPitch2 = _interopRequireDefault(_ItemPitch);
	
	var _PitchSVG = __webpack_require__(1395);
	
	var _PitchSVG2 = _interopRequireDefault(_PitchSVG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var Row = _styledComponents2.default.div(_templateObject2, function (_ref) {
	    var type = _ref.type;
	    return type === 'grid' ? 'center' : 'space-around';
	});
	
	var Pitch = _styledComponents2.default.div(_templateObject3);
	
	function ParticipantLineUp(_ref2) {
	    var _ref2$lineupType = _ref2.lineupType,
	        lineupType = _ref2$lineupType === undefined ? '' : _ref2$lineupType,
	        _ref2$lineupTemplate = _ref2.lineupTemplate,
	        lineupTemplate = _ref2$lineupTemplate === undefined ? '' : _ref2$lineupTemplate;
	
	    lineupTemplate = lineupTemplate.split('-').map(function (item) {
	        return parseInt(item, 10);
	    });
	
	    return _react2.default.createElement(
	        Content,
	        null,
	        lineupTemplate.map(function (row, indexRow) {
	            return _react2.default.createElement(
	                Row,
	                { key: Math.random() + Date.now() + row, type: lineupType },
	                Array.from({ length: row }, function (_, i) {
	                    return i;
	                }).map(function (indexLine) {
	                    return _react2.default.createElement(_ItemPitch2.default, { key: Math.random() + Date.now(), position: '' + (indexRow + 1) + (indexLine + 1) });
	                })
	            );
	        }),
	        lineupType === 'lineup' && _react2.default.createElement(
	            Pitch,
	            null,
	            _react2.default.createElement(_PitchSVG2.default, null)
	        )
	    );
	}
	
	ParticipantLineUp.propTypes = {
	    // From connect
	    lineupType: _propTypes2.default.string.isRequired,
	    lineupTemplate: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref3) {
	    var makerToolPage = _ref3.makerToolPage;
	    return {
	        lineupType: makerToolPage.lineupType,
	        lineupTemplate: makerToolPage.lineupTemplate
	    };
	})(ParticipantLineUp);

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    opacity: 0.8;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n    background-color: rgba(0, 0, 0, 0.75);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(circle at 32% 17%, #fff, #032945 50%, #02101b 85%, #fff);\n    border-image-slice: 1;\n    ', ';\n\n    ::before {\n        content: \'?\';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        font-size: 120px;\n        line-height: 1;\n        color: #fff;\n    }\n\n    ', ';\n'], ['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    opacity: 0.8;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n    background-color: rgba(0, 0, 0, 0.75);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(circle at 32% 17%, #fff, #032945 50%, #02101b 85%, #fff);\n    border-image-slice: 1;\n    ', ';\n\n    ::before {\n        content: \'?\';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        font-size: 120px;\n        line-height: 1;\n        color: #fff;\n    }\n\n    ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    color: #fff;\n\n    ::before {\n        ', ';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: -1;\n        opacity: 0.8;\n        box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n        background-color: rgba(0, 0, 0, 0.75);\n        border-style: solid;\n        border-width: 2px;\n        border-image-source: radial-gradient(circle at 32% 17%, #fff, #032945 50%, #02101b 85%, #fff);\n        border-image-slice: 1;\n    }\n\n    ', ';\n\n    ', ';\n'], ['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    color: #fff;\n\n    ::before {\n        ', ';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: -1;\n        opacity: 0.8;\n        box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n        background-color: rgba(0, 0, 0, 0.75);\n        border-style: solid;\n        border-width: 2px;\n        border-image-source: radial-gradient(circle at 32% 17%, #fff, #032945 50%, #02101b 85%, #fff);\n        border-image-slice: 1;\n    }\n\n    ', ';\n\n    ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    ', ';\n    ', ';\n    ', ';\n'], ['\n    position: relative;\n    width: 140px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    ', ';\n    ', ';\n    ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    z-index: 2;\n    pointer-events: none;\n    ', ';\n'], ['\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    z-index: 2;\n    pointer-events: none;\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _TextInput = __webpack_require__(1392);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	var _SMPlayerLogo2 = _interopRequireDefault(_SMPlayerLogo);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Item = _styledComponents2.default.div(_templateObject, function (_ref) {
	    var type = _ref.type;
	    return type === 'grid' && 'width: 160px; height: 210px;';
	}, function (_ref2) {
	    var large = _ref2.large;
	    return large && '\n        width: 192px;\n        height: 251px;\n        padding: 2px;\n\n        ::before {\n            font-size: 160px;\n        }\n    ';
	});
	
	var Participant = _styledComponents2.default.div(_templateObject2, function (_ref3) {
	    var type = _ref3.type;
	    return type === 'grid' && "content: '';";
	}, function (_ref4) {
	    var type = _ref4.type;
	    return type === 'grid' && '\n    width: 160px;\n    height: 209px;\n    padding: 2px;\n';
	}, function (_ref5) {
	    var large = _ref5.large;
	    return large && '\n    width: 192px;\n    height: 251px;\n    padding: 2px;\n';
	});
	
	var Avatar = _styledComponents2.default.div(_templateObject3, function (_ref6) {
	    var avatarType = _ref6.avatarType;
	    return avatarType === 'teams' && 'padding-bottom: 5px;';
	}, function (_ref7) {
	    var type = _ref7.type;
	    return type === 'grid' && 'width: 160px; height: 150px; padding-top: 10px;';
	}, function (_ref8) {
	    var large = _ref8.large;
	    return large && 'width: 192px; height: 180px;';
	});
	
	var TeamLogoBadge = _styledComponents2.default.div(_templateObject4, function (_ref9) {
	    var type = _ref9.type;
	    return type === 'grid' && 'left: -12px;';
	});
	
	var dragStart = function dragStart(position, participant) {
	    return function (event) {
	        event.dataTransfer.setData('position', position);
	        event.dataTransfer.setData('participant', JSON.stringify(participant));
	    };
	};
	
	var drop = function drop(currentPosition, currentParticipant, action) {
	    return function (event) {
	        var position = event.dataTransfer.getData('position');
	        var participant = event.dataTransfer.getData('participant') && JSON.parse(event.dataTransfer.getData('participant'));
	
	        if (currentPosition && participant) {
	            if (position && currentParticipant && currentPosition !== position) {
	                action(position, currentParticipant);
	            }
	            action(currentPosition, participant);
	            event.dataTransfer.clearData();
	        }
	    };
	};
	
	var dragEnd = function dragEnd(event) {
	    event.preventDefault();
	    event.dataTransfer.clearData();
	};
	
	var getAvatar = function getAvatar(type, participant, lineupType, large) {
	    var imageWrapStyle = {
	        height: '100px',
	        display: 'block',
	        overflow: 'hidden'
	    };
	
	    switch (type) {
	        case 'players':
	            {
	                var logoWidth = 100;
	
	                if (large) {
	                    logoWidth = 168;
	                    imageWrapStyle.height = '180px';
	                } else if (lineupType === 'grid') {
	                    logoWidth = 140;
	                    imageWrapStyle.height = '150px';
	                }
	
	                return [_react2.default.createElement(_SMPlayerLogo2.default, {
	                    key: 'SMPlayerLogo',
	                    teamId: participant.team ? participant.team.id : 0,
	                    playerId: participant.id,
	                    seasonId: 'current',
	                    isGK: participant.position === 'keeper',
	                    size: 'large',
	                    imageWrapStyle: imageWrapStyle,
	                    width: logoWidth,
	                    number: participant.shirtNumber
	                }), _react2.default.createElement(
	                    TeamLogoBadge,
	                    { key: 'TeamLogoBadge', type: lineupType, large: large },
	                    _react2.default.createElement(_SMTeamLogo2.default, { teamId: participant.team ? participant.team.id : 0, width: large && 45 || 35 })
	                )];
	            }
	        case 'teams':
	            return _react2.default.createElement(_SMTeamLogo2.default, { teamId: participant.id, width: large ? 160 : lineupType === 'grid' ? 130 : 95 });
	    }
	};
	
	function ItemPitch(_ref10) {
	    var _ref10$position = _ref10.position,
	        position = _ref10$position === undefined ? '' : _ref10$position,
	        participant = _ref10.participant,
	        lineupType = _ref10.lineupType,
	        lineupTemplate = _ref10.lineupTemplate,
	        setParticipantPitch = _ref10.setParticipantPitch,
	        setParticipantCustomName = _ref10.setParticipantCustomName,
	        setParticipantCustomText = _ref10.setParticipantCustomText;
	
	    var large = !!(lineupType === 'grid' && lineupTemplate === '3');
	
	    if (!participant) {
	        return _react2.default.createElement(Item, {
	            onDragOver: function onDragOver(event) {
	                return event.preventDefault();
	            },
	            onDrop: drop(position, participant, setParticipantPitch),
	            large: large,
	            type: lineupType
	        });
	    }
	
	    var avatarType = participant.countryId ? 'teams' : 'players';
	
	    return _react2.default.createElement(
	        Participant,
	        {
	            onDragStart: dragStart(position, participant),
	            onDrop: drop(position, participant, setParticipantPitch),
	            onDragOver: function onDragOver(event) {
	                return event.preventDefault();
	            },
	            onDragEnd: dragEnd,
	            large: large,
	            type: lineupType
	        },
	        _react2.default.createElement(
	            Avatar,
	            { type: lineupType, large: large, avatarType: avatarType },
	            getAvatar(participant.countryId ? 'teams' : 'players', participant, lineupType, large)
	        ),
	        _react2.default.createElement(_TextInput2.default, {
	            id: participant.id,
	            text: _RCore2.default.getFirstLastName(participant.name).lastName,
	            type: 'top',
	            action: setParticipantCustomName,
	            large: large,
	            lineupType: lineupType
	        }),
	        _react2.default.createElement(_TextInput2.default, {
	            id: participant.id,
	            text: participant.customText,
	            type: 'bottom',
	            action: setParticipantCustomText,
	            large: large,
	            lineupType: lineupType
	        })
	    );
	}
	
	ItemPitch.propTypes = {
	    position: _propTypes2.default.string.isRequired,
	    // From connect
	    participant: _propTypes2.default.object,
	    lineupType: _propTypes2.default.string,
	    lineupTemplate: _propTypes2.default.string,
	    setParticipantPitch: _propTypes2.default.func.isRequired,
	    setParticipantCustomName: _propTypes2.default.func.isRequired,
	    setParticipantCustomText: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref11, _ref12) {
	    var _ref11$makerToolPage = _ref11.makerToolPage;
	    _ref11$makerToolPage = _ref11$makerToolPage === undefined ? {} : _ref11$makerToolPage;
	    var activeParticipants = _ref11$makerToolPage.activeParticipants,
	        mapPitchPos = _ref11$makerToolPage.mapPitchPos,
	        lineupType = _ref11$makerToolPage.lineupType,
	        lineupTemplate = _ref11$makerToolPage.lineupTemplate;
	    var _ref12$position = _ref12.position,
	        position = _ref12$position === undefined ? 0 : _ref12$position;
	    return {
	        lineupType: lineupType,
	        lineupTemplate: lineupTemplate,
	        participant: activeParticipants[mapPitchPos[position]]
	    };
	}, { setParticipantPitch: _actions.setParticipantPitch, setParticipantCustomName: _actions.setParticipantCustomName, setParticipantCustomText: _actions.setParticipantCustomText })(ItemPitch);

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 25px;\n    margin: 0;\n    padding: 0 2px;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 700;\n    border: none;\n    background-color: #005caa;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n    color: #fff;\n    transition: all 0.2s ease;\n\n    :focus {\n        outline: none;\n        background-color: #013663;\n    }\n\n    ::-webkit-input-placeholder {\n        color: #fff;\n    }\n\n    ::-moz-placeholder {\n        color: #fff;\n    }\n\n    :-ms-input-placeholder {\n        color: #fff;\n    }\n\n    :-moz-placeholder {\n        color: #fff;\n    }\n\n    ', ';\n\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n'], ['\n    width: 100%;\n    height: 25px;\n    margin: 0;\n    padding: 0 2px;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 700;\n    border: none;\n    background-color: #005caa;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n    color: #fff;\n    transition: all 0.2s ease;\n\n    :focus {\n        outline: none;\n        background-color: #013663;\n    }\n\n    ::-webkit-input-placeholder {\n        color: #fff;\n    }\n\n    ::-moz-placeholder {\n        color: #fff;\n    }\n\n    :-ms-input-placeholder {\n        color: #fff;\n    }\n\n    :-moz-placeholder {\n        color: #fff;\n    }\n\n    ', ';\n\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var scaleFontSize = function scaleFontSize(value) {
	    var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
	
	    if (value.length < 13) return 'font-size: ' + defaultSize + 'px;';
	    var size = defaultSize - (value.length - 12 + 1);
	
	    return 'font-size: ' + (size >= 12 ? size : 12) + 'px;';
	};
	
	var TextInputTop = _styledComponents2.default.input(_templateObject, function (_ref) {
	    var typeStyle = _ref.typeStyle;
	    return typeStyle === 'bottom' && '\n        background-color: rgba(0, 0, 0, 0.5);\n\n        :focus {\n            background-color: #000;\n        }\n    ';
	}, function (_ref2) {
	    var value = _ref2.value;
	    return scaleFontSize(value, 18);
	}, function (_ref3) {
	    var lineupType = _ref3.lineupType,
	        value = _ref3.value;
	    return lineupType === 'grid' && 'height: 30px; ' + scaleFontSize(value, 18) + ' line-height: 30px;';
	}, function (_ref4) {
	    var large = _ref4.large,
	        value = _ref4.value;
	    return large && 'height: 36px; ' + scaleFontSize(value, 22) + ' line-height: 36px;';
	}, function (_ref5) {
	    var typeStyle = _ref5.typeStyle,
	        large = _ref5.large,
	        value = _ref5.value;
	    return typeStyle === 'bottom' && large && 'height: 30px; ' + scaleFontSize(value, 22) + ' line-height: 30px;';
	});
	
	var TextInput = function (_Component) {
	    _inherits(TextInput, _Component);
	
	    function TextInput() {
	        var _ref6;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TextInput);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
	            value: _this.props.text || ''
	        }, _this.changeTextHandler = function (event) {
	            _this.setState({
	                value: event.target.value
	            });
	        }, _this.blurTextHandler = function (event) {
	            _this.props.action(_this.props.id, event.target.value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TextInput, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.action(this.props.id, this.state.value);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref7) {
	            var nextText = _ref7.text;
	
	            if (nextText !== this.props.text) {
	                this.setState({
	                    value: nextText
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(TextInputTop, {
	                type: 'text',
	                typeStyle: this.props.type,
	                lineupType: this.props.lineupType,
	                large: this.props.large,
	                placeholder: 'Edit text...',
	                value: this.state.value,
	                onChange: this.changeTextHandler,
	                onBlur: this.blurTextHandler
	            });
	        }
	    }]);
	
	    return TextInput;
	}(_react.Component);
	
	TextInput.propTypes = {
	    id: _propTypes2.default.number.isRequired,
	    text: _propTypes2.default.string,
	    large: _propTypes2.default.bool,
	    type: _propTypes2.default.string,
	    lineupType: _propTypes2.default.string,
	    action: _propTypes2.default.func.isRequired
	};
	
	exports.default = TextInput;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PlayerRoundedPhoto = exports.PlayerLogoSPDKFace = exports.PlayerLogoPhoto = exports.PlayerLogoJersey = exports.PlayerLogo3DJerseyFront = exports.PlayerLogo3DJerseyBack = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 22%;\n    left: 50%;\n    line-height: 1;\n    font-family: ', ', sans-serif;\n    font-style: normal;\n    z-index: 1;\n    color: ', ';\n    text-shadow: ', ';\n    transform: translate(-50%, 0%);\n    font-size: ', 'px;\n    ', ';\n    font-weight: normal;\n'], ['\n    position: absolute;\n    top: 22%;\n    left: 50%;\n    line-height: 1;\n    font-family: ', ', sans-serif;\n    font-style: normal;\n    z-index: 1;\n    color: ', ';\n    text-shadow: ', ';\n    transform: translate(-50%, 0%);\n    font-size: ', 'px;\n    ', ';\n    font-weight: normal;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 16%;\n    left: 20%;\n    right: 20%;\n    line-height: 1;\n    font-family: ', ', sans-serif;\n    font-style: normal;\n\n    z-index: 1;\n    color: ', ';\n    text-shadow: ', ';\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ', 'px;\n    line-height: 1em;\n    text-align: center;\n    font-weight: normal;\n'], ['\n    position: absolute;\n    top: 16%;\n    left: 20%;\n    right: 20%;\n    line-height: 1;\n    font-family: ', ', sans-serif;\n    font-style: normal;\n\n    z-index: 1;\n    color: ', ';\n    text-shadow: ', ';\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ', 'px;\n    line-height: 1em;\n    text-align: center;\n    font-weight: normal;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ';\n\n    ', ';\n'], ['\n    ', ';\n\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _TeamColorProfile = __webpack_require__(1361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// import ReactDOM from 'react-dom';
	
	// import { getDisplayName } from 'recompose';
	
	
	var PlayerShirtNumber = _styledComponents2.default.span(_templateObject, function (props) {
	    return props.theme.shirtNumbersFontFamily;
	}, function (props) {
	    return props.is3d ? (0, _TeamColorProfile.colorForTeam)(props.teamId, props.isGK ? 'gkShirtNumber' : 'shirtNumber') : '#fff';
	}, function (props) {
	    return props.is3d ? '' : '0px 0px 1px black';
	}, function (props) {
	    return props.size * 0.53125 || 18;
	}, function (props) {
	    return props.smallNumber && 'font-size: 18px;';
	});
	
	var NameOnShirt = _styledComponents2.default.span(_templateObject2, function (props) {
	    return props.theme.shirtNumbersFontFamily;
	}, function (props) {
	    return props.is3d ? (0, _TeamColorProfile.colorForTeam)(props.teamId, props.isGK ? 'gkShirtNumber' : 'shirtNumber') : '#fff';
	}, function (props) {
	    return props.is3d ? '' : '0px 0px 1px black';
	}, function (props) {
	    return props.size / 300 * 28;
	});
	
	var PL = _styledComponents2.default.span(_templateObject3, function (_ref) {
	    var resetImageWrapStyle = _ref.resetImageWrapStyle;
	    return !resetImageWrapStyle ? 'position: relative; display: inline-block;' : '';
	}, function (_ref2) {
	    var cropLogo = _ref2.cropLogo,
	        height = _ref2.height;
	    return cropLogo ? '\n        > span:nth-child(1) {\n             display: inline-block;\n             height: ' + height + 'px;\n             max-width: ' + height + 'px;\n             overflow: hidden;\n\n             .wdp-sm-plr-logo_image {\n                height: calc(' + height + 'px + 40px);\n                margin-left: 50%;\n                transform: translateX(-50%);\n             }\n        }\n    ' : '';
	});
	
	var PlayerLogo = function (_React$Component) {
	    _inherits(PlayerLogo, _React$Component);
	
	    function PlayerLogo(props) {
	        _classCallCheck(this, PlayerLogo);
	
	        var _this = _possibleConstructorReturn(this, (PlayerLogo.__proto__ || Object.getPrototypeOf(PlayerLogo)).call(this, props));
	
	        _this.getPlrImageSrc = function (playerId, teamId, seasonId, size) {
	            var client = _this.context && _this.context.info && _this.context.info.client;
	            var url = void 0;
	
	            switch (size) {
	                case 'big':
	                    url = _RCore2.default.imageUrls.getPlayerImgBig(teamId, playerId, seasonId);
	                    break;
	                case 'large':
	                    url = _RCore2.default.imageUrls.getPlayerLargeImg(teamId, playerId, seasonId);
	                    break;
	                case 'original':
	                    url = _RCore2.default.imageUrls.getPlayerImgOriginal(teamId, playerId, seasonId);
	                    break;
	                default:
	                    url = _RCore2.default.imageUrls.getPlayerImg(teamId, playerId, seasonId);
	                    break;
	            }
	            // make bucket support
	            if (client === 'spdk') {
	                url = url.replace(/\/wdp\//, '/spdk/');
	            }
	
	            return url;
	        };
	
	        _this.showClubsJerseys = function (playerId, teamId) {
	            var width = 120;
	            var height = 120;
	            return 'https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_' + teamId + '.png&width-px=' + width + '&height-px=' + height + '&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png';
	        };
	
	        return _this;
	    }
	
	    _createClass(PlayerLogo, [{
	        key: 'getPlrLogoSrc',
	        value: function getPlrLogoSrc(playerId, teamId, seasonId, size, isGK, isCoach) {
	            switch (this.getDisplayType()) {
	                case '3d_jersey_back':
	                case '3d_jersey_front':
	                    return isCoach ? 'https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/coach.svg' : 'https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/ic_' + (isGK ? 'gk_' : '') + 'shirt_' + teamId + '.svg';
	                case 'jersey':
	                    return this.showClubsJerseys(playerId, teamId, size, isGK);
	                case 'image':
	                    return this.getPlrImageSrc(playerId, teamId, seasonId, size);
	                default:
	                    return this.showClubsJerseys(playerId, teamId, size, isGK);
	            }
	        }
	    }, {
	        key: 'getDisplayType',
	        value: function getDisplayType() {
	            var seasonId = this.props.seasonId;
	            //If we do not have players images on CDN, show jersey
	            // fallback if there is no player images
	
	            if (this.props.display === 'image' && !_RCore2.default.hasCDNPlayerLogos(seasonId, this.context.info && this.context.info.client)) {
	                return '3d_jersey_front';
	            }
	
	            return this.props.display || 'jersey';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                playerId = _props.playerId,
	                teamId = _props.teamId,
	                seasonId = _props.seasonId,
	                isGK = _props.isGK,
	                isCoach = _props.isCoach,
	                size = _props.size,
	                height = _props.height,
	                width = _props.width,
	                spdk = _props.spdk,
	                _props$number = _props.number,
	                number = _props$number === undefined ? null : _props$number,
	                positionEnetType = _props.positionEnetType,
	                _props$resetImageWrap = _props.resetImageWrapStyle,
	                resetImageWrapStyle = _props$resetImageWrap === undefined ? false : _props$resetImageWrap,
	                _props$imageWrapStyle = _props.imageWrapStyle,
	                imageWrapStyle = _props$imageWrapStyle === undefined ? {} : _props$imageWrapStyle,
	                _props$style = _props.style,
	                style = _props$style === undefined ? {} : _props$style,
	                nameOnShirt = _props.nameOnShirt,
	                rounded = _props.rounded,
	                cropLogo = _props.cropLogo,
	                nameOnShirt3dJerseySize = _props.nameOnShirt3dJerseySize;
	
	            // var screenSize = this.context.screenSizeObserver.screenSize
	
	            if (this.context.plrLogoSettings && this.context.plrLogoSettings.display === 'none') return _react2.default.createElement('span', { className: 'wdp-sm-plr-logo__none' });
	            var imageClasses = (0, _classnames2.default)('wdp-sm-plr-logo', 'wdp-sm-plr-logo_' + this.getDisplayType(), 'wdp-sm-plr-logo_' + size);
	
	            var stylesString = _RCore2.default.stylesObjectToString(_extends({
	                objectFit: !rounded ? 'contain' : 'cover',
	                marginBottom: spdk ? '-38%' : '0'
	            }, style));
	
	            isGK = isGK || positionEnetType === 1;
	            var displayType = this.getDisplayType();
	            var showNumber = ['3d_jersey_front', '3d_jersey_back', 'jersey'].includes(displayType);
	            var smallNumber = displayType === 'jersey';
	            var is3d = ['3d_jersey_front', '3d_jersey_back'].includes(displayType);
	
	            // for rounded img
	            var roundedImgSize = width || height;
	            width = !rounded ? width : roundedImgSize;
	
	            var imageRoundStyles = rounded ? {
	                minWidth: roundedImgSize + 'px',
	                maxWidth: roundedImgSize + 'px',
	                height: roundedImgSize + 'px',
	                overflow: 'hidden',
	                borderRadius: '50%'
	            } : {};
	
	            var imageSpdkFaceSpan = spdk ? {
	                display: 'inline-block',
	                overflow: 'hidden'
	            } : {};
	
	            return _react2.default.createElement(
	                PL,
	                {
	                    className: [this.props.className, displayType].join(' '),
	                    is3d: is3d,
	                    style: _extends({}, imageWrapStyle, imageRoundStyles),
	                    resetImageWrapStyle: resetImageWrapStyle,
	                    cropLogo: cropLogo,
	                    height: height
	                },
	                _react2.default.createElement('span', {
	                    style: _extends({}, imageSpdkFaceSpan),
	                    dangerouslySetInnerHTML: {
	                        __html: '<img style="' + stylesString + '" width="' + (width || 'auto') + '" height="' + (height || 'auto') + '" class="' + imageClasses + ' ' + (spdk ? 'wdp-sm-plr-logo-spdk' : ' ') + ' ' + (rounded ? 'wdp-sm-plr-logo-rounded' : ' ') + '" onerror="this.onerror=null;this.src = \'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_unknown.svg\'" src=\'' + this.getPlrLogoSrc(playerId, teamId, seasonId, size, isGK, isCoach) + '?a=2\' draggable=\'false\'/>'
	                    }
	                }),
	                _react2.default.createElement(
	                    PlayerShirtNumber,
	                    {
	                        className: 'player-shirt-number',
	                        is3d: is3d,
	                        size: nameOnShirt3dJerseySize || _lodash2.default.chain([+height, +width]).compact().first().value(),
	                        isGK: isGK,
	                        teamId: teamId,
	                        smallNumber: smallNumber
	                    },
	                    showNumber && number
	                ),
	                is3d && nameOnShirt && _react2.default.createElement(
	                    NameOnShirt,
	                    {
	                        className: 'mame-on-shirt-number',
	                        is3d: true,
	                        size: nameOnShirt3dJerseySize || _lodash2.default.chain([+height, +width]).compact().first().value(),
	                        isGK: isGK,
	                        teamId: teamId,
	                        smallNumber: smallNumber
	                    },
	                    nameOnShirt
	                )
	            );
	        }
	    }]);
	
	    return PlayerLogo;
	}(_react2.default.Component);
	
	PlayerLogo.defaultProps = {
	    size: 'medium',
	    jerseys: false,
	
	    displayTypes: ['none', 'image', 'jersey']
	};
	PlayerLogo.contextTypes = {
	    info: _propTypes2.default.object,
	    plrLogoSettings: _propTypes2.default.object
	};
	
	PlayerLogo.spec = {
	    propType: {
	        key: 'plrImage',
	        type: 'select_picker',
	        label: 'Player image',
	        options: [{
	            text: 'None',
	            value: 'none'
	        }, {
	            text: 'Jersey',
	            value: 'jersey'
	        }, {
	            text: 'Image',
	            value: 'image'
	        }]
	    }
	};
	
	var PlayerLogo3DJerseyBack = function PlayerLogo3DJerseyBack(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: '3d_jersey_back' }));
	};
	var PlayerLogo3DJerseyFront = function PlayerLogo3DJerseyFront(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: '3d_jersey_front' }));
	};
	var PlayerLogoJersey = function PlayerLogoJersey(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: 'jersey' }));
	};
	var PlayerLogoPhoto = function PlayerLogoPhoto(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: 'image' }));
	};
	var PlayerLogoSPDKFace = function PlayerLogoSPDKFace(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: 'image', spdk: true }));
	};
	var PlayerRoundedPhoto = function PlayerRoundedPhoto(props) {
	    return _react2.default.createElement(PlayerLogo, _extends({}, props, { display: 'image', rounded: true }));
	};
	
	exports.default = PlayerLogo;
	exports.PlayerLogo3DJerseyBack = PlayerLogo3DJerseyBack;
	exports.PlayerLogo3DJerseyFront = PlayerLogo3DJerseyFront;
	exports.PlayerLogoJersey = PlayerLogoJersey;
	exports.PlayerLogoPhoto = PlayerLogoPhoto;
	exports.PlayerLogoSPDKFace = PlayerLogoSPDKFace;
	exports.PlayerRoundedPhoto = PlayerRoundedPhoto;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TeamLogoEmpty = exports.TeamLogo = exports.TeamLogoBlank = exports.options = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: inline-block;\n    position: relative;\n    img {\n        object-fit: contain;\n        opacity: ', ';\n    }\n'], ['\n    display: inline-block;\n    position: relative;\n    img {\n        object-fit: contain;\n        opacity: ', ';\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // main.js
	
	
	var Logo = _styledComponents2.default.span(_templateObject, function (props) {
	    return props.theme.teamLogo === 'transparent' ? 0 : 1;
	});
	
	var TeamLogo = function (_React$Component) {
	    _inherits(TeamLogo, _React$Component);
	
	    function TeamLogo(props) {
	        _classCallCheck(this, TeamLogo);
	
	        var _this = _possibleConstructorReturn(this, (TeamLogo.__proto__ || Object.getPrototypeOf(TeamLogo)).call(this, props));
	
	        _this.showTeamLogo = function (teamId, size) {
	            var sizeFolder = '256x256';
	            return 'https://dxugi372p6nmc.cloudfront.net/wdp/current/' + sizeFolder + '/' + teamId + '/teamlogo.png';
	        };
	
	        _this.showClubsJerseys = function (teamId) {
	            var width = 120;
	            var height = 120;
	            return 'https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_' + teamId + '.png&width-px=' + width + '&height-px=' + height + '&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png';
	        };
	
	        _this.showTeamSVGLogo = function (teamId) {
	            return 'https://dxugi372p6nmc.cloudfront.net/wdp/teams/svg/' + teamId + '.svg';
	        };
	
	        return _this;
	    }
	
	    _createClass(TeamLogo, [{
	        key: 'getDisplay',
	        value: function getDisplay() {
	            if (this.props.jerseys) {
	                return 'jersey';
	            }
	
	            var tournamentId = this.props.tournamentId;
	
	            //If we do not have players images on CDN, show jersey
	
	            if (tournamentId && !_RCore2.default.hasCDNClubLogos(tournamentId)) return 'jersey';
	
	            return this.props.display || this.context.teamLogoSettings.display || 'none';
	        }
	    }, {
	        key: 'getTeamLogoSrc',
	        value: function getTeamLogoSrc(teamId, size) {
	            var teamLogo = this.props.theme.teamLogo;
	
	
	            switch (teamLogo) {
	                case 'jersey':
	                    return this.showClubsJerseys(teamId);
	                case 'logo':
	                    return this.showTeamLogo(teamId, size);
	                case 'empty':
	                    return this.showTeamLogo(teamId, size);
	                case 'transparent':
	                    return this.showTeamLogo(teamId, size);
	                case '3d_jersey':
	                    return 'https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/ic_shirt_' + teamId + '.svg';
	                // return `https://dxugi372p6nmc.cloudfront.net/wdp/current/shirts/ic_shirt_${teamId}.svg`;
	                default:
	                    return this.showClubsJerseys(teamId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                teamId = _props.teamId,
	                name = _props.name,
	                width = _props.width,
	                height = _props.height,
	                _props$theme = _props.theme,
	                theme = _props$theme === undefined ? {} : _props$theme,
	                fontSize = _props.fontSize,
	                _props$style = _props.style,
	                style = _props$style === undefined ? {} : _props$style,
	                teamShortName = _props.teamShortName,
	                className = _props.className,
	                lineHeight = _props.lineHeight,
	                rest = _objectWithoutProperties(_props, ['teamId', 'name', 'width', 'height', 'theme', 'fontSize', 'style', 'teamShortName', 'className', 'lineHeight']);
	
	            if (!teamId || theme.teamLogo === 'empty') return _react2.default.createElement('span', null);
	            if (theme.teamLogo === 'short_name') return _react2.default.createElement(
	                'span',
	                {
	                    className: className + ' wdp-team-logo-name',
	                    style: _extends({
	                        lineHeight: (lineHeight || height || width || 40) + 'px',
	                        fontSize: (fontSize || (height || width || 40) * 0.7) + 'px',
	                        fontWeight: 'bold',
	                        position: 'relative'
	                    }, style)
	                },
	                teamShortName
	            );
	
	            var stylesString = _RCore2.default.stylesObjectToString(style);
	
	            //     <img
	            //     style={this.props.style}
	            //     width={width}
	            //     height={height}
	            //     className="wdp-team-logo"
	            //     src={this.getTeamLogoSrc(teamId)}
	
	            // />
	            return _react2.default.createElement(Logo, {
	                className: className,
	                dangerouslySetInnerHTML: {
	                    __html: '<img style="' + stylesString + '" width="' + (width || 'auto') + '"\n                    class="wdp-team-logo"\n                    height="' + (height || 'auto') + '" onerror="this.onerror=null;this.src = \'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_unknown.svg\'"\n                    src=\'' + this.getTeamLogoSrc(teamId) + '?a=' + new Date().getTime() + '\'/>'
	                }
	            });
	        }
	    }]);
	
	    return TeamLogo;
	}(_react2.default.Component);
	
	TeamLogo.defaultProps = {
	    size: 'medium',
	    jerseys: false,
	    displayTypes: ['none', 'logo', 'jersey', 'svg'],
	    theme: {
	        teamLogo: 'logo'
	    }
	};
	TeamLogo.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	
	var TeamLogoBlank = function TeamLogoBlank(props) {
	    return _react2.default.createElement(TeamLogo, _extends({}, props, { display: '3d_jersey_back' }));
	};
	var TeamLogoEmpty = function TeamLogoEmpty(props) {
	    return;
	};
	
	var options = ['logo', 'jersey', 'empty', 'transparent', 'short_name', '3d_jersey'];
	
	exports.default = (0, _styledComponents.withTheme)(TeamLogo);
	exports.options = options;
	exports.TeamLogoBlank = TeamLogoBlank;
	exports.TeamLogo = TeamLogo;
	exports.TeamLogoEmpty = TeamLogoEmpty;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PitchSVG(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? '#fff' : _ref$color,
	        _ref$background = _ref.background,
	        background = _ref$background === undefined ? '#ecedea' : _ref$background;
	
	    return _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', width: width || null, height: height || null, viewBox: '0 0 950 1172' },
	        _react2.default.createElement(
	            'g',
	            { fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement('path', { fill: background, d: 'M125.0435 0h699.0469l125.0435 1171.1106H0z' }),
	            _react2.default.createElement(
	                'g',
	                { fill: color, opacity: '.8', transform: 'translate(13.6675 8.077)' },
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M.3428 1142.7719l.367-3.8399L117.9987 1.0505h684.958l117.6518 1141.7214H.3428zm915.5236-6.6434L800.4007 3.5798H120.5546L5.0848 1136.1285h910.7816z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M353.1158 504.9818c0-49.5178 48.1533-88.8987 107.3417-88.8987 59.1885 0 107.3417 39.3809 107.3417 88.8987 0 49.5179-48.1532 89.8038-107.3417 89.8038-59.1884 0-107.3417-40.286-107.3417-89.8038zm2.6502 0c0 47.3356 46.9633 85.8433 104.6915 85.8433 57.7283 0 104.6916-38.5096 104.6916-85.8433 0-47.3336-46.9647-85.8433-104.6916-85.8433-57.7269 0-104.6915 38.5077-104.6915 85.8433z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M850.9507 498.3473H70.1262v-3.4398h780.8245zM540.9788 38.6699H382.5026l2.0207-35.8764 1.9625-.0323-1.3027 33.6129h153.1167l-1.3041-33.6129 1.9624.0323z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M294.211 107.8571L304.459 2.8296l2.8856-.1045-9.5917 102.3059h328.8244L616.9871 2.7251l2.8856.1045 10.2466 105.0275z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M418.3927 107.7734l2.3775-.8396c6.053 13.6747 22.6483 22.8617 41.2936 22.8617 18.6452 0 35.239-9.1846 41.2906-22.8569l2.3775.8396c-6.5759 14.8604-24.1256 24.8434-43.6681 24.8434-19.5425 0-37.0938-9.9855-43.671-24.8482zM118.3482 12.5157l-.6038-1.5932c2.7153-.0139 5.3399.0517 8.502-2.2458 3.1623-2.2975 4.5222-3.884 4.824-7.3192l1.4349.5207c-.3598 3.4338-1.4353 5.451-4.7497 7.8591-3.3144 2.408-6.5007 2.851-9.4074 2.7784zM802.7156 13.0324l.6038-1.5932c-2.7154-.014-5.3399.0516-8.502-2.2459-3.1623-2.2974-4.5222-3.884-4.824-7.3192l-1.4349.5207c.3598 3.4339 1.4353 5.4511 4.7497 7.8591 3.3144 2.408 6.5007 2.851 9.4074 2.7785zM343.3626 1138.0777l3.1239-65.7603h230.7632l3.1224 65.7603-2.9186.9639-2.7053-63.6604H348.9895l-2.7082 63.6604z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M220.1045 1138.1154l12.4168-189.867h459.9081l11.8044 189.8844-2.9275.8507-11.4287-187.6712H235.0583l-12.0292 187.6887z'
	                }),
	                _react2.default.createElement('path', {
	                    fillRule: 'nonzero',
	                    d: 'M462.3274 906.515c-26.5519 0-50.7414 19.2641-56.2636 44.8055l-2.7249-2.2676c5.9601-27.5592 31.3197-45.599 58.9885-45.599 27.6925 0 53.0551 18.063 58.996 45.6513l-2.725 2.2588c-5.5059-25.5704-29.6968-44.849-56.271-44.849z'
	                }),
	                _react2.default.createElement('ellipse', { cx: '462.1992', cy: '73.6411', rx: '2.2859', ry: '2.4082' }),
	                _react2.default.createElement('ellipse', { cx: '462.1992', cy: '496.5161', rx: '4.1145', ry: '4.3347' })
	            )
	        )
	    );
	}
	
	PitchSVG.propTypes = {
	    width: _propTypes2.default.string,
	    height: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    background: _propTypes2.default.string
	};
	
	exports.default = PitchSVG;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lineUpTemplateDefault = '1-4-4-2';
	var lineUpTemplates = ['1-5-4-1', '1-5-3-2', '1-4-4-2', '1-4-3-3', '1-3-4-3', '1-3-5-2', '1-4-5-1'];
	
	var gridTemplateDefault = '3-3-3';
	var gridTemplates = [{ type: '3', name: '3x1' }, { type: '3-3', name: '3x2' }, { type: '3-3-3', name: '3x3' }, { type: '4-4-4', name: '4x3' }];
	
	var typeSelectStyle = {
	    marginRight: '10px'
	};
	
	var SelectLineUp = function (_Component) {
	    _inherits(SelectLineUp, _Component);
	
	    function SelectLineUp() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SelectLineUp);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectLineUp.__proto__ || Object.getPrototypeOf(SelectLineUp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            type: localStorage.getItem('selectLineUpType') || 'lineup',
	            value: _this.props.lineupTemplate || localStorage.getItem('selectLineUpValue') || lineUpTemplates[0]
	        }, _this.handleChangeType = function (event, index, type) {
	            event.preventDefault();
	            var value = type === 'lineup' ? lineUpTemplateDefault : gridTemplateDefault;
	
	            _this.setState({ type: type, value: value });
	
	            _this.props.setLineupType(type);
	            _this.props.setLineupTemplate(value);
	
	            localStorage.setItem('selectLineUpType', type);
	            localStorage.setItem('selectLineUpValue', value);
	        }, _this.handleChange = function (event, index, value) {
	            event.preventDefault();
	            _this.setState({ value: value });
	            _this.props.setLineupTemplate(value);
	            localStorage.setItem('selectLineUpValue', value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SelectLineUp, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setLineupType(this.state.type);
	            this.props.setLineupTemplate(this.state.value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                type = _state.type,
	                value = _state.value;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _SelectField2.default,
	                    {
	                        floatingLabelText: 'Type Template',
	                        value: type,
	                        onChange: this.handleChangeType,
	                        style: typeSelectStyle
	                    },
	                    _react2.default.createElement(_MenuItem2.default, { value: 'lineup', primaryText: 'LineUp' }),
	                    _react2.default.createElement(_MenuItem2.default, { value: 'grid', primaryText: 'Grid' })
	                ),
	                type === 'lineup' && _react2.default.createElement(
	                    _SelectField2.default,
	                    { floatingLabelText: 'LineUp Template', value: value, onChange: this.handleChange },
	                    lineUpTemplates.map(function (template) {
	                        return _react2.default.createElement(_MenuItem2.default, { key: template, value: template, primaryText: template.slice(2) });
	                    })
	                ),
	                type === 'grid' && _react2.default.createElement(
	                    _SelectField2.default,
	                    { floatingLabelText: 'Grid Template', value: value, onChange: this.handleChange },
	                    gridTemplates.map(function (template) {
	                        return _react2.default.createElement(_MenuItem2.default, { key: template.name, value: template.type, primaryText: template.name });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SelectLineUp;
	}(_react.Component);
	
	SelectLineUp.propTypes = {
	    // From connect
	    lineupType: _propTypes2.default.string.isRequired,
	    lineupTemplate: _propTypes2.default.string.isRequired,
	    setLineupTemplate: _propTypes2.default.func.isRequired,
	    setLineupType: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var makerToolPage = _ref2.makerToolPage;
	    return {
	        lineupType: makerToolPage.lineupType,
	        lineupTemplate: makerToolPage.lineupTemplate
	    };
	}, { setLineupTemplate: _actions.setLineupTemplate, setLineupType: _actions.setLineupType })(SelectLineUp);

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    text-transform: uppercase;\n    border: 2px dashed #a5a5a55e;\n    background-color: #fff;\n    transition: all 0.2s ease;\n    ', ';\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    text-transform: uppercase;\n    border: 2px dashed #a5a5a55e;\n    background-color: #fff;\n    transition: all 0.2s ease;\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropArea = _styledComponents2.default.div(_templateObject, function (_ref) {
	    var isHover = _ref.isHover;
	    return isHover && 'background: #d3d3d32e; border-color: #a5a5a5b0;';
	});
	
	var DeleteArea = function (_Component) {
	    _inherits(DeleteArea, _Component);
	
	    function DeleteArea() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DeleteArea);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DeleteArea.__proto__ || Object.getPrototypeOf(DeleteArea)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	            isHover: false
	        }, _this.drop = function (event) {
	            var position = event.dataTransfer.getData('position');
	
	            if (position) {
	                _this.props.deleteParticipantPitch(position);
	                event.dataTransfer.clearData();
	            }
	
	            _this.setState({
	                isHover: false
	            });
	        }, _this.dragOver = function (event) {
	            event.preventDefault();
	
	            if (!_this.state.isHover) {
	                _this.setState({ isHover: true });
	            }
	        }, _this.dragLeave = function (event) {
	            event.preventDefault();
	
	            if (_this.state.isHover) {
	                _this.setState({
	                    isHover: false
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DeleteArea, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                DropArea,
	                {
	                    onDrop: this.drop,
	                    onDragOver: this.dragOver,
	                    onDragLeave: this.dragLeave,
	                    isHover: this.state.isHover
	                },
	                'drop here',
	                _react2.default.createElement('br', null),
	                'to delete'
	            );
	        }
	    }]);
	
	    return DeleteArea;
	}(_react.Component);
	
	DeleteArea.propTypes = {
	    // From connect
	    deleteParticipantPitch: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { deleteParticipantPitch: _actions.deleteParticipantPitch })(DeleteArea);

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: 308px;\n    padding-left: 16px;\n'], ['\n    width: 308px;\n    padding-left: 16px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin-bottom: 14px;\n'], ['\n    margin-bottom: 14px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FieldTournamentId = __webpack_require__(1399);
	
	var _FieldTournamentId2 = _interopRequireDefault(_FieldTournamentId);
	
	var _SearchInput = __webpack_require__(1400);
	
	var _SearchInput2 = _interopRequireDefault(_SearchInput);
	
	var _TabsParticipants = __webpack_require__(1401);
	
	var _TabsParticipants2 = _interopRequireDefault(_TabsParticipants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.article(_templateObject);
	
	var Header = _styledComponents2.default.header(_templateObject2);
	
	function ParticipantsPicker() {
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	            Header,
	            null,
	            _react2.default.createElement(_FieldTournamentId2.default, null),
	            _react2.default.createElement(_SearchInput2.default, null)
	        ),
	        _react2.default.createElement(_TabsParticipants2.default, null)
	    );
	}
	
	exports.default = ParticipantsPicker;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldTournamentId = function (_Component) {
	    _inherits(FieldTournamentId, _Component);
	
	    function FieldTournamentId() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FieldTournamentId);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FieldTournamentId.__proto__ || Object.getPrototypeOf(FieldTournamentId)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            ttId: new URL(location.href).searchParams.get('ttId') || localStorage.getItem('ttId') || ''
	        }, _this.loadData = function () {
	            var ttId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            if (ttId) {
	                var _this$props = _this.props,
	                    _fetchPlayers = _this$props.fetchPlayers,
	                    _fetchTeams = _this$props.fetchTeams;
	
	
	                _fetchPlayers(ttId);
	                _fetchTeams(ttId);
	                localStorage.setItem('ttId', ttId);
	                var idLineUp = new URL(location.href).searchParams.get('idLineUp');
	                history.pushState({}, '', '?ttId=' + ttId + (idLineUp ? '&idLineUp=' + idLineUp : ''));
	            }
	        }, _this.handleChange = function (ev, index) {
	            var ttId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	            ev.preventDefault();
	            _this.loadData(ttId);
	            _this.setState({ ttId: ttId });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FieldTournamentId, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchTournaments();
	            this.loadData(this.state.ttId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$tournamentsLis = _props.tournamentsList,
	                tournamentsList = _props$tournamentsLis === undefined ? [] : _props$tournamentsLis,
	                _props$tournaments = _props.tournaments,
	                tournaments = _props$tournaments === undefined ? {} : _props$tournaments;
	            var _state$ttId = this.state.ttId,
	                ttId = _state$ttId === undefined ? '' : _state$ttId;
	
	
	            return _react2.default.createElement(
	                _SelectField2.default,
	                {
	                    floatingLabelText: 'Tournament',
	                    value: parseInt(ttId, 10),
	                    onChange: this.handleChange,
	                    fullWidth: true
	                },
	                tournamentsList.map(function (id) {
	                    return _react2.default.createElement(_MenuItem2.default, {
	                        key: id,
	                        value: id,
	                        primaryText: tournaments[id] && tournaments[id].countryName + ' | ' + tournaments[id].name
	                    });
	                })
	            );
	        }
	    }]);
	
	    return FieldTournamentId;
	}(_react.Component);
	
	FieldTournamentId.propTypes = {
	    // From connect
	    tournaments: _propTypes2.default.object,
	    tournamentsList: _propTypes2.default.arrayOf(_propTypes2.default.number.isRequired),
	    fetchTournaments: _propTypes2.default.func.isRequired,
	    fetchPlayers: _propTypes2.default.func.isRequired,
	    fetchTeams: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { entities: {}, list: {} } : _ref2$requery;
	    return {
	        tournaments: requery.entities && requery.entities.tournaments,
	        tournamentsList: requery.list.tournaments
	    };
	}, { fetchTournaments: _actions.fetchTournaments, fetchPlayers: _actions.fetchPlayers, fetchTeams: _actions.fetchTeams })(FieldTournamentId);

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(635);
	
	var _reactRedux = __webpack_require__(250);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchInput(_ref) {
	    var searchInputText = _ref.searchInputText;
	
	    return _react2.default.createElement(_TextField2.default, {
	        fullWidth: true,
	        hintText: 'Name...',
	        floatingLabelText: 'Search:',
	        onChange: function onChange(ev, newValue) {
	            return searchInputText(newValue);
	        }
	    });
	}
	
	SearchInput.propTypes = {
	    // From connect
	    searchInputText: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { searchInputText: _actions.searchInputText })(SearchInput);

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(817);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Tabs = __webpack_require__(983);
	
	var _ItemParticipant = __webpack_require__(1402);
	
	var _ItemParticipant2 = _interopRequireDefault(_ItemParticipant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabsStyle = {
	    height: '671px',
	    overflow: 'hidden',
	    borderBottom: '1px solid #e0e0e0'
	};
	
	var ListStyle = {
	    height: '623px',
	    maxHeight: '100%',
	    overflowY: 'auto',
	    borderRight: '1px solid #e0e0e0',
	    borderBottom: '1px solid #e0e0e0',
	    borderLeft: '1px solid #e0e0e0'
	};
	
	var TabsParticipants = function (_Component) {
	    _inherits(TabsParticipants, _Component);
	
	    function TabsParticipants() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TabsParticipants);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabsParticipants.__proto__ || Object.getPrototypeOf(TabsParticipants)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeTab: 'players'
	        }, _this.handleChange = function (activeTab) {
	            _this.setState({ activeTab: activeTab });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TabsParticipants, [{
	        key: 'render',
	        value: function render() {
	            var activeTab = this.state.activeTab;
	            var _props = this.props,
	                _props$playerList = _props.playerList,
	                playerList = _props$playerList === undefined ? [] : _props$playerList,
	                _props$teamList = _props.teamList,
	                teamList = _props$teamList === undefined ? [] : _props$teamList;
	
	
	            return _react2.default.createElement(
	                _Tabs.Tabs,
	                { value: activeTab, onChange: this.handleChange, style: TabsStyle },
	                _react2.default.createElement(
	                    _Tabs.Tab,
	                    { label: 'Players', value: 'players' },
	                    _react2.default.createElement(
	                        _List2.default,
	                        { style: ListStyle },
	                        playerList.map(function (id) {
	                            return _react2.default.createElement(_ItemParticipant2.default, { key: id, id: id, type: 'players' });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Tabs.Tab,
	                    { label: 'Teams', value: 'teams' },
	                    _react2.default.createElement(
	                        _List2.default,
	                        { style: ListStyle },
	                        teamList.map(function (id) {
	                            return _react2.default.createElement(_ItemParticipant2.default, { key: id, id: id, type: 'teams' });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TabsParticipants;
	}(_react.Component);
	
	TabsParticipants.propTypes = {
	    // From connect
	    playerList: _propTypes2.default.arrayOf(_propTypes2.default.number.isRequired),
	    teamList: _propTypes2.default.arrayOf(_propTypes2.default.number.isRequired)
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { list: {} } : _ref2$requery;
	    return {
	        playerList: requery.list.players,
	        teamList: requery.list.teams
	    };
	})(TabsParticipants);

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    border-bottom: 1px solid rgb(224, 224, 224);\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    :focus,\n    :hover {\n        background: rgba(0, 0, 0, 0.1);\n    }\n'], ['\n    border-bottom: 1px solid rgb(224, 224, 224);\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    :focus,\n    :hover {\n        background: rgba(0, 0, 0, 0.1);\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(635);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	var _SMPlayerLogo2 = _interopRequireDefault(_SMPlayerLogo);
	
	var _ListItem = __webpack_require__(829);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Draggable = _styledComponents2.default.div(_templateObject);
	
	var ListItemStyle = {
	    pointerEvents: 'none',
	    cursor: 'pointer'
	};
	
	var ItemParticipant = function (_Component) {
	    _inherits(ItemParticipant, _Component);
	
	    function ItemParticipant() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ItemParticipant);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemParticipant.__proto__ || Object.getPrototypeOf(ItemParticipant)).call.apply(_ref, [this].concat(args))), _this), _this.dragStart = function (event) {
	            event.dataTransfer.setData('participant', JSON.stringify(_this.props.participant));
	        }, _this.drop = function (action) {
	            return function (event) {
	                var position = event.dataTransfer.getData('position');
	
	                if (position) {
	                    action(position);
	                    event.dataTransfer.clearData();
	                }
	            };
	        }, _this.dragEnd = function (event) {
	            event.dataTransfer.clearData();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ItemParticipant, [{
	        key: 'getAvatar',
	        value: function getAvatar() {
	            var _props = this.props,
	                id = _props.id,
	                type = _props.type,
	                participant = _props.participant;
	
	
	            switch (type) {
	                case 'players':
	                    return _react2.default.createElement(_SMPlayerLogo2.default, {
	                        teamId: participant.team ? participant.team.id : 0,
	                        playerId: id,
	                        seasonId: 'current',
	                        isGK: participant.position === 'keeper',
	                        size: 'original',
	                        width: 40,
	                        height: 40,
	                        resetImageWrapStyle: true
	                    });
	                case 'teams':
	                    return _react2.default.createElement(_SMTeamLogo2.default, { teamId: id, width: 40 });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                _props2$id = _props2.id,
	                id = _props2$id === undefined ? 0 : _props2$id,
	                _props2$participant = _props2.participant,
	                participant = _props2$participant === undefined ? {} : _props2$participant,
	                _props2$isDisplay = _props2.isDisplay,
	                isDisplay = _props2$isDisplay === undefined ? true : _props2$isDisplay,
	                isActive = _props2.isActive,
	                deleteParticipantPitch = _props2.deleteParticipantPitch;
	
	
	            return _react2.default.createElement(
	                Draggable,
	                {
	                    id: id,
	                    hidden: !isDisplay,
	                    draggable: true,
	                    onDrop: this.drop(deleteParticipantPitch),
	                    onDragStart: this.dragStart,
	                    onDragOver: function onDragOver(event) {
	                        return event.preventDefault();
	                    },
	                    onDragEnd: this.dragEnd
	                },
	                _react2.default.createElement(_ListItem2.default, {
	                    primaryText: participant.name,
	                    leftAvatar: this.getAvatar(),
	                    innerDivStyle: isActive ? { backgroundColor: 'rgba(0, 0, 0, 0.05)' } : {},
	                    style: ListItemStyle
	                    // nestedListStyle={ListItemStyle}
	                })
	            );
	        }
	    }]);
	
	    return ItemParticipant;
	}(_react.Component);
	
	ItemParticipant.propTypes = {
	    id: _propTypes2.default.number.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    // From connect
	    participant: _propTypes2.default.object.isRequired,
	    isDisplay: _propTypes2.default.bool.isRequired,
	    isActive: _propTypes2.default.bool,
	    deleteParticipantPitch: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2, _ref3) {
	    var _ref2$makerToolPage = _ref2.makerToolPage,
	        makerToolPage = _ref2$makerToolPage === undefined ? {} : _ref2$makerToolPage,
	        _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { entities: {} } : _ref2$requery;
	    var _ref3$id = _ref3.id,
	        id = _ref3$id === undefined ? 0 : _ref3$id,
	        _ref3$type = _ref3.type,
	        type = _ref3$type === undefined ? '' : _ref3$type;
	
	    var participant = requery.entities && requery.entities[type] && requery.entities[type][id];
	    var searchInputText = makerToolPage.searchInputText;
	
	    return {
	        participant: participant,
	        isDisplay: searchInputText ? participant.name.toLowerCase().includes(searchInputText.toLowerCase()) : true,
	        isActive: !!makerToolPage.activeParticipants[id]
	    };
	}, { postPackWidget: _actions.postPackWidget, deletePackWidget: _actions.deletePackWidget, deleteParticipantPitch: _actions.deleteParticipantPitch })(ItemParticipant);

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _TeamCustomSMWidget = __webpack_require__(1404);
	
	var _TeamCustomSMWidget2 = _interopRequireDefault(_TeamCustomSMWidget);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WidgetCustomLineUp(_ref) {
	    var _ref$user = _ref.user,
	        user = _ref$user === undefined ? '' : _ref$user,
	        _ref$client = _ref.client,
	        client = _ref$client === undefined ? '' : _ref$client,
	        _ref$lang = _ref.lang,
	        lang = _ref$lang === undefined ? 'en' : _ref$lang,
	        _ref$timezone = _ref.timezone,
	        timezone = _ref$timezone === undefined ? 'CET' : _ref$timezone,
	        idLineUp = _ref.idLineUp,
	        _ref$lineupType = _ref.lineupType,
	        lineupType = _ref$lineupType === undefined ? '' : _ref$lineupType,
	        _ref$players = _ref.players,
	        players = _ref$players === undefined ? [] : _ref$players;
	
	    return _react2.default.createElement(
	        _WDPContext2.default,
	        { token: 'etst', social: true, user: user, client: client },
	        _react2.default.createElement(_TeamCustomSMWidget2.default, {
	            title: 'Custom title',
	            subTitle: 'Description',
	            idLineUp: idLineUp,
	            type: lineupType,
	            players: players,
	            lang: lang,
	            tz: timezone,
	            template: localStorage.getItem('C_DEFAULT_TEMPLATE')
	        })
	    );
	}
	
	WidgetCustomLineUp.propTypes = {
	    user: _propTypes2.default.string,
	    client: _propTypes2.default.string.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    timezone: _propTypes2.default.string.isRequired,
	    idLineUp: _propTypes2.default.number.isRequired,
	    lineupType: _propTypes2.default.string.isRequired,
	    players: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var user = _ref2.user,
	        makerToolPage = _ref2.makerToolPage;
	    return {
	        user: user.username,
	        client: user.client,
	        lang: user.props && user.props.lang,
	        timezone: user.props && user.props.timezone,
	        idLineUp: makerToolPage.idLineUp,
	        lineupType: makerToolPage.lineupType,
	        players: makerToolPage.customPitchLineupList
	    };
	})(WidgetCustomLineUp);

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.i18 = exports.spec = exports.TeamCustomSMWidget = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 1;\n    padding: 9px 0;\n    overflow: hidden;\n    box-sizing: border-box;\n    margin: 0 -', 'px;\n    margin-bottom: -', '%;\n    transform-origin: top;\n    transform: scale(calc(1 - (((', '*2) * (100 / 800)) / 100)));\n'], ['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 1;\n    padding: 9px 0;\n    overflow: hidden;\n    box-sizing: border-box;\n    margin: 0 -', 'px;\n    margin-bottom: -', '%;\n    transform-origin: top;\n    transform: scale(calc(1 - (((', '*2) * (100 / 800)) / 100)));\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n    padding: 0 20px;\n    margin-bottom: 13px;\n\n    > div {\n        margin: 0 9px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n    padding: 0 20px;\n    margin-bottom: 13px;\n\n    > div {\n        margin: 0 9px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.6);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(\n        circle at 32% 17%,\n        #fff,\n        rgba(0, 49, 85, 0.5) 50%,\n        rgba(0, 0, 0, 0.5) 85%,\n        #fff\n    );\n    border-image-slice: 1;\n    ', ';\n\n    ', ';\n\n    span,\n    span.__c__c5 {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        font-size: ', ';\n        line-height: 1;\n        color: rgba(255, 255, 255, 0.8);\n        background: transparent !important;\n    }\n'], ['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    flex-shrink: 0;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.6);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(\n        circle at 32% 17%,\n        #fff,\n        rgba(0, 49, 85, 0.5) 50%,\n        rgba(0, 0, 0, 0.5) 85%,\n        #fff\n    );\n    border-image-slice: 1;\n    ', ';\n\n    ', ';\n\n    span,\n    span.__c__c5 {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        font-size: ', ';\n        line-height: 1;\n        color: rgba(255, 255, 255, 0.8);\n        background: transparent !important;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: ', ';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1 !important;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n    background-color: rgba(0, 0, 0, 0.6);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(\n        circle at 32% 17%,\n        #fff,\n        rgba(0, 49, 85, 0.5) 50%,\n        rgba(0, 0, 0, 0.5) 85%,\n        #fff\n    );\n    border-image-slice: 1;\n'], ['\n    display: ', ';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1 !important;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);\n    background-color: rgba(0, 0, 0, 0.6);\n    border-style: solid;\n    border-width: 2px;\n    border-image-source: radial-gradient(\n        circle at 32% 17%,\n        #fff,\n        rgba(0, 49, 85, 0.5) 50%,\n        rgba(0, 0, 0, 0.5) 85%,\n        #fff\n    );\n    border-image-slice: 1;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    flex-shrink: 0;\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    color: #fff;\n\n    ', ';\n\n    ', ';\n\n    > * {\n        z-index: 2;\n    }\n'], ['\n    position: relative;\n    width: 140px;\n    height: 150px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    flex-shrink: 0;\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    color: #fff;\n\n    ', ';\n\n    ', ';\n\n    > * {\n        z-index: 2;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 140px;\n    z-index: 3;\n    display: flex;\n    justify-content: center;\n    pointer-events: none;\n    ', ';\n    ', ';\n    ', ';\n\n    span span img {\n        width: 100%;\n        max-height: 100%;\n\n        &.wdp-sm-plr-logo-rounded {\n            max-height: none;\n        }\n\n        &.wdp-sm-plr-logo_jersey {\n            max-height: 90%;\n            ', ';\n        }\n\n        &.wdp-sm-plr-logo-spdk {\n            ', ';\n        }\n    }\n\n    .t-shirt-container {\n        width: 140px;\n        display: inherit;\n        justify-content: center;\n\n        .t-shirt-front {\n            object-fit: contain;\n            width: 100%;\n        }\n    }\n'], ['\n    position: relative;\n    width: 140px;\n    z-index: 3;\n    display: flex;\n    justify-content: center;\n    pointer-events: none;\n    ', ';\n    ', ';\n    ', ';\n\n    span span img {\n        width: 100%;\n        max-height: 100%;\n\n        &.wdp-sm-plr-logo-rounded {\n            max-height: none;\n        }\n\n        &.wdp-sm-plr-logo_jersey {\n            max-height: 90%;\n            ', ';\n        }\n\n        &.wdp-sm-plr-logo-spdk {\n            ', ';\n        }\n    }\n\n    .t-shirt-container {\n        width: 140px;\n        display: inherit;\n        justify-content: center;\n\n        .t-shirt-front {\n            object-fit: contain;\n            width: 100%;\n        }\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    z-index: 2;\n    ', ';\n'], ['\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    z-index: 2;\n    ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    height: 25px;\n    margin: 0;\n    padding: 0 2px;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: ', ';\n    background: #005caa !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ', ';\n    ', ';\n    ', ';\n\n    span,\n    span.__c__c1,\n    span.__c__c2,\n    span.__c__c3,\n    span.__c__c4 {\n        background: transparent !important;\n    }\n'], ['\n    height: 25px;\n    margin: 0;\n    padding: 0 2px;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: ', ';\n    background: #005caa !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ', ';\n    ', ';\n    ', ';\n\n    span,\n    span.__c__c1,\n    span.__c__c2,\n    span.__c__c3,\n    span.__c__c4 {\n        background: transparent !important;\n    }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    height: 25px;\n    margin: 0;\n    padding: 0 6px;\n    font-size: 19px;\n    line-height: 24px;\n    font-weight: ', ';\n    border: none;\n    background: rgba(0, 0, 0, 0.5) !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n    ', ';\n    ', ';\n    ', ';\n\n    span,\n    span.__c__c1,\n    span.__c__c2,\n    span.__c__c3,\n    span.__c__c4 {\n        background: transparent !important;\n    }\n'], ['\n    height: 25px;\n    margin: 0;\n    padding: 0 6px;\n    font-size: 19px;\n    line-height: 24px;\n    font-weight: ', ';\n    border: none;\n    background: rgba(0, 0, 0, 0.5) !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n    ', ';\n    ', ';\n    ', ';\n\n    span,\n    span.__c__c1,\n    span.__c__c2,\n    span.__c__c3,\n    span.__c__c4 {\n        background: transparent !important;\n    }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    .sm-lineup__pitch {\n        text-align: center;\n        width: 190px;\n        height: auto;\n        z-index: 0;\n        bottom: 0;\n        ', ';\n    }\n    svg {\n        position: absolute;\n        top: 89px;\n        left: 0;\n        z-index: -1;\n        width: 870px;\n        margin-left: -35px;\n    }\n'], ['\n    .sm-lineup__pitch {\n        text-align: center;\n        width: 190px;\n        height: auto;\n        z-index: 0;\n        bottom: 0;\n        ', ';\n    }\n    svg {\n        position: absolute;\n        top: 89px;\n        left: 0;\n        z-index: -1;\n        width: 870px;\n        margin-left: -35px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _BaseWidget2 = __webpack_require__(1368);
	
	var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);
	
	var _SWTProvider = __webpack_require__(1405);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _pitch = __webpack_require__(1469);
	
	var _pitch2 = _interopRequireDefault(_pitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var scaleFontSize = function scaleFontSize(value) {
	    var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
	
	    if (value.length < 13) return '';
	    var size = defaultSize - (value.length - 12 + 1);
	
	    return 'font-size: ' + (size >= 12 ? size : 12) + 'px;';
	};
	
	var Content = _styledComponents2.default.div(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.contentPadding;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return 100 - 100 * (1 - theme.contentPadding * 3 * (100 / 800) / 100);
	}, function (_ref3) {
	    var theme = _ref3.theme;
	    return theme.contentPadding;
	});
	
	var Row = _styledComponents2.default.div(_templateObject2, function (_ref4) {
	    var type = _ref4.type;
	    return type === 'grid' ? 'center' : 'space-around';
	});
	
	var Unknown = _styledComponents2.default.div(_templateObject3, function (_ref5) {
	    var type = _ref5.type;
	    return type === 'grid' && 'width: 160px; height: 210px;';
	}, function (_ref6) {
	    var large = _ref6.large;
	    return large && '\n        width: 192px;\n        height: 251px;\n        padding: 2px;\n    ';
	}, function (_ref7) {
	    var large = _ref7.large;
	    return large ? '160px' : '120px';
	});
	
	var Div = _styledComponents2.default.div(_templateObject4, function (_ref8) {
	    var type = _ref8.type;
	    return type !== 'grid' && 'none';
	});
	
	var Participant = _styledComponents2.default.div(_templateObject5, function (_ref9) {
	    var type = _ref9.type;
	    return type === 'grid' && '\n        width: 160px;\n        height: 209px;\n        padding: 2px;\n    ';
	}, function (_ref10) {
	    var large = _ref10.large;
	    return large && '\n        width: 192px;\n        height: 251px;\n        padding: 2px;\n    ';
	});
	
	var Avatar = _styledComponents2.default.div(_templateObject6, function (_ref11) {
	    var type = _ref11.type;
	    return type === 'teams' && 'align-items: center;';
	}, function (_ref12) {
	    var lineupType = _ref12.lineupType;
	    return lineupType === 'grid' ? 'width: 156px; height: 150px;' : 'height: 100px;';
	}, function (_ref13) {
	    var large = _ref13.large;
	    return large && 'width: 188px; height: 181px';
	}, function (_ref14) {
	    var lineupType = _ref14.lineupType;
	    return lineupType === 'grid' && 'margin-top: 15px;';
	}, function (_ref15) {
	    var lineupType = _ref15.lineupType;
	    return lineupType === 'grid' && 'width: 122%; margin-left: -11%;';
	});
	
	var TeamLogoBadge = _styledComponents2.default.div(_templateObject7, function (_ref16) {
	    var type = _ref16.type;
	    return type === 'grid' && 'left: -12px;';
	});
	
	var TextTop = _styledComponents2.default.h4(_templateObject8, function (_ref17) {
	    var theme = _ref17.theme;
	    return theme.fonts.main.bold || '700';
	}, function (_ref18) {
	    var value = _ref18.value;
	    return scaleFontSize(value, 18);
	}, function (_ref19) {
	    var type = _ref19.type,
	        value = _ref19.value;
	    return type === 'grid' && 'height: 30px; ' + scaleFontSize(value, 19) + ' line-height: 30px;';
	}, function (_ref20) {
	    var large = _ref20.large,
	        value = _ref20.value;
	    return large && 'height: 36px; ' + scaleFontSize(value, 22) + ' line-height: 36px;';
	});
	
	var TextInputBottom = _styledComponents2.default.h5(_templateObject9, function (_ref21) {
	    var theme = _ref21.theme;
	    return theme.fonts.main.bold || '700';
	}, function (_ref22) {
	    var value = _ref22.value;
	    return scaleFontSize(value, 19);
	}, function (_ref23) {
	    var type = _ref23.type,
	        theme = _ref23.theme;
	    return type === 'grid' && 'font-weight: ' + (theme.fonts.main.normal || '400') + ';';
	}, function (_ref24) {
	    var large = _ref24.large,
	        value = _ref24.value;
	    return large && 'height: 30px; ' + scaleFontSize(value, 22) + ' line-height: 30px;';
	});
	
	var Pitch = _styledComponents2.default.div(_templateObject10, function (props) {
	    return props.pitchImageStyles;
	});
	
	var TeamCustomSMWidget = function (_BaseWidget) {
	    _inherits(TeamCustomSMWidget, _BaseWidget);
	
	    function TeamCustomSMWidget(props) {
	        _classCallCheck(this, TeamCustomSMWidget);
	
	        var _this = _possibleConstructorReturn(this, (TeamCustomSMWidget.__proto__ || Object.getPrototypeOf(TeamCustomSMWidget)).call(this, props));
	
	        _this.getImage = function (teamId) {
	            // const { tournamentId } = this.props;
	            //
	            // if (tournamentId === 46) {
	            //     return `https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts_rich/t_shirts_front_logo_${teamId}.png`;
	            // }
	            //
	            // return `https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts/ic_shirt_${teamId}.png?a=2`;
	
	            return 'https://s3-eu-west-1.amazonaws.com/sport.images/wdp/shirts_rich/t_shirts_front_logo_' + teamId + '.png';
	        };
	
	        _this.getPlayerLogo = function (participant) {
	            var template = _this.state.template;
	            var playerLogoDisplay = _this.props.playerLogoDisplay;
	
	            var lineupType = _this.props.type || _this.state.type;
	
	            var SMPlayerLogo = _StyledUI.styledUI.getDisplay(template, 'playerLogo', _this.props);
	
	            var imageWrapStyle = {
	                display: 'block',
	                overflow: 'hidden'
	            };
	
	            if (playerLogoDisplay === 'PlayerLogo3DJerseyFront') {
	                return _react2.default.createElement('img', {
	                    className: 't-shirt-front',
	                    src: _this.getImage(participant.team ? participant.team.id : 0),
	                    alt: 'img'
	                });
	            }
	
	            return _react2.default.createElement(SMPlayerLogo, {
	                teamId: participant.team ? participant.team.id : 0,
	                playerId: participant.id,
	                seasonId: 'current',
	                isGK: participant.position === 'keeper',
	                size: 'large',
	                imageWrapStyle: imageWrapStyle,
	                number: participant.shirtNumber,
	                nameOnShirt3dJerseySize: lineupType === 'grid' ? 150 : 100
	            });
	        };
	
	        _this.getAvatar = function (participant) {
	            var large = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var template = _this.state.template;
	
	            var type = participant.countryId ? 'teams' : 'players';
	            var SMTeamLogo = _StyledUI.styledUI.getDisplay(template, 'teamLogo', _this.props);
	            var lineupType = _this.props.type || _this.state.type;
	
	            return _react2.default.createElement(
	                Avatar,
	                { type: type, lineupType: lineupType, large: large },
	                type === 'teams' && _react2.default.createElement(SMTeamLogo, { teamId: participant.id, width: large ? 160 : lineupType === 'grid' ? 130 : 95 }),
	                type === 'players' && [_react2.default.createElement(
	                    'span',
	                    { key: 'playerLogo', className: 't-shirt-container' },
	                    _this.getPlayerLogo(participant)
	                ), _react2.default.createElement(
	                    TeamLogoBadge,
	                    { key: 'TeamLogoBadge', type: lineupType, large: large },
	                    _react2.default.createElement(SMTeamLogo, { teamId: participant.team ? participant.team.id : 0, width: large && 45 || 35 })
	                )]
	            );
	        };
	
	        return _this;
	    }
	
	    _createClass(TeamCustomSMWidget, [{
	        key: 'loadData',
	        value: function loadData() {
	            var _props = this.props,
	                idLineUp = _props.idLineUp,
	                playersProps = _props.players;
	
	
	            idLineUp = parseInt(idLineUp, 10);
	
	            var displayPlayersProps = playersProps.length;
	
	            if (!displayPlayersProps && !idLineUp && isNaN(idLineUp)) return _RCore2.default.standardError(404, 'Missing Id LineUp');
	
	            return _RCore2.default.promiseProps({
	                template: Reflect.apply(_SWTProvider.loadData, this, []),
	                lineup: displayPlayersProps ? playersProps : this.fetch(_cfg2.default.apis.ss2 + '/admin/keyval?appName=maker-tool&key=' + idLineUp).then(function (res) {
	                    return res.value;
	                })
	            }).then(function (res) {
	                return _RCore2.default.promiseProps(_extends({}, res, { type: res.lineup.type, players: res.lineup.players }));
	            }).catch(function (e) {
	                return _RCore2.default.standardError(404, e.message);
	            });
	        }
	    }, {
	        key: 'renderParticipant',
	        value: function renderParticipant(participant, large) {
	            var lineupType = this.props.type || this.state.type;
	
	            if (participant.unknown) {
	                return _react2.default.createElement(
	                    Unknown,
	                    {
	                        key: participant.id,
	                        type: lineupType,
	                        large: large,
	                        className: lineupType === 'grid' ? '__c__b5' : ''
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        { className: lineupType === 'grid' ? '__c__c5' : '' },
	                        '?'
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                Participant,
	                { key: participant.id, type: lineupType, large: large },
	                _react2.default.createElement(Div, { type: lineupType, className: lineupType === 'grid' ? '__c__b6' : '' }),
	                this.getAvatar(participant, large),
	                participant.name && _react2.default.createElement(
	                    TextTop,
	                    {
	                        type: lineupType,
	                        className: lineupType === 'grid' ? '__c__b1' : '__c__b2',
	                        large: large,
	                        value: participant.name
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        {
	                            style: { background: 'transparent !important' },
	                            className: lineupType === 'grid' ? '__c__c1' : '__c__c2'
	                        },
	                        participant.name
	                    )
	                ),
	                participant.customText && _react2.default.createElement(
	                    TextInputBottom,
	                    {
	                        type: lineupType,
	                        className: lineupType === 'grid' ? '__c__b3' : '__c__b4',
	                        large: large,
	                        value: participant.customText
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        {
	                            style: { background: 'transparent !important' },
	                            className: lineupType === 'grid' ? '__c__c3' : '__c__c4'
	                        },
	                        participant.customText
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                template = _state.template,
	                __status = _state.__status,
	                _state$type = _state.type,
	                lineupTypeState = _state$type === undefined ? 'grid' : _state$type,
	                _state$players = _state.players,
	                playersState = _state$players === undefined ? [] : _state$players;
	            var _props2 = this.props,
	                _props2$type = _props2.type,
	                lineupTypeProps = _props2$type === undefined ? 'grid' : _props2$type,
	                _props2$players = _props2.players,
	                playersProps = _props2$players === undefined ? [] : _props2$players,
	                title = _props2.title,
	                subTitle = _props2.subTitle;
	
	
	            if (__status || !(playersProps && playersProps.length) && !(playersState && playersState.length)) {
	                return this.smRenderEmpty();
	            }
	
	            var lineupType = lineupTypeProps || lineupTypeState;
	            var players = playersProps.length ? playersProps : playersState;
	
	            var lineupTemplate = Object.entries(Array.from(players).reduce(function (acc, curr) {
	                if (curr.positionCode < 1) return _extends({}, acc);
	                var position = curr.positionCode.charAt(0);
	
	                if (acc[position]) return _extends({}, acc, _defineProperty({}, position, [].concat(_toConsumableArray(acc[position]), [curr])));
	
	                return _extends({}, acc, _defineProperty({}, position, [curr]));
	            }, {}));
	
	            var templateLength = lineupTemplate.length;
	            var pitchTheme = (0, _get2.default)(this, 'state.template.theme.pitch', {});
	            var large = lineupType === 'grid' && players.filter(function (player) {
	                return player.positionCode > 9 && player.positionCode < 20;
	            }).length === players.length;
	
	            return _react2.default.createElement(
	                _SWTProvider.SWTProvider,
	                _extends({}, this.props, {
	                    templateData: template,
	                    title: title,
	                    subTitle: subTitle,
	                    contentProps: lineupType === 'lineup' ? { padding: 0, margin: 0 } : {}
	                    // contentProps={{
	                    //     padding: 0,
	                    //     margin: 0,
	                    // }}
	                }),
	                _react2.default.createElement('div', { empty: true }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        Content,
	                        null,
	                        lineupTemplate.map(function (_ref25) {
	                            var _ref26 = _slicedToArray(_ref25, 2),
	                                rowKey = _ref26[0],
	                                rowVal = _ref26[1];
	
	                            return _react2.default.createElement(
	                                Row,
	                                { key: Math.random() + Date.now() + rowKey, offset: templateLength },
	                                rowVal.map(function (participant) {
	                                    return _this2.renderParticipant(participant, large);
	                                })
	                            );
	                        }),
	                        lineupType === 'lineup' && _react2.default.createElement(
	                            Pitch,
	                            null,
	                            _react2.default.createElement(_pitch2.default, pitchTheme)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamCustomSMWidget;
	}(_BaseWidget3.default);
	
	TeamCustomSMWidget.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object
	};
	TeamCustomSMWidget.defaultProps = {
	    idLineUp: null,
	    type: '',
	    players: []
	};
	
	
	var spec = TeamCustomSMWidget.spec = {
	    id: 'TeamCustomSMWidget',
	    social: true,
	    propTypes: [{
	        key: 'idLineUp',
	        label: 'LineUp Id',
	        type: 'textfield_picker',
	        defaultValue: TeamCustomSMWidget.defaultProps.idLineUp,
	        loader: true,
	        required: true
	    }, (0, _StyledUI.getDisplayPropType)('playerLogo', { ui: true })].concat(_toConsumableArray(_SWTProvider.SWTProvider.spec.propTypes)),
	    demo: [{
	        title: 'Test widget LineUp',
	        props: {
	            title: 'title',
	            subTitle: 'sub title',
	            idLineUp: 28659
	        }
	    }, {
	        title: 'Test widget Grid',
	        props: {
	            title: 'title',
	            subTitle: 'sub title',
	            idLineUp: 33809
	        }
	    }, {
	        title: 'Test widget Grid Large',
	        props: {
	            title: 'title',
	            subTitle: 'sub title',
	            idLineUp: 10976
	        }
	    }],
	    categories: ['events']
	    //v2Categories: [BaseWidget.CATEGORIES.V2.EDITORIAL],
	};
	
	var i18 = TeamCustomSMWidget.i18 = {
	    da: {},
	    en: {}
	};
	
	exports.default = TeamCustomSMWidget;
	exports.TeamCustomSMWidget = TeamCustomSMWidget;
	exports.spec = spec;
	exports.i18 = i18;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SWTProvider = exports.spec = exports.loadDataFunc = exports.loadData = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _url = __webpack_require__(289);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TeamColorProfile = __webpack_require__(1361);
	
	var _SplitImageTPL = __webpack_require__(1406);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _DropBackground = __webpack_require__(1465);
	
	var _DropBackground2 = _interopRequireDefault(_DropBackground);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _isomorphicFetch = __webpack_require__(1375);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOCAL_FONTS = __webpack_require__(1468);
	
	var CustomBGR = function CustomBGR(_ref) {
	    var editMode = _ref.editMode,
	        _ref$areas = _ref.areas,
	        areas = _ref$areas === undefined ? [] : _ref$areas,
	        _ref$direction = _ref.direction,
	        direction = _ref$direction === undefined ? 'row' : _ref$direction,
	        _ref$border = _ref.border,
	        border = _ref$border === undefined ? false : _ref$border;
	
	    var p = (100 / areas.length).toFixed(1);
	    var style = {};
	    style[direction === 'row' ? 'width' : 'height'] = p + '%';
	
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: direction, height: '100%' } },
	        areas.map(function (a, i) {
	            var CC = _extends({}, style, { flexGrow: 1 });
	
	            CC[direction === 'row' ? 'border-right' : 'border-bottom'] = i !== areas.length - 1 && border ? '4px solid #fff' : 'none';
	
	            // CC[ ]
	            return _react2.default.createElement(_DropBackground2.default, _extends({
	                id: a.key,
	                key: a.key,
	                style: CC,
	                url: 'https://talksport.com/wp-content/uploads/sites/5/2015/10/7drogba.jpg?strip=all&w=700',
	                editMode: editMode
	            }, a));
	        })
	    );
	};
	
	var SWTProvider = function (_React$Component) {
	    _inherits(SWTProvider, _React$Component);
	
	    function SWTProvider(props) {
	        _classCallCheck(this, SWTProvider);
	
	        var _this = _possibleConstructorReturn(this, (SWTProvider.__proto__ || Object.getPrototypeOf(SWTProvider)).call(this, props));
	
	        _this.getTeamsColors = function (theme, hasTeamColorLayer) {
	            var teamIdColor = _this.props.teamIdColor;
	
	            var teamBackgroundColor = (0, _TeamColorProfile.colorForTeam)(teamIdColor, 'color', theme.primaryColor);
	            var teamColor = (0, _TeamColorProfile.colorForTeam)(teamIdColor, 'stats', theme.primaryTextColor);
	
	            var contentColors = {
	                color: teamColor,
	                titleColor: teamColor,
	                subTitleColor: teamColor
	            };
	
	            return Object.assign({
	                teamBackgroundColor: teamBackgroundColor,
	                teamColor: teamColor
	            }, hasTeamColorLayer ? contentColors : {});
	        };
	
	        _this.getTheme = function () {
	            var _this$props = _this.props,
	                userTheme = _this$props.userTheme,
	                userTemplate = _this$props.userTemplate,
	                _this$props$widgetThe = _this$props.widgetTheme,
	                widgetTheme = _this$props$widgetThe === undefined ? {} : _this$props$widgetThe,
	                templateData = _this$props.templateData,
	                teamIdColor = _this$props.teamIdColor;
	
	
	            var theme = _lodash2.default.merge({}, _SplitImageTPL.theme, (userTemplate || templateData).theme, widgetTheme, userTheme);
	            var hasTeamColorLayer = false;
	
	            var checkForTeamColor = function checkForTeamColor(l) {
	                return l.backgroundImage.indexOf('isTeamColor=true') > -1;
	            };
	            if (widgetTheme.layers && widgetTheme.layers.length) {
	                hasTeamColorLayer = widgetTheme.layers.some(checkForTeamColor);
	            } else if (theme.layers && theme.layers.length) {
	                hasTeamColorLayer = theme.layers.some(checkForTeamColor);
	            }
	            var teamsColors = teamIdColor ? _this.getTeamsColors(theme, hasTeamColorLayer) : {};
	            theme = _lodash2.default.merge({}, theme, teamsColors);
	            return theme;
	        };
	
	        _this.renderTemplate = function () {
	            var secondaryContent = _this.props.children[0];
	            var primaryContent = _this.props.children[1];
	
	            // console.log('SWT', this.props.);
	
	            var customBGR = _this.props.children[2];
	
	            var areas = _lodash2.default.chain(_this.props).keys().filter(function (k) {
	                return k.indexOf('area') === 0 && _this.props[k] && !_lodash2.default.isEmpty(_this.props[k]);
	            }).map(function (key) {
	                return _extends({ key: key }, _this.props[key]);
	            }).compact().value();
	
	            if (!customBGR && areas.length > 0) {
	                customBGR = _react2.default.createElement(CustomBGR, _extends({ areas: areas }, _this.props.dnd, { editMode: _this.props.editMode }));
	            }
	
	            var _this$props2 = _this.props,
	                template = _this$props2.template,
	                _this$props2$swtPrevi = _this$props2.swtPreviewCustomStyles,
	                swtPreviewCustomStyles = _this$props2$swtPrevi === undefined ? '' : _this$props2$swtPrevi,
	                _this$props2$contentP = _this$props2.contentProps,
	                contentProps = _this$props2$contentP === undefined ? {} : _this$props2$contentP,
	                _this$props2$secondar = _this$props2.secondaryContentProps,
	                secondaryContentProps = _this$props2$secondar === undefined ? {} : _this$props2$secondar,
	                brandingPrimary = _this$props2.brandingPrimary,
	                brandingSecondary = _this$props2.brandingSecondary,
	                brandingAdditionalContent = _this$props2.brandingAdditionalContent,
	                screencast = _this$props2.screencast,
	                branding = _this$props2.branding,
	                _this$props2$showCust = _this$props2.showCustomTitile,
	                showCustomTitile = _this$props2$showCust === undefined ? true : _this$props2$showCust,
	                teamIdColor = _this$props2.teamIdColor;
	
	
	            switch (template) {
	                default:
	                    return _react2.default.createElement(_SplitImageTPL.SplitImageTPL, {
	                        swtPreviewCustomStyles: swtPreviewCustomStyles,
	                        previewLayer: _this.props.previewLayer,
	                        bgrLayer: _this.props.bgrLayer,
	                        background: customBGR,
	                        theme: _this.getTheme(),
	                        titleImage: _this.props.titleImage,
	                        title: showCustomTitile ? _this.props.title : null,
	                        subTitle: _this.props.subTitle,
	                        secondaryContent: secondaryContent,
	                        contentProps: contentProps,
	                        secondaryContentProps: secondaryContentProps,
	                        primaryContent: primaryContent,
	                        screencast: screencast,
	                        brandingPrimary: brandingPrimary,
	                        brandingSecondary: brandingSecondary,
	                        brandingAdditionalContent: brandingAdditionalContent,
	                        brandingProps: branding,
	                        widgetProps: _this.props,
	                        teamIdColor: teamIdColor
	                    });
	            }
	        };
	
	        _this.render = function () {
	            var theme = _this.getTheme();
	            var fonts = theme.fonts;
	
	
	            if (_this.props.children.length < 2) throw new Error('SWTProvider should have 2 children');
	
	            var ssmId = '_widgetscope_';
	            if ((true) && !document.getElementById(ssmId)) {
	                var c = document.createElement('div');
	                c.id = ssmId;
	                window.document.head.appendChild(c);
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: _this.props.widget },
	                _react2.default.createElement('style', {
	                    type: 'text/css',
	                    key: 'Flama',
	                    dangerouslySetInnerHTML: {
	                        __html: LOCAL_FONTS['Flama']
	                    }
	                }),
	                _react2.default.createElement('style', {
	                    type: 'text/css',
	                    key: 'FuturaBold',
	                    dangerouslySetInnerHTML: {
	                        __html: LOCAL_FONTS['FuturaBold']
	                    }
	                }),
	                _react2.default.createElement('style', {
	                    type: 'text/css',
	                    key: 'ProximaNova',
	                    dangerouslySetInnerHTML: {
	                        __html: LOCAL_FONTS['ProximaNova']
	                    }
	                }),
	                _lodash2.default.filter(Object.keys(fonts)).map(function (fontKey) {
	                    var font = fonts[fontKey];
	                    if (LOCAL_FONTS[font.gFontName]) {
	                        return _react2.default.createElement('style', {
	                            type: 'text/css',
	                            key: fontKey,
	                            dangerouslySetInnerHTML: {
	                                __html: LOCAL_FONTS[font.gFontName]
	                            }
	                        });
	                    } else {
	                        return font.gFontName && font.gWeights && _react2.default.createElement('link', {
	                            rel: 'stylesheet',
	                            key: font.gFontName + '_' + fontKey,
	                            href: 'https://fonts.googleapis.com/css?family=' + font.gFontName + ':' + font.gWeights
	                        });
	                    }
	                }),
	                (true) && _react2.default.createElement(
	                    _styledComponents.StyleSheetManager,
	                    { target: document.getElementById(ssmId) },
	                    _this.renderTemplate()
	                ),
	                !(true) && _this.renderTemplate()
	            );
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    return SWTProvider;
	}(_react2.default.Component);
	
	SWTProvider.defaultProps = {
	    templateData: {}
	};
	SWTProvider.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	
	var mergeStyles = function mergeStyles(theme, widgetId, variation) {
	    if (!widgetId) return theme;
	
	    if (variation && variation !== 'default') {
	        var _widgetTheming = _lodash2.default.get(theme, 'variations.' + widgetId + '.' + variation, {});
	
	        // Reflect.deleteProperty(theme, 'variations');
	        Reflect.deleteProperty(theme, 'widgets');
	        theme = _lodash2.default.merge(theme, _widgetTheming);
	        theme = _extends({}, theme, { layers: _lodash2.default.get(_widgetTheming, 'layers', theme.layers) });
	
	        return theme;
	    }
	
	    var widgetTheming = _lodash2.default.get(theme, 'widgets.' + widgetId, {});
	    Reflect.deleteProperty(theme, 'widgets');
	
	    theme = _lodash2.default.merge(theme, widgetTheming);
	    theme = _extends({}, theme, { layers: _lodash2.default.get(widgetTheming, 'layers', theme.layers) });
	    return theme;
	};
	
	var loadDataFunc = function loadDataFunc(client, user, template, widgetId, variation) {
	    return (0, _isomorphicFetch2.default)(_cfg2.default.widgets.url + '/api/clients/' + client + '/users/' + user + '/templates/' + template).then(function (response) {
	        return response.json();
	    }).then(function (tpl) {
	        tpl.theme = mergeStyles(tpl.theme, widgetId, variation);
	        tpl.theme = _lodash2.default.merge({}, _SplitImageTPL.theme, tpl.theme);
	        return tpl;
	    });
	};
	
	var loadData = function loadData() {
	    var _props = this.props,
	        template = _props.template,
	        variation = _props.variation;
	    var _context$info = this.context.info,
	        client = _context$info.client,
	        user = _context$info.user;
	
	    if (this.props.tempTemplate) return Promise.resolve(this.props.tempTemplate);
	    return loadDataFunc(client, user, template, _lodash2.default.get(this, 'constructor.spec.id'), variation);
	};
	
	var spec = SWTProvider.spec = {
	    propTypesNoTile: function propTypesNoTile() {
	        return _lodash2.default.filter(this.propTypes, function (p) {
	            return ['title', 'subTitle', 'titleDisplay'].indexOf(p.key) === -1;
	        });
	    },
	    // propTypesWithDefaults: function(defs) {
	    //     let pt = this.propTypes
	    //     Object.keys(defs).map(k => {
	    //         let prop = pt.find(prop => prop.key == k);
	    //         if (prop) prop.defaultValue = defs[k];
	    //     })
	    //     return pt;
	    // },
	    propTypes: [{
	        key: 'template',
	        type: 'template_picker',
	        label: 'Templates',
	        scope: 'template',
	        ui: true
	    }, {
	        key: 'variation',
	        type: 'textfield_picker',
	        label: 'Template variation',
	        scope: 'template',
	        ui: true
	    }, {
	        key: 'title',
	        label: 'Title',
	        type: 'textfield_picker',
	        scope: 'common',
	        ui: true
	    }, {
	        key: 'subTitle',
	        label: 'Sub title',
	        type: 'textfield_picker',
	        scope: 'common',
	        ui: true
	    }, {
	        key: 'lang',
	        type: 'select_picker',
	        label: 'Language',
	        scope: 'common',
	        loader: true,
	        options: [{
	            text: 'English',
	            value: 'en'
	        }, {
	            text: 'Danish',
	            value: 'da'
	        }, {
	            text: 'Swedish',
	            value: 'se'
	        }, {
	            text: 'Norwegian',
	            value: 'no'
	        }, {
	            text: 'Deutsch',
	            value: 'de'
	        }, {
	            text: 'Finish',
	            value: 'fi'
	        }, {
	            text: 'Thai',
	            value: 'th'
	        }, {
	            text: 'Chinise simpl',
	            value: 'sc'
	        }, {
	            text: 'Chinise trad',
	            value: 'tc'
	        }]
	    }, {
	        key: 'tz',
	        type: 'select_picker',
	        label: 'Timezone',
	        scope: 'common',
	        loader: true,
	        defaultValue: 'CET',
	        options: [{
	            text: 'London',
	            value: 'Europe/London'
	        }, {
	            text: 'GMT',
	            value: 'GMT'
	        }, {
	            text: 'WET',
	            value: 'WET'
	        }, {
	            text: 'CET',
	            value: 'CET'
	        }, {
	            text: 'EEST',
	            value: 'eest'
	        }]
	    }, {
	        key: 'wcwidth',
	        type: 'select_picker',
	        label: 'Widget width mode',
	        scope: 'common',
	        ui: true,
	        defaultValue: 800,
	        options: [{
	            text: 'Narrow (600)',
	            value: 600
	        }, {
	            text: 'Standard (800)',
	            value: 800
	        }, {
	            text: 'Wide (1024)',
	            value: 1024
	        }, {
	            text: 'Full (1080)',
	            value: 1080
	        }, {
	            text: 'XLarge (1200)',
	            value: 1200
	        }]
	    }, {
	        key: 'bgrLayer',
	        label: 'Background Image',
	        type: 'preview_image',
	        ui: true,
	        scope: 'images',
	        depracated: true,
	        props: {
	            disableTopOverlay: true,
	            default: {
	                scale: 1.0,
	                translateX: 0,
	                translateY: 0,
	                opacity: 1.0,
	                backgroundImage: null,
	                backgroundSize: 'cover',
	                backgroundPositionX: 'center',
	                backgroundPositionY: 'center'
	            }
	        }
	    }, {
	        key: 'previewLayer',
	        label: 'Preview Image',
	        type: 'preview_image',
	        ui: true,
	        depracated: true,
	        scope: 'images',
	        props: {
	            disableTopOverlay: true,
	            default: {
	                scale: 1.0,
	                translateX: 0,
	                translateY: 0,
	                opacity: 1.0,
	                backgroundImage: null,
	                backgroundSize: 'contain',
	                backgroundPositionX: 'center',
	                backgroundPositionY: 'bottom'
	            }
	        }
	    }, {
	        key: 'dnd',
	        label: 'NEW Image Manipulations',
	        type: 'dnd_bgr_picker',
	        ui: true,
	        props: {
	            enabled: false,
	            propsMap: {
	                area1: 'area1',
	                area2: 'area2',
	                area3: 'area3',
	                area4: 'area4'
	            }
	        }
	    }, (0, _StyledUI.getDisplayPropType)('title', { ui: true })]
	};
	
	exports.loadData = loadData;
	exports.loadDataFunc = loadDataFunc;
	exports.spec = spec;
	exports.SWTProvider = SWTProvider;
	exports.default = SWTProvider;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SplitImageTPL = exports.theme = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: ', ';\n    position: relative;\n    overflow: hidden;\n    font-family: ', ';\n    font-style: ', ';\n    text-transform: ', ';\n\n    &:hover {\n        .animation-controls {\n            opacity: 1;\n        }\n    }\n\n    table {\n        font-style: inherit;\n        color: inherit;\n    }\n\n    color: ', ';\n\n    .wdp-bgr {\n        position: absolute;\n        display: block;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        pointer-events: none;\n    }\n    .wdp-bgr-custom {\n        pointer-events: all;\n    }\n\n    ', ';\n\n    ', ';\n'], ['\n    width: ', ';\n    position: relative;\n    overflow: hidden;\n    font-family: ', ';\n    font-style: ', ';\n    text-transform: ', ';\n\n    &:hover {\n        .animation-controls {\n            opacity: 1;\n        }\n    }\n\n    table {\n        font-style: inherit;\n        color: inherit;\n    }\n\n    color: ', ';\n\n    .wdp-bgr {\n        position: absolute;\n        display: block;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        pointer-events: none;\n    }\n    .wdp-bgr-custom {\n        pointer-events: all;\n    }\n\n    ', ';\n\n    ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    -webkit-flex-flow: row wrap;\n\n    z-index: 1;\n    overflow: hidden;\n    justify-content: center;\n    min-height: ', ';\n'], ['\n    display: flex;\n    -webkit-flex-flow: row wrap;\n\n    z-index: 1;\n    overflow: hidden;\n    justify-content: center;\n    min-height: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    flex-direction: row;\n    position: relative;\n'], ['\n    flex-direction: row;\n    position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: relative;\n    flex-direction: column;\n    padding: 0;\n    pointer-events: none;\n\n    .widget-customizer & {\n        pointer-events: all;\n    }\n'], ['\n    position: relative;\n    flex-direction: column;\n    padding: 0;\n    pointer-events: none;\n\n    .widget-customizer & {\n        pointer-events: all;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 0;\n    align-items: stretch;\n'], ['\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 0;\n    align-items: stretch;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    overflow: hidden;\n    padding: ', 'px;\n    flex-grow: ', ';\n    flex-basis: 0;\n    display: flex;\n    flex-direction: column;\n\n    ', ';\n'], ['\n    overflow: hidden;\n    padding: ', 'px;\n    flex-grow: ', ';\n    flex-basis: 0;\n    display: flex;\n    flex-direction: column;\n\n    ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    overflow: hidden;\n    padding: ', 'px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    ', ';\n    margin: ', ';\n    padding: ', ';\n    position: relative;\n'], ['\n    overflow: hidden;\n    padding: ', 'px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    ', ';\n    margin: ', ';\n    padding: ', ';\n    position: relative;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    position: relative;\n    padding: ', 'px;\n    overflow: hidden;\n    z-index: 2;\n    flex-grow: ', ';\n    flex-basis: 0;\n    display: flex;\n    flex-direction: column;\n\n    .secondary-block-title {\n        text-align: left !important;\n    }\n    background: ', ';\n'], ['\n    position: relative;\n    padding: ', 'px;\n    overflow: hidden;\n    z-index: 2;\n    flex-grow: ', ';\n    flex-basis: 0;\n    display: flex;\n    flex-direction: column;\n\n    .secondary-block-title {\n        text-align: left !important;\n    }\n    background: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    position: ', ';\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: ', ';\n    z-index: 2;\n\n    margin: ', ';\n    background: ', ';\n    padding: ', ';\n'], ['\n    position: ', ';\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: ', ';\n    z-index: 2;\n\n    margin: ', ';\n    background: ', ';\n    padding: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _WebFontLoaderFactory = __webpack_require__(1407);
	
	var _WebFontLoaderFactory2 = _interopRequireDefault(_WebFontLoaderFactory);
	
	var _ConstantlyMovingBar = __webpack_require__(1408);
	
	var _ConstantlyMovingBar2 = _interopRequireDefault(_ConstantlyMovingBar);
	
	var _AnimationControls = __webpack_require__(1409);
	
	var _AnimationControls2 = _interopRequireDefault(_AnimationControls);
	
	var _Branding = __webpack_require__(1410);
	
	var _Branding2 = _interopRequireDefault(_Branding);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _hexToRgba = __webpack_require__(1463);
	
	var _hexToRgba2 = _interopRequireDefault(_hexToRgba);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable react/no-array-index-key */
	
	
	var defTheme = __webpack_require__(1464);
	
	// const composeGradient = props => {
	//     if (props.gradient === 'radial') {
	//         return `${props.gradient}-gradient(ellipse farthest-corner at ${props.position}, ${props.startColor} 0%,  ${
	//             props.endColor
	//         } 100%)`;
	//     } else {
	//         return `${props.gradient}-gradient(${props.position}, ${props.startColor} 0%,  ${props.endColor} 100%)`;
	//     }
	// };
	
	var layerToStyle = function layerToStyle(layer, i) {
	    return {
	        backgroundImage: 'url(' + layer.backgroundImage + ')',
	        backgroundSize: '' + (layer.backgroundSize || 'initial'),
	        zIndex: i + 1,
	        transform: 'scale(' + (layer.scale || 1.0) + ') translate(' + (layer.translateX || 0) + '%, ' + (layer.translateY || 0) + '%)',
	        '-webkit-transform': 'scale(' + (layer.scale || 1.0) + ') translate(' + (layer.translateX || 0) + '%, ' + (layer.translateY || 0) + '%)',
	
	        opacity: '' + (layer.opacity || 1.0),
	        backgroundPosition: layer.backgroundPositionX + ' ' + layer.backgroundPositionY,
	        backgroundRepeat: 'no-repeat'
	    };
	};
	
	var generateLayerClass = function generateLayerClass(layer, i, theme, teamIdColor) {
	    var isTeamColor = layer.backgroundImage.indexOf('isTeamColor') > -1 && teamIdColor;
	    var noTeamColor = layer.backgroundImage.indexOf('isTeamColor') > -1 && !teamIdColor;
	    var isGradient = layer.backgroundImage.indexOf('gradient.svg') > -1;
	    var bgrPostition = 'center center';
	    var transform = ['scale(' + (layer.scale || 1.0) + ')'];
	    if (layer.backgroundSize === 'cover') bgrPostition = layer.translateX + '% ' + layer.translateY + '%';
	
	    if (layer.backgroundSize === 'contain' || layer.backgroundSize === 'initial') {
	        var bgrX = layer.backgroundPositionX;
	        var bgrY = layer.backgroundPositionY;
	
	        if (layer.backgroundPositionX === 'moveX') {
	            bgrX = 'center';
	            transform.push(['translateX(' + layer.translateX + 'px)']);
	        }
	        if (layer.backgroundPositionY === 'moveY') {
	            bgrY = 'center';
	            transform.push(['translateY(' + layer.translateY + 'px)']);
	        }
	
	        bgrPostition = bgrX + ' ' + bgrY;
	    }
	
	    return '\n        .wdp-bgr-' + i + ' {\n            &:after {\n                content: \'layer ' + i + '\';\n                position: absolute;\n                right: 10;\n                top: ' + (i + 1) * 10 + ';\n                display: none;\n            }\n            position: absolute;\n            display: block;\n            left: 0;\n            right: 0;\n            top: 0;\n            bottom: 0;\n            background-image: url("' + layer.backgroundImage + '");\n            ' + (noTeamColor ? 'background-image: none; ' : '') + '\n            ' + (isTeamColor ? 'background-image: url("' + layer.backgroundImage + '&fromColor=' + (0, _hexToRgba2.default)(theme.teamBackgroundColor) + '&toColor=' + (0, _hexToRgba2.default)(theme.teamBackgroundColor) + '");' : '') + '\n            background-size: ' + (layer.backgroundSize || 'cover') + ';\n            background-position: ' + bgrPostition + ';\n            background-repeat: no-repeat;\n            z-index: ' + (i + 1) + ';\n            transform: ' + transform.join(' ') + ';\n            opacity: ' + (layer.opacity || 1.0) + ';\n\n            ' + (isGradient ? 'left: ' + (theme.content.gradientAlign === 'right' ? 'auto' : 0) + '; top: ' + (theme.content.gradientAlign === 'bottom' ? 'auto' : 0) + '; width: ' + (theme.content.gradientWidth || 0) + '%; height: ' + (theme.content.gradientHeight || 0) + '%' : '') + '\n\n            }\n    ';
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	    return _lodash2.default.isInteger(props.wcwidth) ? props.wcwidth + 'px' : '800px';
	}, function (props) {
	    return props.theme.fonts.main.fontFamily;
	}, function (props) {
	    return props.theme.fonts.main.fontStyle;
	}, function (props) {
	    return props.theme.fonts.main.textTransform;
	}, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.widgetColors && Object.keys(props.widgetColors).reduce(function (tot, cur) {
	        var color = props.widgetColors['' + cur];
	        var property = 'color';
	        if (_lodash2.default.get(cur.split('__c__'), '[1][0]') === 'b') property = 'background-color';
	
	        //for pseudo bg
	        if (_lodash2.default.get(cur.split('__c__'), '[1][0]') === 'a') {
	            tot += '.' + cur + ' {' + property + ': ' + color + '}}';
	            return tot;
	        }
	
	        if (property === 'color') {
	            tot += '.' + cur + ' {' + property + ': ' + color + ' !important; * {' + property + ': ' + color + ' !important;}}';
	        } else {
	            tot += '.' + cur + ' {' + property + ': ' + color + '!important;}';
	        }
	
	        return tot;
	    }, '');
	}, function (props) {
	    return (props.theme.layers || []).map(function (layer, i) {
	        return layer && generateLayerClass(layer, i, props.theme, props.teamIdColor);
	    });
	});
	
	/** CONTAINERS **/
	var Container = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.minHeight && props.minHeight + 'px' || props.theme.content.minHeight && props.theme.content.minHeight + 'px' || 'auto';
	});
	var TwoColumnContainer = (0, _styledComponents2.default)(Container)(_templateObject3);
	
	//pointer-events: ${props => (props.theme.editing ? 'all' : 'none')};
	var OneColumnContainer = (0, _styledComponents2.default)(Container)(_templateObject4);
	
	var BackgroundContainer = (0, _styledComponents2.default)(Container)(_templateObject5);
	
	/** BLOCKS **/
	
	var PrimaryBlock = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.contentPadding;
	}, function (props) {
	    return (props.weight || props.theme.weight) * 10;
	}, function (props) {
	    return props.reverse && 'flex-direction: column-reverse;';
	});
	
	var SingleBlock = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.contentPadding;
	}, function (props) {
	    return props.reverse && 'flex-direction: column-reverse;';
	}, function (props) {
	    return props.margin != undefined && props.margin;
	}, function (props) {
	    return props.padding != undefined && props.padding;
	});
	
	var SecondaryBlock = _styledComponents2.default.div(_templateObject8, function (props) {
	    return props.theme.contentPadding;
	}, function (props) {
	    return (1 - (props.weight || props.theme.weight)) * 10;
	}, function (props) {
	    return props.theme.content.backgroundColor;
	});
	
	var Content = _styledComponents2.default.div(_templateObject9, function (props) {
	    return props.position || 'unset';
	}, function (props) {
	    return props.valign || props.theme.content.valign || 'top';
	}, function (props) {
	    if (props.margin != undefined) {
	        return props.margin;
	    }
	
	    return props.theme.content.margin.replace(/([1-9][0-9]+)/g, '$1px');
	}, function (props) {
	    return props.theme.content.fillColor || 'transparent';
	}, function (props) {
	    if (props.padding != undefined) {
	        return props.padding;
	    }
	
	    return props.theme.content.padding.replace(/([1-9][0-9]+)/g, '$1px');
	});
	
	var SplitImageTPL = function (_React$Component) {
	    _inherits(SplitImageTPL, _React$Component);
	
	    function SplitImageTPL(props) {
	        _classCallCheck(this, SplitImageTPL);
	
	        var _this = _possibleConstructorReturn(this, (SplitImageTPL.__proto__ || Object.getPrototypeOf(SplitImageTPL)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var theme = props.theme;
	
	
	        _this.state = {
	            theme: theme
	        };
	        return _this;
	    }
	
	    return SplitImageTPL;
	}(_react2.default.Component);
	
	SplitImageTPL.propTypes = {
	    social: _propTypes2.default.bool,
	    theme: _propTypes2.default.object,
	    pattern: _propTypes2.default.string,
	    secondaryContent: _propTypes2.default.object,
	    primaryContent: _propTypes2.default.object,
	
	    contentProps: _propTypes2.default.object,
	    secondaryContentProps: _propTypes2.default.object,
	    title: _propTypes2.default.string,
	    preview: _propTypes2.default.object
	};
	SplitImageTPL.defaultProps = {
	    theme: defTheme,
	    social: true
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.componentDidMount = function () {
	        window.addEventListener('startAnimation', _this2.startAnimationListener, false);
	        _this2.reloadFont([_this2.state.theme.googleFontName]);
	    };
	
	    this.componentWillReceiveProps = function (nextProps) {
	        var theme = nextProps.theme;
	
	        if (_this2.state.theme.googleFontName !== theme.googleFontName) {
	            _this2.reloadFont([theme.googleFontName]);
	        }
	        _this2.setState({
	            theme: theme
	        });
	    };
	
	    this.componentWillUnmount = function () {
	        window.removeEventListener('startAnimation', _this2.startAnimationListener, false);
	    };
	
	    this.startAnimationListener = function () {
	        _this2.setState({ pause: false });
	    };
	
	    this.reloadFont = function (fonts) {
	        if (_lodash2.default.isEmpty(fonts)) return;
	        var WFL = _WebFontLoaderFactory2.default.init(window);
	        WFL.load({
	            google: {
	                families: fonts
	            },
	            active: function active() {}
	        });
	    };
	
	    this.renderTopLevelLayers = function () {
	        var theme = _this2.props.theme;
	
	        return theme.layers.map(function (layer, i) {
	            return layer && layer.topOverlay && _react2.default.createElement('span', { key: 'wdp-bgr-' + i, className: 'wdp-bgr wdp-bgr-' + i });
	        });
	    };
	
	    this.renderBackgroundLayers = function () {
	        var _props = _this2.props,
	            theme = _props.theme,
	            bgrLayer = _props.bgrLayer,
	            previewLayer = _props.previewLayer,
	            background = _props.background;
	
	
	        if (theme.layers.length > 0 && bgrLayer && _lodash2.default.isObject(bgrLayer) && bgrLayer.backgroundImage !== '') {
	            theme.layers[0] = bgrLayer;
	        }
	
	        return [background && _react2.default.createElement(
	            'span',
	            { key: 'wdp-bgr-custom', className: 'wdp-bgr wdp-bgr-custom' },
	            background
	        ), !background && theme.layers.map(function (layer, i) {
	            return layer && !layer.topOverlay && _react2.default.createElement('span', { key: 'wdp-bgr-' + i, className: 'wdp-bgr wdp-bgr-' + i });
	        }), previewLayer && _react2.default.createElement('span', {
	            key: 'preview-layer',
	            className: 'wdp-bgr wdp-bgr-' + (theme.layers.length + 3),
	            style: layerToStyle(previewLayer, theme.layers.length + 3)
	        })];
	    };
	
	    this.widgetCanNotBeRenderedMessage = function () {
	        var contentProps = _this2.props.contentProps;
	        var valign = contentProps.valign;
	        var theme = _this2.state.theme;
	
	
	        return _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	                Wrapper,
	                { className: 'sm-wdp', wcwidth: 800 },
	                _react2.default.createElement(
	                    BackgroundContainer,
	                    null,
	                    _this2.renderBackgroundLayers()
	                ),
	                _react2.default.createElement(
	                    OneColumnContainer,
	                    contentProps,
	                    _react2.default.createElement(
	                        SingleBlock,
	                        { valign: valign },
	                        _react2.default.createElement(
	                            Content,
	                            contentProps,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { fontSize: 40, fontWeight: 700, margin: 'auto' } },
	                                'Widget can not be rendered as plain HTML'
	                            )
	                        )
	                    )
	                ),
	                _this2.renderTopLevelLayers()
	            )
	        );
	    };
	
	    this.renderOneColumn = function () {
	        var _props2 = _this2.props,
	            primaryContent = _props2.primaryContent,
	            _props2$contentProps = _props2.contentProps,
	            contentProps = _props2$contentProps === undefined ? {} : _props2$contentProps,
	            widgetProps = _props2.widgetProps,
	            brandingPrimary = _props2.brandingPrimary,
	            brandingSecondary = _props2.brandingSecondary,
	            brandingAdditionalContent = _props2.brandingAdditionalContent,
	            screencast = _props2.screencast,
	            _props2$brandingProps = _props2.brandingProps,
	            brandingProps = _props2$brandingProps === undefined ? {} : _props2$brandingProps;
	        var theme = _this2.state.theme;
	        var disableBranding = contentProps.disableBranding,
	            valign = contentProps.valign;
	        var video = widgetProps.video;
	
	
	        brandingPrimary = brandingPrimary || theme.defaultBranding.brandingPrimary;
	        brandingSecondary = brandingSecondary || theme.defaultBranding.brandingSecondary;
	
	        var _brandingProps = _extends({}, theme.brandingProps, brandingProps, {
	            additionalContent: brandingAdditionalContent
	        });
	        if (disableBranding) _brandingProps.visibility = 'hidden';
	
	        var Title = _StyledUI.styledUI.getCustomComponent({ theme: theme }, 'title', _this2.props.widgetProps);
	
	        return _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	                Wrapper,
	                {
	                    className: 'sm-wdp',
	                    widgetColors: theme.customColors || _this2.state.theme.widgetsColors[_lodash2.default.get(_this2, 'props.widgetProps.name', _lodash2.default.get(_this2, 'props.widgetProps.widget'))],
	                    teamIdColor: _this2.props.teamIdColor,
	                    wcwidth: widgetProps.wcwidth
	                },
	                _react2.default.createElement(
	                    BackgroundContainer,
	                    null,
	                    _this2.renderBackgroundLayers()
	                ),
	                _react2.default.createElement(
	                    OneColumnContainer,
	                    _extends({
	                        style: { visibility: video ? 'hidden' : 'visible' },
	                        className: 'sm-wdp__container'
	                    }, contentProps),
	                    _react2.default.createElement(
	                        SingleBlock,
	                        { valign: valign, reverse: _brandingProps.position === 'top' },
	                        _react2.default.createElement(
	                            Content,
	                            contentProps,
	                            _react2.default.createElement(Title, {
	                                titleImage: _this2.props.titleImage,
	                                title: _this2.props.title,
	                                subTitle: _this2.props.subTitle
	                            }),
	                            primaryContent
	                        ),
	                        _react2.default.createElement(
	                            _Branding2.default,
	                            _brandingProps,
	                            brandingPrimary,
	                            brandingSecondary
	                        )
	                    )
	                ),
	                _this2.renderTopLevelLayers(),
	                _react2.default.createElement(_AnimationControls2.default, _lodash2.default.pick(_this2.props.widgetProps, ['screencast', 'startAnimation', 'video', 'noAnimationControls'])),
	                _react2.default.createElement(_ConstantlyMovingBar2.default, { screencast: screencast })
	            )
	        );
	    };
	
	    this.renderSpitImage = function () {
	        var _props3 = _this2.props,
	            primaryContent = _props3.primaryContent,
	            secondaryContent = _props3.secondaryContent,
	            _props3$contentProps = _props3.contentProps,
	            contentProps = _props3$contentProps === undefined ? {} : _props3$contentProps,
	            secondaryContentProps = _props3.secondaryContentProps,
	            brandingPrimary = _props3.brandingPrimary,
	            brandingSecondary = _props3.brandingSecondary,
	            widgetProps = _props3.widgetProps,
	            brandingAdditionalContent = _props3.brandingAdditionalContent,
	            screencast = _props3.screencast,
	            _props3$brandingProps = _props3.brandingProps,
	            brandingProps = _props3$brandingProps === undefined ? {} : _props3$brandingProps;
	        var theme = _this2.state.theme;
	        var disableBranding = contentProps.disableBranding,
	            weight = contentProps.weight,
	            valign = contentProps.valign;
	        var video = widgetProps.video;
	
	
	        brandingPrimary = brandingPrimary || theme.defaultBranding.brandingPrimary;
	        brandingSecondary = brandingSecondary || theme.defaultBranding.brandingSecondary;
	
	        var Title = _StyledUI.styledUI.getCustomComponent({ theme: theme }, 'title', _this2.props.widgetProps);
	        var _brandingProps = _extends({}, theme.brandingProps, brandingProps, {
	            additionalContent: brandingAdditionalContent
	        });
	
	        return _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	                Wrapper,
	                {
	                    className: 'sm-wdp',
	                    widgetColors: theme.customColors || _this2.state.theme.widgetsColors[_lodash2.default.get(_this2, 'props.widgetProps.name', _lodash2.default.get(_this2, 'props.widgetProps.widget'))],
	                    wcwidth: widgetProps.wcwidth
	                },
	                _react2.default.createElement(
	                    BackgroundContainer,
	                    null,
	                    _this2.renderBackgroundLayers()
	                ),
	                _react2.default.createElement(
	                    TwoColumnContainer,
	                    _extends({
	                        style: { visibility: video ? 'hidden' : 'visible' },
	                        className: 'sm-wdp__container'
	                    }, contentProps),
	                    _react2.default.createElement(
	                        SecondaryBlock,
	                        _extends({}, secondaryContentProps, { weight: weight }),
	                        _react2.default.createElement(Title, {
	                            className: 'secondary-block-title',
	                            titleImage: _this2.props.titleImage,
	                            title: _this2.props.title,
	                            subTitle: _this2.props.subTitle
	                        }),
	                        _react2.default.createElement(
	                            Content,
	                            contentProps,
	                            secondaryContent
	                        ),
	                        !disableBranding && _react2.default.createElement(
	                            _Branding2.default,
	                            { alignment: 'center' },
	                            brandingSecondary
	                        )
	                    ),
	                    _react2.default.createElement(
	                        PrimaryBlock,
	                        { weight: weight, valign: valign, reverse: _brandingProps.position === 'top' },
	                        _react2.default.createElement(
	                            Content,
	                            contentProps,
	                            primaryContent
	                        ),
	                        !disableBranding && _react2.default.createElement(
	                            _Branding2.default,
	                            _brandingProps,
	                            brandingPrimary
	                        )
	                    )
	                ),
	                _this2.renderTopLevelLayers(),
	                _react2.default.createElement(_AnimationControls2.default, _lodash2.default.pick(_this2.props.widgetProps, ['screencast', 'startAnimation', 'video', 'smBrowser', 'noAnimationControls'])),
	                _react2.default.createElement(_ConstantlyMovingBar2.default, { screencast: screencast })
	            )
	        );
	    };
	
	    this.render = function () {
	        // const { video, output } = this.props.widgetProps;
	        // if (output === 'sm' && video) return this.widgetCanNotBeRenderedMessage();
	        var oneColumn = _this2.props.secondaryContent.props.empty;
	        if (oneColumn) return _this2.renderOneColumn();
	        return _this2.renderSpitImage();
	    };
	};
	
	SplitImageTPL.spec = {};
	
	exports.default = SplitImageTPL;
	exports.theme = defTheme;
	exports.SplitImageTPL = SplitImageTPL;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	module.exports = {
	    init: function init(window) {
	        var exportsBackup = module.exports;
	        (function () {
	            function aa(a, b, c) {
	                return a.call.apply(a.bind, arguments);
	            }function ba(a, b, c) {
	                if (!a) throw Error();if (2 < arguments.length) {
	                    var d = Array.prototype.slice.call(arguments, 2);return function () {
	                        var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
	                    };
	                }return function () {
	                    return a.apply(b, arguments);
	                };
	            }function p(a, b, c) {
	                p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;return p.apply(null, arguments);
	            }var q = Date.now || function () {
	                return +new Date();
	            };function ca(a, b) {
	                this.a = a;this.m = b || a;this.c = this.m.document;
	            }var da = !!window.FontFace;function t(a, b, c, d) {
	                b = a.c.createElement(b);if (c) for (var e in c) {
	                    c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
	                }d && b.appendChild(a.c.createTextNode(d));return b;
	            }function u(a, b, c) {
	                a = a.c.getElementsByTagName(b)[0];a || (a = document.documentElement);a.insertBefore(c, a.lastChild);
	            }function v(a) {
	                a.parentNode && a.parentNode.removeChild(a);
	            }
	            function w(a, b, c) {
	                b = b || [];c = c || [];for (var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1) {
	                    for (var f = !1, g = 0; g < d.length; g += 1) {
	                        if (b[e] === d[g]) {
	                            f = !0;break;
	                        }
	                    }f || d.push(b[e]);
	                }b = [];for (e = 0; e < d.length; e += 1) {
	                    f = !1;for (g = 0; g < c.length; g += 1) {
	                        if (d[e] === c[g]) {
	                            f = !0;break;
	                        }
	                    }f || b.push(d[e]);
	                }a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
	            }function y(a, b) {
	                for (var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++) {
	                    if (c[d] == b) return !0;
	                }return !1;
	            }
	            function z(a) {
	                if ("string" === typeof a.f) return a.f;var b = a.m.location.protocol;"about:" == b && (b = a.a.location.protocol);return "https:" == b ? "https:" : "http:";
	            }function ea(a) {
	                return a.m.location.hostname || a.a.location.hostname;
	            }
	            function A(a, b, c) {
	                function d() {
	                    k && e && f && (k(g), k = null);
	                }b = t(a, "link", { rel: "stylesheet", href: b, media: "all" });var e = !1,
	                    f = !0,
	                    g = null,
	                    k = c || null;da ? (b.onload = function () {
	                    e = !0;d();
	                }, b.onerror = function () {
	                    e = !0;g = Error("Stylesheet failed to load");d();
	                }) : setTimeout(function () {
	                    e = !0;d();
	                }, 0);u(a, "head", b);
	            }
	            function B(a, b, c, d) {
	                var e = a.c.getElementsByTagName("head")[0];if (e) {
	                    var f = t(a, "script", { src: b }),
	                        g = !1;f.onload = f.onreadystatechange = function () {
	                        g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
	                    };e.appendChild(f);setTimeout(function () {
	                        g || (g = !0, c && c(Error("Script load timeout")));
	                    }, d || 5E3);return f;
	                }return null;
	            };function C() {
	                this.a = 0;this.c = null;
	            }function D(a) {
	                a.a++;return function () {
	                    a.a--;E(a);
	                };
	            }function F(a, b) {
	                a.c = b;E(a);
	            }function E(a) {
	                0 == a.a && a.c && (a.c(), a.c = null);
	            };function G(a) {
	                this.a = a || "-";
	            }G.prototype.c = function (a) {
	                for (var b = [], c = 0; c < arguments.length; c++) {
	                    b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
	                }return b.join(this.a);
	            };function H(a, b) {
	                this.c = a;this.f = 4;this.a = "n";var c = (b || "n4").match(/^([nio])([1-9])$/i);c && (this.a = c[1], this.f = parseInt(c[2], 10));
	            }function fa(a) {
	                return I(a) + " " + (a.f + "00") + " 300px " + J(a.c);
	            }function J(a) {
	                var b = [];a = a.split(/,\s*/);for (var c = 0; c < a.length; c++) {
	                    var d = a[c].replace(/['"]/g, "");-1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
	                }return b.join(",");
	            }function K(a) {
	                return a.a + a.f;
	            }function I(a) {
	                var b = "normal";"o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");return b;
	            }
	            function ga(a) {
	                var b = 4,
	                    c = "n",
	                    d = null;a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));return c + b;
	            };function ha(a, b) {
	                this.c = a;this.f = a.m.document.documentElement;this.h = b;this.a = new G("-");this.j = !1 !== b.events;this.g = !1 !== b.classes;
	            }function ia(a) {
	                a.g && w(a.f, [a.a.c("wf", "loading")]);L(a, "loading");
	            }function M(a) {
	                if (a.g) {
	                    var b = y(a.f, a.a.c("wf", "active")),
	                        c = [],
	                        d = [a.a.c("wf", "loading")];b || c.push(a.a.c("wf", "inactive"));w(a.f, c, d);
	                }L(a, "inactive");
	            }function L(a, b, c) {
	                if (a.j && a.h[b]) if (c) a.h[b](c.c, K(c));else a.h[b]();
	            };function ja() {
	                this.c = {};
	            }function ka(a, b, c) {
	                var d = [],
	                    e;for (e in b) {
	                    if (b.hasOwnProperty(e)) {
	                        var f = a.c[e];f && d.push(f(b[e], c));
	                    }
	                }return d;
	            };function N(a, b) {
	                this.c = a;this.f = b;this.a = t(this.c, "span", { "aria-hidden": "true" }, this.f);
	            }function O(a) {
	                u(a.c, "body", a.a);
	            }function P(a) {
	                return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + J(a.c) + ";" + ("font-style:" + I(a) + ";font-weight:" + (a.f + "00") + ";");
	            };function Q(a, b, c, d, e, f) {
	                this.g = a;this.j = b;this.a = d;this.c = c;this.f = e || 3E3;this.h = f || void 0;
	            }Q.prototype.start = function () {
	                var a = this.c.m.document,
	                    b = this,
	                    c = q(),
	                    d = new Promise(function (d, e) {
	                    function k() {
	                        q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function (a) {
	                            1 <= a.length ? d() : setTimeout(k, 25);
	                        }, function () {
	                            e();
	                        });
	                    }k();
	                }),
	                    e = new Promise(function (a, d) {
	                    setTimeout(d, b.f);
	                });Promise.race([e, d]).then(function () {
	                    b.g(b.a);
	                }, function () {
	                    b.j(b.a);
	                });
	            };function R(a, b, c, d, e, f, g) {
	                this.v = a;this.B = b;this.c = c;this.a = d;this.s = g || "BESbswy";this.f = {};this.w = e || 3E3;this.u = f || null;this.o = this.j = this.h = this.g = null;this.g = new N(this.c, this.s);this.h = new N(this.c, this.s);this.j = new N(this.c, this.s);this.o = new N(this.c, this.s);a = new H(this.a.c + ",serif", K(this.a));a = P(a);this.g.a.style.cssText = a;a = new H(this.a.c + ",sans-serif", K(this.a));a = P(a);this.h.a.style.cssText = a;a = new H("serif", K(this.a));a = P(a);this.j.a.style.cssText = a;a = new H("sans-serif", K(this.a));a = P(a);this.o.a.style.cssText = a;O(this.g);O(this.h);O(this.j);O(this.o);
	            }var S = { D: "serif", C: "sans-serif" },
	                T = null;function U() {
	                if (null === T) {
	                    var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
	                }return T;
	            }R.prototype.start = function () {
	                this.f.serif = this.j.a.offsetWidth;this.f["sans-serif"] = this.o.a.offsetWidth;this.A = q();la(this);
	            };
	            function ma(a, b, c) {
	                for (var d in S) {
	                    if (S.hasOwnProperty(d) && b === a.f[S[d]] && c === a.f[S[d]]) return !0;
	                }return !1;
	            }function la(a) {
	                var b = a.g.a.offsetWidth,
	                    c = a.h.a.offsetWidth,
	                    d;(d = b === a.f.serif && c === a.f["sans-serif"]) || (d = U() && ma(a, b, c));d ? q() - a.A >= a.w ? U() && ma(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : na(a) : V(a, a.v);
	            }function na(a) {
	                setTimeout(p(function () {
	                    la(this);
	                }, a), 50);
	            }function V(a, b) {
	                setTimeout(p(function () {
	                    v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a);
	                }, a), 0);
	            };function W(a, b, c) {
	                this.c = a;this.a = b;this.f = 0;this.o = this.j = !1;this.s = c;
	            }var X = null;W.prototype.g = function (a) {
	                var b = this.a;b.g && w(b.f, [b.a.c("wf", a.c, K(a).toString(), "active")], [b.a.c("wf", a.c, K(a).toString(), "loading"), b.a.c("wf", a.c, K(a).toString(), "inactive")]);L(b, "fontactive", a);this.o = !0;oa(this);
	            };
	            W.prototype.h = function (a) {
	                var b = this.a;if (b.g) {
	                    var c = y(b.f, b.a.c("wf", a.c, K(a).toString(), "active")),
	                        d = [],
	                        e = [b.a.c("wf", a.c, K(a).toString(), "loading")];c || d.push(b.a.c("wf", a.c, K(a).toString(), "inactive"));w(b.f, d, e);
	                }L(b, "fontinactive", a);oa(this);
	            };function oa(a) {
	                0 == --a.f && a.j && (a.o ? (a = a.a, a.g && w(a.f, [a.a.c("wf", "active")], [a.a.c("wf", "loading"), a.a.c("wf", "inactive")]), L(a, "active")) : M(a.a));
	            };function pa(a) {
	                this.j = a;this.a = new ja();this.h = 0;this.f = this.g = !0;
	            }pa.prototype.load = function (a) {
	                this.c = new ca(this.j, a.context || this.j);this.g = !1 !== a.events;this.f = !1 !== a.classes;qa(this, new ha(this.c, a), a);
	            };
	            function ra(a, b, c, d, e) {
	                var f = 0 == --a.h;(a.f || a.g) && setTimeout(function () {
	                    var a = e || null,
	                        k = d || null || {};if (0 === c.length && f) M(b.a);else {
	                        b.f += c.length;f && (b.j = f);var h,
	                            m = [];for (h = 0; h < c.length; h++) {
	                            var l = c[h],
	                                n = k[l.c],
	                                r = b.a,
	                                x = l;r.g && w(r.f, [r.a.c("wf", x.c, K(x).toString(), "loading")]);L(r, "fontloading", x);r = null;if (null === X) if (window.FontFace) {
	                                var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),
	                                    ya = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
	                                X = x ? 42 < parseInt(x[1], 10) : ya ? !1 : !0;
	                            } else X = !1;X ? r = new Q(p(b.g, b), p(b.h, b), b.c, l, b.s, n) : r = new R(p(b.g, b), p(b.h, b), b.c, l, b.s, a, n);m.push(r);
	                        }for (h = 0; h < m.length; h++) {
	                            m[h].start();
	                        }
	                    }
	                }, 0);
	            }function qa(a, b, c) {
	                var d = [],
	                    e = c.timeout;ia(b);var d = ka(a.a, c, a.c),
	                    f = new W(a.c, b, e);a.h = d.length;b = 0;for (c = d.length; b < c; b++) {
	                    d[b].load(function (b, d, c) {
	                        ra(a, f, b, d, c);
	                    });
	                }
	            };function sa(a, b) {
	                this.c = a;this.a = b;
	            }function ta(a, b, c) {
	                var d = z(a.c);a = (a.a.api || "fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/, "");return d + "//" + a + "/" + b + ".js" + (c ? "?v=" + c : "");
	            }
	            sa.prototype.load = function (a) {
	                function b() {
	                    if (f["__mti_fntLst" + d]) {
	                        var c = f["__mti_fntLst" + d](),
	                            e = [],
	                            h;if (c) for (var m = 0; m < c.length; m++) {
	                            var l = c[m].fontfamily;void 0 != c[m].fontStyle && void 0 != c[m].fontWeight ? (h = c[m].fontStyle + c[m].fontWeight, e.push(new H(l, h))) : e.push(new H(l));
	                        }a(e);
	                    } else setTimeout(function () {
	                        b();
	                    }, 50);
	                }var c = this,
	                    d = c.a.projectId,
	                    e = c.a.version;if (d) {
	                    var f = c.c.m;B(this.c, ta(c, d, e), function (e) {
	                        e ? a([]) : (f["__MonotypeConfiguration__" + d] = function () {
	                            return c.a;
	                        }, b());
	                    }).id = "__MonotypeAPIScript__" + d;
	                } else a([]);
	            };function ua(a, b) {
	                this.c = a;this.a = b;
	            }ua.prototype.load = function (a) {
	                var b,
	                    c,
	                    d = this.a.urls || [],
	                    e = this.a.families || [],
	                    f = this.a.testStrings || {},
	                    g = new C();b = 0;for (c = d.length; b < c; b++) {
	                    A(this.c, d[b], D(g));
	                }var k = [];b = 0;for (c = e.length; b < c; b++) {
	                    if (d = e[b].split(":"), d[1]) for (var h = d[1].split(","), m = 0; m < h.length; m += 1) {
	                        k.push(new H(d[0], h[m]));
	                    } else k.push(new H(d[0]));
	                }F(g, function () {
	                    a(k, f);
	                });
	            };function va(a, b, c) {
	                a ? this.c = a : this.c = b + wa;this.a = [];this.f = [];this.g = c || "";
	            }var wa = "//fonts.googleapis.com/css";function xa(a, b) {
	                for (var c = b.length, d = 0; d < c; d++) {
	                    var e = b[d].split(":");3 == e.length && a.f.push(e.pop());var f = "";2 == e.length && "" != e[1] && (f = ":");a.a.push(e.join(f));
	                }
	            }
	            function za(a) {
	                if (0 == a.a.length) throw Error("No fonts to load!");if (-1 != a.c.indexOf("kit=")) return a.c;for (var b = a.a.length, c = [], d = 0; d < b; d++) {
	                    c.push(a.a[d].replace(/ /g, "+"));
	                }b = a.c + "?family=" + c.join("%7C");0 < a.f.length && (b += "&subset=" + a.f.join(","));0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));return b;
	            };function Aa(a) {
	                this.f = a;this.a = [];this.c = {};
	            }
	            var Ba = { latin: "BESbswy", "latin-ext": "\xE7\xF6\xFC\u011F\u015F", cyrillic: "\u0439\u044F\u0416", greek: "\u03B1\u03B2\u03A3", khmer: "\u1780\u1781\u1782", Hanuman: "\u1780\u1781\u1782" },
	                Ca = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" },
	                Da = { i: "i", italic: "i", n: "n", normal: "n" },
	                Ea = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	            function Fa(a) {
	                for (var b = a.f.length, c = 0; c < b; c++) {
	                    var d = a.f[c].split(":"),
	                        e = d[0].replace(/\+/g, " "),
	                        f = ["n4"];if (2 <= d.length) {
	                        var g;var k = d[1];g = [];if (k) for (var k = k.split(","), h = k.length, m = 0; m < h; m++) {
	                            var l;l = k[m];if (l.match(/^[\w-]+$/)) {
	                                var n = Ea.exec(l.toLowerCase());if (null == n) l = "";else {
	                                    l = n[2];l = null == l || "" == l ? "n" : Da[l];n = n[1];if (null == n || "" == n) n = "4";else var r = Ca[n],
	                                        n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);l = [l, n].join("");
	                                }
	                            } else l = "";l && g.push(l);
	                        }0 < g.length && (f = g);3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = Ba[d[0]]) && (a.c[e] = d));
	                    }a.c[e] || (d = Ba[e]) && (a.c[e] = d);for (d = 0; d < f.length; d += 1) {
	                        a.a.push(new H(e, f[d]));
	                    }
	                }
	            };function Ga(a, b) {
	                this.c = a;this.a = b;
	            }var Ha = { Arimo: !0, Cousine: !0, Tinos: !0 };Ga.prototype.load = function (a) {
	                var b = new C(),
	                    c = this.c,
	                    d = new va(this.a.api, z(c), this.a.text),
	                    e = this.a.families;xa(d, e);var f = new Aa(e);Fa(f);A(c, za(d), D(b));F(b, function () {
	                    a(f.a, f.c, Ha);
	                });
	            };function Ia(a, b) {
	                this.c = a;this.a = b;
	            }Ia.prototype.load = function (a) {
	                var b = this.a.id,
	                    c = this.c.m;b ? B(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function (b) {
	                    if (b) a([]);else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
	                        b = c.Typekit.config.fn;for (var e = [], f = 0; f < b.length; f += 2) {
	                            for (var g = b[f], k = b[f + 1], h = 0; h < k.length; h++) {
	                                e.push(new H(g, k[h]));
	                            }
	                        }try {
	                            c.Typekit.load({ events: !1, classes: !1, async: !0 });
	                        } catch (m) {}a(e);
	                    }
	                }, 2E3) : a([]);
	            };function Ja(a, b) {
	                this.c = a;this.f = b;this.a = [];
	            }Ja.prototype.load = function (a) {
	                var b = this.f.id,
	                    c = this.c.m,
	                    d = this;b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function (b, c) {
	                    for (var g = 0, k = c.fonts.length; g < k; ++g) {
	                        var h = c.fonts[g];d.a.push(new H(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
	                    }a(d.a);
	                }, B(this.c, z(this.c) + (this.f.api || "//f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function (b) {
	                    b && a([]);
	                })) : a([]);
	            };var Y = new pa(window);Y.a.c.custom = function (a, b) {
	                return new ua(b, a);
	            };Y.a.c.fontdeck = function (a, b) {
	                return new Ja(b, a);
	            };Y.a.c.monotype = function (a, b) {
	                return new sa(b, a);
	            };Y.a.c.typekit = function (a, b) {
	                return new Ia(b, a);
	            };Y.a.c.google = function (a, b) {
	                return new Ga(b, a);
	            };var Z = { load: p(Y.load, Y) }; true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return Z;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" !== typeof module && module.exports ? module.exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
	        })();
	
	        var loaderObject = module.exports;
	        module.exports = exportsBackup;
	        return loaderObject;
	    }
	};

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    @keyframes constantlyMovingBarAnimation {\n        to {\n            transform: translate(800px, 0);\n        }\n    }\n    position: absolute;\n    background: tomato;\n    height: 10px;\n    left: 0;\n    width: 100px;\n    bottom: 0;\n    z-index: 30;\n    animation-duration: ', 'ms;\n    animation-name: constantlyMovingBarAnimation;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n'], ['\n    @keyframes constantlyMovingBarAnimation {\n        to {\n            transform: translate(800px, 0);\n        }\n    }\n    position: absolute;\n    background: tomato;\n    height: 10px;\n    left: 0;\n    width: 100px;\n    bottom: 0;\n    z-index: 30;\n    animation-duration: ', 'ms;\n    animation-name: constantlyMovingBarAnimation;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    height: 10px;\n    position: relative;\n'], ['\n    height: 10px;\n    position: relative;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ConstantlyMovingBar = _styledComponents2.default.div(_templateObject, 800 / 60 * 1000);
	
	var ConstantlyMovingBarWrapper = _styledComponents2.default.div(_templateObject2);
	
	var MovingBar = function MovingBar(_ref) {
	    var screencast = _ref.screencast;
	
	    if (!screencast) return null;
	    return _react2.default.createElement(
	        ConstantlyMovingBarWrapper,
	        null,
	        _react2.default.createElement(ConstantlyMovingBar, null)
	    );
	};
	
	exports.default = MovingBar;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    /* background: rgba(0, 0, 0, 0.5); */\n    margin: 0 auto;\n    padding: 10px;\n    justify-content: space-around;\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    font-size: 40px;\n    text-transform: uppercase;\n    z-index: 100000;\n    bottom: 0;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    opacity: 0;\n    transition: all 300ms linear;\n    ', ' a {\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n        text-align: center;\n        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);\n        font-weight: bold;\n        background: white;\n        color: gray;\n        transition: all 300ms linear;\n        opacity: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &:hover {\n            cursor: pointer;\n            color: black;\n            opacity: 1;\n        }\n    }\n\n    /* ----- small btn ------ */\n    width: 70px;\n    height: 70px;\n    font-size: 10px;\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n    pointer-events: all;\n    /* ---------------------- */\n'], ['\n    display: flex;\n    /* background: rgba(0, 0, 0, 0.5); */\n    margin: 0 auto;\n    padding: 10px;\n    justify-content: space-around;\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    font-size: 40px;\n    text-transform: uppercase;\n    z-index: 100000;\n    bottom: 0;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    opacity: 0;\n    transition: all 300ms linear;\n    ', ' a {\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n        text-align: center;\n        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);\n        font-weight: bold;\n        background: white;\n        color: gray;\n        transition: all 300ms linear;\n        opacity: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &:hover {\n            cursor: pointer;\n            color: black;\n            opacity: 1;\n        }\n    }\n\n    /* ----- small btn ------ */\n    width: 70px;\n    height: 70px;\n    font-size: 10px;\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n    pointer-events: all;\n    /* ---------------------- */\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AnimationControlsStyle = _styledComponents2.default.div(_templateObject, function (props) {
	    if (props.pause) {
	        return '\n      opacity: 1;\n      ';
	    }
	});
	
	var AnimationControls = function (_React$Component) {
	    _inherits(AnimationControls, _React$Component);
	
	    function AnimationControls(props) {
	        _classCallCheck(this, AnimationControls);
	
	        var _this = _possibleConstructorReturn(this, (AnimationControls.__proto__ || Object.getPrototypeOf(AnimationControls)).call(this, props));
	
	        _this.handleAnimationCompleted = function () {
	            _this.setState({
	                completed: true,
	                pause: true
	            });
	        };
	
	        _this.handleAnimationRestart = function () {
	            _this.setState({
	                completed: false,
	                pause: false
	            });
	        };
	
	        _this.handleAnimationReset = function () {
	            _this.setState({
	                completed: false,
	                pause: true
	            });
	        };
	
	        _this.handleButtonAction = function () {
	            var _this$state = _this.state,
	                pause = _this$state.pause,
	                completed = _this$state.completed;
	            var noAnimationControls = _this.props.noAnimationControls;
	
	
	            if (noAnimationControls) {
	                window.dispatchEvent(new Event('startAnimation'));
	                return;
	            }
	            if (pause && completed) window.dispatchEvent(new Event('restartAnimation'));
	            if (pause) window.dispatchEvent(new Event('playAnimation'));
	            if (!pause) window.dispatchEvent(new Event('pauseAnimation'));
	        };
	
	        _this.state = {
	            pause: !props.startAnimation
	        };
	        return _this;
	    }
	
	    _createClass(AnimationControls, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('animationCompleted', this.handleAnimationCompleted, false);
	            window.addEventListener('restartAnimation', this.handleAnimationRestart, false);
	            window.addEventListener('resetAnimation', this.handleAnimationReset, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('animationCompleted', this.handleAnimationCompleted, false);
	            window.removeEventListener('restartAnimation', this.handleAnimationRestart, false);
	            window.removeEventListener('resetAnimation', this.handleAnimationReset, false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                pause = _state.pause,
	                completed = _state.completed;
	            var _props = this.props,
	                video = _props.video,
	                screencast = _props.screencast,
	                noAnimationControls = _props.noAnimationControls;
	
	            if (!video || screencast) return null;
	
	            if (noAnimationControls && (!pause || completed)) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                AnimationControlsStyle,
	                { pause: pause, className: 'animation-controls' },
	                _react2.default.createElement(
	                    'a',
	                    {
	                        onClick: function onClick() {
	                            _this2.handleButtonAction();
	                            _this2.setState({
	                                pause: !pause,
	                                completed: completed ? !completed : completed
	                            });
	                        }
	                    },
	                    completed && 'Replay',
	                    pause && !completed && 'Play',
	                    !pause && !completed && 'Pause'
	                )
	            );
	        }
	    }]);
	
	    return AnimationControls;
	}(_react2.default.Component);
	
	exports.default = AnimationControls;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.brandings = exports.defaultOptions = exports.options = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    z-index: 2;\n    background: ', ';\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n\n    padding: ', ';\n    width: ', ';\n    ', ';\n    div {\n        margin: 0 15px;\n    }\n'], ['\n    z-index: 2;\n    background: ', ';\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n\n    padding: ', ';\n    width: ', ';\n    ', ';\n    div {\n        margin: 0 15px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 50 %;\n    top: 50 %;\n    transform: translate(-50 %, -50 %);\n'], ['\n    position: absolute;\n    left: 50 %;\n    top: 50 %;\n    transform: translate(-50 %, -50 %);\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _alka = __webpack_require__(1411);
	
	var _alka2 = _interopRequireDefault(_alka);
	
	var _comeon = __webpack_require__(1412);
	
	var _comeon2 = _interopRequireDefault(_comeon);
	
	var _comeon3 = __webpack_require__(1413);
	
	var _comeon4 = _interopRequireDefault(_comeon3);
	
	var _comeon_black = __webpack_require__(1414);
	
	var _comeon_black2 = _interopRequireDefault(_comeon_black);
	
	var _comeon_box = __webpack_require__(1415);
	
	var _comeon_box2 = _interopRequireDefault(_comeon_box);
	
	var _btdk = __webpack_require__(1416);
	
	var _btdk2 = _interopRequireDefault(_btdk);
	
	var _TemplateConstants = __webpack_require__(1417);
	
	var _TemplateConstants2 = _interopRequireDefault(_TemplateConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var getCss = function getCss(props) {
	    var placement = props.placement,
	        position = props.position;
	
	    var styles = {
	        bottom: 'top: auto; bottom: 0;',
	        top: 'top: 0; bottom: auto;',
	        rtl: 'flex-direction: row-reverse;',
	        ltr: 'flex-direction: row;',
	        absolute: 'position: absolute;',
	        relative: 'position: relative;',
	        left: 'justify-content: flex-start;',
	        right: 'justify-content: flex-end;',
	        center: 'justify-content: center;',
	        edges: 'justify-content: space-between;'
	    };
	
	    if (placement === 'relative') {
	        styles.top += 'margin-top: -' + props.theme.contentPadding + 'px;margin-bottom: ' + props.theme.contentPadding + 'px;';
	        styles.bottom += 'margin-bottom: -' + props.theme.contentPadding + 'px;margin-top: ' + props.theme.contentPadding + 'px;';
	        styles.relative += 'margin-left: -' + (props.theme.contentPadding + 15) + 'px;margin-right: -' + (props.theme.contentPadding + 15) + 'px;';
	    }
	
	    return Object.keys(props).reduce(function (total, current) {
	        total += styles[props[current]] || '';
	        return total;
	    }, '');
	};
	
	var brandings = {
	    alka: _react2.default.createElement(_alka2.default, { height: '30px', width: '190px', fill: '#fff' }),
	    btdk: _react2.default.createElement(_btdk2.default, { height: '30px' }),
	    comeon: _react2.default.createElement(_comeon2.default, { height: '40px' }),
	    comeon18: _react2.default.createElement(_comeon4.default, { height: '40px', width: '40px' }),
	    comeon_black: _react2.default.createElement(_comeon_black2.default, { height: '40px' }),
	    comeon_box: _react2.default.createElement(_comeon_box2.default, { height: '40px' })
	};
	
	var BrandingWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.brandingBackground;
	}, function (props) {
	    return props.theme.brandingProps.padding.replace(/([1-9][0-9]+)/g, '$1px');
	}, function (props) {
	    return props.theme.brandingProps.width || 'auto';
	}, function (props) {
	    return props.css;
	});
	
	var AdditionalContent = _styledComponents2.default.div(_templateObject2);
	
	var Branding = function Branding(props) {
	    var children = props.children,
	        visibility = props.visibility,
	        additionalContent = props.additionalContent,
	        theme = props.theme;
	
	    if (visibility === 'hidden') return null;
	
	    var _ref = Array.isArray(children) ? children : [children, null],
	        _ref2 = _slicedToArray(_ref, 2),
	        primary = _ref2[0],
	        secondary = _ref2[1];
	
	    return _react2.default.createElement(
	        BrandingWrapper,
	        { css: getCss(props), style: { height: props.height } },
	        !(visibility === 'secondary') && _react2.default.createElement(
	            'div',
	            null,
	            brandings[primary] || primary
	        ),
	        additionalContent && _react2.default.createElement(
	            AdditionalContent,
	            null,
	            additionalContent
	        ),
	        !(visibility === 'primary') && secondary && _react2.default.createElement(
	            'div',
	            null,
	            brandings[secondary] || secondary
	        )
	    );
	};
	
	var defaultProps = _TemplateConstants2.default.BRANDING;
	
	var options = {
	    position: ['bottom', 'top'],
	    order: ['ltr', 'rtl'],
	    placement: ['relative', 'absolute'],
	    alignment: ['left', 'right', 'center', 'edges'],
	    visibility: ['hidden', 'primary', 'secondary', 'both']
	};
	
	Branding.defaultProps = defaultProps;
	
	Branding.propTypes = {
	    position: _propTypes2.default.oneOf(options['position']),
	    order: _propTypes2.default.oneOf(options['order']),
	    placement: _propTypes2.default.oneOf(options['placement']),
	    alignment: _propTypes2.default.oneOf(options['alignment']),
	    children: _propTypes2.default.array,
	    visibility: _propTypes2.default.oneOf(options['visibility']),
	    height: _propTypes2.default.string,
	    additionalContent: _propTypes2.default.node
	};
	
	exports.default = (0, _styledComponents.withTheme)(Branding);
	exports.options = options;
	exports.defaultOptions = defaultProps;
	exports.brandings = brandings;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ALKALogo;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ALKALogo(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({ x: "0px", y: "0px", viewBox: "0 0 264.816 35.084", enableBackground: "new 0 0 264.816 35.084" }, props),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("path", { d: "M231.238,16.456v3.634h5.203v6.987h4.348V16.455L231.238,16.456L231.238,16.456z M256.367,8.223h-5.096l-8.199,18.854h4.67 l1.354-3.208h9.195l1.426,3.208h5.1L256.367,8.223z M250.449,20.52l3.209-8.34l3.314,8.34H250.449z M225.392,17.703 c0-3.885,2.781-5.74,7.379-5.74c3.137,0,6.309,0.785,6.309,0.785l0.498-3.743c0,0-2.639-0.891-6.914-0.891 c-6.662,0-11.688,3.101-11.688,9.907c0,5.453,3.42,9.162,8.908,9.162c1.354,0,2.639-0.213,2.639-0.213l2.889-4.279 c0,0-2.426,0.679-4.242,0.679C228.349,23.37,225.392,21.732,225.392,17.703 M139.601,8.294v18.783h2.352V10.219h5.635 c3.24,0,4.738,1.211,4.738,4.276c0,2.565-0.963,4.063-5.17,4.063c-1.354,0-4.242-0.179-4.242-0.179l1.533,1.925 c0,0,1.783,0.142,3.031,0.142c5.416,0,7.307-2.675,7.307-6.201c0-3.886-2.176-5.952-6.594-5.952L139.601,8.294L139.601,8.294z M189.357,13.568c0-3.35-2.139-5.273-7.449-5.273h-7.307v18.783h2.387V10.221h4.602c4.348,0,5.271,1.493,5.271,3.633 c0,2.209-0.996,3.564-4.205,3.564h-2.459l7.164,9.659h2.994l-6.488-8.127C187.681,18.63,189.357,16.49,189.357,13.568 M133.007,8.294v11.082c0,3.957-1.746,5.989-5.453,5.989c-3.354,0-5.562-1.676-5.562-5.881V8.294h-2.389v11.582 c0,4.599,2.533,7.38,7.844,7.38c6.629,0,7.947-4.244,7.947-8.162v-10.8H133.007z M213.558,27.077h4.385V8.294h-4.385V27.077z M199.41,8.294h-4.348v18.783h15.326v-3.779H199.41V8.294z M157.919,27.077h13.084v-1.962H160.31v-6.734h9.945V16.49h-9.945v-6.238 h10.48V8.294h-12.869L157.919,27.077L157.919,27.077z M109.482,16.49c-2.922-0.605-5.49-1.105-5.49-3.565 c0-2.138,1.928-2.887,5.205-2.887c2.674,0,5.703,0.463,5.703,0.463l0.285-1.853c0,0-2.496-0.569-5.846-0.569 c-4.85,0-7.701,1.317-7.701,4.991c0,4.169,3.637,4.812,7.559,5.629c2.891,0.607,4.881,1.035,4.881,3.494 c0,2.352-1.674,3.101-5.199,3.101c-3.029,0-6.561-0.606-6.561-0.606l-0.25,1.998c0,0,3.352,0.57,6.451,0.57 c5.988,0,7.949-1.925,7.949-5.384C116.468,17.917,113.794,17.383,109.482,16.49" })
	        ),
	        _react2.default.createElement("path", { d: "M81.605,0l-2.846,11.188L73.023,3.75L81.605,0z M78.759,28.207l-14.893,6.877l32.805-6.007L61.867,6.225L78.759,28.207z" }),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("path", { d: "M29.486,19.864c-0.088-0.113-0.061-0.261,0.019-0.343c0.076-0.078,6.874-7.166,6.874-7.166 c0.077-0.078,0.186-0.127,0.305-0.127l5.211-0.002c0.142,0,0.207,0.168,0.109,0.269c-0.083,0.086-6.645,6.933-6.721,7.011 c-0.076,0.079-0.1,0.229-0.01,0.34c0.104,0.127,6.648,8.322,6.736,8.43c0.086,0.105,0.014,0.259-0.119,0.259 c-0.115,0-5.207,0.001-5.207,0.001c-0.137,0-0.248-0.059-0.334-0.165S29.547,19.943,29.486,19.864" }),
	            _react2.default.createElement("path", { d: "M17.865,28.27c0,0.146,0.117,0.265,0.266,0.265h3.682c0.145,0,0.263-0.117,0.263-0.263V5.128 c0-0.141-0.114-0.264-0.263-0.264h-3.684c-0.141,0-0.264,0.12-0.264,0.261V28.27z" }),
	            _react2.default.createElement("path", { d: "M29.96,26.167c0,1.452-1.177,2.629-2.629,2.629s-2.629-1.177-2.629-2.629s1.177-2.629,2.629-2.629 S29.96,24.715,29.96,26.167" }),
	            _react2.default.createElement("path", { d: "M29.185,13.598c0,0,0.709-4.798,0.773-6.363V7.227c-0.004-1.449-1.179-2.625-2.631-2.625c-1.45,0-2.626,1.176-2.629,2.625 v0.008c0.062,1.627,0.794,6.412,0.794,6.412l1.29,7.851c0.045,0.28,0.295,0.463,0.546,0.463c0.237,0,0.493-0.17,0.545-0.459 L29.185,13.598z" }),
	            _react2.default.createElement("path", { d: "M9.457,12.23H2.366c-0.151,0-0.267,0.121-0.267,0.26v2.633c0,0.148,0.123,0.264,0.264,0.264h6.619 c1.021,0,2.057,0.891,2.057,2.043c0,0.143,0.001,0.584,0.001,0.849c0,0.132-0.116,0.265-0.261,0.265l-2.92-0.002 c-2.303,0-3.932,0.327-5.271,0.941C1.021,20.205,0,21.755,0,23.54c0,1.5,0.688,2.649,1.667,3.483 c1.793,1.527,5.682,2.164,13.359,1.507c0.1-0.009,0.215-0.107,0.215-0.259l0.001-10.262C15.242,15.003,12.861,12.23,9.457,12.23 M11.038,25.604c0,0.136-0.104,0.223-0.198,0.232c-0.513,0.059-3.917,0.244-5.188-0.408c-0.842-0.431-1.188-1.326-1.188-1.889 c0-0.688,0.4-1.374,1.104-1.698c0.572-0.264,1.268-0.407,2.313-0.407h2.896c0.142,0,0.262,0.115,0.262,0.262L11.038,25.604 L11.038,25.604z" }),
	            _react2.default.createElement("path", { d: "M52.029,12.23h-7.092c-0.149,0-0.267,0.121-0.267,0.26v2.633c0,0.148,0.123,0.264,0.265,0.264h6.617 c1.022,0,2.057,0.891,2.057,2.043c0,0.143,0.004,0.584,0.004,0.849c0,0.132-0.116,0.265-0.262,0.265l-2.918-0.002 c-2.307,0-3.936,0.327-5.271,0.941c-1.568,0.723-2.589,2.272-2.589,4.058c0,1.5,0.688,2.649,1.667,3.483 c1.794,1.527,5.683,2.164,13.359,1.507c0.101-0.009,0.217-0.107,0.217-0.259V18.01C57.814,15.003,55.435,12.23,52.029,12.23 M53.611,25.604c0,0.136-0.106,0.223-0.198,0.232c-0.513,0.059-3.916,0.244-5.188-0.408c-0.843-0.431-1.187-1.326-1.187-1.889 c0-0.688,0.399-1.374,1.104-1.698c0.57-0.264,1.267-0.407,2.312-0.407h2.895c0.142,0,0.262,0.115,0.262,0.262V25.604z" })
	        )
	    );
	}

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ComeOnLogo;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComeOnLogo(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({ x: "0px", y: "0px", viewBox: "0 0 453.5 75.9", enableBackground: "0 0 453.5 75.9" }, props),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("path", {
	                fill: "#F9F9F9",
	                d: "M32.2,26.4c6.2,0,11.6,3.3,14.7,8.2l8.4-13.3c-5.8-6-14-9.8-23.1-9.8C14.4,11.5,0,26,0,43.7 s14.4,32.2,32.2,32.2c8.9,0,17-3.6,22.8-9.5l-8.4-13.2c-3.1,4.7-8.4,7.8-14.4,7.8c-9.5,0-17.3-7.7-17.3-17.3S22.6,26.4,32.2,26.4z"
	            }),
	            _react2.default.createElement("path", {
	                fill: "#F9F9F9",
	                d: "M91.9,11.5c-10.3,0-19.5,4.9-25.4,12.5c-1.8,2.3-3.3,4.9-4.4,7.6c-1.5,3.7-2.3,7.8-2.3,12s0.8,8.3,2.3,12 c1.1,2.7,2.6,5.3,4.4,7.6c5.9,7.6,15.1,12.5,25.5,12.5c17.7,0,32.2-14.4,32.2-32.2S109.6,11.5,91.9,11.5z M91.9,60.9 c-4.7,0-8.9-1.9-12-4.9c-3.2-3.1-5.2-7.5-5.2-12.3c0-4.8,1.9-9.1,5.1-12.2c3.1-3.1,7.4-5.1,12.2-5.1c9.5,0,17.3,7.7,17.3,17.3 S101.4,60.9,91.9,60.9z"
	            }),
	            _react2.default.createElement("path", {
	                fill: "#F9F9F9",
	                d: "M287.5,39.4c-0.7-8.1-4.1-15.1-9.8-20.3c-5.5-4.9-12.9-7.6-20.7-7.6c-8.4,0-16.1,3.3-21.9,9.2 c-5.9,6.1-9.1,14.3-9.1,23.3c0,9.4,3.4,17.5,9.8,23.3c5.9,5.4,14,8.4,22.7,8.4c10.8,0,19.6-3.7,26.1-11l-10.5-9.3 c-3.8,4.2-9.1,6.3-15.5,6.3c-4,0-8-1.2-11.2-3.3c-3.4-2.2-5.7-5.3-6.8-8.9l-0.1-0.4l46.9,0C287.3,49.4,288,45,287.5,39.4z M257,25 c4.4,0,8.4,1.5,11.4,4.3c2.4,2.3,4.2,5.4,5,8.8h-33C241.8,31.6,247.8,25,257,25z"
	            }),
	            _react2.default.createElement("path", {
	                fill: "#F9F9F9",
	                d: "M191.9,11.9c-6.5,0-12.4,2.5-16.8,6.7c-4.4-4.2-10.3-6.7-16.8-6.7c-13.5,0-24.4,10.9-24.4,24.4v37.7h15.3V60.3 V36.4v0h0c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2h0v0v23.9v13.8h15.3V60.3V36.4v0h0c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2h0 v0v23.9v13.8h15.3V36.4C216.3,22.9,205.4,11.9,191.9,11.9z"
	            })
	        ),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("path", {
	                fill: "#8EB50D",
	                d: "M398.5,11.5c-15.7,0-28.4,11.5-28.4,27.2v35.4h16.1V39.3c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.6,12.4,12.4 v34.8h16.1V38.7C426.9,23.1,414.2,11.5,398.5,11.5z"
	            }),
	            _react2.default.createElement("path", {
	                fill: "#8EB50D",
	                d: "M328.5,11.5c-17.7,0-32.2,14.4-32.2,32.2s14.4,32.2,32.2,32.2c17.7,0,32.2-14.4,32.2-32.2 S346.2,11.5,328.5,11.5z M328.5,60.9c-9.5,0-17.3-7.7-17.3-17.3s7.7-17.3,17.3-17.3s17.3,7.7,17.3,17.3S338,60.9,328.5,60.9z"
	            }),
	            _react2.default.createElement(
	                "g",
	                null,
	                _react2.default.createElement("rect", { x: "438.5", y: "60.1", fill: "#8EB50D", width: "15", height: "14" }),
	                _react2.default.createElement("polygon", { fill: "#8EB50D", points: "453.1,50.1 439,50.1 438.6,0.4 453.5,0.4 \t\t" })
	            )
	        )
	    );
	}

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ComeOn18Logo;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComeOn18Logo(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            x: "0px",
	            y: "0px",
	            width: "150px",
	            height: "150px",
	            viewBox: "0 0 150 150",
	            enableBackground: "0 0 150 150"
	        }, props),
	        _react2.default.createElement(
	            "g",
	            { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { transform: "translate(3.000000, 3.000000)", fill: "#FFFFFF", fillRule: "nonzero" },
	                _react2.default.createElement("path", {
	                    d: "M72,5.76 C108.576,5.76 138.24,35.424 138.24,72 C138.24,108.576 108.576,138.24 72,138.24 C35.424,138.24 5.76,108.576 5.76,72 C5.76,35.424 35.424,5.76 72,5.76 Z M72,0 C32.256,0 0,32.256 0,72 C0,111.744 32.256,144 72,144 C111.744,144 144,111.744 144,72 C144,32.256 111.744,0 72,0 Z",
	                    id: "a"
	                }),
	                _react2.default.createElement("path", {
	                    d: "M72,14.0059172 C103.926036,14.0059172 129.994083,40.0739645 129.994083,72 C129.994083,103.926036 103.926036,129.994083 72,129.994083 C40.0739645,129.994083 14.0059172,103.926036 14.0059172,72 C14.0059172,40.0739645 40.0739645,14.0059172 72,14.0059172 Z M72,11.0769231 C38.316568,11.0769231 11.0769231,38.316568 11.0769231,72 C11.0769231,105.683432 38.316568,132.923077 72,132.923077 C105.683432,132.923077 132.923077,105.683432 132.923077,72 C132.923077,38.316568 105.683432,11.0769231 72,11.0769231 Z",
	                    id: "b"
	                }),
	                _react2.default.createElement("polygon", {
	                    id: "c",
	                    points: "44.3076923 84.9230769 44.3076923 81.0161002 48.7384615 81.0161002 48.7384615 63.8855098 44.3076923 63.8855098 44.3076923 60.5796064 54.0553846 59.0769231 54.0553846 81.0161002 59.0769231 81.0161002 59.0769231 84.9230769"
	                }),
	                _react2.default.createElement("path", {
	                    d: "M71.994796,84.9230769 C68.8235079,84.9230769 62.7692308,83.761452 62.7692308,78.53414 C62.7692308,74.1780467 65.9405188,73.306828 67.9586112,72.4356093 L67.9586112,72.1452031 C66.5171166,71.8547969 63.0575297,69.8219533 63.0575297,66.0466724 C63.0575297,61.4001729 67.0937145,59.0769231 71.7064971,59.0769231 C76.3192797,59.0769231 80.0671656,61.1097666 80.0671656,65.46586 C80.0671656,68.3699222 77.7607742,69.8219533 75.4543829,70.4027658 L75.4543829,70.693172 C76.6075786,70.9835782 81.2203612,72.4356093 81.2203612,77.6629213 C81.5086601,83.1806396 75.7426819,84.9230769 71.994796,84.9230769 Z M71.7064971,73.5972342 C70.5533014,74.1780467 67.6703123,75.0492653 67.6703123,77.6629213 C67.6703123,80.5669836 70.2650025,81.4382022 71.7064971,81.4382022 C73.4362906,81.4382022 76.0309808,80.5669836 76.0309808,77.3725151 C76.3192797,74.7588591 72.5713938,74.1780467 71.7064971,73.5972342 Z M71.7064971,62.2713915 C69.9767036,62.2713915 68.2469101,63.1426102 68.2469101,65.7562662 C68.2469101,68.3699222 71.4181982,69.2411409 72.2830949,69.5315471 C73.1479916,69.5315471 75.7426819,68.079516 75.7426819,65.7562662 C75.166084,63.1426102 73.7245895,62.2713915 71.7064971,62.2713915 Z",
	                    id: "d"
	                }),
	                _react2.default.createElement("polygon", {
	                    id: "e",
	                    points: "98.1538462 76.0615385 98.1538462 84.9230769 93.8461538 84.9230769 93.8461538 76.0615385 84.9230769 76.0615385 84.9230769 71.6307692 93.8461538 71.6307692 93.8461538 62.7692308 98.1538462 62.7692308 98.1538462 71.6307692 107.076923 71.6307692 107.076923 76.0615385"
	                })
	            )
	        )
	    );
	}

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ComeOnLogoBlack;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComeOnLogoBlack(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({ x: "0px", y: "0px", viewBox: "0 0 453.5 75.9", enableBackground: "0 0 453.5 75.9" }, props),
	        _react2.default.createElement("path", {
	            fill: "#282B33",
	            d: "M32.2,26c6.2,0,11.6,3.3,14.7,8.2l8.4-13.3c-5.8-6-14-9.8-23.1-9.8C14.4,11.1,0,25.6,0,43.3 s14.4,32.2,32.2,32.2c8.9,0,17-3.6,22.8-9.5l-8.4-13.2c-3.1,4.7-8.4,7.8-14.4,7.8c-9.5,0-17.3-7.7-17.3-17.3S22.6,26,32.2,26z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#8EB50D",
	            d: "M398.5,11.1c-15.7,0-28.4,11.5-28.4,27.2v35.4h16.1V38.9c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.6,12.4,12.4 v34.8h16.1V38.3C426.9,22.7,414.2,11.1,398.5,11.1z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#282B33",
	            d: "M91.9,11.1c-10.3,0-19.5,4.9-25.4,12.5c-1.8,2.3-3.3,4.9-4.4,7.6c-1.5,3.7-2.3,7.8-2.3,12s0.8,8.3,2.3,12 c1.1,2.7,2.6,5.3,4.4,7.6c5.9,7.6,15.1,12.5,25.5,12.5c17.7,0,32.2-14.4,32.2-32.2S109.6,11.1,91.9,11.1z M91.9,60.5 c-4.7,0-8.9-1.9-12-4.9c-3.2-3.1-5.2-7.5-5.2-12.3c0-4.8,1.9-9.1,5.1-12.2C82.8,28,87.1,26,91.9,26c9.5,0,17.3,7.7,17.3,17.3 S101.4,60.5,91.9,60.5z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#8EB50D",
	            d: "M328.5,11.1c-17.7,0-32.2,14.4-32.2,32.2s14.4,32.2,32.2,32.2c17.7,0,32.2-14.4,32.2-32.2 S346.2,11.1,328.5,11.1z M328.5,60.5c-9.5,0-17.3-7.7-17.3-17.3S319,26,328.5,26s17.3,7.7,17.3,17.3S338,60.5,328.5,60.5z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#282B33",
	            d: "M287.5,39c-0.7-8.1-4.1-15.1-9.8-20.3c-5.5-4.9-12.9-7.6-20.7-7.6c-8.4,0-16.1,3.3-21.9,9.2 c-5.9,6.1-9.1,14.3-9.1,23.3c0,9.4,3.4,17.5,9.8,23.3c5.9,5.4,14,8.4,22.7,8.4c10.8,0,19.6-3.7,26.1-11l-10.5-9.3 c-3.8,4.2-9.1,6.3-15.5,6.3c-4,0-8-1.2-11.2-3.3c-3.4-2.2-5.7-5.3-6.8-8.9l-0.1-0.4l46.9,0C287.3,48.9,288,44.6,287.5,39z M257,24.6 c4.4,0,8.4,1.5,11.4,4.3c2.4,2.3,4.2,5.4,5,8.8h-33C241.8,31.2,247.8,24.6,257,24.6z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#282B33",
	            d: "M191.9,11.5c-6.5,0-12.4,2.5-16.8,6.7c-4.4-4.2-10.3-6.7-16.8-6.7c-13.5,0-24.4,10.9-24.4,24.4v37.7h15.3V59.8 V36v0h0c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2h0v0v23.9v13.8h15.3V59.8V36v0h0c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2h0v0 v23.9v13.8h15.3V36C216.3,22.5,205.4,11.5,191.9,11.5z"
	        }),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", { x: "438.5", y: "59.7", fill: "#8EB50D", width: "15", height: "14" }),
	            _react2.default.createElement("polygon", { fill: "#8EB50D", points: "453.1,49.7 439,49.7 438.6,0 453.5,0 \t" })
	        )
	    );
	}

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ComeOnLogoBox;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComeOnLogoBox(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({ x: "0px", y: "0px", viewBox: "0 0 400 130.1", enableBackground: "0 0 400 130.1" }, props),
	        _react2.default.createElement("path", {
	            fill: "#282B33",
	            d: "M387,0H13C5.8,0,0,5.8,0,13v104.1c0,7.2,5.8,13,13,13h374c7.2,0,13-5.8,13-13V13C400,5.8,394.1,0,387,0z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#F9F9F9",
	            d: "M58.1,78.3c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3c4.4,0,8.3,2.3,10.4,5.8l6-9.4 c-4.2-4.3-10-7-16.4-7c-12.6,0-22.9,10.3-22.9,22.9s10.3,22.9,22.9,22.9c6.3,0,12.1-2.6,16.2-6.8l-5.9-9.4 C66.2,76.1,62.4,78.3,58.1,78.3z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#8EB50D",
	            d: "M318.5,43.2c-11.1,0-20.2,8.2-20.2,19.3v25.1h11.4V62.9c0-4.8,3.9-8.8,8.8-8.8c4.8,0,8.8,4,8.8,8.8v24.7h11.4 V62.5C338.6,51.4,329.6,43.2,318.5,43.2z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#F9F9F9",
	            d: "M100.6,43.2c-7.3,0-13.9,3.5-18.1,8.9c-1.3,1.6-2.3,3.5-3.1,5.4c-1.1,2.6-1.7,5.5-1.7,8.6c0,3,0.6,5.9,1.7,8.6 c0.8,1.9,1.8,3.8,3.1,5.4c4.2,5.4,10.7,8.9,18.1,8.9c12.6,0,22.9-10.3,22.9-22.9S113.2,43.2,100.6,43.2z M100.6,78.3 c-3.3,0-6.3-1.3-8.5-3.5c-2.3-2.2-3.7-5.3-3.7-8.8c0-3.4,1.4-6.4,3.6-8.7c2.2-2.2,5.3-3.6,8.7-3.6c6.8,0,12.3,5.5,12.3,12.3 C112.9,72.8,107.4,78.3,100.6,78.3z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#8EB50D",
	            d: "M268.7,43.2c-12.6,0-22.9,10.3-22.9,22.9s10.3,22.9,22.9,22.9s22.9-10.3,22.9-22.9S281.3,43.2,268.7,43.2z M268.7,78.3c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3S281,59.3,281,66C281,72.8,275.5,78.3,268.7,78.3z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#F9F9F9",
	            d: "M239.6,63c-0.5-5.8-2.9-10.8-7-14.4c-3.9-3.5-9.2-5.4-14.7-5.4c-5.9,0-11.5,2.3-15.6,6.6 c-4.2,4.3-6.5,10.2-6.5,16.6c0,6.7,2.4,12.4,6.9,16.6c4.2,3.9,9.9,6,16.1,6c7.7,0,13.9-2.6,18.6-7.8l-7.4-6.6c-2.7,3-6.4,4.5-11,4.5 c-2.9,0-5.7-0.8-8-2.3c-2.4-1.6-4.1-3.7-4.8-6.3l-0.1-0.3l33.3,0C239.5,70.1,239.9,67,239.6,63z M206.1,62c1-4.6,5.3-9.3,11.8-9.3 c3.2,0,6,1.1,8.1,3.1c1.7,1.6,3,3.8,3.6,6.2H206.1z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "#F9F9F9",
	            d: "M171.6,43.5c-4.6,0-8.8,1.8-11.9,4.8c-3.1-2.9-7.3-4.8-11.9-4.8c-9.6,0-17.4,7.8-17.4,17.4v26.8h10.8v-9.8v-17 v0h0c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5h0v0v17v9.8h10.8v-9.8v-17v0h0c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5h0v0v17v9.8 H189V60.8C189,51.3,181.2,43.5,171.6,43.5z"
	        }),
	        _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", { x: "346.9", y: "77.7", fill: "#8EB50D", width: "10.6", height: "9.9" }),
	            _react2.default.createElement("polygon", { fill: "#8EB50D", points: "357.3,70.6 357.6,35.3 346.9,35.3 347.3,70.6 \t" })
	        )
	    );
	}

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = btlogo;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function btlogo(props) {
	    var fill = props.fill;
	    return _react2.default.createElement(
	        "svg",
	        _extends({}, props, { viewBox: "0 0 1920 630.66" }),
	        _react2.default.createElement("path", { d: "M130.117,506.609V124.046h454.644c214.565,0,238.965,9.981,238.965,83.163c0,63.759-26.614,83.723-172.434,83.723h-36.591v26.618h36.591c153.581,0,178.529,21.062,178.529,86.491c0,90.926-44.911,102.568-251.162,102.568H130.117L130.117,506.609z M379.059,277.627H506.58c54.335,0,60.99-10.536,60.99-49.9c0-31.602-10.536-39.918-60.99-39.918H379.059V277.627z M379.059,441.186H506.58c59.328,0,69.311-12.202,69.311-53.232c0-37.698-7.762-51.557-70.418-51.557H379.059V441.186z M1092.631,506.609V203.887H871.405v-79.841h705.796v79.836h-221.766v302.723h-262.805V506.609z" })
	    );
	}

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var config =  true ? __webpack_require__(580).default : require('config');
	
	module.exports = {
	    FONT: {
	        name: 'Roboto',
	        fontFamily: '"Roboto", sans-serif',
	        fontStyle: 'normal',
	        thin: 300,
	        normal: 400,
	        bold: 700,
	        textTransform: '',
	        gFontName: 'Roboto',
	        gWeights: '300,400,700',
	        gSubsets: ''
	    },
	    LAYER: {
	        topOverlay: false,
	        backgroundPositionY: 'center',
	        backgroundPositionX: 'center',
	        backgroundSize: 'cover',
	        opacity: 1,
	        translateY: 50,
	        translateX: 50,
	        scale: 1,
	        backgroundImage: config.assets + '/assets/sm_cover.png'
	    },
	    BRANDING: {
	        position: 'bottom',
	        order: 'ltr',
	        placement: 'relative',
	        alignment: 'edges',
	        visibility: 'both',
	        height: 'auto',
	        width: 'auto',
	        padding: '10 10 10 10'
	    }
	};

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.skins = exports.getDisplayPropType = exports.displayMap = exports.styledUI = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n        font-size: 38px;\n        line-height: 41px;\n        font-weight: 700;\n        text-align: center;\n        padding: 20px 0 30px;\n        margin: 0;\n    '], ['\n        font-size: 38px;\n        line-height: 41px;\n        font-weight: 700;\n        text-align: center;\n        padding: 20px 0 30px;\n        margin: 0;\n    ']),
	    _templateObject3 = _taggedTemplateLiteral(['\n        display: inline-block;\n        .wdp-sm-plr-logo_jersey {\n            padding: 7px;\n        }\n    '], ['\n        display: inline-block;\n        .wdp-sm-plr-logo_jersey {\n            padding: 7px;\n        }\n    ']);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _MainMatchCell = __webpack_require__(1419);
	
	var _MainMatchCell2 = _interopRequireDefault(_MainMatchCell);
	
	var _WHMatchCell = __webpack_require__(1421);
	
	var _WHMatchCell2 = _interopRequireDefault(_WHMatchCell);
	
	var _SkewMatchCell = __webpack_require__(1422);
	
	var _SkewMatchCell2 = _interopRequireDefault(_SkewMatchCell);
	
	var _TextMatchCell = __webpack_require__(1423);
	
	var _TextMatchCell2 = _interopRequireDefault(_TextMatchCell);
	
	var _TextMatchCellCentered = __webpack_require__(1424);
	
	var _TextMatchCellCentered2 = _interopRequireDefault(_TextMatchCellCentered);
	
	var _MainTT = __webpack_require__(1425);
	
	var _MainTT2 = _interopRequireDefault(_MainTT);
	
	var _SimpleTT = __webpack_require__(1434);
	
	var _SimpleTT2 = _interopRequireDefault(_SimpleTT);
	
	var _SkewTT = __webpack_require__(1435);
	
	var _SkewTT2 = _interopRequireDefault(_SkewTT);
	
	var _MainTTStyle = __webpack_require__(1436);
	
	var _MainTTStyle2 = _interopRequireDefault(_MainTTStyle);
	
	var _IncidentWithPhotos = __webpack_require__(1437);
	
	var _IncidentWithPhotos2 = _interopRequireDefault(_IncidentWithPhotos);
	
	var _IncidentWithoutPhotos = __webpack_require__(1441);
	
	var _IncidentWithoutPhotos2 = _interopRequireDefault(_IncidentWithoutPhotos);
	
	var _IncidentStyle = __webpack_require__(1442);
	
	var _IncidentStyle2 = _interopRequireDefault(_IncidentStyle);
	
	var _IncidentStyle3 = __webpack_require__(1443);
	
	var _IncidentStyle4 = _interopRequireDefault(_IncidentStyle3);
	
	var _WHTT = __webpack_require__(1444);
	
	var _WHTT2 = _interopRequireDefault(_WHTT);
	
	var _TextTT = __webpack_require__(1445);
	
	var _TextTT2 = _interopRequireDefault(_TextTT);
	
	var _PlayersListText = __webpack_require__(1446);
	
	var _PlayersListText2 = _interopRequireDefault(_PlayersListText);
	
	var _PlayersListWithChart = __webpack_require__(1447);
	
	var _PlayersListWithChart2 = _interopRequireDefault(_PlayersListWithChart);
	
	var _PlayersListSimple = __webpack_require__(1448);
	
	var _PlayersListSimple2 = _interopRequireDefault(_PlayersListSimple);
	
	var _PlayersListStyle = __webpack_require__(1449);
	
	var _PlayersListStyle2 = _interopRequireDefault(_PlayersListStyle);
	
	var _WHPlayersList = __webpack_require__(1450);
	
	var _WHPlayersList2 = _interopRequireDefault(_WHPlayersList);
	
	var _SkewPlayerList = __webpack_require__(1451);
	
	var _SkewPlayerList2 = _interopRequireDefault(_SkewPlayerList);
	
	var _H2HTableSimple = __webpack_require__(1452);
	
	var _H2HTableSimple2 = _interopRequireDefault(_H2HTableSimple);
	
	var _H2HTableSkew = __webpack_require__(1453);
	
	var _H2HTableSkew2 = _interopRequireDefault(_H2HTableSkew);
	
	var _H2HTableStyle = __webpack_require__(1454);
	
	var _H2HTableStyle2 = _interopRequireDefault(_H2HTableStyle);
	
	var _H2HStyle = __webpack_require__(1455);
	
	var _H2HStyle2 = _interopRequireDefault(_H2HStyle);
	
	var _F1SkewRow = __webpack_require__(1456);
	
	var _F1SkewRow2 = _interopRequireDefault(_F1SkewRow);
	
	var _F1ListRow = __webpack_require__(1458);
	
	var _F1ListRow2 = _interopRequireDefault(_F1ListRow);
	
	var _H2HRadarChart = __webpack_require__(1459);
	
	var _H2HRadarChart2 = _interopRequireDefault(_H2HRadarChart);
	
	var _NationalFlag = __webpack_require__(1461);
	
	var _NationalFlag2 = _interopRequireDefault(_NationalFlag);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _titles = __webpack_require__(1462);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = {
	    Box: _styledComponents2.default.div(_templateObject),
	    H1: _styledComponents2.default.h1(_templateObject2),
	    Logo: _styledComponents2.default.span(_templateObject3)
	};
	
	var StyledUIFactory = function () {
	    function StyledUIFactory() {
	        var _this = this;
	
	        _classCallCheck(this, StyledUIFactory);
	
	        this.displayMap = {
	            title: {
	                default: _titles.Title,
	                'Left Aligned': _titles.LeftAlignedTitle,
	                SkewTitle: _titles.SkewTitle
	            },
	            playersList: {
	                default: _PlayersListSimple2.default, //default is used if no display type matched
	                PlayersListSimple: _PlayersListSimple2.default,
	                PlayersListStyle1: _PlayersListStyle2.default,
	                PlayersListText: _PlayersListText2.default,
	                PlayersListWithChart: _PlayersListWithChart2.default,
	                WHPlayersList: _WHPlayersList2.default,
	                SkewPlayerList: _SkewPlayerList2.default
	            },
	            matchCell: {
	                default: _MainMatchCell2.default,
	                MatchCell: _MainMatchCell2.default,
	                TextMatchCell: _TextMatchCell2.default,
	                TextMatchCellCentered: _TextMatchCellCentered2.default,
	                WHMatchCell: _WHMatchCell2.default,
	                SkewMatchCell: _SkewMatchCell2.default
	            },
	            tournamentTable: {
	                default: _SimpleTT2.default,
	                TournamentTableExtended: _MainTT2.default,
	
	                Simple: _SimpleTT2.default,
	                TournamentTableSkew: _SkewTT2.default,
	                WHTTRow: _WHTT2.default,
	                Textual: _TextTT2.default,
	                TournamentTableStyle1: _MainTTStyle2.default
	            },
	            incidentCard: {
	                default: _IncidentWithoutPhotos2.default,
	                IncidentWithoutPhotos: _IncidentWithoutPhotos2.default,
	                IncidentWithPhotos: _IncidentWithPhotos2.default,
	                IncidentStyle3: _IncidentStyle2.default,
	                IncidentStyle4: _IncidentStyle4.default
	            },
	            playerLogo: {
	                default: _SMPlayerLogo.PlayerLogoJersey,
	                PlayerLogo3DJerseyBack: _SMPlayerLogo.PlayerLogo3DJerseyBack,
	                PlayerLogo3DJerseyFront: _SMPlayerLogo.PlayerLogo3DJerseyBack,
	                PlayerLogoJersey: _SMPlayerLogo.PlayerLogoJersey,
	                PlayerLogoPhoto: _SMPlayerLogo.PlayerLogoPhoto,
	                PlayerLogoSPDKFace: _SMPlayerLogo.PlayerLogoSPDKFace,
	                PlayerRoundedPhoto: _SMPlayerLogo.PlayerRoundedPhoto
	            },
	            teamLogo: {
	                default: _SMTeamLogo.TeamLogo,
	                TeamLogo: _SMTeamLogo.TeamLogo,
	                TeamLogoBlank: _SMTeamLogo.TeamLogoBlank,
	                TeamLogoEmpty: _SMTeamLogo.TeamLogoEmpty
	            },
	            h2hTable: {
	                default: _H2HTableSimple2.default,
	                H2HTableSimple: _H2HTableSimple2.default,
	                H2HTableSkew: _H2HTableSkew2.default,
	                H2HTableStyle3: _H2HTableStyle2.default,
	                H2HStyle4: _H2HStyle2.default,
	                H2HRadarChart: _H2HRadarChart2.default
	            },
	            f1Table: {
	                default: _F1SkewRow2.default
	            },
	            f1List: {
	                default: _F1ListRow2.default
	            },
	            flag: {
	                default: _NationalFlag2.default,
	                skew: _NationalFlag2.default,
	                round: _NationalFlag2.default
	            }
	        };
	        this.skins = [{
	            id: 'default',
	            name: 'Default',
	            displayMap: {
	                title: 'default',
	                playersList: 'default',
	                matchCell: 'default',
	                tournamentTable: 'default',
	                incidentCard: 'default',
	                h2hTable: 'default'
	            }
	        }, {
	            id: 'wh',
	            name: 'WH',
	            displayMap: {
	                title: 'Left Aligned',
	                playersList: 'WHPlayersList',
	                matchCell: 'WHMatchCell',
	                tournamentTable: 'WHTTRow',
	                incidentCard: 'IncidentWithPhotos',
	                h2hTable: 'default'
	            }
	        }, {
	            id: 'sw',
	            name: 'SW',
	            displayMap: {
	                tournamentTable: 'SWTTRow',
	                h2hTable: 'default'
	            }
	        }, {
	            id: 'text',
	            name: 'Textual Skin',
	            displayMap: {
	                title: 'default',
	                playersList: 'PlayersListText',
	                matchCell: 'TextMatchCell',
	                tournamentTable: 'Textual',
	                incidentCard: 'IncidentWithoutPhotos',
	                h2hTable: 'default'
	            }
	        }, {
	            id: 'skew',
	            name: 'Skew Skin',
	            displayMap: {
	                title: 'SkewTitle',
	                tournamentTable: 'TournamentTableSkew',
	                matchCell: 'SkewMatchCell',
	                playersList: 'SkewPlayerList',
	                incidentCard: 'default',
	                h2hTable: 'H2HTableSkew'
	            }
	        }];
	
	        this.getDisplay = function (template, element) {
	            var widgetProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            return _this.getCustomComponent(template, element, widgetProps);
	        };
	
	        this.getStandardComponent = function (template, element) {
	            var widgetProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            return _this.getCustomComponent(template, element, widgetProps);
	        };
	
	        this.getDefaultProp = function (parameter, widgetId, template) {
	            var widgetProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            if (widgetProps[parameter]) return widgetProps[parameter];
	
	            var val = _lodash2.default.get(template, 'widgetProps.' + widgetId + '.' + parameter, widgetProps[parameter]);
	            return val;
	        };
	
	        this.getLayoutType = function (template, element) {
	            var widgetProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        };
	
	        this.getDisplayPropType = this.getDisplayPropType.bind(this);
	    }
	
	    _createClass(StyledUIFactory, [{
	        key: 'getCustomComponentFromTheme',
	        value: function getCustomComponentFromTheme(theme, element, widgetProps) {
	            if (Object.keys(this.displayMap).indexOf(element) === -1) {
	                return null;
	            }
	            //Get display option for element in theme
	            var themeDisplay = _lodash2.default.get(theme, 'display.' + element);
	
	            //Check if widget has custom display property for element
	            var widgetDisplay = _lodash2.default.get(widgetProps, element + 'Display');
	
	            //Get all display options for component
	            var elementDisplayOptions = _lodash2.default.get(this.displayMap, '' + element);
	
	            //Get component with display option from widget custom display or from theme
	            var requestedDisplay = _lodash2.default.get(elementDisplayOptions, widgetDisplay || themeDisplay);
	
	            //If no such display option found, return default display option
	            if (!requestedDisplay) requestedDisplay = _lodash2.default.get(elementDisplayOptions, 'default');
	
	            return requestedDisplay;
	        }
	    }, {
	        key: 'getCustomComponent',
	        value: function getCustomComponent(template, element) {
	            var widgetProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            if (Object.keys(this.displayMap).indexOf(element) === -1) {
	                return null;
	            }
	            //Get display option for element in theme
	            var themeDisplay = _lodash2.default.get(template, 'theme.display.' + element);
	
	            //Check if widget has custom display property for element
	            var widgetDisplay = _lodash2.default.get(widgetProps, element + 'Display');
	
	            //Get all display options for component
	            var elementDisplayOptions = _lodash2.default.get(this.displayMap, '' + element);
	
	            //Get component with display option from widget custom display or from theme
	            var requestedDisplay = _lodash2.default.get(elementDisplayOptions, widgetDisplay || themeDisplay);
	
	            //If no such display option found, return default display option
	            if (!requestedDisplay) requestedDisplay = _lodash2.default.get(elementDisplayOptions, 'default');
	
	            return requestedDisplay;
	        }
	    }, {
	        key: 'getDisplayPropType',
	        value: function getDisplayPropType(element, others) {
	            var label = _lodash2.default.camelCase(element);
	            label = label.charAt(0).toUpperCase() + label.slice(1);
	            return _extends({
	                key: element + 'Display',
	                type: 'select_picker',
	                label: label + ' render component',
	                scope: 'template',
	                defaultValue: null,
	                options: [{ text: 'Inherit from theme', value: null }].concat(_toConsumableArray(Object.keys(this.displayMap[element]).map(function (d) {
	                    return {
	                        text: d,
	                        value: d
	                    };
	                })))
	            }, others);
	        }
	    }]);
	
	    return StyledUIFactory;
	}();
	
	var styledUI = new StyledUIFactory();
	var displayMap = styledUI.displayMap;
	var skins = styledUI.skins;
	var getDisplayPropType = styledUI.getDisplayPropType;
	
	exports.styledUI = styledUI;
	exports.displayMap = displayMap;
	exports.getDisplayPropType = getDisplayPropType;
	exports.skins = skins;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 4px 0;\n'], ['\n    margin: 4px 0;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    padding: 10px 10px;\n    text-align: center;\n'], ['\n    color: ', ';\n    padding: 10px 10px;\n    text-align: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    margin: 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n    }\n    .team-away {\n        text-align: left;\n    }\n'], ['\n    position: relative;\n    margin: 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n    }\n    .team-away {\n        text-align: left;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 24px;\n    font-weight: normal;\n    line-height: 60px;\n    background-color: ', ';\n    color: ', ';\n    & > * {\n        vertical-align: middle;\n        display: inline-block;\n    }\n'], ['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 24px;\n    font-weight: normal;\n    line-height: 60px;\n    background-color: ', ';\n    color: ', ';\n    & > * {\n        vertical-align: middle;\n        display: inline-block;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 120px;\n    height: 60px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    .top-sub-small {\n        font-size: 16px;\n        line-height: 22px;\n        text-transform: uppercase;\n    }\n    .top-sub {\n        font-size: 16px;\n        line-height: 16px;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n    }\n\n    &.__c__b2_style1 {\n        & * {\n            background-color: transparent !important;\n        }\n    }\n\n    .__c__c4_style1 {\n        &,\n        & * {\n            background-color: transparent !important;\n        }\n    }\n\n    * {\n        z-index: 2;\n    }\n'], ['\n    position: relative;\n    width: 120px;\n    height: 60px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    .top-sub-small {\n        font-size: 16px;\n        line-height: 22px;\n        text-transform: uppercase;\n    }\n    .top-sub {\n        font-size: 16px;\n        line-height: 16px;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n    }\n\n    &.__c__b2_style1 {\n        & * {\n            background-color: transparent !important;\n        }\n    }\n\n    .__c__c4_style1 {\n        &,\n        & * {\n            background-color: transparent !important;\n        }\n    }\n\n    * {\n        z-index: 2;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background-color: ', ';\n'], ['\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background-color: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n'], ['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-right: 15px;\n    box-sizing: border-box;\n'], ['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-right: 15px;\n    box-sizing: border-box;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    text-align: left;\n    padding-left: 15px;\n'], ['\n    text-align: left;\n    padding-left: 15px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    color: ', ';\n    padding-bottom: 3px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    i {\n        color: ', ';\n        font-style: normal;\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translate(8px, -50%);\n        font-weight: normal;\n        font-size: 1rem;\n    }\n\n    > * {\n        padding: 6px 0;\n        color: ', ';\n        background-color: ', ';\n        width: 120px;\n        position: relative;\n        font-weight: ', ';\n        font-size: 20px;\n        line-height: 1em;\n    }\n    .odd-type-1 {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .odd-type-X {\n    }\n\n    .odd-type-2 {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n'], ['\n    color: ', ';\n    padding-bottom: 3px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    i {\n        color: ', ';\n        font-style: normal;\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translate(8px, -50%);\n        font-weight: normal;\n        font-size: 1rem;\n    }\n\n    > * {\n        padding: 6px 0;\n        color: ', ';\n        background-color: ', ';\n        width: 120px;\n        position: relative;\n        font-weight: ', ';\n        font-size: 20px;\n        line-height: 1em;\n    }\n    .odd-type-1 {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .odd-type-X {\n    }\n\n    .odd-type-2 {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	var scoreWidth = 100;
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var MatchCellHeader = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject3);
	
	var Team = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.color;
	});
	
	var Score = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.isLive ? props.theme.primaryTextColor : props.theme.content.accentTextColor;
	});
	
	var ScoreBg = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.isLive ? props.theme.primaryColor : props.theme.content.accentColor;
	});
	
	var IsLiveLabel = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var TeamNameHome = _styledComponents2.default.div(_templateObject8);
	
	var TeamNameAway = TeamNameHome.extend(_templateObject9);
	
	var OddsBar = _styledComponents2.default.div(_templateObject10, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.content.accent2TextColor;
	}, function (props) {
	    return props.theme.color;
	}, function (_ref) {
	    var theme = _ref.theme;
	    return theme.content.accent2Color;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.fonts.main.bold || 'bold';
	});
	
	var MatchCell = function (_React$Component) {
	    _inherits(MatchCell, _React$Component);
	
	    function MatchCell(props) {
	        _classCallCheck(this, MatchCell);
	
	        return _possibleConstructorReturn(this, (MatchCell.__proto__ || Object.getPrototypeOf(MatchCell)).call(this, props));
	    }
	
	    _createClass(MatchCell, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                lang = _props.lang,
	                betOffer = _props.betOffer;
	
	            event = (0, _Eventify2.default)(event);
	
	            var tvInfo = event.channel && event.channel.name && _react2.default.createElement(
	                'div',
	                { className: 'tv-info' },
	                event.channel.name
	            );
	            var isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
	            var isFinished = event.isFinished();
	            var isComing = event.isComing();
	            var isLive = event.isLive();
	
	            // console.log('--->', 'betOffer', ['1','x','2'].map(o => {
	            //     const odd = betOffer.outcomes.find(t => t.type === o).odds.toFixed(2);
	            //
	            //     return (
	            //
	            //     );
	            // }));
	
	            return _react2.default.createElement(
	                Wrapper,
	                null,
	                _react2.default.createElement(
	                    Cell,
	                    null,
	                    isLive && _react2.default.createElement(
	                        IsLiveLabel,
	                        null,
	                        'Live'
	                    ),
	                    _react2.default.createElement(
	                        Team,
	                        { className: 'team-home' },
	                        _react2.default.createElement(
	                            TeamNameHome,
	                            null,
	                            event.homeName
	                        ),
	                        _react2.default.createElement(_SMTeamLogo2.default, {
	                            tournamentId: event.tournamentTemplateId,
	                            teamId: event.homeId,
	                            height: 40,
	                            style: {
	                                marginRight: 15,
	                                minWidth: 40
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        Score,
	                        { isLive: isLive },
	                        _react2.default.createElement(ScoreBg, { className: '__c__b2_style1' }),
	                        isFinished && _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.showDate && _react2.default.createElement(
	                                'div',
	                                { className: 'top-sub-small __c__c4_style1' },
	                                _react2.default.createElement(_DateFormatted2.default, {
	                                    className: 'time',
	                                    el: 'div',
	                                    date: event.startDate,
	                                    type: 'DATE_SHORT'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'top-sub-score __c__c4_style1' },
	                                event.score.home + ' - ' + event.score.away
	                            )
	                        ),
	                        event.isCancelled() && _react2.default.createElement(
	                            'div',
	                            { className: '__c__c4_style1' },
	                            i18('status.short.cancelled', lang)
	                        ),
	                        event.isPostponed() && _react2.default.createElement(
	                            'div',
	                            { className: '__c__c4_style1' },
	                            i18('status.short.postponed', lang)
	                        ),
	                        isLive && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'top-sub-score __c__c4_style1' },
	                                event.score.home + ' - ' + event.score.away
	                            ),
	                            tvInfo
	                        ),
	                        isComing && !event.isCancelled() && !event.isPostponed() && (isToday || this.props.timeOnly) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'top-sub __c__c4_style1' },
	                                _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' })
	                            ),
	                            tvInfo
	                        ),
	                        isComing && !event.isCancelled() && !event.isPostponed() && !(isToday || this.props.timeOnly) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'top-sub __c__c4_style1' },
	                                _react2.default.createElement(_DateFormatted2.default, {
	                                    className: 'time',
	                                    el: 'div',
	                                    date: event.startDate,
	                                    type: 'DATE_SHORT'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: '__c__c5_style1' },
	                                _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Team,
	                        { className: 'team-away' },
	                        _react2.default.createElement(_SMTeamLogo2.default, {
	                            tournamentId: event.tournamentTemplateId,
	                            teamId: event.awayId,
	                            height: 40,
	                            style: { marginLeft: 15, minWidth: 40 }
	                        }),
	                        _react2.default.createElement(
	                            TeamNameAway,
	                            null,
	                            event.awayName
	                        )
	                    )
	                ),
	                betOffer && _react2.default.createElement(
	                    OddsBar,
	                    null,
	                    ['1', 'x', '2'].map(function (o) {
	                        var odd = betOffer.outcomes.find(function (t) {
	                            return t.type.toLowerCase() === o.toLowerCase();
	                        }).odds.toFixed(2);
	
	                        return _react2.default.createElement(
	                            'div',
	                            { key: o, className: 'odd-type-' + o },
	                            _react2.default.createElement(
	                                'i',
	                                null,
	                                o
	                            ),
	                            ' ',
	                            odd
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MatchCell;
	}(_react2.default.Component);
	
	MatchCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	
	MatchCell.propTypes = {
	    event: _propTypes2.default.object.isRequired
	};
	
	var Container = function Container(_ref3) {
	    var children = _ref3.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        children
	    );
	};
	
	exports.default = { MatchCellHeader: MatchCellHeader, MatchCell: MatchCell, Container: Container };

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _lodash = __webpack_require__(320);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DateFormatted(_ref, _ref2) {
	    var moment = _ref2.moment;
	
	    var date = _ref.date,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'DATE' : _ref$type,
	        _ref$el = _ref.el,
	        el = _ref$el === undefined ? 'span' : _ref$el,
	        _ref$defFormat = _ref.defFormat,
	        defFormat = _ref$defFormat === undefined ? 'DD MM YY' : _ref$defFormat,
	        inputFormat = _ref.inputFormat,
	        theme = _ref.theme,
	        otherProps = _objectWithoutProperties(_ref, ['date', 'type', 'el', 'defFormat', 'inputFormat', 'theme']);
	
	    var tag = { el: el };
	    var dateFormatted = moment(date, inputFormat).format((0, _lodash2.default)(theme, 'dateFormats.' + type, defFormat));
	
	    return _react2.default.createElement(
	        tag.el,
	        _extends({ title: type }, otherProps),
	        dateFormatted
	    );
	}
	
	DateFormatted.contextTypes = {
	    moment: _propTypes2.default.func
	};
	
	DateFormatted.propTypes = {
	    date: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string,
	    el: _propTypes2.default.string,
	    defFormat: _propTypes2.default.string,
	    inputFormat: _propTypes2.default.string,
	    // From withTheme
	    theme: _propTypes2.default.object
	};
	
	exports.default = (0, _styledComponents.withTheme)(DateFormatted);

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    opacity: 0.9;\n    padding: 10px 10px;\n    font-size: 11px;\n'], ['\n    opacity: 0.9;\n    padding: 10px 10px;\n    font-size: 11px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    margin: 20px 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n        img {\n        }\n    }\n\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -15px;\n        right: -15px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n    &:before {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 50px;\n        right: -15px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n'], ['\n    position: relative;\n    margin: 20px 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n        img {\n        }\n    }\n\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -15px;\n        right: -15px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n    &:before {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 50px;\n        right: -15px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 24px;\n    font-weight: normal;\n    line-height: 60px;\n    position: relative;\n\n    color: ', ';\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0px;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        opacity: 0.8;\n    }\n\n    & > * {\n        position: relative;\n        z-index: 3;\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        display: inline-block;\n        min-width: 70px;\n        text-align: center;\n    }\n'], ['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 24px;\n    font-weight: normal;\n    line-height: 60px;\n    position: relative;\n\n    color: ', ';\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0px;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        opacity: 0.8;\n    }\n\n    & > * {\n        position: relative;\n        z-index: 3;\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        display: inline-block;\n        min-width: 70px;\n        text-align: center;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 120px;\n    height: 60px;\n    z-index: 4;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    & > * {\n        positon: relative;\n        z-index: 6;\n    }\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        transform: skew(-10deg);\n        border-radius: 5px;\n    }\n\n    .top-sub {\n        font-size: 18px;\n        line-height: 24px;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 34px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 15px;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        backgroundcolor: rgba(0, 0, 0, 0.5);\n        font-size: 14px;\n    }\n'], ['\n    position: relative;\n    width: 120px;\n    height: 60px;\n    z-index: 4;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    & > * {\n        positon: relative;\n        z-index: 6;\n    }\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        transform: skew(-10deg);\n        border-radius: 5px;\n    }\n\n    .top-sub {\n        font-size: 18px;\n        line-height: 24px;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 34px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 15px;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        backgroundcolor: rgba(0, 0, 0, 0.5);\n        font-size: 14px;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n'], ['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-left: 10px;\n    box-sizing: border-box;\n'], ['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-left: 10px;\n    box-sizing: border-box;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    text-align: left;\n    padding-right: 10px;\n    padding-left: 0;\n'], ['\n    text-align: left;\n    padding-right: 10px;\n    padding-left: 0;\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var scoreWidth = 100;
	
	var MatchCellHeader = _styledComponents2.default.div(_templateObject);
	
	var Cell = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	
	var Team = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.color;
	});
	
	var Score = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var IsLiveLabel = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var TeamNameHome = _styledComponents2.default.div(_templateObject6);
	
	var TeamNameAway = TeamNameHome.extend(_templateObject7);
	
	var MatchCell = function (_React$Component) {
	    _inherits(MatchCell, _React$Component);
	
	    function MatchCell(props) {
	        _classCallCheck(this, MatchCell);
	
	        return _possibleConstructorReturn(this, (MatchCell.__proto__ || Object.getPrototypeOf(MatchCell)).call(this, props));
	    }
	
	    _createClass(MatchCell, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                lang = _props.lang;
	
	            event = (0, _Eventify2.default)(event);
	
	            var tvInfo = event.channel && event.channel.name && _react2.default.createElement(
	                'div',
	                { className: 'tv-info' },
	                event.channel.name
	            );
	            var isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
	            var isFinished = event.isFinished();
	            var isComing = event.isComing();
	            var isLive = event.isLive();
	
	            return _react2.default.createElement(
	                Cell,
	                null,
	                isLive && _react2.default.createElement(
	                    IsLiveLabel,
	                    null,
	                    'Live'
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-home' },
	                    _react2.default.createElement(
	                        TeamNameHome,
	                        null,
	                        event.homeName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'logo-box' },
	                        _react2.default.createElement(_SMTeamLogo2.default, {
	                            tournamentId: event.tournamentTemplateId,
	                            display: 'logo',
	                            teamId: event.homeId,
	                            height: 40
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    Score,
	                    { isLive: isLive },
	                    isFinished && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        )
	                    ),
	                    isLive && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        ),
	                        tvInfo
	                    ),
	                    event.isCancelled() && _react2.default.createElement(
	                        'div',
	                        null,
	                        i18('status.short.cancelled', lang)
	                    ),
	                    event.isPostponed() && _react2.default.createElement(
	                        'div',
	                        null,
	                        i18('status.short.postponed', lang)
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && isToday && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_DateFormatted2.default, { className: 'top-sub', date: event.startDate, type: 'TIME', el: 'div' }),
	                        tvInfo
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && !isToday && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_DateFormatted2.default, { className: 'top-sub', date: event.startDate, type: 'DATE_SHORT', el: 'div' }),
	                        _react2.default.createElement(_DateFormatted2.default, { date: event.startDate, type: 'TIME', el: 'div' })
	                    )
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-away' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'logo-box' },
	                        _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.awayId, height: 40 })
	                    ),
	                    _react2.default.createElement(
	                        TeamNameAway,
	                        null,
	                        event.awayName
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MatchCell;
	}(_react2.default.Component);
	
	MatchCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	
	MatchCell.propTypes = {
	    event: _propTypes2.default.object.isRequired
	};
	
	var Container = function Container(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        children
	    );
	};
	
	exports.default = { MatchCellHeader: MatchCellHeader, MatchCell: MatchCell, Container: Container };

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    opacity: 0.9;\n    backgroundcolor: rgba(33, 33, 33, 0.6);\n    padding: 10px 10px;\n    font-size: 11px;\n'], ['\n    opacity: 0.9;\n    backgroundcolor: rgba(33, 33, 33, 0.6);\n    padding: 10px 10px;\n    font-size: 11px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    transform: skew(-', 'deg);\n    padding: 15px 0px 0;\n'], ['\n    transform: skew(-', 'deg);\n    padding: 15px 0px 0;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    margin: 3px auto;\n    justify-content: center;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n        img {\n        }\n    }\n'], ['\n    position: relative;\n    margin: 3px auto;\n    justify-content: center;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n        img {\n        }\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    width: calc(50% - 60px);\n    max-width: 240px;\n    white-space: nowrap;\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 36px;\n    line-height: 64px;\n    position: relative;\n\n    color: ', ';\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0px;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        background-color: ', ';\n    }\n\n    & > * {\n        position: relative;\n        z-index: 3;\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        position: absolute;\n        min-width: 70px;\n        top: 50%;\n        text-align: center;\n        transform: translateY(-50%) skew(', 'deg);\n    }\n    &.team-home .logo-box {\n        right: 0;\n    }\n    &.team-away .logo-box {\n        left: 0;\n    }\n'], ['\n    width: calc(50% - 60px);\n    max-width: 240px;\n    white-space: nowrap;\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 36px;\n    line-height: 64px;\n    position: relative;\n\n    color: ', ';\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0px;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        background-color: ', ';\n    }\n\n    & > * {\n        position: relative;\n        z-index: 3;\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        position: absolute;\n        min-width: 70px;\n        top: 50%;\n        text-align: center;\n        transform: translateY(-50%) skew(', 'deg);\n    }\n    &.team-home .logo-box {\n        right: 0;\n    }\n    &.team-away .logo-box {\n        left: 0;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 120px;\n    height: 64px;\n    z-index: 4;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    & > * {\n        positon: relative;\n        z-index: 6;\n    }\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        border: 1px solid ', ';\n        background-color: ', ';\n        opacity: 0.9;\n    }\n\n    .top-sub {\n        font-size: 20px;\n        line-height: 1em;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 15px;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        backgroundcolor: rgba(0, 0, 0, 0.5);\n        font-size: 14px;\n    }\n'], ['\n    position: relative;\n    width: 120px;\n    height: 64px;\n    z-index: 4;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 14px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    & > * {\n        positon: relative;\n        z-index: 6;\n    }\n    &:after {\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        border: 1px solid ', ';\n        background-color: ', ';\n        opacity: 0.9;\n    }\n\n    .top-sub {\n        font-size: 20px;\n        line-height: 1em;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 15px;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        backgroundcolor: rgba(0, 0, 0, 0.5);\n        font-size: 14px;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n'], ['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    box-sizing: border-box;\n    width: 100%;\n    padding-right: 70px;\n\n    transform: skew(', 'deg);\n'], ['\n    display: inline-block;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    box-sizing: border-box;\n    width: 100%;\n    padding-right: 70px;\n\n    transform: skew(', 'deg);\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    text-align: left;\n    padding-left: 70px;\n    padding-right: 0px;\n    transform: skew(', 'deg);\n'], ['\n    text-align: left;\n    padding-left: 70px;\n    padding-right: 0px;\n    transform: skew(', 'deg);\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var scoreWidth = 100;
	
	var MatchCellHeader = _styledComponents2.default.div(_templateObject);
	
	var SkewContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject3);
	
	var Team = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var Score = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.accentTextColor;
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	
	var IsLiveLabel = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var TeamNameHome = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var TeamNameAway = TeamNameHome.extend(_templateObject8, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var MatchCell = function (_React$Component) {
	    _inherits(MatchCell, _React$Component);
	
	    function MatchCell(props) {
	        _classCallCheck(this, MatchCell);
	
	        return _possibleConstructorReturn(this, (MatchCell.__proto__ || Object.getPrototypeOf(MatchCell)).call(this, props));
	    }
	
	    _createClass(MatchCell, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                lang = _props.lang;
	
	            event = (0, _Eventify2.default)(event);
	
	            var tvInfo = event.channel && event.channel.name && _react2.default.createElement(
	                'div',
	                { className: 'tv-info' },
	                event.channel.name
	            );
	            var isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
	            var isFinished = event.isFinished();
	            var isComing = event.isComing();
	            var isLive = event.isLive();
	
	            return _react2.default.createElement(
	                Cell,
	                null,
	                isLive && _react2.default.createElement(
	                    IsLiveLabel,
	                    null,
	                    'Live'
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-home' },
	                    _react2.default.createElement(
	                        TeamNameHome,
	                        null,
	                        event.homeShortName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'logo-box' },
	                        _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.homeId, height: 40 })
	                    )
	                ),
	                _react2.default.createElement(
	                    Score,
	                    { isLive: isLive },
	                    isFinished && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        )
	                    ),
	                    isLive && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        ),
	                        tvInfo
	                    ),
	                    event.isCancelled() && _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        i18('status.short.cancelled', lang)
	                    ),
	                    event.isPostponed() && _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        i18('status.short.postponed', lang)
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && isToday && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' }),
	                        tvInfo
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && !isToday && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub' },
	                            _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'DATE_SHORT' }),
	                            _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-away' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'logo-box' },
	                        _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.awayId, height: 40 })
	                    ),
	                    _react2.default.createElement(
	                        TeamNameAway,
	                        null,
	                        event.awayShortName
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MatchCell;
	}(_react2.default.Component);
	
	MatchCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	
	MatchCell.propTypes = {
	    event: _propTypes2.default.object.isRequired
	};
	
	var Container = function Container(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        SkewContainer,
	        null,
	        children
	    );
	};
	
	exports.default = { MatchCellHeader: MatchCellHeader, MatchCell: MatchCell, Container: Container };

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: table-row-group;\n    vertical-align: middle;\n    border: none;\n'], ['\n    display: table-row-group;\n    vertical-align: middle;\n    border: none;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    opacity: 0.9;\n    padding: 10px 0;\n    font-size: 18px;\n    text-align: left;\n    color: ', ';\n'], ['\n    opacity: 0.9;\n    padding: 10px 0;\n    font-size: 18px;\n    text-align: left;\n    color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: table-row;\n    vertical-align: inherit;\n    border-color: inherit;\n'], ['\n    display: table-row;\n    vertical-align: inherit;\n    border-color: inherit;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: table-cell;\n    color: ', ';\n    padding: 10px 0;\n    font-size: 20px;\n\n    .tv-info {\n        margin-right: 30px;\n        text-align: right;\n        min-width: 90px;\n    }\n\n    .top-sub-score,\n    .tmc-date {\n        min-width: 80px;\n        text-align: right;\n    }\n'], ['\n    display: table-cell;\n    color: ', ';\n    padding: 10px 0;\n    font-size: 20px;\n\n    .tv-info {\n        margin-right: 30px;\n        text-align: right;\n        min-width: 90px;\n    }\n\n    .top-sub-score,\n    .tmc-date {\n        min-width: 80px;\n        text-align: right;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: table-cell;\n    padding: 10px 40px 10px 0;\n    width: 360px;\n    font-size: 20px;\n\n    .vs {\n        padding: 0 10px;\n    }\n'], ['\n    display: table-cell;\n    padding: 10px 40px 10px 0;\n    width: 360px;\n    font-size: 20px;\n\n    .vs {\n        padding: 0 10px;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    display: inline-block;\n'], ['\n    display: inline-block;\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Table = _styledComponents2.default.div(_templateObject);
	
	var MatchCellHeader = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.primaryColor;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject3);
	
	var Score = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.isLive ? props.theme.primaryTextColor : props.theme.color;
	});
	
	var TeamNameBox = _styledComponents2.default.div(_templateObject5);
	
	var TeamName = _styledComponents2.default.span(_templateObject6);
	
	var MatchCell = function (_React$Component) {
	    _inherits(MatchCell, _React$Component);
	
	    function MatchCell(props) {
	        _classCallCheck(this, MatchCell);
	
	        return _possibleConstructorReturn(this, (MatchCell.__proto__ || Object.getPrototypeOf(MatchCell)).call(this, props));
	    }
	
	    _createClass(MatchCell, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                lang = _props.lang;
	
	            event = (0, _Eventify2.default)(event);
	
	            var tvInfo = event.channel && event.channel.name && _react2.default.createElement(
	                'div',
	                { className: 'tv-info' },
	                event.channel.name
	            );
	            var isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
	            var isFinished = event.isFinished();
	            var isComing = event.isComing();
	            var isLive = event.isLive();
	
	            return _react2.default.createElement(
	                Cell,
	                null,
	                _react2.default.createElement(
	                    TeamNameBox,
	                    { className: '__c__c2_textCell' },
	                    _react2.default.createElement(
	                        TeamName,
	                        null,
	                        event.homeName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'vs' },
	                        'vs'
	                    ),
	                    _react2.default.createElement(
	                        TeamName,
	                        null,
	                        event.awayName
	                    )
	                ),
	                _react2.default.createElement(
	                    Score,
	                    { isLive: isLive, className: '__c__c1_textCell' },
	                    isFinished && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        )
	                    ),
	                    isLive && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        tvInfo,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score' },
	                            event.score.home + ' - ' + event.score.away
	                        )
	                    ),
	                    event.isCancelled() && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        i18('status.short.cancelled', lang)
	                    ),
	                    event.isPostponed() && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        i18('status.short.postponed', lang)
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && isToday && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        tvInfo,
	                        _react2.default.createElement(_DateFormatted2.default, { className: 'tmc-date', date: event.startDate, type: 'TIME', el: 'div' })
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && !isToday && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        _react2.default.createElement(_DateFormatted2.default, { className: 'tmc-date', date: event.startDate, type: 'TIME', el: 'div' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MatchCell;
	}(_react2.default.Component);
	
	MatchCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	
	MatchCell.propTypes = {
	    event: _propTypes2.default.object.isRequired
	};
	
	var Container = function Container(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        Table,
	        null,
	        children
	    );
	};
	
	exports.default = { MatchCellHeader: MatchCellHeader, MatchCell: MatchCell, Container: Container };

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    vertical-align: middle;\n    border: none;\n'], ['\n    vertical-align: middle;\n    border: none;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0;\n    font-size: 18px;\n    text-align: center;\n    color: ', ';\n'], ['\n    padding: 0;\n    font-size: 18px;\n    text-align: center;\n    color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    margin: 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n    }\n'], ['\n    position: relative;\n    margin: 0;\n    white-space: nowrap;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    .team-home {\n        text-align: right;\n        img {\n        }\n    }\n    .team-away {\n        text-align: left;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 19px;\n    font-weight: normal;\n    line-height: 58px;\n    color: ', ';\n    & > * {\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        display: inline-block;\n        text-align: center;\n        padding: 0 10px;\n    }\n'], ['\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    text-align: center;\n    font-size: 19px;\n    font-weight: normal;\n    line-height: 58px;\n    color: ', ';\n    & > * {\n        vertical-align: middle;\n        display: inline-block;\n    }\n\n    .logo-box {\n        display: inline-block;\n        text-align: center;\n        padding: 0 10px;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    width: 120px;\n    height: 58px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 16px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    .top-sub {\n        font-size: 21px;\n        font-weight: 700;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n    }\n'], ['\n    width: 120px;\n    height: 58px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    font-size: 16px;\n    line-height: 1.1;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    .top-sub {\n        font-size: 21px;\n        font-weight: 700;\n    }\n    .top-sub-score {\n        font-size: 32px;\n        font-weight: 700;\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        line-height: 34px;\n        font-weight: 700;\n        flex-grow: 1.2;\n    }\n\n    .tv-info {\n        width: 100%;\n        flex-grow: 1;\n        display: flex;\n        text-transform: uppercase;\n        font-weight: 700;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n'], ['\n    background: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    transform: translate(0, -50%) rotate(-90deg);\n    position: absolute;\n    width: 60px;\n    height: 30px;\n    line-height: 22px;\n    box-sizing: border-box;\n    padding: 3px 0 5px;\n    left: -15px;\n    top: 50%;\n    transform-origin: center;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-left: 30px;\n    box-sizing: border-box;\n'], ['\n    display: inline-block;\n    width: calc(100% - 70px);\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: right;\n    padding-left: 30px;\n    box-sizing: border-box;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    text-align: left;\n    padding-right: 30px;\n    padding-left: 0;\n'], ['\n    text-align: left;\n    padding-right: 30px;\n    padding-left: 0;\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Table = _styledComponents2.default.div(_templateObject);
	
	var MatchCellHeader = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.primaryColor;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject3);
	
	var Team = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.color;
	});
	
	var Score = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.isLive ? props.theme.primaryTextColor : props.theme.content.accentTextColor;
	});
	
	var IsLiveLabel = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var TeamNameHome = _styledComponents2.default.div(_templateObject7);
	
	var TeamNameAway = TeamNameHome.extend(_templateObject8);
	
	var MatchCell = function (_React$Component) {
	    _inherits(MatchCell, _React$Component);
	
	    function MatchCell(props) {
	        _classCallCheck(this, MatchCell);
	
	        return _possibleConstructorReturn(this, (MatchCell.__proto__ || Object.getPrototypeOf(MatchCell)).call(this, props));
	    }
	
	    _createClass(MatchCell, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                lang = _props.lang;
	
	            event = (0, _Eventify2.default)(event);
	
	            var tvInfo = event.channel && event.channel.name && _react2.default.createElement(
	                'div',
	                { className: 'tv-info' },
	                event.channel.name
	            );
	            var isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
	            var isFinished = event.isFinished();
	            var isComing = event.isComing();
	            var isLive = event.isLive();
	
	            return _react2.default.createElement(
	                Cell,
	                null,
	                isLive && _react2.default.createElement(
	                    IsLiveLabel,
	                    null,
	                    'Live'
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-home' },
	                    _react2.default.createElement(
	                        TeamNameHome,
	                        null,
	                        event.homeName
	                    )
	                ),
	                _react2.default.createElement(
	                    Score,
	                    { isLive: isLive },
	                    isFinished && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score __c__c5_style1' },
	                            event.score.home + ' - ' + event.score.away
	                        )
	                    ),
	                    isLive && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub-score __c__c5_style1' },
	                            event.score.home + ' - ' + event.score.away
	                        ),
	                        tvInfo
	                    ),
	                    event.isCancelled() && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        i18('status.short.cancelled', lang)
	                    ),
	                    event.isPostponed() && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'flex-end' } },
	                        i18('status.short.postponed', lang)
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && (isToday || this.props.timeOnly) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_DateFormatted2.default, {
	                            className: 'top-sub __c__c5_style1',
	                            date: event.startDate,
	                            type: 'TIME',
	                            el: 'div'
	                        }),
	                        tvInfo
	                    ),
	                    isComing && !event.isCancelled() && !event.isPostponed() && !(isToday || this.props.timeOnly) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-sub __c__c5_style1' },
	                            _react2.default.createElement(_DateFormatted2.default, { date: event.startDate, type: 'DATE_SHORT', el: 'div' })
	                        ),
	                        _react2.default.createElement(_DateFormatted2.default, { date: event.startDate, type: 'TIME', el: 'div' })
	                    )
	                ),
	                _react2.default.createElement(
	                    Team,
	                    { className: 'team-away' },
	                    _react2.default.createElement(
	                        TeamNameAway,
	                        null,
	                        event.awayName
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MatchCell;
	}(_react2.default.Component);
	
	MatchCell.contextTypes = {
	    info: _propTypes2.default.object,
	    screenSizeObserver: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	
	MatchCell.propTypes = {
	    event: _propTypes2.default.object.isRequired
	};
	
	var Container = function Container(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        Table,
	        null,
	        children
	    );
	};
	
	exports.default = { MatchCellHeader: MatchCellHeader, MatchCell: MatchCell, Container: Container };

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    border-collapse: separate;\n    border-spacing: 0 2px;\n    width: 100%;\n'], ['\n    border-collapse: separate;\n    border-spacing: 0 2px;\n    width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    line-height: 28px;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n    padding-left: ', ';\n'], ['\n    text-align: center;\n    line-height: 28px;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n    padding-left: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 18px;\n    line-height: 40px;\n    text-align: ', ';\n    padding-left: ', ';\n    font-weight: ', ';\n\n    &.wdp-nowrap {\n        white-space: nowrap;\n    }\n    div {\n        display: flex;\n        align-items: center;\n    }\n    .wdp-team-logo {\n        margin-right: 15px;\n    }\n'], ['\n    font-size: 18px;\n    line-height: 40px;\n    text-align: ', ';\n    padding-left: ', ';\n    font-weight: ', ';\n\n    &.wdp-nowrap {\n        white-space: nowrap;\n    }\n    div {\n        display: flex;\n        align-items: center;\n    }\n    .wdp-team-logo {\n        margin-right: 15px;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: relative;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n        font-weight: ', ';\n\n        .rel-badge {\n            display: inline-block;\n            background-color: ', ';\n            width: 21px;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n        }\n    }\n'], ['\n    position: relative;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n        font-weight: ', ';\n\n        .rel-badge {\n            display: inline-block;\n            background-color: ', ';\n            width: 21px;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var TblContainer = _styledComponents2.default.table(_templateObject);
	
	var TH = _styledComponents2.default.td(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.paddingLeft;
	});
	
	var TD = _styledComponents2.default.td(_templateObject3, function (props) {
	    return props.left ? 'left' : 'center';
	}, function (props) {
	    return props.paddingLeft;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	});
	
	var QualRelTR = _styledComponents2.default.tr(_templateObject4, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.type && (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() || (0, _color2.default)(props.theme.content.backgroundColor).alpha(0.3).rgb().toString();
	});
	
	var Row = function Row(_ref, ctx) {
	    var row = _ref.row,
	        qualRel = _ref.qualRel,
	        highlight = _ref.highlight,
	        tournamentId = _ref.tournamentId;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        QualRelTR,
	        { key: row.rank, type: qualRel && row.rankType, high: highlight },
	        _react2.default.createElement(
	            TD,
	            { width: '70px', paddingLeft: qualRel && 20 },
	            qualRel && _react2.default.createElement('span', { className: 'rel-badge' }),
	            row.rank
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '450px', left: true },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: tournamentId, teamId: row.teamId, width: 28, height: 28 }),
	                row.teamName
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '70px' },
	            row.matchesPlayed
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '70px', className: 'wdp-nowrap' },
	            row.goalsScored + ' - ' + row.goalsConceded
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '70px' },
	            row.points
	        )
	    );
	};
	
	var Header = function Header(_ref2, ctx) {
	    var qualRel = _ref2.qualRel;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            TH,
	            { width: '70px', paddingLeft: qualRel && 20, className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                '#'
	            )
	        ),
	        _react2.default.createElement(TH, { className: '__c__b1_style1' }),
	        _react2.default.createElement(
	            TH,
	            { className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('matches.short', lang)
	            )
	        ),
	        _react2.default.createElement(
	            TH,
	            { className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('goals.short', lang)
	            )
	        ),
	        _react2.default.createElement(
	            TH,
	            { className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('points.short', lang)
	            )
	        )
	    );
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	var Container = function Container(_ref3) {
	    var children = _ref3.children;
	    return _react2.default.createElement(
	        TblContainer,
	        null,
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    border-collapse: separate;\n    border-spacing: 0 4px;\n    width: 100%;\n'], ['\n    border-collapse: separate;\n    border-spacing: 0 4px;\n    width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    height: 70px;\n    color: ', ';\n    font-weight: ', ';\n\n    .rel-badge {\n        background-color: ', ';\n        width: 4px;\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n    }\n\n    &:nth-child(1) {\n        height: 90px;\n    }\n'], ['\n    height: 70px;\n    color: ', ';\n    font-weight: ', ';\n\n    .rel-badge {\n        background-color: ', ';\n        width: 4px;\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n    }\n\n    &:nth-child(1) {\n        height: 90px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    background: transparent !important;\n    width: ', ';\n    justify-content: ', ';\n    padding: 0;\n    height: 1px;\n    color: inherit;\n'], ['\n    position: relative;\n    background: transparent !important;\n    width: ', ';\n    justify-content: ', ';\n    padding: 0;\n    height: 1px;\n    color: inherit;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    margin: 0 2px;\n    align-items: center;\n    text-transform: uppercase;\n    font-size: 1.75rem;\n    line-height: 1;\n    height: 100%;\n    justify-content: inherit;\n    background-color: ', ';\n'], ['\n    display: flex;\n    margin: 0 2px;\n    align-items: center;\n    text-transform: uppercase;\n    font-size: 1.75rem;\n    line-height: 1;\n    height: 100%;\n    justify-content: inherit;\n    background-color: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    margin: 0 18px;\n'], ['\n    margin: 0 18px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    margin-right: 18px;\n'], ['\n    margin-right: 18px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TblContainer = _styledComponents2.default.table(_templateObject);
	
	var TR = _styledComponents2.default.tr(_templateObject2, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.type && (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() || (0, _color2.default)(props.theme.content.backgroundColor).alpha(0.3).rgb().toString();
	});
	
	var TD = _styledComponents2.default.td(_templateObject3, function (props) {
	    return props.fixedWidth ? '70px' : 'auto';
	}, function (props) {
	    return props.fixedWidth ? 'center' : 'left';
	});
	
	var Col = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.high ? props.theme.statTableBgColor : props.theme.content.backgroundColor;
	});
	
	var Logo = _styledComponents2.default.div(_templateObject5);
	
	var TeamName = _styledComponents2.default.div(_templateObject6);
	
	var Header = function Header() {
	    return null;
	};
	
	var Row = function Row(_ref) {
	    var row = _ref.row,
	        tournamentId = _ref.tournamentId,
	        qualRel = _ref.qualRel,
	        highlight = _ref.highlight;
	
	    return _react2.default.createElement(
	        TR,
	        { type: qualRel && row.rankType, high: highlight },
	        _react2.default.createElement(
	            TD,
	            { fixedWidth: true },
	            qualRel && _react2.default.createElement('span', { className: 'rel-badge' }),
	            _react2.default.createElement(
	                Col,
	                { high: highlight },
	                row.rank
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            null,
	            _react2.default.createElement(
	                Col,
	                { high: highlight },
	                _react2.default.createElement(
	                    Logo,
	                    null,
	                    _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: tournamentId, teamId: row.teamId, width: 50, height: 50 })
	                ),
	                _react2.default.createElement(
	                    TeamName,
	                    null,
	                    row.teamName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { fixedWidth: true },
	            _react2.default.createElement(
	                Col,
	                { high: highlight },
	                row.points
	            )
	        )
	    );
	};
	
	var Container = function Container(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        TblContainer,
	        null,
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    border-collapse: separate;\n    border-spacing: 1px;\n    width: 100%;\n\n    tbody {\n        transform: skew(-', 'deg);\n    }\n'], ['\n    border-collapse: separate;\n    border-spacing: 1px;\n    width: 100%;\n\n    tbody {\n        transform: skew(-', 'deg);\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    line-height: 28px;\n    color: ', ';\n\n    ', ';\n'], ['\n    text-align: center;\n    line-height: 28px;\n    color: ', ';\n\n    ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 30px;\n    line-height: 1.475em;\n    text-transform: uppercase;\n\n    &:nth-child(1) {\n        transform: skew(', 'deg);\n    }\n'], ['\n    font-size: 30px;\n    line-height: 1.475em;\n    text-transform: uppercase;\n\n    &:nth-child(1) {\n        transform: skew(', 'deg);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    text-align: ', ';\n    padding-left: ', ';\n    text-transform: uppercase;\n\n    font-size: 30px;\n    line-height: 1.475em;\n    white-space: nowrap;\n\n    &.tts-team-logo,\n    &.tts-team-name,\n    .rel-rank {\n        display: flex;\n        align-items: center;\n        transform: skew(', 'deg);\n    }\n\n    &.tts-team-name {\n        padding-left: 14px;\n    }\n\n    .rel-rank {\n        display: inline-block;\n    }\n'], ['\n    text-align: ', ';\n    padding-left: ', ';\n    text-transform: uppercase;\n\n    font-size: 30px;\n    line-height: 1.475em;\n    white-space: nowrap;\n\n    &.tts-team-logo,\n    &.tts-team-name,\n    .rel-rank {\n        display: flex;\n        align-items: center;\n        transform: skew(', 'deg);\n    }\n\n    &.tts-team-name {\n        padding-left: 14px;\n    }\n\n    .rel-rank {\n        display: inline-block;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n\n        .rel-badge {\n            display: inline-block;\n            background-color: ', ';\n            width: 6px;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: -9px;\n            transform: skew(0deg);\n        }\n\n        &.tts-team-value {\n            background-color: ', ';\n        }\n\n        &.tts-team-rank,\n        &.tts-team-value-points {\n            border: 1px solid ', ';\n            background-color: ', ';\n            color: ', ';\n        }\n\n        > span {\n            display: inline-block;\n            transform: skew(', 'deg);\n        }\n    }\n'], ['\n    position: relative;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n\n        .rel-badge {\n            display: inline-block;\n            background-color: ', ';\n            width: 6px;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: -9px;\n            transform: skew(0deg);\n        }\n\n        &.tts-team-value {\n            background-color: ', ';\n        }\n\n        &.tts-team-rank,\n        &.tts-team-value-points {\n            border: 1px solid ', ';\n            background-color: ', ';\n            color: ', ';\n        }\n\n        > span {\n            display: inline-block;\n            transform: skew(', 'deg);\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var TblContainer = _styledComponents2.default.table(_templateObject, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var TH = _styledComponents2.default.td(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.bold ? 'font-weight: 700;' : '';
	});
	
	var HeaderTr = _styledComponents2.default.tr(_templateObject3, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var TD = _styledComponents2.default.td(_templateObject4, function (props) {
	    return props.left ? 'left' : 'center';
	}, function (props) {
	    return props.paddingLeft;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var QualRelTR = _styledComponents2.default.tr(_templateObject5, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.type && (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() || props.theme.qualRelColors.relegation;
	}, function (props) {
	    return props.high ? (0, _color2.default)(props.theme.content.accentColor).lighten(0.1).rgb().toString() : (0, _color2.default)(props.theme.content.backgroundColor).lighten(0.1).rgb().toString();
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var Row = function Row(_ref, ctx) {
	    var row = _ref.row,
	        qualRel = _ref.qualRel,
	        highlight = _ref.highlight,
	        tournamentId = _ref.tournamentId;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        QualRelTR,
	        { key: row.rank, type: qualRel && row.rankType, high: highlight },
	        _react2.default.createElement(
	            TD,
	            { width: '8%', className: 'tts-team-rank' },
	            qualRel && _react2.default.createElement('span', { className: 'rel-badge' }),
	            _react2.default.createElement(
	                'span',
	                { className: 'rel-rank' },
	                row.rank
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { left: true, className: 'tts-team-name' },
	            _react2.default.createElement(_SMTeamLogo2.default, {
	                style: {
	                    marginRight: 15,
	                    verticalAlign: 'middle'
	                },
	                tournamentId: tournamentId,
	                teamId: row.teamId,
	                width: 28,
	                height: 28
	            }),
	            row.teamName
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '8%', className: 'tts-team-value' },
	            _react2.default.createElement(
	                'span',
	                null,
	                row.matchesWon
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '8%', className: 'tts-team-value' },
	            _react2.default.createElement(
	                'span',
	                null,
	                row.matchesDraw
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '8%', className: 'tts-team-value' },
	            _react2.default.createElement(
	                'span',
	                null,
	                row.matchesLost
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            { width: '8%', className: 'tts-team-value-points' },
	            _react2.default.createElement(
	                'span',
	                null,
	                row.points
	            )
	        )
	    );
	};
	
	var Header = function Header(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        HeaderTr,
	        null,
	        _react2.default.createElement(TH, null),
	        _react2.default.createElement(TH, null),
	        _react2.default.createElement(
	            TH,
	            null,
	            i18('win.short', lang)
	        ),
	        _react2.default.createElement(
	            TH,
	            null,
	            i18('draw.short', lang)
	        ),
	        _react2.default.createElement(
	            TH,
	            null,
	            i18('loss.short', lang)
	        ),
	        _react2.default.createElement(
	            TH,
	            null,
	            i18('points.short', lang)
	        )
	    );
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var Container = function Container(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        TblContainer,
	        null,
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    border-collapse: separate;\n    width: 100%;\n'], ['\n    border-collapse: separate;\n    width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    font-size: 18px;\n    line-height: 38px;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n'], ['\n    text-align: center;\n    font-size: 18px;\n    line-height: 38px;\n    color: ', ';\n    background-color: ', ';\n    font-weight: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 24px;\n    line-height: 38px;\n    text-align: ', ';\n    padding-left: ', ';\n    font-weight: ', ';\n\n    &.wdp-nowrap {\n        white-space: nowrap;\n    }\n    div {\n        display: flex;\n        align-items: center;\n        padding: 0 9px;\n    }\n    .wdp-team-logo {\n        margin-right: 15px;\n    }\n\n    &.num {\n    }\n'], ['\n    font-size: 24px;\n    line-height: 38px;\n    text-align: ', ';\n    padding-left: ', ';\n    font-weight: ', ';\n\n    &.wdp-nowrap {\n        white-space: nowrap;\n    }\n    div {\n        display: flex;\n        align-items: center;\n        padding: 0 9px;\n    }\n    .wdp-team-logo {\n        margin-right: 15px;\n    }\n\n    &.num {\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    position: relative;\n    color: ', ';\n    font-weight: ', ';\n    background-color: ', ';\n    background-color: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n        font-weight: ', ';\n    }\n'], ['\n    position: relative;\n    color: ', ';\n    font-weight: ', ';\n    background-color: ', ';\n    background-color: ', ';\n\n    td {\n        position: relative;\n        color: ', ';\n        font-weight: ', ';\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var TblContainer = _styledComponents2.default.table(_templateObject);
	
	var TH = _styledComponents2.default.th(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	});
	
	var TD = _styledComponents2.default.td(_templateObject3, function (props) {
	    return props.left ? 'left' : 'center';
	}, function (props) {
	    return props.paddingLeft;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	});
	
	var QualRelTR = _styledComponents2.default.tr(_templateObject4, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.type ? (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() : props.theme.content.accent2Color;
	}, function (props) {
	    return props.isFirstRow && props.theme.qualRelColors.leagueWinner;
	}, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	});
	
	var Row = function Row(_ref) {
	    var row = _ref.row,
	        qualRel = _ref.qualRel,
	        highlight = _ref.highlight,
	        tournamentId = _ref.tournamentId,
	        isFirstRow = _ref.isFirstRow;
	
	    return _react2.default.createElement(
	        QualRelTR,
	        { key: row.rank, type: qualRel && row.rankType, high: highlight, isFirstRow: qualRel && isFirstRow },
	        _react2.default.createElement(
	            TD,
	            { className: 'num' },
	            row.rank
	        ),
	        _react2.default.createElement(
	            TD,
	            { left: true },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: tournamentId, teamId: row.teamId, width: 38, height: 38 }),
	                row.teamName
	            )
	        ),
	        _react2.default.createElement(
	            TD,
	            null,
	            row.matchesPlayed
	        ),
	        _react2.default.createElement(
	            TD,
	            { className: 'wdp-nowrap' },
	            row.goalsScored + ' - ' + row.goalsConceded
	        ),
	        _react2.default.createElement(
	            TD,
	            null,
	            row.points
	        )
	    );
	};
	
	var Header = function Header(_ref2, ctx) {
	    var _ref2$showLogo = _ref2.showLogo,
	        showLogo = _ref2$showLogo === undefined ? true : _ref2$showLogo,
	        props = _ref2.props;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            TH,
	            { width: '45px', className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                '#'
	            )
	        ),
	        _react2.default.createElement(TH, { className: '__c__b1_style1' }),
	        _react2.default.createElement(
	            TH,
	            { width: '45px', className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('matches.short', lang)
	            )
	        ),
	        _react2.default.createElement(
	            TH,
	            { width: '120px', className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('goals.short', lang)
	            )
	        ),
	        _react2.default.createElement(
	            TH,
	            { width: '45px', className: '__c__b1_style1' },
	            _react2.default.createElement(
	                'span',
	                { className: '__c__c1_style1' },
	                i18('points.short', lang)
	            )
	        )
	    );
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object,
	    teamLogoSettings: _propTypes2.default.object
	};
	
	var Container = function Container(_ref3) {
	    var children = _ref3.children;
	    return _react2.default.createElement(
	        TblContainer,
	        null,
	        _react2.default.createElement(
	            'tbody',
	            null,
	            children
	        )
	    );
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Substitution = exports.Card = exports.OwnGoal = exports.Assist = exports.Goal = exports.Wrapper = exports.Preview = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    height: 380px;\n    text-align: center;\n'], ['\n    height: 380px;\n    text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: 700;\n    font-size: 64px;\n    line-height: 69px;\n    font-weight: 700;\n    margin-bottom: 21px;\n    padding-top: 10px;\n'], ['\n    color: ', ';\n    font-weight: 700;\n    font-size: 64px;\n    line-height: 69px;\n    font-weight: 700;\n    margin-bottom: 21px;\n    padding-top: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    top: 50%;\n'], ['\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    top: 50%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: 700;\n    font-size: 48px;\n    line-height: 69px;\n    font-weight: 700;\n    margin-bottom: 54px;\n    padding-top: 10px;\n    text-transform: uppercase;\n'], ['\n    color: ', ';\n    font-weight: 700;\n    font-size: 48px;\n    line-height: 69px;\n    font-weight: 700;\n    margin-bottom: 54px;\n    padding-top: 10px;\n    text-transform: uppercase;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    margin-bottom: 21px;\n'], ['\n    margin-bottom: 21px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-size: 24px;\n    line-height: 27px;\n    line-height: 1;\n    margin: 0;\n    text-transform: uppercase;\n'], ['\n    color: ', ';\n    font-size: 24px;\n    line-height: 27px;\n    line-height: 1;\n    margin: 0;\n    text-transform: uppercase;\n']),
	    _templateObject7 = _taggedTemplateLiteral([''], ['']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    width: 100%;\n    text-align: left;\n    padding: 0 20px;\n    box-sizing: border-box;\n'], ['\n    width: 100%;\n    text-align: left;\n    padding: 0 20px;\n    box-sizing: border-box;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    position: relative;\n    font-size: 25px;\n    color: ', ';\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    .sm-substituted-player__name-wrapper {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    }\n    .sm-substituted-player__info {\n        width: calc(100% - 131px); \n        background: ', ';\n        \n        padding: 6px 10px 6px 20px;\n        box-sizing: border-box;\n    }\n    > div {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    .sm-substituted-player__icon {\n        width: 44px;\n        margin-right: 10px;\n        img {\n            width: 100%;\n            height: auto;\n        }\n    }\n    .sm-substituted-player__photo {\n        height: 80px;\n        width: 80px;\n        margin-right: 10px;\n        margin-bottom: 0;\n        margin-left: 0;\n        display: inline-block;\n        vertical-align: middle;\n    }\n    .sm-substituted-player__number {\n        width: 131px;\n        font-size: 48px;\n        line-height: 92px;\n        padding-right: 48px;\n        box-sizing: border-box;\n        text-align: right;\n        font-weight: 700;\n        background: ', ';\n        position: relative;\n        &_in {\n            color: ', ';\n        }\n        &_out {\n            color: ', ';\n        }\n        \n        .sm-substituted-player__icon_in,\n        .sm-substituted-player__icon_out {\n            position: absolute;\n            right: 10px;\n            top: 50%;\n            transform: translate(0, -50%);\n            width: 0;\n            height: 0;\n            border-style: solid;\n        }\n        \n        .sm-substituted-player__icon_in {\n            border-width: 14px 0 14px 22px;\n            border-color: transparent transparent transparent currentColor;\n        }\n        \n        .sm-substituted-player__icon_out {\n            border-width: 14px 22px 14px 0;\n            border-color: transparent currentColor transparent transparent;\n        }\n    }\n    .sm-substituted-player__name {\n    width: calc(100% - 90px);\n        text-align: left;\n        color: ', ';\n        font-size: 24px;\n        line-height: 27px;\n        font-weight: 700;\n        text-transform: uppercase;\n        display: inline-block;\n        vertical-align: middle;\n}\n    }\n'], ['\n    position: relative;\n    font-size: 25px;\n    color: ', ';\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    .sm-substituted-player__name-wrapper {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    }\n    .sm-substituted-player__info {\n        width: calc(100% - 131px); \n        background: ', ';\n        \n        padding: 6px 10px 6px 20px;\n        box-sizing: border-box;\n    }\n    > div {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    .sm-substituted-player__icon {\n        width: 44px;\n        margin-right: 10px;\n        img {\n            width: 100%;\n            height: auto;\n        }\n    }\n    .sm-substituted-player__photo {\n        height: 80px;\n        width: 80px;\n        margin-right: 10px;\n        margin-bottom: 0;\n        margin-left: 0;\n        display: inline-block;\n        vertical-align: middle;\n    }\n    .sm-substituted-player__number {\n        width: 131px;\n        font-size: 48px;\n        line-height: 92px;\n        padding-right: 48px;\n        box-sizing: border-box;\n        text-align: right;\n        font-weight: 700;\n        background: ', ';\n        position: relative;\n        &_in {\n            color: ', ';\n        }\n        &_out {\n            color: ', ';\n        }\n        \n        .sm-substituted-player__icon_in,\n        .sm-substituted-player__icon_out {\n            position: absolute;\n            right: 10px;\n            top: 50%;\n            transform: translate(0, -50%);\n            width: 0;\n            height: 0;\n            border-style: solid;\n        }\n        \n        .sm-substituted-player__icon_in {\n            border-width: 14px 0 14px 22px;\n            border-color: transparent transparent transparent currentColor;\n        }\n        \n        .sm-substituted-player__icon_out {\n            border-width: 14px 22px 14px 0;\n            border-color: transparent currentColor transparent transparent;\n        }\n    }\n    .sm-substituted-player__name {\n    width: calc(100% - 90px);\n        text-align: left;\n        color: ', ';\n        font-size: 24px;\n        line-height: 27px;\n        font-weight: 700;\n        text-transform: uppercase;\n        display: inline-block;\n        vertical-align: middle;\n}\n    }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    .sm-card {\n        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n        position: absolute;\n        transform: rotate(15deg) translate(10%, -50%);\n        top: 50%;\n        right: 0;\n    }\n'], ['\n    .sm-card {\n        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n        position: absolute;\n        transform: rotate(15deg) translate(10%, -50%);\n        top: 50%;\n        right: 0;\n    }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 40px;\n    font-weight: 700;\n'], ['\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 40px;\n    font-weight: 700;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    position: relative;\n    display: inline-block;\n'], ['\n    position: relative;\n    display: inline-block;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n    width: 160px;\n    height: 160px;\n    border-radius: 50%;\n    margin: 0 auto 22px;\n    overflow: hidden;\n    background-color: ', ';\n    position: relative;\n    img {\n        height: auto;\n        width: 100%;\n        ', ';\n    }\n'], ['\n    width: 160px;\n    height: 160px;\n    border-radius: 50%;\n    margin: 0 auto 22px;\n    overflow: hidden;\n    background-color: ', ';\n    position: relative;\n    img {\n        height: auto;\n        width: 100%;\n        ', ';\n    }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n    ', ' text-align: center;\n    width: 100%;\n    font-size: 64px;\n    line-height: 69px;\n    font-weight: 700;\n    padding-top: 10px;\n'], ['\n    ', ' text-align: center;\n    width: 100%;\n    font-size: 64px;\n    line-height: 69px;\n    font-weight: 700;\n    padding-top: 10px;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n    text-transform: uppercase;\n    .player {\n        font-size: 34px;\n    }\n    .ic-player__surname {\n        font-size: 36px;\n        font-weight: bold;\n    }\n'], ['\n    text-transform: uppercase;\n    .player {\n        font-size: 34px;\n    }\n    .ic-player__surname {\n        font-size: 36px;\n        font-weight: bold;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _SportIcons = __webpack_require__(1438);
	
	var _MatchScore = __webpack_require__(1439);
	
	var _MatchScore2 = _interopRequireDefault(_MatchScore);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18dict = _RCore2.default.i18Register(__webpack_require__(1440), {});
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18dict });
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var GoalTitle = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.titleColor || props.theme.color;
	});
	
	var MatchScoreWrapper = _styledComponents2.default.div(_templateObject3);
	
	var SubstitutionTitle = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.titleColor || props.theme.color;
	});
	
	var CardTitle = SubstitutionTitle.extend(_templateObject5);
	
	var PlayerInfo = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.color;
	});
	
	var PlayerName = _styledComponents2.default.div(_templateObject7);
	
	var SubstitutedPlayers = _styledComponents2.default.div(_templateObject8);
	
	var SubstitutedPlayerWrapper = _styledComponents2.default.div(_templateObject9, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.positiveColor;
	}, function (props) {
	    return props.theme.substitutionOutColor;
	}, function (props) {
	    return props.theme.color;
	});
	
	var CardWrapper = _styledComponents2.default.div(_templateObject10);
	
	var PlayerLastName = _styledComponents2.default.div(_templateObject11);
	
	var PlayerPhotoWrapper = _styledComponents2.default.div(_templateObject12);
	
	var PlayerPhoto = _styledComponents2.default.div(_templateObject13, function (props) {
	    return props.theme.logosBackground;
	}, function (props) {
	    return props.isJersey ? '\n       width: 80%;\n       height: auto;\n       margin: auto;\n       position: absolute;\n       top: 50%;\n       left: 50%;\n       transform: translate(-50%, -50%);\n       ' : '';
	});
	
	var IncidentMinute = _styledComponents2.default.div(_templateObject14, function (props) {
	    return 'color: ' + props.incidentMinuteColor + ';';
	});
	
	var Incident = _styledComponents2.default.div(_templateObject15);
	
	var Player = function Player(_ref) {
	    var teamId = _ref.teamId,
	        player = _ref.player,
	        card = _ref.card,
	        event = _ref.event;
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    return _react2.default.createElement(
	        PlayerInfo,
	        null,
	        _react2.default.createElement(
	            PlayerPhotoWrapper,
	            null,
	            _react2.default.createElement(
	                PlayerPhoto,
	                { isJersey: !_RCore2.default.hasCDNPlayerLogos(event.tournamentId) },
	                _react2.default.createElement(_UI2.default.PlayerLogo, {
	                    className: 'wdp-player-stats__header-teamlogo',
	                    display: 'image',
	                    size: 'large',
	                    playerId: player.id,
	                    seasonId: event.tournamentId,
	                    teamId: teamId
	                })
	            ),
	            card
	        ),
	        _react2.default.createElement(
	            PlayerName,
	            null,
	            player.shirtNumber ? player.shirtNumber + '.' : null,
	            ' ',
	            '' + (name.firstName || '')
	        ),
	        _react2.default.createElement(
	            PlayerLastName,
	            null,
	            '' + (name.lastName || '')
	        )
	    );
	};
	
	var Goal = function Goal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            null,
	            i18('title.goal', lang)
	        ),
	        _react2.default.createElement(Player, _extends({}, props, { teamId: props.incident.teamId }))
	    );
	};
	
	var Assist = function Assist(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            null,
	            i18('title.assist', lang)
	        ),
	        _react2.default.createElement(Player, _extends({}, props, { teamId: props.incident.teamId }))
	    );
	};
	
	var OwnGoal = function OwnGoal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    // swap team id, as incident teamId shows who will get a score
	    var teamId = props.incident.teamId === props.event.homeId ? props.event.awayId : props.event.homeId;
	
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            null,
	            i18('title.owngoal', lang)
	        ),
	        _react2.default.createElement(Player, _extends({}, props, { teamId: teamId }))
	    );
	};
	
	var Card = function Card(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var card = _react2.default.createElement(
	        CardWrapper,
	        null,
	        _react2.default.createElement(_SportIcons.SimpleCard, { width: 58, height: 76, radius: '3', color: props.cardColor })
	    );
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            CardTitle,
	            null,
	            i18('title.' + props.cardName, lang)
	        ),
	        _react2.default.createElement(Player, _extends({}, props, { teamId: props.incident.teamId, card: card }))
	    );
	};
	
	var SubstitutedPlayer = function SubstitutedPlayer(_ref2) {
	    var player = _ref2.player,
	        teamId = _ref2.teamId,
	        type = _ref2.type,
	        event = _ref2.event;
	
	    if (!player) return null;
	    var name = _RCore2.default.getFirstLastName(player.name);
	
	    return _react2.default.createElement(
	        SubstitutedPlayerWrapper,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'sm-substituted-player__number sm-substituted-player__number_' + type },
	            player.shirtNumber || '-',
	            _react2.default.createElement('span', { className: 'sm-substituted-player__icon_' + type })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'sm-substituted-player__info' },
	            _react2.default.createElement(
	                PlayerPhoto,
	                {
	                    isJersey: !_RCore2.default.hasCDNPlayerLogos(event.tournamentId),
	                    className: 'sm-substituted-player__photo'
	                },
	                _react2.default.createElement(_UI2.default.PlayerLogo, {
	                    display: 'image',
	                    size: 'large',
	                    playerId: player.id,
	                    seasonId: event.tournamentId,
	                    teamId: teamId
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'sm-substituted-player__name' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sm-substituted-player__name-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sm-substituted-player__name__inner' },
	                        name.firstName
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sm-substituted-player__name-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sm-substituted-player__name__inner' },
	                        name.lastName
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Substitution = function Substitution(_ref3, ctx) {
	    var event = _ref3.event,
	        incident = _ref3.incident,
	        player = _ref3.player,
	        player2 = _ref3.player2;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            SubstitutionTitle,
	            null,
	            i18('title.subs', lang)
	        ),
	        _react2.default.createElement(
	            SubstitutedPlayers,
	            null,
	            _react2.default.createElement(SubstitutedPlayer, { player: player, event: event, teamId: incident.teamId, type: 'in' }),
	            _react2.default.createElement('div', { style: { height: '10px' } }),
	            _react2.default.createElement(SubstitutedPlayer, { event: event, player: player2, teamId: incident.teamId, type: 'out' })
	        )
	    );
	};
	
	var Preview = function Preview(props, ctx) {
	    var event = props.event,
	        incidentId = props.incidentId,
	        matchScore = props.matchScore,
	        incidentMinuteColor = props.incidentMinuteColor,
	        incidentMinute = props.incidentMinute;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            IncidentMinute,
	            { incidentMinuteColor: incidentMinuteColor },
	            incidentMinute,
	            '\''
	        ),
	        _react2.default.createElement(
	            MatchScoreWrapper,
	            null,
	            _react2.default.createElement(_MatchScore2.default, _extends({}, matchScore, {
	                event: event,
	                view: 'nameScore',
	                styles: 'font-size: 32px;',
	                incidentId: incidentId
	            }))
	        )
	    );
	};
	
	Goal.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Wrapper.contextTypes = {
	    info: _propTypes2.default.object
	};
	Assist.contextTypes = {
	    info: _propTypes2.default.object
	};
	OwnGoal.contextTypes = {
	    info: _propTypes2.default.object
	};
	Card.contextTypes = {
	    info: _propTypes2.default.object
	};
	Preview.contextTypes = {
	    info: _propTypes2.default.object
	};
	Substitution.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = {
	    Preview: Preview,
	    Wrapper: Wrapper,
	    Goal: Goal,
	    Assist: Assist,
	    OwnGoal: OwnGoal,
	    Card: Card,
	    Substitution: Substitution
	};
	exports.Preview = Preview;
	exports.Wrapper = Wrapper;
	exports.Goal = Goal;
	exports.Assist = Assist;
	exports.OwnGoal = OwnGoal;
	exports.Card = Card;
	exports.Substitution = Substitution;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Goal = Goal;
	exports.Card = Card;
	exports.Cards = Cards;
	exports.SimpleCard = SimpleCard;
	exports.SubOut = SubOut;
	exports.Injury = Injury;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Goal(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            x: "0px",
	            y: "0px",
	            width: "200px",
	            height: "200px",
	            viewBox: "0 0 200 200",
	            enableBackground: "new 0 0 200 200"
	        }, props),
	        _react2.default.createElement(
	            "g",
	            { id: "Goal" },
	            _react2.default.createElement("path", {
	                d: "M100.7,8.5C50.8,8.5,10,49.3,10,99.2c0,49.899,40.8,90.7,90.7,90.7s90.7-40.801,90.7-90.7C191.4,49.3,150.6,8.5,100.7,8.5 M162,147.1l-1.6-10.898l-28,6l-15.102,25L127.6,172.1c-8.4,3.102-17.4,4.9-26.9,4.9s-18.5-1.8-26.9-4.9L84.1,167.2L69,142.2l-28-6 L39.4,147.1C29.1,133.9,22.9,117.3,22.9,99.2c0-0.8,0.1-1.7,0.1-2.5l7.4,7.8l19.7-21.9l-3-28.7L36,55.9 C46.2,40.7,61.6,29.4,79.6,24.3L74.3,34.2l26.4,11.3l26.4-11.3l-5.302-9.9c18.102,5.1,33.5,16.4,43.602,31.6L154.3,53.8l-3,28.7 l19.602,21.9l7.398-7.8c0,0.8,0.102,1.7,0.102,2.5C178.6,117.3,172.3,133.9,162,147.1 M100.7,69l31.7,23.4L120.3,129.5H81.1 L68.9,92.4L100.7,69z"
	            })
	        )
	    );
	}
	
	function Card(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            version: "1.1",
	            x: "0px",
	            y: "0px",
	            width: "200px",
	            height: "200px",
	            viewBox: "0 0 200 200",
	            enableBackground: "new 0 0 200 200"
	        }, props),
	        _react2.default.createElement("path", {
	            fill: props.color,
	            d: "M159,171.992c0,9.394-7.615,17.008-17.008,17.008H56.008C46.615,189,39,181.386,39,171.992V30.008 C39,20.615,46.615,13,56.008,13h85.984C151.385,13,159,20.615,159,30.008V171.992z"
	        })
	    );
	}
	
	function Cards(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            x: "0px",
	            y: "0px",
	            width: "200px",
	            height: "200px",
	            viewBox: "0 0 200 200",
	            enableBackground: "new 0 0 200 200"
	        }, props),
	        _react2.default.createElement("path", {
	            fill: "yellow",
	            d: "M125.747,148.817c1.343,7.594-3.726,14.838-11.319,16.18l-69.51,12.287c-7.593,1.342-14.837-3.726-16.179-11.319 L8.449,51.184c-1.342-7.594,3.726-14.838,11.319-16.18l69.511-12.287c7.593-1.342,14.837,3.726,16.179,11.319L125.747,148.817z"
	        }),
	        _react2.default.createElement("path", {
	            fill: "red",
	            d: "M177.359,163.628c-0.899,7.657-7.837,13.138-15.495,12.238l-70.107-8.233c-7.658-0.899-13.137-7.836-12.238-15.495 L93.112,36.373c0.899-7.658,7.838-13.138,15.495-12.239l70.107,8.232c7.658,0.9,13.138,7.837,12.238,15.496L177.359,163.628z"
	        })
	    );
	}
	
	function SimpleCard(props) {
	    var _props$width = props.width,
	        width = _props$width === undefined ? 115 : _props$width,
	        _props$height = props.height,
	        height = _props$height === undefined ? 140 : _props$height,
	        _props$color = props.color,
	        color = _props$color === undefined ? 'black' : _props$color,
	        _props$radius = props.radius,
	        radius = _props$radius === undefined ? 0 : _props$radius;
	
	    return _react2.default.createElement(
	        "svg",
	        { className: "sm-card", width: width, height: height },
	        _react2.default.createElement("rect", { rx: radius, ry: radius, width: width, height: height, fill: color })
	    );
	}
	
	function SubOut(props) {
	    return _react2.default.createElement(
	        "svg",
	        _extends({
	            x: "0px",
	            y: "0px",
	            width: "200px",
	            height: "200px",
	            viewBox: "0 0 200 200",
	            enableBackground: "new 0 0 200 200"
	        }, props),
	        _react2.default.createElement("polygon", { points: "4.834,98.708 94.429,160.551 94.429,120.526 191,120.526 191,76.891 94.429,76.891 94.429,36.866 " })
	    );
	}
	
	function Injury(_ref) {
	    var _ref$width = _ref.width,
	        width = _ref$width === undefined ? 20 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 20 : _ref$height,
	        _ref$colorCircle = _ref.colorCircle,
	        colorCircle = _ref$colorCircle === undefined ? '#cc0000' : _ref$colorCircle,
	        _ref$colorPlus = _ref.colorPlus,
	        colorPlus = _ref$colorPlus === undefined ? 'white' : _ref$colorPlus,
	        otherProps = _objectWithoutProperties(_ref, ["width", "height", "colorCircle", "colorPlus"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: width, height: height, viewBox: "0 0 20 20" }, otherProps),
	        _react2.default.createElement("circle", { r: "10", cx: "10", cy: "10", fill: colorCircle }),
	        _react2.default.createElement("rect", { x: "7.7", y: "2.8", width: "4.5", height: "14", fill: colorPlus }),
	        _react2.default.createElement("rect", { x: "3", y: "7.5", width: "14", height: "4.5", fill: colorPlus })
	    );
	}

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getScore = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    font-size: 25px;\n    line-height: 1;\n    white-space: nowrap;\n    color: ', ';\n    ', ';\n'], ['\n    font-size: 25px;\n    line-height: 1;\n    white-space: nowrap;\n    color: ', ';\n    ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    color: ', ';\n    padding-top: 36px;\n\n    &:after {\n        content: \'\';\n        width: 150%;\n        height: 600%;\n        position: absolute;\n        top: 0;\n        left: -25%;\n        z-index: -1;\n        background-color: currentColor;\n        color: inherit;\n    }\n\n    .sm-match-wrap {\n        font-size: 25px;\n        line-height: 1;\n        color: ', ';\n        ', ';\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .sm-match-score__team-name {\n        font-weight: bold;\n        text-transform: none;\n        font-size: 28px;\n        width: 260px;\n    }\n\n    .status {\n        text-align: center;\n        font-weight: bold;\n        font-size: 23px;\n        margin-bottom: 10px;\n        color: ', ';\n    }\n'], ['\n    position: relative;\n    color: ', ';\n    padding-top: 36px;\n\n    &:after {\n        content: \'\';\n        width: 150%;\n        height: 600%;\n        position: absolute;\n        top: 0;\n        left: -25%;\n        z-index: -1;\n        background-color: currentColor;\n        color: inherit;\n    }\n\n    .sm-match-wrap {\n        font-size: 25px;\n        line-height: 1;\n        color: ', ';\n        ', ';\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .sm-match-score__team-name {\n        font-weight: bold;\n        text-transform: none;\n        font-size: 28px;\n        width: 260px;\n    }\n\n    .status {\n        text-align: center;\n        font-weight: bold;\n        font-size: 23px;\n        margin-bottom: 10px;\n        color: ', ';\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 35px;\n    .score-dash {\n        margin: 0 10px;\n    }\n    > div {\n        display: flex;\n        align-items: center;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 35px;\n    .score-dash {\n        margin: 0 10px;\n    }\n    > div {\n        display: flex;\n        align-items: center;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    color: ', ';\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 90px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n    }\n    .score {\n        display: flex;\n        width: 220px;\n        align-items: center;\n        flex-direction: column;\n        .status {\n            font-size: 22px;\n            text-transform: uppercase;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 64px;\n        line-height: 64px;\n        font-weight: 700;\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n            &.home {\n                text-align: right;\n            }\n            &.away {\n                text-align: left;\n            }\n        }\n        .score-dash {\n            width: 40px;\n            text-align: center;\n        }\n    }\n    .team-name {\n        display: inline-block;\n        margin: 0 10px;\n        font-size: 60px;\n        font-weight: 700;\n        width: calc(50% - 110px);\n\n        &.home {\n            text-align: right;\n            .wdp-team-logo {\n                margin-left: 20px;\n                margin-right: 0px;\n            }\n        }\n        &.away {\n            text-align: left;\n            .wdp-team-logo {\n                margin-right: 20px;\n                margin-left: 0px;\n            }\n        }\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    color: ', ';\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 90px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n    }\n    .score {\n        display: flex;\n        width: 220px;\n        align-items: center;\n        flex-direction: column;\n        .status {\n            font-size: 22px;\n            text-transform: uppercase;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 64px;\n        line-height: 64px;\n        font-weight: 700;\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n            &.home {\n                text-align: right;\n            }\n            &.away {\n                text-align: left;\n            }\n        }\n        .score-dash {\n            width: 40px;\n            text-align: center;\n        }\n    }\n    .team-name {\n        display: inline-block;\n        margin: 0 10px;\n        font-size: 60px;\n        font-weight: 700;\n        width: calc(50% - 110px);\n\n        &.home {\n            text-align: right;\n            .wdp-team-logo {\n                margin-left: 20px;\n                margin-right: 0px;\n            }\n        }\n        &.away {\n            text-align: left;\n            .wdp-team-logo {\n                margin-right: 20px;\n                margin-left: 0px;\n            }\n        }\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    color: ', ';\n\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 140px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n\n        .team-name {\n            width: calc(50% - 40px);\n        }\n    }\n    .score {\n        display: flex;\n        width: 280px;\n        margin-top: -50px;\n        align-items: center;\n        flex-direction: column;\n\n        .status {\n            font-size: 24px;\n            margin-bottom: 12px;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 72px;\n        line-height: 1em;\n        font-weight: 700;\n\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n\n            &.home {\n                text-align: right;\n            }\n\n            &.away {\n                text-align: left;\n            }\n        }\n\n        .score-dash {\n            width: 60px;\n            text-align: center;\n        }\n    }\n    .team-name {\n        display: inline-block;\n        margin: 0 10px;\n        width: calc(50% - 110px);\n        font-size: 60px;\n        font-weight: 700;\n        &.home {\n            text-align: right;\n            .wdp-team-logo {\n                margin-left: 30px;\n                margin-right: 0px;\n            }\n        }\n        &.away {\n            text-align: left;\n            .wdp-team-logo {\n                margin-right: 30px;\n                margin-left: 0px;\n            }\n        }\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    color: ', ';\n\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 140px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n\n        .team-name {\n            width: calc(50% - 40px);\n        }\n    }\n    .score {\n        display: flex;\n        width: 280px;\n        margin-top: -50px;\n        align-items: center;\n        flex-direction: column;\n\n        .status {\n            font-size: 24px;\n            margin-bottom: 12px;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 72px;\n        line-height: 1em;\n        font-weight: 700;\n\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n\n            &.home {\n                text-align: right;\n            }\n\n            &.away {\n                text-align: left;\n            }\n        }\n\n        .score-dash {\n            width: 60px;\n            text-align: center;\n        }\n    }\n    .team-name {\n        display: inline-block;\n        margin: 0 10px;\n        width: calc(50% - 110px);\n        font-size: 60px;\n        font-weight: 700;\n        &.home {\n            text-align: right;\n            .wdp-team-logo {\n                margin-left: 30px;\n                margin-right: 0px;\n            }\n        }\n        &.away {\n            text-align: left;\n            .wdp-team-logo {\n                margin-right: 30px;\n                margin-left: 0px;\n            }\n        }\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    color: ', ';\n\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 250px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n\n        .team-name {\n            width: calc(50% - 40px);\n        }\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 230px;\n\n        .status {\n            font-size: 24px;\n            margin-bottom: 12px;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 120px;\n        line-height: 1em;\n        font-weight: 700;\n\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n\n            &.home {\n                text-align: right;\n            }\n\n            &.away {\n                text-align: left;\n            }\n        }\n\n        .score-dash {\n            width: 60px;\n            text-align: center;\n        }\n    }\n    .team-logo {\n        display: inline-block;\n        margin: 0 10px;\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    \n    .penalty-title {\n      font-size: 30px;\n      line-height: 1em;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    color: ', ';\n\n    .wdp-team-logo {\n        vertical-align: middle;\n        height: 250px;\n        width: auto;\n    }\n\n    &.score-small {\n        .score {\n            width: 80px;\n        }\n\n        .team-name {\n            width: calc(50% - 40px);\n        }\n    }\n    .score {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 230px;\n\n        .status {\n            font-size: 24px;\n            margin-bottom: 12px;\n        }\n    }\n\n    .score-box {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        font-size: 120px;\n        line-height: 1em;\n        font-weight: 700;\n\n        .score-digit {\n            display: inline-block;\n            flex-grow: 1;\n\n            width: calc(50% - 20px);\n\n            &.home {\n                text-align: right;\n            }\n\n            &.away {\n                text-align: left;\n            }\n        }\n\n        .score-dash {\n            width: 60px;\n            text-align: center;\n        }\n    }\n    .team-logo {\n        display: inline-block;\n        margin: 0 10px;\n    }\n\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    \n    .penalty-title {\n      font-size: 30px;\n      line-height: 1em;\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    color: ', ';\n    ', ' ', ' ', ';\n    .sm-match-score__score {\n        display: inline-block;\n        margin: 0 10px;\n    }\n\n    &.no-logo {\n        display: flex;\n        align-items: center;\n        /*hyphens: auto;*/\n\n        .sm-match-score__score {\n            font-size: 74px;\n            font-weight: bold;\n            color: ', ';\n            margin: 0 30px;\n        }\n    }\n'], ['\n    color: ', ';\n    ', ' ', ' ', ';\n    .sm-match-score__score {\n        display: inline-block;\n        margin: 0 10px;\n    }\n\n    &.no-logo {\n        display: flex;\n        align-items: center;\n        /*hyphens: auto;*/\n\n        .sm-match-score__score {\n            font-size: 74px;\n            font-weight: bold;\n            color: ', ';\n            margin: 0 30px;\n        }\n    }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    width: 30px;\n    text-align: center;\n    font-size: 74px;\n    font-weight: bold;\n    color: ', ';\n'], ['\n    width: 30px;\n    text-align: center;\n    font-size: 74px;\n    font-weight: bold;\n    color: ', ';\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var incidentIdsMap = {
	    goal: [7, 8, 28],
	    goal_own: [10],
	    assist: [34],
	    yellow_card: [14],
	    red_card: [15, 16],
	    substitution: [32]
	};
	
	var NameScoreView = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.styles;
	});
	
	var NoLogoView = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.styles;
	}, function (props) {
	    return props.theme.color;
	});
	
	var NameLogoScoreView = _styledComponents2.default.div(_templateObject3);
	
	var LogoScoreView = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.color;
	});
	
	var LargeLogoScoreView = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.color;
	});
	
	var ExtraLargeLogoScoreView = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.color;
	});
	
	var sortIncidents = function sortIncidents(incidents, assistIncidentIds, goalIncidentIds) {
	    //Simple sort by minute and incident id
	    var sortedByMinAndId = _lodash2.default.sortBy(incidents, ['min', 'incidentId']);
	
	    //Find assist incidents which stay before associated goal incident and create map
	    var assistsToGoalsMap = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var inc = _step.value;
	            var typeId = inc.typeId;
	
	            if (assistIncidentIds.indexOf(typeId) > -1) {
	                var _assistIndex = _lodash2.default.findIndex(sortedByMinAndId, function (i) {
	                    return i.incidentId === inc.incidentId;
	                });
	                var _goalIndex = _lodash2.default.findIndex(sortedByMinAndId, function (i) {
	                    return i.min === inc.min && goalIncidentIds.indexOf(i.typeId) > -1 && i.teamId === inc.teamId;
	                });
	
	                if (isNaN(_assistIndex) || isNaN(_goalIndex)) return {
	                        v: void 0
	                    };
	
	                if (_assistIndex < _goalIndex) {
	                    assistsToGoalsMap[_assistIndex] = _goalIndex;
	                }
	            }
	        };
	
	        for (var _iterator = sortedByMinAndId[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ret = _loop();
	
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	
	        //Swap positions of assist and goal in the array so assist always goes after goal
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    for (var assistIndex in assistsToGoalsMap) {
	        if (!assistsToGoalsMap.hasOwnProperty(assistIndex)) continue;
	        var goalIndex = assistsToGoalsMap[assistIndex];
	        var assist = sortedByMinAndId[assistIndex];
	
	        sortedByMinAndId[assistIndex] = sortedByMinAndId[goalIndex];
	        sortedByMinAndId[goalIndex] = assist;
	    }
	
	    return sortedByMinAndId;
	};
	
	var NameScore = _styledComponents2.default.span(_templateObject7, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.isOwnGoal && 'color: ' + props.theme.negativeColor + ';';
	}, function (props) {
	    return props.isOwnGoal && 'font-weight: 700;';
	}, function (props) {
	    return props.scored && 'font-weight: 700;';
	}, function (props) {
	    return props.theme.primaryColor;
	});
	
	var Divider = _styledComponents2.default.span(_templateObject8, function (props) {
	    return props.theme.primaryColor;
	});
	
	var getScore = function getScore(props) {
	    var event = props.event,
	        incidentId = props.incidentId;
	
	
	    if (!incidentId) return event.score;
	
	    var assistIncidentIds = incidentIdsMap['assist'];
	    var goalIncidentIds = incidentIdsMap['goal'];
	    var ownGoalIncidentIds = incidentIdsMap['goal_own'];
	
	    var incidents = event.incidents;
	
	    //Sort incidents so when incidents minutes are equal, they will be sorted by IDS numbers
	
	    incidents = sortIncidents(incidents, assistIncidentIds, goalIncidentIds);
	
	    var incidentIndex = incidents.findIndex(function (inc) {
	        return inc.incidentId === incidentId;
	    });
	
	    return incidents.slice(0, ++incidentIndex).reduce(function (score, inc) {
	        var typeId = inc.typeId;
	
	
	        var homeGoal = inc.home && goalIncidentIds.indexOf(typeId) !== -1;
	        var homeOwnGoal = !inc.home && ownGoalIncidentIds.indexOf(typeId) !== -1;
	
	        var awayGoal = !inc.home && goalIncidentIds.indexOf(typeId) !== -1;
	        var awayOwnGoal = inc.home && ownGoalIncidentIds.indexOf(typeId) !== -1;
	
	        if (homeGoal || awayOwnGoal) score.home = ++score.home;
	        if (awayGoal || homeOwnGoal) score.away = ++score.away;
	
	        return score;
	    }, { home: 0, away: 0 });
	};
	
	var MatchScore = function MatchScore(props, ctx) {
	    var view = props.view,
	        event = props.event,
	        styles = props.styles,
	        homeIsOwnGoal = props.homeIsOwnGoal,
	        awayIsOwnGoal = props.awayIsOwnGoal,
	        homeScored = props.homeScored,
	        awayScored = props.awayScored,
	        alwaysShowZero = props.alwaysShowZero,
	        penaltyTitle = props.penaltyTitle;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var content = null;
	
	    var homeName = event.homeShortName || event.homeName && event.homeName.substr(0, 3).toUpperCase();
	    var awayName = event.awayShortName || event.awayName && event.awayName.substr(0, 3).toUpperCase();
	    var score = getScore(props);
	
	    var e = (0, _Eventify2.default)(event);
	
	    var hasScore = e.isLive() || e.isPostponed() || e.isFT();
	
	    if (view === 'noLogo' || view === MatchScore.SMALL) {
	        content = _react2.default.createElement(
	            NoLogoView,
	            { className: 'noLogo' },
	            hasScore && _react2.default.createElement(
	                'div',
	                { className: 'status __c__c1noLogo' },
	                i18('status.full.' + e.statusType, lang)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'sm-match-wrap' },
	                _react2.default.createElement(
	                    NameScore,
	                    {
	                        className: 'no-logo',
	                        style: { textAlign: 'right' },
	                        isOwnGoal: homeIsOwnGoal,
	                        scored: homeScored
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sm-match-score__team-name __c__c2noLogo' },
	                        event.homeName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sm-match-score__score __c__c3noLogo' },
	                        alwaysShowZero ? 0 : score.home
	                    )
	                ),
	                _react2.default.createElement(
	                    Divider,
	                    { className: '__c__c4noLogo' },
	                    ' - '
	                ),
	                _react2.default.createElement(
	                    NameScore,
	                    { className: 'no-logo', isOwnGoal: awayIsOwnGoal, scored: awayScored },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sm-match-score__score __c__c3noLogo' },
	                        alwaysShowZero ? 0 : score.away
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sm-match-score__team-name __c__c2noLogo' },
	                        event.awayName
	                    )
	                )
	            )
	        );
	    }
	
	    if (view === 'nameScore' || view === MatchScore.SMALL) {
	        content = _react2.default.createElement(
	            NameScoreView,
	            { styles: styles },
	            _react2.default.createElement(
	                NameScore,
	                { isOwnGoal: homeIsOwnGoal, scored: homeScored },
	                homeName,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sm-match-score__score' },
	                    alwaysShowZero ? 0 : score.home
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                null,
	                ' - '
	            ),
	            _react2.default.createElement(
	                NameScore,
	                { isOwnGoal: awayIsOwnGoal, scored: awayScored },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sm-match-score__score' },
	                    alwaysShowZero ? 0 : score.away
	                ),
	                awayName
	            )
	        );
	    }
	
	    if (view === 'logoScore' || view === MatchScore.CLEAN) {
	        content = _react2.default.createElement(
	            LogoScoreView,
	            { className: '' + (!hasScore && 'score-small') },
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name home' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    event.homeShortName
	                ),
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, fontSize: 32, teamId: event.homeId })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                hasScore && _react2.default.createElement(
	                    'span',
	                    { className: 'status __c__c1logoScore' },
	                    i18('status.full.' + e.statusType, lang)
	                ),
	                hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3logoScore' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-digit home' },
	                        score.home
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-digit away' },
	                        score.away
	                    )
	                ),
	                !hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3logoScore' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name away' },
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, fontSize: 32, teamId: event.awayId }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    event.awayShortName
	                )
	            )
	        );
	    }
	
	    if (view === 'nameLogoScore') {
	        content = _react2.default.createElement(
	            NameLogoScoreView,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                homeName,
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    height: 50,
	                    style: { marginLeft: 15 },
	                    tournamentId: event.tournamentTemplateId,
	                    teamId: event.homeId
	                })
	            ),
	            hasScore && _react2.default.createElement(
	                'div',
	                { className: 'score-box __c__c3nameLogoScore' },
	                _react2.default.createElement(
	                    NameScore,
	                    { isOwnGoal: homeIsOwnGoal, scored: homeScored },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'home' },
	                        score.home
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'score-dash' },
	                    '-'
	                ),
	                _react2.default.createElement(
	                    NameScore,
	                    { isOwnGoal: awayIsOwnGoal, scored: awayScored },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'away' },
	                        score.away
	                    )
	                )
	            ),
	            !hasScore && _react2.default.createElement(
	                'div',
	                { className: 'score-box __c__c3nameLogoScore' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'score-dash' },
	                    '-'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    height: 50,
	                    style: { marginRight: 15 },
	                    tournamentId: event.tournamentTemplateId,
	                    teamId: event.awayId
	                }),
	                awayName
	            )
	        );
	    }
	
	    if (view === 'simpleLogoScore') {
	        content = _react2.default.createElement(
	            LogoScoreView,
	            { className: (!hasScore && 'score-small') + ' logo-score-view' },
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name home' },
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    tournamentId: event.tournamentTemplateId,
	                    teamId: event.homeId,
	                    fontSize: 38,
	                    teamShortName: homeName
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'score', style: { width: '150px' } },
	                hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3simpleLogoScore' },
	                    _react2.default.createElement(
	                        NameScore,
	                        {
	                            style: { width: 'calc(50% - 40px)', textAlign: 'right' },
	                            isOwnGoal: homeIsOwnGoal,
	                            scored: homeScored
	                        },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'home' },
	                            score.home
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    ),
	                    _react2.default.createElement(
	                        NameScore,
	                        {
	                            style: { width: 'calc(50% - 40px)', textAlign: 'left' },
	                            isOwnGoal: awayIsOwnGoal,
	                            scored: awayScored
	                        },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'away' },
	                            score.away
	                        )
	                    )
	                ),
	                !hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3simpleLogoScore' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name away' },
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    tournamentId: event.tournamentTemplateId,
	                    teamId: event.awayId,
	                    fontSize: 38,
	                    teamShortName: awayName
	                })
	            )
	        );
	    }
	
	    if (view === 'largeLogoScore' || view === MatchScore.CLEAN) {
	        content = _react2.default.createElement(
	            LargeLogoScoreView,
	            { className: '' + (!hasScore && 'score-small') },
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name home' },
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    tournamentId: event.tournamentTemplateId,
	                    height: 140,
	                    teamId: event.homeId,
	                    teamShortName: homeName
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                hasScore && _react2.default.createElement(
	                    'span',
	                    { className: 'status __c__c1largeLogoScore' },
	                    i18('status.full.' + e.statusType, lang)
	                ),
	                hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3largeLogoScore' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-digit home' },
	                        score.home
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-digit away' },
	                        score.away
	                    )
	                ),
	                !hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3largeLogoScore' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'score-dash' },
	                        '-'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'team-name away' },
	                _react2.default.createElement(_SMTeamLogo2.default, { height: 140, teamId: event.awayId, teamShortName: awayName })
	            )
	        );
	    }
	
	    if (view === 'extraLargeLogoScore' || view === MatchScore.CLEAN) {
	        content = _react2.default.createElement(
	            ExtraLargeLogoScoreView,
	            { className: '' + (!hasScore && 'score-small') },
	            _react2.default.createElement(
	                'span',
	                { className: 'team-logo' },
	                _react2.default.createElement(_SMTeamLogo2.default, {
	                    tournamentId: event.tournamentTemplateId,
	                    height: 250,
	                    teamId: event.homeId,
	                    teamShortName: homeName
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3__extraLargeLogoScore' },
	                    score.home,
	                    '-',
	                    score.away
	                ),
	                !hasScore && _react2.default.createElement(
	                    'div',
	                    { className: 'score-box __c__c3__extraLargeLogoScore' },
	                    '-'
	                ),
	                penaltyTitle && _react2.default.createElement(
	                    'div',
	                    { className: 'penalty-title' },
	                    penaltyTitle
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'team-logo' },
	                _react2.default.createElement(_SMTeamLogo2.default, { height: 140, teamId: event.awayId, teamShortName: awayName })
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'sm-match-score' },
	        content
	    );
	};
	
	MatchScore.propTypes = {
	    view: _propTypes2.default.string.isRequired, //nameScore, logoScore, logoNameScore
	    event: _propTypes2.default.object.isRequired,
	    incidentId: _propTypes2.default.number
	};
	MatchScore.contextTypes = {
	    moment: _propTypes2.default.func,
	    info: _propTypes2.default.object
	};
	
	MatchScore.CLEAN = 'CLEAN';
	MatchScore.SMALL = 'SMALL';
	exports.default = MatchScore;
	exports.getScore = getScore;

/***/ },
/* 1440 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    da: {
	        in: 'ind',
	        min: 'min',
	        out: 'ud',
	        'title.assist': 'ASSIST',
	        'title.goal': 'MÅL',
	        'title.owngoal': 'SELVMÅL',
	        'title.red_card': 'RØDT KORT',
	        'title.subs': 'UDSKIFTNING',
	        'title.yellow_card': 'GULT KORT'
	    },
	    de: {
	        in: 'in',
	        min: 'min',
	        out: 'aus',
	        'title.assist': 'ASSIST',
	        'title.goal': 'TOR',
	        'title.owngoal': 'EIGENTOR',
	        'title.red_card': 'ROTE KARTE',
	        'title.subs': 'AUSWECHSLUNG',
	        'title.yellow_card': 'GELBE KARTE'
	    },
	    en: {
	        in: 'in',
	        min: 'min',
	        out: 'out',
	        'title.assist': 'ASSIST',
	        'title.goal': 'GOAL',
	        'title.owngoal': 'OWN GOAL',
	        'title.red_card': 'RED CARD',
	        'title.subs': 'SUBSTITUTION',
	        'title.yellow_card': 'YELLOW CARD'
	    },
	    fi: {
	        in: 'sisään',
	        min: 'min',
	        out: 'ulos',
	        'title.assist': 'SYÖTTÖ',
	        'title.goal': 'MAALI',
	        'title.owngoal': 'OMA MAALI',
	        'title.red_card': 'PUNAINEN KORTTI',
	        'title.subs': 'VAIHTO',
	        'title.yellow_card': 'KELTAINEN KORTTI'
	    },
	    no: {},
	    sc: {},
	    se: {
	        in: 'i',
	        min: 'min',
	        out: 'ut',
	        'title.assist': 'ASSIST',
	        'title.goal': 'MÅL',
	        'title.owngoal': 'SJÄLVMÅL',
	        'title.red_card': 'RÖTT KORT',
	        'title.subs': 'BYTE',
	        'title.yellow_card': 'GULT KORT'
	    },
	    th: {}
	};

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Substitution = exports.Card = exports.OwnGoal = exports.Assist = exports.Goal = exports.Wrapper = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    font-size: ', 'px;\n    line-height: 1.1;\n    vertical-align: middle;\n    display: inline-block;\n    white-space: nowrap;\n'], ['\n    font-size: ', 'px;\n    line-height: 1.1;\n    vertical-align: middle;\n    display: inline-block;\n    white-space: nowrap;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    height: ', 'px;\n'], ['\n    height: ', 'px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    transform: rotate(15deg) translateY(-4px);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    overflow: hidden;\n    display: inline-block;\n'], ['\n    transform: rotate(15deg) translateY(-4px);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    overflow: hidden;\n    display: inline-block;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    font-size: 36px;\n    text-transform: uppercase;\n    margin-right: 20px;\n    color: ', ';\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    &:before {\n        content: \'\';\n        display: inline-block;\n        margin-right: 20px;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 20px 0 20px 30px;\n        border-color: transparent transparent transparent\n            ', ';\n        vertical-align: middle;\n        ', ';\n    }\n'], ['\n    font-size: 36px;\n    text-transform: uppercase;\n    margin-right: 20px;\n    color: ', ';\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    &:before {\n        content: \'\';\n        display: inline-block;\n        margin-right: 20px;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 20px 0 20px 30px;\n        border-color: transparent transparent transparent\n            ', ';\n        vertical-align: middle;\n        ', ';\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    display: inline-block;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n'], ['\n    display: inline-block;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    width: calc(800px - 320px - 30px - ', 'px);\n    text-align: center;\n\n    strong {\n        display: flex;\n        justify-content: center;\n    }\n'], ['\n    width: calc(800px - 320px - 30px - ', 'px);\n    text-align: center;\n\n    strong {\n        display: flex;\n        justify-content: center;\n    }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    text-align: left;\n    display: flex;\n    justify-content: center;\n'], ['\n    text-align: left;\n    display: flex;\n    justify-content: center;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    text-align: center;\n    margin: auto;\n'], ['\n    text-align: center;\n    margin: auto;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    position: relative;\n    width: ', 'px;\n    img {\n        height: auto;\n    }\n'], ['\n    position: relative;\n    width: ', 'px;\n    img {\n        height: auto;\n    }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    .wdp-team-logo {\n        height: 60px !important;\n    }\n    .team-name {\n        width: calc(50% - 80px) !important;\n    }\n    .score-box {\n        font-size: 50px !important;\n        line-height: 1;\n        font-weight: 400 !important;\n    }\n'], ['\n    .wdp-team-logo {\n        height: 60px !important;\n    }\n    .team-name {\n        width: calc(50% - 80px) !important;\n    }\n    .score-box {\n        font-size: 50px !important;\n        line-height: 1;\n        font-weight: 400 !important;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SportIcons = __webpack_require__(1438);
	
	var _MatchScore = __webpack_require__(1439);
	
	var _MatchScore2 = _interopRequireDefault(_MatchScore);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var dict = _RCore2.default.i18Register(__webpack_require__(1440), {});
	var i18 = _RCore2.default.getTranslation.bind({ dict: dict });
	
	var Text = _styledComponents2.default.span(_templateObject, function (props) {
	    return props.size;
	});
	var Space = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.size;
	});
	var Flex = _styledComponents2.default.div(_templateObject3);
	var CardIconWrapper = _styledComponents2.default.div(_templateObject4);
	var SubstitutionType = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.in ? props.theme.positiveColor : props.theme.substitutionOutColor;
	}, function (props) {
	    return props.in ? props.theme.positiveColor : props.theme.substitutionOutColor;
	}, function (props) {
	    return props.in ? 'transform: rotate(180deg);' : '';
	});
	
	var EllipsisOverflow = _styledComponents2.default.span(_templateObject6);
	
	var InfoWrapper = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.contentPadding * 2;
	});
	
	var MainContent = _styledComponents2.default.div(_templateObject8);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject9);
	
	var ShirtWrapper = _styledComponents2.default.div(_templateObject10, function (props) {
	    return props.width || '320';
	});
	
	var MatchScoreWrapper = _styledComponents2.default.div(_templateObject11);
	
	var getPlayerName = function getPlayerName(_ref) {
	    var shortFirstName = _ref.shortFirstName,
	        lastName = _ref.lastName;
	
	    return shortFirstName + ' ' + lastName;
	};
	
	var getPlayerShirt = function getPlayerShirt(_ref2) {
	    var event = _ref2.event,
	        player = _ref2.player,
	        incident = _ref2.incident,
	        width = _ref2.width;
	
	    var isHome = incident.home === 1;
	    if (incident.typeId === 10) isHome = !isHome; // swap teams for own goal
	
	    return _react2.default.createElement(
	        ShirtWrapper,
	        { width: width },
	        _react2.default.createElement(_SMPlayerLogo.PlayerLogo3DJerseyBack, {
	            display: '3d_jersey_back',
	            number: _lodash2.default.get(player, 'shirtNumber'),
	            playerId: _lodash2.default.get(player, 'id'),
	            width: width || 320,
	            seasonId: event.tournamentId,
	            teamId: isHome ? event.homeId : event.awayId
	        })
	    );
	};
	
	var Score = function Score(_ref3) {
	    var incidentId = _ref3.incidentId,
	        event = _ref3.event,
	        matchScore = _ref3.matchScore;
	
	    return _react2.default.createElement(
	        MatchScoreWrapper,
	        { className: '__c__c5' },
	        _react2.default.createElement(_MatchScore2.default, _extends({}, matchScore, {
	            event: event,
	            view: 'simpleLogoScore',
	            styles: 'font-size: 50px;',
	            incidentId: incidentId
	        }))
	    );
	};
	
	var Wrapper = function Wrapper(_ref4) {
	    var children = _ref4.children,
	        matchScore = _ref4.matchScore,
	        event = _ref4.event,
	        incidentId = _ref4.incidentId,
	        incidentMinute = _ref4.incidentMinute,
	        incidentColor = _ref4.incidentColor;
	
	    return _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	            MainContent,
	            null,
	            children
	        )
	    );
	};
	
	var Assist = function Assist(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Flex,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { marginRight: '10px' } },
	            getPlayerShirt(props)
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                    Text,
	                    { size: 110, bold: true },
	                    i18('title.assist', lang).toUpperCase()
	                )
	            ),
	            _react2.default.createElement(Space, { size: 10 }),
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	
	var IncidentInfo = function IncidentInfo(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var playerName = getPlayerName(props.playerName);
	
	    var fontSize = playerName.length < 15 ? 50 : 30;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            EllipsisOverflow,
	            null,
	            _react2.default.createElement(
	                Text,
	                {
	                    style: {
	                        maxWidth: '100%',
	                        textOverflow: 'ellipsis',
	                        overflow: 'hidden'
	                    },
	                    className: '__c__c1',
	                    size: fontSize
	                },
	                playerName
	            )
	        ),
	        _react2.default.createElement(Space, { size: 20 }),
	        _react2.default.createElement(Score, props),
	        _react2.default.createElement(
	            Text,
	            { className: '__c__c2', size: 30, style: { marginLeft: 10 } },
	            props.incidentMinute,
	            ' ',
	            i18('min', lang),
	            '.'
	        )
	    );
	};
	
	var Goal = function Goal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Flex,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { marginRight: '10px' } },
	            getPlayerShirt(props)
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                    Text,
	                    { size: 130, bold: true, className: '__c__c3' },
	                    i18('title.goal', lang).toUpperCase()
	                )
	            ),
	            _react2.default.createElement(Space, { size: 10 }),
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	
	var OwnGoal = function OwnGoal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        Flex,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { marginRight: '10px' } },
	            getPlayerShirt(props)
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                    Text,
	                    { size: 75, bold: true, style: { color: props.incidentMinuteColor }, className: '__c__c4' },
	                    i18('title.owngoal', lang).toUpperCase()
	                )
	            ),
	            _react2.default.createElement(Space, { size: 10 }),
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	var Card = function Card(_ref5) {
	    var cardColor = _ref5.cardColor,
	        cardName = _ref5.cardName,
	        playerName = _ref5.playerName,
	        props = _objectWithoutProperties(_ref5, ['cardColor', 'cardName', 'playerName']);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Flex,
	            null,
	            _react2.default.createElement(
	                'div',
	                { style: { marginRight: '10px' } },
	                getPlayerShirt(props)
	            ),
	            _react2.default.createElement(
	                InfoWrapper,
	                null,
	                _react2.default.createElement(
	                    CardIconWrapper,
	                    null,
	                    _react2.default.createElement(_SportIcons.SimpleCard, { width: 76, height: 100, color: cardColor })
	                ),
	                _react2.default.createElement(Space, { size: 25 }),
	                _react2.default.createElement(IncidentInfo, _extends({}, props, { playerName: playerName }))
	            )
	        )
	    );
	};
	var Substitution = function Substitution(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Flex,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { position: 'relative', marginTop: -200, marginRight: 100 } },
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        width: 150
	                    }
	                },
	                getPlayerShirt(_extends({}, props, { player: props.player2, width: 150 }))
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        width: 200,
	                        position: 'absolute',
	                        bottom: -200,
	                        left: 30,
	                        zIndex: 2
	                    }
	                },
	                getPlayerShirt(_extends({}, props, { width: 200 }))
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        whiteSpace: 'nowrap',
	                        marginTop: 75,
	                        marginLeft: -40,
	                        overflow: 'hidden'
	                    }
	                },
	                _react2.default.createElement(
	                    SubstitutionType,
	                    { out: true, style: { display: 'inline-block', verticalAlign: 'middle' } },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        i18('out', lang)
	                    )
	                ),
	                _react2.default.createElement(
	                    Text,
	                    {
	                        size: 40,
	                        style: {
	                            display: 'inline-block',
	                            verticalAlign: 'middle',
	                            width: '70%',
	                            textAlign: 'left'
	                        }
	                    },
	                    _react2.default.createElement(
	                        EllipsisOverflow,
	                        { style: { width: '100%' } },
	                        _react2.default.createElement(
	                            Text,
	                            {
	                                className: '__c__c14',
	                                style: {
	                                    maxWidth: '100%',
	                                    textOverflow: 'ellipsis',
	                                    overflow: 'hidden'
	                                },
	                                size: 50
	                            },
	                            getPlayerName(props.player2Name)
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        opacity: 0.85,
	                        whiteSpace: 'nowrap',
	                        marginTop: 20,
	                        overflow: 'hidden'
	                    }
	                },
	                _react2.default.createElement(
	                    SubstitutionType,
	                    { 'in': true, style: { display: 'inline-block', verticalAlign: 'middle' } },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        i18('in', lang)
	                    )
	                ),
	                _react2.default.createElement(
	                    Text,
	                    {
	                        size: 50,
	                        style: {
	                            display: 'inline-block',
	                            verticalAlign: 'middle',
	                            width: '100%',
	                            textAlign: 'left'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%' } },
	                        _react2.default.createElement(
	                            Text,
	                            {
	                                className: '__c__c12',
	                                style: {
	                                    maxWidth: '80%',
	                                    whiteSpace: 'nowrap',
	                                    textOverflow: 'ellipsis',
	                                    overflow: 'hidden'
	                                },
	                                size: 50
	                            },
	                            getPlayerName(props.playerName)
	                        )
	                    )
	                ),
	                _react2.default.createElement(Space, { size: 40 }),
	                _react2.default.createElement(Score, props),
	                _react2.default.createElement(
	                    Text,
	                    { className: '__c__c13', size: 30, style: { textAlign: 'center', width: '100%' } },
	                    props.incidentMinute,
	                    ' ',
	                    i18('min', lang),
	                    '.'
	                )
	            )
	        )
	    );
	};
	
	Goal.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Wrapper.contextTypes = {
	    info: _propTypes2.default.object
	};
	Assist.contextTypes = {
	    info: _propTypes2.default.object
	};
	OwnGoal.contextTypes = {
	    info: _propTypes2.default.object
	};
	Card.contextTypes = {
	    info: _propTypes2.default.object
	};
	Substitution.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = {
	    Wrapper: Wrapper,
	    Goal: Goal,
	    Assist: Assist,
	    OwnGoal: OwnGoal,
	    Card: Card,
	    Substitution: Substitution,
	    disableBranding: true,
	    contentProps: { style: { height: 550 } }
	};
	exports.Wrapper = Wrapper;
	exports.Goal = Goal;
	exports.Assist = Assist;
	exports.OwnGoal = OwnGoal;
	exports.Card = Card;
	exports.Substitution = Substitution;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Substitution = exports.Card = exports.OwnGoal = exports.Assist = exports.Goal = exports.Wrapper = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    .player-logo {\n        position: absolute;\n        right: 50px;\n        bottom: 130px;\n    }\n'], ['\n    .player-logo {\n        position: absolute;\n        right: 50px;\n        bottom: 130px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: 700;\n    font-size: 150px;\n    line-height: 159px;\n    font-weight: 700;\n    white-space: nowrap;\n'], ['\n    color: ', ';\n    font-weight: 700;\n    font-size: 150px;\n    line-height: 159px;\n    font-weight: 700;\n    white-space: nowrap;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: absolute;\n    text-align: center;\n    bottom: 150px;\n    width: 460px;\n    left: ', 'px;\n'], ['\n    position: absolute;\n    text-align: center;\n    bottom: 150px;\n    width: 460px;\n    left: ', 'px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    transform: rotate(10deg);\n    height: 140px;\n    display: inline-block;\n    margin: 0 auto 25px;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    overflow: hidden;\n    img {\n        height: 100%;\n        width: auto;\n    }\n'], ['\n    transform: rotate(10deg);\n    height: 140px;\n    display: inline-block;\n    margin: 0 auto 25px;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    overflow: hidden;\n    img {\n        height: 100%;\n        width: auto;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100px;\n    background: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    padding-left: ', 'px;\n    .sm-match-score {\n        width: 460px;\n        padding: 0 35px;\n        box-sizing: border-box;\n    }\n'], ['\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100px;\n    background: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    padding-left: ', 'px;\n    .sm-match-score {\n        width: 460px;\n        padding: 0 35px;\n        box-sizing: border-box;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    text-align: center;\n    color: ', ';\n    text-transform: uppercase;\n'], ['\n    text-align: center;\n    color: ', ';\n    text-transform: uppercase;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: ', 'px;\n    font-weight: 700;\n    line-height: 42px;\n    margin-bottom: 8px;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n'], ['\n    font-size: ', 'px;\n    font-weight: 700;\n    line-height: 42px;\n    margin-bottom: 8px;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    ', ' text-align: center;\n    font-size: 35px;\n    line-height: 42px;\n'], ['\n    ', ' text-align: center;\n    font-size: 35px;\n    line-height: 42px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    text-transform: uppercase;\n    .player {\n        font-size: 34px;\n    }\n    .ic-player__surname {\n        font-size: 36px;\n        font-weight: bold;\n    }\n'], ['\n    text-transform: uppercase;\n    .player {\n        font-size: 34px;\n    }\n    .ic-player__surname {\n        font-size: 36px;\n        font-weight: bold;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _MatchScore = __webpack_require__(1439);
	
	var _MatchScore2 = _interopRequireDefault(_MatchScore);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IncidentWithPhotos = __webpack_require__(1437);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18dict = _RCore2.default.i18Register(__webpack_require__(1440), {});
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18dict });
	
	var IncidentStyle = _styledComponents2.default.div(_templateObject);
	var GoalTitle = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.color || props.theme.titleColor || props.theme.color;
	});
	
	var MainContent = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.contentPadding;
	});
	
	var CardWrapper = _styledComponents2.default.div(_templateObject4);
	
	var MatchScoreWrapper = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.contentPadding;
	});
	
	var PlayerInfo = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.color;
	});
	
	var PlayerName = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.fontSize || 40;
	});
	
	// const PlayerPhoto = styled.div`
	//     height: 470px;
	//     overflow: hidden;
	//     position: absolute;
	//     right: 0;
	//     bottom: 0;
	//     img {
	//         height: 100%;
	//         width: auto;
	//     }
	//     .wdp-sm-plr-logo_jersey,
	//     .wdp-sm-plr-logo_3d_jersey_front {
	//         height: 100%;
	//         width: 230px;
	//         margin-right: ${props => props.theme.contentPadding}px;
	//         margin: ${props => `-${props.theme.contentPadding}px ${props.theme.contentPadding}px 0 0`};
	//     }
	//     .wdp-sm-plr-logo_3d_jersey_front {
	//         height: auto;
	//         margin-top: 60px;
	//     }
	// `;
	
	var IncidentMinute = _styledComponents2.default.div(_templateObject8, function (props) {
	    return 'color: ' + props.incidentMinuteColor + ';';
	});
	
	var Incident = _styledComponents2.default.div(_templateObject9);
	
	var Player = function Player(_ref, ctx) {
	    var teamId = _ref.teamId,
	        player = _ref.player,
	        card = _ref.card,
	        event = _ref.event,
	        incidentMinuteColor = _ref.incidentMinuteColor,
	        incidentMinute = _ref.incidentMinute;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var name = _RCore2.default.playerShortName(player.name);
	    var fontSize = name.length >= 15 ? 30 : 40;
	    return _react2.default.createElement(
	        PlayerInfo,
	        null,
	        _react2.default.createElement(
	            PlayerName,
	            { fontSize: fontSize },
	            name
	        ),
	        _react2.default.createElement(
	            IncidentMinute,
	            null,
	            incidentMinute,
	            ' ',
	            i18('min', lang),
	            '.'
	        )
	    );
	};
	
	var Goal = function Goal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            null,
	            i18('title.goal', lang)
	        ),
	        _react2.default.createElement(Player, props)
	    );
	};
	
	var Assist = function Assist(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            { style: { fontSize: 75, lineHeight: '80px', marginBottom: 7 } },
	            i18('title.assist', lang)
	        ),
	        _react2.default.createElement(Player, props)
	    );
	};
	
	var OwnGoal = function OwnGoal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            GoalTitle,
	            { style: { fontSize: 75, lineHeight: '80px', marginBottom: 7 }, color: props.incidentMinuteColor },
	            i18('title.owngoal', lang)
	        ),
	        _react2.default.createElement(Player, props)
	    );
	};
	
	var Card = function Card(props) {
	    var card = props.cardName === 'yellow_card' ? _react2.default.createElement('img', { src: _cfg2.default.assets + '/assets/yellow_card_gradient.png', alt: 'yellow' }) : _react2.default.createElement('img', { src: _cfg2.default.assets + '/assets/red_card_gradient.png', alt: 'red' });
	    return _react2.default.createElement(
	        Incident,
	        null,
	        _react2.default.createElement(
	            CardWrapper,
	            null,
	            card
	        ),
	        _react2.default.createElement(Player, props)
	    );
	};
	
	var Wrapper = function Wrapper(props) {
	    var children = props.children,
	        event = props.event,
	        incidentId = props.incidentId,
	        matchScore = props.matchScore,
	        incident = props.incident,
	        player = props.player;
	    //
	
	    var teamId = incident.teamId;
	    // swap team id, as incident teamId shows who will get a score
	    if (matchScore.isOwnGoal) {
	        teamId = props.incident.teamId === props.event.homeId ? props.event.awayId : props.event.homeId;
	    }
	
	    return _react2.default.createElement(
	        IncidentStyle,
	        null,
	        _react2.default.createElement(
	            MainContent,
	            null,
	            children
	        ),
	        _react2.default.createElement(_SMPlayerLogo.PlayerLogo3DJerseyBack, {
	            width: 220,
	            className: 'player-logo',
	            display: '3d_jersey_back',
	            number: _lodash2.default.get(player, 'shirtNumber'),
	            playerId: player.id,
	            seasonId: event.tournamentId,
	            teamId: teamId
	        }),
	        _react2.default.createElement(
	            MatchScoreWrapper,
	            null,
	            _react2.default.createElement(_MatchScore2.default, _extends({}, matchScore, { event: event, view: 'nameLogoScore', incidentId: incidentId }))
	        )
	    );
	};
	
	Goal.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Wrapper.contextTypes = {
	    info: _propTypes2.default.object
	};
	Assist.contextTypes = {
	    info: _propTypes2.default.object
	};
	OwnGoal.contextTypes = {
	    info: _propTypes2.default.object
	};
	Card.contextTypes = {
	    info: _propTypes2.default.object
	};
	Player.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = {
	    Wrapper: Wrapper,
	    Goal: Goal,
	    Assist: Assist,
	    OwnGoal: OwnGoal,
	    Card: Card,
	    Substitution: _IncidentWithPhotos.Substitution,
	    disableBranding: true
	};
	exports.Wrapper = Wrapper;
	exports.Goal = Goal;
	exports.Assist = Assist;
	exports.OwnGoal = OwnGoal;
	exports.Card = Card;
	exports.Substitution = _IncidentWithPhotos.Substitution;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Substitution = exports.Card = exports.OwnGoal = exports.Assist = exports.Goal = exports.Wrapper = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    padding: 8px 10px 20px;\n'], ['\n    display: flex;\n    justify-content: center;\n    padding: 8px 10px 20px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    background-color: ', ';\n'], ['\n    text-align: center;\n    background-color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: ', 'px;\n    line-height: 1.1em;\n    display: inline-block;\n    white-space: nowrap;\n    font-weight: ', ';\n'], ['\n    font-size: ', 'px;\n    line-height: 1.1em;\n    display: inline-block;\n    white-space: nowrap;\n    font-weight: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    height: ', 'px;\n'], ['\n    height: ', 'px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    transform: rotate(15deg) translateY(-4px);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    overflow: hidden;\n    display: inline-block;\n    margin: 10px 0;\n'], ['\n    transform: rotate(15deg) translateY(-4px);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    overflow: hidden;\n    display: inline-block;\n    margin: 10px 0;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    .flex {\n        display: flex;\n        width: 100%;\n        flex-wrap: nowrap;\n        flex-direction: row;\n        text-align: left;\n\n        > div {\n            flex: 0 1 50%;\n\n            .t-shirt-subst-in {\n                margin-left: -80px;\n                margin-top: 90px;\n            }\n        }\n    }\n'], ['\n    .flex {\n        display: flex;\n        width: 100%;\n        flex-wrap: nowrap;\n        flex-direction: row;\n        text-align: left;\n\n        > div {\n            flex: 0 1 50%;\n\n            .t-shirt-subst-in {\n                margin-left: -80px;\n                margin-top: 90px;\n            }\n        }\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: 24px;\n    text-transform: uppercase;\n    color: ', ';\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    &:before {\n        content: \'\';\n        display: inline-block;\n        margin-right: 10px;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 10px 0 10px 20px;\n        border-color: transparent transparent transparent\n            ', ';\n        vertical-align: middle;\n        ', ';\n    }\n'], ['\n    font-size: 24px;\n    text-transform: uppercase;\n    color: ', ';\n    > span {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    &:before {\n        content: \'\';\n        display: inline-block;\n        margin-right: 10px;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 10px 0 10px 20px;\n        border-color: transparent transparent transparent\n            ', ';\n        vertical-align: middle;\n        ', ';\n    }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    display: inline-block;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    overflow: hidden;\n'], ['\n    display: inline-block;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    overflow: hidden;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    text-align: center;\n'], ['\n    text-align: center;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    width: ', 'px;\n    position:relative;\n    margin: 0 auto;\n    img {\n        height: auto;\n    }\n'], ['\n    width: ', 'px;\n    position:relative;\n    margin: 0 auto;\n    img {\n        height: auto;\n    }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    .wdp-team-logo {\n        height: 60px !important;\n    }\n    .team-name {\n        width: calc(50% - 80px) !important;\n    }\n    .score-box {\n        font-size: 57px !important;\n        font-weight: 400 !important;\n    }\n'], ['\n    .wdp-team-logo {\n        height: 60px !important;\n    }\n    .team-name {\n        width: calc(50% - 80px) !important;\n    }\n    .score-box {\n        font-size: 57px !important;\n        font-weight: 400 !important;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SportIcons = __webpack_require__(1438);
	
	var _MatchScore = __webpack_require__(1439);
	
	var _MatchScore2 = _interopRequireDefault(_MatchScore);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var dict = _RCore2.default.i18Register(__webpack_require__(1440), {});
	var i18 = _RCore2.default.getTranslation.bind({ dict: dict });
	
	var MainContent = _styledComponents2.default.div(_templateObject);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.content.backgroundColor;
	});
	
	var Text = _styledComponents2.default.span(_templateObject3, function (props) {
	    return props.size;
	}, function (props) {
	    return props.bold ? 'bold' : '400';
	});
	var Space = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.size;
	});
	
	var CardIconWrapper = _styledComponents2.default.div(_templateObject5);
	
	var SubstitutionWrapper = _styledComponents2.default.div(_templateObject6);
	
	var SubstitutionType = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.in ? props.theme.positiveColor : props.theme.substitutionOutColor;
	}, function (props) {
	    return props.in ? props.theme.positiveColor : props.theme.substitutionOutColor;
	}, function (props) {
	    return props.in ? 'transform: rotate(180deg);' : '';
	});
	
	var EllipsisOverflow = _styledComponents2.default.span(_templateObject8);
	
	var InfoWrapper = _styledComponents2.default.div(_templateObject9);
	
	var ShirtWrapper = _styledComponents2.default.div(_templateObject10, function (props) {
	    return props.width || '320';
	});
	
	var MatchScoreWrapper = _styledComponents2.default.div(_templateObject11);
	
	var getPlayerName = function getPlayerName(_ref) {
	    var shortFirstName = _ref.shortFirstName,
	        lastName = _ref.lastName;
	
	    return shortFirstName + ' ' + lastName;
	};
	
	var getPlayerShirt = function getPlayerShirt(_ref2) {
	    var event = _ref2.event,
	        player = _ref2.player,
	        incident = _ref2.incident,
	        width = _ref2.width;
	
	    var isHome = incident.home === 1;
	    if (incident.typeId === 10) isHome = !isHome; // swap teams for own goal
	
	    return _react2.default.createElement(
	        ShirtWrapper,
	        { width: width },
	        _react2.default.createElement(_SMPlayerLogo.PlayerLogo3DJerseyBack, {
	            display: '3d_jersey_back',
	            number: _lodash2.default.get(player, 'shirtNumber'),
	            playerId: _lodash2.default.get(player, 'id'),
	            width: width || 320,
	            seasonId: event.tournamentId,
	            teamId: isHome ? event.homeId : event.awayId
	        })
	    );
	};
	
	var Score = function Score(_ref3) {
	    var incidentId = _ref3.incidentId,
	        event = _ref3.event,
	        matchScore = _ref3.matchScore;
	
	    return _react2.default.createElement(
	        MatchScoreWrapper,
	        { className: '__c__c5' },
	        _react2.default.createElement(_MatchScore2.default, _extends({}, matchScore, {
	            event: event,
	            view: 'simpleLogoScore',
	            styles: 'font-size: 50px;',
	            incidentId: incidentId
	        }))
	    );
	};
	
	var Wrapper = function Wrapper(_ref4) {
	    var children = _ref4.children;
	
	    return _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	            MainContent,
	            null,
	            children
	        )
	    );
	};
	
	var IncidentInfo = function IncidentInfo(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var playerName = getPlayerName(props.playerName);
	    var fontSize = playerName.length < 15 ? 47 : 30;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            EllipsisOverflow,
	            null,
	            _react2.default.createElement(
	                Text,
	                {
	                    style: {
	                        maxWidth: '400px',
	                        textOverflow: 'ellipsis',
	                        overflow: 'hidden'
	                    },
	                    className: '__c__c1',
	                    size: fontSize
	                },
	                playerName
	            )
	        ),
	        _react2.default.createElement(Space, { size: 7 }),
	        _react2.default.createElement(Score, props),
	        _react2.default.createElement(
	            Text,
	            { className: '__c__c2', bold: true, size: 21, style: { marginTop: '8px' } },
	            props.incidentMinute,
	            ' ',
	            i18('min', lang),
	            '.'
	        )
	    );
	};
	
	var Goal = function Goal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Text,
	            { size: 92, bold: true, className: '__c__c3' },
	            i18('title.goal', lang).toUpperCase()
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            getPlayerShirt(_extends({}, props, { width: 165 }))
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	
	var OwnGoal = function OwnGoal(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Text,
	            { size: 55, bold: true, style: { color: props.incidentMinuteColor }, className: '__c__c4' },
	            i18('title.owngoal', lang).toUpperCase()
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            getPlayerShirt(_extends({}, props, { width: 165 }))
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	
	var Assist = function Assist(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Text,
	            { size: 92, bold: true, className: '__c__c3' },
	            i18('title.assist', lang).toUpperCase()
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            getPlayerShirt(_extends({}, props, { width: 165 }))
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(IncidentInfo, props)
	        )
	    );
	};
	
	var Substitution = function Substitution(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        SubstitutionWrapper,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        getPlayerShirt(_extends({}, props, { player: props.player2, width: 120 }))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 't-shirt-subst-in' },
	                        getPlayerShirt(_extends({}, props, { width: 180 }))
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: 'flex',
	                        flexDirection: 'column',
	                        justifyContent: 'center',
	                        alignItems: 'center'
	                    }
	                },
	                _react2.default.createElement(
	                    SubstitutionType,
	                    { out: true },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        i18('out', lang)
	                    )
	                ),
	                _react2.default.createElement(
	                    Text,
	                    { size: 25 },
	                    _react2.default.createElement(
	                        EllipsisOverflow,
	                        null,
	                        _react2.default.createElement(
	                            Text,
	                            {
	                                className: '__c__c14',
	                                size: 25,
	                                style: {
	                                    lineHeight: '1.3em',
	                                    textOverflow: 'ellipsis',
	                                    maxWidth: '200px'
	                                }
	                            },
	                            getPlayerName(props.player2Name)
	                        )
	                    )
	                ),
	                _react2.default.createElement(Space, { size: 20 }),
	                _react2.default.createElement(
	                    SubstitutionType,
	                    { 'in': true },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        i18('in', lang)
	                    )
	                ),
	                _react2.default.createElement(
	                    Text,
	                    { size: 25 },
	                    _react2.default.createElement(
	                        EllipsisOverflow,
	                        null,
	                        _react2.default.createElement(
	                            Text,
	                            {
	                                className: '__c__c14',
	                                size: 25,
	                                style: {
	                                    lineHeight: '1.3em',
	                                    textOverflow: 'ellipsis',
	                                    maxWidth: '200px'
	                                }
	                            },
	                            getPlayerName(props.playerName)
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(Score, props),
	            _react2.default.createElement(
	                Text,
	                { className: '__c__c13', size: 21, bold: true, style: { textAlign: 'center', width: '100%' } },
	                props.incidentMinute,
	                ' ',
	                i18('min', lang),
	                '.'
	            )
	        )
	    );
	};
	
	var Card = function Card(_ref5) {
	    var cardColor = _ref5.cardColor,
	        playerName = _ref5.playerName,
	        props = _objectWithoutProperties(_ref5, ['cardColor', 'playerName']);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            CardIconWrapper,
	            null,
	            _react2.default.createElement(_SportIcons.SimpleCard, { width: 36, height: 50, color: cardColor })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            getPlayerShirt(_extends({}, props, { width: 165 }))
	        ),
	        _react2.default.createElement(
	            InfoWrapper,
	            null,
	            _react2.default.createElement(IncidentInfo, _extends({}, props, { playerName: playerName }))
	        )
	    );
	};
	
	Goal.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Wrapper.contextTypes = {
	    info: _propTypes2.default.object
	};
	Assist.contextTypes = {
	    info: _propTypes2.default.object
	};
	OwnGoal.contextTypes = {
	    info: _propTypes2.default.object
	};
	Card.contextTypes = {
	    info: _propTypes2.default.object
	};
	Substitution.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = {
	    Wrapper: Wrapper,
	    Goal: Goal,
	    Assist: Assist,
	    OwnGoal: OwnGoal,
	    Card: Card,
	    Substitution: Substitution,
	    disableBranding: true
	    //contentProps: { style: { height: 550 } }
	};
	exports.Wrapper = Wrapper;
	exports.Goal = Goal;
	exports.Assist = Assist;
	exports.OwnGoal = OwnGoal;
	exports.Card = Card;
	exports.Substitution = Substitution;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    font-size: 18px;\n    line-height: 40px;\n    list-style: none;\n    margin-bottom: 4px;\n    position: relative;\n    font-weight: ', ';\n\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        right: 0px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n\n    &:before {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        width: 4px;\n        content: \' \';\n        z-index: 1;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n\n    &:nth-child(1) {\n        &:after {\n            background-color: ', ';\n        }\n    }\n\n    & > * {\n        position: relative;\n        z-index: 2;\n    }\n\n    color: ', ';\n\n    .tt-rank {\n        width: 50px;\n        text-align: right;\n        padding-right: 20px;\n    }\n    .tt-team {\n        flex-grow: 1;\n    }\n    .tt-val {\n        text-align: right;\n    }\n    .tt-points {\n        color: ', ';\n        text-align: right;\n        margin-right: 20px;\n        font-weight: normal;\n    }\n'], ['\n    display: flex;\n    font-size: 18px;\n    line-height: 40px;\n    list-style: none;\n    margin-bottom: 4px;\n    position: relative;\n    font-weight: ', ';\n\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        right: 0px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n\n    &:before {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        width: 4px;\n        content: \' \';\n        z-index: 1;\n        transform: skew(-20deg);\n        background-color: ', ';\n    }\n\n    &:nth-child(1) {\n        &:after {\n            background-color: ', ';\n        }\n    }\n\n    & > * {\n        position: relative;\n        z-index: 2;\n    }\n\n    color: ', ';\n\n    .tt-rank {\n        width: 50px;\n        text-align: right;\n        padding-right: 20px;\n    }\n    .tt-team {\n        flex-grow: 1;\n    }\n    .tt-val {\n        text-align: right;\n    }\n    .tt-points {\n        color: ', ';\n        text-align: right;\n        margin-right: 20px;\n        font-weight: normal;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    line-height: 26px;\n\n    &:after {\n        background-color: ', ';\n    }\n'], ['\n    line-height: 26px;\n\n    &:after {\n        background-color: ', ';\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 0;\n'], ['\n    padding: 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var TTRow = _styledComponents2.default.li(_templateObject, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.high ? props.theme.content.accentColor : props.theme.primaryColor;
	}, function (props) {
	    return props.type && (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() || 'transparent';
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.high && props.theme.content.accentTextColor || props.theme.primaryTextColor;
	}, function (props) {
	    return props.high && props.theme.content.accentTextColor || props.theme.primaryTextColor;
	});
	
	var TTHeader = TTRow.extend(_templateObject2, function (props) {
	    return (0, _color2.default)(props.theme.primaryColor).darken(0.3).toString();
	});
	
	var Header = function Header(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return _react2.default.createElement(
	        TTHeader,
	        { className: '__c__c1_style1' },
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-rank' },
	            '#'
	        ),
	        _react2.default.createElement('div', { className: 'tt-team' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-val', style: { width: '50px' } },
	            i18('matches.short', lang)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-val', style: { width: '50px' } },
	            i18('goals.short', lang)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-points', style: { width: '50px' } },
	            i18('points.short', lang)
	        )
	    );
	};
	
	var Row = function Row(_ref) {
	    var row = _ref.row,
	        tournamentId = _ref.tournamentId,
	        small = _ref.small,
	        style = _ref.style,
	        qualRel = _ref.qualRel,
	        highlight = _ref.highlight;
	
	    var dif = row.goalsScored && row.goalsConceded && row.goalsScored - row.goalsConceded || 0;
	    return _react2.default.createElement(
	        TTRow,
	        { style: style, first: row.rank === 1, small: small, type: qualRel && row.rankType, high: highlight },
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-rank' },
	            row.rank
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-team' },
	            row.teamName
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-val', style: { width: '50px' } },
	            row.matchesPlayed
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-val', style: { width: '50px' } },
	            (dif > 0 ? '+' : '-') + dif
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-points', style: { width: '50px' } },
	            row.points
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var Container = _styledComponents2.default.ul(_templateObject3);
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 87px;\n\n    .tt-values {\n        display: flex;\n        min-width: 150px;\n    }\n\n    .tt-val {\n        color: ', ';\n        text-align: center;\n        min-width: 35px;\n\n        &.grow {\n            flex-grow: 1;\n        }\n    }\n'], ['\n    padding: 0 87px;\n\n    .tt-values {\n        display: flex;\n        min-width: 150px;\n    }\n\n    .tt-val {\n        color: ', ';\n        text-align: center;\n        min-width: 35px;\n\n        &.grow {\n            flex-grow: 1;\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    list-style: none;\n    margin-bottom: 2px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    line-height: 1em;\n    text-transform: uppercase;\n    padding: 6px 25px 6px 32px;\n    font-weight: ', ';\n    background-color: ', ';\n\n    .tt-logo {\n        margin-right: 10px;\n    }\n\n    .tt-rank {\n        width: 35px;\n        text-align: center;\n    }\n\n    .tt-team {\n        flex-grow: 1;\n        align-items: center;\n        display: flex;\n    }\n\n    tt-rank,\n    .tt-team,\n    .tt-val {\n        color: ', ';\n    }\n\n    .rel-badge {\n        display: inline-block;\n        background-color: ', ';\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        position: absolute;\n        top: 50%;\n        left: 9px;\n        transform: translateY(-50%);\n    }\n\n    &:nth-child(1) {\n        .rel-badge {\n            display: none;\n        }\n    }\n'], ['\n    list-style: none;\n    margin-bottom: 2px;\n    position: relative;\n    color: ', ';\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    line-height: 1em;\n    text-transform: uppercase;\n    padding: 6px 25px 6px 32px;\n    font-weight: ', ';\n    background-color: ', ';\n\n    .tt-logo {\n        margin-right: 10px;\n    }\n\n    .tt-rank {\n        width: 35px;\n        text-align: center;\n    }\n\n    .tt-team {\n        flex-grow: 1;\n        align-items: center;\n        display: flex;\n    }\n\n    tt-rank,\n    .tt-team,\n    .tt-val {\n        color: ', ';\n    }\n\n    .rel-badge {\n        display: inline-block;\n        background-color: ', ';\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        position: absolute;\n        top: 50%;\n        left: 9px;\n        transform: translateY(-50%);\n    }\n\n    &:nth-child(1) {\n        .rel-badge {\n            display: none;\n        }\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    > div {\n        opacity: 0.7;\n    }\n'], ['\n    > div {\n        opacity: 0.7;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Container = _styledComponents2.default.ul(_templateObject, function (props) {
	    return props.theme.color;
	});
	
	var LI = _styledComponents2.default.li(_templateObject2, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.theme.fonts.main.bold;
	}, function (props) {
	    return props.high ? props.theme.content.accentColor : 'transparent';
	}, function (props) {
	    return props.high ? props.theme.content.accentTextColor : props.theme.color;
	}, function (props) {
	    return props.type && (0, _color2.default)(props.theme.qualRelColors[props.type]).toString() || props.theme.content.backgroundColor;
	});
	
	var HeadLI = LI.extend(_templateObject3);
	
	var Header = function Header(_ref, ctx) {
	    var qualRel = _ref.qualRel;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        HeadLI,
	        null,
	        qualRel && _react2.default.createElement('span', { className: 'rel-badge' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-rank' },
	            '#'
	        ),
	        _react2.default.createElement('div', { className: 'tt-team' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-values' },
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val' },
	                i18('matches.short', lang)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val grow' },
	                i18('goals.short', lang)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val' },
	                i18('points.short', lang)
	            )
	        )
	    );
	};
	
	var Row = function Row(_ref2) {
	    var row = _ref2.row,
	        tournamentId = _ref2.tournamentId,
	        qualRel = _ref2.qualRel,
	        highlight = _ref2.highlight;
	
	    return _react2.default.createElement(
	        LI,
	        { type: qualRel && row.rankType, high: highlight },
	        qualRel && _react2.default.createElement('span', { className: 'rel-badge' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-rank' },
	            row.rank
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-team' },
	            _react2.default.createElement(_SMTeamLogo2.default, {
	                tournamentId: tournamentId,
	                teamId: row.teamId,
	                width: 28,
	                height: 28,
	                style: { marginRight: '10px' }
	            }),
	            row.teamName
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tt-values' },
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val' },
	                row.matchesPlayed
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val grow' },
	                row.goalsScored + ' - ' + row.goalsConceded
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tt-val' },
	                row.points
	            )
	        )
	    );
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n'], ['\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n\n    & > * {\n        z-index: 2;\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-image {\n        margin: 0 20px;\n        width: 60px;\n    }\n    .list-player-name {\n        line-height: 60px;\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        font-size: 32px;\n        span {\n            margin-right: 5px;\n        }\n    }\n    .tl-score {\n        line-height: 60px;\n        min-width: 80px;\n        text-align: right;\n        font-size: 48px;\n        margin: 0 20px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n'], ['\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n\n    & > * {\n        z-index: 2;\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-image {\n        margin: 0 20px;\n        width: 60px;\n    }\n    .list-player-name {\n        line-height: 60px;\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        font-size: 32px;\n        span {\n            margin-right: 5px;\n        }\n    }\n    .tl-score {\n        line-height: 60px;\n        min-width: 80px;\n        text-align: right;\n        font-size: 48px;\n        margin: 0 20px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n'], ['\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Item = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	var FirstItem = (0, _styledComponents2.default)(Item)(_templateObject3, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	
	var Header = function Header(_ref, ctx) {
	    var valueTitle = _ref.valueTitle;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    return null;
	    return _react2.default.createElement(
	        Item,
	        null,
	        _react2.default.createElement('div', { className: 'tl-image' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name tl-title' },
	            i18('name', lang)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score  tl-title' },
	            valueTitle
	        )
	    );
	};
	
	var SpecialRow = function SpecialRow(_ref2) {
	    var player = _ref2.player,
	        seasonId = _ref2.seasonId,
	        rank = _ref2.rank,
	        highlightFirstPlayer = _ref2.highlightFirstPlayer,
	        highlightTeam = _ref2.highlightTeam;
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    return _react2.default.createElement(
	        FirstItem,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            _react2.default.createElement(
	                'span',
	                null,
	                rank,
	                '. ',
	                name.firstName
	            ),
	            _react2.default.createElement(
	                'b',
	                null,
	                name.lastName
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score' },
	            player.displayValue || player.value,
	            ' ',
	            _react2.default.createElement(
	                'span',
	                { className: 'tl-unit' },
	                player.unit
	            )
	        )
	    );
	};
	
	var StandardRow = function StandardRow(_ref3) {
	    var player = _ref3.player,
	        seasonId = _ref3.seasonId,
	        rank = _ref3.rank,
	        highlightTeam = _ref3.highlightTeam;
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    return _react2.default.createElement(
	        Item,
	        { key: player.id, className: highlightTeam === player.teamId ? 'pls_highlight' : '' },
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            rank,
	            '. ',
	            name.firstName,
	            ' ',
	            _react2.default.createElement(
	                'b',
	                null,
	                name.lastName
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score' },
	            player.displayValue || player.value,
	            ' ',
	            _react2.default.createElement(
	                'span',
	                { className: 'tl-unit' },
	                player.unit
	            )
	        )
	    );
	};
	
	var Row = function Row(_ref4) {
	    var player = _ref4.player,
	        rank = _ref4.rank,
	        seasonId = _ref4.seasonId,
	        highlightFirstPlayer = _ref4.highlightFirstPlayer,
	        highlightTeam = _ref4.highlightTeam;
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    if (rank === 0) return _react2.default.createElement(SpecialRow, {
	        player: player,
	        rank: rank + 1,
	        seasonId: seasonId,
	        highlightFirstPlayer: highlightFirstPlayer,
	        highlightTeam: highlightTeam
	    });
	    return _react2.default.createElement(StandardRow, { player: player, rank: rank + 1, seasonId: seasonId, highlightTeam: highlightTeam });
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    align-content: center;\n    margin: 20px 0px;\n\n    .list-player-name {\n        font-size: 1.25rem;\n        font-weight: normal;\n        padding-right: 15px;\n        flex: 0 1 21%;\n        min-width: 180px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        > span {\n            text-transform: uppercase;\n            font-size: 0.825rem;\n            display: block;\n            letter-spacing: 0.2px;\n            margin-top: 5px;\n            font-weight: 300;\n        }\n    }\n\n    .chart-wrap {\n        width: 100%;\n    }\n\n    .list-team-name {\n        text-transform: uppercase;\n        font-size: 0.875rem;\n    }\n'], ['\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    align-content: center;\n    margin: 20px 0px;\n\n    .list-player-name {\n        font-size: 1.25rem;\n        font-weight: normal;\n        padding-right: 15px;\n        flex: 0 1 21%;\n        min-width: 180px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        > span {\n            text-transform: uppercase;\n            font-size: 0.825rem;\n            display: block;\n            letter-spacing: 0.2px;\n            margin-top: 5px;\n            font-weight: 300;\n        }\n    }\n\n    .chart-wrap {\n        width: 100%;\n    }\n\n    .list-team-name {\n        text-transform: uppercase;\n        font-size: 0.875rem;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    height: 28px;\n    width: ', '%;\n    background-color: ', ';\n    position: relative;\n\n    &:after {\n        content: \'\';\n        width: 2px;\n        height: calc(100% + 14px);\n        background-color: inherit;\n        display: inline-block;\n        position: absolute;\n        top: -7px;\n        left: 0;\n    }\n\n    .ptl_highlight & {\n        background-color: ', ';\n    }\n'], ['\n    height: 28px;\n    width: ', '%;\n    background-color: ', ';\n    position: relative;\n\n    &:after {\n        content: \'\';\n        width: 2px;\n        height: calc(100% + 14px);\n        background-color: inherit;\n        display: inline-block;\n        position: absolute;\n        top: -7px;\n        left: 0;\n    }\n\n    .ptl_highlight & {\n        background-color: ', ';\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    z-index: 2;\n    font-size: 32px;\n    font-weight: bold;\n    white-space: nowrap;\n    margin-left: 10px;\n    .tl-unit {\n        font-size: 12px;\n        margin-left: 3px;\n    }\n\n    .ptl_highlight & {\n        color: ', ';\n\n        .units & {\n            color: ', ';\n        }\n    }\n    text-align: right;\n'], ['\n    z-index: 2;\n    font-size: 32px;\n    font-weight: bold;\n    white-space: nowrap;\n    margin-left: 10px;\n    .tl-unit {\n        font-size: 12px;\n        margin-left: 3px;\n    }\n\n    .ptl_highlight & {\n        color: ', ';\n\n        .units & {\n            color: ', ';\n        }\n    }\n    text-align: right;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    visibility: hidden;\n    font-size: 32px;\n    background: red;\n    white-space: nowrap;\n    padding: 0 15px;\n'], ['\n    visibility: hidden;\n    font-size: 32px;\n    background: red;\n    white-space: nowrap;\n    padding: 0 15px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Item = _styledComponents2.default.div(_templateObject2);
	
	var BarChart = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.width;
	}, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	
	var ScoreBlock = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	var Fake = _styledComponents2.default.div(_templateObject5);
	
	var Header = function Header(_ref, ctx) {
	    var valueTitle = _ref.valueTitle;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement('h1', null);
	};
	
	var Row = function Row(_ref2, ctx) {
	    var player = _ref2.player,
	        max = _ref2.max,
	        rank = _ref2.rank,
	        highlightFirstPlayer = _ref2.highlightFirstPlayer,
	        highlightTeam = _ref2.highlightTeam,
	        maxDislayValue = _ref2.maxDislayValue;
	
	    var name = _RCore2.default.playerShortName(player.name);
	    var chartWidth = 100 / (max / player.value);
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    var symbols = Math.max((Math.round(max) + '').length, (maxDislayValue + '').length);
	
	    return _react2.default.createElement(
	        Item,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'ptl_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name __c__c1style' + rank },
	            name,
	            player.position && player.teamShortName && _react2.default.createElement(
	                'span',
	                null,
	                i18(player.position, lang),
	                ', ',
	                player.teamShortName
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'chart-wrap' },
	            _react2.default.createElement(BarChart, { width: chartWidth, className: '__c__b1_style' + rank })
	        ),
	        _react2.default.createElement(
	            ScoreBlock,
	            { style: { minWidth: symbols * 22 + 5 }, className: '__c__c2style' + rank },
	            player.displayValue || player.value,
	            _react2.default.createElement(
	                'span',
	                { className: 'tl-unit' },
	                player.unit
	            )
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    padding: 10px 20px;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 4px;\n    color: ', ';\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        content: \' \';\n        background-color: ', ';\n        z-index: 0;\n    }\n    & > * {\n        z-index: 2;\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-image {\n        margin: 0 20px;\n        width: 60px;\n    }\n    .list-player-name {\n        font-size: 24px;\n        line-height: 26px;\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-score {\n        text-align: right;\n        font-size: 48px;\n        margin-left: 10px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        color: ', ';\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    &.pls_highlight {\n        background-color: ', ';\n    }\n'], ['\n    position: relative;\n    display: flex;\n    padding: 10px 20px;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 4px;\n    color: ', ';\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        content: \' \';\n        background-color: ', ';\n        z-index: 0;\n    }\n    & > * {\n        z-index: 2;\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-image {\n        margin: 0 20px;\n        width: 60px;\n    }\n    .list-player-name {\n        font-size: 24px;\n        line-height: 26px;\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-score {\n        text-align: right;\n        font-size: 48px;\n        margin-left: 10px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        color: ', ';\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    &.pls_highlight {\n        background-color: ', ';\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _StyledUI = __webpack_require__(1418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var LIList = _styledComponents2.default.li(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	});
	
	var Header = function Header(_ref, ctx) {
	    var valueTitle = _ref.valueTitle;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        LIList,
	        null,
	        _react2.default.createElement('div', { className: 'tl-image' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name tl-title' },
	            i18('name', lang)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score  tl-title' },
	            valueTitle
	        )
	    );
	};
	
	var PlayerLogo = (0, _styledComponents.withTheme)(function (_ref2) {
	    var theme = _ref2.theme,
	        player = _ref2.player,
	        seasonId = _ref2.seasonId,
	        props = _objectWithoutProperties(_ref2, ['theme', 'player', 'seasonId']);
	
	    var SMPlayerLogo = _StyledUI.styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);
	
	    return _react2.default.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        _react2.default.createElement(SMPlayerLogo, {
	            playerId: player.id,
	            teamId: player.teamId,
	            seasonId: seasonId,
	            width: 60,
	            height: 60,
	            number: player.shirtNumber
	        })
	    );
	});
	
	var Row = (0, _styledComponents.withTheme)(function (_ref3) {
	    var player = _ref3.player,
	        seasonId = _ref3.seasonId,
	        highlightFirstPlayer = _ref3.highlightFirstPlayer,
	        highlightTeam = _ref3.highlightTeam,
	        props = _objectWithoutProperties(_ref3, ['player', 'seasonId', 'highlightFirstPlayer', 'highlightTeam']);
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	
	    return _react2.default.createElement(
	        LIList,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-image' },
	            _react2.default.createElement(PlayerLogo, { player: player, seasonId: seasonId, playerLogoDisplay: props.playerLogoDisplay })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            name.firstName,
	            ' ',
	            _react2.default.createElement(
	                'b',
	                null,
	                name.lastName
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score __c__c1_style1' },
	            player.displayValue || player.value
	        )
	    );
	});
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 10px;\n    color: ', ';\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    & > * {\n        z-index: 2;\n    }\n\n    &.pls_highlight {\n        color: ', ';\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-player-country {\n        display: flex;\n        align-items: center;\n        line-height: 14px;\n\n        .tl-team {\n            font-size: 18px;\n            margin-left: 10px;\n            color: ', ';\n        }\n    }\n    .list-player-name {\n        font-size: 36px;\n        line-height: 1.25em;\n        flex-grow: 1;\n        text-align: left;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        padding-left: 10px;\n        width: 50%;\n\n        > div {\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n    .tl-score {\n        text-align: right;\n        font-size: 75px;\n        line-height: 1em;\n        transform: translateY(-4px);\n        margin-left: 10px;\n        font-weight: bold;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    .tl-rank-badge {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 111;\n        font-size: 16px;\n        line-height: 1em;\n        width: 33px;\n        height: 33px;\n        font-weight: bold;\n        color: ', ';\n        background-color: ', ';\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n'], ['\n    position: relative;\n    display: flex;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 10px;\n    color: ', ';\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    & > * {\n        z-index: 2;\n    }\n\n    &.pls_highlight {\n        color: ', ';\n    }\n    .tl-title {\n        font-size: 18px !important;\n        font-weight: normal !important;\n        text-transform: uppercase;\n        flex-grow: 1;\n    }\n\n    .tl-player-country {\n        display: flex;\n        align-items: center;\n        line-height: 14px;\n\n        .tl-team {\n            font-size: 18px;\n            margin-left: 10px;\n            color: ', ';\n        }\n    }\n    .list-player-name {\n        font-size: 36px;\n        line-height: 1.25em;\n        flex-grow: 1;\n        text-align: left;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        padding-left: 10px;\n        width: 50%;\n\n        > div {\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n    .tl-score {\n        text-align: right;\n        font-size: 75px;\n        line-height: 1em;\n        transform: translateY(-4px);\n        margin-left: 10px;\n        font-weight: bold;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    .tl-rank-badge {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 111;\n        font-size: 16px;\n        line-height: 1em;\n        width: 33px;\n        height: 33px;\n        font-weight: bold;\n        color: ', ';\n        background-color: ', ';\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var LIList = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accent2TextColor;
	}, function (props) {
	    return props.theme.content.accent2Color;
	});
	
	var Header = function Header() {
	    return _react2.default.createElement('div', null);
	};
	
	var PlayerLogo = (0, _styledComponents.withTheme)(function (_ref) {
	    var theme = _ref.theme,
	        player = _ref.player,
	        seasonId = _ref.seasonId,
	        props = _objectWithoutProperties(_ref, ['theme', 'player', 'seasonId']);
	
	    var SMPlayerLogo = _StyledUI.styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);
	    var isPhoto = SMPlayerLogo.name === 'PlayerLogoPhoto' || SMPlayerLogo.name === 'PlayerRoundedPhoto';
	    var isRoundedPhoto = SMPlayerLogo.name === 'PlayerRoundedPhoto';
	
	    var playerLogoStyle = isPhoto ? {
	        width: '90',
	        style: {
	            width: '100%'
	        },
	        imageWrapStyle: {
	            width: '90px',
	            height: isRoundedPhoto ? '90px' : 'auto',
	            border: isRoundedPhoto ? '1px solid #fff' : 'none',
	            overflow: 'hidden',
	            display: 'block'
	        }
	    } : {
	        width: '90',
	        imageWrapStyle: {
	            paddingLeft: 0
	        }
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        _react2.default.createElement(SMPlayerLogo, _extends({
	            teamId: player.teamId,
	            playerId: player.id,
	            seasonId: seasonId,
	            size: 'large',
	            height: 'auto',
	            isGK: player.GK,
	            number: player.shirtNumber
	        }, playerLogoStyle))
	    );
	});
	
	var Row = function Row(_ref2) {
	    var player = _ref2.player,
	        seasonId = _ref2.seasonId,
	        highlightFirstPlayer = _ref2.highlightFirstPlayer,
	        highlightTeam = _ref2.highlightTeam,
	        rank = _ref2.rank,
	        props = _objectWithoutProperties(_ref2, ['player', 'seasonId', 'highlightFirstPlayer', 'highlightTeam', 'rank']);
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	
	    return _react2.default.createElement(
	        LIList,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-rank-badge' },
	            '#',
	            rank + 1
	        ),
	        _react2.default.createElement(PlayerLogo, { player: player, seasonId: seasonId, playerLogoDisplay: props.playerLogoDisplay }),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            _react2.default.createElement(
	                'div',
	                null,
	                name.firstName,
	                ' ',
	                name.lastName
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'tl-player-country' },
	                _react2.default.createElement(_SMTeamLogo2.default, { teamId: player.teamId, seasonId: 'current', display: 'logo', width: 30, height: 30 }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tl-team' },
	                    player.teamShortName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score' },
	            player.displayValue || player.value
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 0;\n    padding: 0;\n'], ['\n    margin: 0;\n    padding: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    font-size: 18px;\n    line-height: 40px;\n    font-weight: 300;\n    list-style: none;\n    margin-bottom: 4px;\n    position: relative;\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n    &.tl-header {\n        line-height: 26px;\n        color: ', ';\n        &:after {\n            background-color: ', ';\n        }\n        .name-header {\n            flex-grow: 1;\n        }\n        .val-header {\n            opacity: 0.9;\n            font-weight: 300;\n        }\n    }\n    &:before {\n    }\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        right: 0px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: currentColor;\n    }\n\n    & > * {\n        z-index: 2;\n    }\n\n    .list-player-name {\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        color: ', ';\n    }\n    .tl-score,\n    .val-header {\n        position: relative;\n        text-align: right;\n        color: ', ';\n        margin-left: 0px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        display: block;\n        text-align: right;\n        margin-right: 20px;\n        font-weight: normal;\n\n        span {\n            position: relative;\n            z-index: 3;\n        }\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n'], ['\n    display: flex;\n    font-size: 18px;\n    line-height: 40px;\n    font-weight: 300;\n    list-style: none;\n    margin-bottom: 4px;\n    position: relative;\n    color: ', ';\n\n    &.pls_highlight {\n        color: ', ';\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n    &.tl-header {\n        line-height: 26px;\n        color: ', ';\n        &:after {\n            background-color: ', ';\n        }\n        .name-header {\n            flex-grow: 1;\n        }\n        .val-header {\n            opacity: 0.9;\n            font-weight: 300;\n        }\n    }\n    &:before {\n    }\n    &:after {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: -20px;\n        right: 0px;\n        content: \' \';\n        z-index: 0;\n        transform: skew(-20deg);\n        background-color: currentColor;\n    }\n\n    & > * {\n        z-index: 2;\n    }\n\n    .list-player-name {\n        text-transform: uppercase;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        color: ', ';\n    }\n    .tl-score,\n    .val-header {\n        position: relative;\n        text-align: right;\n        color: ', ';\n        margin-left: 0px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n        display: block;\n        text-align: right;\n        margin-right: 20px;\n        font-weight: normal;\n\n        span {\n            position: relative;\n            z-index: 3;\n        }\n    }\n    .tl-unit {\n        font-size: 22px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Container = _styledComponents2.default.ul(_templateObject);
	
	var LIList = _styledComponents2.default.li(_templateObject2, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	}, function (props) {
	    return (0, _color2.default)(props.theme.primaryColor).darken(0.3).toString();
	}, function (props) {
	    return props.theme.primaryTextColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var Header = function Header(_ref, ctx) {
	    var valueTitle = _ref.valueTitle;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        LIList,
	        { className: 'tl-header' },
	        _react2.default.createElement(
	            'div',
	            { className: 'name-header' },
	            i18('name', lang)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'val-header' },
	            valueTitle
	        )
	    );
	};
	
	var Row = function Row(_ref2) {
	    var player = _ref2.player,
	        seasonId = _ref2.seasonId,
	        highlightFirstPlayer = _ref2.highlightFirstPlayer,
	        highlightTeam = _ref2.highlightTeam;
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    return _react2.default.createElement(
	        LIList,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            name.firstName,
	            ' ',
	            _react2.default.createElement(
	                'b',
	                null,
	                name.lastName
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score' },
	            _react2.default.createElement(
	                'span',
	                null,
	                player.displayValue || player.value
	            )
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    transform: skew(-', 'deg);\n    padding: 15px 0px 0;\n'], ['\n    transform: skew(-', 'deg);\n    padding: 15px 0px 0;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    padding: 0;\n    font-size: 30px;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 3px;\n    text-transform: uppercase;\n    color: ', ';\n\n    & > * {\n        z-index: 2;\n    }\n\n    &.scew-header {\n        padding-bottom: 3px;\n    }\n\n    > * {\n        display: flex;\n        min-height: 64px;\n        background-color: ', ';\n        color: ', ';\n        align-items: center;\n        justify-content: center;\n\n        &.tl-rank {\n            border: 1px solid ', ';\n        }\n\n        &.list-player-name,\n        &.tl-image {\n            background-color: ', ';\n        }\n\n        &.tl-score {\n            border: 1px solid ', ';\n            min-width: 60px;\n            padding: 0 5px;\n        }\n    }\n\n    .tl-rank,\n    .tl-rank {\n        width: 60px;\n        min-width: 60px;\n        > * {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .tl-image {\n        margin: 0 2px;\n        width: 60px;\n        min-width: 60px;\n        overflow: hidden;\n        display: flex;\n        align-items: flex-end;\n\n        > * {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .list-player-name {\n        line-height: 1em;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n\n        padding-left: 14px;\n        justify-content: flex-start;\n\n        > span {\n            transform: skew(', 'deg);\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            display: inline-block;\n        }\n    }\n\n    .tl-score {\n        margin-left: 2px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n\n        > span {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    &.pls_highlight {\n        .tl-image,\n        .list-player-name {\n            background-color: ', ';\n            color: ', ';\n        }\n    }\n'], ['\n    position: relative;\n    display: flex;\n    padding: 0;\n    font-size: 30px;\n    line-height: 20px;\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 3px;\n    text-transform: uppercase;\n    color: ', ';\n\n    & > * {\n        z-index: 2;\n    }\n\n    &.scew-header {\n        padding-bottom: 3px;\n    }\n\n    > * {\n        display: flex;\n        min-height: 64px;\n        background-color: ', ';\n        color: ', ';\n        align-items: center;\n        justify-content: center;\n\n        &.tl-rank {\n            border: 1px solid ', ';\n        }\n\n        &.list-player-name,\n        &.tl-image {\n            background-color: ', ';\n        }\n\n        &.tl-score {\n            border: 1px solid ', ';\n            min-width: 60px;\n            padding: 0 5px;\n        }\n    }\n\n    .tl-rank,\n    .tl-rank {\n        width: 60px;\n        min-width: 60px;\n        > * {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .tl-image {\n        margin: 0 2px;\n        width: 60px;\n        min-width: 60px;\n        overflow: hidden;\n        display: flex;\n        align-items: flex-end;\n\n        > * {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .list-player-name {\n        line-height: 1em;\n        flex-grow: 1;\n        overflow: hidden;\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n\n        padding-left: 14px;\n        justify-content: flex-start;\n\n        > span {\n            transform: skew(', 'deg);\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            display: inline-block;\n        }\n    }\n\n    .tl-score {\n        margin-left: 2px;\n        white-space: nowrap;\n        position: relative;\n        z-index: 3;\n\n        > span {\n            transform: skew(', 'deg);\n        }\n    }\n\n    .tl-unit {\n        font-size: 22px;\n    }\n\n    &.pls_highlight {\n        .tl-image,\n        .list-player-name {\n            background-color: ', ';\n            color: ', ';\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _StyledUI = __webpack_require__(1418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	//const i18Common = require('../../../../i18/i18.Common');
	//const i18 = RCore.getTranslation.bind({ dict: i18Common });
	
	var SkewContainer = _styledComponents2.default.ul(_templateObject, function (props) {
	    return props.theme.skins.skew.angle;
	});
	
	var LIList = _styledComponents2.default.li(_templateObject2, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.content.accentTextColor;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	}, function (props) {
	    return props.theme.skins.skew.angle;
	}, function (props) {
	    return props.theme.content.accentColor;
	}, function (props) {
	    return props.theme.color;
	});
	
	var Header = function Header() {
	    return _react2.default.createElement('div', null);
	};
	
	var Row = (0, _styledComponents.withTheme)(function (_ref) {
	    var theme = _ref.theme,
	        player = _ref.player,
	        seasonId = _ref.seasonId,
	        rank = _ref.rank,
	        highlightFirstPlayer = _ref.highlightFirstPlayer,
	        highlightTeam = _ref.highlightTeam,
	        props = _objectWithoutProperties(_ref, ['theme', 'player', 'seasonId', 'rank', 'highlightFirstPlayer', 'highlightTeam']);
	
	    var name = _RCore2.default.getFirstLastName(player.name);
	    var SMPlayerLogo = _StyledUI.styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);
	
	    return _react2.default.createElement(
	        LIList,
	        {
	            key: player.id,
	            className: highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-rank' },
	            _react2.default.createElement(
	                'span',
	                null,
	                rank + 1
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-image' },
	            _react2.default.createElement(SMPlayerLogo, {
	                playerId: player.id,
	                teamId: player.teamId,
	                seasonId: seasonId,
	                width: 60,
	                height: 60,
	                number: player.shirtNumber
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'list-player-name' },
	            _react2.default.createElement(
	                'span',
	                null,
	                name.firstName,
	                ' ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    name.lastName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'tl-score' },
	            _react2.default.createElement(
	                'span',
	                null,
	                player.displayValue || player.value
	            )
	        )
	    );
	});
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var Container = function Container(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        SkewContainer,
	        null,
	        children
	    );
	};
	
	exports.default = { Header: Header, Row: Row, Container: Container };

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.H2HRow = exports.RowsLarge = exports.Rows = exports.LatestFormRow = exports.HeaderLarge = exports.HeaderMinimized = exports.Header = exports.Container = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: ', ';\n    color: ', ';\n    margin-top: 0px;\n    margin-bottom: 4px;\n    padding: 16px 0;\n\n    .title {\n        font-size: 14px;\n        color: ', ';\n        min-width: 250px;\n        text-align: center;\n    }\n'], ['\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: ', ';\n    color: ', ';\n    margin-top: 0px;\n    margin-bottom: 4px;\n    padding: 16px 0;\n\n    .title {\n        font-size: 14px;\n        color: ', ';\n        min-width: 250px;\n        text-align: center;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 20px 0;\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n\n    & > div {\n        flex-grow: 1;\n    }\n'], ['\n    padding: 20px 0;\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n\n    & > div {\n        flex-grow: 1;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1px;\n'], ['\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: block;\n\n    .devider {\n        font-size: 75px;\n        line-height: 1em;\n        font-weight: 900;\n        transform: translateY(-13px);\n        margin: 0 30px;\n    }\n\n    .teams-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .score-wrapper {\n        > div {\n            width: auto;\n        }\n    }\n'], ['\n    display: block;\n\n    .devider {\n        font-size: 75px;\n        line-height: 1em;\n        font-weight: 900;\n        transform: translateY(-13px);\n        margin: 0 30px;\n    }\n\n    .teams-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .score-wrapper {\n        > div {\n            width: auto;\n        }\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    width: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n\n    .wdp-team-logo {\n        width: 80px;\n        height: 80px;\n        margin: 0;\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        height: 80px;\n        margin: 0;\n        white-space: nowrap;\n        & > * {\n            vertical-align: middle;\n        }\n    }\n\n    .team-name {\n        padding: 0;\n        min-width: 110px;\n        text-align: ', ';\n        margin: ', ';\n        font-size: 60px;\n        font-weight: 700;\n        line-height: 65px;\n        height: 65px;\n        display: inline-block;\n        position: relative;\n    }\n\n    .rank {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        font-weight: normal;\n        transform: translateY(100%);\n        font-size: 15px;\n        line-height: 15px;\n        text-transform: lowercase;\n    }\n'], ['\n    width: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: ', ';\n\n    .wdp-team-logo {\n        width: 80px;\n        height: 80px;\n        margin: 0;\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        height: 80px;\n        margin: 0;\n        white-space: nowrap;\n        & > * {\n            vertical-align: middle;\n        }\n    }\n\n    .team-name {\n        padding: 0;\n        min-width: 110px;\n        text-align: ', ';\n        margin: ', ';\n        font-size: 60px;\n        font-weight: 700;\n        line-height: 65px;\n        height: 65px;\n        display: inline-block;\n        position: relative;\n    }\n\n    .rank {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        font-weight: normal;\n        transform: translateY(100%);\n        font-size: 15px;\n        line-height: 15px;\n        text-transform: lowercase;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    text-align: center;\n    white-space: nowrap;\n\n    width: 300px;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 130px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n'], ['\n    text-align: center;\n    white-space: nowrap;\n\n    width: 300px;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 130px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 22px;\n    padding: 3px 10px;\n    margin-bottom: 10px;\n    background: ', ';\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n'], ['\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 22px;\n    padding: 3px 10px;\n    margin-bottom: 10px;\n    background: ', ';\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    font-size: 1.5rem;\n    margin-bottom: 0;\n    background: none;\n'], ['\n    font-size: 1.5rem;\n    margin-bottom: 0;\n    background: none;\n']),
	    _templateObject9 = _taggedTemplateLiteral([''], ['']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    font-size: 32px;\n    line-height: 34px;\n    font-weight: 700;\n    min-width: 250px;\n    white-space: nowrap;\n    text-align: center;\n\n    .nums {\n        font-size: 80px;\n        line-height: 1em;\n        font-weight: normal;\n\n        .better {\n            font-weight: bold;\n        }\n    }\n'], ['\n    font-size: 32px;\n    line-height: 34px;\n    font-weight: 700;\n    min-width: 250px;\n    white-space: nowrap;\n    text-align: center;\n\n    .nums {\n        font-size: 80px;\n        line-height: 1em;\n        font-weight: normal;\n\n        .better {\n            font-weight: bold;\n        }\n    }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    width: 100%;\n    font-size: 1.5rem;\n    margin-bottom: 30px;\n'], ['\n    width: 100%;\n    font-size: 1.5rem;\n    margin-bottom: 30px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    padding: 0;\n    margin: 0;\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: ', ';\n\n    ', ';\n'], ['\n    padding: 0;\n    margin: 0;\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: ', ';\n\n    ', ';\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    color: #fff;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    width: 24px;\n    height: 24px;\n    margin: 0 8px 4px;\n    font-weight: 700;\n    text-align: center;\n    line-height: 24px;\n    font-size: 12px;\n    text-transform: uppercase;\n'], ['\n    background-color: ', ';\n    color: #fff;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    width: 24px;\n    height: 24px;\n    margin: 0 8px 4px;\n    font-weight: 700;\n    text-align: center;\n    line-height: 24px;\n    font-size: 12px;\n    text-transform: uppercase;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    background-color: ', ';\n    padding: 17px 10px 16px;\n\n    .val {\n        min-width: 50px;\n        font-size: 30px;\n        line-height: 1em;\n        flex-grow: 1;\n        flex-basis: 0;\n        color: ', ';\n\n        &.val_better {\n            font-weight: 700;\n            font-size: 30px;\n        }\n\n        &.tar {\n            text-align: right;\n        }\n    }\n\n    .label {\n        color: ', ';\n        flex-grow: 1;\n        font-size: 18px;\n        line-height: 1.5;\n        text-align: center;\n        width: 1px;\n        padding: 0 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: normal;\n        text-transform: uppercase;\n        min-width: 250px;\n        ', ';\n        ', ';\n    }\n\n    .h2h_stats__chart {\n        flex-grow: 1.5;\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tar {\n        padding-right: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tal {\n        padding-left: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    background-color: ', ';\n    padding: 17px 10px 16px;\n\n    .val {\n        min-width: 50px;\n        font-size: 30px;\n        line-height: 1em;\n        flex-grow: 1;\n        flex-basis: 0;\n        color: ', ';\n\n        &.val_better {\n            font-weight: 700;\n            font-size: 30px;\n        }\n\n        &.tar {\n            text-align: right;\n        }\n    }\n\n    .label {\n        color: ', ';\n        flex-grow: 1;\n        font-size: 18px;\n        line-height: 1.5;\n        text-align: center;\n        width: 1px;\n        padding: 0 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: normal;\n        text-transform: uppercase;\n        min-width: 250px;\n        ', ';\n        ', ';\n    }\n\n    .h2h_stats__chart {\n        flex-grow: 1.5;\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tar {\n        padding-right: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tal {\n        padding-left: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n    background: none;\n    padding: 32px 10px;\n\n    .label {\n        font-size: 28px;\n        line-height: 1em;\n    }\n\n    .val,\n    .val.val_better,\n    .val.tar {\n        font-size: 60px;\n        line-height: 1em;\n        text-align: center;\n\n        strong {\n            font-size: 75px;\n            line-height: 1em;\n        }\n    }\n'], ['\n    background: none;\n    padding: 32px 10px;\n\n    .label {\n        font-size: 28px;\n        line-height: 1em;\n    }\n\n    .val,\n    .val.val_better,\n    .val.tar {\n        font-size: 60px;\n        line-height: 1em;\n        text-align: center;\n\n        strong {\n            font-size: 75px;\n            line-height: 1em;\n        }\n    }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 30px;\n    position: relative;\n\n    &:after {\n        content: \'\';\n        position: absolute;\n        left: ', ';\n        right: ', ';\n        top: 0;\n        bottom: 0;\n        width: ', '%;\n        background-color: ', ';\n    }\n'], ['\n    width: 100%;\n    height: 30px;\n    position: relative;\n\n    &:after {\n        content: \'\';\n        position: absolute;\n        left: ', ';\n        right: ', ';\n        top: 0;\n        bottom: 0;\n        width: ', '%;\n        background-color: ', ';\n    }\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n    text-align: center;\n    text-transform: uppercase;\n    padding: 25px 30px;\n    margin-top: 4px;\n    color: ', ';\n    background-color: ', ';\n\n    .title {\n        font-weight: 400;\n        font-size: 14px;\n        margin-bottom: 15px;\n        color: ', ';\n    }\n\n    .form {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        color: ', ';\n\n        > div {\n            font-weight: bold;\n\n            span {\n                background-color: transparent !important;\n            }\n        }\n    }\n'], ['\n    text-align: center;\n    text-transform: uppercase;\n    padding: 25px 30px;\n    margin-top: 4px;\n    color: ', ';\n    background-color: ', ';\n\n    .title {\n        font-weight: 400;\n        font-size: 14px;\n        margin-bottom: 15px;\n        color: ', ';\n    }\n\n    .form {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        color: ', ';\n\n        > div {\n            font-weight: bold;\n\n            span {\n                background-color: transparent !important;\n            }\n        }\n    }\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n    height: 30px;\n    line-height: 28px;\n    flex-basis: ', '%;\n    white-space: nowrap;\n    min-width: 74px;\n    box-sizing: border-box;\n    padding: 0 20px;\n    font-size: 0.875rem;\n\n    &:nth-child(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: left;\n    }\n\n    &:nth-child(2) {\n        color: ', ';\n        background-color: ', ';\n        padding: 0;\n    }\n\n    &:nth-last-of-type(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: right;\n    }\n'], ['\n    height: 30px;\n    line-height: 28px;\n    flex-basis: ', '%;\n    white-space: nowrap;\n    min-width: 74px;\n    box-sizing: border-box;\n    padding: 0 20px;\n    font-size: 0.875rem;\n\n    &:nth-child(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: left;\n    }\n\n    &:nth-child(2) {\n        color: ', ';\n        background-color: ', ';\n        padding: 0;\n    }\n\n    &:nth-last-of-type(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: right;\n    }\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n    width: 300px;\n    min-height: 300px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    background-color: ', ';\n\n    .wdp-team-logo {\n        width: 150px;\n        margin: 0;\n\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .team-name {\n        font-size: 50px;\n        font-weight: bold;\n        line-height: 1em;\n        margin-top: 20px;\n    }\n'], ['\n    width: 300px;\n    min-height: 300px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    background-color: ', ';\n\n    .wdp-team-logo {\n        width: 150px;\n        margin: 0;\n\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .team-name {\n        font-size: 50px;\n        font-weight: bold;\n        line-height: 1em;\n        margin-top: 20px;\n    }\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n    min-height: 300px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-grow: 1;\n    margin: 0 5px;\n    background-color: ', ';\n'], ['\n    min-height: 300px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-grow: 1;\n    margin: 0 5px;\n    background-color: ', ';\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 22px;\n    padding: 3px 10px;\n    margin-bottom: 10px;\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n    background: none;\n'], ['\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 22px;\n    padding: 3px 10px;\n    margin-bottom: 10px;\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n    background: none;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var StatsFormWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var MatchHeader = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.color;
	});
	
	var MatchHeaderLarge = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.color;
	});
	
	var MatchHeaderMin = MatchHeader.extend(_templateObject4);
	
	var Team = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.side === 'home' ? 'flex-end' : 'flex-start';
	}, function (props) {
	    return props.side === 'home' ? 'right' : 'left';
	}, function (props) {
	    return props.side === 'home' ? '0 15px 0 0' : '0 0 0 15px';
	});
	
	var StartInfo = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.color;
	});
	
	var LiveLabel = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.primaryColor;
	}, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var LiveLabelMin = LiveLabel.extend(_templateObject8);
	
	var FinishedLabel = LiveLabel.extend(_templateObject9);
	
	var FinishedLabelMin = LiveLabelMin.extend(_templateObject9);
	
	var Score = _styledComponents2.default.div(_templateObject10);
	
	var ScoreMin = Score.extend(_templateObject11);
	
	var StatsForm = _styledComponents2.default.ul(_templateObject12, function (_ref) {
	    var align = _ref.align;
	    return align;
	}, function (_ref2) {
	    var align = _ref2.align;
	    return align === 'left' ? 'transform: translateX(-8px);' : 'transform: translateX(8px);';
	});
	
	var StatItem = _styledComponents2.default.li(_templateObject13, function (props) {
	    return props.theme.wdl[props.result];
	});
	
	var StatRows = _styledComponents2.default.div(_templateObject9);
	
	var StatRow = _styledComponents2.default.div(_templateObject14, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	}, function (_ref3) {
	    var onlyLabel = _ref3.onlyLabel;
	    return onlyLabel && 'position: static !important; transform: translate(0, 0) !important;';
	}, function (_ref4) {
	    var labelLength = _ref4.labelLength;
	    return labelLength >= 19 && 'white-space: normal !important;';
	});
	
	var StatRowLarge = StatRow.extend(_templateObject15);
	
	var Chart = _styledComponents2.default.div(_templateObject16, function (props) {
	    return props.dir === 'left' ? 0 : 'auto';
	}, function (props) {
	    return props.dir === 'right' ? 0 : 'auto';
	}, function (props) {
	    return props.val;
	}, function (props) {
	    return props.color === 'home' ? props.theme.statColorHome : props.theme.statColorAway;
	});
	
	var LatestH2HForm = _styledComponents2.default.div(_templateObject17, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject18, function (props) {
	    return props.flexBasis;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorHome;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorNeutral || props.theme.content.statTableBgColor;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorAway;
	});
	
	var TeamLarge = _styledComponents2.default.div(_templateObject19, function (_ref5) {
	    var theme = _ref5.theme;
	    return theme.content.backgroundColor;
	});
	
	var Center = _styledComponents2.default.div(_templateObject20, function (_ref6) {
	    var theme = _ref6.theme;
	    return theme.content.backgroundColor;
	});
	
	var LiveLabelLarge = _styledComponents2.default.div(_templateObject21, function (props) {
	    return props.theme.primaryTextColor;
	});
	
	var Header = function Header(_ref7, ctx) {
	    var event = _ref7.event,
	        rankInfo = _ref7.rankInfo,
	        status = _ref7.status;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	    var _event = event,
	        statusType = _event.statusType,
	        statusFull = _event.statusFull;
	
	    var isLive = statusType === 'inprogress';
	    var isNotStarted = statusType === 'notstarted';
	    var isFinished = statusFull === 'Finished';
	
	    //ToDo: need to change in api
	    var ttName = event.tournamentName && (event.tournamentName.toLowerCase() === 'superliga' || event.tournamentName.toLowerCase() === 'superleague') ? '3F ' + event.tournamentName : event.tournamentName || '';
	
	    return _react2.default.createElement(
	        MatchHeader,
	        null,
	        _react2.default.createElement(
	            Team,
	            { side: 'home' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'team-name' },
	                    _react2.default.createElement('span', null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        event.homeShortName
	                    ),
	                    rankInfo && rankInfo.home && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.home.rank
	                        ),
	                        ' (',
	                        rankInfo.home.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                ),
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.homeId })
	            )
	        ),
	        isNotStarted && _react2.default.createElement(
	            StartInfo,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'tournament' },
	                _react2.default.createElement(_UI2.default.TournamentName, { name: ttName, id: event.tournamentTemplateId })
	            ),
	            _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'span', date: event.startDate, type: 'TIME' }),
	            event.channel && _react2.default.createElement(
	                'div',
	                { className: 'channel' },
	                event.channel.name
	            )
	        ),
	        (isLive || isFinished) && _react2.default.createElement(
	            Score,
	            null,
	            isLive && _react2.default.createElement(
	                LiveLabel,
	                null,
	                i18('live', lang),
	                ' ',
	                event.isHT() ? i18('ht', lang) : event.getMinutes() + '\''
	            ),
	            isFinished && _react2.default.createElement(
	                FinishedLabel,
	                null,
	                i18('finished', lang)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _lodash2.default.get(event, 'score.home'),
	                ' - ',
	                _lodash2.default.get(event, 'score.away')
	            )
	        ),
	        _react2.default.createElement(
	            Team,
	            { side: 'away' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, display: 'logo', teamId: event.awayId }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'team-name' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        event.awayShortName
	                    ),
	                    rankInfo && rankInfo.away && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.away.rank
	                        ),
	                        ' (',
	                        rankInfo.away.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var HeaderLarge = function HeaderLarge(_ref8, ctx) {
	    var event = _ref8.event,
	        rankInfo = _ref8.rankInfo,
	        status = _ref8.status;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	    var _event2 = event,
	        statusType = _event2.statusType,
	        statusFull = _event2.statusFull;
	
	    var isLive = statusType === 'inprogress';
	    var isNotStarted = statusType === 'notstarted';
	    var isFinished = statusFull === 'Finished';
	
	    //ToDo: need to change in api
	    var ttName = event.tournamentName && (event.tournamentName.toLowerCase() === 'superliga' || event.tournamentName.toLowerCase() === 'superleague') ? '3F ' + event.tournamentName : event.tournamentName || '';
	
	    var homeScore = _lodash2.default.get(event, 'score.home', 0);
	    var awayScore = _lodash2.default.get(event, 'score.away', 0);
	    var homeIsBetter = homeScore > awayScore;
	    var awayIsBetter = awayScore > homeScore;
	
	    return _react2.default.createElement(
	        MatchHeaderLarge,
	        null,
	        _react2.default.createElement(
	            TeamLarge,
	            { side: 'home' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.homeId }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'team-name' },
	                    _react2.default.createElement('span', null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        event.homeShortName
	                    ),
	                    rankInfo && rankInfo.home && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.home.rank
	                        ),
	                        ' (',
	                        rankInfo.home.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            Center,
	            null,
	            isNotStarted && _react2.default.createElement(
	                StartInfo,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tournament' },
	                    _react2.default.createElement(_UI2.default.TournamentName, { name: ttName, id: event.tournamentTemplateId })
	                ),
	                _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'span', date: event.startDate, type: 'TIME' }),
	                event.channel && _react2.default.createElement(
	                    'div',
	                    { className: 'channel' },
	                    event.channel.name
	                )
	            ),
	            (isLive || isFinished) && _react2.default.createElement(
	                Score,
	                null,
	                isLive && _react2.default.createElement(
	                    LiveLabelLarge,
	                    null,
	                    i18('live', lang),
	                    ' ',
	                    event.isHT() ? i18('ht', lang) : event.getMinutes() + '\''
	                ),
	                isFinished && _react2.default.createElement(
	                    LiveLabelLarge,
	                    null,
	                    i18('finished', lang)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'nums' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: '' + (homeIsBetter ? 'better' : '') },
	                        homeScore
	                    ),
	                    ' :',
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: '' + (awayIsBetter ? 'better' : '') },
	                        awayScore
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            TeamLarge,
	            { side: 'away' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, display: 'logo', teamId: event.awayId }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'team-name' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        event.awayShortName
	                    ),
	                    rankInfo && rankInfo.away && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.away.rank
	                        ),
	                        ' (',
	                        rankInfo.away.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var HeaderMinimized = function HeaderMinimized(_ref9, ctx) {
	    var event = _ref9.event,
	        rankInfo = _ref9.rankInfo;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	    var _event3 = event,
	        statusType = _event3.statusType,
	        statusFull = _event3.statusFull;
	
	    var isLive = statusType === 'inprogress';
	    var isNotStarted = statusType === 'notstarted';
	    var isFinished = statusFull === 'Finished';
	
	    return _react2.default.createElement(
	        MatchHeaderMin,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'score-wrapper' },
	            isNotStarted && _react2.default.createElement(
	                StartInfo,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tournament' },
	                    _react2.default.createElement(_UI2.default.TournamentName, { name: event.tournamentName, id: event.tournamentTemplateId })
	                ),
	                _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' }),
	                event.channel && _react2.default.createElement(
	                    'div',
	                    { className: 'channel' },
	                    event.channel.name
	                )
	            ),
	            (isLive || isFinished) && _react2.default.createElement(
	                ScoreMin,
	                null,
	                isLive && _react2.default.createElement(
	                    LiveLabelMin,
	                    null,
	                    i18('live', lang),
	                    ' ',
	                    event.isHT() ? i18('ht', lang) : event.getMinutes() + '\''
	                ),
	                isFinished && _react2.default.createElement(
	                    FinishedLabelMin,
	                    null,
	                    i18('finished', lang)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _lodash2.default.get(event, 'score.home'),
	                    ':',
	                    _lodash2.default.get(event, 'score.away')
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'teams-wrapper' },
	            _react2.default.createElement(
	                Team,
	                { side: 'home' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'name-wrapper' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'team-name' },
	                            event.homeShortName
	                        ),
	                        rankInfo && rankInfo.home && _react2.default.createElement(
	                            'span',
	                            { className: 'rank' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '#',
	                                rankInfo.home.rank
	                            ),
	                            ' (',
	                            rankInfo.home.points,
	                            ' ',
	                            i18('points', lang),
	                            ')'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'devider' },
	                '-'
	            ),
	            _react2.default.createElement(
	                Team,
	                { side: 'away' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'name-wrapper' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'team-name' },
	                            event.awayShortName
	                        ),
	                        rankInfo && rankInfo.away && _react2.default.createElement(
	                            'span',
	                            { className: 'rank' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '#',
	                                rankInfo.away.rank
	                            ),
	                            ' (',
	                            rankInfo.away.points,
	                            ' ',
	                            i18('points', lang),
	                            ')'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var LatestFormRow = function LatestFormRow(_ref10, ctx) {
	    var form = _ref10.form,
	        limit = _ref10.limit,
	        title = _ref10.title,
	        clean = _ref10.clean;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    var latestHomeForm = form.home.short_results || [];
	    var latestAwayForm = form.away.short_results || [];
	
	    var latestHomeFormCount = latestHomeForm.length;
	    var latestAwayFormCount = latestAwayForm.length;
	
	    var notPlayedHomeGames = latestHomeFormCount < limit ? new Array(limit - latestHomeFormCount).fill({ result: 'notPlayed' }) : null;
	    var notPlayedAwayGames = latestAwayFormCount < limit ? new Array(limit - latestAwayFormCount).fill({ result: 'notPlayed' }) : null;
	
	    if (notPlayedHomeGames) latestHomeForm = [].concat(_toConsumableArray(notPlayedHomeGames), _toConsumableArray(latestHomeForm));
	    if (notPlayedAwayGames) latestAwayForm = [].concat(_toConsumableArray(notPlayedAwayGames), _toConsumableArray(latestAwayForm));
	
	    return _react2.default.createElement(
	        StatsFormWrapper,
	        { className: '__c__b3_form' },
	        _react2.default.createElement(
	            StatsForm,
	            { align: 'right' },
	            latestHomeForm.map(function (r, i) {
	                return _react2.default.createElement(
	                    StatItem,
	                    { key: i, result: r.result, className: 'stat-item stat-item_' + r.result },
	                    clean ? null : i18(r.result + '.short', lang)
	                );
	            })
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'title __c__cformtitle' },
	            title
	        ),
	        _react2.default.createElement(
	            StatsForm,
	            { align: 'left' },
	            latestAwayForm.map(function (r, i) {
	                return _react2.default.createElement(
	                    StatItem,
	                    { key: i, result: r.result, className: 'stat-item stat-item_' + r.result },
	                    clean ? null : i18(r.result + '.short', lang)
	                );
	            })
	        )
	    );
	};
	
	var Rows = function Rows(_ref11) {
	    var dataset = _ref11.dataset;
	
	    return _react2.default.createElement(
	        StatRows,
	        null,
	        dataset.map(function (_ref12) {
	            var label = _ref12.label,
	                home = _ref12.home,
	                away = _ref12.away,
	                _ref12$postfix = _ref12.postfix,
	                postfix = _ref12$postfix === undefined ? '' : _ref12$postfix,
	                _ref12$prefix = _ref12.prefix,
	                prefix = _ref12$prefix === undefined ? '' : _ref12$prefix,
	                sum = _ref12.sum,
	                _ref12$chart = _ref12.chart,
	                chart = _ref12$chart === undefined ? true : _ref12$chart,
	                _ref12$lessIsBetter = _ref12.lessIsBetter,
	                lessIsBetter = _ref12$lessIsBetter === undefined ? false : _ref12$lessIsBetter,
	                _ref12$toFixed = _ref12.toFixed,
	                toFixed = _ref12$toFixed === undefined ? false : _ref12$toFixed,
	                _ref12$displayChart = _ref12.displayChart,
	                displayChart = _ref12$displayChart === undefined ? false : _ref12$displayChart;
	
	            if (!sum) sum = home + away;
	            var homeIsBetter = home > away;
	            var awayIsBetter = away > home;
	
	            if (lessIsBetter) homeIsBetter = !homeIsBetter;
	            if (lessIsBetter) awayIsBetter = !awayIsBetter;
	
	            return _react2.default.createElement(
	                StatRow,
	                {
	                    key: label,
	                    className: 'stat-row',
	                    onlyLabel: home == null && away == null,
	                    labelLength: label.length
	                },
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'tal h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: home / sum * 100, dir: 'left', color: 'home' })
	                ),
	                home != null && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('tar val __c__c1_style1', { val_better: homeIsBetter }) },
	                    prefix,
	                    Number.isInteger(home) ? home : home.toFixed(toFixed),
	                    postfix
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'label __c__c2_style1' },
	                    label
	                ),
	                away != null && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('val __c__c3_style1', { val_better: awayIsBetter }) },
	                    prefix,
	                    Number.isInteger(away) ? away : away.toFixed(toFixed),
	                    postfix
	                ),
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'tar h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: away / sum * 100, dir: 'right', color: 'away' })
	                )
	            );
	        })
	    );
	};
	
	var getFormattedNumber = function getFormattedNumber(num) {
	    if (!num) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            '-'
	        );
	    }
	
	    var fixNum = Number(num).toFixed(1);
	    var firstSign = ('' + fixNum).charAt(0);
	    var rest = ('' + fixNum).slice(1);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'strong',
	            null,
	            firstSign
	        ),
	        rest,
	        '!'
	    );
	};
	
	var RowsLarge = function RowsLarge(_ref13) {
	    var dataset = _ref13.dataset;
	
	    return _react2.default.createElement(
	        StatRows,
	        null,
	        dataset.map(function (_ref14) {
	            var label = _ref14.label,
	                home = _ref14.home,
	                away = _ref14.away,
	                _ref14$postfix = _ref14.postfix,
	                postfix = _ref14$postfix === undefined ? '' : _ref14$postfix,
	                _ref14$prefix = _ref14.prefix,
	                prefix = _ref14$prefix === undefined ? '' : _ref14$prefix,
	                sum = _ref14.sum,
	                _ref14$chart = _ref14.chart,
	                chart = _ref14$chart === undefined ? true : _ref14$chart,
	                _ref14$lessIsBetter = _ref14.lessIsBetter,
	                lessIsBetter = _ref14$lessIsBetter === undefined ? false : _ref14$lessIsBetter,
	                _ref14$toFixed = _ref14.toFixed,
	                toFixed = _ref14$toFixed === undefined ? false : _ref14$toFixed,
	                _ref14$displayChart = _ref14.displayChart,
	                displayChart = _ref14$displayChart === undefined ? false : _ref14$displayChart,
	                _ref14$largeSign = _ref14.largeSign,
	                largeSign = _ref14$largeSign === undefined ? false : _ref14$largeSign;
	
	            if (!sum) sum = home + away;
	            var homeIsBetter = home > away;
	            var awayIsBetter = away > home;
	
	            if (lessIsBetter) homeIsBetter = !homeIsBetter;
	            if (lessIsBetter) awayIsBetter = !awayIsBetter;
	
	            return _react2.default.createElement(
	                StatRowLarge,
	                {
	                    key: label,
	                    className: 'stat-row',
	                    onlyLabel: home == null && away == null,
	                    labelLength: label.length
	                },
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'tal h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: home / sum * 100, dir: 'left', color: 'home' })
	                ),
	                home != null && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('tar val __c__c1_style1', { val_better: homeIsBetter }) },
	                    prefix,
	                    largeSign ? getFormattedNumber(home) : home,
	                    postfix
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'label __c__c2_style1' },
	                    label
	                ),
	                away != null && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('val __c__c3_style1', { val_better: awayIsBetter }) },
	                    prefix,
	                    largeSign ? getFormattedNumber(away) : away,
	                    postfix
	                ),
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'tar h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: away / sum * 100, dir: 'right', color: 'away' })
	                )
	            );
	        })
	    );
	};
	
	var H2HRow = function H2HRow(_ref15) {
	    var event = _ref15.event,
	        h2h = _ref15.h2h,
	        h2hTitle = _ref15.h2hTitle;
	
	    if (!h2h.homeTeam) return _react2.default.createElement('div', null);
	
	    var cells = [{
	        name: event.homeShortName,
	        value: h2h.homeTeam.wins
	    }, {
	        name: h2hTitle.draw,
	        value: h2h.draws
	    }, {
	        name: event.awayShortName,
	        value: h2h.awayTeam.wins
	    }];
	
	    var numOfMatches = h2h.homeTeam.wins + h2h.draws + h2h.awayTeam.wins;
	
	    return _react2.default.createElement(
	        LatestH2HForm,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'title __c__c5_style1' },
	            numOfMatches,
	            ' ',
	            h2hTitle.title
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'form' },
	            cells.map(function (cell, i) {
	                return _react2.default.createElement(
	                    Cell,
	                    {
	                        key: cell.name + cell.value,
	                        flexBasis: cell.value * (100 / numOfMatches),
	                        className: '__c__b' + i + '_style1'
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        { className: '__c__c' + i + '_style2' },
	                        cell.name,
	                        ': ',
	                        cell.value
	                    )
	                );
	            })
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	HeaderLarge.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	HeaderMinimized.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	LatestFormRow.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	Rows.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	RowsLarge.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	H2HRow.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	var Container = function Container(_ref16) {
	    var children = _ref16.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        children
	    );
	};
	
	exports.default = { Container: Container, Header: Header, HeaderMinimized: HeaderMinimized, HeaderLarge: HeaderLarge, LatestFormRow: LatestFormRow, Rows: Rows, RowsLarge: RowsLarge, H2HRow: H2HRow };
	exports.Container = Container;
	exports.Header = Header;
	exports.HeaderMinimized = HeaderMinimized;
	exports.HeaderLarge = HeaderLarge;
	exports.LatestFormRow = LatestFormRow;
	exports.Rows = Rows;
	exports.RowsLarge = RowsLarge;
	exports.H2HRow = H2HRow;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.H2HRow = exports.Rows = exports.LatestFormRow = exports.HeaderMinimized = exports.Header = exports.Container = undefined;
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background-color: ', ';\n    color: ', ';\n    padding: 18px 0 9px;\n\n    > * {\n        flex: 0 1 33.3%;\n    }\n\n    .title {\n        font-size: 1.1875rem;\n        color: ', ';\n        text-align: center;\n        min-width: 250px;\n    }\n'], ['\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background-color: ', ';\n    color: ', ';\n    padding: 18px 0 9px;\n\n    > * {\n        flex: 0 1 33.3%;\n    }\n\n    .title {\n        font-size: 1.1875rem;\n        color: ', ';\n        text-align: center;\n        min-width: 250px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 20px 5px 20px;\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n\n    & > div {\n        flex-grow: 1;\n    }\n\n    .name {\n        .name-wrapper {\n            display: inline-block;\n\n            .team-name {\n                display: inline-block;\n            }\n        }\n\n        &.left {\n            margin: 0 15px 0 0;\n\n            .name-wrapper {\n                transform: translateX(calc(50% - 20px));\n            }\n\n            > span {\n                transform: translateX(calc(50% + 10px));\n            }\n        }\n\n        &.right {\n            margin: 0 0 0 15px;\n\n            .name-wrapper {\n                transform: translateX(calc(-50% + 20px));\n            }\n\n            > span {\n                transform: translateX(calc(-50% - 10px));\n            }\n        }\n    }\n\n    .name-wrapper {\n        display: inline-block;\n\n        .team-name {\n            display: inline-block;\n        }\n\n        &.left {\n            margin: 0 15px 0 0;\n\n            .team-name {\n                background-color: green;\n                transform: translateX(calc(50% - 20px));\n            }\n        }\n\n        &.right {\n            margin: 0 0 0 15px;\n\n            .team-name {\n                background-color: green;\n                transform: translateX(calc(-50% + 20px));\n            }\n        }\n\n        .rank-wrap {\n            min-height: 21px;\n        }\n    }\n'], ['\n    padding: 20px 5px 20px;\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n\n    & > div {\n        flex-grow: 1;\n    }\n\n    .name {\n        .name-wrapper {\n            display: inline-block;\n\n            .team-name {\n                display: inline-block;\n            }\n        }\n\n        &.left {\n            margin: 0 15px 0 0;\n\n            .name-wrapper {\n                transform: translateX(calc(50% - 20px));\n            }\n\n            > span {\n                transform: translateX(calc(50% + 10px));\n            }\n        }\n\n        &.right {\n            margin: 0 0 0 15px;\n\n            .name-wrapper {\n                transform: translateX(calc(-50% + 20px));\n            }\n\n            > span {\n                transform: translateX(calc(-50% - 10px));\n            }\n        }\n    }\n\n    .name-wrapper {\n        display: inline-block;\n\n        .team-name {\n            display: inline-block;\n        }\n\n        &.left {\n            margin: 0 15px 0 0;\n\n            .team-name {\n                background-color: green;\n                transform: translateX(calc(50% - 20px));\n            }\n        }\n\n        &.right {\n            margin: 0 0 0 15px;\n\n            .team-name {\n                background-color: green;\n                transform: translateX(calc(-50% + 20px));\n            }\n        }\n\n        .rank-wrap {\n            min-height: 21px;\n        }\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: block;\n\n    .devider {\n        font-size: 75px;\n        line-height: 1em;\n        font-weight: 900;\n        transform: translateY(-13px);\n        margin: 0 30px;\n        color: ', ';\n    }\n\n    .teams-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .score-wrapper {\n        > div {\n            width: auto;\n        }\n    }\n'], ['\n    display: block;\n\n    .devider {\n        font-size: 75px;\n        line-height: 1em;\n        font-weight: 900;\n        transform: translateY(-13px);\n        margin: 0 30px;\n        color: ', ';\n    }\n\n    .teams-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .score-wrapper {\n        > div {\n            width: auto;\n        }\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    text-align: center;\n    flex: 0 1 33.3%;\n\n    .wdp-team-logo {\n        width: 60px;\n        height: 60px;\n        margin: 0;\n\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        white-space: nowrap;\n        & > * {\n            vertical-align: middle;\n        }\n    }\n\n    .team-name {\n        padding: 0;\n        font-size: 50px;\n        line-height: 1em;\n        font-weight: 900;\n        color: ', ';\n    }\n\n    .rank {\n        font-size: 1.125rem;\n        display: block;\n        text-transform: lowercase;\n    }\n'], ['\n    text-align: center;\n    flex: 0 1 33.3%;\n\n    .wdp-team-logo {\n        width: 60px;\n        height: 60px;\n        margin: 0;\n\n        img {\n            height: 100%;\n            width: auto;\n        }\n    }\n\n    .name {\n        white-space: nowrap;\n        & > * {\n            vertical-align: middle;\n        }\n    }\n\n    .team-name {\n        padding: 0;\n        font-size: 50px;\n        line-height: 1em;\n        font-weight: 900;\n        color: ', ';\n    }\n\n    .rank {\n        font-size: 1.125rem;\n        display: block;\n        text-transform: lowercase;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    text-align: center;\n    flex: 0 1 33.3%;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 130px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n'], ['\n    text-align: center;\n    flex: 0 1 33.3%;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 130px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: 1.125rem;\n    line-height: 1em;\n    font-weight: 700;\n    margin-bottom: 3px;\n    padding: 3px 10px;\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n'], ['\n    font-size: 1.125rem;\n    line-height: 1em;\n    font-weight: 700;\n    margin-bottom: 3px;\n    padding: 3px 10px;\n    color: ', ';\n    text-align: center;\n    text-transform: uppercase;\n    min-width: 90px;\n    display: inline-block;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    font-size: 1.5rem;\n    margin-bottom: 0;\n    background: none;\n'], ['\n    font-size: 1.5rem;\n    margin-bottom: 0;\n    background: none;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    font-size: 1.125rem;\n    line-height: 1em;\n    min-width: 250px;\n    white-space: nowrap;\n    text-align: center;\n'], ['\n    font-size: 1.125rem;\n    line-height: 1em;\n    min-width: 250px;\n    white-space: nowrap;\n    text-align: center;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    width: 100%;\n    font-size: 1.5rem;\n    margin-bottom: 30px;\n'], ['\n    width: 100%;\n    font-size: 1.5rem;\n    margin-bottom: 30px;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    padding: 0;\n    margin: 0;\n    text-align: center;\n'], ['\n    padding: 0;\n    margin: 0;\n    text-align: center;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin: 0 2px;\n'], ['\n    background-color: ', ';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin: 0 2px;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    background-color: ', ';\n    padding: 8px 0;\n    text-align: center;\n    justify-content: space-around;\n\n    > * {\n        flex: 0 1 33.3%;\n    }\n\n    .val {\n        min-width: 50px;\n        font-size: 24px;\n        line-height: 1em;\n        font-weight: 700;\n        color: ', ';\n    }\n\n    .label {\n        color: ', ';\n        font-size: 18px;\n        line-height: 1em;\n        padding: 0 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: normal;\n        text-transform: uppercase;\n    }\n\n    .h2h_stats__chart {\n        flex-grow: 1.5;\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tar {\n        padding-right: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tal {\n        padding-left: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    background-color: ', ';\n    padding: 8px 0;\n    text-align: center;\n    justify-content: space-around;\n\n    > * {\n        flex: 0 1 33.3%;\n    }\n\n    .val {\n        min-width: 50px;\n        font-size: 24px;\n        line-height: 1em;\n        font-weight: 700;\n        color: ', ';\n    }\n\n    .label {\n        color: ', ';\n        font-size: 18px;\n        line-height: 1em;\n        padding: 0 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: normal;\n        text-transform: uppercase;\n    }\n\n    .h2h_stats__chart {\n        flex-grow: 1.5;\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tar {\n        padding-right: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n\n    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tal {\n        padding-left: 30px;\n\n        .h2h_stats__val {\n            width: auto;\n        }\n    }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 30px;\n    position: relative;\n\n    &:after {\n        content: \'\';\n        position: absolute;\n        left: ', ';\n        right: ', ';\n        top: 0;\n        bottom: 0;\n        width: ', '%;\n        background-color: ', ';\n    }\n'], ['\n    width: 100%;\n    height: 30px;\n    position: relative;\n\n    &:after {\n        content: \'\';\n        position: absolute;\n        left: ', ';\n        right: ', ';\n        top: 0;\n        bottom: 0;\n        width: ', '%;\n        background-color: ', ';\n    }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n    text-align: center;\n    text-transform: uppercase;\n    padding: 12px 30px 20px;\n    color: ', ';\n    background-color: ', ';\n\n    .title {\n        font-weight: 400;\n        font-size: 0.825rem;\n        margin-bottom: 5px;\n        color: ', ';\n    }\n\n    .form {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        color: ', ';\n    }\n'], ['\n    text-align: center;\n    text-transform: uppercase;\n    padding: 12px 30px 20px;\n    color: ', ';\n    background-color: ', ';\n\n    .title {\n        font-weight: 400;\n        font-size: 0.825rem;\n        margin-bottom: 5px;\n        color: ', ';\n    }\n\n    .form {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        color: ', ';\n    }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n    height: 22px;\n    line-height: 22px;\n    flex-basis: ', '%;\n    white-space: nowrap;\n    min-width: 74px;\n    box-sizing: border-box;\n    padding: 0 15px;\n    font-size: 0.875rem;\n    font-weight: bold;\n    transform: skew(-20deg);\n\n    > span {\n        transform: skew(20deg);\n        display: inline-block;\n    }\n\n    &:nth-child(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: left;\n    }\n\n    &:nth-child(2) {\n        color: ', ';\n        background-color: ', ';\n        padding: 0;\n    }\n\n    &:nth-last-of-type(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: right;\n    }\n'], ['\n    height: 22px;\n    line-height: 22px;\n    flex-basis: ', '%;\n    white-space: nowrap;\n    min-width: 74px;\n    box-sizing: border-box;\n    padding: 0 15px;\n    font-size: 0.875rem;\n    font-weight: bold;\n    transform: skew(-20deg);\n\n    > span {\n        transform: skew(20deg);\n        display: inline-block;\n    }\n\n    &:nth-child(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: left;\n    }\n\n    &:nth-child(2) {\n        color: ', ';\n        background-color: ', ';\n        padding: 0;\n    }\n\n    &:nth-last-of-type(1) {\n        color: ', ';\n        background-color: ', ';\n        text-align: right;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _UI = __webpack_require__(1347);
	
	var _UI2 = _interopRequireDefault(_UI);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var SkewContainer = _styledComponents2.default.div(_templateObject);
	
	var StatsFormWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var MatchHeader = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.content.backgroundColor;
	}, function (props) {
	    return props.theme.color;
	});
	
	var MatchHeaderMin = MatchHeader.extend(_templateObject4, function (props) {
	    return props.theme.titleColor;
	});
	
	//text-align: ${props => (props.side === 'home' ? 'right' : 'left')};
	
	var Team = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.titleColor;
	});
	
	var StartInfo = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.color;
	});
	
	var LiveLabel = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.theme.subTitleColor;
	});
	
	var LiveLabelMin = LiveLabel.extend(_templateObject8);
	
	var FinishedLabel = LiveLabel.extend(_templateObject);
	
	var FinishedLabelMin = LiveLabelMin.extend(_templateObject);
	
	var Score = _styledComponents2.default.div(_templateObject9);
	
	var ScoreMin = Score.extend(_templateObject10);
	
	var StatsForm = _styledComponents2.default.ul(_templateObject11);
	
	var StatItem = _styledComponents2.default.li(_templateObject12, function (props) {
	    return props.theme.wdl[props.result];
	});
	
	var StatRows = _styledComponents2.default.div(_templateObject);
	
	var StatRow = _styledComponents2.default.div(_templateObject13, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var Chart = _styledComponents2.default.div(_templateObject14, function (props) {
	    return props.dir === 'left' ? 0 : 'auto';
	}, function (props) {
	    return props.dir === 'right' ? 0 : 'auto';
	}, function (props) {
	    return props.val;
	}, function (props) {
	    return props.color === 'home' ? props.theme.statColorHome : props.theme.statColorAway;
	});
	
	var LatestH2HForm = _styledComponents2.default.div(_templateObject15, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableBgColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var Cell = _styledComponents2.default.div(_templateObject16, function (props) {
	    return props.flexBasis;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorHome;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorNeutral || props.theme.content.statTableBgColor;
	}, function (props) {
	    return props.theme.statTextColor;
	}, function (props) {
	    return props.theme.statColorAway;
	});
	
	var Header = function Header(_ref, ctx) {
	    var event = _ref.event,
	        rankInfo = _ref.rankInfo;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	
	    var moment = ctx.moment;
	    var _event = event,
	        statusType = _event.statusType,
	        statusFull = _event.statusFull;
	
	
	    var isLive = statusType === 'inprogress';
	    var isNotStarted = statusType === 'notstarted';
	    var isFinished = statusFull === 'Finished';
	
	    //ToDo: need to change in api
	    var ttName = event.tournamentName.toLowerCase() === 'superliga' || event.tournamentName.toLowerCase() === 'superleague' ? '3F ' + event.tournamentName : event.tournamentName;
	
	    return _react2.default.createElement(
	        MatchHeader,
	        null,
	        _react2.default.createElement(
	            Team,
	            { side: 'home' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name left' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'team-name __c__c2_header_color_team_1' },
	                        event.homeShortName
	                    ),
	                    rankInfo && rankInfo.home && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.home.rank
	                        ),
	                        ' (',
	                        rankInfo.home.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                ),
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.homeId })
	            )
	        ),
	        isNotStarted && _react2.default.createElement(
	            StartInfo,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'tournament' },
	                _react2.default.createElement(_UI2.default.TournamentName, { name: ttName, id: event.tournamentTemplateId })
	            ),
	            _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' }),
	            event.channel && _react2.default.createElement(
	                'div',
	                { className: 'channel' },
	                event.channel.name
	            )
	        ),
	        (isLive || isFinished) && _react2.default.createElement(
	            Score,
	            null,
	            isLive && _react2.default.createElement(
	                LiveLabel,
	                null,
	                i18('live', lang),
	                ' ',
	                event.isHT() ? i18('ht', lang) : event.getMinutes() + '\''
	            ),
	            isFinished && _react2.default.createElement(
	                FinishedLabel,
	                null,
	                i18('finished', lang)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _lodash2.default.get(event, 'score.home'),
	                ':',
	                _lodash2.default.get(event, 'score.away')
	            )
	        ),
	        _react2.default.createElement(
	            Team,
	            { side: 'away' },
	            _react2.default.createElement(
	                'div',
	                { className: 'name right' },
	                _react2.default.createElement(_SMTeamLogo2.default, { tournamentId: event.tournamentTemplateId, teamId: event.awayId }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'team-name __c__c2_header_color_team_2' },
	                        event.awayShortName
	                    ),
	                    rankInfo && rankInfo.away && _react2.default.createElement(
	                        'span',
	                        { className: 'rank' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            '#',
	                            rankInfo.away.rank
	                        ),
	                        ' (',
	                        rankInfo.away.points,
	                        ' ',
	                        i18('points', lang),
	                        ')'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var HeaderMinimized = function HeaderMinimized(_ref2, ctx) {
	    var event = _ref2.event,
	        rankInfo = _ref2.rankInfo;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	
	    var moment = ctx.moment;
	    var _event2 = event,
	        statusType = _event2.statusType,
	        statusFull = _event2.statusFull;
	
	
	    var isLive = statusType === 'inprogress';
	    var isNotStarted = statusType === 'notstarted';
	    var isFinished = statusFull === 'Finished';
	
	    return _react2.default.createElement(
	        MatchHeaderMin,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'score-wrapper' },
	            isNotStarted && _react2.default.createElement(
	                StartInfo,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tournament' },
	                    _react2.default.createElement(_UI2.default.TournamentName, { name: event.tournamentName, id: event.tournamentTemplateId })
	                ),
	                _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'div', date: event.startDate, type: 'TIME' }),
	                event.channel && _react2.default.createElement(
	                    'div',
	                    { className: 'channel' },
	                    event.channel.name
	                )
	            ),
	            (isLive || isFinished) && _react2.default.createElement(
	                ScoreMin,
	                null,
	                isLive && _react2.default.createElement(
	                    LiveLabelMin,
	                    null,
	                    i18('live', lang),
	                    ' ',
	                    event.isHT() ? i18('ht', lang) : event.getMinutes() + '\''
	                ),
	                isFinished && _react2.default.createElement(
	                    FinishedLabelMin,
	                    null,
	                    i18('finished', lang)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _lodash2.default.get(event, 'score.home'),
	                    ':',
	                    _lodash2.default.get(event, 'score.away')
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'teams-wrapper' },
	            _react2.default.createElement(
	                Team,
	                { side: 'home' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'name-wrapper left' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'team-name __c__c1_header_color_team_1' },
	                            event.homeShortName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rank-wrap' },
	                            rankInfo && rankInfo.home && _react2.default.createElement(
	                                'span',
	                                { className: 'rank' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '#',
	                                    rankInfo.home.rank
	                                ),
	                                ' (',
	                                rankInfo.home.points,
	                                ' ',
	                                i18('points', lang),
	                                ')'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'devider __c__c1_header_color_team_dash' },
	                '-'
	            ),
	            _react2.default.createElement(
	                Team,
	                { side: 'away' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'name-wrapper right' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'team-name __c__c1_header_color_team_2' },
	                            event.awayShortName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rank-wrap' },
	                            rankInfo && rankInfo.away && _react2.default.createElement(
	                                'span',
	                                { className: 'rank' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '#',
	                                    rankInfo.away.rank
	                                ),
	                                ' (',
	                                rankInfo.away.points,
	                                ' ',
	                                i18('points', lang),
	                                ')'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var LatestFormRow = function LatestFormRow(_ref3, ctx) {
	    var form = _ref3.form,
	        limit = _ref3.limit,
	        title = _ref3.title,
	        clean = _ref3.clean;
	
	    var latestHomeForm = form.home.short_results || [];
	    var latestAwayForm = form.away.short_results || [];
	
	    var latestHomeFormCount = latestHomeForm.length;
	    var latestAwayFormCount = latestAwayForm.length;
	
	    var notPlayedHomeGames = latestHomeFormCount < limit ? new Array(limit - latestHomeFormCount).fill({ result: 'notPlayed' }) : null;
	    var notPlayedAwayGames = latestAwayFormCount < limit ? new Array(limit - latestAwayFormCount).fill({ result: 'notPlayed' }) : null;
	
	    if (notPlayedHomeGames) latestHomeForm = [].concat(_toConsumableArray(notPlayedHomeGames), _toConsumableArray(latestHomeForm));
	    if (notPlayedAwayGames) latestAwayForm = [].concat(_toConsumableArray(notPlayedAwayGames), _toConsumableArray(latestAwayForm));
	
	    return _react2.default.createElement(
	        StatsFormWrapper,
	        null,
	        _react2.default.createElement(
	            StatsForm,
	            null,
	            latestHomeForm.map(function (r, i) {
	                return _react2.default.createElement(StatItem, { key: i, result: r.result, className: 'stat-item_' + r.result });
	            })
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'title __c__c1_style1' },
	            title,
	            ' ',
	            latestHomeFormCount
	        ),
	        _react2.default.createElement(
	            StatsForm,
	            null,
	            latestAwayForm.map(function (r, i) {
	                return _react2.default.createElement(StatItem, { key: i, result: r.result, className: 'stat-item_' + r.result });
	            })
	        )
	    );
	};
	
	var Rows = function Rows(_ref4) {
	    var dataset = _ref4.dataset;
	
	    return _react2.default.createElement(
	        StatRows,
	        null,
	        dataset.map(function (row, i) {
	            var label = row.label,
	                home = row.home,
	                away = row.away,
	                _row$postfix = row.postfix,
	                postfix = _row$postfix === undefined ? '' : _row$postfix,
	                _row$prefix = row.prefix,
	                prefix = _row$prefix === undefined ? '' : _row$prefix,
	                sum = row.sum,
	                _row$chart = row.chart,
	                chart = _row$chart === undefined ? true : _row$chart,
	                _row$lessIsBetter = row.lessIsBetter,
	                lessIsBetter = _row$lessIsBetter === undefined ? false : _row$lessIsBetter,
	                _row$toFixed = row.toFixed,
	                toFixed = _row$toFixed === undefined ? false : _row$toFixed,
	                _row$displayChart = row.displayChart,
	                displayChart = _row$displayChart === undefined ? false : _row$displayChart;
	
	
	            if (!sum) sum = home + away;
	            var homeIsBetter = home > away;
	            var awayIsBetter = away > home;
	
	            if (lessIsBetter) homeIsBetter = !homeIsBetter;
	            if (lessIsBetter) awayIsBetter = !awayIsBetter;
	
	            return _react2.default.createElement(
	                StatRow,
	                { key: i },
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: home / sum * 100, dir: 'left', color: 'home' })
	                ),
	                home != null && _react2.default.createElement(
	                    'div',
	                    { className: 'val __c__c4_style1' },
	                    prefix,
	                    Number.isInteger(home) ? home : home.toFixed(toFixed),
	                    postfix
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'label __c__c2_style1' },
	                    label
	                ),
	                away != null && _react2.default.createElement(
	                    'div',
	                    { className: 'val __c__c3_style1' },
	                    prefix,
	                    Number.isInteger(away) ? away : away.toFixed(toFixed),
	                    postfix
	                ),
	                displayChart && _react2.default.createElement(
	                    'div',
	                    { className: 'tar h2h_stats__chart' },
	                    chart && _react2.default.createElement(Chart, { val: away / sum * 100, dir: 'right', color: 'away' })
	                )
	            );
	        })
	    );
	};
	
	var H2HRow = function H2HRow(_ref5) {
	    var event = _ref5.event,
	        h2h = _ref5.h2h,
	        h2hTitle = _ref5.h2hTitle;
	
	    if (!h2h.homeTeam) return _react2.default.createElement('div', null);
	    var cells = [{
	        name: event.homeShortName,
	        value: h2h.homeTeam.wins
	    }, {
	        name: h2hTitle.draw,
	        value: h2h.draws
	    }, {
	        name: event.awayShortName,
	        value: h2h.awayTeam.wins
	    }];
	
	    var numOfMatches = h2h.homeTeam.wins + h2h.draws + h2h.awayTeam.wins;
	
	    return _react2.default.createElement(
	        LatestH2HForm,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'title __c__c5_style1' },
	            numOfMatches,
	            ' ',
	            h2hTitle.title
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'form' },
	            cells.map(function (v, i) {
	                return _react2.default.createElement(
	                    Cell,
	                    { key: i, flexBasis: v.value * (100 / numOfMatches), className: '__c__b' + i + '_style1' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: '__c__c7_style1' },
	                        v.name,
	                        ': ',
	                        v.value
	                    )
	                );
	            })
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	HeaderMinimized.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	LatestFormRow.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	Rows.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	H2HRow.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	var Container = function Container(_ref6) {
	    var children = _ref6.children;
	    return _react2.default.createElement(
	        SkewContainer,
	        null,
	        children
	    );
	};
	
	exports.default = { Container: Container, Header: Header, HeaderMinimized: HeaderMinimized, LatestFormRow: LatestFormRow, Rows: Rows, H2HRow: H2HRow };
	exports.Container = Container;
	exports.Header = Header;
	exports.HeaderMinimized = HeaderMinimized;
	exports.LatestFormRow = LatestFormRow;
	exports.Rows = Rows;
	exports.H2HRow = H2HRow;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    width: calc(50% - 60px);\n'], ['\n    text-align: center;\n    width: calc(50% - 60px);\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    text-align: center;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 120px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n'], ['\n    text-align: center;\n\n    .time {\n        font-size: 38px;\n        line-height: 40px;\n        font-weight: 700;\n        margin-top: 4px;\n        margin-bottom: 4px;\n    }\n\n    .tournament {\n        overflow: hidden;\n        max-width: 120px;\n        margin: 0 auto;\n        text-transform: uppercase;\n        font-size: 16px;\n        line-height: 18px;\n        font-weight: 700;\n\n        svg {\n            height: 13px;\n\n            color: ', ';\n            fill: ', ';\n        }\n    }\n\n    .channel {\n        font-size: 16px;\n        line-height: 18px;\n        white-space: nowrap;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    font-size: 28px;\n    font-weight: 700;\n    text-align: center;\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 0 10px;\n'], ['\n    font-size: 28px;\n    font-weight: 700;\n    text-align: center;\n    width: calc(50% - 60px);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 0 10px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    margin-top: 20px;\n\n    .stat-row {\n        background: transparent;\n        position: relative;\n        padding: 6px 0;\n        justify-content: space-between;\n\n        .val {\n            color: ', ';\n        }\n        .val {\n            width: calc(50% - 60px);\n            text-align: center;\n            flex-basis: initial;\n            flex-grow: initial;\n            &.tar {\n                text-align: center;\n            }\n        }\n        .label {\n            font-size: 20px;\n            font-weight: 400;\n            width: auto;\n            padding: 0;\n            position: absolute;\n            min-width: 1px;\n            overflow: visible;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            color: ', ';\n        }\n    }\n'], ['\n    margin-top: 20px;\n\n    .stat-row {\n        background: transparent;\n        position: relative;\n        padding: 6px 0;\n        justify-content: space-between;\n\n        .val {\n            color: ', ';\n        }\n        .val {\n            width: calc(50% - 60px);\n            text-align: center;\n            flex-basis: initial;\n            flex-grow: initial;\n            &.tar {\n                text-align: center;\n            }\n        }\n        .label {\n            font-size: 20px;\n            font-weight: 400;\n            width: auto;\n            padding: 0;\n            position: absolute;\n            min-width: 1px;\n            overflow: visible;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            color: ', ';\n        }\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    height: 60px;\n    line-height: 60px;\n    background: ', ';\n'], ['\n    height: 60px;\n    line-height: 60px;\n    background: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _H2HTableSimple = __webpack_require__(1452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Flex = _styledComponents2.default.div(_templateObject);
	var LogoWrapper = _styledComponents2.default.div(_templateObject2);
	
	var StartInfo = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.color;
	});
	
	var Team = _styledComponents2.default.div(_templateObject4);
	
	var RowsWrapper = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var EventInfo = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.content.backgroundColor;
	});
	
	var LatestFormRow = function LatestFormRow() {
	    return null;
	};
	var H2HRow = function H2HRow() {
	    return null;
	};
	
	var WrappedRows = function WrappedRows(props) {
	    return _react2.default.createElement(
	        RowsWrapper,
	        null,
	        _react2.default.createElement(_H2HTableSimple.Rows, props)
	    );
	};
	
	var Header = function Header(_ref, ctx) {
	    var event = _ref.event;
	    var _event = event,
	        homeName = _event.homeName,
	        awayName = _event.awayName,
	        homeId = _event.homeId,
	        awayId = _event.awayId,
	        _event$score = _event.score,
	        home = _event$score.home,
	        away = _event$score.away,
	        statusType = _event.statusType;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	
	    var isNotStarted = statusType === 'notstarted';
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 20 } },
	            _react2.default.createElement(
	                Flex,
	                null,
	                _react2.default.createElement(
	                    LogoWrapper,
	                    null,
	                    _react2.default.createElement(_SMTeamLogo2.default, { height: 120, fontSize: 42, teamId: homeId, teamShortName: event.homeShortName })
	                ),
	                _react2.default.createElement(
	                    LogoWrapper,
	                    null,
	                    _react2.default.createElement(_SMTeamLogo2.default, { height: 120, fontSize: 42, teamId: awayId, teamShortName: event.awayShortName })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            EventInfo,
	            null,
	            _react2.default.createElement(
	                Flex,
	                null,
	                _react2.default.createElement(
	                    Team,
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        homeName
	                    )
	                ),
	                isNotStarted && _react2.default.createElement(
	                    StartInfo,
	                    null,
	                    _react2.default.createElement(_DateFormatted2.default, { className: 'time', el: 'span', date: event.startDate, type: 'TIME' }),
	                    event.channel && _react2.default.createElement(
	                        'div',
	                        { className: 'channel' },
	                        event.channel.name
	                    )
	                ),
	                _react2.default.createElement(
	                    Team,
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        awayName
	                    )
	                )
	            )
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var HeaderMinimized = Header;
	
	exports.default = {
	    Container: _H2HTableSimple.Container,
	    Header: Header,
	    HeaderMinimized: HeaderMinimized,
	    LatestFormRow: LatestFormRow,
	    Rows: WrappedRows,
	    H2HRow: H2HRow
	};

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 0;\n\n    .score {\n        font-size: 70px;\n        line-height: 1em;\n        white-space: nowrap;\n        font-weight: bold;\n        min-width: 190px;\n        text-align: center;\n        color: ', ';\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 0;\n\n    .score {\n        font-size: 70px;\n        line-height: 1em;\n        white-space: nowrap;\n        font-weight: bold;\n        min-width: 190px;\n        text-align: center;\n        color: ', ';\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    width: calc(50% - 60px);\n    text-align: center;\n\n    .rank {\n        padding-bottom: 5px;\n        padding-top: 10px;\n        display: block;\n        text-align: center;\n    }\n'], ['\n    width: calc(50% - 60px);\n    text-align: center;\n\n    .rank {\n        padding-bottom: 5px;\n        padding-top: 10px;\n        display: block;\n        text-align: center;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    .stat-row {\n        position: relative;\n        padding: 6px 0;\n        justify-content: space-between;\n        margin-top: 0;\n\n        .val {\n            color: ', ';\n        }\n        .val {\n            width: calc(50% - 60px);\n            text-align: center;\n            flex-basis: initial;\n            flex-grow: initial;\n            font-size: 30px;\n            background: transparent !important;\n\n            &.tar {\n                text-align: center;\n            }\n        }\n        .label {\n            color: ', ';\n            flex-grow: 1;\n            font-size: 14px;\n            line-height: 1.4em;\n            text-align: center;\n            width: 1px;\n            padding: 0 5px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: normal;\n            text-transform: uppercase;\n            min-width: 190px;\n            background: transparent !important;\n        }\n    }\n'], ['\n    .stat-row {\n        position: relative;\n        padding: 6px 0;\n        justify-content: space-between;\n        margin-top: 0;\n\n        .val {\n            color: ', ';\n        }\n        .val {\n            width: calc(50% - 60px);\n            text-align: center;\n            flex-basis: initial;\n            flex-grow: initial;\n            font-size: 30px;\n            background: transparent !important;\n\n            &.tar {\n                text-align: center;\n            }\n        }\n        .label {\n            color: ', ';\n            flex-grow: 1;\n            font-size: 14px;\n            line-height: 1.4em;\n            text-align: center;\n            width: 1px;\n            padding: 0 5px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: normal;\n            text-transform: uppercase;\n            min-width: 190px;\n            background: transparent !important;\n        }\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 700;\n    position: relative;\n    ', ';\n'], ['\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 700;\n    position: relative;\n    ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    text-align: center;\n'], ['\n    text-align: center;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    background: ', ';\n    padding-top: 0;\n    position: relative;\n    z-index: 1;\n'], ['\n    background: ', ';\n    padding-top: 0;\n    position: relative;\n    z-index: 1;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    text-align: center;\n    font-size: 22px;\n    line-height: 28px;\n    text-transform: uppercase;\n    min-width: 190px;\n    text-align: center;\n\n    strong {\n        font-size: 18px;\n    }\n'], ['\n    text-align: center;\n    font-size: 22px;\n    line-height: 28px;\n    text-transform: uppercase;\n    min-width: 190px;\n    text-align: center;\n\n    strong {\n        font-size: 18px;\n    }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    ul {\n        width: calc(100% - 60px);\n        text-align: center;\n        transform: none;\n    }\n    .title {\n        min-width: 190px !important;\n        display: inline-block;\n        text-align: center;\n    }\n\n    > div {\n        margin-bottom: 0;\n    }\n    .stat-item {\n        background: transparent;\n        margin: 0 1px;\n        font-size: 24px;\n        width: auto;\n    }\n    .stat-item_draw {\n        color: ', ';\n    }\n    .stat-item_win {\n        color: ', ';\n    }\n    .stat-item_loss {\n        color: ', ';\n    }\n'], ['\n    ul {\n        width: calc(100% - 60px);\n        text-align: center;\n        transform: none;\n    }\n    .title {\n        min-width: 190px !important;\n        display: inline-block;\n        text-align: center;\n    }\n\n    > div {\n        margin-bottom: 0;\n    }\n    .stat-item {\n        background: transparent;\n        margin: 0 1px;\n        font-size: 24px;\n        width: auto;\n    }\n    .stat-item_draw {\n        color: ', ';\n    }\n    .stat-item_win {\n        color: ', ';\n    }\n    .stat-item_loss {\n        color: ', ';\n    }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    > div {\n        margin-top: 0;\n    }\n\n    &.__c__b_h2hwrapper {\n        .title {\n            background-color: transparent !important;\n        }\n    }\n'], ['\n    > div {\n        margin-top: 0;\n    }\n\n    &.__c__b_h2hwrapper {\n        .title {\n            background-color: transparent !important;\n        }\n    }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    font-size: 35px;\n    font-weight: bold;\n'], ['\n    font-size: 35px;\n    font-weight: bold;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _DateFormatted = __webpack_require__(1420);
	
	var _DateFormatted2 = _interopRequireDefault(_DateFormatted);
	
	var _H2HTableSimple = __webpack_require__(1452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var Flex = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.content.accentTextColor;
	});
	var LogoWrapper = _styledComponents2.default.div(_templateObject2);
	
	var RowsWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.statTableTextColor;
	}, function (props) {
	    return props.theme.statTableLabelTextColor;
	});
	
	var Status = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.status === 'inprogress' ? 'color: ' + props.theme.positiveColor + ';' : '';
	});
	
	var StatusInner = _styledComponents2.default.div(_templateObject5);
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject6, function (props) {
	    return props.theme.content.backgroundColor;
	});
	var StartInfo = _styledComponents2.default.div(_templateObject7);
	
	var FormWrapper = _styledComponents2.default.div(_templateObject8, function (props) {
	    return props.theme.wdl.draw;
	}, function (props) {
	    return props.theme.wdl.win;
	}, function (props) {
	    return props.theme.wdl.loss;
	});
	
	var H2HWrapper = _styledComponents2.default.div(_templateObject9);
	
	var MatchDate = _styledComponents2.default.div(_templateObject10);
	
	var WrappedRows = function WrappedRows(props) {
	    return _react2.default.createElement(
	        RowsWrapper,
	        { className: '__c__b_rows' },
	        _react2.default.createElement(_H2HTableSimple.Rows, props)
	    );
	};
	
	var WrappedH2H = function WrappedH2H(props) {
	    return _react2.default.createElement(
	        H2HWrapper,
	        { className: '__c__b_h2hwrapper' },
	        _react2.default.createElement(_H2HTableSimple.H2HRow, props)
	    );
	};
	
	var WrapperForm = function WrapperForm(props, ctx) {
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        FormWrapper,
	        null,
	        _react2.default.createElement(_H2HTableSimple.LatestFormRow, _extends({}, props, { title: i18('form', lang) }))
	    );
	};
	
	var Header = function Header(_ref, ctx) {
	    var event = _ref.event,
	        rankInfo = _ref.rankInfo,
	        props = _objectWithoutProperties(_ref, ['event', 'rankInfo']);
	
	    var _event = event,
	        homeShortName = _event.homeShortName,
	        awayShortName = _event.awayShortName,
	        homeId = _event.homeId,
	        awayId = _event.awayId,
	        _event$score = _event.score,
	        home = _event$score.home,
	        away = _event$score.away,
	        statusType = _event.statusType;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	    event = (0, _Eventify2.default)(event);
	    return _react2.default.createElement(
	        HeaderWrapper,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            (event.isLive() || event.isFinished()) && _react2.default.createElement(
	                Status,
	                { status: statusType },
	                _react2.default.createElement(
	                    StatusInner,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 23, lineHeight: '1em', padding: '5px' }, className: '__c__b2_status' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: '__c__c2_status' },
	                            event.isLive() && event.isHT() && i18('ht', lang),
	                            event.isLive() && !event.isHT() && i18('live', lang),
	                            event.isFinished() && i18('finished', lang)
	                        )
	                    ),
	                    event.isLive() && !event.isHT() && _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 20, lineHeight: 1, whiteSpace: 'nowrap' } },
	                        '`',
	                        event.getMinutes(),
	                        ' ',
	                        i18('min', lang),
	                        '.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Flex,
	                null,
	                _react2.default.createElement(
	                    LogoWrapper,
	                    { className: '__c__c1_logo' },
	                    _react2.default.createElement(_SMTeamLogo2.default, { height: 60, fontSize: 42, teamId: homeId, teamShortName: homeShortName }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rank-wrap' },
	                        rankInfo && rankInfo.home && _react2.default.createElement(
	                            'div',
	                            { className: 'rank' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '#',
	                                rankInfo.home.rank
	                            ),
	                            ' (',
	                            rankInfo.home.points,
	                            ' ',
	                            i18('points', lang),
	                            ')'
	                        )
	                    )
	                ),
	                !event.isComming() ? _react2.default.createElement(
	                    'div',
	                    { className: 'score' },
	                    home,
	                    ' - ',
	                    away
	                ) : _react2.default.createElement(
	                    StartInfo,
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        i18('matchstart', lang)
	                    ),
	                    _react2.default.createElement(
	                        MatchDate,
	                        null,
	                        _react2.default.createElement(_DateFormatted2.default, { date: event.startDate, type: 'TIME', el: 'div' })
	                    )
	                ),
	                _react2.default.createElement(
	                    LogoWrapper,
	                    { className: '__c__c1_logo' },
	                    _react2.default.createElement(_SMTeamLogo2.default, { height: 60, fontSize: 42, teamId: awayId, teamShortName: awayShortName }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rank-wrap' },
	                        rankInfo && rankInfo.away && _react2.default.createElement(
	                            'div',
	                            { className: 'rank' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '#',
	                                rankInfo.away.rank
	                            ),
	                            ' (',
	                            rankInfo.away.points,
	                            ' ',
	                            i18('points', lang),
	                            ')'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var HeaderMinimized = Header;
	Header.contextTypes = HeaderMinimized.contextTypes = {
	    info: _propTypes2.default.object,
	    moment: _propTypes2.default.func
	};
	
	exports.default = {
	    Container: _H2HTableSimple.Container,
	    Header: Header,
	    HeaderMinimized: HeaderMinimized,
	    LatestFormRow: WrapperForm,
	    Rows: WrappedRows,
	    H2HRow: WrappedH2H
	};

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    --size-row: ', ';\n    margin-right: 15px;\n\n    table {\n        font-size: ', ';\n        width: 100%;\n        border-collapse: separate;\n        border-spacing: 0 3px;\n\n        .f1-cell-header {\n            &.f1-cell-teamName {\n                span {\n                    font-weight: 400;\n                }\n            }\n            &.f1-cell-comment {\n                text-align: right;\n            }\n        }\n    }\n\n    ', ';\n'], ['\n    --size-row: ', ';\n    margin-right: 15px;\n\n    table {\n        font-size: ', ';\n        width: 100%;\n        border-collapse: separate;\n        border-spacing: 0 3px;\n\n        .f1-cell-header {\n            &.f1-cell-teamName {\n                span {\n                    font-weight: 400;\n                }\n            }\n            &.f1-cell-comment {\n                text-align: right;\n            }\n        }\n    }\n\n    ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    height: var(--size-row);\n    line-height: var(--size-row);\n    display: block;\n    padding: 0 15px;\n    text-align: ', ';\n    color: ', ';\n    &:before {\n        transform: skew(-15deg);\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: -1px;\n        top: 0px;\n        bottom: 0px;\n        right: -1px;\n        background: ', ';\n        z-index: -1;\n    }\n    img {\n        height: var(--size-row);\n    }\n'], ['\n    position: relative;\n    height: var(--size-row);\n    line-height: var(--size-row);\n    display: block;\n    padding: 0 15px;\n    text-align: ', ';\n    color: ', ';\n    &:before {\n        transform: skew(-15deg);\n        z-index: 1;\n        position: absolute;\n        content: \'\';\n        left: -1px;\n        top: 0px;\n        bottom: 0px;\n        right: -1px;\n        background: ', ';\n        z-index: -1;\n    }\n    img {\n        height: var(--size-row);\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    &:before {\n        background: ', ';\n    }\n'], ['\n    color: ', ';\n    &:before {\n        background: ', ';\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    min-width: 75px;\n    text-align: center;\n    color: ', ';\n    font-weight: bold;\n    span {\n        position: relative;\n        margin-left: 14px;\n        &::after {\n            content: \'\';\n            position: absolute;\n            content: \'\';\n            left: -14px;\n            top: 50%;\n            transform: translateY(-50%);\n            width: 0;\n            height: 0;\n\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 8px solid ', ';\n        }\n    }\n\n    &.f1-pos-down {\n        color: ', ';\n        span::after {\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 0px solid transparent;\n            border-top: 8px solid ', ';\n        }\n    }\n    &.f1-pos-zero {\n        color: ', ';\n        span::after {\n            border-left: 0 solid transparent;\n            border-right: 8px solid ', ';\n            border-bottom: 5px solid transparent;\n            border-top: 5px solid transparent;\n        }\n    }\n'], ['\n    min-width: 75px;\n    text-align: center;\n    color: ', ';\n    font-weight: bold;\n    span {\n        position: relative;\n        margin-left: 14px;\n        &::after {\n            content: \'\';\n            position: absolute;\n            content: \'\';\n            left: -14px;\n            top: 50%;\n            transform: translateY(-50%);\n            width: 0;\n            height: 0;\n\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 8px solid ', ';\n        }\n    }\n\n    &.f1-pos-down {\n        color: ', ';\n        span::after {\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 0px solid transparent;\n            border-top: 8px solid ', ';\n        }\n    }\n    &.f1-pos-zero {\n        color: ', ';\n        span::after {\n            border-left: 0 solid transparent;\n            border-right: 8px solid ', ';\n            border-bottom: 5px solid transparent;\n            border-top: 5px solid transparent;\n        }\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n\n    padding: 0;\n\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    color: ', ';\n\n    td {\n        margin: 0;\n        margin-bottom: 2px;\n        line-height: var(--size-row);\n        padding: 0px;\n        font-style: italic; \n        white-space: nowrap;\n    }\n    .f1-cell-pos span {\n        padding: 0 5px;\n    }\n    .f1-cell-name,\n    .f1-cell-teamName,\n    .f1-cell-driverName {\n        width: 100%;\n    }\n    .f1-cell-teamName {\n        span {\n            font-weight: bold;\n        }\n    }\n    .f1-cell-pits {\n        width: 60px;\n        max-width: 60px;\n    }   \n    .f1-cell-pos {\n        width: 40px;\n        .f1-pos {\n            z-index: 5;\n            \n            &:after {\n                transform: skew(-15deg);\n                z-index: 1;\n                position: absolute;\n                content: \'\';\n                width: 5px;\n                top: 0px;\n                bottom: 0px;\n                right: -5px;\n                background: ', ';\n                z-index: -1;\n            }\n        }\n    }\n    .f1-cell-pits,\n    .f1-cell-points,\n    .f1-cell-rank {\n        width: 40px;\n        .f1-pits,\n        .f1-points,\n        .f1-rank {\n            z-index: 5;\n            &:after {\n                transform: skew(-15deg);\n                z-index: 1;\n                position: absolute;\n                content: \'\';\n                width: 5px;\n                top: 0px;\n                bottom: 0px;\n                right: -5px;\n                background: ', ';\n                z-index: -1;\n            }\n        }\n    }\n\n    .f1-cell-pits,\n    .f1-cell-points {\n        .f1-pits,\n        .f1-points {\n            &:after {\n                right: auto;\n                left: -5px;\n            }\n        }\n    }\n    \n    .f1-qual {\n        padding-left: 0;\n        text-align: left;\n        min-width: 120px\n    }\n    \n    .f1-qual-q {\n        display: inline-block;\n        padding: 0 5px;\n        margin: 0 5px;\n        position: relative;\n        &:after {\n            text-align: center;\n            z-index: 1;\n            position: absolute;\n            content: attr(data-text);\n            left: 0px;\n            top: 0px;\n            bottom: 0px;\n            right: 0px;\n            line-height: var(--size-row);\n            color: #fff;\n        }\n        &:before {\n            transform: skew(-15deg);\n            z-index: 1;\n            position: absolute;\n            content: \'\';\n            left: 0px;\n            top: 0px;\n            bottom: 0px;\n            right: 0px;\n            color: #fff;\n            \n        }\n        &.f1-qual-q1:before {\n            background: #00acac;\n        }\n        &.f1-qual-q2:before {\n            background: #221248;\n        }\n        &.f1-qual-q3:before {\n            background: #f61216;\n        }\n    }\n    .f1-cell-tyre {\n        & > span {\n            display: flex;\n            align-items: center;\n            .tyre-symb {\n                padding 0 5px;\n            }\n        }\n        \n    }\n    .f1-cell-bolid {\n        min-width: 250px;\n    }\n\n    .f1-empty {\n        display: none;\n        background: transparent;\n    }\n\n    .f1-cell-driverNumber {\n        width: 45px;\n\n        span {\n            padding-right: 0;\n        }\n    }\n'], ['\n    position: relative;\n\n    padding: 0;\n\n    align-items: center;\n    z-index: 2;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    color: ', ';\n\n    td {\n        margin: 0;\n        margin-bottom: 2px;\n        line-height: var(--size-row);\n        padding: 0px;\n        font-style: italic; \n        white-space: nowrap;\n    }\n    .f1-cell-pos span {\n        padding: 0 5px;\n    }\n    .f1-cell-name,\n    .f1-cell-teamName,\n    .f1-cell-driverName {\n        width: 100%;\n    }\n    .f1-cell-teamName {\n        span {\n            font-weight: bold;\n        }\n    }\n    .f1-cell-pits {\n        width: 60px;\n        max-width: 60px;\n    }   \n    .f1-cell-pos {\n        width: 40px;\n        .f1-pos {\n            z-index: 5;\n            \n            &:after {\n                transform: skew(-15deg);\n                z-index: 1;\n                position: absolute;\n                content: \'\';\n                width: 5px;\n                top: 0px;\n                bottom: 0px;\n                right: -5px;\n                background: ', ';\n                z-index: -1;\n            }\n        }\n    }\n    .f1-cell-pits,\n    .f1-cell-points,\n    .f1-cell-rank {\n        width: 40px;\n        .f1-pits,\n        .f1-points,\n        .f1-rank {\n            z-index: 5;\n            &:after {\n                transform: skew(-15deg);\n                z-index: 1;\n                position: absolute;\n                content: \'\';\n                width: 5px;\n                top: 0px;\n                bottom: 0px;\n                right: -5px;\n                background: ', ';\n                z-index: -1;\n            }\n        }\n    }\n\n    .f1-cell-pits,\n    .f1-cell-points {\n        .f1-pits,\n        .f1-points {\n            &:after {\n                right: auto;\n                left: -5px;\n            }\n        }\n    }\n    \n    .f1-qual {\n        padding-left: 0;\n        text-align: left;\n        min-width: 120px\n    }\n    \n    .f1-qual-q {\n        display: inline-block;\n        padding: 0 5px;\n        margin: 0 5px;\n        position: relative;\n        &:after {\n            text-align: center;\n            z-index: 1;\n            position: absolute;\n            content: attr(data-text);\n            left: 0px;\n            top: 0px;\n            bottom: 0px;\n            right: 0px;\n            line-height: var(--size-row);\n            color: #fff;\n        }\n        &:before {\n            transform: skew(-15deg);\n            z-index: 1;\n            position: absolute;\n            content: \'\';\n            left: 0px;\n            top: 0px;\n            bottom: 0px;\n            right: 0px;\n            color: #fff;\n            \n        }\n        &.f1-qual-q1:before {\n            background: #00acac;\n        }\n        &.f1-qual-q2:before {\n            background: #221248;\n        }\n        &.f1-qual-q3:before {\n            background: #f61216;\n        }\n    }\n    .f1-cell-tyre {\n        & > span {\n            display: flex;\n            align-items: center;\n            .tyre-symb {\n                padding 0 5px;\n            }\n        }\n        \n    }\n    .f1-cell-bolid {\n        min-width: 250px;\n    }\n\n    .f1-empty {\n        display: none;\n        background: transparent;\n    }\n\n    .f1-cell-driverNumber {\n        width: 45px;\n\n        span {\n            padding-right: 0;\n        }\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    td span {\n        color: ', ';\n        &:before {\n            background: ', ';\n        }\n    }\n    .f1-cell-rank {\n        .f1-rank {\n            &:before {\n                border-right: 4px solid ', ';\n            }\n        }\n    }\n    .f1-cell-pos {\n        .f1-pos {\n            &:before {\n                border-right: 4px solid ', ';\n            }\n        }\n    }\n'], ['\n    td span {\n        color: ', ';\n        &:before {\n            background: ', ';\n        }\n    }\n    .f1-cell-rank {\n        .f1-rank {\n            &:before {\n                border-right: 4px solid ', ';\n            }\n        }\n    }\n    .f1-cell-pos {\n        .f1-pos {\n            &:before {\n                border-right: 4px solid ', ';\n            }\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _TeamColorProfile = __webpack_require__(1361);
	
	var _NumberForDriver = __webpack_require__(1457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	//These lines are needed to get common i18
	var i18Common = __webpack_require__(1378);
	var i18 = _RCore2.default.getTranslation.bind({ dict: i18Common });
	
	var SkewContainer = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.display === 'large' ? '44px' : '27px';
	}, function (props) {
	    return props.display === 'large' ? '30px' : '16px';
	}, function (props) {
	    return props.display === 'large' && '* {text-transform: none}';
	});
	
	var Cell = _styledComponents2.default.span(_templateObject2, function (props) {
	    return props.textAlign || 'center';
	}, function (props) {
	    return props.theme.f1.tableTextColor;
	}, function (props) {
	    return props.theme.f1.tableBgColor;
	});
	
	var DarkCell = Cell.extend(_templateObject3, function (props) {
	    return props.theme.f1.headerTextColor;
	}, function (props) {
	    return props.theme.f1.headerBgColor;
	});
	
	var LiveCell = Cell.extend(_templateObject3, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return props.theme.positiveColor;
	});
	
	var HighCell = Cell.extend(_templateObject3, function (props) {
	    return props.theme.f1.primaryTextColor;
	}, function (props) {
	    return props.theme.f1.primaryColor;
	});
	
	var DiffCell = Cell.extend(_templateObject4, function (props) {
	    return props.theme.positiveColor;
	}, function (props) {
	    return props.theme.positiveColor;
	}, function (props) {
	    return props.theme.negativeColor;
	}, function (props) {
	    return props.theme.negativeColor;
	}, function (props) {
	    return props.theme.f1.tableTextColor;
	}, function (props) {
	    return props.theme.f1.tableTextColor;
	});
	
	var F1Row = _styledComponents2.default.tr(_templateObject5, function (props) {
	    return props.theme.color;
	}, function (props) {
	    return (0, _TeamColorProfile.colorForTeam)(props.team, 'color');
	}, function (props) {
	    return (0, _TeamColorProfile.colorForTeam)(props.team, 'color');
	});
	
	var HeaderRow = F1Row.extend(_templateObject6, function (props) {
	    return props.theme.f1.headerTextColor;
	}, function (props) {
	    return props.theme.f1.headerBgColor;
	}, function (props) {
	    return props.theme.f1.headerBgColor;
	}, function (props) {
	    return props.theme.f1.headerBgColor;
	});
	var renderVal = function renderVal(key, value, obj) {
	    switch (key) {
	        case 'gpPoints':
	            {
	                if (value === 0) return _react2.default.createElement(Cell, { className: 'f1-empty' });
	                return _react2.default.createElement(
	                    HighCell,
	                    { className: 'f1-' + key },
	                    value
	                );
	            }
	        case 'out':
	            return _react2.default.createElement(
	                HighCell,
	                { className: 'f1-' + key },
	                value
	            );
	        case 'rank':
	        case 'pits':
	        case 'points':
	            return _react2.default.createElement(
	                DarkCell,
	                { className: 'f1-' + key },
	                value
	            );
	        case 'driverNumber':
	            return _react2.default.createElement(
	                Cell,
	                { className: 'f1-' + key },
	                (0, _NumberForDriver.numberForDriver)(value.shortName, value.year)
	            );
	        case 'pos':
	            return obj.out ? _react2.default.createElement(
	                HighCell,
	                { className: 'f1-' + key },
	                value
	            ) : _react2.default.createElement(
	                DarkCell,
	                { className: 'f1-' + key },
	                value
	            );
	        case 'comment':
	        case 'time':
	        case 'gap':
	            return _react2.default.createElement(
	                Cell,
	                { className: 'f1-' + key, textAlign: 'right' },
	                value
	            );
	        case 'teamShortName':
	        case 'teamName':
	            {
	                return _react2.default.createElement(
	                    Cell,
	                    { className: 'f1-' + key, textAlign: 'left' },
	                    value
	                );
	            }
	        case 'name':
	        case 'driverName':
	            {
	                var name = _RCore2.default.getFirstLastName(value);
	                return _react2.default.createElement(
	                    Cell,
	                    { className: 'f1-' + key, textAlign: 'left' },
	                    name.firstName,
	                    ' ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        name.lastName
	                    )
	                );
	            }
	        case 'in_pit':
	            return value !== 'YES' ? _react2.default.createElement(
	                LiveCell,
	                { className: 'f1-' + key + ' f1-' + key + '-' + value },
	                'ON TRACK'
	            ) : _react2.default.createElement(
	                HighCell,
	                null,
	                'INPIT'
	            );
	
	        case 'q1':
	        case 'q2':
	        case 'q3':
	            return _react2.default.createElement(
	                Cell,
	                { className: 'f1-qual ' + key },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'f1-qual-q f1-qual-' + key, 'data-text': key },
	                    key
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'f1-qual-time' },
	                    value
	                )
	            );
	        case 'posChange':
	        case 'diff':
	            {
	                if (value === 0) return _react2.default.createElement(
	                    DiffCell,
	                    { className: 'f1-pos-zero' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        value
	                    )
	                );
	                if (value < 0) return _react2.default.createElement(
	                    DiffCell,
	                    { className: 'f1-pos-down' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        value
	                    )
	                );
	                if (value > 0) return _react2.default.createElement(
	                    DiffCell,
	                    { className: 'f1-pos-up' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '+',
	                        value
	                    )
	                );
	                if (!value) return;
	            }
	        case 'bolid':
	            return _react2.default.createElement(
	                Cell,
	                { textAlign: 'right' },
	                _react2.default.createElement('img', { src: 'http://cdn.tjekscores.dk/f1/cars/' + value + '_rev.png', alt: value, height: '27' })
	            );
	
	        case 'tyre':
	            {
	                return value ? _react2.default.createElement(
	                    Cell,
	                    null,
	                    _react2.default.createElement('img', { height: '22px', src: _cfg2.default.cdn.cdnUrl + '/f1/tyre-types/' + value + '.png', alt: '' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'tyre-symb' },
	                        value
	                    )
	                ) : null;
	            }
	        default:
	            return _react2.default.createElement(
	                Cell,
	                null,
	                value
	            );
	    }
	};
	
	var renderHeader = function renderHeader(key, value) {
	    switch (key) {
	        case 'gap':
	        case 'time':
	            return _react2.default.createElement(
	                Cell,
	                { className: 'f1-' + key, textAlign: 'right' },
	                value
	            );
	        case 'name':
	        case 'teamShortName':
	        case 'teamName':
	        case 'driverName':
	            {
	                return _react2.default.createElement(
	                    Cell,
	                    { className: 'f1-' + key, textAlign: 'left' },
	                    value
	                );
	            }
	        default:
	            return _react2.default.createElement(
	                DarkCell,
	                null,
	                value
	            );
	    }
	};
	
	var Header = function Header(_ref, ctx) {
	    var spec = _ref.spec;
	
	    var lang = _lodash2.default.get(ctx, 'info.lang', 'en');
	
	    return _react2.default.createElement(
	        HeaderRow,
	        null,
	        spec.map(function (key) {
	            if (key === 'end') return _react2.default.createElement(
	                'td',
	                { key: key, className: 'f1-cell-end' },
	                _react2.default.createElement('span', null)
	            );
	            return _react2.default.createElement(
	                'td',
	                { key: key, className: 'f1-cell-' + key + ' f1-cell-header' },
	                renderHeader(key, i18('f1.table.' + key, lang))
	            );
	        })
	    );
	};
	
	var Row = function Row(_ref2) {
	    var driver = _ref2.driver,
	        spec = _ref2.spec,
	        props = _objectWithoutProperties(_ref2, ['driver', 'spec']);
	
	    var values = driver || props.values || props.rowData;
	
	    return _react2.default.createElement(
	        F1Row,
	        _extends({
	            key: values.id,
	            className: 'f1-team-' + values['teamShortName'],
	            team: values['teamShortName']
	        }, props),
	        spec.map(function (key) {
	            if (values[key] === 'empty') return _react2.default.createElement('td', { key: key, className: 'f1-empty' });
	            if (key === 'end') return _react2.default.createElement(
	                'td',
	                { key: key, className: 'f1-cell-end' },
	                _react2.default.createElement('span', null)
	            );
	            return _react2.default.createElement(
	                'td',
	                { key: key, className: 'f1-cell-' + key },
	                renderVal(key, values[key], values)
	            );
	        })
	    );
	};
	
	var HrRow = function HrRow(_ref3) {
	    var length = _ref3.length;
	    return _react2.default.createElement(
	        'tr',
	        { key: 'elimination' },
	        _react2.default.createElement(
	            'td',
	            { colSpan: length },
	            _react2.default.createElement('div', {
	                style: {
	                    height: '5px',
	                    backgroundColor: 'red'
	                }
	            })
	        )
	    );
	};
	
	Header.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var Container = function Container(_ref4) {
	    var children = _ref4.children,
	        display = _ref4.display;
	    return _react2.default.createElement(
	        SkewContainer,
	        { display: display },
	        _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	                'tbody',
	                null,
	                children
	            )
	        )
	    );
	};
	
	exports.default = { Header: Header, Row: Row, HrRow: HrRow, Container: Container };

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.numberForDriver = undefined;
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NumberDriver = {};
	
	NumberDriver.driverVET = { '2018': 5 };
	NumberDriver.driverRAI = { '2018': 7 };
	NumberDriver.driverERI = { '2018': 9 };
	NumberDriver.driverVES = { '2018': 33 };
	NumberDriver.driverSAI = { '2018': 55 };
	NumberDriver.driverRIC = { '2018': 3 };
	NumberDriver.driverBOT = { '2018': 77 };
	NumberDriver.driverHAM = { '2018': 44 };
	NumberDriver.driverVAN = { '2018': 2 };
	NumberDriver.driverALO = { '2018': 14 };
	NumberDriver.driverGAS = { '2018': 10 };
	NumberDriver.driverHAR = { '2018': 28 };
	NumberDriver.driverSIR = { '2018': 35 };
	NumberDriver.driverSTL = { '2018': 18 };
	NumberDriver.driverGRO = { '2018': 8 };
	NumberDriver.driverLEC = { '2018': 16 };
	NumberDriver.driverMAG = { '2018': 20 };
	NumberDriver.driverHUL = { '2018': 27 };
	NumberDriver.driverOCO = { '2018': 31 };
	NumberDriver.driverPER = { '2018': 11 };
	
	var numberForDriver = function numberForDriver(shortName, year) {
	    var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    return _lodash2.default.get(NumberDriver, 'driver' + shortName + '.' + year, def);
	};
	
	exports.default = NumberDriver;
	exports.numberForDriver = numberForDriver;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    padding-left: 0;\n    font-size: 20px;\n    font-weight: 400;\n    font-style: italic;\n    line-height: 1.2;\n    letter-spacing: 0;\n    list-style: none;\n'], ['\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    padding-left: 0;\n    font-size: 20px;\n    font-weight: 400;\n    font-style: italic;\n    line-height: 1.2;\n    letter-spacing: 0;\n    list-style: none;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    --angle-clip: 10px;\n    --clip: polygon(var(--angle-clip) 0, 100% 0, calc(100% - var(--angle-clip)) 100%, 0 100%);\n\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    margin-bottom: 3px;\n    \n    > * {\n        padding: 3px 15px 0;\n        clip-path: var(--clip);\n        color: ', ';\n        background-color: ', ';\n        \n        :last-child {\n            padding-right: 15px;\n        }\n    }\n\n    > * + * {\n        margin-left: calc(0px - var(--angle-clip));\n    }\n'], ['\n    --angle-clip: 10px;\n    --clip: polygon(var(--angle-clip) 0, 100% 0, calc(100% - var(--angle-clip)) 100%, 0 100%);\n\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    margin-bottom: 3px;\n    \n    > * {\n        padding: 3px 15px 0;\n        clip-path: var(--clip);\n        color: ', ';\n        background-color: ', ';\n        \n        :last-child {\n            padding-right: 15px;\n        }\n    }\n\n    > * + * {\n        margin-left: calc(0px - var(--angle-clip));\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    min-width: ', ';\n    display: inline-block;\n    ', ';\n    ', ';\n    padding-right: ', ';\n    padding-left: ', ';\n    font-weight: 700;\n    text-align: ', ';\n    color: ', ';\n    background-color: transparent;\n    box-sizing: border-box;\n    ', '\n\n    ::before {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      z-index: -2;\n      clip-path: var(--clip);\n      background-color: ', ';\n    }\n\n    ::after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        ', ';\n        z-index: -1;\n        width: 15px;\n        height: 100%;\n        display: ', ';\n        background-color: ', ';\n        clip-path: var(--clip);\n    }\n'], ['\n    position: relative;\n    min-width: ', ';\n    display: inline-block;\n    ', ';\n    ', ';\n    padding-right: ', ';\n    padding-left: ', ';\n    font-weight: 700;\n    text-align: ', ';\n    color: ', ';\n    background-color: transparent;\n    box-sizing: border-box;\n    ', '\n\n    ::before {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      z-index: -2;\n      clip-path: var(--clip);\n      background-color: ', ';\n    }\n\n    ::after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        ', ';\n        z-index: -1;\n        width: 15px;\n        height: 100%;\n        display: ', ';\n        background-color: ', ';\n        clip-path: var(--clip);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    font-weight: 400;\n\n    ::before {\n      background-color: ', ';\n    }\n'], ['\n    font-weight: 400;\n\n    ::before {\n      background-color: ', ';\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    padding-right: ', ';\n    padding-left: ', ';\n    flex-grow: 1;\n    text-align: ', ';\n'], ['\n    padding-right: ', ';\n    padding-left: ', ';\n    flex-grow: 1;\n    text-align: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    position: relative;\n    min-width: ', ';\n    display: inline-block;\n    font-weight: 700;\n    text-align: center;\n    box-sizing: border-box;\n\n    ::after {\n        content: \'\';\n        width: 0;\n        height: 0;\n        display: inline-block;\n        margin-left: 7px;\n        border-style: solid;\n    }\n    \n    ', ';\n\n    ', '\n'], ['\n    position: relative;\n    min-width: ', ';\n    display: inline-block;\n    font-weight: 700;\n    text-align: center;\n    box-sizing: border-box;\n\n    ::after {\n        content: \'\';\n        width: 0;\n        height: 0;\n        display: inline-block;\n        margin-left: 7px;\n        border-style: solid;\n    }\n    \n    ', ';\n\n    ', '\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    padding-top: 3px;\n    padding-right: ', ';\n    padding-bottom: 3px;\n    padding-left: ', ';\n\n    img {\n        max-width: 100%;\n        height: auto;\n    }\n'], ['\n    padding-top: 3px;\n    padding-right: ', ';\n    padding-bottom: 3px;\n    padding-left: ', ';\n\n    img {\n        max-width: 100%;\n        height: auto;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _TeamColorProfile = __webpack_require__(1361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var F1List = _styledComponents2.default.ul(_templateObject);
	
	var RowContentWrapper = _styledComponents2.default.li(_templateObject2, function (props) {
	    return props.theme.f1.tableTextColor;
	}, function (props) {
	    return props.theme.f1.tableBgColor;
	});
	
	var Count = _styledComponents2.default.span(_templateObject3, function (props) {
	    return props.minWidth || '56px';
	}, function (props) {
	    return props.posBadge === 'right' && 'padding-right: 20px;';
	}, function (props) {
	    return props.hasBadge && props.posBadge !== 'right' && 'padding-left: 20px;';
	}, function (props) {
	    return props.innerOffsetRight;
	}, function (props) {
	    return props.innerOffsetLeft;
	}, function (props) {
	    return props.textAlign || 'center';
	}, function (props) {
	    return props.theme.f1.headerTextColor;
	}, function (props) {
	    return props.hasVisuality === undefined || props.hasVisuality ? '' : 'opacity: 0;';
	}, function (props) {
	    return props.theme.f1.headerBgColor;
	}, function (props) {
	    return props.posBadge === 'right' ? 'right: 0;' : 'left: 0;';
	}, function (props) {
	    return props.hasBadge === true ? 'block' : 'none';
	}, function (props) {
	    return (0, _TeamColorProfile.colorForTeam)(props.team, 'color');
	});
	
	var CountPrimary = Count.extend(_templateObject4, function (props) {
	    return props.theme.f1.primaryColor;
	});
	
	var Text = _styledComponents2.default.span(_templateObject5, function (props) {
	    return props.innerOffsetRight;
	}, function (props) {
	    return props.innerOffsetLeft;
	}, function (props) {
	    return props.textAlign || 'left';
	});
	
	var Diff = _styledComponents2.default.span(_templateObject6, function (props) {
	    return props.minWidth || '56px';
	}, function (props) {
	    return props.hasDiff === 0 && '\n        font-size: 0;\n        \n        ::after {\n            display: none;\n        }\n    ';
	}, function (props) {
	    return props.hasDiff > 0 ? '\n        color: #25c100;\n\n        ::before {\n            content: \'+\';\n        }\n\n        ::after {\n            border-width: 0 6px 12px 6px;\n            border-color: transparent transparent #25c100 transparent;\n        }\n    ' : '\n        color: #dc0000;\n\n        ::after {\n            border-width: 12px 6px 0 6px;\n            border-color: #dc0000 transparent transparent transparent;\n        }\n    ';
	});
	
	var IconCarWrapper = _styledComponents2.default.div(_templateObject7, function (props) {
	    return props.innerOffsetRight;
	}, function (props) {
	    return props.innerOffsetLeft;
	});
	
	var StandingsRowDriver = function StandingsRowDriver(_ref) {
	    var rowData = _ref.rowData;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.participantId },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, posBadge: 'right', hasBadge: true },
	            rowData.rank
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            rowData.name
	        ),
	        _react2.default.createElement(
	            Text,
	            { textAlign: 'right' },
	            rowData.teamName
	        ),
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, textAlign: 'right', minWidth: '85px', hasBadge: true },
	            rowData.points
	        )
	    );
	};
	
	var StandingsRowTeam = function StandingsRowTeam(_ref2) {
	    var rowData = _ref2.rowData;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.id },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.shortName, posBadge: 'right', hasBadge: true },
	            rowData.rank
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                rowData.name
	            )
	        ),
	        _react2.default.createElement(
	            IconCarWrapper,
	            null,
	            _react2.default.createElement('img', { src: 'http://cdn.tjekscores.dk/f1/cars/' + rowData.teamShortName + '.png', alt: rowData.teamShortName, width: '84', height: '21' })
	        ),
	        _react2.default.createElement(
	            Count,
	            { team: rowData.shortName, textAlign: 'right', minWidth: '85px', hasBadge: true },
	            rowData.points
	        )
	    );
	};
	
	var AfterRaceRowDriver = function AfterRaceRowDriver(_ref3) {
	    var rowData = _ref3.rowData,
	        pos = _ref3.pos;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.pos },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, posBadge: 'right', hasBadge: true },
	            pos
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            rowData.driverName
	        ),
	        _react2.default.createElement(
	            Text,
	            { textAlign: 'right' },
	            rowData.teamName
	        ),
	        _react2.default.createElement(
	            CountPrimary,
	            { team: rowData.teamShortName, minWidth: '65px', hasBadge: true },
	            rowData.gpPoints > 0 ? '+' : null,
	            rowData.gpPoints
	        )
	    );
	};
	
	var AfterRaceRowTeam = function AfterRaceRowTeam(_ref4) {
	    var rowData = _ref4.rowData,
	        pos = _ref4.pos;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.pos },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, posBadge: 'right', hasBadge: true },
	            pos
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                rowData.teamName
	            )
	        ),
	        _react2.default.createElement(
	            IconCarWrapper,
	            null,
	            _react2.default.createElement('img', { src: 'http://cdn.tjekscores.dk/f1/cars/' + rowData.teamShortName + '.png', alt: rowData.teamShortName, width: '84', height: '21' })
	        ),
	        _react2.default.createElement(
	            CountPrimary,
	            { team: rowData.teamShortName, minWidth: '65px', hasBadge: true },
	            rowData.gpPoints > 0 ? '+' : null,
	            rowData.gpPoints
	        )
	    );
	};
	
	var StandingsAfterRaceRowDriver = function StandingsAfterRaceRowDriver(_ref5) {
	    var rowData = _ref5.rowData;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.pos },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, posBadge: 'right', hasBadge: true },
	            rowData.pos
	        ),
	        _react2.default.createElement(
	            Diff,
	            { minWidth: '75px', hasDiff: rowData.posChange },
	            rowData.posChange
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            rowData.driverName
	        ),
	        _react2.default.createElement(
	            Text,
	            { textAlign: 'right', innerOffsetRight: '45px' },
	            rowData.teamName
	        ),
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, minWidth: '85px', hasBadge: true },
	            rowData.points
	        ),
	        _react2.default.createElement(
	            CountPrimary,
	            { team: rowData.teamShortName, minWidth: '64px', hasVisuality: rowData.gpPoints !== 0 },
	            rowData.gpPoints > 0 ? '+' : null,
	            rowData.gpPoints
	        )
	    );
	};
	
	var StandingsAfterRaceRowTeam = function StandingsAfterRaceRowTeam(_ref6) {
	    var rowData = _ref6.rowData;
	    return _react2.default.createElement(
	        RowContentWrapper,
	        { key: rowData.pos },
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, posBadge: 'right', hasBadge: true },
	            rowData.pos
	        ),
	        _react2.default.createElement(
	            Diff,
	            { minWidth: '75px', hasDiff: rowData.posChange },
	            rowData.posChange
	        ),
	        _react2.default.createElement(
	            Text,
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                rowData.teamName
	            )
	        ),
	        _react2.default.createElement(
	            IconCarWrapper,
	            null,
	            _react2.default.createElement('img', { src: 'http://cdn.tjekscores.dk/f1/cars/' + rowData.teamShortName + '.png', alt: rowData.teamShortName, width: '84', height: '21' })
	        ),
	        _react2.default.createElement(
	            Count,
	            { team: rowData.teamShortName, minWidth: '85px', hasBadge: true },
	            rowData.points
	        ),
	        _react2.default.createElement(
	            CountPrimary,
	            { team: rowData.teamShortName, minWidth: '64px', hasVisuality: rowData.gpPoints !== 0 },
	            rowData.gpPoints > 0 ? '+' : null,
	            rowData.gpPoints
	        )
	    );
	};
	
	var renderValRow = function renderValRow(key, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var teamShortName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    switch (key) {
	        case 'pos':
	        case 'rank':
	        case 'points':
	            return _react2.default.createElement(
	                Count,
	                { key: key + Math.random(), team: teamShortName, posBadge: options.posBadge || options.posBadge === undefined && (key === 'pos' || key === 'rank') ? 'right' : '', minWidth: options.minWidth || '56px', textAlign: options.textRight === undefined || options.textRight ? 'right' : '', innerOffsetRight: options.innerOffsetRight || '', innerOffsetLeft: options.innerOffsetLeft || '', hasBadge: true },
	                options.value || value
	            );
	        case 'name':
	        case 'driverName':
	        case 'teamName':
	            return _react2.default.createElement(
	                Text,
	                { key: key + Math.random(), textAlign: options.textRight ? 'right' : '', innerOffsetRight: options.innerOffsetRight || '', innerOffsetLeft: options.innerOffsetLeft || '' },
	                options.strong ? _react2.default.createElement(
	                    'strong',
	                    null,
	                    value
	                ) : value
	            );
	        case 'shortName':
	        case 'teamShortName':
	            return _react2.default.createElement(
	                IconCarWrapper,
	                { key: key + Math.random(), innerOffsetRight: options.innerOffsetRight || '', innerOffsetLeft: options.innerOffsetLeft || '' },
	                _react2.default.createElement('img', { src: 'http://cdn.tjekscores.dk/f1/cars/' + value + '.png', alt: value, width: '84', height: '21' })
	            );
	        case 'gpPoints':
	            return _react2.default.createElement(
	                CountPrimary,
	                { key: key + Math.random(), team: teamShortName, minWidth: options.minWidth || '64px', hasBadge: options.hasBadge, hasVisuality: options.hasVisuality || value !== 0, textAlign: options.textRight === undefined || options.textRight ? 'right' : '' },
	                value > 0 ? '+' : null,
	                value
	            );
	        case 'posChange':
	            return _react2.default.createElement(
	                Diff,
	                { key: key + Math.random(), minWidth: options.minWidth || '75px', hasDiff: value },
	                value
	            );
	        default:
	            return value;
	    }
	};
	
	var Row = function Row(props) {
	    var _props$rowData = props.rowData,
	        rowData = _props$rowData === undefined ? {} : _props$rowData,
	        _props$spec = props.spec,
	        spec = _props$spec === undefined ? [] : _props$spec;
	
	
	    return _react2.default.createElement(
	        RowContentWrapper,
	        null,
	        spec.map(function (key) {
	            return renderValRow(key, rowData[key], props[key], rowData.teamShortName || rowData.shortName);
	        })
	    );
	};
	
	Row.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	var Container = function Container(_ref7) {
	    var children = _ref7.children;
	    return _react2.default.createElement(
	        F1List,
	        null,
	        children
	    );
	};
	
	exports.default = { Container: Container, Row: Row };

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    text-align: center;\n    background-color: ', ';\n    padding: 30px 0;\n    box-sizing: border-box;\n    overflow: visible;\n'], ['\n    text-align: center;\n    background-color: ', ';\n    padding: 30px 0;\n    box-sizing: border-box;\n    overflow: visible;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _H2HTableSimple = __webpack_require__(1452);
	
	var _SVGRadarChart = __webpack_require__(1460);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var RadarChartWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.statTableBgColor;
	});
	
	var Rows = function Rows(_ref) {
	    var dataset = _ref.dataset,
	        chartHeight = _ref.chartHeight,
	        isAxesLines = _ref.isAxesLines,
	        isAxesDots = _ref.isAxesDots,
	        isScaleLines = _ref.isScaleLines,
	        isDashedCircle = _ref.isDashedCircle,
	        isH2H = _ref.isH2H;
	
	    return _react2.default.createElement(
	        RadarChartWrapper,
	        null,
	        _react2.default.createElement(_SVGRadarChart.SVGRadarChart, {
	            stats: dataset,
	            chartHeight: chartHeight,
	            isAxesLines: isAxesLines,
	            isAxesDots: isAxesDots,
	            isScaleLines: isScaleLines,
	            isDashedCircle: isDashedCircle,
	            isH2H: isH2H,
	            colorScheme: 'statsTable'
	        })
	    );
	};
	
	exports.default = { Container: _H2HTableSimple.Container, Header: _H2HTableSimple.Header, HeaderMinimized: _H2HTableSimple.HeaderMinimized, LatestFormRow: _H2HTableSimple.LatestFormRow, Rows: Rows, H2HRow: _H2HTableSimple.H2HRow };

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SVGRadarChart = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    text-align: center;\n    overflow: visible !important;\n\n    svg {\n        width: 100%;\n        overflow: visible;\n        padding: 10px 0 0;\n        //hyphens: auto;\n\n        .grid {\n            polygon:nth-child(1) {\n                stroke: transparent;\n                fill: ', ';\n            }\n        }\n    }\n\n    .dashed-circle {\n        stroke-dasharray: 5px;\n        stroke: currentcolor;\n        fill: none;\n    }\n\n    .circle {\n        fill: #fff;\n\n        &__chart-opponent1 {\n            fill: ', ';\n        }\n\n        &__chart-opponent2 {\n            fill: ', ';\n        }\n\n        &__chart-opponent3 {\n            fill: ', ';\n        }\n    }\n\n    line {\n        stroke: ', ';\n    }\n\n    .label {\n        fill: ', ';\n        font-size: 20px;\n        font-weight: ', ';\n\n        &__opponent1 {\n            fill: ', ';\n            text-transform: none;\n        }\n\n        &__opponent2 {\n            fill: ', ';\n            text-transform: none;\n        }\n\n        &__opponent3 {\n            fill: ', ';\n            text-transform: none;\n        }\n    }\n'], ['\n    text-align: center;\n    overflow: visible !important;\n\n    svg {\n        width: 100%;\n        overflow: visible;\n        padding: 10px 0 0;\n        //hyphens: auto;\n\n        .grid {\n            polygon:nth-child(1) {\n                stroke: transparent;\n                fill: ', ';\n            }\n        }\n    }\n\n    .dashed-circle {\n        stroke-dasharray: 5px;\n        stroke: currentcolor;\n        fill: none;\n    }\n\n    .circle {\n        fill: #fff;\n\n        &__chart-opponent1 {\n            fill: ', ';\n        }\n\n        &__chart-opponent2 {\n            fill: ', ';\n        }\n\n        &__chart-opponent3 {\n            fill: ', ';\n        }\n    }\n\n    line {\n        stroke: ', ';\n    }\n\n    .label {\n        fill: ', ';\n        font-size: 20px;\n        font-weight: ', ';\n\n        &__opponent1 {\n            fill: ', ';\n            text-transform: none;\n        }\n\n        &__opponent2 {\n            fill: ', ';\n            text-transform: none;\n        }\n\n        &__opponent3 {\n            fill: ', ';\n            text-transform: none;\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    fill: none;\n    stroke-width: 1;\n    stroke: ', ';\n\n    &.border-none {\n        stroke: none;\n    }\n\n    &.polygon__chart-opponent1,\n    &.polygon__chart-opponent2,\n    &.polygon__chart-opponent3 {\n        stroke-width: ', ';\n    }\n\n    &.polygon__chart-opponent1 {\n        stroke: ', ';\n        fill: ', ';\n    }\n\n    &.polygon__chart-opponent2 {\n        stroke: ', ';\n        fill: ', ';\n    }\n\n    &.polygon__chart-opponent3 {\n        stroke: ', ';\n        fill: ', ';\n    }\n'], ['\n    fill: none;\n    stroke-width: 1;\n    stroke: ', ';\n\n    &.border-none {\n        stroke: none;\n    }\n\n    &.polygon__chart-opponent1,\n    &.polygon__chart-opponent2,\n    &.polygon__chart-opponent3 {\n        stroke-width: ', ';\n    }\n\n    &.polygon__chart-opponent1 {\n        stroke: ', ';\n        fill: ', ';\n    }\n\n    &.polygon__chart-opponent2 {\n        stroke: ', ';\n        fill: ', ';\n    }\n\n    &.polygon__chart-opponent3 {\n        stroke: ', ';\n        fill: ', ';\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable react/no-array-index-key */
	
	
	var COLOR_SCHEMA = {
	    standard: {
	        bgr: function bgr(props) {
	            return props.theme.content.backgroundColor;
	        },
	        label: function label(props) {
	            return props.theme.color;
	        },
	        chart: function chart(props) {
	            return props.theme.radar.strokeColorHome;
	        },
	        chartFill: function chartFill(props) {
	            return props.theme.radar.fillColorHome;
	        }
	    },
	    statsTable: {
	        bgr: function bgr(props) {
	            return (0, _color2.default)(props.theme.primaryColor).alpha(0.5).rgb().toString();
	        },
	        label: function label(props) {
	            return props.theme.labelTextColor;
	        },
	        chart: function chart(props) {
	            return props.theme.radar.strokeColorHome;
	        },
	        chartFill: function chartFill(props) {
	            return props.theme.radar.fillColorHome;
	        }
	    }
	};
	
	var colorsFor = function colorsFor(props, colorFor) {
	    var set = _lodash2.default.get(COLOR_SCHEMA, '' + props.colorScheme, COLOR_SCHEMA.standard);
	    return set[colorFor] ? set[colorFor](props) : '#fff';
	};
	
	var RadarChart = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.radar.polygonBgColor;
	}, function (props) {
	    return colorsFor(props, 'chart');
	}, function (props) {
	    return props.theme.radar.strokeColorAway;
	}, function (props) {
	    return props.theme.radar.strokeColorOpponent;
	}, function (props) {
	    return props.theme.radar.polygonBorderColor;
	}, function (props) {
	    return colorsFor(props, 'label');
	}, function (_ref) {
	    var theme = _ref.theme;
	    return theme.fonts.main.bold || 'bold';
	}, function (props) {
	    return colorsFor(props, 'chart');
	}, function (props) {
	    return props.theme.radar.strokeColorAway;
	}, function (props) {
	    return props.theme.radar.strokeColorOpponent;
	});
	
	var Polygon = _styledComponents2.default.polygon(_templateObject2, function (props) {
	    return props.theme.radar.polygonBorderColor;
	}, function (_ref2) {
	    var lineWidth = _ref2.lineWidth;
	    return lineWidth || 2;
	}, function (props) {
	    return colorsFor(props, 'chart');
	}, function (props) {
	    return (0, _color2.default)(colorsFor(props, 'chartFill')).rgb().toString();
	}, function (props) {
	    return props.theme.radar.strokeColorAway;
	}, function (props) {
	    return (0, _color2.default)(props.theme.radar.fillColorAway).rgb().toString();
	}, function (props) {
	    return props.theme.radar.strokeColorOpponent;
	}, function (props) {
	    return (0, _color2.default)(props.theme.radar.fillColorOpponent).rgb().toString();
	});
	
	var calcPolygonPoints = function calcPolygonPoints(dotSize, diameter, sides, radiuses) {
	    var RAD = Math.PI / 180;
	    var TWO_PI = Math.PI * 2;
	
	    var center = diameter / 2;
	    var theta = TWO_PI / sides;
	    var angle = RAD * -90;
	
	    var points = radiuses.map(function (radius) {
	        var pointArr = [];
	
	        for (var i = 0; i < sides; i++) {
	            var x = radius * Math.cos(theta * i + angle) + center;
	            var y = radius * Math.sin(theta * i + angle) + center;
	            pointArr.push([x, y]);
	        }
	
	        return pointArr;
	    });
	
	    return points;
	};
	
	var getRadiuses = function getRadiuses(diameter, level) {
	    var radius = diameter / 2;
	    var distance = diameter / (2 * level);
	    var r = 0;
	    var radiuses = [];
	
	    for (var i = 0; i < level; i++) {
	        r = radius;
	        radius -= distance;
	        radiuses.push(r);
	    }
	
	    return radiuses;
	};
	
	var SVGRadarChart = function (_Component) {
	    _inherits(SVGRadarChart, _Component);
	
	    function SVGRadarChart(props, context) {
	        _classCallCheck(this, SVGRadarChart);
	
	        var _this = _possibleConstructorReturn(this, (SVGRadarChart.__proto__ || Object.getPrototypeOf(SVGRadarChart)).call(this, props, context));
	
	        var sides = props.stats.length;
	        _this.state = {
	            polygons: calcPolygonPoints(props.dotSize, props.diameter, sides, getRadiuses(props.diameter, props.level))
	        };
	        return _this;
	    }
	
	    _createClass(SVGRadarChart, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                diameter = _props.diameter,
	                level = _props.level,
	                dotSize = _props.dotSize;
	            var stats = nextProps.stats;
	
	            var sides = stats.length;
	
	            var polygons = calcPolygonPoints(dotSize, diameter, sides, getRadiuses(diameter, level));
	
	            this.setState({
	                polygons: polygons
	            });
	        }
	    }, {
	        key: 'getDotOnChart',
	        value: function getDotOnChart(stat, i) {
	            var _props2 = this.props,
	                stats = _props2.stats,
	                diameter = _props2.diameter;
	
	            var sides = stats.length;
	            var RAD = Math.PI / 180;
	            var TWO_PI = Math.PI * 2;
	
	            var center = diameter / 2;
	            var theta = TWO_PI / sides;
	            var angle = RAD * -90;
	
	            if (!stat.max) stat.max = center;
	
	            var radius = stat.value / stat.max / 2 * diameter;
	
	            var x = radius * Math.cos(theta * i + angle) + center;
	            var y = radius * Math.sin(theta * i + angle) + center;
	
	            return { x: x, y: y };
	        }
	    }, {
	        key: 'getLabelAlignType',
	        value: function getLabelAlignType() {
	            var _props3 = this.props,
	                stats = _props3.stats,
	                labelWidth = _props3.labelWidth,
	                diameter = _props3.diameter;
	
	            var sides = stats.length;
	
	            switch (sides) {
	                case 3:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 4:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: diameter / 2
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 5:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 6:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 7:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 8:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	                case 9:
	                default:
	                    return [{
	                        tAlign: 'center',
	                        textAnchor: 'middle',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'left',
	                        textAnchor: 'start',
	                        offset: 0
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }, {
	                        tAlign: 'right',
	                        textAnchor: 'end',
	                        offset: labelWidth
	                    }];
	            }
	        }
	    }, {
	        key: 'renderLabels',
	        value: function renderLabels() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                stats = _props4.stats,
	                hideStatLabels = _props4.hideStatLabels;
	
	            var opponents = Object.keys(stats[0]).filter(function (o) {
	                return o.includes('opponent');
	            });
	
	            return stats.map(function (stat, index) {
	                var labelOutOfChart = _this2.getDotOnChart({ value: (stat.max || 10) * 1.2, max: stat.max || 10 }, index);
	
	                var text = !hideStatLabels ? _react2.default.createElement(
	                    'text',
	                    {
	                        key: stat.label,
	                        className: 'label',
	                        x: labelOutOfChart.x,
	                        y: labelOutOfChart.y,
	                        dy: -3,
	                        textAnchor: _this2.getLabelAlignType()[index].textAnchor || 'middle'
	                    },
	                    opponents.map(function (opponent, i) {
	                        var opponentStat = Math.round(stats[index][opponent] * 10) / 10;
	                        var isLast = opponents.length - 1 === i;
	
	                        return [_react2.default.createElement(
	                            'tspan',
	                            { key: 'label', className: 'label label__' + opponent },
	                            opponentStat
	                        ), _react2.default.createElement(
	                            'tspan',
	                            { key: 'symbol', className: 'label label__symbol' },
	                            !isLast ? ' / ' : ''
	                        )];
	                    })
	                ) : null;
	
	                return [text, _react2.default.createElement(
	                    'foreignObject',
	                    {
	                        key: 'label',
	                        x: index ? labelOutOfChart.x - _this2.getLabelAlignType()[index].offset : 0,
	                        y: labelOutOfChart.y,
	                        width: _this2.getLabelAlignType()[index].tAlign === 'center' ? '100%' : _this2.props.labelWidth,
	                        height: 90,
	                        style: { textAlign: _this2.getLabelAlignType()[index].tAlign || 'center', fontWeight: 400 },
	                        className: 'label'
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        stat.label,
	                        ' ',
	                        stat.postfix ? '(' + stat.postfix + ')' : ''
	                    )
	                )];
	            });
	        }
	    }, {
	        key: 'getPath',
	        value: function getPath(opponent) {
	            var _this3 = this;
	
	            var stats = this.props.stats;
	
	
	            return stats.reduce(function (accum, curr, index) {
	                var coordinates = _this3.getDotOnChart({ value: curr[opponent] || 0, max: curr.max }, index);
	                return [].concat(_toConsumableArray(accum), [[coordinates.x, coordinates.y]]);
	            }, []);
	        }
	    }, {
	        key: 'renderChart',
	        value: function renderChart() {
	            var _this4 = this;
	
	            var _props5 = this.props,
	                stats = _props5.stats,
	                _props5$dotSize = _props5.dotSize,
	                dotSize = _props5$dotSize === undefined ? 4 : _props5$dotSize,
	                lineWidth = _props5.lineWidth;
	
	            var opponents = Object.keys(stats[0]).filter(function (o) {
	                return o.includes('opponent');
	            });
	
	            return _react2.default.createElement(
	                'g',
	                { className: 'chart' },
	                opponents.map(function (opponent) {
	                    return _react2.default.createElement(
	                        'g',
	                        { className: 'polygon', key: opponent },
	                        _react2.default.createElement(Polygon, {
	                            className: 'polygon polygon__chart-' + opponent,
	                            points: _this4.getPath(opponent).join(' '),
	                            lineWidth: lineWidth
	                        }),
	                        _this4.getPath(opponent).map(function (p) {
	                            var x = p[0];
	                            var y = p[1];
	
	                            return _react2.default.createElement('circle', {
	                                key: opponent + x + y,
	                                cx: x,
	                                cy: y,
	                                r: dotSize,
	                                className: 'circle circle__chart-' + opponent
	                            });
	                        })
	                    );
	                }),
	                _react2.default.createElement(
	                    'g',
	                    { className: 'labels' },
	                    this.renderLabels()
	                )
	            );
	        }
	    }, {
	        key: 'renderSvg',
	        value: function renderSvg() {
	            var _this5 = this;
	
	            var polygons = this.state.polygons;
	            var diameter = this.props.diameter;
	
	            var offset = 50; //for padding top
	
	            if (!polygons.length) return;
	
	            return _react2.default.createElement(
	                'svg',
	                { viewBox: '0 -' + offset + ' ' + diameter + ' ' + (diameter + offset * 2), height: this.props.chartHeight },
	                _react2.default.createElement(
	                    'g',
	                    { className: 'grid' },
	                    polygons.map(function (points, i) {
	                        var pointValues = points.join(' ');
	                        return _react2.default.createElement(Polygon, {
	                            key: i,
	                            className: _this5.props.isScaleLines ? 'polygon' : 'polygon border-none',
	                            points: pointValues
	                        });
	                    })
	                ),
	                this.renderChart()
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                RadarChart,
	                { colorScheme: this.props.colorScheme },
	                this.renderSvg()
	            );
	        }
	    }]);
	
	    return SVGRadarChart;
	}(_react.Component);
	
	SVGRadarChart.defaultProps = {
	    diameter: 300,
	    level: 5,
	    colorScheme: 'standard',
	    isScaleLines: true,
	    isDashedCircle: false,
	    labelWidth: 230
	};
	
	
	SVGRadarChart.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = SVGRadarChart;
	exports.SVGRadarChart = SVGRadarChart;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NationalFlag = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: ', 'px;\n    margin: 0;\n    overflow: hidden;\n    text-align: center;\n\n    ', ';\n    ', ';\n'], ['\n    width: ', 'px;\n    margin: 0;\n    overflow: hidden;\n    text-align: center;\n\n    ', ';\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Flag = _styledComponents2.default.figure(_templateObject, function (props) {
	    return props.width;
	}, function (props) {
	    return props.theme.display.flag === 'round' && 'border-radius: 50%; width: ' + props.height + 'px; height: ' + props.height + 'px';
	}, function (props) {
	    return props.theme.display.flag === 'skew' && 'transform: skew(-15deg)';
	});
	
	var NationalFlag = function NationalFlag(props) {
	    var countryId = props.countryId,
	        width = props.width,
	        height = props.height;
	
	    var difference = 1.525;
	
	    return _react2.default.createElement(
	        Flag,
	        { width: width, height: width / difference },
	        _react2.default.createElement('img', { src: _RCore2.default.imageUrls.getFlagImg(countryId, width, height) })
	    );
	};
	
	NationalFlag.contextTypes = {
	    info: _propTypes2.default.object
	};
	
	exports.default = NationalFlag;
	exports.NationalFlag = NationalFlag;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SkewTitle = exports.LeftAlignedTitle = exports.Title = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\n\n    font-family: ', ';\n    font-style: ', ';\n\n    text-transform: ', ';\n\n    margin-bottom: 20px;\n    .w-title-image {\n        text-align: center;\n    }\n    .w-title {\n        font-size: 32px;\n        font-size: ', ';\n        line-height: 1.31;\n        text-align: center;\n        font-weight: ', ';\n        .alka-superliga-svg svg {\n            height: 24px;\n            fill: ', ';\n        }\n        color: ', ';\n    }\n    .w-sub-title {\n        text-align: center;\n        font-size: 18px;\n        font-size: ', ';\n        line-height: 1.44;\n        font-weight: ', ';\n        color: ', ';\n        .alka-superliga-svg svg {\n            height: 24px;\n            fill: ', ';\n        }\n    }\n'], ['\n    color: ', ';\n\n    font-family: ', ';\n    font-style: ', ';\n\n    text-transform: ', ';\n\n    margin-bottom: 20px;\n    .w-title-image {\n        text-align: center;\n    }\n    .w-title {\n        font-size: 32px;\n        font-size: ', ';\n        line-height: 1.31;\n        text-align: center;\n        font-weight: ', ';\n        .alka-superliga-svg svg {\n            height: 24px;\n            fill: ', ';\n        }\n        color: ', ';\n    }\n    .w-sub-title {\n        text-align: center;\n        font-size: 18px;\n        font-size: ', ';\n        line-height: 1.44;\n        font-weight: ', ';\n        color: ', ';\n        .alka-superliga-svg svg {\n            height: 24px;\n            fill: ', ';\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral([''], ['']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    .w-title-image {\n        text-align: left;\n    }\n    .w-title {\n        text-align: left;\n    }\n    .w-sub-title {\n        text-align: left;\n    }\n'], ['\n    .w-title-image {\n        text-align: left;\n    }\n    .w-title {\n        text-align: left;\n    }\n    .w-sub-title {\n        text-align: left;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    text-align: center;\n\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    .w-sub-title {\n        position: relative;\n        z-index: 6;\n    }\n    hr {\n        max-width: 450px;\n        margin: 7px auto;\n        border-top: 1px solid ', ';\n        border-bottom: none;\n    }\n'], ['\n    text-align: center;\n\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    .w-sub-title {\n        position: relative;\n        z-index: 6;\n    }\n    hr {\n        max-width: 450px;\n        margin: 7px auto;\n        border-top: 1px solid ', ';\n        border-bottom: none;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// add font control here later
	var BaseTitle = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme.titleColor || props.theme.color;
	}, function (props) {
	    return props.theme.fonts.title.fontFamily;
	}, function (props) {
	    return props.theme.fonts.title.fontStyle;
	}, function (props) {
	    return props.theme.fonts.title.textTransform;
	}, function (props) {
	    return props.theme.fonts.title.fontSize + 'px' || '32px';
	}, function (props) {
	    return props.theme.fonts.title.bold;
	}, function (props) {
	    return props.theme.titleColor || props.theme.color;
	}, function (props) {
	    return props.theme.titleColor || props.theme.color;
	}, function (props) {
	    return props.theme.fonts.subTitle.fontSize + 'px' || '18px';
	}, function (props) {
	    return props.theme.fonts.title.normal;
	}, function (props) {
	    return props.theme.subTitleColor || props.theme.color;
	}, function (props) {
	    return props.theme.subTitleColor || props.theme.color;
	});
	var WidgetTitle = BaseTitle.extend(_templateObject2);
	var LeftAlignedWidgetTitle = BaseTitle.extend(_templateObject3);
	
	var Title = function Title(props) {
	    var title = props.text || props.title;
	    var titleImage = props.titleImage;
	    if (!title) return null;
	    return _react2.default.createElement(
	        WidgetTitle,
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title-image' },
	            titleImage
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title' },
	            title
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-sub-title' },
	            props.subTitle
	        )
	    );
	};
	
	var LeftAlignedTitle = function LeftAlignedTitle(props) {
	    var title = props.text || props.title;
	    var titleImage = props.titleImage;
	    if (!title) return null;
	    return _react2.default.createElement(
	        LeftAlignedWidgetTitle,
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title-image' },
	            titleImage
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title' },
	            title
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-sub-title' },
	            props.subTitle
	        )
	    );
	};
	
	var SkewSkinTitle = BaseTitle.extend(_templateObject4, function (props) {
	    return props.theme.titleColor;
	});
	
	var SkewTitle = function SkewTitle(props) {
	    var title = props.text || props.title;
	    var titleImage = props.titleImage;
	    if (!title) return null;
	    return _react2.default.createElement(
	        SkewSkinTitle,
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title-image' },
	            titleImage
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-title' },
	            title
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	            'div',
	            { className: 'w-sub-title' },
	            props.subTitle
	        )
	    );
	};
	
	exports.default = Title;
	exports.Title = Title;
	exports.LeftAlignedTitle = LeftAlignedTitle;
	exports.SkewTitle = SkewTitle;

/***/ },
/* 1463 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function hexToRgba() {
	    var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    hex = hex.replace(new RegExp('#', 'g'), '');
	
	    if (hex.length < 4) {
	        hex = hex.replace(new RegExp('.', 'g'), function (m) {
	            return m.repeat(2);
	        });
	    }
	
	    var _hex$split$filter$map = hex.split(new RegExp('(..)', 'g')).filter(Boolean).map(function (c) {
	        return parseInt(c, 16);
	    }),
	        _hex$split$filter$map2 = _slicedToArray(_hex$split$filter$map, 3),
	        _hex$split$filter$map3 = _hex$split$filter$map2[0],
	        r = _hex$split$filter$map3 === undefined ? 0 : _hex$split$filter$map3,
	        _hex$split$filter$map4 = _hex$split$filter$map2[1],
	        g = _hex$split$filter$map4 === undefined ? 0 : _hex$split$filter$map4,
	        _hex$split$filter$map5 = _hex$split$filter$map2[2],
	        b = _hex$split$filter$map5 === undefined ? 0 : _hex$split$filter$map5;
	
	    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	}
	
	// TESTS
	// console.log('--- TESTS: ƒ hexToRgba ---');
	// console.log(
	//     'Test 1: fff |',
	//     `isOk = ${hexToRgba('fff') === 'rgba(255, 255, 255, 1)'}`,
	//     hexToRgba('fff'),
	//     'rgba(255, 255, 255, 1)',
	// );
	// console.log(
	//     'Test 2: fab781 |',
	//     `isOk = ${hexToRgba('fab781') === 'rgba(250, 183, 129, 1)'}`,
	//     hexToRgba('fab781'),
	//     'rgba(250, 183, 129, 1)',
	// );
	// console.log(
	//     'Test 3: fab781 0.5 |',
	//     `isOk = ${hexToRgba('fab781', 0.5) === 'rgba(250, 183, 129, 0.5)'}`,
	//     hexToRgba('fab781', 0.5),
	//     'rgba(250, 183, 129, 0.5)',
	// );
	// console.log(
	//     'Test 4: #fab781 0.5 |',
	//     `isOk = ${hexToRgba('#fab781', 0.5) === 'rgba(250, 183, 129, 0.5)'}`,
	//     hexToRgba('#fab781', 0.5),
	//     'rgba(250, 183, 129, 0.5)',
	// );
	
	exports.default = hexToRgba;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ = __webpack_require__(339);
	var config =  true ? __webpack_require__(580).default : require('config');
	var TemplateConstants = __webpack_require__(1417);
	
	module.exports = {
	    // @deprecated
	    titleFontFamily: '"Roboto", sans-serif',
	    // @deprecated
	    fontFamily: '"Roboto", sans-serif',
	    // @deprecated
	    shirtNumbersFontFamily: 'BenchNine',
	    // @deprecated
	    googleFontName: 'Roboto',
	
	    teamLogo: 'logo', // empty, invisible, logo, tshirt, 3d-tshirt
	
	    fonts: {
	        main: _.clone(TemplateConstants.FONT),
	        title: _extends({}, _.clone(TemplateConstants.FONT), {
	            fontSize: 32
	        }),
	        subTitle: {
	            fontSize: 18
	        },
	        shirtNumber: {
	            name: 'BenchNine',
	            fontFamily: '"BenchNine", sans-serif',
	            fontStyle: 'normal',
	            thin: 400,
	            normal: 400,
	            bold: 400,
	            textTransform: '',
	            gFontName: 'BenchNine',
	            gWeights: '400',
	            gSubsets: ''
	        },
	        special: _.clone(TemplateConstants.FONT)
	    },
	
	    color: '#fff',
	    titleColor: '#fff',
	    subTitleColor: '#fff',
	    split: 'vertical',
	    weight: 0.5,
	    direction: 'row',
	
	    primaryColor: '#d8005f',
	    primaryTextColor: '#fff',
	
	    statColorHome: '#00589d',
	    statColorNeutral: '#ccc',
	    statColorAway: '#08abd4',
	
	    statTableBgColor: 'rgba(255,255,255,0.9)',
	    statTableTextColor: 'rgba(0,0,0,1.0)',
	    statTableLabelTextColor: 'rgba(0,0,0,1.0)',
	    statTextColor: 'rgba(255,255,255,0.9)',
	
	    positiveColor: '#08e965',
	    negativeColor: '#F44336',
	    substitutionOutColor: '#FA070C',
	    minHeight: 'auto',
	    brandingBackground: 'rgba(255,255,255,0)',
	
	    // whaat
	    logosBackground: 'rgba(255,255,255,0.7)',
	
	    containerPadding: 0, // @deprecated
	    contentPadding: 30, // @deprecated
	    teamBackgroundColor: '',
	    teamColor: '',
	    preview: {
	        fullSize: true,
	        backgroundImage: config.assets + '/assets/sm_cover.png',
	        backgroundPositionX: 50,
	        backgroundPositionY: 50
	    },
	    preview_overlay: {
	        startColor: 'rgba(0,0,0,0.1)',
	        endColor: 'rgba(0,0,0,0.3)',
	        gradient: 'none',
	        position: 'to top right'
	    },
	    widgets: {},
	    widgetsColors: {
	        widgetId: {
	            class: 'color'
	        }
	    },
	    layers: [TemplateConstants.LAYER],
	    content: {
	        backgroundColor: 'rgba(0,0,0,0.5)',
	        accentColor: '#0db4e7',
	        accentTextColor: '#fff',
	        accent2Color: '#0db4e7',
	        accent2TextColor: '#fff',
	        minHeight: 500,
	        valign: 'top',
	        margin: '0 0 0 0',
	        padding: '0 0 0 0',
	        fillColor: 'transparent',
	        gradientAlign: 'left',
	        gradientWidth: '100',
	        gradientHeight: '100'
	    },
	    layer: {},
	    pitch: {
	        lines: '#8AD58A',
	        stripes: '#fff',
	        background: '#2A8337',
	        bottomBorder: '#1C2806'
	    },
	    wdl: {
	        win: '#2ec62a', //TODO: ADD THIS VARIABLE TO THE EDITOR
	        draw: '#757575', //TODO: ADD THIS VARIABLE TO THE EDITOR
	        loss: '#df3746', //TODO: ADD THIS VARIABLE TO THE EDITOR,
	        notPlayed: '#c4c4c4' //TODO: ADD THIS VARIABLE TO THE EDITOR,
	    },
	    qualRelColors: {
	        leagueWinner: '#F12A09',
	        championsleague: '#08abd4',
	        championsleaguequal: '#08abd4',
	        uefacup: '#ff0000',
	        uefaqual: '#08abd4',
	        relegation: '#f57005',
	        promotion: '#08abd4',
	        promotionplayoff: '#08abd4',
	        qualification_to_next_stage: '#08abd4',
	        championship_playoff: '#08abd4',
	        relegationplayoff: '#f57005',
	        uefaqualplayoff: '#08abd4'
	    },
	    brandingProps: TemplateConstants.BRANDING,
	    defaultBranding: {
	        brandingSecondary: 'visit superliga.dk',
	        brandingPrimary: 'alka'
	    },
	    display: {
	        title: 'default',
	        playersList: 'default',
	        matchCell: 'default',
	        tournamentTable: 'default',
	        incidentCard: 'default',
	        playerLogo: 'default',
	        h2hTable: 'default',
	        flag: 'default'
	    },
	
	    radar: {
	        strokeColorHome: 'rgba(20, 216, 255, 1)',
	        strokeColorAway: 'rgba(165, 253, 0, 1)',
	        strokeColorOpponent: 'rgba(115, 255, 192, 1)',
	        fillColorHome: 'rgba(20, 216, 255, 0.1)',
	        fillColorAway: 'rgba(165, 253, 0, 0.1)',
	        fillColorOpponent: 'rgba(115, 255, 192, 1)',
	        chartBorderColor: 'rgba(252, 251, 255, 0.35)',
	        polygonBorderColor: 'rgba(255, 255, 255, 0.35)',
	        labelTextColor: 'rgba(255, 255, 255, 1)',
	        polygonBgColor: 'rgba(18, 29, 84, 0.5)'
	    },
	    f1: {
	        primaryColor: '#fd2c17',
	        primaryTextColor: '#fff',
	        headerBgColor: '#2c2c2c',
	        headerTextColor: '#fff',
	        tableBgColor: '#fff',
	        tableTextColor: '#000',
	        tableSecondaryTextColor: '#333',
	        primaryCellColor: '#FD2C17',
	        secondaryCellColor: '#6A6A6A',
	        primaryCellTextColor: '#6A6A6A',
	        secondaryCellTextColor: '#000000',
	        inprogress: '#03cc27',
	        finished: '#2c2c2c',
	        notstarted: '#2c2c2c',
	        trackLineColor: '#FB251D',
	        trackMapDetails: '#ccc',
	        trackDrsColor: '#fff'
	    },
	    skins: {
	        skew: {
	            angle: 5
	        }
	    },
	    dateFormats: {
	        TIME: 'HH:mm',
	        DATE_AND_TIME_SHORT: 'DD MM, HH:mm',
	        DATE_AND_TIME_FULL: 'DD MMMM, HH:mm',
	        DATE: 'DD MMMM',
	        DATE_SHORT: 'D MMM',
	        DATE_WEEKDAY: 'dddd, D MMMM'
	    },
	    oddsFormat: 'decimal' // fractional
	};
	
	//h:mm A Do MMMM

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    pointer-events: all;\n    flex-grow: 1;\n    overflow: hidden;\n    position: relative;\n    background-color: rgba(255, 0, 0, 0.15);\n    z-index: 0;\n    ', ';\n\n    &:before {\n        content: \'\';\n        position: absolute;\n        left: -10px;\n        right: -10px;\n        top: -10px;\n        bottom: -10px;\n        background: linear-gradient(', 'deg, ', ' 0%, ', ' 100%);\n        ', ' ', '\n        z-index: 2;\n        pointer-events: none;\n    }\n\n    ', ' ', '\n\n    .click-to-edit {\n        display: none;\n    }\n    &:hover .click-to-edit {\n        visibility: visible;\n        display: block;\n        background: #008c9d;\n        z-index: 100000;\n    }\n    box-sizing: border-box;\n'], ['\n    pointer-events: all;\n    flex-grow: 1;\n    overflow: hidden;\n    position: relative;\n    background-color: rgba(255, 0, 0, 0.15);\n    z-index: 0;\n    ', ';\n\n    &:before {\n        content: \'\';\n        position: absolute;\n        left: -10px;\n        right: -10px;\n        top: -10px;\n        bottom: -10px;\n        background: linear-gradient(', 'deg, ', ' 0%, ', ' 100%);\n        ', ' ', '\n        z-index: 2;\n        pointer-events: none;\n    }\n\n    ', ' ', '\n\n    .click-to-edit {\n        display: none;\n    }\n    &:hover .click-to-edit {\n        visibility: visible;\n        display: block;\n        background: #008c9d;\n        z-index: 100000;\n    }\n    box-sizing: border-box;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    transform-origin: 0 0;\n    transform: matrix(', ')\n        rotateX(', 'deg) rotateY(', 'deg)\n        translateY(', ') translateX(', ') !important;\n'], ['\n    transform-origin: 0 0;\n    transform: matrix(', ')\n        rotateX(', 'deg) rotateY(', 'deg)\n        translateY(', ') translateX(', ') !important;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 4px;\n    cursor: pointer;\n    postion: relative;\n    background: #000;\n    color: #fff;\n    z-index: 100000;\n'], ['\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 4px;\n    cursor: pointer;\n    postion: relative;\n    background: #000;\n    color: #fff;\n    z-index: 100000;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDraggable = __webpack_require__(1466);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bgr_drop_default = __webpack_require__(1467);
	
	var _bgr_drop_default2 = _interopRequireDefault(_bgr_drop_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Area = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.edit && 'cursor: move';
	}, function (props) {
	    return props.oa;
	}, function (props) {
	    return props.osc;
	}, function (props) {
	    return props.oec;
	}, function (props) {
	    return props.oa == -1 && 'background: radial-gradient( ' + props.osc + ', ' + props.oec + ');';
	}, function (props) {
	    return props.oa == -2 && 'background: radial-gradient( ' + props.oec + ', ' + props.osc + ');';
	}, function (_ref) {
	    var edit = _ref.edit;
	    return edit && '\n    &:hover:after {\n        content: \'\';\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        border: 3px solid #008c9d;\n        z-index: 1;\n        pointer-events: none;\n    }\n    ';
	}, function (_ref2) {
	    var active = _ref2.active,
	        edit = _ref2.edit;
	    return edit && active && '\n        &:after {\n            content: \'\';\n            position: absolute;\n            left: 0;\n            right: 0;\n            top: 0;\n            bottom: 0;\n            border: 3px solid #008c9d;\n            z-index: 1;\n            pointer-events: none;\n\n        }\n';
	});
	
	var Img = _styledComponents2.default.img(_templateObject2, function (_ref3) {
	    var position = _ref3.position,
	        scale = _ref3.scale;
	    return scale + ', 0, 0, ' + scale + ', 0, 0';
	}, function (_ref4) {
	    var flipY = _ref4.flipY;
	    return flipY ? 180 : 0;
	}, function (_ref5) {
	    var flipX = _ref5.flipX;
	    return flipX ? 180 : 0;
	}, function (_ref6) {
	    var flipY = _ref6.flipY;
	    return flipY ? '-100%' : '0';
	}, function (_ref7) {
	    var flipX = _ref7.flipX;
	    return flipX ? '-100%' : '0';
	});
	
	// this.sendAnEvent = _.debounce(this._sendAnEvent, 100);
	var dispatch = function dispatch(type, id, payload) {
	    var event = new CustomEvent('WDP_IM', {
	        detail: {
	            id: id,
	            values: payload || {},
	            type: type
	        },
	        bubbles: false,
	        cancelable: false
	    });
	
	    window.dispatchEvent(event);
	};
	
	var dispatchDebounce = _lodash2.default.debounce(dispatch, 100);
	
	var activate = function activate(id) {
	    dispatch('ACTIVATE', id);
	};
	
	var containerResize = function containerResize(id, props) {
	    dispatch('CONTAINER_RESIZE', id, props);
	};
	
	var update = function update(id, props) {
	    dispatchDebounce('UPDATE', id, props);
	};
	
	var change = function change(id, props) {
	    dispatchDebounce('CHANGE', id, props);
	};
	
	var isValid = function isValid(container, _ref8, _ref9) {
	    var width = _ref8.width,
	        height = _ref8.height;
	    var scale = _ref9.scale,
	        x = _ref9.x,
	        y = _ref9.y;
	
	    var realWidth = width * scale;
	    var realHeight = height * scale;
	
	    var reachX = realWidth + x;
	    var reachY = realHeight + y;
	
	    var coverLeft = x <= 0.1;
	    var coverRight = reachX - container.width >= -0.1;
	
	    var coverTop = y <= 1;
	    var coverBottom = reachY - container.height >= -0.5;
	
	    return coverLeft && coverRight && coverTop && coverBottom;
	};
	
	var calcFitPosition = function calcFitPosition(container, dimensions) {
	    var neededScaleX = container.width / dimensions.width;
	    var neededScaleY = container.height / dimensions.height;
	
	    var scale = +Math.max(neededScaleX, neededScaleY).toFixed(3);
	    var x = (container.width - dimensions.width * scale).toFixed(3) / 2;
	    var y = (container.height - dimensions.height * scale).toFixed(3) / 2;
	
	    return {
	        scale: scale,
	        x: x,
	        y: y
	    };
	};
	
	// replace to set state...
	// this thing is not working without picker that uses redux outside widget. Why this is important?? can we use state and notify on state change redux about parameters change?
	// should be refactored
	
	var BackgroundArea = function (_Component) {
	    _inherits(BackgroundArea, _Component);
	
	    function BackgroundArea(props) {
	        _classCallCheck(this, BackgroundArea);
	
	        var _this = _possibleConstructorReturn(this, (BackgroundArea.__proto__ || Object.getPrototypeOf(BackgroundArea)).call(this, props));
	
	        _this.handleOnLoad = function (src, width, height) {
	            var dimensions = {
	                width: width,
	                height: height
	            };
	
	            var _this$props = _this.props,
	                x = _this$props.x,
	                y = _this$props.y,
	                scale = _this$props.scale;
	            var container = _this.state.container;
	
	
	            var defaultPosition = calcFitPosition(container, dimensions);
	            //const valid = isValid(container, dimensions, { scale, x, y });
	            var valid = true;
	
	            var shoudReset = !valid || src !== _this.state.url;
	
	            _this.setState({
	                url: src
	            }, function () {
	                if (shoudReset) {
	                    change(_this.props.id, _extends({}, BackgroundArea.defaultProps, { // defs
	                        width: dimensions.width, // calc new pos
	                        height: dimensions.height, // calc new pos
	                        cw: container.width,
	                        ch: container.height
	                    }, defaultPosition, {
	                        url: src
	                    }));
	                }
	            });
	        };
	
	        _this.renderFallback = function () {
	            return _react2.default.createElement('img', {
	                src: _this.props.url,
	                style: {
	                    width: '100%',
	                    height: '100%',
	                    objectFit: 'cover'
	                },
	                alt: ''
	            });
	        };
	
	        _this.componentDidMount = function () {
	            var cRect = _reactDom2.default.findDOMNode(_this.container).getBoundingClientRect();
	
	            _this.setState({ container: { width: cRect.width, height: cRect.height } });
	            // hack
	
	            _this.ct_timeout = setTimeout(function () {
	                _this.checkForSizeChange();
	            }, 500);
	
	            if (_this.props.url) {
	                var img = new Image();
	                var h = _this.handleOnLoad;
	                img.onload = function () {
	                    h(this.src, this.width, this.height);
	                };
	                img.src = _this.props.url;
	            }
	        };
	
	        _this.componentWillMount = function () {
	            if (_this.ct_timeout) clearTimeout(_this.ct_timeout);
	        };
	
	        _this.checkForSizeChange = function () {
	            var container = _this.state.container;
	
	            var el = _reactDom2.default.findDOMNode(_this.container);
	
	            if (!el) return void 0;
	            var cRect2 = el.getBoundingClientRect();
	
	            if (cRect2 && (container && container.height !== cRect2.height || container && container.width !== cRect2.width)) {
	                // console.log('WHAT');
	                _this.setState({ container: { width: cRect2.width, height: cRect2.height } }, function () {
	                    //console.log('SEND', 'CR', this.props.id, cRect2.width, cRect2.height);
	                    containerResize(_this.props.id, { cw: cRect2.width, ch: cRect2.height });
	                });
	                return true;
	            }
	            return false;
	        };
	
	        _this.getBounds = function () {
	            var _this$props2 = _this.props,
	                width = _this$props2.width,
	                height = _this$props2.height,
	                scale = _this$props2.scale;
	            var container = _this.state.container;
	
	            if (!container) return {};
	
	            var neededX = width * scale;
	            var neededY = height * scale;
	
	            return {
	                left: container.width - neededX,
	                top: container.height - neededY,
	                right: 0,
	                bottom: 0
	            };
	        };
	
	        _this.state = {
	            url: props.url
	        };
	        return _this;
	    }
	
	    _createClass(BackgroundArea, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.url !== this.props.ulr) {
	                if (nextProps.url) {
	                    var img = new Image();
	                    var h = this.handleOnLoad;
	                    img.onload = function () {
	                        h(this.src, this.width, this.height);
	                    };
	                    img.src = nextProps.url;
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            this.checkForSizeChange(); // this is dangereosly
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                editMode = _props.editMode,
	                width = _props.width,
	                height = _props.height,
	                id = _props.id,
	                x = _props.x,
	                y = _props.y,
	                scale = _props.scale,
	                flipX = _props.flipX,
	                flipY = _props.flipY,
	                ikey = _props.ikey,
	                active = _props.active;
	            var container = this.state.container;
	
	            var positionParamsAreValid = width && height;
	
	            if (editMode && container) {
	                var realWidth = width * scale;
	                var realHeight = height * scale;
	
	                var reachX = realWidth + x;
	                var reachY = realHeight + y;
	
	                var coverLeft = x <= 0.1;
	                var coverRight = reachX - container.width >= -0.1;
	
	                var coverTop = y <= 1;
	                var coverBottom = reachY - container.height >= -0.5;
	                positionParamsAreValid = coverLeft && coverRight && coverTop && coverBottom;
	            }
	
	            return _react2.default.createElement(
	                Area,
	                _extends({
	                    style: this.props.style,
	                    ref: function ref(r) {
	                        return _this2.container = r;
	                    },
	                    edit: editMode,
	                    onDragOver: function onDragOver(e) {
	                        e.stopPropagation();
	                        e.preventDefault();
	                    },
	                    onClick: function onClick(e) {
	                        activate(_this2.props.id);
	                        e.stopPropagation();
	                        e.preventDefault();
	                    },
	                    onDrop: function onDrop(e) {
	                        // ev.preventDefault();
	                        var url = e.dataTransfer.getData('url');
	                        if (url === _this2.props.url) return;
	
	                        change(id, _extends({}, BackgroundArea.defaultProps, { // defs
	                            x: 0,
	                            y: 0,
	                            width: null,
	                            height: null,
	                            url: url
	                        }));
	                    },
	                    active: editMode && active
	                }, this.props),
	                !editMode && !positionParamsAreValid && this.props.url && this.props.url.length ? this.renderFallback() : null,
	                editMode && !width && !positionParamsAreValid && _react2.default.createElement('div', {
	                    style: {
	                        position: 'absolute',
	                        zIndex: 100,
	                        width: '100%',
	                        textAlign: 'center',
	                        padding: 5
	                    }
	                }),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    {
	                        defaultPosition: { x: x, y: y },
	                        key: x + '_' + y + '_recreate',
	                        bounds: this.getBounds(),
	                        disabled: !this.props.editMode,
	                        onStop: function onStop(e, position) {
	                            update(_this2.props.id, { x: +position.x.toFixed(3), y: +position.y.toFixed(3) });
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(Img, {
	                            onError: this.onError,
	                            draggable: 'false',
	                            src: this.props.url,
	                            flipX: flipX,
	                            flipY: flipY,
	                            scale: scale,
	                            alt: ''
	                        })
	                    )
	                ),
	                editMode && _react2.default.createElement(ClickToEdit, { className: 'click-to-edit' })
	            );
	        }
	    }]);
	
	    return BackgroundArea;
	}(_react.Component);
	
	BackgroundArea.defaultProps = {
	    url: _cfg2.default.assets + '/assets/bgr_drop_default.png',
	    flipX: false,
	    flipY: false,
	    scale: 1
	};
	
	var CTE = _styledComponents2.default.div(_templateObject3);
	var ClickToEdit = function ClickToEdit(props) {
	    return _react2.default.createElement(
	        CTE,
	        props,
	        _react2.default.createElement(
	            'span',
	            null,
	            'Click to edit'
	        )
	    );
	};
	
	BackgroundArea.propTypes = {
	    url: _propTypes2.default.string,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    autoadjust: _propTypes2.default.bool
	};
	
	exports.default = BackgroundArea;
	
	// export default props => <div>{JSON.stringify(props)}</div>;

/***/ },
/* 1466 */,
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/bgr_drop_default.png";

/***/ },
/* 1468 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    Superliga: "@font-face {\n            font-family: 'Superliga';\n            font-style: normal;\n            font-weight: normal;\n            src: url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.woff2') format('woff2'),\n                 url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.woff') format('woff'),\n                 url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.ttf') format('truetype');\n        }",
	    Gotham: "@font-face {\n            font-family: 'Gotham';\n            font-style: normal;\n            font-weight: 400;\n            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.woff2') format('woff2'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.woff') format('woff'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.ttf') format('truetype');\n        }\n        @font-face {\n            font-family: 'Gotham';\n            font-style: normal;\n            font-weight: 300;\n            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.woff2') format('woff2'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.woff') format('woff'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.ttf') format('truetype');\n        }\n        @font-face {\n            font-family: 'Gotham';\n            font-style: normal;\n            font-weight: bold;\n            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.woff2') format('woff2'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.woff') format('woff'),\n                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.ttf') format('truetype');\n        }",
	    Flama: "@font-face {\n            font-family: 'Flama';\n            font-style: normal;\n            font-weight: 400;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-basic.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'Flama';\n            font-style: normal;\n            font-weight: 300;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-light.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'Flama';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-bold.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'Flama';\n            font-style: normal;\n            font-weight: 800;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-extrabold.otf') format('opentype');\n        }",
	    FlamaUltracondensed: "\n        @font-face {\n            font-family: 'FlamaUltracondensed';\n            font-style: normal;\n            font-weight: 400;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-basic.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'FlamaUltracondensed';\n            font-style: normal;\n            font-weight: 300;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-light.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'FlamaUltracondensed';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-bold.otf') format('opentype');\n        }\n        ",
	    FlamaSemicondensed: "\n        @font-face {\n            font-family: 'FlamaSemicondensed';\n            font-style: normal;\n            font-weight: 400;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-semicondensed-book.otf') format('opentype');\n        }\n        @font-face {\n            font-family: 'FlamaSemicondensed';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-semicondensed-bold.otf') format('opentype');\n        }\n        ",
	    MuseoSans: "\n        @font-face {\n            font-family: 'MuseoSans';\n            font-style: normal;\n            font-weight: 100;\n            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_100.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'MuseoSans';\n            font-style: normal;\n            font-weight: 300;\n            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_300.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'MuseoSans';\n            font-style: normal;\n            font-weight: 500;\n            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_500.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'MuseoSans';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_700.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'MuseoSans';\n            font-style: normal;\n            font-weight: 900;\n            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_900.otf') format('truetype');\n        }\n        ",
	    ProximaNova: "\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 100;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedThin.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 300;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedLight.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 400;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedRegular.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 500;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedMedium.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 600;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedSemibild.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedBold.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 800;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedExtrabold.otf') format('truetype');\n        }\n        @font-face {\n            font-family: 'ProximaNova';\n            font-style: normal;\n            font-weight: 900;\n            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedBlack.otf') format('truetype');\n        }\n        ",
	    FuturaBold: "\n        @font-face {\n            font-family: 'FuturaBold';\n            font-style: normal;\n            font-weight: 700;\n            src: url('https://cdn.tjekscores.dk/static/fonts/futura/Futura+Bold.otf') format('truetype');\n        }\n        "
	};

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Pitch2d = exports.Pitch3d = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pitch3d = function Pitch3d(props) {
	    return _react2.default.createElement(
	        'svg',
	        {
	            className: 'sm-pitch',
	            preserveAspectRatio: props.stretch ? 'none' : 'xMinYMin',
	            viewBox: props.viewBox || '0 0 656 520',
	            height: props.height,
	            width: props.width,
	            style: { overflow: 'visible' }
	        },
	        _react2.default.createElement(
	            'g',
	            { transform: 'translate(20, 0)' },
	            _react2.default.createElement(
	                'defs',
	                null,
	                _react2.default.createElement(
	                    'radialGradient',
	                    {
	                        cx: '50%',
	                        cy: '52.7604928%',
	                        fx: '50%',
	                        fy: '52.7604928%',
	                        r: '55.7519317%',
	                        gradientTransform: 'translate(0.500000,0.527605),scale(0.759740,1.000000),rotate(90.000000),translate(-0.500000,-0.527605)',
	                        id: 'radialGradient-1'
	                    },
	                    _react2.default.createElement('stop', { stopColor: props.stopColor0 || '#389E38', offset: '0%' }),
	                    _react2.default.createElement('stop', { stopColor: props.stopColor100 || '#287E36', offset: '100%' })
	                ),
	                _react2.default.createElement(
	                    'filter',
	                    {
	                        x: '-10.7%',
	                        y: '-7.7%',
	                        width: '121.4%',
	                        height: '128.2%',
	                        filterUnits: 'objectBoundingBox',
	                        id: 'filter-3'
	                    },
	                    _react2.default.createElement('feOffset', { dx: '0', dy: '24', 'in': 'SourceAlpha', result: 'shadowOffsetOuter1' }),
	                    _react2.default.createElement('feGaussianBlur', { stdDeviation: '10', 'in': 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
	                    _react2.default.createElement('feColorMatrix', {
	                        values: '0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0',
	                        type: 'matrix',
	                        'in': 'shadowBlurOuter1',
	                        result: 'shadowMatrixOuter1'
	                    }),
	                    _react2.default.createElement('feOffset', { dx: '0', dy: '6', 'in': 'SourceAlpha', result: 'shadowOffsetOuter2' }),
	                    _react2.default.createElement('feGaussianBlur', { stdDeviation: '4.5', 'in': 'shadowOffsetOuter2', result: 'shadowBlurOuter2' }),
	                    _react2.default.createElement('feGaussianBlur', { stdDeviation: '4.5', 'in': 'shadowMatrixOuter2', result: 'shadowBlurOuter2' }),
	                    _react2.default.createElement('feColorMatrix', {
	                        values: '0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.7 0',
	                        type: 'matrix',
	                        'in': 'shadowBlurOuter2',
	                        result: 'shadowMatrixOuter2'
	                    }),
	                    _react2.default.createElement(
	                        'feMerge',
	                        null,
	                        _react2.default.createElement('feMergeNode', { 'in': 'shadowMatrixOuter1' }),
	                        _react2.default.createElement('feMergeNode', { 'in': 'shadowMatrixOuter2' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'g',
	                { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'statium_export' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Pitch' },
	                        _react2.default.createElement('use', { fill: 'black', fillOpacity: '1', filter: 'url(#filter-3)', xlinkHref: '#path-2' }),
	                        _react2.default.createElement('use', { fill: 'url(#radialGradient-1)', fillRule: 'evenodd', xlinkHref: '#path-2' }),
	                        _react2.default.createElement('polygon', {
	                            fill: props.background || '#2A8337',
	                            id: 'path-2',
	                            points: '62.154806 0 553.845194 0 616 468 0 468'
	                        })
	                    ),
	                    _react2.default.createElement('rect', {
	                        id: 'Rectangle-3',
	                        fill: props.bottomBorder || '#1C2806',
	                        x: '-4.54747351e-13',
	                        y: '468',
	                        width: '616',
	                        height: '10'
	                    }),
	                    _react2.default.createElement(
	                        'g',
	                        {
	                            id: 'stripes',
	                            transform: 'translate(3.000000, 0.000000)',
	                            fill: props.stripes || '#fff',
	                            opacity: '0.03'
	                        },
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '58.838278 0 550.161722 0 552.853281 21.3333333 56.146719 21.3333333'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '52.455159 42.6666667 556.544841 42.666667 559.2364 64 50.7636 64'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '47.072041 85.3333333 561.927959 85.3333333 565.619519 106.666667 44.380481 106.666667'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '42.688922 128 567.311078 128 571.002637 149.333333 38.997363 149.333333'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '35.305803 170.666667 573.694197 170.666667 576.385756 192 32.614244 192'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '29.922685 213.333333 580.077315 213.333333 581.768875 234.666667 27.2311254 234.666667'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '23.539566 256 585.460434 256 589.151993 277.333333 22.8480067 277.333333'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '18.156447 298.666667 591.843553 298.666667 594.535112 320 16.4648881 320'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '11.773329 341.333333 597.226671 341.333333 598.918231 362.666667 10.0817694 362.666667'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '7.3902101 384 602.60979 384 604.301349 405.333333 4.69865073 405.333333'
	                        }),
	                        _react2.default.createElement('polygon', {
	                            id: 'Rectangle-2',
	                            points: '3.007091 426.666667 606.992909 426.666667 608.684468 448 0.315532052 448'
	                        })
	                    ),
	                    _react2.default.createElement('path', {
	                        d: 'M307.998675,52.7368421 C291.698491,52.7368421 276.790481,49.9347031 267.439948,45.2674361 L267.454135,45 L264.039415,45 L264,45.6853817 L264.32496,45.8526904 C274.271938,50.9380455 290.371873,54 307.998673,54 C325.627149,54 341.728421,50.9374594 351.675127,45.8512936 L352,45.6839986 L351.960664,45 L348.545944,45 L348.560059,45.2661148 C339.209747,49.9341505 324.300455,52.7368421 307.998675,52.7368421 Z',
	                        id: 'Oval-2',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero'
	                    }),
	                    _react2.default.createElement('path', {
	                        d: 'M308.001646,381.245614 C327.661224,381.245614 345.891895,386.227195 357.791344,394.524558 L357.805454,395 L362,395 L361.960786,393.781544 L361.541052,393.484106 C348.85265,384.443475 329.197884,379 308.001644,379 C286.803388,379 267.146955,384.444517 254.458761,393.486589 L254.039135,393.784003 L254,395 L258.194546,395 L258.208589,394.526907 C270.107876,386.228177 288.340143,381.245614 308.001646,381.245614 Z',
	                        id: 'Oval-2',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero'
	                    }),
	                    _react2.default.createElement('polygon', {
	                        id: 'Path',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero',
	                        points: '57.367181 198 560.633071 200 561 203 56 201'
	                    }),
	                    _react2.default.createElement('polygon', {
	                        id: 'Path',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero',
	                        points: '167.189221 397.303666 162.333333 457 158 457 163.193821 395 451.806179 395 457 457 452.666667 457 447.810779 397.303666'
	                    }),
	                    _react2.default.createElement('polygon', {
	                        id: 'Path',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero',
	                        points: '245.092012 436.3 244.349209 457 240 457 240.881291 434 376.118804 434 377 456.997531 372.650797 456.997531 371.908083 436.3'
	                    }),
	                    _react2.default.createElement('polygon', {
	                        id: 'Path',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero',
	                        points: '194.578855 43.6995433 199.438964 10 196.198336 10 191 45 425 45 419.801664 10 416.561036 10 421.421145 43.6995433'
	                    }),
	                    _react2.default.createElement('polygon', {
	                        id: 'Path',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero',
	                        points: '259.384019 21.7 260.125909 10 256.880208 10 256 23 360 23 359.119887 10.0013958 355.874179 10.0013958 356.615981 21.7'
	                    }),
	                    _react2.default.createElement('path', {
	                        d: 'M22.719732,455.732997 L81.967293,10.2670025 L535.032707,10.2670025 L594.280268,455.732997 L22.719732,455.732997 Z M18,458 L599,458 L537.907088,8 L79.092911,8 L18,458 Z',
	                        id: 'Rectangle',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero'
	                    }),
	                    _react2.default.createElement('path', {
	                        d: 'M308,161 C273.542791,161 244.897818,178.237037 244.019663,199.5 C243.141508,220.762963 271.786481,238 308,238 C344.213519,238 372.858492,220.762963 371.980337,199.5 C371.102182,178.237037 342.457209,161 308,161 Z M308,163.333333 C340.41889,163.333333 367.327803,179.525702 368.102741,199.5 C368.877678,219.474298 341.968765,235.666667 308,235.666667 C274.031235,235.666667 247.122322,219.474298 247.897259,199.5 C248.672197,179.525702 275.58111,163.333333 308,163.333333 Z',
	                        id: 'Combined-Shape',
	                        fill: props.lines || '#8AD58A',
	                        fillRule: 'nonzero'
	                    })
	                )
	            )
	        )
	    );
	};
	exports.default = Pitch3d;
	
	
	var Pitch2d = function Pitch2d(props) {
	    return _react2.default.createElement(
	        'svg',
	        {
	            className: 'sm-pitch',
	            preserveAspectRatio: props.stretch ? 'none' : 'xMinYMin',
	            viewBox: props.viewBox || '0 0 627 682',
	            fill: props.background || '#2A8337',
	            stroke: '#fff',
	            style: { overflow: 'visible', minHeight: props.minHeight }
	        },
	        _react2.default.createElement(
	            'g',
	            { id: 'Bg' },
	            _react2.default.createElement('rect', { y: '0', width: '626', height: '682', stroke: 'transparent' })
	        ),
	        _react2.default.createElement(
	            'g',
	            { id: 'Lines', className: 'st0' },
	            _react2.default.createElement('polyline', { className: 'st1', points: '17,682 17,16 609.4,16 609.4,682 \t' }),
	            _react2.default.createElement('path', {
	                className: 'st1',
	                d: 'M313.2,602.3c-41.8,0-75.7-34-75.7-75.8s34-75.7,75.8-75.7c41.8,0,75.7,33.9,75.7,75.8 C389,568.4,355.1,602.3,313.2,602.3C313.2,602.3,313.2,602.3,313.2,602.3z'
	            }),
	            _react2.default.createElement('path', { className: 'st1', d: 'M372.5,143.7c-26.1,32.7-73.7,38.2-106.5,12.1c-4.5-3.6-8.5-7.6-12.1-12.1' }),
	            _react2.default.createElement('line', { className: 'st1', x1: '609.4', y1: '525.4', x2: '17', y2: '525.4' }),
	            _react2.default.createElement('rect', { x: '155.7', y: '16', className: 'st1', width: '315', height: '127.7' }),
	            _react2.default.createElement('rect', { x: '242.8', y: '16', className: 'st1', width: '142', height: '41.8' })
	        )
	    );
	};
	exports.Pitch3d = Pitch3d;
	exports.Pitch2d = Pitch2d;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditWidgetBtn(_ref) {
	    var _ref$idLineUp = _ref.idLineUp,
	        idLineUp = _ref$idLineUp === undefined ? 0 : _ref$idLineUp,
	        _ref$lang = _ref.lang,
	        lang = _ref$lang === undefined ? 'en' : _ref$lang,
	        _ref$tz = _ref.tz,
	        tz = _ref$tz === undefined ? 'CET' : _ref$tz;
	
	    return _react2.default.createElement(_RaisedButton2.default, {
	        label: 'Edit Widget',
	        onClick: function onClick() {
	            _reactRouter.browserHistory.push({
	                pathname: '/sm/browser/post/TeamCustomSMWidget/',
	                query: { idLineUp: idLineUp, lang: lang, tz: tz, template: localStorage.getItem('C_DEFAULT_TEMPLATE') }
	            });
	        }
	    });
	}
	
	EditWidgetBtn.propTypes = {
	    // From connect
	    idLineUp: _propTypes2.default.number
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var user = _ref2.user,
	        _ref2$makerToolPage = _ref2.makerToolPage;
	    _ref2$makerToolPage = _ref2$makerToolPage === undefined ? {} : _ref2$makerToolPage;
	    var idLineUp = _ref2$makerToolPage.idLineUp;
	    return {
	        idLineUp: idLineUp,
	        lang: user.props && user.props.lang,
	        tz: user.props && user.props.timezone
	    };
	})(EditWidgetBtn);

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 0.53em;\n    padding-bottom: 0.53em;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 0.53em;\n    padding-bottom: 0.53em;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    padding-top: 0.33em;\n'], ['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    padding-top: 0.33em;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: inherit;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    color: ', ';\n    font-weight: inherit;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 16px;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 16px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1472);
	
	var _PPITable = __webpack_require__(1473);
	
	var _PPITable2 = _interopRequireDefault(_PPITable);
	
	var _SaveBtn = __webpack_require__(1476);
	
	var _SaveBtn2 = _interopRequireDefault(_SaveBtn);
	
	var _AddTableRow = __webpack_require__(1477);
	
	var _AddTableRow2 = _interopRequireDefault(_AddTableRow);
	
	var _Card = __webpack_require__(843);
	
	var _viewModule = __webpack_require__(1043);
	
	var _viewModule2 = _interopRequireDefault(_viewModule);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject);
	
	var HeaderLet = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3, _colors.indigo500);
	
	var BtnWrapper = _styledComponents2.default.div(_templateObject4);
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var IconTitleStyle = {
	    color: 'inherit'
	};
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	var defaultPpi = {
	    goalkeeper: {
	        in_line_up: 15,
	        subbed_in: 5,
	        clean_sheet: 100,
	        goal_assists: 100,
	        goals: 240,
	        saved_penalty: 100,
	        saves: 20,
	        total_tackle: 10,
	        blocked_pass: 0,
	        total_clearance: 0,
	        duel_won: 5,
	        total_scoring: 30,
	        missed_penalty: -50,
	        yellow_card: -25,
	        red_card: -100,
	        own_goals: -50,
	        //
	        home_win: 25,
	        away_win: 30,
	        draw: 15,
	        loosing_home: -25,
	        loosing_away: -15,
	        goals_against: -20,
	        minimum_goal_victory: 20
	    },
	    forward: {
	        in_line_up: 15,
	        subbed_in: 5,
	        clean_sheet: 85,
	        goal_assists: 75,
	        goals: 110,
	        saved_penalty: 0,
	        saves: 0,
	        total_tackle: 20,
	        blocked_pass: 5,
	        total_clearance: 2,
	        duel_won: 15,
	        total_scoring: 30,
	        missed_penalty: -50,
	        yellow_card: -25,
	        red_card: -100,
	        own_goals: -50,
	        //
	        home_win: 25,
	        away_win: 30,
	        draw: 15,
	        loosing_home: -25,
	        loosing_away: -15,
	        goals_against: -20,
	        minimum_goal_victory: 20
	    },
	    defender: {
	        in_line_up: 15,
	        subbed_in: 5,
	        clean_sheet: 0,
	        goal_assists: 75,
	        goals: 110,
	        saved_penalty: 0,
	        saves: 0,
	        total_tackle: 15,
	        blocked_pass: 0,
	        total_clearance: 0,
	        duel_won: 15,
	        total_scoring: 30,
	        missed_penalty: -50,
	        yellow_card: -25,
	        red_card: -100,
	        own_goals: -50,
	        //
	        home_win: 25,
	        away_win: 30,
	        draw: 15,
	        loosing_home: -25,
	        loosing_away: -15,
	        goals_against: 0,
	        minimum_goal_victory: 20
	    },
	    midfielder: {
	        in_line_up: 15,
	        subbed_in: 5,
	        clean_sheet: 0,
	        goal_assists: 50,
	        goals: 110,
	        saved_penalty: 0,
	        saves: 0,
	        total_tackle: 10,
	        blocked_pass: 0,
	        total_clearance: 0,
	        duel_won: 5,
	        total_scoring: 30,
	        missed_penalty: -50,
	        yellow_card: -25,
	        red_card: -100,
	        own_goals: -50,
	        //
	        home_win: 25,
	        away_win: 30,
	        draw: 15,
	        loosing_home: -25,
	        loosing_away: -15,
	        goals_against: 0,
	        minimum_goal_victory: 20
	    }
	};
	
	var defaultTableList = ['home_win', 'away_win', 'draw', 'loosing_home', 'loosing_away', 'goals_against', 'minimum_goal_victory',
	//
	'in_line_up', 'subbed_in', 'clean_sheet', 'goal_assists', 'goals', 'saved_penalty', 'saves', 'total_tackle', 'blocked_pass', 'total_clearance', 'duel_won', 'total_scoring', 'missed_penalty', 'yellow_card', 'red_card', 'own_goals'];
	
	var PlayerPerformanceIndex = function (_PureComponent) {
	    _inherits(PlayerPerformanceIndex, _PureComponent);
	
	    function PlayerPerformanceIndex() {
	        _classCallCheck(this, PlayerPerformanceIndex);
	
	        return _possibleConstructorReturn(this, (PlayerPerformanceIndex.__proto__ || Object.getPrototypeOf(PlayerPerformanceIndex)).apply(this, arguments));
	    }
	
	    _createClass(PlayerPerformanceIndex, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.loadDefaultPpiWeights(defaultPpi);
	            this.props.loadDefaultTableRowVisibleList(defaultTableList);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Card.Card,
	                { style: CardStyle },
	                _react2.default.createElement(
	                    _Card.CardHeader,
	                    { style: CardHeaderStyle },
	                    _react2.default.createElement(
	                        HeaderWrapper,
	                        null,
	                        _react2.default.createElement(
	                            HeaderLet,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                _react2.default.createElement(_viewModule2.default, { style: IconTitleStyle }),
	                                'Player Performance Formula Editor'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Card.CardText,
	                    null,
	                    _react2.default.createElement(_PPITable2.default, null),
	                    _react2.default.createElement(
	                        BtnWrapper,
	                        null,
	                        _react2.default.createElement(_AddTableRow2.default, null),
	                        _react2.default.createElement(_SaveBtn2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PlayerPerformanceIndex;
	}(_react.PureComponent);
	
	PlayerPerformanceIndex.propTypes = {
	    // From connect
	    loadDefaultPpiWeights: _propTypes2.default.func.isRequired,
	    loadDefaultTableRowVisibleList: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { loadDefaultPpiWeights: _actions.loadDefaultPpiWeights, loadDefaultTableRowVisibleList: _actions.loadDefaultTableRowVisibleList })(PlayerPerformanceIndex);

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toIdArray = undefined;
	exports.postPpiTable = postPpiTable;
	exports.loadDefaultPpiWeights = loadDefaultPpiWeights;
	exports.loadDefaultTableRowVisibleList = loadDefaultTableRowVisibleList;
	exports.addPpiTableRow = addPpiTableRow;
	exports.deletePpiTableRow = deletePpiTableRow;
	exports.changePpiTableItem = changePpiTableItem;
	
	var _constants = __webpack_require__(583);
	
	var _constants2 = __webpack_require__(579);
	
	// import { SET, DELETE, POST, GENERATE } from '../constants';
	
	// import cfg from 'cfg';
	// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
	var toIdArray = exports.toIdArray = function toIdArray(ar) {
	    return ar.reduce(function (acc, el) {
	        return el.id ? acc.concat(el.id) : acc;
	    }, []);
	};
	
	function postPpiTable() {
	    return {
	        type: _constants2.POST + _constants.PPI_TABLE
	    };
	}
	
	function loadDefaultPpiWeights(playersWeights) {
	    return {
	        type: _constants.LOAD_DEFAULT_PPI_WEIGHTS,
	        payload: { playersWeights: playersWeights }
	    };
	}
	
	function loadDefaultTableRowVisibleList(list) {
	    return {
	        type: _constants.LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST,
	        payload: { list: list }
	    };
	}
	
	function addPpiTableRow(labelRow) {
	    return {
	        type: _constants.ADD_PPI_TABLE_ROW,
	        payload: { labelRow: labelRow }
	    };
	}
	
	function deletePpiTableRow(labelRow) {
	    return {
	        type: _constants.DELETE_PPI_TABLE_ROW,
	        payload: { labelRow: labelRow }
	    };
	}
	
	function changePpiTableItem(typePlayer, label) {
	    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    return {
	        type: _constants.CHANGE_PPI_TABLE_ITEM,
	        payload: { typePlayer: typePlayer, label: label, value: value }
	    };
	}

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1472);
	
	var _PPITableRow = __webpack_require__(1474);
	
	var _PPITableRow2 = _interopRequireDefault(_PPITableRow);
	
	var _Table = __webpack_require__(988);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableHeaderStyle = {
	    backgroundColor: _colors.grey50,
	    textTransform: 'capitalize'
	};
	
	var tableRowColumnTitleStyle = {
	    width: 220
	};
	
	var tableRowColumnDeleteStyle = {
	    width: 62
	};
	
	function PPITable(_ref) {
	    var typePlayersList = _ref.typePlayersList,
	        tableRowList = _ref.tableRowList,
	        deletePpiTableRow = _ref.deletePpiTableRow;
	
	    return _react2.default.createElement(
	        _Table.Table,
	        { selectable: false, hoverable: false },
	        _react2.default.createElement(
	            _Table.TableHeader,
	            {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false,
	                style: tableHeaderStyle
	            },
	            _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { key: 'title', style: tableRowColumnTitleStyle },
	                    'Title'
	                ),
	                typePlayersList.map(function (typePlayer) {
	                    return _react2.default.createElement(
	                        _Table.TableHeaderColumn,
	                        { key: typePlayer },
	                        typePlayer
	                    );
	                }),
	                _react2.default.createElement(_Table.TableHeaderColumn, { key: 'delete', style: tableRowColumnDeleteStyle })
	            )
	        ),
	        _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false, showRowHover: false, deselectOnClickaway: false },
	            tableRowList.map(function (labelId) {
	                return _react2.default.createElement(_PPITableRow2.default, {
	                    key: labelId,
	                    labelId: labelId,
	                    typePlayersList: typePlayersList,
	                    deletePpiTableRow: deletePpiTableRow
	                });
	            })
	        )
	    );
	}
	
	PPITable.propTypes = {
	    // From connect
	    typePlayersList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    tableRowList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    deletePpiTableRow: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$ppi = _ref2.ppi,
	        tableRowVisibleList = _ref2$ppi.tableRowVisibleList,
	        typePlayersList = _ref2$ppi.typePlayersList;
	    return {
	        typePlayersList: typePlayersList,
	        tableRowList: tableRowVisibleList
	    };
	}, { deletePpiTableRow: _actions.deletePpiTableRow })(PPITable);

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PPITableRowColumnInput = __webpack_require__(1475);
	
	var _PPITableRowColumnInput2 = _interopRequireDefault(_PPITableRowColumnInput);
	
	var _TableRow = __webpack_require__(995);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableRowColumn = __webpack_require__(991);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableRowColumnTitleStyle = {
	    width: 220
	};
	
	var tableRowColumnDeleteStyle = {
	    width: 64
	};
	
	var styles = {
	    icon: {
	        width: 24,
	        height: 24
	    },
	    button: {
	        width: 40,
	        height: 40,
	        marginLeft: '-20px',
	        padding: 0
	    }
	};
	
	var PPITableRow = function (_React$PureComponent) {
	    _inherits(PPITableRow, _React$PureComponent);
	
	    function PPITableRow(props) {
	        _classCallCheck(this, PPITableRow);
	
	        return _possibleConstructorReturn(this, (PPITableRow.__proto__ || Object.getPrototypeOf(PPITableRow)).call(this, props));
	    }
	
	    _createClass(PPITableRow, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.labelId !== this.props.labelId;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                labelId = _props.labelId,
	                typePlayersList = _props.typePlayersList,
	                deletePpiTableRow = _props.deletePpiTableRow,
	                otherProps = _objectWithoutProperties(_props, ['labelId', 'typePlayersList', 'deletePpiTableRow']);
	
	            var tableProps = _extends({}, otherProps);
	            Reflect.deleteProperty(tableProps, 'dispatch');
	
	            return _react2.default.createElement(
	                _TableRow2.default,
	                tableProps,
	                _react2.default.createElement(
	                    _TableRowColumn2.default,
	                    { style: tableRowColumnTitleStyle },
	                    labelId
	                ),
	                typePlayersList.map(function (typePlayer) {
	                    return _react2.default.createElement(
	                        _TableRowColumn2.default,
	                        { key: typePlayer },
	                        _react2.default.createElement(_PPITableRowColumnInput2.default, { typePlayer: typePlayer, label: labelId })
	                    );
	                }),
	                _react2.default.createElement(
	                    _TableRowColumn2.default,
	                    { style: tableRowColumnDeleteStyle },
	                    _react2.default.createElement(
	                        _IconButton2.default,
	                        {
	                            iconStyle: styles.icon,
	                            style: styles.button,
	                            onClick: function onClick() {
	                                return deletePpiTableRow(labelId);
	                            }
	                        },
	                        _react2.default.createElement(_delete2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PPITableRow;
	}(_react2.default.PureComponent);
	
	PPITableRow.propTypes = {
	    labelId: _propTypes2.default.string.isRequired,
	    typePlayersList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    deletePpiTableRow: _propTypes2.default.func.isRequired
	};
	
	exports.default = PPITableRow;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1472);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PPITableRowColumnInput = function (_Component) {
	    _inherits(PPITableRowColumnInput, _Component);
	
	    function PPITableRowColumnInput() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PPITableRowColumnInput);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PPITableRowColumnInput.__proto__ || Object.getPrototypeOf(PPITableRowColumnInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            value: _this.props.value || 10
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PPITableRowColumnInput, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                _props$typePlayer = _props.typePlayer,
	                typePlayer = _props$typePlayer === undefined ? '' : _props$typePlayer,
	                _props$label = _props.label,
	                label = _props$label === undefined ? '' : _props$label,
	                changePpiTableItem = _props.changePpiTableItem;
	
	
	            changePpiTableItem(typePlayer, label, parseInt(this.state.value, 10));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var value = _ref2.value;
	
	            if (value != null && value !== this.state.value) {
	                this.setState({ value: value });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                _props2$typePlayer = _props2.typePlayer,
	                typePlayer = _props2$typePlayer === undefined ? '' : _props2$typePlayer,
	                _props2$label = _props2.label,
	                label = _props2$label === undefined ? '' : _props2$label,
	                changePpiTableItem = _props2.changePpiTableItem;
	            var value = this.state.value;
	
	
	            return _react2.default.createElement(_TextField2.default, {
	                fullWidth: true,
	                type: 'number',
	                value: value,
	                hintText: 'Value...',
	                onChange: function onChange(ev, newValue) {
	                    return changePpiTableItem(typePlayer, label, parseInt(newValue, 10));
	                }
	            });
	        }
	    }]);
	
	    return PPITableRowColumnInput;
	}(_react.Component);
	
	PPITableRowColumnInput.propTypes = {
	    typePlayer: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    // From Connect
	    value: _propTypes2.default.number,
	    changePpiTableItem: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref3, _ref4) {
	    var ppi = _ref3.ppi;
	    var typePlayer = _ref4.typePlayer,
	        label = _ref4.label;
	    return {
	        value: ppi.playersWeights[typePlayer] && ppi.playersWeights[typePlayer][label]
	    };
	}, { changePpiTableItem: _actions.changePpiTableItem })(PPITableRowColumnInput);

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1472);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressStyle = {
	    marginTop: '20px'
	};
	
	function SaveBtn(_ref) {
	    var loading = _ref.loading,
	        postPpiTable = _ref.postPpiTable;
	
	    return _react2.default.createElement(_RaisedButton2.default, {
	        label: loading ? _react2.default.createElement(_CircularProgress2.default, { size: 25, thickness: 2, style: ProgressStyle }) : 'Save',
	        disabled: loading,
	        onClick: function onClick() {
	            postPpiTable();
	        }
	    });
	}
	
	SaveBtn.propTypes = {
	    // From connect
	    loading: _propTypes2.default.bool,
	    postPpiTable: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null,
	// ({ makerToolPage: { pitchLineupLoading } = {} }) => ({ loading: pitchLineupLoading }),
	{ postPpiTable: _actions.postPpiTable })(SaveBtn);

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1472);
	
	var _IconMenu = __webpack_require__(900);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddTableRow(_ref) {
	    var tableRowList = _ref.tableRowList,
	        tableRowVisibleList = _ref.tableRowVisibleList,
	        addPpiTableRow = _ref.addPpiTableRow;
	
	    var hiddenRowList = tableRowList.filter(function (rowId) {
	        return !tableRowVisibleList.includes(rowId);
	    });
	
	    if (!Object.keys(hiddenRowList).length) return _react2.default.createElement(
	        'div',
	        null,
	        ' '
	    );
	
	    return _react2.default.createElement(
	        _IconMenu2.default,
	        {
	            iconButtonElement: _react2.default.createElement(
	                _IconButton2.default,
	                null,
	                _react2.default.createElement(_add2.default, null)
	            ),
	            anchorOrigin: { horizontal: 'left', vertical: 'top' },
	            targetOrigin: { horizontal: 'left', vertical: 'top' },
	            onChange: function onChange(ev, value) {
	                addPpiTableRow(value);
	            }
	        },
	        hiddenRowList.map(function (id) {
	            return _react2.default.createElement(_MenuItem2.default, { key: id, primaryText: id, value: id });
	        })
	    );
	}
	
	AddTableRow.propTypes = {
	    // From connect
	    tableRowList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    tableRowVisibleList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    addPpiTableRow: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$ppi = _ref2.ppi;
	    _ref2$ppi = _ref2$ppi === undefined ? {} : _ref2$ppi;
	    var tableRowList = _ref2$ppi.tableRowList,
	        tableRowVisibleList = _ref2$ppi.tableRowVisibleList;
	    return { tableRowList: tableRowList, tableRowVisibleList: tableRowVisibleList };
	}, { addPpiTableRow: _actions.addPpiTableRow })(AddTableRow);

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-block;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n\n    > * + * {\n        margin-left: 20px;\n    }\n'], ['\n    display: inline-block;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n\n    > * + * {\n        margin-left: 20px;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: red;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: red;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(320);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _reactRouter = __webpack_require__(188);
	
	var _CreateDialog = __webpack_require__(1480);
	
	var _CreateDialog2 = _interopRequireDefault(_CreateDialog);
	
	var _Card = __webpack_require__(843);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _viewWeek = __webpack_require__(1034);
	
	var _viewWeek2 = _interopRequireDefault(_viewWeek);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Loader = _styledComponents2.default.div(_templateObject);
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3, _colors.indigo500);
	
	var ButtonWrapper = _styledComponents2.default.div(_templateObject4);
	
	var ErrorText = _styledComponents2.default.h3(_templateObject5);
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var IconPacksStyle = {
	    color: 'inherit'
	};
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	var PacksScene = function (_PureComponent) {
	    _inherits(PacksScene, _PureComponent);
	
	    function PacksScene() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PacksScene);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PacksScene.__proto__ || Object.getPrototypeOf(PacksScene)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            createDialogOpen: false
	        }, _this.toggleCreateDialog = function () {
	            return _this.setState(function (state) {
	                return { createDialogOpen: !state.createDialogOpen };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PacksScene, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchPacks();
	            this.props.fetchWidgets();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var createDialogOpen = this.state.createDialogOpen;
	            var _props = this.props,
	                children = _props.children,
	                _props$isFinishedPack = _props.isFinishedPacks,
	                isFinishedPacks = _props$isFinishedPack === undefined ? false : _props$isFinishedPack,
	                _props$isFinishedWidg = _props.isFinishedWidgets,
	                isFinishedWidgets = _props$isFinishedWidg === undefined ? false : _props$isFinishedWidg,
	                _props$responseStatus = _props.responseStatusWidgets,
	                responseStatusWidgets = _props$responseStatus === undefined ? 0 : _props$responseStatus,
	                _props$responseStatus2 = _props.responseStatusPacks,
	                responseStatusPacks = _props$responseStatus2 === undefined ? 0 : _props$responseStatus2;
	
	            var error = responseStatusWidgets !== 200 || responseStatusPacks !== 200;
	            var isFinished = isFinishedPacks && isFinishedWidgets;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card.Card,
	                    { style: CardStyle },
	                    _react2.default.createElement(
	                        _Card.CardHeader,
	                        { style: CardHeaderStyle },
	                        _react2.default.createElement(
	                            HeaderWrapper,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                _react2.default.createElement(_viewWeek2.default, { style: IconPacksStyle }),
	                                'Packs Dashboard for Admin'
	                            ),
	                            _react2.default.createElement(
	                                ButtonWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/admin/users-packs' },
	                                    _react2.default.createElement(_RaisedButton2.default, { disabled: this.state.saving, label: "Manage user's packs" })
	                                ),
	                                _react2.default.createElement(
	                                    _RaisedButton2.default,
	                                    { onTouchTap: this.toggleCreateDialog, secondary: true, labelColor: '#fff' },
	                                    'Create'
	                                )
	                            )
	                        )
	                    ),
	                    !isFinished && _react2.default.createElement(
	                        Loader,
	                        null,
	                        _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	                    ),
	                    isFinished && error && _react2.default.createElement(
	                        ErrorText,
	                        null,
	                        'An error occurred while saving, refresh the page, or try again later!'
	                    ),
	                    isFinished && !error && children
	                ),
	                _react2.default.createElement(_CreateDialog2.default, { isOpen: createDialogOpen, toggleCreateDialog: this.toggleCreateDialog })
	            );
	        }
	    }]);
	
	    return PacksScene;
	}(_react.PureComponent);
	
	PacksScene.propTypes = {
	    children: _propTypes2.default.element.isRequired,
	    // From connect
	    fetchPacks: _propTypes2.default.func.isRequired,
	    fetchWidgets: _propTypes2.default.func.isRequired,
	    isFinishedWidgets: _propTypes2.default.bool.isRequired,
	    isFinishedPacks: _propTypes2.default.bool.isRequired,
	    responseStatusWidgets: _propTypes2.default.number.isRequired,
	    responseStatusPacks: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? {
	        queries: {}
	    } : _ref2$requery;
	    return {
	        isFinishedWidgets: (0, _lodash2.default)(requery.queries, ['GET:widgets', 'isFinished'], false),
	        isFinishedPacks: (0, _lodash2.default)(requery.queries, ['GET:packs', 'isFinished'], false),
	        responseStatusWidgets: (0, _lodash2.default)(requery.queries, ['GET:widgets', 'status'], 0),
	        responseStatusPacks: (0, _lodash2.default)(requery.queries, ['GET:packs', 'status'], 0)
	    };
	}, { fetchPacks: _actions.fetchPacks, fetchWidgets: _actions.fetchWidgets })(PacksScene);

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deletePack = exports.updatePack = exports.createPack = exports.fetchPacks = exports.fetchWidgets = undefined;
	exports.filterWidgetsText = filterWidgetsText;
	exports.getPackWidgets = getPackWidgets;
	exports.resetPackWidgets = resetPackWidgets;
	exports.postPackWidget = postPackWidget;
	exports.deletePackWidget = deletePackWidget;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _actions = __webpack_require__(593);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers = __webpack_require__(592);
	
	var _constants = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sortByName = function sortByName(arr) {
	    return arr.sort(function (packA, packB) {
	        var nameA = packA.name.toLowerCase();
	        var nameB = packB.name.toLowerCase();
	
	        if (nameA > nameB) return 1;
	        if (nameA < nameB) return -1;
	
	        return 0;
	    });
	};
	
	var fetchWidgets = exports.fetchWidgets = function fetchWidgets() {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken(),
	        update: {
	            widgets: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(_ref) {
	            var widgets = _ref.widgets;
	            return {
	                widgets: widgets.reduce(function (acc, el) {
	                    acc[el._id] = el;
	
	                    return acc;
	                }, {})
	            };
	        },
	        list: function list(_ref2) {
	            var _widgets = _ref2.widgets;
	            return {
	                widgets: function widgets() {
	                    return (0, _helpers.toIdArray)(sortByName(_widgets));
	                }
	            };
	        },
	        queryKey: 'GET:widgets',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var fetchPacks = exports.fetchPacks = function fetchPacks() {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/admin/packs?access_token=' + _auth2.default.getAccessToken(),
	        update: {
	            packs: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                packs: body.reduce(function (acc, el) {
	                    acc[el._id] = el;
	
	                    return acc;
	                }, {})
	            };
	        },
	        list: function list(body) {
	            return {
	                packs: function packs() {
	                    return (0, _helpers.toIdArray)(body);
	                }
	            };
	        },
	        queryKey: 'GET:packs',
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    });
	};
	
	var createPack = exports.createPack = function createPack(pack) {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/admin/packs?access_token=' + _auth2.default.getAccessToken(),
	        body: pack,
	        update: {
	            packs: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                packs: _defineProperty({}, body._id, body)
	            };
	        },
	        list: function list(body) {
	            return {
	                packs: function packs(prevList) {
	                    return prevList.concat(body._id);
	                }
	            };
	        },
	        queryKey: 'POST:packs',
	        options: {
	            method: _actions.httpMethods.POST,
	            headers: {
	                'Content-Type': 'application/json'
	            }
	        }
	    });
	};
	
	var updatePack = exports.updatePack = function updatePack(packId, packWidgets) {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/admin/packs/' + packId + '?access_token=' + _auth2.default.getAccessToken(),
	        body: packWidgets,
	        update: {
	            packs: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                packs: _defineProperty({}, body._id, body)
	            };
	        },
	        list: function list() {
	            return {};
	        },
	        queryKey: 'PUT:packs',
	        options: {
	            method: _actions.httpMethods.PUT
	        }
	    });
	};
	
	var deletePack = exports.deletePack = function deletePack(packId) {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/admin/packs/?access_token=' + _auth2.default.getAccessToken(),
	        body: { id: packId },
	        update: {
	            packs: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform() {
	            return {
	                packs: {}
	            };
	        },
	        list: function list(body) {
	            return {
	                packs: function packs(prevList) {
	                    return prevList.filter(function (id) {
	                        return id !== body._id;
	                    });
	                }
	            };
	        },
	        queryKey: 'DELETE:packs',
	        options: {
	            method: _actions.httpMethods.DELETE
	        }
	    });
	};
	
	function filterWidgetsText(text) {
	    return {
	        type: _constants.FILTER_WIDGETS_TEXT,
	        payload: { text: text }
	    };
	}
	
	function getPackWidgets(packId, widgets) {
	    return {
	        type: _constants.GET_PACK_WIDGETS,
	        payload: { packId: packId, widgets: widgets }
	    };
	}
	
	function resetPackWidgets() {
	    return {
	        type: _constants.RESET_PACK_WIDGETS
	    };
	}
	
	function postPackWidget(widgetId) {
	    return {
	        type: _constants.POST_PACK_WIDGET,
	        payload: { widgetId: widgetId }
	    };
	}
	
	function deletePackWidget(widgetId) {
	    return {
	        type: _constants.DELETE_PACK_WIDGET,
	        payload: { widgetId: widgetId }
	    };
	}

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var buttonCreateStyle = {
	    marginLeft: 10
	};
	
	var CreateDialog = function (_Component) {
	    _inherits(CreateDialog, _Component);
	
	    function CreateDialog() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CreateDialog);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateDialog.__proto__ || Object.getPrototypeOf(CreateDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            name: '',
	            desc: '',
	            required: false
	        }, _this.handleCreate = function () {
	            var _this$state = _this.state,
	                name = _this$state.name,
	                desc = _this$state.desc;
	
	
	            if (!name.length) {
	                _this.setState({
	                    required: true
	                });
	            } else {
	                _this.props.createPack({
	                    name: name,
	                    description: desc
	                });
	
	                _this.props.toggleCreateDialog();
	
	                _this.setState({
	                    name: '',
	                    desc: ''
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CreateDialog, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var required = this.state.required;
	            var _props = this.props,
	                isOpen = _props.isOpen,
	                toggleCreateDialog = _props.toggleCreateDialog;
	
	
	            var actions = [_react2.default.createElement(_FlatButton2.default, { key: 'Cancel', label: 'Cancel', primary: true, onClick: toggleCreateDialog }), _react2.default.createElement(_RaisedButton2.default, { key: 'Create', label: 'Create', secondary: true, onClick: this.handleCreate, style: buttonCreateStyle })];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Dialog2.default,
	                    {
	                        title: 'Create new pack',
	                        actions: actions,
	                        modal: false,
	                        open: isOpen,
	                        onRequestClose: toggleCreateDialog
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Specify name and description for new pack.'
	                    ),
	                    _react2.default.createElement(_TextField2.default, {
	                        fullWidth: true,
	                        hintText: 'Must be unique',
	                        floatingLabelText: 'Pack name*',
	                        errorText: required && 'Required',
	                        errorStyle: { red500: _colors.red500 },
	                        onChange: function onChange(e, value) {
	                            if (value.length) {
	                                _this2.setState({ name: value, required: false });
	                            } else {
	                                _this2.setState({ name: value });
	                            }
	                        }
	                    }),
	                    _react2.default.createElement(_TextField2.default, {
	                        fullWidth: true,
	                        floatingLabelText: 'Pack description',
	                        onChange: function onChange(e, value) {
	                            return _this2.setState({ desc: value });
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CreateDialog;
	}(_react.Component);
	
	CreateDialog.propTypes = {
	    isOpen: _propTypes2.default.bool.isRequired,
	    toggleCreateDialog: _propTypes2.default.func.isRequired,
	    // From connect
	    createPack: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { createPack: _actions.createPack })(CreateDialog);

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _PackColumn = __webpack_require__(1482);
	
	var _PackColumn2 = _interopRequireDefault(_PackColumn);
	
	var _Table = __webpack_require__(988);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var EmptyPacks = _styledComponents2.default.div(_templateObject);
	
	var tableHeaderStyle = {
	    backgroundColor: _colors.grey50
	};
	
	function PacksList(_ref) {
	    var _ref$packs = _ref.packs,
	        packs = _ref$packs === undefined ? {} : _ref$packs,
	        _ref$listPacks = _ref.listPacks,
	        listPacks = _ref$listPacks === undefined ? [] : _ref$listPacks,
	        deletePack = _ref.deletePack;
	
	    if (!listPacks.length) {
	        return _react2.default.createElement(
	            EmptyPacks,
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'There are no packs currently. Create the first one.'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Table.Table,
	        { selectable: false, hoverable: false },
	        _react2.default.createElement(
	            _Table.TableHeader,
	            {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false,
	                style: tableHeaderStyle
	            },
	            _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    null,
	                    'Title'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false, showRowHover: false, deselectOnClickaway: false },
	            listPacks.map(function (packId) {
	                return _react2.default.createElement(_PackColumn2.default, { key: packId, pack: packs[packId], deletePack: deletePack });
	            })
	        )
	    );
	}
	
	PacksList.propTypes = {
	    // From connect
	    packs: _propTypes2.default.object.isRequired,
	    listPacks: _propTypes2.default.array.isRequired,
	    deletePack: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? {
	        entities: {},
	        list: {}
	    } : _ref2$requery;
	    return {
	        packs: requery.entities.packs || {},
	        listPacks: requery.list.packs || []
	    };
	}, { deletePack: _actions.deletePack })(PacksList);

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(188);
	
	var _TableRow = __webpack_require__(995);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableRowColumn = __webpack_require__(991);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _DeleteDialog = __webpack_require__(1483);
	
	var _DeleteDialog2 = _interopRequireDefault(_DeleteDialog);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _deleteForever = __webpack_require__(1086);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableRowColumnDeleteStyle = {
	    width: 54,
	    paddingRight: 6,
	    paddingLeft: 0
	};
	
	var tableRowColumnDeleteDialogStyle = {
	    width: 0
	};
	
	var PackColumn = function (_Component) {
	    _inherits(PackColumn, _Component);
	
	    function PackColumn() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PackColumn);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PackColumn.__proto__ || Object.getPrototypeOf(PackColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            deleteDialogOpen: false
	        }, _this.toggleDeleteDialog = function () {
	            return _this.setState(function (state) {
	                return { deleteDialogOpen: !state.deleteDialogOpen };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PackColumn, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var deleteDialogOpen = this.state.deleteDialogOpen;
	
	            var _props = this.props,
	                _props$pack = _props.pack,
	                pack = _props$pack === undefined ? {} : _props$pack,
	                deletePack = _props.deletePack,
	                otherProps = _objectWithoutProperties(_props, ['pack', 'deletePack']);
	
	            var tableProps = _extends({}, otherProps);
	            Reflect.deleteProperty(tableProps, 'dispatch');
	
	            return _react2.default.createElement(
	                _TableRow2.default,
	                tableProps,
	                _react2.default.createElement(
	                    _TableRowColumn2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/packs/' + pack.id },
	                        pack.name
	                    )
	                ),
	                _react2.default.createElement(
	                    _TableRowColumn2.default,
	                    { style: tableRowColumnDeleteStyle },
	                    _react2.default.createElement(
	                        _IconButton2.default,
	                        {
	                            onClick: function onClick() {
	                                _this2.toggleDeleteDialog();
	                            }
	                        },
	                        _react2.default.createElement(_deleteForever2.default, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _TableRowColumn2.default,
	                    { style: tableRowColumnDeleteDialogStyle },
	                    _react2.default.createElement(_DeleteDialog2.default, {
	                        isOpen: deleteDialogOpen,
	                        deleteId: pack.id,
	                        deleteName: pack.name,
	                        deletePack: deletePack,
	                        toggleCreateDialog: this.toggleDeleteDialog
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PackColumn;
	}(_react.Component);
	
	PackColumn.propTypes = {
	    pack: _propTypes2.default.object.isRequired,
	    deletePack: _propTypes2.default.func.isRequired
	};
	
	exports.default = PackColumn;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonDeleteStyle = {
	    marginLeft: 10
	};
	
	var strongStyle = {
	    color: _colors.red400
	};
	
	function DeleteDialog(_ref) {
	    var isOpen = _ref.isOpen,
	        deleteId = _ref.deleteId,
	        deleteName = _ref.deleteName,
	        deletePack = _ref.deletePack,
	        toggleCreateDialog = _ref.toggleCreateDialog;
	
	    return _react2.default.createElement(
	        _Dialog2.default,
	        {
	            title: 'Create new pack',
	            modal: false,
	            open: isOpen,
	            onRequestClose: toggleCreateDialog,
	            actions: [_react2.default.createElement(_RaisedButton2.default, { key: 'Cancel', label: 'Cancel', secondary: true, onClick: toggleCreateDialog }), _react2.default.createElement(_FlatButton2.default, {
	                key: 'Delete',
	                label: 'Delete',
	                primary: true,
	                style: buttonDeleteStyle,
	                onClick: function onClick() {
	                    deletePack(deleteId);
	                }
	            })]
	        },
	        _react2.default.createElement(
	            'span',
	            null,
	            'Are you sure you want to delete pack ',
	            _react2.default.createElement(
	                'strong',
	                { style: strongStyle },
	                deleteName
	            ),
	            ' ? This can\'t be undone.'
	        )
	    );
	}
	
	DeleteDialog.propTypes = {
	    isOpen: _propTypes2.default.bool.isRequired,
	    deleteId: _propTypes2.default.string.isRequired,
	    deleteName: _propTypes2.default.string.isRequired,
	    deletePack: _propTypes2.default.func.isRequired,
	    toggleCreateDialog: _propTypes2.default.func.isRequired
	};
	
	exports.default = DeleteDialog;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextFilterInput = __webpack_require__(1485);
	
	var _TextFilterInput2 = _interopRequireDefault(_TextFilterInput);
	
	var _WidgetsList = __webpack_require__(1486);
	
	var _WidgetsList2 = _interopRequireDefault(_WidgetsList);
	
	var _ButtonControlWrapper = __webpack_require__(1488);
	
	var _ButtonControlWrapper2 = _interopRequireDefault(_ButtonControlWrapper);
	
	var _CardText = __webpack_require__(851);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pack(_ref) {
	    var params = _ref.params;
	
	    return _react2.default.createElement(
	        _CardText2.default,
	        null,
	        _react2.default.createElement(_TextFilterInput2.default, null),
	        _react2.default.createElement(_WidgetsList2.default, { packId: params.packId }),
	        _react2.default.createElement(_ButtonControlWrapper2.default, null)
	    );
	}
	
	Pack.propTypes = {
	    params: _propTypes2.default.object.isRequired
	};
	
	exports.default = Pack;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(1479);
	
	var _reactRedux = __webpack_require__(250);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TextFilterInput(_ref) {
	    var widgets = _ref.widgets,
	        filterWidgetsText = _ref.filterWidgetsText;
	
	    return _react2.default.createElement(_TextField2.default, {
	        fullWidth: true,
	        hintText: 'Filter by widget',
	        onChange: function onChange(e, newValue) {
	            return filterWidgetsText(newValue, widgets);
	        }
	    });
	}
	
	TextFilterInput.propTypes = {
	    // From connect
	    widgets: _propTypes2.default.object.isRequired,
	    filterWidgetsText: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? {
	        entities: {}
	    } : _ref2$requery;
	    return {
	        widgets: requery.entities.widgets
	    };
	}, { filterWidgetsText: _actions.filterWidgetsText })(TextFilterInput);

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    padding: 0;\n    list-style: none;\n'], ['\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    padding: 0;\n    list-style: none;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _WidgetCell = __webpack_require__(1487);
	
	var _WidgetCell2 = _interopRequireDefault(_WidgetCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var WidgetListWrapper = _styledComponents2.default.ul(_templateObject);
	
	function WidgetsList(_ref) {
	    var _ref$pack = _ref.pack,
	        pack = _ref$pack === undefined ? {} : _ref$pack,
	        _ref$widgets = _ref.widgets,
	        widgets = _ref$widgets === undefined ? {} : _ref$widgets,
	        _ref$listWidgets = _ref.listWidgets,
	        listWidgets = _ref$listWidgets === undefined ? [] : _ref$listWidgets,
	        getPackWidgets = _ref.getPackWidgets,
	        _ref$isResetPackWidge = _ref.isResetPackWidgets,
	        isResetPackWidgets = _ref$isResetPackWidge === undefined ? 0 : _ref$isResetPackWidge;
	
	    getPackWidgets(pack._id, pack.widgets);
	
	    return _react2.default.createElement(
	        WidgetListWrapper,
	        null,
	        listWidgets.map(function (widgetId) {
	            return _react2.default.createElement(_WidgetCell2.default, {
	                key: '' + widgetId + isResetPackWidgets,
	                widget: widgets[widgetId],
	                isChecked: pack.widgets.indexOf(widgets[widgetId].id) !== -1
	            });
	        })
	    );
	}
	
	WidgetsList.propTypes = {
	    // From connect
	    pack: _propTypes2.default.object.isRequired,
	    widgets: _propTypes2.default.object.isRequired,
	    listWidgets: _propTypes2.default.array.isRequired,
	    isResetPackWidgets: _propTypes2.default.number,
	    getPackWidgets: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2, _ref3) {
	    var packs = _ref2.packs,
	        _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { entities: { packs: {}, widgets: {} }, list: { widgets: {} } } : _ref2$requery;
	    var packId = _ref3.packId;
	    return {
	        pack: Object.values(requery.entities.packs).find(function (pack) {
	            return pack.id === packId;
	        }) || {},
	        widgets: requery.entities.widgets || {},
	        listWidgets: requery.list.widgets || [],
	        isResetPackWidgets: packs.resetPackWidgets || 0
	    };
	}, { getPackWidgets: _actions.getPackWidgets })(WidgetsList);

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _Checkbox = __webpack_require__(853);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetCell = function (_Component) {
	    _inherits(WidgetCell, _Component);
	
	    function WidgetCell() {
	        _classCallCheck(this, WidgetCell);
	
	        return _possibleConstructorReturn(this, (WidgetCell.__proto__ || Object.getPrototypeOf(WidgetCell)).apply(this, arguments));
	    }
	
	    _createClass(WidgetCell, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (this.props.isDisplay !== nextProps.isDisplay) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$widget = _props.widget,
	                widget = _props$widget === undefined ? {} : _props$widget,
	                _props$isChecked = _props.isChecked,
	                isChecked = _props$isChecked === undefined ? false : _props$isChecked,
	                _props$isDisplay = _props.isDisplay,
	                isDisplay = _props$isDisplay === undefined ? true : _props$isDisplay,
	                postPackWidget = _props.postPackWidget,
	                deletePackWidget = _props.deletePackWidget;
	
	
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(_Checkbox2.default, {
	                    type: 'checkbox',
	                    label: widget.name,
	                    onCheck: function onCheck(e, isChecked) {
	                        isChecked ? postPackWidget(widget.id) : deletePackWidget(widget.id);
	                    },
	                    defaultChecked: isChecked,
	                    disabled: !isDisplay
	                })
	            );
	        }
	    }]);
	
	    return WidgetCell;
	}(_react.Component);
	
	WidgetCell.propTypes = {
	    widget: _propTypes2.default.object.isRequired,
	    isChecked: _propTypes2.default.bool,
	    // From connect
	    isDisplay: _propTypes2.default.bool,
	    postPackWidget: _propTypes2.default.func.isRequired,
	    deletePackWidget: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref, _ref2) {
	    var packs = _ref.packs;
	    var widget = _ref2.widget;
	
	    var filterWidgetsText = packs.filterWidgetsText;
	
	    return {
	        isDisplay: filterWidgetsText ? widget.name.toLowerCase().indexOf(filterWidgetsText.toLowerCase()) !== -1 : true
	    };
	}, { postPackWidget: _actions.postPackWidget, deletePackWidget: _actions.deletePackWidget })(WidgetCell);

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    text-align: center;\n    margin: 20px;\n\n    > * {\n        margin: 0 10px;\n    }\n'], ['\n    text-align: center;\n    margin: 20px;\n\n    > * {\n        margin: 0 10px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n        margin-left: 10px;\n        font-size: 1.2em;\n        color: black;\n    }\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n        margin-left: 10px;\n        font-size: 1.2em;\n        color: black;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    margin-bottom: 20px;\n    color: red;\n'], ['\n    margin-bottom: 20px;\n    color: red;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1479);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ControlWrapper = _styledComponents2.default.div(_templateObject);
	
	var SnackbarContentWrapper = _styledComponents2.default.div(_templateObject2);
	
	var ErrorText = _styledComponents2.default.h3(_templateObject3);
	
	var snackbarSavingStyle = {
	    backgroundColor: _colors.lightGreenA700
	};
	
	var snackbarSaveStyle = {
	    backgroundColor: _colors.yellowA400
	};
	
	function SnackbarContent(_ref) {
	    var text = _ref.text,
	        isLoader = _ref.isLoader;
	
	    return _react2.default.createElement(
	        SnackbarContentWrapper,
	        null,
	        isLoader && _react2.default.createElement(_CircularProgress2.default, { size: 30, thickness: 3, color: _colors.black }),
	        _react2.default.createElement(
	            'span',
	            null,
	            text
	        )
	    );
	}
	
	SnackbarContent.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    isLoader: _propTypes2.default.bool
	};
	
	var ButtonControlWrapper = function (_Component) {
	    _inherits(ButtonControlWrapper, _Component);
	
	    function ButtonControlWrapper() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ButtonControlWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ButtonControlWrapper.__proto__ || Object.getPrototypeOf(ButtonControlWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	            saving: false,
	            saveSuccessful: false,
	            error: false
	        }, _this.handleClose = function () {
	            _this.setState(function () {
	                return { saving: false, saveSuccessful: false };
	            });
	        }, _this.handleSave = function () {
	            var _this$props = _this.props,
	                packId = _this$props.packId,
	                packWidgets = _this$props.packWidgets,
	                updatePack = _this$props.updatePack;
	
	
	            _this.setState({ saving: true, saveSuccessful: false });
	
	            Promise.resolve(updatePack(packId, packWidgets)).then(function (res) {
	                if (res.status === 200) {
	                    _this.setState({ saving: false, saveSuccessful: true });
	                } else {
	                    _this.setState({ saving: false, error: true });
	                }
	
	                return res;
	            });
	        }, _this.handleReset = function () {
	            var _this$props2 = _this.props,
	                packId = _this$props2.packId,
	                packWidgetsDefault = _this$props2.packWidgetsDefault,
	                getPackWidgets = _this$props2.getPackWidgets,
	                resetPackWidgets = _this$props2.resetPackWidgets,
	                _this$props2$isEditPa = _this$props2.isEditPackWidgets,
	                isEditPackWidgets = _this$props2$isEditPa === undefined ? true : _this$props2$isEditPa;
	
	
	            if (isEditPackWidgets) {
	                getPackWidgets(packId, packWidgetsDefault);
	                resetPackWidgets();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ButtonControlWrapper, [{
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                saving = _state.saving,
	                saveSuccessful = _state.saveSuccessful,
	                error = _state.error;
	
	
	            return _react2.default.createElement(
	                ControlWrapper,
	                null,
	                error && _react2.default.createElement(
	                    ErrorText,
	                    null,
	                    'An error occurred while saving, refresh the page, or try again later!'
	                ),
	                _react2.default.createElement(_RaisedButton2.default, { secondary: true, disabled: error || saving, label: 'Save', onTouchTap: this.handleSave }),
	                _react2.default.createElement(_RaisedButton2.default, { disabled: error || saving, label: 'Reset to previous', onTouchTap: this.handleReset }),
	                _react2.default.createElement(_Snackbar2.default, {
	                    open: !saveSuccessful && saving,
	                    message: _react2.default.createElement(SnackbarContent, { text: 'Saving pack...', isLoader: true }),
	                    onRequestClose: this.handleClose,
	                    bodyStyle: snackbarSavingStyle
	                }),
	                _react2.default.createElement(_Snackbar2.default, {
	                    open: saveSuccessful,
	                    message: _react2.default.createElement(SnackbarContent, { text: 'Save' }),
	                    autoHideDuration: 3000,
	                    onRequestClose: this.handleClose,
	                    bodyStyle: snackbarSaveStyle
	                })
	            );
	        }
	    }]);
	
	    return ButtonControlWrapper;
	}(_react.Component);
	
	ButtonControlWrapper.propTypes = {
	    // From connect
	    packId: _propTypes2.default.string.isRequired,
	    packWidgets: _propTypes2.default.array.isRequired,
	    packWidgetsDefault: _propTypes2.default.array.isRequired,
	    isEditPackWidgets: _propTypes2.default.bool,
	    updatePack: _propTypes2.default.func.isRequired,
	    getPackWidgets: _propTypes2.default.func.isRequired,
	    resetPackWidgets: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref3) {
	    var packs = _ref3.packs,
	        _ref3$requery = _ref3.requery,
	        requery = _ref3$requery === undefined ? { entities: { packs: {} } } : _ref3$requery;
	
	    var pack = Object.values(requery.entities.packs).find(function (pack) {
	        return pack._id === packs.editPackId;
	    });
	
	    return {
	        packId: packs.editPackId || '',
	        packWidgets: packs.editPackWidgets || [],
	        packWidgetsDefault: pack ? pack.widgets : [],
	        isEditPackWidgets: packs.isEditPackWidgets
	    };
	}, { updatePack: _actions.updatePack, getPackWidgets: _actions.getPackWidgets, resetPackWidgets: _actions.resetPackWidgets })(ButtonControlWrapper);

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  height: 50px;\n  line-height: 50px;\n  text-align: left;\n  font-weight: 700;\n  opacity: 0.5;\n  font-weight: 20px;\n  padding: 0;\n  text-transform: uppercase;\n  display: flex;\n"], ["\n  height: 50px;\n  line-height: 50px;\n  text-align: left;\n  font-weight: 700;\n  opacity: 0.5;\n  font-weight: 20px;\n  padding: 0;\n  text-transform: uppercase;\n  display: flex;\n"]),
	    _templateObject2 = _taggedTemplateLiteral([""], [""]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding: 0 15px 10px;\n  background: ", ";\n"], ["\n  padding: 0 15px 10px;\n  background: ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["margin: 20px 0;"], ["margin: 20px 0;"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow-y: scroll;\n"], ["\n  display: flex;\n  overflow-y: scroll;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin: 20px;\n  > * {\n    margin: 0 10px;\n  }\n"], ["\n  text-align: center;\n  margin: 20px;\n  > * {\n    margin: 0 10px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  text-align: center;\n  display: flex;\n  height: calc(100% - 284px);\n  > * {\n    margin: auto;\n  }\n"], ["\n  text-align: center;\n  display: flex;\n  height: calc(100% - 284px);\n  > * {\n    margin: auto;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(188);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _fetch = __webpack_require__(1382);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PackName = _styledComponents2.default.div(_templateObject);
	
	var PackCellWrapper = _styledComponents2.default.div(_templateObject2);
	
	var PackColumnWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.index % 2 === 0 ? "#F5F5F5" : "#FFF";
	});
	
	var UsersPacksDashboardWrapper = _styledComponents2.default.div(_templateObject4);
	
	var Table = _styledComponents2.default.div(_templateObject5);
	
	var ControlWrapper = _styledComponents2.default.div(_templateObject6);
	
	var Loader = _styledComponents2.default.div(_templateObject7);
	
	var PackColumn = function PackColumn(_ref) {
	  var users = _ref.users,
	      pack = _ref.pack,
	      onCheck = _ref.onCheck,
	      index = _ref.index;
	  var name = pack.name,
	      id = pack.id;
	
	  return _react2.default.createElement(
	    PackColumnWrapper,
	    { index: index },
	    _react2.default.createElement(
	      PackName,
	      null,
	      name,
	      " "
	    ),
	    users.map(function (u) {
	      return _react2.default.createElement(PackCell, { onCheck: onCheck, user: u, pack: pack, key: u._id });
	    })
	  );
	};
	
	var PackCell = function PackCell(_ref2) {
	  var pack = _ref2.pack,
	      user = _ref2.user,
	      _onCheck = _ref2.onCheck;
	  var _user$packs = user.packs,
	      packs = _user$packs === undefined ? [] : _user$packs,
	      username = user.username,
	      client = user.client;
	
	
	  return _react2.default.createElement(
	    PackCellWrapper,
	    null,
	    _react2.default.createElement(rmd.Checkbox, {
	      type: "checkbox",
	      label: username + " (" + client + ")",
	      onCheck: function onCheck(e, isChecked) {
	        _onCheck(user._id, pack.id, isChecked);
	      },
	      style: { whiteSpace: "nowrap" },
	      checked: packs.indexOf(pack.id) > -1
	    })
	  );
	};
	
	var UsersPacksDashboard = function (_React$Component) {
	  _inherits(UsersPacksDashboard, _React$Component);
	
	  function UsersPacksDashboard(props) {
	    _classCallCheck(this, UsersPacksDashboard);
	
	    var _this = _possibleConstructorReturn(this, (UsersPacksDashboard.__proto__ || Object.getPrototypeOf(UsersPacksDashboard)).call(this, props));
	
	    _this.handleCheck = function (userId, packId, isChecked) {
	      var users = _this.state.users;
	
	      var clonedUsers = [].concat(_toConsumableArray(users));
	      var modifiedUser = clonedUsers.find(function (u) {
	        return u._id === userId;
	      });
	
	      if (isChecked) {
	        modifiedUser.packs.push(packId);
	      } else {
	        modifiedUser.packs = modifiedUser.packs.filter(function (p) {
	          return p !== packId;
	        });
	      }
	
	      _this.setState({
	        users: clonedUsers,
	        changed: true
	      });
	    };
	
	    _this.handleSave = function () {
	      _this.setState({
	        saving: true
	      }, function () {
	        _bluebird2.default.props({
	          users: _fetch2.default.post(_cfg2.default.dash.api.host + "/api/admin/users?access_token=" + _auth2.default.getAccessToken(), { method: "PUT" }, {
	            users: _this.state.users
	          })
	        }).then(function (data) {
	          return _this.setState(_extends({}, data, {
	            saving: false,
	            showSavedNotification: true,
	            changed: false
	          }));
	        }).catch(function (err) {
	          _this.setState({
	            saving: false,
	            showErrorNotification: true,
	            errorNotificationMessage: "Could not save. Try again later."
	          });
	        });
	      });
	    };
	
	    _this.handleReset = function () {
	      _this.setState({
	        saving: true
	      }, function () {
	        _this.loadData().then(function (data) {
	          return _this.setState(_extends({}, data, {
	            saving: false,
	            changed: false,
	            showResettedNotification: true
	          }));
	        });
	      });
	    };
	
	    _this.componentDidMount = function () {
	      _this.loadData().then(function (data) {
	        _this.setState(_extends({}, data, { dataLoaded: true }));
	      }).catch(function (e) {
	        return _this.setState({ dataLoaded: true, error: true });
	      });
	    };
	
	    _this.loadData = function () {
	      return _bluebird2.default.props({
	        users: _fetch2.default.get(_cfg2.default.dash.api.host + "/api/admin/users?access_token=" + _auth2.default.getAccessToken()),
	        packs: _fetch2.default.get(_cfg2.default.dash.api.host + "/api/admin/packs?access_token=" + _auth2.default.getAccessToken())
	      }).then(function (data) {
	        return data;
	      }).catch(function (err) {
	        return void 0;
	      });
	    };
	
	    _this.state = {
	      users: [],
	      packs: [],
	      dataLoaded: false,
	      changed: false,
	      showSavedNotification: false,
	      showErrorNotification: false,
	      showResettedNotification: false,
	      newPackName: "",
	      newPackDesc: ""
	    };
	    return _this;
	  }
	
	  _createClass(UsersPacksDashboard, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          packs = _state.packs,
	          users = _state.users,
	          dataLoaded = _state.dataLoaded;
	
	
	      if (!dataLoaded) {
	        return _react2.default.createElement(
	          Loader,
	          null,
	          _react2.default.createElement(rmd.CircularProgress, { size: 80, thickness: 5 })
	        );
	      }
	
	      var noPacksAvailable = !packs.length;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !noPacksAvailable && _react2.default.createElement(
	          UsersPacksDashboardWrapper,
	          null,
	          _react2.default.createElement(
	            "h3",
	            {
	              style: {
	                display: "flex",
	                justifyContent: "space-between",
	                alignItems: "center"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              null,
	              "Users Packs Dashboard for Admin"
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/admin/packs" },
	              _react2.default.createElement(rmd.FlatButton, {
	                disabled: this.state.saving,
	                label: "Manage packs"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            Table,
	            null,
	            _lodash2.default.sortBy(packs, function (p) {
	              return p.name;
	            }).map(function (p, i) {
	              return _react2.default.createElement(PackColumn, {
	                index: i,
	                pack: p,
	                users: _lodash2.default.sortBy(users, function (u) {
	                  return u.username;
	                }),
	                key: p.name,
	                onCheck: _this2.handleCheck
	              });
	            })
	          ),
	          _react2.default.createElement(
	            ControlWrapper,
	            null,
	            _react2.default.createElement(rmd.RaisedButton, {
	              secondary: true,
	              disabled: this.state.saving || !this.state.changed,
	              label: "Reset to previous",
	              onTouchTap: this.handleReset
	            }),
	            _react2.default.createElement(rmd.RaisedButton, {
	              primary: true,
	              disabled: this.state.saving || !this.state.changed,
	              label: this.state.saving ? "Saving..." : this.state.changed ? "Save" : "Saved",
	              onTouchTap: this.handleSave
	            })
	          )
	        ),
	        noPacksAvailable && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: "calc(100% - 284px)",
	              width: "100%",
	              display: "flex"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "auto", textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontWeight: 700,
	                  fontSize: "20px",
	                  marginBottom: "15px"
	                }
	              },
	              "There are no packs currently."
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/admin/packs" },
	              _react2.default.createElement(rmd.FlatButton, {
	                disabled: this.state.saving,
	                label: "Manage packs"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(rmd.Snackbar, {
	          open: this.state.showSavedNotification,
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ showSavedNotification: false });
	          },
	          autoHideDuration: 3000,
	          message: "Successfully saved"
	        }),
	        _react2.default.createElement(rmd.Snackbar, {
	          open: this.state.showResettedNotification,
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ showResettedNotification: false });
	          },
	          autoHideDuration: 3000,
	          message: "Successfully resetted to previous state"
	        }),
	        _react2.default.createElement(rmd.Snackbar, {
	          open: this.state.showErrorNotification,
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({
	              showErrorNotification: false,
	              errorNotificationMessage: ""
	            });
	          },
	          autoHideDuration: 3000,
	          bodyStyle: { backgroundColor: "rgba(198,40,40,0.8)" },
	          message: this.state.errorNotificationMessage || "Error occured"
	        })
	      );
	    }
	  }]);
	
	  return UsersPacksDashboard;
	}(_react2.default.Component);
	
	exports.default = UsersPacksDashboard;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding: 15px 0 0;\n'], ['\n    padding: 15px 0 0;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    display: flex;\n    height: calc(100% - 284px);\n\n    > * {\n        margin: auto;\n    }\n'], ['\n    text-align: center;\n    display: flex;\n    height: calc(100% - 284px);\n\n    > * {\n        margin: auto;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n'], ['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1491);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _CommonI18Table = __webpack_require__(1492);
	
	var _CommonI18Table2 = _interopRequireDefault(_CommonI18Table);
	
	var _SaveBtn = __webpack_require__(1496);
	
	var _SaveBtn2 = _interopRequireDefault(_SaveBtn);
	
	var _SelectSecondaryLang = __webpack_require__(1497);
	
	var _SelectSecondaryLang2 = _interopRequireDefault(_SelectSecondaryLang);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Toggle = __webpack_require__(1006);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _Paper = __webpack_require__(787);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// import Chip from 'material-ui/Chip';
	
	
	// const WidgetDashboardWrapper = styled.div``;
	
	var ControlWrapper = _styledComponents2.default.div(_templateObject);
	
	var Loader = _styledComponents2.default.div(_templateObject2);
	
	var WidgetI18Header = _styledComponents2.default.div(_templateObject3);
	
	var WidgetDashboard = function (_React$Component) {
	    _inherits(WidgetDashboard, _React$Component);
	
	    function WidgetDashboard(props) {
	        _classCallCheck(this, WidgetDashboard);
	
	        var _this = _possibleConstructorReturn(this, (WidgetDashboard.__proto__ || Object.getPrototypeOf(WidgetDashboard)).call(this, props));
	
	        _this.componentDidMount = function () {
	            _this.loadData().then(function () {
	                var widgets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                var _this$props$params$wi = _this.props.params.widgetId,
	                    widgetId = _this$props$params$wi === undefined ? '' : _this$props$params$wi;
	
	                _this.loadI18(widgetId);
	
	                _this.setState({
	                    widgets: widgets,
	                    dataLoaded: true
	                });
	            }).catch(function (error) {
	                _this.setState({ dataLoaded: true, error: true });
	            });
	        };
	
	        _this.loadData = function () {
	            return fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken() + '&i18=true').then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                return data.widgets;
	            }).catch(function (err) {
	                return void 0;
	            });
	        };
	
	        _this.loadI18 = function (widgetId) {
	            var user = _auth2.default.getUser();
	            widgetId = widgetId || _this.props.params.widgetId;
	
	            return fetch('/api/i18/' + user.client + '/' + user.username + '?access_token=' + _auth2.default.getAccessToken() + '&' + (widgetId ? 'widgetId=' + widgetId : '')).then(function (res) {
	                return res.json();
	            }).then(function (_ref) {
	                var _ref$values = _ref.values,
	                    values = _ref$values === undefined ? {} : _ref$values;
	                return values[widgetId] || {};
	            }).then(function (i18) {
	                var widget = _this.state.widgets.find(function (_ref2) {
	                    var id = _ref2.id;
	                    return id === widgetId;
	                }) || {};
	                widget = _extends({}, widget, { i18: _extends({}, widget.i18, i18) });
	
	                _this.props.loadCommonDictionary(widget.i18 || {});
	
	                _this.setState({ widget: widget });
	
	                return widget;
	            }).catch(function (error) {
	                return void 0;
	            });
	        };
	
	        _this.handleSave = function (widgetId) {
	            var savingWidget = _this.state.widget;
	
	            _this.setState({
	                saving: true
	            }, function () {
	                return fetch.post(_cfg2.default.dash.api.host + '/api/admin/widgets/' + widgetId + '?access_token=' + _auth2.default.getAccessToken(), { method: 'PUT' }, {
	                    widget: savingWidget
	                }).then(function () {
	                    return fetch.get(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken());
	                }).then(function (data) {
	                    return _this.setState(_extends({}, data, {
	                        saving: false,
	                        showSavedNotification: true,
	                        changed: false
	                    }));
	                }).catch(function (err) {
	                    return void 0;
	                });
	            });
	        };
	
	        _this.renderWidgetI18 = function (widget) {
	            var inherited = _lodash2.default.get(widget, 'i18.inherited', false);
	            var dictionary = _lodash2.default.get(widget, 'i18.en', {});
	            var empty = !inherited && _lodash2.default.isEmpty(dictionary);
	            // showSavedNotification: true,
	            return _react2.default.createElement(
	                'div',
	                { key: widget.id },
	                _react2.default.createElement(
	                    WidgetI18Header,
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Widget localization'
	                    ),
	                    !inherited && !_lodash2.default.isEmpty(dictionary) && _react2.default.createElement(_SelectSecondaryLang2.default, null)
	                ),
	                _lodash2.default.get(widget, 'i18.inherited', false) && _react2.default.createElement(
	                    'div',
	                    null,
	                    'I18 is inherited from parent widget'
	                ),
	                empty ? _react2.default.createElement(
	                    'div',
	                    null,
	                    'Nothing to translate'
	                ) : _react2.default.createElement(_CommonI18Table2.default, { statsList: Object.keys(dictionary), isFinished: true })
	            );
	        };
	
	        _this.saveWidgetTranslations = function (i18) {
	            return _this.props.saveWidgetTranslations(_this.props.params && _this.props.params.widgetId, i18).then(function () {
	                _this.setState({
	                    showSavedNotification: true
	                });
	            });
	        };
	
	        _this.renderWidgetI18Controls = function () {
	            return _react2.default.createElement(
	                ControlWrapper,
	                null,
	                _react2.default.createElement(_SaveBtn2.default, { primary: true, saveCb: _this.saveWidgetTranslations })
	            );
	        };
	
	        _this.renderRlzWidget = function (widget) {
	            var user = _auth2.default.getUser();
	            // const snapshotUrl = `${config.widgets.url}/widget/${user.client}/${user.username}/default/${
	            //     widget.id
	            // }/image?a=69`;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('rlz-widget', _extends({
	                    style: { zoom: 0.5 },
	                    'data-name': widget.id,
	                    'data-username': user.username,
	                    'data-client': user.client
	                }, _RCore2.default.obj2InjectorParams(widget.spec.demo[0].props), {
	                    'data-template': user.defaultTemplateId
	                }))
	            );
	        };
	
	        _this.renderedCenteredMessage = function (message) {
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        height: 'calc(100% - 284px)',
	                        width: '100%',
	                        display: 'flex'
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: 'auto', textAlign: 'center' } },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                fontWeight: 700,
	                                fontSize: '20px',
	                                marginBottom: '15px'
	                            }
	                        },
	                        message
	                    )
	                )
	            );
	        };
	
	        _this.renderSaveButton = function (widgetId) {
	            var label = 'Saved';
	            if (_this.state.saving) label = 'Saving...';else if (_this.state.changed) label = 'Save';
	
	            return _react2.default.createElement(_RaisedButton2.default, {
	                primary: true,
	                disabled: _this.state.saving || !_this.state.changed,
	                label: label,
	                onTouchTap: function onTouchTap() {
	                    return _this.handleSave(widgetId);
	                }
	            });
	        };
	
	        _this.state = {
	            widget: {},
	            widgets: [],
	            widgetsFiltering: '',
	            newWidgetTag: '',
	            showSavedNotification: false,
	            showErrorNotification: false,
	            errorNotificationMessage: '',
	            social: true,
	            error: false
	        };
	        return _this;
	    }
	
	    _createClass(WidgetDashboard, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (nextProps.params.widgetId !== this.props.params.widgetId) {
	                var _nextProps$params$wid = nextProps.params.widgetId,
	                    widgetId = _nextProps$params$wid === undefined ? '' : _nextProps$params$wid;
	
	                this.loadI18(widgetId);
	            }
	        }
	
	        // handleLocalizationFieldChange = (widgetId, field, newValue) => {
	        //     this.setState({
	        //         widgets: this.updateWidget(widgetId, field, newValue),
	        //         changed: true,
	        //     });
	        // };
	
	        // updateWidget = (widgetId, field, value) => {
	        //     const { widgets } = this.state;
	        //     const widget = this.state.widget;
	        //     const _widget = _.cloneDeep(widget);
	        //     _.set(_widget, field, value);
	        //
	        //     const widgetIndex = _.findIndex(widgets, w => w.id === widget.id);
	        //
	        //     return [...widgets.slice(0, widgetIndex), _widget, ...widgets.slice(widgetIndex + 1)];
	        // };
	
	        // handleTagAdd = widgetId => {
	        //     const { newWidgetTag } = this.state;
	        //     const currentWidgetTags = this.state.widget.tags;
	        //
	        //     this.setState({
	        //         widgets: this.updateWidget(widgetId, 'tags', [...currentWidgetTags, newWidgetTag]),
	        //         newWidgetTag: '',
	        //         changed: true,
	        //     });
	        // };
	
	        // handleTagDelete = (widgetId, tag) => {
	        //     const currentWidgetTags = this.state.widget.tags;
	        //
	        //     this.setState({
	        //         widgets: this.updateWidget(widgetId, 'tags', currentWidgetTags.filter(t => t !== tag)),
	        //         changed: true,
	        //     });
	        // };
	
	        // renderForm = widget => {
	        //     return (
	        //         <div>
	        //             <h3>Widget name localizations</h3>
	        //             {supportedLanguages.map(locale => {
	        //                 return (
	        //                     <TextField
	        //                         key={locale}
	        //                         fullWidth
	        //                         onChange={(e, newValue) =>
	        //                             this.handleLocalizationFieldChange(widget.id, `localization.${locale}.name`, newValue)
	        //                         }
	        //                         value={_.get(widget, `localization.${locale}.name`) || ''}
	        //                         floatingLabelText={`Widget ${locale} name`}
	        //                     />
	        //                 );
	        //             })}
	        //         </div>
	        //     );
	        // };
	
	        // renderWidgetTags = widget => {
	        //     if (_.isEmpty(widget.tags)) {
	        //         return (
	        //             <strong style={{ display: 'block', margin: '14px auto 0', opacity: 0.5 }}>
	        //                 Widget does not have any tags yet.
	        //             </strong>
	        //         );
	        //     }
	        //     return widget.tags.map((tag, i) => {
	        //         return (
	        //             <Chip style={{ margin: '4px' }} key={i} onRequestDelete={() => this.handleTagDelete(widget.id, tag)}>
	        //                 {tag}
	        //             </Chip>
	        //         );
	        //     });
	        // };
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                widgets = _state.widgets,
	                dataLoaded = _state.dataLoaded,
	                widgetsFiltering = _state.widgetsFiltering;
	            var widgetId = this.props.params.widgetId;
	
	
	            if (!dataLoaded) {
	                return _react2.default.createElement(
	                    Loader,
	                    null,
	                    _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	                );
	            }
	
	            var widget = this.state.widget;
	            var widgetName = widget.name;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { opacity: 0.5 } },
	                                widgetName || 'Widgets dashboard'
	                            ),
	                            this.renderSaveButton(widgetId)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-9 wdp-container' },
	                        widget.id && this.renderWidgetI18(widget),
	                        widget.id && this.renderWidgetI18Controls(),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            widget.id && _react2.default.createElement(
	                                'div',
	                                { style: { marginTop: 20 }, className: 'col-md-12' },
	                                this.renderRlzWidget(widget)
	                            ),
	                            !widget.id && this.renderedCenteredMessage('Choose widget from right panel to start editing')
	                        ),
	                        _react2.default.createElement(_Snackbar2.default, {
	                            open: this.state.showSavedNotification,
	                            onRequestClose: function onRequestClose() {
	                                return _this2.setState({ showSavedNotification: false });
	                            },
	                            autoHideDuration: 3000,
	                            message: 'Successfully saved'
	                        }),
	                        _react2.default.createElement(_Snackbar2.default, {
	                            open: this.state.showErrorNotification,
	                            onRequestClose: function onRequestClose() {
	                                return _this2.setState({
	                                    showErrorNotification: false,
	                                    errorNotificationMessage: ''
	                                });
	                            },
	                            autoHideDuration: 3000,
	                            bodyStyle: { backgroundColor: 'rgba(198,40,40,0.8)' },
	                            message: this.state.errorNotificationMessage || 'Error occured'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-3' },
	                        _react2.default.createElement(
	                            _Paper2.default,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '1px 16px 10px' } },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { marginBottom: 0 } },
	                                    'Choose widget to edit'
	                                ),
	                                _react2.default.createElement(_TextField2.default, {
	                                    fullWidth: true,
	                                    hintText: 'Filter by widget name',
	                                    value: this.state.widgetsFiltering,
	                                    onChange: function onChange(e, newValue) {
	                                        return _this2.setState({ widgetsFiltering: newValue });
	                                    }
	                                }),
	                                _react2.default.createElement(_Toggle2.default, {
	                                    checked: this.state.social,
	                                    label: 'Social widgets only',
	                                    onToggle: function onToggle(e, val) {
	                                        _this2.setState({ social: val });
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    style: {
	                                        overflowY: 'scroll',
	                                        overflowX: 'hidden',
	                                        height: 'calc(100% - 284px)',
	                                        marginBottom: '40px'
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { paddingBottom: '400px' } },
	                                    _lodash2.default.sortBy(widgets, function (w) {
	                                        return w.id;
	                                    }).filter(function (w) {
	                                        return _this2.state.social ? w.spec.social : true;
	                                    }).filter(function (w) {
	                                        return widgetsFiltering ? (w.name || w.id).toLowerCase().indexOf(widgetsFiltering.toLowerCase()) > -1 : true;
	                                    }).map(function (w) {
	                                        return _react2.default.createElement(
	                                            _MenuItem2.default,
	                                            {
	                                                key: w.id,
	                                                style: {
	                                                    padding: 0,
	                                                    width: '100%',
	                                                    height: '20px',
	                                                    lineHeight: '20px',
	                                                    minHeight: '20px',
	                                                    fontSize: '14px'
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                {
	                                                    style: {
	                                                        display: 'block',
	                                                        padding: '0 24px',
	                                                        margin: '0 -24px',
	                                                        opacity: w.id === widgetId ? 1 : 0.4,
	                                                        textDecoration: w.id === widgetId ? 'underline' : 'none'
	                                                    },
	                                                    to: '/admin/widgets-dashboard/' + w.id
	                                                },
	                                                w.name || '[ID]: ' + w.id
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WidgetDashboard;
	}(_react2.default.Component);
	
	WidgetDashboard.propTypes = {
	    params: _propTypes2.default.shape({
	        widgetId: _propTypes2.default.string
	    }),
	    loadCommonDictionary: _propTypes2.default.func.isRequired,
	    saveWidgetTranslations: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { loadCommonDictionary: _actions.loadCommonDictionary, saveWidgetTranslations: _actions.saveWidgetTranslations })(WidgetDashboard);

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.saveWidgetTranslations = exports.saveTranslations = exports.loadCommonDictionary = exports.loadDictionary = exports.addDefaultCommonDictionary = exports.toIdArray = undefined;
	exports.changeI18TableItem = changeI18TableItem;
	exports.selectSecondaryLang = selectSecondaryLang;
	
	var _actions = __webpack_require__(593);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toIdArray = exports.toIdArray = function toIdArray(ar) {
	    return ar.reduce(function (acc, el) {
	        return el ? acc.concat(el) : acc;
	    }, []);
	};
	
	var addDefaultCommonDictionary = exports.addDefaultCommonDictionary = function addDefaultCommonDictionary(commonDictionaryEn) {
	    return {
	        type: _constants.ADD_DEFAULT_COMMON_DICTIONARY,
	        payload: { commonDictionaryEn: commonDictionaryEn }
	    };
	};
	
	var loadDictionary = exports.loadDictionary = function loadDictionary(commonDictionaryEn) {
	    var user = _auth2.default.getUser();
	
	    return (0, _actions.requestAsync)({
	        url: '/api/i18/' + user.client + '/' + user.username + '/common?access_token=' + _auth2.default.getAccessToken(),
	        update: {
	            i18: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(i18) {
	            return { i18: i18 };
	        },
	        list: function list(body) {
	            return {
	                i18: function i18() {
	                    return Object.keys(body);
	                }
	            };
	        },
	        queryKey: 'GET:i18',
	        options: {
	            method: _actions.httpMethods.GET
	        },
	        nextAction: function nextAction() {
	            return addDefaultCommonDictionary(commonDictionaryEn);
	        }
	    });
	};
	
	var loadCommonDictionary = exports.loadCommonDictionary = function loadCommonDictionary() {
	    var i18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return {
	        type: _constants.LOAD_COMMON_DICTIONARY,
	        payload: { i18: i18 }
	    };
	};
	
	var saveTranslations = exports.saveTranslations = function saveTranslations(i18) {
	    var user = _auth2.default.getUser();
	
	    return (0, _actions.requestAsync)({
	        url: '/api/i18/' + user.client + '/' + user.username + '/common?access_token=' + _auth2.default.getAccessToken(),
	        body: i18,
	        update: {
	            i18: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(i18) {
	            return { i18: i18 };
	        },
	        list: function list(body) {
	            return {
	                i18: function i18() {
	                    return Object.keys(body);
	                }
	            };
	        },
	        queryKey: 'PUT:i18',
	        options: {
	            method: _actions.httpMethods.PUT,
	            headers: {
	                'Content-Type': 'application/json'
	            }
	        }
	    });
	};
	
	var saveWidgetTranslations = exports.saveWidgetTranslations = function saveWidgetTranslations(widgetId) {
	    var i18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var user = _auth2.default.getUser();
	
	    if (!widgetId) {
	        return {
	            type: 'error'
	        };
	    }
	
	    return (0, _actions.requestAsync)({
	        url: '/api/i18/' + user.client + '/' + user.username + '?' + (widgetId ? 'widgetId=' + widgetId : '') + '&access_token=' + _auth2.default.getAccessToken(),
	        body: _defineProperty({}, widgetId, i18),
	        update: {
	            i18Widget: _actions.UPDATE_DEFAULT.LATEST
	        },
	        transform: function transform(i18Widget) {
	            return { i18Widget: i18Widget };
	        },
	        list: function list(body) {
	            return {
	                i18Widget: function i18Widget() {
	                    return Object.keys(body);
	                }
	            };
	        },
	        queryKey: 'PUT:i18Widget',
	        options: {
	            method: _actions.httpMethods.PUT,
	            headers: {
	                'Content-Type': 'application/json'
	            }
	        }
	    });
	};
	
	function changeI18TableItem(lang, label, value) {
	    return {
	        type: _constants.CHANGE_I18_TABLE_ITEM,
	        payload: { lang: lang, label: label, value: value }
	    };
	}
	
	function selectSecondaryLang(lang) {
	    return {
	        type: _constants.SELECT_SECONDARY_LANG,
	        payload: { lang: lang }
	    };
	}

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _CommonI18TableRow = __webpack_require__(1493);
	
	var _CommonI18TableRow2 = _interopRequireDefault(_CommonI18TableRow);
	
	var _SecondaryLanguageText = __webpack_require__(1495);
	
	var _SecondaryLanguageText2 = _interopRequireDefault(_SecondaryLanguageText);
	
	var _Table = __webpack_require__(988);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Loader = _styledComponents2.default.div(_templateObject);
	
	var tableHeaderStyle = {
	    backgroundColor: _colors.grey50,
	    textTransform: 'capitalize'
	};
	
	var tableRowColumnTitleStyle = {
	    width: 220
	};
	
	function CommonI18Table(_ref) {
	    var LANGUAGES = _ref.LANGUAGES,
	        defaultLanguage = _ref.defaultLanguage,
	        tableRowList = _ref.tableRowList,
	        _ref$isFinished = _ref.isFinished,
	        isFinished = _ref$isFinished === undefined ? false : _ref$isFinished;
	
	    if (!isFinished) {
	        return _react2.default.createElement(
	            Loader,
	            null,
	            _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	        );
	    }
	
	    return _react2.default.createElement(
	        _Table.Table,
	        { selectable: false, hoverable: false },
	        _react2.default.createElement(
	            _Table.TableHeader,
	            {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false,
	                style: tableHeaderStyle
	            },
	            _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { style: tableRowColumnTitleStyle },
	                    'Key'
	                ),
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    null,
	                    'Dev example'
	                ),
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    null,
	                    LANGUAGES[defaultLanguage]
	                ),
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    null,
	                    _react2.default.createElement(_SecondaryLanguageText2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false, showRowHover: false, deselectOnClickaway: false },
	            tableRowList.map(function (id) {
	                return _react2.default.createElement(_CommonI18TableRow2.default, { key: id, id: id });
	            })
	        )
	    );
	}
	
	CommonI18Table.propTypes = {
	    // From connect
	    LANGUAGES: _propTypes2.default.object.isRequired,
	    defaultLanguage: _propTypes2.default.string.isRequired,
	    tableRowList: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    isFinished: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2, _ref3) {
	    var _ref2$commonI18Dashbo = _ref2.commonI18Dashboard,
	        LANGUAGES = _ref2$commonI18Dashbo.LANGUAGES,
	        defaultLanguage = _ref2$commonI18Dashbo.defaultLanguage,
	        _ref2$commonI18Dashbo2 = _ref2$commonI18Dashbo.statsList,
	        statsList = _ref2$commonI18Dashbo2 === undefined ? [] : _ref2$commonI18Dashbo2,
	        _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { queries: {} } : _ref2$requery;
	    var _ref3$isFinished = _ref3.isFinished,
	        isFinished = _ref3$isFinished === undefined ? false : _ref3$isFinished;
	    return {
	        LANGUAGES: LANGUAGES,
	        defaultLanguage: defaultLanguage,
	        tableRowList: statsList,
	        isFinished: isFinished || requery.queries['GET:i18'] && requery.queries['GET:i18'].isFinished
	    };
	})(CommonI18Table);

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _CommonI18TableRowColumnInput = __webpack_require__(1494);
	
	var _CommonI18TableRowColumnInput2 = _interopRequireDefault(_CommonI18TableRowColumnInput);
	
	var _TableRow = __webpack_require__(995);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableRowColumn = __webpack_require__(991);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var tableRowColumnTitleStyle = {
	    width: 220
	};
	
	function CommonI18TableRow(_ref) {
	    var id = _ref.id,
	        _ref$defaultLanguage = _ref.defaultLanguage,
	        defaultLanguage = _ref$defaultLanguage === undefined ? 'en' : _ref$defaultLanguage,
	        _ref$statDefault = _ref.statDefault,
	        statDefault = _ref$statDefault === undefined ? ' ' : _ref$statDefault,
	        otherProps = _objectWithoutProperties(_ref, ['id', 'defaultLanguage', 'statDefault']);
	
	    var tableProps = _extends({}, otherProps);
	    Reflect.deleteProperty(tableProps, 'dispatch');
	
	    return _react2.default.createElement(
	        _TableRow2.default,
	        tableProps,
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            { style: tableRowColumnTitleStyle },
	            id
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            null,
	            statDefault
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            null,
	            _react2.default.createElement(_CommonI18TableRowColumnInput2.default, { lang: defaultLanguage, label: id })
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            null,
	            _react2.default.createElement(_CommonI18TableRowColumnInput2.default, { lang: 'secondary', label: id })
	        )
	    );
	}
	
	CommonI18TableRow.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    // From connect
	    statDefault: _propTypes2.default.string,
	    defaultLanguage: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2, _ref3) {
	    var _ref2$commonI18Dashbo = _ref2.commonI18Dashboard,
	        defaultLanguage = _ref2$commonI18Dashbo.defaultLanguage,
	        statsDefault = _ref2$commonI18Dashbo.statsDefault;
	    var id = _ref3.id;
	    return {
	        defaultLanguage: defaultLanguage,
	        statDefault: statsDefault[id]
	    };
	})(CommonI18TableRow);

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1491);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommonI18TableRowColumnInput = function (_Component) {
	    _inherits(CommonI18TableRowColumnInput, _Component);
	
	    function CommonI18TableRowColumnInput() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CommonI18TableRowColumnInput);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommonI18TableRowColumnInput.__proto__ || Object.getPrototypeOf(CommonI18TableRowColumnInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            value: _this.props.value || ''
	        }, _this.handleChange = function (ev, value) {
	            ev.preventDefault();
	            _this.props.changeI18TableItem(_this.props.lang, _this.props.label, value);
	            _this.setState({ value: value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CommonI18TableRowColumnInput, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var _ref2$value = _ref2.value,
	                value = _ref2$value === undefined ? '' : _ref2$value;
	
	            if (value !== this.state.value) {
	                this.setState({ value: value });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_TextField2.default, {
	                fullWidth: true,
	                type: 'text',
	                name: this.state.value,
	                value: this.state.value,
	                hintText: ' ',
	                onChange: this.handleChange
	            });
	        }
	    }]);
	
	    return CommonI18TableRowColumnInput;
	}(_react.Component);
	
	CommonI18TableRowColumnInput.propTypes = {
	    lang: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    // From Connect
	    value: _propTypes2.default.string,
	    changeI18TableItem: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref3, _ref4) {
	    var _ref3$commonI18Dashbo = _ref3.commonI18Dashboard,
	        i18 = _ref3$commonI18Dashbo.i18,
	        secondaryLanguage = _ref3$commonI18Dashbo.secondaryLanguage;
	    var lang = _ref4.lang,
	        label = _ref4.label;
	
	    lang = lang === 'secondary' ? secondaryLanguage : lang;
	
	    return {
	        value: i18[lang] && i18[lang][label]
	    };
	}, { changeI18TableItem: _actions.changeI18TableItem })(CommonI18TableRowColumnInput);

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SecondaryLanguageText(_ref) {
	    var secondaryLanguage = _ref.secondaryLanguage;
	
	    return _react2.default.createElement(
	        'span',
	        null,
	        secondaryLanguage
	    );
	}
	
	SecondaryLanguageText.propTypes = {
	    secondaryLanguage: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$commonI18Dashbo = _ref2.commonI18Dashboard,
	        LANGUAGES = _ref2$commonI18Dashbo.LANGUAGES,
	        secondaryLanguage = _ref2$commonI18Dashbo.secondaryLanguage;
	    return {
	        secondaryLanguage: LANGUAGES[secondaryLanguage]
	    };
	})(SecondaryLanguageText);

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1491);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function SaveBtn(_ref) {
	    var _ref$text = _ref.text,
	        text = _ref$text === undefined ? 'Save translations' : _ref$text,
	        i18 = _ref.i18,
	        saveCb = _ref.saveCb,
	        saveTranslations = _ref.saveTranslations,
	        propsBtn = _objectWithoutProperties(_ref, ['text', 'i18', 'saveCb', 'saveTranslations']);
	
	    return _react2.default.createElement(_RaisedButton2.default, _extends({
	        label: text,
	        onClick: function onClick() {
	            saveCb ? saveCb(i18) : saveTranslations(i18);
	        }
	    }, propsBtn));
	}
	
	SaveBtn.propTypes = {
	    text: _propTypes2.default.string,
	    saveCb: _propTypes2.default.func,
	    // From connect
	    i18: _propTypes2.default.object.isRequired,
	    saveTranslations: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$commonI18Dashbo = _ref2.commonI18Dashboard;
	    _ref2$commonI18Dashbo = _ref2$commonI18Dashbo === undefined ? {} : _ref2$commonI18Dashbo;
	    var i18 = _ref2$commonI18Dashbo.i18;
	    return {
	        i18: i18
	    };
	}, { saveTranslations: _actions.saveTranslations })(SaveBtn);

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1491);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectStyle = {
	    marginTop: -15,
	    marginRight: 20
	};
	
	var SelectSecondaryLang = function (_Component) {
	    _inherits(SelectSecondaryLang, _Component);
	
	    function SelectSecondaryLang() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SelectSecondaryLang);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectSecondaryLang.__proto__ || Object.getPrototypeOf(SelectSecondaryLang)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            value: localStorage.getItem('selectSecondaryLang') || _this.props.secondaryLanguage || ''
	        }, _this.handleChange = function (event, index, value) {
	            event.preventDefault();
	            localStorage.setItem('selectSecondaryLang', value);
	            _this.setState({ value: value });
	            _this.props.selectSecondaryLang(value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SelectSecondaryLang, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.selectSecondaryLang(this.state.value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                LANGUAGES = _props.LANGUAGES,
	                supportedLanguages = _props.supportedLanguages,
	                defaultLanguage = _props.defaultLanguage;
	
	
	            return _react2.default.createElement(
	                _SelectField2.default,
	                {
	                    floatingLabelText: 'Secondary Language',
	                    value: this.state.value,
	                    onChange: this.handleChange,
	                    style: selectStyle
	                },
	                supportedLanguages.filter(function (lang) {
	                    return lang !== defaultLanguage;
	                }).map(function (lang) {
	                    return _react2.default.createElement(_MenuItem2.default, { key: lang, value: lang, primaryText: LANGUAGES[lang] });
	                })
	            );
	        }
	    }]);
	
	    return SelectSecondaryLang;
	}(_react.Component);
	
	SelectSecondaryLang.propTypes = {
	    // From connect
	    LANGUAGES: _propTypes2.default.object.isRequired,
	    supportedLanguages: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	    defaultLanguage: _propTypes2.default.string.isRequired,
	    secondaryLanguage: _propTypes2.default.string.isRequired,
	    selectSecondaryLang: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var _ref2$commonI18Dashbo = _ref2.commonI18Dashboard,
	        LANGUAGES = _ref2$commonI18Dashbo.LANGUAGES,
	        supportedLanguages = _ref2$commonI18Dashbo.supportedLanguages,
	        defaultLanguage = _ref2$commonI18Dashbo.defaultLanguage,
	        secondaryLanguage = _ref2$commonI18Dashbo.secondaryLanguage;
	    return {
	        LANGUAGES: LANGUAGES,
	        supportedLanguages: supportedLanguages,
	        defaultLanguage: defaultLanguage,
	        secondaryLanguage: secondaryLanguage
	    };
	}, { selectSecondaryLang: _actions.selectSecondaryLang })(SelectSecondaryLang);

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n'], ['\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    margin-top: 16px;\n'], ['\n    margin-top: 16px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1491);
	
	var _CommonI18Table = __webpack_require__(1492);
	
	var _CommonI18Table2 = _interopRequireDefault(_CommonI18Table);
	
	var _SelectSecondaryLang = __webpack_require__(1497);
	
	var _SelectSecondaryLang2 = _interopRequireDefault(_SelectSecondaryLang);
	
	var _SaveBtn = __webpack_require__(1496);
	
	var _SaveBtn2 = _interopRequireDefault(_SaveBtn);
	
	var _Card = __webpack_require__(843);
	
	var _language = __webpack_require__(1037);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3, _colors.indigo500);
	
	var BtnWrapper = _styledComponents2.default.div(_templateObject4);
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var IconTitleStyle = {
	    color: 'inherit'
	};
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	var CommonI18DashboardIndex = function (_PureComponent) {
	    _inherits(CommonI18DashboardIndex, _PureComponent);
	
	    function CommonI18DashboardIndex() {
	        _classCallCheck(this, CommonI18DashboardIndex);
	
	        return _possibleConstructorReturn(this, (CommonI18DashboardIndex.__proto__ || Object.getPrototypeOf(CommonI18DashboardIndex)).apply(this, arguments));
	    }
	
	    _createClass(CommonI18DashboardIndex, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.loadDictionary(_RCore2.default.i18Register(__webpack_require__(1376), { en: {} }).en);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Card.Card,
	                { style: CardStyle },
	                _react2.default.createElement(
	                    _Card.CardHeader,
	                    { style: CardHeaderStyle },
	                    _react2.default.createElement(
	                        HeaderWrapper,
	                        null,
	                        _react2.default.createElement(
	                            HeaderLeft,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                _react2.default.createElement(_language2.default, { style: IconTitleStyle }),
	                                'Common I18n Dashboard'
	                            )
	                        ),
	                        _react2.default.createElement(_SelectSecondaryLang2.default, null),
	                        _react2.default.createElement(_SaveBtn2.default, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _Card.CardText,
	                    null,
	                    _react2.default.createElement(_CommonI18Table2.default, null),
	                    _react2.default.createElement(
	                        BtnWrapper,
	                        null,
	                        _react2.default.createElement(_SaveBtn2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CommonI18DashboardIndex;
	}(_react.PureComponent);
	
	CommonI18DashboardIndex.propTypes = {
	    // From connect
	    loadDictionary: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, { loadDictionary: _actions.loadDictionary })(CommonI18DashboardIndex);

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    .sm-wdp:hover {\n        [class*=\'__c__\'] {\n            cursor: pointer;\n            box-shadow: 0px 0px 0px 3px currentColor;\n        }\n    }\n'], ['\n    .sm-wdp:hover {\n        [class*=\'__c__\'] {\n            cursor: pointer;\n            box-shadow: 0px 0px 0px 3px currentColor;\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 0;\n    top: -35px;\n    color: ', ';\n'], ['\n    position: absolute;\n    left: 0;\n    top: -35px;\n    color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    margin: 15px 0;\n    padding: 15px 0;\n    position: relative;\n    border-top: 1px dashed ', ';\n'], ['\n    margin: 15px 0;\n    padding: 15px 0;\n    position: relative;\n    border-top: 1px dashed ', ';\n']);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _fileUpload = __webpack_require__(1385);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _clear = __webpack_require__(1501);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _WidgetNestedMenu = __webpack_require__(1502);
	
	var _WidgetNestedMenu2 = _interopRequireDefault(_WidgetNestedMenu);
	
	var _SWTProvider = __webpack_require__(1405);
	
	var _SWTProvider2 = _interopRequireDefault(_SWTProvider);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _SplitImageTPLEditor = __webpack_require__(1515);
	
	var _SplitImageTPLEditor2 = _interopRequireDefault(_SplitImageTPLEditor);
	
	var _SplitImageTPLDefaultTheme = __webpack_require__(1464);
	
	var _SplitImageTPLDefaultTheme2 = _interopRequireDefault(_SplitImageTPLDefaultTheme);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var C_TEMPLATE_SCREEN_SIZE_KEY = 'C_TEMPLATE_SCREEN_SIZE_KEY_2';
	
	var PreviewContainerWrapper = _styledComponents2.default.div(_templateObject);
	
	var DisplayElementTitle = _styledComponents2.default.p(_templateObject2, function (props) {
	    return props.color || '#fff';
	});
	
	var StandardComponentExample = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.color || '#fff';
	});
	
	function cancellable(func) {
	    var cancelled = false;
	
	    var cancellabled = function cancellabled() {
	        if (!cancelled) {
	            func.apply(undefined, arguments);
	        }
	    };
	
	    cancellabled.cancel = function () {
	        cancelled = true;
	        if (typeof func.onCancel === 'function') {
	            func.onCancel();
	        }
	    };
	
	    return cancellabled;
	}
	
	function difference(object, base) {
	    function changes(object, base) {
	        return _lodash2.default.transform(object, function (result, value, key) {
	            var isEqual = _lodash2.default.isEqual(value, base[key]);
	            var isPrimitive = _lodash2.default.isNumber(value) || _lodash2.default.isString(value) || _lodash2.default.isBoolean(value);
	
	            if (!isEqual && isPrimitive) {
	                result[key] = value;
	            } else if (!_lodash2.default.isArray(value) && _lodash2.default.isObject(value) && _lodash2.default.isObject(base[key]) && !_lodash2.default.isEmpty(value) && !isEqual) {
	                var newObj = changes(value, base[key]);
	                if (!_lodash2.default.isEmpty(newObj)) result[key] = newObj;
	            } else if (_lodash2.default.isArray(value)) {
	                var hash = base[key] && base[key].map(function (e) {
	                    return _lodash2.default.values(e).join('.');
	                }).join(',');
	                var hash2 = value && value.map(function (e) {
	                    return _lodash2.default.values(e).join('.');
	                }).join(',');
	
	                if (value.length && hash !== hash2) {
	                    result[key] = value;
	                }
	            } else if (isEqual) {
	                // console.log('else', key, value, base[key]);
	            }
	        });
	    }
	
	    return changes(object, base);
	}
	
	var displayProps = {
	    tournamentTable: {
	        row: {
	            goalsConceded: 18,
	            goalsScored: 28,
	            groupName: 'Superligaen',
	            matchesDraw: 2,
	            matchesLost: 2,
	            matchesPlayed: 11,
	            matchesWon: 7,
	            overtimeLost: 0,
	            overtimeWon: 0,
	            points: 23,
	            pointsConceded: 0,
	            pointsScored: 0,
	            rank: 1,
	            rankType: 'championship_playoff',
	            sportId: 1,
	            standingId: 236888,
	            teamId: 10202,
	            teamName: 'FC Nordsjaelland',
	            teamShortName: 'FCN',
	            tournamentStageId: 849851,
	            tournamentStageName: 'Superleague'
	        },
	        tournamentId: 46
	    },
	    title: {
	        title: 'Title example',
	        subTitle: 'Subtitle here'
	    },
	    playersList: {
	        rank: 0,
	        player: {
	            id: 175753,
	            name: 'Paal Alexander Kirkevold',
	            teamId: 9950,
	            value: 10
	        },
	        seasonId: 11488,
	        valueTitle: 'goals'
	    },
	    matchCell: {
	        event: {
	            _id: '5938a41c0b77a7617ca0650e',
	            eventId: 2511285,
	            startDate: '2017-10-13T17:00:00.000Z',
	            statusType: 'notstarted',
	            statusFull: 'Not started',
	            homeId: 8487,
	            awayId: 8113,
	            homeName: 'SoenderjyskE',
	            awayName: 'FC Midtjylland',
	            homeShortName: 'SJE',
	            awayShortName: 'FCM',
	            homeCountryId: 1,
	            awayCountryId: 1,
	            countryId: 1,
	            country: 'Denmark',
	            tournamentName: 'Superleague',
	            tournamentStageId: 849851,
	            tournamentYear: '2017/2018',
	            tournamentId: 11488,
	            tournamentTemplateId: 46,
	            sportId: 1,
	            sport: 'football',
	            teams: [8487, 8113],
	            version: 7,
	            score: {
	                away: '0',
	                home: '0'
	            },
	            properties: {
	                round: '12',
	                live: 'yes',
	                venueName: 'Sydbank Park',
	                liveStatsType: 'livestats',
	                startDateTimeToBeDecided: 'yes',
	                commentary: 'full'
	            }
	        }
	    },
	    h2hTable: {
	        dataset: [{
	            away: 36,
	            home: 46,
	            max: 46,
	            label: 'points',
	            lessIsBetter: true,
	            prefix: '#'
	        }, {
	            away: 7,
	            home: 1,
	            max: 9,
	            label: 'goals'
	        }, {
	            away: 5,
	            home: 25,
	            max: 48,
	            label: 'assists'
	        }, {
	            away: 48.6,
	            home: 52.5,
	            max: 72.4,
	            label: 'average Speed'
	        }, {
	            away: 2,
	            home: 4,
	            max: 4,
	            label: 'key Passes'
	        }, {
	            away: 3,
	            home: 5,
	            max: 5,
	            label: 'shotsOnGoal'
	        }],
	        isH2H: true,
	        chartHeight: 400,
	        event: {
	            homeShortName: 'RFC',
	            awayShortName: 'ACH',
	            statusFull: 'Finished',
	            statusType: 'finished',
	            tournamentTemplateId: 46,
	            homeId: 8410,
	            awayId: 9814,
	            score: {
	                away: '1',
	                home: '0'
	            }
	        },
	        h2h: {
	            homeTeam: {
	                wins: 4
	            },
	            awayTeam: {
	                wins: 5
	            },
	            draws: 1
	        },
	        form: {
	            home: {
	                short_results: [{ type: 'home', result: 'draw' }, { type: 'home', result: 'draw' }, { type: 'away', result: 'loss' }, { type: 'away', result: 'win' }, { type: 'home', result: 'draw' }, { type: 'away', result: 'loss' }]
	            },
	            away: {
	                short_results: [{ type: 'away', result: 'draw' }, { type: 'home', result: 'draw' }, { type: 'away', result: 'loss' }, { type: 'home', result: 'draw' }, { type: 'away', result: 'draw' }, { type: 'home', result: 'win' }]
	            }
	        },
	        limit: 6,
	        title: 'Latest',
	        h2hTitle: {
	            title: 'Latest H-2-H',
	            draw: 'Draw'
	        }
	    }
	};
	
	var TemplateCustomizer = function (_React$Component) {
	    _inherits(TemplateCustomizer, _React$Component);
	
	    function TemplateCustomizer(props, context) {
	        _classCallCheck(this, TemplateCustomizer);
	
	        var _this = _possibleConstructorReturn(this, (TemplateCustomizer.__proto__ || Object.getPrototypeOf(TemplateCustomizer)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {
	            previewSize: localStorage.getItem(C_TEMPLATE_SCREEN_SIZE_KEY) || '800px',
	            saveDialogue: false,
	            demoIndex: 0,
	            theme: _lodash2.default.clone(_SplitImageTPLDefaultTheme2.default),
	            downloadTemplateProcess: false,
	            downloadTemplateError: false,
	            snackbarOpen: false,
	            snackbarText: '',
	            importFileLoaded: false
	        };
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(TemplateCustomizer, [{
	        key: 'renderEditor',
	        value: function renderEditor() {
	            var _state = this.state,
	                theme = _state.theme,
	                template = _state.template,
	                tid = _state.tid,
	                wid = _state.wid,
	                variation = _state.variation,
	                widgets = _state.widgets;
	
	
	            var custom = _lodash2.default.get(template.theme, 'widgets.' + wid, null);
	            var customVariation = _lodash2.default.get(template.theme, 'variations.' + wid + '.' + variation, null);
	
	            var widgetProps = _lodash2.default.get(template, 'widgetProps.' + wid, {});
	            var widgetPropsVariation = _lodash2.default.get(template.theme, 'variations.' + wid + '.' + variation + '.widgetProps', null);
	
	            var widget = _lodash2.default.find(widgets, function (w) {
	                return w.id === wid;
	            });
	
	            return _react2.default.createElement(_SplitImageTPLEditor2.default, {
	                ref: 'editor',
	                key: wid + '_' + tid + '_' + variation,
	                widgetId: wid,
	                widget: widget,
	                theme: theme,
	                template: this.state.template,
	                overriden: customVariation || custom || {},
	                widgetProps: widgetPropsVariation || widgetProps || {},
	                onChange: this.handleThemeChange,
	                onCustomColorChange: this.handleCustomColorChange,
	                onWidgetPropsChange: this.handlePropsChange,
	                onWidgetResetProperty: this.handleWidgetResetProperty
	            });
	        }
	    }, {
	        key: 'renderStandardPreview',
	        value: function renderStandardPreview() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var user = this.context.user;
	            var _state2 = this.state,
	                tid = _state2.tid,
	                theme = _state2.theme,
	                template = _state2.template,
	                wid = _state2.wid,
	                variation = _state2.variation,
	                widgets = _state2.widgets,
	                downloadTemplateProcess = _state2.downloadTemplateProcess,
	                snackbarOpen = _state2.snackbarOpen,
	                snackbarText = _state2.snackbarText,
	                importFileLoaded = _state2.importFileLoaded,
	                downloadTemplateError = _state2.downloadTemplateError,
	                widgetTemplate = _state2.widgetTemplate;
	
	
	            if (!widgets) return _react2.default.createElement(
	                'div',
	                null,
	                'Loading'
	            );
	
	            var widget = _lodash2.default.find(widgets, function (w) {
	                return w.id === wid;
	            });
	
	            var customStylingsFor = _lodash2.default.chain(Object.keys(_lodash2.default.get(template, 'theme.widgets', []))).map(function (wid) {
	                return _lodash2.default.find(widgets, function (w) {
	                    return w.id === wid;
	                });
	            }).compact().value();
	
	            theme.editing = true;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'widget-customizer' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-customizer__variables', style: { zIndex: 11, paddingTop: '20px' } },
	                    template && _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'card widget-params', initiallyExpanded: true },
	                        _react2.default.createElement(rmd.CardHeader, {
	                            title: template && template.name,
	                            subtitle: template && 'id: ' + template.id
	                        }),
	                        _react2.default.createElement(rmd.CardText, { expandable: true, style: { padding: 0 } })
	                    ),
	                    this.renderEditor()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-customizer__content' },
	                    _react2.default.createElement(
	                        rmd.Card,
	                        { className: 'card widget-preview', style: { zIndex: 10 } },
	                        _react2.default.createElement(
	                            rmd.Toolbar,
	                            null,
	                            _react2.default.createElement(
	                                rmd.ToolbarGroup,
	                                null,
	                                _react2.default.createElement(_WidgetNestedMenu2.default, {
	                                    style: { width: 350 },
	                                    title: 'Select widget',
	                                    widgets: widgets,
	                                    widgetId: wid,
	                                    disabled: !tid,
	                                    onChange: function onChange(event, value) {
	                                        _this2.props.router.replace({
	                                            pathname: '/sm/templates/edit',
	                                            query: {
	                                                tid: tid,
	                                                wid: value.id,
	                                                variation: variation
	                                            }
	                                        });
	                                    }
	                                }),
	                                wid && _react2.default.createElement(rmd.FlatButton, {
	                                    label: 'Go to generic styling',
	                                    onClick: function onClick() {
	                                        _this2.props.router.replace({
	                                            pathname: '/sm/templates/edit',
	                                            query: {
	                                                tid: tid
	                                            }
	                                        });
	                                    }
	                                }),
	                                _react2.default.createElement(rmd.FlatButton, {
	                                    label: 'Default',
	                                    onClick: function onClick(e) {
	                                        _this2.props.router.replace({
	                                            pathname: '/sm/templates/edit',
	                                            query: {
	                                                tid: tid,
	                                                wid: wid
	                                            }
	                                        });
	                                    }
	                                }),
	                                wid && Object.keys(_lodash2.default.get(widgetTemplate.theme, 'variations.' + wid, {})).filter(function (key) {
	                                    return key[0] === 'v';
	                                }).map(function (v) {
	                                    return _react2.default.createElement(rmd.FlatButton, {
	                                        key: v,
	                                        label: v,
	                                        onClick: function onClick(e) {
	                                            _this2.props.router.replace({
	                                                pathname: '/sm/templates/edit',
	                                                query: {
	                                                    tid: tid,
	                                                    wid: wid,
	                                                    variation: v
	                                                }
	                                            });
	                                        }
	                                    });
	                                })
	                            ),
	                            _react2.default.createElement(
	                                rmd.ToolbarGroup,
	                                { lastChild: true },
	                                _react2.default.createElement(rmd.FlatButton, {
	                                    label: 'Reset widget colors',
	                                    onClick: function onClick() {
	                                        _this2.handleThemeChange(_extends({}, _this2.state.theme, {
	                                            widgetsColors: _extends({}, _this2.state.theme.widgetsColors, _defineProperty({}, wid, null))
	                                        }));
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            rmd.CardText,
	                            { className: 'wdp-preview-container' },
	                            wid && _react2.default.createElement(
	                                PreviewContainerWrapper,
	                                null,
	                                wid && widget && widget.spec && widget.spec.demo && widget.spec.demo.map(function (demo) {
	                                    var CMP = _lodash2.default.get(window, '[rlz' + wid + '][' + wid + ']');
	
	                                    if (!CMP) return;
	
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            key: demo.title,
	                                            id: 'wdp-preview',
	                                            className: 'wdp-preview wdp-preview-800px'
	                                        },
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            'DEMO Widget - ',
	                                            demo.title || demo.name,
	                                            ' ',
	                                            _lodash2.default.get(user, 'props.lang')
	                                        ),
	                                        _react2.default.createElement(
	                                            _WDPContext2.default,
	                                            {
	                                                client: user.client,
	                                                user: user.username,
	                                                token: user.accessToken,
	                                                lang: _lodash2.default.get(user, 'props.lang'),
	                                                key: _lodash2.default.get(template, 'id'),
	                                                social: true,
	                                                variation: variation
	                                            },
	                                            _react2.default.createElement(CMP, _extends({
	                                                name: wid
	                                            }, demo.props, {
	                                                social: true,
	                                                tempTemplate: _lodash2.default.extend({}, template, { theme: theme }),
	                                                variation: variation,
	                                                client: user.client,
	                                                user: user.username,
	                                                lang: _lodash2.default.get(user, 'props.lang'),
	                                                token: user.accessToken,
	                                                template: _lodash2.default.get(template, 'id')
	                                            }))
	                                        )
	                                    );
	                                })
	                            ),
	                            (tid && theme || !tid) && !wid && _react2.default.createElement(
	                                'div',
	                                { id: 'wdp-preview', className: 'wdp-preview wdp-preview-800px' },
	                                _react2.default.createElement(
	                                    _WDPContext2.default,
	                                    { social: true },
	                                    _react2.default.createElement(
	                                        _SWTProvider2.default,
	                                        { templateData: template, userTheme: theme },
	                                        _react2.default.createElement('div', { empty: true }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            this.renderDisplay()
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            rmd.CardActions,
	                            {
	                                style: {
	                                    display: 'flex',
	                                    justifyContent: 'space-between'
	                                }
	                            },
	                            !tid && _react2.default.createElement(rmd.FlatButton, {
	                                label: 'Create template',
	                                onClick: function onClick() {
	                                    _this2.setState({ saveDialogue: true });
	                                }
	                            }),
	                            tid && [_react2.default.createElement(
	                                'div',
	                                {
	                                    key: '1',
	                                    style: {
	                                        textAlign: 'left',
	                                        flexGrow: 1
	                                    }
	                                },
	                                _react2.default.createElement(rmd.FlatButton, { label: 'Save changes', onClick: this.handleSaveOrUpdate })
	                            ), _react2.default.createElement(
	                                'div',
	                                { key: '2' },
	                                _react2.default.createElement(
	                                    rmd.FlatButton,
	                                    {
	                                        label: 'Import',
	                                        style: { position: 'relative' },
	                                        icon: importFileLoaded ? _react2.default.createElement(rmd.CircularProgress, { size: 24 }) : _react2.default.createElement(_fileUpload2.default, null)
	                                    },
	                                    _react2.default.createElement(
	                                        'label',
	                                        {
	                                            htmlFor: 'import-file',
	                                            style: {
	                                                position: 'absolute',
	                                                top: 0,
	                                                right: 0,
	                                                bottom: 0,
	                                                left: 0,
	                                                opacity: 0,
	                                                zIndex: 9,
	                                                cursor: 'pointer'
	                                            }
	                                        },
	                                        'Import'
	                                    )
	                                ),
	                                _react2.default.createElement('input', {
	                                    hidden: true,
	                                    accept: 'application/json',
	                                    type: 'file',
	                                    id: 'import-file',
	                                    onChange: this.handleImport
	                                })
	                            ), _react2.default.createElement(rmd.FlatButton, {
	                                key: 'export',
	                                label: 'Export',
	                                onClick: this.handleExport(template.id),
	                                disabled: downloadTemplateError,
	                                icon: function () {
	                                    if (downloadTemplateError) {
	                                        return _react2.default.createElement(_clear2.default, null);
	                                    } else if (downloadTemplateProcess) {
	                                        return _react2.default.createElement(rmd.CircularProgress, { size: 24 });
	                                    } else {
	                                        return _react2.default.createElement(_fileDownload2.default, null);
	                                    }
	                                }()
	                            })]
	                        )
	                    ),
	                    customStylingsFor.length !== 0 && _react2.default.createElement(
	                        rmd.Card,
	                        { style: { margin: '16px 0' } },
	                        _react2.default.createElement(rmd.CardHeader, { title: 'Individually styled widgets' }),
	                        _react2.default.createElement(rmd.Divider, null),
	                        _react2.default.createElement(
	                            rmd.List,
	                            { defaultValue: wid },
	                            customStylingsFor.map(function (w) {
	                                return _react2.default.createElement(rmd.ListItem, {
	                                    style: { backgroundColor: wid === w.id ? '#eaeaea' : null },
	                                    key: w.id,
	                                    primaryText: w.name,
	                                    secondaryText: Object.keys(template.theme.widgets[w.id]).join(', '),
	                                    onClick: function onClick(e) {
	                                        _this2.props.router.replace('/sm/templates/edit?tid=' + tid + '&wid=' + w.id);
	                                    }
	                                });
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        rmd.Dialog,
	                        {
	                            title: 'Save this template',
	                            actions: _lodash2.default.compact([_react2.default.createElement(rmd.FlatButton, {
	                                label: 'Close',
	                                onClick: function onClick() {
	                                    _this2.setState({ saveDialogue: false });
	                                }
	                            }), _react2.default.createElement(rmd.FlatButton, { primary: true, label: 'Save changes', onClick: this.handleSaveOrUpdate })]),
	                            modal: false,
	                            open: this.state.saveDialogue,
	                            onRequestClose: this.handleClose
	                        },
	                        _react2.default.createElement(rmd.TextField, {
	                            ref: 'name',
	                            key: 'name',
	                            name: this.state.name,
	                            floatingLabelText: 'Template name',
	                            style: { width: '100%' },
	                            onChange: function onChange(e, name) {
	                                _this2.setState({ name: name });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(_Snackbar2.default, {
	                        open: snackbarOpen,
	                        message: snackbarText || 'Sorry, there was an error',
	                        autoHideDuration: 5000,
	                        onRequestClose: function onRequestClose() {
	                            _this2.setState({
	                                snackbarOpen: false,
	                                snackbarText: ''
	                            });
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TemplateCustomizer;
	}(_react2.default.Component);
	
	TemplateCustomizer.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    router: _propTypes2.default.object.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.componentDidMount = function () {};
	
	    this.componentWillReceiveProps = function (nextProps, nextState) {
	        var _state3 = _this3.state,
	            wid = _state3.wid,
	            variation = _state3.variation;
	
	        var newWid = _lodash2.default.get(nextProps, 'router.location.query.wid');
	        var newVariation = _lodash2.default.get(nextProps, 'router.location.query.variation');
	
	        if (newWid !== wid || variation !== newVariation) {
	            _this3.setState({
	                r: Math.round()
	            }, function () {
	                _this3.loadData();
	            });
	        }
	    };
	
	    this.loadData = function () {
	        var tid = _lodash2.default.get(_this3.props, 'location.query.tid');
	        var wid = _lodash2.default.get(_this3.props, 'location.query.wid');
	        var variation = _lodash2.default.get(_this3.props, 'location.query.variation');
	
	        var user = _this3.context.user;
	        var client = user.client,
	            username = user.username;
	
	
	        var authToken = _auth2.default.getAccessToken();
	
	        return _RCore2.default.promiseProps({
	            template: fetch(_cfg2.default.dash.api.host + '/api/clients/' + client + '/users/' + username + '/templates/' + tid).then(function (response) {
	                return response.json();
	            }),
	            widgetTemplate: Reflect.apply(_SWTProvider.loadDataFunc, _this3, [client, username, tid, wid, variation]),
	            widgets: _this3.state.widgets || fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + authToken).then(function (response) {
	                return response.json();
	            }).then(function (resp) {
	                return [].concat(_toConsumableArray(resp.widgets));
	            }),
	            wid: wid,
	            tid: tid,
	            variation: variation
	        }).then(function (res) {
	            var widgetTemplate = res.widgetTemplate;
	
	
	            _this3.setState(_extends({ theme: widgetTemplate.theme }, res), function () {
	                if (wid) _this3.loadWidget();
	            });
	        }).catch(function (err) {});
	    };
	
	    this.loadWidget = function () {
	        var wid = _this3.state.wid;
	
	        _this3.widgetRequestCallback = cancellable(function () {
	            _this3.setState(_defineProperty({}, wid, true));
	        });
	
	        if (wid && !_this3.state[wid]) {
	            window.wdpload(wid, {}, {}, _this3.widgetRequestCallback);
	        }
	    };
	
	    this.handleSaveOrUpdate = function () {
	        var _state4 = _this3.state,
	            tid = _state4.tid,
	            wid = _state4.wid,
	            variation = _state4.variation;
	
	        var url = _cfg2.default.dash.api.host + '/api/templates';
	        if (tid) url = url + ('?id=' + tid);
	
	        var toSave = _this3.state.theme;
	
	        if (wid) {
	            // if we are saving widget
	            toSave = _extends({}, _this3.state.template.theme);
	        }
	
	        return fetch(url, {
	            method: 'post',
	            body: JSON.stringify({
	                name: _this3.state.name,
	                template: 'SplitImageTPL',
	                theme: toSave
	            }),
	            headers: {
	                'Content-Type': 'application/json',
	                authorization: _auth2.default.getAccessToken()
	            }
	        }).then(function (response) {
	            return response.json();
	        }).then(function (tpl) {
	            _this3.context.router.replace(_extends({}, _this3.props.location, {
	                query: { tid: tid || tpl.id, wid: wid, variation: variation }
	            }));
	            _this3.setState({
	                saveDialogue: false,
	                snackbarOpen: true,
	                snackbarText: 'DONE: Template saved'
	            });
	        }).catch(function (err) {
	            _this3.setState({
	                saveDialogue: false,
	                snackbarOpen: true,
	                snackbarText: 'ERROR: Sorry, there was an error'
	            });
	        });
	    };
	
	    this.renderDisplay = function () {
	        var user = _this3.context.user;
	        var _state5 = _this3.state,
	            theme = _state5.theme,
	            wid = _state5.wid,
	            template = _state5.template;
	
	
	        if (_lodash2.default.isEmpty(theme)) return null;
	
	        var displayComponents = Object.keys(theme.display).map(function (element) {
	            var Component = _StyledUI.styledUI.getDisplay({ theme: theme }, element);
	            var componentProps = displayProps[element];
	
	            if (!Component || _lodash2.default.isEmpty(componentProps)) return _react2.default.createElement('div', null);
	
	            var Wrapper = void 0;
	            var elementTitle = 'Standard component "' + element + '" - ' + _lodash2.default.get(theme, 'display[' + element + ']', 'default');
	
	            switch (element) {
	                // case 'tournamentTable':
	                //     Wrapper = props => {
	                //         return (
	                //             <StandardComponentExample color={theme.color}>
	                //                 <DisplayElementTitle>{elementTitle}</DisplayElementTitle>
	                //                 <div>{props.children}</div>
	                //             </StandardComponentExample>
	                //         );
	                //     };
	                //     break;
	                case 'playersList':
	                    Wrapper = function Wrapper(props) {
	                        return _react2.default.createElement(
	                            StandardComponentExample,
	                            null,
	                            _react2.default.createElement(
	                                DisplayElementTitle,
	                                null,
	                                elementTitle
	                            ),
	                            props.children
	                        );
	                    };
	                    break;
	                default:
	                    Wrapper = function Wrapper(props) {
	                        return _react2.default.createElement(
	                            StandardComponentExample,
	                            null,
	                            _react2.default.createElement(
	                                DisplayElementTitle,
	                                null,
	                                elementTitle
	                            ),
	                            props.children
	                        );
	                    };
	            }
	
	            if (['tournamentTable'].includes(element)) {
	                return _react2.default.createElement(
	                    Wrapper,
	                    { key: elementTitle },
	                    _react2.default.createElement(
	                        Component.Container,
	                        componentProps,
	                        _react2.default.createElement(Component.Header, componentProps),
	                        _react2.default.createElement(Component.Row, componentProps),
	                        _react2.default.createElement(Component.Row, componentProps)
	                    )
	                );
	            }
	
	            if (['matchCell'].includes(element)) {
	                return _react2.default.createElement(
	                    Wrapper,
	                    { key: elementTitle },
	                    _react2.default.createElement(
	                        Component.Container,
	                        componentProps,
	                        _react2.default.createElement(Component.MatchCellHeader, componentProps),
	                        _react2.default.createElement(Component.MatchCell, componentProps)
	                    )
	                );
	            }
	
	            if (['playersList'].includes(element)) {
	                return _react2.default.createElement(
	                    Wrapper,
	                    { key: elementTitle },
	                    _react2.default.createElement(
	                        Component.Container,
	                        componentProps,
	                        _react2.default.createElement(Component.Header, componentProps),
	                        _react2.default.createElement(Component.Row, _extends({}, componentProps, { rank: 0 })),
	                        _react2.default.createElement(Component.Row, _extends({}, componentProps, { rank: 1 }))
	                    )
	                );
	            }
	
	            if (['h2hTable'].includes(element)) {
	                return _react2.default.createElement(
	                    Wrapper,
	                    { key: elementTitle },
	                    _react2.default.createElement(
	                        Component.Container,
	                        componentProps,
	                        _react2.default.createElement(Component.Header, componentProps),
	                        _react2.default.createElement(Component.LatestFormRow, componentProps),
	                        _react2.default.createElement(Component.Rows, componentProps),
	                        _react2.default.createElement(Component.H2HRow, componentProps)
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                Wrapper,
	                { key: elementTitle },
	                _react2.default.createElement(Component, componentProps)
	            );
	        });
	
	        return displayComponents;
	    };
	
	    this.handleCustomColorChange = function (widgetId, colors) {
	        var _state6 = _this3.state,
	            wid = _state6.wid,
	            template = _state6.template,
	            variation = _state6.variation,
	            theme = _state6.theme;
	
	
	        if (variation) {
	            var customColors = _lodash2.default.get(theme, 'variations.' + wid + '.' + variation + '.customColors');
	            _lodash2.default.set(theme, 'variations.' + wid + '.' + variation + '.customColors', _extends({}, customColors, colors));
	            _lodash2.default.set(template.theme, 'variations.' + wid + '.' + variation + '.customColors', _extends({}, customColors, colors));
	
	            _lodash2.default.set(theme, 'variations.' + wid + '.' + variation + '.customColors', _extends({}, customColors, colors));
	            _lodash2.default.set(theme, 'customColors', _extends({}, customColors, colors));
	
	            _this3.forceUpdate();
	            _this3.setState({
	                theme: _extends({}, theme)
	            });
	        } else {
	            var _customColors = _lodash2.default.get(theme, 'widgetsColors.' + wid);
	
	            _lodash2.default.set(template.theme.widgetsColors, wid, _extends({}, _customColors, colors));
	            _lodash2.default.set(theme.widgetsColors, wid, _extends({}, _customColors, colors));
	            _this3.forceUpdate();
	
	            _this3.setState({
	                theme: _extends({}, theme)
	            });
	        }
	    };
	
	    this.handleThemeChange = function (theme) {
	        if (!theme) return;
	
	        var _state7 = _this3.state,
	            wid = _state7.wid,
	            template = _state7.template,
	            variation = _state7.variation;
	
	
	        if (wid) {
	            var _theme = _extends({}, _this3.state.template.theme); // original loaded theme
	            var changed = difference(theme, _theme); // DIFFERENCE TO ORIGINAL THEME
	            if (!_lodash2.default.isEmpty(changed)) {
	                if (variation) {
	                    template.theme.variations = template.theme.variations || {};
	                    template.theme.variations['' + wid] = template.theme.variations['' + wid] || {};
	                    template.theme.variations['' + wid][variation] = _lodash2.default.omit(_extends({}, changed), ['widgets', 'widgetsColors', 'variations']);
	                    _this3.setState({
	                        theme: theme,
	                        changes: _lodash2.default.omit(changed, ['widgets', 'widgetsColors', 'variations'])
	                    });
	                } else {
	                    template.theme.widgets = template.theme.widgets || {};
	                    template.theme.widgets[wid] = _lodash2.default.omit(_extends({}, changed), ['widgets', 'widgetsColors', 'variations']);
	                    _this3.setState({
	                        theme: theme,
	                        changes: _lodash2.default.omit(changed, ['widgets', 'widgetsColors', 'variations'])
	                    });
	                }
	            }
	        } else {
	            _this3.setState({ theme: theme });
	        }
	    };
	
	    this.handleWidgetResetProperty = function (key) {
	        var _state8 = _this3.state,
	            wid = _state8.wid,
	            widgets = _state8.widgets,
	            template = _state8.template,
	            theme = _state8.theme;
	
	        _lodash2.default.unset(template, 'theme.widgets.' + wid + '.' + key);
	        _lodash2.default.set(theme, '' + key, _lodash2.default.get(template, 'theme.' + key));
	        _this3.setState({ theme: theme });
	    };
	
	    this.handlePropsChange = function (key, value) {
	        var _state9 = _this3.state,
	            template = _state9.template,
	            tid = _state9.tid,
	            wid = _state9.wid,
	            variation = _state9.variation;
	
	
	        if (variation) {
	            template.theme.variations = template.theme.variations || {};
	            template.theme.variations['' + wid] = template.theme.variations['' + wid] || {};
	            _lodash2.default.set(template, 'theme.variations[' + wid + '][' + variation + '].widgetProps[' + key + ']', value);
	            // template.theme.variations[`${wid}`].widgetProps = {}
	        } else {
	            _lodash2.default.set(template, 'widgetProps.' + wid + '.' + key, value);
	        }
	
	        _this3.setState({
	            template: template
	        });
	
	        var url = _cfg2.default.dash.api.host + '/api/templates?id=' + tid;
	        return fetch(url, {
	            method: 'post',
	            body: JSON.stringify(template),
	            headers: {
	                'Content-Type': 'application/json',
	                authorization: _auth2.default.getAccessToken()
	            }
	        }).then(function (response) {
	            return response.json();
	        }).then(function (tpl) {}).catch(function (err) {
	            _this3.setState({ saveDialogue: false });
	        });
	    };
	
	    this.handleExport = function (id) {
	        return function () {
	            id = encodeURIComponent(id);
	
	            _this3.setState({
	                downloadTemplateProcess: true
	            });
	
	            fetch(_cfg2.default.dash.api.host + '/api/templates/' + id + '/export?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	                if (res.status === 200) {
	                    document.location.href = res.url;
	                    return res;
	                } else if (res.status === 403) throw new Error("You don't have access to template");else if (res.status === 404) throw new Error('Template not found');else throw new Error('Sorry, something went wrong');
	            }).then(function (res) {
	                _this3.setState({
	                    downloadTemplateProcess: false,
	                    snackbarOpen: true,
	                    snackbarText: 'DONE: File downloaded'
	                });
	            }).catch(function (er) {
	                _this3.setState({
	                    downloadTemplateProcess: false,
	                    downloadTemplateError: true,
	                    snackbarOpen: true,
	                    snackbarText: 'ERROR: ' + er.message
	                });
	            });
	        };
	    };
	
	    this.handleImport = function (ev) {
	        var fr = new FileReader();
	
	        if (ev.target.files.length) {
	            fr.readAsText(ev.target.files[0]);
	        }
	
	        fr.onloadstart = function () {
	            _this3.setState({
	                importFileLoaded: true
	            });
	        };
	
	        fr.onload = function () {
	            var result = void 0;
	
	            try {
	                result = JSON.parse(fr.result);
	
	                _this3.setState({
	                    theme: result.theme,
	                    template: _extends({}, _this3.state.template, {
	                        widgetProps: result.widgetProps,
	                        theme: result.theme
	                    }),
	                    widgetTemplate: _extends({}, _this3.state.widgetTemplate, {
	                        widgetProps: result.widgetProps,
	                        theme: result.theme
	                    }),
	                    snackbarOpen: true,
	                    snackbarText: 'DONE: Theme imported'
	                });
	            } catch (er) {
	
	                _this3.setState({
	                    snackbarOpen: true,
	                    snackbarText: 'ERROR: Load file parse'
	                });
	            }
	        };
	
	        fr.onerror = function (er) {
	
	            _this3.setState({
	                snackbarOpen: true,
	                snackbarText: 'ERROR: Load file'
	            });
	        };
	
	        fr.onloadend = function () {
	            _this3.setState({
	                importFileLoaded: false
	            });
	        };
	    };
	};
	
	exports.default = TemplateCustomizer;

/***/ },
/* 1500 */,
/* 1501 */,
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _navigateNext = __webpack_require__(1503);
	
	var _navigateNext2 = _interopRequireDefault(_navigateNext);
	
	var _navigationArrowDropRight = __webpack_require__(1134);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _movie = __webpack_require__(1504);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _person = __webpack_require__(1505);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _peopleOutline = __webpack_require__(1506);
	
	var _peopleOutline2 = _interopRequireDefault(_peopleOutline);
	
	var _group = __webpack_require__(1507);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _highlight = __webpack_require__(1508);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _toll = __webpack_require__(1509);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _compareArrows = __webpack_require__(1510);
	
	var _compareArrows2 = _interopRequireDefault(_compareArrows);
	
	var _directionsCar = __webpack_require__(1511);
	
	var _directionsCar2 = _interopRequireDefault(_directionsCar);
	
	var _viewCarousel = __webpack_require__(1512);
	
	var _viewCarousel2 = _interopRequireDefault(_viewCarousel);
	
	var _code = __webpack_require__(1032);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _casino = __webpack_require__(1513);
	
	var _casino2 = _interopRequireDefault(_casino);
	
	var _touchApp = __webpack_require__(1514);
	
	var _touchApp2 = _interopRequireDefault(_touchApp);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// import { Link } from 'react-router';
	
	// import IconMore from 'material-ui/svg-icons/navigation/more-horiz';
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	// const Label = styled.p`
	//     margin: 0;
	//     padding: 16px 0;
	//     color: #000;
	//     cursor: pointer;
	// `;
	
	var CATEGORIES = {
	    ANIMATED: {
	        name: 'Animated widgets',
	        key: 'animated',
	        leftIcon: _react2.default.createElement(_movie2.default, null)
	    },
	    TOURNAMENTS: {
	        name: 'Tournament widgets',
	        key: 'tournaments',
	        leftIcon: _react2.default.createElement(_highlight2.default, null)
	    },
	    // PRO_TOURNAMENTS: {
	    //     name: 'PRO Tournament widgets',
	    //     key: 'pro_tournaments',
	    //     leftIcon: (
	    //         <rmd.Badge
	    //             badgeContent="P"
	    //             style={{ padding: 0 }}
	    //             secondary
	    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
	    //         >
	    //             <IconTourn />
	    //         </rmd.Badge>
	    //     ),
	    // },
	    EVENTS: {
	        name: 'Match widgets',
	        key: 'events',
	        leftIcon: _react2.default.createElement(_toll2.default, null)
	    },
	    // PRO_EVENTS: {
	    //     name: 'PRO Match widgets',
	    //     key: 'pro_events',
	    //     leftIcon: (
	    //         <rmd.Badge
	    //             badgeContent="P"
	    //             style={{ padding: 0 }}
	    //             secondary
	    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
	    //         >
	    //             <IconMatch />
	    //         </rmd.Badge>
	    //     ),
	    // },
	    TEAM: {
	        name: 'Club widgets',
	        key: 'teams',
	        leftIcon: _react2.default.createElement(_group2.default, null)
	    },
	    // PRO_TEAM: {
	    //     name: 'PRO club widgets',
	    //     key: 'pro_teams',
	    //     leftIcon: (
	    //         <rmd.Badge
	    //             badgeContent="P"
	    //             style={{ padding: 0 }}
	    //             secondary
	    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
	    //         >
	    //             <IconTeam />
	    //         </rmd.Badge>
	    //     ),
	    // },
	    PLAYER_PROFILE: {
	        name: 'Player widgets',
	        key: 'players',
	        leftIcon: _react2.default.createElement(_person2.default, null)
	    },
	    H2H: {
	        name: 'Player vs Player',
	        key: 'player_h2h',
	        leftIcon: _react2.default.createElement(_peopleOutline2.default, null)
	    },
	    // PRO_PLAYER_PROFILE: {
	    //     name: 'PRO player widgets',
	    //     key: 'pro_players',
	    //     leftIcon: (
	    //         <rmd.Badge
	    //             badgeContent="P"
	    //             style={{ padding: 0 }}
	    //             secondary
	    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
	    //         >
	    //             <IconPlayer />
	    //         </rmd.Badge>
	    //     ),
	    // },
	    ODDS_BOOSTER: {
	        name: 'Odds Booster widgets',
	        key: 'odds_booster',
	        leftIcon: _react2.default.createElement(_casino2.default, null)
	    },
	    INTERACTIVE: {
	        name: 'Interactive widgets',
	        key: 'interactive',
	        leftIcon: _react2.default.createElement(_touchApp2.default, null)
	    },
	    F1: {
	        name: 'Formula 1',
	        key: 'f1',
	        leftIcon: _react2.default.createElement(_directionsCar2.default, null)
	    },
	    TRANSFERS: {
	        name: 'Transfers',
	        key: 'transfers',
	        leftIcon: _react2.default.createElement(_compareArrows2.default, null)
	    },
	    LINEUPS: {
	        name: 'Soccer Lineup',
	        key: 'lineups',
	        leftIcon: _react2.default.createElement(_viewCarousel2.default, null)
	    },
	    OTHER: {
	        name: 'Others',
	        key: 'others',
	        leftIcon: _react2.default.createElement(_viewCarousel2.default, null)
	    }
	};
	
	var groupWidgets = function groupWidgets(widgets) {
	    var socialWidgets = _lodash2.default.filter(widgets, function (w) {
	        return w.spec.categories && w.spec.categories.length;
	    });
	
	    var categories = Object.values(CATEGORIES);
	
	    _lodash2.default.each(socialWidgets, function (w) {
	        var cats = w.spec && w.spec.categories || [];
	        _lodash2.default.chain(cats).map(function (catKey) {
	            return _lodash2.default.find(categories, function (c) {
	                return c.key === catKey;
	            });
	        }).compact().each(function (c) {
	            c.widgets = c.widgets || [];
	            c.widgets.push(w);
	        }).value();
	
	        // if no, add to others
	        if (cats.length === 0) {
	            var cat = _lodash2.default.find(categories, function (c) {
	                return c.key === CATEGORIES.OTHER.key;
	            });
	            cat.widgets = cat.widgets || [];
	            cat.widgets.push(w);
	        }
	    });
	
	    var prepearedCategories = categories.map(function (cat) {
	        if (cat.widgets) {
	            var withSub = cat.widgets.filter(function (c) {
	                return c.spec.widgetGroup;
	            });
	            var withoutSub = cat.widgets.filter(function (c) {
	                return !c.spec.widgetGroup;
	            });
	
	            cat.widgets = withoutSub;
	            if (withSub.length) {
	                cat.subWidgets = _lodash2.default.groupBy(withSub, function (s) {
	                    return s.spec.widgetGroup;
	                });
	            }
	        }
	
	        return cat;
	    });
	
	    return prepearedCategories;
	};
	
	var WidgetNestedMenu = function (_React$Component) {
	    _inherits(WidgetNestedMenu, _React$Component);
	
	    function WidgetNestedMenu(props, context) {
	        _classCallCheck(this, WidgetNestedMenu);
	
	        var _this = _possibleConstructorReturn(this, (WidgetNestedMenu.__proto__ || Object.getPrototypeOf(WidgetNestedMenu)).call(this, props, context));
	
	        _this.state = {
	            widgets: groupWidgets(props.widgets),
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(WidgetNestedMenu, [{
	        key: 'renderLabel',
	        value: function renderLabel() {
	            var _this2 = this;
	
	            var _props = this.props,
	                widgetId = _props.widgetId,
	                widgets = _props.widgets,
	                title = _props.title;
	
	            var widget = _lodash2.default.find(widgets, function (w) {
	                return w.id === widgetId;
	            });
	            var labelTitle = title ? title : 'Select a widget';
	
	            return _react2.default.createElement(rmd.FlatButton, {
	                icon: _react2.default.createElement(_code2.default, null),
	                label: widget ? widget.name : labelTitle,
	                onClick: function onClick(e) {
	                    _this2.setState({ anchorEl: e.target, opened: true });
	                }
	            });
	        }
	    }, {
	        key: 'renderMenu',
	        value: function renderMenu() {
	            var _this3 = this;
	
	            var widgets = this.props.widgets;
	
	
	            return _react2.default.createElement(
	                rmd.Popover,
	                {
	                    open: this.state.opened,
	                    anchorEl: this.state.anchorEl,
	                    autoCloseWhenOffScreen: true,
	                    useLayerForClickAway: true,
	                    onRequestClose: function onRequestClose() {
	                        return _this3.setState({ opened: false });
	                    }
	                },
	                _react2.default.createElement(
	                    rmd.Menu,
	                    null,
	                    widgets.map(function (widget) {
	                        if (widget && widget.spec.noCategories) {
	                            return _react2.default.createElement(rmd.MenuItem, {
	                                key: widget.id,
	                                primaryText: widget.name,
	                                leftIcon: _react2.default.createElement(_navigateNext2.default, null),
	                                onClick: function onClick(e) {
	                                    if (_this3.props.onChange) _this3.props.onChange(e, widget);
	                                    _this3.setState({ opened: false });
	                                }
	                            });
	                        }
	
	                        return null;
	                    }),
	                    this.state.widgets.map(function (category) {
	                        if (category.widgets && category.widgets.length > 0) {
	                            var subWidgets = category.subWidgets ? Object.keys(category.subWidgets) : [];
	
	                            return _react2.default.createElement(rmd.MenuItem, {
	                                key: category.name,
	                                primaryText: category.name,
	                                rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null),
	                                leftIcon: category.leftIcon || null,
	                                menuItems: (category.widgets || []).map(function (wdgt) {
	                                    return _react2.default.createElement(rmd.MenuItem, {
	                                        key: wdgt.id + '_' + category.name,
	                                        value: wdgt.id,
	                                        primaryText: wdgt.name,
	                                        onClick: function onClick(e) {
	                                            if (_this3.props.onChange) _this3.props.onChange(e, wdgt);
	                                            _this3.setState({ opened: false });
	                                        }
	                                    });
	                                }).concat(subWidgets.map(function (sw) {
	                                    return _react2.default.createElement(rmd.MenuItem, {
	                                        key: sw,
	                                        value: sw,
	                                        primaryText: sw,
	                                        rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null),
	                                        menuItems: category.subWidgets[sw].map(function (s) {
	                                            return _react2.default.createElement(rmd.MenuItem, {
	                                                key: s.id,
	                                                value: s.id,
	                                                primaryText: s.name,
	                                                onClick: function onClick(e) {
	                                                    if (_this3.props.onChange) _this3.props.onChange(e, s);
	                                                    _this3.setState({ opened: false });
	                                                }
	                                            });
	                                        })
	                                    });
	                                }))
	                            });
	                        }
	
	                        //when widget group have only subWidgets
	                        if (category.widgets && !category.widgets.length && Object.keys(category.subWidgets).length) {
	                            var _subWidgets = category.subWidgets ? Object.keys(category.subWidgets) : [];
	
	                            return _react2.default.createElement(rmd.MenuItem, {
	                                key: category.key,
	                                primaryText: category.name,
	                                rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null),
	                                leftIcon: category.leftIcon || null,
	                                menuItems: _subWidgets.map(function (sw) {
	                                    return _react2.default.createElement(rmd.MenuItem, {
	                                        key: sw,
	                                        value: sw,
	                                        primaryText: sw,
	                                        rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null),
	                                        menuItems: category.subWidgets[sw].map(function (s) {
	                                            return _react2.default.createElement(rmd.MenuItem, {
	                                                key: s.id,
	                                                value: s.id,
	                                                primaryText: s.name,
	                                                onClick: function onClick(e) {
	                                                    if (_this3.props.onChange) _this3.props.onChange(e, s);
	                                                    _this3.setState({ opened: false });
	                                                }
	                                            });
	                                        })
	                                    });
	                                })
	                            });
	                        }
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-toolbar' },
	                _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    this.renderLabel(),
	                    this.renderMenu()
	                )
	            );
	        }
	    }]);
	
	    return WidgetNestedMenu;
	}(_react2.default.Component);
	
	exports.default = WidgetNestedMenu;

/***/ },
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    width: 18px;\n    height: 18px;\n    margin-top: -30px;\n    margin-left: 238px;\n    border: 1px solid #aaa;\n'], ['\n    width: 18px;\n    height: 18px;\n    margin-top: -30px;\n    margin-left: 238px;\n    border: 1px solid #aaa;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var _sync = __webpack_require__(1516);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _StyledUI = __webpack_require__(1418);
	
	var _immutabilityHelper = __webpack_require__(596);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _SplitImageTPL = __webpack_require__(1406);
	
	var _SplitImageTPL2 = _interopRequireDefault(_SplitImageTPL);
	
	var _reactColor = __webpack_require__(1195);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _queryString = __webpack_require__(1055);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _fontDownload = __webpack_require__(1517);
	
	var _fontDownload2 = _interopRequireDefault(_fontDownload);
	
	var _clear = __webpack_require__(1501);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _keyboardArrowUp = __webpack_require__(846);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(847);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _collections = __webpack_require__(1029);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _constants = __webpack_require__(1520);
	
	var _Branding = __webpack_require__(1410);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(1521);
	
	var _ImageManipulationsDialogue = __webpack_require__(1585);
	
	var _ImageManipulationsDialogue2 = _interopRequireDefault(_ImageManipulationsDialogue);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TemplateConstants = __webpack_require__(1417);
	
	var colorsSets = {
	    stats: ['statTableBgColor', 'statTableTextColor', 'statTableLabelTextColor', 'statTextColor', 'statColorHome', 'statColorNeutral', 'statColorAway', 'positiveColor', 'negativeColor'],
	    wld: ['wdl.win', 'wdl.draw', 'wdl.loss', 'wdl.notPlayed'],
	    relegation: ['qualRelColors.leagueWinner', 'qualRelColors.championsleague', 'qualRelColors.championsleaguequal', 'qualRelColors.relegation', 'qualRelColors.championship_playoff', 'qualRelColors.relegationplayoff', 'qualRelColors.uefaqualplayoff', 'qualRelColors.uefacup', 'qualRelColors.uefaqual', 'qualRelColors.promotion', 'qualRelColors.promotionplayoff', 'qualRelColors.qualification_to_next_stage'],
	    pitch: ['pitch.background', 'pitch.lines', 'pitch.stripes', 'pitch.bottomBorder'],
	    radar: ['radar.strokeColorHome', 'radar.strokeColorAway', 'radar.strokeColorOpponent', 'radar.fillColorHome', 'radar.fillColorAway', 'radar.fillColorOpponent', 'radar.polygonBorderColor', 'radar.polygonBgColor', 'radar.labelTextColor'],
	    f1: ['f1.primaryColor', 'f1.primaryTextColor', 'f1.headerBgColor', 'f1.headerTextColor', 'f1.tableBgColor', 'f1.tableTextColor', 'f1.tableSecondaryTextColor', 'f1.primaryCellColor', 'f1.secondaryCellColor', 'f1.primaryCellTextColor', 'f1.secondaryCellTextColor', 'f1.inprogress', 'f1.finished', 'f1.notstarted', 'f1.trackLineColor', 'f1.trackMapDetails', 'f1.trackDrsColor']
	};
	
	var ColorPreview = _styledComponents2.default.div(_templateObject);
	
	var toRGBA = function toRGBA(color) {
	    return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + color.a + ')';
	};
	
	var IMAGE_URL = {
	    GRADIENT: _cfg2.default.dash.api.host + '/api/media/overlays/gradient.svg',
	    TEAM_GRADIENT: _cfg2.default.dash.api.host + '/api/media/overlays/gradient.svg?isTeamColor=true',
	    BORDER: _cfg2.default.dash.api.host + '/api/media/overlays/border.svg',
	    DEFAULT: _cfg2.default.assets + '/assets/sm_cover.png'
	};
	
	var IMAGE_DEFAULT_PARAMS = {
	    GRADIENT: {
	        fromColor: 'rgba(206,147,216,1)',
	        toColor: 'rgba(129,212,250,1)',
	        direction: _constants.GRADIENT_DIRECTION.HORIZONTAL,
	        progression: 'linear',
	        gradientAlign: 'left',
	        gradientWidth: '100',
	        gradientHeight: '100'
	    },
	    BORDER: {
	        color: 'rgba(0,0,0,1)',
	        offset: 16,
	        width: 2
	    },
	    TEAM_COLOR: {
	        direction: _constants.GRADIENT_DIRECTION.HORIZONTAL,
	        progression: 'linear'
	    }
	};
	
	var AddLayerButton = function (_React$PureComponent) {
	    _inherits(AddLayerButton, _React$PureComponent);
	
	    function AddLayerButton() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AddLayerButton);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddLayerButton.__proto__ || Object.getPrototypeOf(AddLayerButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showLayerSelect: false,
	            layerSelectElement: null
	        }, _this.closeLayerPopover = function () {
	            _this.setState({ showLayerSelect: false });
	        }, _this.openLayerPopover = function (event) {
	            var currentTarget = event.currentTarget;
	
	            _this.setState({
	                layerSelectElement: currentTarget,
	                showLayerSelect: true
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AddLayerButton, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                showLayerSelect = _state.showLayerSelect,
	                layerSelectElement = _state.layerSelectElement;
	            var addLayer = this.props.addLayer;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    { open: showLayerSelect, onRequestClose: this.closeLayerPopover, anchorEl: layerSelectElement },
	                    _react2.default.createElement(_materialUi.MenuItem, {
	                        primaryText: 'Image',
	                        onTouchTap: function onTouchTap() {
	                            addLayer(IMAGE_URL.DEFAULT);
	                            _this2.closeLayerPopover();
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.MenuItem, {
	                        primaryText: 'Gradient',
	                        onTouchTap: function onTouchTap() {
	                            addLayer(IMAGE_URL.GRADIENT + '?' + _queryString2.default.stringify(IMAGE_DEFAULT_PARAMS.GRADIENT));
	                            _this2.closeLayerPopover();
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.MenuItem, {
	                        primaryText: 'Border',
	                        onTouchTap: function onTouchTap() {
	                            addLayer(IMAGE_URL.BORDER + '?' + _queryString2.default.stringify(IMAGE_DEFAULT_PARAMS.BORDER));
	                            _this2.closeLayerPopover();
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.MenuItem, {
	                        primaryText: 'Team color',
	                        onTouchTap: function onTouchTap() {
	                            addLayer(IMAGE_URL.TEAM_GRADIENT + '&' + _queryString2.default.stringify(IMAGE_DEFAULT_PARAMS.TEAM_COLOR));
	                            _this2.closeLayerPopover();
	                        }
	                    })
	                ),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    style: { width: '100%', marginTop: 16 },
	                    label: '+Add',
	                    onTouchTap: this.openLayerPopover
	                })
	            );
	        }
	    }]);
	
	    return AddLayerButton;
	}(_react2.default.PureComponent);
	
	AddLayerButton.propTypes = {
	    addLayer: _propTypes2.default.func.isRequired
	};
	
	var FontEditPoporver = function (_React$Component) {
	    _inherits(FontEditPoporver, _React$Component);
	
	    function FontEditPoporver() {
	        var _ref2;
	
	        var _temp2, _this3, _ret2;
	
	        _classCallCheck(this, FontEditPoporver);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = FontEditPoporver.__proto__ || Object.getPrototypeOf(FontEditPoporver)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {
	            value: {}
	        }, _this3.render = function () {
	            var _this3$props = _this3.props,
	                font = _this3$props.font,
	                anchorEl = _this3$props.anchorEl,
	                open = _this3$props.open;
	
	
	            var fields = Object.keys(TemplateConstants.FONT);
	
	            return _react2.default.createElement(
	                _materialUi.Popover,
	                { open: open, anchorEl: anchorEl, anchorOrigin: { horizontal: 'left', vertical: 'bottom' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { padding: 16 } },
	                    fields.map(function (f) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: f },
	                            _react2.default.createElement(_materialUi.TextField, {
	                                defaultValue: font[f],
	                                floatingLabelText: '$' + f,
	                                onBlur: function onBlur(e) {
	                                    _this3.setState((0, _immutabilityHelper2.default)(_this3.state, {
	                                        value: { $merge: _defineProperty({}, f, e.target.value) }
	                                    }));
	                                }
	                            })
	                        );
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_materialUi.FlatButton, {
	                            label: 'Close',
	                            onClick: function onClick() {
	                                if (_this3.props.onCloseRequest) _this3.props.onCloseRequest();
	                            }
	                        }),
	                        _react2.default.createElement(_materialUi.FlatButton, {
	                            label: 'save',
	                            onClick: function onClick() {
	                                var value = _this3.state.value;
	
	
	                                if (_this3.props.onChange) _this3.props.onChange(value);
	                            }
	                        })
	                    )
	                )
	            );
	        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	    }
	
	    return FontEditPoporver;
	}(_react2.default.Component);
	
	var SplitImageTPLEditor = function (_React$Component2) {
	    _inherits(SplitImageTPLEditor, _React$Component2);
	
	    function SplitImageTPLEditor(props, context) {
	        _classCallCheck(this, SplitImageTPLEditor);
	
	        var _this4 = _possibleConstructorReturn(this, (SplitImageTPLEditor.__proto__ || Object.getPrototypeOf(SplitImageTPLEditor)).call(this, props, context));
	
	        _this4.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.widgetId !== _this4.props.widgetId) {
	                _this4.handleCustomColorsEditing('remove');
	            }
	        };
	
	        _this4.notifyChanges = function (theme) {
	            _this4.props.onChange(theme);
	        };
	
	        _this4.handleCustomColorsEditing = function (remove) {
	            if (!_this4.props.widgetId && !remove) return;
	            var widgets = document.querySelectorAll('.sm-wdp');
	            widgets.forEach(function (widget) {
	                return widget[remove ? 'removeEventListener' : 'addEventListener']('mousedown', _this4.customColorsMouseListener);
	            });
	        };
	
	        _this4.customColorsMouseListener = function (e) {
	            var isEditable = function isEditable(el) {
	                return el.classList.value.indexOf('__c__') > -1;
	            };
	
	            e.preventDefault();
	            var el = e.target;
	
	            var editable = isEditable(el);
	            while (!editable && !Array.from(el.classList).includes('sm-wdp')) {
	                el = el.parentElement;
	                editable = isEditable(el);
	            }
	            if (editable) {
	                var classes = Array.from(el.classList);
	                var customClass = classes.find(function (c) {
	                    return c.indexOf('__c__') > -1;
	                });
	                _this4.setState({
	                    showColorPickerForCustomClass: customClass
	                });
	            } else {
	                _this4.setState({
	                    showColorPickerForCustomClass: null
	                });
	            }
	        };
	
	        _this4.addLayer = function (imageUrl) {
	            var theme = _this4.props.theme;
	
	            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                layers: {
	                    $push: [_lodash2.default.merge(_extends({}, TemplateConstants.LAYER, {
	                        backgroundImage: imageUrl
	                    }))]
	                }
	            }));
	        };
	
	        _this4.getGradientsPosition = function () {
	            return _this4.props.theme.preview_overlay.gradient === 'radial' ? ['center'] : ['to bottom right', 'to bottom', 'to bottom left', 'to right', 'to left', 'to top right', 'to top', 'to top left'];
	        };
	
	        _this4.renderMainColor = function () {
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '0' },
	                    initiallyExpanded: localStorage.getItem('COLORS_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('COLORS_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Main colors',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _this4.renderColorField('primaryColor', 'Primary Color'),
	                    _this4.renderColorField('primaryTextColor', 'Primary Text Color'),
	                    _this4.renderColorField('content.backgroundColor', 'Background color'),
	                    _this4.renderColorField('content.accentColor', 'Accent color'),
	                    _this4.renderColorField('content.accentTextColor', 'Accent Text color'),
	                    _this4.renderColorField('content.accent2Color', 'Accent 2 color'),
	                    _this4.renderColorField('content.accent2TextColor', 'Accent Text 2 color'),
	                    _this4.renderColorField('substitutionOutColor', 'Substitution color'),
	                    _this4.renderColorField('brandingBackground', 'Branding background color')
	                )
	            );
	        };
	
	        _this4.renderLayerControlMoreOption = function (layer, index) {
	            var prevLayer = _this4.props.theme.layers[index - 1];
	            var nextLayer = _this4.props.theme.layers[index + 1];
	            var thisLayer = _this4.props.theme.layers[index];
	
	            var theme = _this4.props.theme;
	
	
	            var handleDelete = function handleDelete() {
	                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                    layers: {
	                        $splice: [[index, 1]]
	                    }
	                }));
	            };
	
	            var handeDown = function handeDown() {
	                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                    layers: {
	                        $splice: [[index, 2, nextLayer, thisLayer]]
	                    }
	                }));
	            };
	
	            var handleUp = function handleUp() {
	                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                    layers: {
	                        $splice: [[index - 1, 2, thisLayer, prevLayer]]
	                    }
	                }));
	            };
	
	            return _react2.default.createElement(
	                _materialUi.IconMenu,
	                {
	                    iconButtonElement: _react2.default.createElement(
	                        _materialUi.IconButton,
	                        null,
	                        _react2.default.createElement(_moreVert2.default, null)
	                    )
	                },
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Autolayout' }),
	                _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_keyboardArrowUp2.default, null), disabled: index === 0, primaryText: 'Move Up', onClick: handleUp }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                    leftIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	                    disabled: index === _this4.props.theme.layers.length - 1,
	                    primaryText: 'Move Down',
	                    onClick: handeDown
	                }),
	                _react2.default.createElement(_materialUi.Divider, null),
	                _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_delete2.default, null), primaryText: 'Delete', onClick: handleDelete })
	            );
	        };
	
	        _this4.properyChange = function (index) {
	            return function (object) {
	                var theme = _this4.props.theme;
	
	                var theme2 = (0, _immutabilityHelper2.default)(theme, {
	                    layers: _defineProperty({}, index, { $merge: object })
	                });
	                _this4.notifyChanges(theme2);
	            };
	        };
	
	        _this4.renderBorderLayerControl = function (layer, index) {
	            var backgroundImage = layer.backgroundImage;
	
	            var expanded = _this4.props.layerDetailsExpanded === index;
	            var queryValues = _queryString2.default.parse(_queryString2.default.extract(backgroundImage));
	            var _onChange = function _onChange(keyValObj) {
	                var url = IMAGE_URL.BORDER + '?' + _queryString2.default.stringify(_extends({}, queryValues, keyValObj));
	                _this4.properyChange(index)({ backgroundImage: url });
	            };
	            return _react2.default.createElement(
	                'div',
	                { key: index, style: { paddingBottom: 16 } },
	                _react2.default.createElement(
	                    'h3',
	                    {
	                        style: {
	                            backgroundColor: '#f4f4f4',
	                            margin: '0 -16px',
	                            padding: '12px 16px',
	                            position: 'relative'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        index + 1,
	                        ' Layer (border)'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', right: 0, top: 0 } },
	                        _this4.renderLayerControlMoreOption(layer, index)
	                    )
	                ),
	                _react2.default.createElement('img', { src: backgroundImage, width: '100%', style: { marginTop: '16px' } }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.TextField, {
	                        value: queryValues.color,
	                        onFocus: function onFocus() {
	                            return _this4.invokeColorPicker(index);
	                        },
	                        floatingLabelText: 'Border color'
	                    })
	                ),
	                _this4.state.colorPickerFor !== index ? _react2.default.createElement(ColorPreview, { style: { backgroundColor: queryValues.color } }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', {
	                        style: {
	                            position: 'fixed',
	                            top: '0px',
	                            right: '0px',
	                            bottom: '0px',
	                            left: '0px'
	                        },
	                        onClick: function onClick() {
	                            _this4.setState({ colorPickerFor: false });
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', zIndex: 2 } },
	                        _react2.default.createElement(_reactColor.SketchPicker, {
	                            key: 'color' + index,
	                            color: queryValues.color,
	                            onChangeComplete: function onChangeComplete(_ref3) {
	                                var _ref3$rgb = _ref3.rgb,
	                                    r = _ref3$rgb.r,
	                                    g = _ref3$rgb.g,
	                                    b = _ref3$rgb.b,
	                                    a = _ref3$rgb.a;
	                                return _onChange({
	                                    color: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
	                                });
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'customizer-label' },
	                    'Offset'
	                ),
	                _react2.default.createElement(_materialUi.Slider, {
	                    step: 1,
	                    min: 1,
	                    max: 40,
	                    key: index + '.border.offset',
	                    value: Number(queryValues.offset),
	                    sliderStyle: {
	                        marginBottom: '0px',
	                        marginTop: '12px'
	                    },
	                    onChange: function onChange(e, value) {
	                        _onChange({ offset: value });
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'customizer-label' },
	                    'Width'
	                ),
	                _react2.default.createElement(_materialUi.Slider, {
	                    step: 1,
	                    min: 1,
	                    max: 10,
	                    key: index + '.border.widt',
	                    value: Number(queryValues.width),
	                    sliderStyle: {
	                        marginBottom: '0px',
	                        marginTop: '12px'
	                    },
	                    onChange: function onChange(e, value) {
	                        _onChange({ width: value });
	                    }
	                }),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    style: { width: '100%' },
	                    label: 'Border manipulations',
	                    onClick: function onClick(e) {
	                        return _this4.setState({
	                            layerDetailsExpanded: expanded ? null : index
	                        });
	                    }
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_materialUi.Divider, { style: { marginLeft: -16, marginRight: -16 }, inset: true }),
	                _this4.renderImageManipulationsForLayer(index, layer, expanded)
	            );
	        };
	
	        _this4.renderGradientLayerControl = function (layer, index, el, isTeamColor) {
	            var backgroundImage = layer.backgroundImage;
	
	            var expanded = _this4.state.layerDetailsExpanded === index;
	            var queryValues = _queryString2.default.parse(_queryString2.default.extract(backgroundImage));
	
	            var _onChange2 = function _onChange2(keyValObj) {
	                var url = IMAGE_URL.GRADIENT + '?' + _queryString2.default.stringify(_extends({}, queryValues, keyValObj));
	                var theme = _this4.props.theme;
	
	                var theme2 = (0, _immutabilityHelper2.default)(theme, {
	                    layers: _defineProperty({}, index, { $merge: { backgroundImage: url } })
	                });
	
	                _this4.notifyChanges(theme2);
	            };
	            return _react2.default.createElement(
	                'div',
	                { key: index, style: { paddingBottom: 16 } },
	                _react2.default.createElement(
	                    'h3',
	                    {
	                        style: {
	                            backgroundColor: '#f4f4f4',
	                            margin: '0 -16px',
	                            padding: '12px 16px',
	                            position: 'relative'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        index + 1,
	                        ' Layer (',
	                        isTeamColor ? 'Team color' : 'Gradient',
	                        ')'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', right: 0, top: 0 } },
	                        _this4.renderLayerControlMoreOption(layer, index)
	                    )
	                ),
	                !isTeamColor && _react2.default.createElement('img', { src: backgroundImage, width: '100%', style: { marginTop: '16px' } }),
	                !isTeamColor && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.TextField, {
	                        value: queryValues.fromColor,
	                        onFocus: function onFocus() {
	                            return _this4.invokeColorPicker(index + '.fromColor');
	                        },
	                        floatingLabelText: 'From color'
	                    })
	                ),
	                _this4.state.colorPickerFor !== index + '.fromColor' ? _react2.default.createElement(ColorPreview, { style: { backgroundColor: queryValues.fromColor } }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', {
	                        style: {
	                            position: 'fixed',
	                            top: '0px',
	                            right: '0px',
	                            bottom: '0px',
	                            left: '0px'
	                        },
	                        onClick: function onClick() {
	                            _this4.setState({ colorPickerFor: false });
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', zIndex: 2 } },
	                        _react2.default.createElement(_reactColor.SketchPicker, {
	                            key: index + '.fromColor',
	                            color: queryValues.fromColor,
	                            onChangeComplete: function onChangeComplete(_ref4) {
	                                var _ref4$rgb = _ref4.rgb,
	                                    r = _ref4$rgb.r,
	                                    g = _ref4$rgb.g,
	                                    b = _ref4$rgb.b,
	                                    a = _ref4$rgb.a;
	                                return _onChange2({
	                                    fromColor: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
	                                });
	                            }
	                        })
	                    )
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.TextField, {
	                        value: queryValues.fromColor,
	                        onFocus: function onFocus() {
	                            return _this4.invokeColorPicker(index + '.toColor');
	                        },
	                        floatingLabelText: 'To color'
	                    })
	                ),
	                _this4.state.colorPickerFor !== index + '.toColor' ? _react2.default.createElement(ColorPreview, { style: { backgroundColor: queryValues.toColor } }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', {
	                        style: {
	                            position: 'fixed',
	                            top: '0px',
	                            right: '0px',
	                            bottom: '0px',
	                            left: '0px'
	                        },
	                        onClick: function onClick() {
	                            _this4.setState({ colorPickerFor: false });
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', zIndex: 2 } },
	                        _react2.default.createElement(_reactColor.SketchPicker, {
	                            key: index + '.toColor',
	                            color: queryValues.toColor,
	                            onChangeComplete: function onChangeComplete(_ref5) {
	                                var _ref5$rgb = _ref5.rgb,
	                                    r = _ref5$rgb.r,
	                                    g = _ref5$rgb.g,
	                                    b = _ref5$rgb.b,
	                                    a = _ref5$rgb.a;
	                                return _onChange2({
	                                    toColor: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
	                                });
	                            }
	                        })
	                    )
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        key: 'gradient-align',
	                        floatingLabelText: 'Align',
	                        floatingLabelFixed: true,
	                        defaultValue: _this4.props.theme.content.gradientAlign,
	                        value: _this4.props.theme.content.gradientAlign,
	                        onChange: function onChange(event, index, value) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(_this4.props.theme, {
	                                content: {
	                                    $merge: { gradientAlign: value }
	                                }
	                            }));
	                        }
	                    },
	                    [{ val: 'left', key: 'Left' }, { val: 'right', key: 'Right' }, { val: 'top', key: 'Top' }, { val: 'bottom', key: 'Bottom' }].map(function (k) {
	                        return _react2.default.createElement(_materialUi.MenuItem, { value: k.val, primaryText: k.key, key: k.key });
	                    })
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.content.gradientWidth',
	                        floatingLabelText: 'Width %',
	                        defaultValue: _this4.props.theme.content.gradientWidth,
	                        floatingLabelFixed: true,
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(_this4.props.theme, {
	                                content: { $merge: { gradientWidth: val } }
	                            }));
	                        }
	                    })
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.content.gradientHeight',
	                        floatingLabelText: 'Height %',
	                        defaultValue: _this4.props.theme.content.gradientHeight,
	                        floatingLabelFixed: true,
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(_this4.props.theme, {
	                                content: { $merge: { gradientHeight: val } }
	                            }));
	                        }
	                    })
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        value: queryValues.progression,
	                        onChange: function onChange(event, index, value) {
	                            if (value !== queryValues.progression) {
	                                _onChange2({ progression: value });
	                            }
	                        },
	                        floatingLabelText: 'Progression'
	                    },
	                    _react2.default.createElement(_materialUi.MenuItem, { value: 'linear', primaryText: 'Linear' }),
	                    _react2.default.createElement(_materialUi.MenuItem, { value: 'radial', primaryText: 'Radial' })
	                ),
	                isTeamColor && _react2.default.createElement(
	                    'div',
	                    { style: { height: 80, fontWeight: 700, marginTop: 24, display: 'flex', alignItems: 'center' } },
	                    'Team color is added to widget dynamically. You can change its opacity'
	                ),
	                !isTeamColor && _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                        tooltip: 'Swap colors',
	                        onTouchTap: function onTouchTap() {
	                            return _onChange2({
	                                fromColor: queryValues.toColor,
	                                toColor: queryValues.fromColor
	                            });
	                        }
	                    },
	                    _react2.default.createElement(_sync2.default, null)
	                ),
	                queryValues.progression === 'linear' && !isTeamColor && _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        value: queryValues.direction,
	                        onChange: function onChange(event, index, value) {
	                            if (value !== queryValues.direction) {
	                                _onChange2({ direction: value });
	                            }
	                        },
	                        floatingLabelText: 'Direction'
	                    },
	                    Object.keys(_constants.GRADIENT_DIRECTION).map(function (directionKey) {
	                        return _react2.default.createElement(_materialUi.MenuItem, {
	                            key: directionKey,
	                            value: String(_constants.GRADIENT_DIRECTION[directionKey]),
	                            primaryText: (0, _humanizeString2.default)(directionKey)
	                        });
	                    })
	                ),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    style: { width: '100%' },
	                    label: isTeamColor ? 'Change opacity' : 'Gradient manipulations',
	                    onClick: function onClick(e) {
	                        return _this4.setState({
	                            layerDetailsExpanded: expanded ? null : index,
	                            anchorEl: e.target
	                        });
	                    }
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_materialUi.Divider, { style: { marginLeft: -16, marginRight: -16 }, inset: true }),
	                _this4.renderImageManipulationsForLayer(index, layer, expanded, isTeamColor)
	            );
	        };
	
	        _this4.renderImageManipulationsForLayer = function (index, layer, expanded, isTeamColor) {
	            return _react2.default.createElement(_ImageManipulationsDialogue2.default, {
	                layer: layer,
	                expanded: expanded,
	                anchorEl: _this4.state.anchorEl,
	                isTeamColor: isTeamColor,
	                onProperyChange: function onProperyChange(object) {
	                    var theme = _this4.props.theme;
	
	                    var theme2 = (0, _immutabilityHelper2.default)(theme, {
	                        layers: _defineProperty({}, index, { $merge: object })
	                    });
	                    _this4.notifyChanges(theme2);
	                },
	                onDoneClick: function onDoneClick() {
	                    _this4.setState({ layerDetailsExpanded: null });
	                }
	            });
	        };
	
	        _this4.renderLayerControlByUrl = function (layer, index, el) {
	            var backgroundImage = layer.backgroundImage;
	
	            if (backgroundImage.indexOf(IMAGE_URL.BORDER) === 0) {
	                return _this4.renderBorderLayerControl(layer, index, el);
	            } else if (backgroundImage.indexOf(IMAGE_URL.GRADIENT) === 0) {
	                return _this4.renderGradientLayerControl(layer, index, el, backgroundImage.indexOf('isTeamColor') > -1);
	            }
	            return _this4.renderLayerControl(layer, index, el);
	        };
	
	        _this4.renderLayerControl = function (layer, index) {
	            var expanded = _this4.state.layerDetailsExpanded === index;
	
	            return _react2.default.createElement(
	                'div',
	                { key: index, style: { paddingBottom: 16 } },
	                _react2.default.createElement(
	                    'h3',
	                    {
	                        style: {
	                            backgroundColor: '#eaeaea',
	                            margin: '0 -16px',
	                            padding: '12px 16px',
	                            position: 'relative'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        index + 1,
	                        ' Layer'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', right: 0, top: 0 } },
	                        _this4.renderLayerControlMoreOption(layer, index)
	                    )
	                ),
	                _react2.default.createElement('img', {
	                    src: layer.backgroundImage,
	                    width: '100%',
	                    style: { marginTop: '16px', maxHeight: 200, objectFit: 'contain' }
	                }),
	                _this4.renderImagePickerField('layers.[' + index + '].backgroundImage'),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    style: { width: '100%' },
	                    label: 'Image manipulations',
	                    onClick: function onClick(e) {
	                        return _this4.setState({
	                            layerDetailsExpanded: expanded ? null : index,
	                            anchorEl: e.target
	                        });
	                    }
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_materialUi.Divider, { style: { marginLeft: -16, marginRight: -16 }, inset: true }),
	                _this4.renderImageManipulationsForLayer(index, layer, expanded)
	            );
	        };
	
	        _this4.renderLayersControls = function () {
	            var theme = _this4.props.theme;
	            var _this4$state = _this4.state,
	                layerSelectElement = _this4$state.layerSelectElement,
	                showLayerSelect = _this4$state.showLayerSelect;
	
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '0' },
	                    initiallyExpanded: localStorage.getItem('LAYERS_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('LAYERS_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Layers Image',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: -15 } },
	                        theme.layers.map(_this4.renderLayerControlByUrl)
	                    ),
	                    theme.layers.length === 0 && _react2.default.createElement(
	                        'p',
	                        null,
	                        'No layers'
	                    ),
	                    _react2.default.createElement(AddLayerButton, { addLayer: _this4.addLayer })
	                )
	            );
	        };
	
	        _this4.renderLayoutStaff = function () {
	            var theme = _this4.props.theme;
	
	
	            var getPadding = function getPadding(val) {
	                var nums = val.match(/[0-9]+/g) || ['0'];
	
	                if (!nums || nums.length > 4) return '0';
	
	                return nums.join(' ');
	            };
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '0' },
	                    initiallyExpanded: localStorage.getItem('LAYOUT_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('LAYOUT_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, { className: 'template-editor__header', title: 'Layout', actAsExpander: true, showExpandableButton: true }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.contentPadding',
	                        floatingLabelText: 'Content Padding',
	                        defaultValue: theme.contentPadding,
	                        floatingLabelFixed: true,
	                        style: { width: '100%' },
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                $merge: { contentPadding: parseInt(val, 10) }
	                            }));
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.content.margin',
	                        floatingLabelText: 'Content Offset',
	                        defaultValue: theme.content.margin,
	                        floatingLabelFixed: true,
	                        style: { width: '100%' },
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                content: { $merge: { margin: getPadding(val) } }
	                            }));
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.content.margin',
	                        floatingLabelText: 'Content Padding',
	                        defaultValue: theme.content.padding,
	                        floatingLabelFixed: true,
	                        style: { width: '100%' },
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                content: { $merge: { padding: getPadding(val) } }
	                            }));
	                        }
	                    }),
	                    _this4.renderColorField('content.fillColor', 'Fill color'),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        name: 'theme.content.minHeight',
	                        floatingLabelText: 'Min Height',
	                        defaultValue: theme.content.minHeight,
	                        floatingLabelFixed: true,
	                        style: { width: '100%' },
	                        onChange: function onChange(e, val) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                content: {
	                                    $merge: { minHeight: parseInt(val, 10) }
	                                }
	                            }));
	                        }
	                    }),
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            key: 'top',
	                            floatingLabelText: 'Content align',
	                            floatingLabelFixed: true,
	                            defaultValue: theme.content.valign,
	                            value: theme.content.valign,
	                            onChange: function onChange(event, index, value) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    content: {
	                                        $merge: { valign: value }
	                                    }
	                                }));
	                            }
	                        },
	                        [{ val: 'top', key: 'Top' }, { val: 'center', key: 'Center' }, { val: 'flex-end', key: 'Bottom' }].map(function (k) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: k.val, primaryText: k.key, key: k.key });
	                        })
	                    )
	                )
	            );
	        };
	
	        _this4.renderSkinSelect = function () {
	            var theme = _this4.props.theme;
	
	
	            return _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    floatingLabelText: 'Choose skin',
	                    value: theme.display.skin || null,
	                    key: 'skin',
	                    onChange: function onChange(e, index, skinId) {
	                        var toSet = {};
	                        var skin = _lodash2.default.find(_StyledUI.skins, function (s) {
	                            return s.id === skinId;
	                        });
	                        Object.keys(theme.display).forEach(function (elementName) {
	                            toSet[elementName] = 'default';
	                        });
	
	                        Object.keys(skin.displayMap).forEach(function (elementName) {
	                            toSet[elementName] = skin.displayMap[elementName];
	                        });
	
	                        _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                            display: { $merge: toSet }
	                        }));
	                    }
	                },
	                _StyledUI.skins.map(function (_ref6) {
	                    var name = _ref6.name,
	                        id = _ref6.id;
	
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: id, primaryText: name });
	                })
	            );
	        };
	
	        _this4.renderDisplayStaff = function () {
	            var theme = _this4.props.theme;
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '0' },
	                    initiallyExpanded: localStorage.getItem('STANDARD_COMP_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('STANDARD_COMP_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Default elements',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            key: 'top',
	                            floatingLabelText: 'Team Logo Variants ' + theme.teamLogo,
	                            floatingLabelFixed: true,
	                            defaultValue: theme.teamLogo,
	                            value: theme.teamLogo,
	                            onChange: function onChange(event, index, value) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    $merge: { teamLogo: value }
	                                }));
	                            }
	                        },
	                        _SMTeamLogo.options.map(function (i) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: i, primaryText: i, key: i });
	                        })
	                    ),
	                    _this4.renderSkinSelect(),
	                    Object.keys(_StyledUI.displayMap).map(function (elementName) {
	                        var elementDisplayOptions = Object.keys(_StyledUI.displayMap[elementName]);
	
	                        return _react2.default.createElement(
	                            _materialUi.SelectField,
	                            {
	                                floatingLabelText: elementName,
	                                value: theme.display[elementName],
	                                key: elementName,
	                                onChange: function onChange(e, index, display) {
	                                    var toSet = { skin: null };
	                                    toSet[elementName] = display;
	
	                                    _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                        display: { $merge: toSet }
	                                    }));
	                                }
	                            },
	                            elementDisplayOptions.map(function (o) {
	                                return _react2.default.createElement(_materialUi.MenuItem, { key: o, value: o, primaryText: o });
	                            })
	                        );
	                    })
	                )
	            );
	        };
	
	        _this4.isUsingParentValue = function (key) {
	            if (!_this4.props.widgetId) return false;
	            if (_lodash2.default.get(_this4.props.overriden, key)) {
	                return false;
	            }
	            return true;
	        };
	
	        _this4.resetIfWidgetMode = function (key) {
	            if (_this4.props.widgetId && !_this4.isUsingParentValue('' + key)) {
	                return _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                        iconStyle: { width: 18, height: 18 },
	                        tooltip: 'Reset to theme',
	                        onClick: function onClick() {
	                            return _this4.deleteValueFromWidget(key);
	                        }
	                    },
	                    _react2.default.createElement(_clear2.default, null)
	                );
	            }
	        };
	
	        _this4.deleteValueFromWidget = function (key) {
	            if (_this4.props.onWidgetResetProperty) _this4.props.onWidgetResetProperty(key);
	        };
	
	        _this4.renderFontStaff = function () {
	            var theme = _this4.props.theme;
	
	
	            var backgroundColor = (0, _color2.default)(theme.content.backgroundColor).alpha(1.0).rgb().toString();
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    initiallyExpanded: localStorage.getItem('FONTS_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('FONTS_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, { className: 'template-editor__header', title: 'Fonts', actAsExpander: true, showExpandableButton: true }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _this4.renderFontField('title', 'Title font', {
	                        color: theme.titleColor,
	                        backgroundColor: backgroundColor
	                    }),
	                    _this4.renderColorField('titleColor', 'Title color'),
	                    _this4.renderColorField('subTitleColor', 'Sub title color'),
	                    _react2.default.createElement(
	                        'div',
	                        { key: 'Title font size' },
	                        _this4.renderFontSizeField('Title font size', 'fonts.title.fontSize'),
	                        _this4.renderFontSizeField('Sub Title font size', 'fonts.subTitle.fontSize')
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { margin: '16px -16px' } },
	                        _react2.default.createElement(_materialUi.Divider, null)
	                    ),
	                    _this4.renderFontField('main', 'Main font', {
	                        color: theme.color,
	                        backgroundColor: backgroundColor
	                    }),
	                    _this4.renderColorField('color', 'Main font color')
	                )
	            );
	        };
	
	        _this4.invokeColorPicker = function (key) {
	            _this4.setState({ colorPickerFor: key });
	        };
	
	        _this4.renderColorPicker = function (key, val, onChange) {
	            if (_this4.state.colorPickerFor !== key) return _react2.default.createElement(ColorPreview, { style: { backgroundColor: val } });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', {
	                    key: 'ov',
	                    style: {
	                        position: 'fixed',
	                        top: '0px',
	                        right: '0px',
	                        bottom: '0px',
	                        left: '0px'
	                    },
	                    onClick: function onClick() {
	                        _this4.setState({ colorPickerFor: false });
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', zIndex: 2 } },
	                    _react2.default.createElement(_reactColor.SketchPicker, { key: 'pi', color: val, onChangeComplete: onChange })
	                )
	            );
	        };
	
	        _this4.renderBrandingStaff = function () {
	            var theme = _this4.props.theme;
	
	            var branding = theme.defaultBranding;
	            var brandingProps = theme.brandingProps;
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '0px' },
	                    initiallyExpanded: localStorage.getItem('BRAND_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('BRAND_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Default branding',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            floatingLabelText: 'Primary branding logos',
	                            value: theme.defaultBranding.brandingPrimary,
	                            defaultValue: theme.defaultBranding.brandingPrimary,
	                            onChange: function onChange(e, index, value) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    defaultBranding: {
	                                        $merge: { brandingPrimary: value }
	                                    }
	                                }));
	                            }
	                        },
	                        Object.keys(_Branding.brandings).map(function (option) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: option, primaryText: option, key: option });
	                        })
	                    ),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        onBlur: function onBlur(e) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                defaultBranding: {
	                                    $merge: { brandingPrimary: e.target.value }
	                                }
	                            }));
	                        },
	                        floatingLabelText: 'Textual primary branding'
	                    }),
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            floatingLabelText: 'Secondary branding logos',
	                            value: theme.defaultBranding.brandingSecondary,
	                            defaultValue: theme.defaultBranding.brandingSecondary,
	                            onChange: function onChange(e, index, value) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    defaultBranding: {
	                                        $merge: { brandingSecondary: value }
	                                    }
	                                }));
	                            }
	                        },
	                        Object.keys(_Branding.brandings).map(function (option) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: option, primaryText: option, key: option });
	                        })
	                    ),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        defaultValue: theme.defaultBranding.brandingSecondary,
	                        onBlur: function onBlur(e) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                defaultBranding: {
	                                    $merge: { brandingSecondary: e.target.value }
	                                }
	                            }));
	                        },
	                        floatingLabelText: 'Textual secondary branding'
	                    }),
	                    _lodash2.default.map(_Branding.options, function (options, key) {
	                        return _react2.default.createElement(
	                            _materialUi.SelectField,
	                            {
	                                key: key,
	                                floatingLabelText: key,
	                                value: _lodash2.default.get(brandingProps, key, _lodash2.default.get(_Branding.defaultOptions, key)),
	                                onChange: function onChange(event, index, value) {
	                                    _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                        brandingProps: {
	                                            $merge: _defineProperty({}, key, value)
	                                        }
	                                    }));
	                                }
	                            },
	                            options.map(function (option) {
	                                return _react2.default.createElement(_materialUi.MenuItem, { value: option, primaryText: option, key: option });
	                            })
	                        );
	                    }),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        defaultValue: theme.brandingProps.height,
	                        onBlur: function onBlur(e) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                brandingProps: {
	                                    $merge: { height: e.target.value }
	                                }
	                            }));
	                        },
	                        floatingLabelText: 'Height'
	                    }),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        defaultValue: theme.brandingProps.width,
	                        onBlur: function onBlur(e) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                brandingProps: {
	                                    $merge: { width: e.target.value }
	                                }
	                            }));
	                        },
	                        floatingLabelText: 'Width'
	                    }),
	                    _react2.default.createElement(_materialUi.TextField, {
	                        defaultValue: theme.brandingProps.padding,
	                        onBlur: function onBlur(e) {
	                            _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                brandingProps: {
	                                    $merge: { padding: e.target.value }
	                                }
	                            }));
	                        },
	                        floatingLabelText: 'Padding'
	                    })
	                )
	            );
	        };
	
	        _this4.renderImagePickerField = function (key, title) {
	            var theme = _this4.props.theme;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', alignItems: 'center' } },
	                _react2.default.createElement(_materialUi.TextField, {
	                    name: key + '_' + _lodash2.default.get(theme, key),
	                    defaultValue: _lodash2.default.get(theme, key),
	                    style: { width: '100%' },
	                    onBlur: function onBlur(e) {
	                        _lodash2.default.set(theme, key, e.target.value);
	                        _this4.notifyChanges(theme);
	                    }
	                }),
	                _react2.default.createElement(_materialUi.FlatButton, {
	                    icon: _react2.default.createElement(_collections2.default, null),
	                    style: { minWidth: '44px', marginLeft: 5 },
	                    onClick: function onClick() {
	                        _this4.setState({ imagePickerFor: key });
	                    }
	                })
	            );
	        };
	
	        _this4.renderColorField = function (key, title) {
	            var theme = _this4.props.theme;
	
	            return _react2.default.createElement(
	                'div',
	                { key: key + '_' + _lodash2.default.get(theme, key) },
	                _react2.default.createElement(_materialUi.TextField, {
	                    className: (0, _classnames2.default)({
	                        'wdp-parent-value': _this4.isUsingParentValue('' + key)
	                    }),
	                    value: _lodash2.default.get(theme, key),
	                    onFocus: function onFocus(e) {
	                        _this4.invokeColorPicker(key);
	                    },
	                    floatingLabelText: title
	                }),
	                _this4.resetIfWidgetMode(key),
	                _this4.renderColorPicker(key, _lodash2.default.get(theme, key), function (val) {
	                    _lodash2.default.set(theme, key, toRGBA(val.rgb));
	                    _this4.notifyChanges(theme);
	                })
	            );
	        };
	
	        _this4.renderFontField = function (key, title, stl) {
	            var theme = _this4.props.theme;
	            var _this4$state2 = _this4.state,
	                fontPopoverFor = _this4$state2.fontPopoverFor,
	                fontPopoverForEl = _this4$state2.fontPopoverForEl;
	
	            var font = theme.fonts[key];
	            var popoverKey = 'key_' + key;
	
	            return _react2.default.createElement(
	                'div',
	                { key: key },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: { height: 50, marginBottom: 10, display: 'flex' },
	                        className: (0, _classnames2.default)({
	                            'wdp-parent-value': _this4.isUsingParentValue('fonts.' + key)
	                        })
	                    },
	                    _react2.default.createElement(
	                        'label',
	                        { style: { width: '100%', padding: '16 0' } },
	                        title,
	                        ': ',
	                        font.name
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.IconButton,
	                        {
	                            iconStyle: { width: 18, height: 18 },
	                            onClick: function onClick(e) {
	                                _this4.setState((0, _immutabilityHelper2.default)(_this4.state, {
	                                    $merge: {
	                                        fontPopoverFor: popoverKey,
	                                        fontPopoverForEl: e.target
	                                    }
	                                }));
	                            }
	                        },
	                        _react2.default.createElement(_fontDownload2.default, null)
	                    ),
	                    _this4.resetIfWidgetMode('fonts.' + key)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, font, stl, { padding: 10 }) },
	                    _react2.default.createElement(
	                        'span',
	                        { style: { fontWeight: font.thin } },
	                        'W',
	                        font.thin,
	                        ' ',
	                        key,
	                        ' font is ',
	                        font.gFontName
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { fontWeight: font.normal } },
	                        'W',
	                        font.normal,
	                        ' ',
	                        key,
	                        ' font is ',
	                        font.gFontName
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { fontWeight: font.bold } },
	                        'W',
	                        font.bold,
	                        ' ',
	                        key,
	                        ' font is ',
	                        font.gFontName
	                    )
	                ),
	                _react2.default.createElement(FontEditPoporver, {
	                    open: popoverKey === fontPopoverFor,
	                    font: font,
	                    anchorEl: fontPopoverForEl,
	                    onCloseRequest: function onCloseRequest() {
	                        _this4.setState({ fontPopoverFor: null });
	                    },
	                    onChange: function onChange(font) {
	                        var u1 = (0, _immutabilityHelper2.default)(theme, {
	                            fonts: _defineProperty({}, key, {
	                                $merge: font
	                            })
	                        });
	                        _this4.notifyChanges(u1);
	                    }
	                })
	            );
	        };
	
	        _this4.renderFontSizeField = function (title, path) {
	            var theme = _this4.props.theme;
	
	            var defaultValue = _lodash2.default.get(theme, path);
	
	            return _react2.default.createElement(_materialUi.TextField, {
	                type: 'number',
	                name: 'theme.' + path,
	                floatingLabelText: title,
	                defaultValue: defaultValue,
	                fullWidth: true,
	                onChange: function onChange(e, val) {
	                    _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                        $merge: _lodash2.default.set(theme, path, isNaN(parseInt(val, 10)) ? defaultValue : parseInt(val, 10))
	                    }));
	                }
	            });
	        };
	
	        _this4.renderLayoutType = function () {
	            var _this4$props = _this4.props,
	                widgetId = _this4$props.widgetId,
	                widget = _this4$props.widget,
	                _this4$props$widgetPr = _this4$props.widgetProps,
	                widgetProps = _this4$props$widgetPr === undefined ? {} : _this4$props$widgetPr;
	
	
	            if (!widgetId) return;
	
	            var lll = widget.spec.propTypes.find(function (w) {
	                return w.key === 'layoutType';
	            });
	            if (!lll) return;
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '20px 0' },
	                    initiallyExpanded: localStorage.getItem('LAYOUT_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('LAYOUT_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Layout Type',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            key: 'sd',
	                            value: _lodash2.default.get(widgetProps, 'layoutType'),
	                            onChange: function onChange(event, index, value) {
	                                if (_this4.props.onWidgetPropsChange) _this4.props.onWidgetPropsChange('layoutType', value);
	                            }
	                        },
	                        lll.options.map(function (w) {
	                            if (w.value === null) return; // do no allow to use inherit from theme
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: w.value, primaryText: w.text, key: w.value });
	                        })
	                    )
	                )
	            );
	        };
	
	        _this4.renderColorPickerForCustomClass = function () {
	            var _this4$state3 = _this4.state,
	                showColorPickerForCustomClass = _this4$state3.showColorPickerForCustomClass,
	                customColors = _this4$state3.customColors;
	
	            if (!showColorPickerForCustomClass) return null;
	            var color = customColors[showColorPickerForCustomClass];
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'fixed', zIndex: 2, right: 50, top: 215 } },
	                _react2.default.createElement(_reactColor.SketchPicker, {
	                    key: 'pi',
	                    color: color,
	                    onChangeComplete: function onChangeComplete(picked) {
	                        _this4.setState({
	                            customColors: _extends({}, customColors, _defineProperty({}, showColorPickerForCustomClass, toRGBA(picked.rgb)))
	                        });
	                        // const currentCustomColors = _.get(
	                        //     this,
	                        //     ['props', 'theme', 'widgetsColors', this.props.widgetId],
	                        //     {}
	                        // );
	                        // if (currentCustomColors === null) {
	                        //     customColors = {};
	                        // }
	                        // this.setState(
	                        //     {
	                        //         customColors: {
	                        //             ...customColors,
	                        //             [showColorPickerForCustomClass]: toRGBA(picked.rgb)
	                        //         }
	                        //     },
	
	                        //     () => {
	                        //         this.notifyChanges(
	                        //             update(this.props.theme, {
	                        //                 widgetsColors: {
	                        //                     [this.props.widgetId]: {
	                        //                         $set: {
	                        //                             ...currentCustomColors,
	                        //                             ...this.state.customColors
	                        //                         }
	                        //                     }
	                        //                 }
	                        //             })
	                        //         );
	                        //     }
	                        // );
	
	                        _this4.props.onCustomColorChange(_this4.props.widgetId, _defineProperty({}, showColorPickerForCustomClass, toRGBA(picked.rgb)));
	                    }
	                })
	            );
	        };
	
	        _this4.renderDateFormatsStaff = function () {
	            var dates = ['TIME', 'DATE_AND_TIME_SHORT', 'DATE_AND_TIME_FULL', 'DATE', 'DATE_SHORT'];
	
	            var theme = _this4.props.theme;
	
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '20px 0' },
	                    initiallyExpanded: localStorage.getItem('DATE_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('DATE_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Date formats',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    dates.map(function (d) {
	                        return _react2.default.createElement(_materialUi.TextField, {
	                            key: d,
	                            defaultValue: _lodash2.default.get(_this4.props.theme, 'dateFormats.' + d),
	                            onBlur: function onBlur(e) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    dateFormats: {
	                                        $merge: _defineProperty({}, d, e.target.value)
	                                    }
	                                }));
	                            },
	                            floatingLabelText: d
	                        });
	                    })
	                )
	            );
	        };
	
	        _this4.renderOtherStaff = function () {
	            var theme = _this4.props.theme;
	
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                {
	                    style: { marginTop: '20px 0' },
	                    initiallyExpanded: localStorage.getItem('OTHER_EXP') === 'true',
	                    onExpandChange: function onExpandChange(exp) {
	                        localStorage.setItem('OTHER_EXP', exp);
	                    }
	                },
	                _react2.default.createElement(_materialUi.CardHeader, {
	                    className: 'template-editor__header',
	                    title: 'Other',
	                    subtitle: 'Odds format',
	                    actAsExpander: true,
	                    showExpandableButton: true
	                }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    { expandable: true },
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            key: 'top',
	                            floatingLabelText: 'Odds format',
	                            floatingLabelFixed: true,
	                            defaultValue: theme.oddsFormat,
	                            value: theme.oddsFormat,
	                            onChange: function onChange(event, index, value) {
	                                _this4.notifyChanges((0, _immutabilityHelper2.default)(theme, {
	                                    $merge: { oddsFormat: value }
	                                }));
	                            }
	                        },
	                        [{ val: 'decimal', key: 'Decimal' }, { val: 'fractional', key: 'Fractional' }].map(function (k) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { value: k.val, primaryText: k.key, key: k.key });
	                        })
	                    )
	                )
	            );
	        };
	
	        _this4.state = {
	            imagePickerFor: null,
	            customColors: {},
	            smWdpWidgets: []
	        };
	        return _this4;
	    }
	
	    _createClass(SplitImageTPLEditor, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.notifyChanges();
	            this.interval = setInterval(this.handleCustomColorsEditing, 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.handleCustomColorsEditing('remove');
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var theme = this.props.theme;
	            var widgetId = this.props.widgetId;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderColorPickerForCustomClass(),
	                this.renderLayoutType(),
	                this.renderFontStaff(),
	                this.renderMainColor(),
	                this.renderLayersControls(),
	                this.renderLayoutStaff(),
	                this.renderBrandingStaff(),
	                this.renderDisplayStaff(),
	                _lodash2.default.toPairs(colorsSets).map(function (pair) {
	                    return _react2.default.createElement(
	                        _materialUi.Card,
	                        {
	                            key: pair[0],
	                            style: { marginTop: '0px' },
	                            initiallyExpanded: localStorage.getItem(pair[0] + '_EXP') === 'true',
	                            onExpandChange: function onExpandChange(exp) {
	                                localStorage.setItem(pair[0] + '_EXP', exp);
	                            }
	                        },
	                        _react2.default.createElement(_materialUi.CardHeader, {
	                            className: 'template-editor__header',
	                            title: 'Colors for ' + pair[0],
	                            actAsExpander: true,
	                            showExpandableButton: true
	                        }),
	                        _react2.default.createElement(
	                            _materialUi.CardText,
	                            { expandable: true },
	                            pair[1].map(function (i) {
	                                return _this5.renderColorField(i, i);
	                            })
	                        )
	                    );
	                }),
	                this.renderDateFormatsStaff(),
	                this.renderOtherStaff(),
	                this.state.imagePickerFor && _react2.default.createElement(_ImageUploaderContainer2.default, {
	                    onCopy: function onCopy(url) {
	                        _lodash2.default.set(theme, _this5.state.imagePickerFor, url);
	
	                        _this5.notifyChanges(theme);
	
	                        _this5.setState({
	                            imagePickerFor: null
	                        });
	                    },
	                    onClose: function onClose() {
	                        _this5.setState({
	                            imagePickerFor: null
	                        });
	                    },
	                    modal: true,
	                    galleryFirst: true,
	                    cdnOnly: true,
	                    cdnLabel: 'Pick'
	                })
	            );
	        }
	    }]);
	
	    return SplitImageTPLEditor;
	}(_react2.default.Component);
	
	SplitImageTPLEditor.propTypes = {
	    onChange: _propTypes2.default.func,
	    theme: _propTypes2.default.object
	};
	exports.default = SplitImageTPLEditor;

/***/ },
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */
/***/ function(module, exports) {

	"use strict";
	
	var GRADIENT_DIRECTION = {
	    HORIZONTAL: 1,
	    VERTICAL: 2,
	    FROM_TOP_TO_BOTTOM: 3,
	    FROM_BOTTOM_TO_TOP: 4
	};
	
	module.exports = {
	    GRADIENT_DIRECTION: GRADIENT_DIRECTION
	};

/***/ },
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateConstants = __webpack_require__(1417);
	
	var Component = function (_React$PureComponent) {
	    _inherits(Component, _React$PureComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                layer = _props.layer,
	                expanded = _props.expanded,
	                anchorEl = _props.anchorEl,
	                isTeamColor = _props.isTeamColor;
	
	
	            var properyChange = function properyChange(obj) {
	                _this2.props.onProperyChange(obj);
	                _this2.forceUpdate();
	            };
	
	            if (isTeamColor) {
	                return _react2.default.createElement(
	                    _materialUi.Popover,
	                    { open: expanded, anchorEl: anchorEl },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { padding: 16, width: 400 } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'customizer-label' },
	                            'Opacity'
	                        ),
	                        _react2.default.createElement(_materialUi.Slider, {
	                            step: 0.01,
	                            min: 0.1,
	                            max: 1,
	                            key: 'Opacity',
	                            value: layer.opacity,
	                            sliderStyle: {
	                                marginBottom: '0px',
	                                marginTop: '12px'
	                            },
	                            onChange: function onChange(e, opacity) {
	                                properyChange({ opacity: opacity });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        label: 'Reset',
	                        onClick: function onClick() {
	                            properyChange(_lodash2.default.extend(TemplateConstants.LAYER, { backgroundImage: layer.backgroundImage }));
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.FlatButton, { label: 'Done', onClick: this.props.onDoneClick })
	                );
	            }
	
	            return _react2.default.createElement(
	                _materialUi.Popover,
	                { open: expanded, anchorEl: anchorEl },
	                _react2.default.createElement(
	                    'div',
	                    { style: { padding: 16, width: 400 } },
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            floatingLabelText: 'Horizontal',
	                            value: layer.backgroundSize,
	                            key: 'backgroundSize',
	                            style: { width: '100%' },
	                            onChange: function onChange(e, index, backgroundSize) {
	                                properyChange({ backgroundSize: backgroundSize });
	                            }
	                        },
	                        _react2.default.createElement(_materialUi.MenuItem, { key: 'c2', value: 'contain', primaryText: 'Contain image in widget' }),
	                        _react2.default.createElement(_materialUi.MenuItem, { key: 'c1', value: 'cover', primaryText: 'Cover whole widget' }),
	                        _react2.default.createElement(_materialUi.MenuItem, { key: 'c3', value: 'initial', primaryText: 'Image original' })
	                    ),
	                    _react2.default.createElement(_materialUi.Toggle, {
	                        label: 'Top Overlay',
	                        defaultToggled: layer.topOverlay === true,
	                        onToggle: function onToggle(e, isInputChecked) {
	                            properyChange({
	                                topOverlay: isInputChecked
	                            });
	                        }
	                    }),
	                    layer.backgroundSize === 'contain' || layer.backgroundSize === 'initial' ? [_react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            floatingLabelText: 'Horizontal',
	                            value: layer.backgroundPositionX,
	                            key: 'backgroundPositionX',
	                            style: { width: 150 },
	                            onChange: function onChange(e, index, backgroundPositionX) {
	                                properyChange({ backgroundPositionX: backgroundPositionX });
	                            }
	                        },
	                        _lodash2.default.compact(['center', 'left', 'right', layer.backgroundSize === 'contain' && 'moveX']).map(function (o) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { key: o, value: o, primaryText: o });
	                        })
	                    ), _react2.default.createElement(
	                        _materialUi.SelectField,
	                        {
	                            floatingLabelText: 'Vertical',
	                            value: layer.backgroundPositionY,
	                            key: 'backgroundPositionY',
	                            style: { width: 150 },
	                            onChange: function onChange(e, index, backgroundPositionY) {
	                                properyChange({ backgroundPositionY: backgroundPositionY });
	                            }
	                        },
	                        _lodash2.default.compact(['center', 'top', 'bottom', layer.backgroundSize === 'contain' && 'moveY']).map(function (o) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { key: o, value: o, primaryText: o });
	                        })
	                    ), layer.backgroundPositionX === 'moveX' && _react2.default.createElement(
	                        'div',
	                        { className: 'customizer-label' },
	                        'Move X'
	                    ), layer.backgroundPositionX === 'moveX' && _react2.default.createElement(_materialUi.Slider, {
	                        step: 1,
	                        min: -1000,
	                        max: 1000,
	                        key: 'translateX',
	                        value: layer.translateX,
	                        sliderStyle: {
	                            marginBottom: '0px',
	                            marginTop: '12px'
	                        },
	                        onChange: function onChange(e, translateX) {
	                            properyChange({ translateX: translateX });
	                        }
	                    }), layer.backgroundPositionY === 'moveY' && _react2.default.createElement(
	                        'div',
	                        { className: 'customizer-label' },
	                        'Move Y'
	                    ), layer.backgroundPositionY === 'moveY' && _react2.default.createElement(_materialUi.Slider, {
	                        step: 1,
	                        min: -1000,
	                        max: 1000,
	                        key: 'translateY',
	                        value: layer.translateY,
	                        sliderStyle: {
	                            marginBottom: '0px',
	                            marginTop: '12px'
	                        },
	                        onChange: function onChange(e, translateY) {
	                            properyChange({ translateY: translateY });
	                        }
	                    })] : [_react2.default.createElement(
	                        'div',
	                        { className: 'customizer-label' },
	                        'Move X (if landscape)'
	                    ), _react2.default.createElement(_materialUi.Slider, {
	                        step: 1,
	                        min: 0,
	                        max: 100,
	                        key: 'translateX',
	                        value: layer.translateX,
	                        sliderStyle: {
	                            marginBottom: '0px',
	                            marginTop: '12px'
	                        },
	                        onChange: function onChange(e, translateX) {
	                            properyChange({ translateX: translateX });
	                        }
	                    }), _react2.default.createElement(
	                        'div',
	                        { className: 'customizer-label' },
	                        'Move Y (if portrait)'
	                    ), _react2.default.createElement(_materialUi.Slider, {
	                        step: 1,
	                        min: 0,
	                        max: 100,
	                        key: 'translateY',
	                        value: layer.translateY,
	                        sliderStyle: {
	                            marginBottom: '0px',
	                            marginTop: '12px'
	                        },
	                        onChange: function onChange(e, translateY) {
	                            properyChange({ translateY: translateY });
	                        }
	                    })],
	                    layer.backgroundSize === 'contain' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'customizer-label' },
	                            'Scale/Zoom'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', flexDirection: 'row' } },
	                            _react2.default.createElement(_materialUi.Slider, {
	                                step: 0.01,
	                                min: 0.1,
	                                max: 10,
	                                key: 'Scale',
	                                value: layer.scale,
	                                sliderStyle: {
	                                    marginBottom: '0px',
	                                    marginTop: '12px',
	                                    marginRight: 10,
	                                    width: 200
	                                },
	                                onChange: function onChange(e, scale) {
	                                    properyChange({ scale: scale });
	                                }
	                            }),
	                            _react2.default.createElement(_materialUi.FlatButton, {
	                                label: 'Zoom: 1.0',
	                                onClick: function onClick() {
	                                    properyChange({ scale: 1.0 });
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'customizer-label' },
	                        'Opacity'
	                    ),
	                    _react2.default.createElement(_materialUi.Slider, {
	                        step: 0.01,
	                        min: 0.1,
	                        max: 1,
	                        key: 'Opacity',
	                        value: layer.opacity,
	                        sliderStyle: {
	                            marginBottom: '0px',
	                            marginTop: '12px'
	                        },
	                        onChange: function onChange(e, opacity) {
	                            properyChange({ opacity: opacity });
	                        }
	                    }),
	                    _react2.default.createElement('div', {
	                        style: {
	                            margin: '16px -16px',
	                            height: 1,
	                            background: '#666'
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        label: 'Reset',
	                        onClick: function onClick() {
	                            properyChange(_lodash2.default.extend(TemplateConstants.LAYER, { backgroundImage: layer.backgroundImage }));
	                        }
	                    }),
	                    _react2.default.createElement(_materialUi.FlatButton, { label: 'Done', onClick: this.props.onDoneClick })
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_react2.default.PureComponent);
	
	exports.default = Component;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(188);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _TemplateCard = __webpack_require__(1587);
	
	var _TemplateCard2 = _interopRequireDefault(_TemplateCard);
	
	var _DialogImport = __webpack_require__(1588);
	
	var _DialogImport2 = _interopRequireDefault(_DialogImport);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplatesList = function (_React$Component) {
	    _inherits(TemplatesList, _React$Component);
	
	    function TemplatesList(props, context) {
	        _classCallCheck(this, TemplatesList);
	
	        var _this = _possibleConstructorReturn(this, (TemplatesList.__proto__ || Object.getPrototypeOf(TemplatesList)).call(this, props, context));
	
	        _this.loadData = function (additionalStateParams) {
	            var user = _this.context.user;
	
	            if (!user || !user.client) return null;
	
	            return fetch(_cfg2.default.dash.api.host + '/api/templates?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (templates) {
	                _this.setState(_extends({
	                    templates: templates,
	                    isLoading: false
	                }, additionalStateParams));
	            }).catch(function (e) {
	                _this.setState(_extends({
	                    error: e,
	                    isLoading: false
	                }, additionalStateParams));
	            });
	        };
	
	        _this.handleTemplatesHide = function (id) {
	            id = encodeURIComponent(id);
	
	            fetch(_cfg2.default.dash.api.host + '/api/templates/' + id + '?access_token=' + _auth2.default.getAccessToken(), {
	                method: 'PUT',
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({
	                    isHidden: !_lodash2.default.find(_this.state.templates, ['id', id]).isHidden
	                })
	            }).then(function (response) {
	                if (response.status === 200) {
	                    _this.loadData();
	                }
	            });
	        };
	
	        _this.handleTemplatesClone = function () {
	            var _this$state = _this.state,
	                cloneTemplateName = _this$state.cloneTemplateName,
	                errorFieldClone = _this$state.errorFieldClone,
	                cloneTemplateId = _this$state.cloneTemplateId;
	
	            var id = encodeURIComponent(cloneTemplateId);
	
	            if (cloneTemplateName) {
	                fetch(_cfg2.default.dash.api.host + '/api/templates/' + id + '/clone?templateName=' + cloneTemplateName, {
	                    method: 'POST',
	                    headers: {
	                        authorization: _auth2.default.getAccessToken()
	                    }
	                }).then(function (_ref) {
	                    var status = _ref.status;
	
	                    if (status === 200) {
	                        _this.loadData();
	                    } else {
	                        throw new Error('Error load status: ' + status);
	                    }
	
	                    _this.handleDialogClose('openCloneDialog')();
	                }).catch(function (err) {});
	            } else {
	                _this.setState({
	                    errorFieldClone: !cloneTemplateName ? true : errorFieldClone
	                });
	            };
	        };
	
	        _this.handleDialogOpen = function (type) {
	            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            return function (ev) {
	                if (ev) ev.preventDefault();
	
	                _this.setState(_defineProperty({}, type, true));
	
	                if (payload.cloneTemplateId) _this.setState({ cloneTemplateId: payload.cloneTemplateId });
	            };
	        };
	
	        _this.handleDialogClose = function (type) {
	            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            return function (ev) {
	                if (ev) ev.preventDefault();
	
	                _this.setState(_defineProperty({}, type, false));
	
	                if (type === 'openCloneDialog') _this.setState({ cloneTemplateName: '', errorFieldClone: false });
	            };
	        };
	
	        _this.state = {
	            templates: [],
	            showHidden: _this.props.route.params.isHidden || false,
	            openImportDialog: false,
	            openCloneDialog: false,
	            errorFieldClone: false,
	            cloneTemplateName: '',
	            cloneTemplateId: null
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(TemplatesList, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                templates = _state.templates,
	                openImportDialog = _state.openImportDialog,
	                openCloneDialog = _state.openCloneDialog,
	                errorFieldClone = _state.errorFieldClone,
	                cloneTemplateName = _state.cloneTemplateName;
	
	            var noTemplates = _lodash2.default.isEmpty(templates);
	            var hiddenTemplatesExist = templates.some(function (t) {
	                return t.isHidden;
	            });
	            var hiddenFilterLabel = this.state.showHidden ? 'Show active templates' : 'Show hidden templates';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'pick-theme' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(
	                            rmd.Subheader,
	                            null,
	                            noTemplates ? 'Create your first template!' : 'Choose existing template or',
	                            ' ',
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { onClick: window.location.reload, to: '/sm/templates/create' },
	                                'create new'
	                            ),
	                            ' ',
	                            'or',
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.handleDialogOpen('openImportDialog'), href: '' },
	                                'import template'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6', style: { textAlign: 'right' } },
	                        hiddenTemplatesExist && _react2.default.createElement(
	                            rmd.Subheader,
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { href: this.state.showHidden ? '/sm/templates' : '/sm/templates/hidden' },
	                                hiddenFilterLabel
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        _reactAddonsCssTransitionGroup2.default,
	                        { transitionName: 'rlzFadeAnimation', transitionEnterTimeout: 500, transitionLeave: false },
	                        templates.filter(function (t) {
	                            return _this2.state.showHidden ? t.isHidden : !t.isHidden;
	                        }).map(function (template, i) {
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-6 col-md-4', key: template.id },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'theme-template-wrapper' },
	                                    _react2.default.createElement(_TemplateCard2.default, { template: template, handleTemplatesHide: _this2.handleTemplatesHide, handleTemplatesClone: _this2.handleTemplatesClone, handleDialogOpen: _this2.handleDialogOpen })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(_DialogImport2.default, {
	                    show: openImportDialog,
	                    dialogTitle: 'Import template',
	                    submitCb: this.loadData,
	                    urlSubmit: _cfg2.default.dash.api.host + '/api/templates/import',
	                    closeCb: this.handleDialogClose('openImportDialog')
	                }),
	                _react2.default.createElement(
	                    rmd.Dialog,
	                    {
	                        title: 'Clone template name',
	                        modal: false,
	                        open: openCloneDialog,
	                        onRequestClose: this.handleDialogClose('openCloneDialog'),
	                        actions: _lodash2.default.compact([_react2.default.createElement(rmd.FlatButton, { label: 'Close', onClick: this.handleDialogClose('openCloneDialog') }), _react2.default.createElement(rmd.FlatButton, {
	                            primary: true,
	                            label: 'Clone',
	                            onClick: this.handleTemplatesClone
	                        })])
	                    },
	                    _react2.default.createElement(rmd.TextField, {
	                        fullWidth: true,
	                        floatingLabelText: 'Template name',
	                        errorText: errorFieldClone ? 'This field is required' : '',
	                        name: cloneTemplateName,
	                        onChange: function onChange(e, cloneTemplateName) {
	                            if (errorFieldClone && cloneTemplateName.length) _this2.setState({ errorField: false });
	                            _this2.setState({ cloneTemplateName: cloneTemplateName });
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TemplatesList;
	}(_react2.default.Component);
	
	TemplatesList.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = TemplatesList;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(188);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateCard = function TemplateCard(_ref) {
	    var template = _ref.template,
	        handleTemplatesHide = _ref.handleTemplatesHide,
	        handleDialogOpen = _ref.handleDialogOpen;
	    return _react2.default.createElement(
	        rmd.Card,
	        { className: 'theme-template' },
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'theme__theme-colors widget-img',
	                style: {
	                    position: 'relative',
	                    backgroundSize: 'cover',
	                    backgroundImage: 'url(\'' + _lodash2.default.get(template, 'theme.layers[0].backgroundImage') + '\')'
	                }
	            },
	            _react2.default.createElement(
	                'span',
	                {
	                    style: {
	                        position: 'absolute',
	                        padding: '20px',
	                        top: '50%',
	                        left: '50%',
	                        minWidth: '150px',
	                        transform: 'translate(-50%, -50%)',
	                        backgroundColor: template.theme.content.backgroundColor,
	                        textAlign: 'center',
	                        color: template.theme.color
	                    }
	                },
	                template.name
	            ),
	            _react2.default.createElement(
	                rmd.IconMenu,
	                {
	                    iconButtonElement: _react2.default.createElement(
	                        rmd.IconButton,
	                        null,
	                        _react2.default.createElement(_moreVert2.default, { color: '' + template.theme.color })
	                    ),
	                    menuStyle: { zIndex: 10001, position: 'relative' },
	                    style: {
	                        zIndex: 10001,
	                        position: 'absolute',
	                        top: '0',
	                        right: '0'
	                    },
	                    anchorOrigin: { horizontal: 'right', vertical: 'top' },
	                    targetOrigin: { horizontal: 'right', vertical: 'top' }
	                },
	                _react2.default.createElement(rmd.MenuItem, {
	                    primaryText: template.isHidden ? 'Show' : 'Hide',
	                    onClick: function onClick(e) {
	                        return handleTemplatesHide(template.id);
	                    }
	                }),
	                _react2.default.createElement(rmd.MenuItem, {
	                    primaryText: 'Clone',
	                    onClick: handleDialogOpen('openCloneDialog', { cloneTemplateId: template.id })
	                })
	            ),
	            _react2.default.createElement(
	                rmd.CardActions,
	                {
	                    style: {
	                        position: 'absolute',
	                        left: '0',
	                        right: '0',
	                        bottom: '0',
	                        padding: '0',
	                        border: '0',
	                        display: 'flex',
	                        justifyContent: 'space-between',
	                        flexDirection: 'row-reverse'
	                    }
	                },
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                        style: {
	                            margin: '0',
	                            backgroundColor: template.theme.content.backgroundColor,
	                            color: template.theme.color
	                        },
	                        onClick: window.location.reload,
	                        to: '/sm/templates/edit?tid=' + template.id
	                    },
	                    _react2.default.createElement(rmd.FlatButton, {
	                        labelStyle: { color: '#fff' },
	                        className: 'create',
	                        label: 'Edit',
	                        primary: true
	                    })
	                )
	            )
	        )
	    );
	};
	
	exports.default = TemplateCard;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fileUpload = __webpack_require__(1385);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogImport = function (_Component) {
	    _inherits(DialogImport, _Component);
	
	    function DialogImport(props) {
	        _classCallCheck(this, DialogImport);
	
	        var _this = _possibleConstructorReturn(this, (DialogImport.__proto__ || Object.getPrototypeOf(DialogImport)).call(this, props));
	
	        _this.handleImport = function (ev) {
	            var file = ev.target.files[0];
	
	            _this.setState({
	                file: file,
	                fileName: file ? file.name : '',
	                errorFile: !file
	            });
	        };
	
	        _this.handleClose = function () {
	            var closeCb = _this.props.closeCb;
	
	
	            _this.setState({
	                name: '',
	                uploadTemplateProcess: false,
	                file: null,
	                fileName: '',
	                openImportDialog: false,
	                errorField: false,
	                errorFile: false
	            });
	
	            if (closeCb) closeCb();
	        };
	
	        _this.handleSubmit = function () {
	            var _this$state = _this.state,
	                file = _this$state.file,
	                name = _this$state.name;
	            var _this$props = _this.props,
	                submitCb = _this$props.submitCb,
	                closeCb = _this$props.closeCb,
	                fileType = _this$props.fileType,
	                urlSubmit = _this$props.urlSubmit;
	
	
	            if (file && name) {
	                return fetch(urlSubmit + '?uploadName=' + name, {
	                    method: 'POST',
	                    body: file,
	                    headers: {
	                        'Content-Type': fileType || 'application/json',
	                        authorization: _auth2.default.getAccessToken()
	                    }
	                }).then(function (response) {
	                    return response.json();
	                }).then(function (res) {
	                    if (submitCb) submitCb(res);
	                    if (closeCb) closeCb();
	
	                    _this.handleClose();
	                }).catch(function (err) {});
	            } else {
	                _this.setState({
	                    errorField: !name ? true : _this.state.errorField,
	                    errorFile: !file ? true : _this.state.errorFile
	                });
	            }
	        };
	
	        _this.state = {
	            name: '',
	            errorField: false,
	            errorFile: false,
	            uploadTemplateProcess: false,
	            file: null,
	            fileName: '',
	            openImportDialog: _this.props.show || false
	        };
	        return _this;
	    }
	
	    _createClass(DialogImport, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var show = _ref.show;
	
	            if (show) this.setState({ openImportDialog: show });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                openImportDialog = _state.openImportDialog,
	                errorField = _state.errorField,
	                errorFile = _state.errorFile;
	            var _props = this.props,
	                dialogTitle = _props.dialogTitle,
	                completeActionButtonText = _props.completeActionButtonText,
	                fileType = _props.fileType,
	                textField = _props.textField;
	
	
	            return _react2.default.createElement(
	                rmd.Dialog,
	                { title: dialogTitle || 'Import',
	                    modal: false,
	                    open: openImportDialog,
	                    onRequestClose: this.handleClose,
	                    actions: _lodash2.default.compact([_react2.default.createElement(rmd.FlatButton, {
	                        label: 'Close',
	                        onClick: this.handleClose
	                    }), _react2.default.createElement(rmd.FlatButton, {
	                        primary: true,
	                        label: completeActionButtonText || 'Import',
	                        onClick: this.handleSubmit
	                    })])
	                },
	                _react2.default.createElement(rmd.TextField, { fullWidth: true,
	                    floatingLabelText: textField || 'Template name',
	                    errorText: errorField ? 'This field is required' : '',
	                    name: this.state.name,
	                    onChange: function onChange(e, name) {
	                        if (errorField && name.length) _this2.setState({ errorField: false });
	
	                        _this2.setState({ name: name });
	                    }
	                }),
	                _react2.default.createElement(
	                    'p',
	                    { style: { margin: '17px 0 20px', color: errorFile ? 'rgb(244, 67, 54)' : 'inherit' } },
	                    this.state.fileName ? _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'File name: '
	                        ),
	                        ' ',
	                        this.state.fileName
	                    ) : _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Please load file'
	                    )
	                ),
	                _react2.default.createElement('input', { hidden: true,
	                    accept: fileType || 'application/json',
	                    type: 'file',
	                    id: 'import-file',
	                    onChange: this.handleImport
	                }),
	                _react2.default.createElement(
	                    rmd.RaisedButton,
	                    {
	                        label: 'Select file',
	                        style: { position: 'relative' },
	                        primary: true,
	                        icon: this.state.uploadTemplateProcess ? _react2.default.createElement(rmd.CircularProgress, { size: 24 }) : _react2.default.createElement(_fileUpload2.default, null)
	                    },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'import-file',
	                            style: {
	                                position: 'absolute',
	                                top: 0,
	                                right: 0,
	                                bottom: 0,
	                                left: 0,
	                                opacity: 0,
	                                zIndex: 9,
	                                cursor: 'pointer'
	                            }
	                        },
	                        'Select file'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DialogImport;
	}(_react.Component);
	
	exports.default = DialogImport;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    padding: 15px 0px;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        font-weight: 300;\n    }\n'], ['\n    flex-grow: 1;\n    padding: 15px 0px;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        font-weight: 300;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(188);
	
	var _actions = __webpack_require__(1590);
	
	var _reactRedux = __webpack_require__(250);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
	
	// import { StyleSheetManager } from 'styled-components';
	
	// import Menu from './TournamentSMBMenu';
	
	// import { Link, Redirect } from 'react-router';
	
	
	// const PANE = styled.div`
	//     display: flex;
	//     flex-direction: column;
	//     position: relative;
	// `;
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var HighButton = function HighButton(_ref) {
	    var name = _ref.name,
	        sub = _ref.sub,
	        active = _ref.active,
	        live = _ref.live;
	    return _react2.default.createElement(
	        rmd.FlatButton,
	        {
	            style: {
	                height: 'auto',
	                padding: '5px 15px',
	                lineHeight: '24px',
	                position: 'relative'
	            },
	            primary: active
	        },
	        live && _react2.default.createElement('span', {
	            style: {
	                position: 'absolute',
	                left: 5,
	                top: 14,
	                width: 5,
	                height: 5,
	                borderRadius: 50,
	                background: 'green'
	            }
	        }),
	        _react2.default.createElement(
	            'span',
	            null,
	            name
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'sm',
	            { style: { fontSize: '11px' } },
	            sub
	        )
	    );
	};
	
	var TeamList = function (_React$Component) {
	    _inherits(TeamList, _React$Component);
	
	    function TeamList() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TeamList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TeamList.__proto__ || Object.getPrototypeOf(TeamList)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { expanded: false }, _this.render = function () {
	            var expanded = _this.state.expanded;
	            var _this$props = _this.props,
	                _this$props$teams = _this$props.teams,
	                teams = _this$props$teams === undefined ? [] : _this$props$teams,
	                limit = _this$props.limit,
	                _this$props$link = _this$props.link,
	                link = _this$props$link === undefined ? '' : _this$props$link;
	
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: '10px 0' } },
	                _lodash2.default.take(teams, expanded ? teams.length : limit).map(function (t) {
	                    return _react2.default.createElement(
	                        rmd.IconButton,
	                        {
	                            key: t.id,
	                            tooltip: t.name,
	                            tooltipPosition: 'top-center',
	                            style: { width: 56, height: 56 }
	                        },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: link + '/team/' + t.id },
	                            _react2.default.createElement(_SMTeamLogo2.default, { width: 32, style: { marginRight: 10 }, teamId: t.id })
	                        )
	                    );
	                }),
	                teams.length > limit && !expanded && _react2.default.createElement(rmd.FlatButton, {
	                    label: 'See all (' + teams.length + ')',
	                    onClick: function onClick() {
	                        return _this.setState({ expanded: true });
	                    }
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return TeamList;
	}(_react2.default.Component);
	
	TeamList.defaultProps = {
	    limit: 32
	};
	
	
	var TeamListE = (0, _reactRedux.connect)(function (state) {
	    return { teams: _lodash2.default.get(state, 'smBrowser.teams', []) };
	})(TeamList);
	
	var TournamentSMBrowser = function (_React$Component2) {
	    _inherits(TournamentSMBrowser, _React$Component2);
	
	    function TournamentSMBrowser(props, context) {
	        _classCallCheck(this, TournamentSMBrowser);
	
	        var _this2 = _possibleConstructorReturn(this, (TournamentSMBrowser.__proto__ || Object.getPrototypeOf(TournamentSMBrowser)).call(this, props, context));
	
	        _this2.componentDidMount = function () {
	            var _this2$props = _this2.props,
	                dispatch = _this2$props.dispatch,
	                _this2$props$params = _this2$props.params,
	                tournamentId = _this2$props$params.tournamentId,
	                seasonId = _this2$props$params.seasonId,
	                initLoad = _this2$props.initLoad;
	
	            dispatch(initLoad(tournamentId, seasonId));
	        };
	
	        _this2.componentWillReceiveProps = function (nextProps) {
	            var _nextProps$params = nextProps.params,
	                tournamentId = _nextProps$params.tournamentId,
	                seasonId = _nextProps$params.seasonId,
	                initLoad = nextProps.initLoad,
	                dispatch = nextProps.dispatch;
	
	
	            var tournamentWasChanged = +_this2.props.params.tournamentId !== +tournamentId;
	            var seasonWasChanged = _this2.props.params.seasonId + '' !== seasonId + '';
	
	            if (tournamentWasChanged || seasonWasChanged) {
	                dispatch(initLoad(tournamentId, seasonId));
	            }
	        };
	
	        return _this2;
	    }
	
	    _createClass(TournamentSMBrowser, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                tournament = _props.tournament,
	                season = _props.season,
	                router = _props.router,
	                params = _props.params;
	
	
	            var dd = document.getElementById('hostforstylemanager');
	
	            if (!dd) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement(
	                _styledComponents.StyleSheetManager,
	                { target: dd },
	                _react2.default.createElement(
	                    Content,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	                            _react2.default.createElement(
	                                'h1',
	                                { style: { flexGrow: 1 } },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/sm/browser/' + params.sport + '/tournaments/' + params.tournamentId },
	                                    (tournament && tournament.name || _RCore2.default.nbsp) + ' ' + (season && season.year || _RCore2.default.nbsp)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                rmd.SelectField,
	                                {
	                                    value: season && season.id,
	                                    style: { width: 'auto' },
	                                    onChange: function onChange(event, index, seasonId) {
	                                        router.push('/sm/browser/' + params.sport + '/tournaments/' + params.tournamentId + '/' + seasonId);
	                                    }
	                                },
	                                tournament && _lodash2.default.sortBy(tournament.seasons, function (s) {
	                                    return -s.id;
	                                }).map(function (season) {
	                                    return _react2.default.createElement(rmd.MenuItem, { key: season.id, value: season.id, primaryText: season.year });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(TeamListE, { link: '/sm/browser/football/tournaments/' + tournament.id + '/' + season.id }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            season && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/sm/browser/football/tournaments/' + tournament.id + '/' + season.id },
	                                    _react2.default.createElement(HighButton, { active: !params.stageId, name: 'Season overview', sub: season.year })
	                                ),
	                                season.stages.length > 0 && season.stages.map(function (stage) {
	                                    {
	                                        /* const currentRound =
	                                        _.find(stage.roundsList, r => r.isCurrent) || _.last(stage.roundsList); */
	                                    }
	                                    var dates = (0, _moment2.default)(stage.startDate).format('D MMM') + ' - ' + (0, _moment2.default)(stage.endDate).format('D MMM');
	                                    var live = (0, _moment2.default)().isAfter(stage.startDate) && (0, _moment2.default)().isBefore(stage.endDate);
	                                    return _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        {
	                                            key: stage.id,
	                                            to: '/sm/browser/football/tournaments/' + tournament.id + '/' + season.id + '/stages/' + stage.id
	                                        },
	                                        _react2.default.createElement(HighButton, {
	                                            live: live,
	                                            active: +params.stageId === stage.id,
	                                            name: stage.name,
	                                            sub: dates
	                                        })
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TournamentSMBrowser;
	}(_react2.default.Component);
	
	TournamentSMBrowser.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(state) {
	    // const {
	    //     router: {
	    //         params: { tournamentId, seasonId }
	    //     }
	    // } = props;
	
	    return _extends({}, state.smBrowser);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        initLoad: _actions.initLoad
	    };
	})(TournamentSMBrowser);

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initLoad = exports.loadWidgets = exports.loadBestPlayers = exports.loadEvent = exports.loadOdds = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var loadOdds = exports.loadOdds = function loadOdds(eventId, provider) {
	    return function (dispatch) {
	        fetch(_cfg2.default.apis.ss2 + '/odds/match?eventId=' + eventId + '&provider=' + provider, {
	            headers: {
	                Accept: 'application/json',
	                'Content-Type': 'application/json'
	            }
	        }).then(function (r) {
	            return r.json();
	        }).then(function (payload) {
	            return dispatch({
	                type: 'bulk',
	                payload: payload
	            });
	        });
	    };
	};
	
	var loadEvent = exports.loadEvent = function loadEvent(eventId) {
	    return function (dispatch) {
	        fetch(_cfg2.default.apis.ss2 + '/events/' + eventId, {
	            headers: {
	                Accept: 'application/json',
	                'Content-Type': 'application/json'
	            }
	        }).then(function (r) {
	            return r.json();
	        }).then(function (payload) {
	            return dispatch({
	                type: 'eventLoaded',
	                payload: payload
	            });
	        });
	    };
	};
	
	var loadBestPlayers = exports.loadBestPlayers = function loadBestPlayers(teamId) {
	    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';
	    return function (dispatch) {
	        fetch(_cfg2.default.apis.ss2 + '/incidents/goals/team/' + teamId, {
	            headers: {
	                Accept: 'application/json',
	                'Content-Type': 'application/json'
	            }
	        }).then(function (r) {
	            return r.json();
	        }).then(function (r) {
	            return _lodash2.default.chain(r).takeRight(20).filter({ active: 1 }).groupBy(function (i) {
	                return i.playerId;
	            }).toPairs().map(function (pair) {
	                var incident = pair[1][0];
	                incident.count = pair[1].length;
	                return incident;
	            }).sortBy(function (p) {
	                return -p.count;
	            }).take(3).value();
	        }).then(function (bestPlayers) {
	            return dispatch({
	                type: 'bulk',
	                payload: _defineProperty({}, side, bestPlayers)
	            });
	        });
	    };
	};
	
	var loadWidgets = exports.loadWidgets = function loadWidgets() {
	    return function (dispatch) {
	        return Promise.props({
	            widgets: fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + auth.getAccessToken()).then(function (response) {
	                return response.json();
	            })
	        }).then(function (_ref) {
	            var widgets = _ref.widgets;
	
	            return dispatch({
	                type: 'bulk',
	                payload: {
	                    widgets: widgets
	                }
	            });
	        });
	    };
	};
	
	var initLoad = exports.initLoad = function initLoad(tournamentId, seasonId) {
	    return function (dispatch) {
	        _RCore2.default.promiseProps({
	            tournament: fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId, {
	                headers: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (r) {
	                return r.json();
	            }),
	            teams: fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/teams', {
	                headers: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (r) {
	                return r.json();
	            }),
	            season: fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/season?' + (seasonId === 'current' ? '' : 'seasonId=' + seasonId), {
	                headers: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (r) {
	                return r.json();
	            }).then(function (r) {
	                return r.season;
	            })
	        }).then(function (payload) {
	            return dispatch({
	                type: 'initLoad',
	                payload: payload
	            });
	        });
	    };
	};

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smWidgetsStandings = function smWidgetsStandings(_ref) {
	    var tournamentId = _ref.tournamentId,
	        teamId = _ref.teamId,
	        seasonId = _ref.seasonId;
	
	    return [{
	        name: 'TournamentTableSMWidget',
	        props: {
	            teamId: teamId,
	            seasonId: seasonId,
	            tournamentId: tournamentId,
	            qualRel: false
	        }
	    }, {
	        name: 'TournamentTableSMWidget',
	        props: {
	            teamId: teamId,
	            seasonId: seasonId,
	            tournamentId: tournamentId,
	            qualrel: true,
	            full: true
	        }
	    }, {
	        name: 'LeagueTrackerSMWidget',
	        props: {
	            team1Id: teamId,
	            seasonId: seasonId,
	            tournamentId: tournamentId
	        }
	    }];
	};
	
	var smWidgetsMatches = function smWidgetsMatches(_ref2) {
	    var teamId = _ref2.teamId;
	
	    return [{
	        name: 'TeamMatchesSMWidget',
	        props: {
	            teamId: teamId,
	            status: 'notstarted',
	            limit: 5
	        }
	    }, {
	        name: 'TeamMatchesSMWidget',
	        props: {
	            teamId: teamId,
	            status: 'finished',
	            limit: 5
	        }
	    }];
	};
	
	var smWidgetsBest = function smWidgetsBest(_ref3) {
	    var teamId = _ref3.teamId;
	
	    return [{
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            teamId: teamId,
	            incidentType: 'goals',
	            activePlayers: true,
	            layout: 2
	        }
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            teamId: teamId,
	            incidentType: 'goals',
	            activePlayers: true,
	            layout: 1
	        }
	    }];
	};
	function TeamSeasonHomeSMB(_ref4) {
	    var params = _ref4.params;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgetsStandings(params), title: 'Standings' }),
	        _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgetsMatches(params), title: 'Matches' }),
	        _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgetsBest(params), title: 'Best players' })
	    );
	}
	
	TeamSeasonHomeSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	
	exports.default = TeamSeasonHomeSMB;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-bottom: 5px;\n'], ['\n    margin-bottom: 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    padding: 25px 0px;\n    margin-bottom: 25px;\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n    h1 {\n        margin: 0;\n        font-size: 36px;\n        line-height: 40px;\n        flex-grow: 1;\n\n        font-weight: 300;\n    }\n    &:after {\n        position: absolute;\n        content: \'\';\n        display: inline-block;\n        height: 2px;\n        width: 100px;\n        background: red;\n        bottom: 0px;\n    }\n'], ['\n    position: relative;\n    padding: 25px 0px;\n    margin-bottom: 25px;\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n    h1 {\n        margin: 0;\n        font-size: 36px;\n        line-height: 40px;\n        flex-grow: 1;\n\n        font-weight: 300;\n    }\n    &:after {\n        position: absolute;\n        content: \'\';\n        display: inline-block;\n        height: 2px;\n        width: 100px;\n        background: red;\n        bottom: 0px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    width: 480px;\n    display: grid;\n    position: relative;\n    grid-template-columns: 1fr;\n\n    & > * {\n        grid-column: 1 / 1;\n        grid-row: 1 / 1;\n    }\n\n    .main-frame {\n        z-index: 3;\n    }\n'], ['\n    width: 480px;\n    display: grid;\n    position: relative;\n    grid-template-columns: 1fr;\n\n    & > * {\n        grid-column: 1 / 1;\n        grid-row: 1 / 1;\n    }\n\n    .main-frame {\n        z-index: 3;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    margin: 0 -5px;\n    flex-wrap: wrap;\n    margin-bottom: 140px;\n\n    @media (max-width: 1156px) {\n        align-items: center;\n        justify-content: center;\n        margin: 0px;\n    }\n\n    .smi-widget {\n        width: 480px;\n        min-height: 1px !important;\n        overflow: hidden;\n        min-width: 1px !important;\n        pointer-events: none;\n    }\n\n    .item-single {\n        .header {\n            height: 40px;\n            position: relative;\n            color: #fff;\n            font-weight: 300;\n            label {\n                display: block;\n                line-height: 40px;\n                text-align: center;\n            }\n        }\n    }\n    .column {\n        padding: 0 5px;\n        .stack-item {\n            h3 {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n            width: 480px;\n            margin-bottom: 15px;\n            border-radius: 2px;\n        }\n    }\n    .top-overlay {\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n\n    .smi-widget-box {\n        position: relative;\n        text-align: center;\n        overflow: hidden;\n        .widget-cont {\n        }\n    }\n'], ['\n    display: flex;\n    margin: 0 -5px;\n    flex-wrap: wrap;\n    margin-bottom: 140px;\n\n    @media (max-width: 1156px) {\n        align-items: center;\n        justify-content: center;\n        margin: 0px;\n    }\n\n    .smi-widget {\n        width: 480px;\n        min-height: 1px !important;\n        overflow: hidden;\n        min-width: 1px !important;\n        pointer-events: none;\n    }\n\n    .item-single {\n        .header {\n            height: 40px;\n            position: relative;\n            color: #fff;\n            font-weight: 300;\n            label {\n                display: block;\n                line-height: 40px;\n                text-align: center;\n            }\n        }\n    }\n    .column {\n        padding: 0 5px;\n        .stack-item {\n            h3 {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n            width: 480px;\n            margin-bottom: 15px;\n            border-radius: 2px;\n        }\n    }\n    .top-overlay {\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n\n    .smi-widget-box {\n        position: relative;\n        text-align: center;\n        overflow: hidden;\n        .widget-cont {\n        }\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n    overflow: hidden;\n    &:hover {\n        transition: box-shadow 0.3s ease-in-out;\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n    }\n\n    &:hover:before {\n        content: \'\';\n        position: absolute;\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        background: #f2f2f2;\n        z-index: -1;\n        border-radius: 2px;\n    }\n    .share {\n        display: none;\n    }\n    &:hover {\n        position: relative;\n        .share {\n            display: block;\n        }\n        .smi-widget-box:after {\n            content: \'\';\n            position: absolute;\n            left: 0px;\n            right: 0px;\n            top: 0px;\n            bottom: 0px;\n            background: #000;\n            opacity: 0.2;\n            z-index: 1;\n            border-radius: 2px;\n        }\n    }\n\n    .widget-info {\n        border: 1px solid #efefef;\n        position: relative;\n        display: flex;\n        align-items: center;\n        h3 {\n            font-weight: 300;\n            margin-bottom: 4px;\n            margin-top: 4px;\n            padding-left: 10px;\n            font-size: 22px;\n        }\n    }\n\n    .pagination {\n        text-align: center;\n\n        * {\n            vertical-align: middle;\n        }\n        .dots {\n            box-sizing: content-box;\n            padding: 12px;\n\n            display: inline-block;\n            line-height: 24px;\n        }\n        .dot {\n            display: inline-block;\n            vertical-align: middle;\n            width: 6px;\n            height: 6px;\n            margin: 0 2px;\n            border-radius: 50%;\n            opacity: 0.8;\n            background-color: #fff;\n            &.active {\n                opacity: 1;\n            }\n        }\n    }\n'], ['\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n    overflow: hidden;\n    &:hover {\n        transition: box-shadow 0.3s ease-in-out;\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n    }\n\n    &:hover:before {\n        content: \'\';\n        position: absolute;\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        background: #f2f2f2;\n        z-index: -1;\n        border-radius: 2px;\n    }\n    .share {\n        display: none;\n    }\n    &:hover {\n        position: relative;\n        .share {\n            display: block;\n        }\n        .smi-widget-box:after {\n            content: \'\';\n            position: absolute;\n            left: 0px;\n            right: 0px;\n            top: 0px;\n            bottom: 0px;\n            background: #000;\n            opacity: 0.2;\n            z-index: 1;\n            border-radius: 2px;\n        }\n    }\n\n    .widget-info {\n        border: 1px solid #efefef;\n        position: relative;\n        display: flex;\n        align-items: center;\n        h3 {\n            font-weight: 300;\n            margin-bottom: 4px;\n            margin-top: 4px;\n            padding-left: 10px;\n            font-size: 22px;\n        }\n    }\n\n    .pagination {\n        text-align: center;\n\n        * {\n            vertical-align: middle;\n        }\n        .dots {\n            box-sizing: content-box;\n            padding: 12px;\n\n            display: inline-block;\n            line-height: 24px;\n        }\n        .dot {\n            display: inline-block;\n            vertical-align: middle;\n            width: 6px;\n            height: 6px;\n            margin: 0 2px;\n            border-radius: 50%;\n            opacity: 0.8;\n            background-color: #fff;\n            &.active {\n                opacity: 1;\n            }\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _keyboardArrowLeft = __webpack_require__(1593);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(1594);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactOnScreen = __webpack_require__(1673);
	
	var _reactOnScreen2 = _interopRequireDefault(_reactOnScreen);
	
	var _reactRedux = __webpack_require__(250);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SMStreamContainer = _styledComponents2.default.div(_templateObject);
	var SMHeader = _styledComponents2.default.div(_templateObject2);
	
	var Stack = _styledComponents2.default.div(_templateObject3);
	
	var Grid = _styledComponents2.default.div(_templateObject4);
	
	var StackViewContainer = _styledComponents2.default.div(_templateObject5);
	var C_DISPLAY_TYPE_KEY = 'C_DISPLAY_TYPE_KEY';
	
	var StackView = function (_React$Component) {
	    _inherits(StackView, _React$Component);
	
	    function StackView(props, context) {
	        _classCallCheck(this, StackView);
	
	        var _this = _possibleConstructorReturn(this, (StackView.__proto__ || Object.getPrototypeOf(StackView)).call(this, props, context));
	
	        _this.render = function () {
	            var items = _this.props.children.length;
	            return _react2.default.createElement(
	                StackViewContainer,
	                null,
	                _this.props.children[_this.state.index],
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-info', style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { flexGrow: 1, alignItems: 'center' } },
	                        _this.props.title
	                    ),
	                    items > 1 && _react2.default.createElement(
	                        rmd.IconButton,
	                        {
	                            disabled: _this.state.index === 0,
	                            onClick: function onClick(e) {
	                                return _this.setState({
	                                    index: (_this.state.index - 1) % items
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_keyboardArrowLeft2.default, { color: '#000' })
	                    ),
	                    items > 1 && _react2.default.createElement(
	                        rmd.IconButton,
	                        {
	                            disabled: _this.state.index === items - 1,
	                            onClick: function onClick(e) {
	                                return _this.setState({
	                                    index: (_this.state.index + 1) % items
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_keyboardArrowRight2.default, { color: '#000' })
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            index: 0
	        };
	        return _this;
	    }
	
	    return StackView;
	}(_react2.default.Component);
	
	function cancellable(func) {
	    var cancelled = false;
	
	    var cancellabled = function cancellabled() {
	        if (!cancelled) {
	            func.apply(undefined, arguments);
	        }
	    };
	
	    cancellabled.cancel = function () {
	        cancelled = true;
	        if (typeof func.onCancel === 'function') {
	            func.onCancel();
	        }
	    };
	
	    return cancellabled;
	}
	
	var StackOrder = function (_React$Component2) {
	    _inherits(StackOrder, _React$Component2);
	
	    function StackOrder() {
	        var _ref;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, StackOrder);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = StackOrder.__proto__ || Object.getPrototypeOf(StackOrder)).call.apply(_ref, [this].concat(args))), _this2), _this2.componentDidMount = function () {}, _this2.componentWillUnmount = function () {
	            if (_this2.timeout) clearTimeout(_this2.timeout);
	            if (_this2.handleImgBlurLoaded) _this2.handleImgBlurLoaded.cancel();
	            if (_this2.handleStubLoaded) _this2.handleStubLoaded.cancel();
	            if (_this2.handleMainLoaded) _this2.handleMainLoaded.cancel();
	            if (_this2.handleMainError) _this2.handleMainError.cancel();
	        }, _this2.state = {
	            load: 'none',
	            mainLoaded: false,
	            stubLoaded: false,
	            imageLoadFailed: false
	        }, _this2.handleImgBlurLoaded = cancellable(function () {
	            _this2.setState({ stubLoaded: true });
	        }), _this2.handleStubLoaded = cancellable(function () {
	            _this2.setState({ stubLoaded: true });
	        }), _this2.handleMainLoaded = cancellable(function () {
	            _this2.setState({ mainLoaded: true });
	        }), _this2.handleImageLoadError = cancellable(function () {
	            _this2.props.dispatch({ type: 'hashPreviewFailed' });
	            _this2.setState({ imageLoadFailed: true });
	        }), _this2.renderStub = function (previewUrl) {
	            return _react2.default.createElement(
	                Stack,
	                null,
	                _react2.default.createElement('img', {
	                    style: { width: 480, filter: 'blur(14px)' },
	                    src: previewUrl,
	                    onLoad: _this2.handleImgBlurLoaded,
	                    onError: _this2.handleImageLoadError
	                })
	            );
	        }, _this2.renderJSEmbed = function () {
	            if (!_this2.state.mainLoaded) {
	                clearTimeout(_this2.timeout);
	                _this2.timeout = setTimeout(function () {
	                    _this2.setState({ mainLoaded: true });
	                }, 1000);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'main-frame' },
	                _this2.props.jsWidget
	            );
	        }, _this2.renderImagePreview = function () {
	            var _this2$props = _this2.props,
	                url = _this2$props.url,
	                preview = _this2$props.preview;
	            var mainLoaded = _this2.state.mainLoaded;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('img', {
	                    style: { width: 480, filter: 'blur(14px)', display: !mainLoaded ? 'block' : 'none' },
	                    src: preview && preview.url ? preview.url : url + '&wdpcache=widget'
	                }),
	                _react2.default.createElement('img', {
	                    className: 'main-frame',
	                    style: { width: 480, display: mainLoaded ? 'block' : 'none' },
	                    src: url + '&wdpcache=state',
	                    onLoad: _this2.handleMainLoaded,
	                    onError: _this2.handleImageLoadError
	                })
	            );
	        }, _this2.render = function () {
	            var _this2$props2 = _this2.props,
	                hashImagePreviewEnable = _this2$props2.hashImagePreviewEnable,
	                preview = _this2$props2.preview,
	                url = _this2$props2.url;
	            var _this2$state = _this2.state,
	                imageLoadFailed = _this2$state.imageLoadFailed,
	                stubLoaded = _this2$state.stubLoaded;
	
	
	            var previewUrl = preview && preview.url ? preview.url : url + '&wdpcache=widget';
	
	            // if webshot not working -> use js emebed code
	            if (!hashImagePreviewEnable || imageLoadFailed) return _react2.default.createElement(
	                Stack,
	                null,
	                _this2.renderJSEmbed()
	            );else if (!stubLoaded) return _this2.renderStub(previewUrl);else return _this2.renderImagePreview(previewUrl);
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    return StackOrder;
	}(_react2.default.Component);
	
	var StackOrderE = (0, _reactRedux.connect)(function (state) {
	    return {
	        hashImagePreviewEnable: state.smBrowser.hashImagePreviewEnable
	    };
	}, function (dispatch) {
	    return { dispatch: dispatch };
	})(StackOrder);
	
	var SMStream = function (_React$Component3) {
	    _inherits(SMStream, _React$Component3);
	
	    function SMStream(props, context) {
	        _classCallCheck(this, SMStream);
	
	        var _this3 = _possibleConstructorReturn(this, (SMStream.__proto__ || Object.getPrototypeOf(SMStream)).call(this, props, context));
	
	        _initialiseProps.call(_this3);
	
	        _this3.templateObserver = _this3.context.templateObserver;
	        _this3.state = {
	            smWidgets: [],
	            display: localStorage.getItem(C_DISPLAY_TYPE_KEY) || 'row'
	        };
	        return _this3;
	    }
	
	    _createClass(SMStream, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.templateObserver) {
	                this.templateObserver.unsubscribe(this.handleTempleateUpdate);
	            }
	            window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	        }
	    }, {
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            return _react2.default.createElement(
	                'h1',
	                null,
	                this.props.title || this.constructor.name
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var templateId = this.templateObserver.getTemplate();
	            var smWidgets = this.props.smWidgets;
	            var previewWidget = this.state.previewWidget;
	
	            if (smWidgets.length === 0) return _react2.default.createElement('div', null);
	            // if (this.container) cols = Math.floor(this.container.offsetWidth / 500);
	            var cols = 3;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactOnScreen2.default,
	                    {
	                        once: true,
	                        partialVisibility: true,
	                        key: 'r',
	                        ref: function ref(c) {
	                            _this4.container = c;
	                        }
	                    },
	                    function (_ref2) {
	                        var isVisible = _ref2.isVisible;
	                        return _react2.default.createElement(
	                            SMStreamContainer,
	                            { key: 'rw' },
	                            _react2.default.createElement(
	                                SMHeader,
	                                null,
	                                _this4.renderToolbar()
	                            ),
	                            _this4.renderGroupedWidgets(cols, isVisible)
	                        );
	                    }
	                ),
	                previewWidget && _react2.default.createElement(_SMPostDialog2.default, {
	                    eventId: this.props.eventId,
	                    templateId: templateId,
	                    previewWidget: previewWidget,
	                    widgetName: previewWidget.name,
	                    showAllParams: false,
	                    open: previewWidget !== null,
	                    onRequestClose: function onRequestClose() {
	                        return _this4.setState({
	                            previewWidget: null
	                        });
	                    }
	                })
	            );
	        }
	    }]);
	
	    return SMStream;
	}(_react2.default.Component);
	
	SMStream.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    templateObserver: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this5 = this;
	
	    this.componentDidMount = function () {
	        if (_this5.templateObserver) {
	            _this5.templateObserver.subscribe(_this5.handleTempleateUpdate);
	        }
	        _this5._debounceHandleScreenSizeUpdate = _lodash2.default.debounce(_this5.handleScreenSizeUpdate.bind(_this5), 100);
	        window.addEventListener('resize', _this5._debounceHandleScreenSizeUpdate, false);
	    };
	
	    this.handleTempleateUpdate = function () {
	        _this5.forceUpdate();
	    };
	
	    this.handleScreenSizeUpdate = function () {
	        var width = _reactDom2.default.findDOMNode(_this5).offsetWidth;
	
	        _this5.setState({ width: width });
	    };
	
	    this.renderSMImage = function (name, props, key, displayVisible, cardProps) {
	        var _context = _this5.context,
	            user = _context.user,
	            widgets = _context.widgets;
	
	        var templateId = _this5.templateObserver.getTemplate();
	
	        var style = {};
	
	        var widget = _lodash2.default.find(widgets, function (w) {
	            return w.id === name;
	        });
	        if (!widget) {
	            return _react2.default.createElement('div', null);
	        }
	
	        var load = 'sm';
	        if (widget.spec.video) load = 'video';
	
	        var propsJS = _lodash2.default.extend(props, {
	            template: templateId,
	            lang: user.props.lang,
	            tz: _lodash2.default.get(user, 'props.timezone', 'CET')
	        });
	
	        var widgetURL = _cfg2.default.WDPLinkr.widget.image(user.client, user.username, 'default', name, propsJS);
	
	        return _react2.default.createElement(
	            'div',
	            {
	                className: 'smi-widget-box',
	                style: style,
	                key: widgetURL,
	                onClick: function onClick(e) {
	                    _this5.handleShare(name, props, widget.spec);
	                }
	            },
	            load !== 'video' && _react2.default.createElement(StackOrderE, {
	                key: widgetURL + '_' + displayVisible,
	                preview: widget.preview,
	                url: widgetURL,
	                loadall: displayVisible,
	                mode: 'js',
	                name: name,
	                jsWidget: _react2.default.createElement('rlz-widget', _extends({
	                    'class': 'smi-widget',
	                    'data-name': name,
	                    'data-load': load,
	                    'data-client': user.client,
	                    'data-user': user.username,
	                    'data-lang': _lodash2.default.get(user, 'props.lang'),
	                    'data-tz': _lodash2.default.get(user, 'props.timezone', 'CET'),
	                    'data-token': user.accessToken,
	                    'data-template': templateId,
	                    'data-theme': user.defaultTheme,
	                    'data-min-width': 800,
	                    'data-sm-browser': true,
	                    'data-zoom': 0.6
	                }, _RCore2.default.obj2InjectorParams(props)))
	            }),
	            load === 'video' && _react2.default.createElement('rlz-widget', _extends({
	                key: name,
	                'class': 'smi-widget',
	                'data-name': name,
	                'data-load': 'animated',
	                'data-client': user.client,
	                'data-user': user.username,
	                'data-lang': _lodash2.default.get(user, 'props.lang'),
	                'data-tz': _lodash2.default.get(user, 'props.timezone', 'CET'),
	                'data-token': user.accessToken,
	                'data-template': templateId,
	                'data-theme': user.defaultTheme,
	                'data-min-width': 800,
	                'data-sm-browser': true,
	                'data-zoom': 0.6
	            }, _RCore2.default.obj2InjectorParams(props)))
	        );
	    };
	
	    this.handleShare = function (name, props, spec) {
	        _this5.setState({
	            previewWidget: {
	                name: name,
	                props: _lodash2.default.clone(props),
	                spec: spec
	            }
	        });
	    };
	
	    this.renderGroupedWidgets = function (cols) {
	        var displayVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (cols === 0) return _react2.default.createElement('div', null);
	
	        var smWidgets = _this5.props.smWidgets;
	
	        var groupedWidgetPairs = _lodash2.default.chain(smWidgets).groupBy(function (w) {
	            return w.groupKey || w.name;
	        }).toPairs().value();
	
	        var columns = _lodash2.default.range(cols).map(function (i) {
	            return [];
	        });
	        groupedWidgetPairs.forEach(function (w, i) {
	            return columns[i % cols].push(w);
	        });
	
	        return _react2.default.createElement(
	            Grid,
	            null,
	            columns.map(function (widgets, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'column', key: index },
	                    widgets.map(function (pair, i) {
	                        var name = pair[0];
	                        var widgets = pair[1];
	
	                        var title = widgets[0].groupTitle || widgets[0]['data-title'] || name;
	                        var desc = widgets[0].groupDesc;
	                        var minHeight = widgets[0].minHeight;
	
	                        return _react2.default.createElement(
	                            'div',
	                            { key: name + '_' + i, className: 'stack-item' },
	                            _react2.default.createElement(
	                                StackView,
	                                {
	                                    title: title,
	                                    desc: desc,
	                                    widgets: widgets,
	                                    onShare: _this5.handleShare
	                                },
	                                widgets.map(function (sm) {
	                                    return _this5.renderSMImage(sm.name, sm.props, sm.key, displayVisible, {
	                                        minHeight: minHeight
	                                    });
	                                })
	                            )
	                        );
	                    })
	                );
	            })
	        );
	    };
	};
	
	exports.default = SMStream;

/***/ },
/* 1593 */,
/* 1594 */,
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WidgetParams = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _allInclusive = __webpack_require__(1033);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _link = __webpack_require__(1596);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _edit = __webpack_require__(1597);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _openInNew = __webpack_require__(1296);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _immutabilityHelper = __webpack_require__(596);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _widgets = __webpack_require__(1598);
	
	var _pickers = __webpack_require__(1131);
	
	var _pickers2 = _interopRequireDefault(_pickers);
	
	var _common = __webpack_require__(1599);
	
	var _helpers = __webpack_require__(592);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	var _EmojiPicker = __webpack_require__(1600);
	
	var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
	
	var _odds = __webpack_require__(1638);
	
	var _actions = __webpack_require__(587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnhancedOddsPicker = (0, _recompose.compose)((0, _reactRedux.connect)(), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        if (this.props.eventId) {
	            this.props.dispatch((0, _actions.setEventId)(this.props.eventId));
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	        var eventId = _ref.eventId;
	
	        if (this.props.eventId !== eventId) {
	            this.props.dispatch((0, _actions.setEventId)(eventId));
	        }
	    }
	}))(_odds.OddsPicker);
	
	var fixDialoguePos = function fixDialoguePos() {
	    // window.dispatchEvent(new Event('resize'));
	    setTimeout(function () {
	        window.dispatchEvent(new Event('resize'));
	    }, 500);
	    setTimeout(function () {
	        window.dispatchEvent(new Event('resize'));
	    }, 1000);
	    setTimeout(function () {
	        window.dispatchEvent(new Event('resize'));
	    }, 2000);
	    setTimeout(function () {
	        window.dispatchEvent(new Event('resize'));
	    }, 3000);
	};
	var SMPostDialog = (0, _reactRedux.connect)(function (state) {
	    return {
	        defaultProvider: _lodash2.default.get(state, ['user', 'props', 'oddsProvider']),
	        allowedProviders: _lodash2.default.get(state, ['user', 'props', 'allowedProviders']),
	        bitlyAccessToken: _lodash2.default.get(state, ['user', 'props', 'bitlyAccessToken'], _cfg2.default.bitlyKey)
	    };
	})((_temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            //load user images from media gallery
	
	            window.fbAsyncInit = function () {
	                window.FB.init({
	                    appId: _cfg2.default.fbWDP.appId,
	                    cookie: true,
	                    xfbml: true,
	                    version: 'v2.10'
	                });
	                _this.setState({ fbLoaded: true });
	            };
	
	            fixDialoguePos();
	        };
	
	        _this.assignInputRef = function (el) {
	            if (el) {
	                if (el.input instanceof Node) {
	                    _this.inputRef = el.input;
	                } else {
	                    _this.inputRef = el.input.refs.input;
	                }
	                _this.addText = (0, _common.addInputText)(_this.inputRef, _this.onMessageChange);
	            }
	        };
	
	        _this.handleDownload = function () {
	            var _this$context = _this.context,
	                user = _this$context.user,
	                widgets = _this$context.widgets;
	            var _this$state = _this.state,
	                widget = _this$state.widget,
	                jsprops = _this$state.jsprops;
	
	
	            _this.setState({ downloadProcess: true });
	
	            var widgetCfg = _lodash2.default.find(widgets, function (w) {
	                return String(w.id) === String(widget.name);
	            });
	
	            if (widgetCfg.spec.video) {
	                var videoUrl = _cfg2.default.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.name, _extends({}, _RCore2.default.prepareWidgetPropsObj(jsprops), {
	                    // startAnimation: false,
	                    js: true,
	                    zoom: null,
	                    load: null
	                }));
	                (0, _widgets.browserDownloadWidget2video)(widgetCfg, videoUrl).then(function (r) {
	                    _this.setState({
	                        downloadProcess: false
	                    });
	                });
	            } else {
	                var smUrl = _cfg2.default.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.name, _extends({}, _RCore2.default.prepareWidgetPropsObj(jsprops), {
	                    __mode: 'strict'
	                }));
	
	                var htmlUrl = _cfg2.default.WDPLinkr.widget.iframe(user.client, user.username, user.defaultTheme, widget.name, _extends({}, _RCore2.default.prepareWidgetPropsObj(jsprops), {
	                    __mode: 'strict'
	                }));
	
	                var url = widgetCfg.spec.social ? smUrl : htmlUrl;
	
	                (0, _widgets.browserDownloadWidget2image)(widgetCfg, url).then(function (r) {
	                    return _this.setState({ downloadProcess: false });
	                });
	            }
	        };
	
	        _this.onClose = function (e) {
	            _this.setState(function () {
	                if (_this.props.onRequestClose) {
	                    _this.props.onRequestClose(e);
	                }
	            });
	        };
	
	        _this.onMessageChange = function (event, message) {
	            _this.setState({ message: typeof event === 'string' ? event : message });
	        };
	
	        _this.handleSubmitPost = function (c, params) {
	            var widget = _this.state.widget;
	            var user = _this.context.user;
	
	            var url = _cfg2.default.campaign_manager.host + '/api/posts?access_token=' + _auth2.default.getAccessToken();
	
	            var body = {
	                campaignId: c._id,
	                presentation: {
	                    name: widget.name,
	                    params: _lodash2.default.extend({
	                        username: user.username,
	                        client: user.client,
	                        theme: 'default'
	                    }, params),
	                    type: 'widget-social'
	                },
	                content: {
	                    message: _this.state.message
	                }
	            };
	
	            fetch(url, {
	                method: 'post',
	                headers: {
	                    Accept: 'application/json, text/plain, */*',
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(body)
	            }).then(function (res) {
	                return res.json();
	            }).then(function (res) {
	                _reactRouter.browserHistory.push({
	                    pathname: '/campaigns/view/' + c._id
	                });
	            });
	        };
	
	        _this.handleOddAdd = function (_ref2) {
	            var message = _ref2.message,
	                url = _ref2.url;
	
	            if (url) {
	                _this.setState({ textGenerating: true });
	                var path = _cfg2.default.dash.api.host + '/api/media/shorten-url';
	                _superagent2.default.get(path).query({ url: url, accessToken: _this.props.bitlyAccessToken }).then(function (res) {
	                    _this.setState({ textGenerating: false });
	                    if (res.body.data && res.body.data.url) {
	                        var _url = res.body.data.url;
	
	                        var hasNewLine = message && message.charAt(message.length - 1) === '\n';
	                        var next = null;
	                        if (message) {
	                            next = hasNewLine ? message + _url : message + '\n' + _url;
	                        } else {
	                            next = _url;
	                        }
	                        _this.addText(_this.state.message)(next + '\n');
	                    }
	                }).catch(function (e) {
	                    _this.setState({ textGenerating: false });
	                });
	            } else if (message) {
	                _this.addText(_this.state.message)(message);
	            }
	        };
	
	        var defaultProvider = props.defaultProvider,
	            allowedProviders = props.allowedProviders;
	
	        var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	        var provider = defaultProvider && providers.some(function (p) {
	            return p.id === defaultProvider;
	        }) ? defaultProvider : null;
	
	        _this.templateObserver = _this.context.templateObserver;
	        _this.state = {
	            message: '',
	            textGenerating: false,
	            widget: props.previewWidget,
	            socialMessage: '',
	            fbPagesLoading: false,
	            contentGenerating: false,
	
	            fbIsPosting: false,
	
	            showFBSourceSelect: false,
	            showTwitterSelect: false,
	            // PostingProcess component
	            showProcess: false,
	            // odds
	            providers: providers,
	            provider: provider
	        };
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref3) {
	            var allowedProviders = _ref3.allowedProviders;
	
	            if (this.props.allowedProviders !== allowedProviders) {
	                var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	                this.setState({ providers: providers });
	            }
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var _this2 = this;
	
	            var _context = this.context,
	                user = _context.user,
	                campaigns = _context.campaigns;
	            var showAllParams = this.props.showAllParams;
	            var _state = this.state,
	                downloadProcess = _state.downloadProcess,
	                widget = _state.widget,
	                fbLoaded = _state.fbLoaded,
	                jsprops = _state.jsprops;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                widget && _react2.default.createElement(FastWidgetEdit, {
	                    widget: widget,
	                    showAllParams: showAllParams,
	                    onPropsChange: function onPropsChange(key, val, props) {
	                        _this2.setState({ jsprops: props });
	                        if (_this2.props.onPropsChange) _this2.props.onPropsChange(props);
	                        fixDialoguePos();
	                    }
	                })
	            );
	        }
	    }, {
	        key: 'getActions',
	        value: function getActions() {
	            var _this3 = this;
	
	            var _context2 = this.context,
	                campaigns = _context2.campaigns,
	                user = _context2.user;
	            var _state2 = this.state,
	                downloadProcess = _state2.downloadProcess,
	                widget = _state2.widget,
	                fbLoaded = _state2.fbLoaded,
	                _state2$jsprops = _state2.jsprops,
	                jsprops = _state2$jsprops === undefined ? {} : _state2$jsprops;
	
	
	            var url = void 0;
	
	            if (widget.spec.video) {
	                url = _cfg2.default.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.name, _extends({}, jsprops, {
	                    zoom: null,
	                    load: null
	                }));
	            } else {
	                url = _cfg2.default.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.name, _extends({}, jsprops, {
	                    __mode: 'strict'
	                }));
	            }
	
	            return [_react2.default.createElement(_materialUi.FlatButton, {
	                key: 'Down',
	                label: 'Download',
	                disabled: downloadProcess,
	                onClick: function onClick() {
	                    return _this3.handleDownload();
	                },
	                icon: downloadProcess ? _react2.default.createElement(_materialUi.CircularProgress, { size: 24 }) : _react2.default.createElement(_fileDownload2.default, null)
	            }), _react2.default.createElement(
	                _materialUi.IconMenu,
	                {
	                    key: 'cmp',
	                    iconButtonElement: _react2.default.createElement(_materialUi.FlatButton, {
	                        disabled: campaigns.length === 0,
	                        label: 'Post to campaign',
	                        icon: _react2.default.createElement(_allInclusive2.default, null)
	                    })
	                },
	                campaigns.map(function (c) {
	                    return _react2.default.createElement(_materialUi.MenuItem, {
	                        key: c.title,
	                        desktop: true,
	                        primaryText: c.title,
	                        onTouchTap: function onTouchTap() {
	                            _this3.handleSubmitPost(c, jsprops);
	                        }
	                    });
	                })
	            ), _react2.default.createElement(
	                _materialUi.IconMenu,
	                {
	                    key: 'cmpa',
	                    desktop: true,
	                    iconButtonElement: _react2.default.createElement(_materialUi.FlatButton, { style: { minWidth: 0 }, icon: _react2.default.createElement(_moreVert2.default, null) }),
	                    anchorOrigin: { horizontal: 'right', vertical: 'top' },
	                    targetOrigin: { horizontal: 'right', vertical: 'top' }
	                },
	                _react2.default.createElement(_materialUi.MenuItem, { disabled: true, leftIcon: _react2.default.createElement(_link2.default, null), primaryText: 'Get Links' }),
	                _react2.default.createElement(_materialUi.Divider, null),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                    leftIcon: _react2.default.createElement(_edit2.default, null),
	                    primaryText: 'Full Edit',
	                    onTouchTap: function onTouchTap() {
	                        _reactRouter.browserHistory.push({
	                            pathname: '/sm/browser/post/' + widget.name + '/',
	                            query: jsprops
	                        });
	                    }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                    leftIcon: _react2.default.createElement(_style2.default, null),
	                    primaryText: 'Edit widget theme',
	                    onTouchTap: function onTouchTap() {
	                        return _reactRouter.browserHistory.push({
	                            pathname: '/sm/templates/edit',
	                            query: { wid: widget.name, tid: jsprops.template }
	                        });
	                    }
	                }),
	                _react2.default.createElement(_materialUi.MenuItem, {
	                    leftIcon: _react2.default.createElement(_openInNew2.default, null),
	                    primaryText: 'Open in new window',
	                    onTouchTap: function onTouchTap() {
	                        window.open(url, '_blank');
	                    }
	                })
	            )];
	        }
	    }, {
	        key: 'renderOddsPicker',
	        value: function renderOddsPicker() {
	            var _state3 = this.state,
	                providers = _state3.providers,
	                _state3$jsprops = _state3.jsprops,
	                jsprops = _state3$jsprops === undefined ? {} : _state3$jsprops;
	            var eventId = jsprops.eventId;
	
	            eventId = eventId || this.props.eventId;
	            var shouldShow = providers && providers.length > 0;
	            var showEventPicker = !eventId;
	            return shouldShow ? _react2.default.createElement(EnhancedOddsPicker, { eventId: eventId, showEventPicker: showEventPicker, onAdd: this.handleOddAdd }) : null;
	        }
	    }, {
	        key: 'renderDialogue',
	        value: function renderDialogue() {
	            var _props = this.props,
	                open = _props.open,
	                showAllParams = _props.showAllParams;
	
	            return _react2.default.createElement(
	                _materialUi.Dialog,
	                {
	                    open: open,
	                    modal: false,
	                    autoScrollBodyContent: true,
	                    onRequestClose: this.onClose,
	                    repositionOnUpdate: true,
	                    contentStyle: {
	                        width: 1180,
	                        maxWidth: 'none'
	                    },
	                    actions: this.getActions()
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.renderContent()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', alignItems: 'flex-end' } },
	                        _react2.default.createElement(_materialUi.TextField, {
	                            multiLine: true,
	                            floatingLabelText: 'Social message text',
	                            floatingLabelFixed: true,
	                            hintText: 'For FB and Twitter',
	                            disabled: this.state.textGenerating,
	                            name: 'message',
	                            style: { width: 753 },
	                            value: this.state.message,
	                            onChange: this.onMessageChange,
	                            ref: this.assignInputRef
	                        }),
	                        this.renderOddsPicker(),
	                        _react2.default.createElement(_EmojiPicker2.default, {
	                            value: this.state.message,
	                            disabled: this.state.textGenerating,
	                            onChange: this.onMessageChange,
	                            inputRef: this.inputRef
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderInline',
	        value: function renderInline() {
	            var _this4 = this;
	
	            var _context3 = this.context,
	                user = _context3.user,
	                widgets = _context3.widgets;
	            var widget = this.state.widget;
	
	            var widgetCfg = widget && _lodash2.default.find(widgets, function (w) {
	                return String(w.id) === String(_this4.state.widget.name);
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.Paper,
	                    { style: { marginBottom: 16, marginLeft: -16, marginRight: -16, marginTop: -16 }, zDepth: 0 },
	                    _react2.default.createElement(
	                        _materialUi.Toolbar,
	                        null,
	                        _react2.default.createElement(
	                            _materialUi.ToolbarGroup,
	                            null,
	                            this.props.title || widgetCfg.name
	                        )
	                    )
	                ),
	                this.renderContent(),
	                widget && _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', justifyContent: 'flex-end' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', alignItems: 'flex-end' } },
	                        _react2.default.createElement(_materialUi.TextField, {
	                            multiLine: true,
	                            floatingLabelText: 'Social message text',
	                            floatingLabelFixed: true,
	                            hintText: 'For FB and Twitter',
	                            name: 'message',
	                            style: { width: 753 },
	                            value: this.state.message,
	                            onChange: this.onMessageChange,
	                            ref: this.assignInputRef
	                        }),
	                        this.renderOddsPicker(),
	                        _react2.default.createElement(_EmojiPicker2.default, {
	                            value: this.state.message,
	                            onChange: this.onMessageChange,
	                            inputRef: this.inputRef
	                        })
	                    )
	                ),
	                widget && _react2.default.createElement(
	                    _materialUi.Paper,
	                    { style: { marginBottom: -16, marginLeft: -16, marginRight: -16 }, zDepth: 0 },
	                    _react2.default.createElement(
	                        _materialUi.Toolbar,
	                        null,
	                        _react2.default.createElement(_materialUi.ToolbarGroup, null),
	                        _react2.default.createElement(
	                            _materialUi.ToolbarGroup,
	                            null,
	                            widget && this.getActions()
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var inline = this.props.inline;
	
	
	            if (inline) {
	                return this.renderInline();
	            } else {
	                return this.renderDialogue();
	            }
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component), _class.defaultProps = {
	    showAllParams: false
	}, _class.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    templateObserver: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	}, _temp));
	
	function cancellable(func) {
	    var cancelled = false;
	
	    var cancellabled = function cancellabled() {
	        if (!cancelled) {
	            func.apply(undefined, arguments);
	        }
	    };
	
	    cancellabled.cancel = function () {
	        cancelled = true;
	        if (typeof func.onCancel === 'function') {
	            func.onCancel();
	        }
	    };
	
	    return cancellabled;
	}
	
	var FastWidgetEdit = function (_React$Component2) {
	    _inherits(FastWidgetEdit, _React$Component2);
	
	    function FastWidgetEdit(props, context) {
	        _classCallCheck(this, FastWidgetEdit);
	
	        var _this5 = _possibleConstructorReturn(this, (FastWidgetEdit.__proto__ || Object.getPrototypeOf(FastWidgetEdit)).call(this, props, context));
	
	        _initialiseProps.call(_this5);
	
	        _this5.templateObserver = _this5.context.templateObserver;
	        var user = context.user;
	        var widget = props.widget;
	
	
	        var clientPreferences = {
	            lang: _lodash2.default.get(user, 'props.lang'),
	            tz: _lodash2.default.get(user, 'props.timezone', 'CET')
	        };
	
	        var widgetDefaults = _lodash2.default.chain(widget.spec.propTypes).map(function (i) {
	            return [i.key, i.defaultValue];
	        }).fromPairs().value();
	
	        _this5.state = {
	            widget: widget,
	            jsprops: _lodash2.default.extend({}, _lodash2.default.pickBy(clientPreferences), _lodash2.default.pickBy(widgetDefaults), {
	                template: _this5.templateObserver.getTemplate()
	            }, _RCore2.default.injectorParams2Obj(widget.props))
	        };
	        var widgetId = widget.id || widget.name;
	
	        _this5.widgetRequestCallback = cancellable(function () {
	            _this5.setState(_defineProperty({}, widgetId, true));
	        });
	
	        window.wdpload(widgetId, {}, {}, _this5.widgetRequestCallback);
	        return _this5;
	    }
	
	    return FastWidgetEdit;
	}(_react2.default.Component);
	
	FastWidgetEdit.defaultProps = {
	    showAllParams: false
	};
	FastWidgetEdit.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    templateObserver: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this7 = this;
	
	    this.componentDidMount = function () {
	        if (_this7.props.onPropsChange) _this7.props.onPropsChange(null, null, _this7.state.jsprops);
	    };
	
	    this.componentWillReceiveProps = function () {};
	
	    this.componentWillUnmount = function () {
	        if (_this7.widgetRequestCallback) _this7.widgetRequestCallback.cancel();
	    };
	
	    this.changePropValue = function (prop, val) {
	        var changedProp = void 0;
	        if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	            changedProp = prop;
	        } else {
	            changedProp = {};
	            changedProp[prop] = val;
	        }
	
	        var upd = (0, _immutabilityHelper2.default)(_this7.state, {
	            jsprops: {
	                $merge: changedProp
	            }
	        });
	        upd.jsprops = _lodash2.default.omit(upd.jsprops);
	        _this7.setState(upd, function () {
	            if (_this7.props.onPropsChange) _this7.props.onPropsChange(prop, val, _this7.state.jsprops);
	        });
	    };
	
	    this.render = function () {
	        var user = _this7.context.user;
	        var _props2 = _this7.props,
	            showAllParams = _props2.showAllParams,
	            widget = _props2.widget;
	        var jsprops = _this7.state.jsprops;
	
	
	        var widgetId = widget.id || widget.name;
	
	        var CMP = _lodash2.default.get(window, '[rlz' + widgetId + '][' + widgetId + ']');
	
	        // var widgetCfg = _.find(widgets, w => String(w.id) === String(widgetId));
	
	        //console.log('picker', widget.spec.demo);
	
	        return _react2.default.createElement(
	            'div',
	            { style: { display: 'flex' } },
	            _react2.default.createElement(
	                'div',
	                { style: { width: 300, minWidth: 300, marginRight: 16, flexGrow: 1 } },
	                _react2.default.createElement(WidgetParams, {
	                    key: '123',
	                    widget: widget,
	                    showAllParams: showAllParams,
	                    jsprops: jsprops,
	                    onPropChange: _this7.changePropValue
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _materialUi.Card,
	                    { initiallyExpanded: true },
	                    _react2.default.createElement(_materialUi.CardHeader, { title: 'Demo examples' }),
	                    _react2.default.createElement(
	                        _materialUi.List,
	                        null,
	                        widget && widget.spec.demo.map(function (demo) {
	                            return _react2.default.createElement(_materialUi.ListItem, {
	                                key: demo.title,
	                                primaryText: demo.title,
	                                onClick: function onClick(e) {
	                                    var props = _lodash2.default.clone(demo.props);
	
	                                    Reflect.deleteProperty(props, 'template');
	
	                                    _reactRouter.browserHistory.push({
	                                        pathname: '/sm/browser/post/' + widget.name + '/',
	                                        query: _lodash2.default.extend({}, jsprops, props)
	                                    });
	
	                                    _this7.setState({
	                                        jsprops: _lodash2.default.extend({}, jsprops, props)
	                                    });
	                                }
	                            });
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { width: 800, minWidth: 800, minHeight: 600 } },
	                CMP && _react2.default.createElement(
	                    _materialUi.Paper,
	                    {
	                        zDepth: 1,
	                        style: {
	                            position: 'sticky',
	                            top: '75px'
	                            // position: '-webkit-sticky'
	                        }
	                    },
	                    _react2.default.createElement(
	                        _WDPContext2.default,
	                        _extends({
	                            client: user.client,
	                            user: user.username,
	                            token: user.accessToken,
	                            lang: jsprops.lang,
	                            tz: jsprops.tz,
	                            key: widget.id + '_' + jsprops.template
	                        }, jsprops, {
	                            editMode: true
	                        }),
	                        _react2.default.createElement(CMP, _extends({ name: widgetId }, jsprops, { editMode: true }))
	                    )
	                )
	            )
	        );
	    };
	};
	
	var WidgetParams = function (_React$PureComponent) {
	    _inherits(WidgetParams, _React$PureComponent);
	
	    function WidgetParams() {
	        var _ref4;
	
	        var _temp2, _this6, _ret;
	
	        _classCallCheck(this, WidgetParams);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp2 = (_this6 = _possibleConstructorReturn(this, (_ref4 = WidgetParams.__proto__ || Object.getPrototypeOf(WidgetParams)).call.apply(_ref4, [this].concat(args))), _this6), _this6.shouldComponentUpdate = function (nextProps, nextState) {
	            // if was changed any of required params....
	
	            // let { widget } = this.props;
	            // let newP = nextProps.jsprops;
	            // let oldP = this.props.jsprops;
	            // let requiredParamWasChanged = _.filter(
	            //     widget.spec.propTypes,
	            //     pp =>
	            //         (pp.required && newP[pp.key] !== oldP[pp.key]) ||
	            //         (pp.propsMap && _.find(_.values(pp.propsMap), pm => newP[pm] !== oldP[pm]))
	            // );
	
	            // if (requiredParamWasChanged.length) {
	            //     return true;
	            // }
	
	            return true;
	        }, _this6.render = function () {
	            var _this6$props = _this6.props,
	                widget = _this6$props.widget,
	                showAllParams = _this6$props.showAllParams,
	                jsprops = _this6$props.jsprops,
	                onPropChange = _this6$props.onPropChange,
	                backgroundOnly = _this6$props.backgroundOnly;
	
	
	            var pp = _lodash2.default.filter(widget.spec.propTypes, function (p) {
	                return showAllParams || p.ui;
	            });
	            var groups = _lodash2.default.groupBy(pp, function (i) {
	                if (i.scope) return i.scope;
	                // if (i.loader && i.required === false) return 'other';
	                if (i.required) return 'required';
	                if (i.ui) return 'ui';
	                return 'other';
	            });
	
	            if (backgroundOnly) groups = _lodash2.default.pick(groups, 'images');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                Object.keys(groups).map(function (g) {
	                    var title = g.charAt(0).toUpperCase() + g.substr(1);
	                    return _react2.default.createElement(
	                        _materialUi.Card,
	                        { key: g, zDepth: 1 },
	                        _react2.default.createElement(_materialUi.CardHeader, {
	                            title: title + ' scope',
	                            subtitle: groups[g].map(function (g) {
	                                return g.label;
	                            }).join(', '),
	                            style: { background: '#f0f0f0' },
	                            subtitleStyle: {},
	                            actAsExpander: true,
	                            showExpandableButton: true
	                        }),
	                        _react2.default.createElement(
	                            _materialUi.CardText,
	                            {
	                                expandable: true,
	                                style: {
	                                    boxShadow: 'inset 0 0 3px #f0f0f0',
	                                    marginBottom: -8,
	                                    border: '1px solid #f0f0f0'
	                                },
	                                className: 'pickers-wrapper'
	                            },
	                            groups[g].map(function (propType, i) {
	                                var Picker = _pickers2.default[propType.type];
	                                if (!Picker) return _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    propType.type
	                                );
	                                return [_react2.default.createElement(Picker, _extends({
	                                    key: propType.key,
	                                    propKey: propType.key
	                                }, propType, propType.props, jsprops, {
	                                    value: jsprops[propType.key],
	                                    onChange: onPropChange,
	                                    error: false
	                                })), i !== groups[g].length - 1 && _react2.default.createElement(_materialUi.Divider, {
	                                    key: propType.key + 'd',
	                                    style: { marginLeft: -16, marginRight: -16, marginTop: 16 }
	                                })];
	                            })
	                        )
	                    );
	                })
	            );
	        }, _temp2), _possibleConstructorReturn(_this6, _ret);
	    }
	
	    return WidgetParams;
	}(_react2.default.PureComponent);
	
	SMPostDialog.propTypes = {
	    templateId: _propTypes2.default.string.isRequired,
	    onRequestClose: _propTypes2.default.func.isRequired,
	    open: _propTypes2.default.bool.isRequired
	};
	exports.WidgetParams = WidgetParams;
	exports.default = SMPostDialog;

/***/ },
/* 1596 */,
/* 1597 */,
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.embedInjectorCode = exports.embedCode = exports.embedWPCode = exports.browserDownloadSMWidget2image = exports.widget2videoLink = exports.browserDownloadWidget2video = exports.browserDownloadWidget2image = exports.widget2video = exports.widget2image = exports.htmlwidget2image = exports.smwidget2image = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _prod = __webpack_require__(1299);
	
	var _prod2 = _interopRequireDefault(_prod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smwidget2image = exports.smwidget2image = function smwidget2image(url) {
	    var webshotIsLocal = _cfg2.default.apis.webshot.indexOf('127.0.0.1') !== -1;
	    if (!webshotIsLocal) url = url.replace('http://127.0.0.1:3003', _prod2.default.widgets.url);
	
	    var params = {
	        quality: 100,
	        url: url,
	        captureSelector: '.sm-wdp',
	        whiteBg: false,
	        windowWidth: 800,
	        renderDelay: 200,
	        browser: _cfg2.default.webshotBrowser,
	        streamType: 'png',
	        userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X) AppleWebKit/534.34 (KHTML, like Gecko) PhantomJS/2.1.1 (development) Safari/534.34'
	    };
	    var convertUrl = _cfg2.default.apis.webshot + '/api/convert';
	    return fetch(convertUrl, {
	        method: 'post',
	        body: JSON.stringify(params),
	        headers: { 'Content-Type': 'application/json' }
	    }).then(function (response) {
	        return response.json();
	    });
	};
	
	var htmlwidget2image = exports.htmlwidget2image = function htmlwidget2image(url) {
	    var webshotIsLocal = _cfg2.default.apis.webshot.indexOf('127.0.0.1') !== -1;
	    if (!webshotIsLocal) url = url.replace('http://127.0.0.1:3003', _prod2.default.widgets.url);
	
	    var params = {
	        quality: 100,
	        url: url,
	        captureSelector: '.wdp',
	        whiteBg: false,
	        browser: _cfg2.default.webshotBrowser,
	        windowWidth: 800,
	        renderDelay: 2000,
	        streamType: 'png',
	        userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X) AppleWebKit/534.34 (KHTML, like Gecko) PhantomJS/2.1.1 (development) Safari/534.34'
	    };
	    var convertUrl = _cfg2.default.apis.webshot + '/api/convert';
	    return fetch(convertUrl, {
	        method: 'post',
	        body: JSON.stringify(params),
	        headers: { 'Content-Type': 'application/json' }
	    }).then(function (response) {
	        return response.json();
	    });
	};
	
	var widget2image = exports.widget2image = function widget2image(widget, url) {
	    return widget.spec.social ? smwidget2image(url) : htmlwidget2image(url);
	};
	
	var widget2video = exports.widget2video = function widget2video(widget, url, videoLength) {
	    videoLength = videoLength || widget.spec.videoLength || 30;
	    var generatorIsLocal = _cfg2.default.apis.html2video.indexOf('127.0.0.1') !== -1;
	    if (!generatorIsLocal) url = url.replace('http://127.0.0.1:3003', _prod2.default.widgets.url);
	    var generateUrl = _cfg2.default.apis.html2video + '/api/generate?videoLength=' + videoLength + '&animationSpeedModifier=0.5&url=' + encodeURIComponent(url);
	
	    return fetch(generateUrl, {
	        method: 'get'
	    }).then(function (r) {
	        return r.json();
	    });
	};
	
	var browserDownloadWidget2image = exports.browserDownloadWidget2image = function browserDownloadWidget2image(widget, url) {
	    return widget2image(widget, url).then(function (resp) {
	        // var a = document.createElement('a');
	        // a.href = resp.url;
	        // a.setAttribute('target', '__blank');
	        // a.setAttribute('download', widget.spec.id + '.png');
	        // a.download = widget.spec.id + '.png';
	        // document.body.appendChild(a);
	        // a.click();
	        // document.body.removeChild(a);
	        // a.remove();
	
	        forceDownload(resp.url, widget.name + '.png');
	        return resp;
	    });
	};
	
	var browserDownloadWidget2video = exports.browserDownloadWidget2video = function browserDownloadWidget2video(widget, url, videoLength) {
	    return widget2video(widget, url, videoLength).then(function (r) {
	        return new Promise(function (resolve, reject) {
	            var checkStatusInterval = setInterval(function () {
	                fetch('' + _cfg2.default.apis.html2video + r.location).then(function (r) {
	                    return r.json();
	                }).then(function (queue) {
	                    if (queue.status === 'done') {
	                        clearInterval(checkStatusInterval);
	
	                        forceDownload(queue.location, widget.spec.id + '.mp4');
	
	                        var a = document.createElement('a');
	                        a.href = queue.location;
	                        a.setAttribute('target', '__blank');
	                        a.download = widget.spec.id + '.mp4';
	                        document.body.appendChild(a);
	                        a.click();
	                        document.body.removeChild(a);
	                        a.remove();
	                        resolve(queue.location);
	                    } else if (queue.status === 'failed') {
	                        clearInterval(checkStatusInterval);
	                        reject();
	                    }
	                });
	            }, 10000);
	        });
	    });
	};
	
	var widget2videoLink = exports.widget2videoLink = function widget2videoLink(url, videoLength) {
	    return widget2video(null, url, videoLength).then(function (r) {
	        return new Promise(function (resolve, reject) {
	            var checkStatusInterval = setInterval(function () {
	                fetch('' + _cfg2.default.apis.html2video + r.location).then(function (r) {
	                    return r.json();
	                }).then(function (queue) {
	                    if (queue.status === 'done') {
	                        clearInterval(checkStatusInterval);
	                        resolve({ url: queue.location, video: true, picture: queue.pictureUrl });
	                    } else if (queue.status === 'failed') {
	                        clearInterval(checkStatusInterval);
	                        reject();
	                    }
	                });
	            }, 10000);
	        });
	    });
	};
	
	function forceDownload(url, fileName) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('GET', url, true);
	    xhr.responseType = 'blob';
	    xhr.onload = function () {
	        var urlCreator = window.URL || window.webkitURL;
	        var imageUrl = urlCreator.createObjectURL(this.response);
	        var tag = document.createElement('a');
	        tag.href = imageUrl;
	        tag.download = fileName;
	        document.body.appendChild(tag);
	        tag.click();
	        document.body.removeChild(tag);
	    };
	    xhr.send();
	}
	
	var browserDownloadSMWidget2image = exports.browserDownloadSMWidget2image = function browserDownloadSMWidget2image(url) {
	    return smwidget2image(url).then(function (resp) {
	        forceDownload(resp.url, 'widget.png');
	        return resp;
	    });
	};
	
	var embedWPCode = exports.embedWPCode = function embedWPCode(method, user, commonParams, params) {};
	var embedCode = exports.embedCode = function embedCode(method, name, user) {
	    var common = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    var commonParams = {
	        'data-load': method,
	        // user related
	        'data-client': user.client,
	        'data-user': user.username,
	        'data-token': user.accessToken,
	        'data-ga': user.defaultProps.GA,
	        // core params
	        'data-lang': common.lang,
	        'data-theme': common.theme
	    };
	    var pp = _lodash2.default.clone(params);
	
	    Reflect.deleteProperty(pp, 'data-theme');
	    Reflect.deleteProperty(pp, 'data-debug');
	
	    params = _lodash2.default.extend({}, pp, commonParams);
	
	    var paramsStr = _lodash2.default.chain(params).toPairs().reduce(function (memo, p) {
	        return p[1] ? memo + ' ' + p[0] + '=' + JSON.stringify(p[1]) : memo;
	    }, '').value();
	    return '<rlz-widget data-name="' + name + '" ' + paramsStr + ' />';
	};
	
	var embedInjectorCode = exports.embedInjectorCode = function embedInjectorCode() {
	    return '<script type="text/javascript" src="' + _cfg2.default.WDPLinkr.injector() + '" crossorigin async></script>';
	};

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getProviders = exports.addInputText = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Handler to add text programmatically at the caret position without losing the position of the input caret
	 * @param {*} input ref to HTML input
	 * @param {*} onChange callback which accepts value as 0nth argument
	 */
	var addInputText = exports.addInputText = function addInputText(input, onChange) {
	    return function (currentValue) {
	        return function (text) {
	            if (input) {
	                var currentValString = typeof currentValue === 'string' ? currentValue : '';
	                var nextSelectionStart = (currentValString.slice(0, input.selectionStart) + text).length;
	                var value = currentValString.slice(0, input.selectionStart) + text + currentValString.slice(input.selectionStart, currentValString.length);
	                onChange(value);
	                // restore the caret not to be at the end of the line
	                setTimeout(function () {
	                    return input.setSelectionRange(nextSelectionStart, nextSelectionStart);
	                }, 0);
	            }
	        };
	    };
	};
	
	var PROVIDERS = _cfg2.default.bookmakers.filter(function (e) {
	    return e.id !== 'none';
	});
	var PROVIDERS_MAP = PROVIDERS.reduce(function (acc, el) {
	    acc[el.id] = el.name;
	    return acc;
	}, {});
	
	var getProviders = exports.getProviders = function getProviders(allowed) {
	    return Array.isArray(allowed) ? allowed.reduce(function (acc, el) {
	        var name = PROVIDERS_MAP[el];
	        if (name) {
	            acc.push({ name: name, id: el });
	        }
	        return acc;
	    }, []) : PROVIDERS;
	};

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _emojiMart = __webpack_require__(1601);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _insertEmoticon = __webpack_require__(1633);
	
	var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);
	
	__webpack_require__(1634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Emoji picker component.
	 */
	var EmojiPicker = function (_React$PureComponent) {
	    _inherits(EmojiPicker, _React$PureComponent);
	
	    function EmojiPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EmojiPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmojiPicker.__proto__ || Object.getPrototypeOf(EmojiPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showEmojiPicker: false
	        }, _this.toggleEmoji = function (event) {
	            event.persist();
	            _this.setState(function (_ref2) {
	                var showEmojiPicker = _ref2.showEmojiPicker;
	                return {
	                    showEmojiPicker: !showEmojiPicker,
	                    anchorElem: event.target
	                };
	            });
	        }, _this.close = function () {
	            return _this.setState({ showEmojiPicker: false });
	        }, _this.addEmoji = function (emoji) {
	            if (!_this.props.disabled) {
	                var native = emoji.native;
	
	                if (_this.props.inputRef) {
	                    var input = _this.props.inputRef;
	
	                    var currentVal = typeof _this.props.value === 'string' ? _this.props.value : '';
	                    var nextSelectionStart = (currentVal.slice(0, input.selectionStart) + native).length;
	                    var value = currentVal.slice(0, input.selectionStart) + native + currentVal.slice(input.selectionStart, currentVal.length);
	                    _this.props.onChange(null, value);
	                    // restore the caret not to be at the end of the line
	                    setTimeout(function () {
	                        return input.setSelectionRange(nextSelectionStart, nextSelectionStart);
	                    }, 0);
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EmojiPicker, [{
	        key: 'render',
	        value: function render() {
	            var disabled = this.props.disabled;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: disabled, onTouchTap: this.toggleEmoji },
	                    _react2.default.createElement(_insertEmoticon2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: this.state.showEmojiPicker,
	                        anchorEl: this.state.anchorElem,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: this.close
	                    },
	                    _react2.default.createElement(_emojiMart.Picker, { onClick: this.addEmoji })
	                )
	            );
	        }
	    }]);
	
	    return EmojiPicker;
	}(_react2.default.PureComponent);
	
	EmojiPicker.propTypes = {
	    disabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired,
	    value: _propTypes2.default.string,
	    // eslint-disable-next-line
	    inputRef: _propTypes2.default.any
	};
	
	exports.default = EmojiPicker;

/***/ },
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OddsList = __webpack_require__(1639);
	
	Object.defineProperty(exports, 'OddsList', {
	  enumerable: true,
	  get: function get() {
	    return _OddsList.OddsList;
	  }
	});
	
	var _OddsPicker = __webpack_require__(1670);
	
	Object.defineProperty(exports, 'OddsPicker', {
	  enumerable: true,
	  get: function get() {
	    return _OddsPicker.OddsPicker;
	  }
	});
	
	var _OddsScene = __webpack_require__(1672);
	
	Object.defineProperty(exports, 'OddsScene', {
	  enumerable: true,
	  get: function get() {
	    return _OddsScene.OddsScene;
	  }
	});

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OddsList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _refresh = __webpack_require__(1640);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _common = __webpack_require__(1599);
	
	var _helpers = __webpack_require__(592);
	
	var _selectors = __webpack_require__(618);
	
	var _socialCampaigns = __webpack_require__(1641);
	
	var _events = __webpack_require__(1058);
	
	var _actions = __webpack_require__(587);
	
	var _SocialCampaign = __webpack_require__(1642);
	
	var _constants = __webpack_require__(594);
	
	var _MarketItem = __webpack_require__(1661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OddsList = exports.OddsList = (0, _reactRedux.connect)(function (state) {
	    return {
	        selectedCampaign: _actions.oddsSelection.select(state).selectedCampaign,
	        selectedProvider: _actions.oddsSelection.select(state).selectedProvider,
	        eventId: _actions.oddsSelection.select(state).eventId,
	        defaultProvider: (0, _get2.default)(state, ['user', 'props', 'oddsProvider']),
	        allowedProviders: (0, _get2.default)(state, ['user', 'props', 'allowedProviders']),
	        socialCampaigns: (0, _selectors.getEntities)(state).socialCampaigns
	    };
	})((_temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, ctx) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, ctx));
	
	        _this.onProviderSelect = function (e, i, val) {
	            _this.props.dispatch((0, _actions.setProvider)(val));
	            //  this.clearOddsSelection();
	        };
	
	        _this.clearOddsSelection = function () {
	            _this.onOddSelect({ market: null, outcome: null, text: null, link: null, outcomeObject: null });
	        };
	
	        _this.onCampaignSelect = function (e, i, val) {
	            _this.props.dispatch((0, _actions.setCampaign)(val));
	            if (_this.props.onCampaignChange) {
	                _this.props.onCampaignChange(val);
	            }
	        };
	
	        _this.closeCreateCampaign = function (id) {
	            if (typeof id === 'string') {
	                _this.props.dispatch((0, _actions.setCampaign)(id));
	                _this.setState({ showCreateCampaign: false });
	                if (_this.props.onCampaignChange) {
	                    _this.props.onCampaignChange(id);
	                }
	            } else {
	                _this.setState({ showCreateCampaign: false });
	            }
	        };
	
	        _this.refresh = function () {
	            var _this$props = _this.props,
	                markets = _this$props.markets,
	                eventId = _this$props.eventId,
	                provider = _this$props.selectedProvider;
	
	            markets.forEach(function (market) {
	                _this.props.dispatch((0, _actions.fetchOdds)(eventId, market, provider));
	            });
	        };
	
	        var allowedProviders = props.allowedProviders;
	
	        var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	        _this.state = {
	            providers: providers,
	            showCreateCampaign: false
	        };
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                eventId = _props.eventId,
	                dispatch = _props.dispatch,
	                defaultProvider = _props.defaultProvider,
	                allowedProviders = _props.allowedProviders;
	
	            var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	            var provider = defaultProvider && providers.some(function (p) {
	                return p.id === defaultProvider;
	            }) ? defaultProvider : (0, _get2.default)(providers, [0, 'id'], _constants.emptyValue);
	            dispatch((0, _actions.setProvider)(provider));
	            dispatch((0, _socialCampaigns.getSocialCampaigns)());
	            if (eventId) {
	                dispatch((0, _events.fetchEventById)(eventId));
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var eventId = _ref.eventId;
	
	            if (this.props.eventId !== eventId && eventId) {
	                this.props.dispatch((0, _events.fetchEventById)(eventId));
	            }
	        }
	    }, {
	        key: 'renderProviderSelect',
	        value: function renderProviderSelect() {
	            var _props2 = this.props,
	                defaultProvider = _props2.defaultProvider,
	                provider = _props2.selectedProvider;
	            var _state = this.state,
	                providers = _state.providers,
	                textGenerating = _state.textGenerating;
	
	            var hideProviderSelect = providers.length < 2 && providers.some(function (e) {
	                return e.id === defaultProvider;
	            }) && defaultProvider === provider || providers.length === 0;
	            return hideProviderSelect ? null : _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    disabled: textGenerating,
	                    value: provider,
	                    floatingLabelText: 'Odds provider',
	                    onChange: this.onProviderSelect
	                },
	                providers.map(function (b) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: b.id, value: b.id, primaryText: b.name });
	                })
	            );
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _props3 = this.props,
	                eventId = _props3.eventId,
	                markets = _props3.markets,
	                disabled = _props3.disabled;
	
	            return markets.map(function (market, index) {
	                return _react2.default.createElement(_MarketItem.MarketItem, { key: market, market: market, eventId: eventId, disabled: disabled });
	            });
	        }
	    }, {
	        key: 'renderCampaignSelect',
	        value: function renderCampaignSelect() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                socialCampaigns = _props4.socialCampaigns,
	                selectedCampaign = _props4.selectedCampaign;
	            var showCreateCampaign = this.state.showCreateCampaign;
	
	            var campaigns = Array.isArray(socialCampaigns) ? socialCampaigns : [];
	            return _react2.default.createElement(
	                'div',
	                null,
	                campaigns.length ? _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        floatingLabelText: 'Social campaign',
	                        value: selectedCampaign,
	                        onChange: this.onCampaignSelect
	                    },
	                    _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'None', value: _constants.emptyValue }),
	                    campaigns.map(function (c) {
	                        return _react2.default.createElement(_materialUi.MenuItem, { key: c._id, primaryText: c.name, value: c._id });
	                    })
	                ) : _react2.default.createElement(
	                    'p',
	                    null,
	                    'No social campaigns'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        label: '+ Create campaign',
	                        onClick: function onClick() {
	                            return _this2.setState({ showCreateCampaign: true });
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        title: 'Create social campaign',
	                        open: showCreateCampaign,
	                        onRequestClose: this.closeCreateCampaign,
	                        className: 'no-padding-dialog',
	                        autoScrollBodyContent: true,
	                        autoDetectWindowHeight: true
	                    },
	                    _react2.default.createElement(_SocialCampaign.CreateSocialCampaign, { onCreate: this.closeCreateCampaign })
	                )
	            );
	        }
	    }, {
	        key: 'renderRefresh',
	        value: function renderRefresh() {
	            var _props5 = this.props,
	                disabled = _props5.disabled,
	                eventId = _props5.eventId,
	                provider = _props5.selectedProvider;
	
	            return _react2.default.createElement(
	                _materialUi.IconButton,
	                { disabled: disabled || !eventId || !provider, tooltip: 'Refresh', onClick: this.refresh },
	                _react2.default.createElement(_refresh2.default, null)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex' } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	                        this.renderProviderSelect(),
	                        this.renderRefresh()
	                    ),
	                    this.renderItems(),
	                    this.renderCampaignSelect()
	                )
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component), _class.defaultProps = {
	    markets: ['match', 'halftime', 'nextGoal', 'btts', 'goals', 'score']
	}, _class.propTypes = {
	    disabled: _propTypes2.default.bool,
	    markets: _propTypes2.default.array.isRequired,
	    eventId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    defaultProvider: _propTypes2.default.string,
	    socialCampaigns: _propTypes2.default.array,
	    allowedProviders: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	}, _temp));

/***/ },
/* 1640 */,
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSocialCampaigns = exports.createSocialCampaign = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createSocialCampaign = exports.createSocialCampaign = function createSocialCampaign(body) {
	    return (0, _reduxQuery.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/media/social-campaigns?access_token=' + _auth2.default.getAccessToken(),
	        body: body,
	        force: true,
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        },
	        transform: function transform(item) {
	            return {
	                socialCampaigns: item
	            };
	        },
	        update: {
	            socialCampaigns: function socialCampaigns() {
	                var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                var item = arguments[1];
	                return prev.concat(item);
	            }
	        }
	    });
	};
	
	var getSocialCampaigns = exports.getSocialCampaigns = function getSocialCampaigns() {
	    return (0, _reduxQuery.requestAsync)({
	        url: _cfg2.default.dash.api.host + '/api/media/social-campaigns?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        transform: function transform(items) {
	            return {
	                socialCampaigns: items
	            };
	        },
	        update: {
	            socialCampaigns: function socialCampaigns() {
	                var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                var next = arguments[1];
	                return next;
	            }
	        }
	    });
	};

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CreateSocialCampaign = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactFinalForm = __webpack_require__(1643);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _colors = __webpack_require__(910);
	
	var _finalFormArrays = __webpack_require__(1657);
	
	var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);
	
	var _reactFinalFormArrays = __webpack_require__(1658);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _removeCircleOutline = __webpack_require__(1659);
	
	var _removeCircleOutline2 = _interopRequireDefault(_removeCircleOutline);
	
	var _validation = __webpack_require__(1660);
	
	var _socialCampaigns = __webpack_require__(1641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var initialValues = {
	    customUrl: '${url}',
	    keys: [{ key: 'utm_source', value: '' }, { key: 'utm_medium', value: '' }, { key: 'utm_campaign', value: '' }]
	};
	
	var keyValRowStyle = {
	    display: 'flex',
	    alignItems: 'flex-end'
	};
	var macros = '${url}';
	var CreateSocialCampaign = (0, _reactRedux.connect)()(function (_React$Component) {
	    _inherits(_class2, _React$Component);
	
	    function _class2() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.save = function (_ref2) {
	            var hasCustomUrl = _ref2.hasCustomUrl,
	                rest = _objectWithoutProperties(_ref2, ['hasCustomUrl']);
	
	            var next = !hasCustomUrl ? _extends({}, rest, { customUrl: null }) : rest;
	            return _this.props.dispatch((0, _socialCampaigns.createSocialCampaign)(next)).then(function (res) {
	                var body = res.body;
	
	                if (_this.props.onCreate) {
	                    _this.props.onCreate(body._id);
	                }
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class2, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactFinalForm.Form, {
	                onSubmit: this.save,
	                mutators: _finalFormArrays2.default,
	                initialValues: initialValues,
	                render: function render(_ref3) {
	                    var handleSubmit = _ref3.handleSubmit,
	                        invalid = _ref3.invalid,
	                        values = _ref3.values;
	
	                    return _react2.default.createElement(
	                        'form',
	                        { onSubmit: handleSubmit },
	                        _react2.default.createElement(_reactFinalForm.Field, {
	                            name: 'name',
	                            floatingLabelText: 'Campaign name',
	                            validate: _validation.presence,
	                            component: _reduxFormMaterialUi.TextField
	                        }),
	                        _react2.default.createElement(
	                            _reactFinalFormArrays.FieldArray,
	                            { name: 'keys' },
	                            function (_ref4) {
	                                var fields = _ref4.fields;
	                                return _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        fields.map(function (name, index) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { key: name, style: keyValRowStyle },
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    name: name + '.key',
	                                                    component: _reduxFormMaterialUi.TextField,
	                                                    validate: _validation.presence,
	                                                    floatingLabelText: 'Key'
	                                                }),
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    name: name + '.value',
	                                                    component: _reduxFormMaterialUi.TextField,
	                                                    validate: _validation.presence,
	                                                    floatingLabelText: 'Value'
	                                                }),
	                                                _react2.default.createElement(
	                                                    _materialUi.IconButton,
	                                                    { onClick: function onClick() {
	                                                            return fields.remove(index);
	                                                        } },
	                                                    _react2.default.createElement(_removeCircleOutline2.default, null)
	                                                )
	                                            );
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        _materialUi.IconButton,
	                                        { onClick: function onClick() {
	                                                return fields.push({ key: '', value: '' });
	                                            } },
	                                        _react2.default.createElement(_add2.default, null)
	                                    )
	                                );
	                            }
	                        ),
	                        _react2.default.createElement(_reactFinalForm.Field, {
	                            name: 'hasCustomUrl',
	                            type: 'checkbox',
	                            label: 'Has custom tracking service',
	                            style: { marginTop: 12, marginBottom: 12 },
	                            labelPosition: 'right',
	                            component: _reduxFormMaterialUi.Toggle
	                        }),
	                        values.hasCustomUrl ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _materialUi.Subheader,
	                                null,
	                                'Insert the target link and use macros',
	                                ' ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { color: _colors.deepPurple400 } },
	                                    macros
	                                ),
	                                ' which will be replaced with url to place a bet'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { paddingLeft: 16 } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                        name: 'customUrl',
	                                        multiLine: true,
	                                        floatingLabelText: 'Custom url',
	                                        validate: _validation.presence,
	                                        component: _reduxFormMaterialUi.TextField,
	                                        className: 'col-md-6'
	                                    }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6', style: { fontSize: 12 } },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            'Example: https://ad.doubleclick.net/ddm/clk/417890461;219470871;o?',
	                                            macros
	                                        )
	                                    )
	                                )
	                            )
	                        ) : null,
	                        _react2.default.createElement(_materialUi.FlatButton, { disabled: invalid, label: 'Save', type: 'submit' })
	                    );
	                }
	            });
	        }
	    }]);
	
	    return _class2;
	}(_react2.default.Component));
	exports.CreateSocialCampaign = CreateSocialCampaign;

/***/ },
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var presence = exports.presence = function presence(val) {
	    if (val === undefined || val === null) {
	        return 'Required';
	    }
	    if (val === 0) {
	        return undefined;
	    }
	    return val ? undefined : 'Required';
	};
	
	var minLength = exports.minLength = function minLength(min) {
	    return function (val) {
	        return presence(val) || (val.length >= min ? undefined : 'Minimun length is ' + min);
	    };
	};
	
	var numeric = exports.numeric = function numeric(val) {
	    if (!val) {
	        return undefined;
	    }
	    return String(Number(val)) === String(val) ? undefined : 'Should be numeric value';
	};
	
	var parseNumber = exports.parseNumber = function parseNumber(val) {
	    return val !== '' ? Number(val) : val;
	};
	
	var normalizeArray = exports.normalizeArray = function normalizeArray(isNumeric) {
	    return function (value) {
	        if (typeof value === 'string') {
	            var arr = value.split(/[ ,]+/);
	            if (isNumeric) {
	                return arr.map(parseNumber).filter(isFinite);
	            }
	            return arr;
	        }
	        return value;
	    };
	};
	
	var formatArray = exports.formatArray = function formatArray() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    if (Array.isArray(value)) {
	        return value.join(' ');
	    }
	    return value;
	};

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MarketItem = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(250);
	
	var _selectors = __webpack_require__(618);
	
	var _actions = __webpack_require__(587);
	
	var _TimeElapsed = __webpack_require__(1662);
	
	var _constants = __webpack_require__(594);
	
	var _OutcomeItem = __webpack_require__(1663);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var marketContainerStyle = {
	    display: 'flex',
	    flexWrap: 'wrap'
	};
	
	var BetOffer = (0, _reactRedux.connect)(function (state, _ref) {
	    var id = _ref.id;
	    return { betOffer: (0, _get2.default)((0, _selectors.getEntities)(state).betOffers, id) };
	})(function (_ref2) {
	    var betOffer = _ref2.betOffer,
	        rest = _objectWithoutProperties(_ref2, ['betOffer']);
	
	    return betOffer ? _react2.default.createElement(
	        'div',
	        { style: marketContainerStyle },
	        betOffer.outcomes.map(function (id) {
	            return _react2.default.createElement(_OutcomeItem.OutcomeItem, _extends({}, rest, { key: id, id: id }));
	        })
	    ) : null;
	});
	
	var MarketItem = exports.MarketItem = (0, _reactRedux.connect)(function (state, _ref3) {
	    var eventId = _ref3.eventId,
	        market = _ref3.market;
	
	    var provider = _actions.oddsSelection.select(state).selectedProvider;
	    var oddPath = (0, _actions.oddNameSelector)(eventId, market, provider);
	
	    var _getEntities = (0, _selectors.getEntities)(state),
	        events = _getEntities.events,
	        odds = _getEntities.odds;
	
	    return {
	        provider: provider,
	        event: (0, _get2.default)(events, eventId),
	        oddsObject: (0, _get2.default)(odds, oddPath)
	    };
	})(function (_React$Component) {
	    _inherits(_class2, _React$Component);
	
	    function _class2() {
	        var _ref4;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                eventId = _props.eventId,
	                market = _props.market,
	                provider = _props.provider;
	
	            this.updateOutcomes({ eventId: eventId, market: market, provider: provider });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref5) {
	            var eventId = _ref5.eventId,
	                market = _ref5.market,
	                provider = _ref5.provider;
	
	            if (this.props.eventId !== eventId || this.props.market !== market || this.props.provider !== provider) {
	                this.updateOutcomes({ eventId: eventId, market: market, provider: provider });
	            }
	        }
	    }, {
	        key: 'updateOutcomes',
	        value: function updateOutcomes(_ref6) {
	            var eventId = _ref6.eventId,
	                market = _ref6.market,
	                provider = _ref6.provider;
	
	            if (provider && (typeof provider === 'undefined' ? 'undefined' : _typeof(provider)) !== 'symbol') {
	                this.props.dispatch((0, _actions.fetchOdds)(eventId, market, provider));
	            }
	        }
	    }, {
	        key: 'renderHeader',
	        value: function renderHeader() {
	            var market = this.props.market;
	
	            var date = (0, _get2.default)(this.props.oddsObject, 'lastUpdateAt');
	            var displayName = _constants.marketDisplayName[market] || market;
	            return _react2.default.createElement(
	                'p',
	                { style: { background: '#ccc', display: 'flex', justifyContent: 'space-between' } },
	                displayName,
	                ' ',
	                date && _react2.default.createElement(
	                    'span',
	                    null,
	                    'Updated: ',
	                    _react2.default.createElement(_TimeElapsed.TimeElapsed, { date: date })
	                )
	            );
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var _props2 = this.props,
	                oddsObject = _props2.oddsObject,
	                eventId = _props2.eventId;
	
	            var betOffers = oddsObject && oddsObject.betOffers;
	            return Array.isArray(betOffers) && betOffers.length ? _react2.default.createElement(
	                'div',
	                { style: marketContainerStyle },
	                betOffers.map(function (betOffer) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: betOffer, style: _extends({}, marketContainerStyle, { width: '100%' }) },
	                        _react2.default.createElement(BetOffer, { id: betOffer, eventId: eventId })
	                    );
	                })
	            ) : _react2.default.createElement(
	                'p',
	                null,
	                'No odds'
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var oddsObject = this.props.oddsObject;
	
	            if (!oddsObject) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderHeader(),
	                this.renderContent()
	            );
	        }
	    }]);
	
	    return _class2;
	}(_react2.default.Component));
	
	MarketItem.propTypes = {
	    disabled: _propTypes2.default.bool,
	    market: _propTypes2.default.string.isRequired,
	    eventId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	};

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TimeElapsed = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeElapsed = exports.TimeElapsed = function (_React$Component) {
	    _inherits(TimeElapsed, _React$Component);
	
	    function TimeElapsed() {
	        _classCallCheck(this, TimeElapsed);
	
	        return _possibleConstructorReturn(this, (TimeElapsed.__proto__ || Object.getPrototypeOf(TimeElapsed)).apply(this, arguments));
	    }
	
	    _createClass(TimeElapsed, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // no need to setState, and handle nextProps
	            this.interval = setInterval(this.forceUpdate.bind(this), 30 * 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(this.props.date).fromNow()
	            );
	        }
	    }]);
	
	    return TimeElapsed;
	}(_react2.default.Component);

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OutcomeItem = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _materialUi = __webpack_require__(642);
	
	var _colors = __webpack_require__(910);
	
	var _reactRedux = __webpack_require__(250);
	
	var _selectors = __webpack_require__(618);
	
	var _actions = __webpack_require__(587);
	
	var _utils = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowStyle = { display: 'flex', minWidth: 150, margin: '0px 6px', justifyContent: 'space-between' };
	
	var OutcomeItem = (0, _reactRedux.connect)(function (state, _ref) {
	    var id = _ref.id,
	        eventId = _ref.eventId;
	    return {
	        event: (0, _get2.default)((0, _selectors.getEntities)(state).events, eventId),
	        outcome: (0, _get2.default)((0, _selectors.getEntities)(state).outcomes, [id]),
	        checked: Boolean(_actions.oddsSelection.select(state).selected[id])
	    };
	}, function (dispatch) {
	    return {
	        onClick: function onClick(id) {
	            return dispatch((0, _actions.toggleSelection)(id));
	        }
	    };
	})(function (_React$Component) {
	    _inherits(_class2, _React$Component);
	
	    function _class2() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function () {
	            var _this$props = _this.props,
	                id = _this$props.id,
	                onClick = _this$props.onClick;
	
	            onClick(id);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class2, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                onClick = _props.onClick,
	                checked = _props.checked,
	                outcome = _props.outcome,
	                event = _props.event,
	                eventId = _props.eventId,
	                dispatch = _props.dispatch,
	                rest = _objectWithoutProperties(_props, ['onClick', 'checked', 'outcome', 'event', 'eventId', 'dispatch']);
	
	            return _react2.default.createElement(
	                _materialUi.MenuItem,
	                _extends({}, rest, {
	                    onTouchTap: this.onClick,
	                    style: { border: '1px solid #ccc', backgroundColor: checked ? _colors.green200 : undefined }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginRight: 4 } },
	                        (0, _utils.resolveOutcomeText)(outcome, event)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        outcome && outcome.odds
	                    )
	                )
	            );
	        }
	    }]);
	
	    return _class2;
	}(_react2.default.Component));
	exports.OutcomeItem = OutcomeItem;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUrlAndText = exports.resolveOutcomeText = exports.getUrlWithCampaign = exports.getCommonOutcomeText = exports.getTeamNames = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _compact = __webpack_require__(606);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _head = __webpack_require__(588);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _groupBy = __webpack_require__(1665);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _queryString = __webpack_require__(1055);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _helpers = __webpack_require__(592);
	
	var _constants = __webpack_require__(594);
	
	var _BookieDeeplinker = __webpack_require__(1669);
	
	var _BookieDeeplinker2 = _interopRequireDefault(_BookieDeeplinker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var getTeamNames = exports.getTeamNames = function getTeamNames(event) {
	    return event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' ? { homeName: event.homeName, awayName: event.awayName, drawName: 'Draw' } : { homeName: 1, awayName: 2, drawName: 'X' };
	};
	
	var buildUrl = function buildUrl(url, queryString) {
	    var resultUrl = void 0;
	    if (url.indexOf('#s_') > -1) {
	        //138 odds specific deeplink param
	        var _url = url.split('#s_');
	        resultUrl = _url[0] + '?' + queryString + '#s_' + _url[1];
	    } else {
	        resultUrl = url + '?' + queryString;
	    }
	    return resultUrl;
	};
	
	// deprecated
	var getCommonOutcomeText = exports.getCommonOutcomeText = function getCommonOutcomeText(market, outcomes, event) {
	    if (market === 'btts') {
	        var yes = outcomes['true'].odds;
	        var no = outcomes['false'].odds;
	        return (_constants.marketDisplayName[market] || market) + ' Yes: ' + yes + ', No: ' + no;
	    }
	
	    var _getTeamNames = getTeamNames(event),
	        homeName = _getTeamNames.homeName,
	        awayName = _getTeamNames.awayName,
	        drawName = _getTeamNames.drawName;
	
	    if (_constants.SINGLE_OPTION_MARKETS.indexOf(market) > -1) {
	        var value1 = (0, _get2.default)(outcomes, [1, 'odds']);
	        var value2 = (0, _get2.default)(outcomes, [2, 'odds']);
	        var valueX = (0, _get2.default)(outcomes, ['X', 'odds']);
	        var outcomeText = '';
	        if (!(0, _helpers.isNullOrUndefined)(value1) && !(0, _helpers.isNullOrUndefined)(value2)) {
	            if (!(0, _helpers.isNullOrUndefined)(valueX)) {
	                outcomeText = homeName + ': ' + value1 + ', ' + drawName + ': ' + valueX + ', ' + awayName + ': ' + value2;
	            } else {
	                outcomeText = homeName + ': ' + value1 + ', ' + awayName + ': ' + value2;
	            }
	        }
	        return (_constants.marketDisplayName[market] || market) + ' ' + outcomeText;
	    }
	};
	
	var getUrlWithCampaign = exports.getUrlWithCampaign = function getUrlWithCampaign(url, socialCampaigns, selectedCampaign) {
	    if (!url || !Array.isArray(socialCampaigns) || !selectedCampaign || selectedCampaign === _constants.emptyValue) {
	        return url;
	    }
	    var selectedCampaignObj = socialCampaigns.find(function (i) {
	        return i._id === selectedCampaign;
	    });
	    var params = (0, _get2.default)(selectedCampaignObj, 'keys', []).reduce(function (acc, cur) {
	        acc[cur.key] = cur.value;
	        return acc;
	    }, {});
	
	    var _qs$parseUrl = _queryString2.default.parseUrl(url),
	        query = _qs$parseUrl.query,
	        deeplinkUrl = _qs$parseUrl.url;
	
	    var queryString = _queryString2.default.stringify(_extends({}, query, params));
	
	    var deeplinkedUrl = buildUrl(deeplinkUrl, queryString);
	    var template = (0, _get2.default)(selectedCampaignObj, 'customUrl');
	    return typeof template === 'string' ? template.replace('${url}', deeplinkedUrl) : deeplinkedUrl;
	};
	
	var resolveOutcomeText = exports.resolveOutcomeText = function resolveOutcomeText(outcome, event) {
	    if (!outcome) {
	        return '';
	    }
	    switch (String(outcome.type)) {
	        case '1':
	            {
	                return (0, _get2.default)(event, 'homeName', '1');
	            }
	        case '2':
	            {
	                return (0, _get2.default)(event, 'awayName', '2');
	            }
	        case 'X':
	            {
	                return 'Draw';
	            }
	        case 'true':
	            {
	                return 'Yes';
	            }
	        case 'false':
	            {
	                return 'No';
	            }
	        default:
	            {
	                var value = !(0, _helpers.isNullOrUndefined)(outcome.value) ? ' ' + outcome.value : '';
	                return outcome.type + value;
	            }
	    }
	};
	
	var getUrlAndText = function getUrlAndText(_ref) {
	    var selectedOrder = _ref.selectedOrder,
	        outcomes = _ref.outcomes,
	        betOffers = _ref.betOffers,
	        event = _ref.event,
	        selectedProvider = _ref.selectedProvider;
	
	    if (selectedOrder.length === 0 || [selectedOrder, outcomes, betOffers, selectedProvider, event].some(_helpers.isNullOrUndefined)) {
	        return { url: null, text: null };
	    }
	
	    var isSingleChoice = selectedOrder.length === 1;
	    var firstOutcome = outcomes[(0, _head2.default)(selectedOrder)];
	    var betOfferRef = (0, _get2.default)(firstOutcome, 'internalBetofferId');
	    var betOffer = (0, _get2.default)(betOffers, betOfferRef);
	    var url = null;
	    try {
	        url = _BookieDeeplinker2.default.deeplink(selectedProvider, betOffer, isSingleChoice ? firstOutcome : null, 10);
	    } catch (e) {
	        url = _BookieDeeplinker2.default.deeplink(selectedProvider, betOffer, firstOutcome, 10);
	    }
	
	    var byMarket = (0, _groupBy2.default)(selectedOrder.map(function (item) {
	        var _outcomes$item = outcomes[item],
	            internalBetofferId = _outcomes$item.internalBetofferId,
	            rest = _objectWithoutProperties(_outcomes$item, ['internalBetofferId']);
	
	        return _extends({
	            market: betOffers[internalBetofferId].market.type,
	            ref: item
	        }, rest);
	    }), 'market');
	
	    var text = Object.entries(byMarket).reduce(function (accStr, _ref2, i) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            market = _ref3[0],
	            outcomeItems = _ref3[1];
	
	        var withNewLine = market === 'score' || market === 'goals';
	        var spacer = withNewLine ? '\n' : ' ';
	        accStr += (_constants.marketDisplayName[market] || market) + ':' + spacer;
	        outcomeItems.forEach(function (outcome, index) {
	            var resolvedText = resolveOutcomeText(outcome, event) + ': ' + outcome.odds;
	            accStr += resolvedText + (index === outcomeItems.length - 1 ? '' : spacer);
	        });
	        return accStr + '\n';
	    }, '');
	
	    return { url: url, text: text };
	};
	exports.getUrlAndText = getUrlAndText;

/***/ },
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(339),
	    get = _require.get;
	
	var Deeplinker = {
	    deeplink: function deeplink(prov, betOffer, outcome, stake) {
	        switch (prov) {
	            case 'ds':
	                return this.deeplinkDS(betOffer, outcome, stake);
	            case 'leovegas':
	                return this.deeplinkLeoVegas(betOffer, outcome, stake);
	            case 'unibet':
	                return this.deeplinkUnibet(betOffer, outcome, stake);
	            case '138':
	                return this.deeplink138(betOffer, outcome, stake);
	            case 'bethard':
	                return this.deeplinkBethard(betOffer, outcome, stake, 'en');
	            case 'comeon':
	                return this.deeplinkComeOn(betOffer, outcome, stake, 'en');
	            case 'comeon__de':
	                return this.deeplinkComeOn(betOffer, outcome, stake, 'de');
	            default:
	                return '';
	        }
	    },
	    deeplinkBS: function deeplinkBS(prov, bets, stake) {
	        switch (prov) {
	            case 'ds':
	                return this.deeplinkDSBS(bets, stake);
	            case 'leovegas':
	                return this.deeplinkLeoVegasBS(bets, stake);
	            case 'unibet':
	                return this.deeplinkLeoVegasBS(bets, stake);
	            default:
	                return '';
	        }
	    },
	
	    deeplink138: function deeplink138(betOffer, outcome, stake) {
	        var sportId = get(betOffer, 'meta.bookmakerSportId');
	        var leagueId = get(betOffer, 'meta.bookmakerLeagueId');
	        var eventId = get(betOffer, 'meta.bookmakerEventId');
	        var outcomeId = get(outcome, 'id');
	        if (outcomeId) {
	            return 'https://138.fsbtech.com/sportsbook/' + sportId + '/' + leagueId + '/' + eventId + '/#s_' + outcomeId;
	        } else if (eventId) {
	            return 'https://138.fsbtech.com/sportsbook/' + sportId + '/' + leagueId + '/' + eventId;
	        }
	    },
	
	    deeplinkComeOn: function deeplinkComeOn(betOffer, outcome, stake) {
	        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en';
	
	        if (outcome && outcome.id) {
	            return 'http://m.comeon.com/' + lang + '/mobilegoto.aspx?LineID=' + outcome.id + '&StakeAmount=' + stake;
	        } else if (betOffer && betOffer.bookmakerEventId) {
	            return 'http://m.comeon.com/' + lang + '/mobilegoto.aspx?EventID=' + betOffer.bookmakerEventId;
	        }
	    },
	
	    deeplinkBethard: function deeplinkBethard(betOffer, outcome, stake) {
	        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en';
	
	        if (outcome && outcome.id) {
	            return 'https://www.bethard.com/sports?LineID=' + outcome.id + '&StakeAmount=' + stake;
	        } else if (betOffer && betOffer.bookmakerEventId) {
	            return 'https://www.bethard.com/sports?EventID=' + betOffer.bookmakerEventId;
	        }
	    },
	
	    deeplinkDS: function deeplinkDS(betOffer, outcome, stake) {
	        var base = 'https://oddsetmobil.danskespil.dk/webapp/sportsbook/';
	        return base + '#betslip/sel1=' + outcome.id + '&stk1=' + stake;
	    },
	
	    deeplinkLeoVegas: function deeplinkLeoVegas(betOffer, outcome, stake) {
	        var base = 'https://www.leovegas.com/sv';
	        return base + '#sportsbook/home?coupon=single|' + outcome.id + '|' + stake + '|append|wdp-campaign';
	    },
	    deeplinkUnibet: function deeplinkUnibet(betOffer, outcome, stake) {
	        var base = 'https://www.unibet.com/betting';
	        return base + '#sportsbook/home?coupon=single|' + outcome.id + '|' + stake + '|append|wdp-campaign';
	    },
	    deeplinkDSBS: function deeplinkDSBS(bets, stake) {
	        var base = 'https://oddsetmobil.danskespil.dk/webapp/sportsbook/';
	        var params = '';
	        if (Array.isArray(bets)) {
	            bets.forEach(bets, function (e, i) {
	                params += 'sel' + (i + 1) + '=' + e.outcome.id + '&stk' + (i + 1) + '=' + stake + '&';
	            });
	        }
	        return base + '#betslip/' + params + '&stkacc=' + stake;
	    },
	    deeplinkLeoVegasBS: function deeplinkLeoVegasBS(bets, stake) {
	        var base = 'https://www.leovegas.com/sv';
	        return base + '#sportsbook/home?coupon=combination|' + bets.map(function (e) {
	            return e.outcome.id;
	        }).join(',') + '|' + stake + '|replace|eurocampaign';
	    }
	};
	
	module.exports = Deeplinker;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OddsPicker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _creditCard = __webpack_require__(1671);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _colors = __webpack_require__(910);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(618);
	
	var _OddsList = __webpack_require__(1639);
	
	var _utils = __webpack_require__(1664);
	
	var _actions = __webpack_require__(587);
	
	var _GlobalSnackbar = __webpack_require__(1046);
	
	var _EventByDatePicker = __webpack_require__(1135);
	
	var _EventByDatePicker2 = _interopRequireDefault(_EventByDatePicker);
	
	var _actions2 = __webpack_require__(587);
	
	var _actions3 = __webpack_require__(1047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventInfo = (0, _reactRedux.connect)(function (state, _ref) {
	    var eventId = _ref.eventId;
	    return {
	        event: (0, _get2.default)((0, _selectors.getEntities)(state), ['events', eventId]),
	        pending: (0, _get2.default)((0, _selectors.getQueries)(state), ['events/' + eventId, 'isPending'])
	    };
	})(function (_ref2) {
	    var pending = _ref2.pending,
	        event = _ref2.event;
	
	    if (pending) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'Loading...'
	        );
	    }
	    return event ? _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        event.homeName,
	        ' - ',
	        event.awayName,
	        _react2.default.createElement('br', null),
	        event.statusFull,
	        _react2.default.createElement('br', null),
	        (0, _moment2.default)(event.startDate).format('DD MMM YYYY HH:mm')
	    ) : _react2.default.createElement(
	        'div',
	        null,
	        'Event not found'
	    );
	});
	
	var OddsPicker = exports.OddsPicker = (0, _reactRedux.connect)(function (state) {
	    var _oddsSelection$select = _actions.oddsSelection.select(state),
	        selectedOrder = _oddsSelection$select.selectedOrder,
	        selectedCampaign = _oddsSelection$select.selectedCampaign,
	        selectedProvider = _oddsSelection$select.selectedProvider,
	        eventId = _oddsSelection$select.eventId;
	
	    var _getEntities = (0, _selectors.getEntities)(state),
	        socialCampaigns = _getEntities.socialCampaigns,
	        outcomes = _getEntities.outcomes,
	        betOffers = _getEntities.betOffers,
	        _getEntities$events = _getEntities.events,
	        events = _getEntities$events === undefined ? {} : _getEntities$events;
	
	    return {
	        outcomes: outcomes,
	        betOffers: betOffers,
	        selectedOrder: selectedOrder,
	        selectedCampaign: selectedCampaign,
	        selectedProvider: selectedProvider,
	        socialCampaigns: socialCampaigns,
	        event: events[eventId],
	        user: (0, _get2.default)(state, 'user', {}),
	        bitlyAccessToken: ((0, _get2.default)(state, ['user', 'defaultProps'], []).find(function (_ref3) {
	            var _ref3$key = _ref3.key,
	                key = _ref3$key === undefined ? '' : _ref3$key;
	            return key === 'bitlyAccessToken';
	        }) || {}).bitlyAccessToken || _cfg2.default.bitlyKey
	    };
	})((_temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, ctx) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, ctx));
	
	        _this.updateTextAndUrl = function (_ref4) {
	            var selectedOrder = _ref4.selectedOrder,
	                outcomes = _ref4.outcomes,
	                betOffers = _ref4.betOffers,
	                selectedProvider = _ref4.selectedProvider,
	                event = _ref4.event;
	
	            var _getUrlAndText = (0, _utils.getUrlAndText)({ selectedOrder: selectedOrder, outcomes: outcomes, betOffers: betOffers, event: event, selectedProvider: selectedProvider }),
	                url = _getUrlAndText.url,
	                text = _getUrlAndText.text;
	
	            _this.setState({ selectedText: text, generatedLink: url });
	        };
	
	        _this.open = function (e) {
	            _this.setState({ open: true, target: e.target });
	        };
	
	        _this.close = function () {
	            _this.setState({
	                open: false,
	                selectedText: null,
	                generatedLink: null
	            });
	        };
	
	        _this.onOutcomeChange = function (_ref5) {
	            var selectedText = _ref5.selectedText,
	                generatedLink = _ref5.generatedLink;
	
	            _this.setState({
	                selectedText: selectedText,
	                generatedLink: generatedLink
	            });
	        };
	
	        _this.onAdd = function (_ref6) {
	            var message = _ref6.message,
	                url = _ref6.url;
	            return function () {
	                if (_this.props.onAdd) {
	                    _this.props.onAdd({ message: message, url: url, bitlyAccessToken: _this.props.bitlyAccessToken });
	                }
	                _this.close();
	            };
	        };
	
	        _this.onCopy = function () {
	            _this.props.dispatch((0, _GlobalSnackbar.showSnackBarMessage)('URL was copied to clipboard', 1500));
	        };
	
	        _this.handleEventPickerChange = function (keyChanged, value) {
	            if (keyChanged === 'eventId') {
	                _this.setState({ eventId: value });
	                _this.props.dispatch((0, _actions2.setEventId)(value));
	                _this.props.dispatch((0, _actions3.fetchEventById)(value));
	            }
	        };
	
	        _this.state = {
	            open: false,
	            eventId: props.eventId,
	            // selection
	            selectedText: null,
	            generatedLink: null
	        };
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref7) {
	            var selectedOrder = _ref7.selectedOrder,
	                outcomes = _ref7.outcomes,
	                betOffers = _ref7.betOffers,
	                selectedProvider = _ref7.selectedProvider,
	                event = _ref7.event;
	
	            if (this.props.selectedOrder !== selectedOrder || this.props.outcomes !== outcomes || this.props.betOffers !== betOffers || this.props.selectedProvider !== selectedProvider || this.props.event !== event) {
	                this.updateTextAndUrl({ selectedOrder: selectedOrder, outcomes: outcomes, betOffers: betOffers, event: event, selectedProvider: selectedProvider });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.copiedTimer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                selectedText = _state.selectedText,
	                generatedLink = _state.generatedLink;
	            var _props = this.props,
	                socialCampaigns = _props.socialCampaigns,
	                selectedCampaign = _props.selectedCampaign;
	
	            var hasText = Boolean(selectedText);
	            var hasLink = Boolean(generatedLink);
	            var urlWithCampaign = generatedLink ? (0, _utils.getUrlWithCampaign)(generatedLink, socialCampaigns, selectedCampaign) : null;
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex' } },
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { onClick: this.open },
	                    _react2.default.createElement(_creditCard2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        title: 'Odds picker',
	                        open: this.state.open,
	                        className: 'no-padding-dialog',
	                        titleStyle: { borderBottom: '1px solid ' + _colors.grey300 },
	                        actionsContainerStyle: { borderTop: '1px solid ' + _colors.grey300 },
	                        autoScrollBodyContent: true,
	                        autoDetectWindowHeight: true,
	                        onRequestClose: this.close,
	                        actions: [_react2.default.createElement(_materialUi.FlatButton, {
	                            key: 'Text',
	                            disabled: !hasText,
	                            label: 'Text',
	                            onClick: this.onAdd({ message: selectedText })
	                        }), _react2.default.createElement(_materialUi.FlatButton, {
	                            key: 'Text+Link',
	                            disabled: !hasText || !hasLink,
	                            primary: true,
	                            label: 'Text + link',
	                            onClick: this.onAdd({ message: selectedText, url: urlWithCampaign })
	                        }), _react2.default.createElement(_materialUi.FlatButton, {
	                            key: 'Link',
	                            disabled: !hasLink,
	                            label: 'Link',
	                            onClick: this.onAdd({ url: urlWithCampaign })
	                        })]
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { padding: 12 } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'center' } },
	                            this.props.eventId && _react2.default.createElement(EventInfo, { eventId: this.props.eventId }),
	                            !this.props.eventId && _react2.default.createElement(_EventByDatePicker2.default, { eventId: this.state.eventId, onChange: this.handleEventPickerChange })
	                        ),
	                        _react2.default.createElement(_OddsList.OddsList, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                position: 'absolute',
	                                bottom: 2,
	                                maxWidth: 450,
	                                display: 'inline-flex',
	                                alignItems: 'center'
	                            }
	                        },
	                        _react2.default.createElement(
	                            _reactCopyToClipboard2.default,
	                            { text: urlWithCampaign, onCopy: this.onCopy },
	                            _react2.default.createElement(
	                                _materialUi.IconButton,
	                                {
	                                    disabled: !urlWithCampaign,
	                                    tooltip: 'Copy url to clipboard',
	                                    tooltipPosition: 'top-center'
	                                },
	                                _react2.default.createElement(_contentCopy2.default, null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    whiteSpace: 'nowrap',
	                                    overflow: 'hidden',
	                                    textOverflow: 'ellipsis'
	                                }
	                            },
	                            'URL: ',
	                            urlWithCampaign || 'none'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component), _class.propTypes = {
	    disabled: _propTypes2.default.bool,
	    markets: _propTypes2.default.array,
	    socialCampaigns: _propTypes2.default.array,
	    eventId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    bitlyAccessToken: _propTypes2.default.string.isRequired,
	    onAdd: _propTypes2.default.func
	}, _temp));

/***/ },
/* 1671 */,
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OddsScene = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(588);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _odds = __webpack_require__(1638);
	
	var _actions = __webpack_require__(587);
	
	var _EventByDatePicker = __webpack_require__(1135);
	
	var _EventByDatePicker2 = _interopRequireDefault(_EventByDatePicker);
	
	var _selectors = __webpack_require__(618);
	
	var _utils = __webpack_require__(1664);
	
	var _GlobalSnackbar = __webpack_require__(1046);
	
	var _actions2 = __webpack_require__(1047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultilineText = function MultilineText(_ref) {
	    var text = _ref.text;
	    return _react2.default.createElement(
	        'span',
	        null,
	        (typeof text === 'string' ? text : '').split('\n').map(function (chunk, key) {
	            return _react2.default.createElement(
	                'span',
	                { key: key },
	                chunk,
	                _react2.default.createElement('br', null)
	            );
	        })
	    );
	};
	
	var SelectionPreview = (0, _reactRedux.connect)(function (state) {
	    var _oddsSelection$select = _actions.oddsSelection.select(state),
	        selectedOrder = _oddsSelection$select.selectedOrder,
	        selectedCampaign = _oddsSelection$select.selectedCampaign,
	        selectedProvider = _oddsSelection$select.selectedProvider,
	        eventId = _oddsSelection$select.eventId;
	
	    var _getEntities = (0, _selectors.getEntities)(state),
	        socialCampaigns = _getEntities.socialCampaigns,
	        outcomes = _getEntities.outcomes,
	        betOffers = _getEntities.betOffers,
	        _getEntities$events = _getEntities.events,
	        events = _getEntities$events === undefined ? {} : _getEntities$events;
	
	    return {
	        outcomes: outcomes,
	        betOffers: betOffers,
	        socialCampaigns: socialCampaigns,
	        selectedOrder: selectedOrder,
	        selectedCampaign: selectedCampaign,
	        selectedProvider: selectedProvider,
	        event: events[eventId]
	    };
	})(function (_ref2) {
	    var selectedOrder = _ref2.selectedOrder,
	        outcomes = _ref2.outcomes,
	        betOffers = _ref2.betOffers,
	        selectedProvider = _ref2.selectedProvider,
	        event = _ref2.event,
	        socialCampaigns = _ref2.socialCampaigns,
	        selectedCampaign = _ref2.selectedCampaign,
	        dispatch = _ref2.dispatch;
	
	    var _getUrlAndText = (0, _utils.getUrlAndText)({ selectedOrder: selectedOrder, outcomes: outcomes, betOffers: betOffers, event: event, selectedProvider: selectedProvider }),
	        url = _getUrlAndText.url,
	        text = _getUrlAndText.text;
	
	    var urlWithCampaign = url ? (0, _utils.getUrlWithCampaign)(url, socialCampaigns, selectedCampaign) : url;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'p',
	            null,
	            'URL:',
	            ' ',
	            urlWithCampaign ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'i',
	                    null,
	                    urlWithCampaign
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactCopyToClipboard2.default,
	                    {
	                        text: urlWithCampaign,
	                        onCopy: function onCopy() {
	                            return dispatch((0, _GlobalSnackbar.showSnackBarMessage)('URL was copied', 1500));
	                        }
	                    },
	                    _react2.default.createElement(
	                        _materialUi.IconButton,
	                        {
	                            disabled: !urlWithCampaign,
	                            tooltip: 'Copy url to clipboard',
	                            tooltipPosition: 'top-right'
	                        },
	                        _react2.default.createElement(_contentCopy2.default, null)
	                    )
	                )
	            ) : 'none'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { border: '2px solid #eee' } },
	            _react2.default.createElement(MultilineText, { text: text }),
	            _react2.default.createElement(
	                _reactCopyToClipboard2.default,
	                { text: text, onCopy: function onCopy() {
	                        return dispatch((0, _GlobalSnackbar.showSnackBarMessage)('Text was copied', 1500));
	                    } },
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: !text, tooltip: 'Copy text to clipboard', tooltipPosition: 'bottom-right' },
	                    _react2.default.createElement(_contentCopy2.default, null)
	                )
	            )
	        )
	    );
	});
	
	var OddsScene = exports.OddsScene = (0, _reactRedux.connect)()(function (_React$Component) {
	    _inherits(_class2, _React$Component);
	
	    function _class2() {
	        var _ref3;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref3, [this].concat(args))), _this), _this.handleEventPickerChange = function (keyChanged, value) {
	            if (keyChanged === 'eventId') {
	                var _this$props = _this.props,
	                    router = _this$props.router,
	                    path = _this$props.route.path;
	
	                router.push(path.replace(/\(?\/?:eventId\)?/, '/' + value));
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                params = _props.params,
	                dispatch = _props.dispatch;
	
	            if (params.eventId) {
	                dispatch((0, _actions.setEventId)(params.eventId));
	                dispatch((0, _actions2.fetchEventById)(params.eventId));
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref4) {
	            var params = _ref4.params;
	
	            if (params.eventId !== this.props.params.eventId) {
	                this.props.dispatch((0, _actions.setEventId)(params.eventId));
	                if (params.eventId) {
	                    this.props.dispatch((0, _actions2.fetchEventById)(params.eventId));
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _materialUi.Paper,
	                { style: { padding: 12 } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_EventByDatePicker2.default, { eventId: this.props.params.eventId, onChange: this.handleEventPickerChange }),
	                    _react2.default.createElement(_odds.OddsList, null),
	                    _react2.default.createElement(SelectionPreview, null)
	                )
	            );
	        }
	    }]);
	
	    return _class2;
	}(_react2.default.Component));

/***/ },
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smWidgets = function smWidgets(_ref) {
	    var tournamentId = _ref.tournamentId,
	        teamId = _ref.teamId,
	        seasonId = _ref.seasonId;
	
	    return [{
	        name: 'TeamSeasonFormSMWidget',
	        props: {
	            teamId: teamId,
	            teamSide: 'both',
	            ttIds: [tournamentId],
	            seasonIds: [seasonId]
	        }
	    }, {
	        name: 'TeamSeasonWLMarginSMWidget',
	        props: {
	            teamId: teamId,
	            typeLayout: 'center',
	            ttIds: [tournamentId],
	            seasonIds: [seasonId]
	        }
	    }, {
	        name: 'TeamSeasonH2HSMWidget',
	        props: {
	            teamId: teamId,
	            typeStage: 'preMatch',
	            ttIds: [tournamentId],
	            seasonIds: [seasonId]
	        }
	    }, {
	        name: 'TeamSeasonAverageGoalsSMWidget',
	        props: {
	            teamId: teamId,
	            ttIds: [tournamentId],
	            seasonIds: [seasonId],
	            typeTeam: 'both',
	            typeStage: 'graphDot'
	        }
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            teamId: teamId,
	            incidentType: 'goals',
	            activePlayers: true,
	            layout: 2
	        }
	    }];
	};
	
	function TeamSeasonStatsSMB(_ref2) {
	    var params = _ref2.params;
	
	    return _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgets(params), title: 'Team Stats' });
	}
	
	TeamSeasonStatsSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	
	exports.default = TeamSeasonStatsSMB;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _PlayersList = __webpack_require__(1678);
	
	var _PlayersList2 = _interopRequireDefault(_PlayersList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smWidgets = function smWidgets(_ref) {
	    var teamId = _ref.teamId;
	
	    return [{
	        name: 'TeamSquadListSMWidget',
	        props: {
	            teamId: teamId,
	            layoutType: 'list',
	            groupBy: true,
	            position: 'allGroup',
	            subTextType: 'clubName',
	            showCoach: true,
	            showInjSusp: true
	        }
	    }, {
	        name: 'TeamSquadListSMWidget',
	        props: {
	            teamId: teamId,
	            layoutType: 'grid',
	            groupBy: true,
	            position: 'allGroup',
	            subTextType: 'clubName',
	            showCoach: true,
	            showInjSusp: true
	        }
	    }];
	};
	
	function TeamSquadSMB(_ref2) {
	    var params = _ref2.params;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PlayersList2.default, { params: params }),
	        _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgets(params), title: 'Team Squad' })
	    );
	}
	
	TeamSquadSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired,
	    children: _propTypes2.default.any
	};
	
	exports.default = TeamSquadSMB;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-top: 45px;\n    margin-right: -5px;\n    margin-left: -5px;\n\n    > * {\n        flex-basis: 180px;\n        margin-right: 5px;\n        margin-bottom: 30px;\n        margin-left: 5px;\n    }\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-top: 45px;\n    margin-right: -5px;\n    margin-left: -5px;\n\n    > * {\n        flex-basis: 180px;\n        margin-right: 5px;\n        margin-bottom: 30px;\n        margin-left: 5px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n\n    h3 {\n        margin: 0;\n    }\n'], ['\n    text-align: center;\n\n    h3 {\n        margin: 0;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(188);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var Player = _styledComponents2.default.div(_templateObject2);
	
	var imageWrapStyle = { position: 'relative', display: 'inline-block' };
	
	var PlayersList = function (_Component) {
	    _inherits(PlayersList, _Component);
	
	    function PlayersList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PlayersList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlayersList.__proto__ || Object.getPrototypeOf(PlayersList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            teamId: _this.props.params && _this.props.params.teamId || '',
	            members: {}
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PlayersList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData(this.props.params);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var params = _ref2.params;
	
	            if (params.teamId !== this.state.teamId) {
	                this.loadData(params);
	            }
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData(_ref3) {
	            var _this2 = this;
	
	            var _ref3$teamId = _ref3.teamId,
	                teamId = _ref3$teamId === undefined ? '' : _ref3$teamId;
	
	            Promise.all([fetch('http://ss2.si-ab.com/teams/' + teamId + '/members').then(function (res) {
	                return res.json();
	            })]).then(function (res) {
	                if (res) {
	                    var _res = _slicedToArray(res, 1),
	                        _res$ = _res[0],
	                        members = _res$ === undefined ? {} : _res$;
	
	                    _this2.setState({
	                        teamId: teamId,
	                        members: members
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                _state$teamId = _state.teamId,
	                teamId = _state$teamId === undefined ? '' : _state$teamId,
	                _state$members = _state.members;
	            _state$members = _state$members === undefined ? {} : _state$members;
	            var _state$members$player = _state$members.players,
	                players = _state$members$player === undefined ? [] : _state$members$player;
	            var _props$params = this.props.params,
	                _props$params$tournam = _props$params.tournamentId,
	                tournamentId = _props$params$tournam === undefined ? '' : _props$params$tournam,
	                _props$params$seasonI = _props$params.seasonId,
	                seasonId = _props$params$seasonI === undefined ? '' : _props$params$seasonI;
	
	
	            return _react2.default.createElement(
	                Content,
	                null,
	                players.map(function (player) {
	                    return _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            key: player.id,
	                            to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad/players/' + player.id
	                        },
	                        _react2.default.createElement(
	                            Player,
	                            null,
	                            _react2.default.createElement(_SMPlayerLogo.PlayerLogo3DJerseyBack, {
	                                playerId: player.id,
	                                teamId: teamId,
	                                seasonId: seasonId,
	                                width: 70,
	                                number: ~~player.number,
	                                display: '3d_jersey',
	                                size: 'large',
	                                imageWrapStyle: imageWrapStyle
	                            }),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                player.name
	                            )
	                        )
	                    );
	                }),
	                this.props.children
	            );
	        }
	    }]);
	
	    return PlayersList;
	}(_react.Component);
	
	PlayersList.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired,
	    children: _propTypes2.default.any
	};
	exports.default = PlayersList;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-top: 30px;\n'], ['\n    margin-top: 30px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _TeamHeader = __webpack_require__(1680);
	
	var _TeamHeader2 = _interopRequireDefault(_TeamHeader);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var TeamHostSMB = function (_Component) {
	    _inherits(TeamHostSMB, _Component);
	
	    function TeamHostSMB() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TeamHostSMB);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamHostSMB.__proto__ || Object.getPrototypeOf(TeamHostSMB)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            teamId: _this.props.params && _this.props.params.teamId || '',
	            team: {},
	            tournaments: [],
	            tournamentIds: []
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TeamHostSMB, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData(this.props.params);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var params = _ref2.params;
	
	            if (params.teamId !== this.state.teamId) {
	                this.loadData(params);
	            }
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData(_ref3) {
	            var _this2 = this;
	
	            var _ref3$teamId = _ref3.teamId,
	                teamId = _ref3$teamId === undefined ? '' : _ref3$teamId;
	
	            fetch('http://ss2.si-ab.com/teams/' + teamId + '/').then(function (res) {
	                return res.json();
	            }).then(function (team) {
	                if (team) {
	                    return Promise.all(team.tournamentTemplateId.map(function (id) {
	                        return fetch('http://ss2.si-ab.com/tournaments/' + id).then(function (res) {
	                            return res.json();
	                        });
	                    })).then(function (tournaments) {
	                        if (tournaments) {
	                            _this2.setState({
	                                teamId: teamId,
	                                team: team,
	                                tournaments: tournaments,
	                                tournamentIds: team.tournamentTemplateId
	                            });
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                _state$teamId = _state.teamId,
	                teamId = _state$teamId === undefined ? '' : _state$teamId,
	                _state$team = _state.team,
	                team = _state$team === undefined ? {} : _state$team,
	                _state$tournaments = _state.tournaments,
	                tournaments = _state$tournaments === undefined ? [] : _state$tournaments,
	                _state$tournamentIds = _state.tournamentIds,
	                tournamentIds = _state$tournamentIds === undefined ? [] : _state$tournamentIds;
	            var _props$params = this.props.params,
	                _props$params$tournam = _props$params.tournamentId,
	                tournamentId = _props$params$tournam === undefined ? '' : _props$params$tournam,
	                _props$params$seasonI = _props$params.seasonId,
	                seasonId = _props$params$seasonI === undefined ? '' : _props$params$seasonI;
	
	
	            if (!tournamentIds.find(function (id) {
	                return id === ~~tournamentId;
	            }) && tournaments[0]) {
	                _reactRouter.browserHistory.push({
	                    pathname: location.pathname.replace(new RegExp('tournaments\\/\\d*\\/\\d*'), 'tournaments/' + tournaments[0].id + '/' + tournaments[0].currentSeason.id)
	                });
	            }
	
	            return _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(_TeamHeader2.default, {
	                    teamId: teamId,
	                    team: team,
	                    tournamentId: tournamentId,
	                    seasonId: seasonId,
	                    tournaments: tournaments
	                }),
	                this.props.children
	            );
	        }
	    }]);
	
	    return TeamHostSMB;
	}(_react.Component);
	
	TeamHostSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired,
	    children: _propTypes2.default.any
	};
	
	exports.default = TeamHostSMB;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    margin: 0 0 30px;\n\n    h2 {\n        margin: 0;\n\n        font-size: 3em;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin: 0 0 30px;\n\n    h2 {\n        margin: 0;\n\n        font-size: 3em;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral([''], ['']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ';\n'], ['\n    ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n\n    > * {\n        margin-right: 10px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n\n    > * {\n        margin-right: 10px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _reactRouter = __webpack_require__(188);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Header = _styledComponents2.default.div(_templateObject);
	
	var Ul = _styledComponents2.default.ul(_templateObject2);
	
	var Li = _styledComponents2.default.li(_templateObject3, function (_ref) {
	    var active = _ref.active;
	    return active && '';
	});
	
	var BtnWrapper = _styledComponents2.default.div(_templateObject4);
	
	function TeamHeader(_ref2) {
	    var _ref2$teamId = _ref2.teamId,
	        teamId = _ref2$teamId === undefined ? {} : _ref2$teamId,
	        _ref2$team = _ref2.team,
	        team = _ref2$team === undefined ? {} : _ref2$team,
	        _ref2$tournamentId = _ref2.tournamentId,
	        tournamentId = _ref2$tournamentId === undefined ? '' : _ref2$tournamentId,
	        _ref2$seasonId = _ref2.seasonId,
	        seasonId = _ref2$seasonId === undefined ? '' : _ref2$seasonId,
	        _ref2$tournaments = _ref2.tournaments,
	        tournaments = _ref2$tournaments === undefined ? [] : _ref2$tournaments;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Header,
	            null,
	            _react2.default.createElement(_SMTeamLogo2.default, { width: 100, style: { marginRight: 10 }, teamId: teamId }),
	            _react2.default.createElement(
	                'h2',
	                null,
	                team.name
	            ),
	            _react2.default.createElement(
	                Ul,
	                null,
	                tournaments.filter(function (tournament) {
	                    return tournament.id !== tournamentId;
	                }).map(function (tournament) {
	                    return _react2.default.createElement(
	                        Li,
	                        {
	                            key: tournament.id,
	                            active: location.pathname.includes('/sm/browser/football/tournaments/' + tournament.id + '/' + (tournament.seasons && tournament.seasons[tournament.seasons.length - 1] && tournament.seasons[tournament.seasons.length - 1].id) + '/team/' + teamId)
	                        },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            {
	                                to: '/sm/browser/football/tournaments/' + tournament.id + '/' + (tournament.seasons && tournament.seasons[tournament.seasons.length - 1] && tournament.seasons[tournament.seasons.length - 1].id) + '/team/' + teamId
	                            },
	                            tournament.name
	                        )
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            BtnWrapper,
	            null,
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/home' },
	                _react2.default.createElement(_RaisedButton2.default, {
	                    label: 'Home',
	                    primary: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/home')
	                })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/stats' },
	                _react2.default.createElement(_RaisedButton2.default, {
	                    label: 'Stats',
	                    primary: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/stats')
	                })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad' },
	                _react2.default.createElement(_RaisedButton2.default, {
	                    label: 'Squad',
	                    primary: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad')
	                })
	            )
	        )
	    );
	}
	
	TeamHeader.propTypes = {
	    teamId: _propTypes2.default.string.isRequired,
	    team: _propTypes2.default.object.isRequired,
	    tournamentId: _propTypes2.default.string.isRequired,
	    seasonId: _propTypes2.default.string.isRequired,
	    tournaments: _propTypes2.default.array.isRequired
	};
	
	exports.default = TeamHeader;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-top: 30px;\n'], ['\n    margin-top: 30px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PlayerHeader = __webpack_require__(1682);
	
	var _PlayerHeader2 = _interopRequireDefault(_PlayerHeader);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var PlayerHostSMB = function (_Component) {
	    _inherits(PlayerHostSMB, _Component);
	
	    function PlayerHostSMB() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PlayerHostSMB);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlayerHostSMB.__proto__ || Object.getPrototypeOf(PlayerHostSMB)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            playerId: _this.props.params && _this.props.params.playerId || '',
	            player: {}
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PlayerHostSMB, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData(this.props.params);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var params = _ref2.params;
	
	            if (params.playerId !== this.state.playerId) {
	                this.loadData(params);
	            }
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData(_ref3) {
	            var _this2 = this;
	
	            var _ref3$playerId = _ref3.playerId,
	                playerId = _ref3$playerId === undefined ? '' : _ref3$playerId;
	
	            Promise.all([fetch('https://ss2.si-ab.com/players/' + playerId + '/profile').then(function (res) {
	                return res.json();
	            })]).then(function (res) {
	                if (res) {
	                    var _res = _slicedToArray(res, 1),
	                        _res$ = _res[0],
	                        player = _res$ === undefined ? {} : _res$;
	
	                    _this2.setState({
	                        playerId: playerId,
	                        player: player
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                _state$playerId = _state.playerId,
	                playerId = _state$playerId === undefined ? '' : _state$playerId,
	                _state$player = _state.player,
	                player = _state$player === undefined ? {} : _state$player;
	            var _props$params = this.props.params,
	                _props$params$tournam = _props$params.tournamentId,
	                tournamentId = _props$params$tournam === undefined ? '' : _props$params$tournam,
	                _props$params$seasonI = _props$params.seasonId,
	                seasonId = _props$params$seasonI === undefined ? '' : _props$params$seasonI,
	                _props$params$teamId = _props$params.teamId,
	                teamId = _props$params$teamId === undefined ? '' : _props$params$teamId;
	
	
	            return _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(_PlayerHeader2.default, {
	                    playerId: playerId,
	                    player: player,
	                    tournamentId: tournamentId,
	                    seasonId: seasonId,
	                    teamId: teamId
	                }),
	                this.props.children
	            );
	        }
	    }]);
	
	    return PlayerHostSMB;
	}(_react.Component);
	
	PlayerHostSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired
	    }).isRequired,
	    children: _propTypes2.default.any
	};
	
	exports.default = PlayerHostSMB;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    margin: 0 0 30px;\n\n    h2 {\n        margin: 0;\n\n        font-size: 3em;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin: 0 0 30px;\n\n    h2 {\n        margin: 0;\n\n        font-size: 3em;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral([''], ['']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ';\n'], ['\n    ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n\n    > * {\n        margin-right: 10px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n\n    > * {\n        margin-right: 10px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMPlayerLogo = __webpack_require__(1393);
	
	var _reactRouter = __webpack_require__(188);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Header = _styledComponents2.default.div(_templateObject);
	
	var Ul = _styledComponents2.default.ul(_templateObject2);
	
	var Li = _styledComponents2.default.li(_templateObject3, function (_ref) {
	    var active = _ref.active;
	    return active && '';
	});
	
	var BtnWrapper = _styledComponents2.default.div(_templateObject4);
	
	var imageWrapStyle = { marginRight: 10, position: 'relative' };
	
	// TODO: ADD: Displays name, age, current club, national team, load team (if available)
	function PlayerHeader(_ref2) {
	    var _ref2$playerId = _ref2.playerId,
	        playerId = _ref2$playerId === undefined ? {} : _ref2$playerId,
	        _ref2$player = _ref2.player,
	        player = _ref2$player === undefined ? {} : _ref2$player,
	        _ref2$tournamentId = _ref2.tournamentId,
	        tournamentId = _ref2$tournamentId === undefined ? '' : _ref2$tournamentId,
	        _ref2$seasonId = _ref2.seasonId,
	        seasonId = _ref2$seasonId === undefined ? '' : _ref2$seasonId,
	        _ref2$teamId = _ref2.teamId,
	        teamId = _ref2$teamId === undefined ? '' : _ref2$teamId;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Header,
	            null,
	            _react2.default.createElement(_SMPlayerLogo.PlayerLogo3DJerseyBack, {
	                playerId: player.id,
	                teamId: player.team && player.team.id,
	                seasonId: seasonId,
	                width: 100,
	                number: player.team && ~~player.team.number,
	                display: '3d_jersey',
	                size: 'large',
	                imageWrapStyle: imageWrapStyle
	            }),
	            _react2.default.createElement(
	                'h2',
	                null,
	                player.name
	            ),
	            player.nationalTeam && _react2.default.createElement(
	                Ul,
	                null,
	                _react2.default.createElement(
	                    Li,
	                    {
	                        active: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + player.team.id + '/squad/players/' + playerId + '/home')
	                    },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + player.team.id + '/squad/players/' + playerId
	                        },
	                        player.team.name
	                    )
	                ),
	                _react2.default.createElement(
	                    Li,
	                    {
	                        active: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + player.nationalTeam.id + '/squad/players/' + playerId + '/home')
	                    },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + player.nationalTeam.id + '/squad/players/' + playerId
	                        },
	                        player.nationalTeam.name
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            BtnWrapper,
	            null,
	            _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad/players/' + playerId + '/home'
	                },
	                _react2.default.createElement(_RaisedButton2.default, {
	                    label: 'Home',
	                    primary: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad/players/' + playerId + '/home')
	                })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    to: '/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad/players/' + playerId + '/compare'
	                },
	                _react2.default.createElement(_RaisedButton2.default, {
	                    label: 'compare',
	                    primary: location.pathname.includes('/sm/browser/football/tournaments/' + tournamentId + '/' + seasonId + '/team/' + teamId + '/squad/players/' + playerId + '/compare')
	                })
	            )
	        )
	    );
	}
	
	PlayerHeader.propTypes = {
	    playerId: _propTypes2.default.string.isRequired,
	    player: _propTypes2.default.object.isRequired,
	    tournamentId: _propTypes2.default.string.isRequired,
	    seasonId: _propTypes2.default.string.isRequired,
	    teamId: _propTypes2.default.string.isRequired
	};
	
	exports.default = PlayerHeader;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smWidgets = function smWidgets(_ref) {
	    var tournamentId = _ref.tournamentId,
	        teamId = _ref.teamId,
	        seasonId = _ref.seasonId,
	        playerId = _ref.playerId;
	
	    return [{
	        name: 'PlayerLatestMatchesFormSMWidget',
	        props: {
	            teamId: teamId,
	            playerId: playerId,
	            seasonIds: [seasonId],
	            incedentType: 'goals'
	        }
	    }, {
	        name: 'PlayerLatestMatchesFormSMWidget',
	        props: {
	            teamId: teamId,
	            playerId: playerId,
	            seasonIds: [seasonId],
	            incedentType: 'assists'
	        }
	    }, {
	        name: 'PlayerLatestMatchesFormSMWidget',
	        props: {
	            teamId: teamId,
	            playerId: playerId,
	            seasonIds: [seasonId],
	            incedentType: 'goals+assists'
	        }
	    }, {
	        name: 'PlayerLatestMatchesFormSMWidget',
	        props: {
	            teamId: teamId,
	            playerId: playerId,
	            seasonIds: [seasonId],
	            incedentType: null,
	            limit: 12
	        }
	    }, {
	        name: 'PlayerProfileAdvSMWidget',
	        props: {
	            teamId: teamId,
	            playerId: playerId
	        }
	    }, {
	        name: 'PlayerProfileOpta',
	        props: {
	            teamId: teamId,
	            playerId: playerId,
	            ttIds: tournamentId,
	            seasonIds: seasonId
	        }
	    }];
	};
	
	function PlayerSeasonSMB(_ref2) {
	    var params = _ref2.params;
	
	    return _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgets(params), title: 'Player vs Player' });
	}
	
	PlayerSeasonSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        playerId: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	
	exports.default = PlayerSeasonSMB;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smWidgets = function smWidgets(_ref) {
	    var _ref$tournamentId = _ref.tournamentId,
	        tournamentId = _ref$tournamentId === undefined ? '' : _ref$tournamentId,
	        _ref$teamId = _ref.teamId,
	        teamId = _ref$teamId === undefined ? '' : _ref$teamId,
	        _ref$seasonId = _ref.seasonId,
	        seasonId = _ref$seasonId === undefined ? '' : _ref$seasonId,
	        _ref$playerId = _ref.playerId,
	        playerId = _ref$playerId === undefined ? '' : _ref$playerId;
	
	    return [{
	        name: 'TeamSeasonFormSMWidget',
	        props: {
	            teamId: teamId,
	            player1Id: playerId,
	            player2Id: playerId,
	            tournamentId: tournamentId,
	            seasonId: seasonId
	        }
	    }, {
	        name: 'H2HPlayerProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style1'
	        }
	    }, {
	        name: 'H2HPlayerProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style2'
	        }
	    }, {
	        name: 'H2HPlayerClubProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style1'
	        }
	    }, {
	        name: 'H2HPlayerClubProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style2'
	        }
	    }, {
	        name: 'H2HPlayerTournamentProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style1',
	            ttIds: [tournamentId]
	        }
	    }, {
	        name: 'H2HPlayerTournamentProfileSMWidget',
	        props: {
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style2',
	            ttIds: [tournamentId]
	        }
	    }, {
	        name: 'H2HPlayerSeasonProfileSMWidget',
	        props: {
	            tournamentId: tournamentId,
	            seasonId: seasonId,
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style1',
	            typeProfile: 'goals'
	        }
	    }, {
	        name: 'H2HPlayerSeasonProfileSMWidget',
	        props: {
	            tournamentId: tournamentId,
	            seasonId: seasonId,
	            playerId: playerId,
	            teamId: teamId,
	            opponentId: playerId,
	            opponentTeamId: teamId,
	            typeStyle: 'style2',
	            typeProfile: 'goals'
	        }
	    }];
	};
	
	function PlayerH2HSeasonSMB(_ref2) {
	    var params = _ref2.params;
	
	    return _react2.default.createElement(_SMStream2.default, { smWidgets: smWidgets(params), title: 'Team Stats' });
	}
	
	PlayerH2HSeasonSMB.propTypes = {
	    params: _propTypes2.default.shape({
	        tournamentId: _propTypes2.default.string.isRequired,
	        seasonId: _propTypes2.default.string.isRequired,
	        teamId: _propTypes2.default.string.isRequired,
	        playerId: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	
	exports.default = PlayerH2HSeasonSMB;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var simpleEventWidgets = function simpleEventWidgets(tournamentId) {
	    return _lodash2.default.compact(['MatchAnnouncement', +tournamentId != 46 && 'PreMatchStatsSMWidget', +tournamentId != 46 && 'PreMatchStatsV7', +tournamentId === 46 && 'ProPreMatchStatsSMWidget', +tournamentId === 46 && 'ProLiveMatchStatsSMWidget', 'AnimatedMatchAnnouncement', 'AnimatedMatchAnnouncementTextual', 'AnimatedMatchAnnouncementV2SMWidget']);
	};
	
	var statusWidgets = function statusWidgets(tournamentId) {
	    return _lodash2.default.compact(['MatchStarted', +tournamentId === 46 ? 'ProLiveMatchStatsSMWidget' : 'MatchStats', 'MatchFinished']);
	};
	
	var presentingTeams = function presentingTeams(event) {
	    return [{
	        name: 'TeamH2HTopScorersX3V4',
	        groupKey: 'ts-h2h-current',
	        props: {
	            eventId: event.eventId,
	            tournamentId: event.tournamentTemplateId,
	            seasonId: event.tournamentId
	        },
	        groupTitle: event.tournamentName + ' ' + event.tournamentYear + ' H2H topscorers'
	    }, {
	        name: 'TeamH2HTopScorersX3V4',
	        props: {
	            eventId: event.eventId,
	            tournamentId: event.tournamentTemplateId,
	            currentSeason: false
	        },
	        groupKey: 'ts-h2h-all',
	        groupTitle: 'H2H topscorers in ' + event.tournamentName
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            eventId: event.eventId,
	            teamId: event.homeId,
	            tournamentId: event.tournamentTemplateId,
	            seasonId: event.tournamentId
	        },
	        groupKey: 'ts-' + event.homeName + '-season',
	        groupTitle: event.tournamentName + ' ' + event.tournamentYear + ' ' + event.homeShortName + ' topscorers'
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            eventId: event.eventId,
	            teamId: event.awayId,
	            tournamentId: event.tournamentTemplateId,
	            seasonId: event.tournamentId
	        },
	        groupKey: 'ts-' + event.awayName + '-season',
	        groupTitle: event.tournamentName + ' ' + event.tournamentYear + ' ' + event.awayShortName + ' topscorers'
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            eventId: event.eventId,
	            tournamentId: event.tournamentTemplateId,
	            teamId: event.homeId,
	            currentSeason: false
	        },
	        groupKey: 'ts-' + event.homeName + '-all',
	        groupTitle: event.homeShortName + ' ' + event.tournamentName + ' topscorers  '
	    }, {
	        name: 'TeamSeasonTopScorersSMWidget',
	        props: {
	            eventId: event.eventId,
	            tournamentId: event.tournamentTemplateId,
	            teamId: event.awayId,
	            currentSeason: false
	        },
	        groupKey: 'ts-' + event.awayName + '-all',
	        groupTitle: event.awayShortName + ' ' + event.tournamentName + ' topscorers '
	    }];
	};
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$params = _props.params,
	                eventId = _props$params.eventId,
	                tournamentId = _props$params.tournamentId,
	                event = _props.event;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMStream2.default, {
	                    key: 'inf_' + eventId,
	                    smWidgets: simpleEventWidgets(tournamentId).map(function (name) {
	                        return {
	                            name: name,
	                            props: { eventId: eventId }
	                        };
	                    }),
	                    title: 'Announcments'
	                }),
	                _react2.default.createElement(_SMStream2.default, {
	                    key: 'statuses_' + eventId,
	                    smWidgets: statusWidgets(tournamentId).map(function (name) {
	                        return {
	                            name: name,
	                            props: { eventId: eventId }
	                        };
	                    }),
	                    title: 'Statuses'
	                }),
	                _react2.default.createElement(_SMStream2.default, {
	                    key: 'presenting_teams_' + eventId,
	                    smWidgets: presentingTeams(event),
	                    title: 'Presenting teams'
	                })
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event
	    };
	})(EventSMB);

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var findIndicidents = function findIndicidents(event, types, name) {
	    return [].concat(_toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	        return types.indexOf(i.subtype) !== -1;
	    }).sortBy(function (i) {
	        return -i.min;
	    }).map(function (incident) {
	        return {
	            name: name,
	            groupTitle: incident.min + 'min',
	            groupKey: '' + incident.incidentId,
	            props: {
	                eventId: event.eventId,
	                incidentId: incident.incidentId
	            }
	        };
	    })));
	};
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var event = this.props.event;
	
	
	            if ((0, _Eventify2.default)(event).isComing()) {
	                return _react2.default.createElement(
	                    'h3',
	                    { style: { textAlign: 'center' } },
	                    'Match is not started'
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMStream2.default, { smWidgets: findIndicidents(event, ['goal', 'goal_own'], 'IncidentWidget'), title: 'Goals' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: findIndicidents(event, ['card'], 'IncidentWidget'), title: 'Cards' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: findIndicidents(event, ['subst_in'], 'IncidentWidget'), title: 'Substitutions' }),
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: findIndicidents(event, ['goal', 'goal_own'], 'AnimatedGoal'),
	                    title: 'Animated Goals v1'
	                }),
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: findIndicidents(event, ['goal', 'goal_own'], 'AnimatedIncident'),
	                    title: 'Animated Goals v2'
	                }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: findIndicidents(event, ['card'], 'AnimatedIncident'), title: 'Animated Cards v2' })
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return _extends({}, state.smBrowser);
	})(EventSMB);

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var statSides = ['both', 'home', 'away'];
	
	var thisTournamentOrAllTournaments = function thisTournamentOrAllTournaments(tournament, event) {
	    if (tournament.countryId === 11) return [];
	    // international
	    else return [tournament.id];
	};
	
	var thisSeasonOrAllSeasons = function thisSeasonOrAllSeasons(tournament, event) {
	    if (tournament.countryId === 11) return [];
	    // international
	    else return [event.tournamentId]; // seasonIds
	};
	
	var seasonFormForTeam = function seasonFormForTeam(tournament, season, event, teamSide) {
	    return statSides.map(function (side) {
	        return {
	            groupTitle: 'Season Form ' + event.homeShortName + ' in ' + (side === 'both' ? 'home+away' : side) + ' matches',
	            name: 'TeamSeasonFormSMWidget',
	            groupKey: 'form-' + event.homeId + '-' + side,
	            props: {
	                teamId: _lodash2.default.get(event, teamSide + 'Id'),
	                teamSide: side,
	                ttIds: thisTournamentOrAllTournaments(tournament, event),
	                seasonIds: thisSeasonOrAllSeasons(tournament, event),
	                Xmatches: 30
	            }
	        };
	    });
	};
	
	var seasonWLMarginForTeam = function seasonWLMarginForTeam(tournament, season, event, teamSide) {
	    return statSides.map(function (side) {
	        return {
	            groupTitle: 'Season Form ' + event.homeShortName + ' in ' + (side === 'both' ? 'home+away' : side) + ' matches',
	            name: 'TeamSeasonWLMarginSMWidget',
	            groupKey: 'wlm-' + event.homeId + '-' + side,
	            props: {
	                teamId: _lodash2.default.get(event, teamSide + 'Id'),
	                teamSide: side,
	                ttIds: thisTournamentOrAllTournaments(tournament, event),
	                seasonIds: thisSeasonOrAllSeasons(tournament, event),
	                Xmatches: 30
	            }
	        };
	    });
	};
	
	var seasonH2HForTeam = function seasonH2HForTeam(tournament, season, event, teamSide) {
	    return statSides.map(function (side) {
	        return {
	            groupTitle: 'HT/FT stats ' + event.homeShortName + ' in ' + (side === 'both' ? 'home+away' : side) + ' matches',
	            name: 'TeamSeasonH2HSMWidget',
	            groupKey: 'form-' + event.homeId + '-' + side,
	            props: {
	                teamId: _lodash2.default.get(event, teamSide + 'Id'),
	                typeStage: 'top',
	                teamSide: side,
	                ttIds: thisTournamentOrAllTournaments(tournament, event),
	                seasonIds: thisSeasonOrAllSeasons(tournament, event),
	                Xmatches: 30
	            }
	        };
	    });
	};
	
	var seasonAverageGoals = function seasonAverageGoals(tournament, season, event, teamSide) {
	    return statSides.map(function (side) {
	        return {
	            groupTitle: 'Average goals ' + event.homeShortName + ' in ' + (side === 'both' ? 'home+away' : side) + ' matches',
	            name: 'TeamSeasonAverageGoalsSMWidget',
	            groupKey: 'form-' + event.homeId + '-' + side,
	            props: {
	                teamId: _lodash2.default.get(event, teamSide + 'Id'),
	                typeStage: 'graphDot',
	                teamSide: side,
	                ttIds: thisTournamentOrAllTournaments(tournament, event),
	                seasonIds: thisSeasonOrAllSeasons(tournament, event),
	                Xmatches: 30
	            }
	        };
	    });
	};
	
	var rest = function rest(tournament, season, event) {
	    return [{
	        groupTitle: 'H2H Live ' + event.homeShortName,
	        name: 'TeamSeasonH2HLiveWidget',
	        groupKey: 'match-live-' + event.homeId,
	        props: {
	            teamId: event.homeId,
	            eventId: event.eventId,
	            allTournaments: true,
	            teamSide: 'both'
	        }
	    }, {
	        groupTitle: 'H2H Live ' + event.awayShortName,
	        name: 'TeamSeasonH2HLiveWidget',
	        groupKey: 'match-live-' + event.awayId,
	        props: {
	            teamId: event.awayId,
	            eventId: event.eventId,
	            allTournaments: true,
	            teamSide: 'both'
	        }
	    }, {
	        name: 'TeamSeasonH2HStatsSMWidget',
	        props: {
	            eventId: event.eventId
	        }
	    }];
	};
	
	// return Promise.resolve([
	
	//     {
	//         groupTitle: `H2H Live ${event.homeShortName}`,
	//         name: 'TeamSeasonH2HLiveWidget',
	//         groupKey: `match-live-${event.homeId}`,
	//         props: {
	//             'data-team-id': event.homeId,
	//             'data-event-id': event.eventId,
	//             'data-all-tournaments': false,
	//             'data-team-side': 'both'
	//         },
	//         key: `live-home-${event.homeId}`
	//     },
	//     {
	//         groupTitle: `H2H Live ${event.awayShortName}`,
	//         name: 'TeamSeasonH2HLiveWidget',
	//         groupKey: `match-live-${event.awayId}`,
	//         props: {
	//             'data-team-id': event.awayId,
	//             'data-event-id': event.eventId,
	//             'data-all-tournaments': false,
	//             'data-team-side': 'both'
	//         },
	//         key: `live-away-${event.awayId}`
	//     },
	//     {
	//         name: 'TeamSeasonH2HStatsSMWidget',
	//         props: {
	//             'data-event-id': event.eventId
	//         },
	//         key: `stats-TeamSeasonH2HStatsSMWidget`
	//     }
	// ]);
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var _props = this.props,
	                event = _props.event,
	                tournament = _props.tournament,
	                season = _props.season,
	                _props$params = _props.params,
	                eventId = _props$params.eventId,
	                tournamentId = _props$params.tournamentId;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                ['home', 'away'].map(function (side) {
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: 'sf-' + side,
	                        smWidgets: rest(tournament, season, event, side),
	                        title: 'Form ' + _lodash2.default.get(event, side + 'Name')
	                    });
	                }),
	                ['home', 'away'].map(function (side) {
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: 'sf-' + side,
	                        smWidgets: seasonFormForTeam(tournament, season, event, side),
	                        title: 'Form ' + _lodash2.default.get(event, side + 'Name')
	                    });
	                }),
	                ['home', 'away'].map(function (side) {
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: 'sf-' + side,
	                        smWidgets: seasonWLMarginForTeam(tournament, season, event, side),
	                        title: 'Win/Lost Margin ' + _lodash2.default.get(event, side + 'Name')
	                    });
	                }),
	                ['home', 'away'].map(function (side) {
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: 'sf-' + side,
	                        smWidgets: seasonH2HForTeam(tournament, season, event, side),
	                        title: 'HT/FT stats ' + _lodash2.default.get(event, side + 'Name')
	                    });
	                }),
	                ['home', 'away'].map(function (side) {
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: 'sf-' + side,
	                        smWidgets: seasonAverageGoals(tournament, season, event, side),
	                        title: 'Goals ' + _lodash2.default.get(event, side + 'Name')
	                    });
	                })
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return _extends({}, state.smBrowser);
	})(EventSMB);

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props$params = this.props.params,
	                eventId = _props$params.eventId,
	                tournamentId = _props$params.tournamentId;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Yes, page'
	                )
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = EventSMB;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1590);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventPlayerPerformanceSMB = function (_React$Component) {
	    _inherits(EventPlayerPerformanceSMB, _React$Component);
	
	    function EventPlayerPerformanceSMB(props, context) {
	        _classCallCheck(this, EventPlayerPerformanceSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventPlayerPerformanceSMB.__proto__ || Object.getPrototypeOf(EventPlayerPerformanceSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                event = _this$props.event,
	                loadBestPlayers = _this$props.loadBestPlayers;
	
	
	            loadBestPlayers(event.homeId, 'homeBestPlayers');
	            loadBestPlayers(event.awayId, 'awayBestPlayers');
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventPlayerPerformanceSMB, [{
	        key: 'render',
	
	
	        /// how to get best team player???
	        value: function render() {
	            var _this2 = this;
	
	            var event = this.props.event;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                ['home', 'away'].map(function (side) {
	                    var teamId = event[side + 'Id'];
	                    var teamName = event[side + 'Name'];
	                    var players = _this2.props[side + 'BestPlayers'] || [];
	
	                    return _react2.default.createElement(_SMStream2.default, {
	                        key: side,
	                        smWidgets: _lodash2.default.flatten(players.map(function (player) {
	                            return [{
	                                name: 'PlayerLatestMatchesFormSMWidget',
	                                groupTitle: player.playerName + ' in ' + event.tournamentName,
	                                groupKey: player.playerId,
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId,
	                                    incidentType: 'goals+assists',
	                                    ttIds: JSON.stringify([event.tournamentTemplateId])
	                                }
	                            }, {
	                                name: 'PlayerLatestMatchesFormSMWidget',
	                                groupTitle: '' + player.playerName,
	                                groupKey: player.playerId,
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId
	                                }
	                            }, {
	                                name: 'PlayerProfileOpta',
	                                groupTitle: '' + player.playerName,
	                                groupKey: player.playerId + 'pp',
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId,
	                                    currentSeason: true,
	                                    seasonId: event.tournamentId,
	                                    tournamentId: event.tournamentTemplateId
	                                }
	                            }, {
	                                name: 'PlayerProfileOpta',
	                                groupTitle: '' + player.playerName,
	                                groupKey: player.playerId + 'pp',
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId,
	                                    tournamentId: event.tournamentTemplateId
	                                }
	                            }, {
	                                name: 'PlayerProfileOpta',
	                                groupTitle: '' + player.playerName,
	                                groupKey: player.playerId + 'pp',
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId
	                                }
	                            }, {
	                                name: 'PlayerProfileAdvSMWidget',
	                                groupTitle: player.playerName + ' Full profile',
	                                groupKey: player.playerId + 'pa',
	                                props: {
	                                    playerId: player.playerId,
	                                    teamId: teamId
	                                }
	                            }];
	                        })),
	                        title: 'Best players ' + teamName
	                    });
	                })
	            );
	        }
	    }]);
	
	    return EventPlayerPerformanceSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event,
	        homeBestPlayers: state.smBrowser.homeBestPlayers,
	        awayBestPlayers: state.smBrowser.awayBestPlayers
	    };
	}, function (dispatch) {
	    return {
	        loadBestPlayers: function loadBestPlayers(teamId, side) {
	            return dispatch((0, _actions.loadBestPlayers)(teamId, side));
	        }
	    };
	})(EventPlayerPerformanceSMB);

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var widgets = ['LineupListSMWidget', 'LineupPitchSMWidget'];
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	
	        _this.renderLineupNotAwailableYet = function () {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Lineup is not awailable yet'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Normally expected lineup appers 1 day before and CONFIRMED 1h-30m before match start'
	                )
	            );
	        };
	
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var _props = this.props,
	                event = _props.event,
	                _props$params = _props.params,
	                eventId = _props$params.eventId,
	                tournamentId = _props$params.tournamentId;
	
	
	            var hasLinuep = _lodash2.default.get(event, 'properties.hasLineup', false);
	
	            var hasLinuepConfirmed = _lodash2.default.get(event, 'properties.lineupConfirmed') === 'yes';
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                hasLinuep && _react2.default.createElement(_SMStream2.default, {
	                    key: 'inf_' + eventId,
	                    smWidgets: widgets.map(function (name) {
	                        return {
	                            name: name,
	                            props: { eventId: eventId, team: 'home', teamId: event.homeId }
	                        };
	                    }),
	                    title: 'HOME'
	                }),
	                hasLinuep && _react2.default.createElement(_SMStream2.default, {
	                    key: 'inf_away_' + eventId,
	                    smWidgets: widgets.map(function (name) {
	                        return {
	                            name: name,
	                            props: { eventId: eventId, team: 'away', teamId: event.awayId }
	                        };
	                    }),
	                    title: 'AWAY'
	                }),
	                !hasLinuep && this.renderLineupNotAwailableYet(),
	                _react2.default.createElement(_SMStream2.default, {
	                    key: 'inf_squad_' + eventId,
	                    smWidgets: [event.homeId, event.awayId].map(function (teamId) {
	                        return {
	                            name: 'TeamSquadListSMWidget',
	                            groupTitle: '',
	                            groupKey: teamId + '-1',
	                            props: { teamId: teamId }
	                        };
	                    }),
	                    title: 'Team Squads'
	                })
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { event: state.smBrowser.event };
	})(EventSMB);

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    a {\n        margin: 5px 10px;\n        padding: 0px 10px;\n        line-height: 32px;\n        display: inline-block;\n    }\n    a.active {\n        background: #3f51b5;\n        color: #fff;\n\n        border-radius: 16px;\n    }\n'], ['\n    a {\n        margin: 5px 10px;\n        padding: 0px 10px;\n        line-height: 32px;\n        display: inline-block;\n    }\n    a.active {\n        background: #3f51b5;\n        color: #fff;\n\n        border-radius: 16px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1590);
	
	var _EventCell = __webpack_require__(1692);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var eventLink = function eventLink(e, action) {
	    return '/sm/browser/football/tournaments/' + e.tournamentTemplateId + '/' + e.tournamentId + '/stages/' + e.tournamentStageId + '/rounds/' + encodeURIComponent(e.properties.round) + '/events/' + e.eventId + '/' + action;
	};
	
	var EventHeaderEnhanced = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event
	    };
	})(_EventCell.EventHeader);
	
	var Enav = _styledComponents2.default.p(_templateObject);
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                eventId = _this$props.params.eventId,
	                dispatch = _this$props.dispatch,
	                loadEvent = _this$props.loadEvent;
	
	
	            dispatch(loadEvent(eventId));
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var _this$props2 = _this.props,
	                eventId = _this$props2.params.eventId,
	                dispatch = _this$props2.dispatch,
	                loadEvent = _this$props2.loadEvent;
	
	
	            if (+eventId !== +nextProps.params.eventId) {
	                dispatch(loadEvent(+nextProps.params.eventId));
	            }
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                event = _props.event,
	                router = _props.router;
	
	
	            if (!event) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(EventHeaderEnhanced, null),
	                _react2.default.createElement(
	                    Enav,
	                    { style: { textAlign: 'center' } },
	                    _lodash2.default.toPairs({
	                        home: 'Home',
	                        lineup: 'Lineups',
	                        incidents: 'Incidents',
	                        bookie: 'Bookie',
	                        stats: 'Team stats',
	                        'best-players': 'Player performance'
	                    }).map(function (_ref) {
	                        var _ref2 = _slicedToArray(_ref, 2),
	                            url = _ref2[0],
	                            label = _ref2[1];
	
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            {
	                                key: label,
	                                className: router.isActive(eventLink(event, url)) && 'active',
	                                to: eventLink(event, url)
	                            },
	                            label
	                        );
	                    })
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        loadEvent: _actions.loadEvent
	    };
	})((0, _reactRouter.withRouter)(EventSMB));

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EventHeader = exports.FakeCell = exports.Match = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding: 15px 10px;\n    position: relative;\n    color: #222;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 50px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .rnd {\n        position: absolute;\n        top: 5px;\n        left: 5px;\n        font-size: 12px;\n    }\n'], ['\n    padding: 15px 10px;\n    position: relative;\n    color: #222;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 50px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .rnd {\n        position: absolute;\n        top: 5px;\n        left: 5px;\n        font-size: 12px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    width: 280px;\n    height: 120px;\n    margin: 1px;\n    background: ', ';\n    &:hover {\n        background: rgba(0, 0, 0, 0.1);\n        cursor: pointer;\n    }\n'], ['\n    width: 280px;\n    height: 120px;\n    margin: 1px;\n    background: ', ';\n    &:hover {\n        background: rgba(0, 0, 0, 0.1);\n        cursor: pointer;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    .name {\n        padding: 0 10px;\n        font-size: 36px;\n    }\n    .side {\n        width: calc(50% - 45px);\n    }\n    .score {\n        width: 90px;\n        text-align: center;\n        display: inline-block;\n        font-size: 32px;\n    }\n'], ['\n    .name {\n        padding: 0 10px;\n        font-size: 36px;\n    }\n    .side {\n        width: calc(50% - 45px);\n    }\n    .score {\n        width: 90px;\n        text-align: center;\n        display: inline-block;\n        font-size: 32px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMTeamLogo = __webpack_require__(1394);
	
	var _SMTeamLogo2 = _interopRequireDefault(_SMTeamLogo);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Cell = _styledComponents2.default.div(_templateObject);
	
	var CellSmall = Cell.extend(_templateObject2, function (props) {
	    return props.active ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.05)';
	});
	var CellBig = Cell.extend(_templateObject3);
	var Match = exports.Match = function Match(_ref) {
	    var startDate = _ref.startDate,
	        homeShortName = _ref.homeShortName,
	        awayShortName = _ref.awayShortName,
	        homeId = _ref.homeId,
	        awayId = _ref.awayId,
	        tournamentId = _ref.tournamentId,
	        score = _ref.score,
	        statusType = _ref.statusType,
	        properties = _ref.properties,
	        onClick = _ref.onClick,
	        active = _ref.active;
	    return _react2.default.createElement(
	        CellSmall,
	        { onClick: onClick, active: active },
	        statusType === 'notstarted' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            (0, _moment2.default)(startDate).format('HH:mm')
	        ),
	        statusType === 'finished' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            'FT'
	        ),
	        statusType === 'inprogress' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            'LIVE'
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'rnd' },
	            !_lodash2.default.isNaN(+properties.round) ? 'R' + properties.round : properties.round
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    display: 'flex',
	                    alignItems: 'center',
	                    justifyContent: 'center'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'flex-end' } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    homeShortName
	                ),
	                _react2.default.createElement(_SMTeamLogo2.default, { teamId: homeId, width: 40 })
	            ),
	            statusType === 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                '-:-'
	            ),
	            statusType !== 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                score.home,
	                ':',
	                score.away
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'start' } },
	                _react2.default.createElement(_SMTeamLogo2.default, { teamId: awayId, width: 40 }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    awayShortName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'info', style: { fontSize: 11, textAlign: 'center' } },
	            (0, _moment2.default)(startDate).format('D MMM')
	        )
	    );
	};
	
	var FakeCell = exports.FakeCell = function FakeCell(_ref2) {
	    var text = _ref2.text,
	        onClick = _ref2.onClick;
	    return _react2.default.createElement(
	        CellSmall,
	        { onClick: onClick },
	        text
	    );
	};
	
	var EventHeader = exports.EventHeader = function EventHeader(_ref3) {
	    var event = _ref3.event,
	        active = _ref3.active,
	        onClick = _ref3.onClick;
	    var startDate = event.startDate,
	        homeName = event.homeName,
	        awayName = event.awayName,
	        homeId = event.homeId,
	        awayId = event.awayId,
	        score = event.score,
	        statusType = event.statusType,
	        properties = event.properties;
	
	    return _react2.default.createElement(
	        CellBig,
	        { onClick: onClick, active: active },
	        statusType === 'notstarted' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            (0, _moment2.default)(startDate).format('HH:mm')
	        ),
	        statusType === 'finished' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            'FT'
	        ),
	        statusType === 'inprogress' && _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            'LIVE'
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'rnd' },
	            !_lodash2.default.isNaN(+properties.round) ? 'R' + properties.round : properties.round
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    display: 'flex',
	                    alignItems: 'center',
	                    justifyContent: 'center'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'flex-end' } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    homeName
	                ),
	                _react2.default.createElement(_SMTeamLogo2.default, { teamId: homeId, width: 60 })
	            ),
	            statusType === 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                '-:-'
	            ),
	            statusType !== 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                score.home,
	                ':',
	                score.away
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'start' } },
	                _react2.default.createElement(_SMTeamLogo2.default, { teamId: awayId, width: 60 }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    awayName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'info', style: { fontSize: 11, textAlign: 'center' } },
	            (0, _moment2.default)(startDate).format('D MMM')
	        )
	    );
	};
	
	exports.default = Match;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(1590);
	
	var _recompose = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var oddsWidgets = function oddsWidgets(event, oddsProvider) {
	    var eventId = event.eventId;
	
	
	    var props = { eventId: eventId, oddsProvider: oddsProvider };
	
	    return [{
	        groupTitle: '3way odds',
	        name: 'MatchOddsSMWidget',
	        groupKey: 'match-' + eventId,
	        props: _extends({}, props, {
	            oddsType: 'match'
	        })
	    }, {
	        groupTitle: 'Next Goal',
	        name: 'MatchOddsSMWidget',
	        groupKey: 'nextGoal-' + eventId,
	        props: _extends({}, props, {
	            oddsType: 'nextGoal'
	        })
	    }, {
	        groupTitle: 'Both Team To Score',
	        name: 'MatchOddsSMWidget',
	        groupKey: 'btts-' + eventId,
	        props: _extends({}, props, {
	            oddsType: 'btts'
	        })
	    }].concat(_toConsumableArray(_lodash2.default.range(6).map(function (i) {
	        return 'goals|' + (i + 0.5);
	    }).map(function (type) {
	        return {
	            groupTitle: 'OverUnder',
	            name: 'MatchOddsSMWidget',
	            groupKey: 'ou-' + eventId,
	            props: _extends({}, props, {
	                oddsType: type
	            })
	        };
	    })));
	};
	
	var oddsBoostersWidgets = function oddsBoostersWidgets(event, oddsProvider) {
	    var eventId = event.eventId;
	
	
	    return [{
	        groupTitle: 'Match Odds Booster V1',
	        name: 'MatchOddsBoosterSMWidget',
	        groupKey: '1way-' + eventId,
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X',
	            oddsDrawNew: 'Y',
	            oddsDrawOld: 'X',
	            oddsAwayNew: 'Y',
	            oddsAwayOld: 'Y',
	            layoutType: '3way_odds'
	        },
	        key: 'match-' + eventId
	    }, {
	        groupTitle: 'Match Odds Booster V2',
	        groupKey: '3way_odds_no_old-' + eventId,
	        name: 'MatchOddsBoosterSMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X',
	
	            oddsAwayNew: 'Y',
	            oddsAwayOld: 'Y',
	            layoutType: '3way_odds_no_old'
	        }
	    }, {
	        groupTitle: '2 way odds booster',
	        groupKey: '3way-' + eventId,
	        name: 'MatchOddsBoosterV2SMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X',
	
	            oddsAwayNew: 'Y',
	            oddsAwayOld: 'Y',
	            layoutType: '2way_odds',
	            showMatchInfo: true
	        }
	    }];
	};
	var singleOddsBoostersWidgets = function singleOddsBoostersWidgets(event, oddsProvider) {
	    var eventId = event.eventId;
	
	    return [{
	        groupTitle: 'Single Outcome Booster',
	        name: 'SingleOddBoosterMatchSMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X',
	            layoutType: 'textual_odds'
	        },
	        key: 'ob-circle-odds-' + eventId
	    }, {
	        groupTitle: 'Single Outcome Booster',
	        groupKey: 'CircleOdds-2',
	        name: 'SingleOddBoosterMatchSMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X',
	            layoutType: 'circle_odds'
	        },
	        key: 'ob-circle-odds-' + eventId
	    }, {
	        groupTitle: 'Single Outcome Booster V2',
	        groupKey: 'SingleBoosterV2',
	        name: 'SingleOddBoosterMatchV3',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X'
	        },
	        key: 'ob-single-booster-v2-' + eventId
	    }, {
	        groupTitle: 'Single Outcome Booster V3',
	        groupKey: 'SingleBoosterV3',
	        name: 'SingleOddBoosterMatchV3SMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'Y',
	            oddsHomeOld: 'X'
	        },
	        key: 'ob-single-booster-v3-' + eventId
	    }];
	};
	var freeBetWidgets = function freeBetWidgets(event, oddsProvider) {
	    var eventId = event.eventId;
	
	    return [{
	        groupTitle: 'FreeBet V1',
	        groupKey: 'Freebet-1',
	        name: 'FreeBetMatchSMWidget',
	        props: {
	            eventId: eventId,
	            oddsHomeNew: 'X',
	            oddsDrawNew: 'Y',
	            oddsAwayNew: 'Z',
	            showFullTeamName: true,
	            layoutType: '3way_odds'
	        },
	        key: 'ob-freebet-v1-' + eventId
	    }, {
	        groupTitle: 'FreeBet V2',
	        groupKey: 'Freebet-2',
	        name: 'FreeBetMatchSMWidget',
	        props: {
	            eventId: eventId,
	            layoutType: 'no_odds'
	        },
	        key: 'ob-freebet-v2-' + eventId
	    }];
	};
	
	var OddsStreamEnhanced = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event,
	        user: state.user,
	        smWidgets: state.smBrowser.eventsOdds && state.smBrowser.eventsOdds.length > 0 ? oddsWidgets(state.smBrowser.event, _lodash2.default.get(state, 'user.props.oddsProvider')) : []
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        loadOdds: _actions.loadOdds
	    };
	})((0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var _props = this.props,
	            loadOdds = _props.loadOdds,
	            dispatch = _props.dispatch,
	            user = _props.user,
	            event = _props.event;
	
	        dispatch(loadOdds(event.eventId, user.props.oddsProvider));
	    }
	})(_SMStream2.default));
	
	var EventSMB = function (_React$Component) {
	    _inherits(EventSMB, _React$Component);
	
	    function EventSMB(props, context) {
	        _classCallCheck(this, EventSMB);
	
	        var _this = _possibleConstructorReturn(this, (EventSMB.__proto__ || Object.getPrototypeOf(EventSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.state = {};
	
	        _this.renderOddsStream = function () {
	            var _this$props = _this.props,
	                user = _this$props.user,
	                eventId = _this$props.params.eventId,
	                event = _this$props.event;
	
	            var oddsProvider = user.props.oddsProvider;
	
	            if (!oddsProvider) return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Odds provider is not defined for'
	                )
	            );
	
	            return _react2.default.createElement(OddsStreamEnhanced, { title: 'Odds' });
	        };
	
	        return _this;
	    }
	
	    _createClass(EventSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                user = _props2.user,
	                eventId = _props2.params.eventId,
	                event = _props2.event;
	
	
	            var oddsProvider = user.props.oddsProvider;
	
	            event = (0, _Eventify2.default)(event);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'event page'
	                ),
	                this.renderOddsStream(),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: oddsBoostersWidgets(event), title: '3way odds booster' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: singleOddsBoostersWidgets(event), title: 'Single odds booster' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: freeBetWidgets(event), title: 'FreeBet promotions' })
	            );
	        }
	    }]);
	
	    return EventSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        event: state.smBrowser.event,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch
	    };
	})(EventSMB);

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _events = __webpack_require__(1058);
	
	var _Eventify = __webpack_require__(1354);
	
	var _Eventify2 = _interopRequireDefault(_Eventify);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var eventsPreview = function eventsPreview(tournament, events) {
	    var widgets = [].concat(_toConsumableArray(_lodash2.default.filter(events, function (e) {
	        return (0, _Eventify2.default)(e).isFT();
	    }).map(function (_ref) {
	        var eventId = _ref.eventId;
	        return {
	            groupTitle: 'Finished matches',
	            groupKey: '' + eventId,
	            name: 'MatchFinished',
	            props: {
	                eventId: eventId
	            },
	            key: 'mp-' + eventId
	        };
	    })), _toConsumableArray(_lodash2.default.filter(events, function (e) {
	        return (0, _Eventify2.default)(e).isComing() || (0, _Eventify2.default)(e).isLive();
	    }).map(function (_ref2) {
	        var eventId = _ref2.eventId;
	        return {
	            name: 'PreMatchStatsSMWidget',
	            groupTitle: 'Upcoming matches H2H',
	            groupKey: '' + eventId,
	
	            props: {
	                eventId: eventId
	            },
	            key: 'h2h-' + eventId
	        };
	    })));
	
	    return widgets;
	};
	
	var roundWidgets = function roundWidgets(tournament, season, stage, round, events) {
	    return [{
	        name: 'RoundMatchesSMWidget',
	        groupTitle: 'Round ' + round,
	
	        props: {
	            tournamentId: tournament.id,
	            stageId: stage.id,
	            round: round
	        }
	    }, {
	        name: 'RoundMatchesSMWidget',
	        groupTitle: 'Round ' + round + ' grouped by day',
	        groupKey: 'Round ' + round + '-grounped',
	        props: {
	            tournamentId: tournament.id,
	            stageId: stage.id,
	            round: round,
	            groupByDay: true
	        }
	    }].concat(_toConsumableArray(_lodash2.default.chain(events).groupBy(function (e) {
	        return (0, _moment2.default)(e.startDate).format('YYYY-MM-DD');
	    }).keys().map(function (date) {
	        return {
	            name: 'TodayMatchesSMWidget',
	            groupTitle: 'Matchday ' + (0, _moment2.default)(date).format('D MMM'),
	            groupKey: '' + (date + '_' + tournament.id),
	            props: {
	                tournamentId: tournament.id,
	                stageId: stage.id,
	                date: date
	            },
	            key: '' + (date + '_' + tournament.id)
	        };
	    }).value()));
	};
	
	var StageRoundSMB = function (_React$Component) {
	    _inherits(StageRoundSMB, _React$Component);
	
	    function StageRoundSMB(props, context) {
	        _classCallCheck(this, StageRoundSMB);
	
	        var _this = _possibleConstructorReturn(this, (StageRoundSMB.__proto__ || Object.getPrototypeOf(StageRoundSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.componentWillReceiveProps = function (nextProps) {};
	
	        return _this;
	    }
	
	    _createClass(StageRoundSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                tournament = _props.tournament,
	                season = _props.season,
	                stage = _props.stage,
	                events = _props.events,
	                round = _props.params.round;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMStream2.default, { smWidgets: roundWidgets(tournament, season, stage, round, events), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: eventsPreview(tournament, events), title: 'Round events' })
	            );
	        }
	    }]);
	
	    return StageRoundSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var _props$params = props.params,
	        stageId = _props$params.stageId,
	        round = _props$params.round;
	
	    var ids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchRoundEventsForStageKey)(stageId, round) + ']', []);
	    var events = _lodash2.default.get(state, 'query.entities.events', []);
	    return {
	        tournament: _lodash2.default.get(state.smBrowser, 'tournament'),
	        stages: _lodash2.default.get(state.smBrowser, 'season.stages', []),
	        events: ids.map(function (id) {
	            return events[id];
	        }),
	        stage: _lodash2.default.chain(state.smBrowser).get('season.stages', []).find(function (s) {
	            return +s.id === +props.params.stageId;
	        }).value()
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch
	    };
	})(StageRoundSMB);

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _events = __webpack_require__(1058);
	
	var _EventsList = __webpack_require__(1696);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var matchesList = function matchesList(tournament, events) {
	    var daysToTake = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
	
	    return tournament && _lodash2.default.chain(events).groupBy(function (e) {
	        return (0, _moment2.default)(e.startDate).format('YYYY-MM-DD');
	    }).keys().take(daysToTake).map(function (date) {
	        return {
	            name: 'TodayMatchesSMWidget',
	            groupTitle: 'Matchday ' + (0, _moment2.default)(date).format('D MMM'),
	            groupKey: '' + (date + '_' + tournament.id),
	            props: {
	                tournamentId: tournament.id,
	                date: date
	            },
	            key: '' + (date + '_' + tournament.id)
	        };
	    }).value();
	};
	
	var playoffWCStage = function playoffWCStage(tournament, season) {
	    return [{
	        name: 'PlayoffGridSMWidget',
	        groupKey: 'playoff',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageIds: JSON.stringify(_lodash2.default.filter(season.stages, function (s) {
	                return s.isCup;
	            }).map(function (s) {
	                return s.id;
	            }))
	        },
	        key: 'tt-' + season.id + '-playoff'
	    }, {
	        name: 'TournamentPlayOffSMWidget',
	        props: {
	            tournamentId: tournament.id,
	            stageIds: JSON.stringify(_lodash2.default.filter(season.stages, function (s) {
	                return s.isCup;
	            }).map(function (s) {
	                return s.id;
	            }))
	        }
	    }];
	};
	
	var playoffCLStage = function playoffCLStage(tournament, season) {
	    var qual = season.stages[0];
	    return [qual && {
	        name: 'PlayoffGridSMWidget',
	        groupKey: 'playoff',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageIds: JSON.stringify([qual.id])
	        },
	        key: 'tt-' + season.id + '-qual'
	    }, {
	        name: 'PlayoffGridSMWidget',
	        groupKey: 'playoff-2',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageIds: JSON.stringify(_lodash2.default.filter(season.stages, function (s) {
	                return s.isCup && s.id !== qual.id;
	            }).map(function (s) {
	                return s.id;
	            }))
	        },
	        key: 'tt-' + season.id + '-playoff'
	    }];
	};
	
	var generalTournamentWidget = function generalTournamentWidget(tournament, season) {
	    var withAnimated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var withSVG = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var widgets = tournament && season && [].concat(_toConsumableArray(_lodash2.default.filter(season.stages, function (s) {
	        return !s.isCup;
	    }).map(function (stage) {
	        return {
	            name: 'TournamentTableSMWidget',
	            groupKey: '' + stage.enetPulseName,
	            props: {
	                tournamentId: tournament.id,
	                seasonId: season.id,
	                stageId: stage.id,
	                full: true
	            },
	            key: 'tt-' + season.id + '-' + stage.id
	        };
	    })));
	
	    if (withAnimated) {
	        widgets = widgets.concat(_lodash2.default.filter(season.stages, function (s) {
	            return !s.isCup;
	        }).map(function (stage) {
	            return {
	                name: 'LeagueTrackerSMWidget',
	                groupKey: stage.enetPulseName + ' League Tracker',
	                props: {
	                    tournamentId: tournament.id,
	                    seasonId: season.id,
	                    stageId: stage.id,
	                    lineSmoothing: true
	                },
	                key: 'lt-' + season.id + '-' + stage.id
	            };
	        }));
	    }
	
	    if (withSVG) {
	        widgets = widgets.concat(_lodash2.default.filter(season.stages, function (s) {
	            return !s.isCup;
	        }).map(function (stage) {
	            return {
	                name: 'AnimatedTournamentTable',
	                groupKey: stage.enetPulseName + ' Animated ',
	                props: {
	                    tournamentId: tournament.id,
	                    seasonId: season.id,
	                    stageId: stage.id,
	                    full: true
	                },
	                key: 'tt-a-' + season.id + '-' + stage.id
	            };
	        }));
	    }
	
	    return widgets;
	};
	
	var basicTopList = function basicTopList(tournament, season) {
	    return tournament && [{
	        name: 'TopListSMWidget',
	        groupTitle: 'Top goalscorers',
	        groupKey: 'Top goalscorers',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            sortBy: 'stats.goals'
	        },
	        key: 'tl-' + season.id + '-' + tournament.id
	    }, {
	        name: 'TopListSMWidget',
	        groupTitle: 'Top assisters',
	        groupKey: 'Top assisters',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            sortBy: 'stats.assists'
	        },
	        key: 'ta-' + season.id + '-' + tournament.id
	    }, {
	        name: 'TopListSMWidget',
	        groupTitle: 'Most cleansheets',
	        groupKey: 'Most cleansheets',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            sortBy: 'stats.cleansheets'
	        },
	        key: 'tc-' + season.id + '-' + tournament.id
	    }];
	};
	
	var TournamentHomeSMB = function (_React$Component) {
	    _inherits(TournamentHomeSMB, _React$Component);
	
	    function TournamentHomeSMB() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TournamentHomeSMB);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TournamentHomeSMB.__proto__ || Object.getPrototypeOf(TournamentHomeSMB)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                fetchEvents = _this$props.fetchEvents,
	                _this$props$params = _this$props.params,
	                tournamentId = _this$props$params.tournamentId,
	                seasonId = _this$props$params.seasonId,
	                season = _this$props.season;
	
	
	            dispatch(fetchEvents({
	                ttId: tournamentId,
	                seasonId: seasonId,
	                status: 'notstarted',
	                fromDate: (0, _moment2.default)().startOf('day').format('YYYY-MM-DD')
	            }));
	
	            if (~~seasonId !== season.id) {
	                window.history.pushState('', '', '' + season.id);
	            }
	        }, _this.componentWillReceiveProps = function (nextProps) {
	            var dispatch = nextProps.dispatch,
	                fetchEvents = nextProps.fetchEvents,
	                _nextProps$params = nextProps.params,
	                tournamentId = _nextProps$params.tournamentId,
	                seasonId = _nextProps$params.seasonId;
	
	
	            if (+_this.props.params.tournamentId !== +tournamentId || _this.props.params.seasonId !== seasonId) {
	                dispatch(fetchEvents({
	                    ttId: tournamentId,
	                    seasonId: seasonId,
	                    status: 'notstarted',
	                    fromDate: (0, _moment2.default)().startOf('day').format('YYYY-MM-DD')
	                }));
	            }
	        }, _this.renderCup = function () {
	            var _this$props2 = _this.props,
	                events = _this$props2.events,
	                tournament = _this$props2.tournament,
	                season = _this$props2.season;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: basicTopList(tournament, season, events), title: 'Top Lists' })
	            );
	        }, _this.renderLeague = function () {
	            var _this$props3 = _this.props,
	                events = _this$props3.events,
	                tournament = _this$props3.tournament,
	                season = _this$props3.season,
	                teams = _this$props3.teams;
	
	            var matceshInRound = teams.length / 2;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, limit: matceshInRound }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events, 3), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: generalTournamentWidget(tournament, season, true, true), title: 'Standings' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: basicTopList(tournament, season, events), title: 'Top Lists' })
	            );
	        }, _this.renderWC = function () {
	            var _this$props4 = _this.props,
	                events = _this$props4.events,
	                tournament = _this$props4.tournament,
	                season = _this$props4.season,
	                teams = _this$props4.teams;
	
	            var matceshInRound = teams.length / 2;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, limit: matceshInRound }),
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: [{
	                        name: 'WorldRankingSMWidget',
	                        props: {
	                            tournamentId: tournament.id
	                        }
	                    }, {
	                        name: 'TournamentPlayOffSMWidget',
	                        props: {
	                            tournamentId: tournament.id,
	                            stageIds: JSON.stringify(_lodash2.default.filter(season.stages, function (s) {
	                                return s.isCup;
	                            }).map(function (s) {
	                                return s.id;
	                            }))
	                        }
	                    }, {
	                        name: 'TournamentPlayOffSMWidget',
	                        groupKey: 'last year',
	                        groupTitle: 'Last Year winner',
	                        props: {
	                            tournamentId: 77,
	                            stageIds: JSON.stringify([831483, 831480, 831482, 831481, 831479])
	                        }
	                    }],
	                    title: 'Facts'
	                }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events, 3), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: generalTournamentWidget(tournament, season, true), title: 'Standings' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: playoffWCStage(tournament, season), title: 'Playoff' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: basicTopList(tournament, season, events), title: 'Top Lists' })
	            );
	        }, _this.renderCL = function () {
	            var _this$props5 = _this.props,
	                events = _this$props5.events,
	                tournament = _this$props5.tournament,
	                season = _this$props5.season,
	                stages = _this$props5.stages,
	                teams = _this$props5.teams;
	
	            var matceshInRound = teams.length / 2;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, limit: matceshInRound }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events, 3), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: generalTournamentWidget(tournament, season), title: 'Standings' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: playoffCLStage(tournament, season, stages), title: 'Playoff' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: basicTopList(tournament, season, events), title: 'Top Lists' })
	            );
	        }, _this.renderFriendlies = function () {
	            var _this$props6 = _this.props,
	                events = _this$props6.events,
	                tournament = _this$props6.tournament,
	                teams = _this$props6.teams;
	
	            var matceshInRound = teams.length / 2;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, limit: matceshInRound }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events, 3), title: 'Matchdays' })
	            );
	        }, _this.renderMixed = function () {
	            var _this$props7 = _this.props,
	                events = _this$props7.events,
	                tournament = _this$props7.tournament,
	                season = _this$props7.season,
	                teams = _this$props7.teams;
	
	            var matceshInRound = teams.length / 2;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, limit: matceshInRound }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: matchesList(tournament, events, 3), title: 'Matchdays' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: generalTournamentWidget(tournament, season, true, true), title: 'Standings' }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: basicTopList(tournament, season, events), title: 'Top Lists' })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TournamentHomeSMB, [{
	        key: 'render',
	        value: function render() {
	            var tournament = this.props.tournament;
	
	
	            if (!tournament) return _react2.default.createElement('div', null);
	
	            // special cases
	            if ([77, 50].indexOf(tournament.id) !== -1) return this.renderWC();
	            if ([42, 73].indexOf(tournament.id) !== -1) return this.renderCL();
	            if ([114, 134].indexOf(tournament.id) !== -1) return this.renderFriendlies();
	
	            switch (tournament.type) {
	                case 'league':
	                    return this.renderLeague();
	                case 'cup':
	                    return this.renderCup();
	                case 'mixed':
	                    return this.renderMixed();
	                default:
	                    return this.renderLeague();
	            }
	        }
	    }]);
	
	    return TournamentHomeSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var _props$params = props.params,
	        tournamentId = _props$params.tournamentId,
	        seasonId = _props$params.seasonId;
	
	    var ids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchEventsKey)({
	        ttId: tournamentId,
	        seasonId: seasonId,
	        status: 'notstarted',
	        fromDate: (0, _moment2.default)().startOf('day').format('YYYY-MM-DD')
	    }) + ']', []);
	    var events = _lodash2.default.get(state, 'query.entities.events', []);
	
	    return {
	        events: ids.map(function (id) {
	            return events[id];
	        }),
	        tournament: _lodash2.default.get(state.smBrowser, 'tournament'),
	        season: _lodash2.default.get(state.smBrowser, 'season', {}),
	        teams: _lodash2.default.get(state.smBrowser, 'teams')
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        fetchEvents: _events.fetchEvents
	    };
	})(TournamentHomeSMB);

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EventsList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventCell = __webpack_require__(1692);
	
	var _reactRouter = __webpack_require__(188);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventsList = exports.EventsList = function (_React$Component) {
	    _inherits(EventsList, _React$Component);
	
	    function EventsList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EventsList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventsList.__proto__ || Object.getPrototypeOf(EventsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = { expanded: false }, _this.render = function () {
	            var expanded = _this.state.expanded;
	            var _this$props = _this.props,
	                _this$props$events = _this$props.events,
	                events = _this$props$events === undefined ? [] : _this$props$events,
	                limit = _this$props.limit,
	                title = _this$props.title,
	                eventId = _this$props.eventId;
	
	            if (events.length === 0) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                null,
	                title && _react2.default.createElement(
	                    'p',
	                    null,
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexWrap: 'wrap', margin: '15 0' } },
	                    _lodash2.default.take(events, expanded ? events.length : limit).map(function (e) {
	                        return _react2.default.createElement(_EventCell.Match, _extends({
	                            active: +eventId === +e.eventId,
	                            style: { width: 280 },
	                            onClick: function onClick(ev) {
	                                return _reactRouter.browserHistory.push('/sm/browser/' + e.sport + '/tournaments/' + e.tournamentTemplateId + '/' + e.tournamentId + '/stages/' + e.tournamentStageId + '/rounds/' + encodeURIComponent(e.properties.round) + '/events/' + e.eventId);
	                            },
	                            key: e.eventId
	                        }, e));
	                    }),
	                    events.length > limit && !expanded && _react2.default.createElement(_EventCell.FakeCell, {
	                        text: 'See all (' + events.length + ')',
	                        onClick: function onClick(e) {
	                            return _this.setState({ expanded: true });
	                        }
	                    })
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return EventsList;
	}(_react2.default.Component);
	
	EventsList.defaultProps = {
	    limit: 10
	};
	exports.default = EventsList;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TournamentAnnouncesSMStream = __webpack_require__(1698);
	
	var _TournamentAnnouncesSMStream2 = _interopRequireDefault(_TournamentAnnouncesSMStream);
	
	var _TournamentBasicSMStream = __webpack_require__(1700);
	
	var _TournamentBasicSMStream2 = _interopRequireDefault(_TournamentBasicSMStream);
	
	var _reactRouter = __webpack_require__(188);
	
	var _events = __webpack_require__(1058);
	
	var _EventsList = __webpack_require__(1696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageRoundSMB = function (_React$Component) {
	    _inherits(StageRoundSMB, _React$Component);
	
	    function StageRoundSMB(props, context) {
	        _classCallCheck(this, StageRoundSMB);
	
	        var _this = _possibleConstructorReturn(this, (StageRoundSMB.__proto__ || Object.getPrototypeOf(StageRoundSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                fetchRoundEventsForStage = _this$props.fetchRoundEventsForStage,
	                _this$props$params = _this$props.params,
	                round = _this$props$params.round,
	                stageId = _this$props$params.stageId;
	
	
	            dispatch(fetchRoundEventsForStage(stageId, round));
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                fetchLatestEventsForStage = _this$props2.fetchLatestEventsForStage,
	                params = _this$props2.params;
	
	
	            if (+_this.props.params.stageId !== +nextProps.params.stageId || _this.props.params.round + '' !== nextProps.params.round + '') {
	                dispatch((0, _events.fetchRoundEventsForStage)(+nextProps.params.stageId, nextProps.params.round));
	            }
	        };
	
	        return _this;
	    }
	
	    _createClass(StageRoundSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$params = _props.params,
	                tournamentId = _props$params.tournamentId,
	                seasonId = _props$params.seasonId,
	                sport = _props$params.sport,
	                round = _props$params.round,
	                eventId = _props$params.eventId,
	                tournament = _props.tournament,
	                stage = _props.stage,
	                _props$events = _props.events,
	                events = _props$events === undefined ? [] : _props$events;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_EventsList.EventsList, { events: events, eventId: eventId })
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return StageRoundSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var _props$params2 = props.params,
	        stageId = _props$params2.stageId,
	        round = _props$params2.round;
	
	    var ids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchRoundEventsForStageKey)(stageId, round) + ']', []);
	
	    var events = _lodash2.default.get(state, 'query.entities.events', []);
	
	    return {
	        events: ids.map(function (id) {
	            return events[id];
	        }),
	        tournament: _lodash2.default.get(state.smBrowser, 'tournament'),
	        stages: _lodash2.default.get(state.smBrowser, 'season.stages', []),
	        stage: _lodash2.default.chain(state.smBrowser).get('season.stages', []).find(function (s) {
	            return +s.id === +props.params.stageId;
	        }).value()
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        fetchRoundEventsForStage: _events.fetchRoundEventsForStage
	    };
	})(StageRoundSMB);

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMStream2 = __webpack_require__(1699);
	
	var _SMStream3 = _interopRequireDefault(_SMStream2);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentAnnouncesSMStream = function (_SMStream) {
	    _inherits(TournamentAnnouncesSMStream, _SMStream);
	
	    function TournamentAnnouncesSMStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TournamentAnnouncesSMStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TournamentAnnouncesSMStream.__proto__ || Object.getPrototypeOf(TournamentAnnouncesSMStream)).call.apply(_ref, [this].concat(args))), _this), _this.loadSMWidgets = function (params) {
	            var tournamentId = params.tournamentId,
	                seasonId = params.seasonId,
	                round = params.round;
	            var tournament = params.tournament,
	                events = params.events;
	
	
	            var hasPro = _RCore2.default.isProStatsDataAvailable(tournamentId, seasonId);
	
	            return _RCore2.default.promiseProps({
	                events: events || fetch(_cfg2.default.apis.ss2 + '/events-v2/?ttId[]=' + tournamentId + '&seasonId=' + seasonId + '&fromDate=' + (0, _moment2.default)().add('days', -2).format('YYYY-MM-DD') + '&limit=12').then(function (response) {
	                    return response.json();
	                }).then(function (res) {
	                    return res.events;
	                }),
	                tournament: tournament || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                var tournament = result.tournament;
	
	                var round = parseInt(tournament.currentRound, 10);
	                var daysWithMatches = _lodash2.default.groupBy(result.events, function (m) {
	                    return (0, _moment2.default)(m.startDate).format('YYYY-MM-DD');
	                });
	
	                var finishedMatches = _lodash2.default.filter(result.events, function (e) {
	                    return e.statusType === 'finished';
	                });
	                var liveMatches = _lodash2.default.filter(result.events, function (e) {
	                    return e.statusType === 'inprogress';
	                });
	                var commingMatches = _lodash2.default.filter(result.events, function (e) {
	                    return e.statusType === 'notstarted';
	                });
	
	                var matchDays = Object.keys(daysWithMatches).map(function (date) {
	                    return {
	                        name: 'TodayMatchesSMWidget',
	                        groupTitle: 'Matches by date',
	                        groupDesc: 'Widgets that are representing bla-bla',
	                        props: {
	                            'data-tournament-id': tournamentId,
	                            date: date
	                        },
	                        key: '' + (date + '_' + tournamentId)
	                    };
	                });
	                return _lodash2.default.compact([].concat(_toConsumableArray(matchDays), [round > 1 && {
	                    name: 'RoundMatchesSMWidget',
	                    groupTitle: 'Matches by round',
	                    groupDesc: 'Browse nearest rounds',
	                    props: {
	                        'data-tournament-id': tournamentId,
	                        'data-round': round - 1,
	                        'data-group-by-day': !hasPro
	                    },
	                    key: 'round-1-' + tournamentId
	                }, {
	                    name: 'RoundMatchesSMWidget',
	                    groupTitle: 'Matches by round',
	                    groupDesc: 'Browse nearest rounds',
	                    props: {
	                        'data-tournament-id': tournamentId,
	                        'data-group-by-day': !hasPro
	                    },
	                    key: 'round-' + tournamentId
	                }, {
	                    name: 'RoundMatchesSMWidget',
	                    groupTitle: 'Matches by round',
	                    groupDesc: 'Browse nearest rounds',
	                    props: {
	                        'data-tournament-id': tournamentId,
	                        'data-round': round + 1,
	                        'data-group-by-day': !hasPro
	                    },
	                    key: 'round+1-' + tournamentId
	                }], _toConsumableArray(finishedMatches.map(function (e) {
	                    return hasPro && {
	                        name: 'ProLiveMatchStatsSMWidget',
	
	                        groupTitle: 'Finished matches stats',
	                        groupDesc: 'Latest matches',
	
	                        props: {
	                            'data-event-id': e.eventId
	                        },
	                        key: 'mp-' + e.eventId
	                    };
	                })), _toConsumableArray(finishedMatches.map(function (e) {
	                    return {
	                        groupTitle: 'Finished matches',
	                        groupDesc: 'Latest matches',
	
	                        name: 'MatchFinished',
	                        props: {
	                            'data-event-id': e.eventId
	                        },
	                        key: 'mp-' + e.eventId
	                    };
	                })), _toConsumableArray(finishedMatches.map(function (e) {
	                    return {
	                        groupTitle: 'MatchStats',
	                        groupDesc: 'Latest matches',
	
	                        name: 'MatchStats',
	                        props: {
	                            'data-event-id': e.eventId
	                        },
	                        key: 'ms-' + e.eventId
	                    };
	                })), _toConsumableArray(commingMatches.map(function (e) {
	                    return {
	                        name: 'PreMatchStatsSMWidget',
	                        groupTitle: 'Upcoming matches H2H',
	                        groupDesc: '...',
	
	                        props: {
	                            'data-event-id': e.eventId
	                        },
	                        key: 'h2h-' + e.eventId
	                    };
	                }))));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TournamentAnnouncesSMStream, [{
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            var _state$events = this.state.events,
	                events = _state$events === undefined ? [] : _state$events;
	
	            return [_react2.default.createElement(
	                'div',
	                { key: 'hotlinks' },
	                events.map(function (e) {
	                    return _react2.default.createElement(
	                        'a',
	                        { key: e.eventId },
	                        e.home,
	                        ' - ',
	                        e.away
	                    );
	                })
	            ), _react2.default.createElement(
	                'h1',
	                { key: 'title' },
	                'Tournament coming & latest matches'
	            )];
	        }
	    }]);
	
	    return TournamentAnnouncesSMStream;
	}(_SMStream3.default);
	
	exports.default = TournamentAnnouncesSMStream;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-bottom: 5px;\n'], ['\n    margin-bottom: 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    padding: 25px 0px;\n    margin-bottom: 25px;\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n    h1 {\n        margin: 0;\n        font-size: 36px;\n        line-height: 40px;\n        flex-grow: 1;\n\n        font-weight: 300;\n    }\n    &:after {\n        position: absolute;\n        content: \'\';\n        display: inline-block;\n        height: 2px;\n        width: 100px;\n        background: red;\n        bottom: 0px;\n    }\n'], ['\n    position: relative;\n    padding: 25px 0px;\n    margin-bottom: 25px;\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n    h1 {\n        margin: 0;\n        font-size: 36px;\n        line-height: 40px;\n        flex-grow: 1;\n\n        font-weight: 300;\n    }\n    &:after {\n        position: absolute;\n        content: \'\';\n        display: inline-block;\n        height: 2px;\n        width: 100px;\n        background: red;\n        bottom: 0px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    width: 480px;\n    display: grid;\n    position: relative;\n    grid-template-columns: 1fr;\n\n    & > * {\n        grid-column: 1 / 1;\n        grid-row: 1 / 1;\n    }\n\n    .main-frame {\n        z-index: 3;\n    }\n'], ['\n    width: 480px;\n    display: grid;\n    position: relative;\n    grid-template-columns: 1fr;\n\n    & > * {\n        grid-column: 1 / 1;\n        grid-row: 1 / 1;\n    }\n\n    .main-frame {\n        z-index: 3;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    margin: 0 -15px;\n    flex-wrap: wrap;\n    margin-bottom: 140px;\n\n    @media (max-width: 1156px) {\n        align-items: center;\n        justify-content: center;\n        margin: 0px;\n    }\n\n    .smi-widget {\n        width: 480px;\n        min-height: 1px !important;\n        overflow: hidden;\n        min-width: 1px !important;\n        pointer-events: none;\n    }\n\n    .item-single {\n        .header {\n            height: 40px;\n            position: relative;\n            color: #fff;\n            font-weight: 300;\n            label {\n                display: block;\n                line-height: 40px;\n                text-align: center;\n            }\n        }\n    }\n    .column {\n        margin: 0 15px;\n        .stack-item {\n            margin-bottom: 15px;\n            border-radius: 2px;\n        }\n    }\n    .top-overlay {\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n\n    .smi-widget-box {\n        position: relative;\n        text-align: center;\n        overflow: hidden;\n        .widget-cont {\n        }\n    }\n'], ['\n    display: flex;\n    margin: 0 -15px;\n    flex-wrap: wrap;\n    margin-bottom: 140px;\n\n    @media (max-width: 1156px) {\n        align-items: center;\n        justify-content: center;\n        margin: 0px;\n    }\n\n    .smi-widget {\n        width: 480px;\n        min-height: 1px !important;\n        overflow: hidden;\n        min-width: 1px !important;\n        pointer-events: none;\n    }\n\n    .item-single {\n        .header {\n            height: 40px;\n            position: relative;\n            color: #fff;\n            font-weight: 300;\n            label {\n                display: block;\n                line-height: 40px;\n                text-align: center;\n            }\n        }\n    }\n    .column {\n        margin: 0 15px;\n        .stack-item {\n            margin-bottom: 15px;\n            border-radius: 2px;\n        }\n    }\n    .top-overlay {\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n\n    .smi-widget-box {\n        position: relative;\n        text-align: center;\n        overflow: hidden;\n        .widget-cont {\n        }\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n    overflow: hidden;\n    &:hover {\n        transition: box-shadow 0.3s ease-in-out;\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n    }\n\n    &:hover:before {\n        content: \'\';\n        position: absolute;\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        background: #f2f2f2;\n        z-index: -1;\n        border-radius: 2px;\n    }\n    .share {\n        display: none;\n    }\n    &:hover {\n        position: relative;\n        .share {\n            display: block;\n        }\n        .smi-widget-box:after {\n            content: \'\';\n            position: absolute;\n            left: 0px;\n            right: 0px;\n            top: 0px;\n            bottom: 0px;\n            background: #000;\n            opacity: 0.2;\n            z-index: 1;\n            border-radius: 2px;\n        }\n    }\n\n    .widget-info {\n        background: #555;\n        position: relative;\n        display: flex;\n        align-items: center;\n        h3 {\n            font-weight: 300;\n            margin-bottom: 4px;\n            margin-top: 4px;\n            padding-left: 10px;\n            font-size: 22px;\n        }\n    }\n\n    .pagination {\n        text-align: center;\n\n        * {\n            vertical-align: middle;\n        }\n        .dots {\n            box-sizing: content-box;\n            padding: 12px;\n\n            display: inline-block;\n            line-height: 24px;\n        }\n        .dot {\n            display: inline-block;\n            vertical-align: middle;\n            width: 6px;\n            height: 6px;\n            margin: 0 2px;\n            border-radius: 50%;\n            opacity: 0.8;\n            background-color: #fff;\n            &.active {\n                opacity: 1;\n            }\n        }\n    }\n'], ['\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n    overflow: hidden;\n    &:hover {\n        transition: box-shadow 0.3s ease-in-out;\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n    }\n\n    &:hover:before {\n        content: \'\';\n        position: absolute;\n        left: -5px;\n        right: -5px;\n        top: -5px;\n        bottom: -5px;\n        background: #f2f2f2;\n        z-index: -1;\n        border-radius: 2px;\n    }\n    .share {\n        display: none;\n    }\n    &:hover {\n        position: relative;\n        .share {\n            display: block;\n        }\n        .smi-widget-box:after {\n            content: \'\';\n            position: absolute;\n            left: 0px;\n            right: 0px;\n            top: 0px;\n            bottom: 0px;\n            background: #000;\n            opacity: 0.2;\n            z-index: 1;\n            border-radius: 2px;\n        }\n    }\n\n    .widget-info {\n        background: #555;\n        position: relative;\n        display: flex;\n        align-items: center;\n        h3 {\n            font-weight: 300;\n            margin-bottom: 4px;\n            margin-top: 4px;\n            padding-left: 10px;\n            font-size: 22px;\n        }\n    }\n\n    .pagination {\n        text-align: center;\n\n        * {\n            vertical-align: middle;\n        }\n        .dots {\n            box-sizing: content-box;\n            padding: 12px;\n\n            display: inline-block;\n            line-height: 24px;\n        }\n        .dot {\n            display: inline-block;\n            vertical-align: middle;\n            width: 6px;\n            height: 6px;\n            margin: 0 2px;\n            border-radius: 50%;\n            opacity: 0.8;\n            background-color: #fff;\n            &.active {\n                opacity: 1;\n            }\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _keyboardArrowLeft = __webpack_require__(1593);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(1594);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactOnScreen = __webpack_require__(1673);
	
	var _reactOnScreen2 = _interopRequireDefault(_reactOnScreen);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SMStreamContainer = _styledComponents2.default.div(_templateObject);
	var SMHeader = _styledComponents2.default.div(_templateObject2);
	
	var Stack = _styledComponents2.default.div(_templateObject3);
	
	var Grid = _styledComponents2.default.div(_templateObject4);
	
	var StackViewContainer = _styledComponents2.default.div(_templateObject5);
	var C_DISPLAY_TYPE_KEY = 'C_DISPLAY_TYPE_KEY';
	
	var StackView = function (_React$Component) {
	    _inherits(StackView, _React$Component);
	
	    function StackView(props, context) {
	        _classCallCheck(this, StackView);
	
	        var _this = _possibleConstructorReturn(this, (StackView.__proto__ || Object.getPrototypeOf(StackView)).call(this, props, context));
	
	        _this.render = function () {
	            return _react2.default.createElement(
	                StackViewContainer,
	                null,
	                _this.props.children[_this.state.index],
	                _react2.default.createElement(
	                    'div',
	                    { className: 'widget-info', style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { flexGrow: 1, alignItems: 'center' } },
	                        _this.props.title
	                    ),
	                    _react2.default.createElement(
	                        rmd.IconButton,
	                        {
	                            disabled: _this.state.index === 0,
	                            onClick: function onClick(e) {
	                                return _this.setState({
	                                    index: (_this.state.index - 1) % _this.props.children.length
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_keyboardArrowLeft2.default, { color: '#fff' })
	                    ),
	                    _react2.default.createElement(
	                        rmd.IconButton,
	                        {
	                            disabled: _this.state.index === _this.props.children.length - 1,
	                            onClick: function onClick(e) {
	                                return _this.setState({
	                                    index: (_this.state.index + 1) % _this.props.children.length
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_keyboardArrowRight2.default, { color: '#fff' })
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            index: 0
	        };
	        return _this;
	    }
	
	    return StackView;
	}(_react2.default.Component);
	
	var StackOrder = function (_React$Component2) {
	    _inherits(StackOrder, _React$Component2);
	
	    function StackOrder() {
	        var _ref;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, StackOrder);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = StackOrder.__proto__ || Object.getPrototypeOf(StackOrder)).call.apply(_ref, [this].concat(args))), _this2), _this2.componentDidMount = function () {}, _this2.componentWillUnmount = function () {
	            if (_this2.timeout) clearTimeout(_this2.timeout);
	        }, _this2.state = {
	            load: 'none',
	            failed: false,
	            loadall: false
	        }, _this2.renderStub = function (previewUrl) {
	            return _react2.default.createElement(
	                Stack,
	                null,
	                _react2.default.createElement('img', {
	                    style: { width: 480, filter: 'blur(14px)' },
	                    src: previewUrl,
	                    onLoad: function onLoad() {
	                        _this2.setState({ hwidget: true });
	                    }
	                })
	            );
	        }, _this2.renderJSEmbed = function () {
	            if (!_this2.setState.mainLoaded) {
	                _this2.timeout = setTimeout(function () {
	                    _this2.setState({ mainLoaded: true });
	                }, 2000);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'main-frame' },
	                _this2.props.jsWidget
	            );
	        }, _this2.render = function () {
	            var _this2$props = _this2.props,
	                url = _this2$props.url,
	                preview = _this2$props.preview,
	                loadall = _this2$props.loadall,
	                name = _this2$props.name;
	            var _this2$state = _this2.state,
	                _this2$state$hwidget = _this2$state.hwidget,
	                hwidget = _this2$state$hwidget === undefined ? false : _this2$state$hwidget,
	                _this2$state$hinstanc = _this2$state.hinstance,
	                hinstance = _this2$state$hinstanc === undefined ? false : _this2$state$hinstanc,
	                _this2$state$hstate = _this2$state.hstate,
	                hstate = _this2$state$hstate === undefined ? false : _this2$state$hstate,
	                failed = _this2$state.failed,
	                _this2$state$mainLoad = _this2$state.mainLoaded,
	                mainLoaded = _this2$state$mainLoad === undefined ? false : _this2$state$mainLoad;
	
	            var hide1 = hstate || hinstance;
	            var previewUrl = preview && preview.url ? preview.url : url + '&wdpcache=widget';
	            if (!loadall) return _this2.renderStub(previewUrl);
	
	            return _react2.default.createElement(
	                Stack,
	                null,
	                !mainLoaded && _react2.default.createElement('img', {
	                    style: { width: 480, filter: 'blur(14px)', visibility: !hide1 ? 'visible' : 'invisible' },
	                    src: preview && preview.url ? preview.url : url + '&wdpcache=widget',
	                    onLoad: function onLoad() {
	                        _this2.setState({ hwidget: true });
	                    }
	                }),
	                !failed && _react2.default.createElement('img', {
	                    className: 'main-frame',
	                    style: { width: 480, visibility: hstate ? 'visible' : 'hidden' },
	                    src: url + '&wdpcache=state',
	                    onLoad: function onLoad() {
	                        _this2.setState({ hstate: true, mainLoaded: true });
	                    },
	                    onError: function onError() {
	                        _this2.setState({ failed: true });
	                    }
	                }),
	                failed && _this2.renderJSEmbed()
	            );
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    return StackOrder;
	}(_react2.default.Component);
	
	var SMStream = function (_React$Component3) {
	    _inherits(SMStream, _React$Component3);
	
	    function SMStream(props, context) {
	        _classCallCheck(this, SMStream);
	
	        var _this3 = _possibleConstructorReturn(this, (SMStream.__proto__ || Object.getPrototypeOf(SMStream)).call(this, props, context));
	
	        _initialiseProps.call(_this3);
	
	        _this3.templateObserver = _this3.context.templateObserver;
	        _this3.state = {
	            smWidgets: [],
	            collapsed: false,
	            wasVisible: false,
	            display: localStorage.getItem(C_DISPLAY_TYPE_KEY) || 'row'
	        };
	        return _this3;
	    }
	
	    _createClass(SMStream, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this4 = this;
	
	            this.setState(function () {
	                _this4.loadData(nextProps).then(function (data) {
	                    return _this4.setState(data);
	                });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.templateObserver) {
	                this.templateObserver.unsubscribe(this.handleTempleateUpdate);
	            }
	            window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	        }
	    }, {
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            return _react2.default.createElement(
	                'h1',
	                null,
	                this.props.title || this.constructor.name
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var templateId = this.templateObserver.getTemplate();
	            var _state = this.state,
	                previewWidget = _state.previewWidget,
	                preview = _state.preview,
	                loaded = _state.loaded,
	                smWidgets = _state.smWidgets;
	
	
	            if (!loaded || loaded && smWidgets.length === 0) return _react2.default.createElement(
	                'div',
	                null,
	                '"empty"'
	            );
	
	            // if (this.container) cols = Math.floor(this.container.offsetWidth / 500);
	            var cols = 3;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactOnScreen2.default,
	                    {
	                        once: true,
	                        partialVisibility: true,
	                        ref: function ref(c) {
	                            _this5.container = c;
	                        }
	                    },
	                    function (_ref2) {
	                        var isVisible = _ref2.isVisible;
	                        return _react2.default.createElement(
	                            SMStreamContainer,
	                            null,
	                            _react2.default.createElement(
	                                SMHeader,
	                                null,
	                                _this5.renderToolbar()
	                            ),
	                            _this5.renderGroupedWidgets(cols, isVisible)
	                        );
	                    }
	                ),
	                previewWidget && preview && _react2.default.createElement(_SMPostDialog2.default, {
	                    eventId: this.props.eventId,
	                    templateId: templateId,
	                    previewWidget: previewWidget,
	                    widgetName: previewWidget.name,
	                    showAllParams: false,
	                    open: preview,
	                    onRequestClose: function onRequestClose() {
	                        return _this5.setState({
	                            preview: false
	                        });
	                    }
	                })
	            );
	        }
	    }]);
	
	    return SMStream;
	}(_react2.default.Component);
	
	SMStream.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    templateObserver: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this6 = this;
	
	    this.componentDidMount = function () {
	        if (_this6.templateObserver) {
	            _this6.templateObserver.subscribe(_this6.handleTempleateUpdate);
	        }
	        _this6._debounceHandleScreenSizeUpdate = _lodash2.default.debounce(_this6.handleScreenSizeUpdate.bind(_this6), 100);
	        window.addEventListener('resize', _this6._debounceHandleScreenSizeUpdate, false);
	        _this6.loadData().then(function (res) {
	            _this6.setState(res);
	        });
	    };
	
	    this.handleTempleateUpdate = function () {
	        _this6.forceUpdate();
	    };
	
	    this.loadData = function (params) {
	        var user = _this6.context.user;
	        params = params || _this6.props || {};
	        if (!user || !user.client) return null;
	        return _this6.loadSMWidgets(params).then(function (allWidgets) {
	            return _RCore2.default.promiseProps({
	                smWidgets: allWidgets.filter(function (w) {
	                    return _this6.context.widgets.find(function (aw) {
	                        return aw.id === w.name;
	                    });
	                }),
	                loaded: true
	            });
	        });
	    };
	
	    this.handleScreenSizeUpdate = function () {
	        var width = _reactDom2.default.findDOMNode(_this6).offsetWidth;
	
	        _this6.setState({ width: width });
	    };
	
	    this.loadSMWidgets = function () {
	        return Promise.resolve(_this6.props.smWidgets || []);
	    };
	
	    this.renderSMImage = function (name, props, key, displayVisible, cardProps) {
	        var _context = _this6.context,
	            user = _context.user,
	            widgets = _context.widgets;
	
	        var templateId = _this6.templateObserver.getTemplate();
	
	        var style = {};
	
	        var widget = _lodash2.default.find(widgets, function (w) {
	            return w.id === name;
	        });
	        var load = 'sm';
	        if (widget.spec.video) load = 'video';
	
	        var propsJS = _lodash2.default.extend(_RCore2.default.dataAttributesToObject(props), {
	            template: templateId,
	            lang: user.props.lang,
	            tz: _lodash2.default.get(user, 'props.timezone', 'CET')
	        });
	
	        var widgetURL = _cfg2.default.WDPLinkr.widget.image(user.client, user.username, 'default', name, propsJS);
	
	        return _react2.default.createElement(
	            'div',
	            {
	                className: 'smi-widget-box',
	                style: style,
	                key: widgetURL,
	                onClick: function onClick(e) {
	                    _this6.handleShare(name, props, widget.spec);
	                }
	            },
	            load !== 'video' && _react2.default.createElement(StackOrder, {
	                key: widgetURL + '_' + displayVisible,
	                preview: widget.preview,
	                url: widgetURL,
	                loadall: displayVisible,
	                mode: 'js',
	                name: name,
	                jsWidget: _react2.default.createElement('rlz-widget', _extends({
	                    'class': 'smi-widget',
	                    'data-name': name,
	                    'data-load': load,
	                    'data-client': user.client,
	                    'data-user': user.username,
	                    'data-lang': _lodash2.default.get(user, 'props.lang'),
	                    'data-tz': _lodash2.default.get(user, 'props.timezone', 'CET'),
	                    'data-token': user.accessToken,
	                    'data-template': templateId,
	                    'data-theme': user.defaultTheme,
	                    'data-min-width': 800,
	                    'data-sm-browser': true,
	                    'data-zoom': 0.6
	                }, props))
	            }),
	            load === 'video' && _react2.default.createElement('rlz-widget', _extends({
	                key: name,
	                'class': 'smi-widget',
	                'data-name': name,
	                'data-load': 'animated',
	                'data-client': user.client,
	                'data-user': user.username,
	                'data-lang': _lodash2.default.get(user, 'props.lang'),
	                'data-tz': _lodash2.default.get(user, 'props.timezone', 'CET'),
	                'data-token': user.accessToken,
	                'data-template': templateId,
	                'data-theme': user.defaultTheme,
	                'data-min-width': 800,
	                'data-sm-browser': true,
	                'data-zoom': 0.6
	            }, props))
	        );
	    };
	
	    this.handleShare = function (name, props, spec) {
	        _this6.setState({
	            preview: true,
	            previewWidget: {
	                name: name,
	                props: _lodash2.default.clone(props),
	                spec: spec
	            }
	        });
	    };
	
	    this.renderGroupedWidgets = function (cols) {
	        var displayVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (cols === 0) return _react2.default.createElement('div', null);
	
	        var smWidgets = _this6.state.smWidgets;
	
	        var groupedWidgetPairs = _lodash2.default.chain(smWidgets).groupBy(function (w) {
	            return w.groupKey || w.name;
	        }).toPairs().value();
	
	        var columns = _lodash2.default.range(cols).map(function (i) {
	            return [];
	        });
	        groupedWidgetPairs.forEach(function (w, i) {
	            return columns[i % cols].push(w);
	        });
	
	        return _react2.default.createElement(
	            Grid,
	            null,
	            columns.map(function (widgets, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'column', key: index },
	                    widgets.map(function (pair, i) {
	                        var name = pair[0];
	                        var widgets = pair[1];
	                        var title = widgets[0].groupTitle || widgets[0]['data-title'] || name;
	                        var desc = widgets[0].groupDesc;
	                        var minHeight = widgets[0].minHeight;
	
	                        return _react2.default.createElement(
	                            'div',
	                            { key: name + '_' + i, className: 'stack-item' },
	                            _react2.default.createElement(
	                                StackView,
	                                {
	                                    title: title,
	                                    desc: desc,
	                                    widgets: widgets,
	                                    onShare: _this6.handleShare
	                                },
	                                widgets.map(function (sm) {
	                                    return _this6.renderSMImage(sm.name, sm.props, sm.key, displayVisible, {
	                                        minHeight: minHeight
	                                    });
	                                })
	                            )
	                        );
	                    })
	                );
	            })
	        );
	    };
	};
	
	exports.default = SMStream;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMStream2 = __webpack_require__(1699);
	
	var _SMStream3 = _interopRequireDefault(_SMStream2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProTopListLabels = [{
	    text: 'Goals',
	    value: 'eventsStats.goals'
	}, {
	    text: 'Assists',
	    value: 'eventsStats.assists'
	}, {
	    text: 'Top speed',
	    value: 'maxStats.distanceData.topSpeed'
	}, {
	    text: 'Average distance',
	    value: 'averageStats.distanceData.distance'
	}];
	
	var EISMStream = function (_SMStream) {
	    _inherits(EISMStream, _SMStream);
	
	    function EISMStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EISMStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EISMStream.__proto__ || Object.getPrototypeOf(EISMStream)).call.apply(_ref, [this].concat(args))), _this), _this.prepareTopLists = function (tournament, seasonId) {
	            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            var tournamentId = tournament.id;
	            var hasPro = _RCore2.default.isProStatsDataAvailable(tournamentId, seasonId);
	            if (!hasPro) return [];
	            return ProTopListLabels.map(function (p) {
	                return {
	                    groupKey: 'season-top-list-' + params.teamId,
	                    groupTitle: 'Top players, season',
	                    name: 'ProTopListSMWidget',
	                    props: {
	                        'data-tournament-id': tournamentId,
	                        'data-sort-by': p.value,
	                        'data-team-id': params.teamId
	                    },
	                    key: 'pro-top-list-' + tournamentId + '-' + params.teamId + '-' + p.value
	                };
	            });
	        }, _this.prepareLastRoundTopLists = function (round, tournament, seasonId) {
	            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            return false;
	            var tournamentId = tournament.id;
	            var hasPro = _RCore2.default.isProStatsDataAvailable(tournamentId, seasonId);
	            if (!hasPro) return [];
	            return ProTopListLabels.map(function (p) {
	                return {
	                    groupKey: 'season-top-round-' + round,
	                    groupTitle: 'Top players, Runde ' + round,
	                    name: 'ProTopListSMWidget',
	                    props: {
	                        'data-tournament-id': tournamentId,
	                        'data-round': round,
	                        'data-sort-by': p.value,
	                        'data-team-id': params.teamId
	                    },
	                    key: 'pro-top-list-' + tournamentId + '-' + round
	                };
	            });
	        }, _this.prepareTables = function (tournament, seasonId, params) {
	            var tournamentId = tournament.id;
	
	            return [{
	                name: 'TopListSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-season-id': seasonId
	                },
	                key: 'top-list-' + tournamentId
	            }, {
	                name: 'LeagueTrackerSMWidget',
	                props: _RCore2.default.prepareWidgetPropsObj({
	                    'data-tournament-id': tournamentId,
	                    'data-season-id': seasonId,
	                    'data-stage-id': params.stageId,
	                    'data-show-all-charts': true,
	                    'data-line-smoothing': true,
	                    'data-show-team-name-badge': true,
	                    'data-team1-id': params.teamId,
	                    'data-team2-id': params.team2Id
	                }),
	                key: 'lt-list-' + tournamentId
	            }, {
	                name: 'AnimatedTournamentTable',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-season-id': seasonId,
	                    'data-stage-id': params.stageId
	                },
	                key: 'table-list-' + tournamentId + '-animated'
	            }, {
	                name: 'TournamentTableSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-season-id': seasonId,
	                    'data-limit': 5,
	                    'data-team-id': params.teamId,
	                    'data-team2-id': params.team2Id,
	                    'data-stage-id': params.stageId,
	                    'data-qual-rel': true
	                },
	                key: 'table-list-' + tournamentId
	            }, {
	                name: 'TournamentTableSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-full': true,
	                    'data-team-id': params.teamId,
	                    'data-team2-id': params.team2Id,
	                    'data-stage-id': params.stageId
	                },
	                key: 'table-full-' + tournamentId
	            }, {
	                name: 'TournamentTableSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-full': true,
	                    'data-qual-rel': true,
	                    'data-team-id': params.teamId,
	                    'data-team2-id': params.team2Id,
	                    'data-stage-id': params.stageId
	                },
	                key: 'table-full-w-q-l-' + tournamentId
	            }, {
	                name: 'TournamentTableSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-limit': 3,
	                    'data-team-id': params.teamId,
	                    'data-team2-id': params.team2Id,
	                    'data-stage-id': params.stageId
	                },
	                key: 'table-limit-3-' + tournamentId
	            }, {
	                name: 'TournamentTableSMWidget',
	                props: {
	                    'data-tournament-id': tournamentId,
	                    'data-limit': -5,
	                    'data-team-id': params.teamId,
	                    'data-team2-id': params.team2Id,
	                    'data-stage-id': params.stageId
	                },
	                key: 'table-limit-5-' + tournamentId
	            }];
	        }, _this.loadSMWidgetsForEvent = function (params) {
	            var tournamentId = params.tournamentId,
	                seasonId = params.seasonId,
	                teamId = params.teamId,
	                eventId = params.eventId;
	
	            return _RCore2.default.promiseProps({
	                event: fetch(_cfg2.default.apis.ss2 + '/events/' + eventId).then(function (response) {
	                    return response.json();
	                }),
	                tournament: _this.props.tournament || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                var tournament = result.tournament,
	                    event = result.event;
	                var round = event.properties.round;
	
	                var stageId = event.tournamentStageId;
	                var teamId = event.homeId;
	                var team2Id = event.awayId;
	                return _lodash2.default.compact([].concat(_toConsumableArray(_this.prepareTables(tournament, seasonId, { teamId: teamId, team2Id: team2Id, stageId: stageId })), _toConsumableArray(_this.prepareTopLists(tournament, seasonId, { teamId: teamId, team2Id: team2Id, stageId: stageId })), _toConsumableArray(_this.prepareTopLists(tournament, seasonId, { teamId: team2Id, stageId: stageId })), _toConsumableArray(_this.prepareLastRoundTopLists(round, tournament, seasonId, { teamId: teamId, team2Id: team2Id, stageId: stageId }))));
	            });
	        }, _this.loadSMWidgetsForLeague = function (params) {
	            var tournamentId = params.tournamentId,
	                seasonId = params.seasonId,
	                teamId = params.teamId;
	
	
	            return _RCore2.default.promiseProps({
	                tournament: _this.props.tournament || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId).then(function (response) {
	                    return response.json();
	                }),
	                latestEvent: fetch(_cfg2.default.apis.ss2 + '/events-v2?ttId=' + tournamentId + '&status=finished&limit=1&sortBy=startDate&sortDirection=desc').then(function (response) {
	                    return response.json();
	                }).then(function (r) {
	                    return r.events[0];
	                })
	            }).then(function (result) {
	                var tournament = result.tournament,
	                    latestEvent = result.latestEvent;
	                var round = latestEvent.properties.round;
	
	                return _lodash2.default.compact([].concat(_toConsumableArray(_this.prepareTables(tournament, seasonId, { teamId: teamId })), _toConsumableArray(_this.prepareTopLists(tournament, seasonId, { teamId: teamId })), _toConsumableArray(_this.prepareLastRoundTopLists(round, tournament, seasonId, { teamId: teamId }))));
	            });
	        }, _this.loadSMWidgetsForMixedTournament = function (tournament, stages, params) {
	            return _lodash2.default.compact([{
	                name: 'TopListSMWidget',
	                groupTitle: 'Top List Goals',
	                groupKey: 'Goals',
	                props: {
	                    'data-tournament-id': tournament.id,
	                    'data-season-id': _lodash2.default.get(tournament, 'currentSeason.id', null),
	                    'data-sort-by': 'stats.goals'
	                },
	                key: 'top-list-' + tournament.id
	            }, {
	                name: 'TopListSMWidget',
	                groupTitle: 'Top List Assists',
	                groupKey: 'Assists',
	                props: {
	                    'data-tournament-id': tournament.id,
	                    'data-season-id': _lodash2.default.get(tournament, 'currentSeason.id', null),
	                    'data-sort-by': 'stats.assists'
	                },
	                key: 'top-list-' + tournament.id
	            }].concat(_toConsumableArray(_lodash2.default.filter(stages, function (s) {
	                return !s.isCup;
	            }).map(function (stage) {
	                return {
	                    name: 'TournamentTableSMWidget',
	                    props: {
	                        'data-tournament-id': tournament.id,
	                        'data-season-id': _lodash2.default.get(tournament, 'currentSeason.id', null),
	                        'data-stage-id': stage.id,
	                        'data-full': true,
	                        'data-qual-rel': true
	                    },
	                    key: 'table-list-' + tournament.id + '-' + stage.id
	                };
	            })), [tournament.id === 46 && {
	                name: 'TournamentGroupTableSMWidget',
	                props: {
	                    'data-tournament-id': tournament.id,
	                    'data-qual-rel': true
	                },
	                key: 'table-limit-5-' + tournament.id
	            }]));
	        }, _this.loadSMWidgets = function (params) {
	            var tournamentId = params.tournamentId,
	                seasonId = params.seasonId,
	                teamId = params.teamId,
	                eventId = params.eventId;
	
	            // if in context of event
	
	            if (eventId) return _this.loadSMWidgetsForEvent(params);
	
	            return _RCore2.default.promiseProps({
	                tournament: _this.props.tournament || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId).then(function (response) {
	                    return response.json();
	                }),
	                stages: _this.props.stages || fetch(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/season').then(function (response) {
	                    return response.json();
	                }).then(function (r) {
	                    return r.season.stages;
	                })
	            }).then(function (result) {
	                var tournament = result.tournament,
	                    stages = result.stages;
	
	
	                if (tournament.type === 'cup') return _this.loadSMWidgetsForCup(params);
	                if ((tournament.type === 'league' || tournament.currentType === 'table') && stages.length === 1) return _this.loadSMWidgetsForLeague(params);else return _this.loadSMWidgetsForMixedTournament(tournament, stages, params);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EISMStream, [{
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            return _react2.default.createElement(
	                'h1',
	                null,
	                'Standings'
	            );
	        }
	    }]);
	
	    return EISMStream;
	}(_SMStream3.default);
	
	exports.default = EISMStream;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _events = __webpack_require__(1058);
	
	var _EventsList = __webpack_require__(1696);
	
	var _SMStream = __webpack_require__(1592);
	
	var _SMStream2 = _interopRequireDefault(_SMStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// GroupStageOverviewSMWidget;
	
	var roundWidgets = function roundWidgets(tournament, season, stage, round, events) {
	    return [{
	        name: 'RoundMatchesSMWidget',
	        groupTitle: 'Round ' + round,
	
	        props: {
	            tournamentId: tournament.id,
	            stageId: stage.id,
	            round: round
	        }
	    }].concat(_toConsumableArray(_lodash2.default.chain(events).groupBy(function (e) {
	        return (0, _moment2.default)(e.startDate).format('YYYY-MM-DD');
	    }).keys().map(function (date) {
	        return {
	            name: 'TodayMatchesSMWidget',
	            groupTitle: 'Matchday ' + (0, _moment2.default)(date).format('D MMM'),
	            groupKey: '' + (date + '_' + tournament.id),
	            props: {
	                tournamentId: tournament.id,
	                stageId: stage.id,
	                date: date
	            },
	            key: '' + (date + '_' + tournament.id)
	        };
	    }).value()));
	};
	
	var tournamentTables = function tournamentTables(tournament, season, stage) {
	    return [{
	        name: 'TournamentTableSMWidget',
	        groupTitle: '' + stage.enetPulseName,
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id,
	            full: true
	        }
	    }, {
	        name: 'AnimatedTournamentTable',
	        // groupTitle: `${stage.enetPulseName} animation`,
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id
	        }
	    }, {
	        name: 'LeagueTrackerSMWidget',
	        groupTitle: stage.enetPulseName + ' league tracker',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id
	        }
	    }];
	};
	
	var stageMatchDays = function stageMatchDays(tournament, season, stage, events) {
	    return [].concat(_toConsumableArray(_lodash2.default.chain(events).groupBy(function (e) {
	        return (0, _moment2.default)(e.startDate).format('YYYY-MM-DD');
	    }).keys().map(function (date) {
	        return {
	            name: 'TodayMatchesSMWidget',
	            groupTitle: 'Matchday ' + (0, _moment2.default)(date).format('D MMM'),
	            groupKey: '' + (date + '_' + tournament.id),
	            props: {
	                tournamentId: tournament.id,
	                stageId: stage.id,
	                date: date
	            },
	            key: '' + (date + '_' + tournament.id)
	        };
	    }).value()));
	};
	
	var smallGroupOverviewWidgets = function smallGroupOverviewWidgets(tournament, season, stage) {
	    return [{
	        name: 'GroupStageOverviewSMWidget',
	        groupTitle: 'Group Overview',
	        groupKey: '' + ('_' + tournament.id),
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id
	        }
	    }, {
	        name: 'GroupStageOverviewSMWidget',
	        groupTitle: 'Group + current round',
	        groupKey: '_' + tournament.id + '-current',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id,
	            showMatches: 'current'
	        }
	    }];
	};
	
	var TournamentStageSMB = function (_React$Component) {
	    _inherits(TournamentStageSMB, _React$Component);
	
	    function TournamentStageSMB(props, context) {
	        _classCallCheck(this, TournamentStageSMB);
	
	        var _this = _possibleConstructorReturn(this, (TournamentStageSMB.__proto__ || Object.getPrototypeOf(TournamentStageSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                fetchLatestEventsForStage = _this$props.fetchLatestEventsForStage,
	                params = _this$props.params;
	
	
	            dispatch(fetchLatestEventsForStage(params.stageId));
	            dispatch((0, _events.fetchComingEventsForStage)(params.stageId));
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                fetchLatestEventsForStage = _this$props2.fetchLatestEventsForStage,
	                params = _this$props2.params;
	
	
	            if (+_this.props.params.stageId !== +nextProps.params.stageId) {
	                dispatch(fetchLatestEventsForStage(+nextProps.params.stageId));
	                dispatch((0, _events.fetchComingEventsForStage)(+nextProps.params.stageId));
	            }
	        };
	
	        _this.renderCup = function () {
	            var _this$props3 = _this.props,
	                tournament = _this$props3.tournament,
	                season = _this$props3.season,
	                stage = _this$props3.stage;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'If it is CUP'
	                ),
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: [{
	                        name: 'PlayoffGridSMWidget',
	                        groupKey: 'playoff',
	                        props: {
	                            tournamentId: tournament.id,
	                            seasonId: season.id,
	                            stageIds: JSON.stringify([stage.id])
	                        },
	                        key: 'tt-' + season.id + '-playoff'
	                    }],
	                    title: 'Group overview'
	                })
	            );
	        };
	
	        _this.renderGroupOverview = function () {
	            var _this$props4 = _this.props,
	                tournament = _this$props4.tournament,
	                season = _this$props4.season,
	                stage = _this$props4.stage,
	                events = _this$props4.events,
	                comingEvents = _this$props4.comingEvents;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMStream2.default, { smWidgets: smallGroupOverviewWidgets(tournament, season, stage), title: 'Group overview' }),
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: stageMatchDays(tournament, season, stage, [].concat(_toConsumableArray(events), _toConsumableArray(comingEvents))),
	                    title: 'Group matchdays'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'If it is GROUP'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Current round matches'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Todays matches list'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Stage top scorer'
	                    )
	                )
	            );
	        };
	
	        _this.renderLeague = function () {
	            var _this$props5 = _this.props,
	                tournament = _this$props5.tournament,
	                season = _this$props5.season,
	                stage = _this$props5.stage,
	                comingEvents = _this$props5.comingEvents;
	
	            var currentRound = _lodash2.default.find(stage.roundsList, function (r) {
	                return r.isCurrent;
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SMStream2.default, {
	                    smWidgets: roundWidgets(tournament, season, stage, currentRound && currentRound.name || tournament.currentRound, comingEvents),
	                    title: 'Current round / nearest matchdays'
	                }),
	                _react2.default.createElement(_SMStream2.default, { smWidgets: tournamentTables(tournament, season, stage), title: 'Tournament tables' })
	            );
	        };
	
	        _this.renderFriendliesMatches = function () {
	            var _this$props6 = _this.props,
	                _this$props6$events = _this$props6.events,
	                events = _this$props6$events === undefined ? [] : _this$props6$events,
	                _this$props6$comingEv = _this$props6.comingEvents,
	                comingEvents = _this$props6$comingEv === undefined ? [] : _this$props6$comingEv;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, title: 'Finished events' }),
	                _react2.default.createElement(_EventsList.EventsList, { events: comingEvents, title: 'Upcoming events' })
	            );
	        };
	
	        return _this;
	    }
	
	    _createClass(TournamentStageSMB, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$params = _props.params,
	                tournamentId = _props$params.tournamentId,
	                seasonId = _props$params.seasonId,
	                sport = _props$params.sport,
	                stageId = _props$params.stageId,
	                tournament = _props.tournament,
	                stage = _props.stage,
	                _props$events = _props.events,
	                events = _props$events === undefined ? [] : _props$events,
	                _props$comingEvents = _props.comingEvents,
	                comingEvents = _props$comingEvents === undefined ? [] : _props$comingEvents;
	
	
	            if (!stage) return _react2.default.createElement('div', null);
	
	            if (+tournamentId === 114) return this.renderFriendliesMatches();
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_EventsList.EventsList, { events: events, title: 'Finished events' }),
	                _react2.default.createElement(_EventsList.EventsList, { events: comingEvents, title: 'Upcoming events' }),
	                stage.isCup && this.renderCup(),
	                stage.isCup === false && stage.roundsList.length <= 6 && this.renderGroupOverview(),
	                stage.isCup === false && stage.roundsList.length > 6 && this.renderLeague()
	            );
	        }
	    }]);
	
	    return TournamentStageSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var ids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchLatestEventsForStageKey)(props.params.stageId) + ']', []);
	    var cids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchComingEventsForStageKey)(props.params.stageId) + ']', []);
	
	    var events = _lodash2.default.get(state, 'query.entities.events', []);
	
	    return {
	        events: ids.map(function (id) {
	            return events[id];
	        }),
	        comingEvents: cids.map(function (id) {
	            return events[id];
	        }),
	        tournament: _lodash2.default.get(state.smBrowser, 'tournament'),
	        season: _lodash2.default.get(state.smBrowser, 'season'),
	        stage: _lodash2.default.chain(state.smBrowser).get('season.stages', []).find(function (s) {
	            return +s.id === +props.params.stageId;
	        }).value()
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        fetchLatestEventsForStage: _events.fetchLatestEventsForStage,
	        fetchComingEventsForStage: _events.fetchComingEventsForStage
	    };
	})(TournamentStageSMB);

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _EventIncidentsSMStream = __webpack_require__(1703);
	
	var _EventIncidentsSMStream2 = _interopRequireDefault(_EventIncidentsSMStream);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SportHomeSMBrowser = function (_React$Component) {
	    _inherits(SportHomeSMBrowser, _React$Component);
	
	    function SportHomeSMBrowser(props, context) {
	        _classCallCheck(this, SportHomeSMBrowser);
	
	        var _this = _possibleConstructorReturn(this, (SportHomeSMBrowser.__proto__ || Object.getPrototypeOf(SportHomeSMBrowser)).call(this, props, context));
	
	        _this.componentDidMount = function () {};
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.params.sport !== _this.props.params.sport) {
	                _this.forceUpdate(function () {
	                    _this.loadData();
	                });
	            }
	        };
	
	        _this.loadData = function (additionalStateParams) {
	            var user = _this.context.user;
	            if (!user || !user.client) return null;
	            var sportId = _RCore2.default.sportToId(_this.props.params.sport);
	            return _RCore2.default.promiseProps({
	                tournaments: fetch(_cfg2.default.apis.ss2 + '/tournaments?sportId=' + sportId).then(function (response) {
	                    return response.json();
	                }).then(function (tournaments) {
	                    return _lodash2.default.filter(tournaments, function (t) {
	                        return t.isEnabled;
	                    });
	                })
	            }).then(function (res) {
	                _this.setState(res);
	            });
	        };
	
	        _this.state = {
	            templates: []
	        };
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(SportHomeSMBrowser, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var user = this.context.user;
	            var tournaments = this.state.tournaments;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        this.props.params.sport,
	                        ' sport home'
	                    )
	                ),
	                _lodash2.default.chain(tournaments).groupBy(function (t) {
	                    return t.countryName;
	                }).map(function (tournaments, country) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: country },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'col-md-12' },
	                            country
	                        ),
	                        tournaments.map(function (t) {
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2', key: t.key },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/sm/browser/' + _this2.props.params.sport + '/tournaments/' + t.id },
	                                    t.name
	                                )
	                            );
	                        })
	                    );
	                }).value()
	            );
	        }
	    }]);
	
	    return SportHomeSMBrowser;
	}(_react2.default.Component);
	
	SportHomeSMBrowser.defaultProps = {
	    eventId: 46
	};
	SportHomeSMBrowser.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = SportHomeSMBrowser;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMStream2 = __webpack_require__(1699);
	
	var _SMStream3 = _interopRequireDefault(_SMStream2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EISMStream = function (_SMStream) {
	    _inherits(EISMStream, _SMStream);
	
	    function EISMStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EISMStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EISMStream.__proto__ || Object.getPrototypeOf(EISMStream)).call.apply(_ref, [this].concat(args))), _this), _this.mapTo = function (groupKey, event, incident) {
	            return {
	                name: 'IncidentWidget',
	                groupKey: groupKey,
	                props: {
	                    'data-event-id': event.eventId,
	                    'data-incident-id': incident.incidentId
	                },
	                key: 'i' + incident.incidentId
	            };
	        }, _this.mapToAnimatedGoal = function (groupKey, event, incident) {
	            return {
	                name: 'AnimatedGoal',
	                groupKey: groupKey,
	                props: {
	                    'data-event-id': event.eventId,
	                    'data-incident-id': incident.incidentId
	                },
	                key: 'animated-goal-i' + incident.incidentId
	            };
	        }, _this.mapToAnimatedIncident = function (groupKey, event, incident) {
	            return {
	                name: 'AnimatedIncident',
	                groupKey: groupKey,
	                props: {
	                    'data-event-id': event.eventId,
	                    'data-incident-id': incident.incidentId
	                },
	                key: 'animated-incident-i' + incident.incidentId
	            };
	        }, _this.loadSMWidgets = function (params) {
	            var eventId = params.eventId;
	
	            return _RCore2.default.promiseProps({
	                event: fetch(_cfg2.default.apis.ss2 + '/events/' + eventId).then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                var event = result.event;
	
	                return [].concat(_toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'goal' || i.subtype === 'goal_own';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapTo.bind(_this, 'Goals Incidents', event))), _toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'card';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapTo.bind(_this, 'Cards Incidents', event))), _toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'subst_in';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapTo.bind(_this, 'Substitutions', event))), _toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'goal';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapToAnimatedGoal.bind(_this, 'Animated Goal', event))), _toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'goal' || i.subtype === 'goal_own';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapToAnimatedIncident.bind(_this, 'Animated Incident Goals', event))), _toConsumableArray(_lodash2.default.chain(event.incidents).filter(function (i) {
	                    return i.subtype === 'card';
	                }).sortBy(function (i) {
	                    return -i.min;
	                }).map(_this.mapToAnimatedIncident.bind(_this, 'Animated Incident Cards', event))));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EISMStream, [{
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            return _react2.default.createElement(
	                'h1',
	                null,
	                'Incidents'
	            );
	        }
	    }]);
	
	    return EISMStream;
	}(_SMStream3.default);
	
	exports.default = EISMStream;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var F1HomeSMBrowser = function (_React$Component) {
	    _inherits(F1HomeSMBrowser, _React$Component);
	
	    function F1HomeSMBrowser(props, context) {
	        _classCallCheck(this, F1HomeSMBrowser);
	
	        var _this = _possibleConstructorReturn(this, (F1HomeSMBrowser.__proto__ || Object.getPrototypeOf(F1HomeSMBrowser)).call(this, props, context));
	
	        _this.loadData = function (additionalStateParams) {
	            var eventId = _this.props.eventId;
	
	            var user = _this.context.user;
	            if (!user || !user.client) return null;
	            return _RCore2.default.promiseProps({
	                gpxs: fetch(_cfg2.default.apis.ss2 + '/f1/gpx').then(function (response) {
	                    return response.json();
	                }),
	                gpxsOld: fetch(_cfg2.default.apis.ss2 + '/f1/gpx?year=2017').then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                // console.log("!!", res)
	                _this.setState(_extends({}, result, {
	                    isLoading: false
	                }, additionalStateParams));
	            }).catch(function (e) {
	                _this.setState(_extends({
	                    error: e,
	                    isLoading: false
	                }, additionalStateParams));
	            });
	        };
	
	        _this.state = {
	            templates: [],
	            gpxs: [],
	            gpxsOld: []
	        };
	        return _this;
	    }
	
	    _createClass(F1HomeSMBrowser, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var _state = this.state,
	                gpxs = _state.gpxs,
	                gpxsOld = _state.gpxsOld;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            '2018 season'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            gpxs.map(function (g) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: g.id },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/sm/browser/f1/gpx/' + g.id },
	                                        g.name
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            '2017 season'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            gpxsOld.map(function (g) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: g.id },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/sm/browser/f1/gpx/' + g.id },
	                                        g.name
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return F1HomeSMBrowser;
	}(_react2.default.Component);
	
	F1HomeSMBrowser.defaultProps = {
	    eventId: 46
	};
	F1HomeSMBrowser.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = F1HomeSMBrowser;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _F1SMStream = __webpack_require__(1706);
	
	var _F1SMStream2 = _interopRequireDefault(_F1SMStream);
	
	var _F1SessionSMStream = __webpack_require__(1707);
	
	var _F1SessionSMStream2 = _interopRequireDefault(_F1SessionSMStream);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var F1GPXSMBrowser = function (_React$Component) {
	    _inherits(F1GPXSMBrowser, _React$Component);
	
	    function F1GPXSMBrowser(props, context) {
	        _classCallCheck(this, F1GPXSMBrowser);
	
	        var _this = _possibleConstructorReturn(this, (F1GPXSMBrowser.__proto__ || Object.getPrototypeOf(F1GPXSMBrowser)).call(this, props, context));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            if (nextProps.params.gpId !== _this.props.params.gpId) {
	                _this.forceUpdate(function () {
	                    _this.loadData();
	                });
	            }
	        };
	
	        _this.loadData = function () {
	            var gpId = _this.props.params.gpId;
	
	            var user = _this.context.user;
	            if (!user || !user.client) return null;
	            return _RCore2.default.promiseProps({
	                gp: fetch(_cfg2.default.apis.ss2 + '/f1/gpx/' + gpId + '/info').then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                _this.setState(_extends({}, result, {
	                    template: _lodash2.default.last(result.templates),
	                    isLoading: false
	                }));
	            }).catch(function (e) {
	                _this.setState({
	                    error: e,
	                    isLoading: false
	                });
	            });
	        };
	
	        _this.state = {};
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(F1GPXSMBrowser, [{
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	            var gp = this.state.gp;
	
	            if (!gp) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        gp.name
	                    ),
	                    _react2.default.createElement(
	                        'table',
	                        null,
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            gp.events.map(function (e) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: 'g' + e.eventId },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        e.name
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        e.statusFull
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        (0, _moment2.default)(e.startDate).format('DD MMM, hh:mm')
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(_F1SessionSMStream2.default, { gpId: gp.id, type: 'race' }),
	                    _react2.default.createElement(_F1SessionSMStream2.default, { gpId: gp.id, type: 'qual' }),
	                    _react2.default.createElement(_F1SessionSMStream2.default, { gpId: gp.id, type: 'practice' }),
	                    _react2.default.createElement(_F1SMStream2.default, { gpId: gp.id, year: gp.year })
	                )
	            );
	        }
	    }]);
	
	    return F1GPXSMBrowser;
	}(_react2.default.Component);
	
	F1GPXSMBrowser.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = F1GPXSMBrowser;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMStream2 = __webpack_require__(1699);
	
	var _SMStream3 = _interopRequireDefault(_SMStream2);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EISMStream = function (_SMStream) {
	    _inherits(EISMStream, _SMStream);
	
	    function EISMStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EISMStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EISMStream.__proto__ || Object.getPrototypeOf(EISMStream)).call.apply(_ref, [this].concat(args))), _this), _this.loadSMWidgets = function (params) {
	            var gpId = params.gpId,
	                year = params.year;
	
	
	            return Promise.resolve([{
	                name: 'F1GrandPrixAnnounceSMWidget',
	                props: {
	                    'data-year': year,
	                    'data-gpx-id': gpId
	                },
	                key: 'f1-announce-' + gpId
	            }, {
	                name: 'F1SeasonCalendarSMWidget',
	                props: {
	                    'data-year': year
	                },
	                key: 'f1-calendar-' + gpId
	            }, {
	                name: 'F1Standings',
	                groupTitle: 'Drivers standings',
	                groupKey: 'drivers',
	                props: {
	                    'data-year': year,
	                    type: 'drivers'
	                },
	                key: 'f1-standings-driver'
	            }, {
	                name: 'F1Standings',
	                groupTitle: 'Constructor cup standings',
	                groupKey: 'teams',
	                props: {
	                    'data-year': year,
	                    type: 'teams'
	                },
	                key: 'f1-standings-team'
	            }]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EISMStream, [{
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            return _react2.default.createElement(
	                'h1',
	                null,
	                'F1 Common'
	            );
	        }
	    }]);
	
	    return EISMStream;
	}(_SMStream3.default);
	
	exports.default = EISMStream;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1302);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _autorenew = __webpack_require__(1312);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _reactRouter = __webpack_require__(188);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMStream2 = __webpack_require__(1699);
	
	var _SMStream3 = _interopRequireDefault(_SMStream2);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TEAMS = ['FER', 'MER', 'RBR', 'MCL', 'REN', 'WIL', 'SAU', 'STR', 'FIN'];
	
	var EISMStream = function (_SMStream) {
	    _inherits(EISMStream, _SMStream);
	
	    function EISMStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EISMStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EISMStream.__proto__ || Object.getPrototypeOf(EISMStream)).call.apply(_ref, [this].concat(args))), _this), _this.loadSMWidgets = function (params) {
	            var gpId = params.gpId;
	            var type = _this.props.type;
	
	            return _RCore2.default.promiseProps({
	                gp: fetch(_cfg2.default.apis.ss2 + '/f1/gpx/' + gpId + '/info').then(function (response) {
	                    return response.json();
	                })
	            }).then(function (result) {
	                switch (type) {
	                    case 'practice':
	                        return _this.renderPractice(gpId);
	                    case 'qual':
	                        return _this.renderQual(gpId);
	                    case 'race':
	                        return _this.renderRace(gpId, result.gp);
	                    default:
	                        return _this.renderPractice(gpId);
	                }
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EISMStream, [{
	        key: 'renderToolbar',
	        value: function renderToolbar() {
	            var type = this.props.type;
	
	            switch (type) {
	                case 'practice':
	                    return _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Practices'
	                    );
	                case 'qual':
	                    return _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Qual'
	                    );
	                case 'race':
	                    return _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Race'
	                    );
	                default:
	                    return _react2.default.createElement(
	                        'h1',
	                        null,
	                        'F1 Session'
	                    );
	            }
	        }
	    }, {
	        key: 'renderQual',
	        value: function renderQual(gpId) {
	            return Promise.resolve([].concat(_toConsumableArray(['qual-p1', 'qual-p2', 'qual-p3'].map(function (type) {
	                return {
	                    name: 'F1RaceDetailedResultsSMWidget',
	                    groupKey: 'session-full-' + gpId,
	                    groupTitle: 'Qualification sessions',
	                    props: {
	                        'data-gp-id': gpId,
	                        'data-type': type
	                    },
	                    key: 'f1-d-' + type + '-' + gpId
	                };
	            })), _toConsumableArray(['qual-out-p1', 'qual-out-p2'].map(function (type) {
	                return {
	                    name: 'F1RaceDetailedResultsSMWidget',
	                    groupKey: 'session-out-' + gpId,
	                    groupTitle: 'Qualification sessions OUT drivers',
	                    props: {
	                        'data-gp-id': gpId,
	                        'data-type': type
	                    },
	                    key: 'f1-d-' + type + '-' + gpId
	                };
	            })), [{
	                name: 'F1RaceDetailedResultsSMWidget',
	                props: {
	                    'data-gp-id': gpId,
	                    'data-type': 'qual'
	                },
	                key: 'f1-d-qual-' + gpId
	            }], _toConsumableArray(TEAMS.map(function (type) {
	                return {
	                    name: 'F1QualTeams',
	                    groupKey: 'qual-team-' + gpId,
	                    groupTitle: 'Qualification H2H Team',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-team': type
	                    },
	                    key: 'f1-q-teams-' + type + '-' + gpId
	                };
	            }))));
	        }
	    }, {
	        key: 'renderRace',
	        value: function renderRace(gpId, gp) {
	            var eventRace = gp.events.find(function (ev) {
	                return ev.name === 'Race';
	            });
	
	            return _RCore2.default.promiseProps({
	                raceOut: fetch(_cfg2.default.apis.ss2 + '/f1/gpx/' + gpId + '/events/' + eventRace.eventId + '/race-out').then(function (response) {
	                    return response.json();
	                })
	            }).then(function (res) {
	                return Promise.resolve([{
	                    name: 'F1RaceDetailedResultsSMWidget',
	                    props: {
	                        'data-gp-id': gpId,
	                        'data-type': 'race'
	                    },
	                    key: 'f1-d-race-' + gpId
	                }, {
	                    name: 'F1RaceDetailedResultsSMWidget',
	                    groupTitle: 'Race detailed results OUT drivers',
	                    groupKey: 'd-retired-' + gpId,
	                    props: {
	                        'data-gp-id': gpId,
	                        'data-type': 'retired'
	                    },
	                    key: 'f1-d-retired-' + gpId
	                }, {
	                    name: 'F1ClosingGap',
	                    props: {
	                        'data-gpx-id': gpId
	                    },
	                    key: 'f1-closing-gap-' + gpId
	                }, {
	                    name: 'F1AnimatedPodiumSMWidget',
	                    props: {
	                        'data-gpx-id': gpId
	                    },
	                    key: 'f1-podium-' + gpId
	                }, {
	                    name: 'F1AnimatedFastestLapSMWidget',
	                    props: {
	                        'data-gpx-id': gpId
	                    },
	                    key: 'f1-fastest-lap-' + gpId
	                }].concat(_toConsumableArray(res.raceOut.map(function (d) {
	                    return {
	                        name: 'F1DriverIncidentSMWidget',
	                        groupKey: 'i-drivers-' + gpId,
	                        groupTitle: 'Drivers incident race',
	                        props: {
	                            'data-gpx-id': gpId,
	                            'data-driver': d.driverShortName,
	                            'data-incidentType': 'retired',
	                            'data-customHeadline': null
	                        },
	                        key: 'f1-i-driver-' + d.driverShortName + '-' + gpId
	                    };
	                })), [{
	                    name: 'F1StandingsAfterRace',
	                    groupTitle: 'Drivers standings after race',
	                    groupKey: 'standingsAfterRaceDrivers',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'drivers',
	                        'data-showTop10': false
	                    },
	                    key: 'f1-standings-after-race-drivers-' + gpId
	                }, {
	                    name: 'F1StandingsAfterRace',
	                    groupTitle: 'Drivers standings after race',
	                    groupKey: 'standingsAfterRaceDrivers',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'drivers',
	                        'data-showTop10': true
	                    },
	                    key: 'f1-standings-after-race-drivers-' + gpId
	                }, {
	                    name: 'F1StandingsAfterRace',
	                    groupTitle: 'Constructor cup standings after race',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'teams'
	                    },
	                    key: 'f1-standings-after-race-' + gpId
	                }, {
	                    name: 'F1PointsAfterRace',
	                    groupTitle: 'Drivers after race',
	                    groupKey: 'afterRaceDrivers',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'drivers',
	                        'data-showTop10': false
	                    },
	                    key: 'f1-after-race-drivers-' + gpId
	                }, {
	                    name: 'F1PointsAfterRace',
	                    groupTitle: 'Drivers after race',
	                    groupKey: 'afterRaceDrivers',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'drivers',
	                        'data-showTop10': true
	                    },
	                    key: 'f1-after-race-drivers-' + gpId
	                }, {
	                    name: 'F1PointsAfterRace',
	                    groupTitle: 'Constructor cup after race',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'teams'
	                    },
	                    key: 'f1-after-race-' + gpId
	                }, {
	                    name: 'F1AnimatedStartingGridSMWidget',
	                    groupTitle: 'Animated Starting Grid Widget',
	                    props: {
	                        'data-gpx-id': gpId,
	                        'data-type': 'teams'
	                    },
	                    key: 'f1-starting-grid-' + gpId
	                }]));
	            });
	        }
	    }, {
	        key: 'renderPractice',
	        value: function renderPractice(gpId) {
	            return Promise.resolve(_lodash2.default.flatten(['p1', 'p2', 'p3'].map(function (type) {
	                return [
	                // {
	                //     name: 'F1RaceResultsSMWidget',
	                //     groupKey: `session-${type}-${gpId}`,
	                //     groupTitle: `Session ${type}`,
	
	                //     props: {
	                //         'data-gp-id': gpId,
	                //         'data-type': type
	                //     },
	                //     key: `f1-${type}-${gpId}`
	                // },
	                {
	                    name: 'F1RaceDetailedResultsSMWidget',
	                    groupKey: 'session-full-' + type + '-' + gpId,
	                    groupTitle: 'Session ' + type,
	                    props: {
	                        'data-gp-id': gpId,
	                        'data-type': type
	                    },
	                    key: 'f1-d-' + type + '-' + gpId
	                }];
	            })));
	        }
	    }]);
	
	    return EISMStream;
	}(_SMStream3.default);
	
	exports.default = EISMStream;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	var _SMPostDialog2 = _interopRequireDefault(_SMPostDialog);
	
	var _queryString = __webpack_require__(1055);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _WidgetNestedMenu = __webpack_require__(1502);
	
	var _WidgetNestedMenu2 = _interopRequireDefault(_WidgetNestedMenu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SMPostPage = function (_React$Component) {
	    _inherits(SMPostPage, _React$Component);
	
	    function SMPostPage(props, context) {
	        _classCallCheck(this, SMPostPage);
	
	        var _this = _possibleConstructorReturn(this, (SMPostPage.__proto__ || Object.getPrototypeOf(SMPostPage)).call(this, props, context));
	
	        _this.templateObserver = _this.context.templateObserver;
	        return _this;
	    }
	
	    _createClass(SMPostPage, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var templateId = this.templateObserver.getTemplate();
	            var widgets = this.context.widgets;
	
	
	            var widget = _lodash2.default.find(widgets, function (w) {
	                return w.id === _this2.props.params.widgetId;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wdp-container' },
	                    _react2.default.createElement(_SMPostDialog2.default, {
	                        key: templateId + '_' + (widget && widget.name),
	                        templateId: templateId,
	                        previewWidget: widget && _lodash2.default.extend({}, widget, {
	                            name: widget.id,
	                            props: _RCore2.default.obj2InjectorParams(this.props.location.query)
	                        }),
	                        title: _react2.default.createElement(_WidgetNestedMenu2.default, {
	                            widgets: widgets,
	                            widgetId: this.props.params.widgetId,
	                            onChange: function onChange(e, widget) {
	                                _this2.props.router.push('/sm/browser/post/' + widget.id);
	                            }
	                        }),
	                        open: true,
	                        inline: true,
	                        showAllParams: true,
	                        onRequestClose: function onRequestClose() {
	                            return _this2.setState({ widget: null }, function () {
	                                _this2.props.router.replace({ pathname: location.pathname });
	                            });
	                        },
	                        onPropsChange: function onPropsChange(props) {
	                            var location = _this2.props.location;
	                            var query = _queryString2.default.stringify(_RCore2.default.prepareWidgetPropsObj(props));
	                            window.history.pushState({}, '', location.pathname + '?' + query);
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SMPostPage;
	}(_react2.default.Component);
	
	SMPostPage.contextTypes = {
	    user: _propTypes2.default.object.isRequired,
	    templateObserver: _propTypes2.default.object.isRequired,
	    campaigns: _propTypes2.default.array.isRequired,
	    widgets: _propTypes2.default.array.isRequired
	};
	exports.default = SMPostPage;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SMBrowserMenu = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    font-size: 26px;\n    line-height: 36px;\n    font-weight: 300;\n    padding-left: 5px;\n    padding-right: 15px;\n'], ['\n    font-size: 26px;\n    line-height: 36px;\n    font-weight: 300;\n    padding-left: 5px;\n    padding-right: 15px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _mood = __webpack_require__(1710);
	
	var _mood2 = _interopRequireDefault(_mood);
	
	var _expandMore = __webpack_require__(832);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _navigationArrowDropRight = __webpack_require__(1134);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _expandLess = __webpack_require__(831);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var C_DEFAULT_TEMPLATE = 'C_DEFAULT_TEMPLATE';
	
	var SMToolbarTitle = _styledComponents2.default.span(_templateObject);
	
	var TemplateObserver = function TemplateObserver(px) {
	    this.template = null;
	    this.subscriptions = [];
	};
	
	TemplateObserver.prototype.getTemplate = function () {
	    return this.template;
	};
	
	TemplateObserver.prototype.setTemplate = function (template) {
	    this.template = template;
	    _lodash2.default.values(this.subscriptions).forEach(function (f) {
	        return f();
	    });
	};
	
	TemplateObserver.prototype.subscribe = function (f) {
	    this.subscriptions.push(f);
	};
	
	TemplateObserver.prototype.unsubscribe = function (func) {
	    this.subscriptions = _lodash2.default.filter(this.subscriptions, function (f) {
	        return f !== func;
	    });
	};
	
	var SMBrowser = function (_React$Component) {
	    _inherits(SMBrowser, _React$Component);
	
	    function SMBrowser(props, context) {
	        _classCallCheck(this, SMBrowser);
	
	        var _this = _possibleConstructorReturn(this, (SMBrowser.__proto__ || Object.getPrototypeOf(SMBrowser)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var allParams = _lodash2.default.extend({}, props.params || {}, _lodash2.default.reduce(props.router.routes, function (m, p) {
	            return _lodash2.default.extend(m, p.params);
	        }, {}));
	        _this.state = {
	            templates: [],
	            campaigns: [],
	            widgets: [],
	            sport: allParams.sport || 'football'
	        };
	        _this.templateObserver = new TemplateObserver();
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(SMBrowser, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                templates = _state.templates,
	                template = _state.template,
	                tournaments = _state.tournaments,
	                sport = _state.sport;
	
	            if (!template) return _react2.default.createElement(
	                'div',
	                null,
	                'loading'
	            );
	            var nestedParams = _lodash2.default.clone(this.props.params);
	
	            _lodash2.default.reduce(this.props.routes, function (sum, item) {
	                return _lodash2.default.extend(sum, item.params);
	            }, nestedParams);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { id: 'hostforstylemanager' }),
	                !nestedParams.disableTemplateChange && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        rmd.SelectField,
	                        {
	                            value: this.state.template && this.state.template.id,
	                            floatingLabelFixed: true,
	                            floatingLabelText: 'Template',
	                            style: { margin: '0 auto' },
	                            onChange: function onChange(event, index, val) {
	                                localStorage.setItem(C_DEFAULT_TEMPLATE, val);
	                                _this2.templateObserver.setTemplate(val);
	                                var template = _lodash2.default.find(templates, function (t) {
	                                    return t.id === val;
	                                });
	                                _this2.setState({
	                                    template: template
	                                });
	                            }
	                        },
	                        templates.filter(function (t) {
	                            return _this2.state.showHidden ? t.isHidden : !t.isHidden;
	                        }).map(function (tpl, i) {
	                            return _react2.default.createElement(rmd.MenuItem, { key: tpl.name, primaryText: tpl.name, value: tpl.id });
	                        })
	                    )
	                ),
	                this.renderSportSubMenu(),
	                this.props.children
	            );
	        }
	    }]);
	
	    return SMBrowser;
	}(_react2.default.Component);
	
	SMBrowser.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	SMBrowser.childContextTypes = {
	    templateObserver: _propTypes2.default.object,
	    campaigns: _propTypes2.default.array,
	    widgets: _propTypes2.default.array
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this5 = this;
	
	    this.getChildContext = function () {
	        return {
	            templateObserver: _this5.templateObserver,
	            campaigns: _this5.state.campaigns,
	            widgets: _this5.state.widgets
	        };
	    };
	
	    this.componentWillReceiveProps = function (nextProps) {
	        var allParams = _lodash2.default.extend({}, nextProps.params, _lodash2.default.reduce(_this5.props.router.routes, function (m, p) {
	            return _lodash2.default.extend(m, p.params);
	        }, {}));
	        if (allParams.sport !== _this5.state.sport) {
	            _this5.setState({
	                sport: allParams.sport
	            }, function () {
	                _this5.loadData();
	            });
	        }
	    };
	
	    this.loadData = function (additionalStateParams) {
	        var user = _this5.context.user;
	        if (!user || !user.client) return null;
	        var sportId = _RCore2.default.sportToId(_this5.state.sport || 'football');
	
	        var isF1 = _this5.state.sport === 'f1';
	        var authToken = _auth2.default.getAccessToken();
	
	        var lastUsedTemplate = localStorage.getItem(C_DEFAULT_TEMPLATE);
	
	        return _RCore2.default.promiseProps({
	            templates: fetch('/api/templates/list?access_token=' + authToken).then(function (response) {
	                return response.json();
	            }),
	            campaigns: fetch(_cfg2.default.campaign_manager.host + '/api/campaigns?access_token=' + authToken).then(function (response) {
	                return response.json();
	            }).then(function (r) {
	                return r.campaigns;
	            }).catch(function (e) {
	                return [];
	            }),
	
	            widgets: fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + authToken + '&template=' + lastUsedTemplate).then(function (response) {
	                return response.json();
	            }).then(function (resp) {
	                return resp.widgets;
	            }),
	
	            tournaments: !isF1 && fetch(_cfg2.default.apis.ss2 + '/tournaments?sportId=' + sportId).then(function (response) {
	                return response.json();
	            }).then(function (tournaments) {
	                var tournamentsList = _lodash2.default.filter(tournaments, function (t) {
	                    return t.isTop === true || _cfg2.default.triggerer.supportedLeagues.indexOf(t.id) !== -1;
	                });
	                if (tournamentsList.length === 0) tournamentsList = _lodash2.default.chain(tournaments).filter(function (t) {
	                    return t.isActive;
	                }).sortBy(function (t) {
	                    return t.rank;
	                }).take(10).value();
	                return tournamentsList;
	            }),
	            gpxs: isF1 && fetch(_cfg2.default.apis.ss2 + '/f1/gpx').then(function (response) {
	                return response.json();
	            })
	        }).then(function (result) {
	            var template = _lodash2.default.find(result.templates, function (t) {
	                return t.id === localStorage.getItem(C_DEFAULT_TEMPLATE);
	            }) || _lodash2.default.last(result.templates);
	
	            _this5.templateObserver.setTemplate(template.id);
	            _this5.setState(_extends({}, result, {
	                template: template,
	                isLoading: false
	            }, additionalStateParams));
	        }).catch(function (e) {
	            _this5.setState(_extends({
	                error: e,
	                isLoading: false
	            }, additionalStateParams));
	        });
	    };
	
	    this.renderSportSubMenu = function () {
	        var _state2 = _this5.state,
	            sport = _state2.sport,
	            tournaments = _state2.tournaments,
	            gpxs = _state2.gpxs,
	            templates = _state2.templates,
	            template = _state2.template;
	
	        var params = _this5.props.params;
	        var selectedTournament = _lodash2.default.find(tournaments, function (t) {
	            return t.id === +params.tournamentId;
	        });
	
	        var smbTournaments = _lodash2.default.get(_this5.context.user, 'props.smbTournaments');
	        if (!_lodash2.default.isArray(smbTournaments) || smbTournaments.length === 0) smbTournaments = tournaments.map(function (t) {
	            return t.id;
	        });
	        switch (sport) {
	            case 'f1':
	                return _react2.default.createElement(
	                    'div',
	                    { style: { background: '#ccc' } },
	                    gpxs && gpxs.map(function (gpx) {
	                        var selected = +params.gpId === +gpx.id;
	                        return _react2.default.createElement(rmd.FlatButton, {
	                            key: +gpx.id,
	                            onClick: function onClick(value) {
	                                _this5.props.router.push('/sm/browser/' + sport + '/gpx/' + gpx.id);
	                            },
	                            primary: selected,
	                            label: gpx.country
	                        });
	                    })
	                );
	            default:
	                return selectedTournament && _react2.default.createElement(
	                    'div',
	                    { title: selectedTournament && selectedTournament.name },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        smbTournaments.map(function (tid) {
	                            return _lodash2.default.find(tournaments, function (t) {
	                                return t.id === tid;
	                            });
	                        }).map(function (t) {
	                            var tname = t.name.replace(t.countryName, '').trim();
	                            return _react2.default.createElement(rmd.RaisedButton, {
	                                key: t.id,
	                                onClick: function onClick(e) {
	                                    _this5.props.router.push('/sm/browser/' + params.sport + '/tournaments/' + t.id);
	                                },
	                                primary: selectedTournament && selectedTournament.id === t.id,
	                                label: tname
	                            });
	                        })
	                    )
	                );
	        }
	    };
	};
	
	var SMBrowserMenu = function (_React$Component2) {
	    _inherits(SMBrowserMenu, _React$Component2);
	
	    function SMBrowserMenu(props, context) {
	        _classCallCheck(this, SMBrowserMenu);
	
	        var _this3 = _possibleConstructorReturn(this, (SMBrowserMenu.__proto__ || Object.getPrototypeOf(SMBrowserMenu)).call(this, props, context));
	
	        _initialiseProps2.call(_this3);
	
	        var allParams = _lodash2.default.extend({}, props.params || {}, _lodash2.default.reduce(props.router.routes, function (m, p) {
	            return _lodash2.default.extend(m, p.params);
	        }, {}));
	        _this3.state = {
	            templates: [],
	            sport: allParams.sport || 'football'
	        };
	        return _this3;
	    }
	
	    _createClass(SMBrowserMenu, [{
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var sport = this.state.sport;
	
	            var btnStyle = { height: '64px', color: '#fff' };
	
	            var sports = {
	                football: { label: 'Football', icon: _react2.default.createElement(_mood2.default, null)
	                    // handball: { label: 'Handball', icon: <IconSocial /> },
	                    // hockey: { label: 'Hockey', icon: <IconSocial /> },
	                    // f1: { label: 'F1', icon: <IconSocial /> }
	                } };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _lodash2.default.keys(sports).map(function (btnSport) {
	                    var selected = btnSport === sport;
	
	                    return _react2.default.createElement(rmd.FlatButton, _extends({
	                        key: btnSport + '_' + selected,
	                        style: _lodash2.default.extend({}, btnStyle, selected && { backgroundColor: '#00BCD4' }),
	                        onClick: _this4.handleOpenSport.bind(_this4, btnSport)
	                    }, sports[btnSport]));
	                })
	            );
	        }
	    }]);
	
	    return SMBrowserMenu;
	}(_react2.default.Component);
	
	var _initialiseProps2 = function _initialiseProps2() {
	    var _this6 = this;
	
	    this.componentWillReceiveProps = function (nextProps) {
	        var allParams = _lodash2.default.extend({}, nextProps.params, _lodash2.default.reduce(_this6.props.router.routes, function (m, p) {
	            return _lodash2.default.extend(m, p.params);
	        }, {}));
	        if (allParams.sport !== _this6.state.sport) {
	            _this6.setState({
	                sport: allParams.sport
	            });
	        }
	    };
	
	    this.handleOpenSport = function (sport, e) {
	        _this6.props.router.push('/sm/browser/' + sport);
	    };
	};
	
	exports.default = SMBrowser;
	exports.SMBrowserMenu = SMBrowserMenu;

/***/ },
/* 1710 */,
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(1121);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _googleClientApi = __webpack_require__(1074);
	
	var _googleClientApi2 = _interopRequireDefault(_googleClientApi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetStats = function (_React$Component) {
	    _inherits(WidgetStats, _React$Component);
	
	    function WidgetStats(props, context) {
	        _classCallCheck(this, WidgetStats);
	
	        var _this = _possibleConstructorReturn(this, (WidgetStats.__proto__ || Object.getPrototypeOf(WidgetStats)).call(this, props, context));
	
	        _this.buildCharts = function (wiid) {
	
	            return fetch(_cfg2.default.dash.api.host + "/api/auth/google/token").then(function (response) {
	                return response.json();
	            }).then(function (tokens) {
	                gapi.analytics.auth.authorize({
	                    'serverAuth': {
	                        'access_token': tokens.access_token
	                    }
	                });
	
	                var viewSelector = new gapi.analytics.ViewSelector({
	                    container: 'view-selector'
	                });
	                viewSelector.execute();
	
	                var dataChart = new gapi.analytics.googleCharts.DataChart({
	                    query: {
	                        metrics: 'ga:sessions, ga:pageviews, ga:users',
	                        dimensions: 'ga:date',
	                        filters: "ga:pagePath=@" + wiid,
	                        'start-date': '30daysAgo',
	                        'end-date': 'yesterday'
	                    },
	                    chart: {
	                        container: 'timeline',
	                        type: 'LINE',
	                        options: {
	                            width: '100%'
	                        }
	                    }
	                });
	                viewSelector.on('change', function (ids) {
	                    var newIds = {
	                        query: {
	                            ids: ids
	                        }
	                    };
	                    dataChart.set(newIds).execute();
	                });
	            });
	        };
	
	        _this.state = {
	            widget: {}
	        };
	        return _this;
	    }
	
	    _createClass(WidgetStats, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: "loadData",
	        value: function loadData() {
	            var _this2 = this;
	
	            var user = this.context.user;
	
	            var widgetId = this.props.params.wiid;
	
	            if (!user || !user.client) return null;
	
	            return fetch(_cfg2.default.dash.api.host + "/api/widgets/" + widgetId).then(function (response) {
	                return response.json();
	            }).then(function (widget) {
	                var wiid = widget.props && widget.props.wiid || widget._id || widgetId;
	                _this2.setState({ widget: widget });
	                return (0, _googleClientApi2.default)().then(function (gapi) {
	
	                    gapi.load('analytics', function () {
	                        return _this2.buildCharts(wiid);
	                    });
	                });
	            }).catch(function (err) {
	                _this2.setState({ error: err, isLoading: false });
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var user = this.context.user;
	            var widget = this.state.widget;
	
	            var wiid = widget && widget.props && widget.props.wiid;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "widget-stats" },
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    wiid
	                ),
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    widget.widgetName
	                ),
	                _react2.default.createElement("div", { id: "view-selector", style: { display: 'none' } }),
	                _react2.default.createElement("div", { id: "timeline" })
	            );
	        }
	    }]);
	
	    return WidgetStats;
	}(_react2.default.Component);
	
	WidgetStats.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = WidgetStats;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _under_construction = __webpack_require__(1060);
	
	var _under_construction2 = _interopRequireDefault(_under_construction);
	
	var _tw = __webpack_require__(1061);
	
	var _tw2 = _interopRequireDefault(_tw);
	
	var _fb = __webpack_require__(1062);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _st = __webpack_require__(1713);
	
	var _st2 = _interopRequireDefault(_st);
	
	var _edit_theme = __webpack_require__(1063);
	
	var _edit_theme2 = _interopRequireDefault(_edit_theme);
	
	var _create_widget = __webpack_require__(1064);
	
	var _create_widget2 = _interopRequireDefault(_create_widget);
	
	var _suggested = __webpack_require__(1065);
	
	var _suggested2 = _interopRequireDefault(_suggested);
	
	var _googleClientApi = __webpack_require__(1074);
	
	var _googleClientApi2 = _interopRequireDefault(_googleClientApi);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientStats = function (_React$Component) {
	    _inherits(ClientStats, _React$Component);
	
	    function ClientStats(props, context) {
	        _classCallCheck(this, ClientStats);
	
	        var _this = _possibleConstructorReturn(this, (ClientStats.__proto__ || Object.getPrototypeOf(ClientStats)).call(this, props, context));
	
	        _this.loadData = function () {
	            var user = _this.context.user;
	
	
	            if (!user || !user.client) return null;
	
	            return fetch(_cfg2.default.dash.api.host + '/api/users?client=' + user.client + '&access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (body) {
	                return _this.setState({ users: body.users, isLoading: false });
	            }).catch(function (err) {
	                _this.setState({ error: err, isLoading: false });
	            });
	        };
	
	        _this.buildCharts = function (path, viewSelectorContainer, chartContainer) {
	
	            var viewSelector = new gapi.analytics.ViewSelector({
	                container: viewSelectorContainer
	            });
	            viewSelector.execute();
	
	            var dataChart = new gapi.analytics.googleCharts.DataChart({
	                query: {
	                    metrics: 'ga:sessions, ga:pageviews, ga:users',
	                    dimensions: 'ga:date',
	                    filters: 'ga:pagePath=@' + path,
	                    'start-date': '30daysAgo',
	                    'end-date': 'yesterday'
	                },
	                chart: {
	                    container: chartContainer,
	                    type: 'LINE',
	                    options: {
	                        width: '100%'
	                    }
	                }
	            });
	            viewSelector.on('change', function (ids) {
	                var newIds = {
	                    query: {
	                        ids: ids
	                    }
	                };
	                dataChart.set(newIds).execute();
	            });
	        };
	
	        _this.state = {
	            users: [],
	            isLoading: true
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(ClientStats, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var user = this.context.user;
	
	            (0, _googleClientApi2.default)().then(function (gapi) {
	                gapi.load('analytics', function () {
	                    return fetch(_cfg2.default.dash.api.host + '/api/auth/google/token').then(function (response) {
	                        return response.json();
	                    }).then(function (tokens) {
	                        gapi.analytics.auth.authorize({
	                            'serverAuth': {
	                                'access_token': tokens.access_token
	                            }
	                        });
	                        _this2.buildCharts(user.client, "view-selector-client", "timeline-client");
	                        _this2.state.users.forEach(function (user, i) {
	                            setTimeout(_this2.buildCharts.bind(_this2, "/" + user.username + "/", 'view-selector-' + user._id, 'timeline-' + user._id), i * 300);;
	                        });
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'home' },
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Hi, ',
	                        user.username
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12', style: { display: 'block' } },
	                        _react2.default.createElement(
	                            rmd.Card,
	                            { className: 'home-info-card' },
	                            _react2.default.createElement(rmd.CardTitle, {
	                                title: (user.client + ' client stats').toUpperCase()
	                            }),
	                            _react2.default.createElement('div', { id: 'view-selector-client', style: { display: 'none' } }),
	                            _react2.default.createElement('div', { id: 'timeline-client' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        rmd.Subheader,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Stats per user:'
	                        )
	                    ),
	                    this.state.users.map(function (user) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12', style: { display: 'block' } },
	                            _react2.default.createElement(
	                                rmd.Card,
	                                { className: 'home-info-card' },
	                                _react2.default.createElement(rmd.CardTitle, {
	                                    title: '' + user.username
	                                }),
	                                _react2.default.createElement('div', { id: 'view-selector-' + user._id, style: { display: 'none' } }),
	                                _react2.default.createElement('div', { id: 'timeline-' + user._id })
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ClientStats;
	}(_react2.default.Component);
	
	ClientStats.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = ClientStats;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/assets/st.png";

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _under_construction = __webpack_require__(1060);
	
	var _under_construction2 = _interopRequireDefault(_under_construction);
	
	var _tw = __webpack_require__(1061);
	
	var _tw2 = _interopRequireDefault(_tw);
	
	var _fb = __webpack_require__(1062);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _st = __webpack_require__(1713);
	
	var _st2 = _interopRequireDefault(_st);
	
	var _edit_theme = __webpack_require__(1063);
	
	var _edit_theme2 = _interopRequireDefault(_edit_theme);
	
	var _create_widget = __webpack_require__(1064);
	
	var _create_widget2 = _interopRequireDefault(_create_widget);
	
	var _suggested = __webpack_require__(1065);
	
	var _suggested2 = _interopRequireDefault(_suggested);
	
	var _googleClientApi = __webpack_require__(1074);
	
	var _googleClientApi2 = _interopRequireDefault(_googleClientApi);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetsStats = function (_React$Component) {
	    _inherits(WidgetsStats, _React$Component);
	
	    function WidgetsStats(props, context) {
	        _classCallCheck(this, WidgetsStats);
	
	        var _this = _possibleConstructorReturn(this, (WidgetsStats.__proto__ || Object.getPrototypeOf(WidgetsStats)).call(this, props, context));
	
	        _this.loadData = function () {
	            var user = _this.context.user;
	
	
	            if (!user || !user.client) return null;
	
	            return fetch(_cfg2.default.dash.api.host + '/api/widgets/names?client=' + user.client).then(function (response) {
	                return response.json();
	            }).then(function (body) {
	                return _this.setState({ widgets: body.widgets, isLoading: false });
	            }).catch(function (err) {
	                _this.setState({ error: err, isLoading: false });
	            });
	        };
	
	        _this.buildCharts = function (path, viewSelectorContainer, chartContainer) {
	
	            var viewSelector = new gapi.analytics.ViewSelector({
	                container: viewSelectorContainer
	            });
	            viewSelector.execute();
	
	            var dataChart = new gapi.analytics.googleCharts.DataChart({
	                query: {
	                    metrics: 'ga:sessions, ga:pageviews, ga:users',
	                    dimensions: 'ga:date',
	                    filters: 'ga:pagePath=@' + path,
	                    'start-date': '30daysAgo',
	                    'end-date': 'yesterday'
	                },
	                chart: {
	                    container: chartContainer,
	                    type: 'LINE',
	                    options: {
	                        width: '100%'
	                    }
	                }
	            });
	            viewSelector.on('change', function (ids) {
	                var newIds = {
	                    query: {
	                        ids: ids
	                    }
	                };
	                dataChart.set(newIds).execute();
	            });
	        };
	
	        _this.state = {
	            widgets: [],
	            isLoading: true
	        };
	
	        _this.loadData();
	        return _this;
	    }
	
	    _createClass(WidgetsStats, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var user = this.context.user;
	
	            (0, _googleClientApi2.default)().then(function (gapi) {
	                gapi.load('analytics', function () {
	                    return fetch(_cfg2.default.dash.api.host + '/api/auth/google/token').then(function (response) {
	                        return response.json();
	                    }).then(function (tokens) {
	                        gapi.analytics.auth.authorize({
	                            'serverAuth': {
	                                'access_token': tokens.access_token
	                            }
	                        });
	                        _this2.state.widgets.forEach(function (widget, i) {
	                            setTimeout(_this2.buildCharts.bind(_this2, "/" + widget + "/", 'view-selector-' + widget, 'timeline-' + widget), i * 300);;
	                        });
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.context.user;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'home' },
	                _react2.default.createElement(
	                    rmd.Subheader,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Hi, ',
	                        user.username
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        rmd.Subheader,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Stats per widget:'
	                        )
	                    ),
	                    this.state.widgets.map(function (widget) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12', style: { display: 'block' } },
	                            _react2.default.createElement(
	                                rmd.Card,
	                                { className: 'home-info-card' },
	                                _react2.default.createElement(rmd.CardTitle, {
	                                    title: '' + widget
	                                }),
	                                _react2.default.createElement('div', { id: 'view-selector-' + widget, style: { display: 'none' } }),
	                                _react2.default.createElement('div', { id: 'timeline-' + widget })
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return WidgetsStats;
	}(_react2.default.Component);
	
	WidgetsStats.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	exports.default = WidgetsStats;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1716);
	
	var _Editor = __webpack_require__(1717);
	
	var _editor = __webpack_require__(1756);
	
	var _materialUi = __webpack_require__(642);
	
	var _NetflixGallery = __webpack_require__(1729);
	
	var _NetflixGallery2 = _interopRequireDefault(_NetflixGallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveButton = (0, _editor.withEditorWidget)(_materialUi.FlatButton);
	
	var WidgetPortfolio = function (_React$Component) {
	    _inherits(WidgetPortfolio, _React$Component);
	
	    function WidgetPortfolio() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WidgetPortfolio);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WidgetPortfolio.__proto__ || Object.getPrototypeOf(WidgetPortfolio)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            edit: null,
	            addWidgetTo: null
	        }, _this.actionsForEdit = [_react2.default.createElement(SaveButton, {
	            key: 'save',
	            label: 'save',
	            primary: true,
	            onClick: function onClick(e, _ref2) {
	                var widgetId = _ref2.widgetId,
	                    widgetProps = _ref2.widgetProps;
	
	                _this.props.updateWidget(_this.props.portfolio.type, _this.state.edit._id, {
	                    wid: widgetId,
	                    props: widgetProps
	                }).then(function () {
	                    _this.setState({ edit: null });
	                });
	            }
	        }), _react2.default.createElement(_materialUi.FlatButton, {
	            key: 'close',
	            label: 'close',
	            primary: true,
	            onClick: function onClick() {
	                _this.setState({ edit: null });
	            }
	        })], _this.actionsForCreate = [_react2.default.createElement(SaveButton, {
	            key: 'save',
	            label: 'save',
	            primary: true,
	            onClick: function onClick(e, _ref3) {
	                var widgetId = _ref3.widgetId,
	                    widgetProps = _ref3.widgetProps;
	
	                _this.props.addWidget(_this.props.portfolio.type, _this.state.addWidgetTo, {
	                    wid: widgetId,
	                    props: widgetProps
	                }).then(function () {
	                    _this.setState({ addWidgetTo: null });
	                });
	            }
	        }), _react2.default.createElement(_materialUi.FlatButton, {
	            key: 'close',
	            label: 'close',
	            primary: true,
	            onClick: function onClick() {
	                _this.setState({ addWidgetTo: null });
	            }
	        })], _this.render = function () {
	            var _this$props = _this.props,
	                portfolio = _this$props.portfolio,
	                createCategory = _this$props.createCategory;
	            var edit = _this.state.edit;
	
	            if (!portfolio) return _react2.default.createElement(
	                'div',
	                null,
	                '...'
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'column', flexGrow: 1 } },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Portfolio',
	                    ' ',
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        label: 'Create group',
	                        onClick: function onClick() {
	                            var name = prompt('name');
	                            // alert(name);
	                            createCategory(portfolio.type, name);
	                        }
	                    })
	                ),
	                portfolio.categories.map(function (category) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: category },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            category,
	                            _react2.default.createElement(_materialUi.FlatButton, {
	                                label: 'Add widget',
	                                onClick: function onClick() {
	                                    _this.setState({
	                                        addWidgetTo: category,
	                                        addWidgetTitle: 'Add widget to ' + category
	                                    });
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(_NetflixGallery2.default, {
	                            key: category + '_',
	                            list: portfolio.widgets.filter(function (w) {
	                                return w.category === category;
	                            }),
	                            renderKey: function renderKey(w, props) {
	                                return w._id + '_';
	                            },
	                            renderFullView: function renderFullView(w) {
	                                return _react2.default.createElement(
	                                    'h1',
	                                    null,
	                                    w.id
	                                );
	                            },
	                            renderItem: function renderItem(w, props) {
	                                return _react2.default.createElement(_NetflixGallery.WidgetPreview, _extends({
	                                    key: w._id
	                                }, props, {
	                                    widget: w,
	                                    allowZoom: true,
	                                    widgetId: w.wid,
	                                    props: _extends({}, w.props),
	                                    wdpcache: 'state',
	                                    onClick: function onClick() {
	                                        _this.setState({ edit: w });
	                                    }
	                                }));
	                            }
	                        })
	                    );
	                }),
	                edit && _react2.default.createElement(_Editor.EditorDialogue, {
	                    key: edit.wid,
	                    open: edit,
	                    widgetId: edit.wid,
	                    widgetProps: edit.props,
	                    actions: _this.actionsForEdit,
	                    onChange: function onChange(widget, params) {}
	                }),
	                _react2.default.createElement(_Editor.EditorDialogue, {
	                    open: _this.state.addWidgetTo,
	                    title: _this.state.addWidgetTitle,
	                    allowChangeWidget: true,
	                    actions: _this.actionsForCreate
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return WidgetPortfolio;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref4, _ref5) {
	    var user = _ref4.user,
	        portfolio = _ref4.portfolio;
	    var params = _ref5.params;
	
	    return {
	        user: user,
	        portfolio: portfolio.byIds[params.type]
	    };
	};
	
	var mapDispatchToProps = { loadPortfolio: _actions.loadPortfolio, createCategory: _actions.createCategory, updateWidget: _actions.updateWidget, addWidget: _actions.addWidget };
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {
	        this.props.loadPortfolio(this.props.params.type);
	    }
	}))(WidgetPortfolio);

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadTemplate = exports.loadPortfolio = exports.updateWidget = exports.createCategory = exports.addWidget = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import cfg from 'cfg';
	// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
	
	
	var _constants = __webpack_require__(617);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addWidget = exports.addWidget = function addWidget(portfolio, category, spec) {
	    return function (dispatch) {
	        return fetch(_cfg2.default.dash.api.host + '/api/portfolio/' + portfolio + '/add-widget?access_token=' + _auth2.default.getAccessToken(), {
	            method: 'PUT',
	            headers: {
	                'Content-Type': 'application/json; charset=utf-8'
	            },
	            body: JSON.stringify(_extends({}, spec, {
	                category: category
	            }))
	        }).then(function (res) {
	            return res.status === 200 ? res.json() : new Error(res.text());
	        }).then(function () {
	            dispatch(loadPortfolio(portfolio));
	        }).catch(function (e) {
	            alert('e');
	        });
	    };
	};
	
	var createCategory = exports.createCategory = function createCategory(portfolio, name) {
	    return function (dispatch) {
	        return fetch(_cfg2.default.dash.api.host + '/api/portfolio/' + portfolio + '/create-category?access_token=' + _auth2.default.getAccessToken(), {
	            method: 'PUT',
	            headers: {
	                'Content-Type': 'application/json; charset=utf-8'
	            },
	            body: JSON.stringify({
	                name: name
	            })
	        }).then(function (res) {
	            return res.status === 200 ? res.json() : new Error(res.text());
	        }).then(function () {
	            dispatch(loadPortfolio(portfolio));
	        }).catch(function (e) {
	            alert('e');
	        });
	    };
	};
	
	var updateWidget = exports.updateWidget = function updateWidget(portfolio, id, data) {
	    return function (dispatch) {
	        return fetch(_cfg2.default.dash.api.host + '/api/portfolio/' + portfolio + '/update-widget/' + id + '?access_token=' + _auth2.default.getAccessToken(), {
	            method: 'PUT',
	            headers: {
	                'Content-Type': 'application/json; charset=utf-8'
	            },
	            body: JSON.stringify(data)
	        }).then(function (res) {
	            return res.status === 200 ? res.json() : new Error(res.text());
	        }).then(function () {
	            dispatch(loadPortfolio(portfolio));
	        }).catch(function (e) {
	            alert('e');
	        });
	    };
	};
	
	var loadPortfolio = exports.loadPortfolio = function loadPortfolio(portfolio) {
	    return function (dispatch, getState) {
	        return fetch(_cfg2.default.dash.api.host + '/api/portfolio/' + portfolio + '?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	            return res.status === 200 ? res.json() : new Error(res.text());
	        }).then(function (portfolio) {
	            dispatch({
	                type: _constants.LOAD_PORTFOLIO,
	                payload: portfolio
	            });
	        });
	    };
	};
	
	var loadTemplate = exports.loadTemplate = function loadTemplate(widgetId) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var widgets = _lodash2.default.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets', []);
	        var widget = widgets.find(function (w) {
	            return w.id === widgetId;
	        });
	
	        dispatch({
	            // type: WIDGET_SELECTED,
	            payload: widget
	        });
	    };
	};

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EditorDialogue = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _darkBaseTheme = __webpack_require__(1719);
	
	var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);
	
	var _MuiThemeProvider = __webpack_require__(906);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(907);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _materialUi = __webpack_require__(642);
	
	var _WidgetEdit = __webpack_require__(1720);
	
	var _WidgetEdit2 = _interopRequireDefault(_WidgetEdit);
	
	var _WidgetPickerStandalone = __webpack_require__(1780);
	
	var _WidgetPickerStandalone2 = _interopRequireDefault(_WidgetPickerStandalone);
	
	var _AllWidgetsOverview = __webpack_require__(1808);
	
	var _AllWidgetsOverview2 = _interopRequireDefault(_AllWidgetsOverview);
	
	var _reactCustomScrollbars = __webpack_require__(1738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Editor(_ref) {
	    var allowChangeWidget = _ref.allowChangeWidget,
	        widgetId = _ref.widgetId,
	        tab = _ref.tab,
	        widgetProps = _ref.widgetProps,
	        template = _ref.template,
	        openEditWidget = _ref.openEditWidget,
	        openPicker = _ref.openPicker,
	        mainAction = _ref.mainAction,
	        setTemplate = _ref.setTemplate;
	
	    return widgetId ? _react2.default.createElement(_WidgetEdit2.default, {
	        widgetId: widgetId,
	        widgetProps: widgetProps,
	        template: template,
	        tab: tab,
	        allowChangeWidget: allowChangeWidget,
	        onChangeWidgetRequest: openPicker,
	        mainAction: mainAction
	    }) : _react2.default.createElement(
	        _reactCustomScrollbars.Scrollbars,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { padding: 20 } },
	            _react2.default.createElement(_AllWidgetsOverview2.default, {
	                template: template,
	                onClick: function onClick(e, widget, template) {
	                    openEditWidget(widget.id, widget.props, template);
	                }
	            })
	        )
	    );
	}
	
	var EditorEnhanced = (0, _recompose.compose)((0, _reactRedux.connect)(function () {
	    return {};
	}, { setTemplate: _actions.setTemplate }), (0, _recompose.withStateHandlers)(function (_ref2) {
	    var template = _ref2.template,
	        widgetProps = _ref2.widgetProps,
	        widgetId = _ref2.widgetId;
	    return {
	        widgetId: widgetId,
	        widgetProps: widgetProps,
	        template: template
	    };
	}, {
	    openEditWidget: function openEditWidget() {
	        return function (widgetId, widgetProps, template) {
	            return { widgetId: widgetId, widgetProps: widgetProps, template: template };
	        };
	    },
	    openPicker: function openPicker() {
	        return function () {
	            return {
	                widgetId: null,
	                widgetProps: null
	            };
	        };
	    },
	    setTemplate: function setTemplate() {
	        return function (template) {
	            return { template: template };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        if (this.props.widgetId) {
	            this.props.openEditWidget(this.props.widgetId, this.props.widgetProps, this.props.template);
	        }
	
	        if (this.props.template) {
	            this.props.setTemplate(this.props.template);
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.widgetId != this.props.widgetId) {
	            this.props.openEditWidget(nextProps.widgetId, nextProps.widgetProps, nextProps.template);
	        }
	
	        if (this.props.template != nextProps.template) {
	            this.props.setTemplate(nextProps.template);
	        }
	    }
	}))(Editor);
	
	var defActions = function defActions(_ref3) {
	    var onRequestClose = _ref3.onRequestClose;
	    return [_react2.default.createElement(_materialUi.FlatButton, { key: 'close', label: 'close', primary: true, onClick: onRequestClose })];
	};
	
	var EditorDialogue = function EditorDialogue(_ref4) {
	    var title = _ref4.title,
	        actions = _ref4.actions,
	        _ref4$open = _ref4.open,
	        open = _ref4$open === undefined ? false : _ref4$open,
	        modal = _ref4.modal,
	        onRequestClose = _ref4.onRequestClose,
	        props = _objectWithoutProperties(_ref4, ['title', 'actions', 'open', 'modal', 'onRequestClose']);
	
	    return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: (0, _getMuiTheme2.default)(_darkBaseTheme2.default) },
	        _react2.default.createElement(
	            _materialUi.Dialog,
	            {
	                contentStyle: {
	                    minWidth: '1200px',
	                    maxWidth: '1600px',
	                    width: '90vh',
	                    height: '80vh',
	                    minHeight: '80vh'
	                },
	                bodyStyle: { padding: 0 },
	                title: title,
	                actions: actions,
	                modal: modal,
	                open: open,
	                autoDetectWindowHeight: true,
	                onRequestClose: onRequestClose
	            },
	            _react2.default.createElement(EditorEnhanced, props)
	        )
	    );
	};
	
	exports.default = EditorEnhanced;
	exports.EditorDialogue = EditorDialogue;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.recalculateArea = exports.setPreviewStatus = exports.setTemplate = exports.setWidgets = exports.resetSelectedWidget = exports.updateWidgetJSPropField = exports.changeWidgetJSProp = exports.setEditorWidget = exports.setEditorZoom = exports.setEditorAutoZoom = exports.opentTab = exports.loadWidget = exports.loadWidgets = exports.loadWidgetCMP = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
	
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _constants = __webpack_require__(612);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var loadWidgetCMP = exports.loadWidgetCMP = function loadWidgetCMP(widgetId) {
	    return function (dispatch) {
	        if (!widgetId) {
	            return;
	        }
	        window.wdploadsm(widgetId, {}, {}, function () {
	            dispatch({
	                type: _constants.WIDGET_CMP_LOADED,
	                payload: widgetId
	            });
	        });
	    };
	};
	
	var loadWidgets = exports.loadWidgets = function loadWidgets() {
	    return function (dispatch) {
	        return fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken() + '&social=true').then(function (response) {
	            return response.json();
	        }).then(function (_ref) {
	            var widgets = _ref.widgets;
	
	            return dispatch({
	                type: _constants.WIDGETS_LOAD,
	                payload: {
	                    set: 'all',
	                    widgets: widgets
	                }
	            });
	        });
	    };
	};
	
	var loadWidget = exports.loadWidget = function loadWidget(widgetId) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var keep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (dispatch, getState) {
	        var state = getState();
	
	        if (widgetId === state.editor.widgetId) return;
	        return fetch(_cfg2.default.dash.api.host + '/api/widgets/' + widgetId + '/spec?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	            return res.status === 200 ? res.json() : new Error(res.text());
	        }).then(function (widget) {
	            var state = getState();
	            var user = state.user;
	            // EXPERIMENTAL. set user defaults.
	
	            var username = user.username,
	                client = user.client;
	
	            // let lang = user.defaultProps.find(({ key }) => key === 'lang');
	            // let timezone = user.defaultProps.find(({ key }) => key === 'timezone');
	
	            var _user$props = user.props,
	                _user$props$lang = _user$props.lang,
	                lang = _user$props$lang === undefined ? 'da' : _user$props$lang,
	                _user$props$tz = _user$props.tz,
	                tz = _user$props$tz === undefined ? 'CET' : _user$props$tz;
	
	
	            var defProps = { lang: lang, tz: tz, username: username, client: client };
	            if (keep) {
	                params = state.editor.jsprops;
	            }
	
	            // if (_.isEmpty(params) && widget.layouts) {
	            //     dispatch(opentTab(EDITOR.TABS.LAYOUT));
	            // }
	            dispatch({
	                type: _constants.WIDGET_SELECTED,
	                payload: {
	                    widget: widget,
	                    params: _extends({}, defProps, params)
	                }
	            });
	        }).catch(function (e) {
	            alert('e' + e.message);
	        });
	    };
	};
	
	var opentTab = exports.opentTab = function opentTab(tab) {
	    return function (dispatch) {
	        dispatch({
	            type: _constants.EDITOR_TAB_OPEN,
	            payload: tab
	        });
	    };
	};
	
	var setEditorAutoZoom = exports.setEditorAutoZoom = function setEditorAutoZoom(autozoom) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.EDITOR_AUTO_ZOOM,
	            payload: autozoom
	        });
	    };
	};
	
	var setEditorZoom = exports.setEditorZoom = function setEditorZoom(zoom, autozoom) {
	    return {
	        type: _constants.EDITOR_ZOOM,
	        payload: { zoom: zoom, autozoom: autozoom }
	    };
	};
	
	var setEditorWidget = function setEditorWidget(widgetId) {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        if (widgetId != state.editor.widgetId) {
	            // remove from selected params wcwidth, cause new layout can have its own wcwidth
	            var _state$editor$jsprops = state.editor.jsprops,
	                wcwidth = _state$editor$jsprops.wcwidth,
	                newProps = _objectWithoutProperties(_state$editor$jsprops, ['wcwidth']);
	
	            dispatch(loadWidget(widgetId, _extends({}, newProps)));
	        }
	    };
	};
	
	exports.setEditorWidget = setEditorWidget;
	var changeWidgetJSProp = exports.changeWidgetJSProp = function changeWidgetJSProp(payload) {
	    return function (dispatch) {
	        dispatch({
	            type: _constants.WIDGET_JSPROP_CHANGE,
	            payload: payload
	        });
	    };
	};
	
	var updateWidgetJSPropField = exports.updateWidgetJSPropField = function updateWidgetJSPropField(field, update) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.WIDGET_JSPROP_UPDATE_FILELD,
	            payload: {
	                field: field,
	                update: update
	            }
	        });
	    };
	};
	
	var resetSelectedWidget = exports.resetSelectedWidget = function resetSelectedWidget() {
	    return function (dispatch) {
	        dispatch({
	            type: _constants.EDITOR_RESET_WIDGET
	        });
	    };
	};
	
	var setWidgets = exports.setWidgets = function setWidgets(widgets, set) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.WIDGETS_LOAD,
	            payload: {
	                set: set,
	                widgets: widgets
	            }
	        });
	    };
	};
	
	var setTemplate = exports.setTemplate = function setTemplate(template) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.EDITOR_SET_TEMPLATE,
	            payload: template
	        });
	    };
	};
	
	var setPreviewStatus = exports.setPreviewStatus = function setPreviewStatus(status, error) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.EDITOR_SET_PREVIEW_STATUS,
	            payload: { status: status, error: error }
	        });
	    };
	};
	
	var recalculateArea = exports.recalculateArea = function recalculateArea(id, update) {
	    return function (dispatch, getState) {
	        var _getState = getState(),
	            editor = _getState.editor;
	
	        var area = _lodash2.default.get(editor, 'widgetProps.' + id, {});
	
	        area = _extends({}, area, update);
	
	        if (!isValid(area)) {
	            dispatch({
	                type: _constants.WIDGET_JSPROP_UPDATE_FILELD,
	                payload: {
	                    field: id,
	                    update: _extends({}, update, calcFitPosition(area))
	                }
	            });
	        } else {
	            dispatch({
	                type: _constants.WIDGET_JSPROP_UPDATE_FILELD,
	                payload: {
	                    field: id,
	                    update: update
	                }
	            });
	        }
	    };
	};
	
	var isValid = function isValid(area) {
	    var width = area.width,
	        height = area.height,
	        scale = area.scale,
	        x = area.x,
	        y = area.y,
	        cw = area.cw,
	        ch = area.ch;
	
	
	    var realWidth = width * scale;
	    var realHeight = height * scale;
	
	    var reachX = realWidth + x;
	    var reachY = realHeight + y;
	
	    var coverLeft = x <= 0.1;
	    var coverRight = reachX - cw >= -0.1;
	
	    var coverTop = y <= 1;
	    var coverBottom = reachY - ch >= -0.5;
	
	    return coverLeft && coverRight && coverTop && coverBottom;
	};
	
	var calcFitPosition = function calcFitPosition(area) {
	    var width = area.width,
	        height = area.height,
	        cw = area.cw,
	        ch = area.ch;
	
	    var neededScaleX = cw / width;
	    var neededScaleY = ch / height;
	
	    var scale = +Math.max(neededScaleX, neededScaleY).toFixed(3);
	    var x = (cw - width * scale).toFixed(3) / 2;
	    var y = (ch - height * scale).toFixed(3) / 2;
	
	    return {
	        scale: scale,
	        x: x,
	        y: y
	    };
	};

/***/ },
/* 1719 */,
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import PreviewAndVariations from './PreviewAndVariations';
	
	// import WidgetEmbed from './WidgetEmbed';
	
	// import EditorStandartLayout from './controls/EditorStandartLayout';
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _constants = __webpack_require__(612);
	
	var _actions2 = __webpack_require__(1047);
	
	var _BottomNavigation = __webpack_require__(840);
	
	var _layers = __webpack_require__(1721);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _widgets = __webpack_require__(1722);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _settingsApplications = __webpack_require__(1723);
	
	var _settingsApplications2 = _interopRequireDefault(_settingsApplications);
	
	var _chevronLeft = __webpack_require__(877);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _WidgetImageManipulations = __webpack_require__(1724);
	
	var _WidgetImageManipulations2 = _interopRequireDefault(_WidgetImageManipulations);
	
	var _WidgetDataManipulations = __webpack_require__(1726);
	
	var _WidgetDataManipulations2 = _interopRequireDefault(_WidgetDataManipulations);
	
	var _chevronRight = __webpack_require__(878);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _WidgetLayouts = __webpack_require__(1728);
	
	var _WidgetLayouts2 = _interopRequireDefault(_WidgetLayouts);
	
	var _PreviewAndVariations = __webpack_require__(1732);
	
	var _PreviewAndVariations2 = _interopRequireDefault(_PreviewAndVariations);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FlatButton = __webpack_require__(870);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _reactCustomScrollbars = __webpack_require__(1738);
	
	var _FastImagePicker = __webpack_require__(1755);
	
	var _FastImagePicker2 = _interopRequireDefault(_FastImagePicker);
	
	var _IMControls = __webpack_require__(1757);
	
	var _IMControls2 = _interopRequireDefault(_IMControls);
	
	var _PickerSwitcher = __webpack_require__(1763);
	
	var _PickerSwitcher2 = _interopRequireDefault(_PickerSwitcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetDataTab = function WidgetDataTab() {
	    return _react2.default.createElement(
	        'div',
	        { style: { margin: '0 12px' } },
	        _react2.default.createElement(_WidgetDataManipulations2.default, { title: 'Data selection', expanded: true }),
	        _react2.default.createElement(_WidgetDataManipulations2.default, { title: 'Look & feel', filter: _WidgetDataManipulations.uiFilter, expanded: true }),
	        _react2.default.createElement(_WidgetDataManipulations2.default, { title: 'Common', filter: _WidgetDataManipulations.commonFilter }),
	        _react2.default.createElement(
	            'div',
	            { style: { display: 'none' } },
	            _react2.default.createElement(_WidgetImageManipulations2.default, null)
	        )
	    );
	};
	
	var WidgetIMTab = function WidgetIMTab() {
	    return _react2.default.createElement(
	        'div',
	        { style: { margin: 12 } },
	        _react2.default.createElement(_WidgetImageManipulations2.default, null)
	    );
	};
	
	var TABS = [[_constants.EDITOR.TABS.LAYOUT, _widgets2.default, _WidgetLayouts.LayoutsImagesList, 'Layout'], [_constants.EDITOR.TABS.PARAMS, _settingsApplications2.default, WidgetDataTab, 'Data'], [_constants.EDITOR.TABS.IMAGE_MANIPULATIONS, _layers2.default, WidgetIMTab, 'Images']];
	
	var openV2PostDialogue = function openV2PostDialogue(e, widgetId, widgetProps) {
	    var schedulePost = JSON.stringify({
	        widgetId: widgetId,
	        widgetProps: widgetProps
	    });
	    localStorage.setItem('schedule_post', schedulePost);
	    window.location.href = '/v2/calendar?calendarView=month';
	};
	
	function WidgetEditor(_ref) {
	    var _this = this;
	
	    var tab = _ref.tab,
	        opentTab = _ref.opentTab,
	        widgetId = _ref.widgetId,
	        template = _ref.template,
	        resetSelectedWidget = _ref.resetSelectedWidget,
	        _ref$allowChangeWidge = _ref.allowChangeWidget,
	        allowChangeWidget = _ref$allowChangeWidge === undefined ? false : _ref$allowChangeWidge,
	        onChangeWidgetRequest = _ref.onChangeWidgetRequest,
	        mainAction = _ref.mainAction,
	        widgetProps = _ref.widgetProps;
	
	    var seletedTab = TABS.find(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 1),
	            key = _ref3[0];
	
	        return key === tab;
	    });
	    var LeftComponent = void 0;
	    if (seletedTab) LeftComponent = seletedTab[2];
	
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row', flexGrow: 1 } },
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    maxWidth: 280,
	                    minWidth: 280,
	                    height: '100vh',
	                    position: 'relative',
	                    display: 'flex',
	
	                    flexDirection: 'column',
	                    background: 'rgba(0,0,0,0.2)',
	                    borderRight: '1px solid rgba(0,0,0,0.2)'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                null,
	                allowChangeWidget && _react2.default.createElement(_FlatButton2.default, {
	                    icon: _react2.default.createElement(_chevronLeft2.default, null),
	                    style: { height: 40 },
	                    label: 'Change Widget',
	                    onClick: function onClick() {
	                        if (onChangeWidgetRequest) onChangeWidgetRequest();
	                        resetSelectedWidget();
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { background: '#20272d', display: 'flex', flexDirection: 'row' } },
	                    _react2.default.createElement(
	                        _BottomNavigation.BottomNavigation,
	                        { selectedIndex: TABS.findIndex(function (_ref4) {
	                                var _ref5 = _slicedToArray(_ref4, 1),
	                                    key = _ref5[0];
	
	                                return key === tab;
	                            }) },
	                        TABS.map(function (_ref6) {
	                            var _ref7 = _slicedToArray(_ref6, 4),
	                                action = _ref7[0],
	                                Icon = _ref7[1],
	                                label = _ref7[3];
	
	                            return _react2.default.createElement(_BottomNavigation.BottomNavigationItem, {
	                                key: action,
	                                style: _extends({}, action === tab ? { background: '#000' } : {}),
	                                label: label,
	                                icon: _react2.default.createElement(Icon, null),
	                                onClick: function onClick() {
	                                    return opentTab(action);
	                                }
	                            });
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactCustomScrollbars.Scrollbars,
	                { style: { flexGrow: 1 } },
	                _react2.default.createElement(LeftComponent, { template: template })
	            ),
	            _react2.default.createElement(
	                'h5',
	                {
	                    style: {
	                        textAlign: 'center',
	                        color: '#00505b',
	                        bottom: 0,
	                        width: '100%',
	                        zIndex: 100,
	                        margin: 0,
	                        lineHeight: '50px',
	                        background: '#000'
	                    }
	                },
	                'SPORTSINNOVATION'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { alignSelf: 'stretch', width: '100%', height: '100vh', overflow: 'auto' } },
	            tab === 'layout' ? _react2.default.createElement(_WidgetLayouts2.default, null) : null,
	            tab === 'data' && widgetId ? _react2.default.createElement(_PreviewAndVariations2.default, {
	                label: 'Step 2.',
	                text: 'Select data',
	                mainAction: _react2.default.createElement(_FlatButton2.default, {
	                    label: 'Step 3: Image manipulations',
	                    style: { height: 48 },
	                    backgroundColor: '#008c9c',
	                    color: '#fff',
	                    hoverColor: '#007c8a',
	                    labelPosition: 'before',
	                    icon: _react2.default.createElement(_chevronRight2.default, null),
	                    onClick: function onClick() {
	                        opentTab('im');
	                    }
	                })
	            }) : null,
	            tab === 'im' && widgetId ? _react2.default.createElement(_PreviewAndVariations2.default, {
	                label: 'Step 3.',
	                text: 'Manipulate images',
	                mainAction: _react2.default.createElement(_FlatButton2.default, {
	                    label: _lodash2.default.get(mainAction, 'text', 'PREVIEW & PUBLISH'),
	                    style: { height: 48 },
	                    backgroundColor: '#008c9c',
	                    color: '#fff',
	                    hoverColor: '#007c8a',
	                    labelPosition: 'before',
	                    icon: _react2.default.createElement(_chevronRight2.default, null),
	                    onClick: function onClick(e) {
	                        (mainAction && mainAction.onClick || openV2PostDialogue)(e, widgetId, widgetProps, template);
	                        _this.props.resetSelectedWidget();
	                    }
	                })
	            }) : null
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    maxWidth: 280,
	                    minWidth: 280,
	                    height: '100vh',
	                    position: 'relative'
	                }
	            },
	            _react2.default.createElement(
	                _reactCustomScrollbars.Scrollbars,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            height: '100%',
	                            position: 'relative',
	                            display: 'flex',
	                            padding: 12,
	                            paddingTop: 96,
	                            flexDirection: 'column',
	                            background: 'rgba(0,0,0,0.2)',
	                            borderRight: '1px solid rgba(0,0,0,0.2)'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { background: '#000', padding: 12, margin: -12 } },
	                        _react2.default.createElement(_IMControls2.default, null)
	                    ),
	                    _react2.default.createElement(_PickerSwitcher2.default, { type: 'dialog' }),
	                    _react2.default.createElement(_FastImagePicker2.default, null)
	                )
	            )
	        )
	    );
	}
	
	var WidgetEditorEnhanced = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref8, _ref9) {
	    var editor = _ref8.editor;
	    var widgetId = _ref9.widgetId,
	        template = _ref9.template,
	        widgetProps = _ref9.widgetProps,
	        tab = _ref9.tab;
	
	    return {
	        preview: editor.preview,
	        previewError: editor.previewError,
	        widgetId: editor.widgetId || widgetId, // SHIT
	        widgetProps: editor.widgetProps || widgetProps,
	        tab: editor.tab || tab || 'layout',
	        template: editor.template || template
	    };
	}, {
	    loadWidget: _actions.loadWidget,
	    loadWidgets: _actions.loadWidgets,
	    fetchTemplateById: _actions2.fetchTemplateById,
	    changeWidgetJSProp: _actions.changeWidgetJSProp,
	    opentTab: _actions.opentTab,
	    setTemplate: _actions.setTemplate,
	    resetSelectedWidget: _actions.resetSelectedWidget
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.widgetId !== nextProps.widgetId) {
	            if (nextProps.widgetId) {
	                this.props.loadWidget(nextProps.widgetId, nextProps.widgetProps); // keep params
	                //For widget layouts
	                //for possibility of disabling widget layout for the user
	                this.props.loadWidgets();
	            }
	        }
	
	        if (this.props.template !== nextProps.template) {
	            this.props.setTemplate(nextProps.template);
	        }
	        if (this.props.tab !== nextProps.tab) {
	            this.props.opentTab(nextProps.tab);
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.props.resetSelectedWidget();
	    },
	    componentDidMount: function componentDidMount() {
	        var _props = this.props,
	            widgetId = _props.widgetId,
	            widgetProps = _props.widgetProps,
	            template = _props.template,
	            tab = _props.tab;
	
	
	        if (widgetId) {
	            this.props.loadWidget(widgetId, widgetProps);
	            this.props.setTemplate(template);
	        } else {
	            this.props.resetSelectedWidget();
	        }
	
	        if (tab) this.props.opentTab(tab);
	    }
	}))(WidgetEditor);
	
	exports.default = WidgetEditorEnhanced;

/***/ },
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _BGRAreasControls = __webpack_require__(1725);
	
	var _BGRAreasControls2 = _interopRequireDefault(_BGRAreasControls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function WidgetImageManipulations(_ref) {
	    var widget = _ref.widget,
	        props = _objectWithoutProperties(_ref, ['widget']);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Override background'
	        ),
	        _react2.default.createElement(_BGRAreasControls2.default, null)
	    );
	}
	
	WidgetImageManipulations.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(_ref2, props) {
	    var editor = _ref2.editor,
	        state = _objectWithoutProperties(_ref2, ['editor']);
	
	    return {
	        widget: editor.widget
	    };
	};
	
	var mapDispatchToProps = { loadWidgetCMP: _actions.loadWidgetCMP, changeWidgetJSProp: _actions.changeWidgetJSProp };
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(WidgetImageManipulations);

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _addCircleOutline = __webpack_require__(1112);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AreaManipulations = function AreaManipulations(_ref) {
	    var id = _ref.id,
	        onDelete = _ref.onDelete,
	        name = _ref.name,
	        props = _objectWithoutProperties(_ref, ['id', 'onDelete', 'name']);
	
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0 ' } },
	        _react2.default.createElement('img', { src: props.url, style: { width: 50, height: 50, objectFit: 'cover' } }),
	        _react2.default.createElement(
	            'span',
	            { style: { padding: 10, flexGrow: 1 } },
	            name
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                onClick: function onClick() {
	                    onDelete(id, null);
	                }
	            },
	            _react2.default.createElement(_close2.default, { color: '#fff' })
	        )
	    );
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.withStateHandlers)(null, {
	    enterEditMode: function enterEditMode() {
	        return function (id) {
	            return {
	                propKey: id
	            };
	        };
	    }
	}), (0, _reactRedux.connect)(function (_ref2) {
	    var editor = _ref2.editor;
	
	    var areas = _lodash2.default.chain(editor.widgetProps).keys().filter(function (k) {
	        return k.indexOf('area') === 0 && editor.widgetProps[k] && !_lodash2.default.isEmpty(editor.widgetProps[k]);
	    }).map(function (key) {
	        return _extends({ key: key }, editor.widgetProps[key]);
	    }).value();
	    return {
	        areas: areas,
	        dnd: editor.widgetProps && editor.widgetProps.dnd || {}
	    };
	}, {
	    changeWidgetJSProp: _actions.changeWidgetJSProp,
	    updateWidgetJSPropField: _actions.updateWidgetJSPropField
	}), (0, _recompose.withHandlers)({
	    action: function action(_ref3) {
	        var im = _ref3.im;
	        return function (delta) {};
	    }
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        // window.addEventListener('WDP_IM', this.onManipulation.bind(this), false);
	    }
	}))(function (_ref4) {
	    var _ref4$areas = _ref4.areas,
	        areas = _ref4$areas === undefined ? [] : _ref4$areas,
	        dnd = _ref4.dnd,
	        changeWidgetJSProp = _ref4.changeWidgetJSProp;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        areas.map(function (area, index) {
	            return _react2.default.createElement(AreaManipulations, _extends({
	                key: area.key,
	                id: area.key
	            }, area, {
	                name: index + '. layer',
	                onDelete: function onDelete() {
	                    var update = {};
	                    update[area.key] = null;
	                    changeWidgetJSProp(update);
	                }
	            }));
	        }),
	        areas.length < 5 && _react2.default.createElement(_materialUi.FlatButton, {
	            icon: _react2.default.createElement(_addCircleOutline2.default, null),
	            label: 'Add custom background',
	            onClick: function onClick() {
	                var update = {};
	                update['area' + (areas.length + 1)] = { id: 'area' + (areas.length + 1) };
	                changeWidgetJSProp(update);
	            }
	        }),
	        _react2.default.createElement(_materialUi.Divider, { style: { marginTop: 15, marginBottom: 15 } }),
	        areas.length >= 2 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    floatingLabelText: 'Show backgrounds',
	                    value: dnd.direction || 'row',
	                    onChange: function onChange(e, index, direction) {
	                        changeWidgetJSProp({
	                            dnd: _extends({}, dnd, {
	                                direction: direction
	                            })
	                        });
	                    }
	                },
	                [['row', 'Horizontal'], ['column', 'Vertical']].map(function (_ref5) {
	                    var _ref6 = _slicedToArray(_ref5, 2),
	                        k = _ref6[0],
	                        t = _ref6[1];
	
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: k, value: k, primaryText: t });
	                })
	            ),
	            _react2.default.createElement(_materialUi.Toggle, {
	                label: 'Display border',
	                checked: dnd.border,
	                style: { marginTop: 15 },
	                onToggle: function onToggle(e, isChecked) {
	                    changeWidgetJSProp({
	                        dnd: _extends({}, dnd, {
	                            border: isChecked
	                        })
	                    });
	                }
	            }),
	            _react2.default.createElement(_materialUi.Divider, { style: { marginTop: 15, marginBottom: 15 } })
	        )
	    );
	});

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uiFilter = exports.commonFilter = exports.advancedFilter = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _WidgetParams = __webpack_require__(1727);
	
	var _WidgetParams2 = _interopRequireDefault(_WidgetParams);
	
	var _FlatButton = __webpack_require__(870);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _materialUi = __webpack_require__(642);
	
	var _keyboardArrowDown = __webpack_require__(847);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _keyboardArrowUp = __webpack_require__(846);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var deprecatedPropTypesScope = function deprecatedPropTypesScope(p) {
	    return ['images', 'template'].indexOf(p.scope) >= 0;
	};
	var mainFilter = function mainFilter(p) {
	    return p.required && !deprecatedPropTypesScope(p) && ['dnd'].indexOf(p.key) === -1;
	};
	
	var uiFilter = function uiFilter(p) {
	    return (p.ui || p.loader) && !p.scope && !p.required && !deprecatedPropTypesScope(p) && ['dnd'].indexOf(p.key) === -1;
	};
	
	var filterRequired = function filterRequired(p) {
	    return (p.required || p.loader) && !deprecatedPropTypesScope(p);
	};
	var filterOptions = function filterOptions(p) {
	    return p.ui && !deprecatedPropTypesScope(p);
	};
	
	var advancedFilter = function advancedFilter(p) {
	    return p.scope === 'template';
	};
	
	var commonFilter = function commonFilter(p) {
	    return p.scope === 'common';
	};
	function WidgetDataManipulations(_ref) {
	    var title = _ref.title,
	        _ref$filter = _ref.filter,
	        filter = _ref$filter === undefined ? mainFilter : _ref$filter,
	        _ref$scope = _ref.scope,
	        scope = _ref$scope === undefined ? 'all' : _ref$scope,
	        expandEditor = _ref.expandEditor,
	        expanded = _ref.expanded,
	        props = _objectWithoutProperties(_ref, ['title', 'filter', 'scope', 'expandEditor', 'expanded']);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h4',
	            {
	                style: {
	                    display: 'flex',
	                    alignItems: 'center',
	                    margin: '0px -12px 0 -12px',
	                    padding: '6px 12px',
	                    background: '#333',
	                    fontSize: 18,
	                    fontWeight: 500,
	                    borderBottom: '1px solid #444'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { style: { flexGrow: 1 } },
	                title
	            ),
	            _react2.default.createElement(
	                _materialUi.IconButton,
	                {
	                    onClick: function onClick() {
	                        expandEditor(!expanded);
	                    }
	                },
	                !expanded ? _react2.default.createElement(_keyboardArrowDown2.default, null) : _react2.default.createElement(_keyboardArrowUp2.default, null)
	            )
	        ),
	        expanded && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_WidgetParams2.default, { widgetId: props.params && props.params.widgetId, filter: filter }),
	            _react2.default.createElement('div', { style: { height: 10 } })
	        )
	    );
	}
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	var mapDispatchToProps = { loadWidgetCMP: _actions.loadWidgetCMP, changeWidgetJSProp: _actions.changeWidgetJSProp };
	
	exports.advancedFilter = advancedFilter;
	exports.commonFilter = commonFilter;
	exports.uiFilter = uiFilter;
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withStateHandlers)(function (props) {
	    return {
	        expanded: props.expanded || false
	    };
	}, {
	    expandEditor: function expandEditor() {
	        return function (expanded) {
	            return { expanded: expanded };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(WidgetDataManipulations);

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ConnectedPicker = exports.changeWidgetJSProp = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1718);
	
	var _constants = __webpack_require__(612);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _pickers = __webpack_require__(1131);
	
	var _pickers2 = _interopRequireDefault(_pickers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEBOUNCED = _lodash2.default.debounce(function () {
	    // const { query } = browserHistory.getCurrentLocation();
	    // const { pathname } = window.location;
	    // const q = _.pickBy({ ...query, ...payload }, _.identity);
	    // const qq = _.chain(q)
	    //     .toPairs(q)
	    //     .map(([key, val]) => {
	    //         if (typeof val === 'object') {
	    //             return [key, JSON.stringify(val)];
	    //         } else {
	    //             return [key, val];
	    //         }
	    //     })
	    //     .fromPairs()
	    //     .value();
	    // browserHistory.replace({
	    //     pathname,
	    //     query: qq,
	    // });
	}, 300);
	
	var changeWidgetJSProp = exports.changeWidgetJSProp = function changeWidgetJSProp(payload) {
	    return function (dispatch, getState) {
	        dispatch({
	            type: _constants.WIDGET_JSPROP_CHANGE,
	            payload: payload
	        });
	        var state = getState();
	        DEBOUNCED(state.editor.widgetProps);
	    };
	};
	
	var WidgetParams = (0, _reactRedux.connect)(function (_ref) {
	    var editor = _ref.editor;
	
	    var widget = editor.widget;
	    return {
	        widget: widget
	    };
	}, {
	    loadWidgetCMP: _actions.loadWidgetCMP
	})(function (_ref2) {
	    var widget = _ref2.widget,
	        _ref2$filter = _ref2.filter,
	        filter = _ref2$filter === undefined ? function () {
	        return true;
	    } : _ref2$filter;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        widget && widget.spec.propTypes.filter(filter).map(function (propType) {
	            return _react2.default.createElement(ConnectedPicker, { key: propType.key, propType: propType });
	        })
	    );
	});
	
	var ConnectedPicker = (0, _reactRedux.connect)(function (_ref3) {
	    var editor = _ref3.editor;
	    return {
	        jsprops: editor.jsprops
	    };
	}, {
	    changeWidgetJSProp: changeWidgetJSProp
	})(function (_ref4) {
	    var propType = _ref4.propType,
	        jsprops = _ref4.jsprops,
	        changeWidgetJSProp = _ref4.changeWidgetJSProp,
	        props = _objectWithoutProperties(_ref4, ['propType', 'jsprops', 'changeWidgetJSProp']);
	
	    var Picker = _pickers2.default[propType.type];
	    if (!Picker) return _react2.default.createElement(
	        'div',
	        null,
	        ' ',
	        propType.type,
	        ' '
	    );
	
	    return _react2.default.createElement(Picker, _extends({
	        key: propType.key,
	        propKey: propType.key
	    }, propType, propType.props, jsprops, props, {
	        value: jsprops[propType.key],
	        onChange: function onChange(prop, val) {
	            var changedProp = void 0;
	            if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	                changedProp = prop;
	            } else {
	                changedProp = {};
	                changedProp[prop] = val;
	            }
	            changeWidgetJSProp(changedProp);
	        },
	        error: false
	    }));
	});
	
	exports.ConnectedPicker = ConnectedPicker;
	exports.default = WidgetParams;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LayoutsImagesList = exports.LayoutsList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 6px 0;\n    position: relative;\n    width: 100%;\n\n    cursor: pointer;\n    &:after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.4);\n        z-index: 1004;\n        transition: all 0.3s linear;\n        pointer-events: none;\n    }\n    &:hover:after {\n        background: rgba(0, 0, 0, 0);\n    }\n'], ['\n    margin: 6px 0;\n    position: relative;\n    width: 100%;\n\n    cursor: pointer;\n    &:after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.4);\n        z-index: 1004;\n        transition: all 0.3s linear;\n        pointer-events: none;\n    }\n    &:hover:after {\n        background: rgba(0, 0, 0, 0);\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n\n    background: rgba(0, 0, 0, 0.1);\n\n    .img-container {\n        display: inline-block;\n        overflow: hidden;\n        position: relative;\n    }\n    .demo {\n        position: absolute;\n        top: 12px;\n        right: -23px;\n        background: red;\n        z-index: 1001;\n        padding: 3px 25px;\n        color: #fff;\n        transform: rotate(45deg);\n    }\n'], ['\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n\n    background: rgba(0, 0, 0, 0.1);\n\n    .img-container {\n        display: inline-block;\n        overflow: hidden;\n        position: relative;\n    }\n    .demo {\n        position: absolute;\n        top: 12px;\n        right: -23px;\n        background: red;\n        z-index: 1001;\n        padding: 3px 25px;\n        color: #fff;\n        transform: rotate(45deg);\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reactRouter = __webpack_require__(188);
	
	var _NetflixGallery = __webpack_require__(1729);
	
	var _FlatButton = __webpack_require__(870);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _chevronRight = __webpack_require__(878);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Controls = __webpack_require__(1730);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Header = __webpack_require__(1731);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var LayoutSelection = _styledComponents2.default.div(_templateObject);
	
	var LayoutPreview = _styledComponents2.default.div(_templateObject2);
	
	var Layouts = (0, _recompose.compose)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (_ref, props) {
	    var editor = _ref.editor,
	        user = _ref.user;
	
	    return {
	        user: user,
	        widget: editor.widget,
	        widgetId: editor.widgetId,
	        template: editor.template
	    };
	}, { setEditorWidget: _actions.setEditorWidget, opentTab: _actions.opentTab }), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {}
	}))(function (_ref2) {
	    var widgetId = _ref2.widgetId,
	        widget = _ref2.widget,
	        user = _ref2.user,
	        template = _ref2.template,
	        opentTab = _ref2.opentTab;
	
	    var lang = _lodash2.default.get(user, 'props.lang', 'da');
	    if (!widgetId) return _react2.default.createElement('div', null);
	
	    var demoURL = _cfg2.default.widgets.url + '/widget/' + user.client + '/' + user.username + '/default/' + widgetId + '/demo-image?lang=' + lang + '&template=' + template;
	
	    return _react2.default.createElement(
	        LayoutPreview,
	        null,
	        _react2.default.createElement(_Header2.default, { label: 'Step 1.', text: 'Select layout' }),
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    width: '100%',
	                    flexGrow: 1,
	                    overflow: 'hidden',
	                    textAlign: 'center',
	                    padding: 15,
	                    boxSizing: 'content-box'
	                }
	            },
	            _react2.default.createElement('img', {
	                alt: '',
	                key: widgetId + '_' + template,
	                style: {
	                    flexGrow: 1,
	                    height: '100%',
	                    widows: '100%',
	                    maxHeight: 500,
	                    objectFit: 'contain',
	                    display: 'inline-block'
	                },
	                src: demoURL
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right', background: 'rgba(0,0,0,0.1)' } },
	            _react2.default.createElement(_FlatButton2.default, {
	                label: 'Step 2: Select data'
	                // icon={<IconNext />}
	                , primary: true,
	                style: { height: 48, color: '#fff' },
	                backgroundColor: '#008c9c',
	                color: '#fff',
	                hoverColor: '#007c8a',
	                labelPosition: 'before',
	                icon: _react2.default.createElement(_chevronRight2.default, null),
	                onClick: function onClick() {
	                    opentTab('data');
	                }
	            })
	        )
	    );
	});
	
	var LayoutsImagesList = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref3, props) {
	    var editor = _ref3.editor;
	
	    var widgetIds = editor.widgets.all && editor.widgets.all.map(function (w) {
	        return w.id;
	    }) || [];
	    var layoutsSpec = editor.widget && editor.widget.layoutsSpec.filter(function (w) {
	        return widgetIds.includes(w.id);
	    });
	
	    return {
	        layoutsSpec: layoutsSpec || [],
	        widgetId: editor.widgetId
	    };
	}, { setEditorWidget: _actions.setEditorWidget }), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {}
	}))(function (_ref4) {
	    var layoutsSpec = _ref4.layoutsSpec,
	        widgetId = _ref4.widgetId,
	        template = _ref4.template,
	        setEditorWidget = _ref4.setEditorWidget;
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: 15 } },
	        layoutsSpec.map(function (layout) {
	            return _react2.default.createElement(
	                LayoutSelection,
	                {
	                    key: layout.id,
	                    onClick: function onClick(e) {
	                        setEditorWidget(layout.id);
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            width: '100%'
	                        }
	                    },
	                    _react2.default.createElement(_NetflixGallery.WidgetPreviewStatic, {
	                        style: _extends({
	                            alignSelf: 'stretch',
	                            borderWidth: 5,
	                            borderStyle: 'solid',
	                            borderColor: 'transparent'
	                        }, layout.id === widgetId ? { borderColor: '#fff' } : {}),
	                        widgetId: layout.id,
	                        template: template,
	                        name: layout.name,
	                        demo: true
	                    })
	                ),
	                layout.id === widgetId && _react2.default.createElement(
	                    'p',
	                    {
	                        style: {
	                            position: 'absolute',
	                            top: '50%',
	                            left: 20,
	                            right: 20,
	                            zIndex: 10000,
	                            textAlign: 'center',
	                            background: '#008c9d',
	                            borderRadius: '15px',
	                            padding: '5px 15px'
	                        }
	                    },
	                    'SELECTED LAYOUT'
	                )
	            );
	        })
	    );
	});
	
	var LayoutsList = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref5, props) {
	    var editor = _ref5.editor;
	
	    return {
	        layouts: editor.widget && editor.widget.layouts,
	        widgetId: editor.widgetId
	    };
	}, { setEditorWidget: _actions.setEditorWidget }), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {}
	}))(function (_ref6) {
	    var _ref6$layouts = _ref6.layouts,
	        layouts = _ref6$layouts === undefined ? [] : _ref6$layouts,
	        widgetId = _ref6.widgetId,
	        template = _ref6.template,
	        _ref6$widgetProps = _ref6.widgetProps,
	        widgetProps = _ref6$widgetProps === undefined ? {} : _ref6$widgetProps,
	        setEditorWidget = _ref6.setEditorWidget;
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' } },
	        [widgetId].concat(_toConsumableArray(layouts || [])).map(function (wid) {
	            return _react2.default.createElement(_FlatButton2.default, {
	                key: wid,
	                primary: widgetId === wid,
	                label: wid,
	                onClick: function onClick() {
	                    setEditorWidget(wid);
	                }
	            });
	        })
	    );
	});
	
	exports.LayoutsList = LayoutsList;
	exports.LayoutsImagesList = LayoutsImagesList;
	exports.default = Layouts;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WidgetPreviewStatic = exports.WidgetPreview = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    \n    transform: rotate(0deg);\n  }\n  100% {\n   \n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    \n    transform: rotate(0deg);\n  }\n  100% {\n   \n    transform: rotate(360deg);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  5%,\n  95% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  10%,\n  59% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;\n  }\n  20% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;\n  }\n  38% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;\n  }\n  100% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n'], ['\n  0% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  5%,\n  95% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  10%,\n  59% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;\n  }\n  20% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;\n  }\n  38% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;\n  }\n  100% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    cursor: pointer;\n\n    display: inline-block;\n    width: auto;\n    min-width: 150px;\n    margin: 2px;\n    z-index: 50;\n\n    ', ' .regular-slide {\n        overflow: hidden;\n        position: relative;\n        min-height: 100px;\n        transition: all ', 's linear;\n    }\n\n    &.gallery-item-zoomed {\n        .regular-slide {\n            transform: scale(', ');\n        }\n    }\n    .w-thumb-image {\n        position: relative;\n        height: 100%;\n        max-height: ', ';\n        object-fit: cover;\n        object-position: top;\n        z-index: 99;\n    }\n\n    .w-container {\n        position: relative;\n        background: #000;\n        text-align: center;\n    }\n    .w-container-init {\n        opacity: 0;\n    }\n    .w-name {\n        position: relative;\n        padding: 0 8px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #fff;\n        background: #222;\n\n        font-size: 14px;\n        line-height: 26px;\n    }\n\n    .badges-bar {\n        position: absolute;\n        bottom: 2px;\n        padding: 2px 5px;\n        z-index: 1000;\n        right: 2px;\n        font-size: 14px;\n        opacity: 0.8;\n        background: rgba(0, 0, 0, 0.8);\n        display: flex;\n        align-items: center;\n        span {\n            padding-left: 4px;\n        }\n    }\n\n    .demo-badge {\n        position: absolute;\n        top: 12px;\n        right: -23px;\n        background: red;\n        z-index: 1001;\n        padding: 3px 25px;\n        color: #fff;\n        transform: rotate(45deg);\n    }\n    &:hover {\n        .video-badge {\n            zoom: 1.2;\n            opacity: 0.9;\n        }\n    }\n    .video-badge {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        background: #fff;\n        box-shadow: 0 0 5px #000;\n        z-index: 10000;\n        opacity: 0.8;\n\n        &:after {\n            position: absolute;\n            content: \'\';\n            box-sizing: border-box;\n\n            width: 22px;\n            height: 22px;\n            z-index: 100005;\n            top: 50%;\n            left: 50%;\n            transform: translate(-40%, -50%);\n            border-width: 11px 0px 11px 22px;\n            border-style: solid;\n            border-color: transparent transparent transparent #202020;\n        }\n    }\n    &.gallery-item-loading {\n        .w-thumb-image {\n            opacity: 0.7;\n        }\n    }\n    &.gallery-item-loaded {\n    }\n    &.gallery-item-errored {\n        .w-thumb-image {\n            visibility: hidden;\n        }\n    }\n    .errored {\n        color: #ffffff;\n        font-size: 45px;\n        overflow: hidden;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        margin-left: -25px;\n        margin-top: -25px;\n        position: absolute;\n        z-index: 1001;\n        transform: translateZ(0);\n        left: 50%;\n        top: 50%;\n        background: red;\n    }\n    .loading {\n        color: #ffffff;\n        font-size: 45px;\n        text-indent: -9999em;\n        overflow: hidden;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        margin-left: -25px;\n        margin-top: -25px;\n        position: absolute;\n        z-index: 1001;\n        transform: translateZ(0);\n        left: 50%;\n        top: 50%;\n        animation: ', ' 1.7s infinite ease, ', ' 1.7s infinite ease;\n    }\n'], ['\n    position: relative;\n    cursor: pointer;\n\n    display: inline-block;\n    width: auto;\n    min-width: 150px;\n    margin: 2px;\n    z-index: 50;\n\n    ', ' .regular-slide {\n        overflow: hidden;\n        position: relative;\n        min-height: 100px;\n        transition: all ', 's linear;\n    }\n\n    &.gallery-item-zoomed {\n        .regular-slide {\n            transform: scale(', ');\n        }\n    }\n    .w-thumb-image {\n        position: relative;\n        height: 100%;\n        max-height: ', ';\n        object-fit: cover;\n        object-position: top;\n        z-index: 99;\n    }\n\n    .w-container {\n        position: relative;\n        background: #000;\n        text-align: center;\n    }\n    .w-container-init {\n        opacity: 0;\n    }\n    .w-name {\n        position: relative;\n        padding: 0 8px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #fff;\n        background: #222;\n\n        font-size: 14px;\n        line-height: 26px;\n    }\n\n    .badges-bar {\n        position: absolute;\n        bottom: 2px;\n        padding: 2px 5px;\n        z-index: 1000;\n        right: 2px;\n        font-size: 14px;\n        opacity: 0.8;\n        background: rgba(0, 0, 0, 0.8);\n        display: flex;\n        align-items: center;\n        span {\n            padding-left: 4px;\n        }\n    }\n\n    .demo-badge {\n        position: absolute;\n        top: 12px;\n        right: -23px;\n        background: red;\n        z-index: 1001;\n        padding: 3px 25px;\n        color: #fff;\n        transform: rotate(45deg);\n    }\n    &:hover {\n        .video-badge {\n            zoom: 1.2;\n            opacity: 0.9;\n        }\n    }\n    .video-badge {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        background: #fff;\n        box-shadow: 0 0 5px #000;\n        z-index: 10000;\n        opacity: 0.8;\n\n        &:after {\n            position: absolute;\n            content: \'\';\n            box-sizing: border-box;\n\n            width: 22px;\n            height: 22px;\n            z-index: 100005;\n            top: 50%;\n            left: 50%;\n            transform: translate(-40%, -50%);\n            border-width: 11px 0px 11px 22px;\n            border-style: solid;\n            border-color: transparent transparent transparent #202020;\n        }\n    }\n    &.gallery-item-loading {\n        .w-thumb-image {\n            opacity: 0.7;\n        }\n    }\n    &.gallery-item-loaded {\n    }\n    &.gallery-item-errored {\n        .w-thumb-image {\n            visibility: hidden;\n        }\n    }\n    .errored {\n        color: #ffffff;\n        font-size: 45px;\n        overflow: hidden;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        margin-left: -25px;\n        margin-top: -25px;\n        position: absolute;\n        z-index: 1001;\n        transform: translateZ(0);\n        left: 50%;\n        top: 50%;\n        background: red;\n    }\n    .loading {\n        color: #ffffff;\n        font-size: 45px;\n        text-indent: -9999em;\n        overflow: hidden;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        margin-left: -25px;\n        margin-top: -25px;\n        position: absolute;\n        z-index: 1001;\n        transform: translateZ(0);\n        left: 50%;\n        top: 50%;\n        animation: ', ' 1.7s infinite ease, ', ' 1.7s infinite ease;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    width: ', ';\n    height: auto;\n    min-height: 150px;\n    max-height: none;\n    .w-thumb-image {\n        width: 100%;\n        max-height: none;\n        height: auto;\n    }\n    &.gallery-item-errored {\n        max-height: 150px;\n        background: #000;\n        img {\n            display: none;\n        }\n    }\n'], ['\n    width: ', ';\n    height: auto;\n    min-height: 150px;\n    max-height: none;\n    .w-thumb-image {\n        width: 100%;\n        max-height: none;\n        height: auto;\n    }\n    &.gallery-item-errored {\n        max-height: 150px;\n        background: #000;\n        img {\n            display: none;\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _classnames = __webpack_require__(1025);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ANIMATION_LENGTH = 0.25;
	var SLIDE_WIDTH = 240;
	
	// const SLIDE_SCALE = SLIDE_WIDTH / SLIDE_POPUP_WIDTH;
	
	var roundAnim = (0, _styledComponents.keyframes)(_templateObject);
	
	var load6Anim = (0, _styledComponents.keyframes)(_templateObject2);
	
	var NetflixGallery = function (_React$Component) {
	    _inherits(NetflixGallery, _React$Component);
	
	    function NetflixGallery(props) {
	        _classCallCheck(this, NetflixGallery);
	
	        var _this = _possibleConstructorReturn(this, (NetflixGallery.__proto__ || Object.getPrototypeOf(NetflixGallery)).call(this, props));
	
	        _this.slides = [];
	
	        _this.componentDidMount = function () {
	            _this._autofixIntervalId = setInterval(function () {
	                if (!_this._blocked && _this._lastZoomedIndex != -1 && _this._lastZoomedIndex !== _this.state.zoomedIndex) {
	                    // do zoom
	                    _this.setState({
	                        zoomedItem: _this.props.list[_this._lastZoomedIndex],
	                        zoomedIndex: _this._lastZoomedIndex
	                    });
	                }
	            }, 500);
	            _this._debounceHandleScreenSizeUpdate = _lodash2.default.debounce(function () {
	                _this.forceUpdate();
	            }, 100);
	            window.addEventListener('resize', _this._debounceHandleScreenSizeUpdate, false);
	        };
	
	        _this.componentWillUnmount = function () {
	            if (_this._autofixIntervalId) clearInterval(_this._autofixIntervalId);
	            window.removeEventListener('resize', _this._debounceHandleScreenSizeUpdate, false);
	        };
	
	        _this.onEnter = function (item, i) {
	            // this._lastZoomedIndex = i;
	            if (_this.state.zoomedIndex === i) return;
	            if (_this._blocked) {
	                return;
	            }
	            _this._blocked = true;
	            _this.setState({ zoomedItem: item, zoomedIndex: i });
	
	            clearTimeout(_this._blockedINT);
	            _this._blockedINT = setTimeout(function () {
	                _this._blocked = false;
	            }, ANIMATION_LENGTH * 1000);
	        };
	
	        _this.onLeave = function () {
	            _this.setState({ zoomedItem: null, zoomedIndex: -1 });
	            _this._lastZoomedIndex = -1;
	        };
	
	        _this.state = {
	            zoomedItem: null,
	            zoomedIndex: -1
	        };
	
	
	        _this.onEnterSafe = _lodash2.default.throttle(_this.onEnter, 100);
	        _this.onLeaveSafe = _lodash2.default.throttle(_this.onLeave, 100);
	        _this._blocked = false;
	        _this._lastZoomedIndex = -1;
	        return _this;
	    }
	
	    _createClass(NetflixGallery, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var zoomFactor = this.props.zoomFactor;
	            var _state = this.state,
	                zoomedIndex = _state.zoomedIndex,
	                selectedItem = _state.selectedItem;
	
	
	            var activeSlide = this.slides[zoomedIndex] || {};
	
	            // &:first-child {
	            //     transform: ${props => props.doShift && props.firstIsZoomed && `translate3d(${SLIDE_SHIFT}px, 0, 0)`};
	            // }
	
	            var cw = _lodash2.default.get(this, 'container.offsetWidth', 200);
	            // const sw = (this.slides || []).reduce((sum, s) => sum + s.offsetWidth + 4, 0);
	            // const rzw = _.get(this, 'rowZoomable.offsetWidth', 0);
	
	            var total = 0;
	            var curentRow = -1;
	
	            (this.slides || []).forEach(function (slide, i) {
	                // const startPX = curentRow * cw;
	                // const endPX = (curentRow + 1) * cw;
	
	                var testTotal = total + slide.offsetWidth;
	
	                slide.row = Math.floor(testTotal / cw);
	
	                slide.firstInRow = false;
	                slide.lastInRow = false;
	                if (slide.row !== curentRow) {
	                    slide.firstInRow = true;
	
	                    curentRow = slide.row;
	                    total = curentRow * cw;
	                    if (i > 0) _this2.slides[i - 1].lastInRow = true; // set last in a row
	                }
	                if (_this2.slides.length === i + 1) _this2.slides[i].lastInRow = true;
	                total += slide.offsetWidth;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    ref: function ref(r) {
	                        return _this2.container = r;
	                    },
	                    className: 'netflix',
	                    style: {
	                        zIndex: zoomedIndex !== -1 ? 1000 : 0
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.props.list.map(function (item, i) {
	                        var activeRow = _this2.slides[i] && activeSlide && activeSlide.row === _this2.slides[i].row;
	                        var firstInRow = _this2.slides[i] && _this2.slides[i].firstInRow;
	                        var lastInRow = _this2.slides[i] && _this2.slides[i].lastInRow;
	                        var movedActiveStyles = {
	                            zIndex: 10004
	                        };
	                        var halfZoom = (zoomFactor - 1.0) / 2;
	                        if (firstInRow) {
	                            movedActiveStyles.transform = 'translate3d(' + (activeSlide.offsetWidth * halfZoom || 0) + 'px, 0, 0)';
	                            movedActiveStyles.marginLeft = -2;
	                        } else if (lastInRow) {
	                            movedActiveStyles.transform = 'translate3d(-' + (activeSlide.offsetWidth * halfZoom || 0) + 'px, 0, 0)';
	                        }
	
	                        var movedLeftStyles = {
	                            transform: 'translate3d(' + (-activeSlide.offsetWidth * halfZoom * (activeSlide.lastInRow ? 2 : 1) || 0) + 'px, 0, 0)'
	                        };
	
	                        var movedRightStyles = {
	                            transform: 'translate3d(' + (activeSlide.offsetWidth * halfZoom * (activeSlide.firstInRow ? 2 : 1) || 0) + 'px, 0, 0)'
	                        };
	
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                ref: function ref(r) {
	                                    _this2.slides[i] = r;
	                                },
	                                key: _this2.props.renderKey(item, { zoomed: zoomedIndex === i }),
	                                className: 'netflix-slide ' + (zoomedIndex === i && 'netflix-slide-active'),
	                                style: _extends({
	                                    display: 'inline-block',
	                                    position: 'relative',
	                                    transition: 'all ' + ANIMATION_LENGTH + 's linear',
	                                    zIndex: 100
	                                }, i == zoomedIndex ? movedActiveStyles : {}, activeRow && i < zoomedIndex ? movedLeftStyles : {}, activeRow && i > zoomedIndex ? movedRightStyles : {}),
	                                onMouseEnter: _this2.onEnterSafe.bind(_this2, item, i),
	                                onMouseMove: function onMouseMove() {
	                                    _this2._lastZoomedIndex = i;
	                                },
	                                onMouseLeave: _this2.onLeaveSafe,
	                                onClick: function onClick() {
	                                    _this2.setState({ zoomedItem: null, zoomedIndex: -1 });
	                                    var elem = _reactDom2.default.findDOMNode(_this2.refs.container);
	                                    if (elem) {
	                                        window.scrollTo({
	                                            top: elem.offsetTop,
	                                            behavior: 'smooth'
	                                        });
	                                    }
	                                }
	                            },
	                            _this2.props.renderItem(item, {
	                                zoomFactor: zoomFactor,
	                                zoomed: !selectedItem && zoomedIndex === i
	                            })
	                        );
	                    })
	                ),
	                _react2.default.createElement('div', { style: { height: 50 } })
	            );
	        }
	    }]);
	
	    return NetflixGallery;
	}(_react2.default.Component);
	
	NetflixGallery.defaultProps = {
	    list: [],
	    zoomFactor: 1.5
	};
	
	
	var WidgetPreviewUI = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.allowZoom && '&:hover {\n        z-index: 1000;\n             \n    }';
	}, ANIMATION_LENGTH, function (props) {
	    return props.zoomFactor || 1.7;
	}, SLIDE_WIDTH, load6Anim, roundAnim);
	
	var WidgetPreviewUIHorizontal = WidgetPreviewUI.extend(_templateObject4, SLIDE_WIDTH);
	
	var WidgetPreviewComponent = function (_React$Component2) {
	    _inherits(WidgetPreviewComponent, _React$Component2);
	
	    function WidgetPreviewComponent() {
	        var _ref;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, WidgetPreviewComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = WidgetPreviewComponent.__proto__ || Object.getPrototypeOf(WidgetPreviewComponent)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
	            anim: 'init',
	            expanded: false,
	            imageState: 'loading',
	            retry: 0
	        }, _this3.componentWillReceiveProps = function (nextProps) {
	            var canBeZoomed = _this3.state.imageState !== 'errored';
	
	            if (canBeZoomed && nextProps.zoomed && nextProps.zoomed !== _this3.props.zoomed) {
	                _this3.setState({ anim: 'zoomed' });
	            }
	            if (canBeZoomed && !nextProps.zoomed && nextProps.zoomed !== _this3.props.zoomed) {
	                _this3.setState({ anim: 'idle', expanded: false });
	            }
	
	            if (nextProps.props && nextProps.props.template !== _this3.props.props.template) {
	                _this3.setState({ imageState: 'loading' });
	            }
	        }, _this3.onStartLoad = function (e) {}, _this3.onLoaded = function () {
	            _this3.setState({ imageState: 'loaded' });
	        }, _this3.onErrorLoad = function () {
	            _this3.setState({ imageState: 'errored' });
	        }, _this3.render = function () {
	            var _this3$props = _this3.props,
	                user = _this3$props.user,
	                widgetId = _this3$props.widgetId,
	                widget = _this3$props.widget,
	                name = _this3$props.name,
	                onClick = _this3$props.onClick,
	                props = _this3$props.props,
	                demo = _this3$props.demo,
	                wdpcache = _this3$props.wdpcache,
	                allowZoom = _this3$props.allowZoom,
	                template = _this3$props.template,
	                _this3$props$style = _this3$props.style,
	                style = _this3$props$style === undefined ? {} : _this3$props$style,
	                zoomFactor = _this3$props.zoomFactor;
	            var _this3$state = _this3.state,
	                anim = _this3$state.anim,
	                imageState = _this3$state.imageState,
	                retry = _this3$state.retry;
	
	            //
	            //
	
	            var lang = user.defaultProps.find(function (_ref2) {
	                var key = _ref2.key;
	                return key === 'lang';
	            });
	
	            lang = lang && lang.value || 'da';
	
	            var widgetURL = _cfg2.default.WDPLinkr.widget.image(user.client, user.username, 'default', widgetId, _extends({
	                lang: lang
	            }, props, {
	                wdpcache: wdpcache
	            }));
	            // combine demo url
	
	            if (demo) {
	                widgetURL = widget && widget.demoURL || _cfg2.default.WDPLinkr.widget.demo(user.client, user.username, 'default', widgetId, {
	                    lang: lang,
	                    template: template,
	                    i: 'gallery2'
	                });
	            }
	
	            if (retry !== 0) {
	                widgetURL = _cfg2.default.WDPLinkr.widget.demo(user.client, user.username, 'default', widgetId, {
	                    lang: lang,
	                    template: template,
	                    i: 'gallery2',
	                    forceUpdate: true
	                });
	            }
	
	            var CMP = _this3.props.orientation == 'height' ? WidgetPreviewUI : WidgetPreviewUIHorizontal;
	
	            return _react2.default.createElement(
	                CMP,
	                {
	                    zoomFactor: zoomFactor,
	                    onDragStart: dragStart(widgetId, _extends({}, props, {
	                        client: user.client,
	                        username: user.username
	                    })),
	                    className: (0, _classnames2.default)({
	                        'gallery-items-stack': widget && widget.layouts > 1
	                    }, 'gallery-item-' + imageState, 'gallery-item gallery-item-' + anim),
	                    orientation: _this3.props.orientation,
	                    onClick: onClick,
	                    allowZoom: imageState == 'loaded' && allowZoom,
	                    style: style
	                },
	                imageState === 'loading' && _react2.default.createElement('span', { className: 'loading' }),
	                imageState === 'errored' && _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'errored',
	                        onClick: function onClick(e) {
	                            e.stopPropagation();
	
	                            _this3.setState({
	                                imageState: 'loading',
	                                retry: Math.random()
	                            });
	                        }
	                    },
	                    'Retry'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'regular-slide' },
	                    _lodash2.default.get(widget, 'spec.video', false) && _react2.default.createElement(
	                        'span',
	                        { className: 'video-badge' },
	                        ' '
	                    ),
	                    demo && _react2.default.createElement(
	                        'span',
	                        {
	                            className: 'demo-badge',
	                            onClick: function onClick(e) {
	                                e.stopPropagation();
	
	                                _this3.setState({
	                                    imageState: 'loading',
	                                    retry: Math.random()
	                                });
	                            }
	                        },
	                        'DEMO'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'w-container' },
	                        _react2.default.createElement('img', {
	                            key: widgetURL + '_' + _this3.props.template,
	                            className: 'w-thumb-image',
	                            src: widgetURL,
	                            onLoadStart: _this3.onStartLoad,
	                            onLoad: _this3.onLoaded,
	                            onError: _this3.onErrorLoad
	                        }),
	                        widget && widget.layouts > 1 && _react2.default.createElement(
	                            'div',
	                            { className: 'badges-bar' },
	                            _react2.default.createElement(_contentCopy2.default, { style: { width: 18, height: 18 } }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'x',
	                                widget.layouts
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'w-name' },
	                        name || widget && widget.name || widgetId
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    return WidgetPreviewComponent;
	}(_react2.default.Component);
	
	WidgetPreviewComponent.defaultProps = {
	    demo: false,
	    usePreview: false,
	    wdpcache: 'state',
	    orientation: 'height',
	    allowZoom: false,
	    zoomFactor: 1.7
	};
	
	
	var dragStart = function dragStart(widgetId, props) {
	    return function (event) {
	
	        if (!props.template) {
	            alert('cant be dragged');
	        }
	
	        event.dataTransfer.setData('rule', JSON.stringify({
	            campaignId: '5bee9679a9ae562380ed91fb',
	            presentation: {
	                name: widgetId,
	                params: _extends({}, props),
	                type: 'widget-social'
	            },
	            triggerType: 'time',
	            messageTemplateIds: [],
	            signature: null,
	            message: null,
	            conditions: [],
	            patterns: []
	        }));
	    };
	};
	
	var WidgetPreview = (0, _reactRedux.connect)(function (_ref3) {
	    var user = _ref3.user;
	    return { user: user };
	})(WidgetPreviewComponent);
	
	var WidgetPreviewStatic = (0, _reactRedux.connect)(function (_ref4) {
	    var user = _ref4.user;
	    return { user: user, zoom: false, orientation: 'width' };
	})(WidgetPreviewComponent);
	
	exports.WidgetPreview = WidgetPreview;
	exports.WidgetPreviewStatic = WidgetPreviewStatic;
	exports.default = NetflixGallery;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import { browserDownloadWidget2image } from '../../../../../widgets/actions/widgets';
	
	// import IconAddToFav from 'material-ui/svg-icons/action/favorite';
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _reactRouter = __webpack_require__(188);
	
	var _fileDownload = __webpack_require__(1500);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _openInNew = __webpack_require__(1296);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _allInclusive = __webpack_require__(1033);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _chevronRight = __webpack_require__(878);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _materialUi = __webpack_require__(642);
	
	var _widgets = __webpack_require__(1598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	    var user = _ref.user,
	        editor = _ref.editor;
	    var widget = editor.widget;
	
	    var widgetUrl = widget && _cfg2.default.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.id, _extends({}, _RCore2.default.prepareWidgetPropsObj(editor.widgetProps), {
	        __mode: 'strict'
	    }));
	    if (widget && widget.spec.video) {
	        widgetUrl = widget && _cfg2.default.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.id, _extends({}, _RCore2.default.prepareWidgetPropsObj(editor.widgetProps), {
	            js: true
	        }));
	    }
	
	    return _extends({
	        user: user,
	        widget: widget,
	        widgetUrl: widgetUrl
	    }, editor);
	};
	
	var mapDispatchToProps = { addToFavPortfolio: _actions.addToFavPortfolio };
	
	var MoreMenu = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withStateHandlers)(function () {
	    return {
	        downloading: false
	    };
	}, {
	    onStartDownload: function onStartDownload() {
	        return function () {
	            return {
	                downloading: true
	            };
	        };
	    },
	    onEndDownload: function onEndDownload() {
	        return function () {
	            return {
	                downloading: false
	            };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(function (_ref2) {
	    var widget = _ref2.widget,
	        user = _ref2.user,
	        widgetProps = _ref2.widgetProps,
	        widgetUrl = _ref2.widgetUrl,
	        downloading = _ref2.downloading,
	        onStartDownload = _ref2.onStartDownload,
	        onEndDownload = _ref2.onEndDownload;
	    return _react2.default.createElement(
	        _materialUi.IconMenu,
	        {
	            key: 'cmpa',
	            iconButtonElement: _react2.default.createElement(
	                _materialUi.IconButton,
	                null,
	                _react2.default.createElement(_moreVert2.default, null)
	            ),
	            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
	            targetOrigin: { horizontal: 'right', vertical: 'bottom' }
	        },
	        _react2.default.createElement(_materialUi.MenuItem, {
	            leftIcon: downloading ? _react2.default.createElement(_CircularProgress2.default, null) : _react2.default.createElement(_fileDownload2.default, null),
	            primaryText: 'Download',
	            onTouchTap: function onTouchTap() {
	                onStartDownload();
	                (0, _widgets.browserDownloadWidget2image)(widget, widgetUrl).then(onEndDownload);
	            }
	        }),
	        _react2.default.createElement(_materialUi.MenuItem, {
	            leftIcon: _react2.default.createElement(_style2.default, null),
	            primaryText: 'Edit widget theme',
	            onTouchTap: function onTouchTap() {
	                return _reactRouter.browserHistory.push({
	                    pathname: '/sm/templates/edit',
	                    query: {
	                        tid: widgetProps.template,
	                        wid: widget.id,
	                        variation: widgetProps.variation
	                    }
	                });
	            }
	        }),
	        _react2.default.createElement(_materialUi.MenuItem, {
	            leftIcon: _react2.default.createElement(_openInNew2.default, null),
	            primaryText: 'Open in new window',
	            onTouchTap: function onTouchTap() {
	                var url = void 0;
	
	                if (widget.spec.video) {
	                    url = _cfg2.default.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.id, _extends({}, _RCore2.default.prepareWidgetPropsObj(widgetProps)));
	                } else {
	                    url = _cfg2.default.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.id, _extends({}, _RCore2.default.prepareWidgetPropsObj(widgetProps)));
	                }
	
	                window.open(url, '_blank');
	            }
	        })
	    );
	});
	
	function Controls(_ref3) {
	    var user = _ref3.user,
	        widget = _ref3.widget,
	        widgetId = _ref3.widgetId,
	        widgetProps = _ref3.widgetProps,
	        widgetUrl = _ref3.widgetUrl,
	        downloading = _ref3.downloading,
	        onStartDownload = _ref3.onStartDownload,
	        onEndDownload = _ref3.onEndDownload,
	        style = _ref3.style,
	        mainAction = _ref3.mainAction;
	
	    return _react2.default.createElement(
	        'div',
	        { style: _extends({ display: 'flex', alignItems: 'center' }, style) },
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                key: 'Download',
	                tooltip: 'Download',
	                onClick: function onClick() {
	                    onStartDownload();
	                    if (widget.spec.video) {
	                        (0, _widgets.browserDownloadWidget2video)(widget, widgetUrl).then(onEndDownload);
	                    } else {
	                        // js: true,
	                        (0, _widgets.browserDownloadWidget2image)(widget, widgetUrl).then(onEndDownload);
	                    }
	                }
	            },
	            downloading ? _react2.default.createElement(_CircularProgress2.default, { size: 24 }) : _react2.default.createElement(_fileDownload2.default, null)
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            { href: widgetUrl, target: '_blank', key: 'onw' },
	            _react2.default.createElement(_openInNew2.default, null)
	        ),
	        widget && !widget.spec.video && _react2.default.createElement(_materialUi.FlatButton, {
	            label: 'Post to campaign',
	            onClick: function onClick() {
	                var schedulePost = JSON.stringify({
	                    widgetId: widgetId,
	                    widgetProps: widgetProps
	                });
	                localStorage.setItem('schedule_post', schedulePost);
	                window.location.href = '/v2/calendar?calendarView=month';
	            }
	        }),
	        _react2.default.createElement(MoreMenu, null),
	        _react2.default.createElement('div', { style: { flexGrow: 1 } }),
	        mainAction
	    );
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withStateHandlers)(function () {
	    return {
	        downloading: false
	    };
	}, {
	    onStartDownload: function onStartDownload() {
	        return function () {
	            return {
	                downloading: true
	            };
	        };
	    },
	    onEndDownload: function onEndDownload() {
	        return function () {
	            return {
	                downloading: false
	            };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(Controls);

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var text = _ref.text,
	        label = _ref.label;
	    return _react2.default.createElement(
	        'div',
	        {
	            style: {
	                minHeight: 56,
	                maxHeight: 56,
	                padding: '0px 15px',
	                color: 'rbga(255,255,255,0.5)',
	                fontWeight: 400
	            }
	        },
	        _react2.default.createElement(
	            'h3',
	            { style: { fontWeight: 400 } },
	            label && _react2.default.createElement(
	                'span',
	                { style: { color: '#00a0b5' } },
	                label
	            ),
	            ' ',
	            text
	        )
	    );
	};

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1718);
	
	var _WidgetEmbed = __webpack_require__(1733);
	
	var _WidgetEmbed2 = _interopRequireDefault(_WidgetEmbed);
	
	var _Controls = __webpack_require__(1730);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Header = __webpack_require__(1731);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ZoomControls = __webpack_require__(1735);
	
	var _ZoomControls2 = _interopRequireDefault(_ZoomControls);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hash = __webpack_require__(1734);
	var WidgetEmbedFromEdior = (0, _reactRedux.connect)(function (_ref) {
	    var editor = _ref.editor;
	
	    var template = _lodash2.default.get(editor, 'widgetProps.template', editor.template); // get template
	
	    var propsToOpen = editor.widgetProps;
	
	    return {
	        widgetId: editor.widgetId,
	        widgetProps: _extends({}, propsToOpen, { editMode: true, template: template }),
	        zoom: editor.zoom,
	        autozoom: editor.autozoom
	    };
	})(_WidgetEmbed2.default);
	
	var RenderError = function RenderError(_ref2) {
	    var previewError = _ref2.previewError;
	    return previewError && previewError.message ? _react2.default.createElement(
	        'div',
	        {
	            style: {
	                position: 'absolute',
	                top: '30%',
	                left: '50%',
	                color: '#fff',
	                zIndex: 100,
	                padding: '20px 40px',
	                borderRadius: 5,
	                background: 'rgba(0,0,0,0.5)',
	                transform: 'translate(-50%,-50%)'
	            }
	        },
	        _react2.default.createElement(
	            'p',
	            null,
	            _lodash2.default.capitalize(previewError.message)
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Please select data in "Data" tab '
	        )
	    ) : null;
	};
	
	var styles = {
	    scrollContainer: {
	        flexGrow: 1,
	        alignItems: 'center',
	        overflow: 'auto',
	        display: 'flex',
	        justifyContent: 'center',
	
	        position: 'relative',
	        width: '100%'
	    }
	};
	
	var PreviewAutoZoom = function (_React$Component) {
	    _inherits(PreviewAutoZoom, _React$Component);
	
	    function PreviewAutoZoom() {
	        _classCallCheck(this, PreviewAutoZoom);
	
	        var _this = _possibleConstructorReturn(this, (PreviewAutoZoom.__proto__ || Object.getPrototypeOf(PreviewAutoZoom)).call(this));
	
	        _this.state = {
	            displayValid: false
	        };
	
	        _this._debounceHandleScreenSizeUpdate = _lodash2.default.debounce(function () {
	            _this.forceUpdate();
	        }, 100);
	        return _this;
	    }
	
	    _createClass(PreviewAutoZoom, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	            this.interval = setInterval(function () {
	                _this2.doCheck();
	            }, 400);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
	            if (this.interval) clearInterval(this.interval);
	        }
	    }, {
	        key: 'doCheck',
	        value: function doCheck() {
	            this.containerSize = this.container && {
	                height: this.container.offsetHeight,
	                width: this.container.offsetWidth
	            };
	            if (!this.containerSize) {
	                this.setState({
	                    displayValid: false
	                });
	            }
	            //console.log("!! displayValid ", this.state.displayValid)
	
	            if (this.containerSize && this.widgetSize && this.widgetSize.height > 0 && this.props.autozoom) {
	                var GAP = 15;
	                var wZoom = (this.containerSize.width - 2 * GAP) / this.widgetSize.width;
	                var hZoom = (this.containerSize.height - 2 * GAP) / this.widgetSize.height;
	
	                var zoom = +Math.min(Math.floor(wZoom * 10) / 10, Math.floor(hZoom * 10) / 10, 1.0).toFixed(1);
	
	                zoom = Math.floor(zoom * 10) / 10;
	
	                if (!this.state.displayValid || this.props.zoom != zoom && zoom <= 1.0) {
	                    this.props.setEditorZoom(zoom, zoom > 50);
	                    this.setState({
	                        displayValid: true
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                preview = _props.preview,
	                previewError = _props.previewError,
	                text = _props.text,
	                label = _props.label,
	                mainAction = _props.mainAction,
	                zoom = _props.zoom;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: 'flex',
	                        flexDirection: 'column',
	                        height: '100%',
	                        overflow: 'hidden',
	                        position: 'relative',
	                        width: '100%'
	                    }
	                },
	                _react2.default.createElement(_Header2.default, { label: label, text: text }),
	                _react2.default.createElement(RenderError, { previewError: previewError }),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: function ref(r) {
	                            _this3.container = r;
	                        },
	                        style: _extends({}, styles.scrollContainer, {
	                            filter: preview ? '' : 'blur(4px)'
	                            // opacity: this.state.displayValid ? '1' : '0.01',
	                        })
	                    },
	                    _react2.default.createElement(WidgetEmbedFromEdior, {
	                        onMeasure: function onMeasure(_ref3) {
	                            var width = _ref3.width,
	                                height = _ref3.height;
	
	                            if (!_this3.widgetSize || Math.abs(_this3.widgetSize.width - width) > 10 || Math.abs(_this3.widgetSize.height - height) > 10) {
	                                _this3.widgetSize = { width: width, height: height };
	                                // this.forceUpdate();
	                            }
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', zIndex: 100, background: '#000', left: 10, bottom: 10 + 48 } },
	                    _react2.default.createElement(_ZoomControls2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { minHeight: 48, background: 'rgba(0,0,0,0.1)', textAlign: 'right' } },
	                    _react2.default.createElement(_Controls2.default, { style: { minHeight: 48 }, mainAction: mainAction })
	                )
	            );
	        }
	    }]);
	
	    return PreviewAutoZoom;
	}(_react2.default.Component);
	
	PreviewAutoZoom.defaultProps = {};
	
	
	var PreviewAndVariations = (0, _reactRedux.connect)(function (_ref4) {
	    var editor = _ref4.editor;
	    return {
	        preview: editor.preview,
	        previewError: editor.previewError,
	        autozoom: editor.autozoom,
	        zoom: editor.zoom
	    };
	}, { setEditorZoom: _actions.setEditorZoom })(PreviewAutoZoom);
	
	exports.default = PreviewAndVariations;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hash = __webpack_require__(1734);
	
	var WidgetPreview = function (_React$Component) {
	    _inherits(WidgetPreview, _React$Component);
	
	    function WidgetPreview() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WidgetPreview);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WidgetPreview.__proto__ || Object.getPrototypeOf(WidgetPreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = { height: 0 }, _this.render = function () {
	            var _this$props = _this.props,
	                user = _this$props.user,
	                widgetId = _this$props.widgetId,
	                template = _this$props.template,
	                _this$props$widgetPro = _this$props.widgetProps,
	                widgetProps = _this$props$widgetPro === undefined ? {} : _this$props$widgetPro,
	                _this$props$zoom = _this$props.zoom,
	                zoom = _this$props$zoom === undefined ? 1.0 : _this$props$zoom,
	                widgetCMP = _this$props.widgetCMP,
	                _onMeasure = _this$props.onMeasure,
	                setPreviewStatus = _this$props.setPreviewStatus;
	
	            if (!widgetId) {
	                return _react2.default.createElement('div', null);
	            }
	            var CMP = widgetCMP && _lodash2.default.get(window, '[rlz' + widgetId + '][' + widgetId + ']');
	
	            // return <>;
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: 'flex',
	                        flexDirection: 'column',
	                        height: _this.state.height || 'auto',
	                        zoom: zoom,
	                        '-moz-transform': 'scale(' + zoom + ',' + zoom + ')',
	                        '-webkit-transform': 'scale(' + zoom + ',' + zoom + ')',
	                        alignItems: 'center',
	                        justifyContent: 'center'
	                    }
	                },
	                CMP && _react2.default.createElement(
	                    _WDPContext2.default,
	                    _extends({
	                        client: user.client,
	                        user: user.username,
	                        token: user.accessToken,
	                        key: widgetId + '_' + widgetProps.template + '_' + widgetProps.variation
	                    }, widgetProps, {
	                        template: widgetProps.template || template
	                    }),
	                    _react2.default.createElement(CMP, _extends({
	                        name: widgetId
	                    }, widgetProps, {
	                        onMeasure: function onMeasure(width, height) {
	                            // if (height !== 0 && height !== this.state.height) this.setState({ height });
	                            if (_onMeasure) _onMeasure({ width: width, height: height });
	                        },
	                        onError: function onError(e) {
	                            setPreviewStatus(false, e);
	                        },
	                        onOk: function onOk() {
	                            setPreviewStatus(true);
	                        }
	                    }))
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return WidgetPreview;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	    var user = _ref2.user,
	        editor = _ref2.editor;
	    var widgetId = _ref3.widgetId;
	
	    var widgetCMP = editor.cmps.indexOf(widgetId + '') !== -1;
	
	    return {
	        user: user,
	        widgetCMP: widgetCMP
	    };
	};
	
	var mapDispatchToProps = { loadWidgetCMP: _actions.loadWidgetCMP, setPreviewStatus: _actions.setPreviewStatus };
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.widgetId !== this.props.widgetId) {
	            this.props.loadWidgetCMP(nextProps.widgetId);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        this.props.loadWidgetCMP(this.props.widgetId);
	    }
	}))(WidgetPreview);

/***/ },
/* 1734 */,
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import IconAddToFav from 'material-ui/svg-icons/action/favorite';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _zoomIn = __webpack_require__(1736);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(1737);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	var _materialUi = __webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    smallIcon: {
	        width: 20,
	        height: 20
	    },
	    small: {
	        width: 32,
	        height: 32,
	        padding: 2
	    }
	};
	var ZoomControls = function ZoomControls(_ref) {
	    var zoom = _ref.zoom,
	        autozoom = _ref.autozoom,
	        setEditorZoom = _ref.setEditorZoom,
	        style = _ref.style,
	        setEditorAutoZoom = _ref.setEditorAutoZoom;
	
	    return _react2.default.createElement(
	        'div',
	        { style: _extends({ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }, style) },
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                iconStyle: styles.smallIcon,
	                style: styles.small,
	                onClick: function onClick() {
	                    setEditorZoom(zoom - 0.1, false);
	                }
	            },
	            _react2.default.createElement(_zoomOut2.default, null)
	        ),
	        _react2.default.createElement(
	            'span',
	            { style: { fontSize: 12, display: 'inline-block', minWidth: 30, textAlign: 'center' } },
	            parseInt(zoom * 100) + '%'
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                iconStyle: styles.smallIcon,
	                style: styles.small,
	                onClick: function onClick() {
	                    setEditorZoom(zoom + 0.1, false);
	                }
	            },
	            _react2.default.createElement(_zoomIn2.default, null)
	        )
	    );
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	    var editor = _ref2.editor;
	
	    return {
	        zoom: editor.zoom,
	        autozoom: editor.autozoom
	    };
	};
	var mapDispatchToProps = { setEditorZoom: _actions.setEditorZoom, setEditorAutoZoom: _actions.setEditorAutoZoom };
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(ZoomControls);

/***/ },
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _editor = __webpack_require__(1756);
	
	var _materialUi = __webpack_require__(642);
	
	var _chevronLeft = __webpack_require__(877);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(878);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _ImageUploaderContainer = __webpack_require__(1179);
	
	var _ImageUploaderContainer2 = _interopRequireDefault(_ImageUploaderContainer);
	
	var _recompose = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagesPreview = (0, _recompose.withStateHandlers)({
	    showUploader: false
	}, {
	    displayUploader: function displayUploader() {
	        return function (showUploader) {
	            return {
	                showUploader: showUploader
	            };
	        };
	    }
	})(function (_ref) {
	    var data = _ref.data,
	        _ref$images = _ref.images,
	        images = _ref$images === undefined ? [] : _ref$images,
	        next = _ref.next,
	        doRefreshImages = _ref.doRefreshImages,
	        prev = _ref.prev,
	        offset = _ref.offset,
	        limit = _ref.limit,
	        showUploader = _ref.showUploader,
	        displayUploader = _ref.displayUploader;
	    return _react2.default.createElement(
	        'div',
	        {
	            style: {
	                display: 'flex',
	                flexDirection: 'wrap',
	                flexWrap: 'wrap',
	                alignItems: 'center',
	                justifyContent: 'space-between'
	            }
	        },
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            { disabled: offset == 0, onClick: function onClick() {
	                    return prev();
	                } },
	            _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement('div', { style: { flexGrow: 1, height: 50 } }),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            { disabled: offset + limit >= data.length, onClick: function onClick() {
	                    return next();
	                } },
	            _react2.default.createElement(_chevronRight2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    display: 'flex',
	                    flexDirection: 'wrap',
	                    flexWrap: 'wrap',
	                    alignItems: 'center',
	                    justifyContent: 'space-between'
	                }
	            },
	            _lodash2.default.chain(images).orderBy(function (i) {
	                return -(0, _moment2.default)(i.createdAt);
	            }).map(function (_ref2) {
	                var cdnUrl = _ref2.cdnUrl,
	                    name = _ref2.name,
	                    _ref2$thumbs = _slicedToArray(_ref2.thumbs, 1),
	                    thumb = _ref2$thumbs[0];
	
	                return _react2.default.createElement('img', {
	                    alt: name,
	                    style: {
	                        width: 112,
	                        height: 112,
	                        marginBottom: 15,
	                        border: '1px solid #fff',
	                        objectFit: 'cover',
	                        cursor: 'grab'
	                    },
	                    onDragStart: function onDragStart(e) {
	                        e.dataTransfer.setData('url', cdnUrl);
	                    },
	                    key: thumb.url,
	                    src: thumb.url
	                });
	            }).value()
	        ),
	        _react2.default.createElement(_materialUi.FlatButton, {
	            label: 'Upload image',
	            style: { width: '100%' },
	            onClick: function onClick() {
	                displayUploader(true);
	            }
	        }),
	        showUploader && _react2.default.createElement(_ImageUploaderContainer2.default, {
	            onClose: function onClose() {
	                displayUploader(false);
	                doRefreshImages();
	            },
	            modal: true,
	            showGallery: false
	        })
	    );
	});
	
	exports.default = (0, _editor.withUserImages)(ImagesPreview);

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.withUserImages = exports.withEditorWidget = undefined;
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRedux = __webpack_require__(250);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var withEditorWidget = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref) {
	    var editor = _ref.editor;
	    return {
	        widgetId: editor.widgetId,
	        widgetProps: editor.widgetProps,
	        template: editor.template,
	        disabled: !editor.preview,
	        zoom: editor.zoom
	    };
	}), (0, _recompose.withHandlers)({
	    onClick: function onClick(_ref2) {
	        var widgetId = _ref2.widgetId,
	            widgetProps = _ref2.widgetProps,
	            template = _ref2.template,
	            props = _objectWithoutProperties(_ref2, ['widgetId', 'widgetProps', 'template']);
	
	        return function (event) {
	            props.onClick(event, { widgetId: widgetId, widgetProps: widgetProps }, template);
	        };
	    }
	}));
	
	exports.withEditorWidget = withEditorWidget;
	var withUserImages = exports.withUserImages = (0, _recompose.compose)((0, _recompose.withStateHandlers)({
	    data: [],
	    images: [],
	    offset: 0,
	    limit: 10,
	    rev: 0
	}, {
	    onImages: function onImages(_ref3) {
	        var offset = _ref3.offset,
	            limit = _ref3.limit;
	        return function (data) {
	            return {
	                data: data,
	                images: _lodash2.default.chain(data).orderBy(function (i) {
	                    return -(0, _moment2.default)(i.createdAt);
	                }).take(limit).value()
	            };
	        };
	    },
	    next: function next(_ref4) {
	        var offset = _ref4.offset,
	            limit = _ref4.limit,
	            data = _ref4.data;
	        return function () {
	            return {
	                images: _lodash2.default.chain(data).orderBy(function (i) {
	                    return -(0, _moment2.default)(i.createdAt);
	                }).slice(offset + limit).take(limit).value(),
	                offset: offset + limit
	            };
	        };
	    },
	    prev: function prev(_ref5) {
	        var offset = _ref5.offset,
	            limit = _ref5.limit,
	            data = _ref5.data;
	        return function () {
	            return {
	                offset: Math.max(offset - limit, 0),
	                images: _lodash2.default.chain(data).orderBy(function (i) {
	                    return -(0, _moment2.default)(i.createdAt);
	                }).slice(offset - limit).take(limit).value()
	            };
	        };
	    },
	    doRefreshImages: function doRefreshImages(_ref6) {
	        var rev = _ref6.rev;
	        return function () {
	            return {
	                rev: rev + 1,
	                offset: 0
	            };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        if (nextProps.rev != this.props.rev) {
	            fetch(_cfg2.default.dash.api.host + '/api/media?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                _this.props.onImages(data);
	            });
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        var _this2 = this;
	
	        fetch(_cfg2.default.dash.api.host + '/api/media?access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	            return response.json();
	        }).then(function (data) {
	            _this2.props.onImages(data);
	        });
	    }
	}));

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var _flip = __webpack_require__(1758);
	
	var _flip2 = _interopRequireDefault(_flip);
	
	var _zoomIn = __webpack_require__(1736);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(1737);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	var _blurOff = __webpack_require__(1759);
	
	var _blurOff2 = _interopRequireDefault(_blurOff);
	
	var _blurLinear = __webpack_require__(1760);
	
	var _blurLinear2 = _interopRequireDefault(_blurLinear);
	
	var _blurCircular = __webpack_require__(1761);
	
	var _blurCircular2 = _interopRequireDefault(_blurCircular);
	
	var _blurOn = __webpack_require__(1762);
	
	var _blurOn2 = _interopRequireDefault(_blurOn);
	
	var _reactColor = __webpack_require__(1195);
	
	var _color = __webpack_require__(1426);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(area) {
	    var width = area.width,
	        height = area.height,
	        scale = area.scale,
	        x = area.x,
	        y = area.y,
	        cw = area.cw,
	        ch = area.ch;
	
	
	    var realWidth = width * scale;
	    var realHeight = height * scale;
	
	    var reachX = realWidth + x;
	    var reachY = realHeight + y;
	
	    var coverLeft = x <= 0.1;
	    var coverRight = reachX - cw >= -0.1;
	
	    var coverTop = y <= 1;
	    var coverBottom = reachY - ch >= -0.5;
	
	    return coverLeft && coverRight && coverTop && coverBottom;
	};
	
	var calcFitPosition = function calcFitPosition(area) {
	    var width = area.width,
	        height = area.height,
	        cw = area.cw,
	        ch = area.ch;
	
	    var neededScaleX = cw / width;
	    var neededScaleY = ch / height;
	
	    var scale = +Math.max(neededScaleX, neededScaleY).toFixed(3);
	    var x = (cw - width * scale).toFixed(3) / 2;
	    var y = (ch - height * scale).toFixed(3) / 2;
	
	    return {
	        scale: scale,
	        x: x,
	        y: y
	    };
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.withStateHandlers)({
	    propKey: null,
	    colorPickerFor: null
	}, {
	    enterEditMode: function enterEditMode() {
	        return function (id) {
	            return {
	                propKey: id
	            };
	        };
	    },
	    showColorPicker: function showColorPicker() {
	        return function (colorPickerFor) {
	            return {
	                colorPickerFor: colorPickerFor
	            };
	        };
	    }
	}), (0, _reactRedux.connect)(function (_ref, _ref2) {
	    var editor = _ref.editor;
	    var propKey = _ref2.propKey;
	    return {
	        im: _lodash2.default.get(editor, 'widgetProps.' + propKey, {})
	    };
	}, {
	    changeWidgetJSProp: _actions.changeWidgetJSProp,
	    updateWidgetJSPropField: _actions.updateWidgetJSPropField,
	    recalculateArea: _actions.recalculateArea
	}), (0, _recompose.withHandlers)({
	    handleScale: function handleScale(_ref3) {
	        var im = _ref3.im;
	        return function (delta) {
	            var _im$scale = im.scale,
	                scale = _im$scale === undefined ? 1.0 : _im$scale,
	                width = im.width,
	                height = im.height,
	                x = im.x,
	                y = im.y,
	                cw = im.cw,
	                ch = im.ch;
	
	
	            var defaults = calcFitPosition(im);
	            var newScale = +Math.max(defaults.scale, +(scale + delta)).toFixed(3);
	            var valid = isValid(_extends({}, im, { scale: newScale }));
	
	            var correlation = {};
	
	            if (!valid) {
	                // newScale
	                var dx = x + newScale * width - cw;
	                var dy = y + newScale * height - ch;
	
	                if (dx < 0) correlation.x = +(x - dx).toFixed(3);
	                if (dy < 0) correlation.y = +(y - dy).toFixed(3);
	            }
	            return _extends({
	                scale: newScale
	            }, correlation);
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    onManipulation: function onManipulation(e) {
	        switch (e.detail.type) {
	            case 'ACTIVATE':
	                {
	                    if (this.props.propKey) this.props.updateWidgetJSPropField(this.props.propKey, { active: false }); // reset active mode
	                    this.props.enterEditMode(e.detail.id);
	                    this.props.updateWidgetJSPropField(e.detail.id, { active: true });
	                    break;
	                }
	            case 'CONTAINER_RESIZE':
	                {
	                    // this.props.updateWidgetJSPropField(e.detail.id, e.detail.values);
	
	                    this.props.recalculateArea(e.detail.id, e.detail.values);
	
	                    break;
	                }
	            case 'UPDATE':
	                {
	                    this.props.updateWidgetJSPropField(e.detail.id, e.detail.values);
	                    break;
	                }
	            case 'CHANGE':
	                {
	                    var a = {};
	                    a[e.detail.id] = e.detail.values;
	                    this.props.changeWidgetJSProp(a);
	                    break;
	                }
	        }
	    },
	    onClick: function onClick(e) {},
	    componentDidMount: function componentDidMount() {
	        this._listenter = this.onManipulation.bind(this);
	        this._clicklistenter = this.onClick.bind(this);
	        window.addEventListener('WDP_IM', this._listenter, false);
	        document.addEventListener('click', this._clicklistenter, false);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('WDP_IM', this._listenter);
	        document.removeEventListener('click', this._clicklistenter);
	    }
	}))(function (_ref4) {
	    var propKey = _ref4.propKey,
	        im = _ref4.im,
	        updateWidgetJSPropField = _ref4.updateWidgetJSPropField,
	        handleScale = _ref4.handleScale,
	        showColorPicker = _ref4.showColorPicker,
	        colorPickerFor = _ref4.colorPickerFor;
	
	    var imageWidth = 250;
	
	    if (!im) return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        _react2.default.createElement(
	            'i',
	            { style: { fontSize: 12 } },
	            'Start image manipulation by adding custom background below '
	        )
	    );
	
	    if (im && !im.url) return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        _react2.default.createElement(
	            'i',
	            { style: { fontSize: 12 } },
	            'DROP AN IMAGE TO CONTAINER'
	        )
	    );
	    var previewScale = imageWidth / im.width;
	
	    var bgr = 'rgba(0,0,0,0.5)';
	
	    if (im.oa == -1) bgr = 'radial-gradient(' + im.osc + ', ' + im.oec + ')';else if (im.oa == -2) bgr = 'radial-gradient( ' + im.oec + ', ' + im.osc + ')';else if (_lodash2.default.isInteger(im.oa)) bgr = 'linear-gradient(' + im.oa + 'deg, ' + im.osc + ' 0%, ' + im.oec + ' 100%)';
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', background: '#000', position: 'relative', width: imageWidth } },
	            im && im.url && _react2.default.createElement('img', {
	                alt: '',
	                src: im.url,
	                style: {
	                    objectFit: 'contain',
	                    width: imageWidth,
	                    transformOrigin: '0 0',
	                    transform: 'rotateX(' + (im.flipY ? 180 : 0) + 'deg) rotateY(' + (im.flipX ? 180 : 0) + 'deg) translateY(' + (im.flipY ? '-100%' : '0') + ') translateX(' + (im.flipX ? '-100%' : '0') + ')'
	                }
	            }),
	            _react2.default.createElement('div', {
	                style: {
	                    position: 'absolute',
	                    left: -(im.x * previewScale / im.scale) + 'px',
	                    top: -(im.y * previewScale / im.scale) + 'px',
	                    width: im.cw * previewScale / im.scale + 'px',
	                    height: im.ch * previewScale / im.scale + 'px',
	                    zIndex: 10,
	                    boxShadow: '0 0 1px #fff',
	                    background: bgr
	                }
	            })
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                onClick: function onClick() {
	                    var smartScale = handleScale(0.1);
	                    updateWidgetJSPropField(propKey, _extends({}, smartScale));
	                }
	            },
	            _react2.default.createElement(_zoomIn2.default, null)
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                tooltip: 'Flip Y',
	                tooltipPosition: 'top-center',
	                onClick: function onClick() {
	                    var smartScale = handleScale(-0.1);
	                    updateWidgetJSPropField(propKey, _extends({}, smartScale));
	                }
	            },
	            _react2.default.createElement(_zoomOut2.default, null)
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                iconStyle: { transform: 'rotate(' + (im.flipX ? 0 : 180) + 'deg' },
	                tooltip: 'Flip X',
	                tooltipPosition: 'top-center',
	                onClick: function onClick() {
	                    updateWidgetJSPropField(propKey, { flipX: !im.flipX });
	                }
	            },
	            _react2.default.createElement(_flip2.default, null)
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                tooltip: 'Flip Y',
	                tooltipPosition: 'top-center',
	                iconStyle: { transform: 'rotate(' + (im.flipY ? -90 : -270) + 'deg' },
	                onClick: function onClick() {
	                    updateWidgetJSPropField(propKey, { flipY: !im.flipY });
	                }
	            },
	            _react2.default.createElement(_flip2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            'Gradient'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            [[null, _blurOff2.default, 'off', {}, 'Off'], [90, _blurLinear2.default, 'linear90', { transform: 'rotate(180deg)' }, 'to the right'], [270, _blurLinear2.default, 'linear270', { transform: 'rotate(0deg)' }, 'to the left'], [180, _blurLinear2.default, 'linear0', { transform: 'rotate(270deg)' }, 'from bottom'], [0, _blurLinear2.default, 'linear180', { transform: 'rotate(90deg)' }, 'from top'], [-1, _blurCircular2.default, 'radial', {}, 'radial'], [-2, _blurOn2.default, 'radialinv', {}, 'radial inverse']].map(function (_ref5) {
	                var _ref6 = _slicedToArray(_ref5, 5),
	                    deg = _ref6[0],
	                    Icon = _ref6[1],
	                    key = _ref6[2],
	                    _ref6$ = _ref6[3],
	                    style = _ref6$ === undefined ? {} : _ref6$,
	                    tooltip = _ref6[4];
	
	                return _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                        key: key,
	                        tooltip: tooltip,
	                        tooltipPosition: 'top-center',
	                        iconStyle: _extends({}, style),
	                        primary: deg == im.oa,
	                        onClick: function onClick() {
	                            var update = {};
	                            update.oa = deg;
	
	                            if (!im.osc) update.osc = 'rgba(0,0,0,0.1)';
	                            if (!im.oec) update.oec = 'rgba(0,0,0,0.5)';
	                            updateWidgetJSPropField(propKey, update);
	                        }
	                    },
	                    _react2.default.createElement(Icon, { color: deg == im.oa ? '#008c9d' : '#fff' })
	                );
	            })
	        ),
	        im.oa !== null && _react2.default.createElement(
	            'div',
	            { style: { position: 'relative' } },
	            _react2.default.createElement(_materialUi.FlatButton, {
	                style: { width: '50%' },
	                icon: _react2.default.createElement('div', {
	                    style: {
	                        width: 24,
	                        height: 24,
	                        boxShadow: '0 0 1px #fff',
	                        backgroundColor: im.osc || 'rgba(0,0,0,0.1)',
	                        display: 'inline-block'
	                    }
	                }),
	                label: 'Start',
	                onClick: function onClick(e) {
	                    showColorPicker('osc');
	                }
	            }),
	            _react2.default.createElement(_materialUi.FlatButton, {
	                style: { width: '50%' },
	                icon: _react2.default.createElement('div', {
	                    style: {
	                        width: 24,
	                        height: 24,
	                        boxShadow: '0 0 1px #fff',
	                        backgroundColor: im.oec || 'rgba(0,0,0,0.5)',
	                        display: 'inline-block'
	                    }
	                }),
	                label: 'End',
	                onClick: function onClick(e) {
	                    showColorPicker('oec');
	                }
	            }),
	            colorPickerFor && _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        position: 'absolute',
	                        zIndex: '2'
	                    }
	                },
	                _react2.default.createElement('div', {
	                    style: {
	                        position: 'fixed',
	                        top: '0px',
	                        right: '0px',
	                        bottom: '0px',
	                        left: '0px',
	
	                        background: '#000',
	                        opacity: 0.2
	                    },
	                    onClick: function onClick() {
	                        return showColorPicker(null);
	                    }
	                }),
	                _react2.default.createElement(_reactColor.SketchPicker, {
	                    key: 'pi',
	                    color: im[colorPickerFor],
	                    onChangeComplete: function onChangeComplete(_ref7) {
	                        var rgb = _ref7.rgb;
	
	                        var update = {};
	
	                        update[colorPickerFor] = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
	
	                        updateWidgetJSPropField(propKey, update);
	                    }
	                })
	            )
	        )
	    );
	});

/***/ },
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PickersControls = __webpack_require__(1764);
	
	var _PickersControls2 = _interopRequireDefault(_PickersControls);
	
	var _PickersControlsDialog = __webpack_require__(1779);
	
	var _PickersControlsDialog2 = _interopRequireDefault(_PickersControlsDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PickerSwitcher = function PickerSwitcher(_ref) {
	    var _ref$type = _ref.type,
	        type = _ref$type === undefined ? '' : _ref$type;
	    return type === 'dialog' ? _react2.default.createElement(_PickersControlsDialog2.default, null) : _react2.default.createElement(_PickersControls2.default, null);
	};
	
	PickerSwitcher.propTypes = {
	    type: _propTypes2.default.string
	};
	
	exports.default = PickerSwitcher;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pickerControl = __webpack_require__(1765);
	
	var _pickerControl2 = _interopRequireDefault(_pickerControl);
	
	var _TextPicker = __webpack_require__(1768);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _PlayerPicker = __webpack_require__(1770);
	
	var _PlayerPicker2 = _interopRequireDefault(_PlayerPicker);
	
	var _TeamPicker = __webpack_require__(1776);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextPickerControl = (0, _pickerControl2.default)(_TextPicker2.default);
	var PlayerPickerControl = (0, _pickerControl2.default)(_PlayerPicker2.default);
	var TeamPickerControl = (0, _pickerControl2.default)(_TeamPicker2.default);
	
	var PickersControls = function PickersControls() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(TextPickerControl, null),
	        _react2.default.createElement(PlayerPickerControl, null),
	        _react2.default.createElement(TeamPickerControl, null)
	    );
	};
	
	PickersControls.propTypes = {
	    type: _propTypes2.default.string
	};
	
	exports.default = PickersControls;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(1096);
	
	var _helpers = __webpack_require__(1766);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pickerControl = function pickerControl(DecoratedComponent) {
	    return (0, _recompose.compose)((0, _helpers.withSubscribeEvent)('WDP_TEXTM'))(function (props) {
	        return _react2.default.createElement(DecoratedComponent, props);
	    });
	};
	
	exports.default = pickerControl;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.withSubscribeEvent = exports.addRefComponent = exports.labelTextReplace = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _autoComplete = __webpack_require__(1767);
	
	Object.keys(_autoComplete).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _autoComplete[key];
	        }
	    });
	});
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1718);
	
	var labelTextReplace = exports.labelTextReplace = function labelTextReplace() {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return str.replace(/(^[a-z]{1})|([A-Z])/g, function (_, firstLater, upparCaseLater) {
	        if (firstLater) {
	            return firstLater.toUpperCase();
	        } else {
	            return ' ' + upparCaseLater;
	        }
	    });
	};
	
	var addRefComponent = exports.addRefComponent = function addRefComponent() {
	    return (0, _recompose.withHandlers)(function () {
	        var refElement = null;
	
	        return {
	            getRef: function getRef() {
	                return function () {
	                    return refElement;
	                };
	            },
	            setRef: function setRef() {
	                return function (ref) {
	                    refElement = ref;
	                };
	            }
	        };
	    });
	};
	
	var withSubscribeEvent = exports.withSubscribeEvent = function withSubscribeEvent() {
	    var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return (0, _recompose.compose)((0, _recompose.withStateHandlers)({ id: null }, { enterEditMode: function enterEditMode() {
	            return function (id) {
	                return { id: id };
	            };
	        } }), (0, _reactRedux.connect)(function (_ref, _ref2) {
	        var _ref$editor = _ref.editor,
	            editor = _ref$editor === undefined ? {} : _ref$editor;
	        var id = _ref2.id;
	        return {
	            params: editor.widgetProps && editor.widgetProps[id] || {},
	            widgetProps: editor.widgetProps
	        };
	    }, { changeWidgetJSProp: _actions.changeWidgetJSProp, updateWidgetJSPropField: _actions.updateWidgetJSPropField }), (0, _recompose.lifecycle)({
	        onManipulation: function onManipulation() {
	            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { detail: {} };
	            var _event$detail = event.detail,
	                detail = _event$detail === undefined ? {} : _event$detail;
	
	
	            switch (detail.type) {
	                case 'ACTIVATE':
	                    {
	                        if (this.props.id) {
	                            this.props.updateWidgetJSPropField(this.props.id, { active: false });
	                        }
	
	                        this.props.updateWidgetJSPropField(detail.id, _extends({}, detail.values || {}, {
	                            active: true
	                        }));
	                        this.props.enterEditMode(detail.id);
	
	                        break;
	                    }
	                case 'DEACTIVATE':
	                    {
	                        if (this.props.id) {
	                            this.props.updateWidgetJSPropField(this.props.id, { active: false });
	                            this.props.enterEditMode(null);
	                        }
	
	                        if (this.props.widgetProps && this.props.widgetProps[detail.id] && this.props.widgetProps[detail.id].active) {
	                            this.props.updateWidgetJSPropField(detail.id, { active: false });
	                        }
	
	                        break;
	                    }
	            }
	        },
	        componentDidMount: function componentDidMount() {
	            this._listenter = this.onManipulation.bind(this);
	            window.addEventListener(eventName, this._listenter);
	        },
	
	        // componentWillReceiveProps({ id }) {
	        //     console.log(id, this.props.id);
	        //     if (id && this.props.id !== id) {
	        //         this.props.updateWidgetJSPropField(this.props.id, { active: false });
	        //     }
	        // },
	        componentWillUnmount: function componentWillUnmount() {
	            if (this.props.id) {
	                this.props.updateWidgetJSPropField(this.props.id, { active: false });
	            }
	            window.removeEventListener(eventName, this._listenter);
	        }
	    }));
	};

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.autoCompleteDefaultLifeCycle = exports.autoCompleteWithHandlers = exports.autoCompleteWithHandlerLoadData = exports.autoCompleteWithStateHandlers = exports.autoCompletePickerPropTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _debounce = __webpack_require__(1240);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _recompose = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var autoCompletePickerPropTypes = exports.autoCompletePickerPropTypes = function autoCompletePickerPropTypes() {
	    return (0, _recompose.setPropTypes)({
	        id: _propTypes2.default.string.isRequired,
	        defaultName: _propTypes2.default.string,
	        propsMap: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        updateWidgetJSPropField: _propTypes2.default.func.isRequired
	    });
	};
	
	var autoCompleteWithStateHandlers = exports.autoCompleteWithStateHandlers = function autoCompleteWithStateHandlers() {
	    return (0, _recompose.withStateHandlers)(function (_ref) {
	        var _ref$defaultName = _ref.defaultName,
	            defaultName = _ref$defaultName === undefined ? '' : _ref$defaultName;
	        return {
	            loading: false,
	            searchText: defaultName,
	            data: []
	        };
	    }, {
	        handleLoading: function handleLoading() {
	            return function () {
	                var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	                return { loading: loading };
	            };
	        },
	        handleSearchText: function handleSearchText() {
	            return function () {
	                var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                return { searchText: searchText };
	            };
	        },
	        handleData: function handleData() {
	            return function () {
	                var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                return { data: data };
	            };
	        }
	    });
	};
	
	var autoCompleteWithHandlerLoadData = exports.autoCompleteWithHandlerLoadData = function autoCompleteWithHandlerLoadData() {
	    var fetchDataCb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
	    return (0, _recompose.withHandlers)({
	        loadData: function loadData(_ref2) {
	            var _ref2$loading = _ref2.loading,
	                loading = _ref2$loading === undefined ? false : _ref2$loading,
	                handleLoading = _ref2.handleLoading,
	                handleData = _ref2.handleData;
	            return (0, _debounce2.default)(function () {
	                var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	                var controller = new AbortController();
	                var signal = controller.signal;
	
	                if (loading) {
	                    controller.abort();
	                }
	
	                handleLoading(false);
	
	                fetchDataCb(searchText, signal).then(function (data) {
	                    handleData(data);
	                    handleLoading(false);
	                }).catch(function () {
	                    handleLoading(false);
	                });
	            }, wait);
	        }
	    });
	};
	
	var autoCompleteWithHandlers = exports.autoCompleteWithHandlers = function autoCompleteWithHandlers() {
	    var onNewRequestDefaultKeysCb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return {};
	    };
	    var isLoadDataInHandleUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return (0, _recompose.withHandlers)({
	        handleUpdateInput: function handleUpdateInput(_ref3) {
	            var id = _ref3.id,
	                handleSearchText = _ref3.handleSearchText,
	                loadData = _ref3.loadData,
	                updateWidgetJSPropField = _ref3.updateWidgetJSPropField;
	            return function () {
	                var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	                updateWidgetJSPropField(id, { defaultName: searchText });
	
	                handleSearchText(searchText);
	
	                if (isLoadDataInHandleUpdate) {
	                    loadData(searchText);
	                }
	            };
	        },
	        onNewRequest: function onNewRequest(_ref4) {
	            var id = _ref4.id,
	                propsMap = _ref4.propsMap,
	                updateWidgetJSPropField = _ref4.updateWidgetJSPropField;
	            return function () {
	                var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                updateWidgetJSPropField(id, Object.entries(propsMap).reduce(function (stats, _ref5) {
	                    var _ref6 = _slicedToArray(_ref5, 2),
	                        statName = _ref6[0],
	                        key = _ref6[1];
	
	                    return _extends({}, stats, _defineProperty({}, statName, (0, _get2.default)(data, key)));
	                }, onNewRequestDefaultKeysCb(data)));
	            };
	        },
	        handleOnClose: function handleOnClose(_ref7) {
	            var id = _ref7.id,
	                searchText = _ref7.searchText,
	                updateWidgetJSPropField = _ref7.updateWidgetJSPropField;
	            return function () {
	                updateWidgetJSPropField(id, { defaultName: searchText });
	            };
	        }
	    });
	};
	
	var autoCompleteDefaultLifeCycle = exports.autoCompleteDefaultLifeCycle = function autoCompleteDefaultLifeCycle() {
	    var isDidMountLoadData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return (0, _recompose.lifecycle)({
	        componentDidMount: function componentDidMount() {
	            if (isDidMountLoadData) {
	                this.props.loadData();
	            }
	        },
	        componentWillReceiveProps: function componentWillReceiveProps(_ref8) {
	            var _ref8$defaultName = _ref8.defaultName,
	                defaultName = _ref8$defaultName === undefined ? '' : _ref8$defaultName;
	
	            if (this.props.defaultName !== defaultName) {
	                this.props.handleSearchText(defaultName);
	            }
	        }
	    });
	};

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InputMaterial = __webpack_require__(1769);
	
	var _InputMaterial2 = _interopRequireDefault(_InputMaterial);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TextPicker = function TextPicker(_ref) {
	    var id = _ref.id,
	        _ref$params = _ref.params;
	    _ref$params = _ref$params === undefined ? {} : _ref$params;
	
	    var type = _ref$params.type,
	        _ref$params$placehold = _ref$params.placeholder,
	        placeholder = _ref$params$placehold === undefined ? 'Edit text' : _ref$params$placehold,
	        _ref$params$active = _ref$params.active,
	        active = _ref$params$active === undefined ? false : _ref$params$active,
	        params = _objectWithoutProperties(_ref$params, ['type', 'placeholder', 'active']),
	        _ref$fullWidth = _ref.fullWidth,
	        fullWidth = _ref$fullWidth === undefined ? true : _ref$fullWidth,
	        updateWidgetJSPropField = _ref.updateWidgetJSPropField,
	        _ref$isCustomInput = _ref.isCustomInput,
	        isCustomInput = _ref$isCustomInput === undefined ? true : _ref$isCustomInput;
	
	    if (id == null || type !== 'string' || Object.keys(params || {}).length === 0 || !active) {
	        return null;
	    }
	
	    var InputComponent = isCustomInput ? _InputMaterial2.default : _TextField2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        Object.entries(params && params.propsMap || {}).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                key = _ref3[0];
	
	            return _react2.default.createElement(InputComponent, {
	                key: key,
	                fullWidth: fullWidth,
	                floatingLabelText: placeholder,
	                value: params[key],
	                onChange: function onChange(event, value) {
	                    updateWidgetJSPropField(id, _defineProperty({}, key, value));
	                }
	            });
	        })
	    );
	};
	
	TextPicker.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    params: _propTypes2.default.shape({
	        text: _propTypes2.default.string,
	        placeholder: _propTypes2.default.string
	    }),
	    fullWidth: _propTypes2.default.bool,
	    isCustomInput: _propTypes2.default.bool,
	    updateWidgetJSPropField: _propTypes2.default.func.isRequired
	};
	
	exports.default = TextPicker;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    margin-top: 13px;\n'], ['\n    position: relative;\n    margin-top: 13px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin-top: -2px;\n\n    &:before {\n        content: \'\';\n        width: 0;\n        height: 2px;\n\n        background-color: rgb(0, 151, 167);\n        transition: 0.2s ease all;\n    }\n'], ['\n    position: relative;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin-top: -2px;\n\n    &:before {\n        content: \'\';\n        width: 0;\n        height: 2px;\n\n        background-color: rgb(0, 151, 167);\n        transition: 0.2s ease all;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: absolute;\n    bottom: 50%;\n    left: 0;\n    transform: translateY(50%);\n\n    font-size: 16px;\n\n    color: inherit;\n    opacity: 0.7;\n\n    pointer-events: none;\n    transition: 0.2s ease all;\n'], ['\n    position: absolute;\n    bottom: 50%;\n    left: 0;\n    transform: translateY(50%);\n\n    font-size: 16px;\n\n    color: inherit;\n    opacity: 0.7;\n\n    pointer-events: none;\n    transition: 0.2s ease all;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: block;\n    padding: 4px 0 6px;\n\n    font-size: 14px;\n\n    color: inherit;\n    border: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n    background-color: transparent;\n\n    &:focus {\n        outline: none;\n    }\n\n    &:focus ~ ', ', &:not([value=\'\']) ~ ', ' {\n        transform: translateY(-50%);\n        font-size: 12px;\n        opacity: 0.5;\n    }\n\n    &:focus ~ ', ' {\n        color: rgb(0, 151, 167);\n        opacity: 1;\n    }\n\n    &:focus ~ ', ':before {\n        width: 100%;\n    }\n\n    ', ';\n'], ['\n    display: block;\n    padding: 4px 0 6px;\n\n    font-size: 14px;\n\n    color: inherit;\n    border: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n    background-color: transparent;\n\n    &:focus {\n        outline: none;\n    }\n\n    &:focus ~ ', ', &:not([value=\'\']) ~ ', ' {\n        transform: translateY(-50%);\n        font-size: 12px;\n        opacity: 0.5;\n    }\n\n    &:focus ~ ', ' {\n        color: rgb(0, 151, 167);\n        opacity: 1;\n    }\n\n    &:focus ~ ', ':before {\n        width: 100%;\n    }\n\n    ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Bar = _styledComponents2.default.span(_templateObject2);
	
	var Label = _styledComponents2.default.label(_templateObject3);
	
	var Input = _styledComponents2.default.input(_templateObject4, Label, Label, Label, Bar, function (_ref) {
	    var fullWidth = _ref.fullWidth;
	    return fullWidth && 'width: 100%';
	});
	
	var cb = function cb() {
	    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	    return function (event) {
	        return action(event, event.target.value);
	    };
	};
	
	var InputMaterial = function InputMaterial(_ref2) {
	    var _ref2$value = _ref2.value,
	        value = _ref2$value === undefined ? '' : _ref2$value,
	        _ref2$floatingLabelTe = _ref2.floatingLabelText,
	        floatingLabelText = _ref2$floatingLabelTe === undefined ? '' : _ref2$floatingLabelTe,
	        _ref2$fullWidth = _ref2.fullWidth,
	        fullWidth = _ref2$fullWidth === undefined ? false : _ref2$fullWidth,
	        _ref2$onChange = _ref2.onChange,
	        onChange = _ref2$onChange === undefined ? function () {} : _ref2$onChange,
	        _ref2$onBlur = _ref2.onBlur,
	        onBlur = _ref2$onBlur === undefined ? function () {} : _ref2$onBlur;
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(Input, { type: 'text', value: value, fullWidth: fullWidth, onChange: cb(onChange), onBlur: cb(onBlur) }),
	        _react2.default.createElement(Bar, null),
	        _react2.default.createElement(
	            Label,
	            null,
	            floatingLabelText
	        )
	    );
	};
	
	InputMaterial.propTypes = {
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    floatingLabelText: _propTypes2.default.string,
	    fullWidth: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func
	};
	
	exports.default = InputMaterial;

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(1766);
	
	var _AutoCompletePlayer = __webpack_require__(1771);
	
	var _AutoCompletePlayer2 = _interopRequireDefault(_AutoCompletePlayer);
	
	var _SelectStats = __webpack_require__(1775);
	
	var _SelectStats2 = _interopRequireDefault(_SelectStats);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _InputMaterial = __webpack_require__(1769);
	
	var _InputMaterial2 = _interopRequireDefault(_InputMaterial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PlayerPicker = function PlayerPicker(_ref) {
	    var id = _ref.id,
	        _ref$params = _ref.params;
	    _ref$params = _ref$params === undefined ? {} : _ref$params;
	    var _ref$params$defaultNa = _ref$params.defaultName,
	        defaultName = _ref$params$defaultNa === undefined ? '' : _ref$params$defaultNa,
	        type = _ref$params.type,
	        playerId = _ref$params.playerId,
	        _ref$params$selectVal = _ref$params.selectValue,
	        selectValue = _ref$params$selectVal === undefined ? '' : _ref$params$selectVal,
	        _ref$params$propsMap = _ref$params.propsMap;
	    _ref$params$propsMap = _ref$params$propsMap === undefined ? {} : _ref$params$propsMap;
	
	    var statsMap = _ref$params$propsMap.stats,
	        propsMap = _objectWithoutProperties(_ref$params$propsMap, ['stats']),
	        params = _objectWithoutProperties(_ref$params, ['defaultName', 'type', 'playerId', 'selectValue', 'propsMap']),
	        _ref$fullWidth = _ref.fullWidth,
	        fullWidth = _ref$fullWidth === undefined ? true : _ref$fullWidth,
	        updateWidgetJSPropField = _ref.updateWidgetJSPropField,
	        _ref$isCustomInput = _ref.isCustomInput,
	        isCustomInput = _ref$isCustomInput === undefined ? true : _ref$isCustomInput;
	
	    if (id == null || type !== 'player') {
	        return null;
	    }
	
	    var InputComponent = isCustomInput ? _InputMaterial2.default : _TextField2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AutoCompletePlayer2.default, {
	            id: id,
	            defaultName: defaultName,
	            propsMap: propsMap,
	            updateWidgetJSPropField: updateWidgetJSPropField
	        }),
	        statsMap && playerId && _react2.default.createElement(_SelectStats2.default, {
	            id: id,
	            valueDefault: selectValue,
	            playerId: playerId,
	            propsStatsMap: statsMap,
	            updateWidgetJSPropField: updateWidgetJSPropField
	        }),
	        Object.entries(_extends({}, propsMap, statsMap || {})).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                _ref3$ = _ref3[0],
	                key = _ref3$ === undefined ? '' : _ref3$;
	
	            return _react2.default.createElement(InputComponent, {
	                key: key,
	                floatingLabelText: (0, _helpers.labelTextReplace)(key),
	                value: params[key] == null ? '' : params[key],
	                fullWidth: fullWidth,
	                onChange: function onChange(event, value) {
	                    updateWidgetJSPropField(id, _defineProperty({}, key, value));
	                }
	            });
	        })
	    );
	};
	
	PlayerPicker.propTypes = {
	    id: _propTypes2.default.string,
	    params: _propTypes2.default.shape({
	        name: _propTypes2.default.string,
	        score: _propTypes2.default.string,
	        placeholder: _propTypes2.default.string
	    }),
	    propsMap: _propTypes2.default.objectOf(_propTypes2.default.string),
	    fullWidth: _propTypes2.default.bool,
	    isCustomInput: _propTypes2.default.bool,
	    updateWidgetJSPropField: _propTypes2.default.func.isRequired
	};
	
	exports.default = PlayerPicker;

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AutoComplete = __webpack_require__(789);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _autoCompletePlayerHOC = __webpack_require__(1772);
	
	var _autoCompletePlayerHOC2 = _interopRequireDefault(_autoCompletePlayerHOC);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoCompletePlayer = function AutoCompletePlayer(_ref) {
	    var searchText = _ref.searchText,
	        players = _ref.data,
	        handleOnClose = _ref.handleOnClose,
	        handleUpdateInput = _ref.handleUpdateInput,
	        onNewRequest = _ref.onNewRequest;
	    return _react2.default.createElement(_AutoComplete2.default, {
	        floatingLabelText: 'Player name',
	        fullWidth: true,
	        openOnFocus: true,
	        searchText: searchText,
	        filter: _AutoComplete2.default.caseInsensitiveFilter,
	        dataSource: players,
	        dataSourceConfig: { text: 'name', value: 'id' },
	        onClose: handleOnClose,
	        onUpdateInput: handleUpdateInput,
	        onNewRequest: onNewRequest
	    });
	};
	
	AutoCompletePlayer.propTypes = {
	    searchText: _propTypes2.default.string,
	    data: _propTypes2.default.array.isRequired,
	    onNewRequest: _propTypes2.default.func.isRequired,
	    handleOnClose: _propTypes2.default.func.isRequired,
	    handleUpdateInput: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _autoCompletePlayerHOC2.default)(AutoCompletePlayer);

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(1096);
	
	var _autoComplete = __webpack_require__(1767);
	
	var _api = __webpack_require__(1773);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoCompletePlayerHOC = function autoCompletePlayerHOC(AutoComplete) {
	    return (0, _recompose.compose)((0, _autoComplete.autoCompletePickerPropTypes)(), (0, _autoComplete.autoCompleteWithStateHandlers)(), (0, _autoComplete.autoCompleteWithHandlerLoadData)(_api.fetchSearchPlayers, 300), (0, _autoComplete.autoCompleteWithHandlers)(function (data) {
	        return {
	            playerId: data.id
	        };
	    }, true), (0, _autoComplete.autoCompleteDefaultLifeCycle)())(function (props) {
	        return _react2.default.createElement(AutoComplete, props);
	    });
	};
	
	exports.default = autoCompletePlayerHOC;

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchAllTeams = exports.fetchSearchPlayerCareer = exports.fetchSearchPlayers = exports.fetchOddsShortenUrl = exports.fetchPostStats = exports.fetchSmLinks = exports.putChangeTargetsPost = exports.deletePost = exports.rejectPost = exports.retrySendPost = exports.approvePost = exports.postUpdateMessage = exports.postUpdatePresentation = exports.postNowRule = exports.fetchPost = exports.fetchPosts = exports.deleteCampaignRule = exports.putCampaignRule = exports.postCampaignRule = exports.fetchCampaignRules = exports.fetchTournamentsEvents = exports.fetchTeamEvents = exports.fetchTeamMembers = exports.putUserCampaignInterests = exports.fetchUserCampaigns = exports.fetchAllTemplatesSpecs = exports.fetchAllWidgetsSpecs = exports.fetchUserMe = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(1774);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkResponse(res) {
	    var isOkCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (res) {
	        return res.json();
	    };
	
	    if (res.ok) {
	        return isOkCb(res);
	    } else {
	        throw new Error(res.status + ', ' + res.statusText);
	    }
	}
	
	var fetchUserMe = exports.fetchUserMe = function fetchUserMe() {
	    return fetch(_cfg2.default.dash.api.host + '/api/v2/me?&access_token=' + _auth2.default.getAccessToken()).then(checkResponse);
	};
	
	var fetchAllWidgetsSpecs = exports.fetchAllWidgetsSpecs = function fetchAllWidgetsSpecs() {
	    var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'spdk-rlz-superliga-main-test';
	    return fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?social=true&template=' + template + '&access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref) {
	        var _ref$widgets = _ref.widgets,
	            widgets = _ref$widgets === undefined ? [] : _ref$widgets;
	        return widgets;
	    });
	};
	
	var fetchAllTemplatesSpecs = exports.fetchAllTemplatesSpecs = function fetchAllTemplatesSpecs() {
	    return fetch(_cfg2.default.dash.api.host + '/api/templates/list?access_token=' + _auth2.default.getAccessToken()).then(function (res) {
	        return checkResponse(res, function (res) {
	            return res.clone().json();
	        });
	    });
	};
	
	var fetchUserCampaigns = exports.fetchUserCampaigns = function fetchUserCampaigns() {
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns?access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref2) {
	        var _ref2$campaigns = _ref2.campaigns,
	            campaigns = _ref2$campaigns === undefined ? [] : _ref2$campaigns;
	        return campaigns;
	    });
	};
	
	var putUserCampaignInterests = exports.putUserCampaignInterests = function putUserCampaignInterests() {
	    var campaignId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var interests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'PUT',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({ interests: interests })
	    }).then(checkResponse).then(function (_ref3) {
	        var _ref3$campaign = _ref3.campaign,
	            campaign = _ref3$campaign === undefined ? {} : _ref3$campaign;
	        return campaign;
	    });
	};
	
	var fetchTeamMembers = exports.fetchTeamMembers = function fetchTeamMembers() {
	    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return fetch(_cfg2.default.apis.ss2 + '/teams/' + teamId + '/members').then(checkResponse).then(function (team) {
	        return { id: teamId, members: team };
	    });
	};
	
	var fetchTeamEvents = exports.fetchTeamEvents = function fetchTeamEvents() {
	    var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    return fetch(_cfg2.default.apis.ss2 + '/events-v2?teamId=' + teamId + '&' + query + '&access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref4) {
	        var _ref4$events = _ref4.events,
	            events = _ref4$events === undefined ? [] : _ref4$events;
	        return events;
	    });
	};
	
	var fetchTournamentsEvents = exports.fetchTournamentsEvents = function fetchTournamentsEvents() {
	    var ttIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    return fetch(_cfg2.default.apis.ss2 + '/events-v2?' + ttIds.map(function (id) {
	        return 'ttId[]=' + id;
	    }).join('&') + '&' + query + '&access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref5) {
	        var _ref5$events = _ref5.events,
	            events = _ref5$events === undefined ? [] : _ref5$events;
	        return events;
	    });
	};
	
	var fetchCampaignRules = exports.fetchCampaignRules = function fetchCampaignRules() {
	    var campaignId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/rules?access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref6) {
	        var _ref6$rules = _ref6.rules,
	            rules = _ref6$rules === undefined ? [] : _ref6$rules;
	        return rules;
	    });
	};
	
	var postCampaignRule = exports.postCampaignRule = function postCampaignRule() {
	    var campaignId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var rule = arguments[1];
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/rules?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(rule)
	    }).then(checkResponse).then(function (_ref7) {
	        var _ref7$rule = _ref7.rule,
	            rule = _ref7$rule === undefined ? {} : _ref7$rule;
	        return rule;
	    });
	};
	
	var putCampaignRule = exports.putCampaignRule = function putCampaignRule() {
	    var campaignId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var ruleId = arguments[1];
	    var rule = arguments[2];
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/rules/' + (ruleId || rule._id) + '?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'PUT',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(rule)
	    }).then(checkResponse).then(function (_ref8) {
	        var _ref8$rule = _ref8.rule,
	            rule = _ref8$rule === undefined ? {} : _ref8$rule;
	        return rule;
	    });
	};
	
	var deleteCampaignRule = exports.deleteCampaignRule = function deleteCampaignRule() {
	    var campaignId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var ruleId = arguments[1];
	    return fetch(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/rules/' + ruleId + '?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'DELETE'
	    });
	};
	
	// Posts
	var fetchPosts = exports.fetchPosts = function fetchPosts() {
	    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts?' + query + '&access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref9) {
	        var _ref9$posts = _ref9.posts,
	            posts = _ref9$posts === undefined ? [] : _ref9$posts;
	        return posts;
	    });
	};
	
	// export const fetchModerationPosts = (campaignId = '', limit = 100) =>
	//     fetch(
	//         `${
	//             cfg.campaign_manager.host
	//         }/api/posts?campaignIds=["${campaignId}"]&limit=${limit}&status=awaiting_for_moderation&access_token=${
	//             auth.getAccessToken()
	//         }`,
	//     )
	//         .then(checkResponse)
	//         .then(({ posts = [] }) => posts);
	
	var fetchPost = exports.fetchPost = function fetchPost() {
	    var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '?access_token=' + _auth2.default.getAccessToken()).then(checkResponse).then(function (_ref10) {
	        var _ref10$post = _ref10.post,
	            post = _ref10$post === undefined ? {} : _ref10$post;
	        return post;
	    });
	};
	
	var postNowRule = exports.postNowRule = function postNowRule(campaignId, rule) {
	    var moderate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/post-to-campaign/' + campaignId + '?moderate=' + moderate + '&access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(rule)
	    }).then(checkResponse).then(function (_ref11) {
	        var _ref11$post = _ref11.post,
	            post = _ref11$post === undefined ? {} : _ref11$post;
	        return post;
	    });
	};
	
	var postUpdatePresentation = exports.postUpdatePresentation = function postUpdatePresentation() {
	    var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var widgetName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var widgetParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'PUT',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({ name: widgetName, params: widgetParams })
	    }).then(checkResponse).then(function (_ref12) {
	        var _ref12$post = _ref12.post,
	            post = _ref12$post === undefined ? {} : _ref12$post;
	        return post;
	    });
	};
	
	var postUpdateMessage = exports.postUpdateMessage = function postUpdateMessage() {
	    var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({ message: message })
	    }).then(checkResponse).then(function (_ref13) {
	        var _ref13$post = _ref13.post,
	            post = _ref13$post === undefined ? {} : _ref13$post;
	        return post;
	    });
	};
	
	var approvePost = exports.approvePost = function approvePost(postId) {
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/approve?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST'
	    }).then(checkResponse).then(function (_ref14) {
	        var _ref14$post = _ref14.post,
	            post = _ref14$post === undefined ? {} : _ref14$post;
	        return post;
	    });
	};
	
	var retrySendPost = exports.retrySendPost = function retrySendPost(postId) {
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/reset-attempts?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST'
	    }).then(checkResponse).then(function (_ref15) {
	        var _ref15$post = _ref15.post,
	            post = _ref15$post === undefined ? {} : _ref15$post;
	        return post;
	    });
	};
	
	var rejectPost = exports.rejectPost = function rejectPost(postId) {
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/reject?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST'
	    }).then(checkResponse).then(function (_ref16) {
	        var _ref16$post = _ref16.post,
	            post = _ref16$post === undefined ? {} : _ref16$post;
	        return post;
	    });
	};
	
	var deletePost = exports.deletePost = function deletePost(postId) {
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/delete?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'POST'
	    }).then(checkResponse).then(function (_ref17) {
	        var _ref17$post = _ref17.post,
	            post = _ref17$post === undefined ? {} : _ref17$post;
	        return post;
	    });
	};
	
	var putChangeTargetsPost = exports.putChangeTargetsPost = function putChangeTargetsPost() {
	    var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var targets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    return fetch(_cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/change-targets?access_token=' + _auth2.default.getAccessToken(), {
	        method: 'PUT',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(targets)
	    }).then(checkResponse).then(function (_ref18) {
	        var _ref18$post = _ref18.post,
	            post = _ref18$post === undefined ? {} : _ref18$post;
	        return post;
	    });
	};
	// end Posts
	
	var fetchSmLinks = exports.fetchSmLinks = function fetchSmLinks() {
	    return fetch(_cfg2.default.apis.smpg + '/smlinks?access_token=' + _auth2.default.getAccessToken()).then(checkResponse);
	};
	
	var fetchPostStats = exports.fetchPostStats = function fetchPostStats() {
	    var publicationIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    return fetch(_cfg2.default.apis.smpg + '/stats?resultIds=' + JSON.stringify(publicationIds)).then(checkResponse);
	};
	
	var fetchOddsShortenUrl = exports.fetchOddsShortenUrl = function fetchOddsShortenUrl() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var bitlyAccessToken = arguments[1];
	    return fetch(_cfg2.default.dash.api.host + '/api/media/shorten-url?url=' + url + '&accessToken=' + bitlyAccessToken).then(checkResponse);
	};
	
	var fetchSearchPlayers = exports.fetchSearchPlayers = function fetchSearchPlayers() {
	    var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var signal = arguments[1];
	    return fetch(_cfg2.default.apis.ss2 + '/players?q=' + searchText, signal && { signal: signal }).then(function (res) {
	        return res.json();
	    });
	};
	
	var fetchSearchPlayerCareer = exports.fetchSearchPlayerCareer = function fetchSearchPlayerCareer() {
	    var playerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var signal = arguments[1];
	    return fetch(_cfg2.default.apis.ss2 + '/players/' + playerId + '/career', signal && { signal: signal }).then(function (res) {
	        return res.json();
	    });
	};
	
	var fetchAllTeams = exports.fetchAllTeams = function fetchAllTeams() {
	    return fetch(_cfg2.default.apis.ss2 + '/teams').then(function (res) {
	        return res.json();
	    });
	};

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _auth2.default;
	// temporarty unify AUTH
	//
	//
	// class Auth {
	//     _user = null;
	//     _token = null;
	
	//     get getUser() {
	//         if (this._user) return this._user;
	
	//         const serializedUser = localStorage.getItem('user');
	//         if (!serializedUser) return null;
	//         this._user = JSON.parse(serializedUser);
	
	//         return this._user;
	//     }
	
	//     get getAccessToken() {
	//         return this._token || localStorage.getItem('accessToken');
	//     }
	
	//     get loggedIn() {
	//         return Boolean(this.getAccessToken && this.getUser);
	//     }
	
	//     saveUser(user) {
	//         user.props = (user.defaultProps || []).reduce(
	//             (memo, { key, value }) => {
	//                 try {
	//                     memo[key] = JSON.parse(value);
	//                 } catch (e2) {
	//                     memo[key] = value;
	//                 }
	
	//                 return memo;
	//             },
	//             { lang: 'en' },
	//         );
	
	//         localStorage.setItem('user', JSON.stringify(user));
	
	//         this._user = user;
	//     }
	
	//     saveAccessToken(token) {
	//         localStorage.setItem('accessToken', token);
	//         this._token = token;
	
	//         return this._token;
	//     }
	
	//     logout() {
	//         localStorage.removeItem('user');
	//         localStorage.removeItem('accessToken');
	
	//         this._token = null;
	//         this._user = null;
	//     }
	
	//     hasAdminRights() {
	//         return this.loggedIn && (this.getUser.roles || []).indexOf('admin') >= 0;
	//     }
	// }
	
	// if (process.env.NODE_ENV === 'dev') {
	//     window.auth = new Auth();
	// }
	
	// export default new Auth();

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(1096);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _api = __webpack_require__(1773);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function SelectStats(_ref) {
	    var _ref$selectValue = _ref.selectValue,
	        selectValue = _ref$selectValue === undefined ? 'custom' : _ref$selectValue,
	        _ref$tournamentsList = _ref.tournamentsList,
	        tournamentsList = _ref$tournamentsList === undefined ? [] : _ref$tournamentsList,
	        handleChange = _ref.handleChange;
	
	    return _react2.default.createElement(
	        _SelectField2.default,
	        { floatingLabelText: 'Season select', value: selectValue, onChange: handleChange, fullWidth: true },
	        tournamentsList.map(function (_ref2) {
	            var _ref2$value = _ref2.value,
	                value = _ref2$value === undefined ? '' : _ref2$value,
	                _ref2$text = _ref2.text,
	                text = _ref2$text === undefined ? '' : _ref2$text;
	            return _react2.default.createElement(_MenuItem2.default, { key: value, value: value, primaryText: text });
	        })
	    );
	}
	
	SelectStats.propTypes = {
	    selectValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    tournamentsList: _propTypes2.default.array.isRequired,
	    handleChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
	    id: _propTypes2.default.string.isRequired,
	    valueDefault: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    playerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    propsStatsMap: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	    updateWidgetJSPropField: _propTypes2.default.func.isRequired
	}), (0, _recompose.withStateHandlers)(function (_ref3) {
	    var valueDefault = _ref3.valueDefault;
	    return {
	        loading: false,
	        selectValue: valueDefault,
	        stats: {},
	        tournamentsList: []
	    };
	}, {
	    handleLoading: function handleLoading() {
	        return function () {
	            var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            return { loading: loading };
	        };
	    },
	    handleSelectValue: function handleSelectValue() {
	        return function () {
	            var selectValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'custom';
	            return { selectValue: selectValue };
	        };
	    },
	    handleStats: function handleStats() {
	        return function () {
	            var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            return { stats: stats };
	        };
	    },
	    handleTournamentsList: function handleTournamentsList(_ref4) {
	        var selectValue = _ref4.selectValue;
	        return function () {
	            var tournamentsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return !selectValue && tournamentsList.length > 0 ? { tournamentsList: tournamentsList, selectValue: tournamentsList[0] && tournamentsList[0].value } : { tournamentsList: tournamentsList };
	        };
	    }
	}), (0, _recompose.withHandlers)({
	    loadCareer: function loadCareer(_ref5) {
	        var loading = _ref5.loading,
	            handleTournamentsList = _ref5.handleTournamentsList,
	            handleStats = _ref5.handleStats,
	            handleLoading = _ref5.handleLoading;
	        return function (playerId) {
	            if (playerId == null) {
	                return;
	            }
	
	            var controller = new AbortController();
	            var signal = controller.signal;
	
	            if (loading) {
	                controller.abort();
	            }
	
	            handleLoading(true);
	
	            (0, _api.fetchSearchPlayerCareer)(playerId, signal).then(function (_ref6) {
	                var _ref6$stats = _ref6.stats,
	                    stats = _ref6$stats === undefined ? [] : _ref6$stats;
	
	                stats = stats.filter(function (_ref7) {
	                    var _ref7$season = _ref7.season;
	                    _ref7$season = _ref7$season === undefined ? { year: '' } : _ref7$season;
	                    var _ref7$season$year = _ref7$season.year,
	                        year = _ref7$season$year === undefined ? '' : _ref7$season$year;
	                    return new RegExp('' + new Date().getFullYear()).test('' + year);
	                });
	
	                handleTournamentsList(stats.map(function (_ref8) {
	                    var _ref8$tournament = _ref8.tournament,
	                        tournament = _ref8$tournament === undefined ? {} : _ref8$tournament,
	                        _ref8$season = _ref8.season,
	                        season = _ref8$season === undefined ? {} : _ref8$season;
	                    return {
	                        value: season.id,
	                        text: tournament.name + ' ' + season.year
	                    };
	                }));
	
	                handleStats(stats.reduce(function (acc, _ref9) {
	                    var _ref9$season = _ref9.season,
	                        season = _ref9$season === undefined ? {} : _ref9$season,
	                        _ref9$stats = _ref9.stats,
	                        stats = _ref9$stats === undefined ? {} : _ref9$stats;
	                    return _extends({}, acc, _defineProperty({}, season.id, stats));
	                }, {}));
	                handleLoading(false);
	            }).catch(function () {
	                handleLoading(false);
	            });
	        };
	    },
	    handleChange: function handleChange(_ref10) {
	        var id = _ref10.id,
	            stats = _ref10.stats,
	            propsStatsMap = _ref10.propsStatsMap,
	            updateWidgetJSPropField = _ref10.updateWidgetJSPropField,
	            handleSelectValue = _ref10.handleSelectValue;
	        return function (event, index, selectValue) {
	            handleSelectValue(selectValue);
	            updateWidgetJSPropField(id, { selectValue: selectValue });
	            var statsPlayer = stats[selectValue];
	
	            if (statsPlayer) {
	                updateWidgetJSPropField(id, Object.entries(propsStatsMap).reduce(function (stats, _ref11) {
	                    var _ref12 = _slicedToArray(_ref11, 2),
	                        statName = _ref12[0],
	                        key = _ref12[1];
	
	                    return _extends({}, stats, _defineProperty({}, statName, (0, _get2.default)(statsPlayer, key)));
	                }, {}));
	            }
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        if (this.props.playerId) {
	            this.props.loadCareer(this.props.playerId);
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(_ref13) {
	        var playerId = _ref13.playerId;
	
	        if (playerId && this.props.playerId !== playerId) {
	            this.props.loadCareer(playerId);
	        }
	    }
	}))(SelectStats);

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(1766);
	
	var _AutoCompleteTeam = __webpack_require__(1777);
	
	var _AutoCompleteTeam2 = _interopRequireDefault(_AutoCompleteTeam);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _InputMaterial = __webpack_require__(1769);
	
	var _InputMaterial2 = _interopRequireDefault(_InputMaterial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TeamPicker = function TeamPicker(_ref) {
	    var id = _ref.id,
	        _ref$params = _ref.params;
	    _ref$params = _ref$params === undefined ? {} : _ref$params;
	    var _ref$params$defaultNa = _ref$params.defaultName,
	        defaultName = _ref$params$defaultNa === undefined ? '' : _ref$params$defaultNa,
	        type = _ref$params.type,
	        _ref$params$propsMap = _ref$params.propsMap;
	    _ref$params$propsMap = _ref$params$propsMap === undefined ? {} : _ref$params$propsMap;
	
	    var statsMap = _ref$params$propsMap.stats,
	        propsMap = _objectWithoutProperties(_ref$params$propsMap, ['stats']),
	        params = _objectWithoutProperties(_ref$params, ['defaultName', 'type', 'propsMap']),
	        _ref$fullWidth = _ref.fullWidth,
	        fullWidth = _ref$fullWidth === undefined ? true : _ref$fullWidth,
	        updateWidgetJSPropField = _ref.updateWidgetJSPropField,
	        _ref$isCustomInput = _ref.isCustomInput,
	        isCustomInput = _ref$isCustomInput === undefined ? true : _ref$isCustomInput;
	
	    if (id == null || type !== 'team') {
	        return null;
	    }
	
	    var InputComponent = isCustomInput ? _InputMaterial2.default : _TextField2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AutoCompleteTeam2.default, {
	            id: id,
	            defaultName: defaultName,
	            propsMap: propsMap,
	            updateWidgetJSPropField: updateWidgetJSPropField
	        }),
	        Object.entries(_extends({}, propsMap, statsMap || {})).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                _ref3$ = _ref3[0],
	                key = _ref3$ === undefined ? '' : _ref3$;
	
	            return _react2.default.createElement(InputComponent, {
	                key: key,
	                floatingLabelText: (0, _helpers.labelTextReplace)(key),
	                value: params[key] == null ? '' : params[key],
	                fullWidth: fullWidth,
	                onChange: function onChange(event, value) {
	                    updateWidgetJSPropField(id, _defineProperty({}, key, value));
	                }
	            });
	        })
	    );
	};
	
	TeamPicker.propTypes = {
	    id: _propTypes2.default.string,
	    params: _propTypes2.default.shape({
	        name: _propTypes2.default.string,
	        score: _propTypes2.default.string,
	        placeholder: _propTypes2.default.string
	    }),
	    propsMap: _propTypes2.default.objectOf(_propTypes2.default.string),
	    fullWidth: _propTypes2.default.bool,
	    isCustomInput: _propTypes2.default.bool,
	    updateWidgetJSPropField: _propTypes2.default.func.isRequired
	};
	
	exports.default = TeamPicker;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoCompleteTeamHOC = __webpack_require__(1778);
	
	var _autoCompleteTeamHOC2 = _interopRequireDefault(_autoCompleteTeamHOC);
	
	var _AutoComplete = __webpack_require__(789);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoCompleteTeam = function AutoCompleteTeam(_ref) {
	    var searchText = _ref.searchText,
	        teams = _ref.data,
	        handleOnClose = _ref.handleOnClose,
	        handleUpdateInput = _ref.handleUpdateInput,
	        onNewRequest = _ref.onNewRequest;
	    return _react2.default.createElement(_AutoComplete2.default, {
	        floatingLabelText: 'Team name',
	        fullWidth: true,
	        openOnFocus: true,
	        searchText: searchText,
	        filter: _AutoComplete2.default.fuzzyFilter,
	        dataSource: teams,
	        dataSourceConfig: { text: 'name', value: 'id' },
	        onClose: handleOnClose,
	        onUpdateInput: handleUpdateInput,
	        onNewRequest: onNewRequest,
	        maxSearchResults: 5
	    });
	};
	
	AutoCompleteTeam.propTypes = {
	    searchText: _propTypes2.default.string,
	    data: _propTypes2.default.array.isRequired,
	    onNewRequest: _propTypes2.default.func.isRequired,
	    handleOnClose: _propTypes2.default.func.isRequired,
	    handleUpdateInput: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _autoCompleteTeamHOC2.default)(AutoCompleteTeam);

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(1096);
	
	var _autoComplete = __webpack_require__(1767);
	
	var _api = __webpack_require__(1773);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoCompleteTeamHOC = function autoCompleteTeamHOC(AutoComplete) {
	    return (0, _recompose.compose)((0, _autoComplete.autoCompletePickerPropTypes)(), (0, _autoComplete.autoCompleteWithStateHandlers)(), (0, _autoComplete.autoCompleteWithHandlerLoadData)(_api.fetchAllTeams, 300), (0, _autoComplete.autoCompleteWithHandlers)({}, false), (0, _autoComplete.autoCompleteDefaultLifeCycle)(true))(function (props) {
	        return _react2.default.createElement(AutoComplete, props);
	    });
	};
	
	exports.default = autoCompleteTeamHOC;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: fixed;\n    width: 300px;\n    z-index: 10;\n    transform: translateX(-50%);\n\n    padding: 4px 14px 15px;\n\n    color: rgb(255, 255, 255);\n    background-color: rgb(48, 48, 48);\n    opacity: ', ';\n    box-shadow: rgba(0, 0, 0, 0.16) 0 3px 10px, rgba(0, 0, 0, 0.23) 0 3px 10px;\n    border-radius: 2px;\n\n    transition: ', ';\n'], ['\n    position: fixed;\n    width: 300px;\n    z-index: 10;\n    transform: translateX(-50%);\n\n    padding: 4px 14px 15px;\n\n    color: rgb(255, 255, 255);\n    background-color: rgb(48, 48, 48);\n    opacity: ', ';\n    box-shadow: rgba(0, 0, 0, 0.16) 0 3px 10px, rgba(0, 0, 0, 0.23) 0 3px 10px;\n    border-radius: 2px;\n\n    transition: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin: -4px 0 16px 8px;\n'], ['\n    margin: -4px 0 16px 8px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    > *:not(:last-child) {\n        margin-bottom: 23px;\n    }\n'], ['\n    > *:not(:last-child) {\n        margin-bottom: 23px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _throttle = __webpack_require__(1239);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _helpers = __webpack_require__(1766);
	
	var _TextPicker = __webpack_require__(1768);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _PlayerPicker = __webpack_require__(1770);
	
	var _PlayerPicker2 = _interopRequireDefault(_PlayerPicker);
	
	var _TeamPicker = __webpack_require__(1776);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Dialog = _styledComponents2.default.div(_templateObject, function (_ref) {
	    var _ref$open = _ref.open,
	        open = _ref$open === undefined ? false : _ref$open;
	    return String(open & 1);
	}, function (_ref2) {
	    var _ref2$open = _ref2.open,
	        open = _ref2$open === undefined ? false : _ref2$open;
	    return open ? 'opacity 0.1s 0.2s, top 0.35s cubic-bezier(0.23, 1, 0.32, 1) 0s, left 0.35s cubic-bezier(0.23, 1, 0.32, 1) 0s' : 'opacity 0.1s, top 0.35s 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.35s 0.2s cubic-bezier(0.23, 1, 0.32, 1)';
	});
	
	var Title = _styledComponents2.default.h5(_templateObject2);
	
	var Content = _styledComponents2.default.div(_templateObject3);
	
	var getCoordinatesWithZoom = function getCoordinatesWithZoom() {
	    var coordinates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    return coordinates - coordinates * (1 - zoom);
	};
	
	var getPositionEditAria = function getPositionEditAria() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    var element = document.querySelector('[data-edit-aria-id=' + id + ']');
	    var coordinates = element != null ? element.getBoundingClientRect() : { top: 0, left: 0, height: 0, width: 0 };
	
	    return {
	        top: getCoordinatesWithZoom(coordinates.top, zoom),
	        left: getCoordinatesWithZoom(coordinates.left, zoom),
	        width: getCoordinatesWithZoom(coordinates.width, zoom),
	        height: getCoordinatesWithZoom(coordinates.height, zoom)
	    };
	};
	
	var handlePositionUpdate = function handlePositionUpdate(element) {
	    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	    var positionEditAria = getPositionEditAria(id, zoom);
	    var windowHeight = document.documentElement.clientHeight;
	    var elementPosition = element != null ? element.getBoundingClientRect() : { height: 0 };
	
	    if (element == null) {
	        return;
	    }
	
	    if (windowHeight < positionEditAria.top + elementPosition.height + 10) {
	        element.style.top = positionEditAria.top - elementPosition.height;
	    } else {
	        element.style.top = positionEditAria.top + positionEditAria.height;
	    }
	
	    element.style.left = positionEditAria.left + positionEditAria.width / 2;
	};
	
	var iconButtonStyle = {
	    position: 'absolute',
	    top: 0,
	    right: 0,
	    width: 30,
	    height: 30,
	    padding: 0
	};
	
	var PickersControlsDialog = function PickersControlsDialog(_ref3) {
	    var _ref3$dialogName = _ref3.dialogName,
	        dialogName = _ref3$dialogName === undefined ? '' : _ref3$dialogName,
	        _ref3$isOpenDialog = _ref3.isOpenDialog,
	        isOpenDialog = _ref3$isOpenDialog === undefined ? false : _ref3$isOpenDialog,
	        handleClose = _ref3.handleClose,
	        setRef = _ref3.setRef,
	        props = _objectWithoutProperties(_ref3, ['dialogName', 'isOpenDialog', 'handleClose', 'setRef']);
	
	    return _react2.default.createElement(
	        Dialog,
	        { innerRef: setRef, open: isOpenDialog },
	        dialogName && _react2.default.createElement(
	            Title,
	            null,
	            dialogName
	        ),
	        _react2.default.createElement(
	            _IconButton2.default,
	            { onClick: handleClose, style: iconButtonStyle },
	            _react2.default.createElement(_close2.default, null)
	        ),
	        _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(_TextPicker2.default, props),
	            _react2.default.createElement(_PlayerPicker2.default, props),
	            _react2.default.createElement(_TeamPicker2.default, props)
	        )
	    );
	};
	
	PickersControlsDialog.propTypes = {
	    id: _propTypes2.default.string,
	    dialogName: _propTypes2.default.string,
	    isOpenDialog: _propTypes2.default.bool.isRequired,
	    handleClose: _propTypes2.default.func.isRequired,
	    setRef: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _helpers.addRefComponent)(), (0, _helpers.withSubscribeEvent)('WDP_TEXTM'), (0, _reactRedux.connect)(function (_ref4) {
	    var _ref4$editor = _ref4.editor,
	        editor = _ref4$editor === undefined ? {} : _ref4$editor;
	    return {
	        zoom: editor.zoom
	    };
	}), (0, _recompose.withStateHandlers)(function (_ref5) {
	    var id = _ref5.id;
	    return {
	        isOpenDialog: Boolean(id)
	    };
	}, {
	    handleOpen: function handleOpen() {
	        return function () {
	            return { isOpenDialog: true };
	        };
	    },
	    handleClose: function handleClose(state, _ref6) {
	        var id = _ref6.id,
	            _ref6$updateWidgetJSP = _ref6.updateWidgetJSPropField,
	            updateWidgetJSPropField = _ref6$updateWidgetJSP === undefined ? function () {} : _ref6$updateWidgetJSP,
	            _ref6$enterEditMode = _ref6.enterEditMode,
	            enterEditMode = _ref6$enterEditMode === undefined ? function () {} : _ref6$enterEditMode;
	        return function () {
	            updateWidgetJSPropField(id, { active: false });
	            enterEditMode(null);
	
	            return { isOpenDialog: false };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this._resizeHandlePositionUpdate = (0, _throttle2.default)(function () {
	            return handlePositionUpdate(_this.props.getRef(), _this.props.id, _this.props.zoom);
	        }, 100);
	
	        window.addEventListener('resize', this._resizeHandlePositionUpdate);
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        handlePositionUpdate(this.props.getRef(), this.props.id, this.props.zoom);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(_ref7) {
	        var isOpenDialog = _ref7.isOpenDialog,
	            id = _ref7.id;
	
	        if (!isOpenDialog && !this.props.id && id) {
	            this.props.handleOpen();
	        }
	
	        if (isOpenDialog && id == null) {
	            this.props.handleClose();
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('resize', this._resizeHandlePositionUpdate);
	    }
	}))(PickersControlsDialog);

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _EditorStandartLayout = __webpack_require__(1781);
	
	var _EditorStandartLayout2 = _interopRequireDefault(_EditorStandartLayout);
	
	var _materialUi = __webpack_require__(642);
	
	var _actions = __webpack_require__(1782);
	
	var _List = __webpack_require__(904);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _WidgetPicker = __webpack_require__(1783);
	
	var _WidgetPicker2 = _interopRequireDefault(_WidgetPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetPickerEnhanced = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref, props) {
	    var widgetPicker = _ref.widgetPicker;
	
	    return {
	        template: widgetPicker.template || props.template,
	        tab: 'all'
	    };
	}, function (dispatch, _ref2) {
	    var onWidgetSelected = _ref2.onWidgetSelected,
	        onTemplateSelected = _ref2.onTemplateSelected;
	    return {
	        loadWidgets: _actions.loadWidgets,
	        setTemplate: _actions.setTemplate,
	        onTemplateChanged: function onTemplateChanged(template) {
	            dispatch((0, _actions.setTemplate)(template));
	            if (onTemplateSelected) onTemplateSelected(template);
	        },
	        onWidgetSelected: onWidgetSelected || function (e, widget) {
	            alert('widget selected' + widget.id);
	        }
	    };
	}), (0, _recompose.withStateHandlers)(function () {
	    return {
	        tab: 'all',
	        params: {}
	    };
	}, {
	    onTabOpen: function onTabOpen(state, _ref3) {
	        var _onTabOpen = _ref3.onTabOpen;
	        return _onTabOpen || function (tab, params) {
	            return { tab: tab, params: params };
	        };
	    }
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.template !== nextProps.template) this.props.setTemplate(nextProps.template);
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.template) this.props.setTemplate(this.props.template);
	    }
	}))(_WidgetPicker2.default);
	// import WidgetList from '../components/WidgetList';
	
	exports.default = WidgetPickerEnhanced;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCustomScrollbars = __webpack_require__(1738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DIV = function DIV(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutProperties(_ref, ['children']);
	
	    return _react2.default.createElement(
	        'div',
	        props,
	        children
	    );
	};
	
	exports.default = function (_ref2) {
	    var children = _ref2.children,
	        _ref2$col1Scroll = _ref2.col1Scroll,
	        col1Scroll = _ref2$col1Scroll === undefined ? true : _ref2$col1Scroll,
	        _ref2$col2Scroll = _ref2.col2Scroll,
	        col2Scroll = _ref2$col2Scroll === undefined ? true : _ref2$col2Scroll,
	        _ref2$col1Header = _ref2.col1Header,
	        col1Header = _ref2$col1Header === undefined ? null : _ref2$col1Header;
	
	    var ContCol1 = col1Scroll ? _reactCustomScrollbars.Scrollbars : DIV;
	    var ContCol2 = col2Scroll ? _reactCustomScrollbars.Scrollbars : DIV;
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row', flexGrow: 1 } },
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    maxWidth: 280,
	                    minWidth: 280,
	                    height: '100%',
	                    position: 'relative',
	                    background: 'rgba(0,0,0,0.2)'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                null,
	                col1Header
	            ),
	            _react2.default.createElement(
	                ContCol1,
	                null,
	                children[0],
	                _react2.default.createElement('div', { style: { height: 50 } })
	            ),
	            _react2.default.createElement(
	                'h5',
	                {
	                    style: _defineProperty({
	                        textAlign: 'center',
	                        color: '#00505b',
	                        position: 'absolute',
	                        bottom: 0,
	                        width: '100%',
	                        zIndex: 100,
	                        margin: 0,
	                        lineHeight: '50px',
	                        background: '#000'
	                    }, 'textAlign', 'center')
	                },
	                'SPORTSINNOVATION'
	            )
	        ),
	        _react2.default.createElement(
	            ContCol2,
	            {
	                style: {
	                    minWidth: 260,
	                    position: 'relative',
	                    alignSelf: 'stretch',
	                    flexDirection: 'column',
	                    width: '100%',
	                    height: '100%'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { style: { alignSelf: 'stretch' } },
	                children[1]
	            )
	        )
	    );
	};

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setTemplate = exports.loadWidgets = exports.setInfo = exports.setWidgets = undefined;
	
	var _constants = __webpack_require__(614);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setWidgets = exports.setWidgets = function setWidgets(widgets, set) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.PICKER_WIDGETS_LOAD,
	            payload: {
	                set: set,
	                widgets: widgets
	            }
	        });
	    };
	}; // import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
	var setInfo = exports.setInfo = function setInfo(data, set) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.PICKER_INFO_LOAD,
	            payload: {
	                set: set,
	                data: data
	            }
	        });
	    };
	};
	
	var loadWidgets = exports.loadWidgets = function loadWidgets() {
	    return function (dispatch) {
	        return fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?access_token=' + _auth2.default.getAccessToken() + '&social=true').then(function (response) {
	            return response.json();
	        }).then(function (_ref) {
	            var widgets = _ref.widgets;
	
	            return dispatch({
	                type: _constants.PICKER_WIDGETS_LOAD,
	                payload: {
	                    set: 'all',
	                    widgets: widgets
	                }
	            });
	        });
	    };
	};
	
	var setTemplate = exports.setTemplate = function setTemplate(template) {
	    return function (dispatch) {
	        return dispatch({
	            type: _constants.PICKER_SET_TEMPLATE,
	            payload: template
	        });
	    };
	};

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EditorStandartLayout = __webpack_require__(1781);
	
	var _EditorStandartLayout2 = _interopRequireDefault(_EditorStandartLayout);
	
	var _TemplateChanger = __webpack_require__(1784);
	
	var _PickerMenu = __webpack_require__(1793);
	
	var _PickerMenu2 = _interopRequireDefault(_PickerMenu);
	
	var _WidgetListPanel = __webpack_require__(1796);
	
	var _WidgetListPanel2 = _interopRequireDefault(_WidgetListPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetPicker = function WidgetPicker(_ref) {
	    var _ref$wide = _ref.wide,
	        wide = _ref$wide === undefined ? true : _ref$wide,
	        tab = _ref.tab,
	        _ref$params = _ref.params,
	        params = _ref$params === undefined ? {} : _ref$params,
	        _ref$onWidgetSelected = _ref.onWidgetSelected,
	        onWidgetSelected = _ref$onWidgetSelected === undefined ? function () {} : _ref$onWidgetSelected,
	        template = _ref.template,
	        onTabOpen = _ref.onTabOpen,
	        _ref$onTemplateChange = _ref.onTemplateChanged,
	        onTemplateChanged = _ref$onTemplateChange === undefined ? function () {} : _ref$onTemplateChange;
	
	    return _react2.default.createElement(
	        _EditorStandartLayout2.default,
	        null,
	        _react2.default.createElement(_PickerMenu2.default, {
	            tab: tab,
	            params: params,
	            template: template,
	            onTabOpen: onTabOpen,
	            onTemplateChanged: onTemplateChanged
	        }),
	        template ? _react2.default.createElement(_WidgetListPanel2.default, {
	            wide: wide,
	            tab: tab,
	            params: params,
	            template: template,
	            onTabOpen: onTabOpen,
	            onWidgetSelected: onWidgetSelected
	        }) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_TemplateChanger.TemplateChangerButtons, { template: template, onTemplateChanged: onTemplateChanged })
	        )
	    );
	};
	
	WidgetPicker.propTypes = {
	    onTemplateChanged: _propTypes2.default.func.isRequired,
	    onTabOpen: _propTypes2.default.func.isRequired,
	    onWidgetSelected: _propTypes2.default.func.isRequired,
	    tab: _propTypes2.default.string.isRequired,
	    template: _propTypes2.default.string.isRequired
	};
	
	//
	
	exports.default = WidgetPicker;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.withFetchTemplates = exports.TemplateChangerButtons = exports.TemplatePicker = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _materialUi = __webpack_require__(642);
	
	var _enhancers = __webpack_require__(1785);
	
	var _actions = __webpack_require__(1047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function TemplateChangerButtonsComponent(_ref) {
	    var _ref$templates = _ref.templates,
	        templates = _ref$templates === undefined ? [] : _ref$templates,
	        template = _ref.template,
	        _ref$onTemplateChange = _ref.onTemplateChanged,
	        onTemplateChanged = _ref$onTemplateChange === undefined ? function () {} : _ref$onTemplateChange;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Template ',
	            template
	        ),
	        templates.filter(function (t) {
	            return !t.isHidden;
	        }).map(function (t) {
	            return _react2.default.createElement(_materialUi.FlatButton, {
	                primary: t.id === template,
	                key: t.id,
	                label: t.name,
	                onClick: function onClick() {
	                    return onTemplateChanged(t.id);
	                }
	            });
	        })
	    );
	}
	
	function TemplatePicker(_ref2) {
	    var _ref2$templates = _ref2.templates,
	        templates = _ref2$templates === undefined ? [] : _ref2$templates,
	        template = _ref2.template,
	        _ref2$onTemplateChang = _ref2.onTemplateChanged,
	        onTemplateChanged = _ref2$onTemplateChang === undefined ? function () {} : _ref2$onTemplateChang;
	
	    return _react2.default.createElement(
	        _materialUi.SelectField,
	        {
	            floatingLabelText: 'Template',
	            value: template,
	            onChange: function onChange(event, index, value) {
	                onTemplateChanged(value);
	            }
	        },
	        templates.filter(function (t) {
	            return !t.isHidden;
	        }).map(function (t) {
	            return _react2.default.createElement(_materialUi.MenuItem, { key: t.id, value: t.id, primaryText: t.name });
	        })
	    );
	}
	
	var withFetchTemplates = function withFetchTemplates(CMP) {
	    return (0, _recompose.compose)(_enhancers.withTemplates, (0, _reactRedux.connect)(function () {
	        return {};
	    }, {
	        fetchTemplates: _actions.fetchTemplates
	    }), (0, _recompose.lifecycle)({
	        componentWillReceiveProps: function componentWillReceiveProps() {},
	        componentDidMount: function componentDidMount() {
	            this.props.fetchTemplates();
	        }
	    }))(function (_ref3) {
	        var fetchTemplates = _ref3.fetchTemplates,
	            dispatch = _ref3.dispatch,
	            props = _objectWithoutProperties(_ref3, ['fetchTemplates', 'dispatch']);
	
	        return _react2.default.createElement(CMP, props);
	    });
	};
	
	var TemplateChangerButtons = withFetchTemplates(TemplateChangerButtonsComponent);
	exports.TemplatePicker = TemplatePicker;
	exports.TemplateChangerButtons = TemplateChangerButtons;
	exports.withFetchTemplates = withFetchTemplates;
	exports.default = withFetchTemplates(TemplatePicker);

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withActiveFormProps = __webpack_require__(1786);
	
	Object.defineProperty(exports, 'withActiveFormProps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withActiveFormProps).default;
	  }
	});
	
	var _withTargetsFormProps = __webpack_require__(1787);
	
	Object.defineProperty(exports, 'withTargetsFormProps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withTargetsFormProps).default;
	  }
	});
	
	var _withTriggerType = __webpack_require__(1788);
	
	Object.defineProperty(exports, 'withTriggerType', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withTriggerType).default;
	  }
	});
	
	var _withUserData = __webpack_require__(1789);
	
	Object.defineProperty(exports, 'withUserData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withUserData).default;
	  }
	});
	
	var _withCampaigns = __webpack_require__(1790);
	
	Object.defineProperty(exports, 'withCampaigns', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withCampaigns).default;
	  }
	});
	
	var _withTemplates = __webpack_require__(1792);
	
	Object.defineProperty(exports, 'withTemplates', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withTemplates).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(342);
	
	var _reactRedux = __webpack_require__(250);
	
	var _constants = __webpack_require__(579);
	
	var valueSelector = (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID);
	var mapStateToProps = function mapStateToProps(state) {
	    var activeProps = valueSelector(state, _constants.CAMPAIGN_FORM_KEYS.ACTIVE, _constants.CAMPAIGN_FORM_KEYS.START_DATE, _constants.CAMPAIGN_FORM_KEYS.END_DATE);
	    return {
	        active: activeProps[_constants.CAMPAIGN_FORM_KEYS.ACTIVE],
	        startDate: activeProps[_constants.CAMPAIGN_FORM_KEYS.START_DATE],
	        endDate: activeProps[_constants.CAMPAIGN_FORM_KEYS.END_DATE]
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _selectors = __webpack_require__(618);
	
	var _constants = __webpack_require__(579);
	
	var valueSelector = (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        targets: (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.SMLINKS],
	        selectedTargets: valueSelector(state, _constants.CAMPAIGN_FORM_KEYS.TARGETS.ARRAY)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _constants = __webpack_require__(579);
	
	var mapStateToProps = function mapStateToProps(formName, key) {
	    if (formName === undefined) {
	        throw new Error('formName is undefined in withTriggerType enhancer');
	    }
	    var valueSelector = (0, _reduxForm.formValueSelector)(formName);
	    return function (state) {
	        var triggerType = valueSelector(state, key);
	        return { triggerType: triggerType };
	    };
	};
	
	var withTriggerType = function withTriggerType(formName) {
	    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CAMPAIGN_FORM_KEYS.RULES.KEY;
	    return (0, _reactRedux.connect)(mapStateToProps(formName, key));
	};
	
	exports.default = withTriggerType;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(250);
	
	var withUserData = (0, _reactRedux.connect)(function (state) {
	  return { user: state.user };
	});
	
	exports.default = withUserData;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _selectors = __webpack_require__(618);
	
	var _pagination = __webpack_require__(1791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withCampaigns = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	    return {
	        campaignsById: (0, _selectors.getEntities)(state).campaigns,
	        campaignsPending: _lodash2.default.get((0, _selectors.getQueries)(state), ['GET:campaigns', 'isPending']),
	        campaignsStatus: _lodash2.default.get((0, _selectors.getQueries)(state), ['GET:campaigns', 'status']),
	        campaignIds: (0, _pagination.selectIds)(state.pagination, 'campaigns', (0, _pagination.selectCurrentPage)(state.pagination, 'campaigns'))
	    };
	}), (0, _recompose.withPropsOnChange)(function (cur, next) {
	    return next.campaignsById && Array.isArray(next.campaignIds) && (cur.campaignsById !== next.campaignsById || cur.campaignIds !== next.campaignIds);
	}, function (_ref) {
	    var campaignsById = _ref.campaignsById,
	        campaignIds = _ref.campaignIds;
	    return {
	        campaigns: Array.isArray(campaignIds) && campaignsById ? campaignIds.reduce(function (acc, id) {
	            var cur = campaignsById[id];
	            if (cur) {
	                acc.push(cur);
	            }
	            return acc;
	        }, []) : undefined
	    };
	}));
	
	exports.default = withCampaigns;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectCount = exports.selectPerPage = exports.selectIds = exports.selectCurrentPage = undefined;
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default is 0
	 * @param {Object} pagination
	 * @param {String} key
	 * @returns {Number}
	 */
	var selectCurrentPage = exports.selectCurrentPage = function selectCurrentPage(pagination, key) {
	  return _lodash2.default.get(pagination, key + '.currentPage', 0);
	};
	
	/**
	 * @param {Object} pagination
	 * @param {String} key
	 * @param {Number|String} page | default to current selected or 0
	 * @returns {Array<string>|undefined}
	 */
	var selectIds = exports.selectIds = function selectIds(pagination, key) {
	  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : selectCurrentPage(pagination, key);
	
	  return _lodash2.default.get(pagination, key + '.pages.' + page);
	};
	
	/**
	 * Default is 10
	 * @param {Object} pagination
	 * @param {String} key
	 * @returns {Number}
	 */
	var selectPerPage = exports.selectPerPage = function selectPerPage(pagination, key) {
	  return _lodash2.default.get(pagination, key + '.perPage', 10);
	};
	
	/**
	 * Default is 0
	 * @param {Object} pagination
	 * @param {String} key
	 * @returns {Number}
	 */
	var selectCount = exports.selectCount = function selectCount(pagination, key) {
	  return _lodash2.default.get(pagination, key + '.count', 0);
	};

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(250);
	
	var _selectors = __webpack_require__(618);
	
	var _constants = __webpack_require__(579);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        templates: (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.TEMPLATES]
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _List = __webpack_require__(904);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TemplateChanger = __webpack_require__(1784);
	
	var _archive = __webpack_require__(1794);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _stars = __webpack_require__(1795);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _style = __webpack_require__(1031);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _constants = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var selectedStyle = {
	    backgroundColor: '#1a1a1a',
	    color: '#00505b'
	    // borderLeft: '15px solid #00505b',
	};
	
	var selectedStyleSecondary = {
	    backgroundColor: '#000',
	    color: '#00505b'
	    // borderLeft: '5px solid #00505b',
	};
	
	var WDPMenuItem = function WDPMenuItem(_ref) {
	    var props = _objectWithoutProperties(_ref, []);
	
	    return _react2.default.createElement(_List.ListItem, props);
	};
	var WDPMenuHeader = function WDPMenuHeader(_ref2) {
	    var props = _objectWithoutProperties(_ref2, []);
	
	    return _react2.default.createElement(_List.ListItem, _extends({}, props, {
	        innerDivStyle: { padding: '5px 16px' },
	        style: {
	            fontSize: 12,
	            fontWeight: 'bold',
	            padding: 0,
	            opacity: 0.7
	        }
	    }));
	};
	
	var WDPMenuTemplateChangerItem = (0, _TemplateChanger.withFetchTemplates)(function (_ref3) {
	    var _ref3$templates = _ref3.templates,
	        templates = _ref3$templates === undefined ? [] : _ref3$templates,
	        template = _ref3.template,
	        onTemplateChanged = _ref3.onTemplateChanged,
	        props = _objectWithoutProperties(_ref3, ['templates', 'template', 'onTemplateChanged']);
	
	    return _react2.default.createElement(WDPMenuItem, _extends({}, props, {
	        nestedItems: templates.filter(function (t) {
	            return !t.isHidden;
	        }).map(function (t) {
	            return _react2.default.createElement(WDPMenuItem, {
	                key: t._id,
	                primaryText: t.name,
	                style: template === t.id ? selectedStyleSecondary : {},
	                onClick: function onClick() {
	                    onTemplateChanged(t.id);
	                },
	                secondaryText: t.id
	            });
	        })
	    }));
	});
	
	var WidgetPickerMenu = (0, _reactRedux.connect)(function (_ref4) {
	    var user = _ref4.user,
	        widgetPicker = _ref4.widgetPicker;
	
	    return {
	        interests: user.interests || [],
	        tournament: _lodash2.default.get(widgetPicker, 'info.league.tournament'),
	        team: _lodash2.default.get(widgetPicker, 'info.team.team'),
	        player: _lodash2.default.get(widgetPicker, 'info.player.player')
	    };
	})(function (_ref5) {
	    var interests = _ref5.interests,
	        tab = _ref5.tab,
	        params = _ref5.params,
	        onTabOpen = _ref5.onTabOpen,
	        template = _ref5.template,
	        player = _ref5.player,
	        tournament = _ref5.tournament,
	        team = _ref5.team,
	        onTemplateChanged = _ref5.onTemplateChanged;
	
	    var isInterests = false;
	
	    var selection = {};
	    selection[_constants.TABS.LEAGUE] = tournament && tournament.name;
	    selection[_constants.TABS.TEAM] = team && team.name;
	    selection[_constants.TABS.PLAYER] = '';
	
	    var TABS_INFO = {};
	    TABS_INFO[_constants.TABS.ALL] = {
	        primaryText: 'All widgets',
	        onClick: function onClick() {
	            onTabOpen(_constants.TABS.ALL, {
	                tournamentId: null,
	                teamId: null,
	                eventId: null,
	                playerId: null
	            });
	        }
	    };
	    TABS_INFO[_constants.TABS.LEAGUE] = {
	        primaryText: 'League',
	        secondaryText: tournament && tournament.name,
	        disabled: !tournament,
	        onClick: function onClick() {
	            onTabOpen(_constants.TABS.LEAGUE, {
	                tournamentId: tournament && tournament.id,
	                teamId: null,
	                eventId: null,
	                playerId: null
	            });
	        }
	    };
	    TABS_INFO[_constants.TABS.TEAM] = {
	        primaryText: 'Team',
	        secondaryText: team && team.name,
	        onClick: function onClick() {
	            return onTabOpen(_constants.TABS.TEAM, {
	                tournamentId: tournament && tournament.id,
	                teamId: team && team.id,
	                eventId: null,
	                playerId: null
	            });
	        }
	    };
	    TABS_INFO[_constants.TABS.PLAYER] = {
	        primaryText: 'Player',
	        disabled: !team,
	        secondaryText: player && player.name,
	        onClick: function onClick() {
	            return onTabOpen(_constants.TABS.PLAYER, {
	                tournamentId: tournament && tournament.id,
	                teamId: team && team.id,
	                eventId: null,
	                playerId: null
	            });
	        }
	    };
	    TABS_INFO[_constants.TABS.EVENT] = {
	        primaryText: 'Matches',
	        onClick: function onClick() {
	            return onTabOpen(_constants.TABS.EVENT, {
	                tournamentId: tournament && tournament.id,
	                teamId: team && team.id,
	                eventId: null,
	                playerId: null
	            });
	        }
	    };
	
	    return _react2.default.createElement(
	        _List.List,
	        { style: { margin: 15, paddingTop: 0 } },
	        _react2.default.createElement(WDPMenuHeader, { primaryText: 'Widgets' }),
	        [_constants.TABS.ALL, _constants.TABS.LEAGUE, _constants.TABS.TEAM, _constants.TABS.PLAYER, _constants.TABS.EVENT].map(function (key) {
	            return _react2.default.createElement(WDPMenuItem, _extends({
	                key: key,
	                style: tab === key ? selectedStyle : {},
	                primaryText: key
	            }, TABS_INFO[key] && TABS_INFO[key]));
	        }),
	        _react2.default.createElement(WDPMenuItem, {
	            leftIcon: _react2.default.createElement(_archive2.default, null),
	            primaryText: 'Portfolio',
	            style: tab === _constants.TABS.PORTFOLIO ? selectedStyle : {},
	            onClick: function onClick() {
	                onTabOpen(_constants.TABS.PORTFOLIO, {});
	            }
	        }),
	        _react2.default.createElement(WDPMenuItem, {
	            primaryText: 'Interests',
	            leftIcon: _react2.default.createElement(_stars2.default, null),
	            initiallyOpen: isInterests,
	            style: isInterests ? selectedStyle : {},
	            nestedListStyle: isInterests ? {
	                padding: 0,
	                background: '#1a1a1a'
	            } : {},
	            nestedItems: interests.map(function (interest) {
	                var selected = tab === 'league' && +params.tournamentId == (interest.ttIds.length && interest.ttIds[0]);
	                return _react2.default.createElement(WDPMenuItem, {
	                    key: interest._id,
	                    primaryText: interest.name,
	                    style: selected ? selectedStyleSecondary : {},
	                    onClick: function onClick() {
	                        if (interest.ttIds.length) {
	                            onTabOpen('league', { tournamentId: interest.ttIds[0] });
	                        } else {
	                            alert('not implemented');
	                        }
	                    },
	                    secondaryText: _lodash2.default.compact([interest.ttIds.map(function (id) {
	                        return 'League #' + id;
	                    }).join(', '), interest.teamIds.map(function (id) {
	                        return 'Team #' + id;
	                    }).join(', ')]).join(' | ')
	                });
	            })
	        }),
	        _react2.default.createElement(_materialUi.Divider, null),
	        _react2.default.createElement(WDPMenuHeader, { primaryText: 'Others' }),
	        _react2.default.createElement(WDPMenuTemplateChangerItem, {
	            leftIcon: _react2.default.createElement(_style2.default, null),
	            primaryText: 'Templates',
	            template: template,
	            secondaryText: template,
	            onTemplateChanged: onTemplateChanged
	        })
	    );
	});
	
	exports.default = WidgetPickerMenu;

/***/ },
/* 1794 */,
/* 1795 */,
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _actions = __webpack_require__(1782);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _widgets = __webpack_require__(1798);
	
	var _constants = __webpack_require__(614);
	
	var _LeagueOverview = __webpack_require__(1804);
	
	var _LeagueOverview2 = _interopRequireDefault(_LeagueOverview);
	
	var _TeamOverview = __webpack_require__(1805);
	
	var _TeamOverview2 = _interopRequireDefault(_TeamOverview);
	
	var _EventOverview = __webpack_require__(1806);
	
	var _EventOverview2 = _interopRequireDefault(_EventOverview);
	
	var _PlayerOverview = __webpack_require__(1807);
	
	var _PlayerOverview2 = _interopRequireDefault(_PlayerOverview);
	
	var _AllWidgetsOverview = __webpack_require__(1808);
	
	var _AllWidgetsOverview2 = _interopRequireDefault(_AllWidgetsOverview);
	
	var _Navigator = __webpack_require__(1809);
	
	var _Navigator2 = _interopRequireDefault(_Navigator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioWidgets = (0, _widgets.withPortfolioWidgets)(_WidgetList2.default);
	
	var WidgetListPanel = function WidgetListPanel(_ref) {
	    var wide = _ref.wide,
	        tab = _ref.tab,
	        params = _ref.params,
	        template = _ref.template,
	        onTabOpen = _ref.onTabOpen,
	        onWidgetSelected = _ref.onWidgetSelected;
	
	    params.wide = wide;
	    params.tab = tab;
	
	    return _react2.default.createElement(
	        'div',
	        { style: {} },
	        _react2.default.createElement(_Navigator2.default, _extends({}, params, {
	            onLeagueSelected: function onLeagueSelected(tournamentId) {
	                onTabOpen('league', {
	                    tournamentId: tournamentId,
	                    teamId: null,
	                    playerId: null,
	                    eventId: null
	                });
	            },
	            onEventSelected: function onEventSelected(eventId) {
	                var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                onTabOpen('event', _extends({
	                    tournamentId: params.tournamentId, // ?
	                    teamId: null,
	                    playerId: null,
	                    eventId: eventId
	                }, ctx));
	            },
	            onPlayerSelected: function onPlayerSelected(teamId, playerId) {
	                onTabOpen('player', {
	                    tournamentId: params.tournamentId, // ?
	                    teamId: teamId,
	                    playerId: playerId,
	                    eventId: null
	                });
	            },
	            onTeamSelected: function onTeamSelected(tournamentId, teamId) {
	                onTabOpen('team', {
	                    tournamentId: tournamentId,
	                    teamId: teamId,
	                    playerId: null,
	                    eventId: null
	                });
	            }
	        })),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: 25 } },
	            tab == _constants.TABS.ALL && _react2.default.createElement(_AllWidgetsOverview2.default, { key: template, template: template, onClick: onWidgetSelected }),
	            tab == _constants.TABS.LEAGUE && _react2.default.createElement(_LeagueOverview2.default, _extends({
	                groupBy: 'category',
	                template: template,
	                wdpcache: 'state'
	            }, params, {
	                onLeagueSelected: function onLeagueSelected(tournamentId) {
	                    onTabOpen('league', {
	                        tournamentId: tournamentId
	                    });
	                },
	                onTeamSelected: function onTeamSelected(teamId) {
	                    onTabOpen('team', {
	                        teamId: teamId
	                    });
	                },
	                onClick: onWidgetSelected
	            })),
	            tab == _constants.TABS.PLAYER && _react2.default.createElement(_PlayerOverview2.default, _extends({
	                groupBy: 'category',
	                template: template,
	                wdpcache: 'state'
	            }, params, {
	                onClick: onWidgetSelected
	            })),
	            tab == _constants.TABS.TEAM && _react2.default.createElement(_TeamOverview2.default, _extends({
	                groupBy: 'category',
	                template: template,
	                wdpcache: 'state'
	            }, params, {
	                onClick: onWidgetSelected
	            })),
	            tab == _constants.TABS.EVENT && _react2.default.createElement(_EventOverview2.default, _extends({
	                groupBy: 'category',
	                template: template,
	                wdpcache: 'state'
	            }, params, {
	                onClick: onWidgetSelected
	            })),
	            tab == 'portfolio' && _react2.default.createElement(PortfolioWidgets, _extends({
	                groupBy: 'category',
	                template: template,
	                wdpcache: 'state'
	            }, params, {
	                onClick: onWidgetSelected
	            }))
	        )
	    );
	};
	
	exports.default = WidgetListPanel;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NetflixGallery = __webpack_require__(1729);
	
	var _NetflixGallery2 = _interopRequireDefault(_NetflixGallery);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var WidgetHeader = function WidgetHeader(_ref) {
	    var text = _ref.text;
	    return _react2.default.createElement(
	        'h3',
	        {
	            style: {
	                textAlign: 'left'
	            }
	        },
	        text
	    );
	};
	
	var WidgetList = function WidgetList(_ref2) {
	    var widgets = _ref2.widgets,
	        _ref2$groupBy = _ref2.groupBy,
	        groupBy = _ref2$groupBy === undefined ? 'category' : _ref2$groupBy,
	        _ref2$wide = _ref2.wide,
	        wide = _ref2$wide === undefined ? true : _ref2$wide,
	        _ref2$sortBy = _ref2.sortBy,
	        sortBy = _ref2$sortBy === undefined ? function () {
	        return 0;
	    } : _ref2$sortBy,
	        _ref2$filter = _ref2.filter,
	        filter = _ref2$filter === undefined ? function () {
	        return true;
	    } : _ref2$filter,
	        onClick = _ref2.onClick,
	        _ref2$wdpcache = _ref2.wdpcache,
	        wdpcache = _ref2$wdpcache === undefined ? 'widget' : _ref2$wdpcache,
	        template = _ref2.template,
	        _ref2$propsForWidgets = _ref2.propsForWidgets,
	        propsForWidgets = _ref2$propsForWidgets === undefined ? function () {
	        return {};
	    } : _ref2$propsForWidgets;
	
	    var groups = {};
	
	    widgets = _lodash2.default.chain(widgets).groupBy(function (w) {
	        return _lodash2.default.get(w, 'spec.widgetGroup', w.id);
	    }).toPairs().map(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            groupKey = _ref4[0],
	            widgets = _ref4[1];
	
	        return [groupKey, _lodash2.default.orderBy(widgets, function (w) {
	            return -_lodash2.default.get(w, 'spec.groupWeight', 0);
	        })];
	    }).map(function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 2),
	            groupKey = _ref6[0],
	            _ref6$ = _toArray(_ref6[1]),
	            master = _ref6$[0],
	            rest = _ref6$.slice(1);
	
	        master.layoutsWidgets = [master].concat(_toConsumableArray(rest));
	        master.layouts = master.layoutsWidgets.length;
	        return master;
	    }).value();
	
	    _lodash2.default.each(widgets.filter(function (w) {
	        return w.spec.social;
	    }), function (w) {
	        var groupKey = _lodash2.default.get(w, '' + groupBy);
	
	        if (_lodash2.default.isArray(groupKey)) {
	            // console.log(w.id, groupKey);
	            groupKey.forEach(function (g) {
	                groups[g] = groups[g] || [];
	                groups[g].push(w);
	            });
	        } else if (groupKey) {
	            groups[groupKey] = groups[groupKey] || [];
	            groups[groupKey].push(w);
	        }
	    });
	    var categories = _lodash2.default.chain(groups).toPairs().filter(filter).sortBy(sortBy) // sort categories
	    .map(function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 2),
	            category = _ref8[0],
	            widgets = _ref8[1];
	
	        return [category, _lodash2.default.orderBy(widgets, function (w) {
	            return -_lodash2.default.get(w, 'spec.weight', 0);
	        })];
	    }) // sort widgets in a row
	    .value();
	
	    if (!wide) {
	        return _react2.default.createElement(WidgetColumnList, {
	            categories: categories,
	            wdpcache: wdpcache,
	            template: template,
	            onClick: onClick,
	            propsForWidgets: propsForWidgets
	        });
	    }
	
	    return _react2.default.createElement(WidgetNetflix, {
	        categories: categories,
	        wdpcache: wdpcache,
	        template: template,
	        onClick: onClick,
	        propsForWidgets: propsForWidgets
	    });
	};
	var translations = {
	    TOURNAMENT_FIXTURES: 'Fixtures & Results',
	    TOURNAMENT_TABLES: 'Standings',
	    MATCH_PRE: 'Pre match',
	    MATCH_LIVE: 'Live',
	    PLAYERS_STATS: 'Player stats',
	    PLAYERS_H2H: 'Player compare',
	    TEAMS: 'Team',
	    TOP_LIST: 'Top-lists',
	    TRANSFERS: 'Transfer news',
	    EDITORIAL: 'Editorial pick',
	    ODDS: 'Bookie widgets',
	    BASEBALL: 'Baseball'
	};
	
	var WidgetNetflix = function WidgetNetflix(_ref9) {
	    var categories = _ref9.categories,
	        zoomFactor = _ref9.zoomFactor,
	        _onClick = _ref9.onClick,
	        wdpcache = _ref9.wdpcache,
	        template = _ref9.template,
	        _ref9$propsForWidgets = _ref9.propsForWidgets,
	        propsForWidgets = _ref9$propsForWidgets === undefined ? function () {
	        return {};
	    } : _ref9$propsForWidgets;
	    return _react2.default.createElement(
	        'div',
	        null,
	        categories.map(function (_ref10) {
	            var _ref11 = _slicedToArray(_ref10, 2),
	                category = _ref11[0],
	                widgets = _ref11[1];
	
	            return category !== 'unknown' && _react2.default.createElement(
	                'div',
	                { key: category },
	                _react2.default.createElement(WidgetHeader, { text: translations[category] || category }),
	                _react2.default.createElement(_NetflixGallery2.default, {
	                    key: category + '_',
	                    list: widgets,
	                    zoomFactor: zoomFactor,
	                    renderKey: function renderKey(w) {
	                        return (w.key || w.id) + '_' + template;
	                    },
	                    renderFullView: function renderFullView() {
	                        return _react2.default.createElement('div', null);
	                    },
	                    renderItem: function renderItem(w, props) {
	                        return _react2.default.createElement(_NetflixGallery.WidgetPreview, _extends({
	                            key: w.key || w._id || w.id
	                        }, props, { // props from netflix gallery
	                            widget: w,
	                            widgetId: w.id,
	                            props: _extends({}, w.props || {}, { template: template }),
	                            wdpcache: wdpcache,
	                            template: template,
	                            allowZoom: true
	                        }, propsForWidgets(w), {
	                            onClick: function onClick(e) {
	                                if (_onClick) _onClick(e, w, template);
	                            }
	                        }));
	                    }
	                })
	            );
	        })
	    );
	};
	
	var WidgetColumnList = function WidgetColumnList(_ref12) {
	    var categories = _ref12.categories,
	        _onClick2 = _ref12.onClick,
	        wdpcache = _ref12.wdpcache,
	        template = _ref12.template,
	        propsForWidgets = _ref12.propsForWidgets;
	    return _react2.default.createElement(
	        'div',
	        null,
	        categories.map(function (_ref13) {
	            var _ref14 = _slicedToArray(_ref13, 2),
	                category = _ref14[0],
	                widgets = _ref14[1];
	
	            return category !== 'unknown' && _react2.default.createElement(
	                'div',
	                { key: category },
	                _react2.default.createElement(WidgetHeader, { text: translations[category] || category }),
	                widgets.map(function (w) {
	                    return _react2.default.createElement(_NetflixGallery.WidgetPreviewStatic, _extends({
	                        key: w.key || w._id || w.id,
	                        widget: w,
	                        widgetId: w.id,
	                        props: _extends({}, w.props || {}, { template: template }),
	                        wdpcache: wdpcache,
	                        template: template
	                    }, propsForWidgets(w), {
	                        onClick: function onClick(e) {
	                            if (_onClick2) _onClick2(e, w, template);
	                        }
	                    }));
	                })
	            );
	        })
	    );
	};
	
	exports.default = WidgetList;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.announments = exports.loadAllWidgets = exports.withPortfolioWidgets = exports.withAllWidgets = exports.withPlayerWidgets = exports.withEventWidgets = exports.withTeamWidgets = exports.withLeagueWidgets = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRedux = __webpack_require__(250);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _loaders = __webpack_require__(1799);
	
	var _actions = __webpack_require__(1782);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions2 = __webpack_require__(1716);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hocLoadGenerator = function hocLoadGenerator(loader, key, propName) {
	    return (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref) {
	        var widgetPicker = _ref.widgetPicker;
	        return {
	            widgets: widgetPicker.widgets[key] || []
	        };
	    }, { setWidgets: _actions.setWidgets, setInfo: _actions.setInfo }), (0, _recompose.lifecycle)({
	        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                setWidgets = _props.setWidgets,
	                setInfo = _props.setInfo;
	
	            var templateWasChanged = nextProps.template && nextProps.template !== this.props.template;
	            if (nextProps[propName] && this.props[propName] !== nextProps[propName] || templateWasChanged) {
	                loader(nextProps).then(function (_ref2) {
	                    var widgets = _ref2.widgets,
	                        data = _ref2.data;
	
	                    setWidgets(widgets, key);
	                    setInfo(data, key);
	                });
	            }
	            if (this.props[propName] && !nextProps[propName]) {
	                setInfo(null, key);
	            }
	        },
	        componentDidMount: function componentDidMount() {
	            var _props2 = this.props,
	                setWidgets = _props2.setWidgets,
	                setInfo = _props2.setInfo;
	
	
	            if (this.props[propName]) {
	                loader(this.props).then(function (_ref3) {
	                    var widgets = _ref3.widgets,
	                        data = _ref3.data;
	
	                    setWidgets(widgets, key);
	                    setInfo(data, key);
	                }).catch(function (e) {
	                    setWidgets([], key);
	                    // handel load error
	
	                    setInfo(null, key);
	                });
	            }
	        },
	        componentWillUnmount: function componentWillUnmount() {
	            // const { setInfo } = this.props;
	            // setInfo(null, key);
	        }
	    }));
	};
	
	var withLeagueWidgets = exports.withLeagueWidgets = hocLoadGenerator(function (_ref4) {
	    var tournamentId = _ref4.tournamentId;
	    return (0, _loaders.loadLeagueWidgets)(tournamentId);
	}, 'league', 'tournamentId');
	
	var withTeamWidgets = exports.withTeamWidgets = hocLoadGenerator(function (_ref5) {
	    var teamId = _ref5.teamId;
	    return (0, _loaders.loadTeamWidgets)(teamId);
	}, 'team', 'teamId');
	var withEventWidgets = exports.withEventWidgets = hocLoadGenerator(function (_ref6) {
	    var eventId = _ref6.eventId;
	    return (0, _loaders.loadEventWidgets)(eventId);
	}, 'event', 'eventId');
	var withPlayerWidgets = exports.withPlayerWidgets = hocLoadGenerator(function (_ref7) {
	    var tournamentId = _ref7.tournamentId,
	        teamId = _ref7.teamId,
	        playerId = _ref7.playerId;
	    return (0, _loaders.loadPlayerWidgets)(tournamentId, teamId, playerId);
	}, 'player', 'playerId');
	
	var withAllWidgets = exports.withAllWidgets = hocLoadGenerator(function (_ref8) {
	    var template = _ref8.template;
	    return loadAllWidgets(template);
	}, 'all', 'allwidgets');
	
	var profileWidgetToPortfolio = function profileWidgetToPortfolio(widget) {
	    return {
	        id: widget.wid,
	        props: widget.props,
	        category: [widget.category],
	        spec: {
	            social: true,
	            widgetGroup: widget._id
	        },
	        key: widget._id
	    };
	};
	
	var withPortfolioWidgets = exports.withPortfolioWidgets = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref9, _ref10) {
	    var portfolio = _ref9.portfolio;
	    var _ref10$type = _ref10.type,
	        type = _ref10$type === undefined ? 'default' : _ref10$type;
	    return {
	        widgets: _lodash2.default.get(portfolio, 'byIds[' + type + '].widgets', []).map(profileWidgetToPortfolio)
	    };
	}, { loadPortfolio: _actions2.loadPortfolio }), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.type !== this.props.type) {
	            this.props.loadPortfolio(nextProps.type);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        var _props$type = this.props.type,
	            type = _props$type === undefined ? 'default' : _props$type;
	
	
	        this.props.loadPortfolio(type);
	    }
	}));
	
	var transformDemoToWidget = function transformDemoToWidget(widget) {
	    return {
	        id: widget.spec.id,
	        props: _lodash2.default.get(widget, 'spec.demo[0].props', {}),
	        spec: _lodash2.default.omit(widget.spec, 'propTypes'),
	        category: widget.spec.v2Categories || [],
	        name: widget.name,
	        key: 'wid-' + widget.spec.id,
	        demoURL: widget.demoURL
	    };
	};
	
	var loadAllWidgets = exports.loadAllWidgets = function loadAllWidgets(template) {
	    return Promise.all([fetch(_cfg2.default.dash.api.host + '/api/widgets/spec?social=true&template=' + template + '&access_token=' + _auth2.default.getAccessToken()).then(function (response) {
	        return response.json();
	    }).then(function (res) {
	        return res.widgets || [];
	    })]).then(function (_ref11) {
	        var _ref12 = _slicedToArray(_ref11, 1),
	            widgets = _ref12[0];
	
	        return {
	            widgets: (widgets || []).map(transformDemoToWidget),
	            data: 'OK'
	        };
	    });
	};
	
	var announments = exports.announments = function announments(matches, category) {
	    return matches.map(function (event) {
	        return {
	            id: 'MatchAnnouncement',
	            props: {
	                eventId: event.eventId
	            },
	            spec: {
	                social: true,
	                widgetGroup: event.eventId
	            },
	            category: [category],
	            key: 'an-' + event.eventId
	        };
	    });
	};

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _league = __webpack_require__(1800);
	
	Object.defineProperty(exports, 'loadLeagueWidgets', {
	  enumerable: true,
	  get: function get() {
	    return _league.loadLeagueWidgets;
	  }
	});
	
	var _team = __webpack_require__(1801);
	
	Object.defineProperty(exports, 'loadTeamWidgets', {
	  enumerable: true,
	  get: function get() {
	    return _team.loadTeamWidgets;
	  }
	});
	
	var _event = __webpack_require__(1802);
	
	Object.defineProperty(exports, 'loadEventWidgets', {
	  enumerable: true,
	  get: function get() {
	    return _event.loadEventWidgets;
	  }
	});
	
	var _player = __webpack_require__(1803);
	
	Object.defineProperty(exports, 'loadPlayerWidgets', {
	  enumerable: true,
	  get: function get() {
	    return _player.loadPlayerWidgets;
	  }
	});

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadLeagueWidgets = exports.prepareLeagueWidgets = exports.prepareCup = exports.prepareCLEL = exports.prepareLeagueOPTAWidgets = exports.preparWidgets = exports.announments = exports.leagueTopLists = exports.leagueTable = exports.leagueMatches = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var leagueMatches = exports.leagueMatches = function leagueMatches(data) {
	    var matchdays = data.matchdays,
	        tournament = data.tournament,
	        season = data.season;
	
	    var stage = season.stages[0];
	
	    return [].concat(_toConsumableArray(matchdays.map(function (date) {
	        return {
	            id: 'TodayMatchesSMWidget',
	
	            props: {
	                tournamentId: tournament.id,
	                date: date
	            },
	            spec: {
	                social: true,
	                widgetGroup: 'TodayMatchesSMWidget'
	            },
	            category: ['Matches'],
	            key: '' + (date + '_' + tournament.id)
	        };
	    })), [{
	        id: 'RoundMatchesSMWidget',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id,
	            full: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'RoundMatchesSMWidget'
	        },
	        category: ['Matches'],
	        key: 'tt-' + season.id + '-' + stage.id
	    }]);
	};
	
	var leagueTable = exports.leagueTable = function leagueTable(data) {
	    var tournament = data.tournament,
	        season = data.season;
	
	    var stage = season.stages[0];
	    return [{
	        id: 'TournamentTableSMWidget',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id,
	            full: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TournamentTableSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt-' + season.id + '-' + stage.id + '-table'
	    }, {
	        id: 'LeagueTrackerSMWidget',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: season.id,
	            stageId: stage.id,
	            full: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'LeagueTrackerSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt-' + season.id + '-' + stage.id
	    }];
	};
	
	var leagueTopLists = exports.leagueTopLists = function leagueTopLists(data) {
	    var tournament = data.tournament,
	        season = data.season;
	
	    var stage = season.stages[0];
	
	    return ['stats.goals', 'stats.assists', 'stats.cleansheets'].map(function (stat) {
	        return {
	            id: 'TopListSMWidget',
	            props: {
	                tournamentId: tournament.id,
	                seasonId: season.id,
	                sortBy: stat
	            },
	            spec: {
	                social: true,
	                widgetGroup: stat
	            },
	            category: ['TopLists'],
	            key: 'tt-' + season.id + '-' + stage.id + '-' + stat
	        };
	    });
	};
	
	var announments = exports.announments = function announments(data) {
	    var nextMatches = data.nextMatches;
	
	
	    return nextMatches.map(function (event) {
	        return {
	            id: 'MatchAnnouncement',
	            props: {
	                eventId: event.eventId
	            },
	            spec: {
	                social: true,
	                widgetGroup: event.eventId
	            },
	            category: ['Upcoming Matches'],
	            key: 'an-' + event.eventId
	        };
	    });
	};
	
	var preparWidgets = exports.preparWidgets = function preparWidgets(data) {
	    var tournament = data.tournament;
	    // const tournament = 46;
	    // if (tournament.id == 46) return prepareLeagueOPTAWidgets(data);
	
	    // // if champions league and europa league
	
	    if (tournament.id == 42) return prepareCLEL(data);
	
	    // // if cup
	    // if (tournament.type == 'cup') return prepareCupWidget(data);
	
	    // if standard league
	    // if (tournament.type == 'league')
	    return prepareLeagueWidgets(data);
	};
	
	var prepareLeagueOPTAWidgets = exports.prepareLeagueOPTAWidgets = function prepareLeagueOPTAWidgets() {
	    return [];
	};
	
	var prepareCLEL = exports.prepareCLEL = function prepareCLEL(data) {
	    var matchdays = data.matchdays,
	        tournament = data.tournament,
	        season = data.season;
	
	
	    return [].concat(_toConsumableArray(_lodash2.default.filter(season.stages, function (s) {
	        return !s.isCup;
	    }).map(function (stage) {
	        return {
	            id: 'TournamentTableSMWidget',
	            props: {
	                tournamentId: tournament.id,
	                seasonId: season.id,
	                stageId: stage.id,
	                full: true
	            },
	            spec: {
	                social: true,
	                widgetGroup: 'TournamentTableSMWidget' + stage.id
	            },
	            category: ['Matches'],
	            key: 'tt-' + season.id + '-' + stage.id
	        };
	    })));
	};
	
	var prepareCup = exports.prepareCup = function prepareCup() {
	    return [];
	};
	
	var prepareLeagueWidgets = exports.prepareLeagueWidgets = function prepareLeagueWidgets(data) {
	    return [].concat(_toConsumableArray(leagueMatches(data)), _toConsumableArray(leagueTable(data)), _toConsumableArray(leagueTopLists(data)), _toConsumableArray(announments(data)));
	};
	
	var loadLeagueWidgets = exports.loadLeagueWidgets = function loadLeagueWidgets(tournamentId, seasonId) {
	    return Promise.all([fetch('https://ss2.si-ab.com/tournaments/' + tournamentId).then(function (response) {
	        return response.json();
	    }), fetch('https://ss2.si-ab.com/tournaments/' + tournamentId + '/teams').then(function (response) {
	        return response.json();
	    }), fetch('https://ss2.si-ab.com/tournaments/' + tournamentId + '/season').then(function (response) {
	        return response.json();
	    }),
	    // next matches
	    fetch('https://ss2.si-ab.com/events-v2?ttId=' + tournamentId + '&status[]=live&status[]=notstarted&limit=10').then(function (response) {
	        return response.json();
	    }), fetch('https://ss2.si-ab.com/events-v2?ttId=' + tournamentId + '&status=finished&limit=10&sortDirection=desc').then(function (response) {
	        return response.json();
	    })]
	    // last matches
	    ).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 5),
	            tournament = _ref2[0],
	            teams = _ref2[1],
	            seasonData = _ref2[2],
	            nextMatches = _ref2[3],
	            lastMatches = _ref2[4];
	
	        var data = {
	            tournament: tournament,
	            teams: teams,
	            season: seasonData.season,
	            nextMatches: nextMatches.events,
	            lastMatches: lastMatches.events,
	            matchdays: _lodash2.default.chain(nextMatches.events).groupBy(function (e) {
	                return (0, _moment2.default)(e.startDate).format('YYYY-MM-DD');
	            }).keys().value()
	        };
	        return { widgets: preparWidgets(data), data: data };
	    });
	};

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.topPlayers = exports.leagueTable = exports.announments = exports.prepareLeagueWidgets = exports.loadTeamWidgets = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var loadTeamWidgets = exports.loadTeamWidgets = function loadTeamWidgets(teamId) {
	    return Promise.all([fetch('https://ss2.si-ab.com/teams/' + teamId).then(function (response) {
	        return response.json();
	    })]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            team = _ref2[0];
	
	        return Promise.all([team, fetch('https://ss2.si-ab.com/tournaments/' + team.mainTournamentId).then(function (response) {
	            return response.json();
	        }), fetch('https://ss2.si-ab.com/teams/' + teamId + '/members').then(function (response) {
	            return response.json();
	        }), fetch('https://ss2.si-ab.com/players/?teamId=' + teamId + '&ttId=' + team.mainTournamentId).then(function (response) {
	            return response.json();
	        }).then(function (players) {
	            return _lodash2.default.chain(players).orderBy(function (p) {
	                return -_lodash2.default.get(p, 'stats.assists', 0) - _lodash2.default.get(p, 'stats.goals', 0);
	            }).take(5).value();
	        }), fetch('https://ss2.si-ab.com/events-v2?ttId=' + team.mainTournamentId + '&teamId=' + teamId + '&status[]=live&status[]=notstarted&limit=3&sortDirection=asc').then(function (response) {
	            return response.json();
	        }), fetch('https://ss2.si-ab.com/events-v2?ttId=' + team.mainTournamentId + '&teamId=' + teamId + '&status=finished&limit=3&sortDirection=desc').then(function (response) {
	            return response.json();
	        })]);
	    }).then(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 6),
	            team = _ref4[0],
	            tournament = _ref4[1],
	            members = _ref4[2],
	            topPlayers = _ref4[3],
	            nextMatches = _ref4[4],
	            lastMatches = _ref4[5];
	
	        var data = {
	            team: team,
	            tournament: tournament,
	            members: members,
	            topPlayers: topPlayers,
	            nextMatches: nextMatches.events,
	            lastMatches: lastMatches.events
	        };
	
	        return {
	            data: data,
	            widgets: prepareLeagueWidgets(data)
	        };
	    });
	};
	
	var prepareLeagueWidgets = exports.prepareLeagueWidgets = function prepareLeagueWidgets(data) {
	    return [].concat(_toConsumableArray(announments(data.nextMatches, 'Next matches')), _toConsumableArray(announments(data.lastMatches, 'Last matches')), _toConsumableArray(leagueTable(data)), _toConsumableArray(topPlayers(data)));
	};
	
	var announments = exports.announments = function announments(matches, category) {
	    return matches.map(function (event) {
	        return {
	            id: 'MatchAnnouncement',
	            props: {
	                eventId: event.eventId
	            },
	            spec: {
	                social: true,
	                widgetGroup: event.eventId
	            },
	            category: [category],
	            key: 'an-' + event.eventId
	        };
	    });
	};
	
	var leagueTable = exports.leagueTable = function leagueTable(data) {
	    var tournament = data.tournament,
	        team = data.team;
	
	
	    return [{
	        id: 'TournamentTableSMWidget',
	        props: {
	            tournamentId: tournament.id,
	
	            seasonId: tournament.currentSeason.id,
	            teamId: team.id,
	            team1Id: team.id,
	            full: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TournamentTableSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt-table'
	    }, {
	        id: 'LeagueTrackerSMWidget',
	        props: {
	            tournamentId: tournament.id,
	            seasonId: tournament.currentSeason.id,
	            teamId: team.id,
	            team1Id: team.id
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'LeagueTrackerSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt'
	    }];
	};
	
	var topPlayers = exports.topPlayers = function topPlayers(data) {
	    var tournament = data.tournament,
	        team = data.team;
	
	
	    return [{
	        id: 'TeamSeasonTopscorersX3V1',
	        props: {
	            tournamentId: tournament.id,
	            teamId: team.id,
	            showTShirt: true,
	            showTitle: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TeamSeasonTopscorersX3V1'
	        },
	        category: ['Top players'],
	        key: 'tt-table'
	    }, {
	        id: 'TeamSeasonTopscorersX3V2',
	        props: {
	            tournamentId: tournament.id,
	            teamId: team.id,
	            showTShirt: true,
	            showTitle: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TeamSeasonTopscorersX3V2'
	        },
	        category: ['Top players'],
	        key: 'tt-table-x2'
	    }];
	};

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.topPlayers = exports.leagueTable = exports.announments = exports.prepareEventWidgets = exports.loadEventWidgets = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var loadEventWidgets = exports.loadEventWidgets = function loadEventWidgets(eventId) {
	    return fetch('https://ss2.si-ab.com/events-v2/?eventId=' + eventId).then(function (response) {
	        return response.json();
	    }).then(function (response) {
	        return _lodash2.default.get(response, 'events[0]', null);
	    }).then(function (event) {
	        return Promise.all([event, fetch('https://ss2.si-ab.com/tournaments/' + event.tournamentTemplateId)]
	        // lieneup
	        // streaks
	        // h2h
	        // last matches
	        ).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                event = _ref2[0],
	                tournament = _ref2[1];
	
	            var data = {
	                event: event,
	                tournament: tournament
	            };
	            return {
	                data: data,
	                widgets: prepareEventWidgets(data)
	            };
	        });
	    });
	};
	
	var prepareEventWidgets = exports.prepareEventWidgets = function prepareEventWidgets(data) {
	    var event = data.event;
	
	    return [].concat(_toConsumableArray(announments(event, 'ANNOUNCMENTS')), _toConsumableArray(leagueTable(event, 'STANDINGS')));
	};
	
	var announments = exports.announments = function announments(event, category) {
	    return ['MatchAnnouncement'].map(function (wid) {
	        return {
	            id: wid,
	            props: {
	                eventId: event.eventId
	            },
	            spec: {
	                social: true,
	                widgetGroup: event.eventId
	            },
	            category: [category],
	            key: wid + '-' + event.eventId
	        };
	    });
	};
	
	var leagueTable = exports.leagueTable = function leagueTable(event) {
	    return [{
	        id: 'TournamentTableSMWidget',
	        props: {
	            tournamentId: event.tournamentTemplateId,
	            seasonId: event.tournamentId,
	            teamId: event.homeId,
	            team1Id: event.homeId,
	            team2Id: event.awayId,
	            full: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TournamentTableSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt-table'
	    }, {
	        id: 'LeagueTrackerSMWidget',
	        props: {
	            tournamentId: event.tournamentTemplateId,
	            seasonId: event.tournamentId,
	            teamId: event.homeId,
	            team1Id: event.homeId,
	            team2Id: event.awayId
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'LeagueTrackerSMWidget'
	        },
	        category: ['Table'],
	        key: 'tt'
	    }];
	};
	
	var topPlayers = exports.topPlayers = function topPlayers(data) {
	    var tournament = data.tournament,
	        team = data.team;
	
	
	    return [{
	        id: 'TeamSeasonTopscorersX3V1',
	        props: {
	            tournamentId: tournament.id,
	            teamId: team.id,
	            showTShirt: true,
	            showTitle: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TeamSeasonTopscorersX3V1'
	        },
	        category: ['Top players'],
	        key: 'tt-table'
	    }, {
	        id: 'TeamSeasonTopscorersX3V2',
	        props: {
	            tournamentId: tournament.id,
	            teamId: team.id,
	            showTShirt: true,
	            showTitle: true
	        },
	        spec: {
	            social: true,
	            widgetGroup: 'TeamSeasonTopscorersX3V2'
	        },
	        category: ['Top players'],
	        key: 'tt-table-x2'
	    }];
	};

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.profiles = exports.info = exports.preparePlayerWidgets = exports.loadPlayerWidgets = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var loadPlayerWidgets = exports.loadPlayerWidgets = function loadPlayerWidgets(tournamentId, teamId, playerId) {
	    return fetch('https://ss2.si-ab.com/players/' + playerId + '/profile').then(function (response) {
	        return response.json();
	    }).then(function (player) {
	        return Promise.all([player, player.team && fetch('https://ss2.si-ab.com/teams/' + player.team.id).then(function (response) {
	            return response.json();
	        }), player.nationalTeam && fetch('https://ss2.si-ab.com/teams/' + player.nationalTeam.id).then(function (response) {
	            return response.json();
	        })]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 3),
	                player = _ref2[0],
	                team = _ref2[1],
	                nationalTeam = _ref2[2];
	
	            return Promise.all([player, team, nationalTeam, team && team.id && fetch('https://ss2.si-ab.com/tournaments/' + team.mainTournamentId).then(function (response) {
	                return response.json();
	            })]);
	        }).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 4),
	                player = _ref4[0],
	                team = _ref4[1],
	                nationalTeam = _ref4[2],
	                tournament = _ref4[3];
	
	            var data = {
	                player: player,
	                team: team,
	                nationalTeam: nationalTeam,
	                tournament: tournament
	            };
	            return {
	                data: data,
	                widgets: preparePlayerWidgets(data)
	            };
	        });
	    });
	};
	
	var preparePlayerWidgets = exports.preparePlayerWidgets = function preparePlayerWidgets(data) {
	    var player = data.player,
	        tournament = data.tournament,
	        team = data.team;
	
	    return [].concat(_toConsumableArray(info(player, tournament, team, 'BIO')), _toConsumableArray(profiles(player, tournament, 'STATS')));
	};
	
	var info = exports.info = function info(player, tournament, team, category) {
	    return ['PlayerProfileOpta', 'PlayerProfileAdvSMWidget'].map(function (wid) {
	        return {
	            id: wid,
	            props: {
	                playerId: player.id,
	                tournamentId: tournament.id,
	                teamId: team.id
	            },
	            spec: {
	                social: true,
	                widgetGroup: wid
	            },
	            category: [category],
	            key: 'bio-' + wid + '-' + player.id
	        };
	    });
	};
	
	var profiles = exports.profiles = function profiles(player, tournament, category) {
	    return ['PlayerSeasonProfileX3V1', 'PlayerSeasonProfileX3V2', 'PlayerSeasonProfileX3V3', 'PlayerSeasonProfileX3V4', 'PlayerSeasonProfileX5V1', 'PlayerSeasonProfileX5V2', 'PlayerSeasonProfileX5V3', 'PlayerSeasonProfileX5V4'].map(function (wid) {
	        return {
	            id: wid,
	            props: {
	                playerId: player.id,
	                tournamentId: tournament.id
	            },
	            spec: {
	                social: true,
	                widgetGroup: wid
	            },
	            category: [category],
	            key: 'stats-' + wid + '-' + player.id
	        };
	    });
	};

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _widgets = __webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeagueOverview2 = function LeagueOverview2(_ref) {
	    var tournamentId = _ref.tournamentId,
	        template = _ref.template;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(LeagueWidgetsPage, { tournamentId: tournamentId, template: template, groupBy: 'category', wdpcache: 'state' })
	    );
	};
	
	LeagueOverview2.defaultProps = {
	    wdpcache: 'state'
	};
	
	LeagueOverview2.propTypes = {
	    onLeagueSelected: _propTypes2.default.func.isRequired,
	    onTeamSelected: _propTypes2.default.func.isRequired,
	    template: _propTypes2.default.string.isRequired
	};
	
	var NoWidgets = function NoWidgets() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        'Please select league above'
	    );
	};
	
	var LeagueWidgets = (0, _widgets.withLeagueWidgets)(_WidgetList2.default);
	
	var LeagueWidgetsPage = (0, _recompose.compose)((0, _recompose.branch)(function (_ref2) {
	    var tournamentId = _ref2.tournamentId;
	    return !tournamentId;
	}, (0, _recompose.renderComponent)(NoWidgets)))(LeagueWidgets);
	
	exports.default = LeagueOverview2;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _recompose = __webpack_require__(1096);
	
	var _widgets = __webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoWidgets = function NoWidgets() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        'Please select team above'
	    );
	};
	var NoTWidgets = function NoTWidgets() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        'Please select tournamnet above'
	    );
	};
	
	var TeamOverview = (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
	    var tournamentId = _ref.tournamentId;
	    return !tournamentId;
	}, (0, _recompose.renderComponent)(NoTWidgets)), (0, _recompose.branch)(function (_ref2) {
	    var teamId = _ref2.teamId;
	    return !teamId;
	}, (0, _recompose.renderComponent)(NoWidgets)))((0, _widgets.withTeamWidgets)(_WidgetList2.default));
	
	exports.default = TeamOverview;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _recompose = __webpack_require__(1096);
	
	var _widgets = __webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventOverview = (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
	  var eventId = _ref.eventId;
	  return !eventId;
	}, _recompose.renderNothing))((0, _widgets.withEventWidgets)(_WidgetList2.default));
	
	exports.default = EventOverview;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _recompose = __webpack_require__(1096);
	
	var _widgets = __webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoTournamnet = function NoTournamnet() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        'Please select tournamnet above'
	    );
	};
	var NoTeam = function NoTeam() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        'Please select team above'
	    );
	};
	
	var PlayerOverview = (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
	    var tournamentId = _ref.tournamentId;
	    return !tournamentId;
	}, (0, _recompose.renderComponent)(NoTournamnet)), (0, _recompose.branch)(function (_ref2) {
	    var teamId = _ref2.teamId;
	    return !teamId;
	}, (0, _recompose.renderComponent)(NoTeam)), (0, _recompose.branch)(function (_ref3) {
	    var playerId = _ref3.playerId;
	    return !playerId;
	}, _recompose.renderNothing))((0, _widgets.withPlayerWidgets)(_WidgetList2.default));
	
	exports.default = PlayerOverview;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRedux = __webpack_require__(250);
	
	var _widgets = __webpack_require__(1798);
	
	var _constants = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllWidgetsOverview = (0, _recompose.compose)((0, _reactRedux.connect)(function () {
	    return {
	        allwidgets: 'all',
	        groupBy: _constants.GROUP_KEY,
	        filter: function filter(_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                k = _ref2[0];
	
	            return _constants.ALL_WIDGETS.indexOf(k) !== -1;
	        },
	        sortBy: function sortBy(_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 1),
	                k = _ref4[0];
	
	            return _constants.ALL_WIDGETS.indexOf(k);
	        },
	        propsForWidgets: function propsForWidgets(w) {
	            return { demo: true, name: w.name };
	        }
	    };
	}), (0, _recompose.branch)(function (_ref5) {
	    var template = _ref5.template;
	    return !template;
	}, (0, _recompose.renderComponent)(function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        'no template...'
	    );
	})))((0, _widgets.withAllWidgets)(_WidgetList2.default));
	
	exports.default = AllWidgetsOverview;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _WidgetList = __webpack_require__(1797);
	
	var _WidgetList2 = _interopRequireDefault(_WidgetList);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _EventCell = __webpack_require__(1810);
	
	var _EventCell2 = _interopRequireDefault(_EventCell);
	
	var _PlayerCell = __webpack_require__(1811);
	
	var _PlayerCell2 = _interopRequireDefault(_PlayerCell);
	
	var _widgets = __webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var LeagueSelector = function LeagueSelector(_ref) {
	    var onTabOpen = _ref.onTabOpen,
	        tournamentId = _ref.tournamentId,
	        onLeagueSelected = _ref.onLeagueSelected;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_materialUi.FlatButton, {
	            label: 'Superliga',
	            primary: tournamentId == 46,
	            disabled: tournamentId == 46,
	            onClick: function onClick() {
	                onLeagueSelected(46);
	            }
	        }),
	        _react2.default.createElement(_materialUi.FlatButton, {
	            label: 'England',
	            primary: tournamentId == 47,
	            disabled: tournamentId == 47,
	            onClick: function onClick() {
	                onLeagueSelected(47);
	            }
	        })
	    );
	};
	
	var LeagueSelectorEnchanced = (0, _widgets.withLeagueWidgets)(LeagueSelector);
	
	var Navigator = function Navigator(_ref2) {
	    var tab = _ref2.tab,
	        tournamentId = _ref2.tournamentId,
	        teamId = _ref2.teamId,
	        seasonId = _ref2.seasonId,
	        eventId = _ref2.eventId,
	        playerId = _ref2.playerId,
	        onLeagueSelected = _ref2.onLeagueSelected,
	        onTeamSelected = _ref2.onTeamSelected,
	        onPlayerSelected = _ref2.onPlayerSelected,
	        onEventSelected = _ref2.onEventSelected;
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: 15, background: '#222222' } },
	        _react2.default.createElement(LeagueSelectorEnchanced, { tournamentId: tournamentId, onLeagueSelected: onLeagueSelected }),
	        _react2.default.createElement(LeagueInfoEnchanced, {
	            full: tab === 'league' || tab === 'event' && !teamId,
	            eventId: eventId,
	            onTeamSelected: onTeamSelected,
	            onEventSelected: onEventSelected
	        }),
	        _react2.default.createElement(TeamInfoEnchanced, {
	            full: teamId,
	            teamId: teamId,
	            eventId: eventId,
	            playerId: playerId,
	            onEventSelected: onEventSelected,
	            onPlayerSelected: onPlayerSelected
	        }),
	        _react2.default.createElement(EventInfoEnchanced, { eventId: eventId }),
	        _react2.default.createElement(PleayerInfoEnchanced, { playerId: playerId })
	    );
	};
	
	Navigator.defaultProps = {
	    wdpcache: 'state'
	};
	
	Navigator.propTypes = {
	    onLeagueSelected: _propTypes2.default.func.isRequired,
	    onTeamSelected: _propTypes2.default.func.isRequired,
	    onEventSelected: _propTypes2.default.func.isRequired,
	    onPlayerSelected: _propTypes2.default.func.isRequired,
	    template: _propTypes2.default.string.isRequired
	};
	
	var TeamsList = (0, _recompose.compose)((0, _recompose.branch)(function (_ref3) {
	    var _ref3$teams = _ref3.teams,
	        teams = _ref3$teams === undefined ? [] : _ref3$teams;
	    return teams.length === 0;
	}, _recompose.renderNothing))(function (_ref4) {
	    var title = _ref4.title,
	        teams = _ref4.teams,
	        tournamentId = _ref4.tournamentId,
	        teamId = _ref4.teamId,
	        small = _ref4.small,
	        onTeamSelected = _ref4.onTeamSelected;
	    return _react2.default.createElement(
	        'div',
	        null,
	        teams.map(function (t) {
	            return _react2.default.createElement(
	                _materialUi.IconButton,
	                {
	                    key: t.id,
	                    iconStyle: {
	                        width: small ? 24 : 48,
	                        height: small ? 24 : 48,
	                        transition: 'all 0.5s ease'
	                    },
	                    style: {
	                        transition: 'all 0.5s ease',
	                        width: small ? 48 : 72,
	                        height: small ? 48 : 72
	                    }
	                },
	                _react2.default.createElement('img', {
	                    alt: t.name,
	                    style: {
	                        margin: 5,
	                        transition: 'all 0.5s ease',
	                        backgroundColor: +teamId == +t.id ? '#000' : 'transparent'
	                    },
	                    onClick: function onClick() {
	                        return onTeamSelected(tournamentId, t.id);
	                    },
	                    src: 'https://dxugi372p6nmc.cloudfront.net/wdp/current/original/' + t.id + '/teamlogo.png'
	                })
	            )
	            // <FlatButton
	            //     primary={teamId == t.id}
	            //     disabled={teamId == t.id}
	            //     key={t.id}
	            //     label={t.name}
	            //     onClick={() => onTeamSelected(t.id)}
	            // />
	            ;
	        })
	    );
	});
	
	var NoWidgets = function NoWidgets() {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 15 } },
	        ' - No widgets - '
	    );
	};
	
	var getEventInfo = function getEventInfo(e) {
	    if (e.statusType === 'finished') return 'FT ' + e.homeShortName + '-' + e.awayShortName + ' ' + e.score.home + ':' + e.score.away;
	    if (e.statusType === 'inprogress') return 'LIVE ' + e.homeShortName + '-' + e.awayShortName + ' ' + e.score.home + ':' + e.score.away;
	    if (e.statusType === 'notstarted') return (0, _moment2.default)(e.startDate).format('HH:mm') + ' ' + e.homeShortName + '-' + e.awayShortName;
	    return e.homeShortName + '-' + e.awayShortName;
	};
	var MatchesList = (0, _recompose.compose)((0, _recompose.branch)(function (_ref5) {
	    var _ref5$events = _ref5.events,
	        events = _ref5$events === undefined ? [] : _ref5$events;
	    return events.length === 0;
	}, _recompose.renderNothing))(function (_ref6) {
	    var title = _ref6.title,
	        events = _ref6.events,
	        eventId = _ref6.eventId,
	        _ref6$withContextOf = _ref6.withContextOf,
	        withContextOf = _ref6$withContextOf === undefined ? {} : _ref6$withContextOf,
	        onEventSelected = _ref6.onEventSelected;
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' } },
	        events.map(function (e) {
	            return _react2.default.createElement(_EventCell2.default, _extends({
	                key: e.eventId,
	                active: +e.eventId === +eventId
	            }, e, {
	                onClick: function onClick() {
	                    return onEventSelected(e.eventId, withContextOf);
	                }
	            }));
	        })
	    );
	});
	
	var LeagueInfo = function LeagueInfo(_ref7) {
	    var tournament = _ref7.tournament,
	        teamId = _ref7.teamId,
	        eventId = _ref7.eventId,
	        _ref7$lastMatches = _ref7.lastMatches,
	        lastMatches = _ref7$lastMatches === undefined ? [] : _ref7$lastMatches,
	        _ref7$nextMatches = _ref7.nextMatches,
	        nextMatches = _ref7$nextMatches === undefined ? [] : _ref7$nextMatches,
	        _ref7$teams = _ref7.teams,
	        teams = _ref7$teams === undefined ? [] : _ref7$teams,
	        onEventSelected = _ref7.onEventSelected,
	        onTeamSelected = _ref7.onTeamSelected,
	        _ref7$full = _ref7.full,
	        full = _ref7$full === undefined ? true : _ref7$full;
	    return _react2.default.createElement(
	        'div',
	        null,
	        tournament && _react2.default.createElement(TeamsList, { teams: teams, small: !full, tournamentId: tournament.id, onTeamSelected: onTeamSelected }),
	        full && _react2.default.createElement(MatchesList, { eventId: eventId, title: 'Finished', events: lastMatches, onEventSelected: onEventSelected }),
	        full && _react2.default.createElement(MatchesList, { eventId: eventId, title: 'Upcoming', events: nextMatches, onEventSelected: onEventSelected })
	    );
	};
	
	var EventInfo = (0, _recompose.branch)(function (_ref8) {
	    var event = _ref8.event;
	    return !event;
	}, _recompose.renderNothing)(function (_ref9) {
	    var tournament = _ref9.tournament,
	        event = _ref9.event;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h1',
	            null,
	            event.homeName,
	            '-',
	            event.awayName
	        )
	    );
	});
	var EventInfoEnchanced = (0, _reactRedux.connect)(function (_ref10) {
	    var widgetPicker = _ref10.widgetPicker;
	    return _extends({}, _lodash2.default.get(widgetPicker, 'info.event', {}));
	})((0, _widgets.withEventWidgets)(EventInfo));
	
	var TeamInfo = (0, _recompose.branch)(function (_ref11) {
	    var team = _ref11.team;
	    return !team;
	}, _recompose.renderNothing)(function (_ref12) {
	    var team = _ref12.team,
	        _ref12$members = _ref12.members;
	    _ref12$members = _ref12$members === undefined ? {} : _ref12$members;
	    var _ref12$members$player = _ref12$members.players,
	        players = _ref12$members$player === undefined ? [] : _ref12$members$player,
	        _ref12$members$coach = _ref12$members.coach,
	        coach = _ref12$members$coach === undefined ? [] : _ref12$members$coach,
	        _ref12$topPlayers = _ref12.topPlayers,
	        topPlayers = _ref12$topPlayers === undefined ? [] : _ref12$topPlayers,
	        _ref12$lastMatches = _ref12.lastMatches,
	        lastMatches = _ref12$lastMatches === undefined ? [] : _ref12$lastMatches,
	        _ref12$nextMatches = _ref12.nextMatches,
	        nextMatches = _ref12$nextMatches === undefined ? [] : _ref12$nextMatches,
	        _ref12$teams = _ref12.teams,
	        teams = _ref12$teams === undefined ? [] : _ref12$teams,
	        eventId = _ref12.eventId,
	        playerId = _ref12.playerId,
	        onEventSelected = _ref12.onEventSelected,
	        onPlayerSelected = _ref12.onPlayerSelected,
	        _ref12$full = _ref12.full,
	        full = _ref12$full === undefined ? true : _ref12$full;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h1',
	            { style: { display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement('img', {
	                alt: team && team.name,
	                style: {
	                    width: 36,
	                    margin: 5,
	                    marginRight: 15
	                },
	                src: 'https://dxugi372p6nmc.cloudfront.net/wdp/current/original/' + team.id + '/teamlogo.png'
	            }),
	            team && team.name || 'TEAM INFO'
	        ),
	        full && _react2.default.createElement(MatchesList, {
	            title: 'Matches',
	            eventId: eventId,
	            withContextOf: { teamId: team.id },
	            events: [].concat(_toConsumableArray(lastMatches), _toConsumableArray(nextMatches)),
	            onEventSelected: onEventSelected
	        }),
	        _react2.default.createElement(
	            'h5',
	            null,
	            'Top players'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', alignItems: 'center' } },
	            topPlayers.map(function (p) {
	                return _react2.default.createElement(_PlayerCell2.default, _extends({
	                    key: p.id
	                }, p, {
	                    active: p.id === playerId,
	                    onClick: function onClick() {
	                        return onPlayerSelected(team.id, p.id);
	                    }
	                }));
	            }),
	            _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                    floatingLabelText: 'Find player',
	                    style: {
	                        backgound: '#222',
	                        margin: 5
	                    },
	                    floatingLabelFixed: true,
	                    value: playerId,
	                    onChange: function onChange(e, pId) {
	                        onPlayerSelected(team.id, pId);
	                    }
	                },
	                _lodash2.default.orderBy(players, function (p) {
	                    return -_lodash2.default.get(p, 'stats.minutesPlayed', 0);
	                }).map(function (p) {
	                    return _react2.default.createElement(_materialUi.MenuItem, {
	                        value: p.id,
	                        key: p.id,
	                        primaryText: p.name,
	                        onClick: function onClick() {
	                            return onPlayerSelected(team.id, p.id);
	                        }
	                    });
	                })
	            )
	        )
	    );
	});
	
	var PlayerInfo = (0, _recompose.branch)(function (_ref13) {
	    var player = _ref13.player;
	    return !player;
	}, _recompose.renderNothing)(function (_ref14) {
	    var player = _ref14.player;
	    return _react2.default.createElement(
	        'h1',
	        null,
	        player.name
	    );
	});
	
	var LeagueInfoEnchanced = (0, _reactRedux.connect)(function (_ref15) {
	    var widgetPicker = _ref15.widgetPicker;
	    return _extends({}, _lodash2.default.get(widgetPicker, 'info.league', {}));
	})(LeagueInfo);
	
	var TeamInfoEnchanced = (0, _reactRedux.connect)(function (_ref16) {
	    var widgetPicker = _ref16.widgetPicker;
	    return _extends({}, _lodash2.default.get(widgetPicker, 'info.team', {}));
	})((0, _widgets.withTeamWidgets)(TeamInfo));
	
	var PleayerInfoEnchanced = (0, _reactRedux.connect)(function (_ref17) {
	    var widgetPicker = _ref17.widgetPicker;
	    return _extends({}, _lodash2.default.get(widgetPicker, 'info.player', {}));
	})((0, _widgets.withPlayerWidgets)(PlayerInfo));
	
	var NavigatorEnchanced = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref18, props) {
	    var widgetPicker = _ref18.widgetPicker;
	
	    return {
	        tournamentId: props.tournamentId || _lodash2.default.get(widgetPicker, 'info.team.team.mainTournamentId')
	    };
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(Navigator);
	
	exports.default = NavigatorEnchanced;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FakeCell = exports.Match = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 40px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .info {\n        opacity: 0.7;\n        font-size: 12px;\n        padding-bottom: 3px;\n    }\n'], ['\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 40px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .info {\n        opacity: 0.7;\n        font-size: 12px;\n        padding-bottom: 3px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    width: 280px;\n\n    margin: 5px;\n    border-radius: 5px;\n    background: ', ';\n    &:hover {\n        background: rgba(255, 0, 0, 0.1);\n        cursor: pointer;\n    }\n'], ['\n    width: 280px;\n\n    margin: 5px;\n    border-radius: 5px;\n    background: ', ';\n    &:hover {\n        background: rgba(255, 0, 0, 0.1);\n        cursor: pointer;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Cell = _styledComponents2.default.div(_templateObject);
	
	var CellSmall = Cell.extend(_templateObject2, function (props) {
	    return props.active ? 'rgba(255, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)';
	});
	
	var Match = exports.Match = function Match(_ref) {
	    var startDate = _ref.startDate,
	        homeShortName = _ref.homeShortName,
	        awayShortName = _ref.awayShortName,
	        homeId = _ref.homeId,
	        awayId = _ref.awayId,
	        tournamentId = _ref.tournamentId,
	        score = _ref.score,
	        statusType = _ref.statusType,
	        properties = _ref.properties,
	        onClick = _ref.onClick,
	        active = _ref.active;
	    return _react2.default.createElement(
	        CellSmall,
	        { onClick: onClick, active: active },
	        _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    display: 'flex',
	                    alignItems: 'center',
	                    justifyContent: 'center',
	                    padding: '10px 0'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'flex-end' } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    homeShortName
	                ),
	                _react2.default.createElement('img', {
	                    alt: homeId,
	                    style: {
	                        width: 24,
	                        height: 24,
	                        minWidth: 24,
	                        minHeight: 24
	                    },
	                    src: 'https://dxugi372p6nmc.cloudfront.net/wdp/current/original/' + homeId + '/teamlogo.png'
	                })
	            ),
	            statusType === 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                '-:-'
	            ),
	            statusType !== 'notstarted' && _react2.default.createElement(
	                'div',
	                { className: 'score' },
	                score.home,
	                ':',
	                score.away
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'side', style: { justifyContent: 'start' } },
	                _react2.default.createElement('img', {
	                    alt: homeId,
	                    style: {
	                        width: 24,
	                        height: 24,
	                        minWidth: 24,
	                        minHeight: 24
	                    },
	                    src: 'https://dxugi372p6nmc.cloudfront.net/wdp/current/original/' + awayId + '/teamlogo.png'
	                }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'name' },
	                    awayShortName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            !_lodash2.default.isNaN(+properties.round) ? 'R' + properties.round : properties.round,
	            ' ',
	            (0, _moment2.default)(startDate).format('dd MMM'),
	            ' ',
	            statusType === 'notstarted' && _react2.default.createElement(
	                'span',
	                { className: 'status' },
	                (0, _moment2.default)(startDate).format('HH:mm')
	            ),
	            statusType === 'finished' && _react2.default.createElement(
	                'span',
	                { className: 'status' },
	                'FT'
	            ),
	            statusType === 'inprogress' && _react2.default.createElement(
	                'span',
	                { className: 'status' },
	                'LIVE'
	            )
	        )
	    );
	};
	
	var FakeCell = exports.FakeCell = function FakeCell(_ref2) {
	    var text = _ref2.text,
	        onClick = _ref2.onClick;
	    return _react2.default.createElement(
	        CellSmall,
	        { onClick: onClick },
	        text
	    );
	};
	
	exports.default = Match;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Player = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding: 15px 10px;\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 50px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .rnd {\n        position: absolute;\n        top: 5px;\n        left: 5px;\n        font-size: 12px;\n    }\n'], ['\n    padding: 15px 10px;\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .name {\n        padding: 0 10px;\n        white-space: nowrap;\n    }\n\n    .side {\n        width: calc(50% - 25px);\n        display: flex;\n        padding: 0 5px;\n        align-items: center;\n        justify-content: center;\n    }\n    .status {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 5px;\n        text-align: center;\n    }\n\n    .score {\n        width: 50px;\n        text-align: center;\n        display: inline-block;\n        font-size: 20px;\n    }\n    .rnd {\n        position: absolute;\n        top: 5px;\n        left: 5px;\n        font-size: 12px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    width: 280px;\n    height: 60px;\n    margin: 1px;\n    background: ', ';\n    &:hover {\n        background: rgba(255, 0, 0, 0.1);\n        cursor: pointer;\n    }\n'], ['\n    width: 280px;\n    height: 60px;\n    margin: 1px;\n    background: ', ';\n    &:hover {\n        background: rgba(255, 0, 0, 0.1);\n        cursor: pointer;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Cell = _styledComponents2.default.div(_templateObject);
	
	var CellSmall = Cell.extend(_templateObject2, function (props) {
	    return props.active ? 'rgba(255, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.05)';
	});
	
	var Player = exports.Player = function Player(_ref) {
	    var name = _ref.name,
	        number = _ref.number,
	        _ref$stats = _ref.stats,
	        stats = _ref$stats === undefined ? {} : _ref$stats,
	        onClick = _ref.onClick,
	        active = _ref.active;
	    return _react2.default.createElement(
	        CellSmall,
	        { onClick: onClick, active: active },
	        _react2.default.createElement(
	            'div',
	            null,
	            name
	        ),
	        _lodash2.default.get(stats, 'matchesPlayed', 0),
	        ' / ',
	        _lodash2.default.get(stats, 'goals', 0),
	        ' / ',
	        _lodash2.default.get(stats, 'assists', 0)
	    );
	};
	
	// label={
	//     p.name +
	//     ' ' +
	//     `${_.get(p, 'stats.matchesPlayed', 0)} / ${_.get(p, 'stats.goals', 0)} / ${_.get(
	//         p,
	//         'stats.assists',
	//         0,
	//     )}`
	// }
	
	exports.default = Player;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // import { WidgetPicker } from './WidgetPicker';
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WidgetPicker = __webpack_require__(1783);
	
	var _WidgetPicker2 = _interopRequireDefault(_WidgetPicker);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRouter = __webpack_require__(188);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _qs = __webpack_require__(1813);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetPickerPage = (0, _recompose.compose)((0, _reactRedux.connect)(function (state, _ref) {
	    var params = _ref.params;
	
	    var query = _qs2.default.parse(window.location.search, {
	        ignoreQueryPrefix: true,
	        decoder: function decoder(value) {
	            value = decodeURIComponent(value);
	            try {
	                value = JSON.parse(value);
	            } catch (e) {
	                //
	            }
	            return value;
	        }
	    });
	
	    // prepare required params for WidgetPicker from url
	
	    return {
	        tab: params.tab,
	        params: query,
	        template: query.template
	    };
	}, function () {
	    return {
	        onWidgetSelected: function onWidgetSelected(e, widget) {
	            var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
	                query = _browserHistory$getCu.query;
	
	            var pathname = window.location.pathname;
	
	
	            var urlFriendlyParams = _lodash2.default.chain(widget.props || {}).toPairs().map(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2),
	                    k = _ref3[0],
	                    v = _ref3[1];
	
	                var out = null;
	                if (v === '' || v === null || v === 'undefined' || _lodash2.default.isUndefined(v)) out = null;
	                if (_lodash2.default.isObject(v)) {
	                    out = JSON.stringify(v);
	                } else {
	                    out = v;
	                }
	
	                return [k, out];
	            }).fromPairs()
	            // .compact()
	            .value();
	
	            _reactRouter.browserHistory.push({
	                pathname: '/editor/' + widget.id + '/layout',
	                query: _extends({}, urlFriendlyParams, { template: query.template }) || {}
	            });
	        },
	        onTemplateChanged: function onTemplateChanged(template) {
	            var _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(),
	                query = _browserHistory$getCu2.query;
	
	            var pathname = window.location.pathname;
	
	            _reactRouter.browserHistory.push({
	                pathname: pathname,
	                query: _lodash2.default.omit(_extends({}, query, { template: template }))
	            });
	        },
	        onTabOpen: function onTabOpen(tab, params) {
	            var _browserHistory$getCu3 = _reactRouter.browserHistory.getCurrentLocation(),
	                query = _browserHistory$getCu3.query;
	
	            _reactRouter.browserHistory.push({
	                pathname: '/editor/pick/' + tab,
	                query: _lodash2.default.omit(_extends({}, params, { template: query.template }))
	            });
	        }
	    };
	}), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(_WidgetPicker2.default);
	
	exports.default = WidgetPickerPage;

/***/ },
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WidgetEdit = __webpack_require__(1720);
	
	var _WidgetEdit2 = _interopRequireDefault(_WidgetEdit);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRouter = __webpack_require__(188);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _qs = __webpack_require__(1813);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetEditPage = (0, _recompose.compose)((0, _reactRedux.connect)(), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidMount: function componentDidMount() {}
	}))(function (_ref) {
	    var params = _ref.params;
	
	    // // loaded via router
	
	    var query = _qs2.default.parse(window.location.search, {
	        ignoreQueryPrefix: true,
	        decoder: function decoder(value) {
	            value = decodeURIComponent(value);
	            try {
	                value = JSON.parse(value);
	            } catch (e) {
	                //
	            }
	            return value;
	        }
	    });
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WidgetEdit2.default, {
	            tab: params.tab,
	            widgetId: params.widgetId,
	            widgetProps: query,
	            allowChangeWidget: true,
	            onChangeWidgetRequest: function onChangeWidgetRequest() {
	                var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
	                    query = _browserHistory$getCu.query;
	
	                _reactRouter.browserHistory.push({
	                    pathname: '/editor',
	                    query: { template: query.template }
	                });
	            }
	        }),
	        _react2.default.createElement(PageUrlObserver, null)
	    );
	});
	
	var PageUrlObserver = (0, _recompose.compose)((0, _reactRedux.connect)(function (_ref2) {
	    var editor = _ref2.editor;
	    return {
	        widgetId: editor.widgetId,
	        tab: editor.tab,
	        widgetProps: editor.widgetProps
	    };
	}), (0, _recompose.lifecycle)({
	    pushPropsToUrl: _lodash2.default.debounce(function (tab, widgetId, payload) {
	        if (!widgetId) return;
	
	        var _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(),
	            query = _browserHistory$getCu2.query;
	
	        var q = _lodash2.default.pickBy(_extends({}, query, payload), _lodash2.default.identity);
	        var qq = _lodash2.default.chain(q).toPairs(q).map(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                key = _ref4[0],
	                val = _ref4[1];
	
	            if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	                return [key, JSON.stringify(val)];
	            } else {
	                return [key, val];
	            }
	        }).fromPairs().value();
	
	        _reactRouter.browserHistory.replace({
	            pathname: '/editor/' + widgetId + '/' + tab,
	            query: qq
	        });
	    }, 300),
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var widgetProps = nextProps.widgetProps,
	            widgetId = nextProps.widgetId,
	            tab = nextProps.tab;
	
	        this.pushPropsToUrl(tab, widgetId, widgetProps);
	    },
	    componentDidMount: function componentDidMount() {}
	}))(function () {
	    return _react2.default.createElement('div', null);
	});
	
	exports.default = WidgetEditPage;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SMLinkManager = __webpack_require__(1095);
	
	Object.defineProperty(exports, 'SMLinkManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SMLinkManager).default;
	  }
	});
	
	var _SMLinkTitle = __webpack_require__(1108);
	
	Object.defineProperty(exports, 'SMLinkTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SMLinkTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reduxForm = __webpack_require__(342);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _materialUi = __webpack_require__(642);
	
	var _chevronRight = __webpack_require__(878);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _warning = __webpack_require__(1109);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(1370);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1821);
	
	var _helpers2 = __webpack_require__(1049);
	
	var _campaigns = __webpack_require__(1822);
	
	var _selectors = __webpack_require__(618);
	
	var _schema = __webpack_require__(1823);
	
	var _CampaignForm = __webpack_require__(1839);
	
	var _CampaignForm2 = _interopRequireDefault(_CampaignForm);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers3 = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StrategySelect = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaigns: (0, _selectors.getEntities)(state).campaigns,
	        campaignsPending: _lodash2.default.get((0, _selectors.getQueries)(state)['GET:campaigns'], 'isPending'),
	        campaignsReqStatus: _lodash2.default.get((0, _selectors.getQueries)(state)['GET:campaigns'], 'status')
	    };
	}, function (dispatch) {
	    return {
	        fetchCampaigns: function fetchCampaigns() {
	            return dispatch((0, _campaigns.fetchCampaigns)());
	        }
	    };
	})(function (_React$PureComponent) {
	    _inherits(_StrategySelect, _React$PureComponent);
	
	    function _StrategySelect() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _StrategySelect);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _StrategySelect.__proto__ || Object.getPrototypeOf(_StrategySelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = { strategy: null, campaigns: [], campaign: null }, _this.updateCampaigns = function (campaignsMap) {
	            var array = _lodash2.default.isObject(campaignsMap) ? Object.keys(campaignsMap).map(function (id) {
	                return campaignsMap[id];
	            }).sort(function (a, b) {
	                return a.createdAt - b.createdAt;
	            }) : [];
	            _this.setState({ campaigns: array });
	        }, _this.onStrategyChange = function (e, value) {
	            _this.setState({ strategy: value });
	        }, _this.onCampaignChange = function (e, index, campaign) {
	            _this.setState({ campaign: campaign });
	        }, _this.goNext = function () {
	            var _this$state = _this.state,
	                campaign = _this$state.campaign,
	                strategy = _this$state.strategy;
	
	            var payload = { strategy: strategy };
	            if (strategy === 'clone') {
	                payload.campaign = campaign;
	            }
	            _this.props.onSelect(payload);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_StrategySelect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchCampaigns();
	            if (this.props.campaigns) {
	                this.updateCampaigns(this.props.campaigns);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            if (this.props.campaigns !== props.campaigns) {
	                this.updateCampaigns(props.campaigns);
	            }
	        }
	    }, {
	        key: 'renderCampaignSelect',
	        value: function renderCampaignSelect() {
	            var _state = this.state,
	                campaigns = _state.campaigns,
	                campaign = _state.campaign;
	            var _props = this.props,
	                campaignsPending = _props.campaignsPending,
	                campaignsReqStatus = _props.campaignsReqStatus;
	
	            if (campaignsPending) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: 12 } },
	                    _react2.default.createElement(_materialUi.LinearProgress, null)
	                );
	            }
	            if (!(0, _helpers3.responseStatusIsOk)(campaignsReqStatus)) {
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            display: 'flex',
	                            alignItems: 'center',
	                            flexDirection: 'column'
	                        }
	                    },
	                    _react2.default.createElement(_warning2.default, null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Error while fetching campaigns'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Status code: ',
	                        campaignsReqStatus
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                _materialUi.SelectField,
	                { value: campaign, floatingLabelText: 'Select campaign', onChange: this.onCampaignChange },
	                campaigns.map(function (campaign) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: campaign._id, value: campaign._id, primaryText: campaign.title });
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state2 = this.state,
	                campaigns = _state2.campaigns,
	                strategy = _state2.strategy,
	                campaign = _state2.campaign;
	
	            var canGoNext = strategy === 'empty' || strategy === 'clone' && Boolean(campaign);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Create campaign'
	                ),
	                _react2.default.createElement(
	                    _materialUi.RadioButtonGroup,
	                    { name: 'switch', onChange: this.onStrategyChange },
	                    _react2.default.createElement(_materialUi.RadioButton, { value: 'empty', label: 'new' }),
	                    _react2.default.createElement(_materialUi.RadioButton, { value: 'clone', label: 'based on existing' })
	                ),
	                strategy === 'clone' ? this.renderCampaignSelect() : null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: 12 } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                        primary: true,
	                        label: 'Next',
	                        labelPosition: 'before',
	                        icon: _react2.default.createElement(_chevronRight2.default, null),
	                        onTouchTap: this.goNext,
	                        disabled: !canGoNext
	                    })
	                )
	            );
	        }
	    }]);
	
	    return _StrategySelect;
	}(_react2.default.PureComponent));
	
	StrategySelect.propTypes = {
	    onSelect: _propTypes2.default.func.isRequired
	};
	
	var Scene = function (_React$PureComponent2) {
	    _inherits(Scene, _React$PureComponent2);
	
	    function Scene() {
	        var _ref2;
	
	        var _temp2, _this2, _ret2;
	
	        _classCallCheck(this, Scene);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Scene.__proto__ || Object.getPrototypeOf(Scene)).call.apply(_ref2, [this].concat(args))), _this2), _this2.updateStateByQuery = function () {
	            var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var campaign = query.campaign,
	                strategy = query.strategy;
	
	            _this2.setState({ errorMessage: null, loading: false });
	            if (strategy) {
	                if (!campaign) {
	                    strategy = 'empty';
	                }
	                _this2.setState({ strategy: strategy });
	                if (campaign && strategy === 'clone') {
	                    _this2.setState({ loading: true });
	                    _this2.props.initializeFromCampaign(campaign).then(function () {
	                        return _this2.setState({ loading: false });
	                    }).catch(function (error) {
	                        _this2.setState({
	                            errorMessage: error.message,
	                            loading: false
	                        });
	                    });
	                } else {
	                    _this2.props.initialize({});
	                }
	            } else {
	                _this2.setState({ strategy: strategy });
	            }
	        }, _this2.state = { strategy: null, loading: false, errorMessage: null }, _this2.onStrategySelect = function (payload) {
	            _reactRouter.browserHistory.push({
	                pathname: window.location.pathname,
	                query: payload
	            });
	        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    _createClass(Scene, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateStateByQuery(this.props.location.query);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref3) {
	            var location = _ref3.location;
	
	            if (this.props.location !== location) {
	                var query = location.query;
	
	                this.updateStateByQuery(query);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state3 = this.state,
	                strategy = _state3.strategy,
	                loading = _state3.loading,
	                errorMessage = _state3.errorMessage;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-container' },
	                !strategy ? _react2.default.createElement(StrategySelect, { onSelect: this.onStrategySelect }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    loading ? _react2.default.createElement(_materialUi.LinearProgress, null) : null,
	                    errorMessage ? _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                display: 'flex',
	                                alignItems: 'center',
	                                flexDirection: 'column'
	                            }
	                        },
	                        _react2.default.createElement(_warning2.default, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            errorMessage
	                        )
	                    ) : null,
	                    _react2.default.createElement(_CampaignForm2.default, null),
	                    _react2.default.createElement(_helpers.RowSection, {
	                        hideSplit: true,
	                        style: { marginBottom: 16 },
	                        rightContent: _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: 'Save', onTouchTap: this.props.submit })
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Scene;
	}(_react2.default.PureComponent);
	
	Scene.propTypes = {
	    submit: _propTypes2.default.func.isRequired,
	    initializeFromCampaign: _propTypes2.default.func.isRequired
	};
	
	/**
	 * This bullshit will be fixed.
	 * Should do this due to the stepper.
	 */
	var onSubmit = function onSubmit(values, dispatch, self) {
	    var syncErrors = self.syncErrors;
	
	    var errorKeys = Object.keys(syncErrors || {});
	    if (errorKeys.length === 0) {
	        var mappedData = (0, _schema.mapData)(values);
	        var url = _cfg2.default.campaign_manager.host + '/api/campaigns?access_token=' + _auth2.default.getAccessToken();
	        var params = {
	            body: mappedData,
	            url: url
	        };
	        var config = (0, _helpers2.createPostRequest)(params);
	        return dispatch((0, _reduxQuery.requestAsync)(config)).then(_helpers2.handleServerError);
	    } else {
	        throw new _reduxForm.SubmissionError({ _error_: 'Check your rules' });
	    }
	};
	
	var getCampaign = function getCampaign(campaignId) {
	    return function (dispatch, getState) {
	        var campaign = _lodash2.default.get((0, _selectors.getEntities)(getState()), ['campaigns', campaignId]);
	        return campaign ? Promise.resolve(campaign) : dispatch((0, _campaigns.fetchCampaignById)(campaignId)).then(function (_ref4) {
	            var body = _ref4.body;
	
	            if (body.campaign) {
	                return body.campaign;
	            }
	            throw new Error('No campaign found');
	        });
	    };
	};
	
	var initFromCampaign = function initFromCampaign(campaignId, form) {
	    return function (dispatch, getState) {
	        return dispatch(getCampaign(campaignId)).then(function (campaign) {
	            var copy = _lodash2.default.omit(_lodash2.default.extend({}, campaign, { active: false }), ['_id', 'createdAt', 'updatedAt', 'stats']);
	            copy.title = copy.title + ' copy';
	            dispatch((0, _reduxForm.initialize)(form, copy));
	        });
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        submitSucceeded: (0, _reduxForm.hasSubmitSucceeded)(_constants.CAMPAIGN_FORM_ID)(state),
	        submitting: (0, _reduxForm.isSubmitting)(_constants.CAMPAIGN_FORM_ID)(state)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref5) {
	    var form = _ref5.form;
	
	    return {
	        initializeFromCampaign: function initializeFromCampaign(id) {
	            return dispatch(initFromCampaign(id, form));
	        },
	        dispatch: dispatch
	    };
	};
	
	var CreateEnhanced = (0, _recompose.compose)((0, _reduxForm.reduxForm)({
	    form: _constants.CAMPAIGN_FORM_ID,
	    onSubmit: onSubmit,
	    validate: _schema.defValidate
	}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	    componentWillReceiveProps: function componentWillReceiveProps(_ref6) {
	        var submitSucceeded = _ref6.submitSucceeded;
	
	        if (this.props.submitting && submitSucceeded) {
	            _reactRouter.browserHistory.push('/campaigns');
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        var dispatch = this.props.dispatch;
	
	        var tz = _momentTimezone2.default.tz.guess();
	        dispatch((0, _reduxForm.autofill)(_constants.CAMPAIGN_FORM_ID, _constants.CAMPAIGN_FORM_KEYS.TIMEZONE, tz));
	    }
	}))(Scene);
	
	exports.default = CreateEnhanced;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ActiveLabel = exports.RowSection = exports.Split = exports.DotDivider = exports.DateComponent = exports.BooleanField = exports.getFieldPath = exports.formatDate = exports.marginLeft = exports.yCenter = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _done = __webpack_require__(1117);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _clear = __webpack_require__(1501);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _colors = __webpack_require__(910);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yCenter = exports.yCenter = { display: 'flex', alignItems: 'center' };
	var marginLeft = exports.marginLeft = function marginLeft() {
	    var px = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
	    return {
	        marginLeft: px
	    };
	};
	
	/**
	 * helper function for formatting date in Redux form
	 */
	var formatDate = exports.formatDate = function formatDate(value) {
	    if (value === '') {
	        return null;
	    }
	    return typeof value === 'string' ? new Date(value) : value;
	};
	
	var getFieldPath = exports.getFieldPath = function getFieldPath(sectionPrefix, fieldName) {
	    if (sectionPrefix) {
	        return sectionPrefix.charAt(sectionPrefix.length - 1) === ']' ? sectionPrefix + fieldName : sectionPrefix + '.' + fieldName;
	    }
	    return fieldName;
	};
	
	var BooleanField = exports.BooleanField = function BooleanField(_ref) {
	    var value = _ref.value;
	    return value ? _react2.default.createElement(_done2.default, null) : _react2.default.createElement(_clear2.default, null);
	};
	
	var DateComponent = exports.DateComponent = function DateComponent(_ref2) {
	    var date = _ref2.date,
	        _ref2$text = _ref2.text,
	        text = _ref2$text === undefined ? '' : _ref2$text,
	        _ref2$format = _ref2.format,
	        format = _ref2$format === undefined ? 'DD MMM YYYY HH:mm' : _ref2$format;
	
	    if (!date) {
	        return null;
	    }
	    var formatted = (0, _moment2.default)(date).format(format);
	    return _react2.default.createElement(
	        'span',
	        null,
	        text ? text + ' ' : '',
	        formatted
	    );
	};
	
	var DotDivider = exports.DotDivider = function DotDivider() {
	    return _react2.default.createElement(
	        'span',
	        { style: { margin: '0px 5px' } },
	        '.'
	    );
	};
	
	var Split = exports.Split = function Split() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'row', style: { marginTop: 12, marginBottom: 12 } },
	        _react2.default.createElement(_materialUi.Divider, null)
	    );
	};
	
	var RowSection = exports.RowSection = function RowSection(_ref3) {
	    var leftContent = _ref3.leftContent,
	        _ref3$leftYCenter = _ref3.leftYCenter,
	        leftYCenter = _ref3$leftYCenter === undefined ? true : _ref3$leftYCenter,
	        rightContent = _ref3.rightContent,
	        hideSplit = _ref3.hideSplit,
	        _ref3$style = _ref3.style,
	        style = _ref3$style === undefined ? {} : _ref3$style;
	
	    return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement(
	            'div',
	            { key: 'main', className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                leftContent && leftYCenter ? _react2.default.cloneElement(leftContent, { style: yCenter }) : leftContent
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9' },
	                rightContent
	            )
	        ),
	        !hideSplit ? _react2.default.createElement(Split, { key: 'split' }) : null
	    );
	};
	
	var isCampaignActive = function isCampaignActive(active, startDate, endDate) {
	    if (!active) {
	        return false;
	    }
	    if (active && (!startDate || !endDate)) {
	        return true;
	    }
	    // Remove comparing time. Only date.
	    var start = (0, _moment2.default)((0, _moment2.default)(startDate).format('LL'), 'LL');
	    var end = (0, _moment2.default)((0, _moment2.default)(endDate).format('LL'), 'LL');
	    var current = (0, _moment2.default)((0, _moment2.default)().format('LL'), 'LL');
	    return start.isSameOrBefore(current) && current.isSameOrBefore(end);
	};
	
	var ActiveLabel = exports.ActiveLabel = function ActiveLabel(_ref4) {
	    var active = _ref4.active,
	        startDate = _ref4.startDate,
	        endDate = _ref4.endDate;
	
	    var isActive = isCampaignActive(active, startDate, endDate);
	    var isActiveLabel = isActive ? 'Active now' : 'Not active now';
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h4',
	            { style: { marginBottom: 4 } },
	            'Status'
	        ),
	        _react2.default.createElement(
	            _materialUi.Chip,
	            { backgroundColor: isActive ? _colors.lightGreen300 : _colors.orange300 },
	            isActiveLabel
	        )
	    );
	};

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateCampaign = exports.deleteCampaign = exports.fetchCampaignById = exports.fetchCampaigns = exports.campaignsFetchConfig = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxQuery = __webpack_require__(298);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(1370);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers = __webpack_require__(1049);
	
	var _constants = __webpack_require__(579);
	
	var _selectors = __webpack_require__(618);
	
	var _widgetSpecs = __webpack_require__(1048);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var WIDGET_KEY = _constants.CAMPAIGN_FORM_KEYS.WIDGET;
	var TIME_FORMAT = 'HH:mm';
	var DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
	
	var transformConditionFromServer = function transformConditionFromServer(condition, allValues) {
	    if (!_lodash2.default.isObject(condition)) {
	        return condition;
	    }
	    return Object.keys(condition).reduce(function (acc, cur) {
	        var timezone = allValues.timezone;
	
	
	        switch (cur) {
	            case 'time':
	                {
	                    var utcTime = condition[cur];
	                    var userTime = _momentTimezone2.default.utc(utcTime, TIME_FORMAT).tz(timezone).format(TIME_FORMAT);
	                    acc[cur] = userTime;
	                    break;
	                }
	            case 'dateTime':
	                {
	                    var _utcTime = condition[cur];
	                    var _userTime = _momentTimezone2.default.utc(_utcTime, DATE_TIME_FORMAT).tz(timezone).format(DATE_TIME_FORMAT);
	                    acc[cur] = _userTime;
	                    break;
	                }
	            default:
	                acc[cur] = condition[cur];
	        }
	        return acc;
	    }, {});
	};
	
	var getDate = function getDate(date, timezone) {
	    return date ? (0, _momentTimezone2.default)((0, _momentTimezone2.default)(date).tz(timezone).format('YYYY-MM-DDTHH:mm:ss')).toDate() : null;
	};
	
	/**
	 * Is used to map a campaign to REDUX FORM structure.
	 * @param {*} campaign
	 */
	var updateCampaignFieldsToStruct = function updateCampaignFieldsToStruct(campaign) {
	    var timezone = campaign.timezone;
	
	    campaign.startDate = getDate(campaign.startDate, timezone);
	    campaign.endDate = getDate(campaign.endDate, timezone);
	    campaign.messengerNotifications = campaign.notificationsTo.reduce(function (prev, current) {
	        if (current.type === 'messenger') {
	            prev.push({
	                userName: current.userName,
	                userPhoto: current.userPhoto,
	                userRef: current.value,
	                userId: current.userId,
	                value: current.value
	            });
	        }
	        return prev;
	    }, []);
	    campaign.notificationsTo = campaign.notificationsTo.filter(function (n) {
	        return n.type !== 'messenger';
	    });
	    (campaign.rules || []).forEach(function (rule) {
	        var rest = _lodash2.default.omit(rule.presentation.params, ['theme', 'template', 'client', 'user', 'username']);
	        rule.presentation.additional = [];
	        rule.conditions = rule.conditions.map(function (condition) {
	            return transformConditionFromServer(condition, campaign);
	        });
	        Object.keys(rest).forEach(function (key) {
	            var _rule$presentation$ad;
	
	            rule.presentation.additional.push((_rule$presentation$ad = {
	                key: key
	            }, _defineProperty(_rule$presentation$ad, WIDGET_KEY.PARAMS.ADDITIONAL.VALUE, 'manual'), _defineProperty(_rule$presentation$ad, WIDGET_KEY.PARAMS.ADDITIONAL.CUSTOM_VALUE, rest[key]), _defineProperty(_rule$presentation$ad, WIDGET_KEY.PARAMS.ADDITIONAL.BY_TRIGGER, false), _rule$presentation$ad));
	        });
	        var triggerParams = rule.presentation[WIDGET_KEY.TRIGGER_PARAMS.SECTION] || {};
	        Object.keys(triggerParams).forEach(function (key) {
	            var _rule$presentation$ad2;
	
	            rule.presentation.additional.push((_rule$presentation$ad2 = {
	                key: key
	            }, _defineProperty(_rule$presentation$ad2, WIDGET_KEY.PARAMS.ADDITIONAL.VALUE, triggerParams[key]), _defineProperty(_rule$presentation$ad2, WIDGET_KEY.PARAMS.ADDITIONAL.BY_TRIGGER, true), _rule$presentation$ad2));
	        });
	    });
	    return campaign;
	};
	
	var mapCampaignFromServerData = function mapCampaignFromServerData(data) {
	    var campaign = data.campaign;
	
	    return updateCampaignFieldsToStruct(campaign);
	};
	
	var transformCampaigns = function transformCampaigns(data) {
	    var campaigns = data.campaigns;
	
	    return _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, campaigns.reduce(function (acc, cur) {
	        acc[cur._id] = updateCampaignFieldsToStruct(cur);
	        return acc;
	    }, {}));
	};
	
	var updateCampaigns = _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, function (prev, cur) {
	    return _extends({}, prev, cur);
	});
	
	var campaignsFetchConfig = exports.campaignsFetchConfig = function campaignsFetchConfig() {
	    return {
	        url: _cfg2.default.campaign_manager.host + '/api/campaigns?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        queryKey: 'GET:campaigns',
	        transform: transformCampaigns,
	        update: updateCampaigns
	    };
	};
	
	var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns() {
	    return (0, _reduxQuery.requestAsync)(campaignsFetchConfig());
	};
	
	var transformCampaignById = function transformCampaignById(widgets) {
	    return function (data) {
	        var campaign = mapCampaignFromServerData(data);
	        _lodash2.default.forEach(campaign.rules, function (rule) {
	            var widgetId = _lodash2.default.get(rule, 'presentation.name');
	            var widget = widgets.find(function (el) {
	                return el.id === widgetId;
	            });
	            var additional = rule.presentation.additional;
	            if (widget) {
	                var propTypes = _lodash2.default.get(widget, 'spec.propTypes', []);
	                var newProps = propTypes.filter(function (prop) {
	                    return prop.key !== 'template' && !additional.some(function (add) {
	                        return add.key === prop.key;
	                    });
	                });
	                newProps.forEach(function (prop) {
	                    additional.push({
	                        key: prop.key,
	                        value: 'manual',
	                        customValue: prop.defaultValue,
	                        byTrigger: false
	                    });
	                });
	            }
	        });
	        return _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, _defineProperty({}, campaign._id, campaign));
	    };
	};
	
	var getWidgetSpecs = function getWidgetSpecs(dispatch, getState) {
	    var entities = (0, _selectors.getEntities)(getState());
	    var prevWidgetSpecs = entities[_constants.STORE_KEYS.WIDGET_SPECS];
	    return prevWidgetSpecs && Array.isArray(prevWidgetSpecs.widgets) ? Promise.resolve(prevWidgetSpecs.widgets) : dispatch((0, _widgetSpecs.fetchWidgetSpecs)()).then(function (_ref3) {
	        var entities = _ref3.entities;
	        return entities[_constants.STORE_KEYS.WIDGET_SPECS].widgets;
	    });
	};
	
	var fetchCampaignById = exports.fetchCampaignById = function fetchCampaignById(campaignId) {
	    return function (dispatch) {
	        return dispatch(getWidgetSpecs).then(function (widgets) {
	            var url = _cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '?access_token=' + _auth2.default.getAccessToken();
	            var requestConfig = (0, _helpers.createApiFetch)({
	                url: url,
	                key: _constants.STORE_KEYS.CAMPAIGNS,
	                configOptions: {
	                    transform: transformCampaignById(widgets),
	                    update: _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, function (prev, curr) {
	                        return _extends({}, prev, curr);
	                    })
	                }
	            });
	            return dispatch((0, _reduxQuery.requestAsync)(requestConfig));
	        });
	    };
	};
	
	var deleteCampaign = function deleteCampaign(id) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var url = _cfg2.default.campaign_manager.host + '/api/campaigns/' + id + '?access_token=' + _auth2.default.getAccessToken();
	
	    var options = config.options,
	        restConfig = _objectWithoutProperties(config, ['options']);
	
	    var requestConfig = _extends({
	        url: url,
	        update: _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, function (campaigns) {
	            if (!campaigns) {
	                return campaigns;
	            }
	            // eslint-disable-next-line
	
	            var toDel = campaigns[id],
	                rest = _objectWithoutProperties(campaigns, [id]);
	
	            return rest;
	        }),
	        queryKey: _constants.STORE_KEYS.CAMPAIGNS,
	        options: _extends({}, options, {
	            method: _reduxQuery.httpMethods.DELETE
	        })
	    }, restConfig);
	    return (0, _reduxQuery.mutateAsync)(requestConfig);
	};
	
	exports.deleteCampaign = deleteCampaign;
	var updateCampaign = exports.updateCampaign = function updateCampaign(campaign) {
	    var _id = campaign._id;
	
	    var url = _cfg2.default.campaign_manager.host + '/api/campaigns/' + _id + '?access_token=' + _auth2.default.getAccessToken();
	    var config = {
	        body: campaign,
	        url: url,
	        queryKey: _constants.STORE_KEYS.CAMPAIGNS,
	        key: _constants.STORE_KEYS.CAMPAIGNS,
	        force: true,
	        transform: function transform(response) {
	            var campaign = mapCampaignFromServerData(response);
	            return _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, _defineProperty({}, campaign._id, campaign));
	        },
	        update: _defineProperty({}, _constants.STORE_KEYS.CAMPAIGNS, function (prev, cur) {
	            return _extends({}, prev, cur);
	        }),
	        options: {
	            method: _reduxQuery.httpMethods.PUT
	        }
	    };
	    return (0, _reduxQuery.requestAsync)(config);
	};

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.generateRoutingKey = exports.getWidgetParamsInitValue = exports.validateWizzard = exports.validateConditions = exports.mapData = exports.defValidate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(1370);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _constants = __webpack_require__(579);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _createStore = __webpack_require__(295);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _validation = __webpack_require__(1660);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var WIDGET = _constants.CAMPAIGN_FORM_KEYS.WIDGET;
	var ADD_PARAMS = WIDGET.PARAMS.ADDITIONAL;
	var TIME_FORMAT = 'HH:mm';
	var DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm[Z]';
	
	var defValidate = exports.defValidate = function defValidate() {
	    var errors = {};
	    // if (!_.get(values, 'rules.length')) {
	    //     errors['rules'] = 'At least one rule should be present';
	    // }
	    return errors;
	};
	
	var transformConditionToServer = function transformConditionToServer(condition, allValues) {
	    if (!_lodash2.default.isObject(condition)) {
	        return condition;
	    }
	    return Object.keys(condition).reduce(function (acc, cur) {
	        switch (cur) {
	            case 'time':
	                {
	                    var timezone = allValues.timezone;
	
	                    var userTime = condition[cur];
	                    var utcTime = _momentTimezone2.default.tz(userTime, TIME_FORMAT, timezone).utc().format(TIME_FORMAT);
	                    acc[cur] = utcTime;
	                    break;
	                }
	            case 'dateTime':
	                {
	                    var _timezone = allValues.timezone;
	
	                    var _userTime = condition[cur];
	                    var _utcTime = _momentTimezone2.default.tz(_userTime, DATE_TIME_FORMAT, _timezone).utc().format(DATE_TIME_FORMAT);
	                    acc[cur] = _utcTime;
	                    break;
	                }
	            default:
	                acc[cur] = condition[cur];
	        }
	        return acc;
	    }, {});
	};
	
	var mapData = function mapData(values) {
	    var _store$getState = _createStore2.default.getState(),
	        _store$getState$user = _store$getState.user,
	        username = _store$getState$user.username,
	        client = _store$getState$user.client;
	
	    var copy = _lodash2.default.merge({}, values);
	    var timezone = copy.timezone;
	
	    copy.startDate = copy.startDate ? (0, _momentTimezone2.default)(copy.startDate).tz(timezone).startOf('d').utc().toDate() : null;
	    copy.endDate = copy.endDate ? (0, _momentTimezone2.default)(copy.endDate).tz(timezone).endOf('d').utc().toDate() : null;
	    if (copy.messengerNotifications) {
	        copy.notificationsTo = [].concat(_toConsumableArray(copy.notificationsTo), _toConsumableArray(copy.messengerNotifications.map(function (n) {
	            return {
	                value: n.userRef,
	                userName: n.userName,
	                userId: n.userId,
	                userPhoto: n.userPhoto,
	                type: 'messenger'
	            };
	        })));
	    }
	    if (!Array.isArray(copy.rules)) {
	        copy.rules = [];
	    }
	    copy.rules.forEach(function (rule) {
	        rule.conditions = rule.conditions.map(function (condition) {
	            return transformConditionToServer(condition, values);
	        });
	        rule.presentation.type = _constants.PRESENTATION_TYPES.WIDGET;
	
	        var _rule$presentation = rule.presentation,
	            _rule$presentation$ad = _rule$presentation.additional,
	            additional = _rule$presentation$ad === undefined ? [] : _rule$presentation$ad,
	            rest = _objectWithoutProperties(_rule$presentation, ['additional']);
	
	        rule.presentation = rest;
	        rule.presentation.params = _extends({
	            username: username,
	            client: client,
	            theme: 'default',
	            template: rule.presentation.params.template
	        }, additional.reduce(function (acc, cur) {
	            if (!cur[ADD_PARAMS.BY_TRIGGER]) {
	                var customVal = cur[ADD_PARAMS.CUSTOM_VALUE];
	                var isEmpty = (0, _helpers.isNullOrUndefined)(customVal);
	                acc[cur.key] = isEmpty ? '' : customVal;
	            }
	            return acc;
	        }, {}));
	        rule.presentation[WIDGET.TRIGGER_PARAMS.SECTION] = additional.reduce(function (acc, cur) {
	            if (cur[ADD_PARAMS.BY_TRIGGER]) {
	                acc[cur.key] = cur[ADD_PARAMS.VALUE];
	            }
	            return acc;
	        }, {});
	    });
	    return copy;
	};
	
	exports.mapData = mapData;
	var validateConditions = exports.validateConditions = function validateConditions(values, triggerType) {
	    var trigger = _triggerConstants.triggerTypesMap[triggerType];
	    var requiredConditions = _lodash2.default.get(trigger, 'conditions', []).filter(function (e) {
	        return e.required;
	    });
	    var formConditions = _lodash2.default.get(values, 'conditions', [{}]);
	    var result = formConditions.reduce(function (errors, formCondition, formIndex) {
	        requiredConditions.forEach(function (_ref) {
	            var name = _ref.name;
	
	            var formValue = _lodash2.default.get(formCondition, name);
	            var validationResult = (0, _validation.presence)(formValue);
	            if (validationResult) {
	                errors = _lodash2.default.set(errors, formIndex + '.' + name, validationResult);
	            }
	        });
	        return errors;
	    }, {});
	    if (Object.keys(result).length) {
	        return { conditions: result };
	    }
	    return {};
	};
	
	var WIDGET_NAME = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.NAME;
	var WIDGET_TEMPLATE = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.TEMPLATE;
	
	var validateWizzard = exports.validateWizzard = function validateWizzard(values) {
	    var res = {};
	    var triggerType = values[_constants.CAMPAIGN_FORM_KEYS.RULES.KEY];
	    if (!triggerType) {
	        res[_constants.CAMPAIGN_FORM_KEYS.RULES.KEY] = 'Required';
	    } else {
	        res = _extends({}, validateConditions(values, triggerType), res);
	    }
	    if (!_lodash2.default.get(values, WIDGET_NAME)) {
	        _lodash2.default.set(res, WIDGET_NAME, 'Required');
	    }
	    if (!_lodash2.default.get(values, WIDGET_TEMPLATE)) {
	        _lodash2.default.set(res, WIDGET_TEMPLATE, 'Required');
	    }
	    return res;
	};
	
	/**
	 * Resolves value for props map form (3 step)
	 * @param {Array} widgetProps
	 * @param {Object} triggerPayloadMap Payload that is returned by trigger
	 * @returns {Array}
	 */
	var getWidgetParamsInitValue = exports.getWidgetParamsInitValue = function getWidgetParamsInitValue(widgetProps, triggerPayloadMap) {
	    return widgetProps.filter(function (el) {
	        return el.key !== 'template';
	    }).map(function (prop) {
	        var _ref3;
	
	        var key = prop.key,
	            defaultValue = prop.defaultValue;
	
	        var value = triggerPayloadMap[key];
	        if (value !== undefined) {
	            var _ref2;
	
	            return _ref2 = {}, _defineProperty(_ref2, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.KEY, key), _defineProperty(_ref2, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.VALUE, value), _defineProperty(_ref2, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.BY_TRIGGER, true), _ref2;
	        }
	        return _ref3 = {}, _defineProperty(_ref3, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.KEY, key), _defineProperty(_ref3, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.VALUE, 'manual'), _defineProperty(_ref3, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.BY_TRIGGER, false), _defineProperty(_ref3, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.CUSTOM_VALUE, defaultValue), _ref3;
	    });
	};
	
	var generateRoutingKey = exports.generateRoutingKey = function generateRoutingKey(triggerType) {
	    var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var triggerConditions = _lodash2.default.get(_triggerConstants.triggerTypesMap[triggerType], 'conditions', []);
	    return triggerConditions.reduce(function (acc, cur) {
	        var currentVal = conditions[cur.name];
	        return acc + '.' + currentVal;
	    }, triggerType);
	};

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTriggerPayload = exports.TRIGGER_PAYLOAD = exports.TRIGGER_SCHEMAS = exports.triggerTypesMap = exports.triggerTypes = undefined;
	
	var _enet_event_incident = __webpack_require__(1825);
	
	var _enet_event_incident2 = _interopRequireDefault(_enet_event_incident);
	
	var _enet_event_match_day = __webpack_require__(1826);
	
	var _enet_event_match_day2 = _interopRequireDefault(_enet_event_match_day);
	
	var _enet_event_status = __webpack_require__(1827);
	
	var _enet_event_status2 = _interopRequireDefault(_enet_event_status);
	
	var _event_finished = __webpack_require__(1828);
	
	var _event_finished2 = _interopRequireDefault(_event_finished);
	
	var _event_halftime = __webpack_require__(1829);
	
	var _event_halftime2 = _interopRequireDefault(_event_halftime);
	
	var _event_test = __webpack_require__(1830);
	
	var _event_test2 = _interopRequireDefault(_event_test);
	
	var _event_starts = __webpack_require__(1831);
	
	var _event_starts2 = _interopRequireDefault(_event_starts);
	
	var _schedule = __webpack_require__(1832);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _time = __webpack_require__(1833);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _tourn_match_day = __webpack_require__(1834);
	
	var _tourn_match_day2 = _interopRequireDefault(_tourn_match_day);
	
	var _tourn_round_starts = __webpack_require__(1835);
	
	var _tourn_round_starts2 = _interopRequireDefault(_tourn_round_starts);
	
	var _tourn_round_ends = __webpack_require__(1836);
	
	var _tourn_round_ends2 = _interopRequireDefault(_tourn_round_ends);
	
	var _transfer = __webpack_require__(1837);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var triggerTypes = exports.triggerTypes = __webpack_require__(1838);
	var triggerTypesMap = exports.triggerTypesMap = triggerTypes.reduce(function (acc, cur) {
	    acc[cur.trigger] = cur;
	    return acc;
	}, {});
	
	var TRIGGER_SCHEMAS = exports.TRIGGER_SCHEMAS = {
	    enet_event_incident: _enet_event_incident2.default,
	    enet_event_status: _enet_event_status2.default,
	    enet_event_match_day: _enet_event_match_day2.default,
	    event_halftime: _event_halftime2.default,
	    event_finished: _event_finished2.default,
	    event_test: _event_test2.default,
	    event_starts: _event_starts2.default,
	    schedule: _schedule2.default,
	    time: _time2.default,
	    transfer: _transfer2.default,
	    tourn_match_day: _tourn_match_day2.default,
	    tourn_round_starts: _tourn_round_starts2.default,
	    tourn_round_ends: _tourn_round_ends2.default
	};
	
	var TRIGGER_PAYLOAD = exports.TRIGGER_PAYLOAD = Object.keys(TRIGGER_SCHEMAS).reduce(function (acc, schemaKey) {
	    var props = TRIGGER_SCHEMAS[schemaKey].properties || {};
	    acc[schemaKey] = Object.keys(props).reduce(function (accProps, prop) {
	        if (props[prop].required) {
	            accProps.push(prop);
	        }
	        return accProps;
	    }, []);
	    return acc;
	}, {});
	
	/**
	 * @param {String} triggerType
	 * @returns {Object}
	 */
	var getTriggerPayload = exports.getTriggerPayload = function getTriggerPayload(triggerType) {
	    return (TRIGGER_PAYLOAD[triggerType] || []).reduce(function (acc, cur) {
	        acc[cur] = cur;
	        return acc;
	    }, {});
	};

/***/ },
/* 1825 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/enet_event_incident",
		"type": "object",
		"properties": {
			"eventId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"homeId": {
				"type": "integer",
				"required": true
			},
			"awayId": {
				"type": "integer",
				"required": true
			},
			"incidentId": {
				"type": "integer",
				"required": true
			},
			"debug": {
				"type": "object",
				"properties": {
					"name": {
						"type": "string"
					},
					"created": {
						"type": "date-time"
					},
					"eventVersion": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 1826 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/enet_event_match_day",
		"type": "object",
		"properties": {
			"sportId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"eventId": {
				"type": "integer",
				"required": true
			},
			"homeId": {
				"type": "integer",
				"required": true
			},
			"awayId": {
				"type": "integer",
				"required": true
			}
		}
	};

/***/ },
/* 1827 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/enet_event_status",
		"type": "object",
		"properties": {
			"eventId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"homeId": {
				"type": "integer",
				"required": true
			},
			"awayId": {
				"type": "integer",
				"required": true
			},
			"statusFull": {
				"type": "string",
				"required": true
			},
			"statusType": {
				"type": "string",
				"required": true
			},
			"debug": {
				"type": "object",
				"properties": {
					"name": {
						"type": "string"
					},
					"created": {
						"type": "date-time"
					},
					"eventVersion": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 1828 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/event_finished",
		"type": "object",
		"properties": {
			"sportId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"eventId": {
				"type": "integer",
				"required": true
			},
			"minutes": {
				"type": "integer",
				"required": true
			}
		}
	};

/***/ },
/* 1829 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/event_halftime",
		"type": "object",
		"properties": {
			"sportId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"eventId": {
				"type": "integer",
				"required": true
			},
			"minutes": {
				"type": "integer",
				"required": true
			}
		}
	};

/***/ },
/* 1830 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/event_test",
		"type": "object",
		"properties": {
			"eventId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"minutes": {
				"type": "integer",
				"required": false
			}
		}
	};

/***/ },
/* 1831 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/event_starts",
		"type": "object",
		"properties": {
			"sportId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"eventId": {
				"type": "integer",
				"required": true
			},
			"minutes": {
				"type": "integer",
				"required": true
			}
		}
	};

/***/ },
/* 1832 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/schedule"
	};

/***/ },
/* 1833 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/time"
	};

/***/ },
/* 1834 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/tourn_match_day",
		"type": "object",
		"properties": {
			"countryId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"seasonId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"eventIds": {
				"required": true,
				"type": "array",
				"items": {
					"type": "integer"
				}
			}
		}
	};

/***/ },
/* 1835 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/tourn_round_starts",
		"type": "object",
		"properties": {
			"countryId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"seasonId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"round": {
				"type": "string",
				"required": true
			},
			"eventIds": {
				"required": true,
				"type": "array",
				"items": {
					"type": "integer"
				}
			}
		}
	};

/***/ },
/* 1836 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/tourn_round_ends",
		"type": "object",
		"properties": {
			"countryId": {
				"type": "integer",
				"required": true
			},
			"tournamentId": {
				"type": "integer",
				"required": true
			},
			"seasonId": {
				"type": "integer",
				"required": true
			},
			"sportId": {
				"type": "integer",
				"required": true
			},
			"round": {
				"type": "string",
				"required": true
			},
			"eventIds": {
				"required": true,
				"type": "array",
				"items": {
					"type": "integer"
				}
			}
		}
	};

/***/ },
/* 1837 */
/***/ function(module, exports) {

	module.exports = {
		"id": "/transfer",
		"properties": {
			"transferId": {
				"type": "integer",
				"required": true
			},
			"playerId": {
				"type": "integer",
				"required": true
			},
			"fromTeamId": {
				"type": "integer",
				"required": true
			},
			"toTeamId": {
				"type": "integer",
				"required": true
			},
			"fromTournamentTemplateId": {
				"type": "integer",
				"required": true
			},
			"toTournamentTemplateId": {
				"type": "integer",
				"required": true
			}
		}
	};

/***/ },
/* 1838 */
/***/ function(module, exports) {

	module.exports = [
		{
			"trigger": "enet_event_incident",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "homeId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Home team Id"
				},
				{
					"name": "awayId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Away team Id"
				},
				{
					"name": "incident_type",
					"picker": "enum_picker",
					"data_type": "enum",
					"label": "Incident type",
					"values": [
						{
							"label": "All",
							"value": "*"
						},
						{
							"label": "Goal",
							"value": "goal"
						},
						{
							"label": "Yellow Card",
							"value": "yellow_card"
						},
						{
							"label": "Red Card",
							"value": "red_card"
						},
						{
							"label": "Substitution",
							"value": "substitution"
						},
						{
							"label": "Assist",
							"value": "assist"
						},
						{
							"label": "Goal Cancelled",
							"value": "goal_cancelled"
						}
					]
				}
			]
		},
		{
			"trigger": "enet_event_status",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "homeId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Home team Id"
				},
				{
					"name": "awayId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Away team Id"
				},
				{
					"name": "status",
					"label": "Status",
					"picker": "enum_picker",
					"data_type": "enum",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Match started",
							"value": "1st_half"
						},
						{
							"label": "Halftime",
							"value": "halftime"
						},
						{
							"label": "2nd half started",
							"value": "2nd_half"
						},
						{
							"label": "Extra Time - 1st half",
							"value": "et_1st_half"
						},
						{
							"label": "Extra Time - 2nd half",
							"value": "et_2nd_half"
						},
						{
							"label": "Penalty",
							"value": "penalty"
						},
						{
							"label": "Finished",
							"value": "finished"
						}
					]
				}
			]
		},
		{
			"trigger": "enet_event_match_day",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "homeId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Home team Id"
				},
				{
					"name": "awayId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Away team Id"
				}
			]
		},
		{
			"trigger": "schedule",
			"conditions": [
				{
					"name": "time",
					"label": "Time",
					"picker": "time_picker",
					"data_type": "time",
					"required": true
				}
			]
		},
		{
			"trigger": "time",
			"conditions": [
				{
					"name": "dateTime",
					"label": "Date time",
					"picker": "dateTime_picker",
					"data_type": "dateTime",
					"required": true
				}
			]
		},
		{
			"trigger": "enet_event_live_minute",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "homeId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Home team Id"
				},
				{
					"name": "awayId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Away team Id"
				},
				{
					"name": "minutes",
					"label": "Minutes",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		},
		{
			"trigger": "enet_event_lineup_confirmed",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "homeId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Home team Id"
				},
				{
					"name": "awayId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "Away team Id"
				},
				{
					"name": "incident_type",
					"picker": "enum_picker",
					"data_type": "enum",
					"label": "type",
					"values": [
						{
							"label": "Confirmed",
							"value": "confirmed"
						}
					]
				}
			]
		},
		{
			"trigger": "tourn_match_day",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "time",
					"label": "Time",
					"picker": "time_picker",
					"data_type": "time",
					"required": true
				}
			]
		},
		{
			"trigger": "event_days_before_at",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "days",
					"label": "Days",
					"picker": "number_picker",
					"data_type": "number"
				},
				{
					"name": "time",
					"label": "Time",
					"picker": "time_picker",
					"data_type": "time",
					"required": true
				}
			]
		},
		{
			"trigger": "event_hours_before",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "hours",
					"label": "Hours",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		},
		{
			"trigger": "tourn_round_starts",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "round",
					"label": "Round",
					"picker": "round_picker",
					"data_type": "string"
				},
				{
					"name": "time",
					"label": "Time",
					"picker": "time_picker",
					"data_type": "time",
					"required": true
				}
			]
		},
		{
			"trigger": "tourn_round_ends",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "round",
					"label": "Round",
					"picker": "round_picker",
					"data_type": "string"
				},
				{
					"name": "time",
					"label": "Time",
					"picker": "time_picker",
					"data_type": "time",
					"required": true
				}
			]
		},
		{
			"trigger": "event_starts",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "minutes",
					"label": "Minutes",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		},
		{
			"trigger": "event_halftime",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "minutes",
					"label": "Minutes",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		},
		{
			"trigger": "event_finished",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "minutes",
					"label": "Minutes",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		},
		{
			"trigger": "transfer",
			"conditions": [
				{
					"name": "type",
					"picker": "enum_picker",
					"data_type": "string",
					"label": "Type",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Transfer/confirmed",
							"value": "transfer"
						},
						{
							"label": "Rumour",
							"value": "rumour"
						}
					]
				},
				{
					"name": "fromTTId",
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "From Tournament",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "toTTId",
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "To Tournament",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "fromTeamId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "From team Id"
				},
				{
					"name": "toTeamId",
					"picker": "team_picker",
					"data_type": "number",
					"label": "To team Id"
				},
				{
					"name": "playerId",
					"picker": "player_picker",
					"data_type": "number",
					"label": "Player id"
				}
			]
		},
		{
			"trigger": "event_test",
			"conditions": [
				{
					"name": "sportId",
					"picker": "enum_picker",
					"data_type": "number",
					"label": "Sport",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "Soccer",
							"value": "1"
						},
						{
							"label": "Handball",
							"value": "20"
						},
						{
							"label": "Basket",
							"value": "23"
						},
						{
							"label": "Tennis",
							"value": "2"
						},
						{
							"label": "Hockey",
							"value": "5"
						}
					]
				},
				{
					"name": "ttId",
					"required": true,
					"picker": "tournament_picker",
					"data_type": "number",
					"label": "Tournament Id",
					"values": [
						{
							"label": "Any",
							"value": "*"
						},
						{
							"label": "ALKA Superliga",
							"value": "46"
						},
						{
							"label": "Premier League",
							"value": "47"
						},
						{
							"label": "Spain Primera",
							"value": "87"
						},
						{
							"label": "Bundesliga",
							"value": "54"
						},
						{
							"label": "UEFA Champions League",
							"value": "42"
						},
						{
							"label": "UEFA Europa League",
							"value": "73"
						},
						{
							"label": "Sweden Allsvenskan",
							"value": "67"
						},
						{
							"label": "Norway Eliteserien",
							"value": "59"
						}
					]
				},
				{
					"name": "eventId",
					"label": "Event ID",
					"picker": "event_by_date_picker",
					"data_type": "number"
				},
				{
					"name": "minutes",
					"label": "Minutes",
					"picker": "number_picker",
					"data_type": "number"
				}
			]
		}
	];

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
	
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _info = __webpack_require__(1085);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _checkCircle = __webpack_require__(973);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _highlightOff = __webpack_require__(1840);
	
	var _highlightOff2 = _interopRequireDefault(_highlightOff);
	
	var _timer = __webpack_require__(1841);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	var _notificationsNone = __webpack_require__(1842);
	
	var _notificationsNone2 = _interopRequireDefault(_notificationsNone);
	
	var _cast = __webpack_require__(1843);
	
	var _cast2 = _interopRequireDefault(_cast);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _googleTimezonesJson = __webpack_require__(1844);
	
	var _googleTimezonesJson2 = _interopRequireDefault(_googleTimezonesJson);
	
	var _constants = __webpack_require__(579);
	
	var _RulesArray = __webpack_require__(1846);
	
	var _RulesArray2 = _interopRequireDefault(_RulesArray);
	
	var _SMLinkManager = __webpack_require__(1095);
	
	var _SMLinkManager2 = _interopRequireDefault(_SMLinkManager);
	
	var _helpers = __webpack_require__(1821);
	
	var _Error = __webpack_require__(1866);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _validation = __webpack_require__(1660);
	
	var _TargetsForm = __webpack_require__(1868);
	
	var _TargetsForm2 = _interopRequireDefault(_TargetsForm);
	
	var _NotificationsForm = __webpack_require__(1869);
	
	var _NotificationsForm2 = _interopRequireDefault(_NotificationsForm);
	
	var _REmojiPicker = __webpack_require__(1865);
	
	var _REmojiPicker2 = _interopRequireDefault(_REmojiPicker);
	
	var _enhancers = __webpack_require__(1785);
	
	var _actions = __webpack_require__(1047);
	
	var _smlinks = __webpack_require__(1107);
	
	var _ui = __webpack_require__(574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var timezoneKeys = Object.keys(_googleTimezonesJson2.default);
	
	var iconStyle = {
	    width: 40,
	    height: 40,
	    color: '#3f51b5'
	};
	
	var yCenterXSpaceBetween = _extends({}, _helpers.yCenter, { justifyContent: 'space-between', width: 300 });
	
	var TemplatesForm = function TemplatesForm(_ref) {
	    var _ref$templates = _ref.templates,
	        templates = _ref$templates === undefined ? [] : _ref$templates;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reduxForm.Field,
	            {
	                name: _constants.CAMPAIGN_FORM_KEYS.TEMPLATE,
	                floatingLabelText: 'Template',
	                style: { width: '300px' },
	                validate: _validation.presence,
	                component: _reduxFormMaterialUi.SelectField
	            },
	            templates.filter(function (t) {
	                return !t.isHidden;
	            }).map(function (t) {
	                return _react2.default.createElement(_materialUi.MenuItem, { key: t.id, primaryText: t.name, value: t.id });
	            })
	        )
	    );
	};
	
	var TargetsFormEnhanced = (0, _enhancers.withTargetsFormProps)(_TargetsForm2.default);
	var TemplatesFormEnhanced = (0, _enhancers.withTemplates)(TemplatesForm);
	var ActiveLabelEnhanced = (0, _enhancers.withActiveFormProps)(_helpers.ActiveLabel);
	
	var errSelect = function errSelect(state) {
	    var value = _lodash2.default.get((0, _reduxForm.getFormSubmitErrors)(_constants.CAMPAIGN_FORM_ID)(state), '_error_');
	    return { value: value };
	};
	var ErrorEnhanced = (0, _reactRedux.connect)(errSelect)(_Error2.default);
	
	var ClearButton = (0, _reactRedux.connect)(function (state, _ref2) {
	    var name = _ref2.name;
	    return {
	        clear: !(0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, name)
	    };
	}, function (dispatch, _ref3) {
	    var name = _ref3.name;
	    return {
	        onClick: function onClick() {
	            return dispatch((0, _reduxForm.change)(_constants.CAMPAIGN_FORM_ID, name, ''));
	        }
	    };
	})(function (_ref4) {
	    var clear = _ref4.clear,
	        onClick = _ref4.onClick,
	        rest = _objectWithoutProperties(_ref4, ['clear', 'onClick']);
	
	    return clear ? null : _react2.default.createElement(
	        _materialUi.IconButton,
	        _extends({}, rest, { onTouchTap: onClick }),
	        _react2.default.createElement(_highlightOff2.default, null)
	    );
	});
	
	var TimezoneFastSelect = function TimezoneFastSelect(_ref5) {
	    var onChange = _ref5.onChange;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _constants.TIMEZONE_BUTTONS.map(function (key) {
	            return _react2.default.createElement(_materialUi.FlatButton, { key: key, onTouchTap: function onTouchTap() {
	                    return onChange(key);
	                }, label: _googleTimezonesJson2.default[key] });
	        })
	    );
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onChange: function onChange(timezone) {
	            dispatch((0, _reduxForm.change)(_constants.CAMPAIGN_FORM_ID, _constants.CAMPAIGN_FORM_KEYS.TIMEZONE, timezone));
	        }
	    };
	};
	var TimezoneFastSelectEnhanced = (0, _reactRedux.connect)(null, mapDispatchToProps)(TimezoneFastSelect);
	
	var SMLinkCreate = function SMLinkCreate(_ref6) {
	    var open = _ref6.open,
	        onOpen = _ref6.onOpen,
	        onClose = _ref6.onClose;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'a',
	            {
	                style: {
	                    color: 'rgb(63, 81, 181)',
	                    cursor: 'pointer',
	                    fontSize: 14,
	                    textDecoration: 'underline'
	                },
	                onClick: onOpen
	            },
	            'Link social account'
	        ),
	        _react2.default.createElement(
	            _materialUi.Dialog,
	            { open: open, onRequestClose: onClose },
	            _react2.default.createElement(_SMLinkManager2.default, null)
	        )
	    );
	};
	
	var mapStateToPropsSMLinkCreate = function mapStateToPropsSMLinkCreate(state) {
	    return {
	        open: Boolean(state.ui.smlinkDialogOpen)
	    };
	};
	var mapDispatchToPropsSMLinkCreate = function mapDispatchToPropsSMLinkCreate(dispatch) {
	    return {
	        onOpen: function onOpen() {
	            return dispatch({
	                type: _ui.UI_ACTIONS.CHANGE,
	                key: 'smlinkDialogOpen',
	                value: true
	            });
	        },
	        onClose: function onClose() {
	            return dispatch({
	                type: _ui.UI_ACTIONS.CHANGE,
	                key: 'smlinkDialogOpen',
	                value: false
	            });
	        }
	    };
	};
	var SMLinkCreateEnhanced = (0, _reactRedux.connect)(mapStateToPropsSMLinkCreate, mapDispatchToPropsSMLinkCreate)(SMLinkCreate);
	
	var InfoForm = function InfoForm() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reduxForm.Field, {
	            name: _constants.CAMPAIGN_FORM_KEYS.TITLE,
	            validate: _validation.presence,
	            floatingLabelText: 'Enter campaign name',
	            component: _reduxFormMaterialUi.TextField
	        }),
	        _react2.default.createElement(
	            'div',
	            { style: { display: 'flex' } },
	            _react2.default.createElement(
	                _reduxForm.Field,
	                {
	                    name: _constants.CAMPAIGN_FORM_KEYS.LANGUAGE,
	                    floatingLabelText: 'Language',
	                    component: _reduxFormMaterialUi.SelectField,
	                    style: { width: '30%' }
	                },
	                _constants.LANGUAGES.map(function (lang) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: lang.key, primaryText: lang.name, value: lang.key });
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { width: '70%' } },
	                _react2.default.createElement(
	                    _reduxForm.Field,
	                    {
	                        name: _constants.CAMPAIGN_FORM_KEYS.TIMEZONE,
	                        floatingLabelText: 'Timezone',
	                        style: { width: '300px' },
	                        validate: _validation.presence,
	                        component: _reduxFormMaterialUi.SelectField
	                    },
	                    timezoneKeys.map(function (key) {
	                        return _react2.default.createElement(_materialUi.MenuItem, { key: key, primaryText: _googleTimezonesJson2.default[key], value: key });
	                    })
	                ),
	                _react2.default.createElement(TimezoneFastSelectEnhanced, null)
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_REmojiPicker2.default, { name: 'defaultMessage', floatingLabelText: 'Default post message', multiLine: true })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_REmojiPicker2.default, { name: 'signature', floatingLabelText: 'Signature (hashtags)' })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { style: { width: 150, marginTop: 16, marginBottom: 16 } },
	                _react2.default.createElement(_reduxForm.Field, { label: 'Calendar', name: _constants.CAMPAIGN_FORM_KEYS.CALENDAR, component: _reduxFormMaterialUi.Toggle })
	            )
	        )
	    );
	};
	
	var onStartDateChange = function onStartDateChange(startDate) {
	    return function (dispatch, getState) {
	        if (startDate) {
	            var endDate = (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(getState(), 'endDate');
	            if (endDate && (0, _moment2.default)(endDate).diff((0, _moment2.default)(startDate), 'days') <= 0) {
	                dispatch((0, _reduxForm.change)(_constants.CAMPAIGN_FORM_ID, 'endDate', ''));
	            }
	        }
	    };
	};
	
	var ActiveForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        startDate: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, 'startDate'),
	        timezone: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, 'timezone')
	    };
	}, function (dispatch) {
	    return {
	        onStartChange: function onStartChange(val) {
	            return dispatch(onStartDateChange(val));
	        }
	    };
	})(function (_ref7) {
	    var startDate = _ref7.startDate,
	        onStartChange = _ref7.onStartChange;
	
	    var minDateEnd = startDate ? (0, _moment2.default)(startDate).add(1, 'days').toDate() : new Date();
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { width: 150 } },
	            _react2.default.createElement(_reduxForm.Field, { name: _constants.CAMPAIGN_FORM_KEYS.ACTIVE, label: 'Active', component: _reduxFormMaterialUi.Toggle })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: yCenterXSpaceBetween },
	            _react2.default.createElement(_reduxForm.Field, {
	                name: _constants.CAMPAIGN_FORM_KEYS.START_DATE,
	                floatingLabelText: 'Start',
	                format: _helpers.formatDate,
	                onChange: function onChange(e, val) {
	                    return onStartChange(val);
	                },
	                style: { width: 100 },
	                textFieldStyle: { width: '100%' },
	                component: _reduxFormMaterialUi.DatePicker
	            }),
	            _react2.default.createElement(ClearButton, { name: 'startDate', style: { marginTop: 24 } }),
	            _react2.default.createElement(_reduxForm.Field, {
	                name: _constants.CAMPAIGN_FORM_KEYS.END_DATE,
	                floatingLabelText: 'End',
	                format: _helpers.formatDate,
	                minDate: minDateEnd,
	                style: { width: 100, marginLeft: 24 },
	                textFieldStyle: { width: '100%' },
	                component: _reduxFormMaterialUi.DatePicker
	            }),
	            _react2.default.createElement(ClearButton, { name: 'endDate', style: { marginTop: 24 } })
	        )
	    );
	});
	
	var CampaignForm = function (_React$Component) {
	    _inherits(CampaignForm, _React$Component);
	
	    function CampaignForm() {
	        var _ref8;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CampaignForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref8 = CampaignForm.__proto__ || Object.getPrototypeOf(CampaignForm)).call.apply(_ref8, [this].concat(args))), _this), _this.onSubmitTap = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _reduxForm.submit)(_constants.CAMPAIGN_FORM_ID));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CampaignForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var client = this.context.user.client;
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _smlinks.fetchSmlinks)());
	            dispatch((0, _actions.fetchWidgetSpecs)(client));
	            dispatch((0, _actions.fetchTemplates)());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(ErrorEnhanced, null),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_info2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'h4',
	                            { style: (0, _helpers.marginLeft)() },
	                            'Campaign info'
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(InfoForm, null)
	                }),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_info2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'h4',
	                            { style: (0, _helpers.marginLeft)() },
	                            'Templates'
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(TemplatesFormEnhanced, null)
	                }),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_notificationsNone2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'h4',
	                            { style: (0, _helpers.marginLeft)() },
	                            'Notifications'
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '50%' } },
	                            _react2.default.createElement(_NotificationsForm2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { width: 150, marginTop: 12 } },
	                                _react2.default.createElement(_reduxForm.Field, { label: 'Moderated', name: _constants.CAMPAIGN_FORM_KEYS.MODERATION, component: _reduxFormMaterialUi.Toggle })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    width: '50%',
	                                    color: 'rgba(0, 0, 0, 0.4)',
	                                    padding: 24
	                                }
	                            },
	                            _react2.default.createElement(
	                                'i',
	                                null,
	                                'Created posts will NOT be published until manual approval.'
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'i',
	                                null,
	                                'Subscribers will be notified about all new posts required moderation.'
	                            )
	                        )
	                    )
	                }),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_cast2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { style: (0, _helpers.marginLeft)() },
	                                'Social Media Channels'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginLeft: 12 } },
	                                _react2.default.createElement(SMLinkCreateEnhanced, null)
	                            )
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(TargetsFormEnhanced, null)
	                }),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_checkCircle2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: (0, _helpers.marginLeft)() },
	                            _react2.default.createElement(ActiveLabelEnhanced, null)
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(ActiveForm, null)
	                }),
	                _react2.default.createElement(_helpers.RowSection, {
	                    leftContent: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_timer2.default, { style: iconStyle }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: (0, _helpers.marginLeft)() },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Rules & triggers'
	                            )
	                        )
	                    ),
	                    rightContent: _react2.default.createElement(_reduxForm.FieldArray, { name: _constants.CAMPAIGN_FORM_KEYS.RULES.ARRAY, component: _RulesArray2.default })
	                })
	            );
	        }
	    }]);
	
	    return CampaignForm;
	}(_react2.default.Component);
	
	CampaignForm.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	
	
	CampaignForm.propTypes = {
	    dispatch: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)()(CampaignForm);

/***/ },
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _modeEdit = __webpack_require__(1383);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _pause = __webpack_require__(1847);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _FormWizzard = __webpack_require__(1848);
	
	var _FormWizzard2 = _interopRequireDefault(_FormWizzard);
	
	var _selectors = __webpack_require__(618);
	
	var _constants = __webpack_require__(579);
	
	var _Error = __webpack_require__(1866);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _ReadableCondition = __webpack_require__(1867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dialogContentStyle = {
	    width: '90%',
	    maxWidth: 'none'
	};
	
	var errSelect = function errSelect(state) {
	    var value = _lodash2.default.get((0, _reduxForm.getFormSyncErrors)(_constants.CAMPAIGN_FORM_ID)(state), 'rules');
	    return { value: value };
	};
	var ErrorEnhanced = (0, _reactRedux.connect)(errSelect)(_Error2.default);
	
	var WizzardErrorEnhanced = (0, _reactRedux.connect)(function (state) {
	    return {
	        value: (0, _reduxForm.hasSubmitFailed)(_constants.WIZZARD_FORM_ID)(state) ? (0, _reduxForm.getFormSyncErrors)(_constants.WIZZARD_FORM_ID)(state) : null
	    };
	})(_Error2.default);
	
	var TRGR_FORM_KEY = _constants.CAMPAIGN_FORM_KEYS.RULES.KEY;
	var PRES_NAME = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.NAME;
	
	/**
	 * Redux form component
	 */
	
	var RulesArray = function (_React$Component) {
	    _inherits(RulesArray, _React$Component);
	
	    function RulesArray(props, ctx) {
	        _classCallCheck(this, RulesArray);
	
	        var _this = _possibleConstructorReturn(this, (RulesArray.__proto__ || Object.getPrototypeOf(RulesArray)).call(this, props, ctx));
	
	        _this.onPopoverOpen = function (fieldName) {
	            return function (event) {
	                event.preventDefault();
	                _this.setState({
	                    popoverSelected: fieldName,
	                    anchorEl: event.currentTarget
	                });
	            };
	        };
	
	        _this.onPopoverClose = function () {
	            return _this.setState({ popoverSelected: null });
	        };
	
	        _this.onRuleEdit = function (name, index) {
	            var values = _this.props.values;
	
	            _this.onPopoverClose();
	            _this.openDialog(index);
	            _this.props.dispatch((0, _reduxForm.initialize)(_constants.WIZZARD_FORM_ID, values[index]));
	        };
	
	        _this.onRuleRemove = function (index) {
	            var fields = _this.props.fields;
	
	            fields.remove(index);
	            _this.onPopoverClose();
	        };
	
	        _this.onRuleAdd = function () {
	            var fields = _this.props.fields;
	
	            var selectedIndex = fields.length;
	            _this.openDialog(selectedIndex);
	        };
	
	        _this.openDialog = function (selectedIndex) {
	            _this.setState({ open: true, selectedIndex: selectedIndex });
	        };
	
	        _this.onRuleSave = function (value) {
	            var selectedIndex = _this.state.selectedIndex;
	            var name = _this.props.fields.name;
	
	            _this.props.dispatch((0, _reduxForm.change)(_constants.CAMPAIGN_FORM_ID, name + '.' + selectedIndex, value));
	            _this.closeDialog();
	        };
	
	        _this.onCloseDialog = function () {
	            var wizzardIsPristine = _this.props.wizzardIsPristine;
	
	            if (wizzardIsPristine) {
	                _this.closeDialog();
	            } else {
	                _this.setState({ showAlert: true });
	            }
	        };
	
	        _this.closeDialog = function () {
	            var dispatch = _this.props.dispatch;
	
	            _this.setState({ open: false, selectedIndex: null, showAlert: false });
	            dispatch((0, _reduxForm.destroy)(_constants.WIZZARD_FORM_ID));
	        };
	
	        _this.renderActionsCell = function (field, index) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { onTouchTap: _this.onPopoverOpen(field) },
	                    _react2.default.createElement(_moreVert2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: _this.state.popoverSelected === field,
	                        onRequestClose: _this.onPopoverClose,
	                        anchorEl: _this.state.anchorEl,
	                        anchorOrigin: {
	                            horizontal: 'left',
	                            vertical: 'bottom'
	                        },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' }
	                    },
	                    _react2.default.createElement(
	                        _materialUi.Menu,
	                        null,
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            primaryText: 'Edit',
	                            leftIcon: _react2.default.createElement(_modeEdit2.default, null),
	                            onTouchTap: function onTouchTap() {
	                                return _this.onRuleEdit(field, index);
	                            }
	                        }),
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            onTouchTap: _this.onRuleRemove.bind(_this, index),
	                            leftIcon: _react2.default.createElement(_delete2.default, null),
	                            primaryText: 'Delete'
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.renderTable = function () {
	            var _this$props = _this.props,
	                fields = _this$props.fields,
	                values = _this$props.values;
	
	            if (!fields || !values) {
	                return null;
	            }
	            return _react2.default.createElement(
	                _materialUi.Table,
	                { selectable: false },
	                _react2.default.createElement(
	                    _materialUi.TableHeader,
	                    { displaySelectAll: false, adjustForCheckbox: false },
	                    _react2.default.createElement(
	                        _materialUi.TableRow,
	                        null,
	                        _react2.default.createElement(
	                            _materialUi.TableHeaderColumn,
	                            null,
	                            'Widget'
	                        ),
	                        _react2.default.createElement(
	                            _materialUi.TableHeaderColumn,
	                            { style: { width: 500 } },
	                            'Conditions'
	                        ),
	                        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { width: 72 } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.TableBody,
	                    { displayRowCheckbox: false },
	                    fields.map(function (field, index) {
	                        var rule = values[index];
	                        var triggerType = _lodash2.default.get(rule, TRGR_FORM_KEY);
	                        return _react2.default.createElement(
	                            _materialUi.TableRow,
	                            { key: index },
	                            _react2.default.createElement(
	                                _materialUi.TableRowColumn,
	                                { style: { whiteSpace: 'normal' } },
	                                _react2.default.createElement(
	                                    'span',
	                                    {
	                                        style: {
	                                            marginLeft: -8,
	                                            display: 'inline-block',
	                                            borderLeft: '3px solid #e0e0e0',
	                                            paddingLeft: 5
	                                        }
	                                    },
	                                    _lodash2.default.get(rule, PRES_NAME).split(/(?=[A-Z])/).join(' ')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _materialUi.TableRowColumn,
	                                { style: { width: 500 } },
	                                _lodash2.default.get(rule, 'conditions', []).map(function (condition, cindex, arr) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            key: cindex,
	                                            style: {
	                                                marginTop: 4,
	                                                marginBottom: 4
	                                            }
	                                        },
	                                        _react2.default.createElement(_ReadableCondition.ReadableCondition, { condition: condition, triggerType: triggerType }),
	                                        cindex + 1 < arr.length && _react2.default.createElement(_materialUi.Divider, null)
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _materialUi.TableRowColumn,
	                                { style: { width: 72 } },
	                                _this.renderActionsCell(field, index)
	                            )
	                        );
	                    })
	                )
	            );
	        };
	
	        _this.renderAlertDialog = function () {
	            return _react2.default.createElement(
	                _materialUi.Dialog,
	                {
	                    open: _this.state.showAlert,
	                    title: 'Alert',
	                    actions: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_materialUi.FlatButton, { onTouchTap: function onTouchTap() {
	                                return _this.setState({ showAlert: false });
	                            }, label: 'Cancel' }),
	                        _react2.default.createElement(_materialUi.FlatButton, { secondary: true, onTouchTap: _this.closeDialog, label: 'Ok' })
	                    )
	                },
	                'All the data will not be saved.'
	            );
	        };
	
	        _this.state = {
	            popoverSelected: null,
	            open: false,
	            selectedIndex: null,
	            showAlert: false
	        };
	        return _this;
	    }
	
	    _createClass(RulesArray, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(ErrorEnhanced, null)
	                ),
	                !this.props.fields.length && _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            fontSize: '0.9em',
	                            color: 'rgba(0, 0, 0, 0.4)',
	                            margin: '12px 16px'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        'No rules'
	                    )
	                ),
	                this.renderTable(),
	                _react2.default.createElement(_materialUi.FlatButton, { primary: true, label: 'Add rule', onTouchTap: this.onRuleAdd, icon: _react2.default.createElement(_add2.default, null) }),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        onRequestClose: this.onCloseDialog,
	                        open: this.state.open,
	                        contentStyle: dialogContentStyle,
	                        className: 'no-padding-dialog',
	                        autoScrollBodyContent: true,
	                        repositionOnUpdate: true,
	                        autoDetectWindowHeight: true
	                    },
	                    _react2.default.createElement(WizzardErrorEnhanced, null),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '400px' } },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Widget preview (with fake data)'
	                            ),
	                            _react2.default.createElement(WidgetPreviewEnhanced, null)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { flexGrow: 1 } },
	                            _react2.default.createElement(_FormWizzard2.default, { onSave: this.onRuleSave })
	                        )
	                    )
	                ),
	                this.renderAlertDialog()
	            );
	        }
	    }]);
	
	    return RulesArray;
	}(_react2.default.Component);
	
	var mapPropsToWidgetParams = function mapPropsToWidgetParams(props) {
	    return Object.keys(props).reduce(function (acc, cur) {
	        var key = 'data-' + _lodash2.default.kebabCase(cur);
	        acc[key] = props[cur];
	        return acc;
	    }, {});
	};
	
	var getExampleParams = function getExampleParams(widgetName, widgets) {
	    if (!widgetName || !Array.isArray(widgets)) {
	        return {};
	    }
	    var widget = widgets.find(function (w) {
	        return w.id === widgetName;
	    });
	    if (!widget) {
	        return {};
	    }
	    var demo = widget.spec.demo;
	    var props = demo[0].props;
	
	    var additional = mapPropsToWidgetParams(props);
	    return _extends({
	        'data-name': widgetName
	    }, additional);
	};
	
	var WidgetPreview = function WidgetPreview(_ref) {
	    var widgetName = _ref.widgetName,
	        user = _ref.user,
	        widgets = _ref.widgets,
	        template = _ref.template,
	        additional = _ref.additional;
	
	    if (!widgetName) {
	        return _react2.default.createElement(
	            'p',
	            null,
	            'No widget selected'
	        );
	    }
	    var widgetParameters = getExampleParams(widgetName, widgets);
	    var userParams = (additional || []).reduce(function (acc, cur) {
	        if (!cur.byTrigger && cur.customValue) {
	            acc[cur.key] = cur.customValue;
	        }
	        return acc;
	    }, {});
	    if (template) {
	        userParams.template = template;
	    }
	    var resultParams = _extends({}, widgetParameters, mapPropsToWidgetParams(userParams));
	    return _react2.default.createElement(
	        'div',
	        { style: { width: '400px' } },
	        _react2.default.createElement('rlz-widget', _extends({
	            key: JSON.stringify({ resultParams: resultParams }),
	            'data-client': user.client,
	            'data-user': user.username,
	            'data-token': user.accessToken,
	            'data-load': 'sm'
	        }, resultParams, {
	            'data-zoom': 0.5
	        }))
	    );
	};
	
	var wizzardSelector = (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID);
	var mapStateToPreviewProps = function mapStateToPreviewProps(state) {
	    return {
	        user: state.user,
	        widgetName: wizzardSelector(state, 'presentation.name'),
	        template: wizzardSelector(state, 'presentation.params.template'),
	        additional: wizzardSelector(state, 'presentation.additional'),
	        widgets: _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS], 'widgets')
	    };
	};
	
	var WidgetPreviewEnhanced = (0, _reactRedux.connect)(mapStateToPreviewProps)(WidgetPreview);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        values: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, _constants.CAMPAIGN_FORM_KEYS.RULES.ARRAY),
	        wizzardIsPristine: (0, _reduxForm.isPristine)(_constants.WIZZARD_FORM_ID)(state)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(RulesArray);

/***/ },
/* 1847 */,
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _RuleForm = __webpack_require__(1849);
	
	var _WidgetForm = __webpack_require__(1859);
	
	var _WidgetForm2 = _interopRequireDefault(_WidgetForm);
	
	var _ParamsCuztomizer = __webpack_require__(1860);
	
	var _ParamsCuztomizer2 = _interopRequireDefault(_ParamsCuztomizer);
	
	var _MessageTemplateArray = __webpack_require__(1861);
	
	var _MessageTemplateArray2 = _interopRequireDefault(_MessageTemplateArray);
	
	var _selectors = __webpack_require__(618);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _withFeature = __webpack_require__(1864);
	
	var _withFeature2 = _interopRequireDefault(_withFeature);
	
	var _REmojiPicker = __webpack_require__(1865);
	
	var _REmojiPicker2 = _interopRequireDefault(_REmojiPicker);
	
	var _schema = __webpack_require__(1823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// eslint-disable-next-line
	
	
	var F = _constants.CAMPAIGN_FORM_KEYS;
	
	var MessagePreview = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaignMessage: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, 'defaultMessage'),
	        campaignSignature: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, 'signature'),
	        ruleMessage: (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID)(state, 'message'),
	        ruleSignature: (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID)(state, 'signature')
	    };
	})(function (_ref) {
	    var campaignMessage = _ref.campaignMessage,
	        ruleMessage = _ref.ruleMessage,
	        campaignSignature = _ref.campaignSignature,
	        ruleSignature = _ref.ruleSignature;
	
	    var message = ruleMessage || campaignMessage;
	    var signature = ruleSignature || campaignSignature;
	    var result = [message, signature].filter(function (el) {
	        return el;
	    }).join(' ');
	    return result ? _react2.default.createElement(
	        'span',
	        null,
	        'Message would be: ',
	        result
	    ) : _react2.default.createElement(
	        'span',
	        null,
	        'No text message is provided'
	    );
	});
	
	var mapStateToProps = function mapStateToProps(state) {
	    var widgetSpecs = (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS];
	    var widgets = _lodash2.default.get(widgetSpecs, 'widgets');
	    return {
	        widgets: widgets,
	        templates: (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.TEMPLATES]
	    };
	};
	var WidgetFormEnhanced = (0, _reactRedux.connect)(mapStateToProps)(_WidgetForm2.default);
	
	var initializeAdditionalWidgetParams = function initializeAdditionalWidgetParams(widgetName, triggerType) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var widgets = _lodash2.default.get((0, _selectors.getEntities)(state), 'widget-specs.widgets', []);
	        var widget = widgets.find(function (w) {
	            return w.id === widgetName;
	        });
	        if (widget) {
	            var propTypes = widget.spec.propTypes;
	
	            if (Array.isArray(propTypes)) {
	                var widgetProperties = propTypes.filter(function (prop) {
	                    return prop.key !== 'template';
	                });
	                var triggerPayloadMap = (0, _triggerConstants.getTriggerPayload)(triggerType);
	                var initValue = (0, _schema.getWidgetParamsInitValue)(widgetProperties, triggerPayloadMap);
	                var path = F.WIDGET.SECTION + '.' + F.WIDGET.PARAMS.ADDITIONAL.ARRAY;
	                dispatch((0, _reduxForm.unregisterField)(_constants.WIZZARD_FORM_ID, path));
	                dispatch((0, _reduxForm.change)(_constants.WIZZARD_FORM_ID, path, initValue));
	            }
	        }
	        dispatch((0, _reduxForm.change)(_constants.WIZZARD_FORM_ID, 'messageTemplateIds', []));
	    };
	};
	
	var SOCCER_SPORT_ID = '1';
	
	var LAST_STEP_INDEX = 3;
	
	var MessageTemplateForm = function MessageTemplateForm() {
	    return _react2.default.createElement(_reduxForm.FieldArray, { name: 'messageTemplateIds', component: _MessageTemplateArray2.default });
	};
	
	var FormWizzard = function (_React$Component) {
	    _inherits(FormWizzard, _React$Component);
	
	    function FormWizzard(props, ctx) {
	        _classCallCheck(this, FormWizzard);
	
	        var _this = _possibleConstructorReturn(this, (FormWizzard.__proto__ || Object.getPrototypeOf(FormWizzard)).call(this, props, ctx));
	
	        _this.handleNext = function () {
	            if (_this.state.stepIndex < LAST_STEP_INDEX) {
	                _this.setState(function (_ref2) {
	                    var stepIndex = _ref2.stepIndex;
	                    return {
	                        stepIndex: stepIndex + 1
	                    };
	                });
	            } else {
	                _this.props.dispatch((0, _reduxForm.submit)(_constants.WIZZARD_FORM_ID));
	            }
	        };
	
	        _this.handlePrev = function () {
	            _this.setState(function (_ref3) {
	                var stepIndex = _ref3.stepIndex;
	                return {
	                    stepIndex: Math.max(0, stepIndex - 1)
	                };
	            });
	        };
	
	        _this.onStepSelect = function (stepIndex) {
	            return function () {
	                return _this.setState({ stepIndex: stepIndex });
	            };
	        };
	
	        _this.onSave = function (values) {
	            var _this$props = _this.props,
	                errors = _this$props.errors,
	                onSave = _this$props.onSave;
	
	            if (Object.keys(errors || []).length === 0) {
	                onSave(values);
	                _this.setState({ stepIndex: 0 });
	            } else {
	                throw new _reduxForm.SubmissionError(errors);
	            }
	        };
	
	        _this.onTriggerChange = function (event, triggerType) {
	            var selected = _lodash2.default.get(_triggerConstants.triggerTypesMap, '[' + triggerType + '].conditions');
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                widgetName = _this$props2.widgetName;
	
	            var conditionsArray = _constants.CAMPAIGN_FORM_KEYS.RULES.CONDITIONS.ARRAY;
	            if (Array.isArray(selected) && selected.some(function (e) {
	                return e.name === 'sportId';
	            })) {
	                dispatch((0, _reduxForm.change)(_constants.WIZZARD_FORM_ID, conditionsArray, [{ sportId: SOCCER_SPORT_ID }]));
	            } else {
	                dispatch((0, _reduxForm.change)(_constants.WIZZARD_FORM_ID, conditionsArray, [{}]));
	            }
	            dispatch(initializeAdditionalWidgetParams(widgetName, triggerType));
	        };
	
	        _this.onWidgetChange = function (_ref4) {
	            var value = _ref4.value;
	            var _this$props3 = _this.props,
	                dispatch = _this$props3.dispatch,
	                triggerType = _this$props3.triggerType;
	
	            dispatch(initializeAdditionalWidgetParams(value, triggerType));
	        };
	
	        _this.renderStepActions = function (step) {
	            var stepIndex = _this.state.stepIndex;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { margin: '12px 0' } },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    label: stepIndex === LAST_STEP_INDEX ? 'Finish' : 'Continue',
	                    disableTouchRipple: true,
	                    disableFocusRipple: true,
	                    primary: true,
	                    onTouchTap: _this.handleNext,
	                    style: { marginRight: 12 }
	                }),
	                step > 0 && _react2.default.createElement(_materialUi.FlatButton, {
	                    label: 'Back',
	                    disabled: stepIndex === 0,
	                    disableTouchRipple: true,
	                    disableFocusRipple: true,
	                    onTouchTap: _this.handlePrev
	                })
	            );
	        };
	
	        _this.renderStepperForm = function () {
	            var triggerType = _this.props.triggerType;
	            var stepIndex = _this.state.stepIndex;
	
	
	            return _react2.default.createElement(
	                _materialUi.Stepper,
	                { linear: false, activeStep: stepIndex, orientation: 'vertical' },
	                _react2.default.createElement(
	                    _materialUi.Step,
	                    null,
	                    _react2.default.createElement(
	                        _materialUi.StepButton,
	                        { onClick: _this.onStepSelect(0) },
	                        'Select a widget'
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.StepContent,
	                        null,
	                        _react2.default.createElement(
	                            _reduxForm.FormSection,
	                            { name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION },
	                            _react2.default.createElement(WidgetFormEnhanced, { onChange: _this.onWidgetChange })
	                        ),
	                        _this.renderStepActions(0)
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.Step,
	                    null,
	                    _react2.default.createElement(
	                        _materialUi.StepButton,
	                        { onClick: _this.onStepSelect(1) },
	                        'Select a trigger'
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.StepContent,
	                        null,
	                        _react2.default.createElement(_RuleForm.RuleForm, { triggerType: triggerType, onTriggerChange: _this.onTriggerChange }),
	                        _this.renderStepActions(1)
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.Step,
	                    null,
	                    _react2.default.createElement(
	                        _materialUi.StepButton,
	                        { onClick: _this.onStepSelect(2) },
	                        'Customize widget parameters'
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.StepContent,
	                        null,
	                        _react2.default.createElement(
	                            _reduxForm.FormSection,
	                            { name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION },
	                            _react2.default.createElement(_reduxForm.FieldArray, {
	                                name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY,
	                                triggerType: triggerType,
	                                component: _ParamsCuztomizer2.default
	                            })
	                        ),
	                        _this.renderStepActions(2)
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.Step,
	                    null,
	                    _react2.default.createElement(
	                        _materialUi.StepButton,
	                        { onClick: _this.onStepSelect(3) },
	                        'Post message'
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.StepContent,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_REmojiPicker2.default, { name: 'message', multiLine: true, floatingLabelText: 'Post message' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_REmojiPicker2.default, { name: 'signature', floatingLabelText: 'Signature (hashtags)' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '12px 0px' } },
	                            _react2.default.createElement(MessagePreview, null)
	                        ),
	                        _react2.default.createElement(_materialUi.Divider, null),
	                        _react2.default.createElement(
	                            _withFeature2.default,
	                            { feature: 'messageServices' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '12px 0px' } },
	                                _react2.default.createElement(MessageTemplateForm, null)
	                            )
	                        ),
	                        _this.renderStepActions(3)
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            stepIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(FormWizzard, [{
	        key: 'render',
	        value: function render() {
	            var handleSubmit = this.props.handleSubmit;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reduxForm.Form,
	                    { onSubmit: handleSubmit(this.onSave) },
	                    this.renderStepperForm()
	                )
	            );
	        }
	    }]);
	
	    return FormWizzard;
	}(_react2.default.Component);
	
	FormWizzard.propTypes = {
	    errors: _propTypes2.default.object,
	    triggerType: _propTypes2.default.string,
	    onSave: _propTypes2.default.func.isRequired
	};
	
	var valueSelector = (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID);
	var mapStateToPropsFormWiz = function mapStateToPropsFormWiz(state) {
	    var triggerType = valueSelector(state, F.RULES.KEY);
	    var widgetName = valueSelector(state, 'presentation.name');
	    var errors = (0, _reduxForm.getFormSyncErrors)(_constants.WIZZARD_FORM_ID)(state);
	    return {
	        errors: errors,
	        triggerType: triggerType,
	        widgetName: widgetName
	    };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToPropsFormWiz), (0, _reduxForm.reduxForm)({
	    form: _constants.WIZZARD_FORM_ID,
	    // keepDirtyOnReinitialize: true,
	    // destroyOnUnmount: false,
	    validate: _schema.validateWizzard
	}))(FormWizzard);

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RuleForm = exports.TriggerForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _ConditionForm = __webpack_require__(1850);
	
	var _ConditionForm2 = _interopRequireDefault(_ConditionForm);
	
	var _constants = __webpack_require__(579);
	
	var _triggerTypes = __webpack_require__(1838);
	
	var _triggerTypes2 = _interopRequireDefault(_triggerTypes);
	
	var _validation = __webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yCenter = { display: 'flex', alignItems: 'center' };
	
	var onConditionAdd = function onConditionAdd(fields) {
	    return function () {
	        return fields.push({});
	    };
	};
	var onConditionRemove = function onConditionRemove(fields, index) {
	    return function () {
	        if (fields.length > 1) {
	            fields.remove(index);
	        }
	    };
	};
	
	var ConditionFormArray = function (_React$Component) {
	    _inherits(ConditionFormArray, _React$Component);
	
	    function ConditionFormArray() {
	        _classCallCheck(this, ConditionFormArray);
	
	        return _possibleConstructorReturn(this, (ConditionFormArray.__proto__ || Object.getPrototypeOf(ConditionFormArray)).apply(this, arguments));
	    }
	
	    _createClass(ConditionFormArray, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                fields = _props.fields,
	                triggerType = _props.triggerType;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                fields.map(function (field, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: field, style: yCenter },
	                        _react2.default.createElement(
	                            'span',
	                            { style: { margin: '16px 8px 0px 0px' } },
	                            index + 1,
	                            '.'
	                        ),
	                        _react2.default.createElement(
	                            _reduxForm.FormSection,
	                            { name: field },
	                            _react2.default.createElement(_ConditionForm2.default, { triggerType: triggerType })
	                        ),
	                        _react2.default.createElement(
	                            _materialUi.IconButton,
	                            {
	                                style: { margin: '16px 8px 0px 0px' },
	                                label: 'x',
	                                onTouchTap: onConditionRemove(fields, index)
	                            },
	                            _react2.default.createElement(_delete2.default, null)
	                        )
	                    );
	                }),
	                _react2.default.createElement(_materialUi.FlatButton, { primary: true, label: 'Add condition', onTouchTap: onConditionAdd(fields), icon: _react2.default.createElement(_add2.default, null) })
	            );
	        }
	    }]);
	
	    return ConditionFormArray;
	}(_react2.default.Component);
	
	var TriggerForm = exports.TriggerForm = function TriggerForm(_ref) {
	    var onTriggerChange = _ref.onTriggerChange;
	
	    return _react2.default.createElement(
	        _reduxForm.Field,
	        {
	            validate: _validation.presence,
	            name: _constants.CAMPAIGN_FORM_KEYS.RULES.KEY,
	            label: 'Trigger',
	            component: _reduxFormMaterialUi.SelectField,
	            onChange: onTriggerChange
	        },
	        _triggerTypes2.default.map(function (obj) {
	            return _react2.default.createElement(_materialUi.MenuItem, { key: obj.trigger, value: obj.trigger, primaryText: (0, _humanizeString2.default)(obj.trigger) });
	        })
	    );
	};
	
	TriggerForm.propTypes = {
	    onTriggerChange: _propTypes2.default.func
	};
	
	var RuleForm = exports.RuleForm = function RuleForm(_ref2) {
	    var triggerType = _ref2.triggerType,
	        onTriggerChange = _ref2.onTriggerChange;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(TriggerForm, { onTriggerChange: onTriggerChange }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_reduxForm.FieldArray, { triggerType: triggerType, name: _constants.CAMPAIGN_FORM_KEYS.RULES.CONDITIONS.ARRAY, component: ConditionFormArray })
	    );
	};
	
	RuleForm.propTypes = {
	    triggerType: _propTypes2.default.string,
	    onTriggerChange: _propTypes2.default.func
	};

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _recompose = __webpack_require__(1096);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _pickers = __webpack_require__(1851);
	
	var _validation = __webpack_require__(1660);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS_TO_DISABLE = ['sportId'];
	
	var TournamentPickerWithSport = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(function (state, _ref) {
	    var _ref$_reduxForm = _ref._reduxForm,
	        form = _ref$_reduxForm.form,
	        sectionPrefix = _ref$_reduxForm.sectionPrefix;
	    return {
	        sport: (0, _reduxForm.formValueSelector)(form)(state, (0, _helpers.getFieldPath)(sectionPrefix, 'sportId'))
	    };
	}))(_pickers.TournamentPickerV2);
	
	var withSportAndTtId = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(function (state, _ref2) {
	    var _ref2$_reduxForm = _ref2._reduxForm,
	        form = _ref2$_reduxForm.form,
	        sectionPrefix = _ref2$_reduxForm.sectionPrefix;
	    return {
	        sport: (0, _reduxForm.formValueSelector)(form)(state, (0, _helpers.getFieldPath)(sectionPrefix, 'sportId')),
	        tournamentId: (0, _reduxForm.formValueSelector)(form)(state, (0, _helpers.getFieldPath)(sectionPrefix, 'ttId'))
	    };
	}));
	
	var EventPickerWithProps = withSportAndTtId(_pickers.EventPicker2);
	var TeamPickerWithProps = withSportAndTtId(_pickers.TeamPicker2);
	
	var resolveField = function resolveField(field, index, allRequired) {
	    var name = field.name,
	        required = field.required,
	        pickerType = field.picker,
	        options = field.values,
	        label = field.label;
	
	    var validate = required || allRequired ? _validation.presence : _lodash2.default.noop;
	    var disabled = FIELDS_TO_DISABLE.some(function (e) {
	        return e === name;
	    });
	    switch (pickerType) {
	        case 'tournament_picker':
	            return _react2.default.createElement(TournamentPickerWithSport, { name: name, style: { width: 240 }, validate: validate, disabled: disabled });
	        case 'event_by_date_picker':
	            return _react2.default.createElement(EventPickerWithProps, { name: name, style: { width: 270 }, validate: validate, disabled: disabled });
	        case 'team_picker':
	            return _react2.default.createElement(TeamPickerWithProps, {
	                name: name,
	                style: { width: 200 },
	                validate: validate,
	                floatingLabelText: label || (0, _humanizeString2.default)(name),
	                disabled: disabled
	            });
	        case 'enum_picker':
	            return _react2.default.createElement(
	                _reduxForm.Field,
	                {
	                    name: name,
	                    validate: validate,
	                    disabled: disabled,
	                    floatingLabelText: label || (0, _humanizeString2.default)(name),
	                    style: { width: 200 },
	                    component: _reduxFormMaterialUi.SelectField
	                },
	                options.map(function (option) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { primaryText: option.label, value: option.value, key: option.value });
	                })
	            );
	        default:
	            return _react2.default.createElement(_reduxForm.Field, {
	                name: name,
	                validate: validate,
	                disabled: disabled,
	                floatingLabelText: label || (0, _humanizeString2.default)(name),
	                style: { width: 120 },
	                component: _reduxFormMaterialUi.TextField
	            });
	    }
	};
	
	var ConditionForm = function ConditionForm(_ref3) {
	    var triggerType = _ref3.triggerType,
	        _ref3$allRequired = _ref3.allRequired,
	        allRequired = _ref3$allRequired === undefined ? false : _ref3$allRequired;
	
	    var selected = _lodash2.default.get(_triggerConstants.triggerTypesMap, [triggerType, 'conditions']);
	    if (!triggerType || !Array.isArray(selected)) {
	        return null;
	    }
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' } },
	        selected.map(function (field, index) {
	            return _react2.default.createElement(
	                'span',
	                { key: field.name, style: { display: 'flex', alignItems: 'baseline' } },
	                resolveField(field, index, allRequired)
	            );
	        })
	    );
	};
	
	ConditionForm.propTypes = {
	    triggerType: _propTypes2.default.string,
	    allRequired: _propTypes2.default.bool
	};
	
	exports.default = ConditionForm;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RFSelect = __webpack_require__(1852);
	
	Object.defineProperty(exports, 'RFSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RFSelect).default;
	  }
	});
	
	var _TournamentPicker = __webpack_require__(1853);
	
	Object.defineProperty(exports, 'TournamentPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TournamentPicker).default;
	  }
	});
	
	var _EventPicker = __webpack_require__(1854);
	
	Object.defineProperty(exports, 'EventPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EventPicker).default;
	  }
	});
	
	var _EventPicker2 = __webpack_require__(1855);
	
	Object.defineProperty(exports, 'EventPicker2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EventPicker2).default;
	  }
	});
	
	var _TeamPicker = __webpack_require__(1856);
	
	Object.defineProperty(exports, 'TeamPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TeamPicker).default;
	  }
	});
	
	var _TournamentPicker2 = __webpack_require__(1857);
	
	Object.defineProperty(exports, 'TournamentPickerV2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TournamentPicker2).default;
	  }
	});
	
	var _TeamPicker2 = __webpack_require__(1858);
	
	Object.defineProperty(exports, 'TeamPicker2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TeamPicker2).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1141);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INVALID_RED_COLOR = 'rgb(244, 67, 54)';
	
	var errorStyle = {
	    bottom: 15,
	    fontSize: 12,
	    margin: 12,
	    color: INVALID_RED_COLOR,
	    transition: 'all 450ms'
	};
	
	var RFSelect = function (_React$PureComponent) {
	    _inherits(RFSelect, _React$PureComponent);
	
	    function RFSelect() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RFSelect);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RFSelect.__proto__ || Object.getPrototypeOf(RFSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleInputChange = function (obj) {
	            var valKey = _this.props.valueKey || 'value';
	            var res = obj ? obj[valKey] : '';
	            _this.props.input.onChange(res);
	            _this.props.input.onBlur(res);
	            if (_this.props.onChange) {
	                _this.props.onChange(res);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RFSelect, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var options = _ref2.options,
	                manual = _ref2.manual,
	                value = _ref2.input.value;
	
	            var valKey = this.props.valueKey || 'value';
	            var hasValue = options.find(function (el) {
	                return el[valKey] === value;
	            });
	            if (!manual && value && !hasValue) {
	                this.handleInputChange();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	
	            var valKey = this.props.valueKey || 'value';
	
	            var input = props.input,
	                options = props.options,
	                meta = props.meta,
	                onChange = props.onChange,
	                rest = _objectWithoutProperties(props, ['input', 'options', 'meta', 'onChange']);
	
	            var name = input.name,
	                value = input.value,
	                _onBlur = input.onBlur,
	                rfOnChange = input.onChange,
	                onFocus = input.onFocus;
	
	            var shouldShowError = meta.touched && !meta.valid;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
	                    name: name,
	                    options: options,
	                    onChange: this.handleInputChange,
	                    value: value,
	                    onBlur: function onBlur() {
	                        return _onBlur(value);
	                    },
	                    onFocus: onFocus,
	                    style: shouldShowError ? { borderColor: INVALID_RED_COLOR } : {}
	                })),
	                shouldShowError && _react2.default.createElement(
	                    'div',
	                    { style: errorStyle },
	                    meta.error
	                )
	            );
	        }
	    }]);
	
	    return RFSelect;
	}(_react2.default.PureComponent);
	
	exports.default = RFSelect;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxForm = __webpack_require__(342);
	
	var _selectors = __webpack_require__(618);
	
	var _tournaments = __webpack_require__(1052);
	
	var _constants = __webpack_require__(579);
	
	var _RFSelect = __webpack_require__(1852);
	
	var _RFSelect2 = _interopRequireDefault(_RFSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TournamentPicker = function TournamentPicker(_ref) {
	    var _ref$tournaments = _ref.tournaments,
	        tournaments = _ref$tournaments === undefined ? [] : _ref$tournaments,
	        _ref$name = _ref.name,
	        name = _ref$name === undefined ? 'tournamentId' : _ref$name;
	
	    return _react2.default.createElement(_reduxForm.Field, {
	        name: name,
	        ignoreCase: true,
	        matchProp: 'any',
	        options: tournaments,
	        labelKey: 'name',
	        valueKey: 'id',
	        placeholder: 'Tournament (league)',
	        component: _RFSelect2.default
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    return { tournaments: (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.TOURNAMENTS] };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        this.props.dispatch((0, _tournaments.fetchAllTournaments)());
	    }
	}))(TournamentPicker);

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _RFSelect = __webpack_require__(1852);
	
	var _RFSelect2 = _interopRequireDefault(_RFSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var eventRender = function eventRender(event) {
	    return _react2.default.createElement(
	        'span',
	        null,
	        event.homeName,
	        ' - ',
	        event.awayName
	    );
	};
	
	var EventPicker = function (_React$PureComponent) {
	    _inherits(EventPicker, _React$PureComponent);
	
	    function EventPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EventPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventPicker.__proto__ || Object.getPrototypeOf(EventPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = { date: undefined, events: [] }, _this.onDateChange = function (event, date) {
	            _this.setState({ date: date, events: [] });
	            var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	            _superagent2.default.get(_cfg2.default.apis.ss2 + '/events/soccer/' + formatted).then(function (_ref2) {
	                var body = _ref2.body;
	
	                _this.setState({ events: body });
	            }).catch(function () {});
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EventPicker, [{
	        key: 'render',
	        value: function render() {
	            var _props$name = this.props.name,
	                name = _props$name === undefined ? 'eventId' : _props$name;
	            var _state$events = this.state.events,
	                events = _state$events === undefined ? [] : _state$events;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_materialUi.DatePicker, {
	                    name: 'date',
	                    floatingLabelText: 'Event date',
	                    value: this.state.date,
	                    onChange: this.onDateChange
	                }),
	                _react2.default.createElement(_reduxForm.Field, {
	                    name: name,
	                    ignoreCase: true,
	                    matchProp: 'any',
	                    options: events,
	                    optionRenderer: eventRender,
	                    valueRenderer: eventRender,
	                    valueKey: 'eventId',
	                    placeholder: 'Event (match)',
	                    component: _RFSelect2.default
	                })
	            );
	        }
	    }]);
	
	    return EventPicker;
	}(_react2.default.PureComponent);
	
	exports.default = EventPicker;

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selectors = __webpack_require__(618);
	
	var _actions = __webpack_require__(1047);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getEventLabel = function getEventLabel(events, id) {
	    var event = _lodash2.default.get(events, id);
	    return _lodash2.default.isObject(event) ? event.homeName + ' - ' + event.awayName : 'EventId: ' + id;
	};
	
	var alphabetSort = function alphabetSort(a, b) {
	    var A = a.toLowerCase();
	    var B = b.toLowerCase();
	    if (A < B) {
	        return -1;
	    }
	    return A > B ? 1 : 0;
	};
	
	var groupLabelStyle = {
	    padding: '5px 24px',
	    fontSize: '12px',
	    backgroundColor: '#eaeaea'
	};
	var GroupLabel = function GroupLabel(_ref) {
	    var label = _ref.label;
	    return _react2.default.createElement(
	        'div',
	        { style: groupLabelStyle },
	        label
	    );
	};
	
	var EventPickerByDate = (0, _reactRedux.connect)(function (state, _ref2) {
	    var date = _ref2.date;
	    return {
	        events: (0, _selectors.getEntities)(state).events,
	        eventIds: date ? (0, _selectors.getEntities)(state)[(0, _selectors.eventsKeyByDate)(date)] : null
	    };
	})(function (_ref3) {
	    var date = _ref3.date,
	        eventIds = _ref3.eventIds,
	        events = _ref3.events,
	        onChange = _ref3.onChange;
	
	    var eventsAr = (Array.isArray(eventIds) ? eventIds : []).map(function (id) {
	        return _lodash2.default.get(events, id, { eventId: id, tournamentName: 'N/A' });
	    });
	    var grouped = _lodash2.default.groupBy(eventsAr, 'tournamentName');
	    var tournaments = Object.keys(grouped).sort(alphabetSort);
	    return _react2.default.createElement(
	        'div',
	        null,
	        !Array.isArray(eventIds) ? null : _react2.default.createElement(
	            _materialUi.SelectField,
	            { onChange: onChange, value: null, floatingLabelText: 'Event', style: { width: 420 } },
	            tournaments.map(function (tournament) {
	                var ids = grouped[tournament].map(function (e) {
	                    return e.eventId;
	                });
	                return [_react2.default.createElement(GroupLabel, { key: tournament, label: tournament })].concat(ids.map(function (id) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: String(id), primaryText: getEventLabel(events, id) });
	                }));
	            })
	        )
	    );
	});
	
	var EventPicker = function (_React$PureComponent) {
	    _inherits(EventPicker, _React$PureComponent);
	
	    function EventPicker() {
	        var _ref4;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EventPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = EventPicker.__proto__ || Object.getPrototypeOf(EventPicker)).call.apply(_ref4, [this].concat(args))), _this), _this.state = { dialogOpen: false, date: null }, _this.openDialog = function () {
	            _this.setState({ dialogOpen: true });
	        }, _this.closeDialog = function () {
	            _this.setState({ dialogOpen: false });
	        }, _this.onDateChange = function (jsEvent, date) {
	            _this.setState({ date: date });
	            _this.props.updateEventsByDate(date);
	        }, _this.onEventByDateChange = function (jsEvent, index, eventId) {
	            var _this$props = _this.props,
	                name = _this$props.name,
	                sectionPrefix = _this$props._reduxForm.sectionPrefix;
	
	            var path = (0, _helpers.getFieldPath)(sectionPrefix, name);
	            _this.props.manualChange(path, eventId);
	            _this.closeDialog();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EventPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                sport = _props.sport,
	                tournamentId = _props.tournamentId,
	                updateEvents = _props.updateEvents,
	                value = _props.value,
	                events = _props.events;
	
	            if (value && value !== '*' && !_lodash2.default.get(events, value)) {
	                this.props.fetchEventById(value);
	            }
	            updateEvents(sport, tournamentId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref5) {
	            var sport = _ref5.sport,
	                tournamentId = _ref5.tournamentId;
	
	            if (this.props.sport !== sport || tournamentId !== this.props.tournamentId) {
	                this.props.updateEvents(sport, tournamentId);
	            }
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            var _props2 = this.props,
	                eventIds = _props2.eventIds,
	                value = _props2.value;
	            var events = this.props.events;
	
	            var ids = Array.isArray(eventIds) ? eventIds.slice() : [];
	            if (value && value !== '*' && !ids.some(function (id) {
	                return String(id) === String(value);
	            })) {
	                ids.push(value);
	            }
	            var eventsAr = ids.map(function (id) {
	                return _lodash2.default.get(events, id, { eventId: id, tournamentName: 'N/A' });
	            });
	            var grouped = _lodash2.default.groupBy(eventsAr, 'tournamentName');
	            return Object.keys(grouped).map(function (tournament) {
	                var tournIds = grouped[tournament].map(function (el) {
	                    return el.eventId;
	                });
	                return [_react2.default.createElement(GroupLabel, { key: tournament, label: tournament })].concat(tournIds.map(function (id) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: String(id), primaryText: getEventLabel(events, id) });
	                }));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = this.props.name;
	
	            var fieldProps = _lodash2.default.omit(this.props, Object.keys(EventPicker.propTypes));
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reduxForm.Field,
	                    _extends({ floatingLabelText: 'Event (match)' }, fieldProps, { name: name, component: _reduxFormMaterialUi.SelectField }),
	                    _react2.default.createElement(_materialUi.MenuItem, { value: '*', primaryText: 'Any' }),
	                    this.renderOptions(),
	                    _react2.default.createElement(_materialUi.Divider, null),
	                    _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Find a match', onTouchTap: this.openDialog })
	                ),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        open: this.state.dialogOpen,
	                        onRequestClose: this.closeDialog,
	                        contentStyle: {
	                            display: 'flex',
	                            justifyContent: 'center',
	                            flexDirection: 'column',
	                            alignItems: 'center',
	                            padding: 24
	                        },
	                        actions: [_react2.default.createElement(_materialUi.RaisedButton, { secondary: true, label: 'Close', onTouchTap: this.closeDialog })]
	                    },
	                    _react2.default.createElement(_materialUi.DatePicker, {
	                        value: this.state.date,
	                        floatingLabelText: 'Event date',
	                        onChange: this.onDateChange,
	                        textFieldStyle: { width: 420 }
	                    }),
	                    _react2.default.createElement(EventPickerByDate, { date: this.state.date, onChange: this.onEventByDateChange })
	                )
	            );
	        }
	    }]);
	
	    return EventPicker;
	}(_react2.default.PureComponent);
	
	EventPicker.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    sport: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    tournamentId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    eventIds: _propTypes2.default.array,
	    events: _propTypes2.default.object,
	    updateEvents: _propTypes2.default.func.isRequired,
	    updateEventsByDate: _propTypes2.default.func.isRequired,
	    fetchEventById: _propTypes2.default.func.isRequired,
	    manualChange: _propTypes2.default.func.isRequired,
	    _reduxForm: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref6) {
	    var sport = _ref6.sport,
	        tournamentId = _ref6.tournamentId,
	        name = _ref6.name,
	        _ref6$_reduxForm = _ref6._reduxForm,
	        form = _ref6$_reduxForm.form,
	        sectionPrefix = _ref6$_reduxForm.sectionPrefix;
	
	    var entities = (0, _selectors.getEntities)(state);
	    var eventsKey = (0, _selectors.eventsKeyBySportAndTtId)(sport, tournamentId);
	    var valuePath = (0, _helpers.getFieldPath)(sectionPrefix, name);
	    return {
	        eventIds: entities[eventsKey],
	        events: entities.events,
	        value: (0, _reduxForm.formValueSelector)(form)(state, valuePath)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref7) {
	    var form = _ref7._reduxForm.form;
	    return {
	        updateEvents: function updateEvents(sportId, tournamentId) {
	            return dispatch((0, _actions.fetchEventsByTournament)({ sportId: sportId, tournamentId: tournamentId }));
	        },
	        updateEventsByDate: function updateEventsByDate(date) {
	            return dispatch((0, _actions.fetchEventsByDate)(date));
	        },
	        manualChange: function manualChange(path, eventId) {
	            return dispatch((0, _reduxForm.change)(form, path, eventId));
	        },
	        fetchEventById: function fetchEventById(id) {
	            return dispatch((0, _actions.fetchEventById)(id));
	        }
	    };
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(EventPicker);

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _RFSelect = __webpack_require__(1852);
	
	var _RFSelect2 = _interopRequireDefault(_RFSelect);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamPicker = function (_React$PureComponent) {
	    _inherits(TeamPicker, _React$PureComponent);
	
	    function TeamPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TeamPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamPicker.__proto__ || Object.getPrototypeOf(TeamPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = { teams: [] }, _this.updateTeams = function (tournamentId) {
	            _superagent2.default.get(_cfg2.default.apis.ss2 + '/tournaments/' + tournamentId + '/teams').then(function (_ref2) {
	                var body = _ref2.body;
	
	                _this.setState({ teams: body });
	            }).catch(function () {});
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TeamPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var tournamentId = this.props.tournamentId;
	
	            this.updateTeams(tournamentId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref3) {
	            var tournamentId = _ref3.tournamentId;
	
	            if (this.props.tournamentId !== tournamentId) {
	                this.updateTeams(tournamentId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state$teams = this.state.teams,
	                teams = _state$teams === undefined ? [] : _state$teams;
	            var name = this.props.name;
	
	            return _react2.default.createElement(_reduxForm.Field, {
	                name: name,
	                ignoreCase: true,
	                matchProp: 'any',
	                options: teams,
	                labelKey: 'name',
	                valueKey: 'id',
	                placeholder: 'Team',
	                component: _RFSelect2.default
	            });
	        }
	    }]);
	
	    return TeamPicker;
	}(_react2.default.PureComponent);
	
	TeamPicker.defaultProps = {
	    name: 'teamId'
	};
	
	
	TeamPicker.propTypes = {
	    tournamentId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    name: _propTypes2.default.string
	};
	
	exports.default = TeamPicker;

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _selectors = __webpack_require__(618);
	
	var _tournaments = __webpack_require__(1052);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentPicker = function (_React$PureComponent) {
	    _inherits(TournamentPicker, _React$PureComponent);
	
	    function TournamentPicker() {
	        _classCallCheck(this, TournamentPicker);
	
	        return _possibleConstructorReturn(this, (TournamentPicker.__proto__ || Object.getPrototypeOf(TournamentPicker)).apply(this, arguments));
	    }
	
	    _createClass(TournamentPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.updateTournaments(this.props.sport);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var sport = _ref.sport;
	
	            if (this.props.sport !== sport) {
	                this.props.updateTournaments(this.props.sport);
	            }
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            var tournaments = this.props.tournaments;
	
	            if (!Array.isArray(tournaments)) {
	                return null;
	            }
	            return tournaments.map(function (_ref2) {
	                var id = _ref2.id,
	                    name = _ref2.name;
	                return _react2.default.createElement(_materialUi.MenuItem, { key: id, primaryText: name, value: String(id) });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = this.props.name;
	
	            var fieldProps = _lodash2.default.omit(this.props, Object.keys(TournamentPicker.propTypes));
	            var options = this.renderOptions();
	            return _react2.default.createElement(
	                _reduxForm.Field,
	                _extends({ floatingLabelText: 'Tournament (league)' }, fieldProps, { name: name, component: _reduxFormMaterialUi.SelectField }),
	                options
	            );
	        }
	    }]);
	
	    return TournamentPicker;
	}(_react2.default.PureComponent);
	
	TournamentPicker.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    sport: _propTypes2.default.string,
	    tournaments: _propTypes2.default.array,
	    updateTournaments: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref3) {
	    var sport = _ref3.sport;
	    return {
	        tournaments: (0, _selectors.getEntities)(state)[(0, _selectors.tournamentsKey)(sport)]
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        updateTournaments: function updateTournaments(sport) {
	            return dispatch((0, _tournaments.fetchTournamentsBySport)(sport));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TournamentPicker);

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _reduxForm = __webpack_require__(342);
	
	var _actions = __webpack_require__(1047);
	
	var _selectors = __webpack_require__(618);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamPicker = function (_React$PureComponent) {
	    _inherits(TeamPicker, _React$PureComponent);
	
	    function TeamPicker() {
	        _classCallCheck(this, TeamPicker);
	
	        return _possibleConstructorReturn(this, (TeamPicker.__proto__ || Object.getPrototypeOf(TeamPicker)).apply(this, arguments));
	    }
	
	    _createClass(TeamPicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                sport = _props.sport,
	                tournamentId = _props.tournamentId,
	                fetchTeams = _props.fetchTeams;
	
	            fetchTeams(sport, tournamentId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var sport = _ref.sport,
	                tournamentId = _ref.tournamentId;
	
	            if (this.props.sport !== sport || this.props.tournamentId !== tournamentId) {
	                this.props.fetchTeams(sport, tournamentId);
	            }
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            var teamIds = this.props.teamIds;
	            var _props2 = this.props,
	                teams = _props2.teams,
	                value = _props2.value;
	
	            var ids = Array.isArray(teamIds) ? teamIds.slice() : [];
	            if (value && value !== '*' && !ids.some(function (id) {
	                return String(id) === String(value);
	            })) {
	                ids.push(value);
	            }
	            return ids.map(function (id) {
	                return _react2.default.createElement(_materialUi.MenuItem, {
	                    key: id,
	                    primaryText: _lodash2.default.get(teams, id + '.name', 'TeamId: ' + id),
	                    value: String(id)
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = this.props.name;
	
	            var fieldProps = _lodash2.default.omit(this.props, Object.keys(TeamPicker.propTypes));
	            var options = this.renderOptions();
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reduxForm.Field,
	                    _extends({
	                        floatingLabelText: 'Team'
	                    }, fieldProps, {
	                        name: name,
	                        component: _reduxFormMaterialUi.SelectField
	                    }),
	                    _react2.default.createElement(_materialUi.MenuItem, { value: '*', primaryText: 'Any' }),
	                    _lodash2.default.get(options, 'length') ? _react2.default.createElement(_materialUi.Divider, null) : null,
	                    options
	                )
	            );
	        }
	    }]);
	
	    return TeamPicker;
	}(_react2.default.PureComponent);
	
	var mapStateToProps = function mapStateToProps(state, _ref2) {
	    var sport = _ref2.sport,
	        tournamentId = _ref2.tournamentId,
	        name = _ref2.name,
	        _ref2$_reduxForm = _ref2._reduxForm,
	        form = _ref2$_reduxForm.form,
	        sectionPrefix = _ref2$_reduxForm.sectionPrefix;
	    return {
	        value: (0, _reduxForm.formValueSelector)(form)(state, (0, _helpers.getFieldPath)(sectionPrefix, name)),
	        teamIds: (0, _selectors.getEntities)(state)[(0, _selectors.teamsKeyBySportAndTtId)(sport, tournamentId)],
	        teams: (0, _selectors.getEntities)(state).teams
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchTeams: function fetchTeams(sportId, tournamentId) {
	            return dispatch((0, _actions.fetchTeamsBySportAndLeague)({ sportId: sportId, tournamentId: tournamentId }));
	        }
	    };
	};
	
	exports.default = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(TeamPicker);
	
	
	TeamPicker.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    sport: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    tournamentId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    teamIds: _propTypes2.default.array,
	    teams: _propTypes2.default.object,
	    fetchTeams: _propTypes2.default.func.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    _reduxForm: _propTypes2.default.object
	};

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _validation = __webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetForm = function WidgetForm(_ref) {
	    var _ref$widgets = _ref.widgets,
	        widgets = _ref$widgets === undefined ? [] : _ref$widgets,
	        _ref$templates = _ref.templates,
	        templates = _ref$templates === undefined ? [] : _ref$templates,
	        onChange = _ref.onChange;
	
	    var socialWidgets = Array.isArray(widgets) ? widgets.filter(function (w) {
	        return _lodash2.default.get(w, 'spec.social');
	    }) : [];
	
	    var handleChange = function handleChange(event, value) {
	        if (onChange) {
	            onChange({ widget: socialWidgets.find(function (w) {
	                    return w.id === value;
	                }), value: value });
	        }
	    };
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reduxForm.Field,
	                {
	                    name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.NAME,
	                    floatingLabelText: 'Widget',
	                    component: _reduxFormMaterialUi.SelectField,
	                    onChange: handleChange,
	                    validate: _validation.presence
	                },
	                socialWidgets.map(function (widget) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { key: widget.id, value: widget.id, primaryText: widget.name });
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _reduxForm.FormSection,
	            { name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reduxForm.Field,
	                    {
	                        name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.TEMPLATE,
	                        floatingLabelText: 'Template',
	                        component: _reduxFormMaterialUi.SelectField,
	                        validate: _validation.presence
	                    },
	                    templates.filter(function (el) {
	                        return !el.isHidden;
	                    }).map(function (template) {
	                        return _react2.default.createElement(_materialUi.MenuItem, { key: template._id, value: template.id, primaryText: template.name });
	                    })
	                )
	            )
	        )
	    );
	};
	
	WidgetForm.propTypes = {
	    widgets: _propTypes2.default.array,
	    templates: _propTypes2.default.array,
	    onChange: _propTypes2.default.func
	};
	
	exports.default = WidgetForm;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ParamsCustomizer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _selectors = __webpack_require__(618);
	
	var _validation = __webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PARAM_ADD = _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL;
	// inherited from campaign
	var DISABLED_PROP_TYPES_FOR_CAMPAIGN = ['tz', 'lang'];
	var renderCustomField = function renderCustomField(byTrigger) {
	    var propType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (byTrigger) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            'provided by trigger'
	        );
	    }
	    var type = propType.type,
	        _propType$options = propType.options,
	        options = _propType$options === undefined ? [] : _propType$options;
	
	    var component = void 0;
	    var selectOptions = [];
	    switch (type) {
	        case 'boolean':
	            component = _reduxFormMaterialUi.Toggle;
	            break;
	        case 'select_picker':
	            component = _reduxFormMaterialUi.SelectField;
	            selectOptions = options.map(function (_ref) {
	                var value = _ref.value,
	                    text = _ref.text;
	                return _react2.default.createElement(_materialUi.MenuItem, { value: value, key: value, primaryText: text });
	            });
	            break;
	        default:
	            component = _reduxFormMaterialUi.TextField;
	            break;
	    }
	
	    var isBoolean = type === 'boolean';
	    var validation = propType.required ? _validation.presence : undefined;
	    var parse = isBoolean ? Boolean : undefined;
	
	    return _react2.default.createElement(
	        _reduxForm.Field,
	        { parse: parse, validate: validation, component: component, name: PARAM_ADD.CUSTOM_VALUE },
	        type === 'select_picker' ? selectOptions : null
	    );
	};
	
	var getCurrentWidgetPropTypesMap = function getCurrentWidgetPropTypesMap(widgetId) {
	    var widgets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var currentWidget = widgets.find(function (el) {
	        return el.id === widgetId;
	    });
	    var propTypes = _lodash2.default.get(currentWidget, 'spec.propTypes');
	
	    return !Array.isArray(propTypes) ? {} : propTypes.reduce(function (acc, cur) {
	        acc[cur.key] = cur;
	        return acc;
	    }, {});
	};
	
	var ParamsCustomizer = exports.ParamsCustomizer = function (_React$Component) {
	    _inherits(ParamsCustomizer, _React$Component);
	
	    function ParamsCustomizer() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ParamsCustomizer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ParamsCustomizer.__proto__ || Object.getPrototypeOf(ParamsCustomizer)).call.apply(_ref2, [this].concat(args))), _this), _this.onKeyValueChange = function (index) {
	            return function (event, value) {
	                var name = _this.props.fields.name;
	                var dispatch = _this.props.dispatch;
	
	                var path = name + '[' + index + '].';
	                var byTrigger = value !== 'manual';
	                dispatch((0, _reduxForm.change)(_constants.WIZZARD_FORM_ID, path + PARAM_ADD.BY_TRIGGER, byTrigger));
	                if (byTrigger) {
	                    dispatch((0, _reduxForm.change)(_constants.CAMPAIGN_FORM_ID, path + PARAM_ADD.CUSTOM_VALUE, ''));
	                }
	            };
	        }, _this.renderTable = function () {
	            var _this$props = _this.props,
	                fields = _this$props.fields,
	                triggerType = _this$props.triggerType,
	                values = _this$props.values,
	                widgetId = _this$props.widgetId,
	                widgets = _this$props.widgets;
	
	            var triggerOptions = (_triggerConstants.TRIGGER_PAYLOAD[triggerType] || []).concat(['manual']);
	            var widgetPropTypes = getCurrentWidgetPropTypesMap(widgetId, widgets);
	
	            return _react2.default.createElement(
	                _materialUi.Table,
	                { selectable: false },
	                _react2.default.createElement(
	                    _materialUi.TableHeader,
	                    { displaySelectAll: false, adjustForCheckbox: false },
	                    _react2.default.createElement(
	                        _materialUi.TableRow,
	                        null,
	                        _react2.default.createElement(
	                            _materialUi.TableHeaderColumn,
	                            null,
	                            'Widget parameters'
	                        ),
	                        _react2.default.createElement(
	                            _materialUi.TableHeaderColumn,
	                            null,
	                            'Trigger value'
	                        ),
	                        _react2.default.createElement(
	                            _materialUi.TableHeaderColumn,
	                            null,
	                            'Value'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.TableBody,
	                    { displayRowCheckbox: false },
	                    fields.map(function (field, index) {
	                        var prop = values[index];
	                        var currentKey = prop[PARAM_ADD.KEY];
	                        var widgetPropType = widgetPropTypes[currentKey];
	
	                        if (DISABLED_PROP_TYPES_FOR_CAMPAIGN.indexOf(currentKey) !== -1) return null;
	                        return (
	                            // eslint-disable-next-line
	                            _react2.default.createElement(
	                                _materialUi.TableRow,
	                                { key: index, style: { height: 72 } },
	                                _react2.default.createElement(
	                                    _materialUi.TableRowColumn,
	                                    null,
	                                    currentKey
	                                ),
	                                _react2.default.createElement(
	                                    _materialUi.TableRowColumn,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reduxForm.FormSection,
	                                        { name: field },
	                                        _react2.default.createElement(
	                                            _reduxForm.Field,
	                                            {
	                                                name: PARAM_ADD.VALUE,
	                                                component: _reduxFormMaterialUi.SelectField,
	                                                onChange: _this.onKeyValueChange(index)
	                                            },
	                                            triggerOptions.map(function (option) {
	                                                return _react2.default.createElement(_materialUi.MenuItem, { key: option, value: option, primaryText: option });
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _materialUi.TableRowColumn,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reduxForm.FormSection,
	                                        { name: field },
	                                        renderCustomField(prop[PARAM_ADD.BY_TRIGGER], widgetPropType)
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ParamsCustomizer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderTable()
	            );
	        }
	    }]);
	
	    return ParamsCustomizer;
	}(_react2.default.Component);
	
	ParamsCustomizer.propTypes = {
	    triggerType: _propTypes2.default.string,
	    values: _propTypes2.default.array,
	    widgetId: _propTypes2.default.string,
	    widgets: _propTypes2.default.array
	};
	
	var widgetNameKey = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.NAME;
	var selector = (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID);
	var mapStateToProps = function mapStateToProps(state, _ref3) {
	    var name = _ref3.fields.name;
	
	    var values = selector(state, name);
	    var widgetId = selector(state, widgetNameKey);
	    var widgets = _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS], 'widgets');
	    return { values: values, widgets: widgets, widgetId: widgetId };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ParamsCustomizer);

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _remove = __webpack_require__(1862);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _constants = __webpack_require__(579);
	
	var _actions = __webpack_require__(1863);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var templateExists = function templateExists(template) {
	    return [null, undefined].every(function (v) {
	        return v !== template;
	    });
	};
	
	var LANG_MAP = _constants.LANGUAGES.reduce(function (acc, cur) {
	    acc[cur.key] = cur.name;
	    return acc;
	}, {});
	var MessageTemplate = (0, _reactRedux.connect)(function (state, _ref) {
	    var id = _ref.id;
	    return {
	        message: _lodash2.default.get(state.requery.entities, ['messageTemplates', id]),
	        language: (0, _reduxForm.formValueSelector)(_constants.CAMPAIGN_FORM_ID)(state, 'language') || 'en'
	    };
	})(function (_ref2) {
	    var message = _ref2.message,
	        id = _ref2.id,
	        onClick = _ref2.onClick,
	        language = _ref2.language,
	        leftIcon = _ref2.leftIcon;
	
	    var template = _lodash2.default.get(message, ['template', language]);
	    var beautyLanguage = LANG_MAP[language] || language;
	    return _react2.default.createElement(
	        _materialUi.MenuItem,
	        { onTouchTap: onClick, leftIcon: leftIcon, style: { overflow: 'hidden' } },
	        message ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                message.title
	            ),
	            _react2.default.createElement(
	                'small',
	                { style: { textOverflow: 'ellipsis' } },
	                templateExists(template) ? template : 'No template for ' + beautyLanguage + ' language'
	            )
	        ) : _react2.default.createElement(
	            'div',
	            null,
	            'Deleted or not existing message #',
	            id
	        )
	    );
	});
	
	var MessageTemplateArray = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	    return {
	        ids: state.requery.list['messageTemplates'],
	        entities: state.requery.entities['messageTemplates'],
	        isPending: _lodash2.default.get(state.requery.queries['GET:messageTemplates'], 'isPending'),
	        reqStatus: _lodash2.default.get(state.requery.queries['GET:messageTemplates'], 'status'),
	        trigger: (0, _reduxForm.formValueSelector)(_constants.WIZZARD_FORM_ID)(state, 'triggerType')
	    };
	}, function (dispatch) {
	    return { fetchMessages: function fetchMessages() {
	            return dispatch((0, _actions.fetchMessages)());
	        } };
	}), (0, _recompose.withPropsOnChange)(function (cur, next) {
	    return Array.isArray(next.ids) && (next.ids !== cur.ids || cur.trigger !== next.triggers || cur.entities !== next.entities);
	}, function (props) {
	    var ids = Array.isArray(props.ids) ? props.ids : [];
	    return {
	        ids: ids.filter(function (id) {
	            return _lodash2.default.get(props.entities, [id, 'trigger']) === props.trigger;
	        })
	    };
	}))(function (_React$PureComponent) {
	    _inherits(_MessageTemplateArray, _React$PureComponent);
	
	    function _MessageTemplateArray() {
	        var _ref3;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _MessageTemplateArray);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = _MessageTemplateArray.__proto__ || Object.getPrototypeOf(_MessageTemplateArray)).call.apply(_ref3, [this].concat(args))), _this), _this.onItemClick = function (id, valueIndex) {
	            var isPresent = typeof valueIndex === 'number';
	            if (isPresent) {
	                _this.props.fields.remove(valueIndex);
	            } else {
	                _this.props.fields.push(id);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_MessageTemplateArray, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchMessages();
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _this2 = this;
	
	            var _props = this.props,
	                ids = _props.ids,
	                fields = _props.fields,
	                reqStatus = _props.reqStatus,
	                trigger = _props.trigger;
	
	            if (!Array.isArray(ids) || !(0, _helpers.responseStatusIsOk)(reqStatus)) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: 'center' } },
	                    _react2.default.createElement(_error2.default, null),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { marginLeft: 12 } },
	                        'Error while fetching messages'
	                    )
	                );
	            }
	            if (!trigger) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'No trigger selected'
	                );
	            }
	            if (!ids.length) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'No message templates for trigger type: ',
	                    (0, _humanizeString2.default)(trigger)
	                );
	            }
	            var allValues = fields.getAll();
	            var valArr = Array.isArray(allValues) ? allValues : [];
	            var notSelectedIds = _lodash2.default.difference(ids, valArr);
	            return _react2.default.createElement(
	                'div',
	                null,
	                'Message templates',
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '400px', overflow: 'hidden' } },
	                        valArr.map(function (id, index) {
	                            return _react2.default.createElement(MessageTemplate, {
	                                key: id,
	                                id: id,
	                                leftIcon: _react2.default.createElement(_remove2.default, null),
	                                onClick: function onClick() {
	                                    return _this2.onItemClick(id, index);
	                                }
	                            });
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '400px', overflow: 'hidden' } },
	                        notSelectedIds.map(function (id) {
	                            return _react2.default.createElement(MessageTemplate, {
	                                key: id,
	                                id: id,
	                                leftIcon: _react2.default.createElement(_add2.default, null),
	                                onClick: function onClick() {
	                                    return _this2.onItemClick(id);
	                                }
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isPending = this.props.isPending;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                isPending ? _react2.default.createElement(
	                    'div',
	                    null,
	                    'Loading message templates',
	                    _react2.default.createElement(_materialUi.LinearProgress, null)
	                ) : this.renderItems()
	            );
	        }
	    }]);
	
	    return _MessageTemplateArray;
	}(_react2.default.PureComponent));
	
	exports.default = MessageTemplateArray;

/***/ },
/* 1862 */,
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateMessage = exports.deleteMessage = exports.createMessage = exports.fetchMessages = exports.generateTitle = undefined;
	
	var _actions = __webpack_require__(593);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INTERPOLATION_REGEX = /\${[^}]*\}/g;
	var generateTitle = exports.generateTitle = function generateTitle(template) {
	    return template.replace(INTERPOLATION_REGEX, '...');
	};
	
	var fetchMessages = exports.fetchMessages = function fetchMessages(trigger) {
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.message_service.host + '/messages?access_token=' + _auth2.default.getAccessToken() + (trigger ? '&trigger=' + trigger : ''),
	        update: {
	            messageTemplates: _actions.UPDATE_DEFAULT.MERGE
	        },
	        transform: function transform(body) {
	            return {
	                messageTemplates: body.reduce(function (acc, el) {
	                    acc[el._id] = el;
	                    return acc;
	                }, {})
	            };
	        },
	        list: function list(body) {
	            return _defineProperty({}, trigger ? 'messageTemplates/' + trigger : 'messageTemplates', function () {
	                return (0, _helpers.toIdArray)(body);
	            });
	        },
	        queryKey: trigger ? 'GET:messageTemplates/' + trigger : 'GET:messageTemplates'
	    });
	};
	
	var createMessage = exports.createMessage = function createMessage(message) {
	    var secondaryKey = 'messageTemplates/' + message.trigger;
	    return (0, _actions.requestAsync)({
	        url: _cfg2.default.message_service.host + '/messages?access_token=' + _auth2.default.getAccessToken(),
	        body: message,
	        queryKey: 'POST:messageTemplates',
	        list: function list(body) {
	            return _defineProperty({
	                messageTemplates: function messageTemplates(prevList) {
	                    return [body._id].concat(prevList);
	                }
	            }, secondaryKey, function (prevList) {
	                return [body._id].concat(prevList);
	            });
	        },
	        transform: function transform(body) {
	            return {
	                messageTemplates: _defineProperty({}, body._id, body)
	            };
	        },
	        update: {
	            messageTemplates: _actions.UPDATE_DEFAULT.MERGE
	        },
	        options: {
	            method: _actions.httpMethods.POST
	        }
	    });
	};
	
	var deleteMessage = exports.deleteMessage = function deleteMessage(messageId) {
	    return function (dispatch, getState) {
	        var _getState = getState(),
	            requery = _getState.requery;
	
	        var triggerType = _lodash2.default.get(requery, ['entities', 'messageTemplates', messageId, 'trigger']);
	        var secondKey = 'messageTemplates/' + triggerType;
	        var action = (0, _actions.requestAsync)({
	            url: _cfg2.default.message_service.host + '/messages/' + messageId + '?access_token=' + _auth2.default.getAccessToken(),
	            queryKey: 'DELETE:messageTemplates/' + messageId,
	            list: function list(body) {
	                return _defineProperty({
	                    messageTemplates: function messageTemplates(prevList) {
	                        return prevList.filter(function (e) {
	                            return e !== messageId;
	                        });
	                    }
	                }, secondKey, function (prevList) {
	                    return prevList.filter(function (e) {
	                        return e !== messageId;
	                    });
	                });
	            },
	            transform: function transform(body) {
	                return {
	                    messageTemplates: {}
	                };
	            },
	            update: {
	                messageTemplates: _actions.UPDATE_DEFAULT.MERGE
	            },
	            options: {
	                method: _actions.httpMethods.DELETE
	            }
	        });
	        return dispatch(action);
	    };
	};
	
	var updateMessage = exports.updateMessage = function updateMessage(message) {
	    return function (dispatch, getState) {
	        var _id = message._id;
	
	        var action = (0, _actions.requestAsync)({
	            url: _cfg2.default.message_service.host + '/messages/' + _id + '?access_token=' + _auth2.default.getAccessToken(),
	            body: message,
	            queryKey: 'PUT:messageTemplates/' + _id,
	            list: function list(body) {
	                return {};
	            },
	            transform: function transform(body) {
	                return {
	                    messageTemplates: _defineProperty({}, body._id, body)
	                };
	            },
	            update: {
	                messageTemplates: _actions.UPDATE_DEFAULT.MERGE
	            },
	            options: {
	                method: _actions.httpMethods.PUT
	            }
	        });
	        return dispatch(action);
	    };
	};

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.allPermissionsPresent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allPermissionsPresent = exports.allPermissionsPresent = function allPermissionsPresent(feature, userData) {
	    var permissions = userData && userData.permissions;
	    return permissions && _lodash2.default.castArray(feature).every(function (feature) {
	        return permissions[feature];
	    });
	};
	
	var Feature = (0, _reactRedux.connect)(function (state, _ref) {
	    var feature = _ref.feature;
	    return {
	        hasPermission: allPermissionsPresent(feature, state.user)
	    };
	})(function (_ref2) {
	    var _ref2$component = _ref2.component,
	        component = _ref2$component === undefined ? null : _ref2$component,
	        hasPermission = _ref2.hasPermission,
	        children = _ref2.children;
	    return hasPermission ? children : component;
	});
	
	Feature.propTypes = {
	    feature: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	    component: _propTypes2.default.node
	};
	
	exports.default = Feature;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _emojiMart = __webpack_require__(1601);
	
	var _helpers = __webpack_require__(1821);
	
	var _Popover = __webpack_require__(949);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _insertEmoticon = __webpack_require__(1633);
	
	var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);
	
	__webpack_require__(1634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldWithRef = function (_React$PureComponent) {
	    _inherits(TextFieldWithRef, _React$PureComponent);
	
	    function TextFieldWithRef() {
	        _classCallCheck(this, TextFieldWithRef);
	
	        return _possibleConstructorReturn(this, (TextFieldWithRef.__proto__ || Object.getPrototypeOf(TextFieldWithRef)).apply(this, arguments));
	    }
	
	    _createClass(TextFieldWithRef, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                inputRef = _props.inputRef,
	                _props$emojiTextField = _props.emojiTextFieldStyle,
	                emojiTextFieldStyle = _props$emojiTextField === undefined ? {} : _props$emojiTextField,
	                _props$emojiTextField2 = _props.emojiTextFieldTextareaStyle,
	                emojiTextFieldTextareaStyle = _props$emojiTextField2 === undefined ? {} : _props$emojiTextField2,
	                rest = _objectWithoutProperties(_props, ['inputRef', 'emojiTextFieldStyle', 'emojiTextFieldTextareaStyle']);
	
	            return _react2.default.createElement(_reduxFormMaterialUi.TextField, _extends({}, rest, {
	                ref: inputRef,
	                style: emojiTextFieldStyle,
	                textareaStyle: emojiTextFieldTextareaStyle
	            }));
	        }
	    }]);
	
	    return TextFieldWithRef;
	}(_react2.default.PureComponent);
	
	TextFieldWithRef.propTypes = {
	    inputRef: _propTypes2.default.func,
	    emojiTextFieldStyle: _propTypes2.default.object,
	    emojiTextFieldTextareaStyle: _propTypes2.default.object
	};
	
	/**
	 * Redux form text field with emoji
	 */
	
	var REmojiPicker = function (_React$PureComponent2) {
	    _inherits(REmojiPicker, _React$PureComponent2);
	
	    function REmojiPicker() {
	        var _ref;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, REmojiPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = REmojiPicker.__proto__ || Object.getPrototypeOf(REmojiPicker)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	            showEmojiPicker: false
	        }, _this2.assignRef = function (el) {
	            if (el) {
	                if (el.refs.component.input instanceof Node) {
	                    _this2.input = el.refs.component.input;
	                } else {
	                    _this2.input = el.refs.component.input.refs.input;
	                }
	            }
	        }, _this2.toggleEmoji = function (event) {
	            event.persist();
	
	            _this2.setState(function (_ref2) {
	                var showEmojiPicker = _ref2.showEmojiPicker;
	                return {
	                    showEmojiPicker: !showEmojiPicker,
	                    anchorElem: event.target
	                };
	            });
	        }, _this2.close = function () {
	            return _this2.setState({ showEmojiPicker: false });
	        }, _this2.addEmoji = function (emoji) {
	            var native = emoji.native;
	
	            if (_this2.input) {
	                var _this3 = _this2,
	                    input = _this3.input;
	
	                var nextSelectionStart = (input.value.slice(0, input.selectionStart) + native).length;
	                var value = input.value.slice(0, input.selectionStart) + native + input.value.slice(input.selectionStart, input.value.length);
	                var _this2$context$_redux = _this2.context._reduxForm,
	                    dispatch = _this2$context$_redux.dispatch,
	                    sectionPrefix = _this2$context$_redux.sectionPrefix,
	                    change = _this2$context$_redux.change;
	                var name = _this2.props.name;
	
	
	                dispatch(change((0, _helpers.getFieldPath)(sectionPrefix, name), value));
	                // restore the caret not to be at the end of the line
	                setTimeout(function () {
	                    return input.setSelectionRange(nextSelectionStart, nextSelectionStart);
	                }, 0);
	            }
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(REmojiPicker, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                name = _props2.name,
	                _props2$emojiIconColo = _props2.emojiIconColor,
	                emojiIconColor = _props2$emojiIconColo === undefined ? 'currentcolor' : _props2$emojiIconColo,
	                _props2$emojiIconHove = _props2.emojiIconHoverColor,
	                emojiIconHoverColor = _props2$emojiIconHove === undefined ? 'currentcolor' : _props2$emojiIconHove,
	                rest = _objectWithoutProperties(_props2, ['name', 'emojiIconColor', 'emojiIconHoverColor']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: 'flex-end' } },
	                    _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, inputRef: this.assignRef, component: TextFieldWithRef })),
	                    _react2.default.createElement(
	                        _IconButton2.default,
	                        { onTouchTap: this.toggleEmoji },
	                        _react2.default.createElement(_insertEmoticon2.default, { color: emojiIconColor, hoverColor: emojiIconHoverColor })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        open: this.state.showEmojiPicker,
	                        anchorEl: this.state.anchorElem,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: this.close
	                    },
	                    _react2.default.createElement(_emojiMart.Picker, { onClick: this.addEmoji })
	                )
	            );
	        }
	    }]);
	
	    return REmojiPicker;
	}(_react2.default.PureComponent);
	
	REmojiPicker.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	};
	
	
	REmojiPicker.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    emojiIconColor: _propTypes2.default.string,
	    emojiIconHoverColor: _propTypes2.default.string,
	    emojiTextFieldStyle: _propTypes2.default.object,
	    emojiTextFieldTextareaStyle: _propTypes2.default.object
	};
	
	exports.default = REmojiPicker;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(910);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error = function Error(_ref) {
	    var value = _ref.value,
	        index = _ref.index;
	
	    if (!value) {
	        return _react2.default.createElement('span', null);
	    }
	    var indexText = typeof index !== 'undefined' ? Number(index + 1) + '. ' : '';
	    if (typeof value === 'string') {
	        return _react2.default.createElement(
	            'small',
	            { style: { color: _colors.red500 } },
	            indexText,
	            value
	        );
	    }
	    var errmsg = value.errmsg;
	
	    if (typeof errmsg === 'string') {
	        return _react2.default.createElement(
	            'p',
	            { style: { color: _colors.red500 } },
	            errmsg
	        );
	    }
	    if (Array.isArray(value)) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            value.map(function (obj, index) {
	                return _react2.default.createElement(Error, { key: index, value: obj, index: index });
	            })
	        );
	    }
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        var errors = Object.keys(value).reduce(function (acc, cur) {
	            if (typeof value[cur] === 'string') {
	                var errorKeyText = cur !== '_error' ? (0, _humanizeString2.default)(cur) + ': ' : '';
	                var elem = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'small',
	                        { style: { color: _colors.red500 }, key: cur },
	                        indexText,
	                        errorKeyText,
	                        value[cur]
	                    )
	                );
	                acc.push(elem);
	            } else {
	                acc.push(_react2.default.createElement(Error, { value: value[cur], index: index }));
	            }
	            return acc;
	        }, []);
	        return _react2.default.createElement(
	            'div',
	            null,
	            errors.map(function (el, index) {
	                return _react2.default.cloneElement(el, { key: index });
	            })
	        );
	    }
	    return _react2.default.createElement('span', null);
	};
	
	exports.default = Error;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReadableCondition = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _colors = __webpack_require__(910);
	
	var _error = __webpack_require__(1068);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _constants = __webpack_require__(579);
	
	var _selectors = __webpack_require__(618);
	
	var _actions = __webpack_require__(1047);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var space = _react2.default.createElement(
	    'span',
	    null,
	    '\xA0'
	);
	var wrapperStyle = {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center'
	};
	
	var chipStyle = {
	    margin: 4
	};
	
	var infoChipCommon = {
	    style: chipStyle,
	    backgroundColor: _colors.lightBlue300
	};
	
	var isAny = function isAny(value) {
	    return !value || value === ' ' || value === '*';
	};
	
	/**
	 * Chip proxy with styles
	 */
	var InfoChip = function InfoChip(props) {
	    var propStyles = props.style,
	        restProps = _objectWithoutProperties(props, ['style']);
	
	    var commonStyles = infoChipCommon.style;
	
	    var style = _extends({}, commonStyles, propStyles);
	    return _react2.default.createElement(_materialUi.Chip, _extends({}, infoChipCommon, { style: style }, restProps));
	};
	var Label = function Label(_ref) {
	    var value = _ref.value,
	        requestFinished = _ref.requestFinished,
	        requestPending = _ref.requestPending;
	
	    if (!requestFinished && requestPending) {
	        return _react2.default.createElement(_materialUi.CircularProgress, { size: 20 });
	    }
	    if (requestFinished && !value) {
	        return _react2.default.createElement(_error2.default, null);
	    }
	    return _react2.default.createElement(
	        'span',
	        null,
	        value
	    );
	};
	
	/**
	 * HOC lifecycle with fetch updates
	 * @param {*} propKey
	 * @param {*} fetch
	 */
	var getLifeCycleUpdates = function getLifeCycleUpdates(propKey, fetch) {
	    return (0, _recompose.lifecycle)({
	        componentDidMount: function componentDidMount() {
	            var prop = this.props[propKey];
	
	            if (!isAny(prop)) {
	                var dispatch = this.props.dispatch;
	
	                dispatch(fetch(prop));
	            }
	        },
	        componentWillReceiveProps: function componentWillReceiveProps(_ref2) {
	            var prop = _ref2[propKey];
	
	            if (!isAny(prop)) {
	                var dispatch = this.props.dispatch;
	
	                dispatch(fetch(prop));
	            }
	        }
	    });
	};
	/**
	 * @param {String} storeKey
	 * @param {String} propKey
	 * @returns {function}
	 */
	var getMapStateToProps = function getMapStateToProps(storeKey, propKey) {
	    return function (state, _ref3) {
	        var prop = _ref3[propKey];
	
	        var value = _lodash2.default.get((0, _selectors.getEntities)(state)[storeKey], '[' + prop + '].name');
	        var requestFinished = _lodash2.default.get((0, _selectors.getQueries)(state)[storeKey + '/' + prop], 'isFinished');
	        var requestPending = _lodash2.default.get((0, _selectors.getQueries)(state)[storeKey + '/' + prop], 'isPending');
	        return { value: value, requestFinished: requestFinished, requestPending: requestPending };
	    };
	};
	
	/**
	 * Components for diplaying additional
	 * data from server with fetch logic
	 */
	
	/**
	 * Tournaments Component
	 */
	var TT_KEY = _constants.STORE_KEYS.TOURNAMENTS + _constants.STORE_KEYS.BY_ID;
	var tournamentLabelEnhancer = (0, _recompose.compose)((0, _reactRedux.connect)(getMapStateToProps(TT_KEY, 'tournamentId')), getLifeCycleUpdates('tournamentId', _actions.fetchTournamentById), _recompose.pure);
	var TtLabelEnhanced = tournamentLabelEnhancer(Label);
	TtLabelEnhanced.propTypes = {
	    // eslint-disable-next-line
	    tournamentId: _propTypes2.default.any
	};
	
	/**
	 * Teams Component
	 */
	var teamsLabelEnhancer = (0, _recompose.compose)((0, _reactRedux.connect)(getMapStateToProps(_constants.STORE_KEYS.TEAMS, 'teamId')), getLifeCycleUpdates('teamId', _actions.fetchTeamById), _recompose.pure);
	var TeamsLabelEnhanced = teamsLabelEnhancer(Label);
	TeamsLabelEnhanced.propTypes = {
	    // eslint-disable-next-line
	    teamId: _propTypes2.default.any
	};
	
	/**
	 * Events Component
	 */
	var EVENTS_KEY = _constants.STORE_KEYS.EVENTS;
	var mapStateToEvents = function mapStateToEvents(state, _ref4) {
	    var eventId = _ref4.eventId;
	
	    var value1 = _lodash2.default.get((0, _selectors.getEntities)(state)[EVENTS_KEY], '[' + eventId + '].homeName');
	    var value2 = _lodash2.default.get((0, _selectors.getEntities)(state)[EVENTS_KEY], '[' + eventId + '].awayName');
	    var value = value1 && value2 ? value1 + ' - ' + value2 : undefined;
	    var requestFinished = _lodash2.default.get((0, _selectors.getQueries)(state)[EVENTS_KEY + '/' + eventId], 'isFinished');
	    var requestPending = _lodash2.default.get((0, _selectors.getQueries)(state)[EVENTS_KEY + '/' + eventId], 'isPending');
	    return { value: value, requestFinished: requestFinished, requestPending: requestPending };
	};
	var eventLabelEnhancer = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToEvents), getLifeCycleUpdates('eventId', _actions.fetchEventById), _recompose.pure);
	var EventLabelEnhanced = eventLabelEnhancer(Label);
	EventLabelEnhanced.propTypes = {
	    // eslint-disable-next-line
	    eventId: _propTypes2.default.any
	};
	
	var tournamentIdResolver = function tournamentIdResolver(tournamentId) {
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'in',
	        space,
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            _react2.default.createElement(TtLabelEnhanced, { tournamentId: tournamentId })
	        )
	    );
	};
	
	var timeResolver = function timeResolver(time) {
	    var isMinute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var appendix = isMinute ? 'minute(s)' : 'time';
	    var label = isAny(time) ? 'any ' + appendix : time;
	
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'at ',
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            label
	        ),
	        isMinute && appendix
	    );
	};
	
	var dateTimeResolver = function dateTimeResolver(time) {
	    var label = isAny(time) ? 'any ' + 'time' : time;
	
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'at ',
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            label
	        )
	    );
	};
	
	var incidentTypeResolver = function incidentTypeResolver(incidentType) {
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            (0, _humanizeString2.default)(incidentType)
	        ),
	        ' incident'
	    );
	};
	
	var statusResolver = function statusResolver(status) {
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'when status',
	        space,
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            (0, _humanizeString2.default)(status)
	        )
	    );
	};
	
	var roundResolver = function roundResolver(round) {
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'in',
	        space,
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            (0, _humanizeString2.default)(round)
	        ),
	        space,
	        'round'
	    );
	};
	
	var teamsResolver = function teamsResolver(homeId, awayId) {
	    var getTeam = function getTeam(id) {
	        return !isAny(id) ? _react2.default.createElement(TeamsLabelEnhanced, { teamId: id }) : '*';
	    };
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'in match',
	        ' ',
	        _react2.default.createElement(
	            InfoChip,
	            { labelStyle: _helpers.yCenter },
	            getTeam(homeId),
	            ' - ',
	            getTeam(awayId)
	        )
	    );
	};
	
	var eventIdResolver = function eventIdResolver(eventId) {
	    var all = isAny(eventId);
	    if (all) {
	        return _react2.default.createElement(
	            'span',
	            { style: wrapperStyle },
	            space,
	            'in ',
	            _react2.default.createElement(
	                InfoChip,
	                null,
	                'any'
	            ),
	            ' event'
	        );
	    }
	    return _react2.default.createElement(
	        'span',
	        { style: wrapperStyle },
	        space,
	        'in event',
	        ' ',
	        _react2.default.createElement(
	            InfoChip,
	            null,
	            _react2.default.createElement(EventLabelEnhanced, { eventId: eventId })
	        )
	    );
	};
	
	var jsxArrToInline = function jsxArrToInline(arr) {
	    return (
	        // eslint-disable-next-line
	        _react2.default.createElement(
	            'div',
	            { style: wrapperStyle },
	            arr.map(function (el, index) {
	                return _react2.default.cloneElement(el, { key: index });
	            })
	        )
	    );
	};
	
	/**
	 * Function for resolving beauty node
	 * depending on triggerType and condition map
	 * @param {*} condition
	 * @param {*} triggerType
	 * @returns {JSX.Element}
	 */
	var resolveNodeByConditinon = function resolveNodeByConditinon(condition, triggerType) {
	    var result = [];
	
	    var _ref5 = condition || {},
	        ttId = _ref5.ttId,
	        eventId = _ref5.eventId,
	        homeId = _ref5.homeId,
	        awayId = _ref5.awayId,
	        incidentType = _ref5.incident_type,
	        time = _ref5.time,
	        dateTime = _ref5.dateTime,
	        status = _ref5.status,
	        round = _ref5.round,
	        minutes = _ref5.minutes;
	
	    switch (triggerType) {
	        case 'enet_event_incident':
	            if (incidentType) {
	                result.push(incidentTypeResolver(incidentType));
	            }
	            if (ttId) {
	                result.push(tournamentIdResolver(ttId));
	            }
	            if (eventId) {
	                result.push(eventIdResolver(eventId));
	            }
	            if (homeId || awayId) {
	                result.push(teamsResolver(homeId, awayId));
	            }
	            return jsxArrToInline(result);
	        case 'enet_event_status':
	            if (ttId) {
	                result.push(tournamentIdResolver(ttId));
	            }
	            if (eventId) {
	                result.push(eventIdResolver(eventId));
	            }
	            if (homeId || awayId) {
	                result.push(teamsResolver(homeId, awayId));
	            }
	            if (status) {
	                result.push(statusResolver(status));
	            }
	            return jsxArrToInline(result);
	        case 'schedule':
	            return timeResolver(time);
	        case 'time':
	            return dateTimeResolver(dateTime);
	        case 'tourn_match_day':
	            result.push(timeResolver(time));
	            result.push(_react2.default.createElement(
	                'span',
	                null,
	                space,
	                'when there are matches'
	            ));
	            if (ttId) {
	                result.push(tournamentIdResolver(ttId));
	            }
	            return jsxArrToInline(result);
	        case 'tourn_round_starts':
	        case 'tourn_round_ends':
	            if (ttId) {
	                result.push(tournamentIdResolver(ttId));
	            }
	            if (time) {
	                result.push(timeResolver(time));
	            }
	            if (round) {
	                result.push(roundResolver(round));
	            }
	            return jsxArrToInline(result);
	        case 'event_starts':
	        case 'event_halftime':
	        case 'event_finished':
	        case 'event_test':
	            if (ttId) {
	                result.push(tournamentIdResolver(ttId));
	            }
	            if (eventId) {
	                result.push(eventIdResolver(eventId));
	            }
	            if (minutes) {
	                result.push(timeResolver(minutes, true));
	            }
	            return jsxArrToInline(result);
	        default:
	            return _react2.default.createElement('span', null);
	    }
	};
	
	var ReadableCondition = exports.ReadableCondition = function (_React$Component) {
	    _inherits(ReadableCondition, _React$Component);
	
	    function ReadableCondition() {
	        _classCallCheck(this, ReadableCondition);
	
	        return _possibleConstructorReturn(this, (ReadableCondition.__proto__ || Object.getPrototypeOf(ReadableCondition)).apply(this, arguments));
	    }
	
	    _createClass(ReadableCondition, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(_ref6) {
	            var triggerType = _ref6.triggerType,
	                condition = _ref6.condition;
	
	            return this.props.triggerType !== triggerType || !_lodash2.default.isEqual(condition, this.props.condition);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                triggerType = _props.triggerType,
	                condition = _props.condition;
	
	
	            if (!triggerType || (typeof condition === 'undefined' ? 'undefined' : _typeof(condition)) !== 'object') {
	                return _react2.default.createElement('div', null);
	            }
	
	            var node = resolveNodeByConditinon(condition, triggerType);
	            return _react2.default.createElement(
	                'div',
	                null,
	                node
	            );
	        }
	    }]);
	
	    return ReadableCondition;
	}(_react2.default.Component);
	
	ReadableCondition.propTypes = {
	    condition: _propTypes2.default.object,
	    triggerType: _propTypes2.default.string
	};

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _constants = __webpack_require__(579);
	
	var _validation = __webpack_require__(1660);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var onTargetAdd = function onTargetAdd(fields) {
	    return function () {
	        return fields.push(_defineProperty({}, _constants.CAMPAIGN_FORM_KEYS.TARGETS.TYPE, 'smlink'));
	    };
	};
	
	var onRemoveTarget = function onRemoveTarget(fields, index) {
	    return function () {
	        if (fields.length > 1) {
	            fields.remove(index);
	        }
	    };
	};
	
	var getFilteredTargets = function getFilteredTargets(targets, selectedTargets, currentIndex) {
	    var unneededTargets = selectedTargets.filter(function (el, index) {
	        return index !== currentIndex;
	    });
	    return targets.filter(function (target) {
	        return !unneededTargets.some(function (unneed) {
	            return unneed[_constants.CAMPAIGN_FORM_KEYS.TARGETS.VALUE] === target._id;
	        });
	    });
	};
	
	var renderSingleTarget = function renderSingleTarget(target) {
	    return _react2.default.createElement(_materialUi.MenuItem, {
	        key: target._id,
	        primaryText: target.title,
	        value: target._id
	    });
	};
	
	var renderSingleTargetField = function renderSingleTargetField() {
	    var targets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var onRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;
	
	    return _react2.default.createElement(
	        'div',
	        { style: _helpers.yCenter },
	        _react2.default.createElement(
	            _reduxForm.Field,
	            {
	                name: _constants.CAMPAIGN_FORM_KEYS.TARGETS.VALUE,
	                validate: _validation.presence,
	                floatingLabelText: 'Select account',
	                component: _reduxFormMaterialUi.SelectField
	            },
	            targets.map(renderSingleTarget)
	        ),
	        _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	                style: { marginLeft: 12, marginTop: 12 },
	                onTouchTap: onRemove
	            },
	            _react2.default.createElement(_delete2.default, null)
	        )
	    );
	};
	
	var renderTargetsControl = function renderTargetsControl(_ref) {
	    var fields = _ref.fields,
	        _ref$targets = _ref.targets,
	        targets = _ref$targets === undefined ? [] : _ref$targets,
	        _ref$selectedTargets = _ref.selectedTargets,
	        selectedTargets = _ref$selectedTargets === undefined ? [] : _ref$selectedTargets;
	
	    if (!fields.length) {
	        onTargetAdd(fields)();
	    }
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'p',
	            null,
	            'Social media targets'
	        ),
	        fields.map(function (name, index) {
	            var onRemove = onRemoveTarget(fields, index);
	            var filteredTargets = getFilteredTargets(targets, selectedTargets, index);
	            var targetComponent = renderSingleTargetField(filteredTargets, onRemove);
	            return _react2.default.createElement(
	                'div',
	                { key: name, style: _helpers.yCenter },
	                _react2.default.createElement(
	                    'span',
	                    { style: { marginRight: 12, marginTop: 24 } },
	                    index + 1,
	                    '.'
	                ),
	                _react2.default.createElement(
	                    _reduxForm.FormSection,
	                    { name: name },
	                    targetComponent
	                )
	            );
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            label: 'Add target',
	            icon: _react2.default.createElement(_add2.default, null),
	            onTouchTap: onTargetAdd(fields)
	        })
	    );
	};
	
	var TargetsForm = function TargetsForm(_ref2) {
	    var _ref2$targets = _ref2.targets,
	        targets = _ref2$targets === undefined ? [] : _ref2$targets,
	        _ref2$selectedTargets = _ref2.selectedTargets,
	        selectedTargets = _ref2$selectedTargets === undefined ? [] : _ref2$selectedTargets;
	
	    return _react2.default.createElement(_reduxForm.FieldArray, {
	        name: _constants.CAMPAIGN_FORM_KEYS.TARGETS.ARRAY,
	        targets: targets,
	        selectedTargets: selectedTargets,
	        component: renderTargetsControl
	    });
	};
	
	exports.default = TargetsForm;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _add = __webpack_require__(1066);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _facebookMessengerAsyncInit = __webpack_require__(1870);
	
	var _facebookMessengerAsyncInit2 = _interopRequireDefault(_facebookMessengerAsyncInit);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _validation = __webpack_require__(1660);
	
	var _helpers = __webpack_require__(1821);
	
	var _MessengerOptin = __webpack_require__(1871);
	
	var _MessengerOptin2 = _interopRequireDefault(_MessengerOptin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var appId = _cfg2.default.bots.messenger.appId;
	
	
	var NOTIF_KEYS = _constants.CAMPAIGN_FORM_KEYS.NOTIFICATIONS;
	var onAdd = function onAdd(fields, type) {
	  return function () {
	    return fields.push(_defineProperty({}, NOTIF_KEYS.TYPE, type));
	  };
	};
	
	var NotificationsArray = function NotificationsArray(_ref) {
	  var fields = _ref.fields;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    !fields.length && _react2.default.createElement(
	      "div",
	      {
	        style: {
	          fontSize: "0.9em",
	          color: "rgba(0, 0, 0, 0.4)",
	          margin: "0px 16px"
	        }
	      },
	      _react2.default.createElement(
	        "i",
	        null,
	        "No subscribers"
	      )
	    ),
	    fields.map(function (name, index) {
	      var onRemove = function onRemove() {
	        return fields.remove(index);
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { key: name },
	        _react2.default.createElement(
	          _reduxForm.FormSection,
	          { name: name, style: _helpers.yCenter },
	          _react2.default.createElement(
	            "span",
	            { style: { marginRight: 12, marginTop: 24 } },
	            index + 1,
	            "."
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: NOTIF_KEYS.VALUE,
	            validate: _validation.presence,
	            floatingLabelText: "Email",
	            component: _reduxFormMaterialUi.TextField
	          }),
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	              style: { marginLeft: 12, marginTop: 24 },
	              onTouchTap: onRemove
	            },
	            _react2.default.createElement(_delete2.default, null)
	          )
	        )
	      );
	    }),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(_materialUi.FlatButton, {
	      primary: true,
	      label: "Add subscription",
	      icon: _react2.default.createElement(_add2.default, null),
	      onTouchTap: onAdd(fields, "email")
	    })
	  );
	};
	
	var MessengerNotificationsArray = function (_React$PureComponent) {
	  _inherits(MessengerNotificationsArray, _React$PureComponent);
	
	  function MessengerNotificationsArray() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessengerNotificationsArray);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MessengerNotificationsArray.__proto__ || Object.getPrototypeOf(MessengerNotificationsArray)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      showMessengerOptin: false
	    }, _this.handleCheck = function (userRef) {
	      var _this$state = _this.state,
	          userId = _this$state.userId,
	          userName = _this$state.userName,
	          userPhoto = _this$state.userPhoto;
	      var fields = _this.props.fields;
	
	      fields.push({
	        userRef: userRef,
	        userName: userName,
	        userId: userId,
	        userPhoto: userPhoto
	      });
	    }, _this.handleUncheck = function (userRef) {
	      var fields = _this.props.fields;
	
	
	      var index = fields.getAll().findIndex(function (f) {
	        return f.userRef === userRef;
	      });
	
	      if (index > -1) fields.remove(index);
	    }, _this.setUserInfo = function () {
	      window.FB.api("/me", { fields: "last_name,first_name,picture,id" }, function (response) {
	        if (!response.error) {
	          _this.setState({
	            userName: response.first_name + " " + response.last_name,
	            userId: response.id,
	            showMessengerOptin: true,
	            initialized: true,
	            userPhoto: _lodash2.default.get(response, "picture.data.url")
	          });
	        } else {
	          _this.setState({ showMessengerOptin: true });
	        }
	      });
	    }, _this.handleMessengerNotificationButtonClick = function () {
	      if (!window.FB) return;
	
	      if ((window.FB.getAccessToken() || "").length > 0) {
	        _this.setUserInfo();
	      } else {
	        window.FB.login(function (response) {
	          if (response.authResponse) {
	            this.setUserInfo();
	          } else {}
	        }.bind(_this));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MessengerNotificationsArray, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _facebookMessengerAsyncInit2.default)({
	        appId: appId
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var fields = this.props.fields;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !fields.length && _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "0.9em",
	              color: "rgba(0, 0, 0, 0.4)",
	              margin: "0px 16px"
	            }
	          },
	          _react2.default.createElement(
	            "i",
	            null,
	            "No subscribers"
	          )
	        ),
	        fields.map(function (name, index) {
	          var onRemove = function onRemove() {
	            _this2.setState({ showMessengerOptin: false });
	            return fields.remove(index);
	          };
	
	          var field = fields.get(index);
	
	          return _react2.default.createElement(
	            "div",
	            { key: name },
	            _react2.default.createElement(
	              _reduxForm.FormSection,
	              { name: name, style: _helpers.yCenter },
	              _react2.default.createElement(
	                "span",
	                { style: { marginRight: 12, marginTop: 24 } },
	                index + 1,
	                "."
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: { display: "inline-block", marginTop: 24 } },
	                !field.userName && _react2.default.createElement(
	                  "span",
	                  null,
	                  field.userRef
	                ),
	                field.userName && _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        display: "inline-block",
	                        verticalAlign: "middle"
	                      }
	                    },
	                    field.userName
	                  ),
	                  field.userPhoto && _react2.default.createElement("img", {
	                    style: {
	                      width: "30px",
	                      height: "30px",
	                      marginLeft: "10px",
	                      borderRadius: "50%",
	                      display: "inline-block",
	                      verticalAlign: "middle"
	                    },
	                    src: field.userPhoto,
	                    alt: "_"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _materialUi.IconButton,
	                {
	                  style: { marginLeft: 12, marginTop: 24 },
	                  onTouchTap: onRemove
	                },
	                _react2.default.createElement(_delete2.default, null)
	              )
	            )
	          );
	        }),
	        _react2.default.createElement("br", null),
	        this.state.showMessengerOptin && _react2.default.createElement(_MessengerOptin2.default, {
	          onCheck: this.handleCheck,
	          onUncheck: this.handleUncheck
	        }),
	        !this.state.showMessengerOptin && _react2.default.createElement(_materialUi.FlatButton, {
	          primary: true,
	          label: "Add messenger notifications",
	          icon: _react2.default.createElement(_add2.default, null),
	          onTouchTap: this.handleMessengerNotificationButtonClick
	        })
	      );
	    }
	  }]);
	
	  return MessengerNotificationsArray;
	}(_react2.default.PureComponent);
	
	var NotificationsForm = function NotificationsForm() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reduxForm.FieldArray, { name: NOTIF_KEYS.ARRAY, component: NotificationsArray }),
	    _react2.default.createElement(_reduxForm.FieldArray, {
	      name: "messengerNotifications",
	      component: MessengerNotificationsArray
	    })
	  );
	};
	
	exports.default = NotificationsForm;

/***/ },
/* 1870 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (_ref) {
	    var appId = _ref.appId,
	        _ref$callback = _ref.callback,
	        callback = _ref$callback === undefined ? function () {} : _ref$callback;
	
	    window.fbAsyncInit = function () {
	        window.FB.init({
	            appId: appId,
	            xfbml: true,
	            status: true, // check login status
	            cookie: true, // enable cookies to allow the server to access the session
	            // oauth: true,
	            version: 'v3.0'
	        });
	
	        callback();
	
	        //   if (onCheckboxClick) {
	        //     console.log('Add messenger checkbox subscribe')
	        //     window.FB.Event.subscribe("messenger_checkbox", function(e) {
	        //       console.log("ASDASDADADASD DAJSKHDJAKSDHADHASDK");
	        //       if (e.event == "rendered") {
	        //         console.log("Plugin was rendered");
	        //       } else if (e.event == "checkbox") {
	        //         var checkboxState = e.state;
	        //         console.log("MESSENGER OPTIN DAMN");
	        //         // onCheckboxClick(checkboxState);
	        //       } else if (e.event == "hidden") {
	        //         console.log("Plugin was hidden");
	        //       }
	        //     });
	        //   }
	    };
	
	    (function (d, s, id) {
	        var js;
	        var fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id)) {
	            return;
	        }
	        js = d.createElement(s);
	        js.id = id;
	        js.src = 'https://connect.facebook.net/en_US/sdk/debug.js';
	        fjs.parentNode.insertBefore(js, fjs);
	    })(document, 'script', 'facebook-jssdk');
	};

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _randomstring = __webpack_require__(1872);
	
	var _randomstring2 = _interopRequireDefault(_randomstring);
	
	var _facebookMessengerConfirm = __webpack_require__(1898);
	
	var _facebookMessengerConfirm2 = _interopRequireDefault(_facebookMessengerConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _config$bots$messenge = _cfg2.default.bots.messenger,
	    pageId = _config$bots$messenge.pageId,
	    appId = _config$bots$messenge.appId;
	
	var MessengerOptin = function (_React$Component) {
	    _inherits(MessengerOptin, _React$Component);
	
	    function MessengerOptin() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MessengerOptin);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessengerOptin.__proto__ || Object.getPrototypeOf(MessengerOptin)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            checkboxStatus: 'unchecked',
	            prechecked: false,
	            userRef: _randomstring2.default.generate({ length: 48 })
	        }, _this.handleCheckboxClick = function (status) {
	            var userRef = _this.state.userRef;
	
	            _this.setState({
	                checkboxStatus: status
	            }, function () {
	                if (status === 'checked') {
	                    setTimeout(function () {
	                        (0, _facebookMessengerConfirm2.default)({
	                            appId: appId,
	                            pageId: pageId,
	                            userRef: userRef
	                        });
	                        _this.props.onCheck(userRef);
	                    }, 500);
	                } else {
	                    _this.props.onUncheck(userRef);
	                }
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MessengerOptin, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.FB.Event.subscribe('messenger_checkbox', function (e) {
	                if (e.event === 'rendered') {} else if (e.event === 'checkbox') {
	                    var checkboxState = e.state;
	                    this.handleCheckboxClick(checkboxState);
	                } else if (e.event === 'hidden') {}
	            }.bind(this));
	            window.fbAsyncInit();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', {
	                className: 'fb-messenger-checkbox',
	                'data-origin': window.location.origin,
	                'data-page_id': pageId,
	                'data-messenger_app_id': appId,
	                'data-user_ref': this.state.userRef,
	                'data-prechecked': this.state.prechecked,
	                'data-allow_login': 'true',
	                'data-size': 'large'
	            });
	        }
	    }]);
	
	    return MessengerOptin;
	}(_react2.default.Component);
	
	exports.default = MessengerOptin;

/***/ },
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function confirmOptIn(_ref) {
	  var appId = _ref.appId,
	      pageId = _ref.pageId,
	      ref = _ref.ref,
	      userRef = _ref.userRef;
	
	  FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
	    app_id: appId,
	    page_id: pageId,
	    ref: ref,
	    user_ref: userRef
	  });
	};

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reduxForm = __webpack_require__(342);
	
	var _recompose = __webpack_require__(1096);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(1821);
	
	var _helpers2 = __webpack_require__(1049);
	
	var _selectors = __webpack_require__(618);
	
	var _campaigns = __webpack_require__(1822);
	
	var _schema = __webpack_require__(1823);
	
	var _CampaignForm = __webpack_require__(1839);
	
	var _CampaignForm2 = _interopRequireDefault(_CampaignForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Scene = function Scene(_ref) {
	    var dispatch = _ref.dispatch;
	    return _react2.default.createElement(
	        'div',
	        { className: 'wdp-container' },
	        _react2.default.createElement(_CampaignForm2.default, null),
	        _react2.default.createElement(_helpers.RowSection, {
	            hideSplit: true,
	            style: { marginBottom: 16 },
	            rightContent: _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: 'Save', onTouchTap: function onTouchTap() {
	                    return dispatch((0, _reduxForm.submit)(_constants.CAMPAIGN_FORM_ID));
	                } })
	        })
	    );
	};
	/**
	 * This bullshit will be fixed.
	 * Should do this due to the stepper.
	 */
	var onSubmit = function onSubmit(values, dispatch, self) {
	    var syncErrors = self.syncErrors;
	
	    var errorKeys = Object.keys(syncErrors || {});
	    if (errorKeys.length === 0) {
	        var mappedData = (0, _schema.mapData)(values);
	        return dispatch((0, _campaigns.updateCampaign)(mappedData)).then(_helpers2.handleServerError);
	    } else {
	        throw new _reduxForm.SubmissionError({ _error_: 'Check your rules' });
	    }
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref2) {
	    var campaignId = _ref2.params.campaignId;
	
	    var campaign = _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.CAMPAIGNS], '[' + campaignId + ']');
	    var fetchRequest = (0, _selectors.getQueries)(state)[_constants.STORE_KEYS.CAMPAIGNS];
	    var fetchFinished = fetchRequest && fetchRequest.isFinished;
	    return {
	        campaign: campaign,
	        fetchFinished: fetchFinished,
	        initialValues: (0, _reduxForm.getFormInitialValues)(_constants.CAMPAIGN_FORM_ID)(state),
	        submitSucceeded: (0, _reduxForm.hasSubmitSucceeded)(_constants.CAMPAIGN_FORM_ID)(state),
	        submitting: (0, _reduxForm.isSubmitting)(_constants.CAMPAIGN_FORM_ID)(state)
	    };
	};
	
	var EditEnhanced = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var campaignId = this.props.params.campaignId;
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _campaigns.fetchCampaignById)(campaignId));
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(_ref3) {
	        var campaign = _ref3.campaign,
	            dispatch = _ref3.dispatch,
	            fetchFinished = _ref3.fetchFinished,
	            initialValues = _ref3.initialValues,
	            submitSucceeded = _ref3.submitSucceeded,
	            campaignId = _ref3.params.campaignId;
	
	        if (!initialValues && fetchFinished && campaign) {
	            dispatch((0, _reduxForm.initialize)(_constants.CAMPAIGN_FORM_ID, campaign));
	        }
	        if (this.props.submitting && submitSucceeded) {
	            _reactRouter.browserHistory.push('/campaigns/view/' + campaignId);
	        }
	    }
	}), (0, _reduxForm.reduxForm)({
	    form: _constants.CAMPAIGN_FORM_ID,
	    onSubmit: onSubmit,
	    validate: _schema.defValidate
	}))(Scene);
	
	exports.default = EditEnhanced;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(1096);
	
	var _smlinks = __webpack_require__(1107);
	
	var _withPagination = __webpack_require__(1901);
	
	var _CampaignsList = __webpack_require__(1903);
	
	var _CampaignsList2 = _interopRequireDefault(_CampaignsList);
	
	var _enhancers = __webpack_require__(1785);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listEnhancer = (0, _recompose.compose)(_enhancers.withCampaigns, (0, _reactRedux.connect)(function (state) {
	    return { user: state.user };
	}), (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var _props = this.props,
	            dispatch = _props.dispatch,
	            _id = _props.user._id;
	
	        dispatch((0, _withPagination.fetchCampaignsWithPagination)(_id));
	        dispatch((0, _smlinks.fetchSmlinks)());
	    }
	}));
	
	var ListEnhanced = listEnhancer(_CampaignsList2.default);
	
	var Scene = function Scene() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/campaigns/create' },
	            _react2.default.createElement(_materialUi.RaisedButton, { primary: true, style: { margin: '12px 0' }, label: 'Create campaign' })
	        ),
	        _react2.default.createElement(ListEnhanced, null)
	    );
	};
	
	exports.default = Scene;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCampaignsWithPagination = exports.deleteWithPagination = exports.rejectWithPagination = exports.approveWithPagination = exports.fetchPublishedPostsWithPagination = exports.fetchNotPublishedPostsWithPagination = exports.baseFetchPostsPagination = undefined;
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _posts = __webpack_require__(1902);
	
	var _campaigns = __webpack_require__(1822);
	
	var _pagination = __webpack_require__(586);
	
	var _pagination2 = __webpack_require__(1791);
	
	var _selectors = __webpack_require__(618);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updatePagination = function updatePagination(key, ids, count, currentPage) {
	    return function (dispatch) {
	        dispatch({
	            type: _pagination.ACTION_TYPES.SET_PAGINATION_IDS,
	            ids: ids,
	            key: key,
	            currentPage: currentPage
	        });
	        dispatch({
	            type: _pagination.ACTION_TYPES.SET_COUNT,
	            count: count,
	            key: key
	        });
	    };
	};
	
	var getLimitAndSkip = function getLimitAndSkip(currentPage, perPage) {
	    var limit = perPage;
	    var skip = currentPage * perPage;
	    return {
	        limit: limit,
	        skip: skip
	    };
	};
	
	var selectCampaignId = function selectCampaignId(state, postId) {
	    var entities = (0, _selectors.getEntities)(state);
	    var post = entities && entities.posts && entities.posts[postId];
	    if (!post) {
	        throw new Error('no post in state with id: ' + postId);
	    }
	    return post.campaign._id;
	};
	
	var baseFetchPostsPagination = exports.baseFetchPostsPagination = function baseFetchPostsPagination(partialKey, fetchAction) {
	    return function () {
	        for (var _len = arguments.length, campaignIds = Array(_len), _key = 0; _key < _len; _key++) {
	            campaignIds[_key] = arguments[_key];
	        }
	
	        return function (dispatch, getState) {
	            var key = typeof partialKey === 'function' ? partialKey(campaignIds) : partialKey + (campaignIds.length !== 1 ? '' : _lodash2.default.head(campaignIds));
	
	            var _getState = getState(),
	                pagination = _getState.pagination;
	
	            var currentPage = (0, _pagination2.selectCurrentPage)(pagination, key);
	            var perPage = (0, _pagination2.selectPerPage)(pagination, key);
	
	            var _getLimitAndSkip = getLimitAndSkip(currentPage, perPage),
	                limit = _getLimitAndSkip.limit,
	                skip = _getLimitAndSkip.skip;
	
	            return dispatch(fetchAction({ campaignIds: campaignIds, limit: limit, skip: skip, queryKey: 'GET:' + key })).then(function (res) {
	                var body = res.body,
	                    status = res.status;
	
	                if ((0, _helpers.responseStatusIsOk)(status)) {
	                    var count = body.count,
	                        posts = body.posts;
	
	                    var ids = (0, _helpers.toIdArray)(posts);
	                    dispatch(updatePagination(key, ids, count, currentPage));
	                }
	                return res;
	            });
	        };
	    };
	};
	
	var fetchNotPublishedPostsWithPagination = exports.fetchNotPublishedPostsWithPagination = baseFetchPostsPagination('not-published/', _posts.fetchNotPublishedPosts);
	
	var fetchPublishedPostsWithPagination = exports.fetchPublishedPostsWithPagination = baseFetchPostsPagination('published/', _posts.fetchPublishedPosts);
	
	var approveWithPagination = exports.approveWithPagination = function approveWithPagination(postId) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var campaignId = selectCampaignId(state, postId);
	        var pagination = state.pagination;
	
	        var key = 'not-published/' + campaignId;
	        var currentPage = (0, _pagination2.selectCurrentPage)(pagination, key);
	        var ids = (0, _pagination2.selectIds)(pagination, key, currentPage) || [];
	        return dispatch((0, _posts.approvePost)(postId)).then(function (res) {
	            if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                dispatch({
	                    type: _pagination.ACTION_TYPES.SET_PAGINATION_IDS,
	                    ids: [postId].concat(ids.filter(function (id) {
	                        return id !== postId;
	                    })),
	                    currentPage: currentPage,
	                    key: key
	                });
	            }
	            return res;
	        });
	    };
	};
	
	var rejectWithPagination = exports.rejectWithPagination = function rejectWithPagination(postId) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var campaignId = selectCampaignId(state, postId);
	        var pagination = state.pagination;
	
	        var key = 'not-published/' + campaignId;
	        var currentPage = (0, _pagination2.selectCurrentPage)(pagination, key);
	        return dispatch((0, _posts.rejectPost)(postId)).then(function (res) {
	            if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                dispatch({
	                    type: _pagination.ACTION_TYPES.REMOVE_ID_FROM_PAGE,
	                    id: postId,
	                    currentPage: currentPage,
	                    key: key
	                });
	            }
	            return res;
	        });
	    };
	};
	
	var deleteWithPagination = exports.deleteWithPagination = function deleteWithPagination(postId) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var campaignId = selectCampaignId(state, postId);
	        var pagination = state.pagination;
	
	        var key1 = 'not-published/' + campaignId;
	        var currentPage1 = (0, _pagination2.selectCurrentPage)(pagination, key1);
	        var key2 = 'published/' + campaignId;
	        var currentPage2 = (0, _pagination2.selectCurrentPage)(pagination, key2);
	        return dispatch((0, _posts.deletePost)(postId)).then(function (res) {
	            if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                dispatch({
	                    type: _pagination.ACTION_TYPES.REMOVE_ID_FROM_PAGE,
	                    id: postId,
	                    currentPage: currentPage1,
	                    key: key1
	                });
	                dispatch({
	                    type: _pagination.ACTION_TYPES.REMOVE_ID_FROM_PAGE,
	                    id: postId,
	                    currentPage: currentPage2,
	                    key: key2
	                });
	            }
	            return res;
	        });
	    };
	};
	
	var fetchCampaignsWithPagination = exports.fetchCampaignsWithPagination = function fetchCampaignsWithPagination(userId) {
	    return function (dispatch, getState) {
	        var _getState2 = getState(),
	            pagination = _getState2.pagination;
	
	        var key = 'campaigns';
	        var currentPage = (0, _pagination2.selectCurrentPage)(pagination, key);
	        return dispatch((0, _campaigns.fetchCampaigns)(userId)).then(function (res) {
	            var body = res.body;
	
	            if (body && Array.isArray(body.campaigns)) {
	                var campaigns = body.campaigns;
	
	                var ids = (0, _helpers.toIdArray)(campaigns);
	                dispatch({
	                    type: _pagination.ACTION_TYPES.SET_PAGINATION_IDS,
	                    key: 'campaigns',
	                    currentPage: currentPage,
	                    ids: ids
	                });
	            }
	            return res;
	        });
	    };
	};

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.manualCreatePost = exports.retrySendPost = exports.deletePost = exports.rejectPost = exports.updatePost = exports.updatePostMessage = exports.approvePost = exports.fetchPublishedPosts = exports.fetchNotPublishedPosts = exports.baseFetchPosts = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _updatePosts;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _redux = __webpack_require__(260);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers = __webpack_require__(592);
	
	var _actions = __webpack_require__(593);
	
	var _constants = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var POSTS_KEY = _constants.STORE_KEYS.POSTS;
	
	var getTriggerType = function getTriggerType(post) {
	    if (post && typeof post.triggerKey === 'string') {
	        return _lodash2.default.head(post.triggerKey.split('.'));
	    }
	    return null;
	};
	
	var mapPostFromServerData = function mapPostFromServerData(post) {
	    return _lodash2.default.extend({}, post, {
	        triggerType: getTriggerType(post),
	        publications: Array.isArray(post.publications) ? (0, _helpers.toIdArray)(post.publications) : [],
	        facts: (0, _helpers.toIdArray)(post.facts),
	        hasResolvedFacts: post.facts.some(function (f) {
	            return f.message;
	        })
	    });
	};
	
	var transformPosts = function transformPosts(_ref) {
	    var _ref2;
	
	    var posts = _ref.posts;
	    return _ref2 = {}, _defineProperty(_ref2, POSTS_KEY, (0, _redux.compose)(_helpers.toIdMap, function (posts) {
	        return posts.map(mapPostFromServerData);
	    })(posts)), _defineProperty(_ref2, 'publications', (0, _redux.compose)(_helpers.toIdMap, function (posts) {
	        return posts.reduce(function (acc, post) {
	            return acc.concat(post.publications);
	        }, []);
	    })(posts)), _defineProperty(_ref2, 'facts', (0, _redux.compose)(_helpers.toIdMap, function (posts) {
	        return posts.reduce(function (acc, post) {
	            return acc.concat(post.facts);
	        }, []);
	    })(posts)), _ref2;
	};
	
	var transformSinglePost = function transformSinglePost(_ref3) {
	    var _ref4;
	
	    var post = _ref3.post;
	
	    return _ref4 = {}, _defineProperty(_ref4, POSTS_KEY, _defineProperty({}, post._id, mapPostFromServerData(post))), _defineProperty(_ref4, 'publications', Array.isArray(post.publications) ? (0, _helpers.toIdMap)(post.publications) : {}), _defineProperty(_ref4, 'facts', (0, _helpers.toIdMap)(post.facts)), _ref4;
	};
	
	var updatePosts = (_updatePosts = {}, _defineProperty(_updatePosts, POSTS_KEY, _actions.UPDATE_DEFAULT.MERGE), _defineProperty(_updatePosts, 'publications', _actions.UPDATE_DEFAULT.MERGE), _defineProperty(_updatePosts, 'facts', _actions.UPDATE_DEFAULT.MERGE), _updatePosts);
	
	var getFetchUrl = function getFetchUrl(_ref5) {
	    var campaignIds = _ref5.campaignIds,
	        status = _ref5.status,
	        limit = _ref5.limit,
	        skip = _ref5.skip;
	
	    var statusQuery = '';
	    if (typeof status === 'string') {
	        statusQuery = '&status=' + status;
	    } else if ((typeof status === 'undefined' ? 'undefined' : _typeof(status)) === 'object') {
	        statusQuery = '&status=' + JSON.stringify(status);
	    }
	    return _cfg2.default.campaign_manager.host + '/api/posts?access_token=' + _auth2.default.getAccessToken() + '&campaignIds=' + JSON.stringify(campaignIds) + '&limit=' + limit + '&skip=' + skip + statusQuery;
	};
	
	var baseFetchPosts = exports.baseFetchPosts = function baseFetchPosts(postStatus) {
	    return function (_ref6) {
	        var campaignId = _ref6.campaignId,
	            _ref6$campaignIds = _ref6.campaignIds,
	            campaignIds = _ref6$campaignIds === undefined ? [campaignId] : _ref6$campaignIds,
	            _ref6$limit = _ref6.limit,
	            limit = _ref6$limit === undefined ? 10 : _ref6$limit,
	            _ref6$skip = _ref6.skip,
	            skip = _ref6$skip === undefined ? 0 : _ref6$skip,
	            _ref6$force = _ref6.force,
	            force = _ref6$force === undefined ? true : _ref6$force,
	            queryKey = _ref6.queryKey;
	        return (0, _reduxQuery.requestAsync)({
	            url: getFetchUrl({ campaignIds: campaignIds, status: postStatus, limit: limit, skip: skip }),
	            force: force,
	            queryKey: queryKey,
	            transform: transformPosts,
	            update: updatePosts
	        });
	    };
	};
	
	var fetchNotPublishedPosts = exports.fetchNotPublishedPosts = baseFetchPosts(_constants.POST_STATUS.NOT_PUBLISHED);
	var fetchPublishedPosts = exports.fetchPublishedPosts = baseFetchPosts(_constants.POST_STATUS.PUBLISHED);
	
	var approvePost = exports.approvePost = function approvePost(postId) {
	    var url = _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/approve?access_token=' + _auth2.default.getAccessToken();
	    var config = {
	        url: url,
	        queryKey: 'posts/' + postId + '/approve',
	        key: 'POST:' + POSTS_KEY + '/' + postId + '/approve',
	        force: true,
	        transform: function transform(_ref7) {
	            var post = _ref7.post;
	            return transformSinglePost(post);
	        },
	        update: updatePosts,
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        }
	    };
	    return (0, _reduxQuery.requestAsync)(config);
	};
	
	var updatePostMessage = exports.updatePostMessage = function updatePostMessage(postId) {
	    return function (message) {
	        var url = _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '?access_token=' + _auth2.default.getAccessToken();
	        var config = {
	            url: url,
	            body: { message: message },
	            queryKey: 'posts/' + postId + '/update-message',
	            force: true,
	            transform: transformSinglePost,
	            update: updatePosts,
	            options: {
	                method: _reduxQuery.httpMethods.POST
	            }
	        };
	        return (0, _reduxQuery.requestAsync)(config);
	    };
	};
	
	var updatePost = exports.updatePost = function updatePost(postId) {
	    return function (updates) {
	        var url = _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '?access_token=' + _auth2.default.getAccessToken();
	        var config = {
	            url: url,
	            body: updates,
	            queryKey: 'posts/' + postId,
	            force: true,
	            transform: transformSinglePost,
	            update: updatePosts,
	            options: {
	                method: _reduxQuery.httpMethods.PUT
	            }
	        };
	        return (0, _reduxQuery.requestAsync)(config);
	    };
	};
	
	var rejectPost = exports.rejectPost = function rejectPost(postId) {
	    var url = _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/reject?access_token=' + _auth2.default.getAccessToken();
	    var config = {
	        url: url,
	        queryKey: 'posts/' + postId + '/reject',
	        key: POSTS_KEY,
	        force: true,
	        transform: function transform(_ref8) {
	            var post = _ref8.post;
	            return transformSinglePost(post);
	        },
	        update: updatePosts,
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        }
	    };
	    return (0, _reduxQuery.requestAsync)(config);
	};
	
	var deletePost = exports.deletePost = function deletePost(postId) {
	    var url = _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/delete?access_token=' + _auth2.default.getAccessToken();
	    var config = {
	        url: url,
	        queryKey: 'posts/' + postId + '/delete',
	        force: true,
	        transform: function transform(_ref9) {
	            var post = _ref9.post;
	            return transformSinglePost(post);
	        },
	        update: updatePosts,
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        }
	    };
	    return (0, _reduxQuery.requestAsync)(config);
	};
	
	var retrySendPost = exports.retrySendPost = function retrySendPost(postId) {
	    return (0, _reduxQuery.requestAsync)({
	        url: _cfg2.default.campaign_manager.host + '/api/posts/' + postId + '/reset-attempts?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        },
	        transform: transformSinglePost,
	        update: updatePosts
	    });
	};
	
	var manualCreatePost = exports.manualCreatePost = function manualCreatePost(mappedData) {
	    return function (dispatch, getState) {
	        var url = _cfg2.default.campaign_manager.host + '/api/posts?access_token=' + _auth2.default.getAccessToken();
	        var state = getState();
	        mappedData.presentation.params.username = state.user.username;
	        mappedData.presentation.params.client = state.user.client;
	        mappedData.presentation.params.theme = 'default';
	
	        var config = {
	            url: url,
	            body: mappedData,
	            force: true,
	            queryKey: 'manual-create-post',
	            update: {},
	            transform: _lodash2.default.noop,
	            options: {
	                method: _reduxQuery.httpMethods.POST
	            }
	        };
	        return dispatch((0, _reduxQuery.requestAsync)(config));
	    };
	};

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTable = __webpack_require__(1904);
	
	var _rcTable2 = _interopRequireDefault(_rcTable);
	
	var _reactRouter = __webpack_require__(188);
	
	var _materialUi = __webpack_require__(642);
	
	var _placeholders = __webpack_require__(1938);
	
	var _warning = __webpack_require__(1109);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _helpers = __webpack_require__(1821);
	
	var _constants = __webpack_require__(579);
	
	var _SMLink = __webpack_require__(1819);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RC_TABLE_COLUMNS = [{
	    key: _constants.CAMPAIGN_FORM_KEYS.TITLE,
	    dataIndex: _constants.CAMPAIGN_FORM_KEYS.TITLE,
	    title: 'Title',
	    render: function render(value, _ref) {
	        var _id = _ref._id;
	        return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/campaigns/view/' + _id },
	            _react2.default.createElement(_materialUi.MenuItem, { primaryText: value })
	        );
	    }
	}, {
	    key: _constants.CAMPAIGN_FORM_KEYS.ACTIVE,
	    dataIndex: _constants.CAMPAIGN_FORM_KEYS.ACTIVE,
	    render: function render(value) {
	        return _react2.default.createElement(_helpers.BooleanField, { value: value });
	    },
	    title: 'Active'
	}, {
	    key: _constants.CAMPAIGN_FORM_KEYS.MODERATION,
	    dataIndex: _constants.CAMPAIGN_FORM_KEYS.MODERATION,
	    render: function render(value) {
	        return _react2.default.createElement(_helpers.BooleanField, { value: value });
	    },
	    title: 'Moderation'
	}, {
	    key: _constants.CAMPAIGN_FORM_KEYS.TARGETS.ARRAY,
	    dataIndex: _constants.CAMPAIGN_FORM_KEYS.TARGETS.ARRAY,
	    render: function render(targets) {
	        return targets.map(function (target) {
	            return _react2.default.createElement(
	                'div',
	                { key: target.value },
	                _react2.default.createElement(_SMLink.SMLinkTitle, { id: target.value })
	            );
	        });
	    },
	    title: 'Targets'
	}, {
	    key: 'likes',
	    render: function render(_ref2) {
	        var stats = _ref2.stats;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                'This week: ',
	                (0, _get2.default)(stats, 'thisWeek.total.likes', 'n/a')
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                'Last week: ',
	                (0, _get2.default)(stats, 'lastWeek.total.likes', 'n/a')
	            )
	        );
	    },
	    title: 'Likes'
	}, {
	    key: 'views',
	    render: function render(_ref3) {
	        var stats = _ref3.stats;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                'This week: ',
	                (0, _get2.default)(stats, 'thisWeek.facebook.impressions', 'n/a')
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                'Last week: ',
	                (0, _get2.default)(stats, 'lastWeek.facebook.impressions', 'n/a')
	            )
	        );
	    },
	    title: 'FB views'
	}];
	
	var CampaignsList = function (_PureComponent) {
	    _inherits(CampaignsList, _PureComponent);
	
	    function CampaignsList() {
	        _classCallCheck(this, CampaignsList);
	
	        return _possibleConstructorReturn(this, (CampaignsList.__proto__ || Object.getPrototypeOf(CampaignsList)).apply(this, arguments));
	    }
	
	    _createClass(CampaignsList, [{
	        key: 'renderTable',
	        value: function renderTable() {
	            var _props = this.props,
	                campaigns = _props.campaigns,
	                campaignsPending = _props.campaignsPending,
	                campaignsStatus = _props.campaignsStatus;
	
	            var showTable = campaignsPending || Array.isArray(campaigns);
	            var data = Array.isArray(campaigns) ? campaigns : [];
	            if (showTable) {
	                return _react2.default.createElement(_rcTable2.default, {
	                    columns: RC_TABLE_COLUMNS,
	                    data: data,
	                    rowKey: '_id',
	                    emptyText: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_placeholders.TextBlock, { rows: 7, color: _constants.LOADING_COLOR, className: _constants.LOADING_CLASSNAME })
	                    )
	                });
	            }
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: 'flex',
	                        alignItems: 'center',
	                        flexDirection: 'column'
	                    }
	                },
	                _react2.default.createElement(_warning2.default, null),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Error while fetching campaigns'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Status code: ',
	                    campaignsStatus
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'wdp-container' },
	                this.renderTable()
	            );
	        }
	    }]);
	
	    return CampaignsList;
	}(_react.PureComponent);
	
	exports.default = CampaignsList;
	
	
	CampaignsList.propTypes = {
	    campaigns: _propTypes2.default.array,
	    smlinks: _propTypes2.default.array,
	    campaignsPending: _propTypes2.default.bool,
	    campaignsStatus: _propTypes2.default.number
	};

/***/ },
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaigns = __webpack_require__(1822);
	
	var _CampaignInfo = __webpack_require__(1945);
	
	var _CampaignInfo2 = _interopRequireDefault(_CampaignInfo);
	
	var _NotPublishedList = __webpack_require__(1946);
	
	var _NotPublishedList2 = _interopRequireDefault(_NotPublishedList);
	
	var _PublishedList = __webpack_require__(1956);
	
	var _PublishedList2 = _interopRequireDefault(_PublishedList);
	
	var _withPagination = __webpack_require__(1901);
	
	var _helpers = __webpack_require__(592);
	
	var _selectors = __webpack_require__(618);
	
	var _dialogs = __webpack_require__(1964);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignView = function (_React$PureComponent) {
	    _inherits(CampaignView, _React$PureComponent);
	
	    function CampaignView() {
	        _classCallCheck(this, CampaignView);
	
	        return _possibleConstructorReturn(this, (CampaignView.__proto__ || Object.getPrototypeOf(CampaignView)).apply(this, arguments));
	    }
	
	    _createClass(CampaignView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var campaignId = this.props.params.campaignId;
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _campaigns.fetchCampaignById)(campaignId));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var campaignId = this.props.params.campaignId;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                        onTouchTap: _reactRouter.browserHistory.push.bind(this, '/campaigns'),
	                        primary: true,
	                        label: 'Back',
	                        style: { margin: '12px 0' }
	                    })
	                ),
	                _react2.default.createElement(_CampaignInfo2.default, { campaignId: campaignId }),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'section-header' },
	                    'Moderation queue'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginLeft: -12 } },
	                    _react2.default.createElement(_NotPublishedList2.default, { campaignId: campaignId })
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'section-header' },
	                    'Last published posts'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: 12 } },
	                    _react2.default.createElement(_PublishedList2.default, { campaignId: campaignId })
	                ),
	                _react2.default.createElement(_dialogs.PublishDialog, null),
	                _react2.default.createElement(_dialogs.LogsDialog, null),
	                _react2.default.createElement(_dialogs.RejectDialog, null),
	                _react2.default.createElement(_dialogs.DeleteDialog, null)
	            );
	        }
	    }]);
	
	    return CampaignView;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _reactRedux.connect)()(CampaignView);

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reactRouter = __webpack_require__(188);
	
	var _materialUi = __webpack_require__(642);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _colors = __webpack_require__(910);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _placeholders = __webpack_require__(1938);
	
	var _selectors = __webpack_require__(618);
	
	var _campaigns = __webpack_require__(1822);
	
	var _SMLink = __webpack_require__(1819);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LANG_MAP = _constants.LANGUAGES.reduce(function (acc, cur) {
	    acc[cur.key] = cur.name;
	    return acc;
	}, {});
	
	var ROW_WIDTH = 300;
	var rowFn = function rowFn(loaded) {
	    return function (left, right) {
	        return _react2.default.createElement(
	            'div',
	            { style: { display: 'inline', marginTop: 4, marginBottom: 4 } },
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        width: ROW_WIDTH / 2,
	                        color: _colors.grey600,
	                        display: 'inline-block',
	                        verticalAlign: 'top'
	                    }
	                },
	                typeof left === 'string' ? _react2.default.createElement(
	                    'b',
	                    null,
	                    left
	                ) : left
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { display: 'inline-block', width: ROW_WIDTH / 2 } },
	                loaded ? right : _react2.default.createElement(_placeholders.TextRow, {
	                    className: _constants.LOADING_CLASSNAME,
	                    color: _constants.LOADING_COLOR,
	                    style: { width: '90%', height: 13, margin: 0 }
	                })
	            )
	        );
	    };
	};
	
	var Actions = function (_React$PureComponent) {
	    _inherits(Actions, _React$PureComponent);
	
	    function Actions() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Actions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Actions.__proto__ || Object.getPrototypeOf(Actions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            deleteOpen: false
	        }, _this.handleTouchTap = function (event) {
	            event.preventDefault();
	            _this.setState({
	                open: true,
	                anchorEl: event.currentTarget
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({
	                open: false
	            });
	        }, _this.onCloseDeleteDialog = function () {
	            _this.setState({ deleteOpen: false });
	        }, _this.onOpenDeleteDialog = function () {
	            _this.setState({ deleteOpen: true });
	            _this.handleRequestClose();
	        }, _this.onDelete = function () {
	            _this.props.onDelete();
	            _this.onCloseDeleteDialog();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Actions, [{
	        key: 'render',
	        value: function render() {
	            var campaignId = this.props.campaignId;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { onTouchTap: this.handleTouchTap },
	                    _react2.default.createElement(_moreVert2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        title: 'Deletion',
	                        actions: [_react2.default.createElement(_materialUi.FlatButton, { primary: true, label: 'Cancel', onClick: this.onCloseDeleteDialog }), _react2.default.createElement(_materialUi.FlatButton, { secondary: true, keyboardFocused: true, label: 'Yes, delete', onClick: this.onDelete })],
	                        modal: false,
	                        open: this.state.deleteOpen,
	                        onRequestClose: this.onCloseDeleteDialog
	                    },
	                    'Are you sure you want to delete the campaign?'
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: this.state.open,
	                        anchorEl: this.state.anchorEl,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: this.handleRequestClose
	                    },
	                    _react2.default.createElement(
	                        _materialUi.Menu,
	                        null,
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            style: { color: '#ff4081' },
	                            primaryText: 'Delete',
	                            onTouchTap: this.onOpenDeleteDialog
	                        }),
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            primaryText: 'Edit',
	                            onTouchTap: function onTouchTap() {
	                                return _reactRouter.browserHistory.push('/campaigns/edit/' + campaignId);
	                            }
	                        }),
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            primaryText: 'Manual post',
	                            onTouchTap: function onTouchTap() {
	                                return _reactRouter.browserHistory.push('/campaigns/manual-post/' + campaignId);
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Actions;
	}(_react2.default.PureComponent);
	
	Actions.propTypes = {
	    campaignId: _propTypes2.default.string.isRequired,
	    onDelete: _propTypes2.default.func.isRequired
	};
	
	var CampaignInfo = function CampaignInfo(_ref2) {
	    var campaign = _ref2.campaign,
	        deleteCampaign = _ref2.deleteCampaign;
	
	    var _ref3 = campaign || {},
	        _id = _ref3._id,
	        title = _ref3.title,
	        active = _ref3.active,
	        moderation = _ref3.moderation,
	        language = _ref3.language,
	        _ref3$messengerNotifi = _ref3.messengerNotifications,
	        messengerNotifications = _ref3$messengerNotifi === undefined ? [] : _ref3$messengerNotifi,
	        _ref3$notificationsTo = _ref3.notificationsTo,
	        notificationsTo = _ref3$notificationsTo === undefined ? [] : _ref3$notificationsTo,
	        _ref3$targets = _ref3.targets,
	        targets = _ref3$targets === undefined ? [] : _ref3$targets;
	
	    var notifications = Array.isArray(notificationsTo) ? notificationsTo : [];
	    var targetsAr = Array.isArray(targets) ? targets : [];
	    var getRow = rowFn(Boolean(campaign));
	    return _react2.default.createElement(
	        _materialUi.Card,
	        null,
	        _react2.default.createElement(
	            _materialUi.CardText,
	            null,
	            _react2.default.createElement(
	                'div',
	                { style: { position: 'relative' } },
	                _id ? _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: 0, right: 0 } },
	                    _react2.default.createElement(Actions, { campaignId: _id, onDelete: deleteCampaign })
	                ) : null
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', padding: 16 } },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            display: 'flex',
	                            flexDirection: 'column',
	                            width: ROW_WIDTH
	                        }
	                    },
	                    getRow('Name:', title),
	                    getRow('Status:', active ? 'Active' : 'Not active'),
	                    getRow('Language:', LANG_MAP[language] || 'N/A'),
	                    getRow('Moderation:', moderation ? 'On' : 'Off/Auto')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            display: 'flex',
	                            flexDirection: 'column',
	                            width: ROW_WIDTH
	                        }
	                    },
	                    getRow('Callbacks:', notifications.length ? notifications.map(function (el, index) {
	                        return _react2.default.createElement(
	                            'span',
	                            { style: { display: 'inline-block' }, key: index },
	                            el.value
	                        );
	                    }) : '-'),
	                    getRow('FB Messenger:', messengerNotifications.length ? messengerNotifications.map(function (el, index) {
	                        return _react2.default.createElement(
	                            'span',
	                            { key: index },
	                            el.userName && _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    {
	                                        style: {
	                                            display: 'inline-block',
	                                            verticalAlign: 'middle'
	                                        }
	                                    },
	                                    el.userName
	                                ),
	                                el.userPhoto && _react2.default.createElement('img', {
	                                    style: {
	                                        width: '30px',
	                                        height: '30px',
	                                        marginLeft: '10px',
	                                        borderRadius: '50%',
	                                        display: 'inline-block',
	                                        verticalAlign: 'middle'
	                                    },
	                                    src: el.userPhoto,
	                                    alt: '_'
	                                })
	                            ),
	                            !el.userName && _react2.default.createElement(
	                                'span',
	                                {
	                                    style: {
	                                        wordBreak: 'break-all',
	                                        paddingLeft: '10px',
	                                        textAlign: 'right',
	                                        display: 'inline-block'
	                                    }
	                                },
	                                el.value
	                            )
	                        );
	                    }) : '-'),
	                    getRow('Targets:', targetsAr.map(function (el) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: el.value },
	                            _react2.default.createElement(_SMLink.SMLinkTitle, { id: el.value })
	                        );
	                    }))
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state, _ref4) {
	    var campaignId = _ref4.campaignId;
	    return { campaign: _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.CAMPAIGNS], campaignId) };
	}, function (dispatch, _ref5) {
	    var campaignId = _ref5.campaignId;
	    return {
	        deleteCampaign: function deleteCampaign() {
	            return dispatch((0, _campaigns.deleteCampaign)(campaignId)).then(function () {
	                return _reactRouter.browserHistory.push('/campaigns');
	            });
	        }
	    };
	})(CampaignInfo);

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _withPagination = __webpack_require__(1901);
	
	var _selectors = __webpack_require__(618);
	
	var _pagination = __webpack_require__(1791);
	
	var _NotPublishedPost = __webpack_require__(1947);
	
	var _NotPublishedPost2 = _interopRequireDefault(_NotPublishedPost);
	
	var _constants = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FETCH_INTERVAL_SEC = 15;
	var PostList = (0, _reactRedux.connect)(function (state, _ref) {
	    var campaignId = _ref.campaignId;
	    return {
	        isFinished: _lodash2.default.get((0, _selectors.getQueries)(state), ['GET:not-published/' + campaignId, 'isFinished']),
	        postIds: (0, _pagination.selectIds)(state.pagination, 'not-published/' + campaignId)
	    };
	})(function (_React$PureComponent) {
	    _inherits(_PostList, _React$PureComponent);
	
	    function _PostList(props, ctx) {
	        _classCallCheck(this, _PostList);
	
	        var _this = _possibleConstructorReturn(this, (_PostList.__proto__ || Object.getPrototypeOf(_PostList)).call(this, props, ctx));
	
	        _this.state = {
	            ready: Boolean(props.isFinished)
	        };
	        _this.timer = null;
	        return _this;
	    }
	
	    _createClass(_PostList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaignId = _props.campaignId;
	
	            dispatch((0, _withPagination.fetchNotPublishedPostsWithPagination)(campaignId));
	            this.fetchInterval = window.setInterval(function () {
	                dispatch((0, _withPagination.fetchNotPublishedPostsWithPagination)(campaignId));
	            }, FETCH_INTERVAL_SEC * 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var _this2 = this;
	
	            var isFinished = _ref2.isFinished,
	                postIds = _ref2.postIds;
	
	            if (isFinished !== this.props.isFinished) {
	                if (isFinished) {
	                    window.clearTimeout(this.timer);
	                    this.timer = setTimeout(function () {
	                        return _this2.setState({ ready: isFinished });
	                    }, _constants.FINISHED_REQ_DELAY);
	                } else {
	                    window.clearTimeout(this.timer);
	                    this.setState({
	                        ready: isFinished || Array.isArray(postIds)
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.clearInterval(this.fetchInterval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var ready = this.state.ready;
	            var postIds = this.props.postIds;
	
	            var ids = ready && postIds ? postIds : Array(3).fill(null);
	            return _react2.default.createElement(
	                'div',
	                null,
	                ids.length !== 0 && _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            width: '100%',
	                            overflowX: 'auto',
	                            display: 'flex',
	                            padding: '0px 0px 20px 0px'
	                        }
	                    },
	                    ids.map(function (id, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: id || index, style: { marginLeft: 12 } },
	                            _react2.default.createElement(_NotPublishedPost2.default, { id: id })
	                        );
	                    })
	                ),
	                ids.length === 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'empty-message', style: { margin: 12 } },
	                    'Moderation queue is empty.'
	                )
	            );
	        }
	    }]);
	
	    return _PostList;
	}(_react2.default.PureComponent));
	
	PostList.propTypes = {
	    campaignId: _propTypes2.default.string.isRequired
	};
	
	exports.default = PostList;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _placeholders = __webpack_require__(1938);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(618);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(592);
	
	var _PostImage = __webpack_require__(1948);
	
	var _PostImage2 = _interopRequireDefault(_PostImage);
	
	var _PostStatus = __webpack_require__(1954);
	
	var _PostStatus2 = _interopRequireDefault(_PostStatus);
	
	var _PostActions = __webpack_require__(1955);
	
	var _PostActions2 = _interopRequireDefault(_PostActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CARD_WIDTH = 400;
	var IMAGE_HEIGHT = 250;
	
	var PostActions = function (_React$PureComponent) {
	    _inherits(PostActions, _React$PureComponent);
	
	    function PostActions() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PostActions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostActions.__proto__ || Object.getPrototypeOf(PostActions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            open: false,
	            anchorEl: null
	        }, _this.handleTouchTap = function (event) {
	            event.preventDefault();
	            _this.setState({
	                open: true,
	                anchorEl: event.currentTarget
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({ open: false });
	        }, _this.openLogs = function () {
	            (0, _helpers.addToQuery)('logs', _this.props.postId);
	            _this.handleRequestClose();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PostActions, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { onTouchTap: this.handleTouchTap },
	                    _react2.default.createElement(_moreVert2.default, { color: 'white' })
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: this.state.open,
	                        anchorEl: this.state.anchorEl,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: this.handleRequestClose
	                    },
	                    _react2.default.createElement(
	                        _materialUi.Menu,
	                        null,
	                        _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Logs', onTouchTap: this.openLogs })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostActions;
	}(_react2.default.PureComponent);
	
	var Post = (0, _reactRedux.connect)(function (state, _ref2) {
	    var id = _ref2.id;
	    return {
	        post: id ? (0, _get2.default)((0, _selectors.getEntities)(state)['posts'], id) : null
	    };
	})(function (_React$PureComponent2) {
	    _inherits(_Post, _React$PureComponent2);
	
	    function _Post() {
	        _classCallCheck(this, _Post);
	
	        return _possibleConstructorReturn(this, (_Post.__proto__ || Object.getPrototypeOf(_Post)).apply(this, arguments));
	    }
	
	    _createClass(_Post, [{
	        key: 'renderText',
	        value: function renderText() {
	            var post = this.props.post;
	
	            var loaded = Boolean(post);
	            if (!loaded) {
	                return _react2.default.createElement(_placeholders.TextBlock, { rows: 5, className: _constants.LOADING_CLASSNAME, color: _constants.LOADING_COLOR });
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Last updated: ',
	                    (0, _moment2.default)(post.updatedAt).fromNow()
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Status: ',
	                    _react2.default.createElement(_PostStatus2.default, { post: post })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_PostActions2.default, { post: post })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	
	            var loaded = Boolean(post);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.Card,
	                    { style: { width: CARD_WIDTH } },
	                    loaded ? _react2.default.createElement(
	                        'div',
	                        { style: { position: 'relative' } },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    position: 'absolute',
	                                    top: 0,
	                                    right: 0,
	                                    zIndex: 10
	                                }
	                            },
	                            _react2.default.createElement(PostActions, { postId: this.props.id })
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        _materialUi.CardMedia,
	                        null,
	                        _react2.default.createElement(_PostImage2.default, { post: post, width: CARD_WIDTH, height: IMAGE_HEIGHT })
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.CardText,
	                        null,
	                        this.renderText()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return _Post;
	}(_react2.default.PureComponent));
	
	exports.default = Post;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isPostFailed = exports.isContentGenerationPost = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ';\n    ', ';\n\n    background-color: ', ';\n'], ['\n    ', ';\n    ', ';\n\n    background-color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n    ', ';\n    height: auto;\n\n    object-fit: contain;\n'], ['\n    display: block;\n    width: 100%;\n    ', ';\n    height: auto;\n\n    object-fit: contain;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBigpicture = __webpack_require__(1949);
	
	var _constants = __webpack_require__(579);
	
	var _postConstants = __webpack_require__(1951);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _errorOutline = __webpack_require__(1952);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _cropOriginal = __webpack_require__(1953);
	
	var _cropOriginal2 = _interopRequireDefault(_cropOriginal);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable jsx-a11y/media-has-caption */
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
	    var width = _ref.width;
	    return width && 'max-width: ' + (typeof width === 'number' ? width + 'px' : width);
	}, function (_ref2) {
	    var height = _ref2.height;
	    return height && 'height: ' + (typeof width === 'number' ? height + 'px' : height);
	}, _constants.LOADING_COLOR);
	
	var NotImage = Wrapper.extend(_templateObject2);
	
	var Img = _styledComponents2.default.img(_templateObject3, function (_ref3) {
	    var width = _ref3.width;
	    return width && 'max-width: ' + (typeof width === 'number' ? width + 'px' : width);
	});
	
	var isVideo = function isVideo() {
	    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    var extension = src.split('.');
	
	    return ['mp4'].includes(extension[extension.length - 1]);
	};
	
	var isContentGenerationPost = exports.isContentGenerationPost = function isContentGenerationPost(_ref4) {
	    var _ref4$step = _ref4.step,
	        step = _ref4$step === undefined ? '' : _ref4$step;
	    return step === _postConstants.POST_STEPS.CONTENT_GENERATION;
	};
	
	var isPostFailed = exports.isPostFailed = function isPostFailed(_ref5) {
	    var _ref5$step = _ref5.step,
	        step = _ref5$step === undefined ? '' : _ref5$step,
	        _ref5$state = _ref5.state,
	        state = _ref5$state === undefined ? '' : _ref5$state;
	    return step !== _postConstants.POST_STEPS.AWAITING_FOR_MODERATION && state === _postConstants.STATUS_STATES.FAILED;
	};
	
	function PostImage(_ref6) {
	    var _ref6$post = _ref6.post,
	        post = _ref6$post === undefined ? {} : _ref6$post,
	        _ref6$width = _ref6.width,
	        width = _ref6$width === undefined ? '100%' : _ref6$width,
	        height = _ref6.height,
	        _ref6$iconWidth = _ref6.iconWidth,
	        iconWidth = _ref6$iconWidth === undefined ? 34 : _ref6$iconWidth,
	        _ref6$iconHeight = _ref6.iconHeight,
	        iconHeight = _ref6$iconHeight === undefined ? 34 : _ref6$iconHeight;
	
	    var loaded = Boolean(post);
	
	    if (!loaded) {
	        return _react2.default.createElement(
	            NotImage,
	            { width: width, height: height },
	            _react2.default.createElement(_cropOriginal2.default, { style: { width: iconWidth, height: iconHeight } })
	        );
	    }
	
	    var _post$content = post.content,
	        content = _post$content === undefined ? {} : _post$content,
	        _post$status = post.status,
	        status = _post$status === undefined ? {} : _post$status;
	
	
	    var imageSrc = content.picture;
	    var videoSrc = content.video;
	
	    if (!imageSrc) {
	        return _react2.default.createElement(
	            NotImage,
	            { width: width, height: height },
	            isContentGenerationPost(status) && !isPostFailed(status) ? _react2.default.createElement(_CircularProgress2.default, { size: iconWidth }) : _react2.default.createElement(_errorOutline2.default, { style: { width: iconWidth, height: iconHeight }, color: _colors.red500 })
	        );
	    }
	
	    if (!isVideo(videoSrc || imageSrc)) {
	        return _react2.default.createElement(
	            _reactBigpicture.BPicture,
	            { src: imageSrc },
	            _react2.default.createElement(Img, { src: imageSrc, width: width, alt: 'Post Image' })
	        );
	    }
	
	    return _react2.default.createElement(
	        _reactBigpicture.BVideo,
	        { src: videoSrc },
	        _react2.default.createElement(
	            'video',
	            {
	                style: { width: width, height: height },
	                onError: function onError(e) {
	                    var videoElement = e.currentTarget;
	                    videoElement.style.display = 'none';
	                    videoElement.parentElement.style.background = '#f9f9f9';
	                },
	                loop: true,
	                autoPlay: true,
	                controls: 'controls'
	            },
	            _react2.default.createElement('source', { src: videoSrc })
	        )
	    );
	}
	
	PostImage.propTypes = {
	    post: _propTypes2.default.shape({
	        status: _propTypes2.default.shape({
	            step: _propTypes2.default.string,
	            state: _propTypes2.default.string
	        }),
	        content: _propTypes2.default.shape({
	            picture: _propTypes2.default.string,
	            message: _propTypes2.default.string
	        })
	    }).isRequired,
	    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    iconWidth: _propTypes2.default.number,
	    iconHeight: _propTypes2.default.number
	};
	
	exports.default = PostImage;

/***/ },
/* 1949 */,
/* 1950 */,
/* 1951 */
/***/ function(module, exports) {

	'use strict';
	
	var POST_STEPS = {
	    INITIALIZATION: 'initialization',
	    CONTENT_GENERATION: 'content_generation',
	    AWAITING_FOR_MODERATION: 'awaiting_for_moderation',
	    POST_PUBLISHING: 'post_publishing',
	    NOTIFICATION_SENDING: 'notification_sending',
	    FINISHED: 'finished',
	    DELETE_POST_RESULT: 'deletePostResult'
	};
	
	var STATUS_STATES = {
	    AWAITING: 'awaiting',
	    STARTED: 'started',
	    SUCCESS: 'success',
	    FAILED: 'failed'
	};
	
	var MAX_ATTEMPTS = 3;
	
	var SOURCE_TYPES = {
	    MANUAL: 'manual',
	    TRIGGER: 'trigger'
	};
	
	module.exports = {
	    POST_STEPS: POST_STEPS,
	    STATUS_STATES: STATUS_STATES,
	    MAX_ATTEMPTS: MAX_ATTEMPTS,
	    SOURCE_TYPES: SOURCE_TYPES
	};

/***/ },
/* 1952 */,
/* 1953 */,
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var post = _ref.post;
	
	    var state = _lodash2.default.get(post, ['status', 'state']);
	    var step = _lodash2.default.get(post, ['status', 'step']);
	    var attempts = _lodash2.default.get(post, ['status', 'attempts']);
	    if (state === 'failed' && step === 'awaiting_for_moderation' && attempts === 1) state = 'Rejected';
	
	    return _react2.default.createElement(
	        'span',
	        null,
	        state,
	        ' ',
	        step
	    );
	};

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _refresh = __webpack_require__(1640);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _check = __webpack_require__(828);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _postConstants = __webpack_require__(1951);
	
	var _helpers = __webpack_require__(592);
	
	var _posts = __webpack_require__(1902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPostFailed = function isPostFailed(post) {
	    return post.status.state === _postConstants.STATUS_STATES.FAILED && post.status.step !== _postConstants.POST_STEPS.AWAITING_FOR_MODERATION;
	};
	
	var isAwaitingModeration = function isAwaitingModeration(post) {
	    return post.status.step === _postConstants.POST_STEPS.AWAITING_FOR_MODERATION && post.status.state === _postConstants.STATUS_STATES.STARTED;
	};
	
	var isRejected = function isRejected(post) {
	    return post.status.step === _postConstants.POST_STEPS.AWAITING_FOR_MODERATION && post.status.state === _postConstants.STATUS_STATES.FAILED;
	};
	
	var isDeleted = function isDeleted(post) {
	    return post.status.step === _postConstants.POST_STEPS.DELETE_POST_RESULT && post.status.state === _postConstants.STATUS_STATES.SUCCESS;
	};
	
	var isDeleting = function isDeleting(post) {
	    return post.status.step === _postConstants.POST_STEPS.DELETE_POST_RESULT && [_postConstants.STATUS_STATES.STARTED, _postConstants.STATUS_STATES.AWAITING].some(function (s) {
	        return post.status.state === s;
	    });
	};
	
	var isFinishedPosting = function isFinishedPosting(post) {
	    return post.status.step === _postConstants.POST_STEPS.FINISHED && post.status.state === _postConstants.STATUS_STATES.SUCCESS;
	};
	
	var canRetry = function canRetry(post) {
	    return isPostFailed(post) && post.status.attempts >= 3;
	};
	
	var approve = function approve(id) {
	    return function () {
	        (0, _helpers.addToQuery)('publish', id);
	    };
	};
	
	var reject = function reject(id) {
	    return function () {
	        (0, _helpers.addToQuery)('reject', id);
	    };
	};
	
	var deletePost = function deletePost(id) {
	    return function () {
	        (0, _helpers.addToQuery)('delete', id);
	    };
	};
	
	// const openLogs = id => () => {
	//     addToQuery('logs', id);
	// };
	
	var PostActions = (0, _reactRedux.connect)(null, function (dispatch) {
	    return {
	        retry: function retry(id) {
	            return dispatch((0, _posts.retrySendPost)(id));
	        }
	    };
	})(function (_ref) {
	    var post = _ref.post,
	        retry = _ref.retry;
	
	    if (!post) {
	        return null;
	    }
	    var id = post._id;
	
	    var canBeRetried = canRetry(post);
	    var deleting = isDeleting(post);
	    if (canBeRetried || deleting) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_materialUi.FlatButton, {
	                primary: true,
	                disabled: !canBeRetried,
	                label: 'Retry',
	                icon: _react2.default.createElement(_refresh2.default, null),
	                onTouchTap: function onTouchTap() {
	                    return retry(id);
	                },
	                style: { width: '50%' }
	            }),
	            _react2.default.createElement(_materialUi.FlatButton, {
	                secondary: true,
	                disabled: deleting,
	                onTouchTap: deletePost(id),
	                icon: deleting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 20, thickness: 2.5 }) : _react2.default.createElement(_delete2.default, null),
	                label: 'Delete',
	                style: { width: '50%' }
	            })
	        );
	    }
	    var awaiting = isAwaitingModeration(post);
	    var deleted = isDeleted(post);
	    var rejected = isRejected(post);
	    var finished = isFinishedPosting(post);
	    var inPostingProcess = !awaiting && !deleting && !rejected && !deleted && !finished;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_materialUi.FlatButton, {
	            primary: true,
	            icon: inPostingProcess ? _react2.default.createElement(_materialUi.CircularProgress, { size: 20, thickness: 2.5 }) : _react2.default.createElement(_check2.default, null),
	            disabled: !awaiting,
	            label: 'Approve',
	            onTouchTap: approve(id),
	            style: { width: '50%' }
	        }),
	        _react2.default.createElement(_materialUi.FlatButton, {
	            secondary: true,
	            icon: _react2.default.createElement(_delete2.default, null),
	            onTouchTap: reject(id),
	            disabled: !awaiting,
	            label: 'Reject',
	            style: { width: '50%' }
	        })
	    );
	});
	
	exports.default = PostActions;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _withPagination = __webpack_require__(1901);
	
	var _pagination = __webpack_require__(1791);
	
	var _selectors = __webpack_require__(618);
	
	var _PublishedPost = __webpack_require__(1957);
	
	var _PublishedPost2 = _interopRequireDefault(_PublishedPost);
	
	var _constants = __webpack_require__(579);
	
	var _placeholders = __webpack_require__(1938);
	
	var _Pagination = __webpack_require__(1962);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _helpers = __webpack_require__(592);
	
	var _postStats = __webpack_require__(1963);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FETCH_INTERVAL_SEC = 15;
	var PublishedList = (0, _reactRedux.connect)(function (state, _ref) {
	    var campaignId = _ref.campaignId;
	    return {
	        postIds: (0, _pagination.selectIds)(state.pagination, 'published/' + campaignId),
	        isFinished: _lodash2.default.get((0, _selectors.getQueries)(state), ['GET:published/' + campaignId, 'isFinished'])
	    };
	}, function (dispatch) {
	    return {
	        fetchPosts: function fetchPosts(campaignId) {
	            return dispatch((0, _withPagination.fetchPublishedPostsWithPagination)(campaignId));
	        },
	        fetchStats: function fetchStats(publicationIds) {
	            return dispatch((0, _postStats.fetchStats)(publicationIds));
	        }
	    };
	})(function (_React$PureComponent) {
	    _inherits(_PublishedList, _React$PureComponent);
	
	    function _PublishedList(props, ctx) {
	        _classCallCheck(this, _PublishedList);
	
	        var _this = _possibleConstructorReturn(this, (_PublishedList.__proto__ || Object.getPrototypeOf(_PublishedList)).call(this, props, ctx));
	
	        _this.fetchPostsWithStats = function () {
	            var campaignId = _this.props.campaignId;
	
	            _this.props.fetchPosts(campaignId).then(function (res) {
	                if ((0, _helpers.responseStatusIsOk)(res.status) && Array.isArray(res.body.posts)) {
	                    var publicationIds = res.body.posts.reduce(function (acc, post) {
	                        return acc.concat((0, _helpers.toIdArray)(post.publications));
	                    }, []).filter(function (e) {
	                        return e;
	                    });
	                    _this.props.fetchStats(publicationIds);
	                }
	            });
	        };
	
	        _this.state = {
	            ready: Boolean(props.isFinished)
	        };
	        _this.timer = null;
	        return _this;
	    }
	
	    _createClass(_PublishedList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var campaignId = this.props.campaignId;
	
	            this.fetchPostsWithStats();
	            this.fetchInterval = window.setInterval(function () {
	                _this2.props.fetchPosts(campaignId);
	            }, FETCH_INTERVAL_SEC * 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var _this3 = this;
	
	            var isFinished = _ref2.isFinished,
	                postIds = _ref2.postIds;
	
	            if (isFinished !== this.props.isFinished) {
	                if (isFinished) {
	                    window.clearTimeout(this.timer);
	                    this.timer = setTimeout(function () {
	                        return _this3.setState({ ready: isFinished });
	                    }, _constants.FINISHED_REQ_DELAY);
	                } else {
	                    window.clearTimeout(this.timer);
	                    this.setState({
	                        ready: isFinished || Array.isArray(postIds)
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.clearInterval(this.fetchInterval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var ready = this.state.ready;
	            var _props = this.props,
	                postIds = _props.postIds,
	                isFinished = _props.isFinished,
	                campaignId = _props.campaignId;
	
	            var canShow = ready && Array.isArray(postIds);
	            return !canShow ? _react2.default.createElement(_placeholders.TextBlock, { rows: 7, className: _constants.LOADING_CLASSNAME, color: _constants.LOADING_COLOR }) : _react2.default.createElement(
	                'div',
	                null,
	                postIds.map(function (id, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: canShow ? id : index },
	                        _react2.default.createElement(_PublishedPost2.default, { id: id })
	                    );
	                }),
	                postIds.length !== 0 && _react2.default.createElement(
	                    'div',
	                    { style: { margin: '12px 0px' } },
	                    _react2.default.createElement(_Pagination2.default, {
	                        entity: 'published/' + this.props.campaignId,
	                        fetchFunction: this.fetchPostsWithStats
	                    })
	                ),
	                postIds.length === 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'empty-message', style: { margin: '12px 0px' } },
	                    'There is no published posts yet.'
	                )
	            );
	        }
	    }]);
	
	    return _PublishedList;
	}(_react2.default.PureComponent));
	
	exports.default = PublishedList;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PostLink = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _materialUi = __webpack_require__(642);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _removeRedEye = __webpack_require__(1958);
	
	var _removeRedEye2 = _interopRequireDefault(_removeRedEye);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _thumbUp = __webpack_require__(1959);
	
	var _thumbUp2 = _interopRequireDefault(_thumbUp);
	
	var _comment = __webpack_require__(1960);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selectors = __webpack_require__(618);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _socialIcons = __webpack_require__(1961);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var openLink = function openLink(url) {
	    return function () {
	        window.open(url);
	    };
	};
	
	var getName = function getName(publication) {
	    return _lodash2.default.get(publication, ['meta', 'smlink', 'name']);
	};
	
	var PostLink = (0, _reactRedux.connect)(function (state, _ref) {
	    var publicationId = _ref.publicationId;
	    return {
	        publication: _lodash2.default.get((0, _selectors.getEntities)(state).publications, publicationId)
	    };
	})(function (_ref2) {
	    var publication = _ref2.publication;
	
	    if (!publication) {
	        return null;
	    }
	
	    switch (publication.source) {
	        case 'tw':
	            {
	                var account = _lodash2.default.get(publication, ['meta', 'account']);
	                var idStr = _lodash2.default.get(publication, ['meta', 'id_str']);
	                var url = 'http://twitter.com/' + account + '/status/' + idStr;
	                var valid = account && idStr;
	                return _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                        onTouchTap: valid ? openLink(url) : undefined,
	                        tooltip: valid ? getName(publication) : 'Link is broken'
	                    },
	                    _react2.default.createElement(_socialIcons.TwitterIcon, null)
	                );
	            }
	        case 'fb':
	            {
	                var smlinkId = _lodash2.default.get(publication, ['meta', 'smlink', 'id']);
	                var resId = _lodash2.default.get(publication, ['meta', 'id']);
	                var _url = 'http://facebook.com/' + smlinkId + '/posts/' + resId;
	                var _valid = smlinkId && resId;
	                return _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                        onTouchTap: _valid ? openLink(_url) : undefined,
	                        tooltip: _valid ? getName(publication) : 'Link is broken'
	                    },
	                    _react2.default.createElement(_socialIcons.FacebookIcon, null)
	                );
	            }
	        default:
	            return null;
	    }
	});
	
	var PostActions = function (_React$PureComponent) {
	    _inherits(PostActions, _React$PureComponent);
	
	    function PostActions() {
	        var _ref3;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PostActions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = PostActions.__proto__ || Object.getPrototypeOf(PostActions)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
	            open: false,
	            anchorEl: null
	        }, _this.handleTouchTap = function (event) {
	            event.preventDefault();
	            _this.setState({
	                open: true,
	                anchorEl: event.currentTarget
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({ open: false });
	        }, _this.onDelete = function () {
	            (0, _helpers.addToQuery)('delete', _this.props.postId);
	            _this.handleRequestClose();
	        }, _this.openLogs = function () {
	            (0, _helpers.addToQuery)('logs', _this.props.postId);
	            _this.handleRequestClose();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PostActions, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { onTouchTap: this.handleTouchTap },
	                    _react2.default.createElement(_moreVert2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    {
	                        open: this.state.open,
	                        anchorEl: this.state.anchorEl,
	                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	                        targetOrigin: { horizontal: 'left', vertical: 'top' },
	                        onRequestClose: this.handleRequestClose
	                    },
	                    _react2.default.createElement(
	                        _materialUi.Menu,
	                        null,
	                        _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Logs', onTouchTap: this.openLogs }),
	                        _react2.default.createElement(_materialUi.MenuItem, { style: { color: '#ff4081' }, primaryText: 'Delete', onTouchTap: this.onDelete })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostActions;
	}(_react2.default.PureComponent);
	
	PostActions.propTypes = {
	    postId: _propTypes2.default.string.isRequired
	};
	
	var initialStats = {
	    likes: null,
	    shares: null,
	    comments: null,
	    views: null
	};
	var generateStats = function generateStats(ids, stats) {
	    if (!Array.isArray(ids) || !ids.length || !stats) {
	        return _extends({}, initialStats);
	    }
	    var statsAr = ids.reduce(function (acc, id) {
	        return stats[id] ? acc.concat(stats[id]) : acc;
	    }, []);
	    if (!statsAr.length) {
	        return _extends({}, initialStats);
	    }
	    return statsAr.reduce(function (acc, stat) {
	        var isFB = Boolean(stat.common);
	        if (isFB) {
	            var likes = _lodash2.default.get(stat, ['common', 'likes'], 0);
	            var comments = _lodash2.default.get(stat, ['common', 'comments'], 0);
	            var impressions = _lodash2.default.get(stat, ['insights', 'impressions'], 0);
	            acc.likes += likes;
	            acc.comments += comments;
	            acc.views += impressions;
	        } else {
	            // twitter
	            var retweets = _lodash2.default.get(stat, 'retweets', 0);
	            var _likes = _lodash2.default.get(stat, 'favorites', 0);
	            acc.likes += _likes;
	            acc.shares += retweets;
	        }
	        return acc;
	    }, _extends({}, initialStats));
	};
	
	var getText = function getText(val) {
	    return val === null ? 'N/A' : val;
	};
	var statItems = [{ icon: _react2.default.createElement(_removeRedEye2.default, null), key: 'views' }, { icon: _react2.default.createElement(_share2.default, null), key: 'shares' }, { icon: _react2.default.createElement(_comment2.default, null), key: 'comments' }, { icon: _react2.default.createElement(_thumbUp2.default, null), key: 'likes' }];
	var PostStats = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	    return {
	        postStats: (0, _selectors.getEntities)(state).postStats
	    };
	}), (0, _recompose.withPropsOnChange)(function (cur, next) {
	    return cur.publicationIds !== next.publicationIds || cur.postStats !== next.postStats;
	}, function (_ref4) {
	    var publicationIds = _ref4.publicationIds,
	        postStats = _ref4.postStats;
	    return generateStats(publicationIds, postStats);
	}))(function (props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexWrap: 'wrap' } },
	        statItems.map(function (el) {
	            return _react2.default.createElement(
	                _materialUi.Chip,
	                { key: el.key, style: { marginRight: 12 } },
	                _react2.default.createElement(_materialUi.Avatar, { icon: el.icon }),
	                getText(props[el.key])
	            );
	        })
	    );
	});
	
	var PublishedPost = (0, _reactRedux.connect)(function (state, _ref5) {
	    var id = _ref5.id;
	    return {
	        post: id ? _lodash2.default.get((0, _selectors.getEntities)(state).posts, id) : null
	    };
	})(function (_React$PureComponent2) {
	    _inherits(_PublishedPost, _React$PureComponent2);
	
	    function _PublishedPost() {
	        _classCallCheck(this, _PublishedPost);
	
	        return _possibleConstructorReturn(this, (_PublishedPost.__proto__ || Object.getPrototypeOf(_PublishedPost)).apply(this, arguments));
	    }
	
	    _createClass(_PublishedPost, [{
	        key: 'renderPost',
	        value: function renderPost() {
	            var _props = this.props,
	                post = _props.post,
	                id = _props.id;
	
	            var title = post.content.message || post.presentation.name;
	            var publications = post.publications;
	
	            var tooltip = post.content.message ? 'Post message: ' + title : 'Widget: ' + post.presentation.name;
	            return _react2.default.createElement(
	                'div',
	                { style: { padding: 12 } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'relative' } },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                position: 'absolute',
	                                top: 0,
	                                right: 0
	                            }
	                        },
	                        _react2.default.createElement(PostActions, { postId: id })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            display: 'flex',
	                            justifyContent: 'space-between',
	                            flexWrap: 'wrap',
	                            marginRight: 36
	                        }
	                    },
	                    _react2.default.createElement(
	                        'p',
	                        {
	                            style: {
	                                maxWidth: 600,
	                                whiteSpace: 'nowrap',
	                                overflow: 'hidden',
	                                textOverflow: 'ellipsis'
	                            },
	                            title: tooltip
	                        },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        publications.map(function (publicationId) {
	                            return _react2.default.createElement(PostLink, { key: publicationId, publicationId: publicationId });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    (0, _moment2.default)(post.updatedAt).format('DD MMM HH:mm')
	                ),
	                _react2.default.createElement(PostStats, { publicationIds: publications })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	
	            return post ? _react2.default.createElement(
	                _materialUi.Paper,
	                null,
	                this.renderPost()
	            ) : null;
	        }
	    }]);
	
	    return _PublishedPost;
	}(_react2.default.PureComponent));
	
	exports.default = PublishedPost;
	exports.PostLink = PostLink;

/***/ },
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TelegramIcon = exports.FacebookIcon = exports.TwitterIcon = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterIcon = exports.TwitterIcon = function TwitterIcon() {
	    return _react2.default.createElement(
	        "svg",
	        { height: "24px", viewBox: "0 0 67 67", width: "24px" },
	        _react2.default.createElement("path", {
	            d: "M38.167,22.283c-2.619,0.953-4.274,3.411-4.086,6.101  l0.063,1.038l-1.048-0.127c-3.813-0.487-7.145-2.139-9.974-4.915l-1.383-1.377l-0.356,1.017c-0.754,2.267-0.272,4.661,1.299,6.271  c0.838,0.89,0.649,1.017-0.796,0.487c-0.503-0.169-0.943-0.296-0.985-0.233c-0.146,0.149,0.356,2.076,0.754,2.839  c0.545,1.06,1.655,2.097,2.871,2.712l1.027,0.487l-1.215,0.021c-1.173,0-1.215,0.021-1.089,0.467  c0.419,1.377,2.074,2.839,3.918,3.475l1.299,0.444l-1.131,0.678c-1.676,0.976-3.646,1.526-5.616,1.567  C20.775,43.256,20,43.341,20,43.405c0,0.211,2.557,1.397,4.044,1.864c4.463,1.377,9.765,0.783,13.746-1.568  c2.829-1.674,5.657-5,6.978-8.221c0.713-1.715,1.425-4.851,1.425-6.354c0-0.975,0.063-1.102,1.236-2.267  c0.692-0.678,1.341-1.419,1.467-1.631c0.21-0.403,0.188-0.403-0.88-0.043c-1.781,0.636-2.033,0.551-1.152-0.402  c0.649-0.678,1.425-1.907,1.425-2.267c0-0.063-0.314,0.042-0.671,0.233c-0.377,0.212-1.215,0.53-1.844,0.72l-1.131,0.361l-1.027-0.7  c-0.566-0.381-1.361-0.805-1.781-0.932C40.766,21.902,39.131,21.944,38.167,22.283z M34,64C17.432,64,4,50.568,4,34  C4,17.431,17.432,4,34,4s30,13.431,30,30C64,50.568,50.568,64,34,64z",
	            style: { fillRrule: 'evenodd', clipRule: 'evenodd', fill: '#598DCA' }
	        })
	    );
	};
	
	var FacebookIcon = exports.FacebookIcon = function FacebookIcon() {
	    return _react2.default.createElement(
	        "svg",
	        { height: "24px", viewBox: "0 0 67 67", width: "24px" },
	        _react2.default.createElement("path", {
	            d: "M29.765,50.32h6.744V33.998h4.499l0.596-5.624h-5.095  l0.007-2.816c0-1.466,0.14-2.253,2.244-2.253h2.812V17.68h-4.5c-5.405,0-7.307,2.729-7.307,7.317v3.377h-3.369v5.625h3.369V50.32z   M34,64C17.432,64,4,50.568,4,34C4,17.431,17.432,4,34,4s30,13.431,30,30C64,50.568,50.568,64,34,64z",
	            style: { fillRrule: 'evenodd', clipRule: 'evenodd', fill: '#3A589B' }
	        })
	    );
	};
	
	var TelegramIcon = exports.TelegramIcon = function TelegramIcon() {
	    return _react2.default.createElement(
	        "svg",
	        { height: "24px", viewBox: "0 0 67 67", width: "24px" },
	        _react2.default.createElement(
	            "text",
	            { x: "20", y: "35" },
	            "Telegram"
	        )
	    );
	};

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _pagination = __webpack_require__(1791);
	
	var _pagination2 = __webpack_require__(586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var buttonStyle = {
	    margin: 12
	};
	
	var getJumperOffset = function getJumperOffset(smaller, bigger) {
	    var nothing = smaller === undefined || bigger === undefined || bigger - smaller < 2;
	    if (nothing) {
	        return null;
	    }
	    return Math.min(bigger - smaller, 3);
	};
	
	var getValidator = function getValidator(lastPage) {
	    return function (page) {
	        return page <= lastPage && page >= 0;
	    };
	};
	var transformFlat = function transformFlat(page) {
	    return { page: page };
	};
	
	var getItems = function getItems(count, perPage, currentPage) {
	    var pagesCount = Math.ceil(count / perPage) || 0;
	    var lastPage = pagesCount ? pagesCount - 1 : 0;
	    var prev = [currentPage - 2, currentPage - 1].filter(function (p) {
	        return p > 0;
	    });
	    var next = [currentPage + 1, currentPage + 2].filter(function (p) {
	        return p < lastPage;
	    });
	    var prevJumper = getJumperOffset(0, prev[0]);
	    var nextJumper = getJumperOffset(next[next.length - 1], lastPage);
	    var pj = prevJumper ? [{ jumper: true, page: prev[0] - prevJumper }] : [];
	    var nj = nextJumper ? [{ jumper: true, page: next[next.length - 1] + nextJumper }] : [];
	    var validator = getValidator(lastPage);
	    var start = currentPage === 0 ? [] : [{ page: 0 }];
	    var end = currentPage === lastPage || !lastPage ? [] : [{ page: lastPage }];
	    var items = [].concat(start, pj, _toConsumableArray(prev.map(transformFlat)), [{ page: currentPage }], _toConsumableArray(next.map(transformFlat)), nj, end);
	    return items.filter(function (e) {
	        return validator(e.page);
	    });
	};
	
	var Pagination = function Pagination(_ref) {
	    var count = _ref.count,
	        perPage = _ref.perPage,
	        currentPage = _ref.currentPage,
	        onChange = _ref.onChange;
	
	    var items = getItems(count, perPage, currentPage);
	    return _react2.default.createElement(
	        'div',
	        null,
	        items.map(function (element, index) {
	            var el = element.page;
	            var isJumper = element.jumper;
	            var selected = Number(el) === Number(currentPage);
	            var label = el + 1;
	            var onTouchTap = function onTouchTap() {
	                return onChange(Number(el));
	            };
	            return _react2.default.createElement(
	                _materialUi.FlatButton,
	                {
	                    primary: selected,
	                    disabled: selected,
	                    onTouchTap: onTouchTap,
	                    key: index,
	                    style: { buttonStyle: buttonStyle }
	                },
	                isJumper ? '...' : label
	            );
	        })
	    );
	};
	
	Pagination.propTypes = {
	    count: _propTypes2.default.number,
	    perPage: _propTypes2.default.number,
	    currentPage: _propTypes2.default.number,
	    onChange: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	    var pagination = _ref2.pagination;
	    var entity = _ref3.entity;
	    return {
	        count: (0, _pagination.selectCount)(pagination, entity),
	        perPage: (0, _pagination.selectPerPage)(pagination, entity),
	        currentPage: (0, _pagination.selectCurrentPage)(pagination, entity)
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref4) {
	    var entity = _ref4.entity,
	        fetchFunction = _ref4.fetchFunction;
	
	    return {
	        onChange: function onChange(index) {
	            dispatch({
	                type: _pagination2.ACTION_TYPES.CHANGE_PAGE,
	                key: entity,
	                currentPage: index
	            });
	            fetchFunction();
	        }
	    };
	};
	
	var PaginationEnhanced = (0, _recompose.compose)(_recompose.pure, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(Pagination);
	
	exports.default = PaginationEnhanced;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchStats = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _actions = __webpack_require__(593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smpgUrl = _cfg2.default.apis.smpg;
	
	var fetchStats = exports.fetchStats = function fetchStats(publicationIds) {
	    return (0, _reduxQuery.requestAsync)({
	        url: smpgUrl + '/stats?resultIds=' + JSON.stringify(publicationIds),
	        transform: function transform(res) {
	            return {
	                postStats: res.reduce(function (acc, cur) {
	                    // acc[cur.resultId] = cur;
	                    acc[cur.resultId] = cur;
	                    return acc;
	                }, {})
	            };
	        },
	        update: {
	            postStats: _actions.UPDATE_DEFAULT.MERGE
	        },
	        force: true,
	        queryKey: 'GET:postStats'
	    });
	};

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LogsDialog = exports.DeleteDialog = exports.RejectDialog = exports.AbstractDialog = exports.EditDialog = exports.PublishDialog = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PublishDialog = __webpack_require__(1965);
	
	var _PublishDialog2 = _interopRequireDefault(_PublishDialog);
	
	var _EditDialog = __webpack_require__(1969);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	var _withPagination = __webpack_require__(1901);
	
	var _helpers = __webpack_require__(592);
	
	var _selectors = __webpack_require__(618);
	
	var _recompose = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublishDialog = exports.PublishDialog = (0, _reactRedux.connect)(function (state) {
	    return {
	        postId: _lodash2.default.get(state.routing, ['location', 'query', 'publish'])
	    };
	}, function () {
	    return {
	        close: function close() {
	            return (0, _helpers.removeFromQuery)('publish');
	        }
	    };
	})(_PublishDialog2.default);
	
	var EditDialog = exports.EditDialog = (0, _reactRedux.connect)(function (state) {
	    return {
	        postId: _lodash2.default.get(state.routing, ['location', 'query', 'edit'])
	    };
	}, function () {
	    return {
	        close: function close() {
	            return (0, _helpers.removeFromQuery)('edit');
	        }
	    };
	})(_EditDialog2.default);
	
	var AbstractDialog = exports.AbstractDialog = (0, _reactRedux.connect)(function (state, _ref) {
	    var queryKey = _ref.queryKey;
	    return {
	        queryValue: _lodash2.default.get(state.routing, ['location', 'query', queryKey])
	    };
	})(function (_ref2) {
	    var queryKey = _ref2.queryKey,
	        queryValue = _ref2.queryValue,
	        _ref2$okText = _ref2.okText,
	        okText = _ref2$okText === undefined ? 'Yes' : _ref2$okText,
	        _ref2$cancelText = _ref2.cancelText,
	        cancelText = _ref2$cancelText === undefined ? 'Cancel' : _ref2$cancelText,
	        _ref2$text = _ref2.text,
	        text = _ref2$text === undefined ? 'text here' : _ref2$text,
	        _ref2$okFn = _ref2.okFn,
	        okFn = _ref2$okFn === undefined ? _lodash2.default.noop : _ref2$okFn;
	
	    var onClose = function onClose() {
	        return (0, _helpers.removeFromQuery)(queryKey);
	    };
	    return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	            open: Boolean(queryValue),
	            className: 'no-padding-dialog',
	            dialogContentStyle: {
	                width: '90%',
	                maxWidth: 'none'
	            },
	            title: text,
	            autoScrollBodyContent: true,
	            repositionOnUpdate: true,
	            autoDetectWindowHeight: true,
	            onRequestClose: onClose,
	            modal: false
	        },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, {
	                primary: true,
	                label: okText,
	                onTouchTap: function onTouchTap() {
	                    okFn(queryValue);
	                    onClose();
	                },
	                style: { marginRight: 24 }
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, { onTouchTap: onClose, secondary: true, label: cancelText })
	        )
	    );
	});
	
	var RejectDialog = exports.RejectDialog = (0, _recompose.compose)((0, _reactRedux.connect)(null), (0, _recompose.withProps)(function (props) {
	    return {
	        queryKey: 'reject',
	        okText: 'Yes, reject',
	        text: 'Are you sure to reject the post?',
	        okFn: function okFn(postId) {
	            return props.dispatch((0, _withPagination.rejectWithPagination)(postId));
	        }
	    };
	}))(AbstractDialog);
	
	var DeleteDialog = exports.DeleteDialog = (0, _recompose.compose)((0, _reactRedux.connect)(null), (0, _recompose.withProps)(function (props) {
	    return {
	        queryKey: 'delete',
	        okText: 'Yes, delete',
	        text: 'Are you sure to delete the post and its results?',
	        okFn: function okFn(postId) {
	            return props.dispatch((0, _withPagination.deleteWithPagination)(postId));
	        }
	    };
	}))(AbstractDialog);
	
	var LogsDialog = exports.LogsDialog = (0, _reactRedux.connect)(function (state) {
	    var queryValue = _lodash2.default.get(state.routing, ['location', 'query', 'logs']);
	    var logs = _lodash2.default.get((0, _selectors.getEntities)(state).posts, [queryValue, 'logs']);
	    return {
	        queryValue: queryValue,
	        logs: logs
	    };
	})(function (_ref3) {
	    var queryValue = _ref3.queryValue,
	        logs = _ref3.logs;
	
	    var onClose = function onClose() {
	        return (0, _helpers.removeFromQuery)('logs');
	    };
	    var text = Array.isArray(logs) ? logs.join('\n') : '';
	    return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	            open: Boolean(queryValue),
	            className: 'no-padding-dialog',
	            dialogContentStyle: {
	                width: '90%',
	                maxWidth: 'none'
	            },
	            title: 'Logs',
	            autoScrollBodyContent: true,
	            repositionOnUpdate: true,
	            autoDetectWindowHeight: true,
	            onRequestClose: onClose,
	            modal: false
	        },
	        _react2.default.createElement(
	            'div',
	            { style: { padding: 2 } },
	            _react2.default.createElement('textarea', { value: text, cols: 105, rows: 50 })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_materialUi.RaisedButton, { secondary: true, onTouchTap: onClose, label: 'Ok' })
	        )
	    );
	});

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _publish = __webpack_require__(1966);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _undo = __webpack_require__(1967);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _materialUi = __webpack_require__(642);
	
	var _EmojiPicker = __webpack_require__(1600);
	
	var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selectors = __webpack_require__(618);
	
	var _posts = __webpack_require__(1902);
	
	var _withPagination = __webpack_require__(1901);
	
	var _helpers = __webpack_require__(592);
	
	var _withFeature = __webpack_require__(1864);
	
	var _withFeature2 = _interopRequireDefault(_withFeature);
	
	var _PostFacts = __webpack_require__(1968);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublishDialog = function (_React$PureComponent) {
	    _inherits(PublishDialog, _React$PureComponent);
	
	    function PublishDialog() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PublishDialog);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PublishDialog.__proto__ || Object.getPrototypeOf(PublishDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            message: '',
	            generatedMessages: [],
	            initialMessage: ''
	        }, _this.assignInputRef = function (el) {
	            if (el) {
	                if (el.input instanceof Node) {
	                    _this.inputRef = el.input;
	                } else {
	                    _this.inputRef = el.input.refs.input;
	                }
	            }
	        }, _this.onPublish = function () {
	            var postId = _this.props.postId;
	
	            if (_this.state.message !== _this.state.initialMessage) {
	                _this.props.updateMessage(postId, _this.state.message).then(function (res) {
	                    if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                        _this.props.approvePost(postId).then(function () {
	                            return _this.props.close();
	                        });
	                    }
	                });
	            } else {
	                _this.props.approvePost(postId).then(function () {
	                    return _this.props.close();
	                });
	            }
	        }, _this.onMessageChange = function (message) {
	            return _this.setState({ message: message });
	        }, _this.undo = function () {
	            return _this.onMessageChange(_this.state.initialMessage);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PublishDialog, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            if (this.props.post !== props.post) {
	                var message = _lodash2.default.get(props.post, 'content.message', '');
	                var generatedMessages = _lodash2.default.get(props.post, 'content.generatedMessages', []);
	
	                var nextObject = {
	                    generatedMessages: generatedMessages
	                };
	                this.setState(function (curState) {
	                    if (!curState.message) {
	                        nextObject.message = message;
	                    }
	
	                    if (curState.initialMessage !== message) {
	                        //initial message was changed (new post opened) -> reset
	                        nextObject.initialMessage = message;
	                        nextObject.message = message;
	                    }
	
	                    return nextObject;
	                });
	            }
	        }
	    }, {
	        key: 'renderPost',
	        value: function renderPost() {
	            var _this2 = this;
	
	            var post = this.props.post;
	
	            var imagePath = _lodash2.default.get(post, 'content.picture');
	            var videoSrc = _lodash2.default.get(post, ['content', 'video']);
	
	            var messageChanged = this.state.message !== this.state.initialMessage;
	            var onChange = function onChange(e, val) {
	                return _this2.onMessageChange(val);
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center' } },
	                    !videoSrc && _react2.default.createElement('img', { style: { maxWidth: 600 }, src: imagePath }),
	                    videoSrc && _react2.default.createElement(
	                        'video',
	                        { style: { width: 600 }, loop: true, autoPlay: true, controls: 'controls' },
	                        _react2.default.createElement('source', { src: videoSrc })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: 'flex-end' } },
	                    _react2.default.createElement(_materialUi.TextField, {
	                        multiLine: true,
	                        floatingLabelText: 'Message',
	                        name: 'message',
	                        style: { width: 600 },
	                        value: this.state.message,
	                        onChange: onChange,
	                        ref: this.assignInputRef
	                    }),
	                    _react2.default.createElement(_EmojiPicker2.default, { inputRef: this.inputRef, value: this.state.message, onChange: onChange }),
	                    messageChanged ? _react2.default.createElement(
	                        _materialUi.IconButton,
	                        { tooltip: 'Undo', onTouchTap: this.undo },
	                        _react2.default.createElement(_undo2.default, null)
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'renderGeneratedMessages',
	        value: function renderGeneratedMessages() {
	            var _this3 = this;
	
	            var generatedMessages = Array.isArray(this.state.generatedMessages) ? this.state.generatedMessages : [];
	            var succeessfulMessages = generatedMessages.filter(function (message) {
	                return message.succeed;
	            });
	            if (!succeessfulMessages.length) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Automatically generated messages'
	                ),
	                succeessfulMessages.map(function (el, index) {
	                    return _react2.default.createElement(_materialUi.MenuItem, { primaryText: el.result, key: index, onTouchTap: function onTouchTap() {
	                            return _this3.onMessageChange(el.result);
	                        } });
	                })
	            );
	        }
	    }, {
	        key: 'renderFacts',
	        value: function renderFacts() {
	            var _props$post = this.props.post,
	                facts = _props$post.facts,
	                hasResolvedFacts = _props$post.hasResolvedFacts;
	
	            if (!hasResolvedFacts) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Facts'
	                ),
	                _react2.default.createElement(_PostFacts.FactList, { facts: facts, onClick: this.onMessageChange })
	            );
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var post = this.props.post;
	
	            if (!post) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderPost(),
	                _react2.default.createElement(
	                    _withFeature2.default,
	                    { feature: 'messageServices' },
	                    this.renderGeneratedMessages()
	                ),
	                _react2.default.createElement(
	                    _withFeature2.default,
	                    { feature: 'messageServices' },
	                    this.renderFacts()
	                ),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    primary: true,
	                    label: 'Publish',
	                    style: { marginTop: 12 },
	                    onTouchTap: this.onPublish,
	                    icon: _react2.default.createElement(_publish2.default, null)
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                postId = _props.postId,
	                close = _props.close;
	
	            var open = Boolean(postId);
	            return _react2.default.createElement(
	                _materialUi.Dialog,
	                {
	                    open: open,
	                    className: 'no-padding-dialog',
	                    dialogContentStyle: {
	                        width: '90%',
	                        maxWidth: 'none'
	                    },
	                    autoScrollBodyContent: true,
	                    repositionOnUpdate: true,
	                    autoDetectWindowHeight: true,
	                    modal: false,
	                    title: 'Publish post',
	                    onRequestClose: close
	                },
	                this.renderContent()
	            );
	        }
	    }]);
	
	    return PublishDialog;
	}(_react2.default.PureComponent);
	
	PublishDialog.propTypes = {
	    postId: _propTypes2.default.string,
	    post: _propTypes2.default.object,
	    close: _propTypes2.default.func,
	    updateMessage: _propTypes2.default.func,
	    updatePost: _propTypes2.default.func,
	    approvePost: _propTypes2.default.func,
	    publish: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state, _ref2) {
	    var postId = _ref2.postId;
	    return {
	        post: _lodash2.default.get((0, _selectors.getEntities)(state), ['posts', postId])
	    };
	}, function (dispatch, _ref3) {
	    var campaignId = _ref3.campaignId;
	    return {
	        updateMessage: function updateMessage(postId, message) {
	            return dispatch((0, _posts.updatePostMessage)(postId)(message));
	        },
	        updatePost: function updatePost(postId, updates) {
	            return dispatch((0, _posts.updatePost)(postId)(updates));
	        },
	        approvePost: function approvePost(postId) {
	            return dispatch((0, _withPagination.approveWithPagination)(postId));
	        }
	    };
	})(PublishDialog);

/***/ },
/* 1966 */,
/* 1967 */,
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FactList = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _selectors = __webpack_require__(618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fact = function Fact(_ref) {
	    var message = _ref.fact.message,
	        id = _ref.id,
	        onClick = _ref.onClick;
	
	    return message ? _react2.default.createElement(
	        _materialUi.MenuItem,
	        { onTouchTap: function onTouchTap() {
	                return onClick(message);
	            } },
	        message
	    ) : null;
	};
	
	var FactEnhanced = (0, _reactRedux.connect)(function (state, _ref2) {
	    var id = _ref2.id;
	
	    return { fact: (0, _selectors.getEntities)(state).facts[id] };
	})(Fact);
	
	var FactList = exports.FactList = function FactList(_ref3) {
	    var facts = _ref3.facts,
	        onClick = _ref3.onClick;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        facts.map(function (id, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: id },
	                _react2.default.createElement(FactEnhanced, { id: id, onClick: onClick })
	            );
	        })
	    );
	};

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    .pickers-wrapper {\n        display: flex;\n        justify-content: space-between;\n    }\n    .preview-image-picker {\n        width: 48%;\n        > img {\n            height: auto;\n            width: 100%;\n        }\n    }\n'], ['\n    .pickers-wrapper {\n        display: flex;\n        justify-content: space-between;\n    }\n    .preview-image-picker {\n        width: 48%;\n        > img {\n            height: auto;\n            width: 100%;\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _save = __webpack_require__(1069);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _undo = __webpack_require__(1967);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _queryString = __webpack_require__(1055);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _materialUi = __webpack_require__(642);
	
	var _immutabilityHelper = __webpack_require__(596);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _EmojiPicker = __webpack_require__(1600);
	
	var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	var _selectors = __webpack_require__(618);
	
	var _posts = __webpack_require__(1902);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withPagination = __webpack_require__(1901);
	
	var _helpers = __webpack_require__(592);
	
	var _withFeature = __webpack_require__(1864);
	
	var _withFeature2 = _interopRequireDefault(_withFeature);
	
	var _PostFacts = __webpack_require__(1968);
	
	var _WDPContext = __webpack_require__(1369);
	
	var _WDPContext2 = _interopRequireDefault(_WDPContext);
	
	var _SMPostDialog = __webpack_require__(1595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PropControls = _styledComponents2.default.div(_templateObject);
	
	function cancellable(func) {
	    var cancelled = false;
	
	    var cancellabled = function cancellabled() {
	        if (!cancelled) {
	            func.apply(undefined, arguments);
	        }
	    };
	
	    cancellabled.cancel = function () {
	        cancelled = true;
	        if (typeof func.onCancel === 'function') {
	            func.onCancel();
	        }
	    };
	
	    return cancellabled;
	}
	
	var EditDialog = function (_React$PureComponent) {
	    _inherits(EditDialog, _React$PureComponent);
	
	    function EditDialog() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EditDialog);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (nextProps) {
	            if (_lodash2.default.get(nextProps, 'post.presentation.name') !== _lodash2.default.get(_this, 'props.post.presentation.name')) {
	                _this.loadWidget(_lodash2.default.get(nextProps, 'post.presentation.name'));
	            }
	            if (!nextProps.postId) {
	                _this.resetChanges();
	            }
	        }, _this.state = {
	            newParams: {},
	            title: null
	        }, _this.resetChanges = function () {
	            _this.setState({ newParams: {}, title: null });
	        }, _this.handleSave = function () {
	            var postId = _this.props.postId;
	
	            var changedParams = _extends({}, _this.state.newParams);
	            if (_this.state.title !== undefined) {
	                changedParams.title = _this.state.title;
	            }
	            _this.props.updatePost(postId, changedParams);
	            _this.props.close();
	            _this.resetChanges();
	        }, _this.loadWidget = function (wid) {
	            _this.widgetRequestCallback = cancellable(function () {
	                _this.setState(_defineProperty({}, wid, true));
	            });
	
	            if (wid && !_this.state[wid]) {
	                window.wdpload(wid, {}, {}, _this.widgetRequestCallback);
	            }
	        }, _this.renderControls = function () {
	            var mergedParams = _this.props.post.content.meta.mergedParams;
	
	            var wid = _this.props.post.presentation.name;
	            var widget = _lodash2.default.get(window, '[rlz' + wid + '][' + wid + ']');
	            if (mergedParams.tournamentId) mergedParams.tournamentId = +mergedParams.tournamentId;
	            if (!widget) return null;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_materialUi.TextField, {
	                    floatingLabelText: 'Title',
	                    style: { width: 600 },
	                    value: _this.state.title || mergedParams.title,
	                    onChange: function onChange(event, title) {
	                        _this.setState({ title: title });
	                    }
	                }),
	                _react2.default.createElement(
	                    PropControls,
	                    null,
	                    _react2.default.createElement(_SMPostDialog.WidgetParams, {
	                        widget: widget,
	                        backgroundOnly: true,
	                        jsprops: mergedParams,
	                        onChange: _this.handlePropChange,
	                        onPropChange: _this.handlePropChange
	                    })
	                )
	            );
	        }, _this.handlePropChange = function (prop, val) {
	            var changedProp = void 0;
	            if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	                changedProp = prop;
	            } else {
	                changedProp = {};
	                changedProp[prop] = val;
	            }
	
	            var upd = (0, _immutabilityHelper2.default)(_this.state, {
	                newParams: {
	                    $merge: changedProp
	                }
	            });
	            upd.newParams = _lodash2.default.omit(upd.newParams);
	            _this.setState(upd, function () {
	                // if (this.onPropsChange) this.onPropsChange();
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EditDialog, [{
	        key: 'renderWidget',
	        value: function renderWidget() {
	            var post = this.props.post;
	            var accessToken = this.context.user.accessToken;
	
	            var theme = {};
	            var template = {};
	            var wid = post.presentation.name;
	            var CMP = _lodash2.default.get(window, '[rlz' + wid + '][' + wid + ']');
	            if (!CMP) return;
	            var mergedParams = post.content.meta.mergedParams;
	
	            if (mergedParams.tournamentId) {
	                mergedParams.tournamentId = +mergedParams.tournamentId;
	            }
	
	            mergedParams = _lodash2.default.merge({}, mergedParams, this.state.newParams);
	            if (this.state.title !== undefined) {
	                mergedParams.title = this.state.title;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                        _WDPContext2.default,
	                        _extends({ token: accessToken, key: wid, social: true }, mergedParams),
	                        _react2.default.createElement(CMP, _extends({
	                            name: wid,
	                            social: true,
	                            tempTemplate: _lodash2.default.extend({}, template, { theme: theme }),
	                            token: accessToken
	                        }, mergedParams))
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderContent',
	
	
	        // onPropsChange = () => {
	        //     // let location = this.props.location;
	        //     console.log('this.props.router', this.props.router);
	        //     const query = qs.stringify(RCore.prepareWidgetPropsObj(this.state.newProps));
	        //     console.log('dasdadad', query);
	        //     return;
	        //     window.history.pushState({}, '', location.pathname + '?' + query);
	        // }
	
	        value: function renderContent() {
	            var post = this.props.post;
	
	            if (!post) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderControls(),
	                this.renderWidget(),
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    primary: true,
	                    label: 'Save and generate',
	                    style: { marginTop: 12 },
	                    onTouchTap: this.handleSave,
	                    icon: _react2.default.createElement(_save2.default, null)
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                postId = _props.postId,
	                close = _props.close;
	
	            var open = Boolean(postId);
	            return _react2.default.createElement(
	                _materialUi.Dialog,
	                {
	                    open: open,
	                    className: 'no-padding-dialog',
	                    contentStyle: {
	                        width: '90%',
	                        maxWidth: 863
	                    },
	                    autoScrollBodyContent: true,
	                    repositionOnUpdate: true,
	                    autoDetectWindowHeight: true,
	                    modal: false,
	                    title: 'Edit post and regenerate',
	                    onRequestClose: close
	                },
	                this.renderContent()
	            );
	        }
	    }]);
	
	    return EditDialog;
	}(_react2.default.PureComponent);
	
	EditDialog.contextTypes = {
	    user: _propTypes2.default.object.isRequired
	};
	
	
	EditDialog.propTypes = {
	    postId: _propTypes2.default.string,
	    post: _propTypes2.default.object,
	    close: _propTypes2.default.func,
	    updatePost: _propTypes2.default.func,
	    approvePost: _propTypes2.default.func,
	    publish: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state, _ref2) {
	    var postId = _ref2.postId;
	    return {
	        post: _lodash2.default.get((0, _selectors.getEntities)(state), ['posts', postId])
	    };
	}, function (dispatch, _ref3) {
	    var campaignId = _ref3.campaignId;
	    return {
	        updatePost: function updatePost(postId, updates) {
	            return dispatch((0, _posts.updatePost)(postId)(updates));
	        },
	        approvePost: function approvePost(postId) {
	            return dispatch((0, _withPagination.approveWithPagination)(postId));
	        }
	    };
	})(EditDialog);

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _colors = __webpack_require__(910);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(579);
	
	var _RuleForm = __webpack_require__(1849);
	
	var _ConditionForm = __webpack_require__(1850);
	
	var _ConditionForm2 = _interopRequireDefault(_ConditionForm);
	
	var _PayloadForm = __webpack_require__(1971);
	
	var _PayloadForm2 = _interopRequireDefault(_PayloadForm);
	
	var _Error = __webpack_require__(1866);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _enhancers = __webpack_require__(1785);
	
	var _trigger = __webpack_require__(1973);
	
	var _helpers = __webpack_require__(1049);
	
	var _schema = __webpack_require__(1823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mockData = {
	    conditions: {
	        sportId: '1',
	        ttId: '46',
	        eventId: '5095488',
	        homeId: '10202',
	        awayId: '8410',
	        incident_type: 'goal'
	    },
	    payload: {
	        incidentId: 5095488,
	        awayId: 8410,
	        homeId: 10202,
	        sportId: 1,
	        tournamentId: 46,
	        eventId: 2511282
	    },
	    triggerType: 'enet_event_incident'
	};
	
	var withTriggerTypeHOC = (0, _enhancers.withTriggerType)(_constants.MANUAL_TRIGGER_FORM_ID);
	
	var mapDispatchToPropsTriggerForm = function mapDispatchToPropsTriggerForm(dispatch) {
	    return {
	        onTriggerChange: function onTriggerChange() {
	            dispatch((0, _reduxForm.change)(_constants.MANUAL_TRIGGER_FORM_ID, _constants.CAMPAIGN_FORM_KEYS.RULES.CONDITIONS.ARRAY, { sportId: '1' }));
	            dispatch((0, _reduxForm.change)(_constants.MANUAL_TRIGGER_FORM_ID, 'payload', {}));
	        }
	    };
	};
	
	var TriggerFormEnhanced = (0, _reactRedux.connect)(null, mapDispatchToPropsTriggerForm)(_RuleForm.TriggerForm);
	
	var ConditionFormEnhanced = withTriggerTypeHOC(_ConditionForm2.default);
	
	var PayloadFormEnhanced = withTriggerTypeHOC(_PayloadForm2.default);
	
	var ErrorComponentEnhanced = (0, _reactRedux.connect)(function (state) {
	    return {
	        value: _lodash2.default.get((0, _reduxForm.getFormSubmitErrors)(_constants.MANUAL_TRIGGER_FORM_ID)(state), 'errors')
	    };
	})(_Error2.default);
	
	var EnvComponent = function EnvComponent() {
	    var env = ("prod");
	    var color = env === 'dev' ? _colors.green800 : _colors.red400;
	    return _react2.default.createElement(
	        'h2',
	        null,
	        'ENVIRONMENT: ',
	        _react2.default.createElement(
	            'span',
	            { style: { color: color } },
	            env
	        )
	    );
	};
	
	var ManualTriggerForm = function (_React$PureComponent) {
	    _inherits(ManualTriggerForm, _React$PureComponent);
	
	    function ManualTriggerForm(props, ctx) {
	        _classCallCheck(this, ManualTriggerForm);
	
	        var _this = _possibleConstructorReturn(this, (ManualTriggerForm.__proto__ || Object.getPrototypeOf(ManualTriggerForm)).call(this, props, ctx));
	
	        _this.state = {
	            showBadge: false
	        };
	        return _this;
	    }
	
	    _createClass(ManualTriggerForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.initialize(mockData);
	            window.onbeforeunload = function () {
	                return 'Are you sure to refresh the page?';
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var _this2 = this;
	
	            var submitSucceeded = _ref.submitSucceeded;
	
	            if (this.props.submitting && submitSucceeded) {
	                this.setState({ showBadge: true });
	                setTimeout(function () {
	                    return _this2.setState({ showBadge: false });
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.onbeforeunload = null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                reset = _props.reset,
	                submit = _props.submit,
	                valid = _props.valid;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(EnvComponent, null),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Manual trigger'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(ErrorComponentEnhanced, null)
	                ),
	                _react2.default.createElement(TriggerFormEnhanced, null),
	                _react2.default.createElement(
	                    _reduxForm.FormSection,
	                    { name: _constants.CAMPAIGN_FORM_KEYS.RULES.CONDITIONS.ARRAY },
	                    _react2.default.createElement(ConditionFormEnhanced, { allRequired: true })
	                ),
	                _react2.default.createElement(
	                    _reduxForm.FormSection,
	                    { name: 'payload' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Payload'
	                    ),
	                    _react2.default.createElement(PayloadFormEnhanced, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_materialUi.RaisedButton, { primary: true, onTouchTap: submit, label: 'Submit' }),
	                    _react2.default.createElement(_materialUi.RaisedButton, { secondary: true, style: { marginLeft: 12 }, label: 'Clear', onTouchTap: reset })
	                ),
	                _react2.default.createElement(_materialUi.Snackbar, { open: this.state.showBadge, message: 'Success', autoHideDuration: 4000 })
	            );
	        }
	    }]);
	
	    return ManualTriggerForm;
	}(_react2.default.PureComponent);
	
	var mapData = function mapData(value) {
	    var triggerType = value[_constants.CAMPAIGN_FORM_KEYS.RULES.KEY],
	        conditions = value[_constants.CAMPAIGN_FORM_KEYS.RULES.CONDITIONS.ARRAY],
	        payload = value.payload;
	
	    var routingKey = (0, _schema.generateRoutingKey)(triggerType, conditions);
	    return { routingKey: routingKey, payload: payload };
	};
	
	var onSubmit = function onSubmit(value, dispatch) {
	    var mappedData = mapData(value);
	    return dispatch((0, _trigger.createTrigger)(mappedData)).then(_helpers.handleServerError);
	};
	
	exports.default = (0, _reduxForm.reduxForm)({ form: _constants.MANUAL_TRIGGER_FORM_ID, onSubmit: onSubmit })(ManualTriggerForm);

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _help = __webpack_require__(1972);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _materialUi = __webpack_require__(642);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _validation = __webpack_require__(1660);
	
	var _helpers = __webpack_require__(1821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PayloadForm = function PayloadForm(_ref) {
	    var triggerType = _ref.triggerType;
	
	    var triggerProps = _lodash2.default.get(_triggerConstants.TRIGGER_SCHEMAS[triggerType], 'properties', {});
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' } },
	        Object.keys(triggerProps).filter(function (e) {
	            return e !== 'debug';
	        }).map(function (name, index) {
	            var curProp = triggerProps[name];
	            var validateFunctions = [];
	            var isNumeric = curProp.type === 'integer';
	            var isArray = curProp.type === 'array';
	            var additionalProps = {};
	            if (curProp.required) {
	                validateFunctions.push(_validation.presence);
	            }
	            if (isNumeric) {
	                validateFunctions.push(_validation.numeric);
	            }
	            if (isArray) {
	                isNumeric = curProp.items.type === 'integer';
	                additionalProps = _extends({}, additionalProps, {
	                    normalize: (0, _validation.normalizeArray)(isNumeric),
	                    format: _validation.formatArray
	                });
	            }
	            return _react2.default.createElement(
	                'span',
	                { key: name, style: { display: 'flex', alignItems: 'baseline' } },
	                Boolean(index) && _react2.default.createElement(_helpers.DotDivider, null),
	                _react2.default.createElement(_reduxForm.Field, _extends({
	                    type: isNumeric && !isArray ? 'number' : 'text',
	                    parse: isNumeric && !isArray ? _validation.parseNumber : undefined,
	                    name: name,
	                    component: _reduxFormMaterialUi.TextField,
	                    style: { width: 120 },
	                    floatingLabelText: (0, _humanizeString2.default)(name),
	                    validate: validateFunctions
	                }, additionalProps)),
	                isArray && _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { tooltip: 'Split by spaces' },
	                    _react2.default.createElement(_help2.default, null)
	                )
	            );
	        })
	    );
	};
	
	PayloadForm.propTypes = {
	    triggerType: _propTypes2.default.string
	};
	
	exports.default = PayloadForm;

/***/ },
/* 1972 */,
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createTrigger = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTrigger = exports.createTrigger = function createTrigger(value) {
	    var url = _cfg2.default.triggerer.host + '/api/triggers';
	    var config = {
	        body: value,
	        url: url,
	        queryKey: 'trigger',
	        key: 'trigger',
	        force: true,
	        transform: function transform(response) {
	            return {};
	        },
	        update: {},
	        options: {
	            method: _reduxQuery.httpMethods.POST
	        }
	    };
	    return (0, _reduxQuery.requestAsync)(config);
	};

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(1975);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _selectors = __webpack_require__(618);
	
	var _predictions = __webpack_require__(2122);
	
	var _campaigns = __webpack_require__(1822);
	
	var _events = __webpack_require__(1058);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventLabel = (0, _reactRedux.connect)(function (state, _ref) {
	    var eventId = _ref.eventId;
	    return {
	        event: _lodash2.default.get((0, _selectors.getEntities)(state), 'events.' + eventId),
	        pending: _lodash2.default.get((0, _selectors.getQueries)(state), '[events/' + eventId + '].isPending', true)
	    };
	}, function (dispatch) {
	    return {
	        fetchEvent: function fetchEvent(eventId) {
	            return dispatch((0, _events.fetchEventById)(eventId));
	        }
	    };
	})(function (_React$PureComponent) {
	    _inherits(_EventLabel, _React$PureComponent);
	
	    function _EventLabel() {
	        _classCallCheck(this, _EventLabel);
	
	        return _possibleConstructorReturn(this, (_EventLabel.__proto__ || Object.getPrototypeOf(_EventLabel)).apply(this, arguments));
	    }
	
	    _createClass(_EventLabel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                eventId = _props.eventId,
	                fetchEvent = _props.fetchEvent;
	
	            if (eventId) {
	                fetchEvent(eventId);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var eventId = _ref2.eventId,
	                event = _ref2.event;
	
	            if (this.props.eventId !== eventId && eventId) {
	                this.props.fetchEvent(eventId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                event = _props2.event,
	                pending = _props2.pending;
	
	            var label = event ? 'Event: ' + event.homeShortName + ' - ' + event.awayShortName : '';
	            return _react2.default.createElement(
	                'div',
	                null,
	                pending ? _react2.default.createElement(_materialUi.LinearProgress, null) : label
	            );
	        }
	    }]);
	
	    return _EventLabel;
	}(_react2.default.PureComponent));
	
	var TooltipContent = function TooltipContent(_ref3) {
	    var label = _ref3.label,
	        payload = _ref3.payload,
	        byDate = _ref3.byDate,
	        rules = _ref3.rules;
	
	    var date = (0, _moment2.default)(label);
	    var items = _lodash2.default.get(byDate, date.format('YYYY/MM/DD HH'), []);
	    return _react2.default.createElement(
	        'div',
	        {
	            style: {
	                backgroundColor: 'white',
	                minWidth: 200,
	                minHeight: 200,
	                border: '1px solid #ccc'
	            }
	        },
	        _react2.default.createElement(
	            'h4',
	            { style: { textAlign: 'center' } },
	            date.format('DD MMMM HH:00'),
	            '-',
	            date.clone().add(1, 'h').format('HH:00')
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            Array.isArray(payload) ? payload.map(function (el) {
	                return _react2.default.createElement(
	                    'p',
	                    { key: el.dataKey, style: { padding: 12 } },
	                    el.name,
	                    ': ',
	                    el.value
	                );
	            }) : null,
	            items.map(function (el, index) {
	                var eventId = _lodash2.default.get(el, 'meta.eventId');
	                return _react2.default.createElement(
	                    'div',
	                    { key: index },
	                    _react2.default.createElement(_materialUi.Divider, null),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { padding: 12, marginTop: 4 } },
	                        (0, _moment2.default)(el.date).format('HH:mm'),
	                        ' ',
	                        (0, _humanizeString2.default)(_lodash2.default.get(rules, el.ruleId + '.triggerType', '')),
	                        eventId ? _react2.default.createElement(EventLabel, { eventId: eventId }) : null
	                    )
	                );
	            })
	        )
	    );
	};
	
	var mapPredictions = function mapPredictions(predictions) {
	    if (!predictions || !predictions.length) {
	        return {
	            byDate: {},
	            data: []
	        };
	    }
	    var today = (0, _moment2.default)().startOf('d');
	    var lastDate = (0, _moment2.default)(_lodash2.default.last(predictions).date);
	    var hoursDiff = lastDate.diff(today, 'h');
	    var byDate = predictions.reduce(function (acc, cur) {
	        var date = (0, _moment2.default)(cur.date).format('YYYY/MM/DD HH');
	        if (acc[date]) {
	            acc[date].push(cur);
	        } else {
	            acc[date] = [cur];
	        }
	        return acc;
	    }, {});
	    return {
	        byDate: byDate,
	        data: _lodash2.default.times(hoursDiff).map(function (hoursQuantity) {
	            var curDate = today.clone().add(hoursQuantity, 'h');
	            var formatted = curDate.format('YYYY/MM/DD HH');
	            var curPredictions = Array.isArray(byDate[formatted]) ? byDate[formatted] : [];
	            return {
	                date: curDate.format(),
	                quantity: curPredictions.length
	            };
	        })
	    };
	};
	var ReferenceLabel = function ReferenceLabel(props) {
	    var fill = props.fill,
	        value = props.value,
	        textAnchor = props.textAnchor,
	        fontSize = props.fontSize,
	        viewBox = props.viewBox,
	        dy = props.dy,
	        dx = props.dx;
	
	    var x = viewBox.width + viewBox.x + 5;
	    var y = viewBox.y + 10;
	    return _react2.default.createElement(
	        'text',
	        { x: x, y: y, dy: dy, dx: dx, fill: fill, fontSize: fontSize || 10, textAnchor: textAnchor },
	        value
	    );
	};
	
	var PostPredictions = function (_React$PureComponent2) {
	    _inherits(PostPredictions, _React$PureComponent2);
	
	    function PostPredictions() {
	        var _ref4;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, PostPredictions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref4 = PostPredictions.__proto__ || Object.getPrototypeOf(PostPredictions)).call.apply(_ref4, [this].concat(args))), _this2), _this2.state = {
	            mapped: [],
	            byDate: {},
	            rules: {},
	            dates: [],
	            showSnackbar: false
	        }, _this2.generatePredictions = function () {
	            var campaignId = _this2.props.params.campaignId;
	
	            _superagent2.default.post(_cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/predictions?access_token=' + _auth2.default.getAccessToken()).then(function () {
	                _this2.setState({ showSnackbar: true });
	                setTimeout(function () {
	                    return _this2.setState({ showSnackbar: false });
	                }, 3000);
	            });
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(PostPredictions, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props3 = this.props,
	                params = _props3.params,
	                fetchPredictions = _props3.fetchPredictions,
	                fetchCampaign = _props3.fetchCampaign;
	
	            fetchPredictions(params.campaignId);
	            fetchCampaign(params.campaignId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            if (this.props.data !== props.data) {
	                var _mapPredictions = mapPredictions(props.data),
	                    byDate = _mapPredictions.byDate,
	                    data = _mapPredictions.data;
	
	                var now = (0, _moment2.default)().hour(0).second(0).minute(0);
	                var dates = _lodash2.default.times((0, _moment2.default)(_lodash2.default.get(_lodash2.default.last(data), 'date', now.clone().add(1, 'd').format())).diff(now, 'd')).map(function (count) {
	                    return now.clone().add(count, 'd').toDate();
	                });
	                this.setState({ mapped: data, byDate: byDate, dates: dates });
	            }
	            if (this.props.campaign !== props.campaign) {
	                var rules = _lodash2.default.get(props.campaign, 'rules', []);
	                var rulesMap = rules.reduce(function (acc, cur) {
	                    acc[cur._id] = cur;
	                    return acc;
	                }, {});
	                this.setState({ rules: rulesMap });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                mapped = _state.mapped,
	                byDate = _state.byDate,
	                rules = _state.rules,
	                dates = _state.dates;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { marginTop: 48 } },
	                _react2.default.createElement(_materialUi.RaisedButton, {
	                    onTouchTap: this.generatePredictions,
	                    label: 'Generate',
	                    style: { margin: '0px 12px 16px 12px' }
	                }),
	                _react2.default.createElement(_materialUi.Snackbar, { open: this.state.showSnackbar, message: 'Sent to process' }),
	                _react2.default.createElement(
	                    _recharts.ResponsiveContainer,
	                    { height: 400 },
	                    _react2.default.createElement(
	                        _recharts.LineChart,
	                        { data: mapped },
	                        _react2.default.createElement(_recharts.Tooltip, { isAnimationActive: false, content: TooltipContent, byDate: byDate, rules: rules }),
	                        _react2.default.createElement(_recharts.YAxis, { allowDecimals: false }),
	                        _react2.default.createElement(_recharts.XAxis, {
	                            dataKey: 'date',
	                            minTickGap: 0,
	                            tick: function tick(props) {
	                                var date = _lodash2.default.get(props, 'payload.value');
	                                var mom = (0, _moment2.default)(date);
	                                var hours = mom.hours();
	                                var text = hours === 1 ? mom.format('DD MMM') : mom.format('HH:00');
	                                return _react2.default.createElement(
	                                    'text',
	                                    {
	                                        width: props.width,
	                                        height: props.height,
	                                        x: props.x,
	                                        y: props.y,
	                                        stroke: props.stroke,
	                                        fill: props.fill,
	                                        className: 'recharts-text recharts-cartesian-axis-tick-value',
	                                        textAnchor: props.textAnchor
	                                    },
	                                    _react2.default.createElement(
	                                        'tspan',
	                                        { x: props.x, dy: '0.71em' },
	                                        text
	                                    )
	                                );
	                            }
	                        }),
	                        dates.map(function (el) {
	                            var date = (0, _moment2.default)(el);
	                            var x = date.format();
	                            return _react2.default.createElement(_recharts.ReferenceLine, {
	                                key: x,
	                                x: x,
	                                stroke: '#666',
	                                label: _react2.default.createElement(ReferenceLabel, { value: date.format('DD MMM'), fill: '#666' })
	                            });
	                        }),
	                        _react2.default.createElement(_recharts.Line, { dataKey: 'quantity', name: 'Quantity', type: 'monotone', stroke: '#82ca9d', dot: false })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostPredictions;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function (state, _ref5) {
	    var params = _ref5.params;
	    return {
	        data: (0, _selectors.getEntities)(state)[params.campaignId + '/postPredictions'],
	        campaign: _lodash2.default.get((0, _selectors.getEntities)(state), 'campaigns.' + params.campaignId)
	    };
	}, function (dispatch) {
	    return {
	        fetchPredictions: function fetchPredictions(campaignId) {
	            return dispatch((0, _predictions.fetchPostPredictions)(campaignId));
	        },
	        fetchCampaign: function fetchCampaign(campaignId) {
	            return dispatch((0, _campaigns.fetchCampaignById)(campaignId));
	        }
	    };
	})(PostPredictions);

/***/ },
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPostPredictions = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var fetchPostPredictions = exports.fetchPostPredictions = function fetchPostPredictions(campaignId) {
	    return (0, _reduxQuery.requestAsync)({
	        queryKey: campaignId + '/postPredictions',
	        url: _cfg2.default.campaign_manager.host + '/api/campaigns/' + campaignId + '/predictions?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        transform: function transform(res) {
	            return _defineProperty({}, campaignId + '/postPredictions', res.predictions);
	        },
	        update: _defineProperty({}, campaignId + '/postPredictions', function undefined(prev, next) {
	            return next;
	        })
	    });
	};

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _materialUi = __webpack_require__(642);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selectors = __webpack_require__(618);
	
	var _ui = __webpack_require__(574);
	
	var _constants = __webpack_require__(579);
	
	var _WidgetForm = __webpack_require__(1859);
	
	var _WidgetForm2 = _interopRequireDefault(_WidgetForm);
	
	var _SelectCampaignForm = __webpack_require__(2124);
	
	var _SelectCampaignForm2 = _interopRequireDefault(_SelectCampaignForm);
	
	var _WDPWidgetPreview = __webpack_require__(2125);
	
	var _WDPWidgetPreview2 = _interopRequireDefault(_WDPWidgetPreview);
	
	var _actions = __webpack_require__(1047);
	
	var _posts = __webpack_require__(1902);
	
	var _withPagination = __webpack_require__(1901);
	
	var _enhancers = __webpack_require__(1785);
	
	var _helpers = __webpack_require__(1049);
	
	var _ParamsCuztomizer = __webpack_require__(1860);
	
	var _schema = __webpack_require__(1823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var mapStateToPropsWidget = function mapStateToPropsWidget(state) {
	    var widgets = _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS], 'widgets');
	    var templates = (0, _selectors.getEntities)(state)[_constants.STORE_KEYS.TEMPLATES];
	    return {
	        widgets: widgets,
	        templates: templates
	    };
	};
	
	var paramsPath = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY;
	var updateWidgetParams = function updateWidgetParams(value) {
	    return function (dispatch, getState) {
	        var widget = value.widget;
	        var widgetProps = widget.spec.propTypes;
	
	        var initValue = (0, _schema.getWidgetParamsInitValue)(widgetProps, {});
	        return dispatch((0, _reduxForm.change)(_constants.MANUAL_POST_FORM_ID, paramsPath, initValue));
	    };
	};
	
	var WidgetFormEnhanced = (0, _reactRedux.connect)(mapStateToPropsWidget, function (dispatch) {
	    return {
	        onChange: function onChange(value) {
	            return dispatch(updateWidgetParams(value));
	        }
	    };
	})(_WidgetForm2.default);
	
	var SelectCampaignFormEnhanced = (0, _enhancers.withCampaigns)(_SelectCampaignForm2.default);
	var WDPWidgetPreviewEnhanced = (0, _reactRedux.connect)(function (state) {
	    var values = (0, _reduxForm.getFormValues)(_constants.MANUAL_POST_FORM_ID)(state);
	
	    var widgets = _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS], 'widgets');
	    var widget = _lodash2.default.find(widgets, function (w) {
	        return w.id === _lodash2.default.get(values, 'presentation.name');
	    });
	    var isVideo = _lodash2.default.get(widget, 'spec.video', false);
	
	    return values && values.presentation ? {
	        isVideo: isVideo,
	        name: values.presentation.name,
	        params: _extends({
	            client: state.user.client,
	            user: state.user.username,
	            theme: 'social'
	        }, values.presentation.params, _lodash2.default.fromPairs(_lodash2.default.get(values, 'presentation.additional', []).map(function (o) {
	            return [o.key, o.customValue];
	        })), {
	            load: isVideo ? 'animated' : undefined
	        })
	    } : {};
	})(_WDPWidgetPreview2.default);
	
	var selector = (0, _reduxForm.formValueSelector)(_constants.MANUAL_POST_FORM_ID);
	var widgetNameKey = _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + _constants.CAMPAIGN_FORM_KEYS.WIDGET.NAME;
	
	var mapStateToPropsParams = function mapStateToPropsParams(state, _ref) {
	    var name = _ref.fields.name;
	
	    var values = selector(state, name);
	    var widgetId = selector(state, widgetNameKey);
	    var widgets = _lodash2.default.get((0, _selectors.getEntities)(state)[_constants.STORE_KEYS.WIDGET_SPECS], 'widgets');
	    return { values: values, widgets: widgets, widgetId: widgetId };
	};
	
	var ParamsCustomizerEnhanced = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToPropsParams))(_ParamsCuztomizer.ParamsCustomizer);
	
	var MessageForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        withMessage: Boolean((0, _reduxForm.formValueSelector)(_constants.MANUAL_POST_FORM_ID)(state, 'withMessage'))
	    };
	})(function (_ref2) {
	    var withMessage = _ref2.withMessage;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { width: 200 } },
	            _react2.default.createElement(_reduxForm.Field, { name: 'withMessage', component: _reduxFormMaterialUi.Toggle, label: 'With message' })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            withMessage ? _react2.default.createElement(
	                _reduxForm.FormSection,
	                { name: 'content' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'message', multiLine: true, floatingLabelText: 'Message', component: _reduxFormMaterialUi.TextField })
	            ) : null
	        )
	    );
	});
	
	var ManualPost = function ManualPost(_ref3) {
	    var submit = _ref3.submit,
	        reset = _ref3.reset,
	        showBadge = _ref3.showBadge;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        width: 800,
	                        margin: '20 auto'
	                    }
	                },
	                _react2.default.createElement(WDPWidgetPreviewEnhanced, null)
	            )
	        ),
	        _react2.default.createElement(SelectCampaignFormEnhanced, null),
	        _react2.default.createElement(
	            _reduxForm.FormSection,
	            { name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION },
	            _react2.default.createElement(WidgetFormEnhanced, null),
	            _react2.default.createElement(_reduxForm.FieldArray, {
	                name: _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY,
	                component: ParamsCustomizerEnhanced
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { margin: '12px 0px 12px 0px' } },
	            _react2.default.createElement(MessageForm, null)
	        ),
	        _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: 'Submit', onTouchTap: submit }),
	        _react2.default.createElement(_materialUi.RaisedButton, { secondary: true, style: { marginLeft: 12 }, label: 'Reset', onTouchTap: reset }),
	        _react2.default.createElement(_materialUi.Snackbar, { open: showBadge, message: 'Success' })
	    );
	};
	
	var mapData = function mapData(values) {
	    var _extends2;
	
	    var presentation = values[_constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION],
	        withMessage = values.withMessage,
	        rest = _objectWithoutProperties(values, [_constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION, 'withMessage']);
	
	    var additional = presentation[_constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY],
	        restAdditional = _objectWithoutProperties(presentation, [_constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY]);
	
	    var params = (additional || []).reduce(function (acc, cur) {
	        acc[cur[_constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.KEY]] = cur[_constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.CUSTOM_VALUE];
	        return acc;
	    }, _extends({}, restAdditional[_constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION]));
	    return _extends({}, rest, _defineProperty({
	        content: withMessage ? { message: _lodash2.default.get(rest, 'content.message', '') } : {}
	    }, _constants.CAMPAIGN_FORM_KEYS.WIDGET.SECTION, _extends({}, restAdditional, (_extends2 = {}, _defineProperty(_extends2, _constants.CAMPAIGN_FORM_KEYS.WIDGET.TYPE, 'widget-social'), _defineProperty(_extends2, _constants.CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION, params), _extends2))));
	};
	
	var onSubmit = function onSubmit(values, dispatch) {
	    var mappedData = mapData(values);
	    return dispatch((0, _posts.manualCreatePost)(mappedData)).then(_helpers.handleServerError);
	};
	
	exports.default = (0, _recompose.compose)((0, _reduxForm.reduxForm)({ form: _constants.MANUAL_POST_FORM_ID, onSubmit: onSubmit }), _enhancers.withUserData, (0, _recompose.lifecycle)({
	    componentDidMount: function componentDidMount() {
	        var _props = this.props,
	            _props$user = _props.user,
	            _id = _props$user._id,
	            client = _props$user.client,
	            dispatch = _props.dispatch,
	            _props$params = _props.params,
	            campaignId = _props$params.campaignId,
	            widgetId = _props$params.widgetId,
	            state = _props.location.state,
	            initialize = _props.initialize;
	
	        var widgetData = {
	            presentation: { name: widgetId }
	        };
	        Promise.all([dispatch((0, _actions.fetchWidgetSpecs)(client)), dispatch((0, _actions.fetchTemplates)()), dispatch((0, _withPagination.fetchCampaignsWithPagination)(_id))]).then(function (res) {
	            var widgets = _lodash2.default.get(res[0].entities, 'widget-specs.widgets', []);
	
	            if (state) {
	                widgetData.presentation.name = state.widgetId;
	                _lodash2.default.set(widgetData, 'presentation.params.template', state.template);
	                var props = state.props;
	
	
	                var additional = Object.keys(props || {}).map(function (prop) {
	                    var normalizedProp = _lodash2.default.camelCase(prop.replace('data-', ''));
	                    return {
	                        key: prop,
	                        value: 'manual',
	                        customValue: props[prop],
	                        byTrigger: false
	                    };
	                });
	                var selectedWidget = widgets.find(function (el) {
	                    return el.id === state.widgetId;
	                });
	                if (selectedWidget) {
	                    var propTypes = selectedWidget.spec.propTypes;
	
	                    var filtered = propTypes.filter(function (prop) {
	                        return prop.key !== 'template' && !additional.some(function (el) {
	                            return el.key === prop.key;
	                        });
	                    });
	                    filtered.forEach(function (prop) {
	                        additional.push({
	                            key: prop.key,
	                            value: 'manual',
	                            customValue: prop.defaultValue,
	                            byTrigger: false
	                        });
	                    });
	                }
	                widgetData.presentation.additional = additional;
	                if (campaignId) {
	                    widgetData.campaignId = campaignId;
	                }
	                initialize(widgetData);
	            } else {
	                var _selectedWidget = widgets.find(function (w) {
	                    return w.id === widgetId;
	                });
	                initialize(_extends({ campaignId: campaignId }, widgetData));
	            }
	        });
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(_ref4) {
	        var submitSucceeded = _ref4.submitSucceeded,
	            dispatch = _ref4.dispatch;
	
	        if (this.props.submitting && submitSucceeded) {
	            dispatch({
	                type: _ui.UI_ACTIONS.CHANGE,
	                key: 'showBadge',
	                value: true
	            });
	            setTimeout(function () {
	                return dispatch({
	                    type: _ui.UI_ACTIONS.CHANGE,
	                    key: 'showBadge',
	                    value: false
	                });
	            }, 1000);
	        }
	    }
	}), (0, _reactRedux.connect)(function (state) {
	    return {
	        showBadge: Boolean(state.ui.showBadge)
	    };
	}))(ManualPost);

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _materialUi = __webpack_require__(642);
	
	var _validation = __webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectCampaignForm = function SelectCampaignForm(_ref) {
	    var _ref$campaigns = _ref.campaigns,
	        campaigns = _ref$campaigns === undefined ? [] : _ref$campaigns;
	
	    return _react2.default.createElement(
	        _reduxForm.Field,
	        { name: 'campaignId', validate: _validation.presence, floatingLabelText: 'Select campaign', component: _reduxFormMaterialUi.SelectField },
	        campaigns.map(function (campaign) {
	            return _react2.default.createElement(_materialUi.MenuItem, { key: campaign._id, value: campaign._id, primaryText: campaign.title });
	        })
	    );
	};
	
	SelectCampaignForm.propTypes = {
	    campaigns: _propTypes2.default.array
	};
	
	exports.default = SelectCampaignForm;

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WDPWidgetPreview = function WDPWidgetPreview(_ref) {
	    var name = _ref.name,
	        params = _ref.params,
	        isVideo = _ref.isVideo;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        name && _react2.default.createElement('rlz-widget', _extends({
	            key: name + '_' + JSON.stringify(params),
	            'class': 'smi-widget',
	            'data-load': 'js',
	            'data-name': name,
	            'data-token': 'cb4bf29d',
	            'data-min-width': 800,
	            'data-min-height': 350,
	            'data-sm-browser': true,
	            'data-__mode': 'strict'
	        }, _RCore2.default.obj2InjectorParams(params)))
	    );
	};
	
	WDPWidgetPreview.propTypes = {};
	
	exports.default = WDPWidgetPreview;

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _facts = __webpack_require__(2127);
	
	var _recompose = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FactsView = function (_React$PureComponent) {
	    _inherits(FactsView, _React$PureComponent);
	
	    function FactsView() {
	        _classCallCheck(this, FactsView);
	
	        return _possibleConstructorReturn(this, (FactsView.__proto__ || Object.getPrototypeOf(FactsView)).apply(this, arguments));
	    }
	
	    _createClass(FactsView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _facts.fetchEventFacts)(2511282, 'postMatch'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var facts = this.props.facts;
	
	
	            return _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Type'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Message'
	                    )
	                ),
	                facts.map(function (f) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: f.type },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            f.type
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            f.message
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return FactsView;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _recompose.compose)((0, _recompose.defaultProps)({
	    eventId: 2511282,
	    type: 'postMatch'
	}), (0, _reactRedux.connect)(function (state, _ref) {
	    var eventId = _ref.eventId,
	        type = _ref.type;
	
	    return {
	        facts: _lodash2.default.get(state, 'query.entities[\'' + eventId + '/facts/' + type + '\']', [])
	    };
	}, function (dispatch) {
	    return { dispatch: dispatch };
	}))(FactsView);

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchEventFacts = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var fetchEventFacts = exports.fetchEventFacts = function fetchEventFacts(eventId, type) {
	    return function (dispatch, getState) {
	        return dispatch((0, _reduxQuery.requestAsync)({
	            queryKey: eventId + '/facts/' + type,
	            url: _cfg2.default.apis.facts + '/api/bulk-messages?props.eventId=' + eventId + '&type=' + type + '&locale=' + _lodash2.default.get(getState(), 'user.lang', 'en'),
	            force: true,
	            transform: function transform(res) {
	                return _defineProperty({}, eventId + '/facts/' + type, res);
	            },
	            update: _defineProperty({}, eventId + '/facts/' + type, function undefined(prev, next) {
	                return next;
	            })
	        }));
	    };
	};

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    list-style: none;\n    padding: 0;\n    margin: 0 auto;\n    max-width: 1170px;\n    \n    > div {\n        border: 1px solid rgb(224, 224, 224);\n        border-bottom: none;\n        box-sizing: border-box;\n        padding: 0 !important;\n        margin: 10px 0;\n    }\n    \n    .id {\n        min-width: 120px;\n        text-align: center;\n    }\n    \n    .list-item {\n        > div > div {\n          padding: 0 !important;\n        }\n        \n        a {  \n          span {\n            flex: 0 1 50%;\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n              }\n          }\n        }\n     }   \n'], ['\n    list-style: none;\n    padding: 0;\n    margin: 0 auto;\n    max-width: 1170px;\n    \n    > div {\n        border: 1px solid rgb(224, 224, 224);\n        border-bottom: none;\n        box-sizing: border-box;\n        padding: 0 !important;\n        margin: 10px 0;\n    }\n    \n    .id {\n        min-width: 120px;\n        text-align: center;\n    }\n    \n    .list-item {\n        > div > div {\n          padding: 0 !important;\n        }\n        \n        a {  \n          span {\n            flex: 0 1 50%;\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n              }\n          }\n        }\n     }   \n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  display: flex;\n  height: calc(100% - 284px);\n  > * {\n    margin: auto;\n  }\n'], ['\n  text-align: center;\n  display: flex;\n  height: calc(100% - 284px);\n  > * {\n    margin: auto;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 20px 0;\n  display: block;\n  border: none;\n  a {\n    color: inherit;\n  }\n'], ['\n  margin: 20px 0;\n  display: block;\n  border: none;\n  a {\n    color: inherit;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(188);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _materialUi = __webpack_require__(642);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _forward = __webpack_require__(2129);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var _ = __webpack_require__(339);
	
	var TournamentsList = _styledComponents2.default.div(_templateObject);
	var Loader = _styledComponents2.default.div(_templateObject2);
	var SportMenu = _styledComponents2.default.span(_templateObject3);
	var sportIdToName = {
	    23: 'basketball',
	    51: 'volleyball',
	    33: 'badminton',
	    20: 'handball',
	    5: 'hockey',
	    1: 'soccer'
	};
	var tournamentsToShow = {
	    1: [46, 245, 282, 85, 239, 256, 242, 47, 48, 132, 133, 87, 138, 54, 146, 55, 141, 57, 53, 71, 67, 59, 42, 73, 77, 50, 9375, 76, 292],
	    51: [8884, 8883],
	    20: [352, 354, 358, 350, 348, 361, 363, 387, 353, 355, 359, 349, 362, 368, 364, 388],
	    5: [311, 24, 21, 9436, 33],
	    23: [391, 390, 392],
	    33: [9079]
	};
	
	var IDSTournaments = function (_Component) {
	    _inherits(IDSTournaments, _Component);
	
	    function IDSTournaments() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, IDSTournaments);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IDSTournaments.__proto__ || Object.getPrototypeOf(IDSTournaments)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            tournaments: [],
	            sport: _this.props.params.sport,
	            dataLoading: true,
	            open: false
	        }, _this.handleTouchTap = function () {
	            _this.setState({
	                open: true
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({
	                open: false
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IDSTournaments, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            //when props are change
	            this.setState({
	                sport: nextProps.params.sport,
	                dataLoading: true
	            }, function () {
	                _this2.loadData();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.dataLoading) return _react2.default.createElement(
	                Loader,
	                null,
	                _react2.default.createElement(_CircularProgress2.default, null)
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderTournaments()
	            );
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this3 = this;
	
	            var sport = this.state.sport;
	
	            var sportId = _.findKey(sportIdToName, function (name) {
	                return name === sport;
	            });
	
	            _bluebird2.default.props({
	                tournaments: fetch(_cfg2.default.apis.ss2 + '/tournaments?sportId=' + sportId).then(function (response) {
	                    return response.json();
	                })
	
	            }).then(function (res) {
	                _this3.setState({
	                    tournaments: res.tournaments,
	                    dataLoading: false
	                });
	            });
	        }
	    }, {
	        key: 'getTournaments',
	        value: function getTournaments() {
	            var _state = this.state,
	                tournaments = _state.tournaments,
	                sport = _state.sport;
	
	
	            if (!tournaments || !tournaments.length) return null;
	
	            var sportId = _.findKey(sportIdToName, function (name) {
	                return name === sport;
	            });
	
	            var tournamentsBySportType = tournamentsToShow[sportId];
	
	            return tournamentsBySportType.map(function (id) {
	                return tournaments.filter(function (tournament) {
	                    return tournament.id === id;
	                })[0];
	            });
	        }
	    }, {
	        key: 'renderTournaments',
	        value: function renderTournaments() {
	            var _this4 = this;
	
	            var _state2 = this.state,
	                tournaments = _state2.tournaments,
	                sport = _state2.sport;
	
	
	            if (!tournaments || !tournaments.length || !this.getTournaments()[0]) return null;
	
	            var btnsPositioning = {
	                right: 0,
	                marginRight: 16,
	                position: 'absolute',
	                transform: 'translateY(-50%)',
	                top: '50%'
	            };
	            var styleLink = {
	                display: 'flex',
	                textDecoration: 'none',
	                color: 'inherit',
	                padding: 16,
	                cursor: 'pointer',
	                fontSize: '.875rem'
	            };
	            var snackbarStyle = {
	                textAlign: 'center'
	            };
	
	            var tournamentsList = this.getTournaments().map(function (tournament) {
	                var tournamentUrl = '/ids-finder/' + sport + '/tournaments/' + tournament.id;
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: tournament.id },
	                    _react2.default.createElement(
	                        _materialUi.ListItem,
	                        { className: 'list-item' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: tournamentUrl, style: styleLink },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                tournament.name
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'id' },
	                                tournament.id
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactCopyToClipboard2.default,
	                            { text: tournament.id },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: btnsPositioning },
	                                    _react2.default.createElement(_materialUi.FlatButton, {
	                                        label: 'Copy',
	                                        primary: true,
	                                        icon: _react2.default.createElement(_contentCopy2.default, null),
	                                        onClick: _this4.handleTouchTap
	                                    }),
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: tournamentUrl },
	                                        _react2.default.createElement(_materialUi.FlatButton, {
	                                            primary: true,
	                                            icon: _react2.default.createElement(_forward2.default, null)
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(_materialUi.Snackbar, {
	                                    open: _this4.state.open,
	                                    message: 'ID copied to clipboard',
	                                    autoHideDuration: 3000,
	                                    onRequestClose: _this4.handleRequestClose,
	                                    contentStyle: snackbarStyle
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_materialUi.Divider, null)
	                );
	            });
	
	            var sportKeys = Object.keys(sportIdToName);
	
	            var sportsMenuItems = sportKeys.map(function (key) {
	                var url = '/ids-finder/' + sportIdToName[key] + '/tournaments';
	
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: url, key: key },
	                    _react2.default.createElement(_materialUi.FlatButton, { label: sportIdToName[key], primary: true })
	                );
	            });
	
	            return _react2.default.createElement(
	                TournamentsList,
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    { style: { textTransform: 'capitalize' } },
	                    sport,
	                    ' Tournaments'
	                ),
	                _react2.default.createElement(
	                    _materialUi.List,
	                    null,
	                    _react2.default.createElement(_materialUi.Divider, null),
	                    tournamentsList
	                ),
	                _react2.default.createElement(
	                    SportMenu,
	                    null,
	                    sportsMenuItems
	                )
	            );
	        }
	    }]);
	
	    return IDSTournaments;
	}(_react.Component);
	
	exports.default = IDSTournaments;

/***/ },
/* 2129 */,
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 0 auto 10px;\n    max-width: 1170px;\n'], ['\n    margin: 0 auto 10px;\n    max-width: 1170px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    border-left: 1px solid #e0e0e0;\n    border-right: 1px solid #e0e0e0;\n\n    > div > span > div > div {\n        padding: 0 !important;\n    }\n\n    a {\n        padding: 16px;\n        span {\n            flex: 0 1 50%;\n\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n            }\n        }\n    }\n'], ['\n    border-left: 1px solid #e0e0e0;\n    border-right: 1px solid #e0e0e0;\n\n    > div > span > div > div {\n        padding: 0 !important;\n    }\n\n    a {\n        padding: 16px;\n        span {\n            flex: 0 1 50%;\n\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n            }\n        }\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(188);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _materialUi = __webpack_require__(642);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _forward = __webpack_require__(2129);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	var TeamItem = _styledComponents2.default.div(_templateObject2);
	
	var IDSTournament = function (_Component) {
	    _inherits(IDSTournament, _Component);
	
	    function IDSTournament() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, IDSTournament);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IDSTournament.__proto__ || Object.getPrototypeOf(IDSTournament)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            tournament: {},
	            limit: 10,
	            open: false
	        }, _this.handleTouchTap = function () {
	            _this.setState({
	                open: true
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({
	                open: false
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IDSTournament, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _bluebird2.default.props({
	                finishedEvents: fetch(_cfg2.default.apis.ss2 + '/events-v2?ttId=' + this.props.params.tournamentId + '&status=finished&limit=' + this.state.limit + '&sortDirection=desc').then(function (response) {
	                    return response.json();
	                }),
	                notstartedEvents: fetch(_cfg2.default.apis.ss2 + '/events-v2?ttId=' + this.props.params.tournamentId + '&status=notstarted&limit=' + this.state.limit + '&sortDirection=asc').then(function (response) {
	                    return response.json();
	                }),
	                teams: fetch(_cfg2.default.apis.ss2 + '/tournaments/' + this.props.params.tournamentId + '/teams').then(function (response) {
	                    return response.json();
	                })
	            }).then(function (res) {
	                _this2.setState({
	                    finishedEvents: res.finishedEvents.events,
	                    notstartedEvents: res.notstartedEvents.events,
	                    teams: res.teams
	                });
	            });
	        }
	    }, {
	        key: 'renderLastEvents',
	        value: function renderLastEvents() {
	            var finishedEvents = this.state.finishedEvents;
	
	            var sortedEvents = _lodash2.default.sortBy(finishedEvents, 'startDate');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Last matches'
	                ),
	                this.getEvents(sortedEvents)
	            );
	        }
	    }, {
	        key: 'renderComingEvents',
	        value: function renderComingEvents() {
	            var notstartedEvents = this.state.notstartedEvents;
	
	            var sortedEvents = _lodash2.default.sortBy(notstartedEvents, 'startDate');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Coming matches'
	                ),
	                this.getEvents(sortedEvents)
	            );
	        }
	    }, {
	        key: 'renderTeams',
	        value: function renderTeams() {
	            var _this3 = this;
	
	            var teams = this.state.teams;
	
	
	            if (!teams) return null;
	
	            var sportType = this.props.params.sport; //soccer
	
	            var btnsPositioning = {
	                right: 0,
	                marginRight: 16,
	                position: 'absolute',
	                transform: 'translateY(-50%)',
	                top: '50%'
	            };
	
	            var snackbarStyle = {
	                textAlign: 'center'
	            };
	
	            var styleLink = {
	                display: 'flex',
	                textDecoration: 'none',
	                color: 'inherit',
	                cursor: 'pointer',
	                fontSize: '.875rem'
	            };
	
	            var teamsNames = teams.map(function (item) {
	                var teamUrl = '/ids-finder/' + sportType + '/teams/' + item.id;
	
	                return _react2.default.createElement(
	                    TeamItem,
	                    { key: item.id },
	                    _react2.default.createElement(
	                        _materialUi.ListItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: teamUrl, style: styleLink },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                item.name
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'id' },
	                                item.id
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactCopyToClipboard2.default,
	                            { text: item.id },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: btnsPositioning },
	                                    _react2.default.createElement(_materialUi.FlatButton, {
	                                        label: 'Copy',
	                                        primary: true,
	                                        icon: _react2.default.createElement(_contentCopy2.default, null),
	                                        onClick: _this3.handleTouchTap
	                                    }),
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: teamUrl },
	                                        _react2.default.createElement(_materialUi.FlatButton, { primary: true, icon: _react2.default.createElement(_forward2.default, null) })
	                                    )
	                                ),
	                                _react2.default.createElement(_materialUi.Snackbar, {
	                                    open: _this3.state.open,
	                                    message: 'ID copied to clipboard',
	                                    autoHideDuration: 3000,
	                                    onRequestClose: _this3.handleRequestClose,
	                                    contentStyle: snackbarStyle
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_materialUi.Divider, null)
	                );
	            });
	
	            return _react2.default.createElement(
	                _materialUi.List,
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Teams'
	                ),
	                _react2.default.createElement(_materialUi.Divider, null),
	                teamsNames
	            );
	        }
	    }, {
	        key: 'getEvents',
	        value: function getEvents(event) {
	            var _this4 = this;
	
	            if (!event) return null;
	
	            var btnsPositioning = {
	                right: 0,
	                marginRight: 16,
	                position: 'absolute',
	                transform: 'translateY(-50%)',
	                top: '50%'
	            };
	            var snackbarStyle = {
	                textAlign: 'center'
	            };
	            var listStyle = {
	                display: 'flex',
	                justifyContent: 'space-between',
	                color: 'inherit',
	                fontSize: '.875rem',
	                borderLeft: '1px solid #E0E0E0',
	                borderRight: '1px solid #E0E0E0'
	            };
	            var spanStyle = {
	                flex: '0 1 calc(100% / 3)'
	            };
	
	            var eventsList = event.map(function (ev) {
	                var date = (0, _moment2.default)(ev.startDate).format('DD. MMM. YYYY - HH:mm');
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: ev.eventId },
	                    _react2.default.createElement(
	                        _materialUi.ListItem,
	                        { disabled: true, style: listStyle },
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            date
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.homeName,
	                            ' \u2013 ',
	                            ev.awayName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.statusType === 'finished' ? ev.score.home + ' - ' + ev.score.away : null
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.eventId
	                        ),
	                        _react2.default.createElement(
	                            _reactCopyToClipboard2.default,
	                            { text: ev.eventId },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: btnsPositioning },
	                                    _react2.default.createElement(_materialUi.FlatButton, {
	                                        label: 'Copy',
	                                        primary: true,
	                                        icon: _react2.default.createElement(_contentCopy2.default, null),
	                                        onClick: _this4.handleTouchTap
	                                    })
	                                ),
	                                _react2.default.createElement(_materialUi.Snackbar, {
	                                    open: _this4.state.open,
	                                    message: 'ID copied to clipboard',
	                                    autoHideDuration: 3000,
	                                    onRequestClose: _this4.handleRequestClose,
	                                    contentStyle: snackbarStyle
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_materialUi.Divider, null)
	                );
	            });
	
	            return _react2.default.createElement(
	                _materialUi.List,
	                null,
	                _react2.default.createElement(_materialUi.Divider, null),
	                eventsList
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var finishedEvents = this.state.finishedEvents;
	
	
	            if (!finishedEvents) return null;
	
	            var tournamentName = finishedEvents[0].tournamentName;
	            var country = finishedEvents[0].country;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    { style: { textAlign: 'center' } },
	                    country,
	                    ' ',
	                    tournamentName
	                ),
	                _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    this.renderTeams(),
	                    this.renderLastEvents(),
	                    this.renderComingEvents()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return IDSTournament;
	}(_react.Component);
	
	exports.default = IDSTournament;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 0 auto 10px;\n    max-width: 1170px;\n    \n    .id {\n        min-width: 120px;\n        text-align: center;\n    }\n    \n    .list-item {\n        border-left: 1px solid #E0E0E0;\n        border-right: 1px solid #E0E0E0;  \n        > div > div {\n          display: flex !important;\n          span {\n            flex: 0 1 50%;\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n              }\n          }\n        }\n        span {\n          font-size: .875rem;   \n          i {\n            font-style: normal;\n            display: inline-block;\n            min-width: 20px;\n          }\n        }\n    }\n'], ['\n    margin: 0 auto 10px;\n    max-width: 1170px;\n    \n    .id {\n        min-width: 120px;\n        text-align: center;\n    }\n    \n    .list-item {\n        border-left: 1px solid #E0E0E0;\n        border-right: 1px solid #E0E0E0;  \n        > div > div {\n          display: flex !important;\n          span {\n            flex: 0 1 50%;\n            &.id {\n                flex: 0 1 30%;\n                text-align: right;\n              }\n          }\n        }\n        span {\n          font-size: .875rem;   \n          i {\n            font-style: normal;\n            display: inline-block;\n            min-width: 20px;\n          }\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin-bottom: 20px;\n    font-size: .875rem;   \n'], ['\n    margin-bottom: 20px;\n    font-size: .875rem;   \n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactCopyToClipboard = __webpack_require__(1089);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	var _materialUi = __webpack_require__(642);
	
	var _contentCopy = __webpack_require__(1184);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TeamPlayers = _styledComponents2.default.div(_templateObject);
	var Coach = _styledComponents2.default.div(_templateObject2);
	
	var playersPositions = ['keeper', 'defender', 'midfielder', 'forward'];
	
	var IDSTeam = function (_Component) {
	    _inherits(IDSTeam, _Component);
	
	    function IDSTeam() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, IDSTeam);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IDSTeam.__proto__ || Object.getPrototypeOf(IDSTeam)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            team: null,
	            open: false
	        }, _this.handleTouchTap = function () {
	            _this.setState({
	                open: true
	            });
	        }, _this.handleRequestClose = function () {
	            _this.setState({
	                open: false
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IDSTeam, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var teamId = this.props.params.teamId;
	
	            _bluebird2.default.props({
	                team: fetch(_cfg2.default.apis.ss2 + '/teams/' + teamId + '/profile').then(function (response) {
	                    return response.json();
	                })
	
	            }).then(function (res) {
	                _this2.setState({
	                    team: res.team
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var team = this.state.team;
	
	
	            if (!team) return null;
	
	            return _react2.default.createElement(
	                TeamPlayers,
	                null,
	                this.renderPlayers(),
	                this.renderUpcomingEvents(),
	                this.renderFinishedEvents()
	            );
	        }
	    }, {
	        key: 'getCoach',
	        value: function getCoach() {
	            var team = this.state.team;
	
	
	            if (!team.members || !team.members.coach) return null;
	
	            var coachName = team.members.coach[0].name;
	
	            return _react2.default.createElement(
	                Coach,
	                null,
	                'Coach: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    coachName
	                )
	            );
	        }
	    }, {
	        key: 'renderPlayers',
	        value: function renderPlayers() {
	            var _this3 = this;
	
	            var team = this.state.team;
	
	
	            if (!team || !team.members) return _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                'no team information available'
	            );
	
	            var btnsPositioning = {
	                right: 0,
	                marginRight: 16,
	                position: 'absolute',
	                transform: 'translateY(-50%)',
	                top: '50%'
	            };
	
	            var snackbarStyle = {
	                textAlign: 'center'
	            };
	
	            var sortedPlayers = playersPositions.map(function (position) {
	                return team.members.players.filter(function (plr) {
	                    return plr.position === position;
	                });
	            });
	
	            var players = sortedPlayers.map(function (player) {
	                return player.map(function (plr) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'list-item', key: plr.id },
	                        _react2.default.createElement(
	                            _materialUi.ListItem,
	                            { disabled: true },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    plr.number || '-'
	                                ),
	                                ' ',
	                                plr.name
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'id' },
	                                plr.id
	                            ),
	                            _react2.default.createElement(
	                                _reactCopyToClipboard2.default,
	                                { text: plr.id },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(_materialUi.FlatButton, {
	                                        label: 'Copy',
	                                        primary: true,
	                                        icon: _react2.default.createElement(_contentCopy2.default, null),
	                                        onClick: _this3.handleTouchTap,
	                                        style: btnsPositioning
	                                    }),
	                                    _react2.default.createElement(_materialUi.Snackbar, {
	                                        open: _this3.state.open,
	                                        message: 'ID copied to clipboard',
	                                        autoHideDuration: 3000,
	                                        onRequestClose: _this3.handleRequestClose,
	                                        contentStyle: snackbarStyle
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_materialUi.Divider, null)
	                    );
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    team.name
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Players'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.getCoach()
	                ),
	                _react2.default.createElement(
	                    _materialUi.List,
	                    null,
	                    _react2.default.createElement(_materialUi.Divider, null),
	                    players
	                )
	            );
	        }
	    }, {
	        key: 'renderUpcomingEvents',
	        value: function renderUpcomingEvents() {
	            var team = this.state.team;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Upcoming events'
	                ),
	                this.getEvents(team.upcomingEvents)
	            );
	        }
	    }, {
	        key: 'renderFinishedEvents',
	        value: function renderFinishedEvents() {
	            var team = this.state.team;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Finished events'
	                ),
	                this.getEvents(team.finishedEvents)
	            );
	        }
	    }, {
	        key: 'getEvents',
	        value: function getEvents(event) {
	            var _this4 = this;
	
	            var team = this.state.team;
	
	
	            if (!team || !event) return null;
	
	            var btnsPositioning = {
	                right: 0,
	                marginRight: 16,
	                position: 'absolute',
	                transform: 'translateY(-50%)',
	                top: '50%'
	            };
	            var snackbarStyle = {
	                textAlign: 'center'
	            };
	            var spanStyle = {
	                flex: '0 1 calc(100% / 3)'
	            };
	
	            var eventsList = event.map(function (ev, i) {
	                var date = (0, _moment2.default)(ev.startDate).format('DD. MMM. YYYY - HH:mm');
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: i, className: 'list-item' },
	                    _react2.default.createElement(
	                        _materialUi.ListItem,
	                        { disabled: true },
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            date
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.homeName,
	                            ' \u2013 ',
	                            ev.awayName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.statusType === "finished" ? ev.score.home + ' - ' + ev.score.away : null
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { style: spanStyle },
	                            ev.eventId
	                        ),
	                        _react2.default.createElement(
	                            _reactCopyToClipboard2.default,
	                            { text: ev.eventId },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_materialUi.FlatButton, {
	                                    label: 'Copy',
	                                    primary: true,
	                                    icon: _react2.default.createElement(_contentCopy2.default, null),
	                                    onClick: _this4.handleTouchTap,
	                                    style: btnsPositioning
	                                }),
	                                _react2.default.createElement(_materialUi.Snackbar, {
	                                    open: _this4.state.open,
	                                    message: 'ID copied to clipboard',
	                                    autoHideDuration: 3000,
	                                    onRequestClose: _this4.handleRequestClose,
	                                    contentStyle: snackbarStyle
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_materialUi.Divider, null)
	                );
	            });
	
	            return _react2.default.createElement(
	                _materialUi.List,
	                null,
	                _react2.default.createElement(_materialUi.Divider, null),
	                eventsList
	            );
	        }
	    }]);
	
	    return IDSTeam;
	}(_react.Component);
	
	exports.default = IDSTeam;

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    padding-bottom: 30px;\n\n    h2 {\n        text-transfotm: capitalize;\n    }\n'], ['\n    padding-bottom: 30px;\n\n    h2 {\n        text-transfotm: capitalize;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n    display: flex;\n    height: calc(100% - 284px);\n    > * {\n        margin: auto;\n    }\n'], ['\n    text-align: center;\n    display: flex;\n    height: calc(100% - 284px);\n    > * {\n        margin: auto;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    width: 100%;\n    text-align: left;\n    border-collapse: collapse;\n    border-spacing: 0;\n\n    thead {\n        font-weight: bold;\n    }\n\n    tbody {\n        font-weight: 400;\n    }\n\n    th,\n    td {\n        border: 1px solid #ccc;\n    }\n\n    th {\n        padding: 14px 20px;\n    }\n\n    td {\n        padding: 10px 20px;\n        font-size: 14px;\n\n        &.tif_btns {\n            > div {\n                display: flex;\n                justify-content: space-between;\n\n                span {\n                    display: inline-block;\n                    position: relative;\n\n                    &:nth-child(1):after {\n                        content: \'\';\n                        display: inline-block;\n                        width: 1px;\n                        height: 25px;\n                        background-color: #ccc;\n                        position: absolute;\n                        top: 50%;\n                        right: 0;\n                        transform: translate(10px, -50%);\n                    }\n                }\n            }\n        }\n    }\n'], ['\n    width: 100%;\n    text-align: left;\n    border-collapse: collapse;\n    border-spacing: 0;\n\n    thead {\n        font-weight: bold;\n    }\n\n    tbody {\n        font-weight: 400;\n    }\n\n    th,\n    td {\n        border: 1px solid #ccc;\n    }\n\n    th {\n        padding: 14px 20px;\n    }\n\n    td {\n        padding: 10px 20px;\n        font-size: 14px;\n\n        &.tif_btns {\n            > div {\n                display: flex;\n                justify-content: space-between;\n\n                span {\n                    display: inline-block;\n                    position: relative;\n\n                    &:nth-child(1):after {\n                        content: \'\';\n                        display: inline-block;\n                        width: 1px;\n                        height: 25px;\n                        background-color: #ccc;\n                        position: absolute;\n                        top: 50%;\n                        right: 0;\n                        transform: translate(10px, -50%);\n                    }\n                }\n            }\n        }\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    margin-bottom: 30px;\n    display: flex;\n    align-items: center;\n'], ['\n    margin-bottom: 30px;\n    display: flex;\n    align-items: center;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    padding: 30px 0;\n    display: flex;\n    max-width: 60px;\n    justify-content: space-between;\n    align-items: center;\n'], ['\n    padding: 30px 0;\n    display: flex;\n    max-width: 60px;\n    justify-content: space-between;\n    align-items: center;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(1070);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _materialUi = __webpack_require__(642);
	
	var _keyboardArrowLeft = __webpack_require__(1593);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(1594);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _edit = __webpack_require__(1597);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	//import PropTypes from 'prop-types';
	
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var Loader = _styledComponents2.default.div(_templateObject2);
	
	var Table = _styledComponents2.default.table(_templateObject3);
	
	var Field = _styledComponents2.default.div(_templateObject4);
	
	var Navs = _styledComponents2.default.div(_templateObject5);
	
	var ProviderIds = function (_Component) {
	    _inherits(ProviderIds, _Component);
	
	    function ProviderIds() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ProviderIds);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProviderIds.__proto__ || Object.getPrototypeOf(ProviderIds)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            limit: 20,
	            skip: 0,
	            searchValue: null,
	            preparedDataObject: {
	                source: _this.props.params.source
	            },
	            snackBarText: '',
	            edit: false,
	            dataLoading: true
	        }, _this.handleInputChange = function (ev) {
	            _this.setState({
	                searchValue: ev.target.value
	            }, function () {
	                _this.loadData();
	            });
	        }, _this.handlePrevClick = function () {
	            var _this$state = _this.state,
	                skip = _this$state.skip,
	                limit = _this$state.limit;
	
	
	            _this.setState({
	                skip: skip <= 0 ? 0 : skip - limit
	            }, function () {
	                _this.loadData();
	            });
	        }, _this.handleNextClick = function () {
	            var _this$state2 = _this.state,
	                skip = _this$state2.skip,
	                dataLength = _this$state2.dataLength,
	                limit = _this$state2.limit;
	
	
	            _this.setState({
	                skip: skip < dataLength - limit ? skip + limit : skip
	            }, function () {
	                _this.loadData();
	            });
	        }, _this.handleEventBtnClick = function () {
	            var _this$state3 = _this.state,
	                preparedDataObject = _this$state3.preparedDataObject,
	                edit = _this$state3.edit;
	
	            var defaultDataObject = {
	                extParticipantId: '',
	                extParticipantName: '',
	                enetParticipantId: '',
	                enetParticipantName: '',
	                extra: ''
	            };
	
	            //config.apis.ss2 = 'http://127.0.0.1:3010';
	
	            //PUT
	            if (edit) {
	                return fetch(_cfg2.default.apis.ss2 + '/admin/mapping', {
	                    method: 'PUT',
	                    headers: { 'Content-Type': 'application/json' },
	                    body: JSON.stringify(preparedDataObject)
	                }).then(function (res) {
	                    var status = res.status;
	
	                    if (status === 200) {
	                        return res.json();
	                    } else {
	                        throw new Error('Error load status ' + status);
	                    }
	                }).then(function () {
	                    _this.setState({
	                        edit: false,
	                        preparedDataObject: _extends({}, _this.state.preparedDataObject, defaultDataObject)
	                    });
	
	                    _this.loadData();
	                    _this.showSnackBar('Data was replaced');
	                }).catch(function (e) {
	                    _this.showSnackBar('Error while updating');
	                });
	            }
	
	            //POST
	            return fetch(_cfg2.default.apis.ss2 + '/admin/mapping', {
	                method: 'POST',
	                headers: { 'Content-Type': 'application/json' },
	                body: JSON.stringify(preparedDataObject)
	            }).then(function (res) {
	                var status = res.status;
	
	                if (status !== 200) throw new Error('Error load status ' + status);
	
	                // if (status === 200) {
	                //     return res.json();
	                // } else {
	                //     throw new Error(`Error load status ${status}`);
	                // }
	            }).then(function () {
	                _this.setState({
	                    edit: false,
	                    preparedDataObject: _extends({}, _this.state.preparedDataObject, defaultDataObject)
	                });
	
	                _this.loadData();
	                _this.showSnackBar('Data was added');
	            }).catch(function (e) {
	                _this.showSnackBar('Error while updating');
	            });
	        }, _this.handleDelBtnClick = function (id) {
	            return function () {
	                return fetch(_cfg2.default.apis.ss2 + '/admin/mapping/' + id, {
	                    method: 'DELETE'
	                }).then(function (res) {
	                    var status = res.status;
	
	                    if (status === 200) {
	                        _this.loadData();
	                        _this.showSnackBar('Data was deleted');
	                    } else {
	                        throw new Error('Error load status: ' + status);
	                    }
	                }).catch(function (e) {
	                    _this.showSnackBar('Error while updating');
	                });
	            };
	        }, _this.handlePostInputChange = function (key) {
	            return function (ev) {
	                var isId = key === 'enetParticipantId' || key === 'extParticipantId';
	
	                _this.setState({
	                    preparedDataObject: _extends({}, _this.state.preparedDataObject, _defineProperty({}, key, isId && ev.target.value.length ? +ev.target.value : ev.target.value))
	                });
	            };
	        }, _this.handleEditClick = function (obj) {
	            return function () {
	                _this.setState({
	                    preparedDataObject: obj,
	                    edit: true
	                });
	            };
	        }, _this.showSnackBar = function (text) {
	            _this.setState({ snackBarText: text });
	
	            setTimeout(function () {
	                _this.setState({ snackBarText: '' });
	            }, 3 * 1000);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ProviderIds, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadData();
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData() {
	            var _this2 = this;
	
	            var source = this.props.params.source;
	            var _state = this.state,
	                limit = _state.limit,
	                skip = _state.skip,
	                searchValue = _state.searchValue;
	
	
	            var query = searchValue ? '&search=' + searchValue : '';
	
	            //config.apis.ss2 = 'http://127.0.0.1:3010';
	
	            _bluebird2.default.props({
	                records: fetch(_cfg2.default.apis.ss2 + '/admin/mapping?source=' + source + '&limit=' + limit + '&skip=' + skip + '&arr=' + Math.random() + query).then(function (res) {
	                    return res.json();
	                })
	            }).then(function (res) {
	                _this2.setState({
	                    records: res.records.data,
	                    dataLength: res.records.dataLength,
	                    dataLoading: false
	                });
	            });
	        }
	    }, {
	        key: 'renderSearchField',
	        value: function renderSearchField() {
	            return _react2.default.createElement(
	                Field,
	                null,
	                _react2.default.createElement(_TextField2.default, { floatingLabelText: 'Search:', onChange: this.handleInputChange })
	            );
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            var records = this.state.records;
	
	            var head = ['_id', 'Ext Id', 'Ext Name', 'Enet Id', 'Enet Name', 'Source', ''];
	
	            return _react2.default.createElement(
	                Table,
	                null,
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        head.map(function (name) {
	                            return _react2.default.createElement(
	                                'th',
	                                { key: name },
	                                name
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    records.map(function (team) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: '' + team._id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team._id
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team.extParticipantId || '-'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team.extParticipantName || '-'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team.enetParticipantId || '-'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team.enetParticipantName || '-'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                team.source
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'tif_btns' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _react2.default.createElement(
	                                            _materialUi.IconButton,
	                                            {
	                                                onClick: _this3.handleDelBtnClick(team._id),
	                                                tooltip: 'Delete',
	                                                tooltipPosition: 'top-right'
	                                            },
	                                            _react2.default.createElement(_delete2.default, null)
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _react2.default.createElement(
	                                            _materialUi.IconButton,
	                                            {
	                                                onClick: _this3.handleEditClick(team),
	                                                tooltip: 'Edit',
	                                                tooltipPosition: 'top-right'
	                                            },
	                                            _react2.default.createElement(_edit2.default, null)
	                                        )
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderFields',
	        value: function renderFields() {
	            var _this4 = this;
	
	            var _state2 = this.state,
	                preparedDataObject = _state2.preparedDataObject,
	                edit = _state2.edit;
	            var source = this.props.params.source;
	
	            var inputs = [{
	                name: 'ext id',
	                value: 'extParticipantId'
	            }, {
	                name: 'ext name',
	                value: 'extParticipantName'
	            }, {
	                name: 'enet id',
	                value: 'enetParticipantId'
	            }, {
	                name: 'enet name',
	                value: 'enetParticipantName'
	            }, {
	                name: 'extra',
	                value: 'extra'
	            }, {
	                name: 'source',
	                value: 'source',
	                source: source
	            }];
	
	            return _react2.default.createElement(
	                Field,
	                null,
	                inputs.map(function (field) {
	                    return _react2.default.createElement(_TextField2.default, {
	                        key: field.value,
	                        value: field.source ? field.source : preparedDataObject[field.value]
	                        //value={preparedDataObject[field.value]}
	                        , floatingLabelText: field.name,
	                        onChange: _this4.handlePostInputChange(field.value),
	                        style: { marginRight: '10px' }
	                    });
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column' } },
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                        onClick: this.handleEventBtnClick,
	                        label: !edit ? 'Add' : 'Replace',
	                        style: { margin: '2px 0' }
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderPagination',
	        value: function renderPagination() {
	            var _state3 = this.state,
	                skip = _state3.skip,
	                limit = _state3.limit,
	                dataLength = _state3.dataLength;
	
	            var isPrev = skip !== 0;
	            var isNext = skip < dataLength - limit;
	
	            return _react2.default.createElement(
	                Navs,
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: !isPrev, onClick: this.handlePrevClick },
	                    _react2.default.createElement(_keyboardArrowLeft2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: !isNext, onClick: this.handleNextClick },
	                    _react2.default.createElement(_keyboardArrowRight2.default, null)
	                ),
	                skip + 1,
	                '-',
	                Math.min(skip + limit, dataLength)
	            );
	        }
	
	        //DELETE
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var source = this.props.params.source;
	            var _state4 = this.state,
	                records = _state4.records,
	                dataLoading = _state4.dataLoading,
	                snackBarText = _state4.snackBarText;
	
	
	            if (!records) return _react2.default.createElement('div', null);
	
	            if (dataLoading) return _react2.default.createElement(
	                Loader,
	                null,
	                _react2.default.createElement(_CircularProgress2.default, null)
	            );
	
	            return _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Source: ',
	                    source
	                ),
	                this.renderSearchField(),
	                this.renderTable(),
	                this.renderPagination(),
	                this.renderFields(),
	                _react2.default.createElement(_materialUi.Snackbar, { open: Boolean(snackBarText), message: snackBarText, style: { textAlign: 'center' } })
	            );
	        }
	    }]);
	
	    return ProviderIds;
	}(_react.Component);
	
	ProviderIds.propTypes = {
	    //source: PropTypes.object.isRequired
	};
	
	exports.default = ProviderIds;

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reactRouter = __webpack_require__(188);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _validation = __webpack_require__(1660);
	
	var _accounts = __webpack_require__(2134);
	
	var _PermissionsForm = __webpack_require__(2135);
	
	var _PermissionsForm2 = _interopRequireDefault(_PermissionsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var clients = Object.keys(__webpack_require__(1125));
	
	var USER_TYPES = ['club', 'league', 'media'];
	
	var CreateAccount = function (_React$PureComponent) {
	    _inherits(CreateAccount, _React$PureComponent);
	
	    function CreateAccount() {
	        _classCallCheck(this, CreateAccount);
	
	        return _possibleConstructorReturn(this, (CreateAccount.__proto__ || Object.getPrototypeOf(CreateAccount)).apply(this, arguments));
	    }
	
	    _createClass(CreateAccount, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var submitSucceeded = _ref.submitSucceeded;
	
	            if (this.props.submitting && submitSucceeded) {
	                _reactRouter.browserHistory.push('/admin/accounts');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submit = _props.submit,
	                submitting = _props.submitting;
	
	            return _react2.default.createElement(
	                _materialUi.Card,
	                null,
	                _react2.default.createElement(_materialUi.CardHeader, { title: 'Creating user' }),
	                _react2.default.createElement(
	                    _materialUi.CardText,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: 'email',
	                            type: 'email',
	                            validate: _validation.presence,
	                            floatingLabelText: 'Email',
	                            component: _reduxFormMaterialUi.TextField
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reduxForm.Field, { name: 'username', validate: _validation.presence, floatingLabelText: 'Username', component: _reduxFormMaterialUi.TextField })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reduxForm.Field,
	                            { name: 'client', validate: _validation.presence, floatingLabelText: 'Client', component: _reduxFormMaterialUi.SelectField },
	                            clients.map(function (client) {
	                                return _react2.default.createElement(_materialUi.MenuItem, { value: client, key: client, primaryText: client });
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reduxForm.Field,
	                            { name: 'type', validate: _validation.presence, floatingLabelText: 'User type', component: _reduxFormMaterialUi.SelectField },
	                            USER_TYPES.map(function (type) {
	                                return _react2.default.createElement(_materialUi.MenuItem, { value: type, key: type, primaryText: type });
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: 'password',
	                            validate: (0, _validation.minLength)(6),
	                            floatingLabelText: 'Password',
	                            component: _reduxFormMaterialUi.TextField
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Features'
	                        ),
	                        _react2.default.createElement(_PermissionsForm2.default, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.CardActions,
	                    null,
	                    _react2.default.createElement(_materialUi.RaisedButton, {
	                        onTouchTap: submit,
	                        disabled: submitting,
	                        icon: submitting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 20 }) : undefined,
	                        primary: true,
	                        label: 'Create'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CreateAccount;
	}(_react2.default.PureComponent);
	
	var onSubmit = function onSubmit(value, dispatch) {
	    return dispatch((0, _accounts.createAccount)(value)).then(function (_ref2) {
	        var body = _ref2.body,
	            status = _ref2.status;
	
	        if (status === 400) {
	            throw new _reduxForm.SubmissionError(body);
	        }
	    });
	};
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'createAccount', onSubmit: onSubmit })(CreateAccount);

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateAccountPacks = exports.fetchAccountPacks = exports.updateAccount = exports.fetchUserByNameConfig = exports.fetchUsers = exports.fetchAccountConfig = exports.createAccount = undefined;
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _lodash = __webpack_require__(908);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(593);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultPermissions = {
	    htmlWidgets: false,
	    smWidgets: false,
	    campaigns: false
	};
	
	var mapDataToServer = function mapDataToServer(account) {
	    account.permissions = (0, _lodash2.default)({}, defaultPermissions, account.permissions);
	    return account;
	};
	
	var createAccount = exports.createAccount = function createAccount(account) {
	    return (0, _reduxQuery.requestAsync)({
	        url: '/api/users?access_token=' + _auth2.default.getAccessToken(),
	        body: mapDataToServer(account),
	        force: true,
	        queryKey: 'POST:accounts',
	        transform: function transform(res) {
	            return {
	                accounts: _defineProperty({}, res.username, res)
	            };
	        },
	        update: {
	            accounts: _actions.UPDATE_DEFAULT.MERGE
	        },
	        options: {
	            method: _actions.httpMethods.POST
	        }
	    });
	};
	
	var fetchAccountConfig = exports.fetchAccountConfig = function fetchAccountConfig() {
	    return {
	        url: '/api/users/all?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        queryKey: 'GET:accounts',
	        transform: function transform(res) {
	            return {
	                accounts: res.reduce(function (acc, cur) {
	                    acc[cur.username] = cur;
	                    return acc;
	                }, {})
	            };
	        },
	        update: {
	            accounts: _actions.UPDATE_DEFAULT.MERGE
	        }
	    };
	};
	
	var fetchUsers = exports.fetchUsers = function fetchUsers() {
	    return (0, _reduxQuery.requestAsync)({
	        url: '/api/users/all?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        queryKey: 'GET:accounts',
	        transform: function transform(res) {
	            return {
	                users: (0, _helpers.toIdMap)(res)
	            };
	        },
	        update: {
	            users: _actions.UPDATE_DEFAULT.MERGE
	        }
	    });
	};
	
	var fetchUserByNameConfig = exports.fetchUserByNameConfig = function fetchUserByNameConfig(username) {
	    return {
	        url: '/api/users/' + username + '?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        queryKey: 'GET:accounts/' + username,
	        transform: function transform(res) {
	            return {
	                accounts: _defineProperty({}, res.username, res)
	            };
	        },
	        update: {
	            accounts: _actions.UPDATE_DEFAULT.MERGE
	        }
	    };
	};
	
	var updateAccount = exports.updateAccount = function updateAccount(userId, value) {
	    return (0, _reduxQuery.requestAsync)({
	        url: '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        body: value,
	        queryKey: 'PUT:accounts/' + userId,
	        transform: function transform(res) {
	            return {
	                accounts: _defineProperty({}, res.username, res)
	            };
	        },
	        update: {
	            accounts: _actions.UPDATE_DEFAULT.MERGE
	        },
	        options: {
	            method: _actions.httpMethods.PUT
	        }
	    });
	};
	
	var fetchAccountPacks = exports.fetchAccountPacks = function fetchAccountPacks() {
	    return {
	        url: _cfg2.default.dash.api.host + '/api/admin/packs?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        queryKey: 'GET:accountPacks',
	        transform: function transform(body) {
	            return {
	                accountPacks: body.reduce(function (acc, el) {
	                    acc[el._id] = el;
	                    return acc;
	                }, {})
	            };
	        },
	        update: {
	            accountPacks: _actions.UPDATE_DEFAULT.MERGE
	        },
	        options: {
	            method: _actions.httpMethods.GET
	        }
	    };
	};
	
	var updateAccountPacks = exports.updateAccountPacks = function updateAccountPacks(userId, value) {
	    return (0, _reduxQuery.requestAsync)({
	        url: '/api/users/' + userId + '?access_token=' + _auth2.default.getAccessToken(),
	        force: true,
	        body: value,
	        queryKey: 'PUT:accounts/' + userId,
	        transform: function transform(res) {
	            return {
	                accounts: _defineProperty({}, res.username, res)
	            };
	        },
	        update: {
	            accounts: _actions.UPDATE_DEFAULT.MERGE
	        },
	        options: {
	            method: _actions.httpMethods.PUT
	        }
	    });
	};

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PERMISSIONS = [{
	    key: 'htmlWidgets',
	    label: 'HTML Widgets'
	}, {
	    key: 'smWidgets',
	    label: 'Social media widgets'
	}, {
	    key: 'campaigns',
	    label: 'Campaigns/automations'
	}, {
	    key: 'messageServices',
	    label: 'Message services'
	}, {
	    key: 'tvSchedule',
	    label: 'TV Schedule'
	}, {
	    key: 'gridMakerTool',
	    label: 'Grid Maker Tool'
	}];
	
	var listRender = PERMISSIONS.map(function (permission) {
	    return _react2.default.createElement(_reduxForm.Field, {
	        key: permission.key,
	        name: permission.key,
	        label: permission.label,
	        normalize: function normalize(v) {
	            return Boolean(v);
	        },
	        component: _reduxFormMaterialUi.Checkbox
	    });
	});
	
	function PermissionsForm(_ref) {
	    var ListWrapper = _ref.ListWrapper;
	
	    return _react2.default.createElement(
	        _reduxForm.FormSection,
	        { name: 'permissions' },
	        ListWrapper ? _react2.default.createElement(
	            ListWrapper,
	            null,
	            listRender
	        ) : listRender
	    );
	}
	
	PermissionsForm.propTypes = {
	    ListWrapper: _propTypes2.default.func
	};
	
	exports.default = PermissionsForm;

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(1096);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _reactRouter = __webpack_require__(188);
	
	var _rcTable = __webpack_require__(1904);
	
	var _rcTable2 = _interopRequireDefault(_rcTable);
	
	var _materialUi = __webpack_require__(642);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(618);
	
	var _accounts = __webpack_require__(2134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLUMNS = [{
	    key: 'username',
	    dataIndex: 'username',
	    title: 'Username'
	}, {
	    key: 'createdAt',
	    title: 'Created',
	    render: function render(_ref) {
	        var createdAt = _ref.createdAt;
	        return _react2.default.createElement(
	            'span',
	            null,
	            (0, _moment2.default)(createdAt).format('DD MMM YYYY')
	        );
	    }
	}, {
	    key: 'permissions',
	    title: 'Permissions',
	    render: function render(_ref2) {
	        var permissions = _ref2.permissions;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.htmlWidgets, label: 'HTML widgets' }),
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.smWidgets, label: 'Social media widgets' }),
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.campaigns, label: 'Campaigns/automations' }),
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.messageServices, label: 'Message services' }),
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.tvSchedule, label: 'TV Schedule API' }),
	            _react2.default.createElement(_materialUi.Checkbox, { disabled: true, checked: permissions.gridMakerTool, label: 'Grid Maker Tool' })
	        );
	    }
	}];
	
	var AccountsList = function AccountsList(_ref3) {
	    var items = _ref3.items;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: 'Add user', onTouchTap: function onTouchTap() {
	                return _reactRouter.browserHistory.push('/admin/accounts/create');
	            } }),
	        _react2.default.createElement(_rcTable2.default, {
	            data: items,
	            rowKey: '_id',
	            style: { marginTop: 12 },
	            onRowClick: function onRowClick(_ref4) {
	                var username = _ref4.username;
	                return _reactRouter.browserHistory.push('/admin/accounts/edit/' + username);
	            },
	            columns: COLUMNS
	        })
	    );
	};
	
	exports.default = (0, _recompose.compose)((0, _reduxQuery.connectRequest)(_accounts.fetchAccountConfig), (0, _reactRedux.connect)(function (state) {
	    return { accounts: (0, _selectors.getEntities)(state).accounts };
	}), (0, _recompose.withPropsOnChange)(function (cur, next) {
	    return cur.accounts !== next.accounts;
	}, function (_ref5) {
	    var accounts = _ref5.accounts;
	
	    var items = _lodash2.default.isObject(accounts) ? accounts : {};
	    return {
	        items: Object.keys(items).map(function (name) {
	            return items[name];
	        }).sort(function (a, b) {
	            return new Date(a.createdAt) - new Date(b.createdAt);
	        })
	    };
	}))(AccountsList);

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(320);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _accounts = __webpack_require__(2134);
	
	var _CardText = __webpack_require__(851);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _accountBox = __webpack_require__(2138);
	
	var _accountBox2 = _interopRequireDefault(_accountBox);
	
	var _PageCardWrapper = __webpack_require__(2139);
	
	var _PageCardWrapper2 = _interopRequireDefault(_PageCardWrapper);
	
	var _PacksSection = __webpack_require__(2140);
	
	var _PacksSection2 = _interopRequireDefault(_PacksSection);
	
	var _FeaturesSection = __webpack_require__(2145);
	
	var _FeaturesSection2 = _interopRequireDefault(_FeaturesSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UpdateAccount(_ref) {
	    var _ref$account = _ref.account,
	        _ref$account$_id = _ref$account._id,
	        accountId = _ref$account$_id === undefined ? '' : _ref$account$_id,
	        permissions = _ref$account.permissions,
	        _ref$account$packs = _ref$account.packs,
	        packs = _ref$account$packs === undefined ? [] : _ref$account$packs,
	        _ref$queryAccount$isF = _ref.queryAccount.isFinished,
	        isFinishedAccount = _ref$queryAccount$isF === undefined ? false : _ref$queryAccount$isF,
	        paramsUserName = _ref.params.username;
	
	    return _react2.default.createElement(
	        _PageCardWrapper2.default,
	        {
	            title: 'Edit account ' + paramsUserName,
	            IconHeader: _accountBox2.default,
	            isFinished: isFinishedAccount,
	            isError: !accountId,
	            errorText: 'Not found user ' + paramsUserName
	        },
	        _react2.default.createElement(
	            _CardText2.default,
	            null,
	            _react2.default.createElement(_FeaturesSection2.default, { userId: accountId, permissions: permissions }),
	            _react2.default.createElement(_PacksSection2.default, { userId: accountId, userPacksList: packs })
	        )
	    );
	}
	
	UpdateAccount.propTypes = {
	    account: _propTypes2.default.shape({
	        _id: _propTypes2.default.string.isRequired,
	        username: _propTypes2.default.string.isRequired,
	        permissions: _propTypes2.default.object.isRequired,
	        packs: _propTypes2.default.array.isRequired
	    }),
	    queryAccount: _propTypes2.default.shape({ isFinished: _propTypes2.default.bool.isRequired }),
	    params: _propTypes2.default.shape({ username: _propTypes2.default.string })
	};
	
	exports.default = (0, _recompose.compose)((0, _reduxQuery.connectRequest)(function (_ref2) {
	    var params = _ref2.params;
	    return (0, _accounts.fetchUserByNameConfig)(params.username);
	}), (0, _reactRedux.connect)(function (_ref3, _ref4) {
	    var _ref3$query = _ref3.query,
	        query = _ref3$query === undefined ? { entities: {}, queries: {}, list: {} } : _ref3$query;
	    var params = _ref4.params;
	    return {
	        account: (0, _lodash2.default)(query.entities.accounts, params.username, {
	            _id: '',
	            username: '',
	            permissions: {},
	            packs: []
	        }),
	        queryAccount: (0, _lodash2.default)(query.queries, 'GET:accounts/' + params.username, { isFinished: false })
	    };
	}))(UpdateAccount);

/***/ },
/* 2138 */,
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-block;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n\n    > * + * {\n        margin-left: 20px;\n    }\n'], ['\n    display: inline-block;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n\n    > * + * {\n        margin-left: 20px;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: ', ';\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(843);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Loader = _styledComponents2.default.div(_templateObject);
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3, _colors.indigo500);
	
	var ButtonWrapper = _styledComponents2.default.div(_templateObject4);
	
	var ErrorText = _styledComponents2.default.h3(_templateObject5, _colors.red400);
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var IconPacksStyle = {
	    color: 'inherit'
	};
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	function PageCardWrapper(_ref) {
	    var IconHeader = _ref.IconHeader,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        buttonsAction = _ref.buttonsAction,
	        _ref$isError = _ref.isError,
	        isError = _ref$isError === undefined ? false : _ref$isError,
	        _ref$errorText = _ref.errorText,
	        errorText = _ref$errorText === undefined ? '' : _ref$errorText,
	        _ref$isFinished = _ref.isFinished,
	        isFinished = _ref$isFinished === undefined ? false : _ref$isFinished,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _Card.Card,
	            { style: CardStyle },
	            _react2.default.createElement(
	                _Card.CardHeader,
	                { style: CardHeaderStyle },
	                _react2.default.createElement(
	                    HeaderWrapper,
	                    null,
	                    _react2.default.createElement(
	                        Title,
	                        null,
	                        IconHeader && _react2.default.createElement(IconHeader, { style: IconPacksStyle }),
	                        title
	                    ),
	                    buttonsAction && _react2.default.createElement(
	                        ButtonWrapper,
	                        null,
	                        buttonsAction
	                    )
	                )
	            ),
	            isFinished && isError && _react2.default.createElement(
	                ErrorText,
	                null,
	                errorText
	            ),
	            !isFinished && _react2.default.createElement(
	                Loader,
	                null,
	                _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	            ),
	            isFinished && !isError && children
	        )
	    );
	}
	
	PageCardWrapper.propTypes = {
	    IconHeader: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	    title: _propTypes2.default.string,
	    buttonsAction: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	    isError: _propTypes2.default.bool,
	    errorText: _propTypes2.default.string,
	    isFinished: _propTypes2.default.bool.isRequired,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.func.isRequired, _propTypes2.default.element.isRequired])
	};
	
	exports.default = PageCardWrapper;

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 150px;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 150px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    font-size: 1.6em;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    font-size: 1.6em;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(320);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxQuery = __webpack_require__(298);
	
	var _reduxForm = __webpack_require__(342);
	
	var _accounts = __webpack_require__(2134);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _colors = __webpack_require__(910);
	
	var _SectionList = __webpack_require__(2141);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	var _PacksForm = __webpack_require__(2144);
	
	var _PacksForm2 = _interopRequireDefault(_PacksForm);
	
	var _style = __webpack_require__(2143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Loader = _styledComponents2.default.div(_templateObject);
	
	var Text = _styledComponents2.default.h3(_templateObject2);
	
	var ErrorText = Text.extend(_templateObject3, _colors.red400);
	
	var PacksSection = function (_Component) {
	    _inherits(PacksSection, _Component);
	
	    function PacksSection() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PacksSection);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PacksSection.__proto__ || Object.getPrototypeOf(PacksSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            snackbarSave: false
	        }, _this.showSnackbarSave = function (submitSucceeded) {
	            _this.setState({
	                snackbarSave: submitSucceeded
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PacksSection, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var submitSucceeded = _ref2.submitSucceeded;
	
	            if (this.props.submitSucceeded !== submitSucceeded) {
	                this.showSnackbarSave(submitSucceeded);
	            } else {
	                this.showSnackbarSave(false);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var snackbarSave = this.state.snackbarSave;
	            var _props = this.props,
	                _props$packs = _props.packs,
	                packs = _props$packs === undefined ? {} : _props$packs,
	                _props$listPacks = _props.listPacks,
	                listPacks = _props$listPacks === undefined ? [] : _props$listPacks,
	                _props$userPacksList = _props.userPacksList,
	                userPacksList = _props$userPacksList === undefined ? [] : _props$userPacksList,
	                _props$isFinished = _props.isFinished,
	                isFinished = _props$isFinished === undefined ? false : _props$isFinished,
	                _props$responseStatus = _props.responseStatus,
	                responseStatus = _props$responseStatus === undefined ? 0 : _props$responseStatus,
	                submit = _props.submit,
	                _props$submitting = _props.submitting,
	                submitting = _props$submitting === undefined ? false : _props$submitting,
	                _props$submitFailed = _props.submitFailed,
	                submitFailed = _props$submitFailed === undefined ? false : _props$submitFailed;
	
	
	            if (!isFinished) {
	                return _react2.default.createElement(
	                    Loader,
	                    null,
	                    _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	                );
	            }
	
	            if (responseStatus !== 200) {
	                return _react2.default.createElement(
	                    ErrorText,
	                    null,
	                    'Error load packs'
	                );
	            }
	
	            if (!listPacks.length) return _react2.default.createElement(
	                Text,
	                null,
	                'Packs not found'
	            );
	
	            return _react2.default.createElement(
	                _style.SectionWrapper,
	                null,
	                _react2.default.createElement(_SectionList2.default, {
	                    title: 'Packs',
	                    Component: _PacksForm2.default,
	                    submit: submit,
	                    submitFailed: submitFailed,
	                    packs: packs,
	                    listPacks: listPacks,
	                    userPacksList: userPacksList
	                }),
	                _react2.default.createElement(_Snackbar2.default, { open: submitting, message: 'Packs saving...', autoHideDuration: 10000 }),
	                _react2.default.createElement(_Snackbar2.default, { open: snackbarSave, message: 'Packs save', autoHideDuration: 3000 })
	            );
	        }
	    }]);
	
	    return PacksSection;
	}(_react.Component);
	
	PacksSection.propTypes = {
	    userPacksList: _propTypes2.default.array.isRequired,
	    // From connect
	    packs: _propTypes2.default.object.isRequired,
	    listPacks: _propTypes2.default.array.isRequired,
	    isFinished: _propTypes2.default.bool.isRequired,
	    responseStatus: _propTypes2.default.number.isRequired,
	    // From reduxForm
	    submit: _propTypes2.default.func,
	    submitting: _propTypes2.default.bool.isRequired,
	    submitSucceeded: _propTypes2.default.bool.isRequired,
	    submitFailed: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _reduxQuery.connectRequest)(function () {
	    return (0, _accounts.fetchAccountPacks)();
	}), (0, _reactRedux.connect)(function (_ref3, _ref4) {
	    var _ref3$query = _ref3.query,
	        query = _ref3$query === undefined ? { entities: {}, queries: {} } : _ref3$query;
	    var userPacksList = _ref4.userPacksList;
	
	    var packs = (0, _lodash2.default)(query.entities, 'accountPacks', {});
	    var listPacks = Object.keys((0, _lodash2.default)(query.entities, 'accountPacks', {})) || [];
	    var initialValues = {
	        accountPacks: listPacks.length ? listPacks.reduce(function (acc, packId) {
	            var pack = packs[packId];
	
	            return _extends({}, acc, _defineProperty({}, '' + pack.id, userPacksList.indexOf(pack.id) !== -1));
	        }, {}) : {}
	    };
	
	    return {
	        packs: packs,
	        listPacks: listPacks,
	        isFinished: (0, _lodash2.default)(query.queries, ['GET:accountPacks', 'isFinished'], false),
	        responseStatus: (0, _lodash2.default)(query.queries, ['GET:accountPacks', 'status'], 0),
	        initialValues: initialValues
	    };
	}), (0, _reduxForm.reduxForm)({
	    form: 'editAccountPacks',
	    onSubmit: function onSubmit(_ref5, dispatch, _ref6) {
	        var accountPacks = _ref5.accountPacks;
	        var userId = _ref6.userId;
	
	        var packsList = Object.entries(accountPacks).reduce(function (acc, _ref7) {
	            var _ref8 = _slicedToArray(_ref7, 2),
	                packName = _ref8[0],
	                isActive = _ref8[1];
	
	            if (isActive) return [].concat(_toConsumableArray(acc), [packName]);
	
	            return acc;
	        }, []);
	
	        return dispatch((0, _accounts.updateAccountPacks)(userId, { packs: packsList })).then(function (_ref9) {
	            var body = _ref9.body,
	                status = _ref9.status;
	
	            if (status >= 400) {
	                throw new _reduxForm.SubmissionError(body);
	            }
	        });
	    },
	    pure: true,
	    enableReinitialize: true
	}))(PacksSection);

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    font-size: 1.6em;\n    color: ', ';\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    font-size: 1.6em;\n    color: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FormSubmitButton = __webpack_require__(2142);
	
	var _FormSubmitButton2 = _interopRequireDefault(_FormSubmitButton);
	
	var _style = __webpack_require__(2143);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ErrorText = _styledComponents2.default.h3(_templateObject, _colors.red400);
	
	function SectionList(_ref) {
	    var title = _ref.title,
	        Component = _ref.Component,
	        submit = _ref.submit,
	        _ref$submitFailed = _ref.submitFailed,
	        submitFailed = _ref$submitFailed === undefined ? false : _ref$submitFailed,
	        childrenProps = _objectWithoutProperties(_ref, ['title', 'Component', 'submit', 'submitFailed']);
	
	    if (submitFailed) {
	        return _react2.default.createElement(
	            ErrorText,
	            null,
	            'Error saving!'
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        title && _react2.default.createElement(
	            _style.TitleSection,
	            null,
	            title
	        ),
	        _react2.default.createElement(Component, _extends({ ListWrapper: _style.FormWrapper }, childrenProps)),
	        _react2.default.createElement(
	            _style.ButtonWrapper,
	            null,
	            _react2.default.createElement(_FormSubmitButton2.default, { submit: submit })
	        )
	    );
	}
	
	SectionList.propTypes = {
	    title: _propTypes2.default.string,
	    Component: _propTypes2.default.oneOfType([_propTypes2.default.func.isRequired, _propTypes2.default.element.isRequired]),
	    submit: _propTypes2.default.func.isRequired,
	    submitFailed: _propTypes2.default.bool
	};
	
	exports.default = SectionList;

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormSubmitButton(_ref) {
	    var label = _ref.label,
	        submit = _ref.submit;
	
	    return _react2.default.createElement(_RaisedButton2.default, { primary: true, label: label || 'Save', onClick: submit });
	}
	
	FormSubmitButton.propTypes = {
	    label: _propTypes2.default.string,
	    submit: _propTypes2.default.func
	};
	
	exports.default = FormSubmitButton;

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ButtonWrapper = exports.FormWrapper = exports.TitleSection = exports.SectionWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    & + & {\n        margin-top: 35px;\n    }\n'], ['\n    & + & {\n        margin-top: 35px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin-top: 0;\n    margin-bottom: 15px;\n    font-size: 1.4em;\n'], ['\n    margin-top: 0;\n    margin-bottom: 15px;\n    font-size: 1.4em;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 5px 10px;\n    @supports not (gap: inherit) {\n        grid-gap: 5px 10px;\n    }\n    padding: 0;\n    list-style: none;\n'], ['\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 5px 10px;\n    @supports not (gap: inherit) {\n        grid-gap: 5px 10px;\n    }\n    padding: 0;\n    list-style: none;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    margin-top: 15px;\n'], ['\n    margin-top: 15px;\n']);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SectionWrapper = exports.SectionWrapper = _styledComponents2.default.div(_templateObject);
	
	var TitleSection = exports.TitleSection = _styledComponents2.default.h3(_templateObject2);
	
	var FormWrapper = exports.FormWrapper = _styledComponents2.default.div(_templateObject3);
	
	var ButtonWrapper = exports.ButtonWrapper = _styledComponents2.default.div(_templateObject4);

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listRender = function listRender(listPacks, packs) {
	    return listPacks.map(function (packId) {
	        var pack = packs[packId];
	
	        return _react2.default.createElement(_reduxForm.Field, {
	            key: packId,
	            name: pack.id,
	            label: pack.name,
	            normalize: function normalize(v) {
	                return Boolean(v);
	            },
	            type: 'checkbox',
	            component: _reduxFormMaterialUi.Checkbox
	        });
	    });
	};
	
	function PacksForm(_ref) {
	    var _ref$packs = _ref.packs,
	        packs = _ref$packs === undefined ? {} : _ref$packs,
	        _ref$listPacks = _ref.listPacks,
	        listPacks = _ref$listPacks === undefined ? [] : _ref$listPacks,
	        ListWrapper = _ref.ListWrapper;
	
	    return _react2.default.createElement(
	        _reduxForm.FormSection,
	        { name: 'accountPacks' },
	        ListWrapper ? _react2.default.createElement(
	            ListWrapper,
	            null,
	            listRender(listPacks, packs)
	        ) : listRender(listPacks, packs)
	    );
	}
	
	PacksForm.propTypes = {
	    packs: _propTypes2.default.object.isRequired,
	    listPacks: _propTypes2.default.array.isRequired,
	    ListWrapper: _propTypes2.default.func
	};
	
	exports.default = PacksForm;

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reduxForm = __webpack_require__(342);
	
	var _accounts = __webpack_require__(2134);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _SectionList = __webpack_require__(2141);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	var _PermissionsForm = __webpack_require__(2135);
	
	var _PermissionsForm2 = _interopRequireDefault(_PermissionsForm);
	
	var _style = __webpack_require__(2143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeaturesSection(_ref) {
	    var submit = _ref.submit,
	        _ref$submitting = _ref.submitting,
	        submitting = _ref$submitting === undefined ? false : _ref$submitting,
	        _ref$submitSucceeded = _ref.submitSucceeded,
	        submitSucceeded = _ref$submitSucceeded === undefined ? false : _ref$submitSucceeded,
	        _ref$submitFailed = _ref.submitFailed,
	        submitFailed = _ref$submitFailed === undefined ? false : _ref$submitFailed;
	
	    return _react2.default.createElement(
	        _style.SectionWrapper,
	        null,
	        _react2.default.createElement(_SectionList2.default, { title: 'Features', Component: _PermissionsForm2.default, submit: submit, submitFailed: submitFailed }),
	        _react2.default.createElement(_Snackbar2.default, { open: submitting, message: 'Features saving...', autoHideDuration: 10000 }),
	        _react2.default.createElement(_Snackbar2.default, { open: submitSucceeded, message: 'Features save', autoHideDuration: 3000 })
	    );
	}
	
	FeaturesSection.propTypes = {
	    // From reduxForm
	    submit: _propTypes2.default.func,
	    submitting: _propTypes2.default.bool.isRequired,
	    submitSucceeded: _propTypes2.default.bool.isRequired,
	    submitFailed: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(function (state, _ref2) {
	    var permissions = _ref2.permissions;
	    return {
	        initialValues: { permissions: permissions }
	    };
	}), (0, _reduxForm.reduxForm)({
	    form: 'editAccount',
	    onSubmit: function onSubmit(_ref3, dispatch, _ref4) {
	        var permissions = _ref3.permissions;
	        var userId = _ref4.userId;
	
	        return dispatch((0, _accounts.updateAccount)(userId, { permissions: permissions })).then(function (_ref5) {
	            var body = _ref5.body,
	                status = _ref5.status;
	
	            if (status >= 400) {
	                throw new _reduxForm.SubmissionError(body);
	            }
	        });
	    },
	    pure: true,
	    enableReinitialize: true
	}))(FeaturesSection);

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CampaignsSelect = __webpack_require__(2147);
	
	var _CampaignsSelect2 = _interopRequireDefault(_CampaignsSelect);
	
	var _PostsList = __webpack_require__(2149);
	
	var _PostsList2 = _interopRequireDefault(_PostsList);
	
	var _Filters = __webpack_require__(2157);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _dialogs = __webpack_require__(1964);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hub = function Hub() {
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', paddingTop: 20, width: '100%', marginBottom: 50 } },
	        _react2.default.createElement(
	            'div',
	            { style: { width: 240, minWidth: 240, marginRight: 37 } },
	            _react2.default.createElement(
	                rmd.Paper,
	                null,
	                _react2.default.createElement(_Filters2.default, null)
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { width: 'calc(100% - 277px)' } },
	            _react2.default.createElement(
	                rmd.Paper,
	                null,
	                _react2.default.createElement(_PostsList2.default, null)
	            )
	        ),
	        _react2.default.createElement(_dialogs.PublishDialog, null),
	        _react2.default.createElement(_dialogs.EditDialog, null),
	        _react2.default.createElement(_dialogs.LogsDialog, null),
	        _react2.default.createElement(_dialogs.RejectDialog, null),
	        _react2.default.createElement(_dialogs.DeleteDialog, null)
	    );
	};
	
	exports.default = Hub;

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _campaigns = __webpack_require__(2148);
	
	var _selectors = __webpack_require__(618);
	
	var _materialUi = __webpack_require__(642);
	
	var _helpers = __webpack_require__(592);
	
	var _accounts = __webpack_require__(2134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withAdmin = (0, _recompose.withPropsOnChange)('user', function (_ref) {
	    var user = _ref.user;
	    return {
	        isAdmin: user && Array.isArray(user.roles) && user.roles.indexOf('admin') > -1
	    };
	});
	
	var getSelectedValues = function getSelectedValues(qsVal) {
	    var parsed = (0, _helpers.safeParse)(qsVal);
	    return Array.isArray(parsed) ? parsed : [];
	};
	
	var CampaignsSelect = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	    return {
	        users: (0, _selectors.getEntities)(state).users,
	        user: state.user,
	        campaigns: (0, _selectors.getEntities)(state).campaignsList,
	        selected: _lodash2.default.get(state.routing, ['location', 'query', 'campaigns'])
	    };
	}), withAdmin)(function (_React$PureComponent) {
	    _inherits(_CampaignsSelect, _React$PureComponent);
	
	    function _CampaignsSelect() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _CampaignsSelect);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _CampaignsSelect.__proto__ || Object.getPrototypeOf(_CampaignsSelect)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { ids: null }, _this.onChange = function (e, i, values) {
	            (0, _helpers.addToQuery)('campaigns', JSON.stringify(values));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_CampaignsSelect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                isAdmin = _props.isAdmin,
	                dispatch = _props.dispatch;
	
	            dispatch((0, _campaigns.fetchAllCampaigns)()).then(function (res) {
	                if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                    var ids = (0, _helpers.toIdArray)(res.body);
	                    _this2.setState({ ids: ids }, function () {
	                        if (!getSelectedValues(_this2.props.selected).length) {
	                            _this2.onChange(null, null, ids);
	                        }
	                    });
	                }
	            });
	            if (isAdmin) {
	                dispatch((0, _accounts.fetchUsers)());
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                campaigns = _props2.campaigns,
	                isAdmin = _props2.isAdmin,
	                users = _props2.users,
	                dirtyValues = _props2.selected;
	            var ids = this.state.ids;
	
	            var selected = getSelectedValues(dirtyValues);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.SelectField,
	                    {
	                        value: selected,
	                        multiple: true,
	                        onChange: this.onChange,
	                        floatingLabelText: 'Select campaigns'
	                    },
	                    Array.isArray(ids) ? Object.keys(campaigns).map(function (id) {
	                        var campaign = campaigns[id];
	                        var label = (isAdmin && users ? _lodash2.default.get(users, [campaign.userId, 'username'], '') + ' | ' : '') + campaign.title;
	                        return _react2.default.createElement(_materialUi.MenuItem, {
	                            key: id,
	                            value: id,
	                            checked: selected && selected.indexOf(id) > -1,
	                            primaryText: label,
	                            insetChildren: true
	                        });
	                    }) : null
	                )
	            );
	        }
	    }]);
	
	    return _CampaignsSelect;
	}(_react2.default.PureComponent));
	
	exports.default = CampaignsSelect;

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchAllCampaigns = undefined;
	
	var _reduxQuery = __webpack_require__(298);
	
	var _auth = __webpack_require__(338);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _actions = __webpack_require__(593);
	
	var _helpers = __webpack_require__(592);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchAllCampaigns = exports.fetchAllCampaigns = function fetchAllCampaigns() {
	    return (0, _reduxQuery.requestAsync)({
	        url: _cfg2.default.campaign_manager.host + '/api/campaigns-list?access_token=' + _auth2.default.getAccessToken(),
	        queryKey: 'GET:campaigns-list',
	        transform: function transform(data) {
	            return {
	                campaignsList: (0, _helpers.toIdMap)(data)
	            };
	        },
	        force: true,
	        update: {
	            campaignsList: _actions.UPDATE_DEFAULT.MERGE
	        }
	    });
	};

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _reactResponsiveList = __webpack_require__(2150);
	
	var _withPagination = __webpack_require__(1901);
	
	var _materialUi = __webpack_require__(642);
	
	var _colors = __webpack_require__(910);
	
	var _selectors = __webpack_require__(618);
	
	var _helpers = __webpack_require__(592);
	
	var _posts = __webpack_require__(2154);
	
	var _settingsApplications = __webpack_require__(1723);
	
	var _settingsApplications2 = _interopRequireDefault(_settingsApplications);
	
	var _pagination = __webpack_require__(1791);
	
	var _PostImage = __webpack_require__(1948);
	
	var _PostImage2 = _interopRequireDefault(_PostImage);
	
	var _Pagination = __webpack_require__(1962);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Post = __webpack_require__(2155);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _constants = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FETCH_INTERVAL_SEC = 15;
	
	var PostsList = (0, _reactRedux.connect)(function (state) {
	    return {
	        selectedCampaigns: _lodash2.default.get(state.routing, ['location', 'query', 'campaigns']),
	        selectedStatuses: _lodash2.default.get(state.routing, ['location', 'query', 'statuses']),
	        isPending: _lodash2.default.get((0, _selectors.getEntities)(state), ['GET:hub', 'isPending']),
	        ids: (0, _pagination.selectIds)(state.pagination, 'hub')
	    };
	})(function (_React$PureComponent) {
	    _inherits(_PostsList, _React$PureComponent);
	
	    function _PostsList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _PostsList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _PostsList.__proto__ || Object.getPrototypeOf(_PostsList)).call.apply(_ref, [this].concat(args))), _this), _this.fetchData = function (campaignStr, statusStr) {
	            var ids = (0, _helpers.safeParse)(campaignStr);
	            var statuses = (0, _helpers.safeParse)(statusStr);
	            if (Array.isArray(ids)) {
	                _this.props.dispatch((0, _posts.fetchPostsByCampaignsAndStatuses)(ids, statuses));
	            }
	        }, _this.onPageChange = function () {
	            _this.fetchData(_this.props.selectedCampaigns, _this.props.selectedStatuses);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_PostsList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var dispatch = this.props.dispatch;
	
	            this.fetchData(this.props.selectedCampaigns, this.props.selectedStatuses);
	
	            this.fetchInterval = window.setInterval(function () {
	                _this2.fetchData(_this2.props.selectedCampaigns, _this2.props.selectedStatuses);
	                // dispatch(fetchNotPublishedPostsWithPagination(safeParse(this.props.selectedCampaigns)));
	            }, FETCH_INTERVAL_SEC * 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var _this3 = this;
	
	            var isFinished = _ref2.isFinished,
	                postIds = _ref2.postIds,
	                selectedCampaigns = _ref2.selectedCampaigns,
	                selectedStatuses = _ref2.selectedStatuses;
	
	            if (this.props.selectedCampaigns !== selectedCampaigns) {
	                this.fetchData(selectedCampaigns, selectedStatuses);
	            }
	            if (this.props.selectedStatuses !== selectedStatuses) {
	                this.fetchData(selectedCampaigns, selectedStatuses);
	            }
	
	            if (isFinished !== this.props.isFinished) {
	                if (isFinished) {
	                    window.clearTimeout(this.timer);
	                    this.timer = setTimeout(function () {
	                        return _this3.setState({ ready: isFinished });
	                    }, _constants.FINISHED_REQ_DELAY);
	                } else {
	                    window.clearTimeout(this.timer);
	                    this.setState({
	                        ready: isFinished || Array.isArray(postIds)
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                ids = _props.ids,
	                isPending = _props.isPending;
	
	            if (!ids || isPending) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'No data'
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            fontSize: 24,
	                            lineHeight: '28px',
	                            color: '#3f51b5',
	                            padding: '18px 24px',
	                            backgroundColor: '#f9f9f9',
	                            display: 'flex',
	                            alignItems: 'center'
	                        }
	                    },
	                    _react2.default.createElement(_settingsApplications2.default, { style: { width: 24, height: 24, marginRight: 20 }, color: '#3f51b5' }),
	                    ' Moderation Hub'
	                ),
	                ids.map(function (id) {
	                    return _react2.default.createElement(_Post2.default, { id: id, key: id });
	                }),
	                _react2.default.createElement(_Pagination2.default, { entity: 'hub', fetchFunction: this.onPageChange })
	            );
	        }
	    }]);
	
	    return _PostsList;
	}(_react2.default.PureComponent));
	
	exports.default = PostsList;

/***/ },
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPostsByCampaignsAndStatuses = exports.fetchPostsByCampaigns = undefined;
	
	var _posts = __webpack_require__(1902);
	
	var _withPagination = __webpack_require__(1901);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var fetchAction = (0, _posts.baseFetchPosts)(null);
	var fetchPostsByCampaigns = exports.fetchPostsByCampaigns = function fetchPostsByCampaigns(campaignIds) {
	    return (0, _withPagination.baseFetchPostsPagination)(function () {
	        return 'hub';
	    }, fetchAction).apply(undefined, _toConsumableArray(campaignIds));
	};
	var fetchPostsByCampaignsAndStatuses = exports.fetchPostsByCampaignsAndStatuses = function fetchPostsByCampaignsAndStatuses(campaignIds, statuses) {
	    return (0, _withPagination.baseFetchPostsPagination)(function () {
	        return 'hub';
	    }, (0, _posts.baseFetchPosts)(statuses)).apply(undefined, _toConsumableArray(campaignIds));
	};

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    padding-top: 25px;\n    .imageloader,\n    .bigpicture,\n    video {\n        height: 100%;\n        width: 100%;\n        overflow: hidden;\n    }\n    video {\n        object-fit: fill;\n    }\n'], ['\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    padding-top: 25px;\n    .imageloader,\n    .bigpicture,\n    video {\n        height: 100%;\n        width: 100%;\n        overflow: hidden;\n    }\n    video {\n        object-fit: fill;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    padding-left: 25px;\n    padding-right: 25px;\n    flex: 1 0 35%;\n    max-width: 35%;\n    height: 250px;\n    display: flex;\n    justify-content: center;\n    > div:not(.bigpicture) {\n        width: 100%;\n    }\n'], ['\n    padding-left: 25px;\n    padding-right: 25px;\n    flex: 1 0 35%;\n    max-width: 35%;\n    height: 250px;\n    display: flex;\n    justify-content: center;\n    > div:not(.bigpicture) {\n        width: 100%;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    flex: 1 0 65%;\n    max-width: 65%;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n'], ['\n    flex: 1 0 65%;\n    max-width: 65%;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    flex: 0 1 100%;\n    justify-content: flex-end;\n    display: flex;\n    padding: 5px 25px;\n    > div {\n        width: 260px;\n        display: flex;\n        flex-direction: row-reverse;\n    }\n'], ['\n    flex: 0 1 100%;\n    justify-content: flex-end;\n    display: flex;\n    padding: 5px 25px;\n    > div {\n        width: 260px;\n        display: flex;\n        flex-direction: row-reverse;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    padding-right: 25px;\n'], ['\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    padding-right: 25px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    font-size: 24px;\n    line-height: 34px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color: #4a4a4a;\n    margin-bottom: 1px;\n'], ['\n    font-size: 24px;\n    line-height: 34px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color: #4a4a4a;\n    margin-bottom: 1px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: 14px;\n    line-height: 18px;\n    color: #9b9b9b;\n    margin-right: 5px;\n'], ['\n    font-size: 14px;\n    line-height: 18px;\n    color: #9b9b9b;\n    margin-right: 5px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    button,\n    button svg {\n        width: 18px !important;\n        height: 18px !important;\n    }\n    button {\n        padding: 0 !important;\n        margin: 0 0 0 5px !important;\n    }\n'], ['\n    button,\n    button svg {\n        width: 18px !important;\n        height: 18px !important;\n    }\n    button {\n        padding: 0 !important;\n        margin: 0 0 0 5px !important;\n    }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n    width: 25%;\n    .d__icon {\n        margin-right: 20px;\n        svg {\n            width: 36px !important;\n            height: 36px !important;\n        }\n    }\n    .d__title {\n        text-transform: uppercase;\n        font-size: 12px;\n        color: #9b9b9b;\n        font-weight: 300;\n    }\n    .d__body {\n        font-size: 16px;\n        margin-top: 5px;\n        color: rgba(0, 0, 0, 0.87);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n    width: 25%;\n    .d__icon {\n        margin-right: 20px;\n        svg {\n            width: 36px !important;\n            height: 36px !important;\n        }\n    }\n    .d__title {\n        text-transform: uppercase;\n        font-size: 12px;\n        color: #9b9b9b;\n        font-weight: 300;\n    }\n    .d__body {\n        font-size: 16px;\n        margin-top: 5px;\n        color: rgba(0, 0, 0, 0.87);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 5px;\n    padding-right: 25px;\n'], ['\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 5px;\n    padding-right: 25px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    color: #9b9b9b;\n    line-height: 14px;\n    display: flex;\n    align-items: center;\n\n    div[tabindex] {\n        margin-right: 0 !important;\n        background: transparent !important;\n        svg {\n            width: 36px !important;\n            height: 36px !important;\n        }\n        > span {\n            font-size: 13px !important;\n            font-weight: 700 !important;\n            color: #3f51b5 !important;\n            line-height: 14px !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n    }\n'], ['\n    font-size: 12px;\n    color: #9b9b9b;\n    line-height: 14px;\n    display: flex;\n    align-items: center;\n\n    div[tabindex] {\n        margin-right: 0 !important;\n        background: transparent !important;\n        svg {\n            width: 36px !important;\n            height: 36px !important;\n        }\n        > span {\n            font-size: 13px !important;\n            font-weight: 700 !important;\n            color: #3f51b5 !important;\n            line-height: 14px !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n    }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n    color: rgba(0, 0, 0, 0.3);\n    line-height: 36px;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 20px;\n    display: inline-block;\n'], ['\n    color: rgba(0, 0, 0, 0.3);\n    line-height: 36px;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 20px;\n    display: inline-block;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selectors = __webpack_require__(618);
	
	var _PostImage = __webpack_require__(1948);
	
	var _PostImage2 = _interopRequireDefault(_PostImage);
	
	var _materialUi = __webpack_require__(642);
	
	var rmd = _interopRequireWildcard(_materialUi);
	
	var _momentTimezone = __webpack_require__(1370);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _message = __webpack_require__(1039);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _settings = __webpack_require__(1038);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _accessTime = __webpack_require__(2156);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _person = __webpack_require__(1505);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _widgets = __webpack_require__(1722);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _PublishedPost = __webpack_require__(1957);
	
	var _PostActions = __webpack_require__(1955);
	
	var _PostActions2 = _interopRequireDefault(_PostActions);
	
	var _PostStatus = __webpack_require__(1954);
	
	var _PostStatus2 = _interopRequireDefault(_PostStatus);
	
	var _modeEdit = __webpack_require__(1383);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _posts = __webpack_require__(1902);
	
	var _ReadableCondition = __webpack_require__(1867);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var withPost = (0, _reactRedux.connect)(function (state, _ref) {
	    var id = _ref.id;
	    return {
	        post: _lodash2.default.get((0, _selectors.getEntities)(state).posts, id)
	    };
	}, function (dispatch, _ref2) {
	    var postId = _ref2.postId;
	    return {
	        updatePost: function updatePost(postId, updates) {
	            return dispatch((0, _posts.updatePost)(postId)(updates));
	        }
	    };
	});
	
	var Status = withPost(_PostStatus2.default);
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Image = _styledComponents2.default.div(_templateObject2);
	
	var Content = _styledComponents2.default.div(_templateObject3);
	
	var Actions = _styledComponents2.default.div(_templateObject4);
	
	var Header = _styledComponents2.default.div(_templateObject5);
	
	var Title = _styledComponents2.default.div(_templateObject6);
	
	var Time = _styledComponents2.default.div(_templateObject7);
	
	var Flex = _styledComponents2.default.div(_templateObject8);
	var SocialLinks = _styledComponents2.default.div(_templateObject9);
	
	var Detail = _styledComponents2.default.div(_templateObject10);
	
	var Details = _styledComponents2.default.div(_templateObject11);
	
	var Condition = _styledComponents2.default.div(_templateObject12);
	
	var ActionText = _styledComponents2.default.span(_templateObject13);
	
	var buildPostTitle = function buildPostTitle(post) {
	    return _lodash2.default.get(post, 'presentation.params.title');
	};
	
	var buildPostTime = function buildPostTime(post) {
	    return (0, _momentTimezone2.default)(post.createdAt).fromNow();
	    // if (moment().diff(post.createdAt))
	};
	
	var PostDetail = function PostDetail(_ref3) {
	    var title = _ref3.title,
	        body = _ref3.body,
	        icon = _ref3.icon;
	
	    return _react2.default.createElement(
	        Detail,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'd__icon' },
	            icon
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { minWidth: 0 } },
	            _react2.default.createElement(
	                'div',
	                { className: 'd__title' },
	                title
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'd__body' },
	                body
	            )
	        )
	    );
	};
	
	var edit = function edit(id) {
	    return function () {
	        (0, _helpers.addToQuery)('edit', id);
	    };
	};
	
	var Post = function Post(_ref4) {
	    var id = _ref4.id,
	        post = _ref4.post,
	        updatePost = _ref4.updatePost;
	
	    var isModerated = _lodash2.default.get(post, 'campaign.moderation');
	    var postDetails = [{
	        title: 'Messages:',
	        body: _lodash2.default.get(post, 'content.generatedMessages', []).length,
	        icon: _react2.default.createElement(_message2.default, { color: '#d8d8d8' })
	    }, { title: 'Facts:', body: _lodash2.default.get(post, 'facts', []).length, icon: null }, {
	        title: 'Client:',
	        body: _lodash2.default.get(post, 'presentation.params.client') + '/' + _lodash2.default.get(post, 'presentation.params.username'),
	        icon: _react2.default.createElement(_person2.default, { color: '#d8d8d8' })
	    }, { title: 'Campaign:', body: _lodash2.default.get(post, 'campaign.title'), icon: null }, {
	        title: 'Last update:',
	        body: (0, _momentTimezone2.default)(post.updatedAt).fromNow(),
	        icon: _react2.default.createElement(_accessTime2.default, { color: '#d8d8d8' })
	    }, { title: 'Status:', body: _react2.default.createElement(Status, { id: id }), icon: null }, {
	        title: 'Widget:',
	        body: _lodash2.default.get(post, 'presentation.name'),
	        icon: _react2.default.createElement(_widgets2.default, { color: '#d8d8d8' })
	    }, {
	        title: 'Theme:',
	        body: _lodash2.default.get(post, 'presentation.params.template', '').split('-').slice(2).join('-'),
	        icon: null
	    }];
	
	    var isFinished = _lodash2.default.get(post, 'status.state') === 'success' && _lodash2.default.get(post, 'status.step') === 'finished';
	
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement(_PostImage2.default, { post: post })
	        ),
	        _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	                Header,
	                null,
	                _react2.default.createElement(
	                    Title,
	                    null,
	                    buildPostTitle(post)
	                ),
	                _react2.default.createElement(
	                    Flex,
	                    null,
	                    _react2.default.createElement(
	                        Time,
	                        null,
	                        buildPostTime(post)
	                    ),
	                    _react2.default.createElement(
	                        SocialLinks,
	                        null,
	                        post.publications.map(function (publicationId) {
	                            return _react2.default.createElement(_PublishedPost.PostLink, { key: publicationId, publicationId: publicationId });
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Details,
	                null,
	                postDetails.map(function (_ref5) {
	                    var title = _ref5.title,
	                        body = _ref5.body,
	                        icon = _ref5.icon;
	                    return _react2.default.createElement(PostDetail, { title: title, body: body, icon: icon, key: title });
	                })
	            ),
	            _react2.default.createElement(
	                Condition,
	                null,
	                _react2.default.createElement(_settings2.default, { color: '#d8d8d8', style: { width: 36, height: 36, marginRight: 18 } }),
	                post.trigger && _react2.default.createElement(_ReadableCondition.ReadableCondition, { triggerType: post.triggerType, condition: post.trigger }),
	                !post.trigger && _react2.default.createElement(
	                    'span',
	                    null,
	                    'Manual post'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            Actions,
	            null,
	            !isFinished && isModerated && _react2.default.createElement(rmd.FlatButton, {
	                primary: true,
	                label: 'Edit',
	                style: { marginTop: 0 },
	                onTouchTap: edit(id),
	                icon: _react2.default.createElement(_modeEdit2.default, null)
	            }),
	            !isModerated && !isFinished && _react2.default.createElement(
	                ActionText,
	                null,
	                'No moderation required'
	            ),
	            !isFinished && _react2.default.createElement(_PostActions2.default, { post: post }),
	            isFinished && _react2.default.createElement(
	                ActionText,
	                null,
	                'Post published'
	            )
	        )
	    );
	};
	
	Post.propTypes = {
	    post: _propTypes2.default.object.isRequired,
	    id: _propTypes2.default.string.isRequired
	};
	
	exports.default = withPost(Post);

/***/ },
/* 2156 */,
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    color: #3f51b5;\n    font-size: 24px;\n    line-height: 28px;\n    padding: 18px 15px;\n    background: #f9f9f9;\n'], ['\n    color: #3f51b5;\n    font-size: 24px;\n    line-height: 28px;\n    padding: 18px 15px;\n    background: #f9f9f9;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    margin-left: 17px;\n    padding: 12px 10px 12px 0;\n    .title {\n        color: #9b9b9b;\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n    .subtitle {\n        color: #9b9b9b;\n        font-weight: 700;\n        margin: 15px 0 15px;\n        font-size: 16px;\n    }\n'], ['\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    margin-left: 17px;\n    padding: 12px 10px 12px 0;\n    .title {\n        color: #9b9b9b;\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n    .subtitle {\n        color: #9b9b9b;\n        font-weight: 700;\n        margin: 15px 0 15px;\n        font-size: 16px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _recompose = __webpack_require__(1096);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selectors = __webpack_require__(618);
	
	var _accounts = __webpack_require__(2134);
	
	var _campaigns = __webpack_require__(2148);
	
	var _constants = __webpack_require__(579);
	
	var _helpers = __webpack_require__(592);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _materialUi = __webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var withAdmin = (0, _recompose.withPropsOnChange)('user', function (_ref) {
	    var user = _ref.user;
	    return {
	        isAdmin: user && Array.isArray(user.roles) && user.roles.indexOf('admin') > -1
	    };
	});
	
	var getSelectedValues = function getSelectedValues(qsVal) {
	    var parsed = (0, _helpers.safeParse)(qsVal);
	    return Array.isArray(parsed) ? parsed : [];
	};
	
	var Title = _styledComponents2.default.div(_templateObject);
	
	var Block = _styledComponents2.default.div(_templateObject2);
	
	var Filters = function (_React$PureComponent) {
	    _inherits(Filters, _React$PureComponent);
	
	    function Filters() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Filters);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Filters.__proto__ || Object.getPrototypeOf(Filters)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { ids: null }, _this.onChange = function (e, i, values) {
	            (0, _helpers.addToQuery)('campaigns', JSON.stringify(values));
	        }, _this.onCampaignCheck = function (ids, isChecked) {
	            var _this$props = _this.props,
	                dirtyValues = _this$props.selected,
	                campaigns = _this$props.campaigns;
	
	            var selected = _this.getChangedArray(ids, isChecked, dirtyValues);
	
	            var affectedUsers = selected.map(function (id) {
	                return campaigns[id].userId;
	            });
	
	            if (isChecked) {
	                var newUsers = _this.getChangedArray(affectedUsers, isChecked, _this.props.selectedUsers);
	                (0, _helpers.addToQuery)('users', JSON.stringify(newUsers));
	            }
	            _this.onChange(null, null, selected);
	        }, _this.onUserCheck = function (ids, isChecked) {
	            var _this$props2 = _this.props,
	                campaigns = _this$props2.campaigns,
	                selectedCampaignsDirtyValues = _this$props2.selected;
	
	
	            var selected = _this.getChangedArray(ids, isChecked, _this.props.selectedUsers);
	
	            var selectedCampaigns = getSelectedValues(selectedCampaignsDirtyValues);
	            if (isChecked) selectedCampaigns = _lodash2.default.map(_extends({}, campaigns), function (campaign) {
	                return campaign._id;
	            });
	
	            var affectedCampaigns = _lodash2.default.compact(selectedCampaigns.map(function (s) {
	                return campaigns[s];
	            }).map(function (campaign) {
	                if (ids.includes(campaign.userId)) {
	                    return campaign._id;
	                }
	            }));
	
	            _this.onCampaignCheck(affectedCampaigns, isChecked);
	            (0, _helpers.addToQuery)('users', JSON.stringify(selected));
	        }, _this.onStatusCheck = function (ids, isChecked) {
	            var selectedStatusesDirtyValues = _this.props.selectedStatuses;
	
	
	            var newStatuses = ids; // this.getChangedArray(ids, isChecked,selectedStatusesDirtyValues)
	            if (newStatuses[0] === 'all') newStatuses = [];
	            (0, _helpers.addToQuery)('statuses', JSON.stringify(newStatuses));
	        }, _this.getChangedArray = function (ids, isChecked, dirtyValues) {
	            var selected = getSelectedValues(dirtyValues);
	            if (!isChecked) _lodash2.default.pullAll(selected, ids);else selected = _lodash2.default.uniq([].concat(_toConsumableArray(selected), _toConsumableArray(ids)));
	            return selected;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Filters, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                isAdmin = _props.isAdmin,
	                dispatch = _props.dispatch;
	
	            dispatch((0, _accounts.fetchUsers)()).then(function (res) {
	                if (isAdmin) {
	                    if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                        var userIds = (0, _helpers.toIdArray)(res.body);
	                        _this2.setState({ userIds: userIds }, function () {
	                            if (!getSelectedValues(_this2.props.selectedUsers).length || !getSelectedValues(_this2.props.selected).length) {
	                                (0, _helpers.addToQuery)('users', JSON.stringify(userIds));
	                            }
	                            return;
	                        });
	                    }
	                } else {
	                    return;
	                }
	            }).then(function () {
	                dispatch((0, _campaigns.fetchAllCampaigns)()).then(function (res) {
	                    if ((0, _helpers.responseStatusIsOk)(res.status)) {
	                        var ids = (0, _helpers.toIdArray)(res.body);
	                        _this2.setState({ ids: ids }, function () {
	                            if (!getSelectedValues(_this2.props.selected).length) {
	                                _this2.onChange(null, null, ids);
	                            }
	                        });
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                campaigns = _props2.campaigns,
	                isAdmin = _props2.isAdmin,
	                dirtyValues = _props2.selected,
	                dirtyValuesSelectedUsers = _props2.selectedUsers,
	                dirtyValuesSelectedStatuses = _props2.selectedStatuses;
	
	
	            var users = isAdmin ? _lodash2.default.uniqBy(_lodash2.default.map(campaigns, function (campaign) {
	                return _this3.props.users[campaign.userId];
	            }), '_id') : [];
	
	            var selected = getSelectedValues(dirtyValues);
	            var selectedUsers = getSelectedValues(dirtyValuesSelectedUsers);
	            var selectedStatuses = getSelectedValues(dirtyValuesSelectedStatuses);
	
	            var campaignsArray = _lodash2.default.map(campaigns, function (c) {
	                return c;
	            });
	            var campaignsGroupedByUser = _lodash2.default.groupBy(campaignsArray, 'userId');
	
	            return _react2.default.createElement(
	                'div',
	                { style: { paddingBottom: 40 } },
	                _react2.default.createElement(
	                    Title,
	                    null,
	                    'Filters'
	                ),
	                isAdmin && _react2.default.createElement(
	                    Block,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        'Clients'
	                    ),
	                    users.map(function (user) {
	                        return _react2.default.createElement(_materialUi.Checkbox, {
	                            onCheck: function onCheck(e, isChecked) {
	                                return _this3.onUserCheck([_lodash2.default.get(user, ['_id'])], isChecked);
	                            },
	                            checked: selectedUsers && selectedUsers.indexOf(_lodash2.default.get(user, ['_id'])) > -1,
	                            key: _lodash2.default.get(user, ['_id']),
	                            label: _lodash2.default.get(user, 'username') + ' (' + _lodash2.default.get(user, 'client') + ')'
	                        });
	                    })
	                ),
	                _react2.default.createElement(
	                    Block,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        'Campaigns'
	                    ),
	                    _lodash2.default.map(campaignsGroupedByUser, function (campaigns, user) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: user },
	                            isAdmin && _react2.default.createElement(
	                                'div',
	                                { className: 'subtitle' },
	                                _lodash2.default.get(_this3.props.users, [user, 'username'])
	                            ),
	                            _lodash2.default.map(campaigns, function (campaign) {
	                                return _react2.default.createElement(_materialUi.Checkbox, {
	                                    onCheck: function onCheck(e, isChecked) {
	                                        return _this3.onCampaignCheck([campaign._id], isChecked);
	                                    },
	                                    checked: selected && selected.indexOf(campaign._id) > -1,
	                                    label: campaign.title,
	                                    key: campaign._id
	                                });
	                            })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    Block,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        'Status'
	                    ),
	                    _react2.default.createElement(
	                        _materialUi.RadioButtonGroup,
	                        {
	                            name: 'status',
	                            defaultSelected: selectedStatuses && selectedStatuses[0],
	                            onChange: function onChange(e, value) {
	                                return _this3.onStatusCheck([value], true);
	                            }
	                        },
	                        [{ label: 'All', value: 'all' }, {
	                            label: 'Waiting for moderation',
	                            value: _constants.POST_STATUS.AWAITING
	                        }, { label: 'Published', value: _constants.POST_STATUS.PUBLISHED }, { label: 'Not published', value: _constants.POST_STATUS.NOT_PUBLISHED }, { label: 'Failed', value: _constants.POST_STATUS.FAILED }, { label: 'Rejected', value: _constants.POST_STATUS.REJECTED }, { label: 'In progress', value: _constants.POST_STATUS.IN_PROGRESS }].map(function (_ref3) {
	                            var label = _ref3.label,
	                                value = _ref3.value;
	                            return _react2.default.createElement(_materialUi.RadioButton
	                            // onCheck={(e, isChecked) => this.onStatusCheck([value], isChecked)}
	                            // checked={selectedStatuses && selectedStatuses.indexOf(value) > -1}
	                            , { label: label,
	                                key: value,
	                                value: value
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Filters;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	    return {
	        users: (0, _selectors.getEntities)(state).users,
	        user: state.user,
	        campaigns: (0, _selectors.getEntities)(state).campaignsList,
	        selected: _lodash2.default.get(state.routing, ['location', 'query', 'campaigns']),
	        selectedUsers: _lodash2.default.get(state.routing, ['location', 'query', 'users']),
	        selectedStatuses: _lodash2.default.get(state.routing, ['location', 'query', 'statuses'])
	    };
	}, null), withAdmin)(Filters);

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(642);
	
	var _keyboardArrowLeft = __webpack_require__(1593);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(1594);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _undo = __webpack_require__(1967);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _superagent = __webpack_require__(327);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(250);
	
	var _helpers = __webpack_require__(1821);
	
	var _helpers2 = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ss2 = _cfg2.default.apis.ss2;
	
	var withQueryParams = function withQueryParams() {
	    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	        params[_key] = arguments[_key];
	    }
	
	    return (0, _reactRedux.connect)(function (state) {
	        return params.reduce(function (acc, param) {
	            acc[param] = _lodash2.default.get(state.routing.location, ['query', param]);
	            return acc;
	        }, {});
	    });
	};
	
	var getEventLabel = function getEventLabel(event) {
	    return event.homeName + ' - ' + event.awayName;
	};
	
	var KEY_OPTIONS = [{ label: 'Match link', value: 'matchPageLink' }, { label: 'Channel', value: 'channels' }, { label: 'Liveblog', value: 'lbid' }];
	
	var CHANNELS = [['DR 1'], ['DR 2'], ['DR 3'], ['DRTV'], ['TV 2'], ['TV 2 SPORT'], ['TV 2 PLAY']];
	
	var emptyOption = Symbol(null);
	
	var getVal = function getVal(key, event) {
	    var value = event[key];
	    switch (key) {
	        case 'channels':
	            {
	                if (Array.isArray(value)) {
	                    var channel = _lodash2.default.head(value);
	                    return CHANNELS.find(function (_ref) {
	                        var _ref2 = _slicedToArray(_ref, 1),
	                            el = _ref2[0];
	
	                        return el === channel;
	                    }) || emptyOption;
	                }
	                return emptyOption;
	            }
	        default:
	            {
	                return (0, _helpers2.isNullOrUndefined)(value) || _lodash2.default.isObject(value) || Array.isArray(value) ? null : value;
	            }
	    }
	};
	
	var EventInput = withQueryParams('property', 'dev')((_temp = _class = function (_React$PureComponent) {
	    _inherits(_EventInput, _React$PureComponent);
	
	    function _EventInput(props) {
	        _classCallCheck(this, _EventInput);
	
	        var _this = _possibleConstructorReturn(this, (_EventInput.__proto__ || Object.getPrototypeOf(_EventInput)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var property = props.property;
	
	        var value = property ? getVal(property, props.event) : '';
	        _this.state = {
	            value: value,
	            key: property || '',
	            initialValue: value,
	            snackBarText: '',
	            success: null
	        };
	        return _this;
	    }
	
	    _createClass(_EventInput, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            if (this.props.property !== props.property) {
	                this.onKeyChange(props.property);
	                var value = getVal(props.property, props.event);
	                this.setState({ initialValue: value });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                event = _props.event,
	                appName = _props.appName,
	                dev = _props.dev;
	            var _state = this.state,
	                key = _state.key,
	                value = _state.value,
	                initialValue = _state.initialValue,
	                snackBarText = _state.snackBarText,
	                success = _state.success;
	
	            var canSubmit = key && appName;
	            var valueChanged = initialValue !== value;
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: _extends({}, _helpers.yCenter, {
	                        marginTop: 8,
	                        padding: 8,
	                        flexWrap: 'wrap',
	                        justifyContent: 'space-between'
	                    })
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        getEventLabel(event)
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'eventId: ',
	                        event.eventId,
	                        ' ',
	                        (0, _moment2.default)(event.startDate).format('DD-MMM HH:mm')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, _helpers.yCenter, { flexWrap: 'wrap' }) },
	                    dev ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_materialUi.TextField, { name: 'key', floatingLabelText: 'Key', value: key, onChange: this.onChange }),
	                        _react2.default.createElement(_materialUi.TextField, {
	                            name: 'value',
	                            floatingLabelText: 'Value',
	                            value: value || '',
	                            onChange: this.onChange
	                        })
	                    ) : _react2.default.createElement(
	                        'div',
	                        { style: _extends({}, _helpers.yCenter, { flexWrap: 'wrap' }) },
	                        _react2.default.createElement(
	                            _materialUi.SelectField,
	                            { name: 'key', floatingLabelText: 'Property', value: key },
	                            KEY_OPTIONS.map(function (option) {
	                                return _react2.default.createElement(_materialUi.MenuItem, {
	                                    key: option.value,
	                                    value: option.value,
	                                    onTouchTap: function onTouchTap() {
	                                        return _this2.onKeyChange(option.value);
	                                    },
	                                    primaryText: option.label
	                                });
	                            })
	                        ),
	                        key === 'channels' ? _react2.default.createElement(
	                            _materialUi.SelectField,
	                            { name: 'value', floatingLabelText: 'Channel', value: value },
	                            _react2.default.createElement(_materialUi.MenuItem, {
	                                value: emptyOption,
	                                onTouchTap: function onTouchTap() {
	                                    return _this2.setState({
	                                        value: emptyOption
	                                    });
	                                },
	                                primaryText: 'None'
	                            }),
	                            CHANNELS.map(function (channel) {
	                                return _react2.default.createElement(_materialUi.MenuItem, {
	                                    key: _lodash2.default.head(channel),
	                                    value: channel,
	                                    onTouchTap: function onTouchTap() {
	                                        return _this2.setState({
	                                            value: channel
	                                        });
	                                    },
	                                    primaryText: _lodash2.default.head(channel)
	                                });
	                            })
	                        ) : _react2.default.createElement(_materialUi.TextField, {
	                            name: 'value',
	                            floatingLabelText: key === 'matchPageLink' ? 'Link' : 'Value',
	                            value: value || '',
	                            onChange: this.onChange
	                        })
	                    ),
	                    _react2.default.createElement(_materialUi.FlatButton, {
	                        disabled: !canSubmit || !valueChanged,
	                        primary: true,
	                        label: 'Save',
	                        onTouchTap: this.save
	                    }),
	                    valueChanged ? _react2.default.createElement(
	                        _materialUi.IconButton,
	                        { tooltip: 'Undo', onTouchTap: this.undo },
	                        _react2.default.createElement(_undo2.default, null)
	                    ) : _react2.default.createElement(
	                        'div',
	                        { style: { width: 48 } },
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(_materialUi.Snackbar, {
	                        open: Boolean(snackBarText),
	                        message: snackBarText,
	                        contentStyle: !success ? { color: 'red' } : undefined
	                    })
	                )
	            );
	        }
	    }]);
	
	    return _EventInput;
	}(_react2.default.PureComponent), _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.onChange = function (event, value) {
	        var name = event.target.name;
	
	        _this3.setState(_defineProperty({}, name, value));
	    };
	
	    this.onKeyChange = function (keyName) {
	        var event = _this3.props.event;
	
	        var value = getVal(keyName, event);
	        _this3.setState({
	            key: keyName,
	            initialValue: value,
	            value: value
	        });
	    };
	
	    this.showSnackBar = function (text, isError) {
	        _this3.setState({ snackBarText: text, success: !isError });
	        setTimeout(function () {
	            _this3.setState({ snackBarText: '' });
	        }, 3 * 1000);
	    };
	
	    this.save = function (e) {
	        e.preventDefault();
	        var _state2 = _this3.state,
	            key = _state2.key,
	            value = _state2.value;
	        var _props2 = _this3.props,
	            event = _props2.event,
	            appName = _props2.appName;
	        var eventId = event.eventId;
	
	        _superagent2.default.put(ss2 + '/admin/kv').send({
	            eventId: eventId,
	            appName: appName,
	            key: key,
	            value: value === emptyOption ? null : value
	        }).then(function () {
	            _this3.setState({ initialValue: value });
	            _this3.showSnackBar(getEventLabel(event) + ' saved', false);
	            if (typeof _this3.props.onSave === 'function') {
	                _this3.props.onSave();
	            }
	        }).catch(function () {
	            _this3.showSnackBar('Error while updating ' + getEventLabel(event), true);
	        });
	    };
	
	    this.undo = function () {
	        _this3.setState(function (_ref3) {
	            var initialValue = _ref3.initialValue;
	            return { value: initialValue };
	        });
	    };
	}, _temp));
	
	var EventList = withQueryParams('ttId', 'appName', 'property')(function (_React$PureComponent2) {
	    _inherits(EventList, _React$PureComponent2);
	
	    function EventList() {
	        var _ref4;
	
	        var _temp2, _this4, _ret;
	
	        _classCallCheck(this, EventList);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref4 = EventList.__proto__ || Object.getPrototypeOf(EventList)).call.apply(_ref4, [this].concat(args))), _this4), _this4.state = {
	            date: new Date(),
	            events: [],
	            eventId: null,
	            limit: 20,
	            skip: 0,
	            appName: _this4.props.appName
	        }, _this4.onDateChange = function (e, value) {
	            _this4.setState({ date: value, skip: 0 });
	            var _this4$state = _this4.state,
	                limit = _this4$state.limit,
	                appName = _this4$state.appName;
	            var ttId = _this4.props.ttId;
	
	            _this4.updateEvents(value, limit, 0, ttId, appName);
	        }, _this4.updateEvents = function () {
	            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.state.date;
	            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.state.limit;
	            var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this4.state.skip;
	            var ttId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this4.props.ttId;
	            var appName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _this4.state.appName;
	
	            var fromDate = (0, _moment2.default)(date).local();
	            if (date) {
	                _superagent2.default.get(ss2 + '/events-v2').query({
	                    fromDate: fromDate.format('YYYY-MM-DD'),
	                    appName: appName ? 'dk.releaze.livecenter.' + appName : undefined,
	                    skip: skip,
	                    ttId: ttId,
	                    limit: limit
	                }).then(function (res) {
	                    var events = Array.isArray(res.body.events) ? res.body.events : [];
	                    _this4.setState({ events: events });
	                });
	            } else {
	                _this4.setState({ events: [] });
	            }
	        }, _this4.updateEventsDelayed = _lodash2.default.debounce(_this4.updateEvents, 1 * 1000), _this4.onAppNameChange = function (appName) {
	            _this4.setState({ appName: appName });
	            _this4.updateEventsDelayed();
	        }, _this4.nextPage = function () {
	            var ttId = _this4.props.ttId;
	            var _this4$state2 = _this4.state,
	                limit = _this4$state2.limit,
	                skip = _this4$state2.skip,
	                date = _this4$state2.date,
	                appName = _this4$state2.appName;
	
	            var nextSkip = skip + limit;
	            _this4.setState({ skip: nextSkip });
	            _this4.updateEvents(date, limit, nextSkip, ttId, appName);
	        }, _this4.prevPage = function () {
	            var ttId = _this4.props.ttId;
	            var _this4$state3 = _this4.state,
	                limit = _this4$state3.limit,
	                skip = _this4$state3.skip,
	                date = _this4$state3.date,
	                appName = _this4$state3.appName;
	
	            var nextSkip = Math.max(0, skip - limit);
	            _this4.setState({ skip: nextSkip });
	            _this4.updateEvents(date, limit, nextSkip, ttId, appName);
	        }, _this4.renderPagintation = function () {
	            var _this4$state4 = _this4.state,
	                events = _this4$state4.events,
	                limit = _this4$state4.limit,
	                skip = _this4$state4.skip;
	
	            var canGoNext = events.length === limit;
	            var canGoPrev = skip !== 0;
	            return _react2.default.createElement(
	                'div',
	                { style: _helpers.yCenter },
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: !canGoPrev, onTouchTap: _this4.prevPage },
	                    _react2.default.createElement(_keyboardArrowLeft2.default, null)
	                ),
	                _react2.default.createElement(
	                    _materialUi.IconButton,
	                    { disabled: !canGoNext, onTouchTap: _this4.nextPage },
	                    _react2.default.createElement(_keyboardArrowRight2.default, null)
	                ),
	                skip + 1,
	                '-',
	                skip + Math.min(limit, events.length)
	            );
	        }, _temp2), _possibleConstructorReturn(_this4, _ret);
	    }
	
	    _createClass(EventList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this5 = this;
	
	            this.updateEvents();
	            if (!KEY_OPTIONS.find(function (option) {
	                return option.key === _this5.props.property;
	            })) {
	                KEY_OPTIONS.push({ label: this.props.property, value: this.props.property });
	            }
	        }
	    }, {
	        key: 'renderEvents',
	        value: function renderEvents() {
	            var _this6 = this;
	
	            var _state3 = this.state,
	                events = _state3.events,
	                appName = _state3.appName;
	
	            if (events.length) {
	                return _react2.default.createElement(
	                    _materialUi.Paper,
	                    null,
	                    events.map(function (event) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: event.eventId },
	                            _react2.default.createElement(EventInput, { event: event, appName: appName, onSave: _this6.updateEvents }),
	                            _react2.default.createElement(_materialUi.Divider, null)
	                        );
	                    })
	                );
	            }
	            return _react2.default.createElement(
	                'p',
	                null,
	                'No events'
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var _props3 = this.props,
	                dev = _props3.dev,
	                appName = _props3.appName;
	
	            if (!dev && !appName) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'Incorrect URL'
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                dev && _react2.default.createElement(_materialUi.TextField, {
	                    name: 'appName',
	                    floatingLabelText: 'Application name',
	                    value: this.state.appName,
	                    errorText: !this.state.appName && 'Required',
	                    onChange: function onChange(e, val) {
	                        return _this7.onAppNameChange(val);
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _materialUi.SelectField,
	                        { floatingLabelText: 'Property', value: this.props.property },
	                        KEY_OPTIONS.map(function (option) {
	                            return _react2.default.createElement(_materialUi.MenuItem, {
	                                key: option.value,
	                                value: option.value,
	                                primaryText: option.label,
	                                onTouchTap: function onTouchTap() {
	                                    return (0, _helpers2.addToQuery)('property', option.value);
	                                }
	                            });
	                        })
	                    )
	                ),
	                _react2.default.createElement(_materialUi.DatePicker, {
	                    id: 'date',
	                    value: this.state.date,
	                    floatingLabelText: 'From date',
	                    onChange: this.onDateChange
	                }),
	                this.renderEvents(),
	                this.renderPagintation()
	            );
	        }
	    }]);
	
	    return EventList;
	}(_react2.default.PureComponent));
	
	var Scene = function Scene() {
	    return _react2.default.createElement(
	        'div',
	        { style: { paddingTop: 24 } },
	        _react2.default.createElement(EventList, null)
	    );
	};
	
	exports.default = Scene;

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: inline-block;\n    flex-grow: 1;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n'], ['\n    display: inline-block;\n    flex-grow: 1;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reactRouter = __webpack_require__(188);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _MessageForm = __webpack_require__(2160);
	
	var _MessageForm2 = _interopRequireDefault(_MessageForm);
	
	var _MessageList = __webpack_require__(2166);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _SubmitButton = __webpack_require__(2167);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _actions = __webpack_require__(1863);
	
	var _triggerConstants = __webpack_require__(1824);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Snackbar = __webpack_require__(979);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _Card = __webpack_require__(843);
	
	var _SelectField = __webpack_require__(966);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _message = __webpack_require__(1039);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _filterList = __webpack_require__(2168);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.h2(_templateObject2, _colors.indigo500);
	
	var ButtonWrapper = _styledComponents2.default.div(_templateObject3);
	
	var CreateMessage = (0, _reduxForm.reduxForm)({
	    form: 'createMessage',
	    asyncBlurFields: [],
	    onSubmit: function onSubmit(values, dispatch) {
	        return dispatch((0, _actions.createMessage)(values));
	    }
	})(_MessageForm2.default);
	
	var triggerTypeNames = _triggerConstants.triggerTypes.map(function (t) {
	    return t.trigger;
	});
	
	var getTrigger = function getTrigger(trigger) {
	    if (typeof trigger === 'string') {
	        var lower = trigger.toLowerCase();
	
	        return lower !== 'all' ? lower : null;
	    }
	
	    return null;
	};
	
	var MessageScene = function (_PureComponent) {
	    _inherits(MessageScene, _PureComponent);
	
	    function MessageScene() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MessageScene);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageScene.__proto__ || Object.getPrototypeOf(MessageScene)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showCreate: false,
	            snackbarText: '',
	            trigger: null
	        }, _this.updateValues = function (query) {
	            var dispatch = _this.props.dispatch;
	
	            var trigger = getTrigger(query.trigger);
	
	            dispatch((0, _actions.fetchMessages)(trigger));
	
	            _this.setState({ trigger: trigger });
	        }, _this.onTriggerChange = function (trigger) {
	            _reactRouter.browserHistory.push({
	                pathname: window.location.pathname,
	                query: {
	                    trigger: trigger ? trigger : 'all'
	                }
	            });
	        }, _this.onCreateSuccess = function (result) {
	            _this.setState({ showCreate: false });
	            var title = result.body.title;
	
	            _this.setState({ snackbarText: 'Message ' + title + ' was created' });
	            setTimeout(function () {
	                _this.setState({ snackbarText: '' });
	            }, 2000);
	        }, _this.toggleCreate = function () {
	            return _this.setState(function (_ref2) {
	                var showCreate = _ref2.showCreate;
	                return { showCreate: !showCreate };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MessageScene, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
	                query = _browserHistory$getCu.query;
	
	            this.updateValues(query);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref3) {
	            var location = _ref3.location;
	
	            if (this.props.location !== location) {
	                this.updateValues(location ? location.query : {});
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                showCreate = _state.showCreate,
	                trigger = _state.trigger,
	                snackbarText = _state.snackbarText;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card.Card,
	                    null,
	                    _react2.default.createElement(
	                        _Card.CardHeader,
	                        {
	                            style: {
	                                borderBottom: '1px solid ' + _colors.grey300,
	                                paddingTop: 0,
	                                paddingBottom: 0
	                            }
	                        },
	                        _react2.default.createElement(
	                            HeaderWrapper,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                _react2.default.createElement(_message2.default, { style: { color: 'inherit' } }),
	                                'Social Messages'
	                            ),
	                            _react2.default.createElement(
	                                _SelectField2.default,
	                                {
	                                    value: trigger,
	                                    style: { marginLeft: 24 },
	                                    underlineStyle: { display: 'none' },
	                                    dropDownMenuProps: {
	                                        iconButton: _react2.default.createElement(_filterList2.default, null),
	                                        iconStyle: {
	                                            top: -1,
	                                            right: 'auto',
	                                            left: 0,
	                                            padding: '0',
	                                            textAlign: 'left',
	                                            fill: 'inherit'
	                                        }
	                                    },
	                                    labelStyle: { paddingLeft: 30, paddingRight: 0 }
	                                },
	                                triggerTypeNames.map(function (name) {
	                                    return _react2.default.createElement(_MenuItem2.default, {
	                                        key: name,
	                                        primaryText: (0, _humanizeString2.default)(name),
	                                        value: name,
	                                        onTouchTap: function onTouchTap() {
	                                            return _this2.onTriggerChange(name);
	                                        }
	                                    });
	                                }),
	                                _react2.default.createElement(_MenuItem2.default, {
	                                    value: null,
	                                    primaryText: 'All',
	                                    onTouchTap: function onTouchTap() {
	                                        return _this2.onTriggerChange(null);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                ButtonWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _RaisedButton2.default,
	                                    { onTouchTap: this.toggleCreate, secondary: true, labelColor: '#fff' },
	                                    'Create'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_MessageList2.default, { trigger: trigger })
	                ),
	                _react2.default.createElement(
	                    _Dialog2.default,
	                    {
	                        open: showCreate,
	                        autoScrollBodyContent: true,
	                        autoDetectWindowHeight: true,
	                        onRequestClose: this.toggleCreate
	                    },
	                    _react2.default.createElement(CreateMessage, { onSubmitSuccess: this.onCreateSuccess }),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 30, display: 'flex' } },
	                        _react2.default.createElement(_SubmitButton2.default, { form: 'createMessage', label: 'Create', primary: true }),
	                        _react2.default.createElement(
	                            ButtonWrapper,
	                            null,
	                            _react2.default.createElement(
	                                _RaisedButton2.default,
	                                {
	                                    onTouchTap: this.toggleCreate,
	                                    secondary: true,
	                                    labelColor: '#fff',
	                                    style: { marginLeft: 30 }
	                                },
	                                'Cancel'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_Snackbar2.default, { open: Boolean(snackbarText), message: snackbarText })
	            );
	        }
	    }]);
	
	    return MessageScene;
	}(_react.PureComponent);
	
	MessageScene.propTypes = {
	    location: _propTypes2.default.object,
	    dispatch: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { location: state.routing.location };
	})(MessageScene);

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _TYPES_BY_TRIGGER, _SUBTYPES;
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 40px;\n    margin-top: -5px;\n'], ['\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 40px;\n    margin-top: -5px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin-top: 30px;\n'], ['\n    margin-top: 30px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cfg = __webpack_require__(580);
	
	var _cfg2 = _interopRequireDefault(_cfg);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _materialUi = __webpack_require__(642);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _reduxFormMaterialUi = __webpack_require__(1645);
	
	var _recompose = __webpack_require__(1096);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _MessageBuilder = __webpack_require__(2161);
	
	var _types = __webpack_require__(2165);
	
	var _validation = __webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TypeWrapper = _styledComponents2.default.div(_templateObject);
	
	var SectionWrapper = _styledComponents2.default.div(_templateObject2);
	
	var TYPES = {
	    EVENT: { type: _types.EventType, label: 'Event', name: 'event' },
	    TOURNAMENT: {
	        type: _types.TournamentType,
	        label: 'Tournament',
	        name: 'tournament'
	    },
	    INCIDENT: { type: _types.IncidentType, label: 'Incident', name: 'incident' }
	};
	
	var TRIGGER_TYPES = {
	    ENET_EVENT_STATUS: 'enet_event_status',
	    ENET_EVENT_INCIDENT: 'enet_event_incident',
	    TOURN_MATCH_DAY: 'tourn_match_day',
	    TOURN_ROUND_STARTS: 'tourn_round_starts',
	    TOURN_ROUND_ENDS: 'tourn_round_ends',
	    EVENT_STARTS: 'event_starts',
	    EVENT_HALFTIME: 'event_halftime',
	    EVENT_FINISHED: 'event_finished',
	    EVENT_TEST: 'event_test'
	};
	
	var TYPES_BY_TRIGGER = (_TYPES_BY_TRIGGER = {}, _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.TOURN_MATCH_DAY, [TYPES.TOURNAMENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.TOURN_ROUND_STARTS, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.TOURN_ROUND_ENDS, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.EVENT_STARTS, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.EVENT_HALFTIME, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.EVENT_FINISHED, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.EVENT_TEST, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.ENET_EVENT_STATUS, [TYPES.TOURNAMENT, TYPES.EVENT]), _defineProperty(_TYPES_BY_TRIGGER, TRIGGER_TYPES.ENET_EVENT_INCIDENT, [TYPES.TOURNAMENT, TYPES.EVENT, TYPES.INCIDENT]), _TYPES_BY_TRIGGER);
	
	var SUBTYPES = (_SUBTYPES = {}, _defineProperty(_SUBTYPES, TRIGGER_TYPES.ENET_EVENT_INCIDENT, [{ label: 'All', value: '*' }, { label: 'Goal', value: 'goal' }, { label: 'Yellow Card', value: 'yellow_card' }, { label: 'Red Card', value: 'red_card' }, { label: 'Substitution', value: 'substitution' }, { label: 'Assist', value: 'assist' }]), _defineProperty(_SUBTYPES, TRIGGER_TYPES.ENET_EVENT_STATUS, [{ label: 'Any', value: '*' }, { label: 'Match started', value: '1st_half' }, { label: 'Halftime', value: 'halftime' }, { label: '2nd half started', value: '2nd_half' }, { label: 'Finished', value: 'finished' }]), _SUBTYPES);
	
	var hasOdds = function hasOdds(trigger) {
	    return trigger && trigger !== TRIGGER_TYPES.TOURN_MATCH_DAY;
	};
	
	var triggerTypesOrdered = Object.keys(TRIGGER_TYPES).map(function (key) {
	    return TRIGGER_TYPES[key];
	}).sort(function (a, b) {
	    return a - b;
	});
	
	var MessageBuilderWithTypes = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(function (state, _ref) {
	    var form = _ref._reduxForm.form;
	
	    var trigger = (0, _reduxForm.formValueSelector)(form)(state, 'trigger');
	    return {
	        types: TYPES_BY_TRIGGER[trigger],
	        withOdds: hasOdds(trigger)
	    };
	}))(function (_ref2) {
	    var types = _ref2.types,
	        props = _objectWithoutProperties(_ref2, ['types']);
	
	    return _react2.default.createElement(_reduxForm.Field, _extends({}, props, { types: types, component: _MessageBuilder.RMessageBuilder }));
	});
	
	var SubtypeField = (0, _recompose.compose)((0, _recompose.getContext)({
	    _reduxForm: _propTypes2.default.object
	}), (0, _reactRedux.connect)(function (state, _ref3) {
	    var form = _ref3._reduxForm.form;
	    return {
	        subtypes: SUBTYPES[(0, _reduxForm.formValueSelector)(form)(state, 'trigger')]
	    };
	}))(function (_ref4) {
	    var subtypes = _ref4.subtypes,
	        props = _objectWithoutProperties(_ref4, ['subtypes']);
	
	    return Array.isArray(subtypes) ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reduxForm.Field,
	            _extends({}, props, { component: _reduxFormMaterialUi.SelectField }),
	            subtypes.map(function (el) {
	                return _react2.default.createElement(_materialUi.MenuItem, { key: el.value, value: el.value, primaryText: el.label });
	            })
	        )
	    ) : null;
	});
	
	var LANGUAGES = {
	    en: 'English',
	    da: 'Danish',
	    no: 'Norwegian',
	    de: 'Deutsch',
	    fi: 'Finish',
	    th: 'Thai',
	    se: 'Swedish',
	    sc: 'Chinise simpl',
	    tc: 'Chinise trad'
	};
	
	var validateTabs = function validateTabs(val, _ref5) {
	    var template = _ref5.template;
	
	    if (template) {
	        for (var tpl in template) {
	            if (!template[tpl]) continue;else return undefined;
	        }
	    }
	    return 'Required';
	};
	
	var MessageForm = function (_Component) {
	    _inherits(MessageForm, _Component);
	
	    function MessageForm(props) {
	        _classCallCheck(this, MessageForm);
	
	        var _this = _possibleConstructorReturn(this, (MessageForm.__proto__ || Object.getPrototypeOf(MessageForm)).call(this, props));
	
	        _this.onTriggerChange = function () {
	            _this.props.change('subtype', null);
	        };
	
	        _this.handleTabChange = function (activeTab) {
	            _this.setState({ activeTab: activeTab });
	        };
	
	        _this.state = {
	            activeTab: _this.props.lang
	        };
	        return _this;
	    }
	
	    _createClass(MessageForm, [{
	        key: 'render',
	        value: function render() {
	            var activeTab = this.state.activeTab;
	
	            var supportedLanguages = _cfg2.default.supportedLanguages;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'title', floatingLabelText: 'Title', component: _reduxFormMaterialUi.TextField, validate: _validation.presence, fullWidth: true })
	                ),
	                _react2.default.createElement(
	                    TypeWrapper,
	                    null,
	                    _react2.default.createElement(
	                        _reduxForm.Field,
	                        {
	                            name: 'trigger',
	                            floatingLabelText: 'Trigger type',
	                            onChange: this.onTriggerChange,
	                            component: _reduxFormMaterialUi.SelectField,
	                            validate: _validation.presence,
	                            fullWidth: true
	                        },
	                        triggerTypesOrdered.map(function (trigger) {
	                            return _react2.default.createElement(_materialUi.MenuItem, { key: trigger, value: trigger, primaryText: (0, _humanizeString2.default)(trigger) });
	                        })
	                    ),
	                    _react2.default.createElement(SubtypeField, { name: 'subtype', floatingLabelText: 'Subtype', validate: _validation.presence, fullWidth: true })
	                ),
	                _react2.default.createElement(
	                    SectionWrapper,
	                    null,
	                    _react2.default.createElement(
	                        _reduxForm.FormSection,
	                        { name: 'template' },
	                        _react2.default.createElement(
	                            _materialUi.Tabs,
	                            { value: activeTab, onChange: this.handleTabChange },
	                            supportedLanguages.map(function (lang) {
	                                return _react2.default.createElement(
	                                    _materialUi.Tab,
	                                    { label: LANGUAGES[lang] || lang, value: lang, key: lang },
	                                    _react2.default.createElement(MessageBuilderWithTypes, {
	                                        name: lang,
	                                        validate: validateTabs,
	                                        floatingLabelText: 'Enter ' + (LANGUAGES[lang] || lang) + ' message'
	                                    })
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MessageForm;
	}(_react.Component);
	
	MessageForm.propTypes = {
	    change: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.user.props.lang
	    };
	})((0, _reduxForm.reduxForm)({ form: 'messageForm' })(MessageForm));

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RMessageBuilder = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var _EmojiPicker = __webpack_require__(1600);
	
	var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _inputs = __webpack_require__(2162);
	
	var _TypeCascade = __webpack_require__(2163);
	
	var _OddsPicker = __webpack_require__(2164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageBuilder = function (_React$PureComponent) {
	    _inherits(MessageBuilder, _React$PureComponent);
	
	    function MessageBuilder() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MessageBuilder);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageBuilder.__proto__ || Object.getPrototypeOf(MessageBuilder)).call.apply(_ref, [this].concat(args))), _this), _this.assignRef = function (el) {
	            if (el) {
	                if (el.input instanceof Node) {
	                    _this.input = el.input;
	                } else {
	                    _this.input = el.input.refs.input;
	                }
	                _this.addText = (0, _inputs.addInputText)(_this.input, _this.props.onChange);
	            }
	        }, _this.addProperty = function (property) {
	            _this.addText(_this.props.value)('${' + property + '}');
	        }, _this.onChange = function (e, value) {
	            _this.props.onChange(value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MessageBuilder, [{
	        key: 'renderTypes',
	        value: function renderTypes() {
	            var _this2 = this;
	
	            var types = this.props.types;
	
	            if (Array.isArray(types) && types.length) {
	                return types.map(function (el) {
	                    return _react2.default.createElement(
	                        _materialUi.Paper,
	                        {
	                            key: el.name,
	                            style: {
	                                display: 'inline-block',
	                                marginRight: 20
	                            }
	                        },
	                        _react2.default.createElement(_TypeCascade.TypeCascade, { type: el.type, name: el.name, label: el.label, onClick: _this2.addProperty })
	                    );
	                });
	            }
	            return null;
	        }
	    }, {
	        key: 'renderOdds',
	        value: function renderOdds() {
	            return this.props.withOdds ? _react2.default.createElement(_OddsPicker.OddsPicker, {
	                style: {
	                    margin: '0 20px 0 0'
	                },
	                onAdd: this.addProperty
	            }) : null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = _lodash2.default.omit(this.props, Object.keys(MessageBuilder.propTypes));
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexWrap: 'wrap', marginTop: 15 } },
	                    this.renderTypes(),
	                    this.renderOdds()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: 'flex-end' } },
	                    _react2.default.createElement(_materialUi.TextField, _extends({}, props, { multiLine: true, ref: this.assignRef, fullWidth: true })),
	                    _react2.default.createElement(_EmojiPicker2.default, _extends({}, props, { onChange: this.onChange, inputRef: this.input }))
	                )
	            );
	        }
	    }]);
	
	    return MessageBuilder;
	}(_react2.default.PureComponent);
	
	exports.default = MessageBuilder;
	
	
	MessageBuilder.propTypes = {
	    types: _propTypes2.default.array,
	    withOdds: _propTypes2.default.bool
	};
	
	var RMessageBuilder = exports.RMessageBuilder = function (_React$PureComponent2) {
	    _inherits(RMessageBuilder, _React$PureComponent2);
	
	    function RMessageBuilder() {
	        _classCallCheck(this, RMessageBuilder);
	
	        return _possibleConstructorReturn(this, (RMessageBuilder.__proto__ || Object.getPrototypeOf(RMessageBuilder)).apply(this, arguments));
	    }
	
	    _createClass(RMessageBuilder, [{
	        key: 'render',
	        value: function render() {
	            var userProps = _lodash2.default.omit(this.props, Object.keys(RMessageBuilder.propTypes));
	            var error = this.props.meta.touched ? this.props.meta.error : undefined;
	            return _react2.default.createElement(MessageBuilder, _extends({}, userProps, this.props.input, { errorText: error }));
	        }
	    }]);
	
	    return RMessageBuilder;
	}(_react2.default.PureComponent);
	
	RMessageBuilder.propTypes = {
	    input: _propTypes2.default.object.isRequired,
	    meta: _propTypes2.default.object.isRequired
	};

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(1599);
	
	Object.defineProperty(exports, 'addInputText', {
	  enumerable: true,
	  get: function get() {
	    return _common.addInputText;
	  }
	});

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TypeCascade = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(642);
	
	var _navigationArrowDropRight = __webpack_require__(1134);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TypeCascade = exports.TypeCascade = function (_React$PureComponent) {
	    _inherits(TypeCascade, _React$PureComponent);
	
	    function TypeCascade() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TypeCascade);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeCascade.__proto__ || Object.getPrototypeOf(TypeCascade)).call.apply(_ref, [this].concat(args))), _this), _this.renderRecursiveType = function (type) {
	            var prevPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            return Object.keys(type).sort(function (a, b) {
	                return a - b;
	            }).map(function (key) {
	                var cur = type[key];
	                var hasChildren = (typeof cur === 'undefined' ? 'undefined' : _typeof(cur)) === 'object';
	                if (hasChildren) {
	                    return _react2.default.createElement(_materialUi.MenuItem, {
	                        key: key,
	                        rightIcon: _react2.default.createElement(_navigationArrowDropRight2.default, null),
	                        primaryText: key,
	                        menuItems: _this.renderRecursiveType(cur, prevPath.concat(key))
	                    });
	                }
	                return _react2.default.createElement(_materialUi.MenuItem, {
	                    key: key,
	                    primaryText: key,
	                    onTouchTap: function onTouchTap() {
	                        var path = prevPath.concat(key);
	                        if (_this.props.onClick) {
	                            _this.props.onClick(path.join('.'), path);
	                        }
	                    }
	                });
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TypeCascade, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                name = _props.name,
	                label = _props.label;
	
	            return _react2.default.createElement(_materialUi.MenuItem, { primaryText: label || name, menuItems: this.renderRecursiveType(type, [name]) });
	        }
	    }]);
	
	    return TypeCascade;
	}(_react2.default.PureComponent);
	
	TypeCascade.propTypes = {
	    type: _propTypes2.default.object.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	};

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OddsPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _get = __webpack_require__(480);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _materialUi = __webpack_require__(642);
	
	var _common = __webpack_require__(1599);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ODD_TYPES = ['match', 'nextGoal', 'halftime'];
	
	var OddsPicker = exports.OddsPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        defaultProvider: (0, _get2.default)(state, ['user', 'props', 'oddsProvider']),
	        allowedProviders: (0, _get2.default)(state, ['user', 'props', 'allowedProviders'])
	    };
	})((_temp = _class = function (_React$PureComponent) {
	    _inherits(_class, _React$PureComponent);
	
	    function _class(props, ctx) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, ctx));
	
	        _initialiseProps.call(_this);
	
	        var defaultProvider = props.defaultProvider,
	            allowedProviders = props.allowedProviders;
	
	        var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	        var provider = defaultProvider && providers.some(function (p) {
	            return p.id === defaultProvider;
	        }) ? defaultProvider : null;
	        _this.state = {
	            provider: provider,
	            providers: providers,
	            popoverOpen: false,
	            popoverElement: null,
	            oddType: null,
	            isOptional: false,
	            defaultText: ''
	        };
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var allowedProviders = _ref.allowedProviders;
	
	            if (this.props.allowedProviders !== allowedProviders) {
	                var providers = (0, _common.getProviders)((0, _helpers.safeParse)(allowedProviders));
	                this.setState({ providers: providers });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                popoverElement = _state.popoverElement,
	                popoverOpen = _state.popoverOpen,
	                provider = _state.provider,
	                oddType = _state.oddType,
	                isOptional = _state.isOptional,
	                defaultText = _state.defaultText;
	            var _props$style = this.props.style,
	                style = _props$style === undefined ? {} : _props$style;
	
	            var canSave = oddType && provider;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _materialUi.Paper,
	                    {
	                        style: _extends({
	                            display: 'inline-block',
	                            margin: '16px 32px 16px 0'
	                        }, style)
	                    },
	                    _react2.default.createElement(
	                        _materialUi.MenuItem,
	                        { onTouchTap: this.openPopover },
	                        'Odds'
	                    )
	                ),
	                _react2.default.createElement(
	                    _materialUi.Popover,
	                    { open: popoverOpen, anchorEl: popoverElement, onRequestClose: this.closePopover },
	                    _react2.default.createElement(
	                        _materialUi.Paper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: 16 } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _materialUi.SelectField,
	                                    {
	                                        floatingLabelText: 'Provider',
	                                        value: provider,
	                                        onChange: function onChange(event, index, value) {
	                                            return _this2.setState({ provider: value });
	                                        }
	                                    },
	                                    this.state.providers.map(function (provider) {
	                                        return _react2.default.createElement(_materialUi.MenuItem, {
	                                            value: provider.id,
	                                            key: provider.id,
	                                            primaryText: provider.name
	                                        });
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _materialUi.SelectField,
	                                    {
	                                        value: oddType,
	                                        floatingLabelText: 'Odd type',
	                                        onChange: function onChange(event, index, value) {
	                                            return _this2.setState({ oddType: value });
	                                        }
	                                    },
	                                    ODD_TYPES.map(function (type) {
	                                        return _react2.default.createElement(_materialUi.MenuItem, { primaryText: type, key: type, value: type });
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_materialUi.Toggle, {
	                                    label: 'Optional',
	                                    toggled: isOptional,
	                                    onToggle: function onToggle(e, value) {
	                                        return _this2.setState({ isOptional: value });
	                                    }
	                                }),
	                                _react2.default.createElement(_materialUi.TextField, {
	                                    disabled: !isOptional,
	                                    value: defaultText,
	                                    onChange: function onChange(e, value) {
	                                        return _this2.setState({ defaultText: value });
	                                    },
	                                    floatingLabelText: 'Default text'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_materialUi.FlatButton, { primary: true, disabled: !canSave, label: 'Add', onTouchTap: this.onAdd })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.PureComponent), _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.openPopover = function (event) {
	        _this3.setState({
	            popoverOpen: true,
	            popoverElement: event.target
	        });
	    };
	
	    this.closePopover = function () {
	        _this3.setState({ popoverOpen: false });
	    };
	
	    this.onAdd = function () {
	        var onAdd = _this3.props.onAdd;
	        var _state2 = _this3.state,
	            oddType = _state2.oddType,
	            isOptional = _state2.isOptional,
	            defaultText = _state2.defaultText,
	            provider = _state2.provider;
	
	        var value = 'odds.' + oddType + '|provider=' + provider + (isOptional ? '|default=' + defaultText : '');
	        onAdd(value);
	        _this3.closePopover();
	    };
	}, _temp));
	
	OddsPicker.propTypes = {
	    onAdd: _propTypes2.default.func.isRequired
	};

/***/ },
/* 2165 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var getType = exports.getType = function getType(obj) {
	    if (!obj) {
	        return null;
	    }
	    return Object.keys(obj).reduce(function (acc, cur) {
	        var type = _typeof(obj[cur]);
	        var isArray = Array.isArray(obj[cur]);
	        if (type === 'object' && !isArray) {
	            acc[cur] = getType(obj[cur]);
	        } else if (!isArray) {
	            acc[cur] = type;
	        }
	        return acc;
	    }, {});
	};
	
	var EventType = exports.EventType = {
	    statusFull: 'string',
	    fullName: 'string',
	    shortName: 'string',
	    fullScore: 'string',
	    homeName: 'string',
	    awayName: 'string',
	    homeShortName: 'string',
	    awayShortName: 'string',
	    country: 'string',
	    tournamentName: 'string',
	    tournamentYear: 'string',
	    sport: 'string',
	    score: { home: 'string', away: 'string' },
	    properties: {
	        round: 'string',
	        venueName: 'string'
	    }
	};
	
	var TournamentType = exports.TournamentType = {
	    name: 'string',
	    gender: 'string',
	    countryName: 'string',
	    currentRound: 'string',
	    currentSeason: { id: 'number', year: 'string' }
	};
	
	var IncidentType = exports.IncidentType = {
	    min: 'number',
	    type: 'string',
	    subtype: 'string',
	    teamName: 'string',
	    participantName: 'string'
	};

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n\n    span {\n        padding: 0 2px;\n        overflow: hidden;\n        border-radius: 50%;\n    }\n'], ['\n    display: flex;\n    justify-content: center;\n\n    span {\n        padding: 0 2px;\n        overflow: hidden;\n        border-radius: 50%;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    h4 {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n'], ['\n    h4 {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n\n    p {\n        flex-grow: 1;\n    }\n'], ['\n    display: flex;\n\n    p {\n        flex-grow: 1;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    li {\n        margin-bottom: 12px;\n    }\n'], ['\n    li {\n        margin-bottom: 12px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _reduxForm = __webpack_require__(342);
	
	var _humanizeString = __webpack_require__(1518);
	
	var _humanizeString2 = _interopRequireDefault(_humanizeString);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _MessageForm = __webpack_require__(2160);
	
	var _MessageForm2 = _interopRequireDefault(_MessageForm);
	
	var _SubmitButton = __webpack_require__(2167);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _actions = __webpack_require__(1863);
	
	var _materialUi = __webpack_require__(642);
	
	var _IconMenu = __webpack_require__(900);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _Table = __webpack_require__(988);
	
	var _warning = __webpack_require__(1109);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _delete = __webpack_require__(1104);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _modeEdit = __webpack_require__(1383);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var EditMessage = (0, _reduxForm.reduxForm)({
	    form: 'editMessage',
	    asyncBlurFields: [],
	    onSubmit: function onSubmit(values, dispatch, self) {
	        var onSuccess = function onSuccess(response) {
	            var onSubmitSucceed = self.onSubmitSucceed;
	
	            if (onSubmitSucceed) {
	                onSubmitSucceed(response);
	            }
	        };
	
	        if (values.template) {
	            for (var key in values.template) {
	                if (values.template[key] === '') Reflect.deleteProperty(values.template, key);
	            }
	        }
	
	        return dispatch((0, _actions.updateMessage)(values)).then(onSuccess);
	    }
	})(_MessageForm2.default);
	
	var LANGUAGES = {
	    en: 'English',
	    da: 'Danish',
	    no: 'Norwegian',
	    de: 'Deutsch',
	    fi: 'Finish',
	    th: 'Thai',
	    se: 'Swedish',
	    sc: 'Chinise simpl',
	    tc: 'Chinise trad'
	};
	
	var columnWidth = {
	    column2: 220,
	    column3: 190,
	    column4: 150,
	    column5: 60
	};
	
	var LanguagesWrapper = _styledComponents2.default.div(_templateObject);
	
	var PreviewWrapper = _styledComponents2.default.div(_templateObject2);
	var PreviewWrapperTrigger = _styledComponents2.default.div(_templateObject3);
	
	var PreviewList = _styledComponents2.default.ul(_templateObject4);
	
	var MessagePreviewRow = (0, _reactRedux.connect)(function (state, _ref) {
	    var id = _ref.id;
	    return {
	        message: _lodash2.default.get(state.requery.entities, ['messageTemplates', id])
	    };
	}, function (dispatch, _ref2) {
	    var id = _ref2.id;
	    return {
	        deleteMessage: function deleteMessage() {
	            return dispatch((0, _actions.deleteMessage)(id));
	        },
	        initializeEdit: function initializeEdit(message) {
	            return dispatch((0, _reduxForm.initialize)('editMessage', message));
	        }
	    };
	})(function (_Component) {
	    _inherits(_MessagePreviewRow, _Component);
	
	    function _MessagePreviewRow() {
	        var _ref3;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _MessagePreviewRow);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = _MessagePreviewRow.__proto__ || Object.getPrototypeOf(_MessagePreviewRow)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
	            deleteDialogOpen: false,
	            editDialogOpen: false,
	            previewDialogOpen: false,
	            displayDialogs: false,
	            iconMenuOpen: false
	        }, _this.displayDialogs = function () {
	            _this.setState({ previewDialogOpen: false, displayDialogs: true });
	        }, _this.toggleOpenIconMenu = function () {
	            return _this.setState({ iconMenuOpen: !_this.state.iconMenuOpen });
	        }, _this.toggleOpenDeleteDialog = function () {
	            return _this.setState({ deleteDialogOpen: !_this.state.deleteDialogOpen, iconMenuOpen: false });
	        }, _this.toggleOpenPreviewDialog = function () {
	            return _this.setState({ previewDialogOpen: !_this.state.previewDialogOpen, iconMenuOpen: false });
	        }, _this.openEditDialog = function () {
	            _this.setState({ editDialogOpen: true, iconMenuOpen: false });
	            _this.props.initializeEdit(_this.props.message);
	        }, _this.closeEditDialog = function () {
	            _this.setState({ editDialogOpen: false });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_MessagePreviewRow, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                displayDialogs = _state.displayDialogs,
	                deleteDialogOpen = _state.deleteDialogOpen,
	                editDialogOpen = _state.editDialogOpen,
	                previewDialogOpen = _state.previewDialogOpen,
	                iconMenuOpen = _state.iconMenuOpen;
	            var _props = this.props,
	                message = _props.message,
	                deleteMessage = _props.deleteMessage;
	
	
	            if (!message) {
	                return null;
	            }
	
	            var template = message.template,
	                trigger = message.trigger,
	                title = message.title,
	                subtype = message.subtype;
	
	
	            var tableProps = _extends({}, this.props);
	            Reflect.deleteProperty(tableProps, 'message');
	            Reflect.deleteProperty(tableProps, 'deleteMessage');
	            Reflect.deleteProperty(tableProps, 'initializeEdit');
	
	            var languages = _lodash2.default.isObject(template) ? Object.keys(template).sort() : [];
	
	            return _react2.default.createElement(
	                _Table.TableRow,
	                tableProps,
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { onTouchTap: this.toggleOpenPreviewDialog },
	                    title
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { onTouchTap: this.toggleOpenPreviewDialog, style: { width: columnWidth.column2 } },
	                    (0, _humanizeString2.default)(trigger)
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { onTouchTap: this.toggleOpenPreviewDialog, style: { width: columnWidth.column3 } },
	                    subtype
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                        onTouchTap: this.toggleOpenPreviewDialog,
	                        style: {
	                            width: columnWidth.column4,
	                            textAlign: 'center'
	                        }
	                    },
	                    _react2.default.createElement(
	                        LanguagesWrapper,
	                        null,
	                        languages.map(function (lang) {
	                            return _react2.default.createElement(
	                                'span',
	                                { key: lang },
	                                lang
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    {
	                        style: {
	                            width: columnWidth.column5,
	                            paddingLeft: 6,
	                            paddingRight: 6
	                        }
	                    },
	                    _react2.default.createElement(
	                        _IconMenu2.default,
	                        {
	                            open: iconMenuOpen,
	                            onRequestChange: this.toggleOpenIconMenu,
	                            iconButtonElement: _react2.default.createElement(
	                                _materialUi.IconButton,
	                                null,
	                                _react2.default.createElement(_moreVert2.default, null)
	                            ),
	                            onTouchTap: this.displayDialogs
	                        },
	                        _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', leftIcon: _react2.default.createElement(_modeEdit2.default, null), onTouchTap: this.openEditDialog }),
	                        _react2.default.createElement(_materialUi.MenuItem, {
	                            primaryText: 'Delete',
	                            leftIcon: _react2.default.createElement(_delete2.default, null),
	                            onTouchTap: this.toggleOpenDeleteDialog
	                        })
	                    )
	                ),
	                displayDialogs && _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        open: deleteDialogOpen,
	                        onRequestClose: this.toggleOpenDeleteDialog,
	                        title: title,
	                        actions: [_react2.default.createElement(_materialUi.RaisedButton, {
	                            key: 'Yes, delete',
	                            secondary: true,
	                            onTouchTap: deleteMessage,
	                            label: 'Yes, delete'
	                        }), _react2.default.createElement(_materialUi.FlatButton, { key: 'No', onTouchTap: this.toggleOpenDeleteDialog, label: 'No' })]
	                    },
	                    'Are you sure you want to delete message template `',
	                    title,
	                    '`?'
	                ),
	                ',',
	                displayDialogs && _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        open: editDialogOpen,
	                        onRequestClose: this.closeEditDialog,
	                        autoScrollBodyContent: true,
	                        autoDetectWindowHeight: true,
	                        title: title,
	                        actions: [_react2.default.createElement(_SubmitButton2.default, { key: 'Update', secondary: true, form: 'editMessage', label: 'Update' }), _react2.default.createElement(_materialUi.FlatButton, {
	                            key: 'Cancel',
	                            secondary: true,
	                            onTouchTap: this.closeEditDialog,
	                            label: 'Cancel',
	                            style: { marginLeft: 5 }
	                        })]
	                    },
	                    _react2.default.createElement(EditMessage, { onSubmitSuccess: this.closeEditDialog })
	                ),
	                _react2.default.createElement(
	                    _materialUi.Dialog,
	                    {
	                        open: previewDialogOpen,
	                        onRequestClose: this.toggleOpenPreviewDialog,
	                        autoScrollBodyContent: true,
	                        autoDetectWindowHeight: true,
	                        title: title,
	                        actions: [_react2.default.createElement(_materialUi.RaisedButton, {
	                            key: 'Edit',
	                            primary: true,
	                            onTouchTap: function onTouchTap() {
	                                _this2.setState({ previewDialogOpen: false, displayDialogs: true });
	                                _this2.openEditDialog();
	                            },
	                            label: 'Edit'
	                        }), _react2.default.createElement(_materialUi.FlatButton, {
	                            key: 'Cancel',
	                            secondary: true,
	                            onTouchTap: this.toggleOpenPreviewDialog,
	                            label: 'Cancel',
	                            style: { marginLeft: 5 }
	                        })]
	                    },
	                    _react2.default.createElement(
	                        PreviewWrapper,
	                        null,
	                        _react2.default.createElement(
	                            PreviewWrapperTrigger,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'Trigger:'
	                                ),
	                                ' ',
	                                (0, _humanizeString2.default)(trigger)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'Trigger subtype:'
	                                ),
	                                ' ',
	                                subtype
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Text messages:'
	                        ),
	                        _react2.default.createElement(
	                            PreviewList,
	                            null,
	                            languages.map(function (lang) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: lang },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        LANGUAGES[lang] || lang,
	                                        ': '
	                                    ),
	                                    template[lang]
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return _MessagePreviewRow;
	}(_react.Component));
	
	var MessageList = function (_PureComponent) {
	    _inherits(MessageList, _PureComponent);
	
	    function MessageList() {
	        _classCallCheck(this, MessageList);
	
	        return _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).apply(this, arguments));
	    }
	
	    _createClass(MessageList, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                items = _props2.items,
	                responseStatus = _props2.responseStatus,
	                isFinished = _props2.isFinished;
	
	
	            if (!isFinished) {
	                return _react2.default.createElement(_materialUi.LinearProgress, null);
	            }
	
	            var isOk = responseStatus === 200;
	
	            if (!isOk) {
	                return _react2.default.createElement(
	                    _materialUi.CardText,
	                    {
	                        style: {
	                            display: 'flex',
	                            alignItems: 'center',
	                            flexDirection: 'column'
	                        }
	                    },
	                    _react2.default.createElement(_warning2.default, null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Error while fetching messages'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Status code: ',
	                        responseStatus
	                    )
	                );
	            }
	
	            if (!(Array.isArray(items) && items.length)) {
	                return _react2.default.createElement(
	                    _materialUi.CardText,
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Nothing found'
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _Table.Table,
	                { fixedHeader: true, selectable: false, hoverable: false, height: '80vh' },
	                _react2.default.createElement(
	                    _Table.TableHeader,
	                    {
	                        displaySelectAll: false,
	                        adjustForCheckbox: false,
	                        enableSelectAll: false,
	                        style: { backgroundColor: _colors.grey50 }
	                    },
	                    _react2.default.createElement(
	                        _Table.TableRow,
	                        null,
	                        _react2.default.createElement(
	                            _Table.TableHeaderColumn,
	                            null,
	                            'Title'
	                        ),
	                        _react2.default.createElement(
	                            _Table.TableHeaderColumn,
	                            { style: { width: columnWidth.column2 } },
	                            'Trigger'
	                        ),
	                        _react2.default.createElement(
	                            _Table.TableHeaderColumn,
	                            { style: { width: columnWidth.column3 } },
	                            'Trigger subtype'
	                        ),
	                        _react2.default.createElement(
	                            _Table.TableHeaderColumn,
	                            { style: { width: columnWidth.column4, textAlign: 'center' } },
	                            'Languages'
	                        ),
	                        _react2.default.createElement(_Table.TableHeaderColumn, { style: { width: columnWidth.column5 } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Table.TableBody,
	                    { displayRowCheckbox: false, showRowHover: false, deselectOnClickaway: false },
	                    items.map(function (id) {
	                        return _react2.default.createElement(MessagePreviewRow, { key: id, id: id });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MessageList;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function (_ref4, _ref5) {
	    var requery = _ref4.requery;
	    var trigger = _ref5.trigger;
	
	    var listKey = 'messageTemplates' + (trigger ? '/' + trigger : '');
	    var queryKey = 'GET:messageTemplates' + (trigger ? '/' + trigger : '');
	
	    return {
	        items: requery.list[listKey],
	        isFinished: _lodash2.default.get(requery.queries, [queryKey, 'isFinished']),
	        responseStatus: _lodash2.default.get(requery.queries, [queryKey, 'status'])
	    };
	})(MessageList);

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _materialUi = __webpack_require__(642);
	
	var _reduxForm = __webpack_require__(342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SubmitButton = function SubmitButton(_ref) {
	    var submit = _ref.submit,
	        submitting = _ref.submitting,
	        form = _ref.form,
	        props = _objectWithoutProperties(_ref, ['submit', 'submitting', 'form']);
	
	    return _react2.default.createElement(_materialUi.RaisedButton, _extends({}, props, {
	        disabled: submitting,
	        icon: submitting ? _react2.default.createElement(_materialUi.CircularProgress, { size: 20, thickness: 2.5 }) : undefined,
	        onTouchTap: function onTouchTap() {
	            return submit(form);
	        }
	    }));
	};
	
	SubmitButton.propTypes = {
	    form: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (state, _ref2) {
	    var form = _ref2.form;
	    return {
	        disabled: (0, _reduxForm.isInvalid)(form)(state),
	        submitting: (0, _reduxForm.isSubmitting)(form)(state)
	    };
	}, function (dispatch) {
	    return { submit: function submit(form) {
	            return dispatch((0, _reduxForm.submit)(form));
	        } };
	})(SubmitButton);

/***/ },
/* 2168 */,
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _lodash = __webpack_require__(339);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materialUi = __webpack_require__(642);
	
	var _reactRouter = __webpack_require__(188);
	
	var _events = __webpack_require__(1058);
	
	var _EventCell = __webpack_require__(1692);
	
	var _EventCell2 = _interopRequireDefault(_EventCell);
	
	var _moment = __webpack_require__(619);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _code = __webpack_require__(1032);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TournamentHomeSMB = function (_React$Component) {
	    _inherits(TournamentHomeSMB, _React$Component);
	
	    function TournamentHomeSMB(props, context) {
	        _classCallCheck(this, TournamentHomeSMB);
	
	        var _this = _possibleConstructorReturn(this, (TournamentHomeSMB.__proto__ || Object.getPrototypeOf(TournamentHomeSMB)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                fetchLatestEventsForStage = _this$props.fetchLatestEventsForStage,
	                params = _this$props.params;
	
	
	            dispatch(fetchLatestEventsForStage(params.stageId));
	            dispatch((0, _events.fetchComingEventsForStage)(params.stageId));
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                fetchLatestEventsForStage = _this$props2.fetchLatestEventsForStage,
	                params = _this$props2.params;
	
	
	            if (+_this.props.params.stageId !== +nextProps.params.stageId) {
	                dispatch(fetchLatestEventsForStage(+nextProps.params.stageId));
	                dispatch((0, _events.fetchComingEventsForStage)(+nextProps.params.stageId));
	            }
	        };
	
	        return _this;
	    }
	
	    _createClass(TournamentHomeSMB, [{
	        key: 'renderRoundSelect',
	        value: function renderRoundSelect() {
	            var _props = this.props,
	                _props$params = _props.params,
	                tournamentId = _props$params.tournamentId,
	                seasonId = _props$params.seasonId,
	                sport = _props$params.sport,
	                stageId = _props$params.stageId,
	                round = _props$params.round,
	                tournament = _props.tournament,
	                stage = _props.stage,
	                stages = _props.stages,
	                _props$events = _props.events,
	                events = _props$events === undefined ? [] : _props$events,
	                _props$comingEvents = _props.comingEvents,
	                comingEvents = _props$comingEvents === undefined ? [] : _props$comingEvents;
	
	
	            if (stage.roundsList.length < 2) return;
	
	            var currentRound = _lodash2.default.find(stage.roundsList, function (r) {
	                return r.isCurrent;
	            });
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    _materialUi.IconMenu,
	                    {
	                        style: { marginLeft: 15 },
	                        desktop: true,
	                        iconButtonElement: _react2.default.createElement(_materialUi.FlatButton, {
	                            label: round ? 'Round ' + round : 'Select round',
	                            labelPosition: 'after',
	                            icon: _react2.default.createElement(_code2.default, null),
	                            primary: true
	                        }),
	                        autoWidth: true,
	                        onChange: function onChange(event, value) {
	                            if (value === null) {
	                                _reactRouter.browserHistory.push('/sm/browser/' + sport + '/tournaments/' + tournamentId + '/' + seasonId + '/stages/' + stageId);
	                            } else {
	                                _reactRouter.browserHistory.push('/sm/browser/' + sport + '/tournaments/' + tournamentId + '/' + seasonId + '/stages/' + stageId + '/rounds/' + encodeURIComponent(value));
	                            }
	                        },
	                        value: round || null
	                    },
	                    _react2.default.createElement(_materialUi.MenuItem, { key: 'all', value: null, primaryText: 'All Rounds' }),
	                    _lodash2.default.sortBy(stage.roundsList, function (r) {
	                        return +r.name;
	                    }).map(function (r) {
	                        return _react2.default.createElement(_materialUi.MenuItem, { key: r.name, value: r.name, primaryText: r.name });
	                    })
	                ),
	                currentRound && round + '' !== currentRound.name + '' && _react2.default.createElement(_materialUi.FlatButton, {
	                    href: '/sm/browser/' + sport + '/tournaments/' + tournamentId + '/' + seasonId + '/stages/' + stageId + '/rounds/' + encodeURIComponent(currentRound.name),
	                    label: 'Go to current round (' + currentRound.name + ')',
	                    labelPosition: 'after',
	                    primary: true
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                _props2$params = _props2.params,
	                tournamentId = _props2$params.tournamentId,
	                seasonId = _props2$params.seasonId,
	                sport = _props2$params.sport,
	                stageId = _props2$params.stageId,
	                tournament = _props2.tournament,
	                stage = _props2.stage,
	                stages = _props2.stages,
	                _props2$events = _props2.events,
	                events = _props2$events === undefined ? [] : _props2$events,
	                _props2$comingEvents = _props2.comingEvents,
	                comingEvents = _props2$comingEvents === undefined ? [] : _props2$comingEvents;
	
	
	            if (!stage) return _react2.default.createElement('div', null);
	            var currentRound = _lodash2.default.find(stage.roundsList, function (r) {
	                return r.isCurrent;
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { marginBottom: 0 } },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/sm/browser/' + sport + '/tournaments/' + tournamentId + '/' + seasonId + '/stages/' + stageId },
	                            stage && stage.name
	                        ),
	                        this.renderRoundSelect()
	                    )
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return TournamentHomeSMB;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	    var ids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchLatestEventsForStageKey)(props.params.stageId) + ']', []);
	    var cids = _lodash2.default.get(state, 'query.entities[' + (0, _events.fetchComingEventsForStageKey)(props.params.stageId) + ']', []);
	
	    var events = _lodash2.default.get(state, 'query.entities.events', []);
	
	    return {
	        events: ids.map(function (id) {
	            return events[id];
	        }),
	        comingEvents: cids.map(function (id) {
	            return events[id];
	        }),
	        tournament: _lodash2.default.get(state.smBrowser, 'tournament'),
	        stages: _lodash2.default.get(state.smBrowser, 'season.stages', []),
	        stage: _lodash2.default.chain(state.smBrowser).get('season.stages', []).find(function (s) {
	            return +s.id === +props.params.stageId;
	        }).value()
	    };
	}, function (dispatch) {
	    return {
	        dispatch: dispatch,
	        fetchLatestEventsForStage: _events.fetchLatestEventsForStage,
	        fetchComingEventsForStage: _events.fetchComingEventsForStage
	    };
	})(TournamentHomeSMB);

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: red;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    color: red;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n'], ['\n    display: flex;\n    align-items: center;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n'], ['\n    flex-grow: 1;\n    color: ', ';\n    font-weight: inherit;\n\n    svg {\n        margin-right: 10px;\n        transform: translate(0, 4px);\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    display: inline-block;\n    flex-grow: 1;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n'], ['\n    display: inline-block;\n    flex-grow: 1;\n    text-align: right;\n\n    button {\n        color: #fff;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(250);
	
	var _Card = __webpack_require__(843);
	
	var _star = __webpack_require__(1113);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(910);
	
	var _index = __webpack_require__(2171);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InterestsTable = __webpack_require__(2175);
	
	var _InterestsTable2 = _interopRequireDefault(_InterestsTable);
	
	var _DeleteDialog = __webpack_require__(2179);
	
	var _DeleteDialog2 = _interopRequireDefault(_DeleteDialog);
	
	var _actions = __webpack_require__(1094);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _helpers = __webpack_require__(592);
	
	var _CircularProgress = __webpack_require__(861);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// import PropTypes from 'prop-types';
	
	// import { Link } from 'react-router';
	// import RaisedButton from 'material-ui/RaisedButton';
	// import CircularProgress from 'material-ui/CircularProgress';
	// import CreateDialog from '../../packs/components/CreateDialog';
	
	// import CalendarContent from '../../calendar-page/components/CalendarContent';
	
	
	var Loader = _styledComponents2.default.div(_templateObject);
	
	var ErrorText = _styledComponents2.default.h3(_templateObject2);
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject3);
	
	var Title = _styledComponents2.default.h2(_templateObject4, _colors.indigo500);
	
	var ButtonWrapper = _styledComponents2.default.div(_templateObject5);
	
	var CardStyle = {
	    marginBottom: 15
	};
	
	var CardHeaderStyle = {
	    borderBottom: '1px solid ' + _colors.grey300,
	    paddingTop: 0,
	    paddingBottom: 0
	};
	
	var CardTextStyle = {
	    padding: 0
	};
	
	var IconPacksStyle = {
	    color: 'inherit'
	};
	
	var InterestsPage = function (_PureComponent) {
	    _inherits(InterestsPage, _PureComponent);
	
	    function InterestsPage() {
	        _classCallCheck(this, InterestsPage);
	
	        return _possibleConstructorReturn(this, (InterestsPage.__proto__ || Object.getPrototypeOf(InterestsPage)).apply(this, arguments));
	    }
	
	    _createClass(InterestsPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchInterests();
	            this.props.fetchTournaments();
	            this.props.fetchTeams();
	        }
	    }, {
	        key: 'onOpenAddInterestDialog',
	        value: function onOpenAddInterestDialog() {
	            (0, _helpers.addToQuery)('addInterestDialog', 'newInterest');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Card.Card,
	                { style: CardStyle },
	                _react2.default.createElement(
	                    _Card.CardHeader,
	                    { style: CardHeaderStyle },
	                    _react2.default.createElement(
	                        HeaderWrapper,
	                        null,
	                        _react2.default.createElement(
	                            Title,
	                            null,
	                            _react2.default.createElement(_star2.default, { style: IconPacksStyle }),
	                            'Interests'
	                        ),
	                        _react2.default.createElement(
	                            ButtonWrapper,
	                            null,
	                            _react2.default.createElement(
	                                _RaisedButton2.default,
	                                { onClick: this.onOpenAddInterestDialog, secondary: true, labelColor: '#fff' },
	                                'Create'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Card.CardText,
	                    { style: CardTextStyle },
	                    !this.props.isFinishedFetchInterests && _react2.default.createElement(
	                        Loader,
	                        null,
	                        _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 })
	                    ),
	                    this.props.isFinishedFetchInterests && this.props.responseStatusFetchInterests !== 200 ? _react2.default.createElement(
	                        ErrorText,
	                        null,
	                        'An error occurred while saving, refresh the page, or try again later!'
	                    ) : _react2.default.createElement(_InterestsTable2.default, null)
	                ),
	                _react2.default.createElement(_DeleteDialog2.default, null),
	                _react2.default.createElement(_index2.default, null)
	            );
	        }
	    }]);
	
	    return InterestsPage;
	}(_react.PureComponent);
	
	InterestsPage.propTypes = {
	    isFinishedFetchInterests: _propTypes2.default.bool,
	    responseStatusFetchInterests: _propTypes2.default.number,
	    fetchInterests: _propTypes2.default.func.isRequired,
	    fetchTournaments: _propTypes2.default.func.isRequired,
	    fetchTeams: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref) {
	    var _ref$requery = _ref.requery,
	        requery = _ref$requery === undefined ? { queries: {} } : _ref$requery;
	    return {
	        isFinishedFetchInterests: requery.queries['GET:userInterests'] && requery.queries['GET:userInterests'].isFinished,
	        responseStatusFetchInterests: requery.queries['GET:userInterests'] && requery.queries['GET:userInterests'].status
	    };
	}, { fetchInterests: _actions.fetchInterests, fetchTournaments: _actions.fetchTournaments, fetchTeams: _actions.fetchTeams })(InterestsPage);

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n\n    & > * {\n        flex-basis: calc(50% - 15px);\n        width: calc(50% - 15px);\n        max-width: calc(50% - 15px);\n    }\n'], ['\n    display: flex;\n    justify-content: space-between;\n\n    & > * {\n        flex-basis: calc(50% - 15px);\n        width: calc(50% - 15px);\n        max-width: calc(50% - 15px);\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1094);
	
	var _helpers = __webpack_require__(592);
	
	var _pickerWrapperHOC = __webpack_require__(2172);
	
	var _pickerWrapperHOC2 = _interopRequireDefault(_pickerWrapperHOC);
	
	var _InputTitleInterest = __webpack_require__(2173);
	
	var _InputTitleInterest2 = _interopRequireDefault(_InputTitleInterest);
	
	var _TournamentPicker = __webpack_require__(1136);
	
	var _TournamentPicker2 = _interopRequireDefault(_TournamentPicker);
	
	var _TeamPicker = __webpack_require__(1133);
	
	var _TeamPicker2 = _interopRequireDefault(_TeamPicker);
	
	var _FlatButton = __webpack_require__(869);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _AddedItemsList = __webpack_require__(2174);
	
	var _AddedItemsList2 = _interopRequireDefault(_AddedItemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AddedItemsListWrapper = _styledComponents2.default.div(_templateObject);
	
	var TournamentPickerInterest = (0, _pickerWrapperHOC2.default)(_TournamentPicker2.default, 'tournament');
	var TeamPickerInterest = (0, _pickerWrapperHOC2.default)(_TeamPicker2.default, 'teamIds');
	
	var AddInterestFormDialog = function (_Component) {
	    _inherits(AddInterestFormDialog, _Component);
	
	    function AddInterestFormDialog() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AddInterestFormDialog);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddInterestFormDialog.__proto__ || Object.getPrototypeOf(AddInterestFormDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            name: _this.props.interest.name !== undefined ? _this.props.interest.name : '',
	            ttIds: _this.props.interest.ttIds !== undefined ? new Set(_this.props.interest.ttIds) : new Set(),
	            teamIds: _this.props.interest.teamIds !== undefined ? new Set(_this.props.interest.teamIds) : new Set(),
	            loading: false,
	            error: false
	        }, _this.handleClose = function () {
	            _this.setState({
	                name: '',
	                ttIds: new Set(),
	                teamIds: new Set()
	            });
	            (0, _helpers.removeFromQuery)('addInterestDialog');
	        }, _this.setInterestName = function (_ref2) {
	            var target = _ref2.target;
	
	            _this.setState({ name: target.value });
	        }, _this.onClickSaveBtnPicker = function (type) {
	            return function (value) {
	                _this.setState(function (state) {
	                    return _defineProperty({}, type, new Set(state[type].add(value)));
	                });
	            };
	        }, _this.handleDeleteItem = function (type) {
	            return function (value) {
	                return function () {
	                    _this.setState(function (state) {
	                        var newState = new Set(state[type]);
	                        newState.delete(value);
	
	                        return _defineProperty({}, type, new Set(newState));
	                    });
	                };
	            };
	        }, _this.onSaveForm = function () {
	            if (_this.props.interestId !== 'newInterest') {
	                _this.props.putInterest(_this.props.interestId, {
	                    name: _this.state.name,
	                    ttIds: [].concat(_toConsumableArray(_this.state.ttIds)),
	                    teamIds: [].concat(_toConsumableArray(_this.state.teamIds))
	                });
	            } else {
	                _this.props.postInterest({
	                    name: _this.state.name,
	                    ttIds: [].concat(_toConsumableArray(_this.state.ttIds)),
	                    teamIds: [].concat(_toConsumableArray(_this.state.teamIds))
	                });
	            }
	
	            _this.handleClose();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AddInterestFormDialog, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref5) {
	            var interest = _ref5.interest;
	
	            if (interest.name !== this.props.interest.name || interest.ttIds.toString() !== this.props.interest.ttIds.toString() || interest.teamIds.toString() !== this.props.interest.teamIds.toString()) {
	                this.setState({
	                    name: interest.name !== undefined ? interest.name : '',
	                    ttIds: interest.ttIds !== undefined ? new Set(interest.ttIds) : new Set(),
	                    teamIds: interest.teamIds !== undefined ? new Set(interest.teamIds) : new Set()
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$open = _props.open,
	                open = _props$open === undefined ? false : _props$open,
	                _props$interestId = _props.interestId,
	                interestId = _props$interestId === undefined ? '' : _props$interestId,
	                _props$tournaments = _props.tournaments,
	                tournaments = _props$tournaments === undefined ? {} : _props$tournaments,
	                _props$teams = _props.teams,
	                teams = _props$teams === undefined ? {} : _props$teams;
	            var _state = this.state,
	                _state$name = _state.name,
	                name = _state$name === undefined ? '' : _state$name,
	                _state$ttIds = _state.ttIds,
	                ttIds = _state$ttIds === undefined ? new Set() : _state$ttIds,
	                _state$teamIds = _state.teamIds,
	                teamIds = _state$teamIds === undefined ? new Set() : _state$teamIds,
	                _state$loading = _state.loading,
	                loading = _state$loading === undefined ? false : _state$loading,
	                _state$error = _state.error,
	                error = _state$error === undefined ? false : _state$error;
	
	
	            var actions = [_react2.default.createElement(_FlatButton2.default, { key: 'Cancel', label: 'Cancel', secondary: true, onClick: this.handleClose }), _react2.default.createElement(_FlatButton2.default, {
	                key: 'Submit',
	                label: interestId === 'newInterest' ? 'Submit' : 'Edit',
	                primary: true,
	                disabled: !name || (ttIds.size || teamIds.size) === 0,
	                onClick: this.onSaveForm
	            })];
	
	            return _react2.default.createElement(
	                _Dialog2.default,
	                {
	                    title: interestId === 'newInterest' ? 'New interest' : 'Edit interest',
	                    actions: actions,
	                    modal: false,
	                    open: open,
	                    onRequestClose: this.handleClose,
	                    autoScrollBodyContent: true
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    loading && _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Loading'
	                    ),
	                    error && _react2.default.createElement(
	                        'h1',
	                        { style: { color: 'red' } },
	                        'Error'
	                    ),
	                    _react2.default.createElement(_InputTitleInterest2.default, { value: name, onSave: this.setInterestName }),
	                    (Boolean(ttIds.size) || Boolean(teamIds.size)) && _react2.default.createElement(
	                        AddedItemsListWrapper,
	                        null,
	                        Boolean(ttIds.size) && _react2.default.createElement(_AddedItemsList2.default, {
	                            title: 'Tournaments: ',
	                            itemIdList: [].concat(_toConsumableArray(ttIds)),
	                            mapItems: tournaments,
	                            handleDeleteItem: this.handleDeleteItem('ttIds')
	                        }),
	                        Boolean(teamIds.size) && _react2.default.createElement(_AddedItemsList2.default, {
	                            title: 'Teams: ',
	                            itemIdList: [].concat(_toConsumableArray(teamIds)),
	                            mapItems: teams,
	                            handleDeleteItem: this.handleDeleteItem('teamIds')
	                        })
	                    ),
	                    _react2.default.createElement(TournamentPickerInterest, { hideSeasonPicker: true, onClickSaveBtn: this.onClickSaveBtnPicker('ttIds') }),
	                    _react2.default.createElement(TeamPickerInterest, { onClickSaveBtn: this.onClickSaveBtnPicker('teamIds') })
	                )
	            );
	        }
	    }]);
	
	    return AddInterestFormDialog;
	}(_react.Component);
	
	AddInterestFormDialog.defaultProps = {
	    interestId: 'newInterest',
	    interest: {
	        name: '',
	        ttIds: [],
	        teamIds: []
	    }
	};
	
	AddInterestFormDialog.propTypes = {
	    open: _propTypes2.default.bool,
	    interestId: _propTypes2.default.string,
	    interest: _propTypes2.default.shape({
	        name: _propTypes2.default.string,
	        ttIds: _propTypes2.default.array,
	        teamIds: _propTypes2.default.array
	    }),
	    tournaments: _propTypes2.default.object,
	    teams: _propTypes2.default.object,
	    postInterest: _propTypes2.default.func.isRequired,
	    putInterest: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref6) {
	    var routing = _ref6.routing,
	        requery = _ref6.requery;
	
	    var interestId = routing.location && routing.location.query && routing.location.query.addInterestDialog;
	    var interest = requery.entities && requery.entities.userInterests && requery.entities.userInterests[interestId];
	
	    return {
	        open: Boolean(interestId),
	        interestId: interestId,
	        interest: interest,
	        tournaments: requery.entities && requery.entities.tournaments,
	        teams: requery.entities && requery.entities.teams
	    };
	}, { postInterest: _actions.postInterest, putInterest: _actions.putInterest })(AddInterestFormDialog);

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n'], ['\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var raisedButtonStyle = {
	    marginLeft: 20
	};
	
	var styleWrapperChildComponent = {
	    width: '100%',
	    maxWidth: '530px',
	    display: 'flex',
	    justifyContent: 'space-between'
	};
	
	function pickerWrapper(ChildComponentClass, type) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	        _inherits(PickerWrapper, _Component);
	
	        function PickerWrapper() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, PickerWrapper);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PickerWrapper.__proto__ || Object.getPrototypeOf(PickerWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	                value: null,
	                reset: null,
	                error: false
	            }, _this.addTournament = function (_ref2) {
	                var tournamentId = _ref2.tournamentId;
	
	                if (tournamentId != null) {
	                    _this.setState({ value: tournamentId, reset: false });
	                }
	            }, _this.addTeam = function (_, teamId) {
	                if (teamId != null) {
	                    _this.setState({ value: teamId, reset: false });
	                }
	            }, _this.onSave = function () {
	                if (_this.state.value) {
	                    _this.props.onClickSaveBtn(_this.state.value);
	
	                    _this.setState({ reset: true });
	                } else {
	                    _this.setState({ error: true });
	                }
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(PickerWrapper, [{
	            key: 'onChange',
	            value: function onChange() {
	                if (type === 'tournament') {
	                    return this.addTournament;
	                } else if (type === 'teamIds') {
	                    return this.addTeam;
	                }
	
	                return function () {};
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    _react2.default.createElement(ChildComponentClass, _extends({}, this.props, {
	                        resetPicker: this.state.reset,
	                        onChange: this.onChange(),
	                        styleWrapper: styleWrapperChildComponent
	                    })),
	                    _react2.default.createElement(_RaisedButton2.default, { label: 'Add', onClick: this.onSave, style: raisedButtonStyle })
	                );
	            }
	        }]);
	
	        return PickerWrapper;
	    }(_react.Component), _class.propTypes = {
	        onClickSaveBtn: _propTypes2.default.func.isRequired
	    }, _temp2;
	}
	
	exports.default = pickerWrapper;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(791);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var textFieldStyle = {
	    width: '100%'
	};
	
	var InputTitleInterest = function (_Component) {
	    _inherits(InputTitleInterest, _Component);
	
	    function InputTitleInterest() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, InputTitleInterest);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputTitleInterest.__proto__ || Object.getPrototypeOf(InputTitleInterest)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            value: _this.props.value !== undefined ? _this.props.value : ''
	        }, _this.handleChange = function (_ref2) {
	            var target = _ref2.target;
	
	            _this.setState({
	                value: target.value
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(InputTitleInterest, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref3) {
	            var value = _ref3.value;
	
	            if (value !== this.props.value) {
	                this.setState({ value: value });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_TextField2.default, {
	                floatingLabelText: 'Interest Name',
	                value: this.state.value,
	                style: textFieldStyle,
	                onChange: this.handleChange,
	                onBlur: this.props.onSave
	            });
	        }
	    }]);
	
	    return InputTitleInterest;
	}(_react.Component);
	
	InputTitleInterest.defaultProps = { value: '' };
	
	InputTitleInterest.propTypes = {
	    value: _propTypes2.default.string,
	    onSave: _propTypes2.default.func.isRequired
	};
	
	exports.default = InputTitleInterest;

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 15px 0 5px;\n'], ['\n    margin: 15px 0 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    margin: 0;\n    padding-left: 0;\n    font-size: 14px;\n'], ['\n    margin: 0;\n    padding-left: 0;\n    font-size: 14px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 20px;\n\n    ::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 6px;\n        height: 6px;\n        margin-top: -3px;\n        border-radius: 50%;\n        background-color: #4d4d4d;\n    }\n'], ['\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 20px;\n\n    ::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 6px;\n        height: 6px;\n        margin-top: -3px;\n        border-radius: 50%;\n        background-color: #4d4d4d;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _close = __webpack_require__(1015);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Title = _styledComponents2.default.h4(_templateObject);
	
	var List = _styledComponents2.default.ul(_templateObject2);
	
	var Item = _styledComponents2.default.li(_templateObject3);
	
	var IconButtonStyle = {
	    width: 24,
	    height: 24,
	    marginLeft: 10,
	    padding: 0
	};
	
	var AddedItemsList = function AddedItemsList(_ref) {
	    var title = _ref.title,
	        _ref$itemIdList = _ref.itemIdList,
	        itemIdList = _ref$itemIdList === undefined ? [] : _ref$itemIdList,
	        _ref$mapItems = _ref.mapItems,
	        mapItems = _ref$mapItems === undefined ? {} : _ref$mapItems,
	        handleDeleteItem = _ref.handleDeleteItem;
	
	    if (!itemIdList.length || !Object.keys(mapItems).length) {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        title && _react2.default.createElement(
	            Title,
	            null,
	            title
	        ),
	        _react2.default.createElement(
	            List,
	            null,
	            itemIdList.map(function (itemId) {
	                return _react2.default.createElement(
	                    Item,
	                    { key: itemId },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        mapItems[itemId].name
	                    ),
	                    handleDeleteItem && _react2.default.createElement(
	                        _IconButton2.default,
	                        { onClick: handleDeleteItem(itemId), style: IconButtonStyle },
	                        _react2.default.createElement(_close2.default, null)
	                    )
	                );
	            })
	        )
	    );
	};
	
	AddedItemsList.propTypes = {
	    title: _propTypes2.default.string,
	    itemIdList: _propTypes2.default.arrayOf(_propTypes2.default.number.isRequired).isRequired,
	    mapItems: _propTypes2.default.shape({
	        name: _propTypes2.default.string
	    }).isRequired,
	    handleDeleteItem: _propTypes2.default.func
	};
	
	exports.default = AddedItemsList;

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.columnIsDefaultInterestStyle = exports.columnIconMenuCellStyle = exports.columnNameStyle = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 200px);\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _InterestRow = __webpack_require__(2176);
	
	var _InterestRow2 = _interopRequireDefault(_InterestRow);
	
	var _Table = __webpack_require__(988);
	
	var _colors = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var EmptyInterests = _styledComponents2.default.div(_templateObject);
	
	var tableHeaderStyle = {
	    backgroundColor: _colors.grey50
	};
	
	var columnNameStyle = exports.columnNameStyle = {
	    width: 200
	};
	
	var columnIconMenuCellStyle = exports.columnIconMenuCellStyle = {
	    width: 54,
	    paddingRight: 6,
	    paddingLeft: 0
	};
	
	var columnIsDefaultInterestStyle = exports.columnIsDefaultInterestStyle = {
	    width: 60,
	    paddingRight: 0,
	    paddingLeft: 0,
	    textAlign: 'center'
	};
	
	var InterestsTable = function InterestsTable(_ref) {
	    var _ref$interestsList = _ref.interestsList,
	        interestsList = _ref$interestsList === undefined ? [] : _ref$interestsList;
	
	    if (!interestsList.length) {
	        return _react2.default.createElement(
	            EmptyInterests,
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'There are no interests currently. Create the first one.'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Table.Table,
	        { selectable: false, hoverable: false },
	        _react2.default.createElement(
	            _Table.TableHeader,
	            {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false,
	                style: tableHeaderStyle
	            },
	            _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { style: columnNameStyle },
	                    'Name'
	                ),
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    null,
	                    'Interests'
	                ),
	                _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { style: columnIsDefaultInterestStyle },
	                    'Default'
	                ),
	                _react2.default.createElement(_Table.TableHeaderColumn, { style: columnIconMenuCellStyle })
	            )
	        ),
	        _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false, showRowHover: false, deselectOnClickaway: false },
	            interestsList.map(function (interestId) {
	                return _react2.default.createElement(_InterestRow2.default, { key: interestId, id: interestId });
	            })
	        )
	    );
	};
	
	InterestsTable.propTypes = {
	    interestsList: _propTypes2.default.array
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var requery = _ref2.requery;
	    return {
	        interestsList: requery.list && requery.list.userInterests
	    };
	})(InterestsTable);

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _actions = __webpack_require__(1094);
	
	var _IconMenuCell = __webpack_require__(2177);
	
	var _IconMenuCell2 = _interopRequireDefault(_IconMenuCell);
	
	var _index = __webpack_require__(2175);
	
	var _TableRow = __webpack_require__(995);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableRowColumn = __webpack_require__(991);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _Checkbox = __webpack_require__(853);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _InterestItemList = __webpack_require__(2178);
	
	var _InterestItemList2 = _interopRequireDefault(_InterestItemList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var onCheckIsDefault = function onCheckIsDefault(interestId, action) {
	    return function (event) {
	        var isInputChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        action(interestId, { isDefault: isInputChecked });
	    };
	};
	
	var InterestRow = function InterestRow(_ref) {
	    var _ref$id = _ref.id,
	        id = _ref$id === undefined ? '' : _ref$id,
	        _ref$interest = _ref.interest;
	    _ref$interest = _ref$interest === undefined ? {
	        name: '',
	        isDefault: false,
	        ttIds: [],
	        teamIds: []
	    } : _ref$interest;
	
	    var _ref$interest$name = _ref$interest.name,
	        name = _ref$interest$name === undefined ? '' : _ref$interest$name,
	        _ref$interest$isDefau = _ref$interest.isDefault,
	        isDefault = _ref$interest$isDefau === undefined ? false : _ref$interest$isDefau,
	        _ref$interest$ttIds = _ref$interest.ttIds,
	        ttIds = _ref$interest$ttIds === undefined ? [] : _ref$interest$ttIds,
	        _ref$interest$teamIds = _ref$interest.teamIds,
	        teamIds = _ref$interest$teamIds === undefined ? [] : _ref$interest$teamIds,
	        _ref$tournaments = _ref.tournaments,
	        tournaments = _ref$tournaments === undefined ? {} : _ref$tournaments,
	        _ref$teams = _ref.teams,
	        teams = _ref$teams === undefined ? {} : _ref$teams,
	        putInterest = _ref.putInterest,
	        otherProps = _objectWithoutProperties(_ref, ['id', 'interest', 'tournaments', 'teams', 'putInterest']);
	
	    var tableProps = _extends({}, otherProps);
	    Reflect.deleteProperty(tableProps, 'dispatch');
	
	    _index.columnIsDefaultInterestStyle.paddingLeft = '19px';
	    _index.columnIsDefaultInterestStyle.textAlign = 'left';
	
	    return _react2.default.createElement(
	        _TableRow2.default,
	        tableProps,
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            { style: _index.columnNameStyle },
	            name
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            null,
	            _react2.default.createElement(_InterestItemList2.default, { title: 'Teams: ', itemIdList: teamIds, mapItems: teams }),
	            _react2.default.createElement(_InterestItemList2.default, { title: 'Tournaments: ', itemIdList: ttIds, mapItems: tournaments })
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            { style: _index.columnIsDefaultInterestStyle },
	            _react2.default.createElement(_Checkbox2.default, { defaultChecked: isDefault, onCheck: onCheckIsDefault(id, putInterest) })
	        ),
	        _react2.default.createElement(
	            _TableRowColumn2.default,
	            { style: _index.columnIconMenuCellStyle },
	            _react2.default.createElement(_IconMenuCell2.default, { interestId: id })
	        )
	    );
	};
	
	InterestRow.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    interest: _propTypes2.default.shape({
	        name: _propTypes2.default.string.isRequired,
	        isDefault: _propTypes2.default.bool,
	        ttIds: _propTypes2.default.array,
	        teamIds: _propTypes2.default.array
	    }).isRequired,
	    tournaments: _propTypes2.default.object,
	    teams: _propTypes2.default.object,
	    putInterest: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2, _ref3) {
	    var requery = _ref2.requery;
	    var id = _ref3.id;
	    return {
	        interest: requery.entities && requery.entities.userInterests && requery.entities.userInterests[id],
	        tournaments: requery.entities && requery.entities.tournaments,
	        teams: requery.entities && requery.entities.teams
	    };
	}, { putInterest: _actions.putInterest })(InterestRow);

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconMenu = __webpack_require__(900);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(821);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _IconButton = __webpack_require__(740);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _moreVert = __webpack_require__(1014);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _helpers = __webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconButtonElement = _react2.default.createElement(
	    _IconButton2.default,
	    null,
	    _react2.default.createElement(_moreVert2.default, null)
	);
	
	var anchorOrigin = {
	    horizontal: 'right',
	    vertical: 'top'
	};
	
	var targetOrigin = {
	    horizontal: 'right',
	    vertical: 'top'
	};
	
	var onClick = function onClick(value, id) {
	    return function () {
	        if (value !== undefined || id != null) {
	            (0, _helpers.addToQuery)(value, id);
	        }
	    };
	};
	
	var IconMenuCell = function IconMenuCell(_ref) {
	    var interestId = _ref.interestId;
	
	    return _react2.default.createElement(
	        _IconMenu2.default,
	        { iconButtonElement: iconButtonElement, anchorOrigin: anchorOrigin, targetOrigin: targetOrigin },
	        _react2.default.createElement(_MenuItem2.default, { primaryText: 'Edit', onClick: onClick('addInterestDialog', interestId) }),
	        _react2.default.createElement(_MenuItem2.default, { primaryText: 'Delete', onClick: onClick('deleteInterestId', interestId) })
	    );
	};
	
	IconMenuCell.propTypes = {
	    interestId: _propTypes2.default.string.isRequired
	};
	
	exports.default = IconMenuCell;

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n'], ['\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    display: inline-block;\n\n    img {\n        margin-right: 3px;\n    }\n\n    &:not(:last-child)::after {\n        content: \',\';\n        margin-right: 6px;\n    }\n'], ['\n    position: relative;\n    display: inline-block;\n\n    img {\n        margin-right: 3px;\n    }\n\n    &:not(:last-child)::after {\n        content: \',\';\n        margin-right: 6px;\n    }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1017);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _RCore = __webpack_require__(1137);
	
	var _RCore2 = _interopRequireDefault(_RCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.strong(_templateObject);
	
	var List = _styledComponents2.default.ul(_templateObject2);
	
	var Item = _styledComponents2.default.li(_templateObject3);
	
	var InterestItemList = function InterestItemList(_ref) {
	    var _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        _ref$itemIdList = _ref.itemIdList,
	        itemIdList = _ref$itemIdList === undefined ? [] : _ref$itemIdList,
	        _ref$mapItems = _ref.mapItems,
	        mapItems = _ref$mapItems === undefined ? {} : _ref$mapItems;
	
	    if (!itemIdList.length || !Object.keys(mapItems).length) {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        title && _react2.default.createElement(
	            Title,
	            null,
	            title
	        ),
	        _react2.default.createElement(
	            List,
	            null,
	            itemIdList.map(function (itemId) {
	                return _react2.default.createElement(
	                    Item,
	                    { key: itemId },
	                    mapItems[itemId] && mapItems[itemId].countryId && _react2.default.createElement('img', {
	                        width: '15',
	                        height: '10',
	                        src: _RCore2.default.imageUrls.getFlagImg(mapItems[itemId].countryId, 15, 10),
	                        alt: 'Country flag'
	                    }),
	                    mapItems[itemId] && mapItems[itemId].name
	                );
	            })
	        )
	    );
	};
	
	InterestItemList.propTypes = {
	    title: _propTypes2.default.string,
	    itemIdList: _propTypes2.default.arrayOf(_propTypes2.default.number.isRequired).isRequired,
	    mapItems: _propTypes2.default.shape({
	        name: _propTypes2.default.string,
	        countryId: _propTypes2.default.number
	    }).isRequired
	};
	
	exports.default = InterestItemList;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(191);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(250);
	
	var _helpers = __webpack_require__(592);
	
	var _Dialog = __webpack_require__(882);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _RaisedButton = __webpack_require__(955);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _actions = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dialogContentStyle = {
	    width: '90%',
	    maxWidth: 'none'
	};
	
	var raisedButtonStyle = {
	    marginRight: '10px'
	};
	
	var onClose = function onClose() {
	    (0, _helpers.removeFromQuery)('deleteInterestId');
	};
	
	var DeleteDialog = function DeleteDialog(_ref) {
	    var _ref$open = _ref.open,
	        open = _ref$open === undefined ? false : _ref$open,
	        interestId = _ref.interestId,
	        _ref$interestName = _ref.interestName,
	        interestName = _ref$interestName === undefined ? '' : _ref$interestName,
	        _ref$deleteInterest = _ref.deleteInterest,
	        deleteInterest = _ref$deleteInterest === undefined ? function () {} : _ref$deleteInterest;
	    return _react2.default.createElement(
	        _Dialog2.default,
	        {
	            open: open,
	            dialogContentStyle: dialogContentStyle,
	            title: 'Delete interest ' + interestName + '?',
	            autoScrollBodyContent: true,
	            repositionOnUpdate: true,
	            autoDetectWindowHeight: true,
	            onRequestClose: onClose,
	            modal: false
	        },
	        _react2.default.createElement(_RaisedButton2.default, {
	            primary: true,
	            label: 'Submit',
	            onClick: function onClick() {
	                deleteInterest(interestId);
	                onClose();
	            },
	            style: raisedButtonStyle
	        }),
	        _react2.default.createElement(_RaisedButton2.default, { onClick: onClose, secondary: true, label: 'Cancel' })
	    );
	};
	
	DeleteDialog.propTypes = {
	    open: _propTypes2.default.bool,
	    interestId: _propTypes2.default.string,
	    interestName: _propTypes2.default.string,
	    deleteInterest: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var routing = _ref2.routing,
	        _ref2$requery = _ref2.requery,
	        requery = _ref2$requery === undefined ? { entities: {} } : _ref2$requery;
	
	    var interestId = routing.location && routing.location.query && routing.location.query.deleteInterestId;
	    var interestName = requery.entities.userInterests && requery.entities.userInterests[interestId] && requery.entities.userInterests[interestId].name;
	
	    return {
	        open: Boolean(interestId),
	        interestId: interestId,
	        interestName: interestName
	    };
	}, { deleteInterest: _actions.deleteInterest })(DeleteDialog);

/***/ }
]);


/** WEBPACK FOOTER **
 ** dash.app.js
 **/